
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire10c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire10c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gqMbp", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $bf647330465d8e92$export$ffb0004e005737fa, (v) => $bf647330465d8e92$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $bf647330465d8e92$export$34b9dba7ce09269b, (v) => $bf647330465d8e92$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $bf647330465d8e92$export$25062201e9e25d76, (v) => $bf647330465d8e92$export$25062201e9e25d76 = v);
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bf647330465d8e92$export$ffb0004e005737fa;
var $bf647330465d8e92$export$34b9dba7ce09269b;
var $bf647330465d8e92$export$25062201e9e25d76;
'use strict';
parcelRequire("cM6Vg");

var $h2ArV = parcelRequire("h2ArV");
var $bf647330465d8e92$var$g = 60103;
$bf647330465d8e92$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $bf647330465d8e92$var$h = Symbol.for;
    $bf647330465d8e92$var$g = $bf647330465d8e92$var$h("react.element");
    $bf647330465d8e92$export$ffb0004e005737fa = $bf647330465d8e92$var$h("react.fragment");
}
var $bf647330465d8e92$var$m = $h2ArV.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $bf647330465d8e92$var$n = Object.prototype.hasOwnProperty, $bf647330465d8e92$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $bf647330465d8e92$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$bf647330465d8e92$var$n.call(a, b) && !$bf647330465d8e92$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $bf647330465d8e92$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $bf647330465d8e92$var$m.current
    };
}
$bf647330465d8e92$export$34b9dba7ce09269b = $bf647330465d8e92$var$q;
$bf647330465d8e92$export$25062201e9e25d76 = $bf647330465d8e92$var$q;

});
parcelRegister("cM6Vg", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $94cf566841165658$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $94cf566841165658$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $94cf566841165658$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $94cf566841165658$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $94cf566841165658$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $94cf566841165658$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $94cf566841165658$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($94cf566841165658$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($94cf566841165658$var$getOwnPropertySymbols) {
            symbols = $94cf566841165658$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($94cf566841165658$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("h2ArV", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1vjF9"));

});
parcelRegister("1vjF9", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $1187f04cb0255a9e$export$ffb0004e005737fa, (v) => $1187f04cb0255a9e$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "StrictMode", () => $1187f04cb0255a9e$export$5f8d39834fd61797, (v) => $1187f04cb0255a9e$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Profiler", () => $1187f04cb0255a9e$export$e2c29f18771995cb, (v) => $1187f04cb0255a9e$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "Suspense", () => $1187f04cb0255a9e$export$74bf444e3cd11ea5, (v) => $1187f04cb0255a9e$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "Children", () => $1187f04cb0255a9e$export$dca3b0875bd9a954, (v) => $1187f04cb0255a9e$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1187f04cb0255a9e$export$16fa2f45be04daa8, (v) => $1187f04cb0255a9e$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "PureComponent", () => $1187f04cb0255a9e$export$221d75b3f55bb0bd, (v) => $1187f04cb0255a9e$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1187f04cb0255a9e$export$ae55be85d98224ed, (v) => $1187f04cb0255a9e$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1187f04cb0255a9e$export$e530037191fcd5d7, (v) => $1187f04cb0255a9e$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1187f04cb0255a9e$export$fd42f52fd3ae1109, (v) => $1187f04cb0255a9e$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1187f04cb0255a9e$export$c8a8987d4410bf2d, (v) => $1187f04cb0255a9e$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1187f04cb0255a9e$export$d38cd72104c1f0e9, (v) => $1187f04cb0255a9e$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1187f04cb0255a9e$export$7d1e3a5e95ceca43, (v) => $1187f04cb0255a9e$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1187f04cb0255a9e$export$257a8862b851cb5b, (v) => $1187f04cb0255a9e$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1187f04cb0255a9e$export$a8257692ac88316c, (v) => $1187f04cb0255a9e$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1187f04cb0255a9e$export$488013bae63b21da, (v) => $1187f04cb0255a9e$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1187f04cb0255a9e$export$7c73462e0d25e514, (v) => $1187f04cb0255a9e$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "useCallback", () => $1187f04cb0255a9e$export$35808ee640e87ca7, (v) => $1187f04cb0255a9e$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1187f04cb0255a9e$export$fae74005e78b1a27, (v) => $1187f04cb0255a9e$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1187f04cb0255a9e$export$dc8fbce3eb94dc1e, (v) => $1187f04cb0255a9e$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useEffect", () => $1187f04cb0255a9e$export$6d9c69b0de29b591, (v) => $1187f04cb0255a9e$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1187f04cb0255a9e$export$d5a552a76deda3c2, (v) => $1187f04cb0255a9e$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1187f04cb0255a9e$export$e5c5a5f917a5871c, (v) => $1187f04cb0255a9e$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1187f04cb0255a9e$export$1538c33de8887b59, (v) => $1187f04cb0255a9e$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1187f04cb0255a9e$export$13e3392192263954, (v) => $1187f04cb0255a9e$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1187f04cb0255a9e$export$b8f5890fc79d6aca, (v) => $1187f04cb0255a9e$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1187f04cb0255a9e$export$60241385465d0a34, (v) => $1187f04cb0255a9e$export$60241385465d0a34 = v);
$parcel$export(module.exports, "version", () => $1187f04cb0255a9e$export$83d89fbfd8236492, (v) => $1187f04cb0255a9e$export$83d89fbfd8236492 = v);
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1187f04cb0255a9e$export$ffb0004e005737fa;
var $1187f04cb0255a9e$export$5f8d39834fd61797;
var $1187f04cb0255a9e$export$e2c29f18771995cb;
var $1187f04cb0255a9e$export$74bf444e3cd11ea5;
var $1187f04cb0255a9e$export$dca3b0875bd9a954;
var $1187f04cb0255a9e$export$16fa2f45be04daa8;
var $1187f04cb0255a9e$export$221d75b3f55bb0bd;
var $1187f04cb0255a9e$export$ae55be85d98224ed;
var $1187f04cb0255a9e$export$e530037191fcd5d7;
var $1187f04cb0255a9e$export$fd42f52fd3ae1109;
var $1187f04cb0255a9e$export$c8a8987d4410bf2d;
var $1187f04cb0255a9e$export$d38cd72104c1f0e9;
var $1187f04cb0255a9e$export$7d1e3a5e95ceca43;
var $1187f04cb0255a9e$export$257a8862b851cb5b;
var $1187f04cb0255a9e$export$a8257692ac88316c;
var $1187f04cb0255a9e$export$488013bae63b21da;
var $1187f04cb0255a9e$export$7c73462e0d25e514;
var $1187f04cb0255a9e$export$35808ee640e87ca7;
var $1187f04cb0255a9e$export$fae74005e78b1a27;
var $1187f04cb0255a9e$export$dc8fbce3eb94dc1e;
var $1187f04cb0255a9e$export$6d9c69b0de29b591;
var $1187f04cb0255a9e$export$d5a552a76deda3c2;
var $1187f04cb0255a9e$export$e5c5a5f917a5871c;
var $1187f04cb0255a9e$export$1538c33de8887b59;
var $1187f04cb0255a9e$export$13e3392192263954;
var $1187f04cb0255a9e$export$b8f5890fc79d6aca;
var $1187f04cb0255a9e$export$60241385465d0a34;
var $1187f04cb0255a9e$export$83d89fbfd8236492;
'use strict';

var $cM6Vg = parcelRequire("cM6Vg");
var $1187f04cb0255a9e$var$n = 60103, $1187f04cb0255a9e$var$p = 60106;
$1187f04cb0255a9e$export$ffb0004e005737fa = 60107;
$1187f04cb0255a9e$export$5f8d39834fd61797 = 60108;
$1187f04cb0255a9e$export$e2c29f18771995cb = 60114;
var $1187f04cb0255a9e$var$q = 60109, $1187f04cb0255a9e$var$r = 60110, $1187f04cb0255a9e$var$t = 60112;
$1187f04cb0255a9e$export$74bf444e3cd11ea5 = 60113;
var $1187f04cb0255a9e$var$u = 60115, $1187f04cb0255a9e$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $1187f04cb0255a9e$var$w = Symbol.for;
    $1187f04cb0255a9e$var$n = $1187f04cb0255a9e$var$w("react.element");
    $1187f04cb0255a9e$var$p = $1187f04cb0255a9e$var$w("react.portal");
    $1187f04cb0255a9e$export$ffb0004e005737fa = $1187f04cb0255a9e$var$w("react.fragment");
    $1187f04cb0255a9e$export$5f8d39834fd61797 = $1187f04cb0255a9e$var$w("react.strict_mode");
    $1187f04cb0255a9e$export$e2c29f18771995cb = $1187f04cb0255a9e$var$w("react.profiler");
    $1187f04cb0255a9e$var$q = $1187f04cb0255a9e$var$w("react.provider");
    $1187f04cb0255a9e$var$r = $1187f04cb0255a9e$var$w("react.context");
    $1187f04cb0255a9e$var$t = $1187f04cb0255a9e$var$w("react.forward_ref");
    $1187f04cb0255a9e$export$74bf444e3cd11ea5 = $1187f04cb0255a9e$var$w("react.suspense");
    $1187f04cb0255a9e$var$u = $1187f04cb0255a9e$var$w("react.memo");
    $1187f04cb0255a9e$var$v = $1187f04cb0255a9e$var$w("react.lazy");
}
var $1187f04cb0255a9e$var$x = "function" === typeof Symbol && Symbol.iterator;
function $1187f04cb0255a9e$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1187f04cb0255a9e$var$x && a[$1187f04cb0255a9e$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $1187f04cb0255a9e$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $1187f04cb0255a9e$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1187f04cb0255a9e$var$B = {};
function $1187f04cb0255a9e$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1187f04cb0255a9e$var$B;
    this.updater = c || $1187f04cb0255a9e$var$A;
}
$1187f04cb0255a9e$var$C.prototype.isReactComponent = {};
$1187f04cb0255a9e$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($1187f04cb0255a9e$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1187f04cb0255a9e$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1187f04cb0255a9e$var$D() {}
$1187f04cb0255a9e$var$D.prototype = $1187f04cb0255a9e$var$C.prototype;
function $1187f04cb0255a9e$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1187f04cb0255a9e$var$B;
    this.updater = c || $1187f04cb0255a9e$var$A;
}
var $1187f04cb0255a9e$var$F = $1187f04cb0255a9e$var$E.prototype = new $1187f04cb0255a9e$var$D;
$1187f04cb0255a9e$var$F.constructor = $1187f04cb0255a9e$var$E;
$cM6Vg($1187f04cb0255a9e$var$F, $1187f04cb0255a9e$var$C.prototype);
$1187f04cb0255a9e$var$F.isPureReactComponent = !0;
var $1187f04cb0255a9e$var$G = {
    current: null
}, $1187f04cb0255a9e$var$H = Object.prototype.hasOwnProperty, $1187f04cb0255a9e$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1187f04cb0255a9e$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1187f04cb0255a9e$var$H.call(b, e) && !$1187f04cb0255a9e$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $1187f04cb0255a9e$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $1187f04cb0255a9e$var$G.current
    };
}
function $1187f04cb0255a9e$var$K(a, b) {
    return {
        $$typeof: $1187f04cb0255a9e$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1187f04cb0255a9e$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1187f04cb0255a9e$var$n;
}
function $1187f04cb0255a9e$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1187f04cb0255a9e$var$M = /\/+/g;
function $1187f04cb0255a9e$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1187f04cb0255a9e$var$escape("" + a.key) : b.toString(36);
}
function $1187f04cb0255a9e$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1187f04cb0255a9e$var$n:
                case $1187f04cb0255a9e$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $1187f04cb0255a9e$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($1187f04cb0255a9e$var$M, "$&/") + "/"), $1187f04cb0255a9e$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($1187f04cb0255a9e$var$L(d) && (d = $1187f04cb0255a9e$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($1187f04cb0255a9e$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $1187f04cb0255a9e$var$N(k, g);
        h += $1187f04cb0255a9e$var$O(k, b, c, f, d);
    }
    else if (f = $1187f04cb0255a9e$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $1187f04cb0255a9e$var$N(k, g++), h += $1187f04cb0255a9e$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($1187f04cb0255a9e$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $1187f04cb0255a9e$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $1187f04cb0255a9e$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $1187f04cb0255a9e$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $1187f04cb0255a9e$var$R = {
    current: null
};
function $1187f04cb0255a9e$var$S() {
    var a = $1187f04cb0255a9e$var$R.current;
    if (null === a) throw Error($1187f04cb0255a9e$var$z(321));
    return a;
}
var $1187f04cb0255a9e$var$T = {
    ReactCurrentDispatcher: $1187f04cb0255a9e$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $1187f04cb0255a9e$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $cM6Vg
};
$1187f04cb0255a9e$export$dca3b0875bd9a954 = {
    map: $1187f04cb0255a9e$var$P,
    forEach: function(a, b, c) {
        $1187f04cb0255a9e$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $1187f04cb0255a9e$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1187f04cb0255a9e$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1187f04cb0255a9e$var$L(a)) throw Error($1187f04cb0255a9e$var$z(143));
        return a;
    }
};
$1187f04cb0255a9e$export$16fa2f45be04daa8 = $1187f04cb0255a9e$var$C;
$1187f04cb0255a9e$export$221d75b3f55bb0bd = $1187f04cb0255a9e$var$E;
$1187f04cb0255a9e$export$ae55be85d98224ed = $1187f04cb0255a9e$var$T;
$1187f04cb0255a9e$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($1187f04cb0255a9e$var$z(267, a));
    var e = $cM6Vg({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1187f04cb0255a9e$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1187f04cb0255a9e$var$H.call(b, f) && !$1187f04cb0255a9e$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $1187f04cb0255a9e$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$1187f04cb0255a9e$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $1187f04cb0255a9e$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $1187f04cb0255a9e$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$1187f04cb0255a9e$export$c8a8987d4410bf2d = $1187f04cb0255a9e$var$J;
$1187f04cb0255a9e$export$d38cd72104c1f0e9 = function(a) {
    var b = $1187f04cb0255a9e$var$J.bind(null, a);
    b.type = a;
    return b;
};
$1187f04cb0255a9e$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1187f04cb0255a9e$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1187f04cb0255a9e$var$t,
        render: a
    };
};
$1187f04cb0255a9e$export$a8257692ac88316c = $1187f04cb0255a9e$var$L;
$1187f04cb0255a9e$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1187f04cb0255a9e$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1187f04cb0255a9e$var$Q
    };
};
$1187f04cb0255a9e$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1187f04cb0255a9e$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1187f04cb0255a9e$export$35808ee640e87ca7 = function(a, b) {
    return $1187f04cb0255a9e$var$S().useCallback(a, b);
};
$1187f04cb0255a9e$export$fae74005e78b1a27 = function(a, b) {
    return $1187f04cb0255a9e$var$S().useContext(a, b);
};
$1187f04cb0255a9e$export$dc8fbce3eb94dc1e = function() {};
$1187f04cb0255a9e$export$6d9c69b0de29b591 = function(a, b) {
    return $1187f04cb0255a9e$var$S().useEffect(a, b);
};
$1187f04cb0255a9e$export$d5a552a76deda3c2 = function(a, b, c) {
    return $1187f04cb0255a9e$var$S().useImperativeHandle(a, b, c);
};
$1187f04cb0255a9e$export$e5c5a5f917a5871c = function(a, b) {
    return $1187f04cb0255a9e$var$S().useLayoutEffect(a, b);
};
$1187f04cb0255a9e$export$1538c33de8887b59 = function(a, b) {
    return $1187f04cb0255a9e$var$S().useMemo(a, b);
};
$1187f04cb0255a9e$export$13e3392192263954 = function(a, b, c) {
    return $1187f04cb0255a9e$var$S().useReducer(a, b, c);
};
$1187f04cb0255a9e$export$b8f5890fc79d6aca = function(a) {
    return $1187f04cb0255a9e$var$S().useRef(a);
};
$1187f04cb0255a9e$export$60241385465d0a34 = function(a) {
    return $1187f04cb0255a9e$var$S().useState(a);
};
$1187f04cb0255a9e$export$83d89fbfd8236492 = "17.0.2";

});



parcelRegister("3NhwF", function(module, exports) {
'use strict';
function $2c338afa33a03192$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($2c338afa33a03192$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$2c338afa33a03192$var$checkDCE();

module.exports = (parcelRequire("eyCz4"));

});
parcelRegister("eyCz4", function(module, exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $h2ArV = parcelRequire("h2ArV");

var $cM6Vg = parcelRequire("cM6Vg");

var $iOlAU = parcelRequire("iOlAU");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$h2ArV) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = $h2ArV.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return $cM6Vg({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    $h2ArV.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = $cM6Vg({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return $cM6Vg({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = $cM6Vg({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        $iOlAU.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, $iOlAU.unstable_scheduleCallback($iOlAU.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = $iOlAU.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = $iOlAU.unstable_UserBlockingPriority, ed = $iOlAU.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    $cM6Vg(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = $cM6Vg({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = $cM6Vg({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = $cM6Vg({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = $cM6Vg({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = $cM6Vg({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = $cM6Vg({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = $cM6Vg({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = $cM6Vg({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = $cM6Vg({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = $cM6Vg({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = $cM6Vg({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = $cM6Vg({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return $cM6Vg({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = $iOlAU.unstable_runWithPriority, Of = $iOlAU.unstable_scheduleCallback, Pf = $iOlAU.unstable_cancelCallback, Qf = $iOlAU.unstable_shouldYield, Rf = $iOlAU.unstable_requestPaint, Sf = $iOlAU.unstable_now, Tf = $iOlAU.unstable_getCurrentPriorityLevel, Uf = $iOlAU.unstable_ImmediatePriority, Vf = $iOlAU.unstable_UserBlockingPriority, Wf = $iOlAU.unstable_NormalPriority, Xf = $iOlAU.unstable_LowPriority, Yf = $iOlAU.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = $cM6Vg({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $cM6Vg({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new $h2ArV.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $cM6Vg({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = $cM6Vg({}, e, {
                    value: void 0
                });
                d = $cM6Vg({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $cM6Vg({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

});
parcelRegister("iOlAU", function(module, exports) {
'use strict';

module.exports = (parcelRequire("ivaS8"));

});
parcelRegister("ivaS8", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $d7838e3ff0de3e68$export$c4744153514ff05d, (v) => $d7838e3ff0de3e68$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $d7838e3ff0de3e68$export$b5836b71941fa3ed, (v) => $d7838e3ff0de3e68$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $d7838e3ff0de3e68$export$d66a1c1c77bd778b, (v) => $d7838e3ff0de3e68$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $d7838e3ff0de3e68$export$3e506c1ccc9cc1a7, (v) => $d7838e3ff0de3e68$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $d7838e3ff0de3e68$export$e26fe2ed2fa76875, (v) => $d7838e3ff0de3e68$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $d7838e3ff0de3e68$export$502329bbf4b505b1, (v) => $d7838e3ff0de3e68$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $d7838e3ff0de3e68$export$6e3807111c4874c4, (v) => $d7838e3ff0de3e68$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $d7838e3ff0de3e68$export$c27134553091fb3a, (v) => $d7838e3ff0de3e68$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $d7838e3ff0de3e68$export$33ee1acdc04fd2a2, (v) => $d7838e3ff0de3e68$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $d7838e3ff0de3e68$export$b00a404bbd5edef2, (v) => $d7838e3ff0de3e68$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $d7838e3ff0de3e68$export$8352ce38b91d0c62, (v) => $d7838e3ff0de3e68$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $d7838e3ff0de3e68$export$d3dfb8e4810cb555, (v) => $d7838e3ff0de3e68$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $d7838e3ff0de3e68$export$839f9183b0465a69, (v) => $d7838e3ff0de3e68$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $d7838e3ff0de3e68$export$72fdf0e06517287b, (v) => $d7838e3ff0de3e68$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $d7838e3ff0de3e68$export$4b844e58a3e414b4, (v) => $d7838e3ff0de3e68$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $d7838e3ff0de3e68$export$816d2913ae6b83b1, (v) => $d7838e3ff0de3e68$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $d7838e3ff0de3e68$export$61bcfe829111a1d0, (v) => $d7838e3ff0de3e68$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $d7838e3ff0de3e68$export$7ee8c9beb337bc3f, (v) => $d7838e3ff0de3e68$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $d7838e3ff0de3e68$export$cf845f2c119da08a, (v) => $d7838e3ff0de3e68$export$cf845f2c119da08a = v);
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d7838e3ff0de3e68$export$c4744153514ff05d;
var $d7838e3ff0de3e68$export$b5836b71941fa3ed;
var $d7838e3ff0de3e68$export$d66a1c1c77bd778b;
var $d7838e3ff0de3e68$export$3e506c1ccc9cc1a7;
var $d7838e3ff0de3e68$export$e26fe2ed2fa76875;
var $d7838e3ff0de3e68$export$502329bbf4b505b1;
var $d7838e3ff0de3e68$export$6e3807111c4874c4;
var $d7838e3ff0de3e68$export$c27134553091fb3a;
var $d7838e3ff0de3e68$export$33ee1acdc04fd2a2;
var $d7838e3ff0de3e68$export$b00a404bbd5edef2;
var $d7838e3ff0de3e68$export$8352ce38b91d0c62;
var $d7838e3ff0de3e68$export$d3dfb8e4810cb555;
var $d7838e3ff0de3e68$export$839f9183b0465a69;
var $d7838e3ff0de3e68$export$72fdf0e06517287b;
var $d7838e3ff0de3e68$export$4b844e58a3e414b4;
var $d7838e3ff0de3e68$export$816d2913ae6b83b1;
var $d7838e3ff0de3e68$export$61bcfe829111a1d0;
var $d7838e3ff0de3e68$export$7ee8c9beb337bc3f;
var $d7838e3ff0de3e68$export$cf845f2c119da08a;
'use strict';
var $d7838e3ff0de3e68$var$f, $d7838e3ff0de3e68$var$g, $d7838e3ff0de3e68$var$h, $d7838e3ff0de3e68$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $d7838e3ff0de3e68$var$l = performance;
    $d7838e3ff0de3e68$export$c4744153514ff05d = function() {
        return $d7838e3ff0de3e68$var$l.now();
    };
} else {
    var $d7838e3ff0de3e68$var$p = Date, $d7838e3ff0de3e68$var$q = $d7838e3ff0de3e68$var$p.now();
    $d7838e3ff0de3e68$export$c4744153514ff05d = function() {
        return $d7838e3ff0de3e68$var$p.now() - $d7838e3ff0de3e68$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $d7838e3ff0de3e68$var$t = null, $d7838e3ff0de3e68$var$u = null, $d7838e3ff0de3e68$var$w = function() {
        if (null !== $d7838e3ff0de3e68$var$t) try {
            var a = $d7838e3ff0de3e68$export$c4744153514ff05d();
            $d7838e3ff0de3e68$var$t(!0, a);
            $d7838e3ff0de3e68$var$t = null;
        } catch (b) {
            throw setTimeout($d7838e3ff0de3e68$var$w, 0), b;
        }
    };
    $d7838e3ff0de3e68$var$f = function(a) {
        null !== $d7838e3ff0de3e68$var$t ? setTimeout($d7838e3ff0de3e68$var$f, 0, a) : ($d7838e3ff0de3e68$var$t = a, setTimeout($d7838e3ff0de3e68$var$w, 0));
    };
    $d7838e3ff0de3e68$var$g = function(a, b) {
        $d7838e3ff0de3e68$var$u = setTimeout(a, b);
    };
    $d7838e3ff0de3e68$var$h = function() {
        clearTimeout($d7838e3ff0de3e68$var$u);
    };
    $d7838e3ff0de3e68$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $d7838e3ff0de3e68$var$k = $d7838e3ff0de3e68$export$d66a1c1c77bd778b = function() {};
} else {
    var $d7838e3ff0de3e68$var$x = window.setTimeout, $d7838e3ff0de3e68$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $d7838e3ff0de3e68$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $d7838e3ff0de3e68$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $d7838e3ff0de3e68$var$A = !1, $d7838e3ff0de3e68$var$B = null, $d7838e3ff0de3e68$var$C = -1, $d7838e3ff0de3e68$var$D = 5, $d7838e3ff0de3e68$var$E = 0;
    $d7838e3ff0de3e68$export$b5836b71941fa3ed = function() {
        return $d7838e3ff0de3e68$export$c4744153514ff05d() >= $d7838e3ff0de3e68$var$E;
    };
    $d7838e3ff0de3e68$var$k = function() {};
    $d7838e3ff0de3e68$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $d7838e3ff0de3e68$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $d7838e3ff0de3e68$var$F = new MessageChannel, $d7838e3ff0de3e68$var$G = $d7838e3ff0de3e68$var$F.port2;
    $d7838e3ff0de3e68$var$F.port1.onmessage = function() {
        if (null !== $d7838e3ff0de3e68$var$B) {
            var a = $d7838e3ff0de3e68$export$c4744153514ff05d();
            $d7838e3ff0de3e68$var$E = a + $d7838e3ff0de3e68$var$D;
            try {
                $d7838e3ff0de3e68$var$B(!0, a) ? $d7838e3ff0de3e68$var$G.postMessage(null) : ($d7838e3ff0de3e68$var$A = !1, $d7838e3ff0de3e68$var$B = null);
            } catch (b) {
                throw $d7838e3ff0de3e68$var$G.postMessage(null), b;
            }
        } else $d7838e3ff0de3e68$var$A = !1;
    };
    $d7838e3ff0de3e68$var$f = function(a) {
        $d7838e3ff0de3e68$var$B = a;
        $d7838e3ff0de3e68$var$A || ($d7838e3ff0de3e68$var$A = !0, $d7838e3ff0de3e68$var$G.postMessage(null));
    };
    $d7838e3ff0de3e68$var$g = function(a, b) {
        $d7838e3ff0de3e68$var$C = $d7838e3ff0de3e68$var$x(function() {
            a($d7838e3ff0de3e68$export$c4744153514ff05d());
        }, b);
    };
    $d7838e3ff0de3e68$var$h = function() {
        $d7838e3ff0de3e68$var$y($d7838e3ff0de3e68$var$C);
        $d7838e3ff0de3e68$var$C = -1;
    };
}
function $d7838e3ff0de3e68$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $d7838e3ff0de3e68$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $d7838e3ff0de3e68$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $d7838e3ff0de3e68$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $d7838e3ff0de3e68$var$I(n, c)) void 0 !== r && 0 > $d7838e3ff0de3e68$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $d7838e3ff0de3e68$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $d7838e3ff0de3e68$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $d7838e3ff0de3e68$var$L = [], $d7838e3ff0de3e68$var$M = [], $d7838e3ff0de3e68$var$N = 1, $d7838e3ff0de3e68$var$O = null, $d7838e3ff0de3e68$var$P = 3, $d7838e3ff0de3e68$var$Q = !1, $d7838e3ff0de3e68$var$R = !1, $d7838e3ff0de3e68$var$S = !1;
function $d7838e3ff0de3e68$var$T(a) {
    for(var b = $d7838e3ff0de3e68$var$J($d7838e3ff0de3e68$var$M); null !== b;){
        if (null === b.callback) $d7838e3ff0de3e68$var$K($d7838e3ff0de3e68$var$M);
        else if (b.startTime <= a) $d7838e3ff0de3e68$var$K($d7838e3ff0de3e68$var$M), b.sortIndex = b.expirationTime, $d7838e3ff0de3e68$var$H($d7838e3ff0de3e68$var$L, b);
        else break;
        b = $d7838e3ff0de3e68$var$J($d7838e3ff0de3e68$var$M);
    }
}
function $d7838e3ff0de3e68$var$U(a) {
    $d7838e3ff0de3e68$var$S = !1;
    $d7838e3ff0de3e68$var$T(a);
    if (!$d7838e3ff0de3e68$var$R) {
        if (null !== $d7838e3ff0de3e68$var$J($d7838e3ff0de3e68$var$L)) $d7838e3ff0de3e68$var$R = !0, $d7838e3ff0de3e68$var$f($d7838e3ff0de3e68$var$V);
        else {
            var b = $d7838e3ff0de3e68$var$J($d7838e3ff0de3e68$var$M);
            null !== b && $d7838e3ff0de3e68$var$g($d7838e3ff0de3e68$var$U, b.startTime - a);
        }
    }
}
function $d7838e3ff0de3e68$var$V(a, b) {
    $d7838e3ff0de3e68$var$R = !1;
    $d7838e3ff0de3e68$var$S && ($d7838e3ff0de3e68$var$S = !1, $d7838e3ff0de3e68$var$h());
    $d7838e3ff0de3e68$var$Q = !0;
    var c = $d7838e3ff0de3e68$var$P;
    try {
        $d7838e3ff0de3e68$var$T(b);
        for($d7838e3ff0de3e68$var$O = $d7838e3ff0de3e68$var$J($d7838e3ff0de3e68$var$L); null !== $d7838e3ff0de3e68$var$O && (!($d7838e3ff0de3e68$var$O.expirationTime > b) || a && !$d7838e3ff0de3e68$export$b5836b71941fa3ed());){
            var d = $d7838e3ff0de3e68$var$O.callback;
            if ("function" === typeof d) {
                $d7838e3ff0de3e68$var$O.callback = null;
                $d7838e3ff0de3e68$var$P = $d7838e3ff0de3e68$var$O.priorityLevel;
                var e = d($d7838e3ff0de3e68$var$O.expirationTime <= b);
                b = $d7838e3ff0de3e68$export$c4744153514ff05d();
                "function" === typeof e ? $d7838e3ff0de3e68$var$O.callback = e : $d7838e3ff0de3e68$var$O === $d7838e3ff0de3e68$var$J($d7838e3ff0de3e68$var$L) && $d7838e3ff0de3e68$var$K($d7838e3ff0de3e68$var$L);
                $d7838e3ff0de3e68$var$T(b);
            } else $d7838e3ff0de3e68$var$K($d7838e3ff0de3e68$var$L);
            $d7838e3ff0de3e68$var$O = $d7838e3ff0de3e68$var$J($d7838e3ff0de3e68$var$L);
        }
        if (null !== $d7838e3ff0de3e68$var$O) var m = !0;
        else {
            var n = $d7838e3ff0de3e68$var$J($d7838e3ff0de3e68$var$M);
            null !== n && $d7838e3ff0de3e68$var$g($d7838e3ff0de3e68$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $d7838e3ff0de3e68$var$O = null, $d7838e3ff0de3e68$var$P = c, $d7838e3ff0de3e68$var$Q = !1;
    }
}
var $d7838e3ff0de3e68$var$W = $d7838e3ff0de3e68$var$k;
$d7838e3ff0de3e68$export$3e506c1ccc9cc1a7 = 5;
$d7838e3ff0de3e68$export$e26fe2ed2fa76875 = 1;
$d7838e3ff0de3e68$export$502329bbf4b505b1 = 4;
$d7838e3ff0de3e68$export$6e3807111c4874c4 = 3;
$d7838e3ff0de3e68$export$c27134553091fb3a = null;
$d7838e3ff0de3e68$export$33ee1acdc04fd2a2 = 2;
$d7838e3ff0de3e68$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$d7838e3ff0de3e68$export$8352ce38b91d0c62 = function() {
    $d7838e3ff0de3e68$var$R || $d7838e3ff0de3e68$var$Q || ($d7838e3ff0de3e68$var$R = !0, $d7838e3ff0de3e68$var$f($d7838e3ff0de3e68$var$V));
};
$d7838e3ff0de3e68$export$d3dfb8e4810cb555 = function() {
    return $d7838e3ff0de3e68$var$P;
};
$d7838e3ff0de3e68$export$839f9183b0465a69 = function() {
    return $d7838e3ff0de3e68$var$J($d7838e3ff0de3e68$var$L);
};
$d7838e3ff0de3e68$export$72fdf0e06517287b = function(a) {
    switch($d7838e3ff0de3e68$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $d7838e3ff0de3e68$var$P;
    }
    var c = $d7838e3ff0de3e68$var$P;
    $d7838e3ff0de3e68$var$P = b;
    try {
        return a();
    } finally{
        $d7838e3ff0de3e68$var$P = c;
    }
};
$d7838e3ff0de3e68$export$4b844e58a3e414b4 = function() {};
$d7838e3ff0de3e68$export$816d2913ae6b83b1 = $d7838e3ff0de3e68$var$W;
$d7838e3ff0de3e68$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $d7838e3ff0de3e68$var$P;
    $d7838e3ff0de3e68$var$P = a;
    try {
        return b();
    } finally{
        $d7838e3ff0de3e68$var$P = c;
    }
};
$d7838e3ff0de3e68$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $d7838e3ff0de3e68$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $d7838e3ff0de3e68$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $d7838e3ff0de3e68$var$H($d7838e3ff0de3e68$var$M, a), null === $d7838e3ff0de3e68$var$J($d7838e3ff0de3e68$var$L) && a === $d7838e3ff0de3e68$var$J($d7838e3ff0de3e68$var$M) && ($d7838e3ff0de3e68$var$S ? $d7838e3ff0de3e68$var$h() : $d7838e3ff0de3e68$var$S = !0, $d7838e3ff0de3e68$var$g($d7838e3ff0de3e68$var$U, c - d))) : (a.sortIndex = e, $d7838e3ff0de3e68$var$H($d7838e3ff0de3e68$var$L, a), $d7838e3ff0de3e68$var$R || $d7838e3ff0de3e68$var$Q || ($d7838e3ff0de3e68$var$R = !0, $d7838e3ff0de3e68$var$f($d7838e3ff0de3e68$var$V)));
    return a;
};
$d7838e3ff0de3e68$export$cf845f2c119da08a = function(a) {
    var b = $d7838e3ff0de3e68$var$P;
    return function() {
        var c = $d7838e3ff0de3e68$var$P;
        $d7838e3ff0de3e68$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $d7838e3ff0de3e68$var$P = c;
        }
    };
};

});




parcelRegister("d2HdY", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $97ecfdb9176e881d$var$Stream;

var $3TvIx = parcelRequire("3TvIx");
var $97ecfdb9176e881d$require$EE = $3TvIx.EventEmitter;

var $83QSq = parcelRequire("83QSq");
$83QSq($97ecfdb9176e881d$var$Stream, $97ecfdb9176e881d$require$EE);

$97ecfdb9176e881d$var$Stream.Readable = (parcelRequire("j1BLH"));

$97ecfdb9176e881d$var$Stream.Writable = (parcelRequire("abSdI"));

$97ecfdb9176e881d$var$Stream.Duplex = (parcelRequire("8PgDm"));

$97ecfdb9176e881d$var$Stream.Transform = (parcelRequire("f5kCH"));

$97ecfdb9176e881d$var$Stream.PassThrough = (parcelRequire("7SCJE"));

$97ecfdb9176e881d$var$Stream.finished = (parcelRequire("jysqe"));

$97ecfdb9176e881d$var$Stream.pipeline = (parcelRequire("kVluV"));
// Backwards-compat with node 0.4.x
$97ecfdb9176e881d$var$Stream.Stream = $97ecfdb9176e881d$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $97ecfdb9176e881d$var$Stream() {
    $97ecfdb9176e881d$require$EE.call(this);
}
$97ecfdb9176e881d$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($97ecfdb9176e881d$require$EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("3TvIx", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $2d5f1c8b675107d1$var$R = typeof Reflect === 'object' ? Reflect : null;
var $2d5f1c8b675107d1$var$ReflectApply = $2d5f1c8b675107d1$var$R && typeof $2d5f1c8b675107d1$var$R.apply === 'function' ? $2d5f1c8b675107d1$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $2d5f1c8b675107d1$var$ReflectOwnKeys;
if ($2d5f1c8b675107d1$var$R && typeof $2d5f1c8b675107d1$var$R.ownKeys === 'function') $2d5f1c8b675107d1$var$ReflectOwnKeys = $2d5f1c8b675107d1$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $2d5f1c8b675107d1$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $2d5f1c8b675107d1$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $2d5f1c8b675107d1$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $2d5f1c8b675107d1$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $2d5f1c8b675107d1$var$EventEmitter() {
    $2d5f1c8b675107d1$var$EventEmitter.init.call(this);
}
module.exports = $2d5f1c8b675107d1$var$EventEmitter;
module.exports.once = $2d5f1c8b675107d1$var$once;
// Backwards-compat with node 0.10.x
$2d5f1c8b675107d1$var$EventEmitter.EventEmitter = $2d5f1c8b675107d1$var$EventEmitter;
$2d5f1c8b675107d1$var$EventEmitter.prototype._events = undefined;
$2d5f1c8b675107d1$var$EventEmitter.prototype._eventsCount = 0;
$2d5f1c8b675107d1$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $2d5f1c8b675107d1$var$defaultMaxListeners = 10;
function $2d5f1c8b675107d1$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($2d5f1c8b675107d1$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $2d5f1c8b675107d1$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $2d5f1c8b675107d1$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $2d5f1c8b675107d1$var$defaultMaxListeners = arg;
    }
});
$2d5f1c8b675107d1$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$2d5f1c8b675107d1$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $2d5f1c8b675107d1$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $2d5f1c8b675107d1$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $2d5f1c8b675107d1$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$2d5f1c8b675107d1$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $2d5f1c8b675107d1$var$_getMaxListeners(this);
};
$2d5f1c8b675107d1$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $2d5f1c8b675107d1$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $2d5f1c8b675107d1$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$2d5f1c8b675107d1$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $2d5f1c8b675107d1$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $2d5f1c8b675107d1$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $2d5f1c8b675107d1$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $2d5f1c8b675107d1$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$2d5f1c8b675107d1$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $2d5f1c8b675107d1$var$_addListener(this, type, listener, false);
};
$2d5f1c8b675107d1$var$EventEmitter.prototype.on = $2d5f1c8b675107d1$var$EventEmitter.prototype.addListener;
$2d5f1c8b675107d1$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $2d5f1c8b675107d1$var$_addListener(this, type, listener, true);
};
function $2d5f1c8b675107d1$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $2d5f1c8b675107d1$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $2d5f1c8b675107d1$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$2d5f1c8b675107d1$var$EventEmitter.prototype.once = function once(type, listener) {
    $2d5f1c8b675107d1$var$checkListener(listener);
    this.on(type, $2d5f1c8b675107d1$var$_onceWrap(this, type, listener));
    return this;
};
$2d5f1c8b675107d1$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $2d5f1c8b675107d1$var$checkListener(listener);
    this.prependListener(type, $2d5f1c8b675107d1$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$2d5f1c8b675107d1$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $2d5f1c8b675107d1$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $2d5f1c8b675107d1$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$2d5f1c8b675107d1$var$EventEmitter.prototype.off = $2d5f1c8b675107d1$var$EventEmitter.prototype.removeListener;
$2d5f1c8b675107d1$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $2d5f1c8b675107d1$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $2d5f1c8b675107d1$var$unwrapListeners(evlistener) : $2d5f1c8b675107d1$var$arrayClone(evlistener, evlistener.length);
}
$2d5f1c8b675107d1$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $2d5f1c8b675107d1$var$_listeners(this, type, true);
};
$2d5f1c8b675107d1$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $2d5f1c8b675107d1$var$_listeners(this, type, false);
};
$2d5f1c8b675107d1$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $2d5f1c8b675107d1$var$listenerCount.call(emitter, type);
};
$2d5f1c8b675107d1$var$EventEmitter.prototype.listenerCount = $2d5f1c8b675107d1$var$listenerCount;
function $2d5f1c8b675107d1$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$2d5f1c8b675107d1$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $2d5f1c8b675107d1$var$ReflectOwnKeys(this._events) : [];
};
function $2d5f1c8b675107d1$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $2d5f1c8b675107d1$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $2d5f1c8b675107d1$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $2d5f1c8b675107d1$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $2d5f1c8b675107d1$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $2d5f1c8b675107d1$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $2d5f1c8b675107d1$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $2d5f1c8b675107d1$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $2d5f1c8b675107d1$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("83QSq", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("j1BLH", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $fHA2F = parcelRequire("fHA2F");
'use strict';
module.exports = $dd9b6854c3b51869$var$Readable;
/*<replacement>*/ var $dd9b6854c3b51869$var$Duplex;
/*</replacement>*/ $dd9b6854c3b51869$var$Readable.ReadableState = $dd9b6854c3b51869$var$ReadableState;

var $3TvIx = parcelRequire("3TvIx");
var $dd9b6854c3b51869$require$EE = $3TvIx.EventEmitter;
var $dd9b6854c3b51869$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $dmvBY = parcelRequire("dmvBY");

var $lGjml = parcelRequire("lGjml");
var $dd9b6854c3b51869$require$Buffer = $lGjml.Buffer;
var $dd9b6854c3b51869$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $dd9b6854c3b51869$var$_uint8ArrayToBuffer(chunk) {
    return $dd9b6854c3b51869$require$Buffer.from(chunk);
}
function $dd9b6854c3b51869$var$_isUint8Array(obj) {
    return $dd9b6854c3b51869$require$Buffer.isBuffer(obj) || obj instanceof $dd9b6854c3b51869$var$OurUint8Array;
}

var $k3LaP = parcelRequire("k3LaP");
var $dd9b6854c3b51869$var$debug;
if ($k3LaP && $k3LaP.debuglog) $dd9b6854c3b51869$var$debug = $k3LaP.debuglog('stream');
else $dd9b6854c3b51869$var$debug = function debug() {};

var $8ruJs = parcelRequire("8ruJs");

var $hsXaW = parcelRequire("hsXaW");

var $8kpuq = parcelRequire("8kpuq");
var $dd9b6854c3b51869$var$getHighWaterMark = $8kpuq.getHighWaterMark;

var $igp20 = parcelRequire("igp20");
var $dd9b6854c3b51869$require$_require$codes = $igp20.codes;
var $dd9b6854c3b51869$var$ERR_INVALID_ARG_TYPE = $dd9b6854c3b51869$require$_require$codes.ERR_INVALID_ARG_TYPE, $dd9b6854c3b51869$var$ERR_STREAM_PUSH_AFTER_EOF = $dd9b6854c3b51869$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $dd9b6854c3b51869$var$ERR_METHOD_NOT_IMPLEMENTED = $dd9b6854c3b51869$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $dd9b6854c3b51869$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $dd9b6854c3b51869$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $dd9b6854c3b51869$var$StringDecoder;
var $dd9b6854c3b51869$var$createReadableStreamAsyncIterator;
var $dd9b6854c3b51869$var$from;

(parcelRequire("83QSq"))($dd9b6854c3b51869$var$Readable, $dmvBY);
var $dd9b6854c3b51869$var$errorOrDestroy = $hsXaW.errorOrDestroy;
var $dd9b6854c3b51869$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $dd9b6854c3b51869$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $dd9b6854c3b51869$var$ReadableState(options, stream, isDuplex) {
    $dd9b6854c3b51869$var$Duplex = $dd9b6854c3b51869$var$Duplex || (parcelRequire("8PgDm"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $dd9b6854c3b51869$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $dd9b6854c3b51869$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $8ruJs();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$dd9b6854c3b51869$var$StringDecoder) $dd9b6854c3b51869$var$StringDecoder = (parcelRequire("iCQEj")).StringDecoder;
        this.decoder = new $dd9b6854c3b51869$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $dd9b6854c3b51869$var$Readable(options) {
    $dd9b6854c3b51869$var$Duplex = $dd9b6854c3b51869$var$Duplex || (parcelRequire("8PgDm"));
    if (!(this instanceof $dd9b6854c3b51869$var$Readable)) return new $dd9b6854c3b51869$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $dd9b6854c3b51869$var$Duplex;
    this._readableState = new $dd9b6854c3b51869$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $dmvBY.call(this);
}
Object.defineProperty($dd9b6854c3b51869$var$Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$dd9b6854c3b51869$var$Readable.prototype.destroy = $hsXaW.destroy;
$dd9b6854c3b51869$var$Readable.prototype._undestroy = $hsXaW.undestroy;
$dd9b6854c3b51869$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$dd9b6854c3b51869$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $dd9b6854c3b51869$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $dd9b6854c3b51869$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$dd9b6854c3b51869$var$Readable.prototype.unshift = function(chunk) {
    return $dd9b6854c3b51869$var$readableAddChunk(this, chunk, null, true, false);
};
function $dd9b6854c3b51869$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $dd9b6854c3b51869$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $dd9b6854c3b51869$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $dd9b6854c3b51869$var$chunkInvalid(state, chunk);
        if (er) $dd9b6854c3b51869$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $dd9b6854c3b51869$require$Buffer.prototype) chunk = $dd9b6854c3b51869$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $dd9b6854c3b51869$var$errorOrDestroy(stream, new $dd9b6854c3b51869$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $dd9b6854c3b51869$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $dd9b6854c3b51869$var$errorOrDestroy(stream, new $dd9b6854c3b51869$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $dd9b6854c3b51869$var$addChunk(stream, state, chunk, false);
                    else $dd9b6854c3b51869$var$maybeReadMore(stream, state);
                } else $dd9b6854c3b51869$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $dd9b6854c3b51869$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $dd9b6854c3b51869$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $dd9b6854c3b51869$var$emitReadable(stream);
    }
    $dd9b6854c3b51869$var$maybeReadMore(stream, state);
}
function $dd9b6854c3b51869$var$chunkInvalid(state, chunk) {
    var er;
    if (!$dd9b6854c3b51869$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new $dd9b6854c3b51869$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
$dd9b6854c3b51869$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$dd9b6854c3b51869$var$Readable.prototype.setEncoding = function(enc) {
    if (!$dd9b6854c3b51869$var$StringDecoder) $dd9b6854c3b51869$var$StringDecoder = (parcelRequire("iCQEj")).StringDecoder;
    var decoder = new $dd9b6854c3b51869$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $dd9b6854c3b51869$var$MAX_HWM = 0x40000000;
function $dd9b6854c3b51869$var$computeNewHighWaterMark(n) {
    if (n >= $dd9b6854c3b51869$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $dd9b6854c3b51869$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $dd9b6854c3b51869$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $dd9b6854c3b51869$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$dd9b6854c3b51869$var$Readable.prototype.read = function(n) {
    $dd9b6854c3b51869$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $dd9b6854c3b51869$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $dd9b6854c3b51869$var$endReadable(this);
        else $dd9b6854c3b51869$var$emitReadable(this);
        return null;
    }
    n = $dd9b6854c3b51869$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $dd9b6854c3b51869$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $dd9b6854c3b51869$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $dd9b6854c3b51869$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $dd9b6854c3b51869$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $dd9b6854c3b51869$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $dd9b6854c3b51869$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $dd9b6854c3b51869$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $dd9b6854c3b51869$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $dd9b6854c3b51869$var$onEofChunk(stream, state) {
    $dd9b6854c3b51869$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $dd9b6854c3b51869$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $dd9b6854c3b51869$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $dd9b6854c3b51869$var$emitReadable(stream) {
    var state = stream._readableState;
    $dd9b6854c3b51869$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $dd9b6854c3b51869$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $fHA2F.nextTick($dd9b6854c3b51869$var$emitReadable_, stream);
    }
}
function $dd9b6854c3b51869$var$emitReadable_(stream) {
    var state = stream._readableState;
    $dd9b6854c3b51869$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $dd9b6854c3b51869$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $dd9b6854c3b51869$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $fHA2F.nextTick($dd9b6854c3b51869$var$maybeReadMore_, stream, state);
    }
}
function $dd9b6854c3b51869$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $dd9b6854c3b51869$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$dd9b6854c3b51869$var$Readable.prototype._read = function(n) {
    $dd9b6854c3b51869$var$errorOrDestroy(this, new $dd9b6854c3b51869$var$ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
$dd9b6854c3b51869$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $dd9b6854c3b51869$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $fHA2F.stdout && dest !== $fHA2F.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $fHA2F.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $dd9b6854c3b51869$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $dd9b6854c3b51869$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $dd9b6854c3b51869$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $dd9b6854c3b51869$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $dd9b6854c3b51869$var$debug('ondata');
        var ret = dest.write(chunk);
        $dd9b6854c3b51869$var$debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $dd9b6854c3b51869$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $dd9b6854c3b51869$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $dd9b6854c3b51869$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($dd9b6854c3b51869$var$EElistenerCount(dest, 'error') === 0) $dd9b6854c3b51869$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $dd9b6854c3b51869$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $dd9b6854c3b51869$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $dd9b6854c3b51869$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $dd9b6854c3b51869$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $dd9b6854c3b51869$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $dd9b6854c3b51869$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $dd9b6854c3b51869$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $dd9b6854c3b51869$var$flow(src);
        }
    };
}
$dd9b6854c3b51869$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $dd9b6854c3b51869$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$dd9b6854c3b51869$var$Readable.prototype.on = function(ev, fn) {
    var res = $dmvBY.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $dd9b6854c3b51869$var$debug('on readable', state.length, state.reading);
            if (state.length) $dd9b6854c3b51869$var$emitReadable(this);
            else if (!state.reading) $fHA2F.nextTick($dd9b6854c3b51869$var$nReadingNextTick, this);
        }
    }
    return res;
};
$dd9b6854c3b51869$var$Readable.prototype.addListener = $dd9b6854c3b51869$var$Readable.prototype.on;
$dd9b6854c3b51869$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $dmvBY.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $fHA2F.nextTick($dd9b6854c3b51869$var$updateReadableListening, this);
    return res;
};
$dd9b6854c3b51869$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $dmvBY.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $fHA2F.nextTick($dd9b6854c3b51869$var$updateReadableListening, this);
    return res;
};
function $dd9b6854c3b51869$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount('data') > 0) self1.resume();
}
function $dd9b6854c3b51869$var$nReadingNextTick(self1) {
    $dd9b6854c3b51869$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$dd9b6854c3b51869$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $dd9b6854c3b51869$var$debug('resume');
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $dd9b6854c3b51869$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $dd9b6854c3b51869$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $fHA2F.nextTick($dd9b6854c3b51869$var$resume_, stream, state);
    }
}
function $dd9b6854c3b51869$var$resume_(stream, state) {
    $dd9b6854c3b51869$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $dd9b6854c3b51869$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$dd9b6854c3b51869$var$Readable.prototype.pause = function() {
    $dd9b6854c3b51869$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $dd9b6854c3b51869$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function $dd9b6854c3b51869$var$flow(stream) {
    var state = stream._readableState;
    $dd9b6854c3b51869$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$dd9b6854c3b51869$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $dd9b6854c3b51869$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $dd9b6854c3b51869$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $dd9b6854c3b51869$var$kProxyEvents.length; n++)stream.on($dd9b6854c3b51869$var$kProxyEvents[n], this.emit.bind(this, $dd9b6854c3b51869$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $dd9b6854c3b51869$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === 'function') $dd9b6854c3b51869$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($dd9b6854c3b51869$var$createReadableStreamAsyncIterator === undefined) $dd9b6854c3b51869$var$createReadableStreamAsyncIterator = (parcelRequire("cGAf5"));
    return $dd9b6854c3b51869$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($dd9b6854c3b51869$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($dd9b6854c3b51869$var$Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($dd9b6854c3b51869$var$Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$dd9b6854c3b51869$var$Readable._fromList = $dd9b6854c3b51869$var$fromList;
Object.defineProperty($dd9b6854c3b51869$var$Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $dd9b6854c3b51869$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $dd9b6854c3b51869$var$endReadable(stream) {
    var state = stream._readableState;
    $dd9b6854c3b51869$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $fHA2F.nextTick($dd9b6854c3b51869$var$endReadableNT, state, stream);
    }
}
function $dd9b6854c3b51869$var$endReadableNT(state, stream) {
    $dd9b6854c3b51869$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === 'function') $dd9b6854c3b51869$var$Readable.from = function(iterable, opts) {
    if ($dd9b6854c3b51869$var$from === undefined) $dd9b6854c3b51869$var$from = (parcelRequire("76MJd"));
    return $dd9b6854c3b51869$var$from($dd9b6854c3b51869$var$Readable, iterable, opts);
};
function $dd9b6854c3b51869$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("fHA2F", function(module, exports) {
// shim for using process in browser
var $02f334f92ddb9d4d$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $02f334f92ddb9d4d$var$cachedSetTimeout;
var $02f334f92ddb9d4d$var$cachedClearTimeout;
function $02f334f92ddb9d4d$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $02f334f92ddb9d4d$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $02f334f92ddb9d4d$var$cachedSetTimeout = setTimeout;
        else $02f334f92ddb9d4d$var$cachedSetTimeout = $02f334f92ddb9d4d$var$defaultSetTimout;
    } catch (e) {
        $02f334f92ddb9d4d$var$cachedSetTimeout = $02f334f92ddb9d4d$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $02f334f92ddb9d4d$var$cachedClearTimeout = clearTimeout;
        else $02f334f92ddb9d4d$var$cachedClearTimeout = $02f334f92ddb9d4d$var$defaultClearTimeout;
    } catch (e) {
        $02f334f92ddb9d4d$var$cachedClearTimeout = $02f334f92ddb9d4d$var$defaultClearTimeout;
    }
})();
function $02f334f92ddb9d4d$var$runTimeout(fun) {
    if ($02f334f92ddb9d4d$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($02f334f92ddb9d4d$var$cachedSetTimeout === $02f334f92ddb9d4d$var$defaultSetTimout || !$02f334f92ddb9d4d$var$cachedSetTimeout) && setTimeout) {
        $02f334f92ddb9d4d$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $02f334f92ddb9d4d$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $02f334f92ddb9d4d$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $02f334f92ddb9d4d$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $02f334f92ddb9d4d$var$runClearTimeout(marker) {
    if ($02f334f92ddb9d4d$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($02f334f92ddb9d4d$var$cachedClearTimeout === $02f334f92ddb9d4d$var$defaultClearTimeout || !$02f334f92ddb9d4d$var$cachedClearTimeout) && clearTimeout) {
        $02f334f92ddb9d4d$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $02f334f92ddb9d4d$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $02f334f92ddb9d4d$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $02f334f92ddb9d4d$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $02f334f92ddb9d4d$var$queue = [];
var $02f334f92ddb9d4d$var$draining = false;
var $02f334f92ddb9d4d$var$currentQueue;
var $02f334f92ddb9d4d$var$queueIndex = -1;
function $02f334f92ddb9d4d$var$cleanUpNextTick() {
    if (!$02f334f92ddb9d4d$var$draining || !$02f334f92ddb9d4d$var$currentQueue) return;
    $02f334f92ddb9d4d$var$draining = false;
    if ($02f334f92ddb9d4d$var$currentQueue.length) $02f334f92ddb9d4d$var$queue = $02f334f92ddb9d4d$var$currentQueue.concat($02f334f92ddb9d4d$var$queue);
    else $02f334f92ddb9d4d$var$queueIndex = -1;
    if ($02f334f92ddb9d4d$var$queue.length) $02f334f92ddb9d4d$var$drainQueue();
}
function $02f334f92ddb9d4d$var$drainQueue() {
    if ($02f334f92ddb9d4d$var$draining) return;
    var timeout = $02f334f92ddb9d4d$var$runTimeout($02f334f92ddb9d4d$var$cleanUpNextTick);
    $02f334f92ddb9d4d$var$draining = true;
    var len = $02f334f92ddb9d4d$var$queue.length;
    while(len){
        $02f334f92ddb9d4d$var$currentQueue = $02f334f92ddb9d4d$var$queue;
        $02f334f92ddb9d4d$var$queue = [];
        while(++$02f334f92ddb9d4d$var$queueIndex < len)if ($02f334f92ddb9d4d$var$currentQueue) $02f334f92ddb9d4d$var$currentQueue[$02f334f92ddb9d4d$var$queueIndex].run();
        $02f334f92ddb9d4d$var$queueIndex = -1;
        len = $02f334f92ddb9d4d$var$queue.length;
    }
    $02f334f92ddb9d4d$var$currentQueue = null;
    $02f334f92ddb9d4d$var$draining = false;
    $02f334f92ddb9d4d$var$runClearTimeout(timeout);
}
$02f334f92ddb9d4d$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $02f334f92ddb9d4d$var$queue.push(new $02f334f92ddb9d4d$var$Item(fun, args));
    if ($02f334f92ddb9d4d$var$queue.length === 1 && !$02f334f92ddb9d4d$var$draining) $02f334f92ddb9d4d$var$runTimeout($02f334f92ddb9d4d$var$drainQueue);
};
// v8 likes predictible objects
function $02f334f92ddb9d4d$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$02f334f92ddb9d4d$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$02f334f92ddb9d4d$var$process.title = 'browser';
$02f334f92ddb9d4d$var$process.browser = true;
$02f334f92ddb9d4d$var$process.env = {};
$02f334f92ddb9d4d$var$process.argv = [];
$02f334f92ddb9d4d$var$process.version = ''; // empty string to avoid regexp issues
$02f334f92ddb9d4d$var$process.versions = {};
function $02f334f92ddb9d4d$var$noop() {}
$02f334f92ddb9d4d$var$process.on = $02f334f92ddb9d4d$var$noop;
$02f334f92ddb9d4d$var$process.addListener = $02f334f92ddb9d4d$var$noop;
$02f334f92ddb9d4d$var$process.once = $02f334f92ddb9d4d$var$noop;
$02f334f92ddb9d4d$var$process.off = $02f334f92ddb9d4d$var$noop;
$02f334f92ddb9d4d$var$process.removeListener = $02f334f92ddb9d4d$var$noop;
$02f334f92ddb9d4d$var$process.removeAllListeners = $02f334f92ddb9d4d$var$noop;
$02f334f92ddb9d4d$var$process.emit = $02f334f92ddb9d4d$var$noop;
$02f334f92ddb9d4d$var$process.prependListener = $02f334f92ddb9d4d$var$noop;
$02f334f92ddb9d4d$var$process.prependOnceListener = $02f334f92ddb9d4d$var$noop;
$02f334f92ddb9d4d$var$process.listeners = function(name) {
    return [];
};
$02f334f92ddb9d4d$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$02f334f92ddb9d4d$var$process.cwd = function() {
    return '/';
};
$02f334f92ddb9d4d$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$02f334f92ddb9d4d$var$process.umask = function() {
    return 0;
};

});

parcelRegister("dmvBY", function(module, exports) {

module.exports = (parcelRequire("3TvIx")).EventEmitter;

});

parcelRegister("lGjml", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $fc8c8991f1d2042a$export$a143d493d941bafc, (v) => $fc8c8991f1d2042a$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $fc8c8991f1d2042a$export$e4cf37d7f6fb9e0a, (v) => $fc8c8991f1d2042a$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $fc8c8991f1d2042a$export$f99ded8fe4b79145, (v) => $fc8c8991f1d2042a$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $fc8c8991f1d2042a$export$599f31c3813fae4d, (v) => $fc8c8991f1d2042a$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $fc8c8991f1d2042a$export$a143d493d941bafc;
var $fc8c8991f1d2042a$export$e4cf37d7f6fb9e0a;
var $fc8c8991f1d2042a$export$f99ded8fe4b79145;
var $fc8c8991f1d2042a$export$599f31c3813fae4d;
'use strict';

var $cnhoE = parcelRequire("cnhoE");

var $4he7P = parcelRequire("4he7P");
const $fc8c8991f1d2042a$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$fc8c8991f1d2042a$export$a143d493d941bafc = $fc8c8991f1d2042a$var$Buffer;
$fc8c8991f1d2042a$export$e4cf37d7f6fb9e0a = $fc8c8991f1d2042a$var$SlowBuffer;
$fc8c8991f1d2042a$export$f99ded8fe4b79145 = 50;
const $fc8c8991f1d2042a$var$K_MAX_LENGTH = 0x7fffffff;
$fc8c8991f1d2042a$export$599f31c3813fae4d = $fc8c8991f1d2042a$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $fc8c8991f1d2042a$var$Buffer.TYPED_ARRAY_SUPPORT = $fc8c8991f1d2042a$var$typedArraySupport();
if (!$fc8c8991f1d2042a$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $fc8c8991f1d2042a$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($fc8c8991f1d2042a$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$fc8c8991f1d2042a$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($fc8c8991f1d2042a$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$fc8c8991f1d2042a$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $fc8c8991f1d2042a$var$createBuffer(length) {
    if (length > $fc8c8991f1d2042a$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $fc8c8991f1d2042a$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $fc8c8991f1d2042a$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $fc8c8991f1d2042a$var$allocUnsafe(arg);
    }
    return $fc8c8991f1d2042a$var$from(arg, encodingOrOffset, length);
}
$fc8c8991f1d2042a$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $fc8c8991f1d2042a$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $fc8c8991f1d2042a$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $fc8c8991f1d2042a$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($fc8c8991f1d2042a$var$isInstance(value, ArrayBuffer) || value && $fc8c8991f1d2042a$var$isInstance(value.buffer, ArrayBuffer)) return $fc8c8991f1d2042a$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($fc8c8991f1d2042a$var$isInstance(value, SharedArrayBuffer) || value && $fc8c8991f1d2042a$var$isInstance(value.buffer, SharedArrayBuffer))) return $fc8c8991f1d2042a$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $fc8c8991f1d2042a$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $fc8c8991f1d2042a$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $fc8c8991f1d2042a$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $fc8c8991f1d2042a$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $fc8c8991f1d2042a$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($fc8c8991f1d2042a$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($fc8c8991f1d2042a$var$Buffer, Uint8Array);
function $fc8c8991f1d2042a$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $fc8c8991f1d2042a$var$alloc(size, fill, encoding) {
    $fc8c8991f1d2042a$var$assertSize(size);
    if (size <= 0) return $fc8c8991f1d2042a$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $fc8c8991f1d2042a$var$createBuffer(size).fill(fill, encoding) : $fc8c8991f1d2042a$var$createBuffer(size).fill(fill);
    return $fc8c8991f1d2042a$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $fc8c8991f1d2042a$var$Buffer.alloc = function(size, fill, encoding) {
    return $fc8c8991f1d2042a$var$alloc(size, fill, encoding);
};
function $fc8c8991f1d2042a$var$allocUnsafe(size) {
    $fc8c8991f1d2042a$var$assertSize(size);
    return $fc8c8991f1d2042a$var$createBuffer(size < 0 ? 0 : $fc8c8991f1d2042a$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $fc8c8991f1d2042a$var$Buffer.allocUnsafe = function(size) {
    return $fc8c8991f1d2042a$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $fc8c8991f1d2042a$var$Buffer.allocUnsafeSlow = function(size) {
    return $fc8c8991f1d2042a$var$allocUnsafe(size);
};
function $fc8c8991f1d2042a$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$fc8c8991f1d2042a$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $fc8c8991f1d2042a$var$byteLength(string, encoding) | 0;
    let buf = $fc8c8991f1d2042a$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $fc8c8991f1d2042a$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $fc8c8991f1d2042a$var$checked(array.length) | 0;
    const buf = $fc8c8991f1d2042a$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $fc8c8991f1d2042a$var$fromArrayView(arrayView) {
    if ($fc8c8991f1d2042a$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $fc8c8991f1d2042a$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $fc8c8991f1d2042a$var$fromArrayLike(arrayView);
}
function $fc8c8991f1d2042a$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $fc8c8991f1d2042a$var$Buffer.prototype);
    return buf;
}
function $fc8c8991f1d2042a$var$fromObject(obj) {
    if ($fc8c8991f1d2042a$var$Buffer.isBuffer(obj)) {
        const len = $fc8c8991f1d2042a$var$checked(obj.length) | 0;
        const buf = $fc8c8991f1d2042a$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $fc8c8991f1d2042a$var$numberIsNaN(obj.length)) return $fc8c8991f1d2042a$var$createBuffer(0);
        return $fc8c8991f1d2042a$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $fc8c8991f1d2042a$var$fromArrayLike(obj.data);
}
function $fc8c8991f1d2042a$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $fc8c8991f1d2042a$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $fc8c8991f1d2042a$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $fc8c8991f1d2042a$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $fc8c8991f1d2042a$var$Buffer.alloc(+length);
}
$fc8c8991f1d2042a$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $fc8c8991f1d2042a$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$fc8c8991f1d2042a$var$Buffer.compare = function compare(a, b) {
    if ($fc8c8991f1d2042a$var$isInstance(a, Uint8Array)) a = $fc8c8991f1d2042a$var$Buffer.from(a, a.offset, a.byteLength);
    if ($fc8c8991f1d2042a$var$isInstance(b, Uint8Array)) b = $fc8c8991f1d2042a$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$fc8c8991f1d2042a$var$Buffer.isBuffer(a) || !$fc8c8991f1d2042a$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$fc8c8991f1d2042a$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$fc8c8991f1d2042a$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $fc8c8991f1d2042a$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $fc8c8991f1d2042a$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($fc8c8991f1d2042a$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$fc8c8991f1d2042a$var$Buffer.isBuffer(buf)) buf = $fc8c8991f1d2042a$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$fc8c8991f1d2042a$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $fc8c8991f1d2042a$var$byteLength(string, encoding) {
    if ($fc8c8991f1d2042a$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $fc8c8991f1d2042a$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $fc8c8991f1d2042a$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $fc8c8991f1d2042a$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $fc8c8991f1d2042a$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$fc8c8991f1d2042a$var$Buffer.byteLength = $fc8c8991f1d2042a$var$byteLength;
function $fc8c8991f1d2042a$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $fc8c8991f1d2042a$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $fc8c8991f1d2042a$var$utf8Slice(this, start, end);
        case 'ascii':
            return $fc8c8991f1d2042a$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $fc8c8991f1d2042a$var$latin1Slice(this, start, end);
        case 'base64':
            return $fc8c8991f1d2042a$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $fc8c8991f1d2042a$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$fc8c8991f1d2042a$var$Buffer.prototype._isBuffer = true;
function $fc8c8991f1d2042a$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$fc8c8991f1d2042a$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$fc8c8991f1d2042a$var$swap(this, i, i + 1);
    return this;
};
$fc8c8991f1d2042a$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $fc8c8991f1d2042a$var$swap(this, i, i + 3);
        $fc8c8991f1d2042a$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$fc8c8991f1d2042a$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $fc8c8991f1d2042a$var$swap(this, i, i + 7);
        $fc8c8991f1d2042a$var$swap(this, i + 1, i + 6);
        $fc8c8991f1d2042a$var$swap(this, i + 2, i + 5);
        $fc8c8991f1d2042a$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$fc8c8991f1d2042a$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $fc8c8991f1d2042a$var$utf8Slice(this, 0, length);
    return $fc8c8991f1d2042a$var$slowToString.apply(this, arguments);
};
$fc8c8991f1d2042a$var$Buffer.prototype.toLocaleString = $fc8c8991f1d2042a$var$Buffer.prototype.toString;
$fc8c8991f1d2042a$var$Buffer.prototype.equals = function equals(b) {
    if (!$fc8c8991f1d2042a$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $fc8c8991f1d2042a$var$Buffer.compare(this, b) === 0;
};
$fc8c8991f1d2042a$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $fc8c8991f1d2042a$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($fc8c8991f1d2042a$var$customInspectSymbol) $fc8c8991f1d2042a$var$Buffer.prototype[$fc8c8991f1d2042a$var$customInspectSymbol] = $fc8c8991f1d2042a$var$Buffer.prototype.inspect;
$fc8c8991f1d2042a$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($fc8c8991f1d2042a$var$isInstance(target, Uint8Array)) target = $fc8c8991f1d2042a$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$fc8c8991f1d2042a$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $fc8c8991f1d2042a$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($fc8c8991f1d2042a$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $fc8c8991f1d2042a$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($fc8c8991f1d2042a$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $fc8c8991f1d2042a$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $fc8c8991f1d2042a$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $fc8c8991f1d2042a$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$fc8c8991f1d2042a$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$fc8c8991f1d2042a$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $fc8c8991f1d2042a$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$fc8c8991f1d2042a$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $fc8c8991f1d2042a$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $fc8c8991f1d2042a$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($fc8c8991f1d2042a$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $fc8c8991f1d2042a$var$utf8Write(buf, string, offset, length) {
    return $fc8c8991f1d2042a$var$blitBuffer($fc8c8991f1d2042a$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $fc8c8991f1d2042a$var$asciiWrite(buf, string, offset, length) {
    return $fc8c8991f1d2042a$var$blitBuffer($fc8c8991f1d2042a$var$asciiToBytes(string), buf, offset, length);
}
function $fc8c8991f1d2042a$var$base64Write(buf, string, offset, length) {
    return $fc8c8991f1d2042a$var$blitBuffer($fc8c8991f1d2042a$var$base64ToBytes(string), buf, offset, length);
}
function $fc8c8991f1d2042a$var$ucs2Write(buf, string, offset, length) {
    return $fc8c8991f1d2042a$var$blitBuffer($fc8c8991f1d2042a$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$fc8c8991f1d2042a$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $fc8c8991f1d2042a$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $fc8c8991f1d2042a$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $fc8c8991f1d2042a$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $fc8c8991f1d2042a$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $fc8c8991f1d2042a$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$fc8c8991f1d2042a$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $fc8c8991f1d2042a$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $cnhoE.fromByteArray(buf);
    else return $cnhoE.fromByteArray(buf.slice(start, end));
}
function $fc8c8991f1d2042a$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $fc8c8991f1d2042a$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $fc8c8991f1d2042a$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $fc8c8991f1d2042a$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $fc8c8991f1d2042a$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $fc8c8991f1d2042a$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $fc8c8991f1d2042a$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $fc8c8991f1d2042a$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $fc8c8991f1d2042a$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $fc8c8991f1d2042a$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $fc8c8991f1d2042a$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$fc8c8991f1d2042a$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $fc8c8991f1d2042a$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $fc8c8991f1d2042a$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$fc8c8991f1d2042a$var$Buffer.prototype.readUintLE = $fc8c8991f1d2042a$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $fc8c8991f1d2042a$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$fc8c8991f1d2042a$var$Buffer.prototype.readUintBE = $fc8c8991f1d2042a$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $fc8c8991f1d2042a$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$fc8c8991f1d2042a$var$Buffer.prototype.readUint8 = $fc8c8991f1d2042a$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $fc8c8991f1d2042a$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$fc8c8991f1d2042a$var$Buffer.prototype.readUint16LE = $fc8c8991f1d2042a$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $fc8c8991f1d2042a$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$fc8c8991f1d2042a$var$Buffer.prototype.readUint16BE = $fc8c8991f1d2042a$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $fc8c8991f1d2042a$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$fc8c8991f1d2042a$var$Buffer.prototype.readUint32LE = $fc8c8991f1d2042a$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $fc8c8991f1d2042a$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$fc8c8991f1d2042a$var$Buffer.prototype.readUint32BE = $fc8c8991f1d2042a$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $fc8c8991f1d2042a$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$fc8c8991f1d2042a$var$Buffer.prototype.readBigUInt64LE = $fc8c8991f1d2042a$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $fc8c8991f1d2042a$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $fc8c8991f1d2042a$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$fc8c8991f1d2042a$var$Buffer.prototype.readBigUInt64BE = $fc8c8991f1d2042a$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $fc8c8991f1d2042a$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $fc8c8991f1d2042a$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$fc8c8991f1d2042a$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $fc8c8991f1d2042a$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$fc8c8991f1d2042a$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $fc8c8991f1d2042a$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$fc8c8991f1d2042a$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $fc8c8991f1d2042a$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$fc8c8991f1d2042a$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $fc8c8991f1d2042a$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$fc8c8991f1d2042a$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $fc8c8991f1d2042a$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$fc8c8991f1d2042a$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $fc8c8991f1d2042a$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$fc8c8991f1d2042a$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $fc8c8991f1d2042a$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$fc8c8991f1d2042a$var$Buffer.prototype.readBigInt64LE = $fc8c8991f1d2042a$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $fc8c8991f1d2042a$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $fc8c8991f1d2042a$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$fc8c8991f1d2042a$var$Buffer.prototype.readBigInt64BE = $fc8c8991f1d2042a$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $fc8c8991f1d2042a$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $fc8c8991f1d2042a$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$fc8c8991f1d2042a$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $fc8c8991f1d2042a$var$checkOffset(offset, 4, this.length);
    return $4he7P.read(this, offset, true, 23, 4);
};
$fc8c8991f1d2042a$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $fc8c8991f1d2042a$var$checkOffset(offset, 4, this.length);
    return $4he7P.read(this, offset, false, 23, 4);
};
$fc8c8991f1d2042a$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $fc8c8991f1d2042a$var$checkOffset(offset, 8, this.length);
    return $4he7P.read(this, offset, true, 52, 8);
};
$fc8c8991f1d2042a$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $fc8c8991f1d2042a$var$checkOffset(offset, 8, this.length);
    return $4he7P.read(this, offset, false, 52, 8);
};
function $fc8c8991f1d2042a$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$fc8c8991f1d2042a$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$fc8c8991f1d2042a$var$Buffer.prototype.writeUintLE = $fc8c8991f1d2042a$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $fc8c8991f1d2042a$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$fc8c8991f1d2042a$var$Buffer.prototype.writeUintBE = $fc8c8991f1d2042a$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $fc8c8991f1d2042a$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$fc8c8991f1d2042a$var$Buffer.prototype.writeUint8 = $fc8c8991f1d2042a$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $fc8c8991f1d2042a$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$fc8c8991f1d2042a$var$Buffer.prototype.writeUint16LE = $fc8c8991f1d2042a$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $fc8c8991f1d2042a$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$fc8c8991f1d2042a$var$Buffer.prototype.writeUint16BE = $fc8c8991f1d2042a$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $fc8c8991f1d2042a$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$fc8c8991f1d2042a$var$Buffer.prototype.writeUint32LE = $fc8c8991f1d2042a$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $fc8c8991f1d2042a$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$fc8c8991f1d2042a$var$Buffer.prototype.writeUint32BE = $fc8c8991f1d2042a$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $fc8c8991f1d2042a$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $fc8c8991f1d2042a$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $fc8c8991f1d2042a$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $fc8c8991f1d2042a$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $fc8c8991f1d2042a$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$fc8c8991f1d2042a$var$Buffer.prototype.writeBigUInt64LE = $fc8c8991f1d2042a$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $fc8c8991f1d2042a$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$fc8c8991f1d2042a$var$Buffer.prototype.writeBigUInt64BE = $fc8c8991f1d2042a$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $fc8c8991f1d2042a$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$fc8c8991f1d2042a$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $fc8c8991f1d2042a$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$fc8c8991f1d2042a$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $fc8c8991f1d2042a$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$fc8c8991f1d2042a$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $fc8c8991f1d2042a$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$fc8c8991f1d2042a$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $fc8c8991f1d2042a$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$fc8c8991f1d2042a$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $fc8c8991f1d2042a$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$fc8c8991f1d2042a$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $fc8c8991f1d2042a$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$fc8c8991f1d2042a$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $fc8c8991f1d2042a$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$fc8c8991f1d2042a$var$Buffer.prototype.writeBigInt64LE = $fc8c8991f1d2042a$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $fc8c8991f1d2042a$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$fc8c8991f1d2042a$var$Buffer.prototype.writeBigInt64BE = $fc8c8991f1d2042a$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $fc8c8991f1d2042a$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $fc8c8991f1d2042a$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $fc8c8991f1d2042a$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $fc8c8991f1d2042a$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $4he7P.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$fc8c8991f1d2042a$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $fc8c8991f1d2042a$var$writeFloat(this, value, offset, true, noAssert);
};
$fc8c8991f1d2042a$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $fc8c8991f1d2042a$var$writeFloat(this, value, offset, false, noAssert);
};
function $fc8c8991f1d2042a$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $fc8c8991f1d2042a$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $4he7P.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$fc8c8991f1d2042a$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $fc8c8991f1d2042a$var$writeDouble(this, value, offset, true, noAssert);
};
$fc8c8991f1d2042a$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $fc8c8991f1d2042a$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$fc8c8991f1d2042a$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$fc8c8991f1d2042a$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$fc8c8991f1d2042a$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$fc8c8991f1d2042a$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $fc8c8991f1d2042a$var$Buffer.isBuffer(val) ? val : $fc8c8991f1d2042a$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $fc8c8991f1d2042a$var$errors = {};
function $fc8c8991f1d2042a$var$E(sym, getMessage, Base) {
    $fc8c8991f1d2042a$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$fc8c8991f1d2042a$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$fc8c8991f1d2042a$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$fc8c8991f1d2042a$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $fc8c8991f1d2042a$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $fc8c8991f1d2042a$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $fc8c8991f1d2042a$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $fc8c8991f1d2042a$var$checkBounds(buf, offset, byteLength) {
    $fc8c8991f1d2042a$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $fc8c8991f1d2042a$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $fc8c8991f1d2042a$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $fc8c8991f1d2042a$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $fc8c8991f1d2042a$var$checkBounds(buf, offset, byteLength);
}
function $fc8c8991f1d2042a$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $fc8c8991f1d2042a$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $fc8c8991f1d2042a$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $fc8c8991f1d2042a$var$validateNumber(value, type);
        throw new $fc8c8991f1d2042a$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $fc8c8991f1d2042a$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $fc8c8991f1d2042a$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $fc8c8991f1d2042a$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $fc8c8991f1d2042a$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($fc8c8991f1d2042a$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $fc8c8991f1d2042a$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $fc8c8991f1d2042a$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $fc8c8991f1d2042a$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $fc8c8991f1d2042a$var$base64ToBytes(str) {
    return $cnhoE.toByteArray($fc8c8991f1d2042a$var$base64clean(str));
}
function $fc8c8991f1d2042a$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $fc8c8991f1d2042a$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $fc8c8991f1d2042a$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $fc8c8991f1d2042a$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $fc8c8991f1d2042a$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $fc8c8991f1d2042a$var$BufferBigIntNotDefined : fn;
}
function $fc8c8991f1d2042a$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("cnhoE", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $9025209d7d4fb1a3$export$d622b2ad8d90c771, (v) => $9025209d7d4fb1a3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $9025209d7d4fb1a3$export$6100ba28696e12de, (v) => $9025209d7d4fb1a3$export$6100ba28696e12de = v);
var $9025209d7d4fb1a3$export$a48f0734ac7c2329;
var $9025209d7d4fb1a3$export$d622b2ad8d90c771;
var $9025209d7d4fb1a3$export$6100ba28696e12de;
'use strict';
$9025209d7d4fb1a3$export$a48f0734ac7c2329 = $9025209d7d4fb1a3$var$byteLength;
$9025209d7d4fb1a3$export$d622b2ad8d90c771 = $9025209d7d4fb1a3$var$toByteArray;
$9025209d7d4fb1a3$export$6100ba28696e12de = $9025209d7d4fb1a3$var$fromByteArray;
var $9025209d7d4fb1a3$var$lookup = [];
var $9025209d7d4fb1a3$var$revLookup = [];
var $9025209d7d4fb1a3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $9025209d7d4fb1a3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $9025209d7d4fb1a3$var$i = 0, $9025209d7d4fb1a3$var$len = $9025209d7d4fb1a3$var$code.length; $9025209d7d4fb1a3$var$i < $9025209d7d4fb1a3$var$len; ++$9025209d7d4fb1a3$var$i){
    $9025209d7d4fb1a3$var$lookup[$9025209d7d4fb1a3$var$i] = $9025209d7d4fb1a3$var$code[$9025209d7d4fb1a3$var$i];
    $9025209d7d4fb1a3$var$revLookup[$9025209d7d4fb1a3$var$code.charCodeAt($9025209d7d4fb1a3$var$i)] = $9025209d7d4fb1a3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$9025209d7d4fb1a3$var$revLookup['-'.charCodeAt(0)] = 62;
$9025209d7d4fb1a3$var$revLookup['_'.charCodeAt(0)] = 63;
function $9025209d7d4fb1a3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $9025209d7d4fb1a3$var$byteLength(b64) {
    var lens = $9025209d7d4fb1a3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $9025209d7d4fb1a3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $9025209d7d4fb1a3$var$toByteArray(b64) {
    var tmp;
    var lens = $9025209d7d4fb1a3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $9025209d7d4fb1a3$var$Arr($9025209d7d4fb1a3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $9025209d7d4fb1a3$var$revLookup[b64.charCodeAt(i)] << 18 | $9025209d7d4fb1a3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $9025209d7d4fb1a3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $9025209d7d4fb1a3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $9025209d7d4fb1a3$var$revLookup[b64.charCodeAt(i)] << 2 | $9025209d7d4fb1a3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $9025209d7d4fb1a3$var$revLookup[b64.charCodeAt(i)] << 10 | $9025209d7d4fb1a3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $9025209d7d4fb1a3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $9025209d7d4fb1a3$var$tripletToBase64(num) {
    return $9025209d7d4fb1a3$var$lookup[num >> 18 & 0x3F] + $9025209d7d4fb1a3$var$lookup[num >> 12 & 0x3F] + $9025209d7d4fb1a3$var$lookup[num >> 6 & 0x3F] + $9025209d7d4fb1a3$var$lookup[num & 0x3F];
}
function $9025209d7d4fb1a3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($9025209d7d4fb1a3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $9025209d7d4fb1a3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($9025209d7d4fb1a3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($9025209d7d4fb1a3$var$lookup[tmp >> 2] + $9025209d7d4fb1a3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($9025209d7d4fb1a3$var$lookup[tmp >> 10] + $9025209d7d4fb1a3$var$lookup[tmp >> 4 & 0x3F] + $9025209d7d4fb1a3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("4he7P", function(module, exports) {

$parcel$export(module.exports, "read", () => $31d3b4f101754880$export$aafa59e2e03f2942, (v) => $31d3b4f101754880$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $31d3b4f101754880$export$68d8715fc104d294, (v) => $31d3b4f101754880$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $31d3b4f101754880$export$aafa59e2e03f2942;
var $31d3b4f101754880$export$68d8715fc104d294;
$31d3b4f101754880$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$31d3b4f101754880$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("k3LaP", function(module, exports) {
"use strict";

});

parcelRegister("8ruJs", function(module, exports) {
'use strict';
function $6258af1c17076c8e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6258af1c17076c8e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6258af1c17076c8e$var$ownKeys(Object(source), !0).forEach(function(key) {
            $6258af1c17076c8e$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6258af1c17076c8e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6258af1c17076c8e$var$_defineProperty(obj, key, value) {
    key = $6258af1c17076c8e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6258af1c17076c8e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6258af1c17076c8e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $6258af1c17076c8e$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $6258af1c17076c8e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6258af1c17076c8e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6258af1c17076c8e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $6258af1c17076c8e$var$_toPropertyKey(arg) {
    var key = $6258af1c17076c8e$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $6258af1c17076c8e$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $lGjml = parcelRequire("lGjml");
var $6258af1c17076c8e$var$Buffer = $lGjml.Buffer;

var $k3LaP = parcelRequire("k3LaP");
var $6258af1c17076c8e$var$inspect = $k3LaP.inspect;
var $6258af1c17076c8e$var$custom = $6258af1c17076c8e$var$inspect && $6258af1c17076c8e$var$inspect.custom || 'inspect';
function $6258af1c17076c8e$var$copyBuffer(src, target, offset) {
    $6258af1c17076c8e$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $6258af1c17076c8e$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $6258af1c17076c8e$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $6258af1c17076c8e$var$Buffer.alloc(0);
                var ret = $6258af1c17076c8e$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $6258af1c17076c8e$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $6258af1c17076c8e$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $6258af1c17076c8e$var$custom,
            value: function value(_, options) {
                return $6258af1c17076c8e$var$inspect(this, $6258af1c17076c8e$var$_objectSpread($6258af1c17076c8e$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("hsXaW", function(module, exports) {

var $fHA2F = parcelRequire("fHA2F");
'use strict';
// undocumented cb() API, needed for core, not for public API
function $cb72f432bf2cebda$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $fHA2F.nextTick($cb72f432bf2cebda$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $fHA2F.nextTick($cb72f432bf2cebda$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $fHA2F.nextTick($cb72f432bf2cebda$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $fHA2F.nextTick($cb72f432bf2cebda$var$emitErrorAndCloseNT, _this, err);
            } else $fHA2F.nextTick($cb72f432bf2cebda$var$emitCloseNT, _this);
        } else if (cb) {
            $fHA2F.nextTick($cb72f432bf2cebda$var$emitCloseNT, _this);
            cb(err);
        } else $fHA2F.nextTick($cb72f432bf2cebda$var$emitCloseNT, _this);
    });
    return this;
}
function $cb72f432bf2cebda$var$emitErrorAndCloseNT(self, err) {
    $cb72f432bf2cebda$var$emitErrorNT(self, err);
    $cb72f432bf2cebda$var$emitCloseNT(self);
}
function $cb72f432bf2cebda$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function $cb72f432bf2cebda$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $cb72f432bf2cebda$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
function $cb72f432bf2cebda$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: $cb72f432bf2cebda$var$destroy,
    undestroy: $cb72f432bf2cebda$var$undestroy,
    errorOrDestroy: $cb72f432bf2cebda$var$errorOrDestroy
};

});

parcelRegister("8kpuq", function(module, exports) {
'use strict';

var $6103f6b14031dba0$var$ERR_INVALID_OPT_VALUE = (parcelRequire("igp20")).codes.ERR_INVALID_OPT_VALUE;
function $6103f6b14031dba0$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $6103f6b14031dba0$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $6103f6b14031dba0$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new $6103f6b14031dba0$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $6103f6b14031dba0$var$getHighWaterMark
};

});
parcelRegister("igp20", function(module, exports) {

$parcel$export(module.exports, "codes", () => $d4bd234d0cb04b83$export$e45cb6485273080e, (v) => $d4bd234d0cb04b83$export$e45cb6485273080e = v);
var $d4bd234d0cb04b83$export$e45cb6485273080e;
'use strict';
function $d4bd234d0cb04b83$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $d4bd234d0cb04b83$var$codes = {};
function $d4bd234d0cb04b83$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $d4bd234d0cb04b83$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $d4bd234d0cb04b83$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $d4bd234d0cb04b83$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $d4bd234d0cb04b83$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $d4bd234d0cb04b83$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $d4bd234d0cb04b83$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$d4bd234d0cb04b83$var$createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$d4bd234d0cb04b83$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $d4bd234d0cb04b83$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($d4bd234d0cb04b83$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($d4bd234d0cb04b83$var$oneOf(expected, 'type'));
    else {
        var type = $d4bd234d0cb04b83$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($d4bd234d0cb04b83$var$oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$d4bd234d0cb04b83$var$createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
$d4bd234d0cb04b83$var$createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
$d4bd234d0cb04b83$var$createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
$d4bd234d0cb04b83$var$createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
$d4bd234d0cb04b83$var$createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
$d4bd234d0cb04b83$var$createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
$d4bd234d0cb04b83$var$createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
$d4bd234d0cb04b83$var$createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$d4bd234d0cb04b83$var$createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
$d4bd234d0cb04b83$var$createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
$d4bd234d0cb04b83$export$e45cb6485273080e = $d4bd234d0cb04b83$var$codes;

});


parcelRegister("8PgDm", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $fHA2F = parcelRequire("fHA2F");
'use strict';
/*<replacement>*/ var $66cffd4f25d5ea0c$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $66cffd4f25d5ea0c$var$Duplex;

var $j1BLH = parcelRequire("j1BLH");

var $abSdI = parcelRequire("abSdI");

(parcelRequire("83QSq"))($66cffd4f25d5ea0c$var$Duplex, $j1BLH);
// Allow the keys array to be GC'ed.
var $66cffd4f25d5ea0c$var$keys = $66cffd4f25d5ea0c$var$objectKeys($abSdI.prototype);
for(var $66cffd4f25d5ea0c$var$v = 0; $66cffd4f25d5ea0c$var$v < $66cffd4f25d5ea0c$var$keys.length; $66cffd4f25d5ea0c$var$v++){
    var $66cffd4f25d5ea0c$var$method = $66cffd4f25d5ea0c$var$keys[$66cffd4f25d5ea0c$var$v];
    if (!$66cffd4f25d5ea0c$var$Duplex.prototype[$66cffd4f25d5ea0c$var$method]) $66cffd4f25d5ea0c$var$Duplex.prototype[$66cffd4f25d5ea0c$var$method] = $abSdI.prototype[$66cffd4f25d5ea0c$var$method];
}
function $66cffd4f25d5ea0c$var$Duplex(options) {
    if (!(this instanceof $66cffd4f25d5ea0c$var$Duplex)) return new $66cffd4f25d5ea0c$var$Duplex(options);
    $j1BLH.call(this, options);
    $abSdI.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', $66cffd4f25d5ea0c$var$onend);
        }
    }
}
Object.defineProperty($66cffd4f25d5ea0c$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($66cffd4f25d5ea0c$var$Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($66cffd4f25d5ea0c$var$Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $66cffd4f25d5ea0c$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $fHA2F.nextTick($66cffd4f25d5ea0c$var$onEndNT, this);
}
function $66cffd4f25d5ea0c$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($66cffd4f25d5ea0c$var$Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("abSdI", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $fHA2F = parcelRequire("fHA2F");
'use strict';
module.exports = $76b4fd7e7048b416$var$Writable;
/* <replacement> */ function $76b4fd7e7048b416$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $76b4fd7e7048b416$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $76b4fd7e7048b416$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $76b4fd7e7048b416$var$Duplex;
/*</replacement>*/ $76b4fd7e7048b416$var$Writable.WritableState = $76b4fd7e7048b416$var$WritableState;

/*<replacement>*/ var $76b4fd7e7048b416$var$internalUtil = {
    deprecate: (parcelRequire("bqR3D"))
};

var $dmvBY = parcelRequire("dmvBY");

var $lGjml = parcelRequire("lGjml");
var $76b4fd7e7048b416$require$Buffer = $lGjml.Buffer;
var $76b4fd7e7048b416$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $76b4fd7e7048b416$var$_uint8ArrayToBuffer(chunk) {
    return $76b4fd7e7048b416$require$Buffer.from(chunk);
}
function $76b4fd7e7048b416$var$_isUint8Array(obj) {
    return $76b4fd7e7048b416$require$Buffer.isBuffer(obj) || obj instanceof $76b4fd7e7048b416$var$OurUint8Array;
}

var $hsXaW = parcelRequire("hsXaW");

var $8kpuq = parcelRequire("8kpuq");
var $76b4fd7e7048b416$var$getHighWaterMark = $8kpuq.getHighWaterMark;

var $igp20 = parcelRequire("igp20");
var $76b4fd7e7048b416$require$_require$codes = $igp20.codes;
var $76b4fd7e7048b416$var$ERR_INVALID_ARG_TYPE = $76b4fd7e7048b416$require$_require$codes.ERR_INVALID_ARG_TYPE, $76b4fd7e7048b416$var$ERR_METHOD_NOT_IMPLEMENTED = $76b4fd7e7048b416$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $76b4fd7e7048b416$var$ERR_MULTIPLE_CALLBACK = $76b4fd7e7048b416$require$_require$codes.ERR_MULTIPLE_CALLBACK, $76b4fd7e7048b416$var$ERR_STREAM_CANNOT_PIPE = $76b4fd7e7048b416$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $76b4fd7e7048b416$var$ERR_STREAM_DESTROYED = $76b4fd7e7048b416$require$_require$codes.ERR_STREAM_DESTROYED, $76b4fd7e7048b416$var$ERR_STREAM_NULL_VALUES = $76b4fd7e7048b416$require$_require$codes.ERR_STREAM_NULL_VALUES, $76b4fd7e7048b416$var$ERR_STREAM_WRITE_AFTER_END = $76b4fd7e7048b416$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $76b4fd7e7048b416$var$ERR_UNKNOWN_ENCODING = $76b4fd7e7048b416$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $76b4fd7e7048b416$var$errorOrDestroy = $hsXaW.errorOrDestroy;

(parcelRequire("83QSq"))($76b4fd7e7048b416$var$Writable, $dmvBY);
function $76b4fd7e7048b416$var$nop() {}

function $76b4fd7e7048b416$var$WritableState(options, stream, isDuplex) {
    $76b4fd7e7048b416$var$Duplex = $76b4fd7e7048b416$var$Duplex || (parcelRequire("8PgDm"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $76b4fd7e7048b416$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $76b4fd7e7048b416$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $76b4fd7e7048b416$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $76b4fd7e7048b416$var$CorkedRequest(this);
}
$76b4fd7e7048b416$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($76b4fd7e7048b416$var$WritableState.prototype, 'buffer', {
            get: $76b4fd7e7048b416$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $76b4fd7e7048b416$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $76b4fd7e7048b416$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($76b4fd7e7048b416$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($76b4fd7e7048b416$var$realHasInstance.call(this, object)) return true;
            if (this !== $76b4fd7e7048b416$var$Writable) return false;
            return object && object._writableState instanceof $76b4fd7e7048b416$var$WritableState;
        }
    });
} else $76b4fd7e7048b416$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $76b4fd7e7048b416$var$Writable(options) {
    $76b4fd7e7048b416$var$Duplex = $76b4fd7e7048b416$var$Duplex || (parcelRequire("8PgDm"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $76b4fd7e7048b416$var$Duplex;
    if (!isDuplex && !$76b4fd7e7048b416$var$realHasInstance.call($76b4fd7e7048b416$var$Writable, this)) return new $76b4fd7e7048b416$var$Writable(options);
    this._writableState = new $76b4fd7e7048b416$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $dmvBY.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$76b4fd7e7048b416$var$Writable.prototype.pipe = function() {
    $76b4fd7e7048b416$var$errorOrDestroy(this, new $76b4fd7e7048b416$var$ERR_STREAM_CANNOT_PIPE());
};
function $76b4fd7e7048b416$var$writeAfterEnd(stream, cb) {
    var er = new $76b4fd7e7048b416$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $76b4fd7e7048b416$var$errorOrDestroy(stream, er);
    $fHA2F.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $76b4fd7e7048b416$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $76b4fd7e7048b416$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new $76b4fd7e7048b416$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        $76b4fd7e7048b416$var$errorOrDestroy(stream, er);
        $fHA2F.nextTick(cb, er);
        return false;
    }
    return true;
}
$76b4fd7e7048b416$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $76b4fd7e7048b416$var$_isUint8Array(chunk);
    if (isBuf && !$76b4fd7e7048b416$require$Buffer.isBuffer(chunk)) chunk = $76b4fd7e7048b416$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $76b4fd7e7048b416$var$nop;
    if (state.ending) $76b4fd7e7048b416$var$writeAfterEnd(this, cb);
    else if (isBuf || $76b4fd7e7048b416$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $76b4fd7e7048b416$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$76b4fd7e7048b416$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$76b4fd7e7048b416$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $76b4fd7e7048b416$var$clearBuffer(this, state);
    }
};
$76b4fd7e7048b416$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new $76b4fd7e7048b416$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($76b4fd7e7048b416$var$Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $76b4fd7e7048b416$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $76b4fd7e7048b416$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($76b4fd7e7048b416$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $76b4fd7e7048b416$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $76b4fd7e7048b416$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $76b4fd7e7048b416$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $76b4fd7e7048b416$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $76b4fd7e7048b416$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $76b4fd7e7048b416$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $fHA2F.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $fHA2F.nextTick($76b4fd7e7048b416$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $76b4fd7e7048b416$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $76b4fd7e7048b416$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $76b4fd7e7048b416$var$finishMaybe(stream, state);
    }
}
function $76b4fd7e7048b416$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $76b4fd7e7048b416$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new $76b4fd7e7048b416$var$ERR_MULTIPLE_CALLBACK();
    $76b4fd7e7048b416$var$onwriteStateUpdate(state);
    if (er) $76b4fd7e7048b416$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $76b4fd7e7048b416$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $76b4fd7e7048b416$var$clearBuffer(stream, state);
        if (sync) $fHA2F.nextTick($76b4fd7e7048b416$var$afterWrite, stream, state, finished, cb);
        else $76b4fd7e7048b416$var$afterWrite(stream, state, finished, cb);
    }
}
function $76b4fd7e7048b416$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $76b4fd7e7048b416$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $76b4fd7e7048b416$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $76b4fd7e7048b416$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $76b4fd7e7048b416$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $76b4fd7e7048b416$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $76b4fd7e7048b416$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $76b4fd7e7048b416$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$76b4fd7e7048b416$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $76b4fd7e7048b416$var$ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
$76b4fd7e7048b416$var$Writable.prototype._writev = null;
$76b4fd7e7048b416$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $76b4fd7e7048b416$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($76b4fd7e7048b416$var$Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $76b4fd7e7048b416$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $76b4fd7e7048b416$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $76b4fd7e7048b416$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        $76b4fd7e7048b416$var$finishMaybe(stream, state);
    });
}
function $76b4fd7e7048b416$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $fHA2F.nextTick($76b4fd7e7048b416$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $76b4fd7e7048b416$var$finishMaybe(stream, state) {
    var need = $76b4fd7e7048b416$var$needFinish(state);
    if (need) {
        $76b4fd7e7048b416$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $76b4fd7e7048b416$var$endWritable(stream, state, cb) {
    state.ending = true;
    $76b4fd7e7048b416$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $fHA2F.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $76b4fd7e7048b416$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($76b4fd7e7048b416$var$Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$76b4fd7e7048b416$var$Writable.prototype.destroy = $hsXaW.destroy;
$76b4fd7e7048b416$var$Writable.prototype._undestroy = $hsXaW.undestroy;
$76b4fd7e7048b416$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("bqR3D", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $852b4790fc22f4bd$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $852b4790fc22f4bd$var$deprecate(fn, msg) {
    if ($852b4790fc22f4bd$var$config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($852b4790fc22f4bd$var$config('throwDeprecation')) throw new Error(msg);
            else if ($852b4790fc22f4bd$var$config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $852b4790fc22f4bd$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

});



parcelRegister("iCQEj", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $d8f49da7cafaec32$export$63a7aa211a91ed69, (v) => $d8f49da7cafaec32$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $d8f49da7cafaec32$export$63a7aa211a91ed69;
'use strict';

var $list0 = parcelRequire("list0");
var $d8f49da7cafaec32$require$Buffer = $list0.Buffer;
/*</replacement>*/ var $d8f49da7cafaec32$var$isEncoding = $d8f49da7cafaec32$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $d8f49da7cafaec32$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $d8f49da7cafaec32$var$normalizeEncoding(enc) {
    var nenc = $d8f49da7cafaec32$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($d8f49da7cafaec32$require$Buffer.isEncoding === $d8f49da7cafaec32$var$isEncoding || !$d8f49da7cafaec32$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$d8f49da7cafaec32$export$63a7aa211a91ed69 = $d8f49da7cafaec32$var$StringDecoder;
function $d8f49da7cafaec32$var$StringDecoder(encoding) {
    this.encoding = $d8f49da7cafaec32$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $d8f49da7cafaec32$var$utf16Text;
            this.end = $d8f49da7cafaec32$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $d8f49da7cafaec32$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $d8f49da7cafaec32$var$base64Text;
            this.end = $d8f49da7cafaec32$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $d8f49da7cafaec32$var$simpleWrite;
            this.end = $d8f49da7cafaec32$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $d8f49da7cafaec32$require$Buffer.allocUnsafe(nb);
}
$d8f49da7cafaec32$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$d8f49da7cafaec32$var$StringDecoder.prototype.end = $d8f49da7cafaec32$var$utf8End;
// Returns only complete characters in a Buffer
$d8f49da7cafaec32$var$StringDecoder.prototype.text = $d8f49da7cafaec32$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$d8f49da7cafaec32$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $d8f49da7cafaec32$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $d8f49da7cafaec32$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $d8f49da7cafaec32$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $d8f49da7cafaec32$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $d8f49da7cafaec32$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $d8f49da7cafaec32$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $d8f49da7cafaec32$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $d8f49da7cafaec32$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $d8f49da7cafaec32$var$utf8Text(buf, i) {
    var total = $d8f49da7cafaec32$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $d8f49da7cafaec32$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $d8f49da7cafaec32$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $d8f49da7cafaec32$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $d8f49da7cafaec32$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $d8f49da7cafaec32$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $d8f49da7cafaec32$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $d8f49da7cafaec32$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});
parcelRegister("list0", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $lGjml = parcelRequire("lGjml");
var $f8115c5a6fafad92$var$Buffer = $lGjml.Buffer;
// alternative to using Object.keys for old browsers
function $f8115c5a6fafad92$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($f8115c5a6fafad92$var$Buffer.from && $f8115c5a6fafad92$var$Buffer.alloc && $f8115c5a6fafad92$var$Buffer.allocUnsafe && $f8115c5a6fafad92$var$Buffer.allocUnsafeSlow) module.exports = $lGjml;
else {
    // Copy properties from require('buffer')
    $f8115c5a6fafad92$var$copyProps($lGjml, module.exports);
    module.exports.Buffer = $f8115c5a6fafad92$var$SafeBuffer;
}
function $f8115c5a6fafad92$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $f8115c5a6fafad92$var$Buffer(arg, encodingOrOffset, length);
}
$f8115c5a6fafad92$var$SafeBuffer.prototype = Object.create($f8115c5a6fafad92$var$Buffer.prototype);
// Copy static methods from Buffer
$f8115c5a6fafad92$var$copyProps($f8115c5a6fafad92$var$Buffer, $f8115c5a6fafad92$var$SafeBuffer);
$f8115c5a6fafad92$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $f8115c5a6fafad92$var$Buffer(arg, encodingOrOffset, length);
};
$f8115c5a6fafad92$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $f8115c5a6fafad92$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$f8115c5a6fafad92$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $f8115c5a6fafad92$var$Buffer(size);
};
$f8115c5a6fafad92$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $lGjml.SlowBuffer(size);
};

});


parcelRegister("cGAf5", function(module, exports) {

var $fHA2F = parcelRequire("fHA2F");
'use strict';
var $93c585436eb81f9e$var$_Object$setPrototypeO;
function $93c585436eb81f9e$var$_defineProperty(obj, key, value) {
    key = $93c585436eb81f9e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $93c585436eb81f9e$var$_toPropertyKey(arg) {
    var key = $93c585436eb81f9e$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $93c585436eb81f9e$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $jysqe = parcelRequire("jysqe");
var $93c585436eb81f9e$var$kLastResolve = Symbol('lastResolve');
var $93c585436eb81f9e$var$kLastReject = Symbol('lastReject');
var $93c585436eb81f9e$var$kError = Symbol('error');
var $93c585436eb81f9e$var$kEnded = Symbol('ended');
var $93c585436eb81f9e$var$kLastPromise = Symbol('lastPromise');
var $93c585436eb81f9e$var$kHandlePromise = Symbol('handlePromise');
var $93c585436eb81f9e$var$kStream = Symbol('stream');
function $93c585436eb81f9e$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $93c585436eb81f9e$var$readAndResolve(iter) {
    var resolve = iter[$93c585436eb81f9e$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$93c585436eb81f9e$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$93c585436eb81f9e$var$kLastPromise] = null;
            iter[$93c585436eb81f9e$var$kLastResolve] = null;
            iter[$93c585436eb81f9e$var$kLastReject] = null;
            resolve($93c585436eb81f9e$var$createIterResult(data, false));
        }
    }
}
function $93c585436eb81f9e$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $fHA2F.nextTick($93c585436eb81f9e$var$readAndResolve, iter);
}
function $93c585436eb81f9e$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$93c585436eb81f9e$var$kEnded]) {
                resolve($93c585436eb81f9e$var$createIterResult(undefined, true));
                return;
            }
            iter[$93c585436eb81f9e$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $93c585436eb81f9e$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $93c585436eb81f9e$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($93c585436eb81f9e$var$_Object$setPrototypeO = {
    get stream () {
        return this[$93c585436eb81f9e$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$93c585436eb81f9e$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$93c585436eb81f9e$var$kEnded]) return Promise.resolve($93c585436eb81f9e$var$createIterResult(undefined, true));
        if (this[$93c585436eb81f9e$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $fHA2F.nextTick(function() {
                if (_this[$93c585436eb81f9e$var$kError]) reject(_this[$93c585436eb81f9e$var$kError]);
                else resolve($93c585436eb81f9e$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$93c585436eb81f9e$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($93c585436eb81f9e$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$93c585436eb81f9e$var$kStream].read();
            if (data !== null) return Promise.resolve($93c585436eb81f9e$var$createIterResult(data, false));
            promise = new Promise(this[$93c585436eb81f9e$var$kHandlePromise]);
        }
        this[$93c585436eb81f9e$var$kLastPromise] = promise;
        return promise;
    }
}, $93c585436eb81f9e$var$_defineProperty($93c585436eb81f9e$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $93c585436eb81f9e$var$_defineProperty($93c585436eb81f9e$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$93c585436eb81f9e$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($93c585436eb81f9e$var$createIterResult(undefined, true));
        });
    });
}), $93c585436eb81f9e$var$_Object$setPrototypeO), $93c585436eb81f9e$var$AsyncIteratorPrototype);
var $93c585436eb81f9e$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($93c585436eb81f9e$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $93c585436eb81f9e$var$_defineProperty(_Object$create, $93c585436eb81f9e$var$kStream, {
        value: stream,
        writable: true
    }), $93c585436eb81f9e$var$_defineProperty(_Object$create, $93c585436eb81f9e$var$kLastResolve, {
        value: null,
        writable: true
    }), $93c585436eb81f9e$var$_defineProperty(_Object$create, $93c585436eb81f9e$var$kLastReject, {
        value: null,
        writable: true
    }), $93c585436eb81f9e$var$_defineProperty(_Object$create, $93c585436eb81f9e$var$kError, {
        value: null,
        writable: true
    }), $93c585436eb81f9e$var$_defineProperty(_Object$create, $93c585436eb81f9e$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $93c585436eb81f9e$var$_defineProperty(_Object$create, $93c585436eb81f9e$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$93c585436eb81f9e$var$kStream].read();
            if (data) {
                iterator[$93c585436eb81f9e$var$kLastPromise] = null;
                iterator[$93c585436eb81f9e$var$kLastResolve] = null;
                iterator[$93c585436eb81f9e$var$kLastReject] = null;
                resolve($93c585436eb81f9e$var$createIterResult(data, false));
            } else {
                iterator[$93c585436eb81f9e$var$kLastResolve] = resolve;
                iterator[$93c585436eb81f9e$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$93c585436eb81f9e$var$kLastPromise] = null;
    $jysqe(stream, function(err) {
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            var reject = iterator[$93c585436eb81f9e$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$93c585436eb81f9e$var$kLastPromise] = null;
                iterator[$93c585436eb81f9e$var$kLastResolve] = null;
                iterator[$93c585436eb81f9e$var$kLastReject] = null;
                reject(err);
            }
            iterator[$93c585436eb81f9e$var$kError] = err;
            return;
        }
        var resolve = iterator[$93c585436eb81f9e$var$kLastResolve];
        if (resolve !== null) {
            iterator[$93c585436eb81f9e$var$kLastPromise] = null;
            iterator[$93c585436eb81f9e$var$kLastResolve] = null;
            iterator[$93c585436eb81f9e$var$kLastReject] = null;
            resolve($93c585436eb81f9e$var$createIterResult(undefined, true));
        }
        iterator[$93c585436eb81f9e$var$kEnded] = true;
    });
    stream.on('readable', $93c585436eb81f9e$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $93c585436eb81f9e$var$createReadableStreamAsyncIterator;

});
parcelRegister("jysqe", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $e3c73d5219796b04$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("igp20")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $e3c73d5219796b04$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $e3c73d5219796b04$var$noop() {}
function $e3c73d5219796b04$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function $e3c73d5219796b04$var$eos(stream, opts, callback) {
    if (typeof opts === 'function') return $e3c73d5219796b04$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $e3c73d5219796b04$var$once(callback || $e3c73d5219796b04$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $e3c73d5219796b04$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $e3c73d5219796b04$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on('finish', onfinish);
    };
    if ($e3c73d5219796b04$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = $e3c73d5219796b04$var$eos;

});


parcelRegister("76MJd", function(module, exports) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

});


parcelRegister("f5kCH", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $afb751f7e5aaeb36$var$Transform;

var $igp20 = parcelRequire("igp20");
var $afb751f7e5aaeb36$require$_require$codes = $igp20.codes;
var $afb751f7e5aaeb36$var$ERR_METHOD_NOT_IMPLEMENTED = $afb751f7e5aaeb36$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $afb751f7e5aaeb36$var$ERR_MULTIPLE_CALLBACK = $afb751f7e5aaeb36$require$_require$codes.ERR_MULTIPLE_CALLBACK, $afb751f7e5aaeb36$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $afb751f7e5aaeb36$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $afb751f7e5aaeb36$var$ERR_TRANSFORM_WITH_LENGTH_0 = $afb751f7e5aaeb36$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $8PgDm = parcelRequire("8PgDm");

(parcelRequire("83QSq"))($afb751f7e5aaeb36$var$Transform, $8PgDm);
function $afb751f7e5aaeb36$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new $afb751f7e5aaeb36$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $afb751f7e5aaeb36$var$Transform(options) {
    if (!(this instanceof $afb751f7e5aaeb36$var$Transform)) return new $afb751f7e5aaeb36$var$Transform(options);
    $8PgDm.call(this, options);
    this._transformState = {
        afterTransform: $afb751f7e5aaeb36$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $afb751f7e5aaeb36$var$prefinish);
}
function $afb751f7e5aaeb36$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
        $afb751f7e5aaeb36$var$done(_this, er, data);
    });
    else $afb751f7e5aaeb36$var$done(this, null, null);
}
$afb751f7e5aaeb36$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $8PgDm.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$afb751f7e5aaeb36$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $afb751f7e5aaeb36$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
$afb751f7e5aaeb36$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$afb751f7e5aaeb36$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$afb751f7e5aaeb36$var$Transform.prototype._destroy = function(err, cb) {
    $8PgDm.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $afb751f7e5aaeb36$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $afb751f7e5aaeb36$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $afb751f7e5aaeb36$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("7SCJE", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $5bcb9f9479e0306c$var$PassThrough;

var $f5kCH = parcelRequire("f5kCH");

(parcelRequire("83QSq"))($5bcb9f9479e0306c$var$PassThrough, $f5kCH);
function $5bcb9f9479e0306c$var$PassThrough(options) {
    if (!(this instanceof $5bcb9f9479e0306c$var$PassThrough)) return new $5bcb9f9479e0306c$var$PassThrough(options);
    $f5kCH.call(this, options);
}
$5bcb9f9479e0306c$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("kVluV", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var $f3b9ce8952b3e656$var$eos;
function $f3b9ce8952b3e656$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $igp20 = parcelRequire("igp20");
var $f3b9ce8952b3e656$require$_require$codes = $igp20.codes;
var $f3b9ce8952b3e656$var$ERR_MISSING_ARGS = $f3b9ce8952b3e656$require$_require$codes.ERR_MISSING_ARGS, $f3b9ce8952b3e656$var$ERR_STREAM_DESTROYED = $f3b9ce8952b3e656$require$_require$codes.ERR_STREAM_DESTROYED;
function $f3b9ce8952b3e656$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $f3b9ce8952b3e656$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}

function $f3b9ce8952b3e656$var$destroyer(stream, reading, writing, callback) {
    callback = $f3b9ce8952b3e656$var$once(callback);
    var closed = false;
    stream.on('close', function() {
        closed = true;
    });
    if ($f3b9ce8952b3e656$var$eos === undefined) $f3b9ce8952b3e656$var$eos = (parcelRequire("jysqe"));
    $f3b9ce8952b3e656$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($f3b9ce8952b3e656$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new $f3b9ce8952b3e656$var$ERR_STREAM_DESTROYED('pipe'));
    };
}
function $f3b9ce8952b3e656$var$call(fn) {
    fn();
}
function $f3b9ce8952b3e656$var$pipe(from, to) {
    return from.pipe(to);
}
function $f3b9ce8952b3e656$var$popCallback(streams) {
    if (!streams.length) return $f3b9ce8952b3e656$var$noop;
    if (typeof streams[streams.length - 1] !== 'function') return $f3b9ce8952b3e656$var$noop;
    return streams.pop();
}
function $f3b9ce8952b3e656$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $f3b9ce8952b3e656$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $f3b9ce8952b3e656$var$ERR_MISSING_ARGS('streams');
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $f3b9ce8952b3e656$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($f3b9ce8952b3e656$var$call);
            if (reading) return;
            destroys.forEach($f3b9ce8952b3e656$var$call);
            callback(error);
        });
    });
    return streams.reduce($f3b9ce8952b3e656$var$pipe);
}
module.exports = $f3b9ce8952b3e656$var$pipeline;

});


parcelRegister("hWeez", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $fHA2F = parcelRequire("fHA2F");
'use strict';
function $d0f2e506d7f678d7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d0f2e506d7f678d7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d0f2e506d7f678d7$var$_typeof(o);
}
function $d0f2e506d7f678d7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $d0f2e506d7f678d7$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $d0f2e506d7f678d7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d0f2e506d7f678d7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d0f2e506d7f678d7$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $d0f2e506d7f678d7$var$_toPropertyKey(arg) {
    var key = $d0f2e506d7f678d7$var$_toPrimitive(arg, "string");
    return $d0f2e506d7f678d7$var$_typeof(key) === "symbol" ? key : String(key);
}
function $d0f2e506d7f678d7$var$_toPrimitive(input, hint) {
    if ($d0f2e506d7f678d7$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($d0f2e506d7f678d7$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $d0f2e506d7f678d7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $k2p1p = parcelRequire("k2p1p");
var $d0f2e506d7f678d7$var$_require$codes = $k2p1p.codes, $d0f2e506d7f678d7$var$ERR_AMBIGUOUS_ARGUMENT = $d0f2e506d7f678d7$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $d0f2e506d7f678d7$var$ERR_INVALID_ARG_TYPE = $d0f2e506d7f678d7$var$_require$codes.ERR_INVALID_ARG_TYPE, $d0f2e506d7f678d7$var$ERR_INVALID_ARG_VALUE = $d0f2e506d7f678d7$var$_require$codes.ERR_INVALID_ARG_VALUE, $d0f2e506d7f678d7$var$ERR_INVALID_RETURN_VALUE = $d0f2e506d7f678d7$var$_require$codes.ERR_INVALID_RETURN_VALUE, $d0f2e506d7f678d7$var$ERR_MISSING_ARGS = $d0f2e506d7f678d7$var$_require$codes.ERR_MISSING_ARGS;

var $47nfq = parcelRequire("47nfq");

var $62zul = parcelRequire("62zul");
var $d0f2e506d7f678d7$var$inspect = $62zul.inspect;

var $62zul = parcelRequire("62zul");
var $d0f2e506d7f678d7$require$_require$types = $62zul.types;
var $d0f2e506d7f678d7$var$isPromise = $d0f2e506d7f678d7$require$_require$types.isPromise, $d0f2e506d7f678d7$var$isRegExp = $d0f2e506d7f678d7$require$_require$types.isRegExp;

var $d0f2e506d7f678d7$var$objectAssign = (parcelRequire("7eUdm"))();

var $d0f2e506d7f678d7$var$objectIs = (parcelRequire("fI8Iu"))();

var $d0f2e506d7f678d7$var$RegExpPrototypeTest = (parcelRequire("9vhRH"))('RegExp.prototype.test');
var $d0f2e506d7f678d7$var$errorCache = new Map();
var $d0f2e506d7f678d7$var$isDeepEqual;
var $d0f2e506d7f678d7$var$isDeepStrictEqual;
var $d0f2e506d7f678d7$var$parseExpressionAt;
var $d0f2e506d7f678d7$var$findNodeAround;
var $d0f2e506d7f678d7$var$decoder;

function $d0f2e506d7f678d7$var$lazyLoadComparison() {
    var comparison = (parcelRequire("bgMK7"));
    $d0f2e506d7f678d7$var$isDeepEqual = comparison.isDeepEqual;
    $d0f2e506d7f678d7$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
}
// Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $d0f2e506d7f678d7$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $d0f2e506d7f678d7$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    '\\b',
    '',
    '',
    "\\u000b",
    '\\f',
    '',
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $d0f2e506d7f678d7$var$escapeFn = function escapeFn(str) {
    return $d0f2e506d7f678d7$var$meta[str.charCodeAt(0)];
};
var $d0f2e506d7f678d7$var$warned = false;
// The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $d0f2e506d7f678d7$var$assert = module.exports = $d0f2e506d7f678d7$var$ok;
var $d0f2e506d7f678d7$var$NO_EXCEPTION_SENTINEL = {};
// All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $d0f2e506d7f678d7$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $47nfq(obj);
}
function $d0f2e506d7f678d7$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = 'Failed';
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($d0f2e506d7f678d7$var$warned === false) {
            $d0f2e506d7f678d7$var$warned = true;
            var warn = $fHA2F.emitWarning ? $fHA2F.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", 'DeprecationWarning', 'DEP0094');
        }
        if (argsLen === 2) operator = '!=';
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? 'fail' : operator,
        stackStartFn: stackStartFn || $d0f2e506d7f678d7$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $47nfq(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$d0f2e506d7f678d7$var$assert.fail = $d0f2e506d7f678d7$var$fail;
// The AssertionError is defined in internal/error.
$d0f2e506d7f678d7$var$assert.AssertionError = $47nfq;
function $d0f2e506d7f678d7$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = 'No value argument passed to `assert.ok()`';
        } else if (message instanceof Error) throw message;
        var err = new $47nfq({
            actual: value,
            expected: true,
            message: message,
            operator: '==',
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
// Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $d0f2e506d7f678d7$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $d0f2e506d7f678d7$var$innerOk.apply(void 0, [
        $d0f2e506d7f678d7$var$ok,
        args.length
    ].concat(args));
}
$d0f2e506d7f678d7$var$assert.ok = $d0f2e506d7f678d7$var$ok;
// The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $d0f2e506d7f678d7$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $d0f2e506d7f678d7$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual != expected) $d0f2e506d7f678d7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '==',
        stackStartFn: equal
    });
};
// The non-equality assertion tests for whether two objects are not
// equal with !=.
$d0f2e506d7f678d7$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $d0f2e506d7f678d7$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual == expected) $d0f2e506d7f678d7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '!=',
        stackStartFn: notEqual
    });
};
// The equivalence assertion tests a deep equality relation.
$d0f2e506d7f678d7$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $d0f2e506d7f678d7$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($d0f2e506d7f678d7$var$isDeepEqual === undefined) $d0f2e506d7f678d7$var$lazyLoadComparison();
    if (!$d0f2e506d7f678d7$var$isDeepEqual(actual, expected)) $d0f2e506d7f678d7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepEqual',
        stackStartFn: deepEqual
    });
};
// The non-equivalence assertion tests for any deep inequality.
$d0f2e506d7f678d7$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $d0f2e506d7f678d7$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($d0f2e506d7f678d7$var$isDeepEqual === undefined) $d0f2e506d7f678d7$var$lazyLoadComparison();
    if ($d0f2e506d7f678d7$var$isDeepEqual(actual, expected)) $d0f2e506d7f678d7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepEqual',
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $d0f2e506d7f678d7$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $d0f2e506d7f678d7$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($d0f2e506d7f678d7$var$isDeepEqual === undefined) $d0f2e506d7f678d7$var$lazyLoadComparison();
    if (!$d0f2e506d7f678d7$var$isDeepStrictEqual(actual, expected)) $d0f2e506d7f678d7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepStrictEqual',
        stackStartFn: deepStrictEqual
    });
};
$d0f2e506d7f678d7$var$assert.notDeepStrictEqual = $d0f2e506d7f678d7$var$notDeepStrictEqual;
function $d0f2e506d7f678d7$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $d0f2e506d7f678d7$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($d0f2e506d7f678d7$var$isDeepEqual === undefined) $d0f2e506d7f678d7$var$lazyLoadComparison();
    if ($d0f2e506d7f678d7$var$isDeepStrictEqual(actual, expected)) $d0f2e506d7f678d7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepStrictEqual',
        stackStartFn: $d0f2e506d7f678d7$var$notDeepStrictEqual
    });
}
$d0f2e506d7f678d7$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $d0f2e506d7f678d7$var$ERR_MISSING_ARGS('actual', 'expected');
    if (!$d0f2e506d7f678d7$var$objectIs(actual, expected)) $d0f2e506d7f678d7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'strictEqual',
        stackStartFn: strictEqual
    });
};
$d0f2e506d7f678d7$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $d0f2e506d7f678d7$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($d0f2e506d7f678d7$var$objectIs(actual, expected)) $d0f2e506d7f678d7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notStrictEqual',
        stackStartFn: notStrictEqual
    });
};
var $d0f2e506d7f678d7$var$Comparison = /*#__PURE__*/ $d0f2e506d7f678d7$var$_createClass(function Comparison(obj, keys, actual) {
    var _this = this;
    $d0f2e506d7f678d7$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === 'string' && $d0f2e506d7f678d7$var$isRegExp(obj[key]) && $d0f2e506d7f678d7$var$RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
});
function $d0f2e506d7f678d7$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$d0f2e506d7f678d7$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $d0f2e506d7f678d7$var$Comparison(actual, keys);
            var b = new $d0f2e506d7f678d7$var$Comparison(expected, keys, actual);
            var err = new $47nfq({
                actual: a,
                expected: b,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $d0f2e506d7f678d7$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $d0f2e506d7f678d7$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== 'function') {
        if ($d0f2e506d7f678d7$var$isRegExp(expected)) return $d0f2e506d7f678d7$var$RegExpPrototypeTest(expected, actual);
        // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $d0f2e506d7f678d7$var$ERR_INVALID_ARG_TYPE('expected', [
            'Function',
            'RegExp'
        ], expected);
        // Handle primitives properly.
        if ($d0f2e506d7f678d7$var$_typeof(actual) !== 'object' || actual === null) {
            var err = new $47nfq({
                actual: actual,
                expected: expected,
                message: msg,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected);
        // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push('name', 'message');
        else if (keys.length === 0) throw new $d0f2e506d7f678d7$var$ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
        if ($d0f2e506d7f678d7$var$isDeepEqual === undefined) $d0f2e506d7f678d7$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === 'string' && $d0f2e506d7f678d7$var$isRegExp(expected[key]) && $d0f2e506d7f678d7$var$RegExpPrototypeTest(expected[key], actual[key])) return;
            $d0f2e506d7f678d7$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    }
    // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $d0f2e506d7f678d7$var$getActual(fn) {
    if (typeof fn !== 'function') throw new $d0f2e506d7f678d7$var$ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $d0f2e506d7f678d7$var$NO_EXCEPTION_SENTINEL;
}
function $d0f2e506d7f678d7$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $d0f2e506d7f678d7$var$isPromise(obj) || obj !== null && $d0f2e506d7f678d7$var$_typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
}
function $d0f2e506d7f678d7$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === 'function') {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn();
            // Fail in case no promise is returned.
            if (!$d0f2e506d7f678d7$var$checkIsPromise(resultPromise)) throw new $d0f2e506d7f678d7$var$ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
        } else if ($d0f2e506d7f678d7$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $d0f2e506d7f678d7$var$ERR_INVALID_ARG_TYPE('promiseFn', [
            'Function',
            'Promise'
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $d0f2e506d7f678d7$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $d0f2e506d7f678d7$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === 'string') {
        if (arguments.length === 4) throw new $d0f2e506d7f678d7$var$ERR_INVALID_ARG_TYPE('error', [
            'Object',
            'Error',
            'Function',
            'RegExp'
        ], error);
        if ($d0f2e506d7f678d7$var$_typeof(actual) === 'object' && actual !== null) {
            if (actual.message === error) throw new $d0f2e506d7f678d7$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
        } else if (actual === error) throw new $d0f2e506d7f678d7$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
        message = error;
        error = undefined;
    } else if (error != null && $d0f2e506d7f678d7$var$_typeof(error) !== 'object' && typeof error !== 'function') throw new $d0f2e506d7f678d7$var$ERR_INVALID_ARG_TYPE('error', [
        'Object',
        'Error',
        'Function',
        'RegExp'
    ], error);
    if (actual === $d0f2e506d7f678d7$var$NO_EXCEPTION_SENTINEL) {
        var details = '';
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
        $d0f2e506d7f678d7$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$d0f2e506d7f678d7$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $d0f2e506d7f678d7$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $d0f2e506d7f678d7$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === 'string') {
        message = error;
        error = undefined;
    }
    if (!error || $d0f2e506d7f678d7$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
        $d0f2e506d7f678d7$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$d0f2e506d7f678d7$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $d0f2e506d7f678d7$var$expectsError.apply(void 0, [
        throws,
        $d0f2e506d7f678d7$var$getActual(promiseFn)
    ].concat(args));
};
$d0f2e506d7f678d7$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $d0f2e506d7f678d7$var$waitForActual(promiseFn).then(function(result) {
        return $d0f2e506d7f678d7$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$d0f2e506d7f678d7$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $d0f2e506d7f678d7$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $d0f2e506d7f678d7$var$getActual(fn)
    ].concat(args));
};
$d0f2e506d7f678d7$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $d0f2e506d7f678d7$var$waitForActual(fn).then(function(result) {
        return $d0f2e506d7f678d7$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$d0f2e506d7f678d7$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = 'ifError got unwanted exception: ';
        if ($d0f2e506d7f678d7$var$_typeof(err) === 'object' && typeof err.message === 'string') {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $d0f2e506d7f678d7$var$inspect(err);
        var newErr = new $47nfq({
            actual: err,
            expected: null,
            operator: 'ifError',
            message: message,
            stackStartFn: ifError
        });
        // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === 'string') {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split('\n');
            tmp2.shift();
            // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split('\n');
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
        }
        throw newErr;
    }
};
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
function $d0f2e506d7f678d7$var$internalMatch(string, regexp, message, fn, fnName) {
    if (!$d0f2e506d7f678d7$var$isRegExp(regexp)) throw new $d0f2e506d7f678d7$var$ERR_INVALID_ARG_TYPE('regexp', 'RegExp', regexp);
    var match = fnName === 'match';
    if (typeof string !== 'string' || $d0f2e506d7f678d7$var$RegExpPrototypeTest(regexp, string) !== match) {
        if (message instanceof Error) throw message;
        var generatedMessage = !message;
        // 'The input was expected to not match the regular expression ' +
        message = message || (typeof string !== 'string' ? 'The "string" argument must be of type string. Received type ' + "".concat($d0f2e506d7f678d7$var$_typeof(string), " (").concat($d0f2e506d7f678d7$var$inspect(string), ")") : (match ? 'The input did not match the regular expression ' : 'The input was expected to not match the regular expression ') + "".concat($d0f2e506d7f678d7$var$inspect(regexp), ". Input:\n\n").concat($d0f2e506d7f678d7$var$inspect(string), "\n"));
        var err = new $47nfq({
            actual: string,
            expected: regexp,
            message: message,
            operator: fnName,
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
$d0f2e506d7f678d7$var$assert.match = function match(string, regexp, message) {
    $d0f2e506d7f678d7$var$internalMatch(string, regexp, message, match, 'match');
};
$d0f2e506d7f678d7$var$assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
    $d0f2e506d7f678d7$var$internalMatch(string, regexp, message, doesNotMatch, 'doesNotMatch');
};
// Expose a strict only variant of assert
function $d0f2e506d7f678d7$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $d0f2e506d7f678d7$var$innerOk.apply(void 0, [
        $d0f2e506d7f678d7$var$strict,
        args.length
    ].concat(args));
}
$d0f2e506d7f678d7$var$assert.strict = $d0f2e506d7f678d7$var$objectAssign($d0f2e506d7f678d7$var$strict, $d0f2e506d7f678d7$var$assert, {
    equal: $d0f2e506d7f678d7$var$assert.strictEqual,
    deepEqual: $d0f2e506d7f678d7$var$assert.deepStrictEqual,
    notEqual: $d0f2e506d7f678d7$var$assert.notStrictEqual,
    notDeepEqual: $d0f2e506d7f678d7$var$assert.notDeepStrictEqual
});
$d0f2e506d7f678d7$var$assert.strict.strict = $d0f2e506d7f678d7$var$assert.strict;

});
parcelRegister("k2p1p", function(module, exports) {

$parcel$export(module.exports, "codes", () => $e96767586612cfe6$export$e45cb6485273080e, (v) => $e96767586612cfe6$export$e45cb6485273080e = v);
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $e96767586612cfe6$export$e45cb6485273080e;
'use strict';
// The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $e96767586612cfe6$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e96767586612cfe6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e96767586612cfe6$var$_typeof(o);
}
function $e96767586612cfe6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $e96767586612cfe6$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $e96767586612cfe6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e96767586612cfe6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e96767586612cfe6$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $e96767586612cfe6$var$_toPropertyKey(arg) {
    var key = $e96767586612cfe6$var$_toPrimitive(arg, "string");
    return $e96767586612cfe6$var$_typeof(key) === "symbol" ? key : String(key);
}
function $e96767586612cfe6$var$_toPrimitive(input, hint) {
    if ($e96767586612cfe6$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($e96767586612cfe6$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $e96767586612cfe6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e96767586612cfe6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $e96767586612cfe6$var$_setPrototypeOf(subClass, superClass);
}
function $e96767586612cfe6$var$_setPrototypeOf(o, p) {
    $e96767586612cfe6$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e96767586612cfe6$var$_setPrototypeOf(o, p);
}
function $e96767586612cfe6$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $e96767586612cfe6$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $e96767586612cfe6$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $e96767586612cfe6$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $e96767586612cfe6$var$_possibleConstructorReturn(this, result);
    };
}
function $e96767586612cfe6$var$_possibleConstructorReturn(self, call) {
    if (call && ($e96767586612cfe6$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $e96767586612cfe6$var$_assertThisInitialized(self);
}
function $e96767586612cfe6$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $e96767586612cfe6$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $e96767586612cfe6$var$_getPrototypeOf(o) {
    $e96767586612cfe6$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e96767586612cfe6$var$_getPrototypeOf(o);
}
var $e96767586612cfe6$var$codes = {};
// Lazy loaded
var $e96767586612cfe6$var$assert;
var $e96767586612cfe6$var$util;
function $e96767586612cfe6$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $e96767586612cfe6$var$_inherits(NodeError, _Base);
        var _super = $e96767586612cfe6$var$_createSuper(NodeError);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $e96767586612cfe6$var$_classCallCheck(this, NodeError);
            _this = _super.call(this, getMessage(arg1, arg2, arg3));
            _this.code = code;
            return _this;
        }
        return $e96767586612cfe6$var$_createClass(NodeError);
    }(Base);
    $e96767586612cfe6$var$codes[code] = NodeError;
}
// https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $e96767586612cfe6$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $e96767586612cfe6$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $e96767586612cfe6$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $e96767586612cfe6$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$e96767586612cfe6$var$createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);

$e96767586612cfe6$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    if ($e96767586612cfe6$var$assert === undefined) $e96767586612cfe6$var$assert = (parcelRequire("hWeez"));
    $e96767586612cfe6$var$assert(typeof name === 'string', "'name' must be a string");
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $e96767586612cfe6$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($e96767586612cfe6$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($e96767586612cfe6$var$oneOf(expected, 'type'));
    else {
        var type = $e96767586612cfe6$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($e96767586612cfe6$var$oneOf(expected, 'type'));
    }
    // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($e96767586612cfe6$var$_typeof(actual));
    return msg;
}, TypeError);

$e96767586612cfe6$var$createErrorType('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
    if ($e96767586612cfe6$var$util === undefined) $e96767586612cfe6$var$util = (parcelRequire("62zul"));
    var inspected = $e96767586612cfe6$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$e96767586612cfe6$var$createErrorType('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($e96767586612cfe6$var$_typeof(value));
    return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
}, TypeError);

$e96767586612cfe6$var$createErrorType('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($e96767586612cfe6$var$assert === undefined) $e96767586612cfe6$var$assert = (parcelRequire("hWeez"));
    $e96767586612cfe6$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg = 'The ';
    var len = args.length;
    args = args.map(function(a) {
        return "\"".concat(a, "\"");
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(', ');
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$e96767586612cfe6$export$e45cb6485273080e = $e96767586612cfe6$var$codes;

});
parcelRegister("62zul", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $fHA2F = parcelRequire("fHA2F");
var $465e75394f616c31$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $465e75394f616c31$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$465e75394f616c31$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($465e75394f616c31$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($465e75394f616c31$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($465e75394f616c31$var$isNull(x) || !$465e75394f616c31$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $465e75394f616c31$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    var warned;
    return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    function deprecated() {
        if (!warned) {
            if ($fHA2F.throwDeprecation) throw new Error(msg);
            else if ($fHA2F.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
};
var $465e75394f616c31$var$debugs = {};
var $465e75394f616c31$var$debugEnvRegex = /^$/;
var $465e75394f616c31$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$465e75394f616c31$var$debugs[set]) {
        if ($465e75394f616c31$var$debugEnvRegex.test(set)) {
            var pid = $fHA2F.pid;
            $465e75394f616c31$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $465e75394f616c31$var$debugs[set] = function() {};
    }
    return $465e75394f616c31$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $465e75394f616c31$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $465e75394f616c31$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($465e75394f616c31$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($465e75394f616c31$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($465e75394f616c31$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($465e75394f616c31$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($465e75394f616c31$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $465e75394f616c31$var$stylizeWithColor;
    return $465e75394f616c31$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $465e75394f616c31$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$465e75394f616c31$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$465e75394f616c31$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $465e75394f616c31$var$stylizeWithColor(str, styleType) {
    var style = $465e75394f616c31$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $465e75394f616c31$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $465e75394f616c31$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $465e75394f616c31$var$stylizeNoColor(str, styleType) {
    return str;
}
function $465e75394f616c31$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $465e75394f616c31$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $465e75394f616c31$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$465e75394f616c31$var$isString(ret)) ret = $465e75394f616c31$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $465e75394f616c31$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $465e75394f616c31$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($465e75394f616c31$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $465e75394f616c31$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($465e75394f616c31$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($465e75394f616c31$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($465e75394f616c31$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($465e75394f616c31$var$isError(value)) return $465e75394f616c31$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($465e75394f616c31$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($465e75394f616c31$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($465e75394f616c31$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($465e75394f616c31$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($465e75394f616c31$var$isError(value)) base = ' ' + $465e75394f616c31$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($465e75394f616c31$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $465e75394f616c31$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $465e75394f616c31$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $465e75394f616c31$var$reduceToSingleString(output, base, braces);
}
function $465e75394f616c31$var$formatPrimitive(ctx, value) {
    if ($465e75394f616c31$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($465e75394f616c31$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($465e75394f616c31$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($465e75394f616c31$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($465e75394f616c31$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $465e75394f616c31$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $465e75394f616c31$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($465e75394f616c31$var$hasOwnProperty(value, String(i))) output.push($465e75394f616c31$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($465e75394f616c31$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $465e75394f616c31$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$465e75394f616c31$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($465e75394f616c31$var$isNull(recurseTimes)) str = $465e75394f616c31$var$formatValue(ctx, desc.value, null);
            else str = $465e75394f616c31$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($465e75394f616c31$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $465e75394f616c31$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("esUDM"));
function $465e75394f616c31$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $465e75394f616c31$var$isArray;
function $465e75394f616c31$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $465e75394f616c31$var$isBoolean;
function $465e75394f616c31$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $465e75394f616c31$var$isNull;
function $465e75394f616c31$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $465e75394f616c31$var$isNullOrUndefined;
function $465e75394f616c31$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $465e75394f616c31$var$isNumber;
function $465e75394f616c31$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $465e75394f616c31$var$isString;
function $465e75394f616c31$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $465e75394f616c31$var$isSymbol;
function $465e75394f616c31$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $465e75394f616c31$var$isUndefined;
function $465e75394f616c31$var$isRegExp(re) {
    return $465e75394f616c31$var$isObject(re) && $465e75394f616c31$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $465e75394f616c31$var$isRegExp;
module.exports.types.isRegExp = $465e75394f616c31$var$isRegExp;
function $465e75394f616c31$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $465e75394f616c31$var$isObject;
function $465e75394f616c31$var$isDate(d) {
    return $465e75394f616c31$var$isObject(d) && $465e75394f616c31$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $465e75394f616c31$var$isDate;
module.exports.types.isDate = $465e75394f616c31$var$isDate;
function $465e75394f616c31$var$isError(e) {
    return $465e75394f616c31$var$isObject(e) && ($465e75394f616c31$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $465e75394f616c31$var$isError;
module.exports.types.isNativeError = $465e75394f616c31$var$isError;
function $465e75394f616c31$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $465e75394f616c31$var$isFunction;
function $465e75394f616c31$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $465e75394f616c31$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("lDWiX"));
function $465e75394f616c31$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $465e75394f616c31$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $465e75394f616c31$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $465e75394f616c31$var$timestamp() {
    var d = new Date();
    var time = [
        $465e75394f616c31$var$pad(d.getHours()),
        $465e75394f616c31$var$pad(d.getMinutes()),
        $465e75394f616c31$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $465e75394f616c31$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $465e75394f616c31$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("83QSq"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$465e75394f616c31$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $465e75394f616c31$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $465e75394f616c31$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($465e75394f616c31$var$kCustomPromisifiedSymbol && original[$465e75394f616c31$var$kCustomPromisifiedSymbol]) {
        var fn = original[$465e75394f616c31$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $465e75394f616c31$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($465e75394f616c31$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $465e75394f616c31$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $465e75394f616c31$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $465e75394f616c31$var$kCustomPromisifiedSymbol;
function $465e75394f616c31$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $465e75394f616c31$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $fHA2F.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $fHA2F.nextTick($465e75394f616c31$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $465e75394f616c31$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $465e75394f616c31$var$callbackify;

});
parcelRegister("esUDM", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $hEBy5 = parcelRequire("hEBy5");

var $5Uj4o = parcelRequire("5Uj4o");

var $1X664 = parcelRequire("1X664");

var $6xpxt = parcelRequire("6xpxt");
function $a87f9de2aa87556e$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $a87f9de2aa87556e$var$BigIntSupported = typeof BigInt !== 'undefined';
var $a87f9de2aa87556e$var$SymbolSupported = typeof Symbol !== 'undefined';
var $a87f9de2aa87556e$var$ObjectToString = $a87f9de2aa87556e$var$uncurryThis(Object.prototype.toString);
var $a87f9de2aa87556e$var$numberValue = $a87f9de2aa87556e$var$uncurryThis(Number.prototype.valueOf);
var $a87f9de2aa87556e$var$stringValue = $a87f9de2aa87556e$var$uncurryThis(String.prototype.valueOf);
var $a87f9de2aa87556e$var$booleanValue = $a87f9de2aa87556e$var$uncurryThis(Boolean.prototype.valueOf);
if ($a87f9de2aa87556e$var$BigIntSupported) var $a87f9de2aa87556e$var$bigIntValue = $a87f9de2aa87556e$var$uncurryThis(BigInt.prototype.valueOf);
if ($a87f9de2aa87556e$var$SymbolSupported) var $a87f9de2aa87556e$var$symbolValue = $a87f9de2aa87556e$var$uncurryThis(Symbol.prototype.valueOf);
function $a87f9de2aa87556e$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $hEBy5;
module.exports.isGeneratorFunction = $5Uj4o;
module.exports.isTypedArray = $6xpxt;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $a87f9de2aa87556e$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $a87f9de2aa87556e$var$isPromise;
function $a87f9de2aa87556e$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $6xpxt(value) || $a87f9de2aa87556e$var$isDataView(value);
}
module.exports.isArrayBufferView = $a87f9de2aa87556e$var$isArrayBufferView;
function $a87f9de2aa87556e$var$isUint8Array(value) {
    return $1X664(value) === 'Uint8Array';
}
module.exports.isUint8Array = $a87f9de2aa87556e$var$isUint8Array;
function $a87f9de2aa87556e$var$isUint8ClampedArray(value) {
    return $1X664(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $a87f9de2aa87556e$var$isUint8ClampedArray;
function $a87f9de2aa87556e$var$isUint16Array(value) {
    return $1X664(value) === 'Uint16Array';
}
module.exports.isUint16Array = $a87f9de2aa87556e$var$isUint16Array;
function $a87f9de2aa87556e$var$isUint32Array(value) {
    return $1X664(value) === 'Uint32Array';
}
module.exports.isUint32Array = $a87f9de2aa87556e$var$isUint32Array;
function $a87f9de2aa87556e$var$isInt8Array(value) {
    return $1X664(value) === 'Int8Array';
}
module.exports.isInt8Array = $a87f9de2aa87556e$var$isInt8Array;
function $a87f9de2aa87556e$var$isInt16Array(value) {
    return $1X664(value) === 'Int16Array';
}
module.exports.isInt16Array = $a87f9de2aa87556e$var$isInt16Array;
function $a87f9de2aa87556e$var$isInt32Array(value) {
    return $1X664(value) === 'Int32Array';
}
module.exports.isInt32Array = $a87f9de2aa87556e$var$isInt32Array;
function $a87f9de2aa87556e$var$isFloat32Array(value) {
    return $1X664(value) === 'Float32Array';
}
module.exports.isFloat32Array = $a87f9de2aa87556e$var$isFloat32Array;
function $a87f9de2aa87556e$var$isFloat64Array(value) {
    return $1X664(value) === 'Float64Array';
}
module.exports.isFloat64Array = $a87f9de2aa87556e$var$isFloat64Array;
function $a87f9de2aa87556e$var$isBigInt64Array(value) {
    return $1X664(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $a87f9de2aa87556e$var$isBigInt64Array;
function $a87f9de2aa87556e$var$isBigUint64Array(value) {
    return $1X664(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $a87f9de2aa87556e$var$isBigUint64Array;
function $a87f9de2aa87556e$var$isMapToString(value) {
    return $a87f9de2aa87556e$var$ObjectToString(value) === '[object Map]';
}
$a87f9de2aa87556e$var$isMapToString.working = typeof Map !== 'undefined' && $a87f9de2aa87556e$var$isMapToString(new Map());
function $a87f9de2aa87556e$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $a87f9de2aa87556e$var$isMapToString.working ? $a87f9de2aa87556e$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $a87f9de2aa87556e$var$isMap;
function $a87f9de2aa87556e$var$isSetToString(value) {
    return $a87f9de2aa87556e$var$ObjectToString(value) === '[object Set]';
}
$a87f9de2aa87556e$var$isSetToString.working = typeof Set !== 'undefined' && $a87f9de2aa87556e$var$isSetToString(new Set());
function $a87f9de2aa87556e$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $a87f9de2aa87556e$var$isSetToString.working ? $a87f9de2aa87556e$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $a87f9de2aa87556e$var$isSet;
function $a87f9de2aa87556e$var$isWeakMapToString(value) {
    return $a87f9de2aa87556e$var$ObjectToString(value) === '[object WeakMap]';
}
$a87f9de2aa87556e$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $a87f9de2aa87556e$var$isWeakMapToString(new WeakMap());
function $a87f9de2aa87556e$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $a87f9de2aa87556e$var$isWeakMapToString.working ? $a87f9de2aa87556e$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $a87f9de2aa87556e$var$isWeakMap;
function $a87f9de2aa87556e$var$isWeakSetToString(value) {
    return $a87f9de2aa87556e$var$ObjectToString(value) === '[object WeakSet]';
}
$a87f9de2aa87556e$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $a87f9de2aa87556e$var$isWeakSetToString(new WeakSet());
function $a87f9de2aa87556e$var$isWeakSet(value) {
    return $a87f9de2aa87556e$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $a87f9de2aa87556e$var$isWeakSet;
function $a87f9de2aa87556e$var$isArrayBufferToString(value) {
    return $a87f9de2aa87556e$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$a87f9de2aa87556e$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $a87f9de2aa87556e$var$isArrayBufferToString(new ArrayBuffer());
function $a87f9de2aa87556e$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $a87f9de2aa87556e$var$isArrayBufferToString.working ? $a87f9de2aa87556e$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $a87f9de2aa87556e$var$isArrayBuffer;
function $a87f9de2aa87556e$var$isDataViewToString(value) {
    return $a87f9de2aa87556e$var$ObjectToString(value) === '[object DataView]';
}
$a87f9de2aa87556e$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $a87f9de2aa87556e$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $a87f9de2aa87556e$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $a87f9de2aa87556e$var$isDataViewToString.working ? $a87f9de2aa87556e$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $a87f9de2aa87556e$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $a87f9de2aa87556e$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $a87f9de2aa87556e$var$isSharedArrayBufferToString(value) {
    return $a87f9de2aa87556e$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $a87f9de2aa87556e$var$isSharedArrayBuffer(value) {
    if (typeof $a87f9de2aa87556e$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $a87f9de2aa87556e$var$isSharedArrayBufferToString.working === 'undefined') $a87f9de2aa87556e$var$isSharedArrayBufferToString.working = $a87f9de2aa87556e$var$isSharedArrayBufferToString(new $a87f9de2aa87556e$var$SharedArrayBufferCopy());
    return $a87f9de2aa87556e$var$isSharedArrayBufferToString.working ? $a87f9de2aa87556e$var$isSharedArrayBufferToString(value) : value instanceof $a87f9de2aa87556e$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $a87f9de2aa87556e$var$isSharedArrayBuffer;
function $a87f9de2aa87556e$var$isAsyncFunction(value) {
    return $a87f9de2aa87556e$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $a87f9de2aa87556e$var$isAsyncFunction;
function $a87f9de2aa87556e$var$isMapIterator(value) {
    return $a87f9de2aa87556e$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $a87f9de2aa87556e$var$isMapIterator;
function $a87f9de2aa87556e$var$isSetIterator(value) {
    return $a87f9de2aa87556e$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $a87f9de2aa87556e$var$isSetIterator;
function $a87f9de2aa87556e$var$isGeneratorObject(value) {
    return $a87f9de2aa87556e$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $a87f9de2aa87556e$var$isGeneratorObject;
function $a87f9de2aa87556e$var$isWebAssemblyCompiledModule(value) {
    return $a87f9de2aa87556e$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $a87f9de2aa87556e$var$isWebAssemblyCompiledModule;
function $a87f9de2aa87556e$var$isNumberObject(value) {
    return $a87f9de2aa87556e$var$checkBoxedPrimitive(value, $a87f9de2aa87556e$var$numberValue);
}
module.exports.isNumberObject = $a87f9de2aa87556e$var$isNumberObject;
function $a87f9de2aa87556e$var$isStringObject(value) {
    return $a87f9de2aa87556e$var$checkBoxedPrimitive(value, $a87f9de2aa87556e$var$stringValue);
}
module.exports.isStringObject = $a87f9de2aa87556e$var$isStringObject;
function $a87f9de2aa87556e$var$isBooleanObject(value) {
    return $a87f9de2aa87556e$var$checkBoxedPrimitive(value, $a87f9de2aa87556e$var$booleanValue);
}
module.exports.isBooleanObject = $a87f9de2aa87556e$var$isBooleanObject;
function $a87f9de2aa87556e$var$isBigIntObject(value) {
    return $a87f9de2aa87556e$var$BigIntSupported && $a87f9de2aa87556e$var$checkBoxedPrimitive(value, $a87f9de2aa87556e$var$bigIntValue);
}
module.exports.isBigIntObject = $a87f9de2aa87556e$var$isBigIntObject;
function $a87f9de2aa87556e$var$isSymbolObject(value) {
    return $a87f9de2aa87556e$var$SymbolSupported && $a87f9de2aa87556e$var$checkBoxedPrimitive(value, $a87f9de2aa87556e$var$symbolValue);
}
module.exports.isSymbolObject = $a87f9de2aa87556e$var$isSymbolObject;
function $a87f9de2aa87556e$var$isBoxedPrimitive(value) {
    return $a87f9de2aa87556e$var$isNumberObject(value) || $a87f9de2aa87556e$var$isStringObject(value) || $a87f9de2aa87556e$var$isBooleanObject(value) || $a87f9de2aa87556e$var$isBigIntObject(value) || $a87f9de2aa87556e$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $a87f9de2aa87556e$var$isBoxedPrimitive;
function $a87f9de2aa87556e$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($a87f9de2aa87556e$var$isArrayBuffer(value) || $a87f9de2aa87556e$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $a87f9de2aa87556e$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("hEBy5", function(module, exports) {
'use strict';

var $cda34c85a323aa65$var$hasToStringTag = (parcelRequire("78jow"))();

var $35eIN = parcelRequire("35eIN");
var $cda34c85a323aa65$var$$toString = $35eIN('Object.prototype.toString');
/** @type {import('.')} */ var $cda34c85a323aa65$var$isStandardArguments = function isArguments(value) {
    if ($cda34c85a323aa65$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $cda34c85a323aa65$var$$toString(value) === '[object Arguments]';
};
/** @type {import('.')} */ var $cda34c85a323aa65$var$isLegacyArguments = function isArguments(value) {
    if ($cda34c85a323aa65$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && 'length' in value && typeof value.length === 'number' && value.length >= 0 && $cda34c85a323aa65$var$$toString(value) !== '[object Array]' && 'callee' in value && $cda34c85a323aa65$var$$toString(value.callee) === '[object Function]';
};
var $cda34c85a323aa65$var$supportsStandardArguments = function() {
    return $cda34c85a323aa65$var$isStandardArguments(arguments);
}();
// @ts-expect-error TODO make this not error
$cda34c85a323aa65$var$isStandardArguments.isLegacyArguments = $cda34c85a323aa65$var$isLegacyArguments; // for tests
/** @type {import('.')} */ module.exports = $cda34c85a323aa65$var$supportsStandardArguments ? $cda34c85a323aa65$var$isStandardArguments : $cda34c85a323aa65$var$isLegacyArguments;

});
parcelRegister("78jow", function(module, exports) {
'use strict';

var $hPohd = parcelRequire("hPohd");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $hPohd() && !!Symbol.toStringTag;
};

});
parcelRegister("hPohd", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("35eIN", function(module, exports) {
'use strict';

var $io8Ib = parcelRequire("io8Ib");

var $d4vMJ = parcelRequire("d4vMJ");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $23ed421d5bd633d0$var$$indexOf = $d4vMJ([
    $io8Ib('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $io8Ib(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $23ed421d5bd633d0$var$$indexOf(name, '.prototype.') > -1) return $d4vMJ(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});
parcelRegister("io8Ib", function(module, exports) {
'use strict';
var $d63139d7cea01f9b$var$undefined1;

var $1QTlY = parcelRequire("1QTlY");

var $11nuP = parcelRequire("11nuP");

var $iT5b5 = parcelRequire("iT5b5");

var $bZgIk = parcelRequire("bZgIk");

var $5ttVV = parcelRequire("5ttVV");

var $gPj8q = parcelRequire("gPj8q");

var $hbvaB = parcelRequire("hbvaB");

var $gSqJ0 = parcelRequire("gSqJ0");

var $bBpf0 = parcelRequire("bBpf0");

var $lMoAI = parcelRequire("lMoAI");

var $5sK8Q = parcelRequire("5sK8Q");

var $1US79 = parcelRequire("1US79");

var $cdB5p = parcelRequire("cdB5p");

var $5YJmp = parcelRequire("5YJmp");

var $eUc8M = parcelRequire("eUc8M");
var $d63139d7cea01f9b$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $d63139d7cea01f9b$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $d63139d7cea01f9b$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $2yQlG = parcelRequire("2yQlG");

var $2RODR = parcelRequire("2RODR");
var $d63139d7cea01f9b$var$throwTypeError = function() {
    throw new $hbvaB();
};
var $d63139d7cea01f9b$var$ThrowTypeError = $2yQlG ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $d63139d7cea01f9b$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $2yQlG(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $d63139d7cea01f9b$var$throwTypeError;
        }
    }
}() : $d63139d7cea01f9b$var$throwTypeError;

var $d63139d7cea01f9b$var$hasSymbols = (parcelRequire("ilpTl"))();

var $gWSlc = parcelRequire("gWSlc");

var $cV0eW = parcelRequire("cV0eW");

var $TfFYE = parcelRequire("TfFYE");

var $7Ml9t = parcelRequire("7Ml9t");

var $bFdTq = parcelRequire("bFdTq");
var $d63139d7cea01f9b$var$needsEval = {};
var $d63139d7cea01f9b$var$TypedArray = typeof Uint8Array === 'undefined' || !$gWSlc ? undefined : $gWSlc(Uint8Array);
var $d63139d7cea01f9b$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $d63139d7cea01f9b$var$hasSymbols && $gWSlc ? $gWSlc([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $d63139d7cea01f9b$var$needsEval,
    '%AsyncGenerator%': $d63139d7cea01f9b$var$needsEval,
    '%AsyncGeneratorFunction%': $d63139d7cea01f9b$var$needsEval,
    '%AsyncIteratorPrototype%': $d63139d7cea01f9b$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $11nuP,
    '%eval%': eval,
    '%EvalError%': $iT5b5,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $d63139d7cea01f9b$var$$Function,
    '%GeneratorFunction%': $d63139d7cea01f9b$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $d63139d7cea01f9b$var$hasSymbols && $gWSlc ? $gWSlc($gWSlc([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$d63139d7cea01f9b$var$hasSymbols || !$gWSlc ? undefined : $gWSlc(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $1QTlY,
    '%Object.getOwnPropertyDescriptor%': $2yQlG,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $bZgIk,
    '%ReferenceError%': $5ttVV,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$d63139d7cea01f9b$var$hasSymbols || !$gWSlc ? undefined : $gWSlc(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $d63139d7cea01f9b$var$hasSymbols && $gWSlc ? $gWSlc(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $d63139d7cea01f9b$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $gPj8q,
    '%ThrowTypeError%': $d63139d7cea01f9b$var$ThrowTypeError,
    '%TypedArray%': $d63139d7cea01f9b$var$TypedArray,
    '%TypeError%': $hbvaB,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $gSqJ0,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $bFdTq,
    '%Function.prototype.apply%': $7Ml9t,
    '%Object.defineProperty%': $2RODR,
    '%Object.getPrototypeOf%': $cV0eW,
    '%Math.abs%': $bBpf0,
    '%Math.floor%': $lMoAI,
    '%Math.max%': $5sK8Q,
    '%Math.min%': $1US79,
    '%Math.pow%': $cdB5p,
    '%Math.round%': $5YJmp,
    '%Math.sign%': $eUc8M,
    '%Reflect.getPrototypeOf%': $TfFYE
};
if ($gWSlc) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $d63139d7cea01f9b$var$errorProto = $gWSlc($gWSlc(e));
    $d63139d7cea01f9b$var$INTRINSICS['%Error.prototype%'] = $d63139d7cea01f9b$var$errorProto;
}
var $d63139d7cea01f9b$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $d63139d7cea01f9b$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $d63139d7cea01f9b$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $d63139d7cea01f9b$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $gWSlc) value = $gWSlc(gen.prototype);
    }
    $d63139d7cea01f9b$var$INTRINSICS[name] = value;
    return value;
};
var $d63139d7cea01f9b$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $hi9NP = parcelRequire("hi9NP");

var $lnX6V = parcelRequire("lnX6V");
var $d63139d7cea01f9b$var$$concat = $hi9NP.call($bFdTq, Array.prototype.concat);
var $d63139d7cea01f9b$var$$spliceApply = $hi9NP.call($7Ml9t, Array.prototype.splice);
var $d63139d7cea01f9b$var$$replace = $hi9NP.call($bFdTq, String.prototype.replace);
var $d63139d7cea01f9b$var$$strSlice = $hi9NP.call($bFdTq, String.prototype.slice);
var $d63139d7cea01f9b$var$$exec = $hi9NP.call($bFdTq, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $d63139d7cea01f9b$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $d63139d7cea01f9b$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $d63139d7cea01f9b$var$stringToPath = function stringToPath(string) {
    var first = $d63139d7cea01f9b$var$$strSlice(string, 0, 1);
    var last = $d63139d7cea01f9b$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $gPj8q('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $gPj8q('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $d63139d7cea01f9b$var$$replace(string, $d63139d7cea01f9b$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $d63139d7cea01f9b$var$$replace(subString, $d63139d7cea01f9b$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $d63139d7cea01f9b$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($lnX6V($d63139d7cea01f9b$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $d63139d7cea01f9b$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($lnX6V($d63139d7cea01f9b$var$INTRINSICS, intrinsicName)) {
        var value = $d63139d7cea01f9b$var$INTRINSICS[intrinsicName];
        if (value === $d63139d7cea01f9b$var$needsEval) value = $d63139d7cea01f9b$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $hbvaB('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $gPj8q('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $hbvaB('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $hbvaB('"allowMissing" argument must be a boolean');
    if ($d63139d7cea01f9b$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $gPj8q('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $d63139d7cea01f9b$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $d63139d7cea01f9b$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $d63139d7cea01f9b$var$$spliceApply(parts, $d63139d7cea01f9b$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $d63139d7cea01f9b$var$$strSlice(part, 0, 1);
        var last = $d63139d7cea01f9b$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $gPj8q('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($lnX6V($d63139d7cea01f9b$var$INTRINSICS, intrinsicRealName)) value = $d63139d7cea01f9b$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $hbvaB('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($2yQlG && i + 1 >= parts.length) {
                var desc = $2yQlG(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $lnX6V(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $d63139d7cea01f9b$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("1QTlY", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("11nuP", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("iT5b5", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("bZgIk", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("5ttVV", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("gPj8q", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("hbvaB", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("gSqJ0", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("bBpf0", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("lMoAI", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("5sK8Q", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("1US79", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("cdB5p", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("5YJmp", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("eUc8M", function(module, exports) {
'use strict';

var $h2TbY = parcelRequire("h2TbY");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($h2TbY(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("h2TbY", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("2yQlG", function(module, exports) {
'use strict';

var $3OD8g = parcelRequire("3OD8g");
var $1dd75d22934f4677$require$$gOPD = $3OD8g;
if ($1dd75d22934f4677$require$$gOPD) try {
    $1dd75d22934f4677$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $1dd75d22934f4677$require$$gOPD = null;
}
module.exports = $1dd75d22934f4677$require$$gOPD;

});
parcelRegister("3OD8g", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("2RODR", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $2167d06a33faffa1$var$$defineProperty = Object.defineProperty || false;
if ($2167d06a33faffa1$var$$defineProperty) try {
    $2167d06a33faffa1$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $2167d06a33faffa1$var$$defineProperty = false;
}
module.exports = $2167d06a33faffa1$var$$defineProperty;

});

parcelRegister("ilpTl", function(module, exports) {
'use strict';
var $d5ae45b4deeb3687$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $hPohd = parcelRequire("hPohd");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $d5ae45b4deeb3687$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $d5ae45b4deeb3687$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $hPohd();
};

});

parcelRegister("gWSlc", function(module, exports) {
'use strict';

var $TfFYE = parcelRequire("TfFYE");

var $cV0eW = parcelRequire("cV0eW");

var $l4h7p = parcelRequire("l4h7p");
/** @type {import('.')} */ module.exports = $TfFYE ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $TfFYE(O);
} : $cV0eW ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $cV0eW(O);
} : $l4h7p ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $l4h7p(O);
} : null;

});
parcelRegister("TfFYE", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("cV0eW", function(module, exports) {
'use strict';

var $1QTlY = parcelRequire("1QTlY");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $1QTlY.getPrototypeOf || null;

});

parcelRegister("l4h7p", function(module, exports) {
'use strict';

var $d4vMJ = parcelRequire("d4vMJ");

var $2yQlG = parcelRequire("2yQlG");
var $f567400f6d9d51e9$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $f567400f6d9d51e9$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $f567400f6d9d51e9$var$desc = !!$f567400f6d9d51e9$var$hasProtoAccessor && $2yQlG && $2yQlG(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $f567400f6d9d51e9$var$$Object = Object;
var $f567400f6d9d51e9$var$$getPrototypeOf = $f567400f6d9d51e9$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $f567400f6d9d51e9$var$desc && typeof $f567400f6d9d51e9$var$desc.get === 'function' ? $d4vMJ([
    $f567400f6d9d51e9$var$desc.get
]) : typeof $f567400f6d9d51e9$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $f567400f6d9d51e9$var$$getPrototypeOf(value == null ? value : $f567400f6d9d51e9$var$$Object(value));
} : false;

});
parcelRegister("d4vMJ", function(module, exports) {
'use strict';

var $hi9NP = parcelRequire("hi9NP");

var $hbvaB = parcelRequire("hbvaB");

var $bFdTq = parcelRequire("bFdTq");

var $7xt41 = parcelRequire("7xt41");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $hbvaB('a function is required');
    return $7xt41($hi9NP, $bFdTq, args);
};

});
parcelRegister("hi9NP", function(module, exports) {
'use strict';

var $lpTqZ = parcelRequire("lpTqZ");
module.exports = Function.prototype.bind || $lpTqZ;

});
parcelRegister("lpTqZ", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $f976eede1af7ad91$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $f976eede1af7ad91$var$toStr = Object.prototype.toString;
var $f976eede1af7ad91$var$max = Math.max;
var $f976eede1af7ad91$var$funcType = '[object Function]';
var $f976eede1af7ad91$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $f976eede1af7ad91$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $f976eede1af7ad91$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $f976eede1af7ad91$var$toStr.apply(target) !== $f976eede1af7ad91$var$funcType) throw new TypeError($f976eede1af7ad91$var$ERROR_MESSAGE + target);
    var args = $f976eede1af7ad91$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $f976eede1af7ad91$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $f976eede1af7ad91$var$concatty(args, arguments));
    };
    var boundLength = $f976eede1af7ad91$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $f976eede1af7ad91$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("bFdTq", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("7xt41", function(module, exports) {
'use strict';

var $hi9NP = parcelRequire("hi9NP");

var $7Ml9t = parcelRequire("7Ml9t");

var $bFdTq = parcelRequire("bFdTq");

var $fua7U = parcelRequire("fua7U");
/** @type {import('./actualApply')} */ module.exports = $fua7U || $hi9NP.call($bFdTq, $7Ml9t);

});
parcelRegister("7Ml9t", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("fua7U", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("lnX6V", function(module, exports) {
'use strict';
var $f91999183b3baa73$var$call = Function.prototype.call;
var $f91999183b3baa73$var$$hasOwn = Object.prototype.hasOwnProperty;

var $hi9NP = parcelRequire("hi9NP");
/** @type {import('.')} */ module.exports = $hi9NP.call($f91999183b3baa73$var$call, $f91999183b3baa73$var$$hasOwn);

});




parcelRegister("5Uj4o", function(module, exports) {
'use strict';

var $35eIN = parcelRequire("35eIN");

var $9dV52 = parcelRequire("9dV52");
var $44d0f99588d7fc39$var$isFnRegex = $9dV52(/^\s*(?:function)?\*/);

var $44d0f99588d7fc39$var$hasToStringTag = (parcelRequire("78jow"))();

var $gWSlc = parcelRequire("gWSlc");
var $44d0f99588d7fc39$var$toStr = $35eIN('Object.prototype.toString');
var $44d0f99588d7fc39$var$fnToStr = $35eIN('Function.prototype.toString');

var $3AYGr = parcelRequire("3AYGr");
/** @type {import('.')} */ module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($44d0f99588d7fc39$var$isFnRegex($44d0f99588d7fc39$var$fnToStr(fn))) return true;
    if (!$44d0f99588d7fc39$var$hasToStringTag) {
        var str = $44d0f99588d7fc39$var$toStr(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$gWSlc) return false;
    var GeneratorFunction = $3AYGr();
    return GeneratorFunction && $gWSlc(fn) === GeneratorFunction.prototype;
};

});
parcelRegister("9dV52", function(module, exports) {
'use strict';

var $35eIN = parcelRequire("35eIN");

var $cXo5q = parcelRequire("cXo5q");
var $6b719aeb26f3c141$var$$exec = $35eIN('RegExp.prototype.exec');

var $hbvaB = parcelRequire("hbvaB");
/** @type {import('.')} */ module.exports = function regexTester(regex) {
    if (!$cXo5q(regex)) throw new $hbvaB('`regex` must be a RegExp');
    return function test(s) {
        return $6b719aeb26f3c141$var$$exec(regex, s) !== null;
    };
};

});
parcelRegister("cXo5q", function(module, exports) {
'use strict';

var $35eIN = parcelRequire("35eIN");

var $96edadd2a3680074$var$hasToStringTag = (parcelRequire("78jow"))();

var $lnX6V = parcelRequire("lnX6V");

var $2yQlG = parcelRequire("2yQlG");
/** @type {import('.')} */ var $96edadd2a3680074$var$fn;
if ($96edadd2a3680074$var$hasToStringTag) {
    /** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */ var $96edadd2a3680074$var$$exec = $35eIN('RegExp.prototype.exec');
    /** @type {object} */ var $96edadd2a3680074$var$isRegexMarker = {};
    var $96edadd2a3680074$var$throwRegexMarker = function() {
        throw $96edadd2a3680074$var$isRegexMarker;
    };
    /** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */ var $96edadd2a3680074$var$badStringifier = {
        toString: $96edadd2a3680074$var$throwRegexMarker,
        valueOf: $96edadd2a3680074$var$throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === 'symbol') $96edadd2a3680074$var$badStringifier[Symbol.toPrimitive] = $96edadd2a3680074$var$throwRegexMarker;
    /** @type {import('.')} */ // @ts-expect-error TS can't figure out that the $exec call always throws
    // eslint-disable-next-line consistent-return
    $96edadd2a3680074$var$fn = function isRegex(value) {
        if (!value || typeof value !== 'object') return false;
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {NonNullable<typeof gOPD>} */ $2yQlG(/** @type {{ lastIndex?: unknown }} */ value, 'lastIndex');
        var hasLastIndexDataProperty = descriptor && $lnX6V(descriptor, 'value');
        if (!hasLastIndexDataProperty) return false;
        try {
            // eslint-disable-next-line no-extra-parens
            $96edadd2a3680074$var$$exec(value, /** @type {unknown} */ $96edadd2a3680074$var$badStringifier);
        } catch (e) {
            return e === $96edadd2a3680074$var$isRegexMarker;
        }
    };
} else {
    /** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */ var $96edadd2a3680074$var$$toString = $35eIN('Object.prototype.toString');
    /** @const @type {'[object RegExp]'} */ var $96edadd2a3680074$var$regexClass = '[object RegExp]';
    /** @type {import('.')} */ $96edadd2a3680074$var$fn = function isRegex(value) {
        // In older browsers, typeof regex incorrectly returns 'function'
        if (!value || typeof value !== 'object' && typeof value !== 'function') return false;
        return $96edadd2a3680074$var$$toString(value) === $96edadd2a3680074$var$regexClass;
    };
}
module.exports = $96edadd2a3680074$var$fn;

});


parcelRegister("3AYGr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $42693d089c2b8e83$export$2e2bcd8739ae039);

var $3so3r = parcelRequire("3so3r");
var /** @type {import('./index.d.mts').default} */ $42693d089c2b8e83$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($3so3r)));

});
parcelRegister("3so3r", function(module, exports) {
'use strict';
// eslint-disable-next-line no-extra-parens, no-empty-function
const $2846a55d8497a533$var$cached = /** @type {GeneratorFunctionConstructor} */ (function*() {}).constructor;
/** @type {import('.')} */ module.exports = ()=>$2846a55d8497a533$var$cached;

});



parcelRegister("1X664", function(module, exports) {
'use strict';

var $loj0Y = parcelRequire("loj0Y");

var $24f3M = parcelRequire("24f3M");

var $cZXXz = parcelRequire("cZXXz");

var $35eIN = parcelRequire("35eIN");

var $2yQlG = parcelRequire("2yQlG");

var $gWSlc = parcelRequire("gWSlc");
var $16c007d69951ba61$var$$toString = $35eIN('Object.prototype.toString');

var $16c007d69951ba61$var$hasToStringTag = (parcelRequire("78jow"))();
var $16c007d69951ba61$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $16c007d69951ba61$var$typedArrays = $24f3M();
var $16c007d69951ba61$var$$slice = $35eIN('String.prototype.slice');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $16c007d69951ba61$var$$indexOf = $35eIN('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {import('./types').Getter} Getter */ /** @type {import('./types').Cache} */ var $16c007d69951ba61$var$cache = {
    __proto__: null
};
if ($16c007d69951ba61$var$hasToStringTag && $2yQlG && $gWSlc) $loj0Y($16c007d69951ba61$var$typedArrays, function(typedArray) {
    var arr = new $16c007d69951ba61$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $gWSlc) {
        var proto = $gWSlc(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $2yQlG(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $gWSlc(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $2yQlG(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $16c007d69951ba61$var$cache['$' + typedArray] = $cZXXz(descriptor.get);
    }
});
else $loj0Y($16c007d69951ba61$var$typedArrays, function(typedArray) {
    var arr = new $16c007d69951ba61$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) $16c007d69951ba61$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ // @ts-expect-error TODO FIXME
    $cZXXz(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $16c007d69951ba61$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $loj0Y(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $16c007d69951ba61$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {import('.').TypedArrayName} */ $16c007d69951ba61$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $16c007d69951ba61$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $loj0Y(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $16c007d69951ba61$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {import('.').TypedArrayName} */ $16c007d69951ba61$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$16c007d69951ba61$var$hasToStringTag) {
        /** @type {string} */ var tag = $16c007d69951ba61$var$$slice($16c007d69951ba61$var$$toString(value), 8, -1);
        if ($16c007d69951ba61$var$$indexOf($16c007d69951ba61$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $16c007d69951ba61$var$trySlices(value);
    }
    if (!$2yQlG) return null;
     // unknown engine
    return $16c007d69951ba61$var$tryTypedArrays(value);
};

});
parcelRegister("loj0Y", function(module, exports) {
'use strict';

var $jeY8y = parcelRequire("jeY8y");
var $f92a96ca9ce6e5d0$var$toStr = Object.prototype.toString;
var $f92a96ca9ce6e5d0$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $f92a96ca9ce6e5d0$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($f92a96ca9ce6e5d0$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $f92a96ca9ce6e5d0$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $f92a96ca9ce6e5d0$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($f92a96ca9ce6e5d0$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $f92a96ca9ce6e5d0$var$isArray(x) {
    return $f92a96ca9ce6e5d0$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$jeY8y(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($f92a96ca9ce6e5d0$var$isArray(list)) $f92a96ca9ce6e5d0$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $f92a96ca9ce6e5d0$var$forEachString(list, iterator, receiver);
    else $f92a96ca9ce6e5d0$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("jeY8y", function(module, exports) {
'use strict';
var $e01df91840818cca$var$fnToStr = Function.prototype.toString;
var $e01df91840818cca$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $e01df91840818cca$var$badArrayLike;
var $e01df91840818cca$var$isCallableMarker;
if (typeof $e01df91840818cca$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $e01df91840818cca$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $e01df91840818cca$var$isCallableMarker;
        }
    });
    $e01df91840818cca$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $e01df91840818cca$var$reflectApply(function() {
        throw 42;
    }, null, $e01df91840818cca$var$badArrayLike);
} catch (_) {
    if (_ !== $e01df91840818cca$var$isCallableMarker) $e01df91840818cca$var$reflectApply = null;
}
else $e01df91840818cca$var$reflectApply = null;
var $e01df91840818cca$var$constructorRegex = /^\s*class\b/;
var $e01df91840818cca$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $e01df91840818cca$var$fnToStr.call(value);
        return $e01df91840818cca$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $e01df91840818cca$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($e01df91840818cca$var$isES6ClassFn(value)) return false;
        $e01df91840818cca$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $e01df91840818cca$var$toStr = Object.prototype.toString;
var $e01df91840818cca$var$objectClass = '[object Object]';
var $e01df91840818cca$var$fnClass = '[object Function]';
var $e01df91840818cca$var$genClass = '[object GeneratorFunction]';
var $e01df91840818cca$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $e01df91840818cca$var$ddaClass2 = '[object HTML document.all class]';
var $e01df91840818cca$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $e01df91840818cca$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $e01df91840818cca$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $e01df91840818cca$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $e01df91840818cca$var$all = document.all;
    if ($e01df91840818cca$var$toStr.call($e01df91840818cca$var$all) === $e01df91840818cca$var$toStr.call(document.all)) $e01df91840818cca$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($e01df91840818cca$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $e01df91840818cca$var$toStr.call(value);
            return (str === $e01df91840818cca$var$ddaClass || str === $e01df91840818cca$var$ddaClass2 || str === $e01df91840818cca$var$ddaClass3 // opera 12.16
             || str === $e01df91840818cca$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $e01df91840818cca$var$reflectApply ? function isCallable(value) {
    if ($e01df91840818cca$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $e01df91840818cca$var$reflectApply(value, null, $e01df91840818cca$var$badArrayLike);
    } catch (e) {
        if (e !== $e01df91840818cca$var$isCallableMarker) return false;
    }
    return !$e01df91840818cca$var$isES6ClassFn(value) && $e01df91840818cca$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($e01df91840818cca$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($e01df91840818cca$var$hasToStringTag) return $e01df91840818cca$var$tryFunctionObject(value);
    if ($e01df91840818cca$var$isES6ClassFn(value)) return false;
    var strClass = $e01df91840818cca$var$toStr.call(value);
    if (strClass !== $e01df91840818cca$var$fnClass && strClass !== $e01df91840818cca$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $e01df91840818cca$var$tryFunctionObject(value);
};

});


parcelRegister("24f3M", function(module, exports) {
'use strict';

var $jaTJj = parcelRequire("jaTJj");
var $1817a318cd50be0c$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $jaTJj.length; i++)if (typeof $1817a318cd50be0c$var$g[$jaTJj[i]] === 'function') // @ts-expect-error
    out[out.length] = $jaTJj[i];
    return out;
};

});
parcelRegister("jaTJj", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float16Array',
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});


parcelRegister("cZXXz", function(module, exports) {
'use strict';

var $jvAo5 = parcelRequire("jvAo5");

var $2RODR = parcelRequire("2RODR");

var $d4vMJ = parcelRequire("d4vMJ");

var $kGW8S = parcelRequire("kGW8S");
module.exports = function callBind(originalFunction) {
    var func = $d4vMJ(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $jvAo5(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($2RODR) $2RODR(module.exports, 'apply', {
    value: $kGW8S
});
else module.exports.apply = $kGW8S;

});
parcelRegister("jvAo5", function(module, exports) {
'use strict';

var $io8Ib = parcelRequire("io8Ib");

var $8JJpe = parcelRequire("8JJpe");

var $e33d235eb2b9c88f$var$hasDescriptors = (parcelRequire("7DNYW"))();

var $2yQlG = parcelRequire("2yQlG");

var $hbvaB = parcelRequire("hbvaB");
var $e33d235eb2b9c88f$var$$floor = $io8Ib('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $hbvaB('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $e33d235eb2b9c88f$var$$floor(length) !== length) throw new $hbvaB('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $2yQlG) {
        var desc = $2yQlG(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($e33d235eb2b9c88f$var$hasDescriptors) $8JJpe(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $8JJpe(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("8JJpe", function(module, exports) {
'use strict';

var $2RODR = parcelRequire("2RODR");

var $gPj8q = parcelRequire("gPj8q");

var $hbvaB = parcelRequire("hbvaB");

var $2yQlG = parcelRequire("2yQlG");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $hbvaB('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $hbvaB('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $hbvaB('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $hbvaB('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $hbvaB('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $hbvaB('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$2yQlG && $2yQlG(obj, property);
    if ($2RODR) $2RODR(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $gPj8q('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("7DNYW", function(module, exports) {
'use strict';

var $2RODR = parcelRequire("2RODR");
var $5902f24b5dc5ea46$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$2RODR;
};
$5902f24b5dc5ea46$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$2RODR) return null;
    try {
        return $2RODR([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $5902f24b5dc5ea46$var$hasPropertyDescriptors;

});


parcelRegister("kGW8S", function(module, exports) {
'use strict';

var $hi9NP = parcelRequire("hi9NP");

var $7Ml9t = parcelRequire("7Ml9t");

var $7xt41 = parcelRequire("7xt41");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $7xt41($hi9NP, $7Ml9t, arguments);
};

});



parcelRegister("6xpxt", function(module, exports) {
'use strict';

var $1X664 = parcelRequire("1X664");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$1X664(value);
};

});


parcelRegister("lDWiX", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});



parcelRegister("47nfq", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $fHA2F = parcelRequire("fHA2F");
'use strict';
function $2ff9d9669fb5af89$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2ff9d9669fb5af89$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2ff9d9669fb5af89$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2ff9d9669fb5af89$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2ff9d9669fb5af89$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2ff9d9669fb5af89$var$_defineProperty(obj, key, value) {
    key = $2ff9d9669fb5af89$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2ff9d9669fb5af89$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2ff9d9669fb5af89$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $2ff9d9669fb5af89$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $2ff9d9669fb5af89$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2ff9d9669fb5af89$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2ff9d9669fb5af89$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $2ff9d9669fb5af89$var$_toPropertyKey(arg) {
    var key = $2ff9d9669fb5af89$var$_toPrimitive(arg, "string");
    return $2ff9d9669fb5af89$var$_typeof(key) === "symbol" ? key : String(key);
}
function $2ff9d9669fb5af89$var$_toPrimitive(input, hint) {
    if ($2ff9d9669fb5af89$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($2ff9d9669fb5af89$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $2ff9d9669fb5af89$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $2ff9d9669fb5af89$var$_setPrototypeOf(subClass, superClass);
}
function $2ff9d9669fb5af89$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $2ff9d9669fb5af89$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $2ff9d9669fb5af89$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $2ff9d9669fb5af89$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $2ff9d9669fb5af89$var$_possibleConstructorReturn(this, result);
    };
}
function $2ff9d9669fb5af89$var$_possibleConstructorReturn(self, call) {
    if (call && ($2ff9d9669fb5af89$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $2ff9d9669fb5af89$var$_assertThisInitialized(self);
}
function $2ff9d9669fb5af89$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $2ff9d9669fb5af89$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $2ff9d9669fb5af89$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$2ff9d9669fb5af89$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $2ff9d9669fb5af89$var$_construct(Class, arguments, $2ff9d9669fb5af89$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $2ff9d9669fb5af89$var$_setPrototypeOf(Wrapper, Class);
    };
    return $2ff9d9669fb5af89$var$_wrapNativeSuper(Class);
}
function $2ff9d9669fb5af89$var$_construct(Parent, args, Class) {
    if ($2ff9d9669fb5af89$var$_isNativeReflectConstruct()) $2ff9d9669fb5af89$var$_construct = Reflect.construct.bind();
    else $2ff9d9669fb5af89$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $2ff9d9669fb5af89$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $2ff9d9669fb5af89$var$_construct.apply(null, arguments);
}
function $2ff9d9669fb5af89$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $2ff9d9669fb5af89$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $2ff9d9669fb5af89$var$_setPrototypeOf(o, p) {
    $2ff9d9669fb5af89$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $2ff9d9669fb5af89$var$_setPrototypeOf(o, p);
}
function $2ff9d9669fb5af89$var$_getPrototypeOf(o) {
    $2ff9d9669fb5af89$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $2ff9d9669fb5af89$var$_getPrototypeOf(o);
}
function $2ff9d9669fb5af89$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2ff9d9669fb5af89$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2ff9d9669fb5af89$var$_typeof(o);
}

var $62zul = parcelRequire("62zul");
var $2ff9d9669fb5af89$var$inspect = $62zul.inspect;

var $k2p1p = parcelRequire("k2p1p");
var $2ff9d9669fb5af89$var$ERR_INVALID_ARG_TYPE = $k2p1p.codes.ERR_INVALID_ARG_TYPE;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $2ff9d9669fb5af89$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $2ff9d9669fb5af89$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return '';
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $2ff9d9669fb5af89$var$blue = '';
var $2ff9d9669fb5af89$var$green = '';
var $2ff9d9669fb5af89$var$red = '';
var $2ff9d9669fb5af89$var$white = '';
var $2ff9d9669fb5af89$var$kReadableOperator = {
    deepStrictEqual: 'Expected values to be strictly deep-equal:',
    strictEqual: 'Expected values to be strictly equal:',
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: 'Expected values to be loosely deep-equal:',
    equal: 'Expected values to be loosely equal:',
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: 'Values identical but not reference-equal:'
};
// Comparing short primitives should just show === / !== instead of using the
// diff.
var $2ff9d9669fb5af89$var$kMaxShortLength = 10;
function $2ff9d9669fb5af89$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, 'message', {
        value: source.message
    });
    return target;
}
function $2ff9d9669fb5af89$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $2ff9d9669fb5af89$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $2ff9d9669fb5af89$var$createErrDiff(actual, expected, operator) {
    var other = '';
    var res = '';
    var lastPos = 0;
    var end = '';
    var skipped = false;
    var actualInspected = $2ff9d9669fb5af89$var$inspectValue(actual);
    var actualLines = actualInspected.split('\n');
    var expectedLines = $2ff9d9669fb5af89$var$inspectValue(expected).split('\n');
    var i = 0;
    var indicator = '';
    // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === 'strictEqual' && $2ff9d9669fb5af89$var$_typeof(actual) === 'object' && $2ff9d9669fb5af89$var$_typeof(expected) === 'object' && actual !== null && expected !== null) operator = 'strictEqualObject';
    // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length;
        // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $2ff9d9669fb5af89$var$kMaxShortLength) {
            if (($2ff9d9669fb5af89$var$_typeof(actual) !== 'object' || actual === null) && ($2ff9d9669fb5af89$var$_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($2ff9d9669fb5af89$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== 'strictEqualObject') {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $fHA2F.stderr && $fHA2F.stderr.isTTY ? $fHA2F.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($2ff9d9669fb5af89$var$repeat(' ', i), "^");
                    i = 0;
                }
            }
        }
    }
    // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length);
    // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split('\n');
        // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($2ff9d9669fb5af89$var$blue, "...").concat($2ff9d9669fb5af89$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($2ff9d9669fb5af89$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
    }
    if (i > 3) {
        end = "\n".concat($2ff9d9669fb5af89$var$blue, "...").concat($2ff9d9669fb5af89$var$white).concat(end);
        skipped = true;
    }
    if (other !== '') {
        end = "\n  ".concat(other).concat(end);
        other = '';
    }
    var printedLines = 0;
    var msg = $2ff9d9669fb5af89$var$kReadableOperator[operator] + "\n".concat($2ff9d9669fb5af89$var$green, "+ actual").concat($2ff9d9669fb5af89$var$white, " ").concat($2ff9d9669fb5af89$var$red, "- expected").concat($2ff9d9669fb5af89$var$white);
    var skippedMsg = " ".concat($2ff9d9669fb5af89$var$blue, "...").concat($2ff9d9669fb5af89$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($2ff9d9669fb5af89$var$blue, "...").concat($2ff9d9669fb5af89$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the expected line to the cache.
            other += "\n".concat($2ff9d9669fb5af89$var$red, "-").concat($2ff9d9669fb5af89$var$white, " ").concat(expectedLines[i]);
            printedLines++;
        // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($2ff9d9669fb5af89$var$blue, "...").concat($2ff9d9669fb5af89$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the actual line to the result.
            res += "\n".concat($2ff9d9669fb5af89$var$green, "+").concat($2ff9d9669fb5af89$var$white, " ").concat(actualLines[i]);
            printedLines++;
        // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i];
            // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$2ff9d9669fb5af89$var$endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine);
            // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $2ff9d9669fb5af89$var$endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ',';
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($2ff9d9669fb5af89$var$blue, "...").concat($2ff9d9669fb5af89$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                // Mark the current line as the last diverging one.
                lastPos = i;
                // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($2ff9d9669fb5af89$var$green, "+").concat($2ff9d9669fb5af89$var$white, " ").concat(actualLine);
                other += "\n".concat($2ff9d9669fb5af89$var$red, "-").concat($2ff9d9669fb5af89$var$white, " ").concat(expectedLine);
                printedLines += 2;
            // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = '';
                // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        }
        // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($2ff9d9669fb5af89$var$blue, "...").concat($2ff9d9669fb5af89$var$white).concat(other, "\n") + "".concat($2ff9d9669fb5af89$var$blue, "...").concat($2ff9d9669fb5af89$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $2ff9d9669fb5af89$var$AssertionError = /*#__PURE__*/ function(_Error, _inspect$custom) {
    $2ff9d9669fb5af89$var$_inherits(AssertionError, _Error);
    var _super = $2ff9d9669fb5af89$var$_createSuper(AssertionError);
    function AssertionError(options) {
        var _this;
        $2ff9d9669fb5af89$var$_classCallCheck(this, AssertionError);
        if ($2ff9d9669fb5af89$var$_typeof(options) !== 'object' || options === null) throw new $2ff9d9669fb5af89$var$ERR_INVALID_ARG_TYPE('options', 'Object', options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = _super.call(this, String(message));
        else {
            if ($fHA2F.stderr && $fHA2F.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($fHA2F.stderr && $fHA2F.stderr.getColorDepth && $fHA2F.stderr.getColorDepth() !== 1) {
                    $2ff9d9669fb5af89$var$blue = "\x1B[34m";
                    $2ff9d9669fb5af89$var$green = "\x1B[32m";
                    $2ff9d9669fb5af89$var$white = "\x1B[39m";
                    $2ff9d9669fb5af89$var$red = "\x1B[31m";
                } else {
                    $2ff9d9669fb5af89$var$blue = '';
                    $2ff9d9669fb5af89$var$green = '';
                    $2ff9d9669fb5af89$var$white = '';
                    $2ff9d9669fb5af89$var$red = '';
                }
            }
            // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($2ff9d9669fb5af89$var$_typeof(actual) === 'object' && actual !== null && $2ff9d9669fb5af89$var$_typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
                actual = $2ff9d9669fb5af89$var$copyError(actual);
                expected = $2ff9d9669fb5af89$var$copyError(expected);
            }
            if (operator === 'deepStrictEqual' || operator === 'strictEqual') _this = _super.call(this, $2ff9d9669fb5af89$var$createErrDiff(actual, expected, operator));
            else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $2ff9d9669fb5af89$var$kReadableOperator[operator];
                var res = $2ff9d9669fb5af89$var$inspectValue(actual).split('\n');
                // In case "actual" is an object, it should not be reference equal.
                if (operator === 'notStrictEqual' && $2ff9d9669fb5af89$var$_typeof(actual) === 'object' && actual !== null) base = $2ff9d9669fb5af89$var$kReadableOperator.notStrictEqualObject;
                // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($2ff9d9669fb5af89$var$blue, "...").concat($2ff9d9669fb5af89$var$white);
                    while(res.length > 27)res.pop();
                }
                // Only print a single input.
                if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n"));
            } else {
                var _res = $2ff9d9669fb5af89$var$inspectValue(actual);
                var other = '';
                var knownOperators = $2ff9d9669fb5af89$var$kReadableOperator[operator];
                if (operator === 'notDeepEqual' || operator === 'notEqual') {
                    _res = "".concat($2ff9d9669fb5af89$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($2ff9d9669fb5af89$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === 'deepEqual' || operator === 'equal') _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = _super.call(this, "".concat(_res).concat(other));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($2ff9d9669fb5af89$var$_assertThisInitialized(_this), 'name', {
            value: 'AssertionError [ERR_ASSERTION]',
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = 'ERR_ASSERTION';
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($2ff9d9669fb5af89$var$_assertThisInitialized(_this), stackStartFn);
        // Create error message including the error code in the name.
        _this.stack;
        // Reset the name.
        _this.name = 'AssertionError';
        return $2ff9d9669fb5af89$var$_possibleConstructorReturn(_this);
    }
    $2ff9d9669fb5af89$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: _inspect$custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $2ff9d9669fb5af89$var$inspect(this, $2ff9d9669fb5af89$var$_objectSpread($2ff9d9669fb5af89$var$_objectSpread({}, ctx), {}, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}(/*#__PURE__*/ $2ff9d9669fb5af89$var$_wrapNativeSuper(Error), $2ff9d9669fb5af89$var$inspect.custom);
module.exports = $2ff9d9669fb5af89$var$AssertionError;

});

parcelRegister("7eUdm", function(module, exports) {
'use strict';

var $4VA4T = parcelRequire("4VA4T");
var $5455723de9c9c038$var$lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = 'abcdefghijklmnopqrst';
    var letters = str.split('');
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = '';
    for(var k in obj)actual += k;
    return str !== actual;
};
var $5455723de9c9c038$var$assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, 'xy');
    } catch (e) {
        return thrower[1] === 'y';
    }
    return false;
};
module.exports = function getPolyfill() {
    if (!Object.assign) return $4VA4T;
    if ($5455723de9c9c038$var$lacksProperEnumerationOrder()) return $4VA4T;
    if ($5455723de9c9c038$var$assignHasPendingExceptions()) return $4VA4T;
    return Object.assign;
};

});
parcelRegister("4VA4T", function(module, exports) {
'use strict';

var $63xRK = parcelRequire("63xRK");

var $3968789cfb0658ac$var$hasSymbols = (parcelRequire("hPohd"))();

var $35eIN = parcelRequire("35eIN");

var $1QTlY = parcelRequire("1QTlY");
var $3968789cfb0658ac$var$$push = $35eIN('Array.prototype.push');
var $3968789cfb0658ac$var$$propIsEnumerable = $35eIN('Object.prototype.propertyIsEnumerable');
var $3968789cfb0658ac$var$originalGetSymbols = $3968789cfb0658ac$var$hasSymbols ? $1QTlY.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
    if (target == null) throw new TypeError('target must be an object');
    var to = $1QTlY(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = $1QTlY(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = $63xRK(from);
        var getSymbols = $3968789cfb0658ac$var$hasSymbols && ($1QTlY.getOwnPropertySymbols || $3968789cfb0658ac$var$originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($3968789cfb0658ac$var$$propIsEnumerable(from, key)) $3968789cfb0658ac$var$$push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($3968789cfb0658ac$var$$propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};

});
parcelRegister("63xRK", function(module, exports) {
'use strict';
var $468d4af9a3363f11$var$slice = Array.prototype.slice;

var $9PGN4 = parcelRequire("9PGN4");
var $468d4af9a3363f11$var$origKeys = Object.keys;

var $468d4af9a3363f11$var$keysShim = $468d4af9a3363f11$var$origKeys ? function keys(o) {
    return $468d4af9a3363f11$var$origKeys(o);
} : (parcelRequire("ibaeG"));
var $468d4af9a3363f11$var$originalKeys = Object.keys;
$468d4af9a3363f11$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($9PGN4(object)) return $468d4af9a3363f11$var$originalKeys($468d4af9a3363f11$var$slice.call(object));
            return $468d4af9a3363f11$var$originalKeys(object);
        };
    } else Object.keys = $468d4af9a3363f11$var$keysShim;
    return Object.keys || $468d4af9a3363f11$var$keysShim;
};
module.exports = $468d4af9a3363f11$var$keysShim;

});
parcelRegister("9PGN4", function(module, exports) {
'use strict';
var $728a11cb54b0cd16$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $728a11cb54b0cd16$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $728a11cb54b0cd16$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("ibaeG", function(module, exports) {
'use strict';
var $d3c131b45b9ea2c5$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $d3c131b45b9ea2c5$var$has = Object.prototype.hasOwnProperty;
    var $d3c131b45b9ea2c5$var$toStr = Object.prototype.toString;
    var $d3c131b45b9ea2c5$var$isArgs = (parcelRequire("9PGN4")); // eslint-disable-line global-require
    var $d3c131b45b9ea2c5$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $d3c131b45b9ea2c5$var$hasDontEnumBug = !$d3c131b45b9ea2c5$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $d3c131b45b9ea2c5$var$hasProtoEnumBug = $d3c131b45b9ea2c5$var$isEnumerable.call(function() {}, 'prototype');
    var $d3c131b45b9ea2c5$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $d3c131b45b9ea2c5$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $d3c131b45b9ea2c5$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $d3c131b45b9ea2c5$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$d3c131b45b9ea2c5$var$excludedKeys['$' + k] && $d3c131b45b9ea2c5$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $d3c131b45b9ea2c5$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $d3c131b45b9ea2c5$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$d3c131b45b9ea2c5$var$hasAutomationEqualityBug) return $d3c131b45b9ea2c5$var$equalsConstructorPrototype(o);
        try {
            return $d3c131b45b9ea2c5$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $d3c131b45b9ea2c5$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $d3c131b45b9ea2c5$var$toStr.call(object) === '[object Function]';
        var isArguments = $d3c131b45b9ea2c5$var$isArgs(object);
        var isString = isObject && $d3c131b45b9ea2c5$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $d3c131b45b9ea2c5$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$d3c131b45b9ea2c5$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $d3c131b45b9ea2c5$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($d3c131b45b9ea2c5$var$hasDontEnumBug) {
            var skipConstructor = $d3c131b45b9ea2c5$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $d3c131b45b9ea2c5$var$dontEnums.length; ++k)if (!(skipConstructor && $d3c131b45b9ea2c5$var$dontEnums[k] === 'constructor') && $d3c131b45b9ea2c5$var$has.call(object, $d3c131b45b9ea2c5$var$dontEnums[k])) theKeys.push($d3c131b45b9ea2c5$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $d3c131b45b9ea2c5$var$keysShim;

});




parcelRegister("fI8Iu", function(module, exports) {
'use strict';

var $hQV2N = parcelRequire("hQV2N");
module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : $hQV2N;
};

});
parcelRegister("hQV2N", function(module, exports) {
'use strict';
var $cff38ac6d1078fc3$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($cff38ac6d1078fc3$var$numberIsNaN(a) && $cff38ac6d1078fc3$var$numberIsNaN(b)) return true;
    return false;
};

});


parcelRegister("9vhRH", function(module, exports) {
'use strict';

var $io8Ib = parcelRequire("io8Ib");

var $cZXXz = parcelRequire("cZXXz");
var $6eb4ddecaff48dd9$var$$indexOf = $cZXXz($io8Ib('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $io8Ib(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $6eb4ddecaff48dd9$var$$indexOf(name, '.prototype.') > -1) return $cZXXz(intrinsic);
    return intrinsic;
};

});

parcelRegister("bgMK7", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';
function $8346ffa362ea4697$var$_slicedToArray(arr, i) {
    return $8346ffa362ea4697$var$_arrayWithHoles(arr) || $8346ffa362ea4697$var$_iterableToArrayLimit(arr, i) || $8346ffa362ea4697$var$_unsupportedIterableToArray(arr, i) || $8346ffa362ea4697$var$_nonIterableRest();
}
function $8346ffa362ea4697$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8346ffa362ea4697$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8346ffa362ea4697$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8346ffa362ea4697$var$_arrayLikeToArray(o, minLen);
}
function $8346ffa362ea4697$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8346ffa362ea4697$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $8346ffa362ea4697$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $8346ffa362ea4697$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8346ffa362ea4697$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8346ffa362ea4697$var$_typeof(o);
}
var $8346ffa362ea4697$var$regexFlagsSupported = /a/g.flags !== undefined;
var $8346ffa362ea4697$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $8346ffa362ea4697$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $8346ffa362ea4697$var$objectIs = Object.is ? Object.is : (parcelRequire("eSXKX"));
var $8346ffa362ea4697$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $8346ffa362ea4697$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("9uy3b"));
function $8346ffa362ea4697$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $8346ffa362ea4697$var$hasOwnProperty = $8346ffa362ea4697$var$uncurryThis(Object.prototype.hasOwnProperty);
var $8346ffa362ea4697$var$propertyIsEnumerable = $8346ffa362ea4697$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $8346ffa362ea4697$var$objectToString = $8346ffa362ea4697$var$uncurryThis(Object.prototype.toString);

var $62zul = parcelRequire("62zul");
var $8346ffa362ea4697$require$_require$types = $62zul.types;
var $8346ffa362ea4697$var$isAnyArrayBuffer = $8346ffa362ea4697$require$_require$types.isAnyArrayBuffer, $8346ffa362ea4697$var$isArrayBufferView = $8346ffa362ea4697$require$_require$types.isArrayBufferView, $8346ffa362ea4697$var$isDate = $8346ffa362ea4697$require$_require$types.isDate, $8346ffa362ea4697$var$isMap = $8346ffa362ea4697$require$_require$types.isMap, $8346ffa362ea4697$var$isRegExp = $8346ffa362ea4697$require$_require$types.isRegExp, $8346ffa362ea4697$var$isSet = $8346ffa362ea4697$require$_require$types.isSet, $8346ffa362ea4697$var$isNativeError = $8346ffa362ea4697$require$_require$types.isNativeError, $8346ffa362ea4697$var$isBoxedPrimitive = $8346ffa362ea4697$require$_require$types.isBoxedPrimitive, $8346ffa362ea4697$var$isNumberObject = $8346ffa362ea4697$require$_require$types.isNumberObject, $8346ffa362ea4697$var$isStringObject = $8346ffa362ea4697$require$_require$types.isStringObject, $8346ffa362ea4697$var$isBooleanObject = $8346ffa362ea4697$require$_require$types.isBooleanObject, $8346ffa362ea4697$var$isBigIntObject = $8346ffa362ea4697$require$_require$types.isBigIntObject, $8346ffa362ea4697$var$isSymbolObject = $8346ffa362ea4697$require$_require$types.isSymbolObject, $8346ffa362ea4697$var$isFloat32Array = $8346ffa362ea4697$require$_require$types.isFloat32Array, $8346ffa362ea4697$var$isFloat64Array = $8346ffa362ea4697$require$_require$types.isFloat64Array;
function $8346ffa362ea4697$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    }
    // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $8346ffa362ea4697$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($8346ffa362ea4697$var$isNonIndex).concat($8346ffa362ea4697$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
}
// Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $8346ffa362ea4697$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $8346ffa362ea4697$var$ONLY_ENUMERABLE = undefined;
var $8346ffa362ea4697$var$kStrict = true;
var $8346ffa362ea4697$var$kLoose = false;
var $8346ffa362ea4697$var$kNoIterator = 0;
var $8346ffa362ea4697$var$kIsArray = 1;
var $8346ffa362ea4697$var$kIsSet = 2;
var $8346ffa362ea4697$var$kIsMap = 3;
// Check if they have the same source and flags
function $8346ffa362ea4697$var$areSimilarRegExps(a, b) {
    return $8346ffa362ea4697$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $8346ffa362ea4697$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $8346ffa362ea4697$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $8346ffa362ea4697$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $8346ffa362ea4697$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $8346ffa362ea4697$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $8346ffa362ea4697$var$isEqualBoxedPrimitive(val1, val2) {
    if ($8346ffa362ea4697$var$isNumberObject(val1)) return $8346ffa362ea4697$var$isNumberObject(val2) && $8346ffa362ea4697$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($8346ffa362ea4697$var$isStringObject(val1)) return $8346ffa362ea4697$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($8346ffa362ea4697$var$isBooleanObject(val1)) return $8346ffa362ea4697$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($8346ffa362ea4697$var$isBigIntObject(val1)) return $8346ffa362ea4697$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $8346ffa362ea4697$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
}
// Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $8346ffa362ea4697$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $8346ffa362ea4697$var$objectIs(val1, val2) : true;
    }
    // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($8346ffa362ea4697$var$_typeof(val1) !== 'object') return typeof val1 === 'number' && $8346ffa362ea4697$var$numberIsNaN(val1) && $8346ffa362ea4697$var$numberIsNaN(val2);
        if ($8346ffa362ea4697$var$_typeof(val2) !== 'object' || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $8346ffa362ea4697$var$_typeof(val1) !== 'object') {
            if (val2 === null || $8346ffa362ea4697$var$_typeof(val2) !== 'object') // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $8346ffa362ea4697$var$_typeof(val2) !== 'object') return false;
    }
    var val1Tag = $8346ffa362ea4697$var$objectToString(val1);
    var val2Tag = $8346ffa362ea4697$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $8346ffa362ea4697$var$getOwnNonIndexProperties(val1, $8346ffa362ea4697$var$ONLY_ENUMERABLE);
        var keys2 = $8346ffa362ea4697$var$getOwnNonIndexProperties(val2, $8346ffa362ea4697$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $8346ffa362ea4697$var$keyCheck(val1, val2, strict, memos, $8346ffa362ea4697$var$kIsArray, keys1);
    }
    // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === '[object Object]') {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$8346ffa362ea4697$var$isMap(val1) && $8346ffa362ea4697$var$isMap(val2) || !$8346ffa362ea4697$var$isSet(val1) && $8346ffa362ea4697$var$isSet(val2)) return false;
    }
    if ($8346ffa362ea4697$var$isDate(val1)) {
        if (!$8346ffa362ea4697$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($8346ffa362ea4697$var$isRegExp(val1)) {
        if (!$8346ffa362ea4697$var$isRegExp(val2) || !$8346ffa362ea4697$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($8346ffa362ea4697$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($8346ffa362ea4697$var$isArrayBufferView(val1)) {
        if (!strict && ($8346ffa362ea4697$var$isFloat32Array(val1) || $8346ffa362ea4697$var$isFloat64Array(val1))) {
            if (!$8346ffa362ea4697$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$8346ffa362ea4697$var$areSimilarTypedArrays(val1, val2)) return false;
        // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $8346ffa362ea4697$var$getOwnNonIndexProperties(val1, $8346ffa362ea4697$var$ONLY_ENUMERABLE);
        var _keys2 = $8346ffa362ea4697$var$getOwnNonIndexProperties(val2, $8346ffa362ea4697$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $8346ffa362ea4697$var$keyCheck(val1, val2, strict, memos, $8346ffa362ea4697$var$kNoIterator, _keys);
    } else if ($8346ffa362ea4697$var$isSet(val1)) {
        if (!$8346ffa362ea4697$var$isSet(val2) || val1.size !== val2.size) return false;
        return $8346ffa362ea4697$var$keyCheck(val1, val2, strict, memos, $8346ffa362ea4697$var$kIsSet);
    } else if ($8346ffa362ea4697$var$isMap(val1)) {
        if (!$8346ffa362ea4697$var$isMap(val2) || val1.size !== val2.size) return false;
        return $8346ffa362ea4697$var$keyCheck(val1, val2, strict, memos, $8346ffa362ea4697$var$kIsMap);
    } else if ($8346ffa362ea4697$var$isAnyArrayBuffer(val1)) {
        if (!$8346ffa362ea4697$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($8346ffa362ea4697$var$isBoxedPrimitive(val1) && !$8346ffa362ea4697$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $8346ffa362ea4697$var$keyCheck(val1, val2, strict, memos, $8346ffa362ea4697$var$kNoIterator);
}
function $8346ffa362ea4697$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $8346ffa362ea4697$var$propertyIsEnumerable(val, k);
    });
}
function $8346ffa362ea4697$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2);
        // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    }
    // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$8346ffa362ea4697$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $8346ffa362ea4697$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($8346ffa362ea4697$var$propertyIsEnumerable(val1, key)) {
                    if (!$8346ffa362ea4697$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($8346ffa362ea4697$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $8346ffa362ea4697$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $8346ffa362ea4697$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $8346ffa362ea4697$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $8346ffa362ea4697$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $8346ffa362ea4697$var$kNoIterator || iterationType === $8346ffa362ea4697$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
    // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $8346ffa362ea4697$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $8346ffa362ea4697$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $8346ffa362ea4697$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($8346ffa362ea4697$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
}
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $8346ffa362ea4697$var$findLooseMatchingPrimitives(prim) {
    switch($8346ffa362ea4697$var$_typeof(prim)){
        case 'undefined':
            return null;
        case 'object':
            // Only pass in null as object!
            return undefined;
        case 'symbol':
            return false;
        case 'string':
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case 'number':
            if ($8346ffa362ea4697$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $8346ffa362ea4697$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $8346ffa362ea4697$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $8346ffa362ea4697$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $8346ffa362ea4697$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$8346ffa362ea4697$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $8346ffa362ea4697$var$innerDeepEqual(item, curB, false, memo);
}
function $8346ffa362ea4697$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $8346ffa362ea4697$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i];
        // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($8346ffa362ea4697$var$_typeof(val) === 'object' && val !== null) {
            if (set === null) set = new Set();
            // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false;
            // Fast path to detect missing string, symbol, undefined and null values.
            if (!$8346ffa362ea4697$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $8346ffa362ea4697$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i];
            // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($8346ffa362ea4697$var$_typeof(_val) === 'object' && _val !== null) {
                if (!$8346ffa362ea4697$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$8346ffa362ea4697$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $8346ffa362ea4697$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $8346ffa362ea4697$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($8346ffa362ea4697$var$innerDeepEqual(key1, key2, strict, memo) && $8346ffa362ea4697$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $8346ffa362ea4697$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $8346ffa362ea4697$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $8346ffa362ea4697$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($8346ffa362ea4697$var$_typeof(key) === 'object' && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$8346ffa362ea4697$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false;
                // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$8346ffa362ea4697$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $8346ffa362ea4697$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $8346ffa362ea4697$var$_slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($8346ffa362ea4697$var$_typeof(_key) === 'object' && _key !== null) {
                if (!$8346ffa362ea4697$var$mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(_key) || !$8346ffa362ea4697$var$innerDeepEqual(a.get(_key), item, false, memo)) && !$8346ffa362ea4697$var$mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $8346ffa362ea4697$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $8346ffa362ea4697$var$kIsSet) {
        if (!$8346ffa362ea4697$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $8346ffa362ea4697$var$kIsMap) {
        if (!$8346ffa362ea4697$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $8346ffa362ea4697$var$kIsArray) for(; i < a.length; i++){
        if ($8346ffa362ea4697$var$hasOwnProperty(a, i)) {
            if (!$8346ffa362ea4697$var$hasOwnProperty(b, i) || !$8346ffa362ea4697$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($8346ffa362ea4697$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$8346ffa362ea4697$var$hasOwnProperty(b, key) || !$8346ffa362ea4697$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
    // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key2 = keys[i];
        if (!$8346ffa362ea4697$var$innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
    }
    return true;
}
function $8346ffa362ea4697$var$isDeepEqual(val1, val2) {
    return $8346ffa362ea4697$var$innerDeepEqual(val1, val2, $8346ffa362ea4697$var$kLoose);
}
function $8346ffa362ea4697$var$isDeepStrictEqual(val1, val2) {
    return $8346ffa362ea4697$var$innerDeepEqual(val1, val2, $8346ffa362ea4697$var$kStrict);
}
module.exports = {
    isDeepEqual: $8346ffa362ea4697$var$isDeepEqual,
    isDeepStrictEqual: $8346ffa362ea4697$var$isDeepStrictEqual
};

});
parcelRegister("eSXKX", function(module, exports) {
'use strict';

var $9uwfE = parcelRequire("9uwfE");

var $cZXXz = parcelRequire("cZXXz");

var $hQV2N = parcelRequire("hQV2N");

var $fI8Iu = parcelRequire("fI8Iu");

var $bkRlI = parcelRequire("bkRlI");
var $ad6476336423314f$var$polyfill = $cZXXz($fI8Iu(), Object);
$9uwfE($ad6476336423314f$var$polyfill, {
    getPolyfill: $fI8Iu,
    implementation: $hQV2N,
    shim: $bkRlI
});
module.exports = $ad6476336423314f$var$polyfill;

});
parcelRegister("9uwfE", function(module, exports) {
'use strict';

var $63xRK = parcelRequire("63xRK");
var $6e8feedf595bf5d4$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $6e8feedf595bf5d4$var$toStr = Object.prototype.toString;
var $6e8feedf595bf5d4$var$concat = Array.prototype.concat;

var $8JJpe = parcelRequire("8JJpe");
var $6e8feedf595bf5d4$var$isFunction = function(fn) {
    return typeof fn === 'function' && $6e8feedf595bf5d4$var$toStr.call(fn) === '[object Function]';
};

var $6e8feedf595bf5d4$var$supportsDescriptors = (parcelRequire("7DNYW"))();
var $6e8feedf595bf5d4$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$6e8feedf595bf5d4$var$isFunction(predicate) || !predicate()) return;
    }
    if ($6e8feedf595bf5d4$var$supportsDescriptors) $8JJpe(object, name, value, true);
    else $8JJpe(object, name, value);
};
var $6e8feedf595bf5d4$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $63xRK(map);
    if ($6e8feedf595bf5d4$var$hasSymbols) props = $6e8feedf595bf5d4$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$6e8feedf595bf5d4$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$6e8feedf595bf5d4$var$defineProperties.supportsDescriptors = !!$6e8feedf595bf5d4$var$supportsDescriptors;
module.exports = $6e8feedf595bf5d4$var$defineProperties;

});

parcelRegister("bkRlI", function(module, exports) {
'use strict';

var $fI8Iu = parcelRequire("fI8Iu");

var $9uwfE = parcelRequire("9uwfE");
module.exports = function shimObjectIs() {
    var polyfill = $fI8Iu();
    $9uwfE(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("9uy3b", function(module, exports) {
'use strict';

var $cZXXz = parcelRequire("cZXXz");

var $9uwfE = parcelRequire("9uwfE");

var $eUDPV = parcelRequire("eUDPV");

var $dF7F0 = parcelRequire("dF7F0");

var $aYT5D = parcelRequire("aYT5D");
var $6e9154196c9d205a$var$polyfill = $cZXXz($dF7F0(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $9uwfE($6e9154196c9d205a$var$polyfill, {
    getPolyfill: $dF7F0,
    implementation: $eUDPV,
    shim: $aYT5D
});
module.exports = $6e9154196c9d205a$var$polyfill;

});
parcelRegister("eUDPV", function(module, exports) {
'use strict';
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRegister("dF7F0", function(module, exports) {
'use strict';

var $eUDPV = parcelRequire("eUDPV");
module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) return Number.isNaN;
    return $eUDPV;
};

});

parcelRegister("aYT5D", function(module, exports) {
'use strict';

var $9uwfE = parcelRequire("9uwfE");

var $dF7F0 = parcelRequire("dF7F0");
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $dF7F0();
    $9uwfE(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});




parcelRegister("3fly5", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $25d37cf8c3b6e468$export$bf730a2d8bf68b42, (v) => $25d37cf8c3b6e468$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $25d37cf8c3b6e468$export$bf730a2d8bf68b42;
"use strict";

var $h2ArV = parcelRequire("h2ArV");

var $gJBKK = parcelRequire("gJBKK");
function $25d37cf8c3b6e468$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $25d37cf8c3b6e468$var$objectIs = "function" === typeof Object.is ? Object.is : $25d37cf8c3b6e468$var$is, $25d37cf8c3b6e468$var$useSyncExternalStore = $gJBKK.useSyncExternalStore, $25d37cf8c3b6e468$var$useRef = $h2ArV.useRef, $25d37cf8c3b6e468$var$useEffect = $h2ArV.useEffect, $25d37cf8c3b6e468$var$useMemo = $h2ArV.useMemo, $25d37cf8c3b6e468$var$useDebugValue = $h2ArV.useDebugValue;
$25d37cf8c3b6e468$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $25d37cf8c3b6e468$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $25d37cf8c3b6e468$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($25d37cf8c3b6e468$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $25d37cf8c3b6e468$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $25d37cf8c3b6e468$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $25d37cf8c3b6e468$var$useDebugValue(value);
    return value;
};

});
parcelRegister("gJBKK", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8CoLD"));

});
parcelRegister("8CoLD", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $6465159af9edb5b5$export$306c0aa65ff9ec16, (v) => $6465159af9edb5b5$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6465159af9edb5b5$export$306c0aa65ff9ec16;
"use strict";

var $h2ArV = parcelRequire("h2ArV");
function $6465159af9edb5b5$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $6465159af9edb5b5$var$objectIs = "function" === typeof Object.is ? Object.is : $6465159af9edb5b5$var$is, $6465159af9edb5b5$var$useState = $h2ArV.useState, $6465159af9edb5b5$var$useEffect = $h2ArV.useEffect, $6465159af9edb5b5$var$useLayoutEffect = $h2ArV.useLayoutEffect, $6465159af9edb5b5$var$useDebugValue = $h2ArV.useDebugValue;
function $6465159af9edb5b5$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $6465159af9edb5b5$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $6465159af9edb5b5$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $6465159af9edb5b5$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $6465159af9edb5b5$var$useEffect(function() {
        $6465159af9edb5b5$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $6465159af9edb5b5$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $6465159af9edb5b5$var$useDebugValue(value);
    return value;
}
function $6465159af9edb5b5$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$6465159af9edb5b5$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $6465159af9edb5b5$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $6465159af9edb5b5$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $6465159af9edb5b5$var$useSyncExternalStore$1 : $6465159af9edb5b5$var$useSyncExternalStore$2;
$6465159af9edb5b5$export$306c0aa65ff9ec16 = void 0 !== $h2ArV.useSyncExternalStore ? $h2ArV.useSyncExternalStore : $6465159af9edb5b5$var$shim;

});



parcelRegister("hkL0p", function(module, exports) {

$parcel$export(module.exports, "isDraft", () => r);
$parcel$export(module.exports, "isDraftable", () => t);
$parcel$export(module.exports, "immerable", () => L);
$parcel$export(module.exports, "original", () => e);
$parcel$export(module.exports, "freeze", () => d);
$parcel$export(module.exports, "nothing", () => H);
$parcel$export(module.exports, "current", () => R);
$parcel$export(module.exports, "enableES5", () => F);
$parcel$export(module.exports, "enablePatches", () => T);
$parcel$export(module.exports, "enableMapSet", () => C);
$parcel$export(module.exports, "enableAllPlugins", () => J);
$parcel$export(module.exports, "castDraft", () => K);
$parcel$export(module.exports, "castImmutable", () => $);
$parcel$export(module.exports, "Immer", () => un);
$parcel$export(module.exports, "produce", () => fn);
$parcel$export(module.exports, "produceWithPatches", () => cn);
$parcel$export(module.exports, "setAutoFreeze", () => sn);
$parcel$export(module.exports, "setUseProxies", () => vn);
$parcel$export(module.exports, "applyPatches", () => pn);
$parcel$export(module.exports, "createDraft", () => ln);
$parcel$export(module.exports, "finishDraft", () => dn);
$parcel$export(module.exports, "default", () => $c9e8c44478fe1be0$export$2e2bcd8739ae039);
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $c9e8c44478fe1be0$export$2e2bcd8739ae039 = fn;

});

parcelRegister("2ObCI", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', promiseTag = '[object Promise]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */ function addMapEntry(map, pair) {
    // Don't return `map.set` because it's not chainable in IE 11.
    map.set(pair[0], pair[1]);
    return map;
}
/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */ function addSetEntry(set, value) {
    // Don't return `set.add` because it's not chainable in IE 11.
    set.add(value);
    return set;
}
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array ? array.length : 0;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__['delete'](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) object[key] = value;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
}
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
    var result;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!isObject(value)) return value;
    var isArr = isArray(value);
    if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) return copyArray(value, result);
    } else {
        var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) return cloneBuffer(value, isDeep);
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
            if (isHostObject(value)) return object ? value : {};
            result = initCloneObject(isFunc ? {} : value);
            if (!isDeep) return copySymbols(value, baseAssign(result, value));
        } else {
            if (!cloneableTags[tag]) return object ? value : {};
            result = initCloneByTag(value, tag, baseClone, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if (!isArr) var props = isFull ? getAllKeys(value) : keys(value);
    arrayEach(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
    });
    return result;
}
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */ function baseCreate(proto) {
    return isObject(proto) ? objectCreate(proto) : {};
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var result = new buffer.constructor(buffer.length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */ function cloneMap(map, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
    return arrayReduce(array, addMapEntry, new map.constructor);
}
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */ function cloneSet(set, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
    return arrayReduce(array, addSetEntry, new set.constructor);
}
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        assignValue(object, key, newValue === undefined ? source[key] : newValue);
    }
    return object;
}
/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray(array) {
    var length = array.length, result = array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag(object, tag, cloneFunc, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case arrayBufferTag:
            return cloneArrayBuffer(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case dataViewTag:
            return cloneDataView(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            return cloneTypedArray(object, isDeep);
        case mapTag:
            return cloneMap(object, isDeep, cloneFunc);
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            return cloneRegExp(object);
        case setTag:
            return cloneSet(object, isDeep, cloneFunc);
        case symbolTag:
            return cloneSymbol(object);
    }
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function cloneDeep(value) {
    return baseClone(value, true, true);
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = cloneDeep;

});

parcelRegister("1fEyG", function(module, exports) {
typeof document !== "undefined" && typeof navigator !== "undefined" && function(global, factory) {
    module.exports = factory();
}(module.exports, function() {
    'use strict';
    var svgNS = 'http://www.w3.org/2000/svg';
    var locationHref = '';
    var _useWebWorker = false;
    var initialDefaultFrame = -999999;
    var setWebWorker = function setWebWorker(flag) {
        _useWebWorker = !!flag;
    };
    var getWebWorker = function getWebWorker() {
        return _useWebWorker;
    };
    var setLocationHref = function setLocationHref(value) {
        locationHref = value;
    };
    var getLocationHref = function getLocationHref() {
        return locationHref;
    };
    function createTag(type) {
        // return {appendChild:function(){},setAttribute:function(){},style:{}}
        return document.createElement(type);
    }
    function extendPrototype(sources, destination) {
        var i;
        var len = sources.length;
        var sourcePrototype;
        for(i = 0; i < len; i += 1){
            sourcePrototype = sources[i].prototype;
            for(var attr in sourcePrototype)if (Object.prototype.hasOwnProperty.call(sourcePrototype, attr)) destination.prototype[attr] = sourcePrototype[attr];
        }
    }
    function getDescriptor(object, prop) {
        return Object.getOwnPropertyDescriptor(object, prop);
    }
    function createProxyFunction(prototype) {
        function ProxyFunction() {}
        ProxyFunction.prototype = prototype;
        return ProxyFunction;
    }
    // import Howl from '../../3rd_party/howler';
    var audioControllerFactory = function() {
        function AudioController(audioFactory) {
            this.audios = [];
            this.audioFactory = audioFactory;
            this._volume = 1;
            this._isMuted = false;
        }
        AudioController.prototype = {
            addAudio: function addAudio(audio) {
                this.audios.push(audio);
            },
            pause: function pause() {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].pause();
            },
            resume: function resume() {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].resume();
            },
            setRate: function setRate(rateValue) {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].setRate(rateValue);
            },
            createAudio: function createAudio(assetPath) {
                if (this.audioFactory) return this.audioFactory(assetPath);
                if (window.Howl) return new window.Howl({
                    src: [
                        assetPath
                    ]
                });
                return {
                    isPlaying: false,
                    play: function play() {
                        this.isPlaying = true;
                    },
                    seek: function seek() {
                        this.isPlaying = false;
                    },
                    playing: function playing() {},
                    rate: function rate() {},
                    setVolume: function setVolume() {}
                };
            },
            setAudioFactory: function setAudioFactory(audioFactory) {
                this.audioFactory = audioFactory;
            },
            setVolume: function setVolume(value) {
                this._volume = value;
                this._updateVolume();
            },
            mute: function mute() {
                this._isMuted = true;
                this._updateVolume();
            },
            unmute: function unmute() {
                this._isMuted = false;
                this._updateVolume();
            },
            getVolume: function getVolume() {
                return this._volume;
            },
            _updateVolume: function _updateVolume() {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].volume(this._volume * (this._isMuted ? 0 : 1));
            }
        };
        return function() {
            return new AudioController();
        };
    }();
    var createTypedArray = function() {
        function createRegularArray(type, len) {
            var i = 0;
            var arr = [];
            var value;
            switch(type){
                case 'int16':
                case 'uint8c':
                    value = 1;
                    break;
                default:
                    value = 1.1;
                    break;
            }
            for(i = 0; i < len; i += 1)arr.push(value);
            return arr;
        }
        function createTypedArrayFactory(type, len) {
            if (type === 'float32') return new Float32Array(len);
            if (type === 'int16') return new Int16Array(len);
            if (type === 'uint8c') return new Uint8ClampedArray(len);
            return createRegularArray(type, len);
        }
        if (typeof Uint8ClampedArray === 'function' && typeof Float32Array === 'function') return createTypedArrayFactory;
        return createRegularArray;
    }();
    function createSizedArray(len) {
        return Array.apply(null, {
            length: len
        });
    }
    function _typeof$3(o) {
        "@babel/helpers - typeof";
        return _typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, _typeof$3(o);
    }
    var subframeEnabled = true;
    var expressionsPlugin = null;
    var expressionsInterfaces = null;
    var idPrefix$1 = '';
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    var _shouldRoundValues = false;
    var bmPow = Math.pow;
    var bmSqrt = Math.sqrt;
    var bmFloor = Math.floor;
    var bmMax = Math.max;
    var bmMin = Math.min;
    var BMMath = {};
    (function() {
        var propertyNames = [
            'abs',
            'acos',
            'acosh',
            'asin',
            'asinh',
            'atan',
            'atanh',
            'atan2',
            'ceil',
            'cbrt',
            'expm1',
            'clz32',
            'cos',
            'cosh',
            'exp',
            'floor',
            'fround',
            'hypot',
            'imul',
            'log',
            'log1p',
            'log2',
            'log10',
            'max',
            'min',
            'pow',
            'random',
            'round',
            'sign',
            'sin',
            'sinh',
            'sqrt',
            'tan',
            'tanh',
            'trunc',
            'E',
            'LN10',
            'LN2',
            'LOG10E',
            'LOG2E',
            'PI',
            'SQRT1_2',
            'SQRT2'
        ];
        var i;
        var len = propertyNames.length;
        for(i = 0; i < len; i += 1)BMMath[propertyNames[i]] = Math[propertyNames[i]];
    })();
    function ProjectInterface$1() {
        return {};
    }
    BMMath.random = Math.random;
    BMMath.abs = function(val) {
        var tOfVal = _typeof$3(val);
        if (tOfVal === 'object' && val.length) {
            var absArr = createSizedArray(val.length);
            var i;
            var len = val.length;
            for(i = 0; i < len; i += 1)absArr[i] = Math.abs(val[i]);
            return absArr;
        }
        return Math.abs(val);
    };
    var defaultCurveSegments = 150;
    var degToRads = Math.PI / 180;
    var roundCorner = 0.5519;
    function roundValues(flag) {
        _shouldRoundValues = !!flag;
    }
    function bmRnd(value) {
        if (_shouldRoundValues) return Math.round(value);
        return value;
    }
    function styleDiv(element) {
        element.style.position = 'absolute';
        element.style.top = 0;
        element.style.left = 0;
        element.style.display = 'block';
        element.style.transformOrigin = '0 0';
        element.style.webkitTransformOrigin = '0 0';
        element.style.backfaceVisibility = 'visible';
        element.style.webkitBackfaceVisibility = 'visible';
        element.style.transformStyle = 'preserve-3d';
        element.style.webkitTransformStyle = 'preserve-3d';
        element.style.mozTransformStyle = 'preserve-3d';
    }
    function BMEnterFrameEvent(type, currentTime, totalTime, frameMultiplier) {
        this.type = type;
        this.currentTime = currentTime;
        this.totalTime = totalTime;
        this.direction = frameMultiplier < 0 ? -1 : 1;
    }
    function BMCompleteEvent(type, frameMultiplier) {
        this.type = type;
        this.direction = frameMultiplier < 0 ? -1 : 1;
    }
    function BMCompleteLoopEvent(type, totalLoops, currentLoop, frameMultiplier) {
        this.type = type;
        this.currentLoop = currentLoop;
        this.totalLoops = totalLoops;
        this.direction = frameMultiplier < 0 ? -1 : 1;
    }
    function BMSegmentStartEvent(type, firstFrame, totalFrames) {
        this.type = type;
        this.firstFrame = firstFrame;
        this.totalFrames = totalFrames;
    }
    function BMDestroyEvent(type, target) {
        this.type = type;
        this.target = target;
    }
    function BMRenderFrameErrorEvent(nativeError, currentTime) {
        this.type = 'renderFrameError';
        this.nativeError = nativeError;
        this.currentTime = currentTime;
    }
    function BMConfigErrorEvent(nativeError) {
        this.type = 'configError';
        this.nativeError = nativeError;
    }
    function BMAnimationConfigErrorEvent(type, nativeError) {
        this.type = type;
        this.nativeError = nativeError;
    }
    var createElementID = function() {
        var _count = 0;
        return function createID() {
            _count += 1;
            return idPrefix$1 + '__lottie_element_' + _count;
        };
    }();
    function HSVtoRGB(h, s, v) {
        var r;
        var g;
        var b;
        var i;
        var f;
        var p;
        var q;
        var t;
        i = Math.floor(h * 6);
        f = h * 6 - i;
        p = v * (1 - s);
        q = v * (1 - f * s);
        t = v * (1 - (1 - f) * s);
        switch(i % 6){
            case 0:
                r = v;
                g = t;
                b = p;
                break;
            case 1:
                r = q;
                g = v;
                b = p;
                break;
            case 2:
                r = p;
                g = v;
                b = t;
                break;
            case 3:
                r = p;
                g = q;
                b = v;
                break;
            case 4:
                r = t;
                g = p;
                b = v;
                break;
            case 5:
                r = v;
                g = p;
                b = q;
                break;
            default:
                break;
        }
        return [
            r,
            g,
            b
        ];
    }
    function RGBtoHSV(r, g, b) {
        var max = Math.max(r, g, b);
        var min = Math.min(r, g, b);
        var d = max - min;
        var h;
        var s = max === 0 ? 0 : d / max;
        var v = max / 255;
        switch(max){
            case min:
                h = 0;
                break;
            case r:
                h = g - b + d * (g < b ? 6 : 0);
                h /= 6 * d;
                break;
            case g:
                h = b - r + d * 2;
                h /= 6 * d;
                break;
            case b:
                h = r - g + d * 4;
                h /= 6 * d;
                break;
            default:
                break;
        }
        return [
            h,
            s,
            v
        ];
    }
    function addSaturationToRGB(color, offset) {
        var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
        hsv[1] += offset;
        if (hsv[1] > 1) hsv[1] = 1;
        else if (hsv[1] <= 0) hsv[1] = 0;
        return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
    }
    function addBrightnessToRGB(color, offset) {
        var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
        hsv[2] += offset;
        if (hsv[2] > 1) hsv[2] = 1;
        else if (hsv[2] < 0) hsv[2] = 0;
        return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
    }
    function addHueToRGB(color, offset) {
        var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
        hsv[0] += offset / 360;
        if (hsv[0] > 1) hsv[0] -= 1;
        else if (hsv[0] < 0) hsv[0] += 1;
        return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
    }
    var rgbToHex = function() {
        var colorMap = [];
        var i;
        var hex;
        for(i = 0; i < 256; i += 1){
            hex = i.toString(16);
            colorMap[i] = hex.length === 1 ? '0' + hex : hex;
        }
        return function(r, g, b) {
            if (r < 0) r = 0;
            if (g < 0) g = 0;
            if (b < 0) b = 0;
            return '#' + colorMap[r] + colorMap[g] + colorMap[b];
        };
    }();
    var setSubframeEnabled = function setSubframeEnabled(flag) {
        subframeEnabled = !!flag;
    };
    var getSubframeEnabled = function getSubframeEnabled() {
        return subframeEnabled;
    };
    var setExpressionsPlugin = function setExpressionsPlugin(value) {
        expressionsPlugin = value;
    };
    var getExpressionsPlugin = function getExpressionsPlugin() {
        return expressionsPlugin;
    };
    var setExpressionInterfaces = function setExpressionInterfaces(value) {
        expressionsInterfaces = value;
    };
    var getExpressionInterfaces = function getExpressionInterfaces() {
        return expressionsInterfaces;
    };
    var setDefaultCurveSegments = function setDefaultCurveSegments(value) {
        defaultCurveSegments = value;
    };
    var getDefaultCurveSegments = function getDefaultCurveSegments() {
        return defaultCurveSegments;
    };
    var setIdPrefix = function setIdPrefix(value) {
        idPrefix$1 = value;
    };
    var getIdPrefix = function getIdPrefix() {
        return idPrefix$1;
    };
    function createNS(type) {
        // return {appendChild:function(){},setAttribute:function(){},style:{}}
        return document.createElementNS(svgNS, type);
    }
    function _typeof$2(o) {
        "@babel/helpers - typeof";
        return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, _typeof$2(o);
    }
    var dataManager = function() {
        var _counterId = 1;
        var processes = [];
        var workerFn;
        var workerInstance;
        var workerProxy = {
            onmessage: function onmessage() {},
            postMessage: function postMessage(path) {
                workerFn({
                    data: path
                });
            }
        };
        var _workerSelf = {
            postMessage: function postMessage(data) {
                workerProxy.onmessage({
                    data: data
                });
            }
        };
        function createWorker(fn) {
            if (window.Worker && window.Blob && getWebWorker()) {
                var blob = new Blob([
                    'var _workerSelf = self; self.onmessage = ',
                    fn.toString()
                ], {
                    type: 'text/javascript'
                });
                // var blob = new Blob(['self.onmessage = ', fn.toString()], { type: 'text/javascript' });
                var url = URL.createObjectURL(blob);
                return new Worker(url);
            }
            workerFn = fn;
            return workerProxy;
        }
        function setupWorker() {
            if (!workerInstance) {
                workerInstance = createWorker(function workerStart(e) {
                    function dataFunctionManager() {
                        function completeLayers(layers, comps) {
                            var layerData;
                            var i;
                            var len = layers.length;
                            var j;
                            var jLen;
                            var k;
                            var kLen;
                            for(i = 0; i < len; i += 1){
                                layerData = layers[i];
                                if ('ks' in layerData && !layerData.completed) {
                                    layerData.completed = true;
                                    if (layerData.hasMask) {
                                        var maskProps = layerData.masksProperties;
                                        jLen = maskProps.length;
                                        for(j = 0; j < jLen; j += 1)if (maskProps[j].pt.k.i) convertPathsToAbsoluteValues(maskProps[j].pt.k);
                                        else {
                                            kLen = maskProps[j].pt.k.length;
                                            for(k = 0; k < kLen; k += 1){
                                                if (maskProps[j].pt.k[k].s) convertPathsToAbsoluteValues(maskProps[j].pt.k[k].s[0]);
                                                if (maskProps[j].pt.k[k].e) convertPathsToAbsoluteValues(maskProps[j].pt.k[k].e[0]);
                                            }
                                        }
                                    }
                                    if (layerData.ty === 0) {
                                        layerData.layers = findCompLayers(layerData.refId, comps);
                                        completeLayers(layerData.layers, comps);
                                    } else if (layerData.ty === 4) completeShapes(layerData.shapes);
                                    else if (layerData.ty === 5) completeText(layerData);
                                }
                            }
                        }
                        function completeChars(chars, assets) {
                            if (chars) {
                                var i = 0;
                                var len = chars.length;
                                for(i = 0; i < len; i += 1)if (chars[i].t === 1) {
                                    // var compData = findComp(chars[i].data.refId, assets);
                                    chars[i].data.layers = findCompLayers(chars[i].data.refId, assets);
                                    // chars[i].data.ip = 0;
                                    // chars[i].data.op = 99999;
                                    // chars[i].data.st = 0;
                                    // chars[i].data.sr = 1;
                                    // chars[i].w = compData.w;
                                    // chars[i].data.ks = {
                                    //   a: { k: [0, 0, 0], a: 0 },
                                    //   p: { k: [0, -compData.h, 0], a: 0 },
                                    //   r: { k: 0, a: 0 },
                                    //   s: { k: [100, 100], a: 0 },
                                    //   o: { k: 100, a: 0 },
                                    // };
                                    completeLayers(chars[i].data.layers, assets);
                                }
                            }
                        }
                        function findComp(id, comps) {
                            var i = 0;
                            var len = comps.length;
                            while(i < len){
                                if (comps[i].id === id) return comps[i];
                                i += 1;
                            }
                            return null;
                        }
                        function findCompLayers(id, comps) {
                            var comp = findComp(id, comps);
                            if (comp) {
                                if (!comp.layers.__used) {
                                    comp.layers.__used = true;
                                    return comp.layers;
                                }
                                return JSON.parse(JSON.stringify(comp.layers));
                            }
                            return null;
                        }
                        function completeShapes(arr) {
                            var i;
                            var len = arr.length;
                            var j;
                            var jLen;
                            for(i = len - 1; i >= 0; i -= 1){
                                if (arr[i].ty === 'sh') {
                                    if (arr[i].ks.k.i) convertPathsToAbsoluteValues(arr[i].ks.k);
                                    else {
                                        jLen = arr[i].ks.k.length;
                                        for(j = 0; j < jLen; j += 1){
                                            if (arr[i].ks.k[j].s) convertPathsToAbsoluteValues(arr[i].ks.k[j].s[0]);
                                            if (arr[i].ks.k[j].e) convertPathsToAbsoluteValues(arr[i].ks.k[j].e[0]);
                                        }
                                    }
                                } else if (arr[i].ty === 'gr') completeShapes(arr[i].it);
                            }
                        }
                        function convertPathsToAbsoluteValues(path) {
                            var i;
                            var len = path.i.length;
                            for(i = 0; i < len; i += 1){
                                path.i[i][0] += path.v[i][0];
                                path.i[i][1] += path.v[i][1];
                                path.o[i][0] += path.v[i][0];
                                path.o[i][1] += path.v[i][1];
                            }
                        }
                        function checkVersion(minimum, animVersionString) {
                            var animVersion = animVersionString ? animVersionString.split('.') : [
                                100,
                                100,
                                100
                            ];
                            if (minimum[0] > animVersion[0]) return true;
                            if (animVersion[0] > minimum[0]) return false;
                            if (minimum[1] > animVersion[1]) return true;
                            if (animVersion[1] > minimum[1]) return false;
                            if (minimum[2] > animVersion[2]) return true;
                            if (animVersion[2] > minimum[2]) return false;
                            return null;
                        }
                        var checkText = function() {
                            var minimumVersion = [
                                4,
                                4,
                                14
                            ];
                            function updateTextLayer(textLayer) {
                                var documentData = textLayer.t.d;
                                textLayer.t.d = {
                                    k: [
                                        {
                                            s: documentData,
                                            t: 0
                                        }
                                    ]
                                };
                            }
                            function iterateLayers(layers) {
                                var i;
                                var len = layers.length;
                                for(i = 0; i < len; i += 1)if (layers[i].ty === 5) updateTextLayer(layers[i]);
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        var checkChars = function() {
                            var minimumVersion = [
                                4,
                                7,
                                99
                            ];
                            return function(animationData) {
                                if (animationData.chars && !checkVersion(minimumVersion, animationData.v)) {
                                    var i;
                                    var len = animationData.chars.length;
                                    for(i = 0; i < len; i += 1){
                                        var charData = animationData.chars[i];
                                        if (charData.data && charData.data.shapes) {
                                            completeShapes(charData.data.shapes);
                                            charData.data.ip = 0;
                                            charData.data.op = 99999;
                                            charData.data.st = 0;
                                            charData.data.sr = 1;
                                            charData.data.ks = {
                                                p: {
                                                    k: [
                                                        0,
                                                        0
                                                    ],
                                                    a: 0
                                                },
                                                s: {
                                                    k: [
                                                        100,
                                                        100
                                                    ],
                                                    a: 0
                                                },
                                                a: {
                                                    k: [
                                                        0,
                                                        0
                                                    ],
                                                    a: 0
                                                },
                                                r: {
                                                    k: 0,
                                                    a: 0
                                                },
                                                o: {
                                                    k: 100,
                                                    a: 0
                                                }
                                            };
                                            if (!animationData.chars[i].t) {
                                                charData.data.shapes.push({
                                                    ty: 'no'
                                                });
                                                charData.data.shapes[0].it.push({
                                                    p: {
                                                        k: [
                                                            0,
                                                            0
                                                        ],
                                                        a: 0
                                                    },
                                                    s: {
                                                        k: [
                                                            100,
                                                            100
                                                        ],
                                                        a: 0
                                                    },
                                                    a: {
                                                        k: [
                                                            0,
                                                            0
                                                        ],
                                                        a: 0
                                                    },
                                                    r: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    o: {
                                                        k: 100,
                                                        a: 0
                                                    },
                                                    sk: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    sa: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    ty: 'tr'
                                                });
                                            }
                                        }
                                    }
                                }
                            };
                        }();
                        var checkPathProperties = function() {
                            var minimumVersion = [
                                5,
                                7,
                                15
                            ];
                            function updateTextLayer(textLayer) {
                                var pathData = textLayer.t.p;
                                if (typeof pathData.a === 'number') pathData.a = {
                                    a: 0,
                                    k: pathData.a
                                };
                                if (typeof pathData.p === 'number') pathData.p = {
                                    a: 0,
                                    k: pathData.p
                                };
                                if (typeof pathData.r === 'number') pathData.r = {
                                    a: 0,
                                    k: pathData.r
                                };
                            }
                            function iterateLayers(layers) {
                                var i;
                                var len = layers.length;
                                for(i = 0; i < len; i += 1)if (layers[i].ty === 5) updateTextLayer(layers[i]);
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        var checkColors = function() {
                            var minimumVersion = [
                                4,
                                1,
                                9
                            ];
                            function iterateShapes(shapes) {
                                var i;
                                var len = shapes.length;
                                var j;
                                var jLen;
                                for(i = 0; i < len; i += 1){
                                    if (shapes[i].ty === 'gr') iterateShapes(shapes[i].it);
                                    else if (shapes[i].ty === 'fl' || shapes[i].ty === 'st') {
                                        if (shapes[i].c.k && shapes[i].c.k[0].i) {
                                            jLen = shapes[i].c.k.length;
                                            for(j = 0; j < jLen; j += 1){
                                                if (shapes[i].c.k[j].s) {
                                                    shapes[i].c.k[j].s[0] /= 255;
                                                    shapes[i].c.k[j].s[1] /= 255;
                                                    shapes[i].c.k[j].s[2] /= 255;
                                                    shapes[i].c.k[j].s[3] /= 255;
                                                }
                                                if (shapes[i].c.k[j].e) {
                                                    shapes[i].c.k[j].e[0] /= 255;
                                                    shapes[i].c.k[j].e[1] /= 255;
                                                    shapes[i].c.k[j].e[2] /= 255;
                                                    shapes[i].c.k[j].e[3] /= 255;
                                                }
                                            }
                                        } else {
                                            shapes[i].c.k[0] /= 255;
                                            shapes[i].c.k[1] /= 255;
                                            shapes[i].c.k[2] /= 255;
                                            shapes[i].c.k[3] /= 255;
                                        }
                                    }
                                }
                            }
                            function iterateLayers(layers) {
                                var i;
                                var len = layers.length;
                                for(i = 0; i < len; i += 1)if (layers[i].ty === 4) iterateShapes(layers[i].shapes);
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        var checkShapes = function() {
                            var minimumVersion = [
                                4,
                                4,
                                18
                            ];
                            function completeClosingShapes(arr) {
                                var i;
                                var len = arr.length;
                                var j;
                                var jLen;
                                for(i = len - 1; i >= 0; i -= 1){
                                    if (arr[i].ty === 'sh') {
                                        if (arr[i].ks.k.i) arr[i].ks.k.c = arr[i].closed;
                                        else {
                                            jLen = arr[i].ks.k.length;
                                            for(j = 0; j < jLen; j += 1){
                                                if (arr[i].ks.k[j].s) arr[i].ks.k[j].s[0].c = arr[i].closed;
                                                if (arr[i].ks.k[j].e) arr[i].ks.k[j].e[0].c = arr[i].closed;
                                            }
                                        }
                                    } else if (arr[i].ty === 'gr') completeClosingShapes(arr[i].it);
                                }
                            }
                            function iterateLayers(layers) {
                                var layerData;
                                var i;
                                var len = layers.length;
                                var j;
                                var jLen;
                                var k;
                                var kLen;
                                for(i = 0; i < len; i += 1){
                                    layerData = layers[i];
                                    if (layerData.hasMask) {
                                        var maskProps = layerData.masksProperties;
                                        jLen = maskProps.length;
                                        for(j = 0; j < jLen; j += 1)if (maskProps[j].pt.k.i) maskProps[j].pt.k.c = maskProps[j].cl;
                                        else {
                                            kLen = maskProps[j].pt.k.length;
                                            for(k = 0; k < kLen; k += 1){
                                                if (maskProps[j].pt.k[k].s) maskProps[j].pt.k[k].s[0].c = maskProps[j].cl;
                                                if (maskProps[j].pt.k[k].e) maskProps[j].pt.k[k].e[0].c = maskProps[j].cl;
                                            }
                                        }
                                    }
                                    if (layerData.ty === 4) completeClosingShapes(layerData.shapes);
                                }
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        function completeData(animationData) {
                            if (animationData.__complete) return;
                            checkColors(animationData);
                            checkText(animationData);
                            checkChars(animationData);
                            checkPathProperties(animationData);
                            checkShapes(animationData);
                            completeLayers(animationData.layers, animationData.assets);
                            completeChars(animationData.chars, animationData.assets);
                            animationData.__complete = true;
                        }
                        function completeText(data) {
                            data.t.a.length === 0 && data.t.p;
                        }
                        var moduleOb = {};
                        moduleOb.completeData = completeData;
                        moduleOb.checkColors = checkColors;
                        moduleOb.checkChars = checkChars;
                        moduleOb.checkPathProperties = checkPathProperties;
                        moduleOb.checkShapes = checkShapes;
                        moduleOb.completeLayers = completeLayers;
                        return moduleOb;
                    }
                    if (!_workerSelf.dataManager) _workerSelf.dataManager = dataFunctionManager();
                    if (!_workerSelf.assetLoader) _workerSelf.assetLoader = function() {
                        function formatResponse(xhr) {
                            // using typeof doubles the time of execution of this method,
                            // so if available, it's better to use the header to validate the type
                            var contentTypeHeader = xhr.getResponseHeader('content-type');
                            if (contentTypeHeader && xhr.responseType === 'json' && contentTypeHeader.indexOf('json') !== -1) return xhr.response;
                            if (xhr.response && _typeof$2(xhr.response) === 'object') return xhr.response;
                            if (xhr.response && typeof xhr.response === 'string') return JSON.parse(xhr.response);
                            if (xhr.responseText) return JSON.parse(xhr.responseText);
                            return null;
                        }
                        function loadAsset(path, fullPath, callback, errorCallback) {
                            var response;
                            var xhr = new XMLHttpRequest();
                            // set responseType after calling open or IE will break.
                            try {
                                // This crashes on Android WebView prior to KitKat
                                xhr.responseType = 'json';
                            } catch (err) {} // eslint-disable-line no-empty
                            xhr.onreadystatechange = function() {
                                if (xhr.readyState === 4) {
                                    if (xhr.status === 200) {
                                        response = formatResponse(xhr);
                                        callback(response);
                                    } else try {
                                        response = formatResponse(xhr);
                                        callback(response);
                                    } catch (err) {
                                        if (errorCallback) errorCallback(err);
                                    }
                                }
                            };
                            try {
                                // Hack to workaround banner validation
                                xhr.open([
                                    'G',
                                    'E',
                                    'T'
                                ].join(''), path, true);
                            } catch (error) {
                                // Hack to workaround banner validation
                                xhr.open([
                                    'G',
                                    'E',
                                    'T'
                                ].join(''), fullPath + '/' + path, true);
                            }
                            xhr.send();
                        }
                        return {
                            load: loadAsset
                        };
                    }();
                    if (e.data.type === 'loadAnimation') _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function(data) {
                        _workerSelf.dataManager.completeData(data);
                        _workerSelf.postMessage({
                            id: e.data.id,
                            payload: data,
                            status: 'success'
                        });
                    }, function() {
                        _workerSelf.postMessage({
                            id: e.data.id,
                            status: 'error'
                        });
                    });
                    else if (e.data.type === 'complete') {
                        var animation = e.data.animation;
                        _workerSelf.dataManager.completeData(animation);
                        _workerSelf.postMessage({
                            id: e.data.id,
                            payload: animation,
                            status: 'success'
                        });
                    } else if (e.data.type === 'loadData') _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function(data) {
                        _workerSelf.postMessage({
                            id: e.data.id,
                            payload: data,
                            status: 'success'
                        });
                    }, function() {
                        _workerSelf.postMessage({
                            id: e.data.id,
                            status: 'error'
                        });
                    });
                });
                workerInstance.onmessage = function(event) {
                    var data = event.data;
                    var id = data.id;
                    var process = processes[id];
                    processes[id] = null;
                    if (data.status === 'success') process.onComplete(data.payload);
                    else if (process.onError) process.onError();
                };
            }
        }
        function createProcess(onComplete, onError) {
            _counterId += 1;
            var id = 'processId_' + _counterId;
            processes[id] = {
                onComplete: onComplete,
                onError: onError
            };
            return id;
        }
        function loadAnimation(path, onComplete, onError) {
            setupWorker();
            var processId = createProcess(onComplete, onError);
            workerInstance.postMessage({
                type: 'loadAnimation',
                path: path,
                fullPath: window.location.origin + window.location.pathname,
                id: processId
            });
        }
        function loadData(path, onComplete, onError) {
            setupWorker();
            var processId = createProcess(onComplete, onError);
            workerInstance.postMessage({
                type: 'loadData',
                path: path,
                fullPath: window.location.origin + window.location.pathname,
                id: processId
            });
        }
        function completeAnimation(anim, onComplete, onError) {
            setupWorker();
            var processId = createProcess(onComplete, onError);
            workerInstance.postMessage({
                type: 'complete',
                animation: anim,
                id: processId
            });
        }
        return {
            loadAnimation: loadAnimation,
            loadData: loadData,
            completeAnimation: completeAnimation
        };
    }();
    var ImagePreloader = function() {
        var proxyImage = function() {
            var canvas = createTag('canvas');
            canvas.width = 1;
            canvas.height = 1;
            var ctx = canvas.getContext('2d');
            ctx.fillStyle = 'rgba(0,0,0,0)';
            ctx.fillRect(0, 0, 1, 1);
            return canvas;
        }();
        function imageLoaded() {
            this.loadedAssets += 1;
            if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
                if (this.imagesLoadedCb) this.imagesLoadedCb(null);
            }
        }
        function footageLoaded() {
            this.loadedFootagesCount += 1;
            if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
                if (this.imagesLoadedCb) this.imagesLoadedCb(null);
            }
        }
        function getAssetsPath(assetData, assetsPath, originalPath) {
            var path = '';
            if (assetData.e) path = assetData.p;
            else if (assetsPath) {
                var imagePath = assetData.p;
                if (imagePath.indexOf('images/') !== -1) imagePath = imagePath.split('/')[1];
                path = assetsPath + imagePath;
            } else {
                path = originalPath;
                path += assetData.u ? assetData.u : '';
                path += assetData.p;
            }
            return path;
        }
        function testImageLoaded(img) {
            var _count = 0;
            var intervalId = setInterval((function() {
                var box = img.getBBox();
                if (box.width || _count > 500) {
                    this._imageLoaded();
                    clearInterval(intervalId);
                }
                _count += 1;
            }).bind(this), 50);
        }
        function createImageData(assetData) {
            var path = getAssetsPath(assetData, this.assetsPath, this.path);
            var img = createNS('image');
            if (isSafari) this.testImageLoaded(img);
            else img.addEventListener('load', this._imageLoaded, false);
            img.addEventListener('error', (function() {
                ob.img = proxyImage;
                this._imageLoaded();
            }).bind(this), false);
            img.setAttributeNS('http://www.w3.org/1999/xlink', 'href', path);
            if (this._elementHelper.append) this._elementHelper.append(img);
            else this._elementHelper.appendChild(img);
            var ob = {
                img: img,
                assetData: assetData
            };
            return ob;
        }
        function createImgData(assetData) {
            var path = getAssetsPath(assetData, this.assetsPath, this.path);
            var img = createTag('img');
            img.crossOrigin = 'anonymous';
            img.addEventListener('load', this._imageLoaded, false);
            img.addEventListener('error', (function() {
                ob.img = proxyImage;
                this._imageLoaded();
            }).bind(this), false);
            img.src = path;
            var ob = {
                img: img,
                assetData: assetData
            };
            return ob;
        }
        function createFootageData(data) {
            var ob = {
                assetData: data
            };
            var path = getAssetsPath(data, this.assetsPath, this.path);
            dataManager.loadData(path, (function(footageData) {
                ob.img = footageData;
                this._footageLoaded();
            }).bind(this), (function() {
                ob.img = {};
                this._footageLoaded();
            }).bind(this));
            return ob;
        }
        function loadAssets(assets, cb) {
            this.imagesLoadedCb = cb;
            var i;
            var len = assets.length;
            for(i = 0; i < len; i += 1)if (!assets[i].layers) {
                if (!assets[i].t || assets[i].t === 'seq') {
                    this.totalImages += 1;
                    this.images.push(this._createImageData(assets[i]));
                } else if (assets[i].t === 3) {
                    this.totalFootages += 1;
                    this.images.push(this.createFootageData(assets[i]));
                }
            }
        }
        function setPath(path) {
            this.path = path || '';
        }
        function setAssetsPath(path) {
            this.assetsPath = path || '';
        }
        function getAsset(assetData) {
            var i = 0;
            var len = this.images.length;
            while(i < len){
                if (this.images[i].assetData === assetData) return this.images[i].img;
                i += 1;
            }
            return null;
        }
        function destroy() {
            this.imagesLoadedCb = null;
            this.images.length = 0;
        }
        function loadedImages() {
            return this.totalImages === this.loadedAssets;
        }
        function loadedFootages() {
            return this.totalFootages === this.loadedFootagesCount;
        }
        function setCacheType(type, elementHelper) {
            if (type === 'svg') {
                this._elementHelper = elementHelper;
                this._createImageData = this.createImageData.bind(this);
            } else this._createImageData = this.createImgData.bind(this);
        }
        function ImagePreloaderFactory() {
            this._imageLoaded = imageLoaded.bind(this);
            this._footageLoaded = footageLoaded.bind(this);
            this.testImageLoaded = testImageLoaded.bind(this);
            this.createFootageData = createFootageData.bind(this);
            this.assetsPath = '';
            this.path = '';
            this.totalImages = 0;
            this.totalFootages = 0;
            this.loadedAssets = 0;
            this.loadedFootagesCount = 0;
            this.imagesLoadedCb = null;
            this.images = [];
        }
        ImagePreloaderFactory.prototype = {
            loadAssets: loadAssets,
            setAssetsPath: setAssetsPath,
            setPath: setPath,
            loadedImages: loadedImages,
            loadedFootages: loadedFootages,
            destroy: destroy,
            getAsset: getAsset,
            createImgData: createImgData,
            createImageData: createImageData,
            imageLoaded: imageLoaded,
            footageLoaded: footageLoaded,
            setCacheType: setCacheType
        };
        return ImagePreloaderFactory;
    }();
    function BaseEvent() {}
    BaseEvent.prototype = {
        triggerEvent: function triggerEvent(eventName, args) {
            if (this._cbs[eventName]) {
                var callbacks = this._cbs[eventName];
                for(var i = 0; i < callbacks.length; i += 1)callbacks[i](args);
            }
        },
        addEventListener: function addEventListener(eventName, callback) {
            if (!this._cbs[eventName]) this._cbs[eventName] = [];
            this._cbs[eventName].push(callback);
            return (function() {
                this.removeEventListener(eventName, callback);
            }).bind(this);
        },
        removeEventListener: function removeEventListener(eventName, callback) {
            if (!callback) this._cbs[eventName] = null;
            else if (this._cbs[eventName]) {
                var i = 0;
                var len = this._cbs[eventName].length;
                while(i < len){
                    if (this._cbs[eventName][i] === callback) {
                        this._cbs[eventName].splice(i, 1);
                        i -= 1;
                        len -= 1;
                    }
                    i += 1;
                }
                if (!this._cbs[eventName].length) this._cbs[eventName] = null;
            }
        }
    };
    var markerParser = function() {
        function parsePayloadLines(payload) {
            var lines = payload.split('\r\n');
            var keys = {};
            var line;
            var keysCount = 0;
            for(var i = 0; i < lines.length; i += 1){
                line = lines[i].split(':');
                if (line.length === 2) {
                    keys[line[0]] = line[1].trim();
                    keysCount += 1;
                }
            }
            if (keysCount === 0) throw new Error();
            return keys;
        }
        return function(_markers) {
            var markers = [];
            for(var i = 0; i < _markers.length; i += 1){
                var _marker = _markers[i];
                var markerData = {
                    time: _marker.tm,
                    duration: _marker.dr
                };
                try {
                    markerData.payload = JSON.parse(_markers[i].cm);
                } catch (_) {
                    try {
                        markerData.payload = parsePayloadLines(_markers[i].cm);
                    } catch (__) {
                        markerData.payload = {
                            name: _markers[i].cm
                        };
                    }
                }
                markers.push(markerData);
            }
            return markers;
        };
    }();
    var ProjectInterface = function() {
        function registerComposition(comp) {
            this.compositions.push(comp);
        }
        return function() {
            function _thisProjectFunction(name) {
                var i = 0;
                var len = this.compositions.length;
                while(i < len){
                    if (this.compositions[i].data && this.compositions[i].data.nm === name) {
                        if (this.compositions[i].prepareFrame && this.compositions[i].data.xt) this.compositions[i].prepareFrame(this.currentFrame);
                        return this.compositions[i].compInterface;
                    }
                    i += 1;
                }
                return null;
            }
            _thisProjectFunction.compositions = [];
            _thisProjectFunction.currentFrame = 0;
            _thisProjectFunction.registerComposition = registerComposition;
            return _thisProjectFunction;
        };
    }();
    var renderers = {};
    var registerRenderer = function registerRenderer(key, value) {
        renderers[key] = value;
    };
    function getRenderer(key) {
        return renderers[key];
    }
    function getRegisteredRenderer() {
        // Returns canvas by default for compatibility
        if (renderers.canvas) return 'canvas';
        // Returns any renderer that is registered
        for(var key in renderers){
            if (renderers[key]) return key;
        }
        return '';
    }
    function _typeof$1(o) {
        "@babel/helpers - typeof";
        return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, _typeof$1(o);
    }
    var AnimationItem = function AnimationItem() {
        this._cbs = [];
        this.name = '';
        this.path = '';
        this.isLoaded = false;
        this.currentFrame = 0;
        this.currentRawFrame = 0;
        this.firstFrame = 0;
        this.totalFrames = 0;
        this.frameRate = 0;
        this.frameMult = 0;
        this.playSpeed = 1;
        this.playDirection = 1;
        this.playCount = 0;
        this.animationData = {};
        this.assets = [];
        this.isPaused = true;
        this.autoplay = false;
        this.loop = true;
        this.renderer = null;
        this.animationID = createElementID();
        this.assetsPath = '';
        this.timeCompleted = 0;
        this.segmentPos = 0;
        this.isSubframeEnabled = getSubframeEnabled();
        this.segments = [];
        this._idle = true;
        this._completedLoop = false;
        this.projectInterface = ProjectInterface();
        this.imagePreloader = new ImagePreloader();
        this.audioController = audioControllerFactory();
        this.markers = [];
        this.configAnimation = this.configAnimation.bind(this);
        this.onSetupError = this.onSetupError.bind(this);
        this.onSegmentComplete = this.onSegmentComplete.bind(this);
        this.drawnFrameEvent = new BMEnterFrameEvent('drawnFrame', 0, 0, 0);
        this.expressionsPlugin = getExpressionsPlugin();
    };
    extendPrototype([
        BaseEvent
    ], AnimationItem);
    AnimationItem.prototype.setParams = function(params) {
        if (params.wrapper || params.container) this.wrapper = params.wrapper || params.container;
        var animType = 'svg';
        if (params.animType) animType = params.animType;
        else if (params.renderer) animType = params.renderer;
        var RendererClass = getRenderer(animType);
        this.renderer = new RendererClass(this, params.rendererSettings);
        this.imagePreloader.setCacheType(animType, this.renderer.globalData.defs);
        this.renderer.setProjectInterface(this.projectInterface);
        this.animType = animType;
        if (params.loop === '' || params.loop === null || params.loop === undefined || params.loop === true) this.loop = true;
        else if (params.loop === false) this.loop = false;
        else this.loop = parseInt(params.loop, 10);
        this.autoplay = 'autoplay' in params ? params.autoplay : true;
        this.name = params.name ? params.name : '';
        this.autoloadSegments = Object.prototype.hasOwnProperty.call(params, 'autoloadSegments') ? params.autoloadSegments : true;
        this.assetsPath = params.assetsPath;
        this.initialSegment = params.initialSegment;
        if (params.audioFactory) this.audioController.setAudioFactory(params.audioFactory);
        if (params.animationData) this.setupAnimation(params.animationData);
        else if (params.path) {
            if (params.path.lastIndexOf('\\') !== -1) this.path = params.path.substr(0, params.path.lastIndexOf('\\') + 1);
            else this.path = params.path.substr(0, params.path.lastIndexOf('/') + 1);
            this.fileName = params.path.substr(params.path.lastIndexOf('/') + 1);
            this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf('.json'));
            dataManager.loadAnimation(params.path, this.configAnimation, this.onSetupError);
        }
    };
    AnimationItem.prototype.onSetupError = function() {
        this.trigger('data_failed');
    };
    AnimationItem.prototype.setupAnimation = function(data) {
        dataManager.completeAnimation(data, this.configAnimation);
    };
    AnimationItem.prototype.setData = function(wrapper, animationData) {
        if (animationData) {
            if (_typeof$1(animationData) !== 'object') animationData = JSON.parse(animationData);
        }
        var params = {
            wrapper: wrapper,
            animationData: animationData
        };
        var wrapperAttributes = wrapper.attributes;
        params.path = wrapperAttributes.getNamedItem('data-animation-path') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-animation-path').value : wrapperAttributes.getNamedItem('data-bm-path') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-path').value : wrapperAttributes.getNamedItem('bm-path') ? wrapperAttributes.getNamedItem('bm-path').value : '';
        params.animType = wrapperAttributes.getNamedItem('data-anim-type') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-anim-type').value : wrapperAttributes.getNamedItem('data-bm-type') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-type').value : wrapperAttributes.getNamedItem('bm-type') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('bm-type').value : wrapperAttributes.getNamedItem('data-bm-renderer') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-renderer').value : wrapperAttributes.getNamedItem('bm-renderer') ? wrapperAttributes.getNamedItem('bm-renderer').value : getRegisteredRenderer() || 'canvas';
        var loop = wrapperAttributes.getNamedItem('data-anim-loop') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-anim-loop').value : wrapperAttributes.getNamedItem('data-bm-loop') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-loop').value : wrapperAttributes.getNamedItem('bm-loop') ? wrapperAttributes.getNamedItem('bm-loop').value : '';
        if (loop === 'false') params.loop = false;
        else if (loop === 'true') params.loop = true;
        else if (loop !== '') params.loop = parseInt(loop, 10);
        var autoplay = wrapperAttributes.getNamedItem('data-anim-autoplay') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-anim-autoplay').value : wrapperAttributes.getNamedItem('data-bm-autoplay') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-autoplay').value : wrapperAttributes.getNamedItem('bm-autoplay') ? wrapperAttributes.getNamedItem('bm-autoplay').value : true;
        params.autoplay = autoplay !== 'false';
        params.name = wrapperAttributes.getNamedItem('data-name') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-name').value : wrapperAttributes.getNamedItem('data-bm-name') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-name').value : wrapperAttributes.getNamedItem('bm-name') ? wrapperAttributes.getNamedItem('bm-name').value : '';
        var prerender = wrapperAttributes.getNamedItem('data-anim-prerender') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-anim-prerender').value : wrapperAttributes.getNamedItem('data-bm-prerender') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-prerender').value : wrapperAttributes.getNamedItem('bm-prerender') ? wrapperAttributes.getNamedItem('bm-prerender').value : '';
        if (prerender === 'false') params.prerender = false;
        if (!params.path) this.trigger('destroy');
        else this.setParams(params);
    };
    AnimationItem.prototype.includeLayers = function(data) {
        if (data.op > this.animationData.op) {
            this.animationData.op = data.op;
            this.totalFrames = Math.floor(data.op - this.animationData.ip);
        }
        var layers = this.animationData.layers;
        var i;
        var len = layers.length;
        var newLayers = data.layers;
        var j;
        var jLen = newLayers.length;
        for(j = 0; j < jLen; j += 1){
            i = 0;
            while(i < len){
                if (layers[i].id === newLayers[j].id) {
                    layers[i] = newLayers[j];
                    break;
                }
                i += 1;
            }
        }
        if (data.chars || data.fonts) {
            this.renderer.globalData.fontManager.addChars(data.chars);
            this.renderer.globalData.fontManager.addFonts(data.fonts, this.renderer.globalData.defs);
        }
        if (data.assets) {
            len = data.assets.length;
            for(i = 0; i < len; i += 1)this.animationData.assets.push(data.assets[i]);
        }
        this.animationData.__complete = false;
        dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
    };
    AnimationItem.prototype.onSegmentComplete = function(data) {
        this.animationData = data;
        var expressionsPlugin = getExpressionsPlugin();
        if (expressionsPlugin) expressionsPlugin.initExpressions(this);
        this.loadNextSegment();
    };
    AnimationItem.prototype.loadNextSegment = function() {
        var segments = this.animationData.segments;
        if (!segments || segments.length === 0 || !this.autoloadSegments) {
            this.trigger('data_ready');
            this.timeCompleted = this.totalFrames;
            return;
        }
        var segment = segments.shift();
        this.timeCompleted = segment.time * this.frameRate;
        var segmentPath = this.path + this.fileName + '_' + this.segmentPos + '.json';
        this.segmentPos += 1;
        dataManager.loadData(segmentPath, this.includeLayers.bind(this), (function() {
            this.trigger('data_failed');
        }).bind(this));
    };
    AnimationItem.prototype.loadSegments = function() {
        var segments = this.animationData.segments;
        if (!segments) this.timeCompleted = this.totalFrames;
        this.loadNextSegment();
    };
    AnimationItem.prototype.imagesLoaded = function() {
        this.trigger('loaded_images');
        this.checkLoaded();
    };
    AnimationItem.prototype.preloadImages = function() {
        this.imagePreloader.setAssetsPath(this.assetsPath);
        this.imagePreloader.setPath(this.path);
        this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
    };
    AnimationItem.prototype.configAnimation = function(animData) {
        if (!this.renderer) return;
        try {
            this.animationData = animData;
            if (this.initialSegment) {
                this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]);
                this.firstFrame = Math.round(this.initialSegment[0]);
            } else {
                this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip);
                this.firstFrame = Math.round(this.animationData.ip);
            }
            this.renderer.configAnimation(animData);
            if (!animData.assets) animData.assets = [];
            this.assets = this.animationData.assets;
            this.frameRate = this.animationData.fr;
            this.frameMult = this.animationData.fr / 1000;
            this.renderer.searchExtraCompositions(animData.assets);
            this.markers = markerParser(animData.markers || []);
            this.trigger('config_ready');
            this.preloadImages();
            this.loadSegments();
            this.updaFrameModifier();
            this.waitForFontsLoaded();
            if (this.isPaused) this.audioController.pause();
        } catch (error) {
            this.triggerConfigError(error);
        }
    };
    AnimationItem.prototype.waitForFontsLoaded = function() {
        if (!this.renderer) return;
        if (this.renderer.globalData.fontManager.isLoaded) this.checkLoaded();
        else setTimeout(this.waitForFontsLoaded.bind(this), 20);
    };
    AnimationItem.prototype.checkLoaded = function() {
        if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== 'canvas') && this.imagePreloader.loadedFootages()) {
            this.isLoaded = true;
            var expressionsPlugin = getExpressionsPlugin();
            if (expressionsPlugin) expressionsPlugin.initExpressions(this);
            this.renderer.initItems();
            setTimeout((function() {
                this.trigger('DOMLoaded');
            }).bind(this), 0);
            this.gotoFrame();
            if (this.autoplay) this.play();
        }
    };
    AnimationItem.prototype.resize = function(width, height) {
        // Adding this validation for backwards compatibility in case an event object was being passed down
        var _width = typeof width === 'number' ? width : undefined;
        var _height = typeof height === 'number' ? height : undefined;
        this.renderer.updateContainerSize(_width, _height);
    };
    AnimationItem.prototype.setSubframe = function(flag) {
        this.isSubframeEnabled = !!flag;
    };
    AnimationItem.prototype.gotoFrame = function() {
        this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame; // eslint-disable-line no-bitwise
        if (this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted) this.currentFrame = this.timeCompleted;
        this.trigger('enterFrame');
        this.renderFrame();
        this.trigger('drawnFrame');
    };
    AnimationItem.prototype.renderFrame = function() {
        if (this.isLoaded === false || !this.renderer) return;
        try {
            if (this.expressionsPlugin) this.expressionsPlugin.resetFrame();
            this.renderer.renderFrame(this.currentFrame + this.firstFrame);
        } catch (error) {
            this.triggerRenderFrameError(error);
        }
    };
    AnimationItem.prototype.play = function(name) {
        if (name && this.name !== name) return;
        if (this.isPaused === true) {
            this.isPaused = false;
            this.trigger('_play');
            this.audioController.resume();
            if (this._idle) {
                this._idle = false;
                this.trigger('_active');
            }
        }
    };
    AnimationItem.prototype.pause = function(name) {
        if (name && this.name !== name) return;
        if (this.isPaused === false) {
            this.isPaused = true;
            this.trigger('_pause');
            this._idle = true;
            this.trigger('_idle');
            this.audioController.pause();
        }
    };
    AnimationItem.prototype.togglePause = function(name) {
        if (name && this.name !== name) return;
        if (this.isPaused === true) this.play();
        else this.pause();
    };
    AnimationItem.prototype.stop = function(name) {
        if (name && this.name !== name) return;
        this.pause();
        this.playCount = 0;
        this._completedLoop = false;
        this.setCurrentRawFrameValue(0);
    };
    AnimationItem.prototype.getMarkerData = function(markerName) {
        var marker;
        for(var i = 0; i < this.markers.length; i += 1){
            marker = this.markers[i];
            if (marker.payload && marker.payload.name === markerName) return marker;
        }
        return null;
    };
    AnimationItem.prototype.goToAndStop = function(value, isFrame, name) {
        if (name && this.name !== name) return;
        var numValue = Number(value);
        if (isNaN(numValue)) {
            var marker = this.getMarkerData(value);
            if (marker) this.goToAndStop(marker.time, true);
        } else if (isFrame) this.setCurrentRawFrameValue(value);
        else this.setCurrentRawFrameValue(value * this.frameModifier);
        this.pause();
    };
    AnimationItem.prototype.goToAndPlay = function(value, isFrame, name) {
        if (name && this.name !== name) return;
        var numValue = Number(value);
        if (isNaN(numValue)) {
            var marker = this.getMarkerData(value);
            if (marker) {
                if (!marker.duration) this.goToAndStop(marker.time, true);
                else this.playSegments([
                    marker.time,
                    marker.time + marker.duration
                ], true);
            }
        } else this.goToAndStop(numValue, isFrame, name);
        this.play();
    };
    AnimationItem.prototype.advanceTime = function(value) {
        if (this.isPaused === true || this.isLoaded === false) return;
        var nextValue = this.currentRawFrame + value * this.frameModifier;
        var _isComplete = false;
        // Checking if nextValue > totalFrames - 1 for addressing non looping and looping animations.
        // If animation won't loop, it should stop at totalFrames - 1. If it will loop it should complete the last frame and then loop.
        if (nextValue >= this.totalFrames - 1 && this.frameModifier > 0) {
            if (!this.loop || this.playCount === this.loop) {
                if (!this.checkSegments(nextValue > this.totalFrames ? nextValue % this.totalFrames : 0)) {
                    _isComplete = true;
                    nextValue = this.totalFrames - 1;
                }
            } else if (nextValue >= this.totalFrames) {
                this.playCount += 1;
                if (!this.checkSegments(nextValue % this.totalFrames)) {
                    this.setCurrentRawFrameValue(nextValue % this.totalFrames);
                    this._completedLoop = true;
                    this.trigger('loopComplete');
                }
            } else this.setCurrentRawFrameValue(nextValue);
        } else if (nextValue < 0) {
            if (!this.checkSegments(nextValue % this.totalFrames)) {
                if (this.loop && !(this.playCount-- <= 0 && this.loop !== true)) {
                    // eslint-disable-line no-plusplus
                    this.setCurrentRawFrameValue(this.totalFrames + nextValue % this.totalFrames);
                    if (!this._completedLoop) this._completedLoop = true;
                    else this.trigger('loopComplete');
                } else {
                    _isComplete = true;
                    nextValue = 0;
                }
            }
        } else this.setCurrentRawFrameValue(nextValue);
        if (_isComplete) {
            this.setCurrentRawFrameValue(nextValue);
            this.pause();
            this.trigger('complete');
        }
    };
    AnimationItem.prototype.adjustSegment = function(arr, offset) {
        this.playCount = 0;
        if (arr[1] < arr[0]) {
            if (this.frameModifier > 0) {
                if (this.playSpeed < 0) this.setSpeed(-this.playSpeed);
                else this.setDirection(-1);
            }
            this.totalFrames = arr[0] - arr[1];
            this.timeCompleted = this.totalFrames;
            this.firstFrame = arr[1];
            this.setCurrentRawFrameValue(this.totalFrames - 0.001 - offset);
        } else if (arr[1] > arr[0]) {
            if (this.frameModifier < 0) {
                if (this.playSpeed < 0) this.setSpeed(-this.playSpeed);
                else this.setDirection(1);
            }
            this.totalFrames = arr[1] - arr[0];
            this.timeCompleted = this.totalFrames;
            this.firstFrame = arr[0];
            this.setCurrentRawFrameValue(0.001 + offset);
        }
        this.trigger('segmentStart');
    };
    AnimationItem.prototype.setSegment = function(init, end) {
        var pendingFrame = -1;
        if (this.isPaused) {
            if (this.currentRawFrame + this.firstFrame < init) pendingFrame = init;
            else if (this.currentRawFrame + this.firstFrame > end) pendingFrame = end - init;
        }
        this.firstFrame = init;
        this.totalFrames = end - init;
        this.timeCompleted = this.totalFrames;
        if (pendingFrame !== -1) this.goToAndStop(pendingFrame, true);
    };
    AnimationItem.prototype.playSegments = function(arr, forceFlag) {
        if (forceFlag) this.segments.length = 0;
        if (_typeof$1(arr[0]) === 'object') {
            var i;
            var len = arr.length;
            for(i = 0; i < len; i += 1)this.segments.push(arr[i]);
        } else this.segments.push(arr);
        if (this.segments.length && forceFlag) this.adjustSegment(this.segments.shift(), 0);
        if (this.isPaused) this.play();
    };
    AnimationItem.prototype.resetSegments = function(forceFlag) {
        this.segments.length = 0;
        this.segments.push([
            this.animationData.ip,
            this.animationData.op
        ]);
        if (forceFlag) this.checkSegments(0);
    };
    AnimationItem.prototype.checkSegments = function(offset) {
        if (this.segments.length) {
            this.adjustSegment(this.segments.shift(), offset);
            return true;
        }
        return false;
    };
    AnimationItem.prototype.destroy = function(name) {
        if (name && this.name !== name || !this.renderer) return;
        this.renderer.destroy();
        this.imagePreloader.destroy();
        this.trigger('destroy');
        this._cbs = null;
        this.onEnterFrame = null;
        this.onLoopComplete = null;
        this.onComplete = null;
        this.onSegmentStart = null;
        this.onDestroy = null;
        this.renderer = null;
        this.expressionsPlugin = null;
        this.imagePreloader = null;
        this.projectInterface = null;
    };
    AnimationItem.prototype.setCurrentRawFrameValue = function(value) {
        this.currentRawFrame = value;
        this.gotoFrame();
    };
    AnimationItem.prototype.setSpeed = function(val) {
        this.playSpeed = val;
        this.updaFrameModifier();
    };
    AnimationItem.prototype.setDirection = function(val) {
        this.playDirection = val < 0 ? -1 : 1;
        this.updaFrameModifier();
    };
    AnimationItem.prototype.setLoop = function(isLooping) {
        this.loop = isLooping;
    };
    AnimationItem.prototype.setVolume = function(val, name) {
        if (name && this.name !== name) return;
        this.audioController.setVolume(val);
    };
    AnimationItem.prototype.getVolume = function() {
        return this.audioController.getVolume();
    };
    AnimationItem.prototype.mute = function(name) {
        if (name && this.name !== name) return;
        this.audioController.mute();
    };
    AnimationItem.prototype.unmute = function(name) {
        if (name && this.name !== name) return;
        this.audioController.unmute();
    };
    AnimationItem.prototype.updaFrameModifier = function() {
        this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
        this.audioController.setRate(this.playSpeed * this.playDirection);
    };
    AnimationItem.prototype.getPath = function() {
        return this.path;
    };
    AnimationItem.prototype.getAssetsPath = function(assetData) {
        var path = '';
        if (assetData.e) path = assetData.p;
        else if (this.assetsPath) {
            var imagePath = assetData.p;
            if (imagePath.indexOf('images/') !== -1) imagePath = imagePath.split('/')[1];
            path = this.assetsPath + imagePath;
        } else {
            path = this.path;
            path += assetData.u ? assetData.u : '';
            path += assetData.p;
        }
        return path;
    };
    AnimationItem.prototype.getAssetData = function(id) {
        var i = 0;
        var len = this.assets.length;
        while(i < len){
            if (id === this.assets[i].id) return this.assets[i];
            i += 1;
        }
        return null;
    };
    AnimationItem.prototype.hide = function() {
        this.renderer.hide();
    };
    AnimationItem.prototype.show = function() {
        this.renderer.show();
    };
    AnimationItem.prototype.getDuration = function(isFrame) {
        return isFrame ? this.totalFrames : this.totalFrames / this.frameRate;
    };
    AnimationItem.prototype.updateDocumentData = function(path, documentData, index) {
        try {
            var element = this.renderer.getElementByPath(path);
            element.updateDocumentData(documentData, index);
        } catch (error) {
        // TODO: decide how to handle catch case
        }
    };
    AnimationItem.prototype.trigger = function(name) {
        if (this._cbs && this._cbs[name]) switch(name){
            case 'enterFrame':
                this.triggerEvent(name, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameModifier));
                break;
            case 'drawnFrame':
                this.drawnFrameEvent.currentTime = this.currentFrame;
                this.drawnFrameEvent.totalTime = this.totalFrames;
                this.drawnFrameEvent.direction = this.frameModifier;
                this.triggerEvent(name, this.drawnFrameEvent);
                break;
            case 'loopComplete':
                this.triggerEvent(name, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
                break;
            case 'complete':
                this.triggerEvent(name, new BMCompleteEvent(name, this.frameMult));
                break;
            case 'segmentStart':
                this.triggerEvent(name, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
                break;
            case 'destroy':
                this.triggerEvent(name, new BMDestroyEvent(name, this));
                break;
            default:
                this.triggerEvent(name);
        }
        if (name === 'enterFrame' && this.onEnterFrame) this.onEnterFrame.call(this, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameMult));
        if (name === 'loopComplete' && this.onLoopComplete) this.onLoopComplete.call(this, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
        if (name === 'complete' && this.onComplete) this.onComplete.call(this, new BMCompleteEvent(name, this.frameMult));
        if (name === 'segmentStart' && this.onSegmentStart) this.onSegmentStart.call(this, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
        if (name === 'destroy' && this.onDestroy) this.onDestroy.call(this, new BMDestroyEvent(name, this));
    };
    AnimationItem.prototype.triggerRenderFrameError = function(nativeError) {
        var error = new BMRenderFrameErrorEvent(nativeError, this.currentFrame);
        this.triggerEvent('error', error);
        if (this.onError) this.onError.call(this, error);
    };
    AnimationItem.prototype.triggerConfigError = function(nativeError) {
        var error = new BMConfigErrorEvent(nativeError, this.currentFrame);
        this.triggerEvent('error', error);
        if (this.onError) this.onError.call(this, error);
    };
    var animationManager = function() {
        var moduleOb = {};
        var registeredAnimations = [];
        var initTime = 0;
        var len = 0;
        var playingAnimationsNum = 0;
        var _stopped = true;
        var _isFrozen = false;
        function removeElement(ev) {
            var i = 0;
            var animItem = ev.target;
            while(i < len){
                if (registeredAnimations[i].animation === animItem) {
                    registeredAnimations.splice(i, 1);
                    i -= 1;
                    len -= 1;
                    if (!animItem.isPaused) subtractPlayingCount();
                }
                i += 1;
            }
        }
        function registerAnimation(element, animationData) {
            if (!element) return null;
            var i = 0;
            while(i < len){
                if (registeredAnimations[i].elem === element && registeredAnimations[i].elem !== null) return registeredAnimations[i].animation;
                i += 1;
            }
            var animItem = new AnimationItem();
            setupAnimation(animItem, element);
            animItem.setData(element, animationData);
            return animItem;
        }
        function getRegisteredAnimations() {
            var i;
            var lenAnims = registeredAnimations.length;
            var animations = [];
            for(i = 0; i < lenAnims; i += 1)animations.push(registeredAnimations[i].animation);
            return animations;
        }
        function addPlayingCount() {
            playingAnimationsNum += 1;
            activate();
        }
        function subtractPlayingCount() {
            playingAnimationsNum -= 1;
        }
        function setupAnimation(animItem, element) {
            animItem.addEventListener('destroy', removeElement);
            animItem.addEventListener('_active', addPlayingCount);
            animItem.addEventListener('_idle', subtractPlayingCount);
            registeredAnimations.push({
                elem: element,
                animation: animItem
            });
            len += 1;
        }
        function loadAnimation(params) {
            var animItem = new AnimationItem();
            setupAnimation(animItem, null);
            animItem.setParams(params);
            return animItem;
        }
        function setSpeed(val, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.setSpeed(val, animation);
        }
        function setDirection(val, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.setDirection(val, animation);
        }
        function play(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.play(animation);
        }
        function resume(nowTime) {
            var elapsedTime = nowTime - initTime;
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.advanceTime(elapsedTime);
            initTime = nowTime;
            if (playingAnimationsNum && !_isFrozen) window.requestAnimationFrame(resume);
            else _stopped = true;
        }
        function first(nowTime) {
            initTime = nowTime;
            window.requestAnimationFrame(resume);
        }
        function pause(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.pause(animation);
        }
        function goToAndStop(value, isFrame, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.goToAndStop(value, isFrame, animation);
        }
        function stop(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.stop(animation);
        }
        function togglePause(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.togglePause(animation);
        }
        function destroy(animation) {
            var i;
            for(i = len - 1; i >= 0; i -= 1)registeredAnimations[i].animation.destroy(animation);
        }
        function searchAnimations(animationData, standalone, renderer) {
            var animElements = [].concat([].slice.call(document.getElementsByClassName('lottie')), [].slice.call(document.getElementsByClassName('bodymovin')));
            var i;
            var lenAnims = animElements.length;
            for(i = 0; i < lenAnims; i += 1){
                if (renderer) animElements[i].setAttribute('data-bm-type', renderer);
                registerAnimation(animElements[i], animationData);
            }
            if (standalone && lenAnims === 0) {
                if (!renderer) renderer = 'svg';
                var body = document.getElementsByTagName('body')[0];
                body.innerText = '';
                var div = createTag('div');
                div.style.width = '100%';
                div.style.height = '100%';
                div.setAttribute('data-bm-type', renderer);
                body.appendChild(div);
                registerAnimation(div, animationData);
            }
        }
        function resize() {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.resize();
        }
        function activate() {
            if (!_isFrozen && playingAnimationsNum) {
                if (_stopped) {
                    window.requestAnimationFrame(first);
                    _stopped = false;
                }
            }
        }
        function freeze() {
            _isFrozen = true;
        }
        function unfreeze() {
            _isFrozen = false;
            activate();
        }
        function setVolume(val, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.setVolume(val, animation);
        }
        function mute(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.mute(animation);
        }
        function unmute(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.unmute(animation);
        }
        moduleOb.registerAnimation = registerAnimation;
        moduleOb.loadAnimation = loadAnimation;
        moduleOb.setSpeed = setSpeed;
        moduleOb.setDirection = setDirection;
        moduleOb.play = play;
        moduleOb.pause = pause;
        moduleOb.stop = stop;
        moduleOb.togglePause = togglePause;
        moduleOb.searchAnimations = searchAnimations;
        moduleOb.resize = resize;
        // moduleOb.start = start;
        moduleOb.goToAndStop = goToAndStop;
        moduleOb.destroy = destroy;
        moduleOb.freeze = freeze;
        moduleOb.unfreeze = unfreeze;
        moduleOb.setVolume = setVolume;
        moduleOb.mute = mute;
        moduleOb.unmute = unmute;
        moduleOb.getRegisteredAnimations = getRegisteredAnimations;
        return moduleOb;
    }();
    /* eslint-disable */ var BezierFactory = function() {
        /**
       * BezierEasing - use bezier curve for transition easing function
       * by Gaëtan Renaudeau 2014 - 2015 – MIT License
       *
       * Credits: is based on Firefox's nsSMILKeySpline.cpp
       * Usage:
       * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
       * spline.get(x) => returns the easing value | x must be in [0, 1] range
       *
       */ var ob = {};
        ob.getBezierEasing = getBezierEasing;
        var beziers = {};
        function getBezierEasing(a, b, c, d, nm) {
            var str = nm || ('bez_' + a + '_' + b + '_' + c + '_' + d).replace(/\./g, 'p');
            if (beziers[str]) return beziers[str];
            var bezEasing = new BezierEasing([
                a,
                b,
                c,
                d
            ]);
            beziers[str] = bezEasing;
            return bezEasing;
        }
        // These values are established by empiricism with tests (tradeoff: performance VS precision)
        var NEWTON_ITERATIONS = 4;
        var NEWTON_MIN_SLOPE = 0.001;
        var SUBDIVISION_PRECISION = 0.0000001;
        var SUBDIVISION_MAX_ITERATIONS = 10;
        var kSplineTableSize = 11;
        var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
        var float32ArraySupported = typeof Float32Array === 'function';
        function A(aA1, aA2) {
            return 1.0 - 3.0 * aA2 + 3.0 * aA1;
        }
        function B(aA1, aA2) {
            return 3.0 * aA2 - 6.0 * aA1;
        }
        function C(aA1) {
            return 3.0 * aA1;
        }
        // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
        function calcBezier(aT, aA1, aA2) {
            return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
        }
        // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
        function getSlope(aT, aA1, aA2) {
            return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
        }
        function binarySubdivide(aX, aA, aB, mX1, mX2) {
            var currentX, currentT, i = 0;
            do {
                currentT = aA + (aB - aA) / 2.0;
                currentX = calcBezier(currentT, mX1, mX2) - aX;
                if (currentX > 0.0) aB = currentT;
                else aA = currentT;
            }while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
            return currentT;
        }
        function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
            for(var i = 0; i < NEWTON_ITERATIONS; ++i){
                var currentSlope = getSlope(aGuessT, mX1, mX2);
                if (currentSlope === 0.0) return aGuessT;
                var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
                aGuessT -= currentX / currentSlope;
            }
            return aGuessT;
        }
        /**
       * points is an array of [ mX1, mY1, mX2, mY2 ]
       */ function BezierEasing(points) {
            this._p = points;
            this._mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
            this._precomputed = false;
            this.get = this.get.bind(this);
        }
        BezierEasing.prototype = {
            get: function get(x) {
                var mX1 = this._p[0], mY1 = this._p[1], mX2 = this._p[2], mY2 = this._p[3];
                if (!this._precomputed) this._precompute();
                if (mX1 === mY1 && mX2 === mY2) return x; // linear
                // Because JavaScript number are imprecise, we should guarantee the extremes are right.
                if (x === 0) return 0;
                if (x === 1) return 1;
                return calcBezier(this._getTForX(x), mY1, mY2);
            },
            // Private part
            _precompute: function _precompute() {
                var mX1 = this._p[0], mY1 = this._p[1], mX2 = this._p[2], mY2 = this._p[3];
                this._precomputed = true;
                if (mX1 !== mY1 || mX2 !== mY2) this._calcSampleValues();
            },
            _calcSampleValues: function _calcSampleValues() {
                var mX1 = this._p[0], mX2 = this._p[2];
                for(var i = 0; i < kSplineTableSize; ++i)this._mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
            },
            /**
           * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
           */ _getTForX: function _getTForX(aX) {
                var mX1 = this._p[0], mX2 = this._p[2], mSampleValues = this._mSampleValues;
                var intervalStart = 0.0;
                var currentSample = 1;
                var lastSample = kSplineTableSize - 1;
                for(; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample)intervalStart += kSampleStepSize;
                --currentSample;
                // Interpolate to provide an initial guess for t
                var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample + 1] - mSampleValues[currentSample]);
                var guessForT = intervalStart + dist * kSampleStepSize;
                var initialSlope = getSlope(guessForT, mX1, mX2);
                if (initialSlope >= NEWTON_MIN_SLOPE) return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
                if (initialSlope === 0.0) return guessForT;
                return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
            }
        };
        return ob;
    }();
    var pooling = function() {
        function _double(arr) {
            return arr.concat(createSizedArray(arr.length));
        }
        return {
            "double": _double
        };
    }();
    var poolFactory = function() {
        return function(initialLength, _create, _release) {
            var _length = 0;
            var _maxLength = initialLength;
            var pool = createSizedArray(_maxLength);
            var ob = {
                newElement: newElement,
                release: release
            };
            function newElement() {
                var element;
                if (_length) {
                    _length -= 1;
                    element = pool[_length];
                } else element = _create();
                return element;
            }
            function release(element) {
                if (_length === _maxLength) {
                    pool = pooling["double"](pool);
                    _maxLength *= 2;
                }
                if (_release) _release(element);
                pool[_length] = element;
                _length += 1;
            }
            return ob;
        };
    }();
    var bezierLengthPool = function() {
        function create() {
            return {
                addedLength: 0,
                percents: createTypedArray('float32', getDefaultCurveSegments()),
                lengths: createTypedArray('float32', getDefaultCurveSegments())
            };
        }
        return poolFactory(8, create);
    }();
    var segmentsLengthPool = function() {
        function create() {
            return {
                lengths: [],
                totalLength: 0
            };
        }
        function release(element) {
            var i;
            var len = element.lengths.length;
            for(i = 0; i < len; i += 1)bezierLengthPool.release(element.lengths[i]);
            element.lengths.length = 0;
        }
        return poolFactory(8, create, release);
    }();
    function bezFunction() {
        var math = Math;
        function pointOnLine2D(x1, y1, x2, y2, x3, y3) {
            var det1 = x1 * y2 + y1 * x3 + x2 * y3 - x3 * y2 - y3 * x1 - x2 * y1;
            return det1 > -0.001 && det1 < 0.001;
        }
        function pointOnLine3D(x1, y1, z1, x2, y2, z2, x3, y3, z3) {
            if (z1 === 0 && z2 === 0 && z3 === 0) return pointOnLine2D(x1, y1, x2, y2, x3, y3);
            var dist1 = math.sqrt(math.pow(x2 - x1, 2) + math.pow(y2 - y1, 2) + math.pow(z2 - z1, 2));
            var dist2 = math.sqrt(math.pow(x3 - x1, 2) + math.pow(y3 - y1, 2) + math.pow(z3 - z1, 2));
            var dist3 = math.sqrt(math.pow(x3 - x2, 2) + math.pow(y3 - y2, 2) + math.pow(z3 - z2, 2));
            var diffDist;
            if (dist1 > dist2) {
                if (dist1 > dist3) diffDist = dist1 - dist2 - dist3;
                else diffDist = dist3 - dist2 - dist1;
            } else if (dist3 > dist2) diffDist = dist3 - dist2 - dist1;
            else diffDist = dist2 - dist1 - dist3;
            return diffDist > -0.0001 && diffDist < 0.0001;
        }
        var getBezierLength = function() {
            return function(pt1, pt2, pt3, pt4) {
                var curveSegments = getDefaultCurveSegments();
                var k;
                var i;
                var len;
                var ptCoord;
                var perc;
                var addedLength = 0;
                var ptDistance;
                var point = [];
                var lastPoint = [];
                var lengthData = bezierLengthPool.newElement();
                len = pt3.length;
                for(k = 0; k < curveSegments; k += 1){
                    perc = k / (curveSegments - 1);
                    ptDistance = 0;
                    for(i = 0; i < len; i += 1){
                        ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * pt3[i] + 3 * (1 - perc) * bmPow(perc, 2) * pt4[i] + bmPow(perc, 3) * pt2[i];
                        point[i] = ptCoord;
                        if (lastPoint[i] !== null) ptDistance += bmPow(point[i] - lastPoint[i], 2);
                        lastPoint[i] = point[i];
                    }
                    if (ptDistance) {
                        ptDistance = bmSqrt(ptDistance);
                        addedLength += ptDistance;
                    }
                    lengthData.percents[k] = perc;
                    lengthData.lengths[k] = addedLength;
                }
                lengthData.addedLength = addedLength;
                return lengthData;
            };
        }();
        function getSegmentsLength(shapeData) {
            var segmentsLength = segmentsLengthPool.newElement();
            var closed = shapeData.c;
            var pathV = shapeData.v;
            var pathO = shapeData.o;
            var pathI = shapeData.i;
            var i;
            var len = shapeData._length;
            var lengths = segmentsLength.lengths;
            var totalLength = 0;
            for(i = 0; i < len - 1; i += 1){
                lengths[i] = getBezierLength(pathV[i], pathV[i + 1], pathO[i], pathI[i + 1]);
                totalLength += lengths[i].addedLength;
            }
            if (closed && len) {
                lengths[i] = getBezierLength(pathV[i], pathV[0], pathO[i], pathI[0]);
                totalLength += lengths[i].addedLength;
            }
            segmentsLength.totalLength = totalLength;
            return segmentsLength;
        }
        function BezierData(length) {
            this.segmentLength = 0;
            this.points = new Array(length);
        }
        function PointData(partial, point) {
            this.partialLength = partial;
            this.point = point;
        }
        var buildBezierData = function() {
            var storedData = {};
            return function(pt1, pt2, pt3, pt4) {
                var bezierName = (pt1[0] + '_' + pt1[1] + '_' + pt2[0] + '_' + pt2[1] + '_' + pt3[0] + '_' + pt3[1] + '_' + pt4[0] + '_' + pt4[1]).replace(/\./g, 'p');
                if (!storedData[bezierName]) {
                    var curveSegments = getDefaultCurveSegments();
                    var k;
                    var i;
                    var len;
                    var ptCoord;
                    var perc;
                    var addedLength = 0;
                    var ptDistance;
                    var point;
                    var lastPoint = null;
                    if (pt1.length === 2 && (pt1[0] !== pt2[0] || pt1[1] !== pt2[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt1[0] + pt3[0], pt1[1] + pt3[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt2[0] + pt4[0], pt2[1] + pt4[1])) curveSegments = 2;
                    var bezierData = new BezierData(curveSegments);
                    len = pt3.length;
                    for(k = 0; k < curveSegments; k += 1){
                        point = createSizedArray(len);
                        perc = k / (curveSegments - 1);
                        ptDistance = 0;
                        for(i = 0; i < len; i += 1){
                            ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * (pt1[i] + pt3[i]) + 3 * (1 - perc) * bmPow(perc, 2) * (pt2[i] + pt4[i]) + bmPow(perc, 3) * pt2[i];
                            point[i] = ptCoord;
                            if (lastPoint !== null) ptDistance += bmPow(point[i] - lastPoint[i], 2);
                        }
                        ptDistance = bmSqrt(ptDistance);
                        addedLength += ptDistance;
                        bezierData.points[k] = new PointData(ptDistance, point);
                        lastPoint = point;
                    }
                    bezierData.segmentLength = addedLength;
                    storedData[bezierName] = bezierData;
                }
                return storedData[bezierName];
            };
        }();
        function getDistancePerc(perc, bezierData) {
            var percents = bezierData.percents;
            var lengths = bezierData.lengths;
            var len = percents.length;
            var initPos = bmFloor((len - 1) * perc);
            var lengthPos = perc * bezierData.addedLength;
            var lPerc = 0;
            if (initPos === len - 1 || initPos === 0 || lengthPos === lengths[initPos]) return percents[initPos];
            var dir = lengths[initPos] > lengthPos ? -1 : 1;
            var flag = true;
            while(flag){
                if (lengths[initPos] <= lengthPos && lengths[initPos + 1] > lengthPos) {
                    lPerc = (lengthPos - lengths[initPos]) / (lengths[initPos + 1] - lengths[initPos]);
                    flag = false;
                } else initPos += dir;
                if (initPos < 0 || initPos >= len - 1) {
                    // FIX for TypedArrays that don't store floating point values with enough accuracy
                    if (initPos === len - 1) return percents[initPos];
                    flag = false;
                }
            }
            return percents[initPos] + (percents[initPos + 1] - percents[initPos]) * lPerc;
        }
        function getPointInSegment(pt1, pt2, pt3, pt4, percent, bezierData) {
            var t1 = getDistancePerc(percent, bezierData);
            var u1 = 1 - t1;
            var ptX = math.round((u1 * u1 * u1 * pt1[0] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[0] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[0] + t1 * t1 * t1 * pt2[0]) * 1000) / 1000;
            var ptY = math.round((u1 * u1 * u1 * pt1[1] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[1] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[1] + t1 * t1 * t1 * pt2[1]) * 1000) / 1000;
            return [
                ptX,
                ptY
            ];
        }
        var bezierSegmentPoints = createTypedArray('float32', 8);
        function getNewSegment(pt1, pt2, pt3, pt4, startPerc, endPerc, bezierData) {
            if (startPerc < 0) startPerc = 0;
            else if (startPerc > 1) startPerc = 1;
            var t0 = getDistancePerc(startPerc, bezierData);
            endPerc = endPerc > 1 ? 1 : endPerc;
            var t1 = getDistancePerc(endPerc, bezierData);
            var i;
            var len = pt1.length;
            var u0 = 1 - t0;
            var u1 = 1 - t1;
            var u0u0u0 = u0 * u0 * u0;
            var t0u0u0_3 = t0 * u0 * u0 * 3; // eslint-disable-line camelcase
            var t0t0u0_3 = t0 * t0 * u0 * 3; // eslint-disable-line camelcase
            var t0t0t0 = t0 * t0 * t0;
            //
            var u0u0u1 = u0 * u0 * u1;
            var t0u0u1_3 = t0 * u0 * u1 + u0 * t0 * u1 + u0 * u0 * t1; // eslint-disable-line camelcase
            var t0t0u1_3 = t0 * t0 * u1 + u0 * t0 * t1 + t0 * u0 * t1; // eslint-disable-line camelcase
            var t0t0t1 = t0 * t0 * t1;
            //
            var u0u1u1 = u0 * u1 * u1;
            var t0u1u1_3 = t0 * u1 * u1 + u0 * t1 * u1 + u0 * u1 * t1; // eslint-disable-line camelcase
            var t0t1u1_3 = t0 * t1 * u1 + u0 * t1 * t1 + t0 * u1 * t1; // eslint-disable-line camelcase
            var t0t1t1 = t0 * t1 * t1;
            //
            var u1u1u1 = u1 * u1 * u1;
            var t1u1u1_3 = t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1; // eslint-disable-line camelcase
            var t1t1u1_3 = t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1; // eslint-disable-line camelcase
            var t1t1t1 = t1 * t1 * t1;
            for(i = 0; i < len; i += 1){
                bezierSegmentPoints[i * 4] = math.round((u0u0u0 * pt1[i] + t0u0u0_3 * pt3[i] + t0t0u0_3 * pt4[i] + t0t0t0 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints[i * 4 + 1] = math.round((u0u0u1 * pt1[i] + t0u0u1_3 * pt3[i] + t0t0u1_3 * pt4[i] + t0t0t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints[i * 4 + 2] = math.round((u0u1u1 * pt1[i] + t0u1u1_3 * pt3[i] + t0t1u1_3 * pt4[i] + t0t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints[i * 4 + 3] = math.round((u1u1u1 * pt1[i] + t1u1u1_3 * pt3[i] + t1t1u1_3 * pt4[i] + t1t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
            }
            return bezierSegmentPoints;
        }
        return {
            getSegmentsLength: getSegmentsLength,
            getNewSegment: getNewSegment,
            getPointInSegment: getPointInSegment,
            buildBezierData: buildBezierData,
            pointOnLine2D: pointOnLine2D,
            pointOnLine3D: pointOnLine3D
        };
    }
    var bez = bezFunction();
    var initFrame = initialDefaultFrame;
    var mathAbs = Math.abs;
    function interpolateValue(frameNum, caching) {
        var offsetTime = this.offsetTime;
        var newValue;
        if (this.propType === 'multidimensional') newValue = createTypedArray('float32', this.pv.length);
        var iterationIndex = caching.lastIndex;
        var i = iterationIndex;
        var len = this.keyframes.length - 1;
        var flag = true;
        var keyData;
        var nextKeyData;
        var keyframeMetadata;
        while(flag){
            keyData = this.keyframes[i];
            nextKeyData = this.keyframes[i + 1];
            if (i === len - 1 && frameNum >= nextKeyData.t - offsetTime) {
                if (keyData.h) keyData = nextKeyData;
                iterationIndex = 0;
                break;
            }
            if (nextKeyData.t - offsetTime > frameNum) {
                iterationIndex = i;
                break;
            }
            if (i < len - 1) i += 1;
            else {
                iterationIndex = 0;
                flag = false;
            }
        }
        keyframeMetadata = this.keyframesMetadata[i] || {};
        var k;
        var kLen;
        var perc;
        var jLen;
        var j;
        var fnc;
        var nextKeyTime = nextKeyData.t - offsetTime;
        var keyTime = keyData.t - offsetTime;
        var endValue;
        if (keyData.to) {
            if (!keyframeMetadata.bezierData) keyframeMetadata.bezierData = bez.buildBezierData(keyData.s, nextKeyData.s || keyData.e, keyData.to, keyData.ti);
            var bezierData = keyframeMetadata.bezierData;
            if (frameNum >= nextKeyTime || frameNum < keyTime) {
                var ind = frameNum >= nextKeyTime ? bezierData.points.length - 1 : 0;
                kLen = bezierData.points[ind].point.length;
                for(k = 0; k < kLen; k += 1)newValue[k] = bezierData.points[ind].point[k];
            // caching._lastKeyframeIndex = -1;
            } else {
                if (keyframeMetadata.__fnct) fnc = keyframeMetadata.__fnct;
                else {
                    fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y, keyData.n).get;
                    keyframeMetadata.__fnct = fnc;
                }
                perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
                var distanceInLine = bezierData.segmentLength * perc;
                var segmentPerc;
                var addedLength = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastAddedLength : 0;
                j = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastPoint : 0;
                flag = true;
                jLen = bezierData.points.length;
                while(flag){
                    addedLength += bezierData.points[j].partialLength;
                    if (distanceInLine === 0 || perc === 0 || j === bezierData.points.length - 1) {
                        kLen = bezierData.points[j].point.length;
                        for(k = 0; k < kLen; k += 1)newValue[k] = bezierData.points[j].point[k];
                        break;
                    } else if (distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j + 1].partialLength) {
                        segmentPerc = (distanceInLine - addedLength) / bezierData.points[j + 1].partialLength;
                        kLen = bezierData.points[j].point.length;
                        for(k = 0; k < kLen; k += 1)newValue[k] = bezierData.points[j].point[k] + (bezierData.points[j + 1].point[k] - bezierData.points[j].point[k]) * segmentPerc;
                        break;
                    }
                    if (j < jLen - 1) j += 1;
                    else flag = false;
                }
                caching._lastPoint = j;
                caching._lastAddedLength = addedLength - bezierData.points[j].partialLength;
                caching._lastKeyframeIndex = i;
            }
        } else {
            var outX;
            var outY;
            var inX;
            var inY;
            var keyValue;
            len = keyData.s.length;
            endValue = nextKeyData.s || keyData.e;
            if (this.sh && keyData.h !== 1) {
                if (frameNum >= nextKeyTime) {
                    newValue[0] = endValue[0];
                    newValue[1] = endValue[1];
                    newValue[2] = endValue[2];
                } else if (frameNum <= keyTime) {
                    newValue[0] = keyData.s[0];
                    newValue[1] = keyData.s[1];
                    newValue[2] = keyData.s[2];
                } else {
                    var quatStart = createQuaternion(keyData.s);
                    var quatEnd = createQuaternion(endValue);
                    var time = (frameNum - keyTime) / (nextKeyTime - keyTime);
                    quaternionToEuler(newValue, slerp(quatStart, quatEnd, time));
                }
            } else for(i = 0; i < len; i += 1){
                if (keyData.h !== 1) {
                    if (frameNum >= nextKeyTime) perc = 1;
                    else if (frameNum < keyTime) perc = 0;
                    else {
                        if (keyData.o.x.constructor === Array) {
                            if (!keyframeMetadata.__fnct) keyframeMetadata.__fnct = [];
                            if (!keyframeMetadata.__fnct[i]) {
                                outX = keyData.o.x[i] === undefined ? keyData.o.x[0] : keyData.o.x[i];
                                outY = keyData.o.y[i] === undefined ? keyData.o.y[0] : keyData.o.y[i];
                                inX = keyData.i.x[i] === undefined ? keyData.i.x[0] : keyData.i.x[i];
                                inY = keyData.i.y[i] === undefined ? keyData.i.y[0] : keyData.i.y[i];
                                fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                                keyframeMetadata.__fnct[i] = fnc;
                            } else fnc = keyframeMetadata.__fnct[i];
                        } else if (!keyframeMetadata.__fnct) {
                            outX = keyData.o.x;
                            outY = keyData.o.y;
                            inX = keyData.i.x;
                            inY = keyData.i.y;
                            fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                            keyData.keyframeMetadata = fnc;
                        } else fnc = keyframeMetadata.__fnct;
                        perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
                    }
                }
                endValue = nextKeyData.s || keyData.e;
                keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i] + (endValue[i] - keyData.s[i]) * perc;
                if (this.propType === 'multidimensional') newValue[i] = keyValue;
                else newValue = keyValue;
            }
        }
        caching.lastIndex = iterationIndex;
        return newValue;
    }
    // based on @Toji's https://github.com/toji/gl-matrix/
    function slerp(a, b, t) {
        var out = [];
        var ax = a[0];
        var ay = a[1];
        var az = a[2];
        var aw = a[3];
        var bx = b[0];
        var by = b[1];
        var bz = b[2];
        var bw = b[3];
        var omega;
        var cosom;
        var sinom;
        var scale0;
        var scale1;
        cosom = ax * bx + ay * by + az * bz + aw * bw;
        if (cosom < 0.0) {
            cosom = -cosom;
            bx = -bx;
            by = -by;
            bz = -bz;
            bw = -bw;
        }
        if (1.0 - cosom > 0.000001) {
            omega = Math.acos(cosom);
            sinom = Math.sin(omega);
            scale0 = Math.sin((1.0 - t) * omega) / sinom;
            scale1 = Math.sin(t * omega) / sinom;
        } else {
            scale0 = 1.0 - t;
            scale1 = t;
        }
        out[0] = scale0 * ax + scale1 * bx;
        out[1] = scale0 * ay + scale1 * by;
        out[2] = scale0 * az + scale1 * bz;
        out[3] = scale0 * aw + scale1 * bw;
        return out;
    }
    function quaternionToEuler(out, quat) {
        var qx = quat[0];
        var qy = quat[1];
        var qz = quat[2];
        var qw = quat[3];
        var heading = Math.atan2(2 * qy * qw - 2 * qx * qz, 1 - 2 * qy * qy - 2 * qz * qz);
        var attitude = Math.asin(2 * qx * qy + 2 * qz * qw);
        var bank = Math.atan2(2 * qx * qw - 2 * qy * qz, 1 - 2 * qx * qx - 2 * qz * qz);
        out[0] = heading / degToRads;
        out[1] = attitude / degToRads;
        out[2] = bank / degToRads;
    }
    function createQuaternion(values) {
        var heading = values[0] * degToRads;
        var attitude = values[1] * degToRads;
        var bank = values[2] * degToRads;
        var c1 = Math.cos(heading / 2);
        var c2 = Math.cos(attitude / 2);
        var c3 = Math.cos(bank / 2);
        var s1 = Math.sin(heading / 2);
        var s2 = Math.sin(attitude / 2);
        var s3 = Math.sin(bank / 2);
        var w = c1 * c2 * c3 - s1 * s2 * s3;
        var x = s1 * s2 * c3 + c1 * c2 * s3;
        var y = s1 * c2 * c3 + c1 * s2 * s3;
        var z = c1 * s2 * c3 - s1 * c2 * s3;
        return [
            x,
            y,
            z,
            w
        ];
    }
    function getValueAtCurrentTime() {
        var frameNum = this.comp.renderedFrame - this.offsetTime;
        var initTime = this.keyframes[0].t - this.offsetTime;
        var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
        if (!(frameNum === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= endTime && frameNum >= endTime || this._caching.lastFrame < initTime && frameNum < initTime))) {
            if (this._caching.lastFrame >= frameNum) {
                this._caching._lastKeyframeIndex = -1;
                this._caching.lastIndex = 0;
            }
            var renderResult = this.interpolateValue(frameNum, this._caching);
            this.pv = renderResult;
        }
        this._caching.lastFrame = frameNum;
        return this.pv;
    }
    function setVValue(val) {
        var multipliedValue;
        if (this.propType === 'unidimensional') {
            multipliedValue = val * this.mult;
            if (mathAbs(this.v - multipliedValue) > 0.00001) {
                this.v = multipliedValue;
                this._mdf = true;
            }
        } else {
            var i = 0;
            var len = this.v.length;
            while(i < len){
                multipliedValue = val[i] * this.mult;
                if (mathAbs(this.v[i] - multipliedValue) > 0.00001) {
                    this.v[i] = multipliedValue;
                    this._mdf = true;
                }
                i += 1;
            }
        }
    }
    function processEffectsSequence() {
        if (this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) return;
        if (this.lock) {
            this.setVValue(this.pv);
            return;
        }
        this.lock = true;
        this._mdf = this._isFirstFrame;
        var i;
        var len = this.effectsSequence.length;
        var finalValue = this.kf ? this.pv : this.data.k;
        for(i = 0; i < len; i += 1)finalValue = this.effectsSequence[i](finalValue);
        this.setVValue(finalValue);
        this._isFirstFrame = false;
        this.lock = false;
        this.frameId = this.elem.globalData.frameId;
    }
    function addEffect(effectFunction) {
        this.effectsSequence.push(effectFunction);
        this.container.addDynamicProperty(this);
    }
    function ValueProperty(elem, data, mult, container) {
        this.propType = 'unidimensional';
        this.mult = mult || 1;
        this.data = data;
        this.v = mult ? data.k * mult : data.k;
        this.pv = data.k;
        this._mdf = false;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.k = false;
        this.kf = false;
        this.vel = 0;
        this.effectsSequence = [];
        this._isFirstFrame = true;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.addEffect = addEffect;
    }
    function MultiDimensionalProperty(elem, data, mult, container) {
        this.propType = 'multidimensional';
        this.mult = mult || 1;
        this.data = data;
        this._mdf = false;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.k = false;
        this.kf = false;
        this.frameId = -1;
        var i;
        var len = data.k.length;
        this.v = createTypedArray('float32', len);
        this.pv = createTypedArray('float32', len);
        this.vel = createTypedArray('float32', len);
        for(i = 0; i < len; i += 1){
            this.v[i] = data.k[i] * this.mult;
            this.pv[i] = data.k[i];
        }
        this._isFirstFrame = true;
        this.effectsSequence = [];
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.addEffect = addEffect;
    }
    function KeyframedValueProperty(elem, data, mult, container) {
        this.propType = 'unidimensional';
        this.keyframes = data.k;
        this.keyframesMetadata = [];
        this.offsetTime = elem.data.st;
        this.frameId = -1;
        this._caching = {
            lastFrame: initFrame,
            lastIndex: 0,
            value: 0,
            _lastKeyframeIndex: -1
        };
        this.k = true;
        this.kf = true;
        this.data = data;
        this.mult = mult || 1;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.v = initFrame;
        this.pv = initFrame;
        this._isFirstFrame = true;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.interpolateValue = interpolateValue;
        this.effectsSequence = [
            getValueAtCurrentTime.bind(this)
        ];
        this.addEffect = addEffect;
    }
    function KeyframedMultidimensionalProperty(elem, data, mult, container) {
        this.propType = 'multidimensional';
        var i;
        var len = data.k.length;
        var s;
        var e;
        var to;
        var ti;
        for(i = 0; i < len - 1; i += 1)if (data.k[i].to && data.k[i].s && data.k[i + 1] && data.k[i + 1].s) {
            s = data.k[i].s;
            e = data.k[i + 1].s;
            to = data.k[i].to;
            ti = data.k[i].ti;
            if (s.length === 2 && !(s[0] === e[0] && s[1] === e[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], s[0] + to[0], s[1] + to[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], e[0] + ti[0], e[1] + ti[1]) || s.length === 3 && !(s[0] === e[0] && s[1] === e[1] && s[2] === e[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], s[0] + to[0], s[1] + to[1], s[2] + to[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], e[0] + ti[0], e[1] + ti[1], e[2] + ti[2])) {
                data.k[i].to = null;
                data.k[i].ti = null;
            }
            if (s[0] === e[0] && s[1] === e[1] && to[0] === 0 && to[1] === 0 && ti[0] === 0 && ti[1] === 0) {
                if (s.length === 2 || s[2] === e[2] && to[2] === 0 && ti[2] === 0) {
                    data.k[i].to = null;
                    data.k[i].ti = null;
                }
            }
        }
        this.effectsSequence = [
            getValueAtCurrentTime.bind(this)
        ];
        this.data = data;
        this.keyframes = data.k;
        this.keyframesMetadata = [];
        this.offsetTime = elem.data.st;
        this.k = true;
        this.kf = true;
        this._isFirstFrame = true;
        this.mult = mult || 1;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.interpolateValue = interpolateValue;
        this.frameId = -1;
        var arrLen = data.k[0].s.length;
        this.v = createTypedArray('float32', arrLen);
        this.pv = createTypedArray('float32', arrLen);
        for(i = 0; i < arrLen; i += 1){
            this.v[i] = initFrame;
            this.pv[i] = initFrame;
        }
        this._caching = {
            lastFrame: initFrame,
            lastIndex: 0,
            value: createTypedArray('float32', arrLen)
        };
        this.addEffect = addEffect;
    }
    var PropertyFactory = function() {
        function getProp(elem, data, type, mult, container) {
            if (data.sid) data = elem.globalData.slotManager.getProp(data);
            var p;
            if (!data.k.length) p = new ValueProperty(elem, data, mult, container);
            else if (typeof data.k[0] === 'number') p = new MultiDimensionalProperty(elem, data, mult, container);
            else switch(type){
                case 0:
                    p = new KeyframedValueProperty(elem, data, mult, container);
                    break;
                case 1:
                    p = new KeyframedMultidimensionalProperty(elem, data, mult, container);
                    break;
                default:
                    break;
            }
            if (p.effectsSequence.length) container.addDynamicProperty(p);
            return p;
        }
        var ob = {
            getProp: getProp
        };
        return ob;
    }();
    function DynamicPropertyContainer() {}
    DynamicPropertyContainer.prototype = {
        addDynamicProperty: function addDynamicProperty(prop) {
            if (this.dynamicProperties.indexOf(prop) === -1) {
                this.dynamicProperties.push(prop);
                this.container.addDynamicProperty(this);
                this._isAnimated = true;
            }
        },
        iterateDynamicProperties: function iterateDynamicProperties() {
            this._mdf = false;
            var i;
            var len = this.dynamicProperties.length;
            for(i = 0; i < len; i += 1){
                this.dynamicProperties[i].getValue();
                if (this.dynamicProperties[i]._mdf) this._mdf = true;
            }
        },
        initDynamicPropertyContainer: function initDynamicPropertyContainer(container) {
            this.container = container;
            this.dynamicProperties = [];
            this._mdf = false;
            this._isAnimated = false;
        }
    };
    var pointPool = function() {
        function create() {
            return createTypedArray('float32', 2);
        }
        return poolFactory(8, create);
    }();
    function ShapePath() {
        this.c = false;
        this._length = 0;
        this._maxLength = 8;
        this.v = createSizedArray(this._maxLength);
        this.o = createSizedArray(this._maxLength);
        this.i = createSizedArray(this._maxLength);
    }
    ShapePath.prototype.setPathData = function(closed, len) {
        this.c = closed;
        this.setLength(len);
        var i = 0;
        while(i < len){
            this.v[i] = pointPool.newElement();
            this.o[i] = pointPool.newElement();
            this.i[i] = pointPool.newElement();
            i += 1;
        }
    };
    ShapePath.prototype.setLength = function(len) {
        while(this._maxLength < len)this.doubleArrayLength();
        this._length = len;
    };
    ShapePath.prototype.doubleArrayLength = function() {
        this.v = this.v.concat(createSizedArray(this._maxLength));
        this.i = this.i.concat(createSizedArray(this._maxLength));
        this.o = this.o.concat(createSizedArray(this._maxLength));
        this._maxLength *= 2;
    };
    ShapePath.prototype.setXYAt = function(x, y, type, pos, replace) {
        var arr;
        this._length = Math.max(this._length, pos + 1);
        if (this._length >= this._maxLength) this.doubleArrayLength();
        switch(type){
            case 'v':
                arr = this.v;
                break;
            case 'i':
                arr = this.i;
                break;
            case 'o':
                arr = this.o;
                break;
            default:
                arr = [];
                break;
        }
        if (!arr[pos] || arr[pos] && !replace) arr[pos] = pointPool.newElement();
        arr[pos][0] = x;
        arr[pos][1] = y;
    };
    ShapePath.prototype.setTripleAt = function(vX, vY, oX, oY, iX, iY, pos, replace) {
        this.setXYAt(vX, vY, 'v', pos, replace);
        this.setXYAt(oX, oY, 'o', pos, replace);
        this.setXYAt(iX, iY, 'i', pos, replace);
    };
    ShapePath.prototype.reverse = function() {
        var newPath = new ShapePath();
        newPath.setPathData(this.c, this._length);
        var vertices = this.v;
        var outPoints = this.o;
        var inPoints = this.i;
        var init = 0;
        if (this.c) {
            newPath.setTripleAt(vertices[0][0], vertices[0][1], inPoints[0][0], inPoints[0][1], outPoints[0][0], outPoints[0][1], 0, false);
            init = 1;
        }
        var cnt = this._length - 1;
        var len = this._length;
        var i;
        for(i = init; i < len; i += 1){
            newPath.setTripleAt(vertices[cnt][0], vertices[cnt][1], inPoints[cnt][0], inPoints[cnt][1], outPoints[cnt][0], outPoints[cnt][1], i, false);
            cnt -= 1;
        }
        return newPath;
    };
    ShapePath.prototype.length = function() {
        return this._length;
    };
    var shapePool = function() {
        function create() {
            return new ShapePath();
        }
        function release(shapePath) {
            var len = shapePath._length;
            var i;
            for(i = 0; i < len; i += 1){
                pointPool.release(shapePath.v[i]);
                pointPool.release(shapePath.i[i]);
                pointPool.release(shapePath.o[i]);
                shapePath.v[i] = null;
                shapePath.i[i] = null;
                shapePath.o[i] = null;
            }
            shapePath._length = 0;
            shapePath.c = false;
        }
        function clone(shape) {
            var cloned = factory.newElement();
            var i;
            var len = shape._length === undefined ? shape.v.length : shape._length;
            cloned.setLength(len);
            cloned.c = shape.c;
            for(i = 0; i < len; i += 1)cloned.setTripleAt(shape.v[i][0], shape.v[i][1], shape.o[i][0], shape.o[i][1], shape.i[i][0], shape.i[i][1], i);
            return cloned;
        }
        var factory = poolFactory(4, create, release);
        factory.clone = clone;
        return factory;
    }();
    function ShapeCollection() {
        this._length = 0;
        this._maxLength = 4;
        this.shapes = createSizedArray(this._maxLength);
    }
    ShapeCollection.prototype.addShape = function(shapeData) {
        if (this._length === this._maxLength) {
            this.shapes = this.shapes.concat(createSizedArray(this._maxLength));
            this._maxLength *= 2;
        }
        this.shapes[this._length] = shapeData;
        this._length += 1;
    };
    ShapeCollection.prototype.releaseShapes = function() {
        var i;
        for(i = 0; i < this._length; i += 1)shapePool.release(this.shapes[i]);
        this._length = 0;
    };
    var shapeCollectionPool = function() {
        var ob = {
            newShapeCollection: newShapeCollection,
            release: release
        };
        var _length = 0;
        var _maxLength = 4;
        var pool = createSizedArray(_maxLength);
        function newShapeCollection() {
            var shapeCollection;
            if (_length) {
                _length -= 1;
                shapeCollection = pool[_length];
            } else shapeCollection = new ShapeCollection();
            return shapeCollection;
        }
        function release(shapeCollection) {
            var i;
            var len = shapeCollection._length;
            for(i = 0; i < len; i += 1)shapePool.release(shapeCollection.shapes[i]);
            shapeCollection._length = 0;
            if (_length === _maxLength) {
                pool = pooling["double"](pool);
                _maxLength *= 2;
            }
            pool[_length] = shapeCollection;
            _length += 1;
        }
        return ob;
    }();
    var ShapePropertyFactory = function() {
        var initFrame = -999999;
        function interpolateShape(frameNum, previousValue, caching) {
            var iterationIndex = caching.lastIndex;
            var keyPropS;
            var keyPropE;
            var isHold;
            var j;
            var k;
            var jLen;
            var kLen;
            var perc;
            var vertexValue;
            var kf = this.keyframes;
            if (frameNum < kf[0].t - this.offsetTime) {
                keyPropS = kf[0].s[0];
                isHold = true;
                iterationIndex = 0;
            } else if (frameNum >= kf[kf.length - 1].t - this.offsetTime) {
                keyPropS = kf[kf.length - 1].s ? kf[kf.length - 1].s[0] : kf[kf.length - 2].e[0];
                /* if(kf[kf.length - 1].s){
                  keyPropS = kf[kf.length - 1].s[0];
              }else{
                  keyPropS = kf[kf.length - 2].e[0];
              } */ isHold = true;
            } else {
                var i = iterationIndex;
                var len = kf.length - 1;
                var flag = true;
                var keyData;
                var nextKeyData;
                var keyframeMetadata;
                while(flag){
                    keyData = kf[i];
                    nextKeyData = kf[i + 1];
                    if (nextKeyData.t - this.offsetTime > frameNum) break;
                    if (i < len - 1) i += 1;
                    else flag = false;
                }
                keyframeMetadata = this.keyframesMetadata[i] || {};
                isHold = keyData.h === 1;
                iterationIndex = i;
                if (!isHold) {
                    if (frameNum >= nextKeyData.t - this.offsetTime) perc = 1;
                    else if (frameNum < keyData.t - this.offsetTime) perc = 0;
                    else {
                        var fnc;
                        if (keyframeMetadata.__fnct) fnc = keyframeMetadata.__fnct;
                        else {
                            fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y).get;
                            keyframeMetadata.__fnct = fnc;
                        }
                        perc = fnc((frameNum - (keyData.t - this.offsetTime)) / (nextKeyData.t - this.offsetTime - (keyData.t - this.offsetTime)));
                    }
                    keyPropE = nextKeyData.s ? nextKeyData.s[0] : keyData.e[0];
                }
                keyPropS = keyData.s[0];
            }
            jLen = previousValue._length;
            kLen = keyPropS.i[0].length;
            caching.lastIndex = iterationIndex;
            for(j = 0; j < jLen; j += 1)for(k = 0; k < kLen; k += 1){
                vertexValue = isHold ? keyPropS.i[j][k] : keyPropS.i[j][k] + (keyPropE.i[j][k] - keyPropS.i[j][k]) * perc;
                previousValue.i[j][k] = vertexValue;
                vertexValue = isHold ? keyPropS.o[j][k] : keyPropS.o[j][k] + (keyPropE.o[j][k] - keyPropS.o[j][k]) * perc;
                previousValue.o[j][k] = vertexValue;
                vertexValue = isHold ? keyPropS.v[j][k] : keyPropS.v[j][k] + (keyPropE.v[j][k] - keyPropS.v[j][k]) * perc;
                previousValue.v[j][k] = vertexValue;
            }
        }
        function interpolateShapeCurrentTime() {
            var frameNum = this.comp.renderedFrame - this.offsetTime;
            var initTime = this.keyframes[0].t - this.offsetTime;
            var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
            var lastFrame = this._caching.lastFrame;
            if (!(lastFrame !== initFrame && (lastFrame < initTime && frameNum < initTime || lastFrame > endTime && frameNum > endTime))) {
                /// /
                this._caching.lastIndex = lastFrame < frameNum ? this._caching.lastIndex : 0;
                this.interpolateShape(frameNum, this.pv, this._caching);
            /// /
            }
            this._caching.lastFrame = frameNum;
            return this.pv;
        }
        function resetShape() {
            this.paths = this.localShapeCollection;
        }
        function shapesEqual(shape1, shape2) {
            if (shape1._length !== shape2._length || shape1.c !== shape2.c) return false;
            var i;
            var len = shape1._length;
            for(i = 0; i < len; i += 1){
                if (shape1.v[i][0] !== shape2.v[i][0] || shape1.v[i][1] !== shape2.v[i][1] || shape1.o[i][0] !== shape2.o[i][0] || shape1.o[i][1] !== shape2.o[i][1] || shape1.i[i][0] !== shape2.i[i][0] || shape1.i[i][1] !== shape2.i[i][1]) return false;
            }
            return true;
        }
        function setVValue(newPath) {
            if (!shapesEqual(this.v, newPath)) {
                this.v = shapePool.clone(newPath);
                this.localShapeCollection.releaseShapes();
                this.localShapeCollection.addShape(this.v);
                this._mdf = true;
                this.paths = this.localShapeCollection;
            }
        }
        function processEffectsSequence() {
            if (this.elem.globalData.frameId === this.frameId) return;
            if (!this.effectsSequence.length) {
                this._mdf = false;
                return;
            }
            if (this.lock) {
                this.setVValue(this.pv);
                return;
            }
            this.lock = true;
            this._mdf = false;
            var finalValue;
            if (this.kf) finalValue = this.pv;
            else if (this.data.ks) finalValue = this.data.ks.k;
            else finalValue = this.data.pt.k;
            var i;
            var len = this.effectsSequence.length;
            for(i = 0; i < len; i += 1)finalValue = this.effectsSequence[i](finalValue);
            this.setVValue(finalValue);
            this.lock = false;
            this.frameId = this.elem.globalData.frameId;
        }
        function ShapeProperty(elem, data, type) {
            this.propType = 'shape';
            this.comp = elem.comp;
            this.container = elem;
            this.elem = elem;
            this.data = data;
            this.k = false;
            this.kf = false;
            this._mdf = false;
            var pathData = type === 3 ? data.pt.k : data.ks.k;
            this.v = shapePool.clone(pathData);
            this.pv = shapePool.clone(this.v);
            this.localShapeCollection = shapeCollectionPool.newShapeCollection();
            this.paths = this.localShapeCollection;
            this.paths.addShape(this.v);
            this.reset = resetShape;
            this.effectsSequence = [];
        }
        function addEffect(effectFunction) {
            this.effectsSequence.push(effectFunction);
            this.container.addDynamicProperty(this);
        }
        ShapeProperty.prototype.interpolateShape = interpolateShape;
        ShapeProperty.prototype.getValue = processEffectsSequence;
        ShapeProperty.prototype.setVValue = setVValue;
        ShapeProperty.prototype.addEffect = addEffect;
        function KeyframedShapeProperty(elem, data, type) {
            this.propType = 'shape';
            this.comp = elem.comp;
            this.elem = elem;
            this.container = elem;
            this.offsetTime = elem.data.st;
            this.keyframes = type === 3 ? data.pt.k : data.ks.k;
            this.keyframesMetadata = [];
            this.k = true;
            this.kf = true;
            var len = this.keyframes[0].s[0].i.length;
            this.v = shapePool.newElement();
            this.v.setPathData(this.keyframes[0].s[0].c, len);
            this.pv = shapePool.clone(this.v);
            this.localShapeCollection = shapeCollectionPool.newShapeCollection();
            this.paths = this.localShapeCollection;
            this.paths.addShape(this.v);
            this.lastFrame = initFrame;
            this.reset = resetShape;
            this._caching = {
                lastFrame: initFrame,
                lastIndex: 0
            };
            this.effectsSequence = [
                interpolateShapeCurrentTime.bind(this)
            ];
        }
        KeyframedShapeProperty.prototype.getValue = processEffectsSequence;
        KeyframedShapeProperty.prototype.interpolateShape = interpolateShape;
        KeyframedShapeProperty.prototype.setVValue = setVValue;
        KeyframedShapeProperty.prototype.addEffect = addEffect;
        var EllShapeProperty = function() {
            var cPoint = roundCorner;
            function EllShapePropertyFactory(elem, data) {
                this.v = shapePool.newElement();
                this.v.setPathData(true, 4);
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.paths = this.localShapeCollection;
                this.localShapeCollection.addShape(this.v);
                this.d = data.d;
                this.elem = elem;
                this.comp = elem.comp;
                this.frameId = -1;
                this.initDynamicPropertyContainer(elem);
                this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
                this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertEllToPath();
                }
            }
            EllShapePropertyFactory.prototype = {
                reset: resetShape,
                getValue: function getValue() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertEllToPath();
                },
                convertEllToPath: function convertEllToPath() {
                    var p0 = this.p.v[0];
                    var p1 = this.p.v[1];
                    var s0 = this.s.v[0] / 2;
                    var s1 = this.s.v[1] / 2;
                    var _cw = this.d !== 3;
                    var _v = this.v;
                    _v.v[0][0] = p0;
                    _v.v[0][1] = p1 - s1;
                    _v.v[1][0] = _cw ? p0 + s0 : p0 - s0;
                    _v.v[1][1] = p1;
                    _v.v[2][0] = p0;
                    _v.v[2][1] = p1 + s1;
                    _v.v[3][0] = _cw ? p0 - s0 : p0 + s0;
                    _v.v[3][1] = p1;
                    _v.i[0][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
                    _v.i[0][1] = p1 - s1;
                    _v.i[1][0] = _cw ? p0 + s0 : p0 - s0;
                    _v.i[1][1] = p1 - s1 * cPoint;
                    _v.i[2][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
                    _v.i[2][1] = p1 + s1;
                    _v.i[3][0] = _cw ? p0 - s0 : p0 + s0;
                    _v.i[3][1] = p1 + s1 * cPoint;
                    _v.o[0][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
                    _v.o[0][1] = p1 - s1;
                    _v.o[1][0] = _cw ? p0 + s0 : p0 - s0;
                    _v.o[1][1] = p1 + s1 * cPoint;
                    _v.o[2][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
                    _v.o[2][1] = p1 + s1;
                    _v.o[3][0] = _cw ? p0 - s0 : p0 + s0;
                    _v.o[3][1] = p1 - s1 * cPoint;
                }
            };
            extendPrototype([
                DynamicPropertyContainer
            ], EllShapePropertyFactory);
            return EllShapePropertyFactory;
        }();
        var StarShapeProperty = function() {
            function StarShapePropertyFactory(elem, data) {
                this.v = shapePool.newElement();
                this.v.setPathData(true, 0);
                this.elem = elem;
                this.comp = elem.comp;
                this.data = data;
                this.frameId = -1;
                this.d = data.d;
                this.initDynamicPropertyContainer(elem);
                if (data.sy === 1) {
                    this.ir = PropertyFactory.getProp(elem, data.ir, 0, 0, this);
                    this.is = PropertyFactory.getProp(elem, data.is, 0, 0.01, this);
                    this.convertToPath = this.convertStarToPath;
                } else this.convertToPath = this.convertPolygonToPath;
                this.pt = PropertyFactory.getProp(elem, data.pt, 0, 0, this);
                this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
                this.r = PropertyFactory.getProp(elem, data.r, 0, degToRads, this);
                this.or = PropertyFactory.getProp(elem, data.or, 0, 0, this);
                this.os = PropertyFactory.getProp(elem, data.os, 0, 0.01, this);
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.localShapeCollection.addShape(this.v);
                this.paths = this.localShapeCollection;
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertToPath();
                }
            }
            StarShapePropertyFactory.prototype = {
                reset: resetShape,
                getValue: function getValue() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertToPath();
                },
                convertStarToPath: function convertStarToPath() {
                    var numPts = Math.floor(this.pt.v) * 2;
                    var angle = Math.PI * 2 / numPts;
                    /* this.v.v.length = numPts;
                  this.v.i.length = numPts;
                  this.v.o.length = numPts; */ var longFlag = true;
                    var longRad = this.or.v;
                    var shortRad = this.ir.v;
                    var longRound = this.os.v;
                    var shortRound = this.is.v;
                    var longPerimSegment = 2 * Math.PI * longRad / (numPts * 2);
                    var shortPerimSegment = 2 * Math.PI * shortRad / (numPts * 2);
                    var i;
                    var rad;
                    var roundness;
                    var perimSegment;
                    var currentAng = -Math.PI / 2;
                    currentAng += this.r.v;
                    var dir = this.data.d === 3 ? -1 : 1;
                    this.v._length = 0;
                    for(i = 0; i < numPts; i += 1){
                        rad = longFlag ? longRad : shortRad;
                        roundness = longFlag ? longRound : shortRound;
                        perimSegment = longFlag ? longPerimSegment : shortPerimSegment;
                        var x = rad * Math.cos(currentAng);
                        var y = rad * Math.sin(currentAng);
                        var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
                        var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
                        x += +this.p.v[0];
                        y += +this.p.v[1];
                        this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
                        /* this.v.v[i] = [x,y];
                      this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
                      this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
                      this.v._length = numPts; */ longFlag = !longFlag;
                        currentAng += angle * dir;
                    }
                },
                convertPolygonToPath: function convertPolygonToPath() {
                    var numPts = Math.floor(this.pt.v);
                    var angle = Math.PI * 2 / numPts;
                    var rad = this.or.v;
                    var roundness = this.os.v;
                    var perimSegment = 2 * Math.PI * rad / (numPts * 4);
                    var i;
                    var currentAng = -Math.PI * 0.5;
                    var dir = this.data.d === 3 ? -1 : 1;
                    currentAng += this.r.v;
                    this.v._length = 0;
                    for(i = 0; i < numPts; i += 1){
                        var x = rad * Math.cos(currentAng);
                        var y = rad * Math.sin(currentAng);
                        var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
                        var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
                        x += +this.p.v[0];
                        y += +this.p.v[1];
                        this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
                        currentAng += angle * dir;
                    }
                    this.paths.length = 0;
                    this.paths[0] = this.v;
                }
            };
            extendPrototype([
                DynamicPropertyContainer
            ], StarShapePropertyFactory);
            return StarShapePropertyFactory;
        }();
        var RectShapeProperty = function() {
            function RectShapePropertyFactory(elem, data) {
                this.v = shapePool.newElement();
                this.v.c = true;
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.localShapeCollection.addShape(this.v);
                this.paths = this.localShapeCollection;
                this.elem = elem;
                this.comp = elem.comp;
                this.frameId = -1;
                this.d = data.d;
                this.initDynamicPropertyContainer(elem);
                this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
                this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
                this.r = PropertyFactory.getProp(elem, data.r, 0, 0, this);
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertRectToPath();
                }
            }
            RectShapePropertyFactory.prototype = {
                convertRectToPath: function convertRectToPath() {
                    var p0 = this.p.v[0];
                    var p1 = this.p.v[1];
                    var v0 = this.s.v[0] / 2;
                    var v1 = this.s.v[1] / 2;
                    var round = bmMin(v0, v1, this.r.v);
                    var cPoint = round * (1 - roundCorner);
                    this.v._length = 0;
                    if (this.d === 2 || this.d === 1) {
                        this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, 0, true);
                        this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, p0 + v0, p1 + v1 - round, 1, true);
                        if (round !== 0) {
                            this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, 2, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0 + round, p1 + v1, 3, true);
                            this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, 4, true);
                            this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1 + round, 5, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, 6, true);
                            this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, p0 + v0 - round, p1 - v1, 7, true);
                        } else {
                            this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0, p1 + v1, 2);
                            this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1, 3);
                        }
                    } else {
                        this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, p0 + v0, p1 - v1 + round, 0, true);
                        if (round !== 0) {
                            this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, 1, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0 + round, p1 - v1, 2, true);
                            this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, 3, true);
                            this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1 - round, 4, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, 5, true);
                            this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0 - round, p1 + v1, 6, true);
                            this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, 7, true);
                        } else {
                            this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0, p1 - v1, 1, true);
                            this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1, 2, true);
                            this.v.setTripleAt(p0 + v0, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0, p1 + v1, 3, true);
                        }
                    }
                },
                getValue: function getValue() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertRectToPath();
                },
                reset: resetShape
            };
            extendPrototype([
                DynamicPropertyContainer
            ], RectShapePropertyFactory);
            return RectShapePropertyFactory;
        }();
        function getShapeProp(elem, data, type) {
            var prop;
            if (type === 3 || type === 4) {
                var dataProp = type === 3 ? data.pt : data.ks;
                var keys = dataProp.k;
                if (keys.length) prop = new KeyframedShapeProperty(elem, data, type);
                else prop = new ShapeProperty(elem, data, type);
            } else if (type === 5) prop = new RectShapeProperty(elem, data);
            else if (type === 6) prop = new EllShapeProperty(elem, data);
            else if (type === 7) prop = new StarShapeProperty(elem, data);
            if (prop.k) elem.addDynamicProperty(prop);
            return prop;
        }
        function getConstructorFunction() {
            return ShapeProperty;
        }
        function getKeyframedConstructorFunction() {
            return KeyframedShapeProperty;
        }
        var ob = {};
        ob.getShapeProp = getShapeProp;
        ob.getConstructorFunction = getConstructorFunction;
        ob.getKeyframedConstructorFunction = getKeyframedConstructorFunction;
        return ob;
    }();
    /*!
   Transformation Matrix v2.0
   (c) Epistemex 2014-2015
   www.epistemex.com
   By Ken Fyrstenberg
   Contributions by leeoniya.
   License: MIT, header required.
   */ /**
   * 2D transformation matrix object initialized with identity matrix.
   *
   * The matrix can synchronize a canvas context by supplying the context
   * as an argument, or later apply current absolute transform to an
   * existing context.
   *
   * All values are handled as floating point values.
   *
   * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
   * @prop {number} a - scale x
   * @prop {number} b - shear y
   * @prop {number} c - shear x
   * @prop {number} d - scale y
   * @prop {number} e - translate x
   * @prop {number} f - translate y
   * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
   * @constructor
   */ var Matrix = function() {
        var _cos = Math.cos;
        var _sin = Math.sin;
        var _tan = Math.tan;
        var _rnd = Math.round;
        function reset() {
            this.props[0] = 1;
            this.props[1] = 0;
            this.props[2] = 0;
            this.props[3] = 0;
            this.props[4] = 0;
            this.props[5] = 1;
            this.props[6] = 0;
            this.props[7] = 0;
            this.props[8] = 0;
            this.props[9] = 0;
            this.props[10] = 1;
            this.props[11] = 0;
            this.props[12] = 0;
            this.props[13] = 0;
            this.props[14] = 0;
            this.props[15] = 1;
            return this;
        }
        function rotate(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function rotateX(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(1, 0, 0, 0, 0, mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1);
        }
        function rotateY(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, 0, mSin, 0, 0, 1, 0, 0, -mSin, 0, mCos, 0, 0, 0, 0, 1);
        }
        function rotateZ(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function shear(sx, sy) {
            return this._t(1, sy, sx, 1, 0, 0);
        }
        function skew(ax, ay) {
            return this.shear(_tan(ax), _tan(ay));
        }
        function skewFromAxis(ax, angle) {
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, mSin, 0, 0, -mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, _tan(ax), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        // return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, _tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
        }
        function scale(sx, sy, sz) {
            if (!sz && sz !== 0) sz = 1;
            if (sx === 1 && sy === 1 && sz === 1) return this;
            return this._t(sx, 0, 0, 0, 0, sy, 0, 0, 0, 0, sz, 0, 0, 0, 0, 1);
        }
        function setTransform(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p) {
            this.props[0] = a;
            this.props[1] = b;
            this.props[2] = c;
            this.props[3] = d;
            this.props[4] = e;
            this.props[5] = f;
            this.props[6] = g;
            this.props[7] = h;
            this.props[8] = i;
            this.props[9] = j;
            this.props[10] = k;
            this.props[11] = l;
            this.props[12] = m;
            this.props[13] = n;
            this.props[14] = o;
            this.props[15] = p;
            return this;
        }
        function translate(tx, ty, tz) {
            tz = tz || 0;
            if (tx !== 0 || ty !== 0 || tz !== 0) return this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, tx, ty, tz, 1);
            return this;
        }
        function transform(a2, b2, c2, d2, e2, f2, g2, h2, i2, j2, k2, l2, m2, n2, o2, p2) {
            var _p = this.props;
            if (a2 === 1 && b2 === 0 && c2 === 0 && d2 === 0 && e2 === 0 && f2 === 1 && g2 === 0 && h2 === 0 && i2 === 0 && j2 === 0 && k2 === 1 && l2 === 0) {
                // NOTE: commenting this condition because TurboFan deoptimizes code when present
                // if(m2 !== 0 || n2 !== 0 || o2 !== 0){
                _p[12] = _p[12] * a2 + _p[15] * m2;
                _p[13] = _p[13] * f2 + _p[15] * n2;
                _p[14] = _p[14] * k2 + _p[15] * o2;
                _p[15] *= p2;
                // }
                this._identityCalculated = false;
                return this;
            }
            var a1 = _p[0];
            var b1 = _p[1];
            var c1 = _p[2];
            var d1 = _p[3];
            var e1 = _p[4];
            var f1 = _p[5];
            var g1 = _p[6];
            var h1 = _p[7];
            var i1 = _p[8];
            var j1 = _p[9];
            var k1 = _p[10];
            var l1 = _p[11];
            var m1 = _p[12];
            var n1 = _p[13];
            var o1 = _p[14];
            var p1 = _p[15];
            /* matrix order (canvas compatible):
           * ace
           * bdf
           * 001
           */ _p[0] = a1 * a2 + b1 * e2 + c1 * i2 + d1 * m2;
            _p[1] = a1 * b2 + b1 * f2 + c1 * j2 + d1 * n2;
            _p[2] = a1 * c2 + b1 * g2 + c1 * k2 + d1 * o2;
            _p[3] = a1 * d2 + b1 * h2 + c1 * l2 + d1 * p2;
            _p[4] = e1 * a2 + f1 * e2 + g1 * i2 + h1 * m2;
            _p[5] = e1 * b2 + f1 * f2 + g1 * j2 + h1 * n2;
            _p[6] = e1 * c2 + f1 * g2 + g1 * k2 + h1 * o2;
            _p[7] = e1 * d2 + f1 * h2 + g1 * l2 + h1 * p2;
            _p[8] = i1 * a2 + j1 * e2 + k1 * i2 + l1 * m2;
            _p[9] = i1 * b2 + j1 * f2 + k1 * j2 + l1 * n2;
            _p[10] = i1 * c2 + j1 * g2 + k1 * k2 + l1 * o2;
            _p[11] = i1 * d2 + j1 * h2 + k1 * l2 + l1 * p2;
            _p[12] = m1 * a2 + n1 * e2 + o1 * i2 + p1 * m2;
            _p[13] = m1 * b2 + n1 * f2 + o1 * j2 + p1 * n2;
            _p[14] = m1 * c2 + n1 * g2 + o1 * k2 + p1 * o2;
            _p[15] = m1 * d2 + n1 * h2 + o1 * l2 + p1 * p2;
            this._identityCalculated = false;
            return this;
        }
        function multiply(matrix) {
            var matrixProps = matrix.props;
            return this.transform(matrixProps[0], matrixProps[1], matrixProps[2], matrixProps[3], matrixProps[4], matrixProps[5], matrixProps[6], matrixProps[7], matrixProps[8], matrixProps[9], matrixProps[10], matrixProps[11], matrixProps[12], matrixProps[13], matrixProps[14], matrixProps[15]);
        }
        function isIdentity() {
            if (!this._identityCalculated) {
                this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1);
                this._identityCalculated = true;
            }
            return this._identity;
        }
        function equals(matr) {
            var i = 0;
            while(i < 16){
                if (matr.props[i] !== this.props[i]) return false;
                i += 1;
            }
            return true;
        }
        function clone(matr) {
            var i;
            for(i = 0; i < 16; i += 1)matr.props[i] = this.props[i];
            return matr;
        }
        function cloneFromProps(props) {
            var i;
            for(i = 0; i < 16; i += 1)this.props[i] = props[i];
        }
        function applyToPoint(x, y, z) {
            return {
                x: x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
                y: x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
                z: x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
            };
        /* return {
           x: x * me.a + y * me.c + me.e,
           y: x * me.b + y * me.d + me.f
           }; */ }
        function applyToX(x, y, z) {
            return x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12];
        }
        function applyToY(x, y, z) {
            return x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13];
        }
        function applyToZ(x, y, z) {
            return x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14];
        }
        function getInverseMatrix() {
            var determinant = this.props[0] * this.props[5] - this.props[1] * this.props[4];
            var a = this.props[5] / determinant;
            var b = -this.props[1] / determinant;
            var c = -this.props[4] / determinant;
            var d = this.props[0] / determinant;
            var e = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / determinant;
            var f = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / determinant;
            var inverseMatrix = new Matrix();
            inverseMatrix.props[0] = a;
            inverseMatrix.props[1] = b;
            inverseMatrix.props[4] = c;
            inverseMatrix.props[5] = d;
            inverseMatrix.props[12] = e;
            inverseMatrix.props[13] = f;
            return inverseMatrix;
        }
        function inversePoint(pt) {
            var inverseMatrix = this.getInverseMatrix();
            return inverseMatrix.applyToPointArray(pt[0], pt[1], pt[2] || 0);
        }
        function inversePoints(pts) {
            var i;
            var len = pts.length;
            var retPts = [];
            for(i = 0; i < len; i += 1)retPts[i] = inversePoint(pts[i]);
            return retPts;
        }
        function applyToTriplePoints(pt1, pt2, pt3) {
            var arr = createTypedArray('float32', 6);
            if (this.isIdentity()) {
                arr[0] = pt1[0];
                arr[1] = pt1[1];
                arr[2] = pt2[0];
                arr[3] = pt2[1];
                arr[4] = pt3[0];
                arr[5] = pt3[1];
            } else {
                var p0 = this.props[0];
                var p1 = this.props[1];
                var p4 = this.props[4];
                var p5 = this.props[5];
                var p12 = this.props[12];
                var p13 = this.props[13];
                arr[0] = pt1[0] * p0 + pt1[1] * p4 + p12;
                arr[1] = pt1[0] * p1 + pt1[1] * p5 + p13;
                arr[2] = pt2[0] * p0 + pt2[1] * p4 + p12;
                arr[3] = pt2[0] * p1 + pt2[1] * p5 + p13;
                arr[4] = pt3[0] * p0 + pt3[1] * p4 + p12;
                arr[5] = pt3[0] * p1 + pt3[1] * p5 + p13;
            }
            return arr;
        }
        function applyToPointArray(x, y, z) {
            var arr;
            if (this.isIdentity()) arr = [
                x,
                y,
                z
            ];
            else arr = [
                x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
                x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
                x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
            ];
            return arr;
        }
        function applyToPointStringified(x, y) {
            if (this.isIdentity()) return x + ',' + y;
            var _p = this.props;
            return Math.round((x * _p[0] + y * _p[4] + _p[12]) * 100) / 100 + ',' + Math.round((x * _p[1] + y * _p[5] + _p[13]) * 100) / 100;
        }
        function toCSS() {
            // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
            /* if(this.isIdentity()) {
              return '';
          } */ var i = 0;
            var props = this.props;
            var cssValue = 'matrix3d(';
            var v = 10000;
            while(i < 16){
                cssValue += _rnd(props[i] * v) / v;
                cssValue += i === 15 ? ')' : ',';
                i += 1;
            }
            return cssValue;
        }
        function roundMatrixProperty(val) {
            var v = 10000;
            if (val < 0.000001 && val > 0 || val > -0.000001 && val < 0) return _rnd(val * v) / v;
            return val;
        }
        function to2dCSS() {
            // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
            /* if(this.isIdentity()) {
              return '';
          } */ var props = this.props;
            var _a = roundMatrixProperty(props[0]);
            var _b = roundMatrixProperty(props[1]);
            var _c = roundMatrixProperty(props[4]);
            var _d = roundMatrixProperty(props[5]);
            var _e = roundMatrixProperty(props[12]);
            var _f = roundMatrixProperty(props[13]);
            return 'matrix(' + _a + ',' + _b + ',' + _c + ',' + _d + ',' + _e + ',' + _f + ')';
        }
        return function() {
            this.reset = reset;
            this.rotate = rotate;
            this.rotateX = rotateX;
            this.rotateY = rotateY;
            this.rotateZ = rotateZ;
            this.skew = skew;
            this.skewFromAxis = skewFromAxis;
            this.shear = shear;
            this.scale = scale;
            this.setTransform = setTransform;
            this.translate = translate;
            this.transform = transform;
            this.multiply = multiply;
            this.applyToPoint = applyToPoint;
            this.applyToX = applyToX;
            this.applyToY = applyToY;
            this.applyToZ = applyToZ;
            this.applyToPointArray = applyToPointArray;
            this.applyToTriplePoints = applyToTriplePoints;
            this.applyToPointStringified = applyToPointStringified;
            this.toCSS = toCSS;
            this.to2dCSS = to2dCSS;
            this.clone = clone;
            this.cloneFromProps = cloneFromProps;
            this.equals = equals;
            this.inversePoints = inversePoints;
            this.inversePoint = inversePoint;
            this.getInverseMatrix = getInverseMatrix;
            this._t = this.transform;
            this.isIdentity = isIdentity;
            this._identity = true;
            this._identityCalculated = false;
            this.props = createTypedArray('float32', 16);
            this.reset();
        };
    }();
    function _typeof(o) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, _typeof(o);
    }
    var lottie = {};
    var standalone = '__[STANDALONE]__';
    var animationData = '__[ANIMATIONDATA]__';
    var renderer = '';
    function setLocation(href) {
        setLocationHref(href);
    }
    function searchAnimations() {
        if (standalone === true) animationManager.searchAnimations(animationData, standalone, renderer);
        else animationManager.searchAnimations();
    }
    function setSubframeRendering(flag) {
        setSubframeEnabled(flag);
    }
    function setPrefix(prefix) {
        setIdPrefix(prefix);
    }
    function loadAnimation(params) {
        if (standalone === true) params.animationData = JSON.parse(animationData);
        return animationManager.loadAnimation(params);
    }
    function setQuality(value) {
        if (typeof value === 'string') switch(value){
            case 'high':
                setDefaultCurveSegments(200);
                break;
            default:
            case 'medium':
                setDefaultCurveSegments(50);
                break;
            case 'low':
                setDefaultCurveSegments(10);
                break;
        }
        else if (!isNaN(value) && value > 1) setDefaultCurveSegments(value);
        if (getDefaultCurveSegments() >= 50) roundValues(false);
        else roundValues(true);
    }
    function inBrowser() {
        return typeof navigator !== 'undefined';
    }
    function installPlugin(type, plugin) {
        if (type === 'expressions') setExpressionsPlugin(plugin);
    }
    function getFactory(name) {
        switch(name){
            case 'propertyFactory':
                return PropertyFactory;
            case 'shapePropertyFactory':
                return ShapePropertyFactory;
            case 'matrix':
                return Matrix;
            default:
                return null;
        }
    }
    lottie.play = animationManager.play;
    lottie.pause = animationManager.pause;
    lottie.setLocationHref = setLocation;
    lottie.togglePause = animationManager.togglePause;
    lottie.setSpeed = animationManager.setSpeed;
    lottie.setDirection = animationManager.setDirection;
    lottie.stop = animationManager.stop;
    lottie.searchAnimations = searchAnimations;
    lottie.registerAnimation = animationManager.registerAnimation;
    lottie.loadAnimation = loadAnimation;
    lottie.setSubframeRendering = setSubframeRendering;
    lottie.resize = animationManager.resize;
    // lottie.start = start;
    lottie.goToAndStop = animationManager.goToAndStop;
    lottie.destroy = animationManager.destroy;
    lottie.setQuality = setQuality;
    lottie.inBrowser = inBrowser;
    lottie.installPlugin = installPlugin;
    lottie.freeze = animationManager.freeze;
    lottie.unfreeze = animationManager.unfreeze;
    lottie.setVolume = animationManager.setVolume;
    lottie.mute = animationManager.mute;
    lottie.unmute = animationManager.unmute;
    lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations;
    lottie.useWebWorker = setWebWorker;
    lottie.setIDPrefix = setPrefix;
    lottie.__getFactory = getFactory;
    lottie.version = '5.13.0';
    function checkReady() {
        if (document.readyState === 'complete') {
            clearInterval(readyStateCheckInterval);
            searchAnimations();
        }
    }
    function getQueryVariable(variable) {
        var vars = queryString.split('&');
        for(var i = 0; i < vars.length; i += 1){
            var pair = vars[i].split('=');
            if (decodeURIComponent(pair[0]) == variable) // eslint-disable-line eqeqeq
            return decodeURIComponent(pair[1]);
        }
        return null;
    }
    var queryString = '';
    if (standalone) {
        var scripts = document.getElementsByTagName('script');
        var index = scripts.length - 1;
        var myScript = scripts[index] || {
            src: ''
        };
        queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, '') : ''; // eslint-disable-line no-useless-escape
        renderer = getQueryVariable('renderer');
    }
    var readyStateCheckInterval = setInterval(checkReady, 100);
    // this adds bodymovin to the window object for backwards compatibility
    try {
        if (!(_typeof(module.exports) === 'object' && true) && !(typeof define === 'function' && define.amd // eslint-disable-line no-undef
        )) window.bodymovin = lottie;
    } catch (err) {
    //
    }
    var ShapeModifiers = function() {
        var ob = {};
        var modifiers = {};
        ob.registerModifier = registerModifier;
        ob.getModifier = getModifier;
        function registerModifier(nm, factory) {
            if (!modifiers[nm]) modifiers[nm] = factory;
        }
        function getModifier(nm, elem, data) {
            return new modifiers[nm](elem, data);
        }
        return ob;
    }();
    function ShapeModifier() {}
    ShapeModifier.prototype.initModifierProperties = function() {};
    ShapeModifier.prototype.addShapeToModifier = function() {};
    ShapeModifier.prototype.addShape = function(data) {
        if (!this.closed) {
            // Adding shape to dynamic properties. It covers the case where a shape has no effects applied, to reset it's _mdf state on every tick.
            data.sh.container.addDynamicProperty(data.sh);
            var shapeData = {
                shape: data.sh,
                data: data,
                localShapeCollection: shapeCollectionPool.newShapeCollection()
            };
            this.shapes.push(shapeData);
            this.addShapeToModifier(shapeData);
            if (this._isAnimated) data.setAsAnimated();
        }
    };
    ShapeModifier.prototype.init = function(elem, data) {
        this.shapes = [];
        this.elem = elem;
        this.initDynamicPropertyContainer(elem);
        this.initModifierProperties(elem, data);
        this.frameId = initialDefaultFrame;
        this.closed = false;
        this.k = false;
        if (this.dynamicProperties.length) this.k = true;
        else this.getValue(true);
    };
    ShapeModifier.prototype.processKeys = function() {
        if (this.elem.globalData.frameId === this.frameId) return;
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();
    };
    extendPrototype([
        DynamicPropertyContainer
    ], ShapeModifier);
    function TrimModifier() {}
    extendPrototype([
        ShapeModifier
    ], TrimModifier);
    TrimModifier.prototype.initModifierProperties = function(elem, data) {
        this.s = PropertyFactory.getProp(elem, data.s, 0, 0.01, this);
        this.e = PropertyFactory.getProp(elem, data.e, 0, 0.01, this);
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0, this);
        this.sValue = 0;
        this.eValue = 0;
        this.getValue = this.processKeys;
        this.m = data.m;
        this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
    };
    TrimModifier.prototype.addShapeToModifier = function(shapeData) {
        shapeData.pathsData = [];
    };
    TrimModifier.prototype.calculateShapeEdges = function(s, e, shapeLength, addedLength, totalModifierLength) {
        var segments = [];
        if (e <= 1) segments.push({
            s: s,
            e: e
        });
        else if (s >= 1) segments.push({
            s: s - 1,
            e: e - 1
        });
        else {
            segments.push({
                s: s,
                e: 1
            });
            segments.push({
                s: 0,
                e: e - 1
            });
        }
        var shapeSegments = [];
        var i;
        var len = segments.length;
        var segmentOb;
        for(i = 0; i < len; i += 1){
            segmentOb = segments[i];
            if (!(segmentOb.e * totalModifierLength < addedLength || segmentOb.s * totalModifierLength > addedLength + shapeLength)) {
                var shapeS;
                var shapeE;
                if (segmentOb.s * totalModifierLength <= addedLength) shapeS = 0;
                else shapeS = (segmentOb.s * totalModifierLength - addedLength) / shapeLength;
                if (segmentOb.e * totalModifierLength >= addedLength + shapeLength) shapeE = 1;
                else shapeE = (segmentOb.e * totalModifierLength - addedLength) / shapeLength;
                shapeSegments.push([
                    shapeS,
                    shapeE
                ]);
            }
        }
        if (!shapeSegments.length) shapeSegments.push([
            0,
            0
        ]);
        return shapeSegments;
    };
    TrimModifier.prototype.releasePathsData = function(pathsData) {
        var i;
        var len = pathsData.length;
        for(i = 0; i < len; i += 1)segmentsLengthPool.release(pathsData[i]);
        pathsData.length = 0;
        return pathsData;
    };
    TrimModifier.prototype.processShapes = function(_isFirstFrame) {
        var s;
        var e;
        if (this._mdf || _isFirstFrame) {
            var o = this.o.v % 360 / 360;
            if (o < 0) o += 1;
            if (this.s.v > 1) s = 1 + o;
            else if (this.s.v < 0) s = 0 + o;
            else s = this.s.v + o;
            if (this.e.v > 1) e = 1 + o;
            else if (this.e.v < 0) e = 0 + o;
            else e = this.e.v + o;
            if (s > e) {
                var _s = s;
                s = e;
                e = _s;
            }
            s = Math.round(s * 10000) * 0.0001;
            e = Math.round(e * 10000) * 0.0001;
            this.sValue = s;
            this.eValue = e;
        } else {
            s = this.sValue;
            e = this.eValue;
        }
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var pathsData;
        var pathData;
        var totalShapeLength;
        var totalModifierLength = 0;
        if (e === s) for(i = 0; i < len; i += 1){
            this.shapes[i].localShapeCollection.releaseShapes();
            this.shapes[i].shape._mdf = true;
            this.shapes[i].shape.paths = this.shapes[i].localShapeCollection;
            if (this._mdf) this.shapes[i].pathsData.length = 0;
        }
        else if (!(e === 1 && s === 0 || e === 0 && s === 1)) {
            var segments = [];
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                // if shape hasn't changed and trim properties haven't changed, cached previous path can be used
                if (!shapeData.shape._mdf && !this._mdf && !_isFirstFrame && this.m !== 2) shapeData.shape.paths = shapeData.localShapeCollection;
                else {
                    shapePaths = shapeData.shape.paths;
                    jLen = shapePaths._length;
                    totalShapeLength = 0;
                    if (!shapeData.shape._mdf && shapeData.pathsData.length) totalShapeLength = shapeData.totalShapeLength;
                    else {
                        pathsData = this.releasePathsData(shapeData.pathsData);
                        for(j = 0; j < jLen; j += 1){
                            pathData = bez.getSegmentsLength(shapePaths.shapes[j]);
                            pathsData.push(pathData);
                            totalShapeLength += pathData.totalLength;
                        }
                        shapeData.totalShapeLength = totalShapeLength;
                        shapeData.pathsData = pathsData;
                    }
                    totalModifierLength += totalShapeLength;
                    shapeData.shape._mdf = true;
                }
            }
            var shapeS = s;
            var shapeE = e;
            var addedLength = 0;
            var edges;
            for(i = len - 1; i >= 0; i -= 1){
                shapeData = this.shapes[i];
                if (shapeData.shape._mdf) {
                    localShapeCollection = shapeData.localShapeCollection;
                    localShapeCollection.releaseShapes();
                    // if m === 2 means paths are trimmed individually so edges need to be found for this specific shape relative to whoel group
                    if (this.m === 2 && len > 1) {
                        edges = this.calculateShapeEdges(s, e, shapeData.totalShapeLength, addedLength, totalModifierLength);
                        addedLength += shapeData.totalShapeLength;
                    } else edges = [
                        [
                            shapeS,
                            shapeE
                        ]
                    ];
                    jLen = edges.length;
                    for(j = 0; j < jLen; j += 1){
                        shapeS = edges[j][0];
                        shapeE = edges[j][1];
                        segments.length = 0;
                        if (shapeE <= 1) segments.push({
                            s: shapeData.totalShapeLength * shapeS,
                            e: shapeData.totalShapeLength * shapeE
                        });
                        else if (shapeS >= 1) segments.push({
                            s: shapeData.totalShapeLength * (shapeS - 1),
                            e: shapeData.totalShapeLength * (shapeE - 1)
                        });
                        else {
                            segments.push({
                                s: shapeData.totalShapeLength * shapeS,
                                e: shapeData.totalShapeLength
                            });
                            segments.push({
                                s: 0,
                                e: shapeData.totalShapeLength * (shapeE - 1)
                            });
                        }
                        var newShapesData = this.addShapes(shapeData, segments[0]);
                        if (segments[0].s !== segments[0].e) {
                            if (segments.length > 1) {
                                var lastShapeInCollection = shapeData.shape.paths.shapes[shapeData.shape.paths._length - 1];
                                if (lastShapeInCollection.c) {
                                    var lastShape = newShapesData.pop();
                                    this.addPaths(newShapesData, localShapeCollection);
                                    newShapesData = this.addShapes(shapeData, segments[1], lastShape);
                                } else {
                                    this.addPaths(newShapesData, localShapeCollection);
                                    newShapesData = this.addShapes(shapeData, segments[1]);
                                }
                            }
                            this.addPaths(newShapesData, localShapeCollection);
                        }
                    }
                    shapeData.shape.paths = localShapeCollection;
                }
            }
        } else if (this._mdf) for(i = 0; i < len; i += 1){
            // Releasign Trim Cached paths data when no trim applied in case shapes are modified inbetween.
            // Don't remove this even if it's losing cached info.
            this.shapes[i].pathsData.length = 0;
            this.shapes[i].shape._mdf = true;
        }
    };
    TrimModifier.prototype.addPaths = function(newPaths, localShapeCollection) {
        var i;
        var len = newPaths.length;
        for(i = 0; i < len; i += 1)localShapeCollection.addShape(newPaths[i]);
    };
    TrimModifier.prototype.addSegment = function(pt1, pt2, pt3, pt4, shapePath, pos, newShape) {
        shapePath.setXYAt(pt2[0], pt2[1], 'o', pos);
        shapePath.setXYAt(pt3[0], pt3[1], 'i', pos + 1);
        if (newShape) shapePath.setXYAt(pt1[0], pt1[1], 'v', pos);
        shapePath.setXYAt(pt4[0], pt4[1], 'v', pos + 1);
    };
    TrimModifier.prototype.addSegmentFromArray = function(points, shapePath, pos, newShape) {
        shapePath.setXYAt(points[1], points[5], 'o', pos);
        shapePath.setXYAt(points[2], points[6], 'i', pos + 1);
        if (newShape) shapePath.setXYAt(points[0], points[4], 'v', pos);
        shapePath.setXYAt(points[3], points[7], 'v', pos + 1);
    };
    TrimModifier.prototype.addShapes = function(shapeData, shapeSegment, shapePath) {
        var pathsData = shapeData.pathsData;
        var shapePaths = shapeData.shape.paths.shapes;
        var i;
        var len = shapeData.shape.paths._length;
        var j;
        var jLen;
        var addedLength = 0;
        var currentLengthData;
        var segmentCount;
        var lengths;
        var segment;
        var shapes = [];
        var initPos;
        var newShape = true;
        if (!shapePath) {
            shapePath = shapePool.newElement();
            segmentCount = 0;
            initPos = 0;
        } else {
            segmentCount = shapePath._length;
            initPos = shapePath._length;
        }
        shapes.push(shapePath);
        for(i = 0; i < len; i += 1){
            lengths = pathsData[i].lengths;
            shapePath.c = shapePaths[i].c;
            jLen = shapePaths[i].c ? lengths.length : lengths.length + 1;
            for(j = 1; j < jLen; j += 1){
                currentLengthData = lengths[j - 1];
                if (addedLength + currentLengthData.addedLength < shapeSegment.s) {
                    addedLength += currentLengthData.addedLength;
                    shapePath.c = false;
                } else if (addedLength > shapeSegment.e) {
                    shapePath.c = false;
                    break;
                } else {
                    if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + currentLengthData.addedLength) {
                        this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[j], shapePaths[i].v[j], shapePath, segmentCount, newShape);
                        newShape = false;
                    } else {
                        segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[j], shapePaths[i].o[j - 1], shapePaths[i].i[j], (shapeSegment.s - addedLength) / currentLengthData.addedLength, (shapeSegment.e - addedLength) / currentLengthData.addedLength, lengths[j - 1]);
                        this.addSegmentFromArray(segment, shapePath, segmentCount, newShape);
                        // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
                        newShape = false;
                        shapePath.c = false;
                    }
                    addedLength += currentLengthData.addedLength;
                    segmentCount += 1;
                }
            }
            if (shapePaths[i].c && lengths.length) {
                currentLengthData = lengths[j - 1];
                if (addedLength <= shapeSegment.e) {
                    var segmentLength = lengths[j - 1].addedLength;
                    if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + segmentLength) {
                        this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[0], shapePaths[i].v[0], shapePath, segmentCount, newShape);
                        newShape = false;
                    } else {
                        segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[0], shapePaths[i].o[j - 1], shapePaths[i].i[0], (shapeSegment.s - addedLength) / segmentLength, (shapeSegment.e - addedLength) / segmentLength, lengths[j - 1]);
                        this.addSegmentFromArray(segment, shapePath, segmentCount, newShape);
                        // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
                        newShape = false;
                        shapePath.c = false;
                    }
                } else shapePath.c = false;
                addedLength += currentLengthData.addedLength;
                segmentCount += 1;
            }
            if (shapePath._length) {
                shapePath.setXYAt(shapePath.v[initPos][0], shapePath.v[initPos][1], 'i', initPos);
                shapePath.setXYAt(shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1], 'o', shapePath._length - 1);
            }
            if (addedLength > shapeSegment.e) break;
            if (i < len - 1) {
                shapePath = shapePool.newElement();
                newShape = true;
                shapes.push(shapePath);
                segmentCount = 0;
            }
        }
        return shapes;
    };
    function PuckerAndBloatModifier() {}
    extendPrototype([
        ShapeModifier
    ], PuckerAndBloatModifier);
    PuckerAndBloatModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
        this._isAnimated = !!this.amount.effectsSequence.length;
    };
    PuckerAndBloatModifier.prototype.processPath = function(path, amount) {
        var percent = amount / 100;
        var centerPoint = [
            0,
            0
        ];
        var pathLength = path._length;
        var i = 0;
        for(i = 0; i < pathLength; i += 1){
            centerPoint[0] += path.v[i][0];
            centerPoint[1] += path.v[i][1];
        }
        centerPoint[0] /= pathLength;
        centerPoint[1] /= pathLength;
        var clonedPath = shapePool.newElement();
        clonedPath.c = path.c;
        var vX;
        var vY;
        var oX;
        var oY;
        var iX;
        var iY;
        for(i = 0; i < pathLength; i += 1){
            vX = path.v[i][0] + (centerPoint[0] - path.v[i][0]) * percent;
            vY = path.v[i][1] + (centerPoint[1] - path.v[i][1]) * percent;
            oX = path.o[i][0] + (centerPoint[0] - path.o[i][0]) * -percent;
            oY = path.o[i][1] + (centerPoint[1] - path.o[i][1]) * -percent;
            iX = path.i[i][0] + (centerPoint[0] - path.i[i][0]) * -percent;
            iY = path.i[i][1] + (centerPoint[1] - path.i[i][1]) * -percent;
            clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, i);
        }
        return clonedPath;
    };
    PuckerAndBloatModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var amount = this.amount.v;
        if (amount !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], amount));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    var TransformPropertyFactory = function() {
        var defaultVector = [
            0,
            0
        ];
        function applyToMatrix(mat) {
            var _mdf = this._mdf;
            this.iterateDynamicProperties();
            this._mdf = this._mdf || _mdf;
            if (this.a) mat.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
            if (this.s) mat.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
            if (this.sk) mat.skewFromAxis(-this.sk.v, this.sa.v);
            if (this.r) mat.rotate(-this.r.v);
            else mat.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
            if (this.data.p.s) {
                if (this.data.p.z) mat.translate(this.px.v, this.py.v, -this.pz.v);
                else mat.translate(this.px.v, this.py.v, 0);
            } else mat.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
        }
        function processKeys(forceRender) {
            if (this.elem.globalData.frameId === this.frameId) return;
            if (this._isDirty) {
                this.precalculateMatrix();
                this._isDirty = false;
            }
            this.iterateDynamicProperties();
            if (this._mdf || forceRender) {
                var frameRate;
                this.v.cloneFromProps(this.pre.props);
                if (this.appliedTransformations < 1) this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
                if (this.appliedTransformations < 2) this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
                if (this.sk && this.appliedTransformations < 3) this.v.skewFromAxis(-this.sk.v, this.sa.v);
                if (this.r && this.appliedTransformations < 4) this.v.rotate(-this.r.v);
                else if (!this.r && this.appliedTransformations < 4) this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
                if (this.autoOriented) {
                    var v1;
                    var v2;
                    frameRate = this.elem.globalData.frameRate;
                    if (this.p && this.p.keyframes && this.p.getValueAtTime) {
                        if (this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t) {
                            v1 = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / frameRate, 0);
                            v2 = this.p.getValueAtTime(this.p.keyframes[0].t / frameRate, 0);
                        } else if (this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t) {
                            v1 = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / frameRate, 0);
                            v2 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / frameRate, 0);
                        } else {
                            v1 = this.p.pv;
                            v2 = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / frameRate, this.p.offsetTime);
                        }
                    } else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                        v1 = [];
                        v2 = [];
                        var px = this.px;
                        var py = this.py;
                        if (px._caching.lastFrame + px.offsetTime <= px.keyframes[0].t) {
                            v1[0] = px.getValueAtTime((px.keyframes[0].t + 0.01) / frameRate, 0);
                            v1[1] = py.getValueAtTime((py.keyframes[0].t + 0.01) / frameRate, 0);
                            v2[0] = px.getValueAtTime(px.keyframes[0].t / frameRate, 0);
                            v2[1] = py.getValueAtTime(py.keyframes[0].t / frameRate, 0);
                        } else if (px._caching.lastFrame + px.offsetTime >= px.keyframes[px.keyframes.length - 1].t) {
                            v1[0] = px.getValueAtTime(px.keyframes[px.keyframes.length - 1].t / frameRate, 0);
                            v1[1] = py.getValueAtTime(py.keyframes[py.keyframes.length - 1].t / frameRate, 0);
                            v2[0] = px.getValueAtTime((px.keyframes[px.keyframes.length - 1].t - 0.01) / frameRate, 0);
                            v2[1] = py.getValueAtTime((py.keyframes[py.keyframes.length - 1].t - 0.01) / frameRate, 0);
                        } else {
                            v1 = [
                                px.pv,
                                py.pv
                            ];
                            v2[0] = px.getValueAtTime((px._caching.lastFrame + px.offsetTime - 0.01) / frameRate, px.offsetTime);
                            v2[1] = py.getValueAtTime((py._caching.lastFrame + py.offsetTime - 0.01) / frameRate, py.offsetTime);
                        }
                    } else {
                        v2 = defaultVector;
                        v1 = v2;
                    }
                    this.v.rotate(-Math.atan2(v1[1] - v2[1], v1[0] - v2[0]));
                }
                if (this.data.p && this.data.p.s) {
                    if (this.data.p.z) this.v.translate(this.px.v, this.py.v, -this.pz.v);
                    else this.v.translate(this.px.v, this.py.v, 0);
                } else this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
            }
            this.frameId = this.elem.globalData.frameId;
        }
        function precalculateMatrix() {
            this.appliedTransformations = 0;
            this.pre.reset();
            if (!this.a.effectsSequence.length) {
                this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
                this.appliedTransformations = 1;
            } else return;
            if (!this.s.effectsSequence.length) {
                this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
                this.appliedTransformations = 2;
            } else return;
            if (this.sk) {
                if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length) {
                    this.pre.skewFromAxis(-this.sk.v, this.sa.v);
                    this.appliedTransformations = 3;
                } else return;
            }
            if (this.r) {
                if (!this.r.effectsSequence.length) {
                    this.pre.rotate(-this.r.v);
                    this.appliedTransformations = 4;
                }
            } else if (!this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length) {
                this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
                this.appliedTransformations = 4;
            }
        }
        function autoOrient() {
        //
        // var prevP = this.getValueAtTime();
        }
        function addDynamicProperty(prop) {
            this._addDynamicProperty(prop);
            this.elem.addDynamicProperty(prop);
            this._isDirty = true;
        }
        function TransformProperty(elem, data, container) {
            this.elem = elem;
            this.frameId = -1;
            this.propType = 'transform';
            this.data = data;
            this.v = new Matrix();
            // Precalculated matrix with non animated properties
            this.pre = new Matrix();
            this.appliedTransformations = 0;
            this.initDynamicPropertyContainer(container || elem);
            if (data.p && data.p.s) {
                this.px = PropertyFactory.getProp(elem, data.p.x, 0, 0, this);
                this.py = PropertyFactory.getProp(elem, data.p.y, 0, 0, this);
                if (data.p.z) this.pz = PropertyFactory.getProp(elem, data.p.z, 0, 0, this);
            } else this.p = PropertyFactory.getProp(elem, data.p || {
                k: [
                    0,
                    0,
                    0
                ]
            }, 1, 0, this);
            if (data.rx) {
                this.rx = PropertyFactory.getProp(elem, data.rx, 0, degToRads, this);
                this.ry = PropertyFactory.getProp(elem, data.ry, 0, degToRads, this);
                this.rz = PropertyFactory.getProp(elem, data.rz, 0, degToRads, this);
                if (data.or.k[0].ti) {
                    var i;
                    var len = data.or.k.length;
                    for(i = 0; i < len; i += 1){
                        data.or.k[i].to = null;
                        data.or.k[i].ti = null;
                    }
                }
                this.or = PropertyFactory.getProp(elem, data.or, 1, degToRads, this);
                // sh Indicates it needs to be capped between -180 and 180
                this.or.sh = true;
            } else this.r = PropertyFactory.getProp(elem, data.r || {
                k: 0
            }, 0, degToRads, this);
            if (data.sk) {
                this.sk = PropertyFactory.getProp(elem, data.sk, 0, degToRads, this);
                this.sa = PropertyFactory.getProp(elem, data.sa, 0, degToRads, this);
            }
            this.a = PropertyFactory.getProp(elem, data.a || {
                k: [
                    0,
                    0,
                    0
                ]
            }, 1, 0, this);
            this.s = PropertyFactory.getProp(elem, data.s || {
                k: [
                    100,
                    100,
                    100
                ]
            }, 1, 0.01, this);
            // Opacity is not part of the transform properties, that's why it won't use this.dynamicProperties. That way transforms won't get updated if opacity changes.
            if (data.o) this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, elem);
            else this.o = {
                _mdf: false,
                v: 1
            };
            this._isDirty = true;
            if (!this.dynamicProperties.length) this.getValue(true);
        }
        TransformProperty.prototype = {
            applyToMatrix: applyToMatrix,
            getValue: processKeys,
            precalculateMatrix: precalculateMatrix,
            autoOrient: autoOrient
        };
        extendPrototype([
            DynamicPropertyContainer
        ], TransformProperty);
        TransformProperty.prototype.addDynamicProperty = addDynamicProperty;
        TransformProperty.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;
        function getTransformProperty(elem, data, container) {
            return new TransformProperty(elem, data, container);
        }
        return {
            getTransformProperty: getTransformProperty
        };
    }();
    function RepeaterModifier() {}
    extendPrototype([
        ShapeModifier
    ], RepeaterModifier);
    RepeaterModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.c = PropertyFactory.getProp(elem, data.c, 0, null, this);
        this.o = PropertyFactory.getProp(elem, data.o, 0, null, this);
        this.tr = TransformPropertyFactory.getTransformProperty(elem, data.tr, this);
        this.so = PropertyFactory.getProp(elem, data.tr.so, 0, 0.01, this);
        this.eo = PropertyFactory.getProp(elem, data.tr.eo, 0, 0.01, this);
        this.data = data;
        if (!this.dynamicProperties.length) this.getValue(true);
        this._isAnimated = !!this.dynamicProperties.length;
        this.pMatrix = new Matrix();
        this.rMatrix = new Matrix();
        this.sMatrix = new Matrix();
        this.tMatrix = new Matrix();
        this.matrix = new Matrix();
    };
    RepeaterModifier.prototype.applyTransforms = function(pMatrix, rMatrix, sMatrix, transform, perc, inv) {
        var dir = inv ? -1 : 1;
        var scaleX = transform.s.v[0] + (1 - transform.s.v[0]) * (1 - perc);
        var scaleY = transform.s.v[1] + (1 - transform.s.v[1]) * (1 - perc);
        pMatrix.translate(transform.p.v[0] * dir * perc, transform.p.v[1] * dir * perc, transform.p.v[2]);
        rMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
        rMatrix.rotate(-transform.r.v * dir * perc);
        rMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
        sMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
        sMatrix.scale(inv ? 1 / scaleX : scaleX, inv ? 1 / scaleY : scaleY);
        sMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
    };
    RepeaterModifier.prototype.init = function(elem, arr, pos, elemsData) {
        this.elem = elem;
        this.arr = arr;
        this.pos = pos;
        this.elemsData = elemsData;
        this._currentCopies = 0;
        this._elements = [];
        this._groups = [];
        this.frameId = -1;
        this.initDynamicPropertyContainer(elem);
        this.initModifierProperties(elem, arr[pos]);
        while(pos > 0){
            pos -= 1;
            // this._elements.unshift(arr.splice(pos,1)[0]);
            this._elements.unshift(arr[pos]);
        }
        if (this.dynamicProperties.length) this.k = true;
        else this.getValue(true);
    };
    RepeaterModifier.prototype.resetElements = function(elements) {
        var i;
        var len = elements.length;
        for(i = 0; i < len; i += 1){
            elements[i]._processed = false;
            if (elements[i].ty === 'gr') this.resetElements(elements[i].it);
        }
    };
    RepeaterModifier.prototype.cloneElements = function(elements) {
        var newElements = JSON.parse(JSON.stringify(elements));
        this.resetElements(newElements);
        return newElements;
    };
    RepeaterModifier.prototype.changeGroupRender = function(elements, renderFlag) {
        var i;
        var len = elements.length;
        for(i = 0; i < len; i += 1){
            elements[i]._render = renderFlag;
            if (elements[i].ty === 'gr') this.changeGroupRender(elements[i].it, renderFlag);
        }
    };
    RepeaterModifier.prototype.processShapes = function(_isFirstFrame) {
        var items;
        var itemsTransform;
        var i;
        var dir;
        var cont;
        var hasReloaded = false;
        if (this._mdf || _isFirstFrame) {
            var copies = Math.ceil(this.c.v);
            if (this._groups.length < copies) {
                while(this._groups.length < copies){
                    var group = {
                        it: this.cloneElements(this._elements),
                        ty: 'gr'
                    };
                    group.it.push({
                        a: {
                            a: 0,
                            ix: 1,
                            k: [
                                0,
                                0
                            ]
                        },
                        nm: 'Transform',
                        o: {
                            a: 0,
                            ix: 7,
                            k: 100
                        },
                        p: {
                            a: 0,
                            ix: 2,
                            k: [
                                0,
                                0
                            ]
                        },
                        r: {
                            a: 1,
                            ix: 6,
                            k: [
                                {
                                    s: 0,
                                    e: 0,
                                    t: 0
                                },
                                {
                                    s: 0,
                                    e: 0,
                                    t: 1
                                }
                            ]
                        },
                        s: {
                            a: 0,
                            ix: 3,
                            k: [
                                100,
                                100
                            ]
                        },
                        sa: {
                            a: 0,
                            ix: 5,
                            k: 0
                        },
                        sk: {
                            a: 0,
                            ix: 4,
                            k: 0
                        },
                        ty: 'tr'
                    });
                    this.arr.splice(0, 0, group);
                    this._groups.splice(0, 0, group);
                    this._currentCopies += 1;
                }
                this.elem.reloadShapes();
                hasReloaded = true;
            }
            cont = 0;
            var renderFlag;
            for(i = 0; i <= this._groups.length - 1; i += 1){
                renderFlag = cont < copies;
                this._groups[i]._render = renderFlag;
                this.changeGroupRender(this._groups[i].it, renderFlag);
                if (!renderFlag) {
                    var elems = this.elemsData[i].it;
                    var transformData = elems[elems.length - 1];
                    if (transformData.transform.op.v !== 0) {
                        transformData.transform.op._mdf = true;
                        transformData.transform.op.v = 0;
                    } else transformData.transform.op._mdf = false;
                }
                cont += 1;
            }
            this._currentCopies = copies;
            /// /
            var offset = this.o.v;
            var offsetModulo = offset % 1;
            var roundOffset = offset > 0 ? Math.floor(offset) : Math.ceil(offset);
            var pProps = this.pMatrix.props;
            var rProps = this.rMatrix.props;
            var sProps = this.sMatrix.props;
            this.pMatrix.reset();
            this.rMatrix.reset();
            this.sMatrix.reset();
            this.tMatrix.reset();
            this.matrix.reset();
            var iteration = 0;
            if (offset > 0) {
                while(iteration < roundOffset){
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
                    iteration += 1;
                }
                if (offsetModulo) {
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, offsetModulo, false);
                    iteration += offsetModulo;
                }
            } else if (offset < 0) {
                while(iteration > roundOffset){
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, true);
                    iteration -= 1;
                }
                if (offsetModulo) {
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -offsetModulo, true);
                    iteration -= offsetModulo;
                }
            }
            i = this.data.m === 1 ? 0 : this._currentCopies - 1;
            dir = this.data.m === 1 ? 1 : -1;
            cont = this._currentCopies;
            var j;
            var jLen;
            while(cont){
                items = this.elemsData[i].it;
                itemsTransform = items[items.length - 1].transform.mProps.v.props;
                jLen = itemsTransform.length;
                items[items.length - 1].transform.mProps._mdf = true;
                items[items.length - 1].transform.op._mdf = true;
                items[items.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1));
                if (iteration !== 0) {
                    if (i !== 0 && dir === 1 || i !== this._currentCopies - 1 && dir === -1) this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
                    this.matrix.transform(rProps[0], rProps[1], rProps[2], rProps[3], rProps[4], rProps[5], rProps[6], rProps[7], rProps[8], rProps[9], rProps[10], rProps[11], rProps[12], rProps[13], rProps[14], rProps[15]);
                    this.matrix.transform(sProps[0], sProps[1], sProps[2], sProps[3], sProps[4], sProps[5], sProps[6], sProps[7], sProps[8], sProps[9], sProps[10], sProps[11], sProps[12], sProps[13], sProps[14], sProps[15]);
                    this.matrix.transform(pProps[0], pProps[1], pProps[2], pProps[3], pProps[4], pProps[5], pProps[6], pProps[7], pProps[8], pProps[9], pProps[10], pProps[11], pProps[12], pProps[13], pProps[14], pProps[15]);
                    for(j = 0; j < jLen; j += 1)itemsTransform[j] = this.matrix.props[j];
                    this.matrix.reset();
                } else {
                    this.matrix.reset();
                    for(j = 0; j < jLen; j += 1)itemsTransform[j] = this.matrix.props[j];
                }
                iteration += 1;
                cont -= 1;
                i += dir;
            }
        } else {
            cont = this._currentCopies;
            i = 0;
            dir = 1;
            while(cont){
                items = this.elemsData[i].it;
                itemsTransform = items[items.length - 1].transform.mProps.v.props;
                items[items.length - 1].transform.mProps._mdf = false;
                items[items.length - 1].transform.op._mdf = false;
                cont -= 1;
                i += dir;
            }
        }
        return hasReloaded;
    };
    RepeaterModifier.prototype.addShape = function() {};
    function RoundCornersModifier() {}
    extendPrototype([
        ShapeModifier
    ], RoundCornersModifier);
    RoundCornersModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.rd = PropertyFactory.getProp(elem, data.r, 0, null, this);
        this._isAnimated = !!this.rd.effectsSequence.length;
    };
    RoundCornersModifier.prototype.processPath = function(path, round) {
        var clonedPath = shapePool.newElement();
        clonedPath.c = path.c;
        var i;
        var len = path._length;
        var currentV;
        var currentI;
        var currentO;
        var closerV;
        var distance;
        var newPosPerc;
        var index = 0;
        var vX;
        var vY;
        var oX;
        var oY;
        var iX;
        var iY;
        for(i = 0; i < len; i += 1){
            currentV = path.v[i];
            currentO = path.o[i];
            currentI = path.i[i];
            if (currentV[0] === currentO[0] && currentV[1] === currentO[1] && currentV[0] === currentI[0] && currentV[1] === currentI[1]) {
                if ((i === 0 || i === len - 1) && !path.c) {
                    clonedPath.setTripleAt(currentV[0], currentV[1], currentO[0], currentO[1], currentI[0], currentI[1], index);
                    /* clonedPath.v[index] = currentV;
                  clonedPath.o[index] = currentO;
                  clonedPath.i[index] = currentI; */ index += 1;
                } else {
                    if (i === 0) closerV = path.v[len - 1];
                    else closerV = path.v[i - 1];
                    distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
                    newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
                    iX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
                    vX = iX;
                    iY = currentV[1] - (currentV[1] - closerV[1]) * newPosPerc;
                    vY = iY;
                    oX = vX - (vX - currentV[0]) * roundCorner;
                    oY = vY - (vY - currentV[1]) * roundCorner;
                    clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
                    index += 1;
                    if (i === len - 1) closerV = path.v[0];
                    else closerV = path.v[i + 1];
                    distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
                    newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
                    oX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
                    vX = oX;
                    oY = currentV[1] + (closerV[1] - currentV[1]) * newPosPerc;
                    vY = oY;
                    iX = vX - (vX - currentV[0]) * roundCorner;
                    iY = vY - (vY - currentV[1]) * roundCorner;
                    clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
                    index += 1;
                }
            } else {
                clonedPath.setTripleAt(path.v[i][0], path.v[i][1], path.o[i][0], path.o[i][1], path.i[i][0], path.i[i][1], index);
                index += 1;
            }
        }
        return clonedPath;
    };
    RoundCornersModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var rd = this.rd.v;
        if (rd !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], rd));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function floatEqual(a, b) {
        return Math.abs(a - b) * 100000 <= Math.min(Math.abs(a), Math.abs(b));
    }
    function floatZero(f) {
        return Math.abs(f) <= 0.00001;
    }
    function lerp(p0, p1, amount) {
        return p0 * (1 - amount) + p1 * amount;
    }
    function lerpPoint(p0, p1, amount) {
        return [
            lerp(p0[0], p1[0], amount),
            lerp(p0[1], p1[1], amount)
        ];
    }
    function quadRoots(a, b, c) {
        // no root
        if (a === 0) return [];
        var s = b * b - 4 * a * c;
        // Complex roots
        if (s < 0) return [];
        var singleRoot = -b / (2 * a);
        // 1 root
        if (s === 0) return [
            singleRoot
        ];
        var delta = Math.sqrt(s) / (2 * a);
        // 2 roots
        return [
            singleRoot - delta,
            singleRoot + delta
        ];
    }
    function polynomialCoefficients(p0, p1, p2, p3) {
        return [
            -p0 + 3 * p1 - 3 * p2 + p3,
            3 * p0 - 6 * p1 + 3 * p2,
            -3 * p0 + 3 * p1,
            p0
        ];
    }
    function singlePoint(p) {
        return new PolynomialBezier(p, p, p, p, false);
    }
    function PolynomialBezier(p0, p1, p2, p3, linearize) {
        if (linearize && pointEqual(p0, p1)) p1 = lerpPoint(p0, p3, 1 / 3);
        if (linearize && pointEqual(p2, p3)) p2 = lerpPoint(p0, p3, 2 / 3);
        var coeffx = polynomialCoefficients(p0[0], p1[0], p2[0], p3[0]);
        var coeffy = polynomialCoefficients(p0[1], p1[1], p2[1], p3[1]);
        this.a = [
            coeffx[0],
            coeffy[0]
        ];
        this.b = [
            coeffx[1],
            coeffy[1]
        ];
        this.c = [
            coeffx[2],
            coeffy[2]
        ];
        this.d = [
            coeffx[3],
            coeffy[3]
        ];
        this.points = [
            p0,
            p1,
            p2,
            p3
        ];
    }
    PolynomialBezier.prototype.point = function(t) {
        return [
            ((this.a[0] * t + this.b[0]) * t + this.c[0]) * t + this.d[0],
            ((this.a[1] * t + this.b[1]) * t + this.c[1]) * t + this.d[1]
        ];
    };
    PolynomialBezier.prototype.derivative = function(t) {
        return [
            (3 * t * this.a[0] + 2 * this.b[0]) * t + this.c[0],
            (3 * t * this.a[1] + 2 * this.b[1]) * t + this.c[1]
        ];
    };
    PolynomialBezier.prototype.tangentAngle = function(t) {
        var p = this.derivative(t);
        return Math.atan2(p[1], p[0]);
    };
    PolynomialBezier.prototype.normalAngle = function(t) {
        var p = this.derivative(t);
        return Math.atan2(p[0], p[1]);
    };
    PolynomialBezier.prototype.inflectionPoints = function() {
        var denom = this.a[1] * this.b[0] - this.a[0] * this.b[1];
        if (floatZero(denom)) return [];
        var tcusp = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / denom;
        var square = tcusp * tcusp - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / denom;
        if (square < 0) return [];
        var root = Math.sqrt(square);
        if (floatZero(root)) {
            if (root > 0 && root < 1) return [
                tcusp
            ];
            return [];
        }
        return [
            tcusp - root,
            tcusp + root
        ].filter(function(r) {
            return r > 0 && r < 1;
        });
    };
    PolynomialBezier.prototype.split = function(t) {
        if (t <= 0) return [
            singlePoint(this.points[0]),
            this
        ];
        if (t >= 1) return [
            this,
            singlePoint(this.points[this.points.length - 1])
        ];
        var p10 = lerpPoint(this.points[0], this.points[1], t);
        var p11 = lerpPoint(this.points[1], this.points[2], t);
        var p12 = lerpPoint(this.points[2], this.points[3], t);
        var p20 = lerpPoint(p10, p11, t);
        var p21 = lerpPoint(p11, p12, t);
        var p3 = lerpPoint(p20, p21, t);
        return [
            new PolynomialBezier(this.points[0], p10, p20, p3, true),
            new PolynomialBezier(p3, p21, p12, this.points[3], true)
        ];
    };
    function extrema(bez, comp) {
        var min = bez.points[0][comp];
        var max = bez.points[bez.points.length - 1][comp];
        if (min > max) {
            var e = max;
            max = min;
            min = e;
        }
        // Derivative roots to find min/max
        var f = quadRoots(3 * bez.a[comp], 2 * bez.b[comp], bez.c[comp]);
        for(var i = 0; i < f.length; i += 1)if (f[i] > 0 && f[i] < 1) {
            var val = bez.point(f[i])[comp];
            if (val < min) min = val;
            else if (val > max) max = val;
        }
        return {
            min: min,
            max: max
        };
    }
    PolynomialBezier.prototype.bounds = function() {
        return {
            x: extrema(this, 0),
            y: extrema(this, 1)
        };
    };
    PolynomialBezier.prototype.boundingBox = function() {
        var bounds = this.bounds();
        return {
            left: bounds.x.min,
            right: bounds.x.max,
            top: bounds.y.min,
            bottom: bounds.y.max,
            width: bounds.x.max - bounds.x.min,
            height: bounds.y.max - bounds.y.min,
            cx: (bounds.x.max + bounds.x.min) / 2,
            cy: (bounds.y.max + bounds.y.min) / 2
        };
    };
    function intersectData(bez, t1, t2) {
        var box = bez.boundingBox();
        return {
            cx: box.cx,
            cy: box.cy,
            width: box.width,
            height: box.height,
            bez: bez,
            t: (t1 + t2) / 2,
            t1: t1,
            t2: t2
        };
    }
    function splitData(data) {
        var split = data.bez.split(0.5);
        return [
            intersectData(split[0], data.t1, data.t),
            intersectData(split[1], data.t, data.t2)
        ];
    }
    function boxIntersect(b1, b2) {
        return Math.abs(b1.cx - b2.cx) * 2 < b1.width + b2.width && Math.abs(b1.cy - b2.cy) * 2 < b1.height + b2.height;
    }
    function intersectsImpl(d1, d2, depth, tolerance, intersections, maxRecursion) {
        if (!boxIntersect(d1, d2)) return;
        if (depth >= maxRecursion || d1.width <= tolerance && d1.height <= tolerance && d2.width <= tolerance && d2.height <= tolerance) {
            intersections.push([
                d1.t,
                d2.t
            ]);
            return;
        }
        var d1s = splitData(d1);
        var d2s = splitData(d2);
        intersectsImpl(d1s[0], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
        intersectsImpl(d1s[0], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
        intersectsImpl(d1s[1], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
        intersectsImpl(d1s[1], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
    }
    PolynomialBezier.prototype.intersections = function(other, tolerance, maxRecursion) {
        if (tolerance === undefined) tolerance = 2;
        if (maxRecursion === undefined) maxRecursion = 7;
        var intersections = [];
        intersectsImpl(intersectData(this, 0, 1), intersectData(other, 0, 1), 0, tolerance, intersections, maxRecursion);
        return intersections;
    };
    PolynomialBezier.shapeSegment = function(shapePath, index) {
        var nextIndex = (index + 1) % shapePath.length();
        return new PolynomialBezier(shapePath.v[index], shapePath.o[index], shapePath.i[nextIndex], shapePath.v[nextIndex], true);
    };
    PolynomialBezier.shapeSegmentInverted = function(shapePath, index) {
        var nextIndex = (index + 1) % shapePath.length();
        return new PolynomialBezier(shapePath.v[nextIndex], shapePath.i[nextIndex], shapePath.o[index], shapePath.v[index], true);
    };
    function crossProduct(a, b) {
        return [
            a[1] * b[2] - a[2] * b[1],
            a[2] * b[0] - a[0] * b[2],
            a[0] * b[1] - a[1] * b[0]
        ];
    }
    function lineIntersection(start1, end1, start2, end2) {
        var v1 = [
            start1[0],
            start1[1],
            1
        ];
        var v2 = [
            end1[0],
            end1[1],
            1
        ];
        var v3 = [
            start2[0],
            start2[1],
            1
        ];
        var v4 = [
            end2[0],
            end2[1],
            1
        ];
        var r = crossProduct(crossProduct(v1, v2), crossProduct(v3, v4));
        if (floatZero(r[2])) return null;
        return [
            r[0] / r[2],
            r[1] / r[2]
        ];
    }
    function polarOffset(p, angle, length) {
        return [
            p[0] + Math.cos(angle) * length,
            p[1] - Math.sin(angle) * length
        ];
    }
    function pointDistance(p1, p2) {
        return Math.hypot(p1[0] - p2[0], p1[1] - p2[1]);
    }
    function pointEqual(p1, p2) {
        return floatEqual(p1[0], p2[0]) && floatEqual(p1[1], p2[1]);
    }
    function ZigZagModifier() {}
    extendPrototype([
        ShapeModifier
    ], ZigZagModifier);
    ZigZagModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.amplitude = PropertyFactory.getProp(elem, data.s, 0, null, this);
        this.frequency = PropertyFactory.getProp(elem, data.r, 0, null, this);
        this.pointsType = PropertyFactory.getProp(elem, data.pt, 0, null, this);
        this._isAnimated = this.amplitude.effectsSequence.length !== 0 || this.frequency.effectsSequence.length !== 0 || this.pointsType.effectsSequence.length !== 0;
    };
    function setPoint(outputBezier, point, angle, direction, amplitude, outAmplitude, inAmplitude) {
        var angO = angle - Math.PI / 2;
        var angI = angle + Math.PI / 2;
        var px = point[0] + Math.cos(angle) * direction * amplitude;
        var py = point[1] - Math.sin(angle) * direction * amplitude;
        outputBezier.setTripleAt(px, py, px + Math.cos(angO) * outAmplitude, py - Math.sin(angO) * outAmplitude, px + Math.cos(angI) * inAmplitude, py - Math.sin(angI) * inAmplitude, outputBezier.length());
    }
    function getPerpendicularVector(pt1, pt2) {
        var vector = [
            pt2[0] - pt1[0],
            pt2[1] - pt1[1]
        ];
        var rot = -Math.PI * 0.5;
        var rotatedVector = [
            Math.cos(rot) * vector[0] - Math.sin(rot) * vector[1],
            Math.sin(rot) * vector[0] + Math.cos(rot) * vector[1]
        ];
        return rotatedVector;
    }
    function getProjectingAngle(path, cur) {
        var prevIndex = cur === 0 ? path.length() - 1 : cur - 1;
        var nextIndex = (cur + 1) % path.length();
        var prevPoint = path.v[prevIndex];
        var nextPoint = path.v[nextIndex];
        var pVector = getPerpendicularVector(prevPoint, nextPoint);
        return Math.atan2(0, 1) - Math.atan2(pVector[1], pVector[0]);
    }
    function zigZagCorner(outputBezier, path, cur, amplitude, frequency, pointType, direction) {
        var angle = getProjectingAngle(path, cur);
        var point = path.v[cur % path._length];
        var prevPoint = path.v[cur === 0 ? path._length - 1 : cur - 1];
        var nextPoint = path.v[(cur + 1) % path._length];
        var prevDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - prevPoint[0], 2) + Math.pow(point[1] - prevPoint[1], 2)) : 0;
        var nextDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - nextPoint[0], 2) + Math.pow(point[1] - nextPoint[1], 2)) : 0;
        setPoint(outputBezier, path.v[cur % path._length], angle, direction, amplitude, nextDist / ((frequency + 1) * 2), prevDist / ((frequency + 1) * 2), pointType);
    }
    function zigZagSegment(outputBezier, segment, amplitude, frequency, pointType, direction) {
        for(var i = 0; i < frequency; i += 1){
            var t = (i + 1) / (frequency + 1);
            var dist = pointType === 2 ? Math.sqrt(Math.pow(segment.points[3][0] - segment.points[0][0], 2) + Math.pow(segment.points[3][1] - segment.points[0][1], 2)) : 0;
            var angle = segment.normalAngle(t);
            var point = segment.point(t);
            setPoint(outputBezier, point, angle, direction, amplitude, dist / ((frequency + 1) * 2), dist / ((frequency + 1) * 2), pointType);
            direction = -direction;
        }
        return direction;
    }
    ZigZagModifier.prototype.processPath = function(path, amplitude, frequency, pointType) {
        var count = path._length;
        var clonedPath = shapePool.newElement();
        clonedPath.c = path.c;
        if (!path.c) count -= 1;
        if (count === 0) return clonedPath;
        var direction = -1;
        var segment = PolynomialBezier.shapeSegment(path, 0);
        zigZagCorner(clonedPath, path, 0, amplitude, frequency, pointType, direction);
        for(var i = 0; i < count; i += 1){
            direction = zigZagSegment(clonedPath, segment, amplitude, frequency, pointType, -direction);
            if (i === count - 1 && !path.c) segment = null;
            else segment = PolynomialBezier.shapeSegment(path, (i + 1) % count);
            zigZagCorner(clonedPath, path, i + 1, amplitude, frequency, pointType, direction);
        }
        return clonedPath;
    };
    ZigZagModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var amplitude = this.amplitude.v;
        var frequency = Math.max(0, Math.round(this.frequency.v));
        var pointType = this.pointsType.v;
        if (amplitude !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], amplitude, frequency, pointType));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function linearOffset(p1, p2, amount) {
        var angle = Math.atan2(p2[0] - p1[0], p2[1] - p1[1]);
        return [
            polarOffset(p1, angle, amount),
            polarOffset(p2, angle, amount)
        ];
    }
    function offsetSegment(segment, amount) {
        var p0;
        var p1a;
        var p1b;
        var p2b;
        var p2a;
        var p3;
        var e;
        e = linearOffset(segment.points[0], segment.points[1], amount);
        p0 = e[0];
        p1a = e[1];
        e = linearOffset(segment.points[1], segment.points[2], amount);
        p1b = e[0];
        p2b = e[1];
        e = linearOffset(segment.points[2], segment.points[3], amount);
        p2a = e[0];
        p3 = e[1];
        var p1 = lineIntersection(p0, p1a, p1b, p2b);
        if (p1 === null) p1 = p1a;
        var p2 = lineIntersection(p2a, p3, p1b, p2b);
        if (p2 === null) p2 = p2a;
        return new PolynomialBezier(p0, p1, p2, p3);
    }
    function joinLines(outputBezier, seg1, seg2, lineJoin, miterLimit) {
        var p0 = seg1.points[3];
        var p1 = seg2.points[0];
        // Bevel
        if (lineJoin === 3) return p0;
        // Connected, they don't need a joint
        if (pointEqual(p0, p1)) return p0;
        // Round
        if (lineJoin === 2) {
            var angleOut = -seg1.tangentAngle(1);
            var angleIn = -seg2.tangentAngle(0) + Math.PI;
            var center = lineIntersection(p0, polarOffset(p0, angleOut + Math.PI / 2, 100), p1, polarOffset(p1, angleOut + Math.PI / 2, 100));
            var radius = center ? pointDistance(center, p0) : pointDistance(p0, p1) / 2;
            var tan = polarOffset(p0, angleOut, 2 * radius * roundCorner);
            outputBezier.setXYAt(tan[0], tan[1], 'o', outputBezier.length() - 1);
            tan = polarOffset(p1, angleIn, 2 * radius * roundCorner);
            outputBezier.setTripleAt(p1[0], p1[1], p1[0], p1[1], tan[0], tan[1], outputBezier.length());
            return p1;
        }
        // Miter
        var t0 = pointEqual(p0, seg1.points[2]) ? seg1.points[0] : seg1.points[2];
        var t1 = pointEqual(p1, seg2.points[1]) ? seg2.points[3] : seg2.points[1];
        var intersection = lineIntersection(t0, p0, p1, t1);
        if (intersection && pointDistance(intersection, p0) < miterLimit) {
            outputBezier.setTripleAt(intersection[0], intersection[1], intersection[0], intersection[1], intersection[0], intersection[1], outputBezier.length());
            return intersection;
        }
        return p0;
    }
    function getIntersection(a, b) {
        var intersect = a.intersections(b);
        if (intersect.length && floatEqual(intersect[0][0], 1)) intersect.shift();
        if (intersect.length) return intersect[0];
        return null;
    }
    function pruneSegmentIntersection(a, b) {
        var outa = a.slice();
        var outb = b.slice();
        var intersect = getIntersection(a[a.length - 1], b[0]);
        if (intersect) {
            outa[a.length - 1] = a[a.length - 1].split(intersect[0])[0];
            outb[0] = b[0].split(intersect[1])[1];
        }
        if (a.length > 1 && b.length > 1) {
            intersect = getIntersection(a[0], b[b.length - 1]);
            if (intersect) return [
                [
                    a[0].split(intersect[0])[0]
                ],
                [
                    b[b.length - 1].split(intersect[1])[1]
                ]
            ];
        }
        return [
            outa,
            outb
        ];
    }
    function pruneIntersections(segments) {
        var e;
        for(var i = 1; i < segments.length; i += 1){
            e = pruneSegmentIntersection(segments[i - 1], segments[i]);
            segments[i - 1] = e[0];
            segments[i] = e[1];
        }
        if (segments.length > 1) {
            e = pruneSegmentIntersection(segments[segments.length - 1], segments[0]);
            segments[segments.length - 1] = e[0];
            segments[0] = e[1];
        }
        return segments;
    }
    function offsetSegmentSplit(segment, amount) {
        /*
      We split each bezier segment into smaller pieces based
      on inflection points, this ensures the control point
      polygon is convex.
       (A cubic bezier can have none, one, or two inflection points)
    */ var flex = segment.inflectionPoints();
        var left;
        var right;
        var split;
        var mid;
        if (flex.length === 0) return [
            offsetSegment(segment, amount)
        ];
        if (flex.length === 1 || floatEqual(flex[1], 1)) {
            split = segment.split(flex[0]);
            left = split[0];
            right = split[1];
            return [
                offsetSegment(left, amount),
                offsetSegment(right, amount)
            ];
        }
        split = segment.split(flex[0]);
        left = split[0];
        var t = (flex[1] - flex[0]) / (1 - flex[0]);
        split = split[1].split(t);
        mid = split[0];
        right = split[1];
        return [
            offsetSegment(left, amount),
            offsetSegment(mid, amount),
            offsetSegment(right, amount)
        ];
    }
    function OffsetPathModifier() {}
    extendPrototype([
        ShapeModifier
    ], OffsetPathModifier);
    OffsetPathModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
        this.miterLimit = PropertyFactory.getProp(elem, data.ml, 0, null, this);
        this.lineJoin = data.lj;
        this._isAnimated = this.amount.effectsSequence.length !== 0;
    };
    OffsetPathModifier.prototype.processPath = function(inputBezier, amount, lineJoin, miterLimit) {
        var outputBezier = shapePool.newElement();
        outputBezier.c = inputBezier.c;
        var count = inputBezier.length();
        if (!inputBezier.c) count -= 1;
        var i;
        var j;
        var segment;
        var multiSegments = [];
        for(i = 0; i < count; i += 1){
            segment = PolynomialBezier.shapeSegment(inputBezier, i);
            multiSegments.push(offsetSegmentSplit(segment, amount));
        }
        if (!inputBezier.c) for(i = count - 1; i >= 0; i -= 1){
            segment = PolynomialBezier.shapeSegmentInverted(inputBezier, i);
            multiSegments.push(offsetSegmentSplit(segment, amount));
        }
        multiSegments = pruneIntersections(multiSegments);
        // Add bezier segments to the output and apply line joints
        var lastPoint = null;
        var lastSeg = null;
        for(i = 0; i < multiSegments.length; i += 1){
            var multiSegment = multiSegments[i];
            if (lastSeg) lastPoint = joinLines(outputBezier, lastSeg, multiSegment[0], lineJoin, miterLimit);
            lastSeg = multiSegment[multiSegment.length - 1];
            for(j = 0; j < multiSegment.length; j += 1){
                segment = multiSegment[j];
                if (lastPoint && pointEqual(segment.points[0], lastPoint)) outputBezier.setXYAt(segment.points[1][0], segment.points[1][1], 'o', outputBezier.length() - 1);
                else outputBezier.setTripleAt(segment.points[0][0], segment.points[0][1], segment.points[1][0], segment.points[1][1], segment.points[0][0], segment.points[0][1], outputBezier.length());
                outputBezier.setTripleAt(segment.points[3][0], segment.points[3][1], segment.points[3][0], segment.points[3][1], segment.points[2][0], segment.points[2][1], outputBezier.length());
                lastPoint = segment.points[3];
            }
        }
        if (multiSegments.length) joinLines(outputBezier, lastSeg, multiSegments[0][0], lineJoin, miterLimit);
        return outputBezier;
    };
    OffsetPathModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var amount = this.amount.v;
        var miterLimit = this.miterLimit.v;
        var lineJoin = this.lineJoin;
        if (amount !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], amount, lineJoin, miterLimit));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function getFontProperties(fontData) {
        var styles = fontData.fStyle ? fontData.fStyle.split(' ') : [];
        var fWeight = 'normal';
        var fStyle = 'normal';
        var len = styles.length;
        var styleName;
        for(var i = 0; i < len; i += 1){
            styleName = styles[i].toLowerCase();
            switch(styleName){
                case 'italic':
                    fStyle = 'italic';
                    break;
                case 'bold':
                    fWeight = '700';
                    break;
                case 'black':
                    fWeight = '900';
                    break;
                case 'medium':
                    fWeight = '500';
                    break;
                case 'regular':
                case 'normal':
                    fWeight = '400';
                    break;
                case 'light':
                case 'thin':
                    fWeight = '200';
                    break;
                default:
                    break;
            }
        }
        return {
            style: fStyle,
            weight: fontData.fWeight || fWeight
        };
    }
    var FontManager = function() {
        var maxWaitingTime = 5000;
        var emptyChar = {
            w: 0,
            size: 0,
            shapes: [],
            data: {
                shapes: []
            }
        };
        var combinedCharacters = [];
        // Hindi characters
        combinedCharacters = combinedCharacters.concat([
            2304,
            2305,
            2306,
            2307,
            2362,
            2363,
            2364,
            2364,
            2366,
            2367,
            2368,
            2369,
            2370,
            2371,
            2372,
            2373,
            2374,
            2375,
            2376,
            2377,
            2378,
            2379,
            2380,
            2381,
            2382,
            2383,
            2387,
            2388,
            2389,
            2390,
            2391,
            2402,
            2403
        ]);
        var BLACK_FLAG_CODE_POINT = 127988;
        var CANCEL_TAG_CODE_POINT = 917631;
        var A_TAG_CODE_POINT = 917601;
        var Z_TAG_CODE_POINT = 917626;
        var VARIATION_SELECTOR_16_CODE_POINT = 65039;
        var ZERO_WIDTH_JOINER_CODE_POINT = 8205;
        var REGIONAL_CHARACTER_A_CODE_POINT = 127462;
        var REGIONAL_CHARACTER_Z_CODE_POINT = 127487;
        var surrogateModifiers = [
            'd83cdffb',
            'd83cdffc',
            'd83cdffd',
            'd83cdffe',
            'd83cdfff'
        ];
        function trimFontOptions(font) {
            var familyArray = font.split(',');
            var i;
            var len = familyArray.length;
            var enabledFamilies = [];
            for(i = 0; i < len; i += 1)if (familyArray[i] !== 'sans-serif' && familyArray[i] !== 'monospace') enabledFamilies.push(familyArray[i]);
            return enabledFamilies.join(',');
        }
        function setUpNode(font, family) {
            var parentNode = createTag('span');
            // Node is invisible to screen readers.
            parentNode.setAttribute('aria-hidden', true);
            parentNode.style.fontFamily = family;
            var node = createTag('span');
            // Characters that vary significantly among different fonts
            node.innerText = 'giItT1WQy@!-/#';
            // Visible - so we can measure it - but not on the screen
            parentNode.style.position = 'absolute';
            parentNode.style.left = '-10000px';
            parentNode.style.top = '-10000px';
            // Large font size makes even subtle changes obvious
            parentNode.style.fontSize = '300px';
            // Reset any font properties
            parentNode.style.fontVariant = 'normal';
            parentNode.style.fontStyle = 'normal';
            parentNode.style.fontWeight = 'normal';
            parentNode.style.letterSpacing = '0';
            parentNode.appendChild(node);
            document.body.appendChild(parentNode);
            // Remember width with no applied web font
            var width = node.offsetWidth;
            node.style.fontFamily = trimFontOptions(font) + ', ' + family;
            return {
                node: node,
                w: width,
                parent: parentNode
            };
        }
        function checkLoadedFonts() {
            var i;
            var len = this.fonts.length;
            var node;
            var w;
            var loadedCount = len;
            for(i = 0; i < len; i += 1){
                if (this.fonts[i].loaded) loadedCount -= 1;
                else if (this.fonts[i].fOrigin === 'n' || this.fonts[i].origin === 0) this.fonts[i].loaded = true;
                else {
                    node = this.fonts[i].monoCase.node;
                    w = this.fonts[i].monoCase.w;
                    if (node.offsetWidth !== w) {
                        loadedCount -= 1;
                        this.fonts[i].loaded = true;
                    } else {
                        node = this.fonts[i].sansCase.node;
                        w = this.fonts[i].sansCase.w;
                        if (node.offsetWidth !== w) {
                            loadedCount -= 1;
                            this.fonts[i].loaded = true;
                        }
                    }
                    if (this.fonts[i].loaded) {
                        this.fonts[i].sansCase.parent.parentNode.removeChild(this.fonts[i].sansCase.parent);
                        this.fonts[i].monoCase.parent.parentNode.removeChild(this.fonts[i].monoCase.parent);
                    }
                }
            }
            if (loadedCount !== 0 && Date.now() - this.initTime < maxWaitingTime) setTimeout(this.checkLoadedFontsBinded, 20);
            else setTimeout(this.setIsLoadedBinded, 10);
        }
        function createHelper(fontData, def) {
            var engine = document.body && def ? 'svg' : 'canvas';
            var helper;
            var fontProps = getFontProperties(fontData);
            if (engine === 'svg') {
                var tHelper = createNS('text');
                tHelper.style.fontSize = '100px';
                // tHelper.style.fontFamily = fontData.fFamily;
                tHelper.setAttribute('font-family', fontData.fFamily);
                tHelper.setAttribute('font-style', fontProps.style);
                tHelper.setAttribute('font-weight', fontProps.weight);
                tHelper.textContent = '1';
                if (fontData.fClass) {
                    tHelper.style.fontFamily = 'inherit';
                    tHelper.setAttribute('class', fontData.fClass);
                } else tHelper.style.fontFamily = fontData.fFamily;
                def.appendChild(tHelper);
                helper = tHelper;
            } else {
                var tCanvasHelper = new OffscreenCanvas(500, 500).getContext('2d');
                tCanvasHelper.font = fontProps.style + ' ' + fontProps.weight + ' 100px ' + fontData.fFamily;
                helper = tCanvasHelper;
            }
            function measure(text) {
                if (engine === 'svg') {
                    helper.textContent = text;
                    return helper.getComputedTextLength();
                }
                return helper.measureText(text).width;
            }
            return {
                measureText: measure
            };
        }
        function addFonts(fontData, defs) {
            if (!fontData) {
                this.isLoaded = true;
                return;
            }
            if (this.chars) {
                this.isLoaded = true;
                this.fonts = fontData.list;
                return;
            }
            if (!document.body) {
                this.isLoaded = true;
                fontData.list.forEach(function(data) {
                    data.helper = createHelper(data);
                    data.cache = {};
                });
                this.fonts = fontData.list;
                return;
            }
            var fontArr = fontData.list;
            var i;
            var len = fontArr.length;
            var _pendingFonts = len;
            for(i = 0; i < len; i += 1){
                var shouldLoadFont = true;
                var loadedSelector;
                var j;
                fontArr[i].loaded = false;
                fontArr[i].monoCase = setUpNode(fontArr[i].fFamily, 'monospace');
                fontArr[i].sansCase = setUpNode(fontArr[i].fFamily, 'sans-serif');
                if (!fontArr[i].fPath) {
                    fontArr[i].loaded = true;
                    _pendingFonts -= 1;
                } else if (fontArr[i].fOrigin === 'p' || fontArr[i].origin === 3) {
                    loadedSelector = document.querySelectorAll('style[f-forigin="p"][f-family="' + fontArr[i].fFamily + '"], style[f-origin="3"][f-family="' + fontArr[i].fFamily + '"]');
                    if (loadedSelector.length > 0) shouldLoadFont = false;
                    if (shouldLoadFont) {
                        var s = createTag('style');
                        s.setAttribute('f-forigin', fontArr[i].fOrigin);
                        s.setAttribute('f-origin', fontArr[i].origin);
                        s.setAttribute('f-family', fontArr[i].fFamily);
                        s.type = 'text/css';
                        s.innerText = '@font-face {font-family: ' + fontArr[i].fFamily + "; font-style: normal; src: url('" + fontArr[i].fPath + "');}";
                        defs.appendChild(s);
                    }
                } else if (fontArr[i].fOrigin === 'g' || fontArr[i].origin === 1) {
                    loadedSelector = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]');
                    for(j = 0; j < loadedSelector.length; j += 1)if (loadedSelector[j].href.indexOf(fontArr[i].fPath) !== -1) // Font is already loaded
                    shouldLoadFont = false;
                    if (shouldLoadFont) {
                        var l = createTag('link');
                        l.setAttribute('f-forigin', fontArr[i].fOrigin);
                        l.setAttribute('f-origin', fontArr[i].origin);
                        l.type = 'text/css';
                        l.rel = 'stylesheet';
                        l.href = fontArr[i].fPath;
                        document.body.appendChild(l);
                    }
                } else if (fontArr[i].fOrigin === 't' || fontArr[i].origin === 2) {
                    loadedSelector = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]');
                    for(j = 0; j < loadedSelector.length; j += 1)if (fontArr[i].fPath === loadedSelector[j].src) // Font is already loaded
                    shouldLoadFont = false;
                    if (shouldLoadFont) {
                        var sc = createTag('link');
                        sc.setAttribute('f-forigin', fontArr[i].fOrigin);
                        sc.setAttribute('f-origin', fontArr[i].origin);
                        sc.setAttribute('rel', 'stylesheet');
                        sc.setAttribute('href', fontArr[i].fPath);
                        defs.appendChild(sc);
                    }
                }
                fontArr[i].helper = createHelper(fontArr[i], defs);
                fontArr[i].cache = {};
                this.fonts.push(fontArr[i]);
            }
            if (_pendingFonts === 0) this.isLoaded = true;
            else // On some cases even if the font is loaded, it won't load correctly when measuring text on canvas.
            // Adding this timeout seems to fix it
            setTimeout(this.checkLoadedFonts.bind(this), 100);
        }
        function addChars(chars) {
            if (!chars) return;
            if (!this.chars) this.chars = [];
            var i;
            var len = chars.length;
            var j;
            var jLen = this.chars.length;
            var found;
            for(i = 0; i < len; i += 1){
                j = 0;
                found = false;
                while(j < jLen){
                    if (this.chars[j].style === chars[i].style && this.chars[j].fFamily === chars[i].fFamily && this.chars[j].ch === chars[i].ch) found = true;
                    j += 1;
                }
                if (!found) {
                    this.chars.push(chars[i]);
                    jLen += 1;
                }
            }
        }
        function getCharData(_char, style, font) {
            var i = 0;
            var len = this.chars.length;
            while(i < len){
                if (this.chars[i].ch === _char && this.chars[i].style === style && this.chars[i].fFamily === font) return this.chars[i];
                i += 1;
            }
            if ((typeof _char === 'string' && _char.charCodeAt(0) !== 13 || !_char) && console && console.warn // eslint-disable-line no-console
             && !this._warned) {
                this._warned = true;
                console.warn('Missing character from exported characters list: ', _char, style, font); // eslint-disable-line no-console
            }
            return emptyChar;
        }
        function measureText(_char2, fontName, size) {
            var fontData = this.getFontByName(fontName);
            // Using the char instead of char.charCodeAt(0)
            // to avoid collisions between equal chars
            var index = _char2;
            if (!fontData.cache[index]) {
                var tHelper = fontData.helper;
                if (_char2 === ' ') {
                    var doubleSize = tHelper.measureText('|' + _char2 + '|');
                    var singleSize = tHelper.measureText('||');
                    fontData.cache[index] = (doubleSize - singleSize) / 100;
                } else fontData.cache[index] = tHelper.measureText(_char2) / 100;
            }
            return fontData.cache[index] * size;
        }
        function getFontByName(name) {
            var i = 0;
            var len = this.fonts.length;
            while(i < len){
                if (this.fonts[i].fName === name) return this.fonts[i];
                i += 1;
            }
            return this.fonts[0];
        }
        function getCodePoint(string) {
            var codePoint = 0;
            var first = string.charCodeAt(0);
            if (first >= 0xD800 && first <= 0xDBFF) {
                var second = string.charCodeAt(1);
                if (second >= 0xDC00 && second <= 0xDFFF) codePoint = (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
            }
            return codePoint;
        }
        // Skin tone modifiers
        function isModifier(firstCharCode, secondCharCode) {
            var sum = firstCharCode.toString(16) + secondCharCode.toString(16);
            return surrogateModifiers.indexOf(sum) !== -1;
        }
        function isZeroWidthJoiner(charCode) {
            return charCode === ZERO_WIDTH_JOINER_CODE_POINT;
        }
        // This codepoint may change the appearance of the preceding character.
        // If that is a symbol, dingbat or emoji, U+FE0F forces it to be rendered
        // as a colorful image as compared to a monochrome text variant.
        function isVariationSelector(charCode) {
            return charCode === VARIATION_SELECTOR_16_CODE_POINT;
        }
        // The regional indicator symbols are a set of 26 alphabetic Unicode
        /// characters (A–Z) intended to be used to encode ISO 3166-1 alpha-2
        // two-letter country codes in a way that allows optional special treatment.
        function isRegionalCode(string) {
            var codePoint = getCodePoint(string);
            if (codePoint >= REGIONAL_CHARACTER_A_CODE_POINT && codePoint <= REGIONAL_CHARACTER_Z_CODE_POINT) return true;
            return false;
        }
        // Some Emoji implementations represent combinations of
        // two “regional indicator” letters as a single flag symbol.
        function isFlagEmoji(string) {
            return isRegionalCode(string.substr(0, 2)) && isRegionalCode(string.substr(2, 2));
        }
        function isCombinedCharacter(_char3) {
            return combinedCharacters.indexOf(_char3) !== -1;
        }
        // Regional flags start with a BLACK_FLAG_CODE_POINT
        // folowed by 5 chars in the TAG range
        // and end with a CANCEL_TAG_CODE_POINT
        function isRegionalFlag(text, index) {
            var codePoint = getCodePoint(text.substr(index, 2));
            if (codePoint !== BLACK_FLAG_CODE_POINT) return false;
            var count = 0;
            index += 2;
            while(count < 5){
                codePoint = getCodePoint(text.substr(index, 2));
                if (codePoint < A_TAG_CODE_POINT || codePoint > Z_TAG_CODE_POINT) return false;
                count += 1;
                index += 2;
            }
            return getCodePoint(text.substr(index, 2)) === CANCEL_TAG_CODE_POINT;
        }
        function setIsLoaded() {
            this.isLoaded = true;
        }
        var Font = function Font() {
            this.fonts = [];
            this.chars = null;
            this.typekitLoaded = 0;
            this.isLoaded = false;
            this._warned = false;
            this.initTime = Date.now();
            this.setIsLoadedBinded = this.setIsLoaded.bind(this);
            this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
        };
        Font.isModifier = isModifier;
        Font.isZeroWidthJoiner = isZeroWidthJoiner;
        Font.isFlagEmoji = isFlagEmoji;
        Font.isRegionalCode = isRegionalCode;
        Font.isCombinedCharacter = isCombinedCharacter;
        Font.isRegionalFlag = isRegionalFlag;
        Font.isVariationSelector = isVariationSelector;
        Font.BLACK_FLAG_CODE_POINT = BLACK_FLAG_CODE_POINT;
        var fontPrototype = {
            addChars: addChars,
            addFonts: addFonts,
            getCharData: getCharData,
            getFontByName: getFontByName,
            measureText: measureText,
            checkLoadedFonts: checkLoadedFonts,
            setIsLoaded: setIsLoaded
        };
        Font.prototype = fontPrototype;
        return Font;
    }();
    function SlotManager(animationData) {
        this.animationData = animationData;
    }
    SlotManager.prototype.getProp = function(data) {
        if (this.animationData.slots && this.animationData.slots[data.sid]) return Object.assign(data, this.animationData.slots[data.sid].p);
        return data;
    };
    function slotFactory(animationData) {
        return new SlotManager(animationData);
    }
    function RenderableElement() {}
    RenderableElement.prototype = {
        initRenderable: function initRenderable() {
            // layer's visibility related to inpoint and outpoint. Rename isVisible to isInRange
            this.isInRange = false;
            // layer's display state
            this.hidden = false;
            // If layer's transparency equals 0, it can be hidden
            this.isTransparent = false;
            // list of animated components
            this.renderableComponents = [];
        },
        addRenderableComponent: function addRenderableComponent(component) {
            if (this.renderableComponents.indexOf(component) === -1) this.renderableComponents.push(component);
        },
        removeRenderableComponent: function removeRenderableComponent(component) {
            if (this.renderableComponents.indexOf(component) !== -1) this.renderableComponents.splice(this.renderableComponents.indexOf(component), 1);
        },
        prepareRenderableFrame: function prepareRenderableFrame(num) {
            this.checkLayerLimits(num);
        },
        checkTransparency: function checkTransparency() {
            if (this.finalTransform.mProp.o.v <= 0) {
                if (!this.isTransparent && this.globalData.renderConfig.hideOnTransparent) {
                    this.isTransparent = true;
                    this.hide();
                }
            } else if (this.isTransparent) {
                this.isTransparent = false;
                this.show();
            }
        },
        /**
       * @function
       * Initializes frame related properties.
       *
       * @param {number} num
       * current frame number in Layer's time
       *
       */ checkLayerLimits: function checkLayerLimits(num) {
            if (this.data.ip - this.data.st <= num && this.data.op - this.data.st > num) {
                if (this.isInRange !== true) {
                    this.globalData._mdf = true;
                    this._mdf = true;
                    this.isInRange = true;
                    this.show();
                }
            } else if (this.isInRange !== false) {
                this.globalData._mdf = true;
                this.isInRange = false;
                this.hide();
            }
        },
        renderRenderable: function renderRenderable() {
            var i;
            var len = this.renderableComponents.length;
            for(i = 0; i < len; i += 1)this.renderableComponents[i].renderFrame(this._isFirstFrame);
        /* this.maskManager.renderFrame(this.finalTransform.mat);
          this.renderableEffectsManager.renderFrame(this._isFirstFrame); */ },
        sourceRectAtTime: function sourceRectAtTime() {
            return {
                top: 0,
                left: 0,
                width: 100,
                height: 100
            };
        },
        getLayerSize: function getLayerSize() {
            if (this.data.ty === 5) return {
                w: this.data.textData.width,
                h: this.data.textData.height
            };
            return {
                w: this.data.width,
                h: this.data.height
            };
        }
    };
    var getBlendMode = function() {
        var blendModeEnums = {
            0: 'source-over',
            1: 'multiply',
            2: 'screen',
            3: 'overlay',
            4: 'darken',
            5: 'lighten',
            6: 'color-dodge',
            7: 'color-burn',
            8: 'hard-light',
            9: 'soft-light',
            10: 'difference',
            11: 'exclusion',
            12: 'hue',
            13: 'saturation',
            14: 'color',
            15: 'luminosity'
        };
        return function(mode) {
            return blendModeEnums[mode] || '';
        };
    }();
    function SliderEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function AngleEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function ColorEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
    }
    function PointEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
    }
    function LayerIndexEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function MaskIndexEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function CheckboxEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function NoValueEffect() {
        this.p = {};
    }
    function EffectsManager(data, element) {
        var effects = data.ef || [];
        this.effectElements = [];
        var i;
        var len = effects.length;
        var effectItem;
        for(i = 0; i < len; i += 1){
            effectItem = new GroupEffect(effects[i], element);
            this.effectElements.push(effectItem);
        }
    }
    function GroupEffect(data, element) {
        this.init(data, element);
    }
    extendPrototype([
        DynamicPropertyContainer
    ], GroupEffect);
    GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties;
    GroupEffect.prototype.init = function(data, element) {
        this.data = data;
        this.effectElements = [];
        this.initDynamicPropertyContainer(element);
        var i;
        var len = this.data.ef.length;
        var eff;
        var effects = this.data.ef;
        for(i = 0; i < len; i += 1){
            eff = null;
            switch(effects[i].ty){
                case 0:
                    eff = new SliderEffect(effects[i], element, this);
                    break;
                case 1:
                    eff = new AngleEffect(effects[i], element, this);
                    break;
                case 2:
                    eff = new ColorEffect(effects[i], element, this);
                    break;
                case 3:
                    eff = new PointEffect(effects[i], element, this);
                    break;
                case 4:
                case 7:
                    eff = new CheckboxEffect(effects[i], element, this);
                    break;
                case 10:
                    eff = new LayerIndexEffect(effects[i], element, this);
                    break;
                case 11:
                    eff = new MaskIndexEffect(effects[i], element, this);
                    break;
                case 5:
                    eff = new EffectsManager(effects[i], element, this);
                    break;
                // case 6:
                default:
                    eff = new NoValueEffect(effects[i], element, this);
                    break;
            }
            if (eff) this.effectElements.push(eff);
        }
    };
    function BaseElement() {}
    BaseElement.prototype = {
        checkMasks: function checkMasks() {
            if (!this.data.hasMask) return false;
            var i = 0;
            var len = this.data.masksProperties.length;
            while(i < len){
                if (this.data.masksProperties[i].mode !== 'n' && this.data.masksProperties[i].cl !== false) return true;
                i += 1;
            }
            return false;
        },
        initExpressions: function initExpressions() {
            var expressionsInterfaces = getExpressionInterfaces();
            if (!expressionsInterfaces) return;
            var LayerExpressionInterface = expressionsInterfaces('layer');
            var EffectsExpressionInterface = expressionsInterfaces('effects');
            var ShapeExpressionInterface = expressionsInterfaces('shape');
            var TextExpressionInterface = expressionsInterfaces('text');
            var CompExpressionInterface = expressionsInterfaces('comp');
            this.layerInterface = LayerExpressionInterface(this);
            if (this.data.hasMask && this.maskManager) this.layerInterface.registerMaskInterface(this.maskManager);
            var effectsInterface = EffectsExpressionInterface.createEffectsInterface(this, this.layerInterface);
            this.layerInterface.registerEffectsInterface(effectsInterface);
            if (this.data.ty === 0 || this.data.xt) this.compInterface = CompExpressionInterface(this);
            else if (this.data.ty === 4) {
                this.layerInterface.shapeInterface = ShapeExpressionInterface(this.shapesData, this.itemsData, this.layerInterface);
                this.layerInterface.content = this.layerInterface.shapeInterface;
            } else if (this.data.ty === 5) {
                this.layerInterface.textInterface = TextExpressionInterface(this);
                this.layerInterface.text = this.layerInterface.textInterface;
            }
        },
        setBlendMode: function setBlendMode() {
            var blendModeValue = getBlendMode(this.data.bm);
            var elem = this.baseElement || this.layerElement;
            elem.style['mix-blend-mode'] = blendModeValue;
        },
        initBaseData: function initBaseData(data, globalData, comp) {
            this.globalData = globalData;
            this.comp = comp;
            this.data = data;
            this.layerId = createElementID();
            // Stretch factor for old animations missing this property.
            if (!this.data.sr) this.data.sr = 1;
            // effects manager
            this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
        },
        getType: function getType() {
            return this.type;
        },
        sourceRectAtTime: function sourceRectAtTime() {}
    };
    /**
   * @file
   * Handles element's layer frame update.
   * Checks layer in point and out point
   *
   */ function FrameElement() {}
    FrameElement.prototype = {
        /**
       * @function
       * Initializes frame related properties.
       *
       */ initFrame: function initFrame() {
            // set to true when inpoint is rendered
            this._isFirstFrame = false;
            // list of animated properties
            this.dynamicProperties = [];
            // If layer has been modified in current tick this will be true
            this._mdf = false;
        },
        /**
       * @function
       * Calculates all dynamic values
       *
       * @param {number} num
       * current frame number in Layer's time
       * @param {boolean} isVisible
       * if layers is currently in range
       *
       */ prepareProperties: function prepareProperties(num, isVisible) {
            var i;
            var len = this.dynamicProperties.length;
            for(i = 0; i < len; i += 1)if (isVisible || this._isParent && this.dynamicProperties[i].propType === 'transform') {
                this.dynamicProperties[i].getValue();
                if (this.dynamicProperties[i]._mdf) {
                    this.globalData._mdf = true;
                    this._mdf = true;
                }
            }
        },
        addDynamicProperty: function addDynamicProperty(prop) {
            if (this.dynamicProperties.indexOf(prop) === -1) this.dynamicProperties.push(prop);
        }
    };
    function FootageElement(data, globalData, comp) {
        this.initFrame();
        this.initRenderable();
        this.assetData = globalData.getAssetData(data.refId);
        this.footageData = globalData.imageLoader.getAsset(this.assetData);
        this.initBaseData(data, globalData, comp);
    }
    FootageElement.prototype.prepareFrame = function() {};
    extendPrototype([
        RenderableElement,
        BaseElement,
        FrameElement
    ], FootageElement);
    FootageElement.prototype.getBaseElement = function() {
        return null;
    };
    FootageElement.prototype.renderFrame = function() {};
    FootageElement.prototype.destroy = function() {};
    FootageElement.prototype.initExpressions = function() {
        var expressionsInterfaces = getExpressionInterfaces();
        if (!expressionsInterfaces) return;
        var FootageInterface = expressionsInterfaces('footage');
        this.layerInterface = FootageInterface(this);
    };
    FootageElement.prototype.getFootageData = function() {
        return this.footageData;
    };
    function AudioElement(data, globalData, comp) {
        this.initFrame();
        this.initRenderable();
        this.assetData = globalData.getAssetData(data.refId);
        this.initBaseData(data, globalData, comp);
        this._isPlaying = false;
        this._canPlay = false;
        var assetPath = this.globalData.getAssetsPath(this.assetData);
        this.audio = this.globalData.audioController.createAudio(assetPath);
        this._currentTime = 0;
        this.globalData.audioController.addAudio(this);
        this._volumeMultiplier = 1;
        this._volume = 1;
        this._previousVolume = null;
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
        this.lv = PropertyFactory.getProp(this, data.au && data.au.lv ? data.au.lv : {
            k: [
                100
            ]
        }, 1, 0.01, this);
    }
    AudioElement.prototype.prepareFrame = function(num) {
        this.prepareRenderableFrame(num, true);
        this.prepareProperties(num, true);
        if (!this.tm._placeholder) {
            var timeRemapped = this.tm.v;
            this._currentTime = timeRemapped;
        } else this._currentTime = num / this.data.sr;
        this._volume = this.lv.v[0];
        var totalVolume = this._volume * this._volumeMultiplier;
        if (this._previousVolume !== totalVolume) {
            this._previousVolume = totalVolume;
            this.audio.volume(totalVolume);
        }
    };
    extendPrototype([
        RenderableElement,
        BaseElement,
        FrameElement
    ], AudioElement);
    AudioElement.prototype.renderFrame = function() {
        if (this.isInRange && this._canPlay) {
            if (!this._isPlaying) {
                this.audio.play();
                this.audio.seek(this._currentTime / this.globalData.frameRate);
                this._isPlaying = true;
            } else if (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) this.audio.seek(this._currentTime / this.globalData.frameRate);
        }
    };
    AudioElement.prototype.show = function() {
    // this.audio.play()
    };
    AudioElement.prototype.hide = function() {
        this.audio.pause();
        this._isPlaying = false;
    };
    AudioElement.prototype.pause = function() {
        this.audio.pause();
        this._isPlaying = false;
        this._canPlay = false;
    };
    AudioElement.prototype.resume = function() {
        this._canPlay = true;
    };
    AudioElement.prototype.setRate = function(rateValue) {
        this.audio.rate(rateValue);
    };
    AudioElement.prototype.volume = function(volumeValue) {
        this._volumeMultiplier = volumeValue;
        this._previousVolume = volumeValue * this._volume;
        this.audio.volume(this._previousVolume);
    };
    AudioElement.prototype.getBaseElement = function() {
        return null;
    };
    AudioElement.prototype.destroy = function() {};
    AudioElement.prototype.sourceRectAtTime = function() {};
    AudioElement.prototype.initExpressions = function() {};
    function BaseRenderer() {}
    BaseRenderer.prototype.checkLayers = function(num) {
        var i;
        var len = this.layers.length;
        var data;
        this.completeLayers = true;
        for(i = len - 1; i >= 0; i -= 1){
            if (!this.elements[i]) {
                data = this.layers[i];
                if (data.ip - data.st <= num - this.layers[i].st && data.op - data.st > num - this.layers[i].st) this.buildItem(i);
            }
            this.completeLayers = this.elements[i] ? this.completeLayers : false;
        }
        this.checkPendingElements();
    };
    BaseRenderer.prototype.createItem = function(layer) {
        switch(layer.ty){
            case 2:
                return this.createImage(layer);
            case 0:
                return this.createComp(layer);
            case 1:
                return this.createSolid(layer);
            case 3:
                return this.createNull(layer);
            case 4:
                return this.createShape(layer);
            case 5:
                return this.createText(layer);
            case 6:
                return this.createAudio(layer);
            case 13:
                return this.createCamera(layer);
            case 15:
                return this.createFootage(layer);
            default:
                return this.createNull(layer);
        }
    };
    BaseRenderer.prototype.createCamera = function() {
        throw new Error('You\'re using a 3d camera. Try the html renderer.');
    };
    BaseRenderer.prototype.createAudio = function(data) {
        return new AudioElement(data, this.globalData, this);
    };
    BaseRenderer.prototype.createFootage = function(data) {
        return new FootageElement(data, this.globalData, this);
    };
    BaseRenderer.prototype.buildAllItems = function() {
        var i;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1)this.buildItem(i);
        this.checkPendingElements();
    };
    BaseRenderer.prototype.includeLayers = function(newLayers) {
        this.completeLayers = false;
        var i;
        var len = newLayers.length;
        var j;
        var jLen = this.layers.length;
        for(i = 0; i < len; i += 1){
            j = 0;
            while(j < jLen){
                if (this.layers[j].id === newLayers[i].id) {
                    this.layers[j] = newLayers[i];
                    break;
                }
                j += 1;
            }
        }
    };
    BaseRenderer.prototype.setProjectInterface = function(pInterface) {
        this.globalData.projectInterface = pInterface;
    };
    BaseRenderer.prototype.initItems = function() {
        if (!this.globalData.progressiveLoad) this.buildAllItems();
    };
    BaseRenderer.prototype.buildElementParenting = function(element, parentName, hierarchy) {
        var elements = this.elements;
        var layers = this.layers;
        var i = 0;
        var len = layers.length;
        while(i < len){
            if (layers[i].ind == parentName) {
                // eslint-disable-line eqeqeq
                if (!elements[i] || elements[i] === true) {
                    this.buildItem(i);
                    this.addPendingElement(element);
                } else {
                    hierarchy.push(elements[i]);
                    elements[i].setAsParent();
                    if (layers[i].parent !== undefined) this.buildElementParenting(element, layers[i].parent, hierarchy);
                    else element.setHierarchy(hierarchy);
                }
            }
            i += 1;
        }
    };
    BaseRenderer.prototype.addPendingElement = function(element) {
        this.pendingElements.push(element);
    };
    BaseRenderer.prototype.searchExtraCompositions = function(assets) {
        var i;
        var len = assets.length;
        for(i = 0; i < len; i += 1)if (assets[i].xt) {
            var comp = this.createComp(assets[i]);
            comp.initExpressions();
            this.globalData.projectInterface.registerComposition(comp);
        }
    };
    BaseRenderer.prototype.getElementById = function(ind) {
        var i;
        var len = this.elements.length;
        for(i = 0; i < len; i += 1){
            if (this.elements[i].data.ind === ind) return this.elements[i];
        }
        return null;
    };
    BaseRenderer.prototype.getElementByPath = function(path) {
        var pathValue = path.shift();
        var element;
        if (typeof pathValue === 'number') element = this.elements[pathValue];
        else {
            var i;
            var len = this.elements.length;
            for(i = 0; i < len; i += 1)if (this.elements[i].data.nm === pathValue) {
                element = this.elements[i];
                break;
            }
        }
        if (path.length === 0) return element;
        return element.getElementByPath(path);
    };
    BaseRenderer.prototype.setupGlobalData = function(animData, fontsContainer) {
        this.globalData.fontManager = new FontManager();
        this.globalData.slotManager = slotFactory(animData);
        this.globalData.fontManager.addChars(animData.chars);
        this.globalData.fontManager.addFonts(animData.fonts, fontsContainer);
        this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
        this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
        this.globalData.imageLoader = this.animationItem.imagePreloader;
        this.globalData.audioController = this.animationItem.audioController;
        this.globalData.frameId = 0;
        this.globalData.frameRate = animData.fr;
        this.globalData.nm = animData.nm;
        this.globalData.compSize = {
            w: animData.w,
            h: animData.h
        };
    };
    var effectTypes = {
        TRANSFORM_EFFECT: 'transformEFfect'
    };
    function TransformElement() {}
    TransformElement.prototype = {
        initTransform: function initTransform() {
            var mat = new Matrix();
            this.finalTransform = {
                mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
                    o: 0
                },
                _matMdf: false,
                _localMatMdf: false,
                _opMdf: false,
                mat: mat,
                localMat: mat,
                localOpacity: 1
            };
            if (this.data.ao) this.finalTransform.mProp.autoOriented = true;
            // TODO: check TYPE 11: Guided elements
            this.data.ty;
        },
        renderTransform: function renderTransform() {
            this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame;
            this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame;
            if (this.hierarchy) {
                var mat;
                var finalMat = this.finalTransform.mat;
                var i = 0;
                var len = this.hierarchy.length;
                // Checking if any of the transformation matrices in the hierarchy chain has changed.
                if (!this.finalTransform._matMdf) while(i < len){
                    if (this.hierarchy[i].finalTransform.mProp._mdf) {
                        this.finalTransform._matMdf = true;
                        break;
                    }
                    i += 1;
                }
                if (this.finalTransform._matMdf) {
                    mat = this.finalTransform.mProp.v.props;
                    finalMat.cloneFromProps(mat);
                    for(i = 0; i < len; i += 1)finalMat.multiply(this.hierarchy[i].finalTransform.mProp.v);
                }
            }
            if (!this.localTransforms || this.finalTransform._matMdf) this.finalTransform._localMatMdf = this.finalTransform._matMdf;
            if (this.finalTransform._opMdf) this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
        },
        renderLocalTransform: function renderLocalTransform() {
            if (this.localTransforms) {
                var i = 0;
                var len = this.localTransforms.length;
                this.finalTransform._localMatMdf = this.finalTransform._matMdf;
                if (!this.finalTransform._localMatMdf || !this.finalTransform._opMdf) while(i < len){
                    if (this.localTransforms[i]._mdf) this.finalTransform._localMatMdf = true;
                    if (this.localTransforms[i]._opMdf && !this.finalTransform._opMdf) {
                        this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
                        this.finalTransform._opMdf = true;
                    }
                    i += 1;
                }
                if (this.finalTransform._localMatMdf) {
                    var localMat = this.finalTransform.localMat;
                    this.localTransforms[0].matrix.clone(localMat);
                    for(i = 1; i < len; i += 1){
                        var lmat = this.localTransforms[i].matrix;
                        localMat.multiply(lmat);
                    }
                    localMat.multiply(this.finalTransform.mat);
                }
                if (this.finalTransform._opMdf) {
                    var localOp = this.finalTransform.localOpacity;
                    for(i = 0; i < len; i += 1)localOp *= this.localTransforms[i].opacity * 0.01;
                    this.finalTransform.localOpacity = localOp;
                }
            }
        },
        searchEffectTransforms: function searchEffectTransforms() {
            if (this.renderableEffectsManager) {
                var transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
                if (transformEffects.length) {
                    this.localTransforms = [];
                    this.finalTransform.localMat = new Matrix();
                    var i = 0;
                    var len = transformEffects.length;
                    for(i = 0; i < len; i += 1)this.localTransforms.push(transformEffects[i]);
                }
            }
        },
        globalToLocal: function globalToLocal(pt) {
            var transforms = [];
            transforms.push(this.finalTransform);
            var flag = true;
            var comp = this.comp;
            while(flag)if (comp.finalTransform) {
                if (comp.data.hasMask) transforms.splice(0, 0, comp.finalTransform);
                comp = comp.comp;
            } else flag = false;
            var i;
            var len = transforms.length;
            var ptNew;
            for(i = 0; i < len; i += 1){
                ptNew = transforms[i].mat.applyToPointArray(0, 0, 0);
                // ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);
                pt = [
                    pt[0] - ptNew[0],
                    pt[1] - ptNew[1],
                    0
                ];
            }
            return pt;
        },
        mHelper: new Matrix()
    };
    function MaskElement(data, element, globalData) {
        this.data = data;
        this.element = element;
        this.globalData = globalData;
        this.storedData = [];
        this.masksProperties = this.data.masksProperties || [];
        this.maskElement = null;
        var defs = this.globalData.defs;
        var i;
        var len = this.masksProperties ? this.masksProperties.length : 0;
        this.viewData = createSizedArray(len);
        this.solidPath = '';
        var path;
        var properties = this.masksProperties;
        var count = 0;
        var currentMasks = [];
        var j;
        var jLen;
        var layerId = createElementID();
        var rect;
        var expansor;
        var feMorph;
        var x;
        var maskType = 'clipPath';
        var maskRef = 'clip-path';
        for(i = 0; i < len; i += 1){
            if (properties[i].mode !== 'a' && properties[i].mode !== 'n' || properties[i].inv || properties[i].o.k !== 100 || properties[i].o.x) {
                maskType = 'mask';
                maskRef = 'mask';
            }
            if ((properties[i].mode === 's' || properties[i].mode === 'i') && count === 0) {
                rect = createNS('rect');
                rect.setAttribute('fill', '#ffffff');
                rect.setAttribute('width', this.element.comp.data.w || 0);
                rect.setAttribute('height', this.element.comp.data.h || 0);
                currentMasks.push(rect);
            } else rect = null;
            path = createNS('path');
            if (properties[i].mode === 'n') {
                // TODO move this to a factory or to a constructor
                this.viewData[i] = {
                    op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
                    prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
                    elem: path,
                    lastPath: ''
                };
                defs.appendChild(path);
            } else {
                count += 1;
                path.setAttribute('fill', properties[i].mode === 's' ? '#000000' : '#ffffff');
                path.setAttribute('clip-rule', 'nonzero');
                var filterID;
                if (properties[i].x.k !== 0) {
                    maskType = 'mask';
                    maskRef = 'mask';
                    x = PropertyFactory.getProp(this.element, properties[i].x, 0, null, this.element);
                    filterID = createElementID();
                    expansor = createNS('filter');
                    expansor.setAttribute('id', filterID);
                    feMorph = createNS('feMorphology');
                    feMorph.setAttribute('operator', 'erode');
                    feMorph.setAttribute('in', 'SourceGraphic');
                    feMorph.setAttribute('radius', '0');
                    expansor.appendChild(feMorph);
                    defs.appendChild(expansor);
                    path.setAttribute('stroke', properties[i].mode === 's' ? '#000000' : '#ffffff');
                } else {
                    feMorph = null;
                    x = null;
                }
                // TODO move this to a factory or to a constructor
                this.storedData[i] = {
                    elem: path,
                    x: x,
                    expan: feMorph,
                    lastPath: '',
                    lastOperator: '',
                    filterId: filterID,
                    lastRadius: 0
                };
                if (properties[i].mode === 'i') {
                    jLen = currentMasks.length;
                    var g = createNS('g');
                    for(j = 0; j < jLen; j += 1)g.appendChild(currentMasks[j]);
                    var mask = createNS('mask');
                    mask.setAttribute('mask-type', 'alpha');
                    mask.setAttribute('id', layerId + '_' + count);
                    mask.appendChild(path);
                    defs.appendChild(mask);
                    g.setAttribute('mask', 'url(' + getLocationHref() + '#' + layerId + '_' + count + ')');
                    currentMasks.length = 0;
                    currentMasks.push(g);
                } else currentMasks.push(path);
                if (properties[i].inv && !this.solidPath) this.solidPath = this.createLayerSolidPath();
                // TODO move this to a factory or to a constructor
                this.viewData[i] = {
                    elem: path,
                    lastPath: '',
                    op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
                    prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
                    invRect: rect
                };
                if (!this.viewData[i].prop.k) this.drawPath(properties[i], this.viewData[i].prop.v, this.viewData[i]);
            }
        }
        this.maskElement = createNS(maskType);
        len = currentMasks.length;
        for(i = 0; i < len; i += 1)this.maskElement.appendChild(currentMasks[i]);
        if (count > 0) {
            this.maskElement.setAttribute('id', layerId);
            this.element.maskedElement.setAttribute(maskRef, 'url(' + getLocationHref() + '#' + layerId + ')');
            defs.appendChild(this.maskElement);
        }
        if (this.viewData.length) this.element.addRenderableComponent(this);
    }
    MaskElement.prototype.getMaskProperty = function(pos) {
        return this.viewData[pos].prop;
    };
    MaskElement.prototype.renderFrame = function(isFirstFrame) {
        var finalMat = this.element.finalTransform.mat;
        var i;
        var len = this.masksProperties.length;
        for(i = 0; i < len; i += 1){
            if (this.viewData[i].prop._mdf || isFirstFrame) this.drawPath(this.masksProperties[i], this.viewData[i].prop.v, this.viewData[i]);
            if (this.viewData[i].op._mdf || isFirstFrame) this.viewData[i].elem.setAttribute('fill-opacity', this.viewData[i].op.v);
            if (this.masksProperties[i].mode !== 'n') {
                if (this.viewData[i].invRect && (this.element.finalTransform.mProp._mdf || isFirstFrame)) this.viewData[i].invRect.setAttribute('transform', finalMat.getInverseMatrix().to2dCSS());
                if (this.storedData[i].x && (this.storedData[i].x._mdf || isFirstFrame)) {
                    var feMorph = this.storedData[i].expan;
                    if (this.storedData[i].x.v < 0) {
                        if (this.storedData[i].lastOperator !== 'erode') {
                            this.storedData[i].lastOperator = 'erode';
                            this.storedData[i].elem.setAttribute('filter', 'url(' + getLocationHref() + '#' + this.storedData[i].filterId + ')');
                        }
                        feMorph.setAttribute('radius', -this.storedData[i].x.v);
                    } else {
                        if (this.storedData[i].lastOperator !== 'dilate') {
                            this.storedData[i].lastOperator = 'dilate';
                            this.storedData[i].elem.setAttribute('filter', null);
                        }
                        this.storedData[i].elem.setAttribute('stroke-width', this.storedData[i].x.v * 2);
                    }
                }
            }
        }
    };
    MaskElement.prototype.getMaskelement = function() {
        return this.maskElement;
    };
    MaskElement.prototype.createLayerSolidPath = function() {
        var path = 'M0,0 ';
        path += ' h' + this.globalData.compSize.w;
        path += ' v' + this.globalData.compSize.h;
        path += ' h-' + this.globalData.compSize.w;
        path += ' v-' + this.globalData.compSize.h + ' ';
        return path;
    };
    MaskElement.prototype.drawPath = function(pathData, pathNodes, viewData) {
        var pathString = ' M' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
        var i;
        var len;
        len = pathNodes._length;
        for(i = 1; i < len; i += 1)// pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
        pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[i][0] + ',' + pathNodes.i[i][1] + ' ' + pathNodes.v[i][0] + ',' + pathNodes.v[i][1];
        // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];
        if (pathNodes.c && len > 1) pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[0][0] + ',' + pathNodes.i[0][1] + ' ' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
        // pathNodes.__renderedString = pathString;
        if (viewData.lastPath !== pathString) {
            var pathShapeValue = '';
            if (viewData.elem) {
                if (pathNodes.c) pathShapeValue = pathData.inv ? this.solidPath + pathString : pathString;
                viewData.elem.setAttribute('d', pathShapeValue);
            }
            viewData.lastPath = pathString;
        }
    };
    MaskElement.prototype.destroy = function() {
        this.element = null;
        this.globalData = null;
        this.maskElement = null;
        this.data = null;
        this.masksProperties = null;
    };
    var filtersFactory = function() {
        var ob = {};
        ob.createFilter = createFilter;
        ob.createAlphaToLuminanceFilter = createAlphaToLuminanceFilter;
        function createFilter(filId, skipCoordinates) {
            var fil = createNS('filter');
            fil.setAttribute('id', filId);
            if (skipCoordinates !== true) {
                fil.setAttribute('filterUnits', 'objectBoundingBox');
                fil.setAttribute('x', '0%');
                fil.setAttribute('y', '0%');
                fil.setAttribute('width', '100%');
                fil.setAttribute('height', '100%');
            }
            return fil;
        }
        function createAlphaToLuminanceFilter() {
            var feColorMatrix = createNS('feColorMatrix');
            feColorMatrix.setAttribute('type', 'matrix');
            feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
            feColorMatrix.setAttribute('values', '0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1');
            return feColorMatrix;
        }
        return ob;
    }();
    var featureSupport = function() {
        var ob = {
            maskType: true,
            svgLumaHidden: true,
            offscreenCanvas: typeof OffscreenCanvas !== 'undefined'
        };
        if (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) ob.maskType = false;
        if (/firefox/i.test(navigator.userAgent)) ob.svgLumaHidden = false;
        return ob;
    }();
    var registeredEffects = {};
    var idPrefix = 'filter_result_';
    function SVGEffects(elem) {
        var i;
        var source = 'SourceGraphic';
        var len = elem.data.ef ? elem.data.ef.length : 0;
        var filId = createElementID();
        var fil = filtersFactory.createFilter(filId, true);
        var count = 0;
        this.filters = [];
        var filterManager;
        for(i = 0; i < len; i += 1){
            filterManager = null;
            var type = elem.data.ef[i].ty;
            if (registeredEffects[type]) {
                var Effect = registeredEffects[type].effect;
                filterManager = new Effect(fil, elem.effectsManager.effectElements[i], elem, idPrefix + count, source);
                source = idPrefix + count;
                if (registeredEffects[type].countsAsEffect) count += 1;
            }
            if (filterManager) this.filters.push(filterManager);
        }
        if (count) {
            elem.globalData.defs.appendChild(fil);
            elem.layerElement.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
        }
        if (this.filters.length) elem.addRenderableComponent(this);
    }
    SVGEffects.prototype.renderFrame = function(_isFirstFrame) {
        var i;
        var len = this.filters.length;
        for(i = 0; i < len; i += 1)this.filters[i].renderFrame(_isFirstFrame);
    };
    SVGEffects.prototype.getEffects = function(type) {
        var i;
        var len = this.filters.length;
        var effects = [];
        for(i = 0; i < len; i += 1)if (this.filters[i].type === type) effects.push(this.filters[i]);
        return effects;
    };
    function registerEffect(id, effect, countsAsEffect) {
        registeredEffects[id] = {
            effect: effect,
            countsAsEffect: countsAsEffect
        };
    }
    function SVGBaseElement() {}
    SVGBaseElement.prototype = {
        initRendererElement: function initRendererElement() {
            this.layerElement = createNS('g');
        },
        createContainerElements: function createContainerElements() {
            this.matteElement = createNS('g');
            this.transformedElement = this.layerElement;
            this.maskedElement = this.layerElement;
            this._sizeChanged = false;
            var layerElementParent = null;
            // If this layer acts as a mask for the following layer
            if (this.data.td) {
                this.matteMasks = {};
                var gg = createNS('g');
                gg.setAttribute('id', this.layerId);
                gg.appendChild(this.layerElement);
                layerElementParent = gg;
                this.globalData.defs.appendChild(gg);
            } else if (this.data.tt) {
                this.matteElement.appendChild(this.layerElement);
                layerElementParent = this.matteElement;
                this.baseElement = this.matteElement;
            } else this.baseElement = this.layerElement;
            if (this.data.ln) this.layerElement.setAttribute('id', this.data.ln);
            if (this.data.cl) this.layerElement.setAttribute('class', this.data.cl);
            // Clipping compositions to hide content that exceeds boundaries. If collapsed transformations is on, component should not be clipped
            if (this.data.ty === 0 && !this.data.hd) {
                var cp = createNS('clipPath');
                var pt = createNS('path');
                pt.setAttribute('d', 'M0,0 L' + this.data.w + ',0 L' + this.data.w + ',' + this.data.h + ' L0,' + this.data.h + 'z');
                var clipId = createElementID();
                cp.setAttribute('id', clipId);
                cp.appendChild(pt);
                this.globalData.defs.appendChild(cp);
                if (this.checkMasks()) {
                    var cpGroup = createNS('g');
                    cpGroup.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + clipId + ')');
                    cpGroup.appendChild(this.layerElement);
                    this.transformedElement = cpGroup;
                    if (layerElementParent) layerElementParent.appendChild(this.transformedElement);
                    else this.baseElement = this.transformedElement;
                } else this.layerElement.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + clipId + ')');
            }
            if (this.data.bm !== 0) this.setBlendMode();
        },
        renderElement: function renderElement() {
            if (this.finalTransform._localMatMdf) this.transformedElement.setAttribute('transform', this.finalTransform.localMat.to2dCSS());
            if (this.finalTransform._opMdf) this.transformedElement.setAttribute('opacity', this.finalTransform.localOpacity);
        },
        destroyBaseElement: function destroyBaseElement() {
            this.layerElement = null;
            this.matteElement = null;
            this.maskManager.destroy();
        },
        getBaseElement: function getBaseElement() {
            if (this.data.hd) return null;
            return this.baseElement;
        },
        createRenderableComponents: function createRenderableComponents() {
            this.maskManager = new MaskElement(this.data, this, this.globalData);
            this.renderableEffectsManager = new SVGEffects(this);
            this.searchEffectTransforms();
        },
        getMatte: function getMatte(matteType) {
            // This should not be a common case. But for backward compatibility, we'll create the matte object.
            // It solves animations that have two consecutive layers marked as matte masks.
            // Which is an undefined behavior in AE.
            if (!this.matteMasks) this.matteMasks = {};
            if (!this.matteMasks[matteType]) {
                var id = this.layerId + '_' + matteType;
                var filId;
                var fil;
                var useElement;
                var gg;
                if (matteType === 1 || matteType === 3) {
                    var masker = createNS('mask');
                    masker.setAttribute('id', id);
                    masker.setAttribute('mask-type', matteType === 3 ? 'luminance' : 'alpha');
                    useElement = createNS('use');
                    useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + this.layerId);
                    masker.appendChild(useElement);
                    this.globalData.defs.appendChild(masker);
                    if (!featureSupport.maskType && matteType === 1) {
                        masker.setAttribute('mask-type', 'luminance');
                        filId = createElementID();
                        fil = filtersFactory.createFilter(filId);
                        this.globalData.defs.appendChild(fil);
                        fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
                        gg = createNS('g');
                        gg.appendChild(useElement);
                        masker.appendChild(gg);
                        gg.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
                    }
                } else if (matteType === 2) {
                    var maskGroup = createNS('mask');
                    maskGroup.setAttribute('id', id);
                    maskGroup.setAttribute('mask-type', 'alpha');
                    var maskGrouper = createNS('g');
                    maskGroup.appendChild(maskGrouper);
                    filId = createElementID();
                    fil = filtersFactory.createFilter(filId);
                    /// /
                    var feCTr = createNS('feComponentTransfer');
                    feCTr.setAttribute('in', 'SourceGraphic');
                    fil.appendChild(feCTr);
                    var feFunc = createNS('feFuncA');
                    feFunc.setAttribute('type', 'table');
                    feFunc.setAttribute('tableValues', '1.0 0.0');
                    feCTr.appendChild(feFunc);
                    /// /
                    this.globalData.defs.appendChild(fil);
                    var alphaRect = createNS('rect');
                    alphaRect.setAttribute('width', this.comp.data.w);
                    alphaRect.setAttribute('height', this.comp.data.h);
                    alphaRect.setAttribute('x', '0');
                    alphaRect.setAttribute('y', '0');
                    alphaRect.setAttribute('fill', '#ffffff');
                    alphaRect.setAttribute('opacity', '0');
                    maskGrouper.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
                    maskGrouper.appendChild(alphaRect);
                    useElement = createNS('use');
                    useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + this.layerId);
                    maskGrouper.appendChild(useElement);
                    if (!featureSupport.maskType) {
                        maskGroup.setAttribute('mask-type', 'luminance');
                        fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
                        gg = createNS('g');
                        maskGrouper.appendChild(alphaRect);
                        gg.appendChild(this.layerElement);
                        maskGrouper.appendChild(gg);
                    }
                    this.globalData.defs.appendChild(maskGroup);
                }
                this.matteMasks[matteType] = id;
            }
            return this.matteMasks[matteType];
        },
        setMatte: function setMatte(id) {
            if (!this.matteElement) return;
            this.matteElement.setAttribute('mask', 'url(' + getLocationHref() + '#' + id + ')');
        }
    };
    /**
   * @file
   * Handles AE's layer parenting property.
   *
   */ function HierarchyElement() {}
    HierarchyElement.prototype = {
        /**
       * @function
       * Initializes hierarchy properties
       *
       */ initHierarchy: function initHierarchy() {
            // element's parent list
            this.hierarchy = [];
            // if element is parent of another layer _isParent will be true
            this._isParent = false;
            this.checkParenting();
        },
        /**
       * @function
       * Sets layer's hierarchy.
       * @param {array} hierarch
       * layer's parent list
       *
       */ setHierarchy: function setHierarchy(hierarchy) {
            this.hierarchy = hierarchy;
        },
        /**
       * @function
       * Sets layer as parent.
       *
       */ setAsParent: function setAsParent() {
            this._isParent = true;
        },
        /**
       * @function
       * Searches layer's parenting chain
       *
       */ checkParenting: function checkParenting() {
            if (this.data.parent !== undefined) this.comp.buildElementParenting(this, this.data.parent, []);
        }
    };
    function RenderableDOMElement() {}
    (function() {
        var _prototype = {
            initElement: function initElement(data, globalData, comp) {
                this.initFrame();
                this.initBaseData(data, globalData, comp);
                this.initTransform(data, globalData, comp);
                this.initHierarchy();
                this.initRenderable();
                this.initRendererElement();
                this.createContainerElements();
                this.createRenderableComponents();
                this.createContent();
                this.hide();
            },
            hide: function hide() {
                // console.log('HIDE', this);
                if (!this.hidden && (!this.isInRange || this.isTransparent)) {
                    var elem = this.baseElement || this.layerElement;
                    elem.style.display = 'none';
                    this.hidden = true;
                }
            },
            show: function show() {
                // console.log('SHOW', this);
                if (this.isInRange && !this.isTransparent) {
                    if (!this.data.hd) {
                        var elem = this.baseElement || this.layerElement;
                        elem.style.display = 'block';
                    }
                    this.hidden = false;
                    this._isFirstFrame = true;
                }
            },
            renderFrame: function renderFrame() {
                // If it is exported as hidden (data.hd === true) no need to render
                // If it is not visible no need to render
                if (this.data.hd || this.hidden) return;
                this.renderTransform();
                this.renderRenderable();
                this.renderLocalTransform();
                this.renderElement();
                this.renderInnerContent();
                if (this._isFirstFrame) this._isFirstFrame = false;
            },
            renderInnerContent: function renderInnerContent() {},
            prepareFrame: function prepareFrame(num) {
                this._mdf = false;
                this.prepareRenderableFrame(num);
                this.prepareProperties(num, this.isInRange);
                this.checkTransparency();
            },
            destroy: function destroy() {
                this.innerElem = null;
                this.destroyBaseElement();
            }
        };
        extendPrototype([
            RenderableElement,
            createProxyFunction(_prototype)
        ], RenderableDOMElement);
    })();
    function IImageElement(data, globalData, comp) {
        this.assetData = globalData.getAssetData(data.refId);
        if (this.assetData && this.assetData.sid) this.assetData = globalData.slotManager.getProp(this.assetData);
        this.initElement(data, globalData, comp);
        this.sourceRect = {
            top: 0,
            left: 0,
            width: this.assetData.w,
            height: this.assetData.h
        };
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], IImageElement);
    IImageElement.prototype.createContent = function() {
        var assetPath = this.globalData.getAssetsPath(this.assetData);
        this.innerElem = createNS('image');
        this.innerElem.setAttribute('width', this.assetData.w + 'px');
        this.innerElem.setAttribute('height', this.assetData.h + 'px');
        this.innerElem.setAttribute('preserveAspectRatio', this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio);
        this.innerElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);
        this.layerElement.appendChild(this.innerElem);
    };
    IImageElement.prototype.sourceRectAtTime = function() {
        return this.sourceRect;
    };
    function ProcessedElement(element, position) {
        this.elem = element;
        this.pos = position;
    }
    function IShapeElement() {}
    IShapeElement.prototype = {
        addShapeToModifiers: function addShapeToModifiers(data) {
            var i;
            var len = this.shapeModifiers.length;
            for(i = 0; i < len; i += 1)this.shapeModifiers[i].addShape(data);
        },
        isShapeInAnimatedModifiers: function isShapeInAnimatedModifiers(data) {
            var i = 0;
            var len = this.shapeModifiers.length;
            while(i < len){
                if (this.shapeModifiers[i].isAnimatedWithShape(data)) return true;
            }
            return false;
        },
        renderModifiers: function renderModifiers() {
            if (!this.shapeModifiers.length) return;
            var i;
            var len = this.shapes.length;
            for(i = 0; i < len; i += 1)this.shapes[i].sh.reset();
            len = this.shapeModifiers.length;
            var shouldBreakProcess;
            for(i = len - 1; i >= 0; i -= 1){
                shouldBreakProcess = this.shapeModifiers[i].processShapes(this._isFirstFrame);
                // workaround to fix cases where a repeater resets the shape so the following processes get called twice
                // TODO: find a better solution for this
                if (shouldBreakProcess) break;
            }
        },
        searchProcessedElement: function searchProcessedElement(elem) {
            var elements = this.processedElements;
            var i = 0;
            var len = elements.length;
            while(i < len){
                if (elements[i].elem === elem) return elements[i].pos;
                i += 1;
            }
            return 0;
        },
        addProcessedElement: function addProcessedElement(elem, pos) {
            var elements = this.processedElements;
            var i = elements.length;
            while(i){
                i -= 1;
                if (elements[i].elem === elem) {
                    elements[i].pos = pos;
                    return;
                }
            }
            elements.push(new ProcessedElement(elem, pos));
        },
        prepareFrame: function prepareFrame(num) {
            this.prepareRenderableFrame(num);
            this.prepareProperties(num, this.isInRange);
        }
    };
    var lineCapEnum = {
        1: 'butt',
        2: 'round',
        3: 'square'
    };
    var lineJoinEnum = {
        1: 'miter',
        2: 'round',
        3: 'bevel'
    };
    function SVGShapeData(transformers, level, shape) {
        this.caches = [];
        this.styles = [];
        this.transformers = transformers;
        this.lStr = '';
        this.sh = shape;
        this.lvl = level;
        // TODO find if there are some cases where _isAnimated can be false.
        // For now, since shapes add up with other shapes. They have to be calculated every time.
        // One way of finding out is checking if all styles associated to this shape depend only of this shape
        this._isAnimated = !!shape.k;
        // TODO: commenting this for now since all shapes are animated
        var i = 0;
        var len = transformers.length;
        while(i < len){
            if (transformers[i].mProps.dynamicProperties.length) {
                this._isAnimated = true;
                break;
            }
            i += 1;
        }
    }
    SVGShapeData.prototype.setAsAnimated = function() {
        this._isAnimated = true;
    };
    function SVGStyleData(data, level) {
        this.data = data;
        this.type = data.ty;
        this.d = '';
        this.lvl = level;
        this._mdf = false;
        this.closed = data.hd === true;
        this.pElem = createNS('path');
        this.msElem = null;
    }
    SVGStyleData.prototype.reset = function() {
        this.d = '';
        this._mdf = false;
    };
    function DashProperty(elem, data, renderer, container) {
        this.elem = elem;
        this.frameId = -1;
        this.dataProps = createSizedArray(data.length);
        this.renderer = renderer;
        this.k = false;
        this.dashStr = '';
        this.dashArray = createTypedArray('float32', data.length ? data.length - 1 : 0);
        this.dashoffset = createTypedArray('float32', 1);
        this.initDynamicPropertyContainer(container);
        var i;
        var len = data.length || 0;
        var prop;
        for(i = 0; i < len; i += 1){
            prop = PropertyFactory.getProp(elem, data[i].v, 0, 0, this);
            this.k = prop.k || this.k;
            this.dataProps[i] = {
                n: data[i].n,
                p: prop
            };
        }
        if (!this.k) this.getValue(true);
        this._isAnimated = this.k;
    }
    DashProperty.prototype.getValue = function(forceRender) {
        if (this.elem.globalData.frameId === this.frameId && !forceRender) return;
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();
        this._mdf = this._mdf || forceRender;
        if (this._mdf) {
            var i = 0;
            var len = this.dataProps.length;
            if (this.renderer === 'svg') this.dashStr = '';
            for(i = 0; i < len; i += 1)if (this.dataProps[i].n !== 'o') {
                if (this.renderer === 'svg') this.dashStr += ' ' + this.dataProps[i].p.v;
                else this.dashArray[i] = this.dataProps[i].p.v;
            } else this.dashoffset[0] = this.dataProps[i].p.v;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], DashProperty);
    function SVGStrokeStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
        this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
        this.d = new DashProperty(elem, data.d || {}, 'svg', this);
        this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
        this.style = styleOb;
        this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGStrokeStyleData);
    function SVGFillStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
        this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
        this.style = styleOb;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGFillStyleData);
    function SVGNoStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.style = styleOb;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGNoStyleData);
    function GradientProperty(elem, data, container) {
        this.data = data;
        this.c = createTypedArray('uint8c', data.p * 4);
        var cLength = data.k.k[0].s ? data.k.k[0].s.length - data.p * 4 : data.k.k.length - data.p * 4;
        this.o = createTypedArray('float32', cLength);
        this._cmdf = false;
        this._omdf = false;
        this._collapsable = this.checkCollapsable();
        this._hasOpacity = cLength;
        this.initDynamicPropertyContainer(container);
        this.prop = PropertyFactory.getProp(elem, data.k, 1, null, this);
        this.k = this.prop.k;
        this.getValue(true);
    }
    GradientProperty.prototype.comparePoints = function(values, points) {
        var i = 0;
        var len = this.o.length / 2;
        var diff;
        while(i < len){
            diff = Math.abs(values[i * 4] - values[points * 4 + i * 2]);
            if (diff > 0.01) return false;
            i += 1;
        }
        return true;
    };
    GradientProperty.prototype.checkCollapsable = function() {
        if (this.o.length / 2 !== this.c.length / 4) return false;
        if (this.data.k.k[0].s) {
            var i = 0;
            var len = this.data.k.k.length;
            while(i < len){
                if (!this.comparePoints(this.data.k.k[i].s, this.data.p)) return false;
                i += 1;
            }
        } else if (!this.comparePoints(this.data.k.k, this.data.p)) return false;
        return true;
    };
    GradientProperty.prototype.getValue = function(forceRender) {
        this.prop.getValue();
        this._mdf = false;
        this._cmdf = false;
        this._omdf = false;
        if (this.prop._mdf || forceRender) {
            var i;
            var len = this.data.p * 4;
            var mult;
            var val;
            for(i = 0; i < len; i += 1){
                mult = i % 4 === 0 ? 100 : 255;
                val = Math.round(this.prop.v[i] * mult);
                if (this.c[i] !== val) {
                    this.c[i] = val;
                    this._cmdf = !forceRender;
                }
            }
            if (this.o.length) {
                len = this.prop.v.length;
                for(i = this.data.p * 4; i < len; i += 1){
                    mult = i % 2 === 0 ? 100 : 1;
                    val = i % 2 === 0 ? Math.round(this.prop.v[i] * 100) : this.prop.v[i];
                    if (this.o[i - this.data.p * 4] !== val) {
                        this.o[i - this.data.p * 4] = val;
                        this._omdf = !forceRender;
                    }
                }
            }
            this._mdf = !forceRender;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], GradientProperty);
    function SVGGradientFillStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.initGradientData(elem, data, styleOb);
    }
    SVGGradientFillStyleData.prototype.initGradientData = function(elem, data, styleOb) {
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
        this.s = PropertyFactory.getProp(elem, data.s, 1, null, this);
        this.e = PropertyFactory.getProp(elem, data.e, 1, null, this);
        this.h = PropertyFactory.getProp(elem, data.h || {
            k: 0
        }, 0, 0.01, this);
        this.a = PropertyFactory.getProp(elem, data.a || {
            k: 0
        }, 0, degToRads, this);
        this.g = new GradientProperty(elem, data.g, this);
        this.style = styleOb;
        this.stops = [];
        this.setGradientData(styleOb.pElem, data);
        this.setGradientOpacity(data, styleOb);
        this._isAnimated = !!this._isAnimated;
    };
    SVGGradientFillStyleData.prototype.setGradientData = function(pathElement, data) {
        var gradientId = createElementID();
        var gfill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
        gfill.setAttribute('id', gradientId);
        gfill.setAttribute('spreadMethod', 'pad');
        gfill.setAttribute('gradientUnits', 'userSpaceOnUse');
        var stops = [];
        var stop;
        var j;
        var jLen;
        jLen = data.g.p * 4;
        for(j = 0; j < jLen; j += 4){
            stop = createNS('stop');
            gfill.appendChild(stop);
            stops.push(stop);
        }
        pathElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + getLocationHref() + '#' + gradientId + ')');
        this.gf = gfill;
        this.cst = stops;
    };
    SVGGradientFillStyleData.prototype.setGradientOpacity = function(data, styleOb) {
        if (this.g._hasOpacity && !this.g._collapsable) {
            var stop;
            var j;
            var jLen;
            var mask = createNS('mask');
            var maskElement = createNS('path');
            mask.appendChild(maskElement);
            var opacityId = createElementID();
            var maskId = createElementID();
            mask.setAttribute('id', maskId);
            var opFill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
            opFill.setAttribute('id', opacityId);
            opFill.setAttribute('spreadMethod', 'pad');
            opFill.setAttribute('gradientUnits', 'userSpaceOnUse');
            jLen = data.g.k.k[0].s ? data.g.k.k[0].s.length : data.g.k.k.length;
            var stops = this.stops;
            for(j = data.g.p * 4; j < jLen; j += 2){
                stop = createNS('stop');
                stop.setAttribute('stop-color', 'rgb(255,255,255)');
                opFill.appendChild(stop);
                stops.push(stop);
            }
            maskElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + getLocationHref() + '#' + opacityId + ')');
            if (data.ty === 'gs') {
                maskElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
                maskElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);
                if (data.lj === 1) maskElement.setAttribute('stroke-miterlimit', data.ml);
            }
            this.of = opFill;
            this.ms = mask;
            this.ost = stops;
            this.maskId = maskId;
            styleOb.msElem = maskElement;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], SVGGradientFillStyleData);
    function SVGGradientStrokeStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
        this.d = new DashProperty(elem, data.d || {}, 'svg', this);
        this.initGradientData(elem, data, styleOb);
        this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([
        SVGGradientFillStyleData,
        DynamicPropertyContainer
    ], SVGGradientStrokeStyleData);
    function ShapeGroupData() {
        this.it = [];
        this.prevViewData = [];
        this.gr = createNS('g');
    }
    function SVGTransformData(mProps, op, container) {
        this.transform = {
            mProps: mProps,
            op: op,
            container: container
        };
        this.elements = [];
        this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
    }
    var buildShapeString = function buildShapeString(pathNodes, length, closed, mat) {
        if (length === 0) return '';
        var _o = pathNodes.o;
        var _i = pathNodes.i;
        var _v = pathNodes.v;
        var i;
        var shapeString = ' M' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
        for(i = 1; i < length; i += 1)shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[i][0], _i[i][1]) + ' ' + mat.applyToPointStringified(_v[i][0], _v[i][1]);
        if (closed && length) {
            shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[0][0], _i[0][1]) + ' ' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
            shapeString += 'z';
        }
        return shapeString;
    };
    var SVGElementsRenderer = function() {
        var _identityMatrix = new Matrix();
        var _matrixHelper = new Matrix();
        var ob = {
            createRenderFunction: createRenderFunction
        };
        function createRenderFunction(data) {
            switch(data.ty){
                case 'fl':
                    return renderFill;
                case 'gf':
                    return renderGradient;
                case 'gs':
                    return renderGradientStroke;
                case 'st':
                    return renderStroke;
                case 'sh':
                case 'el':
                case 'rc':
                case 'sr':
                    return renderPath;
                case 'tr':
                    return renderContentTransform;
                case 'no':
                    return renderNoop;
                default:
                    return null;
            }
        }
        function renderContentTransform(styleData, itemData, isFirstFrame) {
            if (isFirstFrame || itemData.transform.op._mdf) itemData.transform.container.setAttribute('opacity', itemData.transform.op.v);
            if (isFirstFrame || itemData.transform.mProps._mdf) itemData.transform.container.setAttribute('transform', itemData.transform.mProps.v.to2dCSS());
        }
        function renderNoop() {}
        function renderPath(styleData, itemData, isFirstFrame) {
            var j;
            var jLen;
            var pathStringTransformed;
            var redraw;
            var pathNodes;
            var l;
            var lLen = itemData.styles.length;
            var lvl = itemData.lvl;
            var paths;
            var mat;
            var iterations;
            var k;
            for(l = 0; l < lLen; l += 1){
                redraw = itemData.sh._mdf || isFirstFrame;
                if (itemData.styles[l].lvl < lvl) {
                    mat = _matrixHelper.reset();
                    iterations = lvl - itemData.styles[l].lvl;
                    k = itemData.transformers.length - 1;
                    while(!redraw && iterations > 0){
                        redraw = itemData.transformers[k].mProps._mdf || redraw;
                        iterations -= 1;
                        k -= 1;
                    }
                    if (redraw) {
                        iterations = lvl - itemData.styles[l].lvl;
                        k = itemData.transformers.length - 1;
                        while(iterations > 0){
                            mat.multiply(itemData.transformers[k].mProps.v);
                            iterations -= 1;
                            k -= 1;
                        }
                    }
                } else mat = _identityMatrix;
                paths = itemData.sh.paths;
                jLen = paths._length;
                if (redraw) {
                    pathStringTransformed = '';
                    for(j = 0; j < jLen; j += 1){
                        pathNodes = paths.shapes[j];
                        if (pathNodes && pathNodes._length) pathStringTransformed += buildShapeString(pathNodes, pathNodes._length, pathNodes.c, mat);
                    }
                    itemData.caches[l] = pathStringTransformed;
                } else pathStringTransformed = itemData.caches[l];
                itemData.styles[l].d += styleData.hd === true ? '' : pathStringTransformed;
                itemData.styles[l]._mdf = redraw || itemData.styles[l]._mdf;
            }
        }
        function renderFill(styleData, itemData, isFirstFrame) {
            var styleElem = itemData.style;
            if (itemData.c._mdf || isFirstFrame) styleElem.pElem.setAttribute('fill', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
            if (itemData.o._mdf || isFirstFrame) styleElem.pElem.setAttribute('fill-opacity', itemData.o.v);
        }
        function renderGradientStroke(styleData, itemData, isFirstFrame) {
            renderGradient(styleData, itemData, isFirstFrame);
            renderStroke(styleData, itemData, isFirstFrame);
        }
        function renderGradient(styleData, itemData, isFirstFrame) {
            var gfill = itemData.gf;
            var hasOpacity = itemData.g._hasOpacity;
            var pt1 = itemData.s.v;
            var pt2 = itemData.e.v;
            if (itemData.o._mdf || isFirstFrame) {
                var attr = styleData.ty === 'gf' ? 'fill-opacity' : 'stroke-opacity';
                itemData.style.pElem.setAttribute(attr, itemData.o.v);
            }
            if (itemData.s._mdf || isFirstFrame) {
                var attr1 = styleData.t === 1 ? 'x1' : 'cx';
                var attr2 = attr1 === 'x1' ? 'y1' : 'cy';
                gfill.setAttribute(attr1, pt1[0]);
                gfill.setAttribute(attr2, pt1[1]);
                if (hasOpacity && !itemData.g._collapsable) {
                    itemData.of.setAttribute(attr1, pt1[0]);
                    itemData.of.setAttribute(attr2, pt1[1]);
                }
            }
            var stops;
            var i;
            var len;
            var stop;
            if (itemData.g._cmdf || isFirstFrame) {
                stops = itemData.cst;
                var cValues = itemData.g.c;
                len = stops.length;
                for(i = 0; i < len; i += 1){
                    stop = stops[i];
                    stop.setAttribute('offset', cValues[i * 4] + '%');
                    stop.setAttribute('stop-color', 'rgb(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ')');
                }
            }
            if (hasOpacity && (itemData.g._omdf || isFirstFrame)) {
                var oValues = itemData.g.o;
                if (itemData.g._collapsable) stops = itemData.cst;
                else stops = itemData.ost;
                len = stops.length;
                for(i = 0; i < len; i += 1){
                    stop = stops[i];
                    if (!itemData.g._collapsable) stop.setAttribute('offset', oValues[i * 2] + '%');
                    stop.setAttribute('stop-opacity', oValues[i * 2 + 1]);
                }
            }
            if (styleData.t === 1) {
                if (itemData.e._mdf || isFirstFrame) {
                    gfill.setAttribute('x2', pt2[0]);
                    gfill.setAttribute('y2', pt2[1]);
                    if (hasOpacity && !itemData.g._collapsable) {
                        itemData.of.setAttribute('x2', pt2[0]);
                        itemData.of.setAttribute('y2', pt2[1]);
                    }
                }
            } else {
                var rad;
                if (itemData.s._mdf || itemData.e._mdf || isFirstFrame) {
                    rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
                    gfill.setAttribute('r', rad);
                    if (hasOpacity && !itemData.g._collapsable) itemData.of.setAttribute('r', rad);
                }
                if (itemData.s._mdf || itemData.e._mdf || itemData.h._mdf || itemData.a._mdf || isFirstFrame) {
                    if (!rad) rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
                    var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
                    var percent = itemData.h.v;
                    if (percent >= 1) percent = 0.99;
                    else if (percent <= -1) percent = -0.99;
                    var dist = rad * percent;
                    var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
                    var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
                    gfill.setAttribute('fx', x);
                    gfill.setAttribute('fy', y);
                    if (hasOpacity && !itemData.g._collapsable) {
                        itemData.of.setAttribute('fx', x);
                        itemData.of.setAttribute('fy', y);
                    }
                }
            // gfill.setAttribute('fy','200');
            }
        }
        function renderStroke(styleData, itemData, isFirstFrame) {
            var styleElem = itemData.style;
            var d = itemData.d;
            if (d && (d._mdf || isFirstFrame) && d.dashStr) {
                styleElem.pElem.setAttribute('stroke-dasharray', d.dashStr);
                styleElem.pElem.setAttribute('stroke-dashoffset', d.dashoffset[0]);
            }
            if (itemData.c && (itemData.c._mdf || isFirstFrame)) styleElem.pElem.setAttribute('stroke', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
            if (itemData.o._mdf || isFirstFrame) styleElem.pElem.setAttribute('stroke-opacity', itemData.o.v);
            if (itemData.w._mdf || isFirstFrame) {
                styleElem.pElem.setAttribute('stroke-width', itemData.w.v);
                if (styleElem.msElem) styleElem.msElem.setAttribute('stroke-width', itemData.w.v);
            }
        }
        return ob;
    }();
    function SVGShapeElement(data, globalData, comp) {
        // List of drawable elements
        this.shapes = [];
        // Full shape data
        this.shapesData = data.shapes;
        // List of styles that will be applied to shapes
        this.stylesList = [];
        // List of modifiers that will be applied to shapes
        this.shapeModifiers = [];
        // List of items in shape tree
        this.itemsData = [];
        // List of items in previous shape tree
        this.processedElements = [];
        // List of animated components
        this.animatedContents = [];
        this.initElement(data, globalData, comp);
        // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
        // List of elements that have been created
        this.prevViewData = [];
    // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        IShapeElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], SVGShapeElement);
    SVGShapeElement.prototype.initSecondaryElement = function() {};
    SVGShapeElement.prototype.identityMatrix = new Matrix();
    SVGShapeElement.prototype.buildExpressionInterface = function() {};
    SVGShapeElement.prototype.createContent = function() {
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
        this.filterUniqueShapes();
    };
    /*
  This method searches for multiple shapes that affect a single element and one of them is animated
  */ SVGShapeElement.prototype.filterUniqueShapes = function() {
        var i;
        var len = this.shapes.length;
        var shape;
        var j;
        var jLen = this.stylesList.length;
        var style;
        var tempShapes = [];
        var areAnimated = false;
        for(j = 0; j < jLen; j += 1){
            style = this.stylesList[j];
            areAnimated = false;
            tempShapes.length = 0;
            for(i = 0; i < len; i += 1){
                shape = this.shapes[i];
                if (shape.styles.indexOf(style) !== -1) {
                    tempShapes.push(shape);
                    areAnimated = shape._isAnimated || areAnimated;
                }
            }
            if (tempShapes.length > 1 && areAnimated) this.setShapesAsAnimated(tempShapes);
        }
    };
    SVGShapeElement.prototype.setShapesAsAnimated = function(shapes) {
        var i;
        var len = shapes.length;
        for(i = 0; i < len; i += 1)shapes[i].setAsAnimated();
    };
    SVGShapeElement.prototype.createStyleElement = function(data, level) {
        // TODO: prevent drawing of hidden styles
        var elementData;
        var styleOb = new SVGStyleData(data, level);
        var pathElement = styleOb.pElem;
        if (data.ty === 'st') elementData = new SVGStrokeStyleData(this, data, styleOb);
        else if (data.ty === 'fl') elementData = new SVGFillStyleData(this, data, styleOb);
        else if (data.ty === 'gf' || data.ty === 'gs') {
            var GradientConstructor = data.ty === 'gf' ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
            elementData = new GradientConstructor(this, data, styleOb);
            this.globalData.defs.appendChild(elementData.gf);
            if (elementData.maskId) {
                this.globalData.defs.appendChild(elementData.ms);
                this.globalData.defs.appendChild(elementData.of);
                pathElement.setAttribute('mask', 'url(' + getLocationHref() + '#' + elementData.maskId + ')');
            }
        } else if (data.ty === 'no') elementData = new SVGNoStyleData(this, data, styleOb);
        if (data.ty === 'st' || data.ty === 'gs') {
            pathElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
            pathElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);
            pathElement.setAttribute('fill-opacity', '0');
            if (data.lj === 1) pathElement.setAttribute('stroke-miterlimit', data.ml);
        }
        if (data.r === 2) pathElement.setAttribute('fill-rule', 'evenodd');
        if (data.ln) pathElement.setAttribute('id', data.ln);
        if (data.cl) pathElement.setAttribute('class', data.cl);
        if (data.bm) pathElement.style['mix-blend-mode'] = getBlendMode(data.bm);
        this.stylesList.push(styleOb);
        this.addToAnimatedContents(data, elementData);
        return elementData;
    };
    SVGShapeElement.prototype.createGroupElement = function(data) {
        var elementData = new ShapeGroupData();
        if (data.ln) elementData.gr.setAttribute('id', data.ln);
        if (data.cl) elementData.gr.setAttribute('class', data.cl);
        if (data.bm) elementData.gr.style['mix-blend-mode'] = getBlendMode(data.bm);
        return elementData;
    };
    SVGShapeElement.prototype.createTransformElement = function(data, container) {
        var transformProperty = TransformPropertyFactory.getTransformProperty(this, data, this);
        var elementData = new SVGTransformData(transformProperty, transformProperty.o, container);
        this.addToAnimatedContents(data, elementData);
        return elementData;
    };
    SVGShapeElement.prototype.createShapeElement = function(data, ownTransformers, level) {
        var ty = 4;
        if (data.ty === 'rc') ty = 5;
        else if (data.ty === 'el') ty = 6;
        else if (data.ty === 'sr') ty = 7;
        var shapeProperty = ShapePropertyFactory.getShapeProp(this, data, ty, this);
        var elementData = new SVGShapeData(ownTransformers, level, shapeProperty);
        this.shapes.push(elementData);
        this.addShapeToModifiers(elementData);
        this.addToAnimatedContents(data, elementData);
        return elementData;
    };
    SVGShapeElement.prototype.addToAnimatedContents = function(data, element) {
        var i = 0;
        var len = this.animatedContents.length;
        while(i < len){
            if (this.animatedContents[i].element === element) return;
            i += 1;
        }
        this.animatedContents.push({
            fn: SVGElementsRenderer.createRenderFunction(data),
            element: element,
            data: data
        });
    };
    SVGShapeElement.prototype.setElementStyles = function(elementData) {
        var arr = elementData.styles;
        var j;
        var jLen = this.stylesList.length;
        for(j = 0; j < jLen; j += 1)if (arr.indexOf(this.stylesList[j]) === -1 && !this.stylesList[j].closed) arr.push(this.stylesList[j]);
    };
    SVGShapeElement.prototype.reloadShapes = function() {
        this._isFirstFrame = true;
        var i;
        var len = this.itemsData.length;
        for(i = 0; i < len; i += 1)this.prevViewData[i] = this.itemsData[i];
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
        this.filterUniqueShapes();
        len = this.dynamicProperties.length;
        for(i = 0; i < len; i += 1)this.dynamicProperties[i].getValue();
        this.renderModifiers();
    };
    SVGShapeElement.prototype.searchShapes = function(arr, itemsData, prevViewData, container, level, transformers, render) {
        var ownTransformers = [].concat(transformers);
        var i;
        var len = arr.length - 1;
        var j;
        var jLen;
        var ownStyles = [];
        var ownModifiers = [];
        var currentTransform;
        var modifier;
        var processedPos;
        for(i = len; i >= 0; i -= 1){
            processedPos = this.searchProcessedElement(arr[i]);
            if (!processedPos) arr[i]._render = render;
            else itemsData[i] = prevViewData[processedPos - 1];
            if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs' || arr[i].ty === 'no') {
                if (!processedPos) itemsData[i] = this.createStyleElement(arr[i], level);
                else itemsData[i].style.closed = arr[i].hd;
                if (arr[i]._render) {
                    if (itemsData[i].style.pElem.parentNode !== container) container.appendChild(itemsData[i].style.pElem);
                }
                ownStyles.push(itemsData[i].style);
            } else if (arr[i].ty === 'gr') {
                if (!processedPos) itemsData[i] = this.createGroupElement(arr[i]);
                else {
                    jLen = itemsData[i].it.length;
                    for(j = 0; j < jLen; j += 1)itemsData[i].prevViewData[j] = itemsData[i].it[j];
                }
                this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, itemsData[i].gr, level + 1, ownTransformers, render);
                if (arr[i]._render) {
                    if (itemsData[i].gr.parentNode !== container) container.appendChild(itemsData[i].gr);
                }
            } else if (arr[i].ty === 'tr') {
                if (!processedPos) itemsData[i] = this.createTransformElement(arr[i], container);
                currentTransform = itemsData[i].transform;
                ownTransformers.push(currentTransform);
            } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
                if (!processedPos) itemsData[i] = this.createShapeElement(arr[i], ownTransformers, level);
                this.setElementStyles(itemsData[i]);
            } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'ms' || arr[i].ty === 'pb' || arr[i].ty === 'zz' || arr[i].ty === 'op') {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    modifier.init(this, arr[i]);
                    itemsData[i] = modifier;
                    this.shapeModifiers.push(modifier);
                } else {
                    modifier = itemsData[i];
                    modifier.closed = false;
                }
                ownModifiers.push(modifier);
            } else if (arr[i].ty === 'rp') {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    itemsData[i] = modifier;
                    modifier.init(this, arr, i, itemsData);
                    this.shapeModifiers.push(modifier);
                    render = false;
                } else {
                    modifier = itemsData[i];
                    modifier.closed = true;
                }
                ownModifiers.push(modifier);
            }
            this.addProcessedElement(arr[i], i + 1);
        }
        len = ownStyles.length;
        for(i = 0; i < len; i += 1)ownStyles[i].closed = true;
        len = ownModifiers.length;
        for(i = 0; i < len; i += 1)ownModifiers[i].closed = true;
    };
    SVGShapeElement.prototype.renderInnerContent = function() {
        this.renderModifiers();
        var i;
        var len = this.stylesList.length;
        for(i = 0; i < len; i += 1)this.stylesList[i].reset();
        this.renderShape();
        for(i = 0; i < len; i += 1)if (this.stylesList[i]._mdf || this._isFirstFrame) {
            if (this.stylesList[i].msElem) {
                this.stylesList[i].msElem.setAttribute('d', this.stylesList[i].d);
                // Adding M0 0 fixes same mask bug on all browsers
                this.stylesList[i].d = 'M0 0' + this.stylesList[i].d;
            }
            this.stylesList[i].pElem.setAttribute('d', this.stylesList[i].d || 'M0 0');
        }
    };
    SVGShapeElement.prototype.renderShape = function() {
        var i;
        var len = this.animatedContents.length;
        var animatedContent;
        for(i = 0; i < len; i += 1){
            animatedContent = this.animatedContents[i];
            if ((this._isFirstFrame || animatedContent.element._isAnimated) && animatedContent.data !== true) animatedContent.fn(animatedContent.data, animatedContent.element, this._isFirstFrame);
        }
    };
    SVGShapeElement.prototype.destroy = function() {
        this.destroyBaseElement();
        this.shapesData = null;
        this.itemsData = null;
    };
    function LetterProps(o, sw, sc, fc, m, p) {
        this.o = o;
        this.sw = sw;
        this.sc = sc;
        this.fc = fc;
        this.m = m;
        this.p = p;
        this._mdf = {
            o: true,
            sw: !!sw,
            sc: !!sc,
            fc: !!fc,
            m: true,
            p: true
        };
    }
    LetterProps.prototype.update = function(o, sw, sc, fc, m, p) {
        this._mdf.o = false;
        this._mdf.sw = false;
        this._mdf.sc = false;
        this._mdf.fc = false;
        this._mdf.m = false;
        this._mdf.p = false;
        var updated = false;
        if (this.o !== o) {
            this.o = o;
            this._mdf.o = true;
            updated = true;
        }
        if (this.sw !== sw) {
            this.sw = sw;
            this._mdf.sw = true;
            updated = true;
        }
        if (this.sc !== sc) {
            this.sc = sc;
            this._mdf.sc = true;
            updated = true;
        }
        if (this.fc !== fc) {
            this.fc = fc;
            this._mdf.fc = true;
            updated = true;
        }
        if (this.m !== m) {
            this.m = m;
            this._mdf.m = true;
            updated = true;
        }
        if (p.length && (this.p[0] !== p[0] || this.p[1] !== p[1] || this.p[4] !== p[4] || this.p[5] !== p[5] || this.p[12] !== p[12] || this.p[13] !== p[13])) {
            this.p = p;
            this._mdf.p = true;
            updated = true;
        }
        return updated;
    };
    function TextProperty(elem, data) {
        this._frameId = initialDefaultFrame;
        this.pv = '';
        this.v = '';
        this.kf = false;
        this._isFirstFrame = true;
        this._mdf = false;
        if (data.d && data.d.sid) data.d = elem.globalData.slotManager.getProp(data.d);
        this.data = data;
        this.elem = elem;
        this.comp = this.elem.comp;
        this.keysIndex = 0;
        this.canResize = false;
        this.minimumFontSize = 1;
        this.effectsSequence = [];
        this.currentData = {
            ascent: 0,
            boxWidth: this.defaultBoxWidth,
            f: '',
            fStyle: '',
            fWeight: '',
            fc: '',
            j: '',
            justifyOffset: '',
            l: [],
            lh: 0,
            lineWidths: [],
            ls: '',
            of: '',
            s: '',
            sc: '',
            sw: 0,
            t: 0,
            tr: 0,
            sz: 0,
            ps: null,
            fillColorAnim: false,
            strokeColorAnim: false,
            strokeWidthAnim: false,
            yOffset: 0,
            finalSize: 0,
            finalText: [],
            finalLineHeight: 0,
            __complete: false
        };
        this.copyData(this.currentData, this.data.d.k[0].s);
        if (!this.searchProperty()) this.completeTextData(this.currentData);
    }
    TextProperty.prototype.defaultBoxWidth = [
        0,
        0
    ];
    TextProperty.prototype.copyData = function(obj, data) {
        for(var s in data)if (Object.prototype.hasOwnProperty.call(data, s)) obj[s] = data[s];
        return obj;
    };
    TextProperty.prototype.setCurrentData = function(data) {
        if (!data.__complete) this.completeTextData(data);
        this.currentData = data;
        this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth;
        this._mdf = true;
    };
    TextProperty.prototype.searchProperty = function() {
        return this.searchKeyframes();
    };
    TextProperty.prototype.searchKeyframes = function() {
        this.kf = this.data.d.k.length > 1;
        if (this.kf) this.addEffect(this.getKeyframeValue.bind(this));
        return this.kf;
    };
    TextProperty.prototype.addEffect = function(effectFunction) {
        this.effectsSequence.push(effectFunction);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.getValue = function(_finalValue) {
        if ((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !_finalValue) return;
        this.currentData.t = this.data.d.k[this.keysIndex].s.t;
        var currentValue = this.currentData;
        var currentIndex = this.keysIndex;
        if (this.lock) {
            this.setCurrentData(this.currentData);
            return;
        }
        this.lock = true;
        this._mdf = false;
        var i;
        var len = this.effectsSequence.length;
        var finalValue = _finalValue || this.data.d.k[this.keysIndex].s;
        for(i = 0; i < len; i += 1)// Checking if index changed to prevent creating a new object every time the expression updates.
        if (currentIndex !== this.keysIndex) finalValue = this.effectsSequence[i](finalValue, finalValue.t);
        else finalValue = this.effectsSequence[i](this.currentData, finalValue.t);
        if (currentValue !== finalValue) this.setCurrentData(finalValue);
        this.v = this.currentData;
        this.pv = this.v;
        this.lock = false;
        this.frameId = this.elem.globalData.frameId;
    };
    TextProperty.prototype.getKeyframeValue = function() {
        var textKeys = this.data.d.k;
        var frameNum = this.elem.comp.renderedFrame;
        var i = 0;
        var len = textKeys.length;
        while(i <= len - 1){
            if (i === len - 1 || textKeys[i + 1].t > frameNum) break;
            i += 1;
        }
        if (this.keysIndex !== i) this.keysIndex = i;
        return this.data.d.k[this.keysIndex].s;
    };
    TextProperty.prototype.buildFinalText = function(text) {
        var charactersArray = [];
        var i = 0;
        var len = text.length;
        var charCode;
        var secondCharCode;
        var shouldCombine = false;
        var shouldCombineNext = false;
        var currentChars = '';
        while(i < len){
            shouldCombine = shouldCombineNext;
            shouldCombineNext = false;
            charCode = text.charCodeAt(i);
            currentChars = text.charAt(i);
            if (FontManager.isCombinedCharacter(charCode)) shouldCombine = true;
            else if (charCode >= 0xD800 && charCode <= 0xDBFF) {
                if (FontManager.isRegionalFlag(text, i)) currentChars = text.substr(i, 14);
                else {
                    secondCharCode = text.charCodeAt(i + 1);
                    // It's a surrogate pair (this is the Low surrogate)
                    if (secondCharCode >= 0xDC00 && secondCharCode <= 0xDFFF) {
                        if (FontManager.isModifier(charCode, secondCharCode)) {
                            currentChars = text.substr(i, 2);
                            shouldCombine = true;
                        } else if (FontManager.isFlagEmoji(text.substr(i, 4))) currentChars = text.substr(i, 4);
                        else currentChars = text.substr(i, 2);
                    }
                }
            } else if (charCode > 0xDBFF) {
                secondCharCode = text.charCodeAt(i + 1);
                if (FontManager.isVariationSelector(charCode)) shouldCombine = true;
            } else if (FontManager.isZeroWidthJoiner(charCode)) {
                shouldCombine = true;
                shouldCombineNext = true;
            }
            if (shouldCombine) {
                charactersArray[charactersArray.length - 1] += currentChars;
                shouldCombine = false;
            } else charactersArray.push(currentChars);
            i += currentChars.length;
        }
        return charactersArray;
    };
    TextProperty.prototype.completeTextData = function(documentData) {
        documentData.__complete = true;
        var fontManager = this.elem.globalData.fontManager;
        var data = this.data;
        var letters = [];
        var i;
        var len;
        var newLineFlag;
        var index = 0;
        var val;
        var anchorGrouping = data.m.g;
        var currentSize = 0;
        var currentPos = 0;
        var currentLine = 0;
        var lineWidths = [];
        var lineWidth = 0;
        var maxLineWidth = 0;
        var j;
        var jLen;
        var fontData = fontManager.getFontByName(documentData.f);
        var charData;
        var cLength = 0;
        var fontProps = getFontProperties(fontData);
        documentData.fWeight = fontProps.weight;
        documentData.fStyle = fontProps.style;
        documentData.finalSize = documentData.s;
        documentData.finalText = this.buildFinalText(documentData.t);
        len = documentData.finalText.length;
        documentData.finalLineHeight = documentData.lh;
        var trackingOffset = documentData.tr / 1000 * documentData.finalSize;
        var charCode;
        if (documentData.sz) {
            var flag = true;
            var boxWidth = documentData.sz[0];
            var boxHeight = documentData.sz[1];
            var currentHeight;
            var finalText;
            while(flag){
                finalText = this.buildFinalText(documentData.t);
                currentHeight = 0;
                lineWidth = 0;
                len = finalText.length;
                trackingOffset = documentData.tr / 1000 * documentData.finalSize;
                var lastSpaceIndex = -1;
                for(i = 0; i < len; i += 1){
                    charCode = finalText[i].charCodeAt(0);
                    newLineFlag = false;
                    if (finalText[i] === ' ') lastSpaceIndex = i;
                    else if (charCode === 13 || charCode === 3) {
                        lineWidth = 0;
                        newLineFlag = true;
                        currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
                    }
                    if (fontManager.chars) {
                        charData = fontManager.getCharData(finalText[i], fontData.fStyle, fontData.fFamily);
                        cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
                    } else // tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
                    cLength = fontManager.measureText(finalText[i], documentData.f, documentData.finalSize);
                    if (lineWidth + cLength > boxWidth && finalText[i] !== ' ') {
                        if (lastSpaceIndex === -1) len += 1;
                        else i = lastSpaceIndex;
                        currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
                        finalText.splice(i, lastSpaceIndex === i ? 1 : 0, '\r');
                        // finalText = finalText.substr(0,i) + "\r" + finalText.substr(i === lastSpaceIndex ? i + 1 : i);
                        lastSpaceIndex = -1;
                        lineWidth = 0;
                    } else {
                        lineWidth += cLength;
                        lineWidth += trackingOffset;
                    }
                }
                currentHeight += fontData.ascent * documentData.finalSize / 100;
                if (this.canResize && documentData.finalSize > this.minimumFontSize && boxHeight < currentHeight) {
                    documentData.finalSize -= 1;
                    documentData.finalLineHeight = documentData.finalSize * documentData.lh / documentData.s;
                } else {
                    documentData.finalText = finalText;
                    len = documentData.finalText.length;
                    flag = false;
                }
            }
        }
        lineWidth = -trackingOffset;
        cLength = 0;
        var uncollapsedSpaces = 0;
        var currentChar;
        for(i = 0; i < len; i += 1){
            newLineFlag = false;
            currentChar = documentData.finalText[i];
            charCode = currentChar.charCodeAt(0);
            if (charCode === 13 || charCode === 3) {
                uncollapsedSpaces = 0;
                lineWidths.push(lineWidth);
                maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
                lineWidth = -2 * trackingOffset;
                val = '';
                newLineFlag = true;
                currentLine += 1;
            } else val = currentChar;
            if (fontManager.chars) {
                charData = fontManager.getCharData(currentChar, fontData.fStyle, fontManager.getFontByName(documentData.f).fFamily);
                cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
            } else // var charWidth = fontManager.measureText(val, documentData.f, documentData.finalSize);
            // tCanvasHelper.font = documentData.finalSize + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
            cLength = fontManager.measureText(val, documentData.f, documentData.finalSize);
            //
            if (currentChar === ' ') uncollapsedSpaces += cLength + trackingOffset;
            else {
                lineWidth += cLength + trackingOffset + uncollapsedSpaces;
                uncollapsedSpaces = 0;
            }
            letters.push({
                l: cLength,
                an: cLength,
                add: currentSize,
                n: newLineFlag,
                anIndexes: [],
                val: val,
                line: currentLine,
                animatorJustifyOffset: 0
            });
            if (anchorGrouping == 2) {
                // eslint-disable-line eqeqeq
                currentSize += cLength;
                if (val === '' || val === ' ' || i === len - 1) {
                    if (val === '' || val === ' ') currentSize -= cLength;
                    while(currentPos <= i){
                        letters[currentPos].an = currentSize;
                        letters[currentPos].ind = index;
                        letters[currentPos].extra = cLength;
                        currentPos += 1;
                    }
                    index += 1;
                    currentSize = 0;
                }
            } else if (anchorGrouping == 3) {
                // eslint-disable-line eqeqeq
                currentSize += cLength;
                if (val === '' || i === len - 1) {
                    if (val === '') currentSize -= cLength;
                    while(currentPos <= i){
                        letters[currentPos].an = currentSize;
                        letters[currentPos].ind = index;
                        letters[currentPos].extra = cLength;
                        currentPos += 1;
                    }
                    currentSize = 0;
                    index += 1;
                }
            } else {
                letters[index].ind = index;
                letters[index].extra = 0;
                index += 1;
            }
        }
        documentData.l = letters;
        maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
        lineWidths.push(lineWidth);
        if (documentData.sz) {
            documentData.boxWidth = documentData.sz[0];
            documentData.justifyOffset = 0;
        } else {
            documentData.boxWidth = maxLineWidth;
            switch(documentData.j){
                case 1:
                    documentData.justifyOffset = -documentData.boxWidth;
                    break;
                case 2:
                    documentData.justifyOffset = -documentData.boxWidth / 2;
                    break;
                default:
                    documentData.justifyOffset = 0;
            }
        }
        documentData.lineWidths = lineWidths;
        var animators = data.a;
        var animatorData;
        var letterData;
        jLen = animators.length;
        var based;
        var ind;
        var indexes = [];
        for(j = 0; j < jLen; j += 1){
            animatorData = animators[j];
            if (animatorData.a.sc) documentData.strokeColorAnim = true;
            if (animatorData.a.sw) documentData.strokeWidthAnim = true;
            if (animatorData.a.fc || animatorData.a.fh || animatorData.a.fs || animatorData.a.fb) documentData.fillColorAnim = true;
            ind = 0;
            based = animatorData.s.b;
            for(i = 0; i < len; i += 1){
                letterData = letters[i];
                letterData.anIndexes[j] = ind;
                if (based == 1 && letterData.val !== '' || based == 2 && letterData.val !== '' && letterData.val !== ' ' || based == 3 && (letterData.n || letterData.val == ' ' || i == len - 1) || based == 4 && (letterData.n || i == len - 1)) {
                    // eslint-disable-line eqeqeq
                    if (animatorData.s.rn === 1) indexes.push(ind);
                    ind += 1;
                }
            }
            data.a[j].s.totalChars = ind;
            var currentInd = -1;
            var newInd;
            if (animatorData.s.rn === 1) for(i = 0; i < len; i += 1){
                letterData = letters[i];
                if (currentInd != letterData.anIndexes[j]) {
                    // eslint-disable-line eqeqeq
                    currentInd = letterData.anIndexes[j];
                    newInd = indexes.splice(Math.floor(Math.random() * indexes.length), 1)[0];
                }
                letterData.anIndexes[j] = newInd;
            }
        }
        documentData.yOffset = documentData.finalLineHeight || documentData.finalSize * 1.2;
        documentData.ls = documentData.ls || 0;
        documentData.ascent = fontData.ascent * documentData.finalSize / 100;
    };
    TextProperty.prototype.updateDocumentData = function(newData, index) {
        index = index === undefined ? this.keysIndex : index;
        var dData = this.copyData({}, this.data.d.k[index].s);
        dData = this.copyData(dData, newData);
        this.data.d.k[index].s = dData;
        this.recalculate(index);
        this.setCurrentData(dData);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.recalculate = function(index) {
        var dData = this.data.d.k[index].s;
        dData.__complete = false;
        this.keysIndex = 0;
        this._isFirstFrame = true;
        this.getValue(dData);
    };
    TextProperty.prototype.canResizeFont = function(_canResize) {
        this.canResize = _canResize;
        this.recalculate(this.keysIndex);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.setMinimumFontSize = function(_fontValue) {
        this.minimumFontSize = Math.floor(_fontValue) || 1;
        this.recalculate(this.keysIndex);
        this.elem.addDynamicProperty(this);
    };
    var TextSelectorProp = function() {
        var max = Math.max;
        var min = Math.min;
        var floor = Math.floor;
        function TextSelectorPropFactory(elem, data) {
            this._currentTextLength = -1;
            this.k = false;
            this.data = data;
            this.elem = elem;
            this.comp = elem.comp;
            this.finalS = 0;
            this.finalE = 0;
            this.initDynamicPropertyContainer(elem);
            this.s = PropertyFactory.getProp(elem, data.s || {
                k: 0
            }, 0, 0, this);
            if ('e' in data) this.e = PropertyFactory.getProp(elem, data.e, 0, 0, this);
            else this.e = {
                v: 100
            };
            this.o = PropertyFactory.getProp(elem, data.o || {
                k: 0
            }, 0, 0, this);
            this.xe = PropertyFactory.getProp(elem, data.xe || {
                k: 0
            }, 0, 0, this);
            this.ne = PropertyFactory.getProp(elem, data.ne || {
                k: 0
            }, 0, 0, this);
            this.sm = PropertyFactory.getProp(elem, data.sm || {
                k: 100
            }, 0, 0, this);
            this.a = PropertyFactory.getProp(elem, data.a, 0, 0.01, this);
            if (!this.dynamicProperties.length) this.getValue();
        }
        TextSelectorPropFactory.prototype = {
            getMult: function getMult(ind) {
                if (this._currentTextLength !== this.elem.textProperty.currentData.l.length) this.getValue();
                var x1 = 0;
                var y1 = 0;
                var x2 = 1;
                var y2 = 1;
                if (this.ne.v > 0) x1 = this.ne.v / 100.0;
                else y1 = -this.ne.v / 100.0;
                if (this.xe.v > 0) x2 = 1.0 - this.xe.v / 100.0;
                else y2 = 1.0 + this.xe.v / 100.0;
                var easer = BezierFactory.getBezierEasing(x1, y1, x2, y2).get;
                var mult = 0;
                var s = this.finalS;
                var e = this.finalE;
                var type = this.data.sh;
                if (type === 2) {
                    if (e === s) mult = ind >= e ? 1 : 0;
                    else mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
                    mult = easer(mult);
                } else if (type === 3) {
                    if (e === s) mult = ind >= e ? 0 : 1;
                    else mult = 1 - max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
                    mult = easer(mult);
                } else if (type === 4) {
                    if (e === s) mult = 0;
                    else {
                        mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
                        if (mult < 0.5) mult *= 2;
                        else mult = 1 - 2 * (mult - 0.5);
                    }
                    mult = easer(mult);
                } else if (type === 5) {
                    if (e === s) mult = 0;
                    else {
                        var tot = e - s;
                        /* ind += 0.5;
                      mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind; */ ind = min(max(0, ind + 0.5 - s), e - s);
                        var x = -tot / 2 + ind;
                        var a = tot / 2;
                        mult = Math.sqrt(1 - x * x / (a * a));
                    }
                    mult = easer(mult);
                } else if (type === 6) {
                    if (e === s) mult = 0;
                    else {
                        ind = min(max(0, ind + 0.5 - s), e - s);
                        mult = (1 + Math.cos(Math.PI + Math.PI * 2 * ind / (e - s))) / 2; // eslint-disable-line
                    }
                    mult = easer(mult);
                } else {
                    if (ind >= floor(s)) {
                        if (ind - s < 0) mult = max(0, min(min(e, 1) - (s - ind), 1));
                        else mult = max(0, min(e - ind, 1));
                    }
                    mult = easer(mult);
                }
                // Smoothness implementation.
                // The smoothness represents a reduced range of the original [0; 1] range.
                // if smoothness is 25%, the new range will be [0.375; 0.625]
                // Steps are:
                // - find the lower value of the new range (threshold)
                // - if multiplier is smaller than that value, floor it to 0
                // - if it is larger,
                //     - subtract the threshold
                //     - divide it by the smoothness (this will return the range to [0; 1])
                // Note: If it doesn't work on some scenarios, consider applying it before the easer.
                if (this.sm.v !== 100) {
                    var smoothness = this.sm.v * 0.01;
                    if (smoothness === 0) smoothness = 0.00000001;
                    var threshold = 0.5 - smoothness * 0.5;
                    if (mult < threshold) mult = 0;
                    else {
                        mult = (mult - threshold) / smoothness;
                        if (mult > 1) mult = 1;
                    }
                }
                return mult * this.a.v;
            },
            getValue: function getValue(newCharsFlag) {
                this.iterateDynamicProperties();
                this._mdf = newCharsFlag || this._mdf;
                this._currentTextLength = this.elem.textProperty.currentData.l.length || 0;
                if (newCharsFlag && this.data.r === 2) this.e.v = this._currentTextLength;
                var divisor = this.data.r === 2 ? 1 : 100 / this.data.totalChars;
                var o = this.o.v / divisor;
                var s = this.s.v / divisor + o;
                var e = this.e.v / divisor + o;
                if (s > e) {
                    var _s = s;
                    s = e;
                    e = _s;
                }
                this.finalS = s;
                this.finalE = e;
            }
        };
        extendPrototype([
            DynamicPropertyContainer
        ], TextSelectorPropFactory);
        function getTextSelectorProp(elem, data, arr) {
            return new TextSelectorPropFactory(elem, data, arr);
        }
        return {
            getTextSelectorProp: getTextSelectorProp
        };
    }();
    function TextAnimatorDataProperty(elem, animatorProps, container) {
        var defaultData = {
            propType: false
        };
        var getProp = PropertyFactory.getProp;
        var textAnimatorAnimatables = animatorProps.a;
        this.a = {
            r: textAnimatorAnimatables.r ? getProp(elem, textAnimatorAnimatables.r, 0, degToRads, container) : defaultData,
            rx: textAnimatorAnimatables.rx ? getProp(elem, textAnimatorAnimatables.rx, 0, degToRads, container) : defaultData,
            ry: textAnimatorAnimatables.ry ? getProp(elem, textAnimatorAnimatables.ry, 0, degToRads, container) : defaultData,
            sk: textAnimatorAnimatables.sk ? getProp(elem, textAnimatorAnimatables.sk, 0, degToRads, container) : defaultData,
            sa: textAnimatorAnimatables.sa ? getProp(elem, textAnimatorAnimatables.sa, 0, degToRads, container) : defaultData,
            s: textAnimatorAnimatables.s ? getProp(elem, textAnimatorAnimatables.s, 1, 0.01, container) : defaultData,
            a: textAnimatorAnimatables.a ? getProp(elem, textAnimatorAnimatables.a, 1, 0, container) : defaultData,
            o: textAnimatorAnimatables.o ? getProp(elem, textAnimatorAnimatables.o, 0, 0.01, container) : defaultData,
            p: textAnimatorAnimatables.p ? getProp(elem, textAnimatorAnimatables.p, 1, 0, container) : defaultData,
            sw: textAnimatorAnimatables.sw ? getProp(elem, textAnimatorAnimatables.sw, 0, 0, container) : defaultData,
            sc: textAnimatorAnimatables.sc ? getProp(elem, textAnimatorAnimatables.sc, 1, 0, container) : defaultData,
            fc: textAnimatorAnimatables.fc ? getProp(elem, textAnimatorAnimatables.fc, 1, 0, container) : defaultData,
            fh: textAnimatorAnimatables.fh ? getProp(elem, textAnimatorAnimatables.fh, 0, 0, container) : defaultData,
            fs: textAnimatorAnimatables.fs ? getProp(elem, textAnimatorAnimatables.fs, 0, 0.01, container) : defaultData,
            fb: textAnimatorAnimatables.fb ? getProp(elem, textAnimatorAnimatables.fb, 0, 0.01, container) : defaultData,
            t: textAnimatorAnimatables.t ? getProp(elem, textAnimatorAnimatables.t, 0, 0, container) : defaultData
        };
        this.s = TextSelectorProp.getTextSelectorProp(elem, animatorProps.s, container);
        this.s.t = animatorProps.s.t;
    }
    function TextAnimatorProperty(textData, renderType, elem) {
        this._isFirstFrame = true;
        this._hasMaskedPath = false;
        this._frameId = -1;
        this._textData = textData;
        this._renderType = renderType;
        this._elem = elem;
        this._animatorsData = createSizedArray(this._textData.a.length);
        this._pathData = {};
        this._moreOptions = {
            alignment: {}
        };
        this.renderedLetters = [];
        this.lettersChangedFlag = false;
        this.initDynamicPropertyContainer(elem);
    }
    TextAnimatorProperty.prototype.searchProperties = function() {
        var i;
        var len = this._textData.a.length;
        var animatorProps;
        var getProp = PropertyFactory.getProp;
        for(i = 0; i < len; i += 1){
            animatorProps = this._textData.a[i];
            this._animatorsData[i] = new TextAnimatorDataProperty(this._elem, animatorProps, this);
        }
        if (this._textData.p && 'm' in this._textData.p) {
            this._pathData = {
                a: getProp(this._elem, this._textData.p.a, 0, 0, this),
                f: getProp(this._elem, this._textData.p.f, 0, 0, this),
                l: getProp(this._elem, this._textData.p.l, 0, 0, this),
                r: getProp(this._elem, this._textData.p.r, 0, 0, this),
                p: getProp(this._elem, this._textData.p.p, 0, 0, this),
                m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
            };
            this._hasMaskedPath = true;
        } else this._hasMaskedPath = false;
        this._moreOptions.alignment = getProp(this._elem, this._textData.m.a, 1, 0, this);
    };
    TextAnimatorProperty.prototype.getMeasures = function(documentData, lettersChangedFlag) {
        this.lettersChangedFlag = lettersChangedFlag;
        if (!this._mdf && !this._isFirstFrame && !lettersChangedFlag && (!this._hasMaskedPath || !this._pathData.m._mdf)) return;
        this._isFirstFrame = false;
        var alignment = this._moreOptions.alignment.v;
        var animators = this._animatorsData;
        var textData = this._textData;
        var matrixHelper = this.mHelper;
        var renderType = this._renderType;
        var renderedLettersCount = this.renderedLetters.length;
        var xPos;
        var yPos;
        var i;
        var len;
        var letters = documentData.l;
        var pathInfo;
        var currentLength;
        var currentPoint;
        var segmentLength;
        var flag;
        var pointInd;
        var segmentInd;
        var prevPoint;
        var points;
        var segments;
        var partialLength;
        var totalLength;
        var perc;
        var tanAngle;
        var mask;
        if (this._hasMaskedPath) {
            mask = this._pathData.m;
            if (!this._pathData.n || this._pathData._mdf) {
                var paths = mask.v;
                if (this._pathData.r.v) paths = paths.reverse();
                // TODO: release bezier data cached from previous pathInfo: this._pathData.pi
                pathInfo = {
                    tLength: 0,
                    segments: []
                };
                len = paths._length - 1;
                var bezierData;
                totalLength = 0;
                for(i = 0; i < len; i += 1){
                    bezierData = bez.buildBezierData(paths.v[i], paths.v[i + 1], [
                        paths.o[i][0] - paths.v[i][0],
                        paths.o[i][1] - paths.v[i][1]
                    ], [
                        paths.i[i + 1][0] - paths.v[i + 1][0],
                        paths.i[i + 1][1] - paths.v[i + 1][1]
                    ]);
                    pathInfo.tLength += bezierData.segmentLength;
                    pathInfo.segments.push(bezierData);
                    totalLength += bezierData.segmentLength;
                }
                i = len;
                if (mask.v.c) {
                    bezierData = bez.buildBezierData(paths.v[i], paths.v[0], [
                        paths.o[i][0] - paths.v[i][0],
                        paths.o[i][1] - paths.v[i][1]
                    ], [
                        paths.i[0][0] - paths.v[0][0],
                        paths.i[0][1] - paths.v[0][1]
                    ]);
                    pathInfo.tLength += bezierData.segmentLength;
                    pathInfo.segments.push(bezierData);
                    totalLength += bezierData.segmentLength;
                }
                this._pathData.pi = pathInfo;
            }
            pathInfo = this._pathData.pi;
            currentLength = this._pathData.f.v;
            segmentInd = 0;
            pointInd = 1;
            segmentLength = 0;
            flag = true;
            segments = pathInfo.segments;
            if (currentLength < 0 && mask.v.c) {
                if (pathInfo.tLength < Math.abs(currentLength)) currentLength = -Math.abs(currentLength) % pathInfo.tLength;
                segmentInd = segments.length - 1;
                points = segments[segmentInd].points;
                pointInd = points.length - 1;
                while(currentLength < 0){
                    currentLength += points[pointInd].partialLength;
                    pointInd -= 1;
                    if (pointInd < 0) {
                        segmentInd -= 1;
                        points = segments[segmentInd].points;
                        pointInd = points.length - 1;
                    }
                }
            }
            points = segments[segmentInd].points;
            prevPoint = points[pointInd - 1];
            currentPoint = points[pointInd];
            partialLength = currentPoint.partialLength;
        }
        len = letters.length;
        xPos = 0;
        yPos = 0;
        var yOff = documentData.finalSize * 1.2 * 0.714;
        var firstLine = true;
        var animatorProps;
        var animatorSelector;
        var j;
        var jLen;
        var letterValue;
        jLen = animators.length;
        var mult;
        var ind = -1;
        var offf;
        var xPathPos;
        var yPathPos;
        var initPathPos = currentLength;
        var initSegmentInd = segmentInd;
        var initPointInd = pointInd;
        var currentLine = -1;
        var elemOpacity;
        var sc;
        var sw;
        var fc;
        var k;
        var letterSw;
        var letterSc;
        var letterFc;
        var letterM = '';
        var letterP = this.defaultPropsArray;
        var letterO;
        //
        if (documentData.j === 2 || documentData.j === 1) {
            var animatorJustifyOffset = 0;
            var animatorFirstCharOffset = 0;
            var justifyOffsetMult = documentData.j === 2 ? -0.5 : -1;
            var lastIndex = 0;
            var isNewLine = true;
            for(i = 0; i < len; i += 1)if (letters[i].n) {
                if (animatorJustifyOffset) animatorJustifyOffset += animatorFirstCharOffset;
                while(lastIndex < i){
                    letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
                    lastIndex += 1;
                }
                animatorJustifyOffset = 0;
                isNewLine = true;
            } else {
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.t.propType) {
                        if (isNewLine && documentData.j === 2) animatorFirstCharOffset += animatorProps.t.v * justifyOffsetMult;
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (mult.length) animatorJustifyOffset += animatorProps.t.v * mult[0] * justifyOffsetMult;
                        else animatorJustifyOffset += animatorProps.t.v * mult * justifyOffsetMult;
                    }
                }
                isNewLine = false;
            }
            if (animatorJustifyOffset) animatorJustifyOffset += animatorFirstCharOffset;
            while(lastIndex < i){
                letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
                lastIndex += 1;
            }
        }
        //
        for(i = 0; i < len; i += 1){
            matrixHelper.reset();
            elemOpacity = 1;
            if (letters[i].n) {
                xPos = 0;
                yPos += documentData.yOffset;
                yPos += firstLine ? 1 : 0;
                currentLength = initPathPos;
                firstLine = false;
                if (this._hasMaskedPath) {
                    segmentInd = initSegmentInd;
                    pointInd = initPointInd;
                    points = segments[segmentInd].points;
                    prevPoint = points[pointInd - 1];
                    currentPoint = points[pointInd];
                    partialLength = currentPoint.partialLength;
                    segmentLength = 0;
                }
                letterM = '';
                letterFc = '';
                letterSw = '';
                letterO = '';
                letterP = this.defaultPropsArray;
            } else {
                if (this._hasMaskedPath) {
                    if (currentLine !== letters[i].line) {
                        switch(documentData.j){
                            case 1:
                                currentLength += totalLength - documentData.lineWidths[letters[i].line];
                                break;
                            case 2:
                                currentLength += (totalLength - documentData.lineWidths[letters[i].line]) / 2;
                                break;
                            default:
                                break;
                        }
                        currentLine = letters[i].line;
                    }
                    if (ind !== letters[i].ind) {
                        if (letters[ind]) currentLength += letters[ind].extra;
                        currentLength += letters[i].an / 2;
                        ind = letters[i].ind;
                    }
                    currentLength += alignment[0] * letters[i].an * 0.005;
                    var animatorOffset = 0;
                    for(j = 0; j < jLen; j += 1){
                        animatorProps = animators[j].a;
                        if (animatorProps.p.propType) {
                            animatorSelector = animators[j].s;
                            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                            if (mult.length) animatorOffset += animatorProps.p.v[0] * mult[0];
                            else animatorOffset += animatorProps.p.v[0] * mult;
                        }
                        if (animatorProps.a.propType) {
                            animatorSelector = animators[j].s;
                            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                            if (mult.length) animatorOffset += animatorProps.a.v[0] * mult[0];
                            else animatorOffset += animatorProps.a.v[0] * mult;
                        }
                    }
                    flag = true;
                    // Force alignment only works with a single line for now
                    if (this._pathData.a.v) {
                        currentLength = letters[0].an * 0.5 + (totalLength - this._pathData.f.v - letters[0].an * 0.5 - letters[letters.length - 1].an * 0.5) * ind / (len - 1);
                        currentLength += this._pathData.f.v;
                    }
                    while(flag){
                        if (segmentLength + partialLength >= currentLength + animatorOffset || !points) {
                            perc = (currentLength + animatorOffset - segmentLength) / currentPoint.partialLength;
                            xPathPos = prevPoint.point[0] + (currentPoint.point[0] - prevPoint.point[0]) * perc;
                            yPathPos = prevPoint.point[1] + (currentPoint.point[1] - prevPoint.point[1]) * perc;
                            matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -(alignment[1] * yOff) * 0.01);
                            flag = false;
                        } else if (points) {
                            segmentLength += currentPoint.partialLength;
                            pointInd += 1;
                            if (pointInd >= points.length) {
                                pointInd = 0;
                                segmentInd += 1;
                                if (!segments[segmentInd]) {
                                    if (mask.v.c) {
                                        pointInd = 0;
                                        segmentInd = 0;
                                        points = segments[segmentInd].points;
                                    } else {
                                        segmentLength -= currentPoint.partialLength;
                                        points = null;
                                    }
                                } else points = segments[segmentInd].points;
                            }
                            if (points) {
                                prevPoint = currentPoint;
                                currentPoint = points[pointInd];
                                partialLength = currentPoint.partialLength;
                            }
                        }
                    }
                    offf = letters[i].an / 2 - letters[i].add;
                    matrixHelper.translate(-offf, 0, 0);
                } else {
                    offf = letters[i].an / 2 - letters[i].add;
                    matrixHelper.translate(-offf, 0, 0);
                    // Grouping alignment
                    matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -alignment[1] * yOff * 0.01, 0);
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.t.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        // This condition is to prevent applying tracking to first character in each line. Might be better to use a boolean "isNewLine"
                        if (xPos !== 0 || documentData.j !== 0) {
                            if (this._hasMaskedPath) {
                                if (mult.length) currentLength += animatorProps.t.v * mult[0];
                                else currentLength += animatorProps.t.v * mult;
                            } else if (mult.length) xPos += animatorProps.t.v * mult[0];
                            else xPos += animatorProps.t.v * mult;
                        }
                    }
                }
                if (documentData.strokeWidthAnim) sw = documentData.sw || 0;
                if (documentData.strokeColorAnim) {
                    if (documentData.sc) sc = [
                        documentData.sc[0],
                        documentData.sc[1],
                        documentData.sc[2]
                    ];
                    else sc = [
                        0,
                        0,
                        0
                    ];
                }
                if (documentData.fillColorAnim && documentData.fc) fc = [
                    documentData.fc[0],
                    documentData.fc[1],
                    documentData.fc[2]
                ];
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.a.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (mult.length) matrixHelper.translate(-animatorProps.a.v[0] * mult[0], -animatorProps.a.v[1] * mult[1], animatorProps.a.v[2] * mult[2]);
                        else matrixHelper.translate(-animatorProps.a.v[0] * mult, -animatorProps.a.v[1] * mult, animatorProps.a.v[2] * mult);
                    }
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.s.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (mult.length) matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult[0], 1 + (animatorProps.s.v[1] - 1) * mult[1], 1);
                        else matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult, 1 + (animatorProps.s.v[1] - 1) * mult, 1);
                    }
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    animatorSelector = animators[j].s;
                    mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                    if (animatorProps.sk.propType) {
                        if (mult.length) matrixHelper.skewFromAxis(-animatorProps.sk.v * mult[0], animatorProps.sa.v * mult[1]);
                        else matrixHelper.skewFromAxis(-animatorProps.sk.v * mult, animatorProps.sa.v * mult);
                    }
                    if (animatorProps.r.propType) {
                        if (mult.length) matrixHelper.rotateZ(-animatorProps.r.v * mult[2]);
                        else matrixHelper.rotateZ(-animatorProps.r.v * mult);
                    }
                    if (animatorProps.ry.propType) {
                        if (mult.length) matrixHelper.rotateY(animatorProps.ry.v * mult[1]);
                        else matrixHelper.rotateY(animatorProps.ry.v * mult);
                    }
                    if (animatorProps.rx.propType) {
                        if (mult.length) matrixHelper.rotateX(animatorProps.rx.v * mult[0]);
                        else matrixHelper.rotateX(animatorProps.rx.v * mult);
                    }
                    if (animatorProps.o.propType) {
                        if (mult.length) elemOpacity += (animatorProps.o.v * mult[0] - elemOpacity) * mult[0];
                        else elemOpacity += (animatorProps.o.v * mult - elemOpacity) * mult;
                    }
                    if (documentData.strokeWidthAnim && animatorProps.sw.propType) {
                        if (mult.length) sw += animatorProps.sw.v * mult[0];
                        else sw += animatorProps.sw.v * mult;
                    }
                    if (documentData.strokeColorAnim && animatorProps.sc.propType) {
                        for(k = 0; k < 3; k += 1)if (mult.length) sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult[0];
                        else sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult;
                    }
                    if (documentData.fillColorAnim && documentData.fc) {
                        if (animatorProps.fc.propType) {
                            for(k = 0; k < 3; k += 1)if (mult.length) fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult[0];
                            else fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult;
                        }
                        if (animatorProps.fh.propType) {
                            if (mult.length) fc = addHueToRGB(fc, animatorProps.fh.v * mult[0]);
                            else fc = addHueToRGB(fc, animatorProps.fh.v * mult);
                        }
                        if (animatorProps.fs.propType) {
                            if (mult.length) fc = addSaturationToRGB(fc, animatorProps.fs.v * mult[0]);
                            else fc = addSaturationToRGB(fc, animatorProps.fs.v * mult);
                        }
                        if (animatorProps.fb.propType) {
                            if (mult.length) fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult[0]);
                            else fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult);
                        }
                    }
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.p.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (this._hasMaskedPath) {
                            if (mult.length) matrixHelper.translate(0, animatorProps.p.v[1] * mult[0], -animatorProps.p.v[2] * mult[1]);
                            else matrixHelper.translate(0, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
                        } else if (mult.length) matrixHelper.translate(animatorProps.p.v[0] * mult[0], animatorProps.p.v[1] * mult[1], -animatorProps.p.v[2] * mult[2]);
                        else matrixHelper.translate(animatorProps.p.v[0] * mult, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
                    }
                }
                if (documentData.strokeWidthAnim) letterSw = sw < 0 ? 0 : sw;
                if (documentData.strokeColorAnim) letterSc = 'rgb(' + Math.round(sc[0] * 255) + ',' + Math.round(sc[1] * 255) + ',' + Math.round(sc[2] * 255) + ')';
                if (documentData.fillColorAnim && documentData.fc) letterFc = 'rgb(' + Math.round(fc[0] * 255) + ',' + Math.round(fc[1] * 255) + ',' + Math.round(fc[2] * 255) + ')';
                if (this._hasMaskedPath) {
                    matrixHelper.translate(0, -documentData.ls);
                    matrixHelper.translate(0, alignment[1] * yOff * 0.01 + yPos, 0);
                    if (this._pathData.p.v) {
                        tanAngle = (currentPoint.point[1] - prevPoint.point[1]) / (currentPoint.point[0] - prevPoint.point[0]);
                        var rot = Math.atan(tanAngle) * 180 / Math.PI;
                        if (currentPoint.point[0] < prevPoint.point[0]) rot += 180;
                        matrixHelper.rotate(-rot * Math.PI / 180);
                    }
                    matrixHelper.translate(xPathPos, yPathPos, 0);
                    currentLength -= alignment[0] * letters[i].an * 0.005;
                    if (letters[i + 1] && ind !== letters[i + 1].ind) {
                        currentLength += letters[i].an / 2;
                        currentLength += documentData.tr * 0.001 * documentData.finalSize;
                    }
                } else {
                    matrixHelper.translate(xPos, yPos, 0);
                    if (documentData.ps) // matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
                    matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
                    switch(documentData.j){
                        case 1:
                            matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]), 0, 0);
                            break;
                        case 2:
                            matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]) / 2, 0, 0);
                            break;
                        default:
                            break;
                    }
                    matrixHelper.translate(0, -documentData.ls);
                    matrixHelper.translate(offf, 0, 0);
                    matrixHelper.translate(alignment[0] * letters[i].an * 0.005, alignment[1] * yOff * 0.01, 0);
                    xPos += letters[i].l + documentData.tr * 0.001 * documentData.finalSize;
                }
                if (renderType === 'html') letterM = matrixHelper.toCSS();
                else if (renderType === 'svg') letterM = matrixHelper.to2dCSS();
                else letterP = [
                    matrixHelper.props[0],
                    matrixHelper.props[1],
                    matrixHelper.props[2],
                    matrixHelper.props[3],
                    matrixHelper.props[4],
                    matrixHelper.props[5],
                    matrixHelper.props[6],
                    matrixHelper.props[7],
                    matrixHelper.props[8],
                    matrixHelper.props[9],
                    matrixHelper.props[10],
                    matrixHelper.props[11],
                    matrixHelper.props[12],
                    matrixHelper.props[13],
                    matrixHelper.props[14],
                    matrixHelper.props[15]
                ];
                letterO = elemOpacity;
            }
            if (renderedLettersCount <= i) {
                letterValue = new LetterProps(letterO, letterSw, letterSc, letterFc, letterM, letterP);
                this.renderedLetters.push(letterValue);
                renderedLettersCount += 1;
                this.lettersChangedFlag = true;
            } else {
                letterValue = this.renderedLetters[i];
                this.lettersChangedFlag = letterValue.update(letterO, letterSw, letterSc, letterFc, letterM, letterP) || this.lettersChangedFlag;
            }
        }
    };
    TextAnimatorProperty.prototype.getValue = function() {
        if (this._elem.globalData.frameId === this._frameId) return;
        this._frameId = this._elem.globalData.frameId;
        this.iterateDynamicProperties();
    };
    TextAnimatorProperty.prototype.mHelper = new Matrix();
    TextAnimatorProperty.prototype.defaultPropsArray = [];
    extendPrototype([
        DynamicPropertyContainer
    ], TextAnimatorProperty);
    function ITextElement() {}
    ITextElement.prototype.initElement = function(data, globalData, comp) {
        this.lettersChangedFlag = true;
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.textProperty = new TextProperty(this, data.t, this.dynamicProperties);
        this.textAnimator = new TextAnimatorProperty(data.t, this.renderType, this);
        this.initTransform(data, globalData, comp);
        this.initHierarchy();
        this.initRenderable();
        this.initRendererElement();
        this.createContainerElements();
        this.createRenderableComponents();
        this.createContent();
        this.hide();
        this.textAnimator.searchProperties(this.dynamicProperties);
    };
    ITextElement.prototype.prepareFrame = function(num) {
        this._mdf = false;
        this.prepareRenderableFrame(num);
        this.prepareProperties(num, this.isInRange);
    };
    ITextElement.prototype.createPathShape = function(matrixHelper, shapes) {
        var j;
        var jLen = shapes.length;
        var pathNodes;
        var shapeStr = '';
        for(j = 0; j < jLen; j += 1)if (shapes[j].ty === 'sh') {
            pathNodes = shapes[j].ks.k;
            shapeStr += buildShapeString(pathNodes, pathNodes.i.length, true, matrixHelper);
        }
        return shapeStr;
    };
    ITextElement.prototype.updateDocumentData = function(newData, index) {
        this.textProperty.updateDocumentData(newData, index);
    };
    ITextElement.prototype.canResizeFont = function(_canResize) {
        this.textProperty.canResizeFont(_canResize);
    };
    ITextElement.prototype.setMinimumFontSize = function(_fontSize) {
        this.textProperty.setMinimumFontSize(_fontSize);
    };
    ITextElement.prototype.applyTextPropertiesToMatrix = function(documentData, matrixHelper, lineNumber, xPos, yPos) {
        if (documentData.ps) matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
        matrixHelper.translate(0, -documentData.ls, 0);
        switch(documentData.j){
            case 1:
                matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]), 0, 0);
                break;
            case 2:
                matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]) / 2, 0, 0);
                break;
            default:
                break;
        }
        matrixHelper.translate(xPos, yPos, 0);
    };
    ITextElement.prototype.buildColor = function(colorData) {
        return 'rgb(' + Math.round(colorData[0] * 255) + ',' + Math.round(colorData[1] * 255) + ',' + Math.round(colorData[2] * 255) + ')';
    };
    ITextElement.prototype.emptyProp = new LetterProps();
    ITextElement.prototype.destroy = function() {};
    ITextElement.prototype.validateText = function() {
        if (this.textProperty._mdf || this.textProperty._isFirstFrame) {
            this.buildNewText();
            this.textProperty._isFirstFrame = false;
            this.textProperty._mdf = false;
        }
    };
    var emptyShapeData = {
        shapes: []
    };
    function SVGTextLottieElement(data, globalData, comp) {
        this.textSpans = [];
        this.renderType = 'svg';
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement,
        ITextElement
    ], SVGTextLottieElement);
    SVGTextLottieElement.prototype.createContent = function() {
        if (this.data.singleShape && !this.globalData.fontManager.chars) this.textContainer = createNS('text');
    };
    SVGTextLottieElement.prototype.buildTextContents = function(textArray) {
        var i = 0;
        var len = textArray.length;
        var textContents = [];
        var currentTextContent = '';
        while(i < len){
            if (textArray[i] === String.fromCharCode(13) || textArray[i] === String.fromCharCode(3)) {
                textContents.push(currentTextContent);
                currentTextContent = '';
            } else currentTextContent += textArray[i];
            i += 1;
        }
        textContents.push(currentTextContent);
        return textContents;
    };
    SVGTextLottieElement.prototype.buildShapeData = function(data, scale) {
        // data should probably be cloned to apply scale separately to each instance of a text on different layers
        // but since text internal content gets only rendered once and then it's never rerendered,
        // it's probably safe not to clone data and reuse always the same instance even if the object is mutated.
        // Avoiding cloning is preferred since cloning each character shape data is expensive
        if (data.shapes && data.shapes.length) {
            var shape = data.shapes[0];
            if (shape.it) {
                var shapeItem = shape.it[shape.it.length - 1];
                if (shapeItem.s) {
                    shapeItem.s.k[0] = scale;
                    shapeItem.s.k[1] = scale;
                }
            }
        }
        return data;
    };
    SVGTextLottieElement.prototype.buildNewText = function() {
        this.addDynamicProperty(this);
        var i;
        var len;
        var documentData = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData ? documentData.l.length : 0);
        if (documentData.fc) this.layerElement.setAttribute('fill', this.buildColor(documentData.fc));
        else this.layerElement.setAttribute('fill', 'rgba(0,0,0,0)');
        if (documentData.sc) {
            this.layerElement.setAttribute('stroke', this.buildColor(documentData.sc));
            this.layerElement.setAttribute('stroke-width', documentData.sw);
        }
        this.layerElement.setAttribute('font-size', documentData.finalSize);
        var fontData = this.globalData.fontManager.getFontByName(documentData.f);
        if (fontData.fClass) this.layerElement.setAttribute('class', fontData.fClass);
        else {
            this.layerElement.setAttribute('font-family', fontData.fFamily);
            var fWeight = documentData.fWeight;
            var fStyle = documentData.fStyle;
            this.layerElement.setAttribute('font-style', fStyle);
            this.layerElement.setAttribute('font-weight', fWeight);
        }
        this.layerElement.setAttribute('aria-label', documentData.t);
        var letters = documentData.l || [];
        var usesGlyphs = !!this.globalData.fontManager.chars;
        len = letters.length;
        var tSpan;
        var matrixHelper = this.mHelper;
        var shapeStr = '';
        var singleShape = this.data.singleShape;
        var xPos = 0;
        var yPos = 0;
        var firstLine = true;
        var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
        if (singleShape && !usesGlyphs && !documentData.sz) {
            var tElement = this.textContainer;
            var justify = 'start';
            switch(documentData.j){
                case 1:
                    justify = 'end';
                    break;
                case 2:
                    justify = 'middle';
                    break;
                default:
                    justify = 'start';
                    break;
            }
            tElement.setAttribute('text-anchor', justify);
            tElement.setAttribute('letter-spacing', trackingOffset);
            var textContent = this.buildTextContents(documentData.finalText);
            len = textContent.length;
            yPos = documentData.ps ? documentData.ps[1] + documentData.ascent : 0;
            for(i = 0; i < len; i += 1){
                tSpan = this.textSpans[i].span || createNS('tspan');
                tSpan.textContent = textContent[i];
                tSpan.setAttribute('x', 0);
                tSpan.setAttribute('y', yPos);
                tSpan.style.display = 'inherit';
                tElement.appendChild(tSpan);
                if (!this.textSpans[i]) this.textSpans[i] = {
                    span: null,
                    glyph: null
                };
                this.textSpans[i].span = tSpan;
                yPos += documentData.finalLineHeight;
            }
            this.layerElement.appendChild(tElement);
        } else {
            var cachedSpansLength = this.textSpans.length;
            var charData;
            for(i = 0; i < len; i += 1){
                if (!this.textSpans[i]) this.textSpans[i] = {
                    span: null,
                    childSpan: null,
                    glyph: null
                };
                if (!usesGlyphs || !singleShape || i === 0) {
                    tSpan = cachedSpansLength > i ? this.textSpans[i].span : createNS(usesGlyphs ? 'g' : 'text');
                    if (cachedSpansLength <= i) {
                        tSpan.setAttribute('stroke-linecap', 'butt');
                        tSpan.setAttribute('stroke-linejoin', 'round');
                        tSpan.setAttribute('stroke-miterlimit', '4');
                        this.textSpans[i].span = tSpan;
                        if (usesGlyphs) {
                            var childSpan = createNS('g');
                            tSpan.appendChild(childSpan);
                            this.textSpans[i].childSpan = childSpan;
                        }
                        this.textSpans[i].span = tSpan;
                        this.layerElement.appendChild(tSpan);
                    }
                    tSpan.style.display = 'inherit';
                }
                matrixHelper.reset();
                if (singleShape) {
                    if (letters[i].n) {
                        xPos = -trackingOffset;
                        yPos += documentData.yOffset;
                        yPos += firstLine ? 1 : 0;
                        firstLine = false;
                    }
                    this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
                    xPos += letters[i].l || 0;
                    // xPos += letters[i].val === ' ' ? 0 : trackingOffset;
                    xPos += trackingOffset;
                }
                if (usesGlyphs) {
                    charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
                    var glyphElement;
                    // t === 1 means the character has been replaced with an animated shaped
                    if (charData.t === 1) glyphElement = new SVGCompElement(charData.data, this.globalData, this);
                    else {
                        var data = emptyShapeData;
                        if (charData.data && charData.data.shapes) data = this.buildShapeData(charData.data, documentData.finalSize);
                        glyphElement = new SVGShapeElement(data, this.globalData, this);
                    }
                    if (this.textSpans[i].glyph) {
                        var glyph = this.textSpans[i].glyph;
                        this.textSpans[i].childSpan.removeChild(glyph.layerElement);
                        glyph.destroy();
                    }
                    this.textSpans[i].glyph = glyphElement;
                    glyphElement._debug = true;
                    glyphElement.prepareFrame(0);
                    glyphElement.renderFrame();
                    this.textSpans[i].childSpan.appendChild(glyphElement.layerElement);
                    // when using animated shapes, the layer will be scaled instead of replacing the internal scale
                    // this might have issues with strokes and might need a different solution
                    if (charData.t === 1) this.textSpans[i].childSpan.setAttribute('transform', 'scale(' + documentData.finalSize / 100 + ',' + documentData.finalSize / 100 + ')');
                } else {
                    if (singleShape) tSpan.setAttribute('transform', 'translate(' + matrixHelper.props[12] + ',' + matrixHelper.props[13] + ')');
                    tSpan.textContent = letters[i].val;
                    tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
                }
            //
            }
            if (singleShape && tSpan) tSpan.setAttribute('d', shapeStr);
        }
        while(i < this.textSpans.length){
            this.textSpans[i].span.style.display = 'none';
            i += 1;
        }
        this._sizeChanged = true;
    };
    SVGTextLottieElement.prototype.sourceRectAtTime = function() {
        this.prepareFrame(this.comp.renderedFrame - this.data.st);
        this.renderInnerContent();
        if (this._sizeChanged) {
            this._sizeChanged = false;
            var textBox = this.layerElement.getBBox();
            this.bbox = {
                top: textBox.y,
                left: textBox.x,
                width: textBox.width,
                height: textBox.height
            };
        }
        return this.bbox;
    };
    SVGTextLottieElement.prototype.getValue = function() {
        var i;
        var len = this.textSpans.length;
        var glyphElement;
        this.renderedFrame = this.comp.renderedFrame;
        for(i = 0; i < len; i += 1){
            glyphElement = this.textSpans[i].glyph;
            if (glyphElement) {
                glyphElement.prepareFrame(this.comp.renderedFrame - this.data.st);
                if (glyphElement._mdf) this._mdf = true;
            }
        }
    };
    SVGTextLottieElement.prototype.renderInnerContent = function() {
        this.validateText();
        if (!this.data.singleShape || this._mdf) {
            this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
            if (this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
                this._sizeChanged = true;
                var i;
                var len;
                var renderedLetters = this.textAnimator.renderedLetters;
                var letters = this.textProperty.currentData.l;
                len = letters.length;
                var renderedLetter;
                var textSpan;
                var glyphElement;
                for(i = 0; i < len; i += 1)if (!letters[i].n) {
                    renderedLetter = renderedLetters[i];
                    textSpan = this.textSpans[i].span;
                    glyphElement = this.textSpans[i].glyph;
                    if (glyphElement) glyphElement.renderFrame();
                    if (renderedLetter._mdf.m) textSpan.setAttribute('transform', renderedLetter.m);
                    if (renderedLetter._mdf.o) textSpan.setAttribute('opacity', renderedLetter.o);
                    if (renderedLetter._mdf.sw) textSpan.setAttribute('stroke-width', renderedLetter.sw);
                    if (renderedLetter._mdf.sc) textSpan.setAttribute('stroke', renderedLetter.sc);
                    if (renderedLetter._mdf.fc) textSpan.setAttribute('fill', renderedLetter.fc);
                }
            }
        }
    };
    function ISolidElement(data, globalData, comp) {
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        IImageElement
    ], ISolidElement);
    ISolidElement.prototype.createContent = function() {
        var rect = createNS('rect');
        /// /rect.style.width = this.data.sw;
        /// /rect.style.height = this.data.sh;
        /// /rect.style.fill = this.data.sc;
        rect.setAttribute('width', this.data.sw);
        rect.setAttribute('height', this.data.sh);
        rect.setAttribute('fill', this.data.sc);
        this.layerElement.appendChild(rect);
    };
    function NullElement(data, globalData, comp) {
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.initFrame();
        this.initTransform(data, globalData, comp);
        this.initHierarchy();
    }
    NullElement.prototype.prepareFrame = function(num) {
        this.prepareProperties(num, true);
    };
    NullElement.prototype.renderFrame = function() {};
    NullElement.prototype.getBaseElement = function() {
        return null;
    };
    NullElement.prototype.destroy = function() {};
    NullElement.prototype.sourceRectAtTime = function() {};
    NullElement.prototype.hide = function() {};
    extendPrototype([
        BaseElement,
        TransformElement,
        HierarchyElement,
        FrameElement
    ], NullElement);
    function SVGRendererBase() {}
    extendPrototype([
        BaseRenderer
    ], SVGRendererBase);
    SVGRendererBase.prototype.createNull = function(data) {
        return new NullElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createShape = function(data) {
        return new SVGShapeElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createText = function(data) {
        return new SVGTextLottieElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createImage = function(data) {
        return new IImageElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createSolid = function(data) {
        return new ISolidElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.configAnimation = function(animData) {
        this.svgElement.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        this.svgElement.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');
        if (this.renderConfig.viewBoxSize) this.svgElement.setAttribute('viewBox', this.renderConfig.viewBoxSize);
        else this.svgElement.setAttribute('viewBox', '0 0 ' + animData.w + ' ' + animData.h);
        if (!this.renderConfig.viewBoxOnly) {
            this.svgElement.setAttribute('width', animData.w);
            this.svgElement.setAttribute('height', animData.h);
            this.svgElement.style.width = '100%';
            this.svgElement.style.height = '100%';
            this.svgElement.style.transform = 'translate3d(0,0,0)';
            this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility;
        }
        if (this.renderConfig.width) this.svgElement.setAttribute('width', this.renderConfig.width);
        if (this.renderConfig.height) this.svgElement.setAttribute('height', this.renderConfig.height);
        if (this.renderConfig.className) this.svgElement.setAttribute('class', this.renderConfig.className);
        if (this.renderConfig.id) this.svgElement.setAttribute('id', this.renderConfig.id);
        if (this.renderConfig.focusable !== undefined) this.svgElement.setAttribute('focusable', this.renderConfig.focusable);
        this.svgElement.setAttribute('preserveAspectRatio', this.renderConfig.preserveAspectRatio);
        // this.layerElement.style.transform = 'translate3d(0,0,0)';
        // this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";
        this.animationItem.wrapper.appendChild(this.svgElement);
        // Mask animation
        var defs = this.globalData.defs;
        this.setupGlobalData(animData, defs);
        this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
        this.data = animData;
        var maskElement = createNS('clipPath');
        var rect = createNS('rect');
        rect.setAttribute('width', animData.w);
        rect.setAttribute('height', animData.h);
        rect.setAttribute('x', 0);
        rect.setAttribute('y', 0);
        var maskId = createElementID();
        maskElement.setAttribute('id', maskId);
        maskElement.appendChild(rect);
        this.layerElement.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + maskId + ')');
        defs.appendChild(maskElement);
        this.layers = animData.layers;
        this.elements = createSizedArray(animData.layers.length);
    };
    SVGRendererBase.prototype.destroy = function() {
        if (this.animationItem.wrapper) this.animationItem.wrapper.innerText = '';
        this.layerElement = null;
        this.globalData.defs = null;
        var i;
        var len = this.layers ? this.layers.length : 0;
        for(i = 0; i < len; i += 1)if (this.elements[i] && this.elements[i].destroy) this.elements[i].destroy();
        this.elements.length = 0;
        this.destroyed = true;
        this.animationItem = null;
    };
    SVGRendererBase.prototype.updateContainerSize = function() {};
    SVGRendererBase.prototype.findIndexByInd = function(ind) {
        var i = 0;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1){
            if (this.layers[i].ind === ind) return i;
        }
        return -1;
    };
    SVGRendererBase.prototype.buildItem = function(pos) {
        var elements = this.elements;
        if (elements[pos] || this.layers[pos].ty === 99) return;
        elements[pos] = true;
        var element = this.createItem(this.layers[pos]);
        elements[pos] = element;
        if (getExpressionsPlugin()) {
            if (this.layers[pos].ty === 0) this.globalData.projectInterface.registerComposition(element);
            element.initExpressions();
        }
        this.appendElementInPos(element, pos);
        if (this.layers[pos].tt) {
            var elementIndex = 'tp' in this.layers[pos] ? this.findIndexByInd(this.layers[pos].tp) : pos - 1;
            if (elementIndex === -1) return;
            if (!this.elements[elementIndex] || this.elements[elementIndex] === true) {
                this.buildItem(elementIndex);
                this.addPendingElement(element);
            } else {
                var matteElement = elements[elementIndex];
                var matteMask = matteElement.getMatte(this.layers[pos].tt);
                element.setMatte(matteMask);
            }
        }
    };
    SVGRendererBase.prototype.checkPendingElements = function() {
        while(this.pendingElements.length){
            var element = this.pendingElements.pop();
            element.checkParenting();
            if (element.data.tt) {
                var i = 0;
                var len = this.elements.length;
                while(i < len){
                    if (this.elements[i] === element) {
                        var elementIndex = 'tp' in element.data ? this.findIndexByInd(element.data.tp) : i - 1;
                        var matteElement = this.elements[elementIndex];
                        var matteMask = matteElement.getMatte(this.layers[i].tt);
                        element.setMatte(matteMask);
                        break;
                    }
                    i += 1;
                }
            }
        }
    };
    SVGRendererBase.prototype.renderFrame = function(num) {
        if (this.renderedFrame === num || this.destroyed) return;
        if (num === null) num = this.renderedFrame;
        else this.renderedFrame = num;
        // console.log('-------');
        // console.log('FRAME ',num);
        this.globalData.frameNum = num;
        this.globalData.frameId += 1;
        this.globalData.projectInterface.currentFrame = num;
        this.globalData._mdf = false;
        var i;
        var len = this.layers.length;
        if (!this.completeLayers) this.checkLayers(num);
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].prepareFrame(num - this.layers[i].st);
        if (this.globalData._mdf) {
            for(i = 0; i < len; i += 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
        }
    };
    SVGRendererBase.prototype.appendElementInPos = function(element, pos) {
        var newElement = element.getBaseElement();
        if (!newElement) return;
        var i = 0;
        var nextElement;
        while(i < pos){
            if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement()) nextElement = this.elements[i].getBaseElement();
            i += 1;
        }
        if (nextElement) this.layerElement.insertBefore(newElement, nextElement);
        else this.layerElement.appendChild(newElement);
    };
    SVGRendererBase.prototype.hide = function() {
        this.layerElement.style.display = 'none';
    };
    SVGRendererBase.prototype.show = function() {
        this.layerElement.style.display = 'block';
    };
    function ICompElement() {}
    extendPrototype([
        BaseElement,
        TransformElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], ICompElement);
    ICompElement.prototype.initElement = function(data, globalData, comp) {
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.initTransform(data, globalData, comp);
        this.initRenderable();
        this.initHierarchy();
        this.initRendererElement();
        this.createContainerElements();
        this.createRenderableComponents();
        if (this.data.xt || !globalData.progressiveLoad) this.buildAllItems();
        this.hide();
    };
    /* ICompElement.prototype.hide = function(){
      if(!this.hidden){
          this.hideElement();
          var i,len = this.elements.length;
          for( i = 0; i < len; i+=1 ){
              if(this.elements[i]){
                  this.elements[i].hide();
              }
          }
      }
  }; */ ICompElement.prototype.prepareFrame = function(num) {
        this._mdf = false;
        this.prepareRenderableFrame(num);
        this.prepareProperties(num, this.isInRange);
        if (!this.isInRange && !this.data.xt) return;
        if (!this.tm._placeholder) {
            var timeRemapped = this.tm.v;
            if (timeRemapped === this.data.op) timeRemapped = this.data.op - 1;
            this.renderedFrame = timeRemapped;
        } else this.renderedFrame = num / this.data.sr;
        var i;
        var len = this.elements.length;
        if (!this.completeLayers) this.checkLayers(this.renderedFrame);
        // This iteration needs to be backwards because of how expressions connect between each other
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) {
            this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st);
            if (this.elements[i]._mdf) this._mdf = true;
        }
    };
    ICompElement.prototype.renderInnerContent = function() {
        var i;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
    };
    ICompElement.prototype.setElements = function(elems) {
        this.elements = elems;
    };
    ICompElement.prototype.getElements = function() {
        return this.elements;
    };
    ICompElement.prototype.destroyElements = function() {
        var i;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1)if (this.elements[i]) this.elements[i].destroy();
    };
    ICompElement.prototype.destroy = function() {
        this.destroyElements();
        this.destroyBaseElement();
    };
    function SVGCompElement(data, globalData, comp) {
        this.layers = data.layers;
        this.supports3d = true;
        this.completeLayers = false;
        this.pendingElements = [];
        this.elements = this.layers ? createSizedArray(this.layers.length) : [];
        this.initElement(data, globalData, comp);
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
    }
    extendPrototype([
        SVGRendererBase,
        ICompElement,
        SVGBaseElement
    ], SVGCompElement);
    SVGCompElement.prototype.createComp = function(data) {
        return new SVGCompElement(data, this.globalData, this);
    };
    function SVGRenderer(animationItem, config) {
        this.animationItem = animationItem;
        this.layers = null;
        this.renderedFrame = -1;
        this.svgElement = createNS('svg');
        var ariaLabel = '';
        if (config && config.title) {
            var titleElement = createNS('title');
            var titleId = createElementID();
            titleElement.setAttribute('id', titleId);
            titleElement.textContent = config.title;
            this.svgElement.appendChild(titleElement);
            ariaLabel += titleId;
        }
        if (config && config.description) {
            var descElement = createNS('desc');
            var descId = createElementID();
            descElement.setAttribute('id', descId);
            descElement.textContent = config.description;
            this.svgElement.appendChild(descElement);
            ariaLabel += ' ' + descId;
        }
        if (ariaLabel) this.svgElement.setAttribute('aria-labelledby', ariaLabel);
        var defs = createNS('defs');
        this.svgElement.appendChild(defs);
        var maskElement = createNS('g');
        this.svgElement.appendChild(maskElement);
        this.layerElement = maskElement;
        this.renderConfig = {
            preserveAspectRatio: config && config.preserveAspectRatio || 'xMidYMid meet',
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
            contentVisibility: config && config.contentVisibility || 'visible',
            progressiveLoad: config && config.progressiveLoad || false,
            hideOnTransparent: !(config && config.hideOnTransparent === false),
            viewBoxOnly: config && config.viewBoxOnly || false,
            viewBoxSize: config && config.viewBoxSize || false,
            className: config && config.className || '',
            id: config && config.id || '',
            focusable: config && config.focusable,
            filterSize: {
                width: config && config.filterSize && config.filterSize.width || '100%',
                height: config && config.filterSize && config.filterSize.height || '100%',
                x: config && config.filterSize && config.filterSize.x || '0%',
                y: config && config.filterSize && config.filterSize.y || '0%'
            },
            width: config && config.width,
            height: config && config.height,
            runExpressions: !config || config.runExpressions === undefined || config.runExpressions
        };
        this.globalData = {
            _mdf: false,
            frameNum: -1,
            defs: defs,
            renderConfig: this.renderConfig
        };
        this.elements = [];
        this.pendingElements = [];
        this.destroyed = false;
        this.rendererType = 'svg';
    }
    extendPrototype([
        SVGRendererBase
    ], SVGRenderer);
    SVGRenderer.prototype.createComp = function(data) {
        return new SVGCompElement(data, this.globalData, this);
    };
    // Registering renderers
    registerRenderer('svg', SVGRenderer);
    // Registering shape modifiers
    ShapeModifiers.registerModifier('tm', TrimModifier);
    ShapeModifiers.registerModifier('pb', PuckerAndBloatModifier);
    ShapeModifiers.registerModifier('rp', RepeaterModifier);
    ShapeModifiers.registerModifier('rd', RoundCornersModifier);
    ShapeModifiers.registerModifier('zz', ZigZagModifier);
    ShapeModifiers.registerModifier('op', OffsetPathModifier);
    return lottie;
});

});

parcelRegister("8LbvY", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
var $660ba51cdbd0c6e2$var$envHasBigInt64Array = typeof BigInt64Array !== 'undefined';
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            for (i of a.entries())if (!b.has(i[0])) return false;
            for (i of a.entries())if (!equal(i[1], b.get(i[0]))) return false;
            return true;
        }
        if (a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            for (i of a.entries())if (!b.has(i[0])) return false;
            return true;
        }
        if (ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("iZdGe", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3rQ4x"))();

});
parcelRegister("3rQ4x", function(module, exports) {

var $lGjml = parcelRequire("lGjml");
var $282c492e71758c77$require$Buffer = $lGjml.Buffer;
'use strict';
module.exports = $282c492e71758c77$var$rfdc;
function $282c492e71758c77$var$copyBuffer(cur) {
    if (cur instanceof $282c492e71758c77$require$Buffer) return $282c492e71758c77$require$Buffer.from(cur);
    return new cur.constructor(cur.buffer.slice(), cur.byteOffset, cur.length);
}
function $282c492e71758c77$var$rfdc(opts) {
    opts = opts || {};
    if (opts.circles) return $282c492e71758c77$var$rfdcCircles(opts);
    const constructorHandlers = new Map();
    constructorHandlers.set(Date, (o)=>new Date(o));
    constructorHandlers.set(Map, (o, fn)=>new Map(cloneArray(Array.from(o), fn)));
    constructorHandlers.set(Set, (o, fn)=>new Set(cloneArray(Array.from(o), fn)));
    if (opts.constructorHandlers) for (const handler of opts.constructorHandlers)constructorHandlers.set(handler[0], handler[1]);
    let handler = null;
    return opts.proto ? cloneProto : clone;
    function cloneArray(a, fn) {
        const keys = Object.keys(a);
        const a2 = new Array(keys.length);
        for(let i = 0; i < keys.length; i++){
            const k = keys[i];
            const cur = a[k];
            if (typeof cur !== 'object' || cur === null) a2[k] = cur;
            else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) a2[k] = handler(cur, fn);
            else if (ArrayBuffer.isView(cur)) a2[k] = $282c492e71758c77$var$copyBuffer(cur);
            else a2[k] = fn(cur);
        }
        return a2;
    }
    function clone(o) {
        if (typeof o !== 'object' || o === null) return o;
        if (Array.isArray(o)) return cloneArray(o, clone);
        if (o.constructor !== Object && (handler = constructorHandlers.get(o.constructor))) return handler(o, clone);
        const o2 = {};
        for(const k in o){
            if (Object.hasOwnProperty.call(o, k) === false) continue;
            const cur = o[k];
            if (typeof cur !== 'object' || cur === null) o2[k] = cur;
            else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) o2[k] = handler(cur, clone);
            else if (ArrayBuffer.isView(cur)) o2[k] = $282c492e71758c77$var$copyBuffer(cur);
            else o2[k] = clone(cur);
        }
        return o2;
    }
    function cloneProto(o) {
        if (typeof o !== 'object' || o === null) return o;
        if (Array.isArray(o)) return cloneArray(o, cloneProto);
        if (o.constructor !== Object && (handler = constructorHandlers.get(o.constructor))) return handler(o, cloneProto);
        const o2 = {};
        for(const k in o){
            const cur = o[k];
            if (typeof cur !== 'object' || cur === null) o2[k] = cur;
            else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) o2[k] = handler(cur, cloneProto);
            else if (ArrayBuffer.isView(cur)) o2[k] = $282c492e71758c77$var$copyBuffer(cur);
            else o2[k] = cloneProto(cur);
        }
        return o2;
    }
}
function $282c492e71758c77$var$rfdcCircles(opts) {
    const refs = [];
    const refsNew = [];
    const constructorHandlers = new Map();
    constructorHandlers.set(Date, (o)=>new Date(o));
    constructorHandlers.set(Map, (o, fn)=>new Map(cloneArray(Array.from(o), fn)));
    constructorHandlers.set(Set, (o, fn)=>new Set(cloneArray(Array.from(o), fn)));
    if (opts.constructorHandlers) for (const handler of opts.constructorHandlers)constructorHandlers.set(handler[0], handler[1]);
    let handler = null;
    return opts.proto ? cloneProto : clone;
    function cloneArray(a, fn) {
        const keys = Object.keys(a);
        const a2 = new Array(keys.length);
        for(let i = 0; i < keys.length; i++){
            const k = keys[i];
            const cur = a[k];
            if (typeof cur !== 'object' || cur === null) a2[k] = cur;
            else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) a2[k] = handler(cur, fn);
            else if (ArrayBuffer.isView(cur)) a2[k] = $282c492e71758c77$var$copyBuffer(cur);
            else {
                const index = refs.indexOf(cur);
                if (index !== -1) a2[k] = refsNew[index];
                else a2[k] = fn(cur);
            }
        }
        return a2;
    }
    function clone(o) {
        if (typeof o !== 'object' || o === null) return o;
        if (Array.isArray(o)) return cloneArray(o, clone);
        if (o.constructor !== Object && (handler = constructorHandlers.get(o.constructor))) return handler(o, clone);
        const o2 = {};
        refs.push(o);
        refsNew.push(o2);
        for(const k in o){
            if (Object.hasOwnProperty.call(o, k) === false) continue;
            const cur = o[k];
            if (typeof cur !== 'object' || cur === null) o2[k] = cur;
            else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) o2[k] = handler(cur, clone);
            else if (ArrayBuffer.isView(cur)) o2[k] = $282c492e71758c77$var$copyBuffer(cur);
            else {
                const i = refs.indexOf(cur);
                if (i !== -1) o2[k] = refsNew[i];
                else o2[k] = clone(cur);
            }
        }
        refs.pop();
        refsNew.pop();
        return o2;
    }
    function cloneProto(o) {
        if (typeof o !== 'object' || o === null) return o;
        if (Array.isArray(o)) return cloneArray(o, cloneProto);
        if (o.constructor !== Object && (handler = constructorHandlers.get(o.constructor))) return handler(o, cloneProto);
        const o2 = {};
        refs.push(o);
        refsNew.push(o2);
        for(const k in o){
            const cur = o[k];
            if (typeof cur !== 'object' || cur === null) o2[k] = cur;
            else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) o2[k] = handler(cur, cloneProto);
            else if (ArrayBuffer.isView(cur)) o2[k] = $282c492e71758c77$var$copyBuffer(cur);
            else {
                const i = refs.indexOf(cur);
                if (i !== -1) o2[k] = refsNew[i];
                else o2[k] = cloneProto(cur);
            }
        }
        refs.pop();
        refsNew.pop();
        return o2;
    }
}

});


parcelRegister("8rnSG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $62535e9d013ed09e$export$2e2bcd8739ae039);
var $62535e9d013ed09e$var$focusableSelectors = [
    'a[href]:not([tabindex^="-"])',
    'area[href]:not([tabindex^="-"])',
    'input:not([type="hidden"]):not([type="radio"]):not([disabled]):not([tabindex^="-"])',
    'input[type="radio"]:not([disabled]):not([tabindex^="-"])',
    'select:not([disabled]):not([tabindex^="-"])',
    'textarea:not([disabled]):not([tabindex^="-"])',
    'button:not([disabled]):not([tabindex^="-"])',
    'iframe:not([tabindex^="-"])',
    'audio[controls]:not([tabindex^="-"])',
    'video[controls]:not([tabindex^="-"])',
    '[contenteditable]:not([tabindex^="-"])',
    '[tabindex]:not([tabindex^="-"])'
];
var $62535e9d013ed09e$var$TAB_KEY = 'Tab';
var $62535e9d013ed09e$var$ESCAPE_KEY = 'Escape';
/**
 * Define the constructor to instantiate a dialog
 *
 * @constructor
 * @param {Element} element
 */ function $62535e9d013ed09e$export$2e2bcd8739ae039(element) {
    // Prebind the functions that will be bound in addEventListener and
    // removeEventListener to avoid losing references
    this._show = this.show.bind(this);
    this._hide = this.hide.bind(this);
    this._maintainFocus = this._maintainFocus.bind(this);
    this._bindKeypress = this._bindKeypress.bind(this);
    this.$el = element;
    this.shown = false;
    this._id = this.$el.getAttribute('data-a11y-dialog') || this.$el.id;
    this._previouslyFocused = null;
    this._listeners = {};
    // Initialise everything needed for the dialog to work properly
    this.create();
}
/**
 * Set up everything necessary for the dialog to be functioning
 *
 * @param {(NodeList | Element | string)} targets
 * @return {this}
 */ $62535e9d013ed09e$export$2e2bcd8739ae039.prototype.create = function() {
    this.$el.setAttribute('aria-hidden', true);
    this.$el.setAttribute('aria-modal', true);
    this.$el.setAttribute('tabindex', -1);
    if (!this.$el.hasAttribute('role')) this.$el.setAttribute('role', 'dialog');
    // Keep a collection of dialog openers, each of which will be bound a click
    // event listener to open the dialog
    this._openers = $62535e9d013ed09e$var$$$('[data-a11y-dialog-show="' + this._id + '"]');
    this._openers.forEach((function(opener) {
        opener.addEventListener('click', this._show);
    }).bind(this));
    // Keep a collection of dialog closers, each of which will be bound a click
    // event listener to close the dialog
    const $el = this.$el;
    this._closers = $62535e9d013ed09e$var$$$('[data-a11y-dialog-hide]', this.$el)// This filter is necessary in case there are nested dialogs, so that
    // only closers from the current dialog are retrieved and effective
    .filter(function(closer) {
        // Testing for `[aria-modal="true"]` is not enough since this attribute
        // and the collect of closers is done at instantation time, when nested
        // dialogs might not have yet been instantiated. Note that if the dialogs
        // are manually instantiated, this could still fail because none of these
        // selectors would match; this would cause closers to close all parent
        // dialogs instead of just the current one
        return closer.closest('[aria-modal="true"], [data-a11y-dialog]') === $el;
    }).concat($62535e9d013ed09e$var$$$('[data-a11y-dialog-hide="' + this._id + '"]'));
    this._closers.forEach((function(closer) {
        closer.addEventListener('click', this._hide);
    }).bind(this));
    // Execute all callbacks registered for the `create` event
    this._fire('create');
    return this;
};
/**
 * Show the dialog element, disable all the targets (siblings), trap the
 * current focus within it, listen for some specific key presses and fire all
 * registered callbacks for `show` event
 *
 * @param {CustomEvent} event
 * @return {this}
 */ $62535e9d013ed09e$export$2e2bcd8739ae039.prototype.show = function(event) {
    // If the dialog is already open, abort
    if (this.shown) return this;
    // Keep a reference to the currently focused element to be able to restore
    // it later
    this._previouslyFocused = document.activeElement;
    // Due to a long lasting bug in Safari, clicking an interactive element (like
    // a <button>) does *not* move the focus to that element, which means
    // `document.activeElement` is whatever element is currently focused (like an
    // <input>), or the <body> element otherwise. We can work around that problem
    // by checking whether the focused element is the <body>, and if it, store the
    // click event target.
    // See: https://bugs.webkit.org/show_bug.cgi?id=22261
    const target = event && event.target ? event.target : null;
    if (target && Object.is(this._previouslyFocused, document.body)) this._previouslyFocused = target;
    this.$el.removeAttribute('aria-hidden');
    this.shown = true;
    // Set the focus to the dialog element
    $62535e9d013ed09e$var$moveFocusToDialog(this.$el);
    // Bind a focus event listener to the body element to make sure the focus
    // stays trapped inside the dialog while open, and start listening for some
    // specific key presses (TAB and ESC)
    document.body.addEventListener('focus', this._maintainFocus, true);
    document.addEventListener('keydown', this._bindKeypress);
    // Execute all callbacks registered for the `show` event
    this._fire('show', event);
    return this;
};
/**
 * Hide the dialog element, enable all the targets (siblings), restore the
 * focus to the previously active element, stop listening for some specific
 * key presses and fire all registered callbacks for `hide` event
 *
 * @param {CustomEvent} event
 * @return {this}
 */ $62535e9d013ed09e$export$2e2bcd8739ae039.prototype.hide = function(event) {
    // If the dialog is already closed, abort
    if (!this.shown) return this;
    this.shown = false;
    this.$el.setAttribute('aria-hidden', 'true');
    // If there was a focused element before the dialog was opened (and it has a
    // `focus` method), restore the focus back to it
    // See: https://github.com/KittyGiraudel/a11y-dialog/issues/108
    if (this._previouslyFocused && this._previouslyFocused.focus) this._previouslyFocused.focus();
    // Remove the focus event listener to the body element and stop listening
    // for specific key presses
    document.body.removeEventListener('focus', this._maintainFocus, true);
    document.removeEventListener('keydown', this._bindKeypress);
    // Execute all callbacks registered for the `hide` event
    this._fire('hide', event);
    return this;
};
/**
 * Destroy the current instance (after making sure the dialog has been hidden)
 * and remove all associated listeners from dialog openers and closers
 *
 * @return {this}
 */ $62535e9d013ed09e$export$2e2bcd8739ae039.prototype.destroy = function() {
    // Hide the dialog to avoid destroying an open instance
    this.hide();
    // Remove the click event listener from all dialog openers
    this._openers.forEach((function(opener) {
        opener.removeEventListener('click', this._show);
    }).bind(this));
    // Remove the click event listener from all dialog closers
    this._closers.forEach((function(closer) {
        closer.removeEventListener('click', this._hide);
    }).bind(this));
    // Execute all callbacks registered for the `destroy` event
    this._fire('destroy');
    // Keep an object of listener types mapped to callback functions
    this._listeners = {};
    return this;
};
/**
 * Register a new callback for the given event type
 *
 * @param {string} type
 * @param {Function} handler
 */ $62535e9d013ed09e$export$2e2bcd8739ae039.prototype.on = function(type, handler) {
    if (typeof this._listeners[type] === 'undefined') this._listeners[type] = [];
    this._listeners[type].push(handler);
    return this;
};
/**
 * Unregister an existing callback for the given event type
 *
 * @param {string} type
 * @param {Function} handler
 */ $62535e9d013ed09e$export$2e2bcd8739ae039.prototype.off = function(type, handler) {
    var index = (this._listeners[type] || []).indexOf(handler);
    if (index > -1) this._listeners[type].splice(index, 1);
    return this;
};
/**
 * Iterate over all registered handlers for given type and call them all with
 * the dialog element as first argument, event as second argument (if any). Also
 * dispatch a custom event on the DOM element itself to make it possible to
 * react to the lifecycle of auto-instantiated dialogs.
 *
 * @access private
 * @param {string} type
 * @param {CustomEvent} event
 */ $62535e9d013ed09e$export$2e2bcd8739ae039.prototype._fire = function(type, event) {
    var listeners = this._listeners[type] || [];
    var domEvent = new CustomEvent(type, {
        detail: event
    });
    this.$el.dispatchEvent(domEvent);
    listeners.forEach((function(listener) {
        listener(this.$el, event);
    }).bind(this));
};
/**
 * Private event handler used when listening to some specific key presses
 * (namely ESCAPE and TAB)
 *
 * @access private
 * @param {Event} event
 */ $62535e9d013ed09e$export$2e2bcd8739ae039.prototype._bindKeypress = function(event) {
    // This is an escape hatch in case there are nested dialogs, so the keypresses
    // are only reacted to for the most recent one
    const focused = document.activeElement;
    if (focused && focused.closest('[aria-modal="true"]') !== this.$el) return;
    // If the dialog is shown and the ESCAPE key is being pressed, prevent any
    // further effects from the ESCAPE key and hide the dialog, unless its role
    // is 'alertdialog', which should be modal
    if (this.shown && event.key === $62535e9d013ed09e$var$ESCAPE_KEY && this.$el.getAttribute('role') !== 'alertdialog') {
        event.preventDefault();
        this.hide(event);
    }
    // If the dialog is shown and the TAB key is being pressed, make sure the
    // focus stays trapped within the dialog element
    if (this.shown && event.key === $62535e9d013ed09e$var$TAB_KEY) $62535e9d013ed09e$var$trapTabKey(this.$el, event);
};
/**
 * Private event handler used when making sure the focus stays within the
 * currently open dialog
 *
 * @access private
 * @param {Event} event
 */ $62535e9d013ed09e$export$2e2bcd8739ae039.prototype._maintainFocus = function(event) {
    // If the dialog is shown and the focus is not within a dialog element (either
    // this one or another one in case of nested dialogs) or within an element
    // with the `data-a11y-dialog-focus-trap-ignore` attribute, move it back to
    // its first focusable child.
    // See: https://github.com/KittyGiraudel/a11y-dialog/issues/177
    if (this.shown && !event.target.closest('[aria-modal="true"]') && !event.target.closest('[data-a11y-dialog-ignore-focus-trap]')) $62535e9d013ed09e$var$moveFocusToDialog(this.$el);
};
/**
 * Convert a NodeList into an array
 *
 * @param {NodeList} collection
 * @return {Array<Element>}
 */ function $62535e9d013ed09e$var$toArray(collection) {
    return Array.prototype.slice.call(collection);
}
/**
 * Query the DOM for nodes matching the given selector, scoped to context (or
 * the whole document)
 *
 * @param {String} selector
 * @param {Element} [context = document]
 * @return {Array<Element>}
 */ function $62535e9d013ed09e$var$$$(selector, context) {
    return $62535e9d013ed09e$var$toArray((context || document).querySelectorAll(selector));
}
/**
 * Set the focus to the first element with `autofocus` with the element or the
 * element itself
 *
 * @param {Element} node
 */ function $62535e9d013ed09e$var$moveFocusToDialog(node) {
    var focused = node.querySelector('[autofocus]') || node;
    focused.focus();
}
/**
 * Get the focusable children of the given element
 *
 * @param {Element} node
 * @return {Array<Element>}
 */ function $62535e9d013ed09e$var$getFocusableChildren(node) {
    return $62535e9d013ed09e$var$$$($62535e9d013ed09e$var$focusableSelectors.join(','), node).filter(function(child) {
        return !!(child.offsetWidth || child.offsetHeight || child.getClientRects().length);
    });
}
/**
 * Trap the focus inside the given element
 *
 * @param {Element} node
 * @param {Event} event
 */ function $62535e9d013ed09e$var$trapTabKey(node, event) {
    var focusableChildren = $62535e9d013ed09e$var$getFocusableChildren(node);
    var focusedItemIndex = focusableChildren.indexOf(document.activeElement);
    // If the SHIFT key is being pressed while tabbing (moving backwards) and
    // the currently focused item is the first one, move the focus to the last
    // focusable item from the dialog element
    if (event.shiftKey && focusedItemIndex === 0) {
        focusableChildren[focusableChildren.length - 1].focus();
        event.preventDefault();
    // If the SHIFT key is not being pressed (moving forwards) and the currently
    // focused item is the last one, move the focus to the first focusable item
    // from the dialog element
    } else if (!event.shiftKey && focusedItemIndex === focusableChildren.length - 1) {
        focusableChildren[0].focus();
        event.preventDefault();
    }
}
function $62535e9d013ed09e$var$instantiateDialogs() {
    $62535e9d013ed09e$var$$$('[data-a11y-dialog]').forEach(function(node) {
        new $62535e9d013ed09e$export$2e2bcd8739ae039(node);
    });
}
if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $62535e9d013ed09e$var$instantiateDialogs);
    else if (window.requestAnimationFrame) window.requestAnimationFrame($62535e9d013ed09e$var$instantiateDialogs);
    else window.setTimeout($62535e9d013ed09e$var$instantiateDialogs, 16);
}

});

parcelRegister("3eqDI", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $25a757f9126129b2$var$ReactIs, $25a757f9126129b2$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("8y05r"))();

});
parcelRegister("8y05r", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $2Gmge = parcelRequire("2Gmge");
function $639190f0c43c50e8$var$emptyFunction() {}
function $639190f0c43c50e8$var$emptyFunctionWithReset() {}
$639190f0c43c50e8$var$emptyFunctionWithReset.resetWarningCache = $639190f0c43c50e8$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $2Gmge) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $639190f0c43c50e8$var$emptyFunctionWithReset,
        resetWarningCache: $639190f0c43c50e8$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("2Gmge", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $1f40c58daf160e20$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $1f40c58daf160e20$var$ReactPropTypesSecret;

});



parcelRegister("8K1s2", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used as the `TypeError` message for "Functions" methods. */ var FUNC_ERROR_TEXT = 'Expected a function';
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used to compose bitmasks for comparison styles. */ var UNORDERED_COMPARE_FLAG = 1, PARTIAL_COMPARE_FLAG = 2;
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', promiseTag = '[object Promise]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, reLeadingDot = /^\./, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values ? values.length : 0;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__['delete'](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function baseAggregator(collection, setter, iteratee, accumulator) {
    baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = createBaseEach(baseForOwn);
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
}
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = isKey(path, object) ? [
        path
    ] : castPath(path);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, customizer, bitmask, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObject(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
    if (!objIsArr) {
        objTag = getTag(object);
        objTag = objTag == argsTag ? objectTag : objTag;
    }
    if (!othIsArr) {
        othTag = getTag(other);
        othTag = othTag == argsTag ? objectTag : othTag;
    }
    var objIsObj = objTag == objectTag && !isHostObject(object), othIsObj = othTag == objectTag && !isHostObject(other), isSameTag = objTag == othTag;
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
    }
    if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack) : result)) return false;
        }
    }
    return true;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return identity;
    if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
    };
}
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value) {
    return isArray(value) ? value : stringToPath(value);
}
/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
        return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
    };
}
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!seen.has(othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) return seen.add(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= UNORDERED_COMPARE_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = isKey(path, object) ? [
        path
    ] : castPath(path);
    var result, index = -1, length = path.length;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result) return result;
    var length = object ? object.length : 0;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoize(function(string) {
    string = toString(string);
    var result = [];
    if (reLeadingDot.test(string)) result.push('');
    string.replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : number || match);
    });
    return result;
});
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == 'string' || isSymbol(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity]
 *  The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var groupBy = createAggregator(function(result, value, key) {
    if (hasOwnProperty.call(result, key)) result[key].push(value);
    else result[key] = [
        value
    ];
});
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != 'function' || resolver && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
memoize.Cache = MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? '' : baseToString(value);
}
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = groupBy;

});

parcelRegister("lpVsW", function(module, exports) {
module.exports = import("bmouz").then(()=>parcelRequire('hha4Y'));

});

parcelRegister("i9dMJ", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $d363c2ad98d90aba$export$a7c73072b1a182ae, (v) => $d363c2ad98d90aba$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $d363c2ad98d90aba$export$9f27bc3417b4524d, (v) => $d363c2ad98d90aba$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $d363c2ad98d90aba$export$db77ccec0bb4ccac, (v) => $d363c2ad98d90aba$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $d363c2ad98d90aba$export$8392c0c9d3dcbd35, (v) => $d363c2ad98d90aba$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $d363c2ad98d90aba$export$ffb0004e005737fa, (v) => $d363c2ad98d90aba$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $d363c2ad98d90aba$export$b624eff549462981, (v) => $d363c2ad98d90aba$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $d363c2ad98d90aba$export$7897aa7841a5380c, (v) => $d363c2ad98d90aba$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $d363c2ad98d90aba$export$602eac185826482c, (v) => $d363c2ad98d90aba$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $d363c2ad98d90aba$export$e2c29f18771995cb, (v) => $d363c2ad98d90aba$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $d363c2ad98d90aba$export$5f8d39834fd61797, (v) => $d363c2ad98d90aba$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $d363c2ad98d90aba$export$74bf444e3cd11ea5, (v) => $d363c2ad98d90aba$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $d363c2ad98d90aba$export$998bcd577473dd93, (v) => $d363c2ad98d90aba$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $d363c2ad98d90aba$export$92387174baf9b227, (v) => $d363c2ad98d90aba$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $d363c2ad98d90aba$export$ec112efeb987d9c6, (v) => $d363c2ad98d90aba$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $d363c2ad98d90aba$export$b706b080d889d2c9, (v) => $d363c2ad98d90aba$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $d363c2ad98d90aba$export$5be5a87408f70ddc, (v) => $d363c2ad98d90aba$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $d363c2ad98d90aba$export$45a5e7f76e0caa8d, (v) => $d363c2ad98d90aba$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $d363c2ad98d90aba$export$455c2e768291efa6, (v) => $d363c2ad98d90aba$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $d363c2ad98d90aba$export$9522e17588c12572, (v) => $d363c2ad98d90aba$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $d363c2ad98d90aba$export$2110ac352bb060b9, (v) => $d363c2ad98d90aba$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $d363c2ad98d90aba$export$56885ab8b9c456ab, (v) => $d363c2ad98d90aba$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $d363c2ad98d90aba$export$d927fcb6adf8f9de, (v) => $d363c2ad98d90aba$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $d363c2ad98d90aba$export$b82d16f27459e05a, (v) => $d363c2ad98d90aba$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $d363c2ad98d90aba$export$522c17b4f5e123e8, (v) => $d363c2ad98d90aba$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $d363c2ad98d90aba$export$1aabd8a0274ecfd6, (v) => $d363c2ad98d90aba$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $d363c2ad98d90aba$export$3d6c20d97e46b957, (v) => $d363c2ad98d90aba$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $d363c2ad98d90aba$export$9b621391a187a31a, (v) => $d363c2ad98d90aba$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $d363c2ad98d90aba$export$f5bbd400c2f4426f, (v) => $d363c2ad98d90aba$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d363c2ad98d90aba$export$a7c73072b1a182ae;
var $d363c2ad98d90aba$export$9f27bc3417b4524d;
var $d363c2ad98d90aba$export$db77ccec0bb4ccac;
var $d363c2ad98d90aba$export$8392c0c9d3dcbd35;
var $d363c2ad98d90aba$export$ffb0004e005737fa;
var $d363c2ad98d90aba$export$b624eff549462981;
var $d363c2ad98d90aba$export$7897aa7841a5380c;
var $d363c2ad98d90aba$export$602eac185826482c;
var $d363c2ad98d90aba$export$e2c29f18771995cb;
var $d363c2ad98d90aba$export$5f8d39834fd61797;
var $d363c2ad98d90aba$export$74bf444e3cd11ea5;
var $d363c2ad98d90aba$export$998bcd577473dd93;
var $d363c2ad98d90aba$export$92387174baf9b227;
var $d363c2ad98d90aba$export$ec112efeb987d9c6;
var $d363c2ad98d90aba$export$b706b080d889d2c9;
var $d363c2ad98d90aba$export$5be5a87408f70ddc;
var $d363c2ad98d90aba$export$45a5e7f76e0caa8d;
var $d363c2ad98d90aba$export$455c2e768291efa6;
var $d363c2ad98d90aba$export$9522e17588c12572;
var $d363c2ad98d90aba$export$2110ac352bb060b9;
var $d363c2ad98d90aba$export$56885ab8b9c456ab;
var $d363c2ad98d90aba$export$d927fcb6adf8f9de;
var $d363c2ad98d90aba$export$b82d16f27459e05a;
var $d363c2ad98d90aba$export$522c17b4f5e123e8;
var $d363c2ad98d90aba$export$1aabd8a0274ecfd6;
var $d363c2ad98d90aba$export$3d6c20d97e46b957;
var $d363c2ad98d90aba$export$9b621391a187a31a;
var $d363c2ad98d90aba$export$f5bbd400c2f4426f;
'use strict';
var $d363c2ad98d90aba$var$b = Symbol.for("react.element"), $d363c2ad98d90aba$var$c = Symbol.for("react.portal"), $d363c2ad98d90aba$var$d = Symbol.for("react.fragment"), $d363c2ad98d90aba$var$e = Symbol.for("react.strict_mode"), $d363c2ad98d90aba$var$f = Symbol.for("react.profiler"), $d363c2ad98d90aba$var$g = Symbol.for("react.provider"), $d363c2ad98d90aba$var$h = Symbol.for("react.context"), $d363c2ad98d90aba$var$k = Symbol.for("react.server_context"), $d363c2ad98d90aba$var$l = Symbol.for("react.forward_ref"), $d363c2ad98d90aba$var$m = Symbol.for("react.suspense"), $d363c2ad98d90aba$var$n = Symbol.for("react.suspense_list"), $d363c2ad98d90aba$var$p = Symbol.for("react.memo"), $d363c2ad98d90aba$var$q = Symbol.for("react.lazy"), $d363c2ad98d90aba$var$t = Symbol.for("react.offscreen"), $d363c2ad98d90aba$var$u;
$d363c2ad98d90aba$var$u = Symbol.for("react.module.reference");
function $d363c2ad98d90aba$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $d363c2ad98d90aba$var$b:
                switch(a = a.type, a){
                    case $d363c2ad98d90aba$var$d:
                    case $d363c2ad98d90aba$var$f:
                    case $d363c2ad98d90aba$var$e:
                    case $d363c2ad98d90aba$var$m:
                    case $d363c2ad98d90aba$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $d363c2ad98d90aba$var$k:
                            case $d363c2ad98d90aba$var$h:
                            case $d363c2ad98d90aba$var$l:
                            case $d363c2ad98d90aba$var$q:
                            case $d363c2ad98d90aba$var$p:
                            case $d363c2ad98d90aba$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $d363c2ad98d90aba$var$c:
                return r;
        }
    }
}
$d363c2ad98d90aba$export$a7c73072b1a182ae = $d363c2ad98d90aba$var$h;
$d363c2ad98d90aba$export$9f27bc3417b4524d = $d363c2ad98d90aba$var$g;
$d363c2ad98d90aba$export$db77ccec0bb4ccac = $d363c2ad98d90aba$var$b;
$d363c2ad98d90aba$export$8392c0c9d3dcbd35 = $d363c2ad98d90aba$var$l;
$d363c2ad98d90aba$export$ffb0004e005737fa = $d363c2ad98d90aba$var$d;
$d363c2ad98d90aba$export$b624eff549462981 = $d363c2ad98d90aba$var$q;
$d363c2ad98d90aba$export$7897aa7841a5380c = $d363c2ad98d90aba$var$p;
$d363c2ad98d90aba$export$602eac185826482c = $d363c2ad98d90aba$var$c;
$d363c2ad98d90aba$export$e2c29f18771995cb = $d363c2ad98d90aba$var$f;
$d363c2ad98d90aba$export$5f8d39834fd61797 = $d363c2ad98d90aba$var$e;
$d363c2ad98d90aba$export$74bf444e3cd11ea5 = $d363c2ad98d90aba$var$m;
$d363c2ad98d90aba$export$998bcd577473dd93 = $d363c2ad98d90aba$var$n;
$d363c2ad98d90aba$export$92387174baf9b227 = function() {
    return !1;
};
$d363c2ad98d90aba$export$ec112efeb987d9c6 = function() {
    return !1;
};
$d363c2ad98d90aba$export$b706b080d889d2c9 = function(a) {
    return $d363c2ad98d90aba$var$v(a) === $d363c2ad98d90aba$var$h;
};
$d363c2ad98d90aba$export$5be5a87408f70ddc = function(a) {
    return $d363c2ad98d90aba$var$v(a) === $d363c2ad98d90aba$var$g;
};
$d363c2ad98d90aba$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $d363c2ad98d90aba$var$b;
};
$d363c2ad98d90aba$export$455c2e768291efa6 = function(a) {
    return $d363c2ad98d90aba$var$v(a) === $d363c2ad98d90aba$var$l;
};
$d363c2ad98d90aba$export$9522e17588c12572 = function(a) {
    return $d363c2ad98d90aba$var$v(a) === $d363c2ad98d90aba$var$d;
};
$d363c2ad98d90aba$export$2110ac352bb060b9 = function(a) {
    return $d363c2ad98d90aba$var$v(a) === $d363c2ad98d90aba$var$q;
};
$d363c2ad98d90aba$export$56885ab8b9c456ab = function(a) {
    return $d363c2ad98d90aba$var$v(a) === $d363c2ad98d90aba$var$p;
};
$d363c2ad98d90aba$export$d927fcb6adf8f9de = function(a) {
    return $d363c2ad98d90aba$var$v(a) === $d363c2ad98d90aba$var$c;
};
$d363c2ad98d90aba$export$b82d16f27459e05a = function(a) {
    return $d363c2ad98d90aba$var$v(a) === $d363c2ad98d90aba$var$f;
};
$d363c2ad98d90aba$export$522c17b4f5e123e8 = function(a) {
    return $d363c2ad98d90aba$var$v(a) === $d363c2ad98d90aba$var$e;
};
$d363c2ad98d90aba$export$1aabd8a0274ecfd6 = function(a) {
    return $d363c2ad98d90aba$var$v(a) === $d363c2ad98d90aba$var$m;
};
$d363c2ad98d90aba$export$3d6c20d97e46b957 = function(a) {
    return $d363c2ad98d90aba$var$v(a) === $d363c2ad98d90aba$var$n;
};
$d363c2ad98d90aba$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $d363c2ad98d90aba$var$d || a === $d363c2ad98d90aba$var$f || a === $d363c2ad98d90aba$var$e || a === $d363c2ad98d90aba$var$m || a === $d363c2ad98d90aba$var$n || a === $d363c2ad98d90aba$var$t || "object" === typeof a && null !== a && (a.$$typeof === $d363c2ad98d90aba$var$q || a.$$typeof === $d363c2ad98d90aba$var$p || a.$$typeof === $d363c2ad98d90aba$var$g || a.$$typeof === $d363c2ad98d90aba$var$h || a.$$typeof === $d363c2ad98d90aba$var$l || a.$$typeof === $d363c2ad98d90aba$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$d363c2ad98d90aba$export$f5bbd400c2f4426f = $d363c2ad98d90aba$var$v;

});

var $d15f6e8ca8604f1a$exports = {};
'use strict';

$d15f6e8ca8604f1a$exports = (parcelRequire("gqMbp"));



var $h2ArV = parcelRequire("h2ArV");

var $3NhwF = parcelRequire("3NhwF");
let $b1e4a7d525070c66$var$e = {
    data: ""
}, $b1e4a7d525070c66$var$t = (t)=>{
    if ("object" == typeof window) {
        let e = (t ? t.querySelector("#_goober") : window._goober) || Object.assign(document.createElement("style"), {
            innerHTML: " ",
            id: "_goober"
        });
        return e.nonce = window.__nonce__, e.parentNode || (t || document.head).appendChild(e), e.firstChild;
    }
    return t || $b1e4a7d525070c66$var$e;
}, $b1e4a7d525070c66$export$54aba348a7896325 = (e)=>{
    let r = $b1e4a7d525070c66$var$t(e), l = r.data;
    return r.data = "", l;
}, $b1e4a7d525070c66$var$l = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, $b1e4a7d525070c66$var$a = /\/\*[^]*?\*\/|  +/g, $b1e4a7d525070c66$var$n = /\n+/g, $b1e4a7d525070c66$var$o = (e, t)=>{
    let r = "", l = "", a = "";
    for(let n in e){
        let c = e[n];
        "@" == n[0] ? "i" == n[1] ? r = n + " " + c + ";" : l += "f" == n[1] ? $b1e4a7d525070c66$var$o(c, n) : n + "{" + $b1e4a7d525070c66$var$o(c, "k" == n[1] ? "" : t) + "}" : "object" == typeof c ? l += $b1e4a7d525070c66$var$o(c, t ? t.replace(/([^,])+/g, (e)=>n.replace(/([^,]*:\S+\([^)]*\))|([^,])+/g, (t)=>/&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t)) : n) : null != c && (n = /^--/.test(n) ? n : n.replace(/[A-Z]/g, "-$&").toLowerCase(), a += $b1e4a7d525070c66$var$o.p ? $b1e4a7d525070c66$var$o.p(n, c) : n + ":" + c + ";");
    }
    return r + (t && a ? t + "{" + a + "}" : a) + l;
}, $b1e4a7d525070c66$var$c = {}, $b1e4a7d525070c66$var$s = (e)=>{
    if ("object" == typeof e) {
        let t = "";
        for(let r in e)t += r + $b1e4a7d525070c66$var$s(e[r]);
        return t;
    }
    return e;
}, $b1e4a7d525070c66$var$i = (e, t, r, i, p)=>{
    let u = $b1e4a7d525070c66$var$s(e), d = $b1e4a7d525070c66$var$c[u] || ($b1e4a7d525070c66$var$c[u] = ((e)=>{
        let t = 0, r = 11;
        for(; t < e.length;)r = 101 * r + e.charCodeAt(t++) >>> 0;
        return "go" + r;
    })(u));
    if (!$b1e4a7d525070c66$var$c[d]) {
        let t = u !== e ? e : ((e)=>{
            let t, r, o = [
                {}
            ];
            for(; t = $b1e4a7d525070c66$var$l.exec(e.replace($b1e4a7d525070c66$var$a, ""));)t[4] ? o.shift() : t[3] ? (r = t[3].replace($b1e4a7d525070c66$var$n, " ").trim(), o.unshift(o[0][r] = o[0][r] || {})) : o[0][t[1]] = t[2].replace($b1e4a7d525070c66$var$n, " ").trim();
            return o[0];
        })(e);
        $b1e4a7d525070c66$var$c[d] = $b1e4a7d525070c66$var$o(p ? {
            ["@keyframes " + d]: t
        } : t, r ? "" : "." + d);
    }
    let f = r && $b1e4a7d525070c66$var$c.g ? $b1e4a7d525070c66$var$c.g : null;
    return r && ($b1e4a7d525070c66$var$c.g = $b1e4a7d525070c66$var$c[d]), ((e, t, r, l)=>{
        l ? t.data = t.data.replace(l, e) : -1 === t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
    })($b1e4a7d525070c66$var$c[d], t, i, f), d;
}, $b1e4a7d525070c66$var$p = (e, t, r)=>e.reduce((e, l, a)=>{
        let n = t[a];
        if (n && n.call) {
            let e = n(r), t = e && e.props && e.props.className || /^go/.test(e) && e;
            n = t ? "." + t : e && "object" == typeof e ? e.props ? "" : $b1e4a7d525070c66$var$o(e, "") : !1 === e ? "" : e;
        }
        return e + l + (null == n ? "" : n);
    }, "");
function $b1e4a7d525070c66$export$dbf350e5966cf602(e) {
    let r = this || {}, l = e.call ? e(r.p) : e;
    return $b1e4a7d525070c66$var$i(l.unshift ? l.raw ? $b1e4a7d525070c66$var$p(l, [].slice.call(arguments, 1), r.p) : l.reduce((e, t)=>Object.assign(e, t && t.call ? t(r.p) : t), {}) : l, $b1e4a7d525070c66$var$t(r.target), r.g, r.o, r.k);
}
let $b1e4a7d525070c66$var$d, $b1e4a7d525070c66$var$f, $b1e4a7d525070c66$var$g, $b1e4a7d525070c66$export$442f1a04865e4790 = $b1e4a7d525070c66$export$dbf350e5966cf602.bind({
    g: 1
}), $b1e4a7d525070c66$export$d25ddfdf17c3ad3e = $b1e4a7d525070c66$export$dbf350e5966cf602.bind({
    k: 1
});
function $b1e4a7d525070c66$export$de27182ff8187d6c(e, t, r, l) {
    $b1e4a7d525070c66$var$o.p = t, $b1e4a7d525070c66$var$d = e, $b1e4a7d525070c66$var$f = r, $b1e4a7d525070c66$var$g = l;
}
function $b1e4a7d525070c66$export$3817b7a54a07cec7(e, t) {
    let r = this || {};
    return function() {
        let l = arguments;
        function a(n, o) {
            let c = Object.assign({}, n), s = c.className || a.className;
            r.p = Object.assign({
                theme: $b1e4a7d525070c66$var$f && $b1e4a7d525070c66$var$f()
            }, c), r.o = / *go\d+/.test(s), c.className = $b1e4a7d525070c66$export$dbf350e5966cf602.apply(r, l) + (s ? " " + s : ""), t && (c.ref = o);
            let i = e;
            return e[0] && (i = c.as || e, delete c.as), $b1e4a7d525070c66$var$g && i[0] && $b1e4a7d525070c66$var$g(c), $b1e4a7d525070c66$var$d(i, c);
        }
        return t ? t(a) : a;
    };
}


/**
 * React Router DOM v6.30.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $h2ArV = parcelRequire("h2ArV");

var $3NhwF = parcelRequire("3NhwF");
/**
 * @remix-run/router v1.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $8280ca3af81a1b06$var$_extends() {
    $8280ca3af81a1b06$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8280ca3af81a1b06$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $8280ca3af81a1b06$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($8280ca3af81a1b06$export$e19cd5f9376f8cee || ($8280ca3af81a1b06$export$e19cd5f9376f8cee = {}));
const $8280ca3af81a1b06$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $8280ca3af81a1b06$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $8280ca3af81a1b06$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $8280ca3af81a1b06$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $8280ca3af81a1b06$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $8280ca3af81a1b06$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $8280ca3af81a1b06$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $8280ca3af81a1b06$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $8280ca3af81a1b06$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $8280ca3af81a1b06$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $8280ca3af81a1b06$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $8280ca3af81a1b06$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $8280ca3af81a1b06$export$fe53371bee54353d(to);
    }
    return $8280ca3af81a1b06$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $8280ca3af81a1b06$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $8280ca3af81a1b06$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $8280ca3af81a1b06$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $8280ca3af81a1b06$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $8280ca3af81a1b06$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $8280ca3af81a1b06$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $8280ca3af81a1b06$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $8280ca3af81a1b06$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $8280ca3af81a1b06$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $8280ca3af81a1b06$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $8280ca3af81a1b06$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $8280ca3af81a1b06$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $8280ca3af81a1b06$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $8280ca3af81a1b06$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $8280ca3af81a1b06$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $8280ca3af81a1b06$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $8280ca3af81a1b06$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $8280ca3af81a1b06$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($8280ca3af81a1b06$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $8280ca3af81a1b06$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $8280ca3af81a1b06$export$e19cd5f9376f8cee.Push;
        let location = $8280ca3af81a1b06$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $8280ca3af81a1b06$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $8280ca3af81a1b06$export$e19cd5f9376f8cee.Replace;
        let location = $8280ca3af81a1b06$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $8280ca3af81a1b06$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $8280ca3af81a1b06$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $8280ca3af81a1b06$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($8280ca3af81a1b06$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($8280ca3af81a1b06$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $8280ca3af81a1b06$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($8280ca3af81a1b06$var$ResultType || ($8280ca3af81a1b06$var$ResultType = {}));
const $8280ca3af81a1b06$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $8280ca3af81a1b06$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $8280ca3af81a1b06$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $8280ca3af81a1b06$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $8280ca3af81a1b06$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($8280ca3af81a1b06$var$isIndexRoute(route)) {
            let indexRoute = $8280ca3af81a1b06$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $8280ca3af81a1b06$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $8280ca3af81a1b06$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $8280ca3af81a1b06$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $8280ca3af81a1b06$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $8280ca3af81a1b06$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $8280ca3af81a1b06$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $8280ca3af81a1b06$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $8280ca3af81a1b06$var$flattenRoutes(routes);
    $8280ca3af81a1b06$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $8280ca3af81a1b06$export$30d21fd6d7295f52(pathname);
        matches = $8280ca3af81a1b06$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $8280ca3af81a1b06$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $8280ca3af81a1b06$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $8280ca3af81a1b06$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $8280ca3af81a1b06$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $8280ca3af81a1b06$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $8280ca3af81a1b06$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $8280ca3af81a1b06$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $8280ca3af81a1b06$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $8280ca3af81a1b06$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $8280ca3af81a1b06$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $8280ca3af81a1b06$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $8280ca3af81a1b06$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $8280ca3af81a1b06$var$paramRe = /^:[\w-]+$/;
const $8280ca3af81a1b06$var$dynamicSegmentValue = 3;
const $8280ca3af81a1b06$var$indexRouteValue = 2;
const $8280ca3af81a1b06$var$emptySegmentValue = 1;
const $8280ca3af81a1b06$var$staticSegmentValue = 10;
const $8280ca3af81a1b06$var$splatPenalty = -2;
const $8280ca3af81a1b06$var$isSplat = (s)=>s === "*";
function $8280ca3af81a1b06$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($8280ca3af81a1b06$var$isSplat)) initialScore += $8280ca3af81a1b06$var$splatPenalty;
    if (index) initialScore += $8280ca3af81a1b06$var$indexRouteValue;
    return segments.filter((s)=>!$8280ca3af81a1b06$var$isSplat(s)).reduce((score, segment)=>score + ($8280ca3af81a1b06$var$paramRe.test(segment) ? $8280ca3af81a1b06$var$dynamicSegmentValue : segment === "" ? $8280ca3af81a1b06$var$emptySegmentValue : $8280ca3af81a1b06$var$staticSegmentValue), initialScore);
}
function $8280ca3af81a1b06$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $8280ca3af81a1b06$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $8280ca3af81a1b06$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $8280ca3af81a1b06$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $8280ca3af81a1b06$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $8280ca3af81a1b06$export$a5c6d149b50c1d86($8280ca3af81a1b06$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $8280ca3af81a1b06$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $8280ca3af81a1b06$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $8280ca3af81a1b06$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $8280ca3af81a1b06$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $8280ca3af81a1b06$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $8280ca3af81a1b06$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $8280ca3af81a1b06$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $8280ca3af81a1b06$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $8280ca3af81a1b06$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $8280ca3af81a1b06$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $8280ca3af81a1b06$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $8280ca3af81a1b06$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $8280ca3af81a1b06$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $8280ca3af81a1b06$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $8280ca3af81a1b06$var$normalizeSearch(search),
        hash: $8280ca3af81a1b06$var$normalizeHash(hash)
    };
}
function $8280ca3af81a1b06$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $8280ca3af81a1b06$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $8280ca3af81a1b06$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $8280ca3af81a1b06$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $8280ca3af81a1b06$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $8280ca3af81a1b06$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $8280ca3af81a1b06$export$8ccf933b0513f8d0(toArg);
    else {
        to = $8280ca3af81a1b06$var$_extends({}, toArg);
        $8280ca3af81a1b06$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $8280ca3af81a1b06$var$getInvalidPathError("?", "pathname", "search", to));
        $8280ca3af81a1b06$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $8280ca3af81a1b06$var$getInvalidPathError("#", "pathname", "hash", to));
        $8280ca3af81a1b06$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $8280ca3af81a1b06$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $8280ca3af81a1b06$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $8280ca3af81a1b06$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $8280ca3af81a1b06$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $8280ca3af81a1b06$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $8280ca3af81a1b06$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $8280ca3af81a1b06$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $8280ca3af81a1b06$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $8280ca3af81a1b06$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $8280ca3af81a1b06$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $8280ca3af81a1b06$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $8280ca3af81a1b06$export$4051a07651545597(data, init) {
    return new $8280ca3af81a1b06$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $8280ca3af81a1b06$export$42a99a7a4bc0e76a extends Error {
}
class $8280ca3af81a1b06$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $8280ca3af81a1b06$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $8280ca3af81a1b06$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $8280ca3af81a1b06$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $8280ca3af81a1b06$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $8280ca3af81a1b06$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $8280ca3af81a1b06$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $8280ca3af81a1b06$var$unwrapTrackedPromise(value) {
    if (!$8280ca3af81a1b06$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $8280ca3af81a1b06$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $8280ca3af81a1b06$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $8280ca3af81a1b06$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $8280ca3af81a1b06$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $8280ca3af81a1b06$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $8280ca3af81a1b06$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $8280ca3af81a1b06$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $8280ca3af81a1b06$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $8280ca3af81a1b06$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $8280ca3af81a1b06$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $8280ca3af81a1b06$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $8280ca3af81a1b06$var$validMutationMethods = new Set($8280ca3af81a1b06$var$validMutationMethodsArr);
const $8280ca3af81a1b06$var$validRequestMethodsArr = [
    "get",
    ...$8280ca3af81a1b06$var$validMutationMethodsArr
];
const $8280ca3af81a1b06$var$validRequestMethods = new Set($8280ca3af81a1b06$var$validRequestMethodsArr);
const $8280ca3af81a1b06$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $8280ca3af81a1b06$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $8280ca3af81a1b06$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $8280ca3af81a1b06$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $8280ca3af81a1b06$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $8280ca3af81a1b06$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $8280ca3af81a1b06$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $8280ca3af81a1b06$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $8280ca3af81a1b06$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $8280ca3af81a1b06$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $8280ca3af81a1b06$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $8280ca3af81a1b06$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $8280ca3af81a1b06$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $8280ca3af81a1b06$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $8280ca3af81a1b06$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $8280ca3af81a1b06$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $8280ca3af81a1b06$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$8280ca3af81a1b06$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$8280ca3af81a1b06$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $8280ca3af81a1b06$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $8280ca3af81a1b06$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $8280ca3af81a1b06$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $8280ca3af81a1b06$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $8280ca3af81a1b06$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$8280ca3af81a1b06$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($8280ca3af81a1b06$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $8280ca3af81a1b06$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $8280ca3af81a1b06$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $8280ca3af81a1b06$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $8280ca3af81a1b06$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $8280ca3af81a1b06$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $8280ca3af81a1b06$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $8280ca3af81a1b06$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $8280ca3af81a1b06$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $8280ca3af81a1b06$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($8280ca3af81a1b06$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $8280ca3af81a1b06$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $8280ca3af81a1b06$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $8280ca3af81a1b06$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $8280ca3af81a1b06$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $8280ca3af81a1b06$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $8280ca3af81a1b06$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $8280ca3af81a1b06$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $8280ca3af81a1b06$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $8280ca3af81a1b06$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $8280ca3af81a1b06$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $8280ca3af81a1b06$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $8280ca3af81a1b06$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $8280ca3af81a1b06$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $8280ca3af81a1b06$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $8280ca3af81a1b06$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $8280ca3af81a1b06$var$findNearestBoundary(matches).route.id,
            {
                type: $8280ca3af81a1b06$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $8280ca3af81a1b06$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($8280ca3af81a1b06$var$isErrorResult(result) && $8280ca3af81a1b06$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $8280ca3af81a1b06$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $8280ca3af81a1b06$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $8280ca3af81a1b06$var$_extends({
            matches: updatedMatches || matches
        }, $8280ca3af81a1b06$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $8280ca3af81a1b06$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $8280ca3af81a1b06$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $8280ca3af81a1b06$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $8280ca3af81a1b06$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $8280ca3af81a1b06$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $8280ca3af81a1b06$var$ResultType.error,
            error: $8280ca3af81a1b06$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($8280ca3af81a1b06$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $8280ca3af81a1b06$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($8280ca3af81a1b06$var$isDeferredResult(result)) throw $8280ca3af81a1b06$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($8280ca3af81a1b06$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $8280ca3af81a1b06$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $8280ca3af81a1b06$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $8280ca3af81a1b06$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $8280ca3af81a1b06$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($8280ca3af81a1b06$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $8280ca3af81a1b06$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $8280ca3af81a1b06$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $8280ca3af81a1b06$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $8280ca3af81a1b06$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $8280ca3af81a1b06$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $8280ca3af81a1b06$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $8280ca3af81a1b06$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $8280ca3af81a1b06$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $8280ca3af81a1b06$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $8280ca3af81a1b06$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$8280ca3af81a1b06$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $8280ca3af81a1b06$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $8280ca3af81a1b06$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $8280ca3af81a1b06$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $8280ca3af81a1b06$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $8280ca3af81a1b06$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $8280ca3af81a1b06$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $8280ca3af81a1b06$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $8280ca3af81a1b06$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $8280ca3af81a1b06$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $8280ca3af81a1b06$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $8280ca3af81a1b06$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $8280ca3af81a1b06$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($8280ca3af81a1b06$var$isRedirectResult(actionResult) || $8280ca3af81a1b06$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $8280ca3af81a1b06$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($8280ca3af81a1b06$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $8280ca3af81a1b06$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $8280ca3af81a1b06$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($8280ca3af81a1b06$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($8280ca3af81a1b06$var$isDeferredResult(actionResult)) throw $8280ca3af81a1b06$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $8280ca3af81a1b06$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $8280ca3af81a1b06$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $8280ca3af81a1b06$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $8280ca3af81a1b06$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $8280ca3af81a1b06$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $8280ca3af81a1b06$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $8280ca3af81a1b06$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $8280ca3af81a1b06$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $8280ca3af81a1b06$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $8280ca3af81a1b06$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $8280ca3af81a1b06$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $8280ca3af81a1b06$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $8280ca3af81a1b06$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $8280ca3af81a1b06$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $8280ca3af81a1b06$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $8280ca3af81a1b06$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($8280ca3af81a1b06$var$isDeferredResult(result)) result = await $8280ca3af81a1b06$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $8280ca3af81a1b06$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($8280ca3af81a1b06$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $8280ca3af81a1b06$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($8280ca3af81a1b06$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $8280ca3af81a1b06$export$3e9cee6b33872309(!$8280ca3af81a1b06$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $8280ca3af81a1b06$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $8280ca3af81a1b06$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $8280ca3af81a1b06$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $8280ca3af81a1b06$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($8280ca3af81a1b06$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $8280ca3af81a1b06$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $8280ca3af81a1b06$export$e19cd5f9376f8cee.Replace : $8280ca3af81a1b06$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $8280ca3af81a1b06$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($8280ca3af81a1b06$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $8280ca3af81a1b06$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $8280ca3af81a1b06$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $8280ca3af81a1b06$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $8280ca3af81a1b06$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $8280ca3af81a1b06$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($8280ca3af81a1b06$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $8280ca3af81a1b06$var$ResultType.redirect,
                response: $8280ca3af81a1b06$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $8280ca3af81a1b06$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $8280ca3af81a1b06$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $8280ca3af81a1b06$var$ResultType.error,
                    error: $8280ca3af81a1b06$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $8280ca3af81a1b06$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $8280ca3af81a1b06$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $8280ca3af81a1b06$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $8280ca3af81a1b06$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $8280ca3af81a1b06$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $8280ca3af81a1b06$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $8280ca3af81a1b06$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $8280ca3af81a1b06$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $8280ca3af81a1b06$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $8280ca3af81a1b06$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $8280ca3af81a1b06$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $8280ca3af81a1b06$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $8280ca3af81a1b06$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $8280ca3af81a1b06$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$8280ca3af81a1b06$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $8280ca3af81a1b06$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $8280ca3af81a1b06$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $8280ca3af81a1b06$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $8280ca3af81a1b06$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $8280ca3af81a1b06$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $8280ca3af81a1b06$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $8280ca3af81a1b06$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $8280ca3af81a1b06$export$4d0306f8f6a4585b = Symbol("deferred");
function $8280ca3af81a1b06$export$3336b097a6fbc59a(routes, opts) {
    $8280ca3af81a1b06$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $8280ca3af81a1b06$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $8280ca3af81a1b06$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $8280ca3af81a1b06$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $8280ca3af81a1b06$var$createLocation("", $8280ca3af81a1b06$export$fe53371bee54353d(url), null, "default");
        let matches = $8280ca3af81a1b06$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$8280ca3af81a1b06$var$isValidMethod(method) && method !== "HEAD") {
            let error = $8280ca3af81a1b06$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $8280ca3af81a1b06$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $8280ca3af81a1b06$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $8280ca3af81a1b06$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($8280ca3af81a1b06$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $8280ca3af81a1b06$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $8280ca3af81a1b06$var$createLocation("", $8280ca3af81a1b06$export$fe53371bee54353d(url), null, "default");
        let matches = $8280ca3af81a1b06$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$8280ca3af81a1b06$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $8280ca3af81a1b06$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $8280ca3af81a1b06$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $8280ca3af81a1b06$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $8280ca3af81a1b06$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $8280ca3af81a1b06$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($8280ca3af81a1b06$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$8280ca3af81a1b06$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $8280ca3af81a1b06$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($8280ca3af81a1b06$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $8280ca3af81a1b06$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $8280ca3af81a1b06$var$isResponse(result) ? result : $8280ca3af81a1b06$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($8280ca3af81a1b06$var$isDataStrategyResult(e) && $8280ca3af81a1b06$var$isResponse(e.result)) {
                if (e.type === $8280ca3af81a1b06$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($8280ca3af81a1b06$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $8280ca3af81a1b06$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $8280ca3af81a1b06$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $8280ca3af81a1b06$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($8280ca3af81a1b06$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($8280ca3af81a1b06$var$isDeferredResult(result)) {
            let error = $8280ca3af81a1b06$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $8280ca3af81a1b06$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($8280ca3af81a1b06$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($8280ca3af81a1b06$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $8280ca3af81a1b06$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $8280ca3af81a1b06$var$_extends({}, context, {
                statusCode: $8280ca3af81a1b06$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $8280ca3af81a1b06$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $8280ca3af81a1b06$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $8280ca3af81a1b06$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $8280ca3af81a1b06$var$isErrorResult(pendingActionResult[1]) ? $8280ca3af81a1b06$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $8280ca3af81a1b06$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $8280ca3af81a1b06$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $8280ca3af81a1b06$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $8280ca3af81a1b06$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $8280ca3af81a1b06$var$callDataStrategyImpl(dataStrategy || $8280ca3af81a1b06$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($8280ca3af81a1b06$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $8280ca3af81a1b06$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($8280ca3af81a1b06$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $8280ca3af81a1b06$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $8280ca3af81a1b06$export$fec11da027c70692(routes, context, error) {
    let newContext = $8280ca3af81a1b06$var$_extends({}, context, {
        statusCode: $8280ca3af81a1b06$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $8280ca3af81a1b06$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $8280ca3af81a1b06$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $8280ca3af81a1b06$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $8280ca3af81a1b06$export$cae722b0cc860f13(to ? to : ".", $8280ca3af81a1b06$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $8280ca3af81a1b06$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $8280ca3af81a1b06$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $8280ca3af81a1b06$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $8280ca3af81a1b06$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $8280ca3af81a1b06$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$8280ca3af81a1b06$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$8280ca3af81a1b06$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $8280ca3af81a1b06$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $8280ca3af81a1b06$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $8280ca3af81a1b06$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$8280ca3af81a1b06$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$8280ca3af81a1b06$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $8280ca3af81a1b06$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $8280ca3af81a1b06$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $8280ca3af81a1b06$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $8280ca3af81a1b06$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $8280ca3af81a1b06$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($8280ca3af81a1b06$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $8280ca3af81a1b06$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $8280ca3af81a1b06$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $8280ca3af81a1b06$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $8280ca3af81a1b06$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $8280ca3af81a1b06$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $8280ca3af81a1b06$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $8280ca3af81a1b06$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $8280ca3af81a1b06$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $8280ca3af81a1b06$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $8280ca3af81a1b06$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($8280ca3af81a1b06$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $8280ca3af81a1b06$var$shouldRevalidateLoader(match, $8280ca3af81a1b06$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $8280ca3af81a1b06$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $8280ca3af81a1b06$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $8280ca3af81a1b06$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $8280ca3af81a1b06$var$shouldRevalidateLoader(fetcherMatch, $8280ca3af81a1b06$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $8280ca3af81a1b06$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $8280ca3af81a1b06$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $8280ca3af81a1b06$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $8280ca3af81a1b06$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $8280ca3af81a1b06$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $8280ca3af81a1b06$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$8280ca3af81a1b06$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $8280ca3af81a1b06$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $8280ca3af81a1b06$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$8280ca3af81a1b06$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $8280ca3af81a1b06$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $8280ca3af81a1b06$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $8280ca3af81a1b06$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$8280ca3af81a1b06$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $8280ca3af81a1b06$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $8280ca3af81a1b06$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $8280ca3af81a1b06$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $8280ca3af81a1b06$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $8280ca3af81a1b06$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $8280ca3af81a1b06$var$ResultType.data,
                result: undefined
            });
        };
        return $8280ca3af81a1b06$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $8280ca3af81a1b06$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $8280ca3af81a1b06$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $8280ca3af81a1b06$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $8280ca3af81a1b06$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $8280ca3af81a1b06$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $8280ca3af81a1b06$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $8280ca3af81a1b06$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($8280ca3af81a1b06$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $8280ca3af81a1b06$var$ResultType.error,
                error: e
            };
        }
        if (type === $8280ca3af81a1b06$var$ResultType.error) return {
            type: $8280ca3af81a1b06$var$ResultType.error,
            error: new $8280ca3af81a1b06$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $8280ca3af81a1b06$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $8280ca3af81a1b06$var$ResultType.error) {
        if ($8280ca3af81a1b06$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $8280ca3af81a1b06$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $8280ca3af81a1b06$var$ResultType.error,
                error: new $8280ca3af81a1b06$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $8280ca3af81a1b06$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $8280ca3af81a1b06$var$ResultType.error,
            error: result,
            statusCode: $8280ca3af81a1b06$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($8280ca3af81a1b06$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $8280ca3af81a1b06$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($8280ca3af81a1b06$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $8280ca3af81a1b06$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $8280ca3af81a1b06$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $8280ca3af81a1b06$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $8280ca3af81a1b06$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$8280ca3af81a1b06$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $8280ca3af81a1b06$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $8280ca3af81a1b06$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($8280ca3af81a1b06$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $8280ca3af81a1b06$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $8280ca3af81a1b06$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($8280ca3af81a1b06$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $8280ca3af81a1b06$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $8280ca3af81a1b06$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $8280ca3af81a1b06$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $8280ca3af81a1b06$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $8280ca3af81a1b06$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $8280ca3af81a1b06$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $8280ca3af81a1b06$export$3e9cee6b33872309(!$8280ca3af81a1b06$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($8280ca3af81a1b06$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $8280ca3af81a1b06$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $8280ca3af81a1b06$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($8280ca3af81a1b06$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $8280ca3af81a1b06$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $8280ca3af81a1b06$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $8280ca3af81a1b06$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($8280ca3af81a1b06$var$isErrorResult(result)) {
            let boundaryMatch = $8280ca3af81a1b06$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $8280ca3af81a1b06$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($8280ca3af81a1b06$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $8280ca3af81a1b06$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($8280ca3af81a1b06$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $8280ca3af81a1b06$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $8280ca3af81a1b06$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $8280ca3af81a1b06$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $8280ca3af81a1b06$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $8280ca3af81a1b06$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $8280ca3af81a1b06$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $8280ca3af81a1b06$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $8280ca3af81a1b06$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $8280ca3af81a1b06$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $8280ca3af81a1b06$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $8280ca3af81a1b06$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($8280ca3af81a1b06$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $8280ca3af81a1b06$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $8280ca3af81a1b06$export$8ccf933b0513f8d0(path) : path;
    return $8280ca3af81a1b06$export$fe53371bee54353d($8280ca3af81a1b06$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $8280ca3af81a1b06$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $8280ca3af81a1b06$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $8280ca3af81a1b06$var$ResultType.data || result.type === $8280ca3af81a1b06$var$ResultType.error);
}
function $8280ca3af81a1b06$var$isRedirectDataStrategyResultResult(result) {
    return $8280ca3af81a1b06$var$isResponse(result.result) && $8280ca3af81a1b06$var$redirectStatusCodes.has(result.result.status);
}
function $8280ca3af81a1b06$var$isDeferredResult(result) {
    return result.type === $8280ca3af81a1b06$var$ResultType.deferred;
}
function $8280ca3af81a1b06$var$isErrorResult(result) {
    return result.type === $8280ca3af81a1b06$var$ResultType.error;
}
function $8280ca3af81a1b06$var$isRedirectResult(result) {
    return (result && result.type) === $8280ca3af81a1b06$var$ResultType.redirect;
}
function $8280ca3af81a1b06$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $8280ca3af81a1b06$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $8280ca3af81a1b06$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $8280ca3af81a1b06$var$isRedirectResponse(result) {
    if (!$8280ca3af81a1b06$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $8280ca3af81a1b06$var$isValidMethod(method) {
    return $8280ca3af81a1b06$var$validRequestMethods.has(method.toLowerCase());
}
function $8280ca3af81a1b06$var$isMutationMethod(method) {
    return $8280ca3af81a1b06$var$validMutationMethods.has(method.toLowerCase());
}
async function $8280ca3af81a1b06$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$8280ca3af81a1b06$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($8280ca3af81a1b06$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $8280ca3af81a1b06$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $8280ca3af81a1b06$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($8280ca3af81a1b06$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $8280ca3af81a1b06$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $8280ca3af81a1b06$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $8280ca3af81a1b06$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $8280ca3af81a1b06$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $8280ca3af81a1b06$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $8280ca3af81a1b06$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $8280ca3af81a1b06$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $8280ca3af81a1b06$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $8280ca3af81a1b06$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $8280ca3af81a1b06$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $8280ca3af81a1b06$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $8280ca3af81a1b06$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $8280ca3af81a1b06$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $8280ca3af81a1b06$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $8280ca3af81a1b06$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $8280ca3af81a1b06$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $8280ca3af81a1b06$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $8280ca3af81a1b06$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($8280ca3af81a1b06$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $8280ca3af81a1b06$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($8280ca3af81a1b06$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $8280ca3af81a1b06$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $h2ArV = parcelRequire("h2ArV");

function $4b112c041340d9ed$var$_extends() {
    $4b112c041340d9ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4b112c041340d9ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $4b112c041340d9ed$export$3add0d5dce533e2e = /*#__PURE__*/ $h2ArV.createContext(null);
const $4b112c041340d9ed$export$145dfa71566a64dc = /*#__PURE__*/ $h2ArV.createContext(null);
const $4b112c041340d9ed$var$AwaitContext = /*#__PURE__*/ $h2ArV.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $4b112c041340d9ed$export$26749e8557646306 = /*#__PURE__*/ $h2ArV.createContext(null);
const $4b112c041340d9ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $h2ArV.createContext(null);
const $4b112c041340d9ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $h2ArV.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $4b112c041340d9ed$var$RouteErrorContext = /*#__PURE__*/ $h2ArV.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $4b112c041340d9ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$4b112c041340d9ed$export$9c954a9d03d32f4a() && (0, $8280ca3af81a1b06$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $h2ArV.useContext($4b112c041340d9ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $4b112c041340d9ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $8280ca3af81a1b06$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $4b112c041340d9ed$export$9c954a9d03d32f4a() {
    return $h2ArV.useContext($4b112c041340d9ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $4b112c041340d9ed$export$45d76561a5302f2b() {
    !$4b112c041340d9ed$export$9c954a9d03d32f4a() && (0, $8280ca3af81a1b06$export$3e9cee6b33872309)(false);
    return $h2ArV.useContext($4b112c041340d9ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $4b112c041340d9ed$export$1b3f31771c5d07c() {
    return $h2ArV.useContext($4b112c041340d9ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $4b112c041340d9ed$export$6c330e8992e8a295(pattern) {
    !$4b112c041340d9ed$export$9c954a9d03d32f4a() && (0, $8280ca3af81a1b06$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $4b112c041340d9ed$export$45d76561a5302f2b();
    return $h2ArV.useMemo(()=>(0, $8280ca3af81a1b06$export$81336c211d5ff295)(pattern, (0, $8280ca3af81a1b06$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $4b112c041340d9ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $4b112c041340d9ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $h2ArV.useContext($4b112c041340d9ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $h2ArV.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $4b112c041340d9ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $h2ArV.useContext($4b112c041340d9ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $4b112c041340d9ed$var$useNavigateStable() : $4b112c041340d9ed$var$useNavigateUnstable();
}
function $4b112c041340d9ed$var$useNavigateUnstable() {
    !$4b112c041340d9ed$export$9c954a9d03d32f4a() && (0, $8280ca3af81a1b06$export$3e9cee6b33872309)(false);
    let dataRouterContext = $h2ArV.useContext($4b112c041340d9ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $h2ArV.useContext($4b112c041340d9ed$export$26749e8557646306);
    let { matches: matches } = $h2ArV.useContext($4b112c041340d9ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $4b112c041340d9ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $8280ca3af81a1b06$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $h2ArV.useRef(false);
    $4b112c041340d9ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $h2ArV.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $8280ca3af81a1b06$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $8280ca3af81a1b06$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $4b112c041340d9ed$var$OutletContext = /*#__PURE__*/ $h2ArV.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $4b112c041340d9ed$export$4138103a3ae699cc() {
    return $h2ArV.useContext($4b112c041340d9ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $4b112c041340d9ed$export$a3be3530d8e40d0b(context) {
    let outlet = $h2ArV.useContext($4b112c041340d9ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $h2ArV.createElement($4b112c041340d9ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $4b112c041340d9ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $h2ArV.useContext($4b112c041340d9ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $4b112c041340d9ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $h2ArV.useContext($4b112c041340d9ed$export$26749e8557646306);
    let { matches: matches } = $h2ArV.useContext($4b112c041340d9ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $4b112c041340d9ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $8280ca3af81a1b06$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $h2ArV.useMemo(()=>(0, $8280ca3af81a1b06$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $4b112c041340d9ed$export$5d3fca4a98652595(routes, locationArg) {
    return $4b112c041340d9ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $4b112c041340d9ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$4b112c041340d9ed$export$9c954a9d03d32f4a() && (0, $8280ca3af81a1b06$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $h2ArV.useContext($4b112c041340d9ed$export$26749e8557646306);
    let { matches: parentMatches } = $h2ArV.useContext($4b112c041340d9ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $4b112c041340d9ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $8280ca3af81a1b06$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $8280ca3af81a1b06$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $8280ca3af81a1b06$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $4b112c041340d9ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $8280ca3af81a1b06$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $8280ca3af81a1b06$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $h2ArV.createElement($4b112c041340d9ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $4b112c041340d9ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $8280ca3af81a1b06$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $4b112c041340d9ed$var$DefaultErrorComponent() {
    let error = $4b112c041340d9ed$export$ed527bf60f6e05f2();
    let message = (0, $8280ca3af81a1b06$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $h2ArV.createElement($h2ArV.Fragment, null, /*#__PURE__*/ $h2ArV.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $h2ArV.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $h2ArV.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $4b112c041340d9ed$var$defaultErrorElement = /*#__PURE__*/ $h2ArV.createElement($4b112c041340d9ed$var$DefaultErrorComponent, null);
class $4b112c041340d9ed$var$RenderErrorBoundary extends $h2ArV.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $h2ArV.createElement($4b112c041340d9ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $h2ArV.createElement($4b112c041340d9ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $4b112c041340d9ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $h2ArV.useContext($4b112c041340d9ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $h2ArV.createElement($4b112c041340d9ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $4b112c041340d9ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $8280ca3af81a1b06$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $4b112c041340d9ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $4b112c041340d9ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $h2ArV.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $h2ArV.createElement($4b112c041340d9ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $h2ArV.createElement($4b112c041340d9ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $4b112c041340d9ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($4b112c041340d9ed$var$DataRouterHook || {});
var $4b112c041340d9ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($4b112c041340d9ed$var$DataRouterStateHook || {});
function $4b112c041340d9ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $4b112c041340d9ed$var$useDataRouterContext(hookName) {
    let ctx = $h2ArV.useContext($4b112c041340d9ed$export$3add0d5dce533e2e);
    !ctx && (0, $8280ca3af81a1b06$export$3e9cee6b33872309)(false);
    return ctx;
}
function $4b112c041340d9ed$var$useDataRouterState(hookName) {
    let state = $h2ArV.useContext($4b112c041340d9ed$export$145dfa71566a64dc);
    !state && (0, $8280ca3af81a1b06$export$3e9cee6b33872309)(false);
    return state;
}
function $4b112c041340d9ed$var$useRouteContext(hookName) {
    let route = $h2ArV.useContext($4b112c041340d9ed$export$9072aa6dd1f93057);
    !route && (0, $8280ca3af81a1b06$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $4b112c041340d9ed$var$useCurrentRouteId(hookName) {
    let route = $4b112c041340d9ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $8280ca3af81a1b06$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $4b112c041340d9ed$export$5fc8298006ad9e58() {
    return $4b112c041340d9ed$var$useCurrentRouteId($4b112c041340d9ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $4b112c041340d9ed$export$d0fd4b7106de2769() {
    let state = $4b112c041340d9ed$var$useDataRouterState($4b112c041340d9ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $4b112c041340d9ed$export$600dc272ed516c15() {
    let dataRouterContext = $4b112c041340d9ed$var$useDataRouterContext($4b112c041340d9ed$var$DataRouterHook.UseRevalidator);
    let state = $4b112c041340d9ed$var$useDataRouterState($4b112c041340d9ed$var$DataRouterStateHook.UseRevalidator);
    return $h2ArV.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $4b112c041340d9ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $4b112c041340d9ed$var$useDataRouterState($4b112c041340d9ed$var$DataRouterStateHook.UseMatches);
    return $h2ArV.useMemo(()=>matches.map((m)=>(0, $8280ca3af81a1b06$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $4b112c041340d9ed$export$1448a5050d252c4d() {
    let state = $4b112c041340d9ed$var$useDataRouterState($4b112c041340d9ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $4b112c041340d9ed$var$useCurrentRouteId($4b112c041340d9ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $4b112c041340d9ed$export$fd5d37484eab868d(routeId) {
    let state = $4b112c041340d9ed$var$useDataRouterState($4b112c041340d9ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $4b112c041340d9ed$export$fdc00f3f26066d5e() {
    let state = $4b112c041340d9ed$var$useDataRouterState($4b112c041340d9ed$var$DataRouterStateHook.UseActionData);
    let routeId = $4b112c041340d9ed$var$useCurrentRouteId($4b112c041340d9ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $4b112c041340d9ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $h2ArV.useContext($4b112c041340d9ed$var$RouteErrorContext);
    let state = $4b112c041340d9ed$var$useDataRouterState($4b112c041340d9ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $4b112c041340d9ed$var$useCurrentRouteId($4b112c041340d9ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $4b112c041340d9ed$export$78a72ddb39bdd145() {
    let value = $h2ArV.useContext($4b112c041340d9ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $4b112c041340d9ed$export$17f53340677d5831() {
    let value = $h2ArV.useContext($4b112c041340d9ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $4b112c041340d9ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $4b112c041340d9ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $4b112c041340d9ed$var$useDataRouterContext($4b112c041340d9ed$var$DataRouterHook.UseBlocker);
    let state = $4b112c041340d9ed$var$useDataRouterState($4b112c041340d9ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $h2ArV.useState("");
    let blockerFunction = $h2ArV.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $4b112c041340d9ed$var$_extends({}, currentLocation, {
                pathname: (0, $8280ca3af81a1b06$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $4b112c041340d9ed$var$_extends({}, nextLocation, {
                pathname: (0, $8280ca3af81a1b06$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $h2ArV.useEffect(()=>{
        let key = String(++$4b112c041340d9ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $h2ArV.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $8280ca3af81a1b06$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $4b112c041340d9ed$var$useNavigateStable() {
    let { router: router } = $4b112c041340d9ed$var$useDataRouterContext($4b112c041340d9ed$var$DataRouterHook.UseNavigateStable);
    let id = $4b112c041340d9ed$var$useCurrentRouteId($4b112c041340d9ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $h2ArV.useRef(false);
    $4b112c041340d9ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $h2ArV.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $4b112c041340d9ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $4b112c041340d9ed$var$alreadyWarned$1 = {};
function $4b112c041340d9ed$var$warningOnce(key, cond, message) {
    if (!cond && !$4b112c041340d9ed$var$alreadyWarned$1[key]) $4b112c041340d9ed$var$alreadyWarned$1[key] = true;
}
const $4b112c041340d9ed$var$alreadyWarned = {};
function $4b112c041340d9ed$var$warnOnce(key, message) {}
const $4b112c041340d9ed$var$logDeprecation = (flag, msg, link)=>$4b112c041340d9ed$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $4b112c041340d9ed$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $4b112c041340d9ed$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $4b112c041340d9ed$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $4b112c041340d9ed$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $4b112c041340d9ed$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $4b112c041340d9ed$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $4b112c041340d9ed$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $4b112c041340d9ed$var$START_TRANSITION = "startTransition";
const $4b112c041340d9ed$var$startTransitionImpl = $h2ArV[$4b112c041340d9ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $4b112c041340d9ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $h2ArV.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $h2ArV.useCallback((newState)=>{
        if (v7_startTransition && $4b112c041340d9ed$var$startTransitionImpl) $4b112c041340d9ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $h2ArV.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $h2ArV.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $h2ArV.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $h2ArV.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $h2ArV.useEffect(()=>$4b112c041340d9ed$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $h2ArV.createElement($h2ArV.Fragment, null, /*#__PURE__*/ $h2ArV.createElement($4b112c041340d9ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $h2ArV.createElement($4b112c041340d9ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $h2ArV.createElement($4b112c041340d9ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $h2ArV.createElement($4b112c041340d9ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $4b112c041340d9ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $4b112c041340d9ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $4b112c041340d9ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $h2ArV.useRef();
    if (historyRef.current == null) historyRef.current = (0, $8280ca3af81a1b06$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $h2ArV.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $h2ArV.useCallback((newState)=>{
        v7_startTransition && $4b112c041340d9ed$var$startTransitionImpl ? $4b112c041340d9ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $h2ArV.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $h2ArV.useEffect(()=>$4b112c041340d9ed$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $h2ArV.createElement($4b112c041340d9ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $4b112c041340d9ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$4b112c041340d9ed$export$9c954a9d03d32f4a() && (0, $8280ca3af81a1b06$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $h2ArV.useContext($4b112c041340d9ed$export$26749e8557646306);
    let { matches: matches } = $h2ArV.useContext($4b112c041340d9ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $4b112c041340d9ed$export$45d76561a5302f2b();
    let navigate = $4b112c041340d9ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $8280ca3af81a1b06$export$cae722b0cc860f13)(to, (0, $8280ca3af81a1b06$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $h2ArV.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $4b112c041340d9ed$export$910ae8079b2c2852(props) {
    return $4b112c041340d9ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $4b112c041340d9ed$export$e7b0ac011bb776c6(_props) {
    (0, $8280ca3af81a1b06$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $4b112c041340d9ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $8280ca3af81a1b06$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$4b112c041340d9ed$export$9c954a9d03d32f4a() && (0, $8280ca3af81a1b06$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $h2ArV.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $4b112c041340d9ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $8280ca3af81a1b06$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $h2ArV.useMemo(()=>{
        let trailingPathname = (0, $8280ca3af81a1b06$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $h2ArV.createElement($4b112c041340d9ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $h2ArV.createElement($4b112c041340d9ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $4b112c041340d9ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $4b112c041340d9ed$export$5d3fca4a98652595($4b112c041340d9ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $4b112c041340d9ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $h2ArV.createElement($4b112c041340d9ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $h2ArV.createElement($4b112c041340d9ed$var$ResolveAwait, null, children));
}
var $4b112c041340d9ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($4b112c041340d9ed$var$AwaitRenderStatus || {});
const $4b112c041340d9ed$var$neverSettledPromise = new Promise(()=>{});
class $4b112c041340d9ed$var$AwaitErrorBoundary extends $h2ArV.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $4b112c041340d9ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $4b112c041340d9ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $4b112c041340d9ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $4b112c041340d9ed$var$AwaitRenderStatus.error : "_data" in promise ? $4b112c041340d9ed$var$AwaitRenderStatus.success : $4b112c041340d9ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $4b112c041340d9ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $4b112c041340d9ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $8280ca3af81a1b06$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $4b112c041340d9ed$var$neverSettledPromise;
        if (status === $4b112c041340d9ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $4b112c041340d9ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $h2ArV.createElement($4b112c041340d9ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $4b112c041340d9ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $h2ArV.createElement($4b112c041340d9ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $4b112c041340d9ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $4b112c041340d9ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $h2ArV.createElement($h2ArV.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $4b112c041340d9ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $h2ArV.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $h2ArV.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $h2ArV.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $4b112c041340d9ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $4b112c041340d9ed$export$e7b0ac011bb776c6) && (0, $8280ca3af81a1b06$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $8280ca3af81a1b06$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $4b112c041340d9ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $4b112c041340d9ed$export$daf73786167a7f72(matches) {
    return $4b112c041340d9ed$var$_renderMatches(matches);
}
function $4b112c041340d9ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $h2ArV.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $h2ArV.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $h2ArV.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $4b112c041340d9ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $8280ca3af81a1b06$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $4b112c041340d9ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $8280ca3af81a1b06$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $4b112c041340d9ed$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $ea9c8114d35b5a84$var$_extends() {
    $ea9c8114d35b5a84$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ea9c8114d35b5a84$var$_extends.apply(this, arguments);
}
function $ea9c8114d35b5a84$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $ea9c8114d35b5a84$var$defaultMethod = "get";
const $ea9c8114d35b5a84$var$defaultEncType = "application/x-www-form-urlencoded";
function $ea9c8114d35b5a84$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $ea9c8114d35b5a84$var$isButtonElement(object) {
    return $ea9c8114d35b5a84$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $ea9c8114d35b5a84$var$isFormElement(object) {
    return $ea9c8114d35b5a84$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $ea9c8114d35b5a84$var$isInputElement(object) {
    return $ea9c8114d35b5a84$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $ea9c8114d35b5a84$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $ea9c8114d35b5a84$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$ea9c8114d35b5a84$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $ea9c8114d35b5a84$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $ea9c8114d35b5a84$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $ea9c8114d35b5a84$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $ea9c8114d35b5a84$var$_formDataSupportsSubmitter = null;
function $ea9c8114d35b5a84$var$isFormDataSubmitterSupported() {
    if ($ea9c8114d35b5a84$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $ea9c8114d35b5a84$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $ea9c8114d35b5a84$var$_formDataSupportsSubmitter = true;
    }
    return $ea9c8114d35b5a84$var$_formDataSupportsSubmitter;
}
const $ea9c8114d35b5a84$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $ea9c8114d35b5a84$var$getFormEncType(encType) {
    if (encType != null && !$ea9c8114d35b5a84$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $ea9c8114d35b5a84$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($ea9c8114d35b5a84$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $8280ca3af81a1b06$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $ea9c8114d35b5a84$var$defaultMethod;
        encType = $ea9c8114d35b5a84$var$getFormEncType(target.getAttribute("enctype")) || $ea9c8114d35b5a84$var$defaultEncType;
        formData = new FormData(target);
    } else if ($ea9c8114d35b5a84$var$isButtonElement(target) || $ea9c8114d35b5a84$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $8280ca3af81a1b06$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $ea9c8114d35b5a84$var$defaultMethod;
        encType = $ea9c8114d35b5a84$var$getFormEncType(target.getAttribute("formenctype")) || $ea9c8114d35b5a84$var$getFormEncType(form.getAttribute("enctype")) || $ea9c8114d35b5a84$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$ea9c8114d35b5a84$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($ea9c8114d35b5a84$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $ea9c8114d35b5a84$var$defaultMethod;
        action = null;
        encType = $ea9c8114d35b5a84$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $ea9c8114d35b5a84$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $ea9c8114d35b5a84$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $ea9c8114d35b5a84$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $ea9c8114d35b5a84$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $ea9c8114d35b5a84$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $ea9c8114d35b5a84$export$1f3f55432a00e06d(routes, opts) {
    return (0, $8280ca3af81a1b06$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $ea9c8114d35b5a84$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $8280ca3af81a1b06$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $ea9c8114d35b5a84$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $4b112c041340d9ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $ea9c8114d35b5a84$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $8280ca3af81a1b06$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $ea9c8114d35b5a84$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $8280ca3af81a1b06$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $ea9c8114d35b5a84$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $4b112c041340d9ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $ea9c8114d35b5a84$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $ea9c8114d35b5a84$var$_extends({}, state, {
        errors: $ea9c8114d35b5a84$var$deserializeErrors(state.errors)
    });
    return state;
}
function $ea9c8114d35b5a84$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $8280ca3af81a1b06$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $ea9c8114d35b5a84$export$7ad602f0e94e62d1 = /*#__PURE__*/ $h2ArV.createContext({
    isTransitioning: false
});
const $ea9c8114d35b5a84$export$148fd98d095596d4 = /*#__PURE__*/ $h2ArV.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $ea9c8114d35b5a84$var$START_TRANSITION = "startTransition";
const $ea9c8114d35b5a84$var$startTransitionImpl = $h2ArV[$ea9c8114d35b5a84$var$START_TRANSITION];
const $ea9c8114d35b5a84$var$FLUSH_SYNC = "flushSync";
const $ea9c8114d35b5a84$var$flushSyncImpl = $3NhwF[$ea9c8114d35b5a84$var$FLUSH_SYNC];
const $ea9c8114d35b5a84$var$USE_ID = "useId";
const $ea9c8114d35b5a84$var$useIdImpl = $h2ArV[$ea9c8114d35b5a84$var$USE_ID];
function $ea9c8114d35b5a84$var$startTransitionSafe(cb) {
    if ($ea9c8114d35b5a84$var$startTransitionImpl) $ea9c8114d35b5a84$var$startTransitionImpl(cb);
    else cb();
}
function $ea9c8114d35b5a84$var$flushSyncSafe(cb) {
    if ($ea9c8114d35b5a84$var$flushSyncImpl) $ea9c8114d35b5a84$var$flushSyncImpl(cb);
    else cb();
}
class $ea9c8114d35b5a84$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $ea9c8114d35b5a84$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $h2ArV.useState(router.state);
    let [pendingState, setPendingState] = $h2ArV.useState();
    let [vtContext, setVtContext] = $h2ArV.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $h2ArV.useState();
    let [transition, setTransition] = $h2ArV.useState();
    let [interruption, setInterruption] = $h2ArV.useState();
    let fetcherData = $h2ArV.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $h2ArV.useCallback((cb)=>{
        if (v7_startTransition) $ea9c8114d35b5a84$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $h2ArV.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $ea9c8114d35b5a84$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $ea9c8114d35b5a84$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $ea9c8114d35b5a84$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $ea9c8114d35b5a84$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $ea9c8114d35b5a84$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $h2ArV.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $h2ArV.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $ea9c8114d35b5a84$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $h2ArV.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $h2ArV.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $h2ArV.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $h2ArV.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $h2ArV.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $h2ArV.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $h2ArV.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $h2ArV.useEffect(()=>(0, $4b112c041340d9ed$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $h2ArV.createElement($h2ArV.Fragment, null, /*#__PURE__*/ $h2ArV.createElement((0, $4b112c041340d9ed$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $h2ArV.createElement((0, $4b112c041340d9ed$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $h2ArV.createElement($ea9c8114d35b5a84$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $h2ArV.createElement($ea9c8114d35b5a84$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $h2ArV.createElement((0, $4b112c041340d9ed$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $h2ArV.createElement($ea9c8114d35b5a84$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $ea9c8114d35b5a84$var$MemoizedDataRoutes = /*#__PURE__*/ $h2ArV.memo($ea9c8114d35b5a84$var$DataRoutes);
function $ea9c8114d35b5a84$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $4b112c041340d9ed$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $ea9c8114d35b5a84$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $h2ArV.useRef();
    if (historyRef.current == null) historyRef.current = (0, $8280ca3af81a1b06$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $h2ArV.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $h2ArV.useCallback((newState)=>{
        v7_startTransition && $ea9c8114d35b5a84$var$startTransitionImpl ? $ea9c8114d35b5a84$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $h2ArV.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $h2ArV.useEffect(()=>(0, $4b112c041340d9ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $h2ArV.createElement((0, $4b112c041340d9ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $ea9c8114d35b5a84$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $h2ArV.useRef();
    if (historyRef.current == null) historyRef.current = (0, $8280ca3af81a1b06$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $h2ArV.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $h2ArV.useCallback((newState)=>{
        v7_startTransition && $ea9c8114d35b5a84$var$startTransitionImpl ? $ea9c8114d35b5a84$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $h2ArV.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $h2ArV.useEffect(()=>(0, $4b112c041340d9ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $h2ArV.createElement((0, $4b112c041340d9ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $ea9c8114d35b5a84$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $h2ArV.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $h2ArV.useCallback((newState)=>{
        v7_startTransition && $ea9c8114d35b5a84$var$startTransitionImpl ? $ea9c8114d35b5a84$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $h2ArV.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $h2ArV.useEffect(()=>(0, $4b112c041340d9ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $h2ArV.createElement((0, $4b112c041340d9ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $ea9c8114d35b5a84$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $ea9c8114d35b5a84$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $ea9c8114d35b5a84$export$a6c7ac8248d6e38a = /*#__PURE__*/ $h2ArV.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $ea9c8114d35b5a84$var$_objectWithoutPropertiesLoose(_ref7, $ea9c8114d35b5a84$var$_excluded);
    let { basename: basename } = $h2ArV.useContext((0, $4b112c041340d9ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $ea9c8114d35b5a84$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($ea9c8114d35b5a84$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $8280ca3af81a1b06$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $4b112c041340d9ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $ea9c8114d35b5a84$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $h2ArV.createElement("a", $ea9c8114d35b5a84$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $ea9c8114d35b5a84$export$b0d92dbee9b5b60d = /*#__PURE__*/ $h2ArV.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $ea9c8114d35b5a84$var$_objectWithoutPropertiesLoose(_ref8, $ea9c8114d35b5a84$var$_excluded2);
    let path = (0, $4b112c041340d9ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $4b112c041340d9ed$export$45d76561a5302f2b)();
    let routerState = $h2ArV.useContext((0, $4b112c041340d9ed$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $h2ArV.useContext((0, $4b112c041340d9ed$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $ea9c8114d35b5a84$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $8280ca3af81a1b06$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $h2ArV.createElement($ea9c8114d35b5a84$export$a6c7ac8248d6e38a, $ea9c8114d35b5a84$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $ea9c8114d35b5a84$export$a7fed597f4b8afd8 = /*#__PURE__*/ $h2ArV.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $ea9c8114d35b5a84$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $ea9c8114d35b5a84$var$_objectWithoutPropertiesLoose(_ref9, $ea9c8114d35b5a84$var$_excluded3);
    let submit = $ea9c8114d35b5a84$export$47c85c6e3a081d3();
    let formAction = $ea9c8114d35b5a84$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $h2ArV.createElement("form", $ea9c8114d35b5a84$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $ea9c8114d35b5a84$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $ea9c8114d35b5a84$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $ea9c8114d35b5a84$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($ea9c8114d35b5a84$var$DataRouterHook || ($ea9c8114d35b5a84$var$DataRouterHook = {}));
var $ea9c8114d35b5a84$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($ea9c8114d35b5a84$var$DataRouterStateHook || ($ea9c8114d35b5a84$var$DataRouterStateHook = {}));
// Internal hooks
function $ea9c8114d35b5a84$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $ea9c8114d35b5a84$var$useDataRouterContext(hookName) {
    let ctx = $h2ArV.useContext((0, $4b112c041340d9ed$export$3add0d5dce533e2e));
    !ctx && (0, $8280ca3af81a1b06$export$3e9cee6b33872309)(false);
    return ctx;
}
function $ea9c8114d35b5a84$var$useDataRouterState(hookName) {
    let state = $h2ArV.useContext((0, $4b112c041340d9ed$export$145dfa71566a64dc));
    !state && (0, $8280ca3af81a1b06$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $ea9c8114d35b5a84$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $4b112c041340d9ed$export$9770f232ac06a008)();
    let location = (0, $4b112c041340d9ed$export$45d76561a5302f2b)();
    let path = (0, $4b112c041340d9ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $h2ArV.useCallback((event)=>{
        if ($ea9c8114d35b5a84$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $8280ca3af81a1b06$export$fe53371bee54353d)(location) === (0, $8280ca3af81a1b06$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $ea9c8114d35b5a84$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $h2ArV.useRef($ea9c8114d35b5a84$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $h2ArV.useRef(false);
    let location = (0, $4b112c041340d9ed$export$45d76561a5302f2b)();
    let searchParams = $h2ArV.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $ea9c8114d35b5a84$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $4b112c041340d9ed$export$9770f232ac06a008)();
    let setSearchParams = $h2ArV.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $ea9c8114d35b5a84$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $ea9c8114d35b5a84$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $ea9c8114d35b5a84$var$fetcherId = 0;
let $ea9c8114d35b5a84$var$getUniqueFetcherId = ()=>"__" + String(++$ea9c8114d35b5a84$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $ea9c8114d35b5a84$export$47c85c6e3a081d3() {
    let { router: router } = $ea9c8114d35b5a84$var$useDataRouterContext($ea9c8114d35b5a84$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $h2ArV.useContext((0, $4b112c041340d9ed$export$26749e8557646306));
    let currentRouteId = (0, $4b112c041340d9ed$export$5fc8298006ad9e58)();
    return $h2ArV.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $ea9c8114d35b5a84$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $ea9c8114d35b5a84$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $ea9c8114d35b5a84$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $ea9c8114d35b5a84$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $h2ArV.useContext((0, $4b112c041340d9ed$export$26749e8557646306));
    let routeContext = $h2ArV.useContext((0, $4b112c041340d9ed$export$9072aa6dd1f93057));
    !routeContext && (0, $8280ca3af81a1b06$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $ea9c8114d35b5a84$var$_extends({}, (0, $4b112c041340d9ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $4b112c041340d9ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $8280ca3af81a1b06$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $8280ca3af81a1b06$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $ea9c8114d35b5a84$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $ea9c8114d35b5a84$var$useDataRouterContext($ea9c8114d35b5a84$var$DataRouterHook.UseFetcher);
    let state = $ea9c8114d35b5a84$var$useDataRouterState($ea9c8114d35b5a84$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $h2ArV.useContext($ea9c8114d35b5a84$export$148fd98d095596d4);
    let route = $h2ArV.useContext((0, $4b112c041340d9ed$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $8280ca3af81a1b06$export$3e9cee6b33872309)(false);
    !route && (0, $8280ca3af81a1b06$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $8280ca3af81a1b06$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $ea9c8114d35b5a84$var$useIdImpl ? $ea9c8114d35b5a84$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $h2ArV.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($ea9c8114d35b5a84$var$getUniqueFetcherId());
    // Registration/cleanup
    $h2ArV.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $h2ArV.useCallback((href, opts)=>{
        !routeId && (0, $8280ca3af81a1b06$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $ea9c8114d35b5a84$export$47c85c6e3a081d3();
    let submit = $h2ArV.useCallback((target, opts)=>{
        submitImpl(target, $ea9c8114d35b5a84$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $h2ArV.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $h2ArV.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $h2ArV.createElement($ea9c8114d35b5a84$export$a7fed597f4b8afd8, $ea9c8114d35b5a84$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $8280ca3af81a1b06$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $h2ArV.useMemo(()=>$ea9c8114d35b5a84$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $ea9c8114d35b5a84$export$fa996778a3a31087() {
    let state = $ea9c8114d35b5a84$var$useDataRouterState($ea9c8114d35b5a84$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $ea9c8114d35b5a84$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $ea9c8114d35b5a84$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $ea9c8114d35b5a84$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $ea9c8114d35b5a84$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $ea9c8114d35b5a84$var$useDataRouterContext($ea9c8114d35b5a84$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $ea9c8114d35b5a84$var$useDataRouterState($ea9c8114d35b5a84$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $h2ArV.useContext((0, $4b112c041340d9ed$export$26749e8557646306));
    let location = (0, $4b112c041340d9ed$export$45d76561a5302f2b)();
    let matches = (0, $4b112c041340d9ed$export$2378eb7f5ff86053)();
    let navigation = (0, $4b112c041340d9ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $h2ArV.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $ea9c8114d35b5a84$var$usePageHide($h2ArV.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $ea9c8114d35b5a84$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $ea9c8114d35b5a84$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($ea9c8114d35b5a84$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $h2ArV.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $ea9c8114d35b5a84$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $ea9c8114d35b5a84$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $h2ArV.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($ea9c8114d35b5a84$var$_extends({}, location, {
                    pathname: (0, $8280ca3af81a1b06$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($ea9c8114d35b5a84$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $h2ArV.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $ea9c8114d35b5a84$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $h2ArV.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $ea9c8114d35b5a84$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $h2ArV.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $ea9c8114d35b5a84$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $4b112c041340d9ed$export$b273b3273281a049)(when);
    $h2ArV.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $h2ArV.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $ea9c8114d35b5a84$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $h2ArV.useContext($ea9c8114d35b5a84$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $8280ca3af81a1b06$export$3e9cee6b33872309)(false);
    let { basename: basename } = $ea9c8114d35b5a84$var$useDataRouterContext($ea9c8114d35b5a84$var$DataRouterHook.useViewTransitionState);
    let path = (0, $4b112c041340d9ed$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $8280ca3af81a1b06$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $8280ca3af81a1b06$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $8280ca3af81a1b06$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $8280ca3af81a1b06$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}





const $63f12a9c983db38b$export$7c6e2c02157bb7d2 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('main')`
  flex: 1;
  display: flex;
`;
const $63f12a9c983db38b$export$a92c4e92ed722350 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('main')`
  flex: 1;
  display: flex;
  flex-direction: column;
`;
const $63f12a9c983db38b$export$5e3f251c730829 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('main')`
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
  justify-content: center;
  text-align: center;
`;




var $h2ArV = parcelRequire("h2ArV");

var $de07f2c205919029$exports = {};
!function(t, e) {
    $de07f2c205919029$exports = e();
}($de07f2c205919029$exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});


var $11e5497bd9439d83$exports = {};
!function(r, e) {
    $11e5497bd9439d83$exports = e();
}($11e5497bd9439d83$exports, function() {
    "use strict";
    return function(r, e, t) {
        r = r || {};
        var n = e.prototype, o = {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        };
        function i(r, e, t, o) {
            return n.fromToBase(r, e, t, o);
        }
        t.en.relativeTime = o, n.fromToBase = function(e, n, i, d, u) {
            for(var f, a, s, l = i.$locale().relativeTime || o, h = r.thresholds || [
                {
                    l: "s",
                    r: 44,
                    d: "second"
                },
                {
                    l: "m",
                    r: 89
                },
                {
                    l: "mm",
                    r: 44,
                    d: "minute"
                },
                {
                    l: "h",
                    r: 89
                },
                {
                    l: "hh",
                    r: 21,
                    d: "hour"
                },
                {
                    l: "d",
                    r: 35
                },
                {
                    l: "dd",
                    r: 25,
                    d: "day"
                },
                {
                    l: "M",
                    r: 45
                },
                {
                    l: "MM",
                    r: 10,
                    d: "month"
                },
                {
                    l: "y",
                    r: 17
                },
                {
                    l: "yy",
                    d: "year"
                }
            ], m = h.length, c = 0; c < m; c += 1){
                var y = h[c];
                y.d && (f = d ? t(e).diff(i, y.d, !0) : i.diff(e, y.d, !0));
                var p = (r.rounding || Math.round)(Math.abs(f));
                if (s = f > 0, p <= y.r || !y.r) {
                    p <= 1 && c > 0 && (y = h[c - 1]);
                    var v = l[y.l];
                    u && (p = u("" + p)), a = "string" == typeof v ? v.replace("%d", p) : v(p, n, y.l, s);
                    break;
                }
            }
            if (n) return a;
            var M = s ? l.future : l.past;
            return "function" == typeof M ? M(a) : M.replace("%s", a);
        }, n.to = function(r, e) {
            return i(r, e, this, !0);
        }, n.from = function(r, e) {
            return i(r, e, this);
        };
        var d = function(r) {
            return r.$u ? t.utc() : t();
        };
        n.toNow = function(r) {
            return this.to(d(this), r);
        }, n.fromNow = function(r) {
            return this.from(d(this), r);
        };
    };
});




var $h2ArV = parcelRequire("h2ArV");

var $6a124476dce670ed$exports = {};
/*jslint node:true */ var $6efd4bc11af435ee$exports = {};
var $b96fe3030242c613$exports = {};

var $lGjml = parcelRequire("lGjml");
var $b96fe3030242c613$require$Buffer = $lGjml.Buffer;


(function(sax) {
    sax.parser = function(strict, opt) {
        return new SAXParser(strict, opt);
    };
    sax.SAXParser = SAXParser;
    sax.SAXStream = SAXStream;
    sax.createStream = createStream;
    // When we pass the MAX_BUFFER_LENGTH position, start checking for buffer overruns.
    // When we check, schedule the next check for MAX_BUFFER_LENGTH - (max(buffer lengths)),
    // since that's the earliest that a buffer overrun could occur.  This way, checks are
    // as rare as required, but as often as necessary to ensure never crossing this bound.
    // Furthermore, buffers are only tested at most once per write(), so passing a very
    // large string into write() might have undesirable effects, but this is manageable by
    // the caller, so it is assumed to be safe.  Thus, a call to write() may, in the extreme
    // edge case, result in creating at most one complete copy of the string passed in.
    // Set to Infinity to have unlimited buffers.
    sax.MAX_BUFFER_LENGTH = 65536;
    var buffers = [
        'comment',
        'sgmlDecl',
        'textNode',
        'tagName',
        'doctype',
        'procInstName',
        'procInstBody',
        'entity',
        'attribName',
        'attribValue',
        'cdata',
        'script'
    ];
    sax.EVENTS = [
        'text',
        'processinginstruction',
        'sgmldeclaration',
        'doctype',
        'comment',
        'opentagstart',
        'attribute',
        'opentag',
        'closetag',
        'opencdata',
        'cdata',
        'closecdata',
        'error',
        'end',
        'ready',
        'script',
        'opennamespace',
        'closenamespace'
    ];
    function SAXParser(strict, opt) {
        if (!(this instanceof SAXParser)) return new SAXParser(strict, opt);
        var parser = this;
        clearBuffers(parser);
        parser.q = parser.c = '';
        parser.bufferCheckPosition = sax.MAX_BUFFER_LENGTH;
        parser.opt = opt || {};
        parser.opt.lowercase = parser.opt.lowercase || parser.opt.lowercasetags;
        parser.looseCase = parser.opt.lowercase ? 'toLowerCase' : 'toUpperCase';
        parser.tags = [];
        parser.closed = parser.closedRoot = parser.sawRoot = false;
        parser.tag = parser.error = null;
        parser.strict = !!strict;
        parser.noscript = !!(strict || parser.opt.noscript);
        parser.state = S.BEGIN;
        parser.strictEntities = parser.opt.strictEntities;
        parser.ENTITIES = parser.strictEntities ? Object.create(sax.XML_ENTITIES) : Object.create(sax.ENTITIES);
        parser.attribList = [];
        // namespaces form a prototype chain.
        // it always points at the current tag,
        // which protos to its parent tag.
        if (parser.opt.xmlns) parser.ns = Object.create(rootNS);
        // disallow unquoted attribute values if not otherwise configured
        // and strict mode is true
        if (parser.opt.unquotedAttributeValues === undefined) parser.opt.unquotedAttributeValues = !strict;
        // mostly just for error reporting
        parser.trackPosition = parser.opt.position !== false;
        if (parser.trackPosition) parser.position = parser.line = parser.column = 0;
        emit(parser, 'onready');
    }
    if (!Object.create) Object.create = function(o) {
        function F() {}
        F.prototype = o;
        var newf = new F();
        return newf;
    };
    if (!Object.keys) Object.keys = function(o) {
        var a = [];
        for(var i in o)if (o.hasOwnProperty(i)) a.push(i);
        return a;
    };
    function checkBufferLength(parser) {
        var maxAllowed = Math.max(sax.MAX_BUFFER_LENGTH, 10);
        var maxActual = 0;
        for(var i = 0, l = buffers.length; i < l; i++){
            var len = parser[buffers[i]].length;
            if (len > maxAllowed) // Text/cdata nodes can get big, and since they're buffered,
            // we can get here under normal conditions.
            // Avoid issues by emitting the text node now,
            // so at least it won't get any bigger.
            switch(buffers[i]){
                case 'textNode':
                    closeText(parser);
                    break;
                case 'cdata':
                    emitNode(parser, 'oncdata', parser.cdata);
                    parser.cdata = '';
                    break;
                case 'script':
                    emitNode(parser, 'onscript', parser.script);
                    parser.script = '';
                    break;
                default:
                    error(parser, 'Max buffer length exceeded: ' + buffers[i]);
            }
            maxActual = Math.max(maxActual, len);
        }
        // schedule the next check for the earliest possible buffer overrun.
        var m = sax.MAX_BUFFER_LENGTH - maxActual;
        parser.bufferCheckPosition = m + parser.position;
    }
    function clearBuffers(parser) {
        for(var i = 0, l = buffers.length; i < l; i++)parser[buffers[i]] = '';
    }
    function flushBuffers(parser) {
        closeText(parser);
        if (parser.cdata !== '') {
            emitNode(parser, 'oncdata', parser.cdata);
            parser.cdata = '';
        }
        if (parser.script !== '') {
            emitNode(parser, 'onscript', parser.script);
            parser.script = '';
        }
    }
    SAXParser.prototype = {
        end: function() {
            end(this);
        },
        write: write,
        resume: function() {
            this.error = null;
            return this;
        },
        close: function() {
            return this.write(null);
        },
        flush: function() {
            flushBuffers(this);
        }
    };
    var Stream;
    try {
        Stream = (parcelRequire("d2HdY")).Stream;
    } catch (ex) {
        Stream = function() {};
    }
    if (!Stream) Stream = function() {};
    var streamWraps = sax.EVENTS.filter(function(ev) {
        return ev !== 'error' && ev !== 'end';
    });
    function createStream(strict, opt) {
        return new SAXStream(strict, opt);
    }
    function SAXStream(strict, opt) {
        if (!(this instanceof SAXStream)) return new SAXStream(strict, opt);
        Stream.apply(this);
        this._parser = new SAXParser(strict, opt);
        this.writable = true;
        this.readable = true;
        var me = this;
        this._parser.onend = function() {
            me.emit('end');
        };
        this._parser.onerror = function(er) {
            me.emit('error', er);
            // if didn't throw, then means error was handled.
            // go ahead and clear error, so we can write again.
            me._parser.error = null;
        };
        this._decoder = null;
        streamWraps.forEach(function(ev) {
            Object.defineProperty(me, 'on' + ev, {
                get: function() {
                    return me._parser['on' + ev];
                },
                set: function(h) {
                    if (!h) {
                        me.removeAllListeners(ev);
                        me._parser['on' + ev] = h;
                        return h;
                    }
                    me.on(ev, h);
                },
                enumerable: true,
                configurable: false
            });
        });
    }
    SAXStream.prototype = Object.create(Stream.prototype, {
        constructor: {
            value: SAXStream
        }
    });
    SAXStream.prototype.write = function(data) {
        if (typeof $b96fe3030242c613$require$Buffer === 'function' && typeof $b96fe3030242c613$require$Buffer.isBuffer === 'function' && $b96fe3030242c613$require$Buffer.isBuffer(data)) {
            if (!this._decoder) {
                var SD = (parcelRequire("iCQEj")).StringDecoder;
                this._decoder = new SD('utf8');
            }
            data = this._decoder.write(data);
        }
        this._parser.write(data.toString());
        this.emit('data', data);
        return true;
    };
    SAXStream.prototype.end = function(chunk) {
        if (chunk && chunk.length) this.write(chunk);
        this._parser.end();
        return true;
    };
    SAXStream.prototype.on = function(ev, handler) {
        var me = this;
        if (!me._parser['on' + ev] && streamWraps.indexOf(ev) !== -1) me._parser['on' + ev] = function() {
            var args = arguments.length === 1 ? [
                arguments[0]
            ] : Array.apply(null, arguments);
            args.splice(0, 0, ev);
            me.emit.apply(me, args);
        };
        return Stream.prototype.on.call(me, ev, handler);
    };
    // this really needs to be replaced with character classes.
    // XML allows all manner of ridiculous numbers and digits.
    var CDATA = '[CDATA[';
    var DOCTYPE = 'DOCTYPE';
    var XML_NAMESPACE = 'http://www.w3.org/XML/1998/namespace';
    var XMLNS_NAMESPACE = 'http://www.w3.org/2000/xmlns/';
    var rootNS = {
        xml: XML_NAMESPACE,
        xmlns: XMLNS_NAMESPACE
    };
    // http://www.w3.org/TR/REC-xml/#NT-NameStartChar
    // This implementation works on strings, a single character at a time
    // as such, it cannot ever support astral-plane characters (10000-EFFFF)
    // without a significant breaking change to either this  parser, or the
    // JavaScript language.  Implementation of an emoji-capable xml parser
    // is left as an exercise for the reader.
    var nameStart = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/;
    var nameBody = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/;
    var entityStart = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/;
    var entityBody = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/;
    function isWhitespace(c) {
        return c === ' ' || c === '\n' || c === '\r' || c === '\t';
    }
    function isQuote(c) {
        return c === '"' || c === '\'';
    }
    function isAttribEnd(c) {
        return c === '>' || isWhitespace(c);
    }
    function isMatch(regex, c) {
        return regex.test(c);
    }
    function notMatch(regex, c) {
        return !isMatch(regex, c);
    }
    var S = 0;
    sax.STATE = {
        BEGIN: S++,
        BEGIN_WHITESPACE: S++,
        TEXT: S++,
        TEXT_ENTITY: S++,
        OPEN_WAKA: S++,
        SGML_DECL: S++,
        SGML_DECL_QUOTED: S++,
        DOCTYPE: S++,
        DOCTYPE_QUOTED: S++,
        DOCTYPE_DTD: S++,
        DOCTYPE_DTD_QUOTED: S++,
        COMMENT_STARTING: S++,
        COMMENT: S++,
        COMMENT_ENDING: S++,
        COMMENT_ENDED: S++,
        CDATA: S++,
        CDATA_ENDING: S++,
        CDATA_ENDING_2: S++,
        PROC_INST: S++,
        PROC_INST_BODY: S++,
        PROC_INST_ENDING: S++,
        OPEN_TAG: S++,
        OPEN_TAG_SLASH: S++,
        ATTRIB: S++,
        ATTRIB_NAME: S++,
        ATTRIB_NAME_SAW_WHITE: S++,
        ATTRIB_VALUE: S++,
        ATTRIB_VALUE_QUOTED: S++,
        ATTRIB_VALUE_CLOSED: S++,
        ATTRIB_VALUE_UNQUOTED: S++,
        ATTRIB_VALUE_ENTITY_Q: S++,
        ATTRIB_VALUE_ENTITY_U: S++,
        CLOSE_TAG: S++,
        CLOSE_TAG_SAW_WHITE: S++,
        SCRIPT: S++,
        SCRIPT_ENDING: S++ // <script> ... <
    };
    sax.XML_ENTITIES = {
        'amp': '&',
        'gt': '>',
        'lt': '<',
        'quot': '"',
        'apos': "'"
    };
    sax.ENTITIES = {
        'amp': '&',
        'gt': '>',
        'lt': '<',
        'quot': '"',
        'apos': "'",
        'AElig': 198,
        'Aacute': 193,
        'Acirc': 194,
        'Agrave': 192,
        'Aring': 197,
        'Atilde': 195,
        'Auml': 196,
        'Ccedil': 199,
        'ETH': 208,
        'Eacute': 201,
        'Ecirc': 202,
        'Egrave': 200,
        'Euml': 203,
        'Iacute': 205,
        'Icirc': 206,
        'Igrave': 204,
        'Iuml': 207,
        'Ntilde': 209,
        'Oacute': 211,
        'Ocirc': 212,
        'Ograve': 210,
        'Oslash': 216,
        'Otilde': 213,
        'Ouml': 214,
        'THORN': 222,
        'Uacute': 218,
        'Ucirc': 219,
        'Ugrave': 217,
        'Uuml': 220,
        'Yacute': 221,
        'aacute': 225,
        'acirc': 226,
        'aelig': 230,
        'agrave': 224,
        'aring': 229,
        'atilde': 227,
        'auml': 228,
        'ccedil': 231,
        'eacute': 233,
        'ecirc': 234,
        'egrave': 232,
        'eth': 240,
        'euml': 235,
        'iacute': 237,
        'icirc': 238,
        'igrave': 236,
        'iuml': 239,
        'ntilde': 241,
        'oacute': 243,
        'ocirc': 244,
        'ograve': 242,
        'oslash': 248,
        'otilde': 245,
        'ouml': 246,
        'szlig': 223,
        'thorn': 254,
        'uacute': 250,
        'ucirc': 251,
        'ugrave': 249,
        'uuml': 252,
        'yacute': 253,
        'yuml': 255,
        'copy': 169,
        'reg': 174,
        'nbsp': 160,
        'iexcl': 161,
        'cent': 162,
        'pound': 163,
        'curren': 164,
        'yen': 165,
        'brvbar': 166,
        'sect': 167,
        'uml': 168,
        'ordf': 170,
        'laquo': 171,
        'not': 172,
        'shy': 173,
        'macr': 175,
        'deg': 176,
        'plusmn': 177,
        'sup1': 185,
        'sup2': 178,
        'sup3': 179,
        'acute': 180,
        'micro': 181,
        'para': 182,
        'middot': 183,
        'cedil': 184,
        'ordm': 186,
        'raquo': 187,
        'frac14': 188,
        'frac12': 189,
        'frac34': 190,
        'iquest': 191,
        'times': 215,
        'divide': 247,
        'OElig': 338,
        'oelig': 339,
        'Scaron': 352,
        'scaron': 353,
        'Yuml': 376,
        'fnof': 402,
        'circ': 710,
        'tilde': 732,
        'Alpha': 913,
        'Beta': 914,
        'Gamma': 915,
        'Delta': 916,
        'Epsilon': 917,
        'Zeta': 918,
        'Eta': 919,
        'Theta': 920,
        'Iota': 921,
        'Kappa': 922,
        'Lambda': 923,
        'Mu': 924,
        'Nu': 925,
        'Xi': 926,
        'Omicron': 927,
        'Pi': 928,
        'Rho': 929,
        'Sigma': 931,
        'Tau': 932,
        'Upsilon': 933,
        'Phi': 934,
        'Chi': 935,
        'Psi': 936,
        'Omega': 937,
        'alpha': 945,
        'beta': 946,
        'gamma': 947,
        'delta': 948,
        'epsilon': 949,
        'zeta': 950,
        'eta': 951,
        'theta': 952,
        'iota': 953,
        'kappa': 954,
        'lambda': 955,
        'mu': 956,
        'nu': 957,
        'xi': 958,
        'omicron': 959,
        'pi': 960,
        'rho': 961,
        'sigmaf': 962,
        'sigma': 963,
        'tau': 964,
        'upsilon': 965,
        'phi': 966,
        'chi': 967,
        'psi': 968,
        'omega': 969,
        'thetasym': 977,
        'upsih': 978,
        'piv': 982,
        'ensp': 8194,
        'emsp': 8195,
        'thinsp': 8201,
        'zwnj': 8204,
        'zwj': 8205,
        'lrm': 8206,
        'rlm': 8207,
        'ndash': 8211,
        'mdash': 8212,
        'lsquo': 8216,
        'rsquo': 8217,
        'sbquo': 8218,
        'ldquo': 8220,
        'rdquo': 8221,
        'bdquo': 8222,
        'dagger': 8224,
        'Dagger': 8225,
        'bull': 8226,
        'hellip': 8230,
        'permil': 8240,
        'prime': 8242,
        'Prime': 8243,
        'lsaquo': 8249,
        'rsaquo': 8250,
        'oline': 8254,
        'frasl': 8260,
        'euro': 8364,
        'image': 8465,
        'weierp': 8472,
        'real': 8476,
        'trade': 8482,
        'alefsym': 8501,
        'larr': 8592,
        'uarr': 8593,
        'rarr': 8594,
        'darr': 8595,
        'harr': 8596,
        'crarr': 8629,
        'lArr': 8656,
        'uArr': 8657,
        'rArr': 8658,
        'dArr': 8659,
        'hArr': 8660,
        'forall': 8704,
        'part': 8706,
        'exist': 8707,
        'empty': 8709,
        'nabla': 8711,
        'isin': 8712,
        'notin': 8713,
        'ni': 8715,
        'prod': 8719,
        'sum': 8721,
        'minus': 8722,
        'lowast': 8727,
        'radic': 8730,
        'prop': 8733,
        'infin': 8734,
        'ang': 8736,
        'and': 8743,
        'or': 8744,
        'cap': 8745,
        'cup': 8746,
        'int': 8747,
        'there4': 8756,
        'sim': 8764,
        'cong': 8773,
        'asymp': 8776,
        'ne': 8800,
        'equiv': 8801,
        'le': 8804,
        'ge': 8805,
        'sub': 8834,
        'sup': 8835,
        'nsub': 8836,
        'sube': 8838,
        'supe': 8839,
        'oplus': 8853,
        'otimes': 8855,
        'perp': 8869,
        'sdot': 8901,
        'lceil': 8968,
        'rceil': 8969,
        'lfloor': 8970,
        'rfloor': 8971,
        'lang': 9001,
        'rang': 9002,
        'loz': 9674,
        'spades': 9824,
        'clubs': 9827,
        'hearts': 9829,
        'diams': 9830
    };
    Object.keys(sax.ENTITIES).forEach(function(key) {
        var e = sax.ENTITIES[key];
        var s = typeof e === 'number' ? String.fromCharCode(e) : e;
        sax.ENTITIES[key] = s;
    });
    for(var s in sax.STATE)sax.STATE[sax.STATE[s]] = s;
    // shorthand
    S = sax.STATE;
    function emit(parser, event, data) {
        parser[event] && parser[event](data);
    }
    function emitNode(parser, nodeType, data) {
        if (parser.textNode) closeText(parser);
        emit(parser, nodeType, data);
    }
    function closeText(parser) {
        parser.textNode = textopts(parser.opt, parser.textNode);
        if (parser.textNode) emit(parser, 'ontext', parser.textNode);
        parser.textNode = '';
    }
    function textopts(opt, text) {
        if (opt.trim) text = text.trim();
        if (opt.normalize) text = text.replace(/\s+/g, ' ');
        return text;
    }
    function error(parser, er) {
        closeText(parser);
        if (parser.trackPosition) er += '\nLine: ' + parser.line + '\nColumn: ' + parser.column + '\nChar: ' + parser.c;
        er = new Error(er);
        parser.error = er;
        emit(parser, 'onerror', er);
        return parser;
    }
    function end(parser) {
        if (parser.sawRoot && !parser.closedRoot) strictFail(parser, 'Unclosed root tag');
        if (parser.state !== S.BEGIN && parser.state !== S.BEGIN_WHITESPACE && parser.state !== S.TEXT) error(parser, 'Unexpected end');
        closeText(parser);
        parser.c = '';
        parser.closed = true;
        emit(parser, 'onend');
        SAXParser.call(parser, parser.strict, parser.opt);
        return parser;
    }
    function strictFail(parser, message) {
        if (typeof parser !== 'object' || !(parser instanceof SAXParser)) throw new Error('bad call to strictFail');
        if (parser.strict) error(parser, message);
    }
    function newTag(parser) {
        if (!parser.strict) parser.tagName = parser.tagName[parser.looseCase]();
        var parent = parser.tags[parser.tags.length - 1] || parser;
        var tag = parser.tag = {
            name: parser.tagName,
            attributes: {}
        };
        // will be overridden if tag contails an xmlns="foo" or xmlns:foo="bar"
        if (parser.opt.xmlns) tag.ns = parent.ns;
        parser.attribList.length = 0;
        emitNode(parser, 'onopentagstart', tag);
    }
    function qname(name, attribute) {
        var i = name.indexOf(':');
        var qualName = i < 0 ? [
            '',
            name
        ] : name.split(':');
        var prefix = qualName[0];
        var local = qualName[1];
        // <x "xmlns"="http://foo">
        if (attribute && name === 'xmlns') {
            prefix = 'xmlns';
            local = '';
        }
        return {
            prefix: prefix,
            local: local
        };
    }
    function attrib(parser) {
        if (!parser.strict) parser.attribName = parser.attribName[parser.looseCase]();
        if (parser.attribList.indexOf(parser.attribName) !== -1 || parser.tag.attributes.hasOwnProperty(parser.attribName)) {
            parser.attribName = parser.attribValue = '';
            return;
        }
        if (parser.opt.xmlns) {
            var qn = qname(parser.attribName, true);
            var prefix = qn.prefix;
            var local = qn.local;
            if (prefix === 'xmlns') {
                // namespace binding attribute. push the binding into scope
                if (local === 'xml' && parser.attribValue !== XML_NAMESPACE) strictFail(parser, 'xml: prefix must be bound to ' + XML_NAMESPACE + '\n' + 'Actual: ' + parser.attribValue);
                else if (local === 'xmlns' && parser.attribValue !== XMLNS_NAMESPACE) strictFail(parser, 'xmlns: prefix must be bound to ' + XMLNS_NAMESPACE + '\n' + 'Actual: ' + parser.attribValue);
                else {
                    var tag = parser.tag;
                    var parent = parser.tags[parser.tags.length - 1] || parser;
                    if (tag.ns === parent.ns) tag.ns = Object.create(parent.ns);
                    tag.ns[local] = parser.attribValue;
                }
            }
            // defer onattribute events until all attributes have been seen
            // so any new bindings can take effect. preserve attribute order
            // so deferred events can be emitted in document order
            parser.attribList.push([
                parser.attribName,
                parser.attribValue
            ]);
        } else {
            // in non-xmlns mode, we can emit the event right away
            parser.tag.attributes[parser.attribName] = parser.attribValue;
            emitNode(parser, 'onattribute', {
                name: parser.attribName,
                value: parser.attribValue
            });
        }
        parser.attribName = parser.attribValue = '';
    }
    function openTag(parser, selfClosing) {
        if (parser.opt.xmlns) {
            // emit namespace binding events
            var tag = parser.tag;
            // add namespace info to tag
            var qn = qname(parser.tagName);
            tag.prefix = qn.prefix;
            tag.local = qn.local;
            tag.uri = tag.ns[qn.prefix] || '';
            if (tag.prefix && !tag.uri) {
                strictFail(parser, 'Unbound namespace prefix: ' + JSON.stringify(parser.tagName));
                tag.uri = qn.prefix;
            }
            var parent = parser.tags[parser.tags.length - 1] || parser;
            if (tag.ns && parent.ns !== tag.ns) Object.keys(tag.ns).forEach(function(p) {
                emitNode(parser, 'onopennamespace', {
                    prefix: p,
                    uri: tag.ns[p]
                });
            });
            // handle deferred onattribute events
            // Note: do not apply default ns to attributes:
            //   http://www.w3.org/TR/REC-xml-names/#defaulting
            for(var i = 0, l = parser.attribList.length; i < l; i++){
                var nv = parser.attribList[i];
                var name = nv[0];
                var value = nv[1];
                var qualName = qname(name, true);
                var prefix = qualName.prefix;
                var local = qualName.local;
                var uri = prefix === '' ? '' : tag.ns[prefix] || '';
                var a = {
                    name: name,
                    value: value,
                    prefix: prefix,
                    local: local,
                    uri: uri
                };
                // if there's any attributes with an undefined namespace,
                // then fail on them now.
                if (prefix && prefix !== 'xmlns' && !uri) {
                    strictFail(parser, 'Unbound namespace prefix: ' + JSON.stringify(prefix));
                    a.uri = prefix;
                }
                parser.tag.attributes[name] = a;
                emitNode(parser, 'onattribute', a);
            }
            parser.attribList.length = 0;
        }
        parser.tag.isSelfClosing = !!selfClosing;
        // process the tag
        parser.sawRoot = true;
        parser.tags.push(parser.tag);
        emitNode(parser, 'onopentag', parser.tag);
        if (!selfClosing) {
            // special case for <script> in non-strict mode.
            if (!parser.noscript && parser.tagName.toLowerCase() === 'script') parser.state = S.SCRIPT;
            else parser.state = S.TEXT;
            parser.tag = null;
            parser.tagName = '';
        }
        parser.attribName = parser.attribValue = '';
        parser.attribList.length = 0;
    }
    function closeTag(parser) {
        if (!parser.tagName) {
            strictFail(parser, 'Weird empty close tag.');
            parser.textNode += '</>';
            parser.state = S.TEXT;
            return;
        }
        if (parser.script) {
            if (parser.tagName !== 'script') {
                parser.script += '</' + parser.tagName + '>';
                parser.tagName = '';
                parser.state = S.SCRIPT;
                return;
            }
            emitNode(parser, 'onscript', parser.script);
            parser.script = '';
        }
        // first make sure that the closing tag actually exists.
        // <a><b></c></b></a> will close everything, otherwise.
        var t = parser.tags.length;
        var tagName = parser.tagName;
        if (!parser.strict) tagName = tagName[parser.looseCase]();
        var closeTo = tagName;
        while(t--){
            var close = parser.tags[t];
            if (close.name !== closeTo) // fail the first time in strict mode
            strictFail(parser, 'Unexpected close tag');
            else break;
        }
        // didn't find it.  we already failed for strict, so just abort.
        if (t < 0) {
            strictFail(parser, 'Unmatched closing tag: ' + parser.tagName);
            parser.textNode += '</' + parser.tagName + '>';
            parser.state = S.TEXT;
            return;
        }
        parser.tagName = tagName;
        var s = parser.tags.length;
        while(s-- > t){
            var tag = parser.tag = parser.tags.pop();
            parser.tagName = parser.tag.name;
            emitNode(parser, 'onclosetag', parser.tagName);
            var x = {};
            for(var i in tag.ns)x[i] = tag.ns[i];
            var parent = parser.tags[parser.tags.length - 1] || parser;
            if (parser.opt.xmlns && tag.ns !== parent.ns) // remove namespace bindings introduced by tag
            Object.keys(tag.ns).forEach(function(p) {
                var n = tag.ns[p];
                emitNode(parser, 'onclosenamespace', {
                    prefix: p,
                    uri: n
                });
            });
        }
        if (t === 0) parser.closedRoot = true;
        parser.tagName = parser.attribValue = parser.attribName = '';
        parser.attribList.length = 0;
        parser.state = S.TEXT;
    }
    function parseEntity(parser) {
        var entity = parser.entity;
        var entityLC = entity.toLowerCase();
        var num;
        var numStr = '';
        if (parser.ENTITIES[entity]) return parser.ENTITIES[entity];
        if (parser.ENTITIES[entityLC]) return parser.ENTITIES[entityLC];
        entity = entityLC;
        if (entity.charAt(0) === '#') {
            if (entity.charAt(1) === 'x') {
                entity = entity.slice(2);
                num = parseInt(entity, 16);
                numStr = num.toString(16);
            } else {
                entity = entity.slice(1);
                num = parseInt(entity, 10);
                numStr = num.toString(10);
            }
        }
        entity = entity.replace(/^0+/, '');
        if (isNaN(num) || numStr.toLowerCase() !== entity) {
            strictFail(parser, 'Invalid character entity');
            return '&' + parser.entity + ';';
        }
        return String.fromCodePoint(num);
    }
    function beginWhiteSpace(parser, c) {
        if (c === '<') {
            parser.state = S.OPEN_WAKA;
            parser.startTagPosition = parser.position;
        } else if (!isWhitespace(c)) {
            // have to process this as a text node.
            // weird, but happens.
            strictFail(parser, 'Non-whitespace before first tag.');
            parser.textNode = c;
            parser.state = S.TEXT;
        }
    }
    function charAt(chunk, i) {
        var result = '';
        if (i < chunk.length) result = chunk.charAt(i);
        return result;
    }
    function write(chunk) {
        var parser = this;
        if (this.error) throw this.error;
        if (parser.closed) return error(parser, 'Cannot write after close. Assign an onready handler.');
        if (chunk === null) return end(parser);
        if (typeof chunk === 'object') chunk = chunk.toString();
        var i = 0;
        var c = '';
        while(true){
            c = charAt(chunk, i++);
            parser.c = c;
            if (!c) break;
            if (parser.trackPosition) {
                parser.position++;
                if (c === '\n') {
                    parser.line++;
                    parser.column = 0;
                } else parser.column++;
            }
            switch(parser.state){
                case S.BEGIN:
                    parser.state = S.BEGIN_WHITESPACE;
                    if (c === '\uFEFF') continue;
                    beginWhiteSpace(parser, c);
                    continue;
                case S.BEGIN_WHITESPACE:
                    beginWhiteSpace(parser, c);
                    continue;
                case S.TEXT:
                    if (parser.sawRoot && !parser.closedRoot) {
                        var starti = i - 1;
                        while(c && c !== '<' && c !== '&'){
                            c = charAt(chunk, i++);
                            if (c && parser.trackPosition) {
                                parser.position++;
                                if (c === '\n') {
                                    parser.line++;
                                    parser.column = 0;
                                } else parser.column++;
                            }
                        }
                        parser.textNode += chunk.substring(starti, i - 1);
                    }
                    if (c === '<' && !(parser.sawRoot && parser.closedRoot && !parser.strict)) {
                        parser.state = S.OPEN_WAKA;
                        parser.startTagPosition = parser.position;
                    } else {
                        if (!isWhitespace(c) && (!parser.sawRoot || parser.closedRoot)) strictFail(parser, 'Text data outside of root node.');
                        if (c === '&') parser.state = S.TEXT_ENTITY;
                        else parser.textNode += c;
                    }
                    continue;
                case S.SCRIPT:
                    // only non-strict
                    if (c === '<') parser.state = S.SCRIPT_ENDING;
                    else parser.script += c;
                    continue;
                case S.SCRIPT_ENDING:
                    if (c === '/') parser.state = S.CLOSE_TAG;
                    else {
                        parser.script += '<' + c;
                        parser.state = S.SCRIPT;
                    }
                    continue;
                case S.OPEN_WAKA:
                    // either a /, ?, !, or text is coming next.
                    if (c === '!') {
                        parser.state = S.SGML_DECL;
                        parser.sgmlDecl = '';
                    } else if (isWhitespace(c)) ;
                    else if (isMatch(nameStart, c)) {
                        parser.state = S.OPEN_TAG;
                        parser.tagName = c;
                    } else if (c === '/') {
                        parser.state = S.CLOSE_TAG;
                        parser.tagName = '';
                    } else if (c === '?') {
                        parser.state = S.PROC_INST;
                        parser.procInstName = parser.procInstBody = '';
                    } else {
                        strictFail(parser, 'Unencoded <');
                        // if there was some whitespace, then add that in.
                        if (parser.startTagPosition + 1 < parser.position) {
                            var pad = parser.position - parser.startTagPosition;
                            c = new Array(pad).join(' ') + c;
                        }
                        parser.textNode += '<' + c;
                        parser.state = S.TEXT;
                    }
                    continue;
                case S.SGML_DECL:
                    if (parser.sgmlDecl + c === '--') {
                        parser.state = S.COMMENT;
                        parser.comment = '';
                        parser.sgmlDecl = '';
                        continue;
                    }
                    if (parser.doctype && parser.doctype !== true && parser.sgmlDecl) {
                        parser.state = S.DOCTYPE_DTD;
                        parser.doctype += '<!' + parser.sgmlDecl + c;
                        parser.sgmlDecl = '';
                    } else if ((parser.sgmlDecl + c).toUpperCase() === CDATA) {
                        emitNode(parser, 'onopencdata');
                        parser.state = S.CDATA;
                        parser.sgmlDecl = '';
                        parser.cdata = '';
                    } else if ((parser.sgmlDecl + c).toUpperCase() === DOCTYPE) {
                        parser.state = S.DOCTYPE;
                        if (parser.doctype || parser.sawRoot) strictFail(parser, 'Inappropriately located doctype declaration');
                        parser.doctype = '';
                        parser.sgmlDecl = '';
                    } else if (c === '>') {
                        emitNode(parser, 'onsgmldeclaration', parser.sgmlDecl);
                        parser.sgmlDecl = '';
                        parser.state = S.TEXT;
                    } else if (isQuote(c)) {
                        parser.state = S.SGML_DECL_QUOTED;
                        parser.sgmlDecl += c;
                    } else parser.sgmlDecl += c;
                    continue;
                case S.SGML_DECL_QUOTED:
                    if (c === parser.q) {
                        parser.state = S.SGML_DECL;
                        parser.q = '';
                    }
                    parser.sgmlDecl += c;
                    continue;
                case S.DOCTYPE:
                    if (c === '>') {
                        parser.state = S.TEXT;
                        emitNode(parser, 'ondoctype', parser.doctype);
                        parser.doctype = true // just remember that we saw it.
                        ;
                    } else {
                        parser.doctype += c;
                        if (c === '[') parser.state = S.DOCTYPE_DTD;
                        else if (isQuote(c)) {
                            parser.state = S.DOCTYPE_QUOTED;
                            parser.q = c;
                        }
                    }
                    continue;
                case S.DOCTYPE_QUOTED:
                    parser.doctype += c;
                    if (c === parser.q) {
                        parser.q = '';
                        parser.state = S.DOCTYPE;
                    }
                    continue;
                case S.DOCTYPE_DTD:
                    if (c === ']') {
                        parser.doctype += c;
                        parser.state = S.DOCTYPE;
                    } else if (c === '<') {
                        parser.state = S.OPEN_WAKA;
                        parser.startTagPosition = parser.position;
                    } else if (isQuote(c)) {
                        parser.doctype += c;
                        parser.state = S.DOCTYPE_DTD_QUOTED;
                        parser.q = c;
                    } else parser.doctype += c;
                    continue;
                case S.DOCTYPE_DTD_QUOTED:
                    parser.doctype += c;
                    if (c === parser.q) {
                        parser.state = S.DOCTYPE_DTD;
                        parser.q = '';
                    }
                    continue;
                case S.COMMENT:
                    if (c === '-') parser.state = S.COMMENT_ENDING;
                    else parser.comment += c;
                    continue;
                case S.COMMENT_ENDING:
                    if (c === '-') {
                        parser.state = S.COMMENT_ENDED;
                        parser.comment = textopts(parser.opt, parser.comment);
                        if (parser.comment) emitNode(parser, 'oncomment', parser.comment);
                        parser.comment = '';
                    } else {
                        parser.comment += '-' + c;
                        parser.state = S.COMMENT;
                    }
                    continue;
                case S.COMMENT_ENDED:
                    if (c !== '>') {
                        strictFail(parser, 'Malformed comment');
                        // allow <!-- blah -- bloo --> in non-strict mode,
                        // which is a comment of " blah -- bloo "
                        parser.comment += '--' + c;
                        parser.state = S.COMMENT;
                    } else if (parser.doctype && parser.doctype !== true) parser.state = S.DOCTYPE_DTD;
                    else parser.state = S.TEXT;
                    continue;
                case S.CDATA:
                    if (c === ']') parser.state = S.CDATA_ENDING;
                    else parser.cdata += c;
                    continue;
                case S.CDATA_ENDING:
                    if (c === ']') parser.state = S.CDATA_ENDING_2;
                    else {
                        parser.cdata += ']' + c;
                        parser.state = S.CDATA;
                    }
                    continue;
                case S.CDATA_ENDING_2:
                    if (c === '>') {
                        if (parser.cdata) emitNode(parser, 'oncdata', parser.cdata);
                        emitNode(parser, 'onclosecdata');
                        parser.cdata = '';
                        parser.state = S.TEXT;
                    } else if (c === ']') parser.cdata += ']';
                    else {
                        parser.cdata += ']]' + c;
                        parser.state = S.CDATA;
                    }
                    continue;
                case S.PROC_INST:
                    if (c === '?') parser.state = S.PROC_INST_ENDING;
                    else if (isWhitespace(c)) parser.state = S.PROC_INST_BODY;
                    else parser.procInstName += c;
                    continue;
                case S.PROC_INST_BODY:
                    if (!parser.procInstBody && isWhitespace(c)) continue;
                    else if (c === '?') parser.state = S.PROC_INST_ENDING;
                    else parser.procInstBody += c;
                    continue;
                case S.PROC_INST_ENDING:
                    if (c === '>') {
                        emitNode(parser, 'onprocessinginstruction', {
                            name: parser.procInstName,
                            body: parser.procInstBody
                        });
                        parser.procInstName = parser.procInstBody = '';
                        parser.state = S.TEXT;
                    } else {
                        parser.procInstBody += '?' + c;
                        parser.state = S.PROC_INST_BODY;
                    }
                    continue;
                case S.OPEN_TAG:
                    if (isMatch(nameBody, c)) parser.tagName += c;
                    else {
                        newTag(parser);
                        if (c === '>') openTag(parser);
                        else if (c === '/') parser.state = S.OPEN_TAG_SLASH;
                        else {
                            if (!isWhitespace(c)) strictFail(parser, 'Invalid character in tag name');
                            parser.state = S.ATTRIB;
                        }
                    }
                    continue;
                case S.OPEN_TAG_SLASH:
                    if (c === '>') {
                        openTag(parser, true);
                        closeTag(parser);
                    } else {
                        strictFail(parser, 'Forward-slash in opening tag not followed by >');
                        parser.state = S.ATTRIB;
                    }
                    continue;
                case S.ATTRIB:
                    // haven't read the attribute name yet.
                    if (isWhitespace(c)) continue;
                    else if (c === '>') openTag(parser);
                    else if (c === '/') parser.state = S.OPEN_TAG_SLASH;
                    else if (isMatch(nameStart, c)) {
                        parser.attribName = c;
                        parser.attribValue = '';
                        parser.state = S.ATTRIB_NAME;
                    } else strictFail(parser, 'Invalid attribute name');
                    continue;
                case S.ATTRIB_NAME:
                    if (c === '=') parser.state = S.ATTRIB_VALUE;
                    else if (c === '>') {
                        strictFail(parser, 'Attribute without value');
                        parser.attribValue = parser.attribName;
                        attrib(parser);
                        openTag(parser);
                    } else if (isWhitespace(c)) parser.state = S.ATTRIB_NAME_SAW_WHITE;
                    else if (isMatch(nameBody, c)) parser.attribName += c;
                    else strictFail(parser, 'Invalid attribute name');
                    continue;
                case S.ATTRIB_NAME_SAW_WHITE:
                    if (c === '=') parser.state = S.ATTRIB_VALUE;
                    else if (isWhitespace(c)) continue;
                    else {
                        strictFail(parser, 'Attribute without value');
                        parser.tag.attributes[parser.attribName] = '';
                        parser.attribValue = '';
                        emitNode(parser, 'onattribute', {
                            name: parser.attribName,
                            value: ''
                        });
                        parser.attribName = '';
                        if (c === '>') openTag(parser);
                        else if (isMatch(nameStart, c)) {
                            parser.attribName = c;
                            parser.state = S.ATTRIB_NAME;
                        } else {
                            strictFail(parser, 'Invalid attribute name');
                            parser.state = S.ATTRIB;
                        }
                    }
                    continue;
                case S.ATTRIB_VALUE:
                    if (isWhitespace(c)) continue;
                    else if (isQuote(c)) {
                        parser.q = c;
                        parser.state = S.ATTRIB_VALUE_QUOTED;
                    } else {
                        if (!parser.opt.unquotedAttributeValues) error(parser, 'Unquoted attribute value');
                        parser.state = S.ATTRIB_VALUE_UNQUOTED;
                        parser.attribValue = c;
                    }
                    continue;
                case S.ATTRIB_VALUE_QUOTED:
                    if (c !== parser.q) {
                        if (c === '&') parser.state = S.ATTRIB_VALUE_ENTITY_Q;
                        else parser.attribValue += c;
                        continue;
                    }
                    attrib(parser);
                    parser.q = '';
                    parser.state = S.ATTRIB_VALUE_CLOSED;
                    continue;
                case S.ATTRIB_VALUE_CLOSED:
                    if (isWhitespace(c)) parser.state = S.ATTRIB;
                    else if (c === '>') openTag(parser);
                    else if (c === '/') parser.state = S.OPEN_TAG_SLASH;
                    else if (isMatch(nameStart, c)) {
                        strictFail(parser, 'No whitespace between attributes');
                        parser.attribName = c;
                        parser.attribValue = '';
                        parser.state = S.ATTRIB_NAME;
                    } else strictFail(parser, 'Invalid attribute name');
                    continue;
                case S.ATTRIB_VALUE_UNQUOTED:
                    if (!isAttribEnd(c)) {
                        if (c === '&') parser.state = S.ATTRIB_VALUE_ENTITY_U;
                        else parser.attribValue += c;
                        continue;
                    }
                    attrib(parser);
                    if (c === '>') openTag(parser);
                    else parser.state = S.ATTRIB;
                    continue;
                case S.CLOSE_TAG:
                    if (!parser.tagName) {
                        if (isWhitespace(c)) continue;
                        else if (notMatch(nameStart, c)) {
                            if (parser.script) {
                                parser.script += '</' + c;
                                parser.state = S.SCRIPT;
                            } else strictFail(parser, 'Invalid tagname in closing tag.');
                        } else parser.tagName = c;
                    } else if (c === '>') closeTag(parser);
                    else if (isMatch(nameBody, c)) parser.tagName += c;
                    else if (parser.script) {
                        parser.script += '</' + parser.tagName;
                        parser.tagName = '';
                        parser.state = S.SCRIPT;
                    } else {
                        if (!isWhitespace(c)) strictFail(parser, 'Invalid tagname in closing tag');
                        parser.state = S.CLOSE_TAG_SAW_WHITE;
                    }
                    continue;
                case S.CLOSE_TAG_SAW_WHITE:
                    if (isWhitespace(c)) continue;
                    if (c === '>') closeTag(parser);
                    else strictFail(parser, 'Invalid characters in closing tag');
                    continue;
                case S.TEXT_ENTITY:
                case S.ATTRIB_VALUE_ENTITY_Q:
                case S.ATTRIB_VALUE_ENTITY_U:
                    var returnState;
                    var buffer;
                    switch(parser.state){
                        case S.TEXT_ENTITY:
                            returnState = S.TEXT;
                            buffer = 'textNode';
                            break;
                        case S.ATTRIB_VALUE_ENTITY_Q:
                            returnState = S.ATTRIB_VALUE_QUOTED;
                            buffer = 'attribValue';
                            break;
                        case S.ATTRIB_VALUE_ENTITY_U:
                            returnState = S.ATTRIB_VALUE_UNQUOTED;
                            buffer = 'attribValue';
                            break;
                    }
                    if (c === ';') {
                        var parsedEntity = parseEntity(parser);
                        if (parser.opt.unparsedEntities && !Object.values(sax.XML_ENTITIES).includes(parsedEntity)) {
                            parser.entity = '';
                            parser.state = returnState;
                            parser.write(parsedEntity);
                        } else {
                            parser[buffer] += parsedEntity;
                            parser.entity = '';
                            parser.state = returnState;
                        }
                    } else if (isMatch(parser.entity.length ? entityBody : entityStart, c)) parser.entity += c;
                    else {
                        strictFail(parser, 'Invalid character in entity name');
                        parser[buffer] += '&' + parser.entity + c;
                        parser.entity = '';
                        parser.state = returnState;
                    }
                    continue;
                default:
                    throw new Error(parser, 'Unknown state: ' + parser.state);
            }
        } // while
        if (parser.position >= parser.bufferCheckPosition) checkBufferLength(parser);
        return parser;
    }
    /*! http://mths.be/fromcodepoint v0.1.0 by @mathias */ /* istanbul ignore next */ if (!String.fromCodePoint) (function() {
        var stringFromCharCode = String.fromCharCode;
        var floor = Math.floor;
        var fromCodePoint = function() {
            var MAX_SIZE = 0x4000;
            var codeUnits = [];
            var highSurrogate;
            var lowSurrogate;
            var index = -1;
            var length = arguments.length;
            if (!length) return '';
            var result = '';
            while(++index < length){
                var codePoint = Number(arguments[index]);
                if (!isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
                codePoint < 0 || // not a valid Unicode code point
                codePoint > 0x10FFFF || // not a valid Unicode code point
                floor(codePoint) !== codePoint // not an integer
                ) throw RangeError('Invalid code point: ' + codePoint);
                if (codePoint <= 0xFFFF) codeUnits.push(codePoint);
                else {
                    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                    codePoint -= 0x10000;
                    highSurrogate = (codePoint >> 10) + 0xD800;
                    lowSurrogate = codePoint % 0x400 + 0xDC00;
                    codeUnits.push(highSurrogate, lowSurrogate);
                }
                if (index + 1 === length || codeUnits.length > MAX_SIZE) {
                    result += stringFromCharCode.apply(null, codeUnits);
                    codeUnits.length = 0;
                }
            }
            return result;
        };
        /* istanbul ignore next */ if (Object.defineProperty) Object.defineProperty(String, 'fromCodePoint', {
            value: fromCodePoint,
            configurable: true,
            writable: true
        });
        else String.fromCodePoint = fromCodePoint;
    })();
})($b96fe3030242c613$exports);


var $6efd4bc11af435ee$var$expat /*= require('node-expat');*/  = {
    on: function() {},
    parse: function() {}
};
var $450776c707e891ad$exports = {};
var $367415893dc5fd5e$exports = {};
$367415893dc5fd5e$exports = {
    isArray: function(value) {
        if (Array.isArray) return Array.isArray(value);
        // fallback for older browsers like  IE 8
        return Object.prototype.toString.call(value) === '[object Array]';
    }
};


var $450776c707e891ad$require$isArray = $367415893dc5fd5e$exports.isArray;
$450776c707e891ad$exports = {
    copyOptions: function(options) {
        var key, copy = {};
        for(key in options)if (options.hasOwnProperty(key)) copy[key] = options[key];
        return copy;
    },
    ensureFlagExists: function(item, options) {
        if (!(item in options) || typeof options[item] !== 'boolean') options[item] = false;
    },
    ensureSpacesExists: function(options) {
        if (!('spaces' in options) || typeof options.spaces !== 'number' && typeof options.spaces !== 'string') options.spaces = 0;
    },
    ensureAlwaysArrayExists: function(options) {
        if (!('alwaysArray' in options) || typeof options.alwaysArray !== 'boolean' && !$450776c707e891ad$require$isArray(options.alwaysArray)) options.alwaysArray = false;
    },
    ensureKeyExists: function(key, options) {
        if (!(key + 'Key' in options) || typeof options[key + 'Key'] !== 'string') options[key + 'Key'] = options.compact ? '_' + key : key;
    },
    checkFnExists: function(key, options) {
        return key + 'Fn' in options;
    }
};



var $6efd4bc11af435ee$require$isArray = $367415893dc5fd5e$exports.isArray;
var $6efd4bc11af435ee$var$options;
var $6efd4bc11af435ee$var$pureJsParser = true;
var $6efd4bc11af435ee$var$currentElement;
function $6efd4bc11af435ee$var$validateOptions(userOptions) {
    $6efd4bc11af435ee$var$options = $450776c707e891ad$exports.copyOptions(userOptions);
    $450776c707e891ad$exports.ensureFlagExists('ignoreDeclaration', $6efd4bc11af435ee$var$options);
    $450776c707e891ad$exports.ensureFlagExists('ignoreInstruction', $6efd4bc11af435ee$var$options);
    $450776c707e891ad$exports.ensureFlagExists('ignoreAttributes', $6efd4bc11af435ee$var$options);
    $450776c707e891ad$exports.ensureFlagExists('ignoreText', $6efd4bc11af435ee$var$options);
    $450776c707e891ad$exports.ensureFlagExists('ignoreComment', $6efd4bc11af435ee$var$options);
    $450776c707e891ad$exports.ensureFlagExists('ignoreCdata', $6efd4bc11af435ee$var$options);
    $450776c707e891ad$exports.ensureFlagExists('ignoreDoctype', $6efd4bc11af435ee$var$options);
    $450776c707e891ad$exports.ensureFlagExists('compact', $6efd4bc11af435ee$var$options);
    $450776c707e891ad$exports.ensureFlagExists('alwaysChildren', $6efd4bc11af435ee$var$options);
    $450776c707e891ad$exports.ensureFlagExists('addParent', $6efd4bc11af435ee$var$options);
    $450776c707e891ad$exports.ensureFlagExists('trim', $6efd4bc11af435ee$var$options);
    $450776c707e891ad$exports.ensureFlagExists('nativeType', $6efd4bc11af435ee$var$options);
    $450776c707e891ad$exports.ensureFlagExists('nativeTypeAttributes', $6efd4bc11af435ee$var$options);
    $450776c707e891ad$exports.ensureFlagExists('sanitize', $6efd4bc11af435ee$var$options);
    $450776c707e891ad$exports.ensureFlagExists('instructionHasAttributes', $6efd4bc11af435ee$var$options);
    $450776c707e891ad$exports.ensureFlagExists('captureSpacesBetweenElements', $6efd4bc11af435ee$var$options);
    $450776c707e891ad$exports.ensureAlwaysArrayExists($6efd4bc11af435ee$var$options);
    $450776c707e891ad$exports.ensureKeyExists('declaration', $6efd4bc11af435ee$var$options);
    $450776c707e891ad$exports.ensureKeyExists('instruction', $6efd4bc11af435ee$var$options);
    $450776c707e891ad$exports.ensureKeyExists('attributes', $6efd4bc11af435ee$var$options);
    $450776c707e891ad$exports.ensureKeyExists('text', $6efd4bc11af435ee$var$options);
    $450776c707e891ad$exports.ensureKeyExists('comment', $6efd4bc11af435ee$var$options);
    $450776c707e891ad$exports.ensureKeyExists('cdata', $6efd4bc11af435ee$var$options);
    $450776c707e891ad$exports.ensureKeyExists('doctype', $6efd4bc11af435ee$var$options);
    $450776c707e891ad$exports.ensureKeyExists('type', $6efd4bc11af435ee$var$options);
    $450776c707e891ad$exports.ensureKeyExists('name', $6efd4bc11af435ee$var$options);
    $450776c707e891ad$exports.ensureKeyExists('elements', $6efd4bc11af435ee$var$options);
    $450776c707e891ad$exports.ensureKeyExists('parent', $6efd4bc11af435ee$var$options);
    $450776c707e891ad$exports.checkFnExists('doctype', $6efd4bc11af435ee$var$options);
    $450776c707e891ad$exports.checkFnExists('instruction', $6efd4bc11af435ee$var$options);
    $450776c707e891ad$exports.checkFnExists('cdata', $6efd4bc11af435ee$var$options);
    $450776c707e891ad$exports.checkFnExists('comment', $6efd4bc11af435ee$var$options);
    $450776c707e891ad$exports.checkFnExists('text', $6efd4bc11af435ee$var$options);
    $450776c707e891ad$exports.checkFnExists('instructionName', $6efd4bc11af435ee$var$options);
    $450776c707e891ad$exports.checkFnExists('elementName', $6efd4bc11af435ee$var$options);
    $450776c707e891ad$exports.checkFnExists('attributeName', $6efd4bc11af435ee$var$options);
    $450776c707e891ad$exports.checkFnExists('attributeValue', $6efd4bc11af435ee$var$options);
    $450776c707e891ad$exports.checkFnExists('attributes', $6efd4bc11af435ee$var$options);
    return $6efd4bc11af435ee$var$options;
}
function $6efd4bc11af435ee$var$nativeType(value) {
    var nValue = Number(value);
    if (!isNaN(nValue)) return nValue;
    var bValue = value.toLowerCase();
    if (bValue === 'true') return true;
    else if (bValue === 'false') return false;
    return value;
}
function $6efd4bc11af435ee$var$addField(type, value) {
    var key;
    if ($6efd4bc11af435ee$var$options.compact) {
        if (!$6efd4bc11af435ee$var$currentElement[$6efd4bc11af435ee$var$options[type + 'Key']] && ($6efd4bc11af435ee$require$isArray($6efd4bc11af435ee$var$options.alwaysArray) ? $6efd4bc11af435ee$var$options.alwaysArray.indexOf($6efd4bc11af435ee$var$options[type + 'Key']) !== -1 : $6efd4bc11af435ee$var$options.alwaysArray)) $6efd4bc11af435ee$var$currentElement[$6efd4bc11af435ee$var$options[type + 'Key']] = [];
        if ($6efd4bc11af435ee$var$currentElement[$6efd4bc11af435ee$var$options[type + 'Key']] && !$6efd4bc11af435ee$require$isArray($6efd4bc11af435ee$var$currentElement[$6efd4bc11af435ee$var$options[type + 'Key']])) $6efd4bc11af435ee$var$currentElement[$6efd4bc11af435ee$var$options[type + 'Key']] = [
            $6efd4bc11af435ee$var$currentElement[$6efd4bc11af435ee$var$options[type + 'Key']]
        ];
        if (type + 'Fn' in $6efd4bc11af435ee$var$options && typeof value === 'string') value = $6efd4bc11af435ee$var$options[type + 'Fn'](value, $6efd4bc11af435ee$var$currentElement);
        if (type === 'instruction' && ('instructionFn' in $6efd4bc11af435ee$var$options || 'instructionNameFn' in $6efd4bc11af435ee$var$options)) {
            for(key in value)if (value.hasOwnProperty(key)) {
                if ('instructionFn' in $6efd4bc11af435ee$var$options) value[key] = $6efd4bc11af435ee$var$options.instructionFn(value[key], key, $6efd4bc11af435ee$var$currentElement);
                else {
                    var temp = value[key];
                    delete value[key];
                    value[$6efd4bc11af435ee$var$options.instructionNameFn(key, temp, $6efd4bc11af435ee$var$currentElement)] = temp;
                }
            }
        }
        if ($6efd4bc11af435ee$require$isArray($6efd4bc11af435ee$var$currentElement[$6efd4bc11af435ee$var$options[type + 'Key']])) $6efd4bc11af435ee$var$currentElement[$6efd4bc11af435ee$var$options[type + 'Key']].push(value);
        else $6efd4bc11af435ee$var$currentElement[$6efd4bc11af435ee$var$options[type + 'Key']] = value;
    } else {
        if (!$6efd4bc11af435ee$var$currentElement[$6efd4bc11af435ee$var$options.elementsKey]) $6efd4bc11af435ee$var$currentElement[$6efd4bc11af435ee$var$options.elementsKey] = [];
        var element = {};
        element[$6efd4bc11af435ee$var$options.typeKey] = type;
        if (type === 'instruction') {
            for(key in value){
                if (value.hasOwnProperty(key)) break;
            }
            element[$6efd4bc11af435ee$var$options.nameKey] = 'instructionNameFn' in $6efd4bc11af435ee$var$options ? $6efd4bc11af435ee$var$options.instructionNameFn(key, value, $6efd4bc11af435ee$var$currentElement) : key;
            if ($6efd4bc11af435ee$var$options.instructionHasAttributes) {
                element[$6efd4bc11af435ee$var$options.attributesKey] = value[key][$6efd4bc11af435ee$var$options.attributesKey];
                if ('instructionFn' in $6efd4bc11af435ee$var$options) element[$6efd4bc11af435ee$var$options.attributesKey] = $6efd4bc11af435ee$var$options.instructionFn(element[$6efd4bc11af435ee$var$options.attributesKey], key, $6efd4bc11af435ee$var$currentElement);
            } else {
                if ('instructionFn' in $6efd4bc11af435ee$var$options) value[key] = $6efd4bc11af435ee$var$options.instructionFn(value[key], key, $6efd4bc11af435ee$var$currentElement);
                element[$6efd4bc11af435ee$var$options.instructionKey] = value[key];
            }
        } else {
            if (type + 'Fn' in $6efd4bc11af435ee$var$options) value = $6efd4bc11af435ee$var$options[type + 'Fn'](value, $6efd4bc11af435ee$var$currentElement);
            element[$6efd4bc11af435ee$var$options[type + 'Key']] = value;
        }
        if ($6efd4bc11af435ee$var$options.addParent) element[$6efd4bc11af435ee$var$options.parentKey] = $6efd4bc11af435ee$var$currentElement;
        $6efd4bc11af435ee$var$currentElement[$6efd4bc11af435ee$var$options.elementsKey].push(element);
    }
}
function $6efd4bc11af435ee$var$manipulateAttributes(attributes) {
    if ('attributesFn' in $6efd4bc11af435ee$var$options && attributes) attributes = $6efd4bc11af435ee$var$options.attributesFn(attributes, $6efd4bc11af435ee$var$currentElement);
    if (($6efd4bc11af435ee$var$options.trim || 'attributeValueFn' in $6efd4bc11af435ee$var$options || 'attributeNameFn' in $6efd4bc11af435ee$var$options || $6efd4bc11af435ee$var$options.nativeTypeAttributes) && attributes) {
        var key;
        for(key in attributes)if (attributes.hasOwnProperty(key)) {
            if ($6efd4bc11af435ee$var$options.trim) attributes[key] = attributes[key].trim();
            if ($6efd4bc11af435ee$var$options.nativeTypeAttributes) attributes[key] = $6efd4bc11af435ee$var$nativeType(attributes[key]);
            if ('attributeValueFn' in $6efd4bc11af435ee$var$options) attributes[key] = $6efd4bc11af435ee$var$options.attributeValueFn(attributes[key], key, $6efd4bc11af435ee$var$currentElement);
            if ('attributeNameFn' in $6efd4bc11af435ee$var$options) {
                var temp = attributes[key];
                delete attributes[key];
                attributes[$6efd4bc11af435ee$var$options.attributeNameFn(key, attributes[key], $6efd4bc11af435ee$var$currentElement)] = temp;
            }
        }
    }
    return attributes;
}
function $6efd4bc11af435ee$var$onInstruction(instruction) {
    var attributes = {};
    if (instruction.body && (instruction.name.toLowerCase() === 'xml' || $6efd4bc11af435ee$var$options.instructionHasAttributes)) {
        var attrsRegExp = /([\w:-]+)\s*=\s*(?:"([^"]*)"|'([^']*)'|(\w+))\s*/g;
        var match;
        while((match = attrsRegExp.exec(instruction.body)) !== null)attributes[match[1]] = match[2] || match[3] || match[4];
        attributes = $6efd4bc11af435ee$var$manipulateAttributes(attributes);
    }
    if (instruction.name.toLowerCase() === 'xml') {
        if ($6efd4bc11af435ee$var$options.ignoreDeclaration) return;
        $6efd4bc11af435ee$var$currentElement[$6efd4bc11af435ee$var$options.declarationKey] = {};
        if (Object.keys(attributes).length) $6efd4bc11af435ee$var$currentElement[$6efd4bc11af435ee$var$options.declarationKey][$6efd4bc11af435ee$var$options.attributesKey] = attributes;
        if ($6efd4bc11af435ee$var$options.addParent) $6efd4bc11af435ee$var$currentElement[$6efd4bc11af435ee$var$options.declarationKey][$6efd4bc11af435ee$var$options.parentKey] = $6efd4bc11af435ee$var$currentElement;
    } else {
        if ($6efd4bc11af435ee$var$options.ignoreInstruction) return;
        if ($6efd4bc11af435ee$var$options.trim) instruction.body = instruction.body.trim();
        var value = {};
        if ($6efd4bc11af435ee$var$options.instructionHasAttributes && Object.keys(attributes).length) {
            value[instruction.name] = {};
            value[instruction.name][$6efd4bc11af435ee$var$options.attributesKey] = attributes;
        } else value[instruction.name] = instruction.body;
        $6efd4bc11af435ee$var$addField('instruction', value);
    }
}
function $6efd4bc11af435ee$var$onStartElement(name, attributes) {
    var element;
    if (typeof name === 'object') {
        attributes = name.attributes;
        name = name.name;
    }
    attributes = $6efd4bc11af435ee$var$manipulateAttributes(attributes);
    if ('elementNameFn' in $6efd4bc11af435ee$var$options) name = $6efd4bc11af435ee$var$options.elementNameFn(name, $6efd4bc11af435ee$var$currentElement);
    if ($6efd4bc11af435ee$var$options.compact) {
        element = {};
        if (!$6efd4bc11af435ee$var$options.ignoreAttributes && attributes && Object.keys(attributes).length) {
            element[$6efd4bc11af435ee$var$options.attributesKey] = {};
            var key;
            for(key in attributes)if (attributes.hasOwnProperty(key)) element[$6efd4bc11af435ee$var$options.attributesKey][key] = attributes[key];
        }
        if (!(name in $6efd4bc11af435ee$var$currentElement) && ($6efd4bc11af435ee$require$isArray($6efd4bc11af435ee$var$options.alwaysArray) ? $6efd4bc11af435ee$var$options.alwaysArray.indexOf(name) !== -1 : $6efd4bc11af435ee$var$options.alwaysArray)) $6efd4bc11af435ee$var$currentElement[name] = [];
        if ($6efd4bc11af435ee$var$currentElement[name] && !$6efd4bc11af435ee$require$isArray($6efd4bc11af435ee$var$currentElement[name])) $6efd4bc11af435ee$var$currentElement[name] = [
            $6efd4bc11af435ee$var$currentElement[name]
        ];
        if ($6efd4bc11af435ee$require$isArray($6efd4bc11af435ee$var$currentElement[name])) $6efd4bc11af435ee$var$currentElement[name].push(element);
        else $6efd4bc11af435ee$var$currentElement[name] = element;
    } else {
        if (!$6efd4bc11af435ee$var$currentElement[$6efd4bc11af435ee$var$options.elementsKey]) $6efd4bc11af435ee$var$currentElement[$6efd4bc11af435ee$var$options.elementsKey] = [];
        element = {};
        element[$6efd4bc11af435ee$var$options.typeKey] = 'element';
        element[$6efd4bc11af435ee$var$options.nameKey] = name;
        if (!$6efd4bc11af435ee$var$options.ignoreAttributes && attributes && Object.keys(attributes).length) element[$6efd4bc11af435ee$var$options.attributesKey] = attributes;
        if ($6efd4bc11af435ee$var$options.alwaysChildren) element[$6efd4bc11af435ee$var$options.elementsKey] = [];
        $6efd4bc11af435ee$var$currentElement[$6efd4bc11af435ee$var$options.elementsKey].push(element);
    }
    element[$6efd4bc11af435ee$var$options.parentKey] = $6efd4bc11af435ee$var$currentElement; // will be deleted in onEndElement() if !options.addParent
    $6efd4bc11af435ee$var$currentElement = element;
}
function $6efd4bc11af435ee$var$onText(text) {
    if ($6efd4bc11af435ee$var$options.ignoreText) return;
    if (!text.trim() && !$6efd4bc11af435ee$var$options.captureSpacesBetweenElements) return;
    if ($6efd4bc11af435ee$var$options.trim) text = text.trim();
    if ($6efd4bc11af435ee$var$options.nativeType) text = $6efd4bc11af435ee$var$nativeType(text);
    if ($6efd4bc11af435ee$var$options.sanitize) text = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    $6efd4bc11af435ee$var$addField('text', text);
}
function $6efd4bc11af435ee$var$onComment(comment) {
    if ($6efd4bc11af435ee$var$options.ignoreComment) return;
    if ($6efd4bc11af435ee$var$options.trim) comment = comment.trim();
    $6efd4bc11af435ee$var$addField('comment', comment);
}
function $6efd4bc11af435ee$var$onEndElement(name) {
    var parentElement = $6efd4bc11af435ee$var$currentElement[$6efd4bc11af435ee$var$options.parentKey];
    if (!$6efd4bc11af435ee$var$options.addParent) delete $6efd4bc11af435ee$var$currentElement[$6efd4bc11af435ee$var$options.parentKey];
    $6efd4bc11af435ee$var$currentElement = parentElement;
}
function $6efd4bc11af435ee$var$onCdata(cdata) {
    if ($6efd4bc11af435ee$var$options.ignoreCdata) return;
    if ($6efd4bc11af435ee$var$options.trim) cdata = cdata.trim();
    $6efd4bc11af435ee$var$addField('cdata', cdata);
}
function $6efd4bc11af435ee$var$onDoctype(doctype) {
    if ($6efd4bc11af435ee$var$options.ignoreDoctype) return;
    doctype = doctype.replace(/^ /, '');
    if ($6efd4bc11af435ee$var$options.trim) doctype = doctype.trim();
    $6efd4bc11af435ee$var$addField('doctype', doctype);
}
function $6efd4bc11af435ee$var$onError(error) {
    error.note = error; //console.error(error);
}
$6efd4bc11af435ee$exports = function(xml, userOptions) {
    var parser = $6efd4bc11af435ee$var$pureJsParser ? $b96fe3030242c613$exports.parser(true, {}) : parser = new $6efd4bc11af435ee$var$expat.Parser('UTF-8');
    var result = {};
    $6efd4bc11af435ee$var$currentElement = result;
    $6efd4bc11af435ee$var$options = $6efd4bc11af435ee$var$validateOptions(userOptions);
    if ($6efd4bc11af435ee$var$pureJsParser) {
        parser.opt = {
            strictEntities: true
        };
        parser.onopentag = $6efd4bc11af435ee$var$onStartElement;
        parser.ontext = $6efd4bc11af435ee$var$onText;
        parser.oncomment = $6efd4bc11af435ee$var$onComment;
        parser.onclosetag = $6efd4bc11af435ee$var$onEndElement;
        parser.onerror = $6efd4bc11af435ee$var$onError;
        parser.oncdata = $6efd4bc11af435ee$var$onCdata;
        parser.ondoctype = $6efd4bc11af435ee$var$onDoctype;
        parser.onprocessinginstruction = $6efd4bc11af435ee$var$onInstruction;
    } else {
        parser.on('startElement', $6efd4bc11af435ee$var$onStartElement);
        parser.on('text', $6efd4bc11af435ee$var$onText);
        parser.on('comment', $6efd4bc11af435ee$var$onComment);
        parser.on('endElement', $6efd4bc11af435ee$var$onEndElement);
        parser.on('error', $6efd4bc11af435ee$var$onError);
    //parser.on('startCdata', onStartCdata);
    //parser.on('endCdata', onEndCdata);
    //parser.on('entityDecl', onEntityDecl);
    }
    if ($6efd4bc11af435ee$var$pureJsParser) parser.write(xml).close();
    else {
        if (!parser.parse(xml)) throw new Error('XML parsing error: ' + parser.getError());
    }
    if (result[$6efd4bc11af435ee$var$options.elementsKey]) {
        var temp = result[$6efd4bc11af435ee$var$options.elementsKey];
        delete result[$6efd4bc11af435ee$var$options.elementsKey];
        result[$6efd4bc11af435ee$var$options.elementsKey] = temp;
        delete result.text;
    }
    return result;
};


var $dd3d1dea81a85fab$exports = {};


function $dd3d1dea81a85fab$var$validateOptions(userOptions) {
    var options = $450776c707e891ad$exports.copyOptions(userOptions);
    $450776c707e891ad$exports.ensureSpacesExists(options);
    return options;
}
$dd3d1dea81a85fab$exports = function(xml, userOptions) {
    var options, js, json, parentKey;
    options = $dd3d1dea81a85fab$var$validateOptions(userOptions);
    js = $6efd4bc11af435ee$exports(xml, options);
    parentKey = 'compact' in options && options.compact ? '_parent' : 'parent';
    // parentKey = ptions.compact ? '_parent' : 'parent'; // consider this
    if ('addParent' in options && options.addParent) json = JSON.stringify(js, function(k, v) {
        return k === parentKey ? '_' : v;
    }, options.spaces);
    else json = JSON.stringify(js, null, options.spaces);
    return json.replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
};


var $13492a8f410eb86a$exports = {};


var $13492a8f410eb86a$require$isArray = $367415893dc5fd5e$exports.isArray;
var $13492a8f410eb86a$var$currentElement, $13492a8f410eb86a$var$currentElementName;
function $13492a8f410eb86a$var$validateOptions(userOptions) {
    var options = $450776c707e891ad$exports.copyOptions(userOptions);
    $450776c707e891ad$exports.ensureFlagExists('ignoreDeclaration', options);
    $450776c707e891ad$exports.ensureFlagExists('ignoreInstruction', options);
    $450776c707e891ad$exports.ensureFlagExists('ignoreAttributes', options);
    $450776c707e891ad$exports.ensureFlagExists('ignoreText', options);
    $450776c707e891ad$exports.ensureFlagExists('ignoreComment', options);
    $450776c707e891ad$exports.ensureFlagExists('ignoreCdata', options);
    $450776c707e891ad$exports.ensureFlagExists('ignoreDoctype', options);
    $450776c707e891ad$exports.ensureFlagExists('compact', options);
    $450776c707e891ad$exports.ensureFlagExists('indentText', options);
    $450776c707e891ad$exports.ensureFlagExists('indentCdata', options);
    $450776c707e891ad$exports.ensureFlagExists('indentAttributes', options);
    $450776c707e891ad$exports.ensureFlagExists('indentInstruction', options);
    $450776c707e891ad$exports.ensureFlagExists('fullTagEmptyElement', options);
    $450776c707e891ad$exports.ensureFlagExists('noQuotesForNativeAttributes', options);
    $450776c707e891ad$exports.ensureSpacesExists(options);
    if (typeof options.spaces === 'number') options.spaces = Array(options.spaces + 1).join(' ');
    $450776c707e891ad$exports.ensureKeyExists('declaration', options);
    $450776c707e891ad$exports.ensureKeyExists('instruction', options);
    $450776c707e891ad$exports.ensureKeyExists('attributes', options);
    $450776c707e891ad$exports.ensureKeyExists('text', options);
    $450776c707e891ad$exports.ensureKeyExists('comment', options);
    $450776c707e891ad$exports.ensureKeyExists('cdata', options);
    $450776c707e891ad$exports.ensureKeyExists('doctype', options);
    $450776c707e891ad$exports.ensureKeyExists('type', options);
    $450776c707e891ad$exports.ensureKeyExists('name', options);
    $450776c707e891ad$exports.ensureKeyExists('elements', options);
    $450776c707e891ad$exports.checkFnExists('doctype', options);
    $450776c707e891ad$exports.checkFnExists('instruction', options);
    $450776c707e891ad$exports.checkFnExists('cdata', options);
    $450776c707e891ad$exports.checkFnExists('comment', options);
    $450776c707e891ad$exports.checkFnExists('text', options);
    $450776c707e891ad$exports.checkFnExists('instructionName', options);
    $450776c707e891ad$exports.checkFnExists('elementName', options);
    $450776c707e891ad$exports.checkFnExists('attributeName', options);
    $450776c707e891ad$exports.checkFnExists('attributeValue', options);
    $450776c707e891ad$exports.checkFnExists('attributes', options);
    $450776c707e891ad$exports.checkFnExists('fullTagEmptyElement', options);
    return options;
}
function $13492a8f410eb86a$var$writeIndentation(options, depth, firstLine) {
    return (!firstLine && options.spaces ? '\n' : '') + Array(depth + 1).join(options.spaces);
}
function $13492a8f410eb86a$var$writeAttributes(attributes, options, depth) {
    if (options.ignoreAttributes) return '';
    if ('attributesFn' in options) attributes = options.attributesFn(attributes, $13492a8f410eb86a$var$currentElementName, $13492a8f410eb86a$var$currentElement);
    var key, attr, attrName, quote, result = [];
    for(key in attributes)if (attributes.hasOwnProperty(key) && attributes[key] !== null && attributes[key] !== undefined) {
        quote = options.noQuotesForNativeAttributes && typeof attributes[key] !== 'string' ? '' : '"';
        attr = '' + attributes[key]; // ensure number and boolean are converted to String
        attr = attr.replace(/"/g, '&quot;');
        attrName = 'attributeNameFn' in options ? options.attributeNameFn(key, attr, $13492a8f410eb86a$var$currentElementName, $13492a8f410eb86a$var$currentElement) : key;
        result.push(options.spaces && options.indentAttributes ? $13492a8f410eb86a$var$writeIndentation(options, depth + 1, false) : ' ');
        result.push(attrName + '=' + quote + ('attributeValueFn' in options ? options.attributeValueFn(attr, key, $13492a8f410eb86a$var$currentElementName, $13492a8f410eb86a$var$currentElement) : attr) + quote);
    }
    if (attributes && Object.keys(attributes).length && options.spaces && options.indentAttributes) result.push($13492a8f410eb86a$var$writeIndentation(options, depth, false));
    return result.join('');
}
function $13492a8f410eb86a$var$writeDeclaration(declaration, options, depth) {
    $13492a8f410eb86a$var$currentElement = declaration;
    $13492a8f410eb86a$var$currentElementName = 'xml';
    return options.ignoreDeclaration ? '' : "<?xml" + $13492a8f410eb86a$var$writeAttributes(declaration[options.attributesKey], options, depth) + '?>';
}
function $13492a8f410eb86a$var$writeInstruction(instruction, options, depth) {
    if (options.ignoreInstruction) return '';
    var key;
    for(key in instruction){
        if (instruction.hasOwnProperty(key)) break;
    }
    var instructionName = 'instructionNameFn' in options ? options.instructionNameFn(key, instruction[key], $13492a8f410eb86a$var$currentElementName, $13492a8f410eb86a$var$currentElement) : key;
    if (typeof instruction[key] === 'object') {
        $13492a8f410eb86a$var$currentElement = instruction;
        $13492a8f410eb86a$var$currentElementName = instructionName;
        return '<?' + instructionName + $13492a8f410eb86a$var$writeAttributes(instruction[key][options.attributesKey], options, depth) + '?>';
    } else {
        var instructionValue = instruction[key] ? instruction[key] : '';
        if ('instructionFn' in options) instructionValue = options.instructionFn(instructionValue, key, $13492a8f410eb86a$var$currentElementName, $13492a8f410eb86a$var$currentElement);
        return '<?' + instructionName + (instructionValue ? ' ' + instructionValue : '') + '?>';
    }
}
function $13492a8f410eb86a$var$writeComment(comment, options) {
    return options.ignoreComment ? '' : '<!--' + ('commentFn' in options ? options.commentFn(comment, $13492a8f410eb86a$var$currentElementName, $13492a8f410eb86a$var$currentElement) : comment) + '-->';
}
function $13492a8f410eb86a$var$writeCdata(cdata, options) {
    return options.ignoreCdata ? '' : '<![CDATA[' + ('cdataFn' in options ? options.cdataFn(cdata, $13492a8f410eb86a$var$currentElementName, $13492a8f410eb86a$var$currentElement) : cdata.replace(']]>', ']]]]><![CDATA[>')) + ']]>';
}
function $13492a8f410eb86a$var$writeDoctype(doctype, options) {
    return options.ignoreDoctype ? '' : '<!DOCTYPE ' + ('doctypeFn' in options ? options.doctypeFn(doctype, $13492a8f410eb86a$var$currentElementName, $13492a8f410eb86a$var$currentElement) : doctype) + '>';
}
function $13492a8f410eb86a$var$writeText(text, options) {
    if (options.ignoreText) return '';
    text = '' + text; // ensure Number and Boolean are converted to String
    text = text.replace(/&amp;/g, '&'); // desanitize to avoid double sanitization
    text = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    return 'textFn' in options ? options.textFn(text, $13492a8f410eb86a$var$currentElementName, $13492a8f410eb86a$var$currentElement) : text;
}
function $13492a8f410eb86a$var$hasContent(element, options) {
    var i;
    if (element.elements && element.elements.length) for(i = 0; i < element.elements.length; ++i)switch(element.elements[i][options.typeKey]){
        case 'text':
            if (options.indentText) return true;
            break; // skip to next key
        case 'cdata':
            if (options.indentCdata) return true;
            break; // skip to next key
        case 'instruction':
            if (options.indentInstruction) return true;
            break; // skip to next key
        case 'doctype':
        case 'comment':
        case 'element':
            return true;
        default:
            return true;
    }
    return false;
}
function $13492a8f410eb86a$var$writeElement(element, options, depth) {
    $13492a8f410eb86a$var$currentElement = element;
    $13492a8f410eb86a$var$currentElementName = element.name;
    var xml = [], elementName = 'elementNameFn' in options ? options.elementNameFn(element.name, element) : element.name;
    xml.push('<' + elementName);
    if (element[options.attributesKey]) xml.push($13492a8f410eb86a$var$writeAttributes(element[options.attributesKey], options, depth));
    var withClosingTag = element[options.elementsKey] && element[options.elementsKey].length || element[options.attributesKey] && element[options.attributesKey]['xml:space'] === 'preserve';
    if (!withClosingTag) {
        if ('fullTagEmptyElementFn' in options) withClosingTag = options.fullTagEmptyElementFn(element.name, element);
        else withClosingTag = options.fullTagEmptyElement;
    }
    if (withClosingTag) {
        xml.push('>');
        if (element[options.elementsKey] && element[options.elementsKey].length) {
            xml.push($13492a8f410eb86a$var$writeElements(element[options.elementsKey], options, depth + 1));
            $13492a8f410eb86a$var$currentElement = element;
            $13492a8f410eb86a$var$currentElementName = element.name;
        }
        xml.push(options.spaces && $13492a8f410eb86a$var$hasContent(element, options) ? '\n' + Array(depth + 1).join(options.spaces) : '');
        xml.push('</' + elementName + '>');
    } else xml.push('/>');
    return xml.join('');
}
function $13492a8f410eb86a$var$writeElements(elements, options, depth, firstLine) {
    return elements.reduce(function(xml, element) {
        var indent = $13492a8f410eb86a$var$writeIndentation(options, depth, firstLine && !xml);
        switch(element.type){
            case 'element':
                return xml + indent + $13492a8f410eb86a$var$writeElement(element, options, depth);
            case 'comment':
                return xml + indent + $13492a8f410eb86a$var$writeComment(element[options.commentKey], options);
            case 'doctype':
                return xml + indent + $13492a8f410eb86a$var$writeDoctype(element[options.doctypeKey], options);
            case 'cdata':
                return xml + (options.indentCdata ? indent : '') + $13492a8f410eb86a$var$writeCdata(element[options.cdataKey], options);
            case 'text':
                return xml + (options.indentText ? indent : '') + $13492a8f410eb86a$var$writeText(element[options.textKey], options);
            case 'instruction':
                var instruction = {};
                instruction[element[options.nameKey]] = element[options.attributesKey] ? element : element[options.instructionKey];
                return xml + (options.indentInstruction ? indent : '') + $13492a8f410eb86a$var$writeInstruction(instruction, options, depth);
        }
    }, '');
}
function $13492a8f410eb86a$var$hasContentCompact(element, options, anyContent) {
    var key;
    for(key in element)if (element.hasOwnProperty(key)) switch(key){
        case options.parentKey:
        case options.attributesKey:
            break; // skip to next key
        case options.textKey:
            if (options.indentText || anyContent) return true;
            break; // skip to next key
        case options.cdataKey:
            if (options.indentCdata || anyContent) return true;
            break; // skip to next key
        case options.instructionKey:
            if (options.indentInstruction || anyContent) return true;
            break; // skip to next key
        case options.doctypeKey:
        case options.commentKey:
            return true;
        default:
            return true;
    }
    return false;
}
function $13492a8f410eb86a$var$writeElementCompact(element, name, options, depth, indent) {
    $13492a8f410eb86a$var$currentElement = element;
    $13492a8f410eb86a$var$currentElementName = name;
    var elementName = 'elementNameFn' in options ? options.elementNameFn(name, element) : name;
    if (typeof element === 'undefined' || element === null || element === '') return 'fullTagEmptyElementFn' in options && options.fullTagEmptyElementFn(name, element) || options.fullTagEmptyElement ? '<' + elementName + '></' + elementName + '>' : '<' + elementName + '/>';
    var xml = [];
    if (name) {
        xml.push('<' + elementName);
        if (typeof element !== 'object') {
            xml.push('>' + $13492a8f410eb86a$var$writeText(element, options) + '</' + elementName + '>');
            return xml.join('');
        }
        if (element[options.attributesKey]) xml.push($13492a8f410eb86a$var$writeAttributes(element[options.attributesKey], options, depth));
        var withClosingTag = $13492a8f410eb86a$var$hasContentCompact(element, options, true) || element[options.attributesKey] && element[options.attributesKey]['xml:space'] === 'preserve';
        if (!withClosingTag) {
            if ('fullTagEmptyElementFn' in options) withClosingTag = options.fullTagEmptyElementFn(name, element);
            else withClosingTag = options.fullTagEmptyElement;
        }
        if (withClosingTag) xml.push('>');
        else {
            xml.push('/>');
            return xml.join('');
        }
    }
    xml.push($13492a8f410eb86a$var$writeElementsCompact(element, options, depth + 1, false));
    $13492a8f410eb86a$var$currentElement = element;
    $13492a8f410eb86a$var$currentElementName = name;
    if (name) xml.push((indent ? $13492a8f410eb86a$var$writeIndentation(options, depth, false) : '') + '</' + elementName + '>');
    return xml.join('');
}
function $13492a8f410eb86a$var$writeElementsCompact(element, options, depth, firstLine) {
    var i, key, nodes, xml = [];
    for(key in element)if (element.hasOwnProperty(key)) {
        nodes = $13492a8f410eb86a$require$isArray(element[key]) ? element[key] : [
            element[key]
        ];
        for(i = 0; i < nodes.length; ++i){
            switch(key){
                case options.declarationKey:
                    xml.push($13492a8f410eb86a$var$writeDeclaration(nodes[i], options, depth));
                    break;
                case options.instructionKey:
                    xml.push((options.indentInstruction ? $13492a8f410eb86a$var$writeIndentation(options, depth, firstLine) : '') + $13492a8f410eb86a$var$writeInstruction(nodes[i], options, depth));
                    break;
                case options.attributesKey:
                case options.parentKey:
                    break; // skip
                case options.textKey:
                    xml.push((options.indentText ? $13492a8f410eb86a$var$writeIndentation(options, depth, firstLine) : '') + $13492a8f410eb86a$var$writeText(nodes[i], options));
                    break;
                case options.cdataKey:
                    xml.push((options.indentCdata ? $13492a8f410eb86a$var$writeIndentation(options, depth, firstLine) : '') + $13492a8f410eb86a$var$writeCdata(nodes[i], options));
                    break;
                case options.doctypeKey:
                    xml.push($13492a8f410eb86a$var$writeIndentation(options, depth, firstLine) + $13492a8f410eb86a$var$writeDoctype(nodes[i], options));
                    break;
                case options.commentKey:
                    xml.push($13492a8f410eb86a$var$writeIndentation(options, depth, firstLine) + $13492a8f410eb86a$var$writeComment(nodes[i], options));
                    break;
                default:
                    xml.push($13492a8f410eb86a$var$writeIndentation(options, depth, firstLine) + $13492a8f410eb86a$var$writeElementCompact(nodes[i], key, options, depth, $13492a8f410eb86a$var$hasContentCompact(nodes[i], options)));
            }
            firstLine = firstLine && !xml.length;
        }
    }
    return xml.join('');
}
$13492a8f410eb86a$exports = function(js, options) {
    options = $13492a8f410eb86a$var$validateOptions(options);
    var xml = [];
    $13492a8f410eb86a$var$currentElement = js;
    $13492a8f410eb86a$var$currentElementName = '_root_';
    if (options.compact) xml.push($13492a8f410eb86a$var$writeElementsCompact(js, options, 0, true));
    else {
        if (js[options.declarationKey]) xml.push($13492a8f410eb86a$var$writeDeclaration(js[options.declarationKey], options, 0));
        if (js[options.elementsKey] && js[options.elementsKey].length) xml.push($13492a8f410eb86a$var$writeElements(js[options.elementsKey], options, 0, !xml.length));
    }
    return xml.join('');
};


var $ddc34d7344eb48a6$exports = {};

var $lGjml = parcelRequire("lGjml");
var $ddc34d7344eb48a6$require$Buffer = $lGjml.Buffer;

$ddc34d7344eb48a6$exports = function(json, options) {
    if (json instanceof $ddc34d7344eb48a6$require$Buffer) json = json.toString();
    var js = null;
    if (typeof json === 'string') try {
        js = JSON.parse(json);
    } catch (e) {
        throw new Error('The JSON structure is invalid');
    }
    else js = json;
    return $13492a8f410eb86a$exports(js, options);
};


$6a124476dce670ed$exports = {
    xml2js: $6efd4bc11af435ee$exports,
    xml2json: $dd3d1dea81a85fab$exports,
    js2xml: $13492a8f410eb86a$exports,
    json2xml: $ddc34d7344eb48a6$exports
};


/// <reference types="node" />
var $13b1cf2afbe50b70$exports = {};
$13b1cf2afbe50b70$exports = JSON.parse("{\"apiKey\":\"AIzaSyDdo6CtBkirOqPd0XfT4mbWBDCn3N3QEhk\",\"authDomain\":\"automatarium-dev.firebaseapp.com\",\"projectId\":\"automatarium-dev\",\"storageBucket\":\"automatarium-dev.appspot.com\",\"messagingSenderId\":\"1007726941830\",\"appId\":\"1:1007726941830:web:d4ee6a5d56853d1b4f6307\"}");


const $d59e810d2f517544$var$COLORS = {
    red: {
        h: 0,
        s: 63,
        l: 48
    },
    orange: {
        h: 38,
        s: 84,
        l: 50
    },
    green: {
        h: 111,
        s: 52,
        l: 45
    },
    teal: {
        h: 173,
        s: 100,
        l: 34
    },
    blue: {
        h: 201,
        s: 98,
        l: 41
    },
    purple: {
        h: 262,
        s: 60,
        l: 48
    },
    pink: {
        h: 316,
        s: 70,
        l: 43
    }
};
var $d59e810d2f517544$export$2e2bcd8739ae039 = $d59e810d2f517544$var$COLORS;


var $8f13b60c0ee5b277$exports = {};
$8f13b60c0ee5b277$exports = JSON.parse("{\"name\":\"frontend\",\"version\":\"1.0.0\",\"schemaVersion\":\"1.0.0\",\"type\":\"module\",\"private\":true,\"scripts\":{\"start\":\"yarn prebuild && parcel public/index.html --no-cache\",\"copy:locales\":\"cp -r public/locales dist\",\"prebuild\":\"rm -rf dist && mkdir dist && yarn copy:locales && cp public/ping.txt dist/\",\"build\":\"yarn prebuild && parcel build public/index.html --public-url ./ && yarn postbuild\",\"postbuild\":\"yarn tsx build-sw.ts\",\"serve\":\"serve dist -l 3000\",\"check:types\":\"tsc --noemit\"},\"dependencies\":{\"@automatarium/jflap-translator\":\"1.0.0\",\"@automatarium/simulation\":\"2.0.0\",\"@eslint/eslintrc\":\"^3.3.1\",\"@eslint/js\":\"^9.28.0\",\"@msgpack/msgpack\":\"^2.8.0\",\"@parcel/transformer-typescript-types\":\"^2.15.2\",\"axios\":\"^0.30.0\",\"csstype\":\"^3.1.3\",\"dayjs\":\"^1.11.13\",\"globals\":\"^16.2.0\",\"goober\":\"^2.1.16\",\"i18next\":\"^23.16.8\",\"i18next-http-backend\":\"^3.0.2\",\"immer\":\"^9.0.21\",\"lodash.clonedeep\":\"^4.5.0\",\"lodash.groupby\":\"^4.6.0\",\"lucide-react\":\"^0.515.0\",\"prop-types\":\"^15.8.1\",\"react\":\"^17.0.2\",\"react-a11y-dialog\":\"^6.2.0\",\"react-dom\":\"^17.0.2\",\"react-hook-form\":\"^7.57.0\",\"react-i18next\":\"^14.1.3\",\"react-lottie-player\":\"^2.1.0\",\"react-markdown\":\"^8.0.7\",\"react-resizable\":\"^3.0.5\",\"react-router-dom\":\"^6.30.1\",\"typescript\":\"^4.9.5\",\"workbox-precaching\":\"^7.3.0\",\"zustand\":\"^4.5.7\"},\"devDependencies\":{\"@parcel/packager-raw-url\":\"2.16.0\",\"@parcel/transformer-inline-string\":\"^2.15.2\",\"@parcel/transformer-webmanifest\":\"2.16.0\",\"@types/lodash.groupby\":\"^4.6.9\",\"@types/node\":\"^20.19.0\",\"@types/react\":\"^18.3.23\",\"assert\":\"^2.1.0\",\"browserify-zlib\":\"^0.2.0\",\"buffer\":\"^6.0.3\",\"events\":\"^3.3.0\",\"glob\":\"^11.0.3\",\"parcel\":\"^2.15.2\",\"process\":\"^0.11.10\",\"serve\":\"^14.2.4\",\"stream-browserify\":\"^3.0.0\",\"tsx\":\"^4.20.6\",\"util\":\"^0.12.5\",\"workbox-build\":\"^7.3.0\"}}");


const $09ff7c1d5f0c0758$export$3167453beff01750 = (0, (/*@__PURE__*/$parcel$interopDefault($8f13b60c0ee5b277$exports))).schemaVersion;
const $09ff7c1d5f0c0758$export$8ee1df3c6367a60 = (0, (/*@__PURE__*/$parcel$interopDefault($8f13b60c0ee5b277$exports))).version;
const $09ff7c1d5f0c0758$export$3609f80921b12b4b = 'FSA';
const $09ff7c1d5f0c0758$export$84ea809ec961cd1 = 'q';
const $09ff7c1d5f0c0758$export$6a13b8d132417b20 = '|';
const $09ff7c1d5f0c0758$export$951617dc07b67a12 = 'both';
const $09ff7c1d5f0c0758$export$63642992e287c571 = {
    FSA: 'orange',
    PDA: 'red',
    TM: 'purple'
};


const $bc8beea5b4cede8b$var$env = "production";
const $bc8beea5b4cede8b$var$config = {
    development: {
        baseUrl: 'http://localhost:1234',
        API: 'http://localhost:3001',
        documentTitle: '[Dev] Automatarium',
        firebaseConfig: (0, (/*@__PURE__*/$parcel$interopDefault($13b1cf2afbe50b70$exports)))
    },
    production: {
        baseUrl: 'https://automatarium.tdib.xyz',
        API: 'https://api.automatarium.tdib.xyz',
        documentTitle: 'Automatarium',
        firebaseConfig: (0, (/*@__PURE__*/$parcel$interopDefault($13b1cf2afbe50b70$exports)))
    }
};
var $bc8beea5b4cede8b$export$2e2bcd8739ae039 = $bc8beea5b4cede8b$var$config[$bc8beea5b4cede8b$var$env];


function $be180ebd7a95f287$export$804de46662e4ac95(value) {}


const $fc69c1d2a2a16816$var$PROJECT_TYPE_MAP = {
    fa: 'FSA',
    pda: 'PDA',
    turing: 'TM'
};
const $fc69c1d2a2a16816$export$3f7dcd42a14cc9f5 = (xml)=>{
    const jflapProject = (0, $6a124476dce670ed$exports.xml2js)(xml, {
        compact: true,
        ignoreComment: true,
        ignoreDeclaration: true
    });
    return $fc69c1d2a2a16816$export$3300b2141975042a(jflapProject);
};
const $fc69c1d2a2a16816$export$3300b2141975042a = (jflapProject)=>{
    // Pull out necessary values from jflap project
    let { structure: { type: type, automaton: { state: states, transition: transitions, note: notes } } } = jflapProject;
    const projectType = $fc69c1d2a2a16816$var$PROJECT_TYPE_MAP[type._text];
    // Check if format is unsupported
    if (!Object.keys($fc69c1d2a2a16816$var$PROJECT_TYPE_MAP).includes(type._text)) throw new Error(`Unsupported JFLAP project type "${type._text}"!`);
    // Convert attributes to arrays if they are not already
    const toArray = (x)=>x === undefined ? [] : Array.isArray(x) ? x : [
            x
        ];
    states = toArray(states);
    transitions = toArray(transitions);
    notes = toArray(notes);
    // Find initial state
    const initialState = states.find((s)=>s.initial);
    const initialStateID = Number(initialState._attributes.id);
    // Convert states
    const automatariumStates = states.map((state)=>({
            id: Number(state._attributes.id),
            name: state._attributes.name,
            label: state.label ? state.label._text : '',
            x: Number(state.x._text),
            y: Number(state.y._text),
            isFinal: state.final !== undefined
        }));
    // Convert transitions
    const automatariumTransitions = transitions.map((transition, idx)=>{
        const trans = {
            id: idx,
            from: Number(transition.from._text),
            to: Number(transition.to._text),
            read: transition.read._text ? transition.read._text : ''
        };
        // Add any extra fields if needed
        if (projectType === 'PDA') {
            (0, $be180ebd7a95f287$export$804de46662e4ac95)(trans);
            // Copy is needed to please type checker
            trans.push = transition.push._text ?? '';
            trans.pop = transition.pop._text ?? '';
            // We don't support multi character input at the moment
            if (trans.push.length > 1 || trans.pop.length > 1) throw new Error("Automatarium doesn't support multi character input");
        } else if (projectType === 'TM') {
            (0, $be180ebd7a95f287$export$804de46662e4ac95)(trans);
            trans.write = transition.write._text ?? '';
            trans.direction = transition.move._text ?? '';
        }
        return trans;
    });
    // Convert comments
    const automatariumComments = notes.map((note, idx)=>({
            id: idx,
            text: note.text._text,
            x: Number(note.x._text),
            y: Number(note.y._text)
        }));
    return {
        _id: crypto.randomUUID(),
        config: {
            type: projectType,
            statePrefix: (0, $09ff7c1d5f0c0758$export$84ea809ec961cd1),
            color: (0, $09ff7c1d5f0c0758$export$63642992e287c571)[projectType],
            orOperator: (0, $09ff7c1d5f0c0758$export$6a13b8d132417b20),
            acceptanceCriteria: projectType === 'PDA' ? (0, $09ff7c1d5f0c0758$export$951617dc07b67a12) : undefined
        },
        meta: {
            name: '',
            dateCreated: new Date().getTime(),
            dateEdited: new Date().getTime(),
            version: (0, $09ff7c1d5f0c0758$export$3167453beff01750),
            automatariumVersion: (0, $09ff7c1d5f0c0758$export$8ee1df3c6367a60)
        },
        projectType: projectType,
        simResult: [],
        tests: {
            batch: [
                ''
            ],
            single: ''
        },
        initialState: initialStateID,
        states: automatariumStates,
        transitions: automatariumTransitions,
        comments: automatariumComments
    };
};



class $cb912592ed19a590$var$Collection {
    isEmpty() {
        return this.items.length === 0;
    }
    size() {
        return this.items.length;
    }
    clear() {
        this.items = [];
    }
    constructor(){
        this.items = [];
    }
}
class $cb912592ed19a590$export$3dc07afe418952bc extends $cb912592ed19a590$var$Collection {
    add(item) {
        this.items.push(item);
    }
    remove() {
        return this.items.shift();
    }
    peek() {
        return this.items[0];
    }
}
class $cb912592ed19a590$export$694e0d28c7ffc90c extends $cb912592ed19a590$var$Collection {
    add(item) {
        this.items.push(item);
    }
    remove() {
        return this.items.pop();
    }
    peek() {
        return this.items[this.items.length - 1];
    }
}


const $a2164468561efe4a$export$bc48d40a3b6f6f4b = (graph)=>{
    const frontier = new (0, $cb912592ed19a590$export$3dc07afe418952bc)();
    const reached = new Map();
    let node = graph.initial;
    frontier.add(node);
    reached.set(node.state.key(), node);
    while(!frontier.isEmpty()){
        // Bang is necessary because TS doesn't understand that the frontier is not empty here
        node = frontier.remove();
        if (graph.isFinalState(node)) return node;
        for (const successor of graph.getSuccessors(node))if (!reached.has(successor.state.key())) {
            frontier.add(successor);
            reached.set(successor.state.key(), successor);
        }
    }
    return node;
};
const $a2164468561efe4a$export$98a1d510892e5419 = (graph)=>{
    const frontier = new (0, $cb912592ed19a590$export$3dc07afe418952bc)();
    const reached = new Map();
    let node = graph.initial;
    frontier.add(node);
    reached.set(node.state.key(), node);
    while(!frontier.isEmpty()){
        // Bang is necessary because TS doesn't understand that the frontier is not empty here
        node = frontier.remove();
        for (const successor of graph.getSuccessors(node))if (!reached.has(successor.state.key())) {
            frontier.add(successor);
            reached.set(successor.state.key(), successor);
        }
    }
    return node;
};


const $daf601bb5fd2cd59$var$RANGE_REG = /\[(\w-\w)]/g;
const $daf601bb5fd2cd59$var$LITERAL_REG = /\S/;
const $daf601bb5fd2cd59$export$e92f54924d78e6ed = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
/**
 * Create an array of characters in between the two characters. Uses 0-9a-zA-Z ordering.
 *
 * @param start - Character used as start of range
 * @param stop - Character used as end of range
 * @returns Array of characters in range. Includes the start and stop characters.
 *
 * @example Create list of all digit characters
 * ```ts
 * const digits = makeCharRange('0', '9')
 * ```
 *
 * @example Create list of all lowercase and uppercase letters
 * ```ts
 * const letters = makeCharRange('a', 'Z')
 * ```
 *
 * @internal
 */ const $daf601bb5fd2cd59$var$makeCharRange = (start, stop)=>{
    const startChar = $daf601bb5fd2cd59$export$e92f54924d78e6ed.indexOf(start);
    const stopChar = $daf601bb5fd2cd59$export$e92f54924d78e6ed.indexOf(stop);
    return Array.from({
        length: stopChar - startChar + 1
    }).map((_, i)=>$daf601bb5fd2cd59$export$e92f54924d78e6ed[startChar + i]);
};
const $daf601bb5fd2cd59$export$3d937f95c796e6d6 = (read)=>{
    // Find ranges
    const rangeStrings = read.match($daf601bb5fd2cd59$var$RANGE_REG) ?? [];
    read = read.replace($daf601bb5fd2cd59$var$RANGE_REG, '');
    const ranges = rangeStrings.map((str)=>{
        const [start, stop] = str.split('-');
        return $daf601bb5fd2cd59$var$makeCharRange(start.slice(1), stop.slice(0, -1));
    });
    const rangeSymbols = ranges.reduce((acc, v)=>[
            ...acc,
            ...v
        ], []);
    // Find literals
    const symbols = read.split('').filter((s)=>$daf601bb5fd2cd59$var$LITERAL_REG.test(s));
    if (read.includes('!')) // Don't sort if there is an exclusion operator present
    return Array.from(new Set([
        ...symbols,
        ...rangeSymbols
    ])).join('');
    else return Array.from(new Set([
        ...symbols,
        ...rangeSymbols
    ])).sort().join('');
};


class $ce181ead39041575$export$7254cc27399e90bd {
    constructor(id, isFinal){
        this.id = id;
        this.isFinal = isFinal;
    }
}
class $ce181ead39041575$export$85c928794f8d04d4 {
    constructor(state, parent = null){
        this.state = state;
        this.parent = parent;
        this.depth = parent ? parent.depth + 1 : 0;
    }
}
class $ce181ead39041575$export$614db49f3febe941 {
    constructor(initial, states, transitions){
        this.initial = initial;
        this.states = states;
        this.transitions = transitions;
    }
}




const $7431f94c7ac0c9a7$var$EXCL_PARENTHESES_REG = /!\(([^&)]+&)+[^&)]+\)/g;
const $7431f94c7ac0c9a7$var$RANGE_REG = /\[(.*?)]/g;
const $7431f94c7ac0c9a7$var$SPLIT_CHAR_REG = /(\[.*?])|(![^ ]+)|([^! ])/g;
const $7431f94c7ac0c9a7$var$SYMBOLS_TO_EXCLUDE_REG = /(!\.)|(!\(([^&)]+&)*[^&)]*\))|(!\[[^\]]+\])|(![^()[\]]+)|!\(|!\[/g;
const $7431f94c7ac0c9a7$export$193046f9d1fa1ed1 = (input, orOperator)=>{
    // If there are any exclusion operators proceeded by anything, only that expression is returned
    const exclusion = $7431f94c7ac0c9a7$export$8d4e623ea79b9f83(input);
    if (exclusion) return exclusion;
    const [inputWithoutRanges, ranges] = $7431f94c7ac0c9a7$export$45af6fbea5f7bc2f(input);
    input = $7431f94c7ac0c9a7$export$2903f02042bf33f2(inputWithoutRanges);
    input = $7431f94c7ac0c9a7$export$e1dbea7bde5280ad(input, orOperator);
    input = $7431f94c7ac0c9a7$export$7b45e27c0253a60(input);
    return `${input}${ranges.join('')}`;
};
const $7431f94c7ac0c9a7$export$8b9d5f9a071daa33 = (text, orOperator = '|')=>{
    if (!text) return text;
    return $7431f94c7ac0c9a7$export$28bc762bb8d549bb($7431f94c7ac0c9a7$export$f060a421894da09a(text, orOperator));
};
const $7431f94c7ac0c9a7$export$f060a421894da09a = (text, orOperator)=>{
    if (text.length <= 1) return text;
    const joinStr = orOperator !== ' ' ? ` ${orOperator} ` : ' ';
    const parts = text.match($7431f94c7ac0c9a7$var$SPLIT_CHAR_REG) || [];
    return parts.join(joinStr);
};
const $7431f94c7ac0c9a7$export$28bc762bb8d549bb = (input)=>{
    const matches = input.match($7431f94c7ac0c9a7$var$EXCL_PARENTHESES_REG);
    if (!matches) return input;
    for (const match of matches){
        const formattedMatch = match.replace(/&/g, ' & ');
        input = input.replace(match, formattedMatch);
    }
    return input;
};
const $7431f94c7ac0c9a7$export$8c577b12ee95f830 = (input)=>{
    const matches = input.match($7431f94c7ac0c9a7$var$SYMBOLS_TO_EXCLUDE_REG) || [];
    return matches.flatMap((match)=>{
        if (match.startsWith('!(')) {
            if (match === '!(') return [
                '('
            ];
            return match.slice(2, -1).split('&').flatMap((s)=>s.length > 1 ? s.split('') : s);
        } else if (match.startsWith('![')) return (0, $daf601bb5fd2cd59$export$3d937f95c796e6d6)(match.slice(1)).split('');
        else if (match.startsWith('!')) return match.slice(1).split('');
        return [];
    });
};
const $7431f94c7ac0c9a7$export$2903f02042bf33f2 = (input)=>{
    return input.replace(/\s+/g, '');
};
const $7431f94c7ac0c9a7$export$e1dbea7bde5280ad = (input, orOperator)=>{
    for (const op of $7431f94c7ac0c9a7$export$ee21342480424ca8(orOperator))input = input.split(op).join('');
    return input;
};
const $7431f94c7ac0c9a7$export$7b45e27c0253a60 = (input)=>{
    return Array.from(new Set(input.split(''))).join('');
};
const $7431f94c7ac0c9a7$export$45af6fbea5f7bc2f = (input)=>{
    const ranges = input.match($7431f94c7ac0c9a7$var$RANGE_REG) || [];
    input = input.replace($7431f94c7ac0c9a7$var$RANGE_REG, '');
    return [
        input,
        ranges
    ];
};
const $7431f94c7ac0c9a7$export$8d4e623ea79b9f83 = (input)=>{
    // Matches the different types of exclusions, e.g. !(a&b), ![a-c], !a
    const exclamationWithParentheses = input.match($7431f94c7ac0c9a7$var$EXCL_PARENTHESES_REG);
    const exclamationWithRange = input.match(/!\[[^\]]+]/);
    const singleExclamation = input.match(/!./);
    const handleParenthesesExclusion = (match)=>{
        // Check if the pattern inside parentheses adheres to single characters separated by &
        const content = match[0].slice(2, -1).split('&').map((p)=>p.trim());
        return content.every((part)=>part.length === 1) ? `!(${content.join('&')})` : '!(';
    };
    // Check and handle each exclusion type
    if (exclamationWithParentheses) return handleParenthesesExclusion(exclamationWithParentheses);
    else if (exclamationWithRange) return exclamationWithRange[0];
    else if (singleExclamation) return singleExclamation[0] === '!!' ? '!' : `!${singleExclamation[0][1]}`;
    return null;
};
const $7431f94c7ac0c9a7$export$ee21342480424ca8 = (orOperator)=>{
    switch(orOperator){
        case '+':
        case "\uFF0B":
            return [
                '+',
                "\uFF0B"
            ];
        case "\u2223":
        case '|':
            return [
                "\u2223",
                '|'
            ];
        case "\u2225":
        case '||':
        case "\u2223\u2223":
            return [
                "\u2225",
                '||',
                "\u2223\u2223"
            ];
        case "\u2228":
        case 'v':
        case 'V':
            return [
                "\u2228",
                'v',
                'V'
            ];
        case ' ':
        case '':
        case '  ':
            return [
                ' ',
                '',
                '  '
            ];
        default:
            return [
                orOperator
            ];
    }
};


class $63be718836364bba$export$ce739041b2375d0 extends (0, $ce181ead39041575$export$7254cc27399e90bd) {
    constructor(id, isFinal, read = null, remaining = '', stack = [], pop = '', push = ''){
        super(id, isFinal), this.read = read, this.remaining = remaining, this.stack = stack, this.pop = pop, this.push = push;
    }
    key() {
        return [
            this.remaining,
            this.id,
            this.stack.join('')
        ].join("_");
    }
    toTransitionString() {
        // TODO find better place to put function
        const formatSymbol = (char)=>char === null || char === '' ? "\u03BB" : char;
        return `${formatSymbol(this.read)},${formatSymbol(this.pop)};${formatSymbol(this.push)}`;
    }
}
class $63be718836364bba$export$fb4f3c32c115192a extends (0, $ce181ead39041575$export$614db49f3febe941) {
    isFinalState(node) {
        return node.state.isFinal && node.state.remaining.length === 0 && node.state.stack.length === 0;
    }
    getSuccessors(node) {
        const transitions = this.transitions.filter((transition)=>transition.from === node.state.id);
        const successors = [];
        for (const transition of transitions){
            const nextState = this.states.find((state)=>state.id === transition.to);
            let invalidPop = false;
            const lambdaTransition = transition.read.length === 0;
            const symbol = node.state.remaining[0];
            // Get any symbols preceded by an exclusion operator
            const symbolsToExclude = (0, $7431f94c7ac0c9a7$export$8c577b12ee95f830)(transition.read);
            const pop = transition.pop;
            const push = transition.push;
            // If there is no next state
            if (nextState === undefined || !lambdaTransition && !transition.read.includes(symbol) && symbolsToExclude.length === 0 || !lambdaTransition && symbolsToExclude.length > 0 && symbolsToExclude.includes(symbol)) continue;
            // Check valid stack operations
            const nodeStack = node.state.stack.slice() // the stack carries forward to each node
            ;
            // Handle pop symbol first
            if (pop !== '') {
                // Pop if symbol matches top of stack
                if (pop === nodeStack[nodeStack.length - 1]) nodeStack.pop();
                else if (nodeStack.length === 0) // Else operation is invalid
                // Empty stack case
                invalidPop = true;
                else if (pop !== nodeStack[nodeStack.length - 1]) // Non-matching symbol case
                invalidPop = true;
            }
            // Handle push symbol if it exists
            if (push !== '') nodeStack.push(push);
            // If stack operations were valid, add the successor
            if (!invalidPop) {
                const graphState = new $63be718836364bba$export$ce739041b2375d0(nextState.id, nextState.isFinal, lambdaTransition ? '' : symbol, lambdaTransition ? node.state.remaining : node.state.remaining.slice(1), nodeStack, pop, push);
                const successor = new (0, $ce181ead39041575$export$85c928794f8d04d4)(graphState, node);
                successors.push(successor);
            }
        }
        return successors;
    }
}




class $1b693f7a7a9a02af$export$cd21d08b01560c2d extends (0, $ce181ead39041575$export$7254cc27399e90bd) {
    constructor(id, isFinal, read = null, remaining = ''){
        super(id, isFinal), this.read = read, this.remaining = remaining;
    }
    key() {
        return [
            this.id,
            this.remaining
        ].join("_");
    }
    toTransitionString() {
        // TODO find better place to put function
        const formatSymbol = (char)=>char === null || char === '' ? "\u03BB" : char;
        return `${formatSymbol(this.read)}`;
    }
}
class $1b693f7a7a9a02af$export$c5de5368b4b7011d extends (0, $ce181ead39041575$export$614db49f3febe941) {
    isFinalState(node) {
        return node.state.isFinal && node.state.remaining.length === 0;
    }
    getSuccessors(node) {
        const transitions = this.transitions.filter((transition)=>transition.from === node.state.id);
        const successors = [];
        for (const transition of transitions){
            const nextState = this.states.find((state)=>state.id === transition.to);
            const lambdaTransition = transition.read.length === 0;
            const symbol = node.state.remaining[0];
            // Get any symbols preceded by an exclusion operator
            const symbolsToExclude = (0, $7431f94c7ac0c9a7$export$8c577b12ee95f830)(transition.read);
            if (nextState === undefined || !lambdaTransition && !transition.read.includes(symbol) && symbolsToExclude.length === 0 || !lambdaTransition && symbolsToExclude.length > 0 && symbolsToExclude.includes(symbol)) continue;
            const graphState = new $1b693f7a7a9a02af$export$cd21d08b01560c2d(nextState.id, nextState.isFinal, lambdaTransition ? '' : symbol, lambdaTransition ? node.state.remaining : node.state.remaining.slice(1));
            const successor = new (0, $ce181ead39041575$export$85c928794f8d04d4)(graphState, node);
            successors.push(successor);
        }
        return successors;
    }
}




class $208bec1398813a04$export$fda3015c34001716 extends (0, $ce181ead39041575$export$7254cc27399e90bd) {
    constructor(id, isFinal, tape, direction = null, read = null, write = null){
        super(id, isFinal), this.tape = tape, this.direction = direction, this.read = read, this.write = write;
    }
    key() {
        const traceAdd = this.tape.trace.toString() ?? '';
        return [
            this.id,
            this.tape.pointer,
            traceAdd
        ].join("_");
    }
    toTransitionString() {
        // TODO find better place to put function
        const formatSymbol = (char)=>char === null || char === '' ? "\u03BB" : char;
        return `${formatSymbol(this.read)},${formatSymbol(this.write)};${formatSymbol(this.direction)}`;
    }
}
class $208bec1398813a04$export$383d594f25f6bf8e extends (0, $ce181ead39041575$export$614db49f3febe941) {
    isFinalState(node) {
        return node.state.isFinal;
    }
    getSuccessors(node) {
        const transitions = this.transitions.filter((transition)=>transition.from === node.state.id);
        const successors = [];
        for (const transition of transitions){
            const nextState = this.states.find((state)=>state.id === transition.to);
            const tapePointer = node.state.tape.pointer;
            const tapeTrace = node.state.tape.trace;
            const lambdaTransitionRead = transition.read.length === 0;
            const lambdaTransitionWrite = transition.write.length === 0;
            // Undefined means its out of tape bounds, so we treat that has a lambda transition
            const symbol = tapeTrace[tapePointer] ?? '';
            const writeSymbol = transition.write ?? '';
            let nextTape = this.progressTape(node, transition);
            // Get any symbols preceded by an exclusion operator
            const symbolsToExclude = (0, $7431f94c7ac0c9a7$export$8c577b12ee95f830)(transition.read);
            // If there is no next state
            if (nextState === undefined || symbolsToExclude.length === 0 && !transition.read.includes(symbol) || symbolsToExclude.length > 0 && symbolsToExclude.includes(symbol)) continue;
            // Add a lambda on the tape to the start of the known tape
            if (nextTape.pointer < 0) nextTape = {
                pointer: 0,
                trace: [
                    '',
                    ...nextTape.trace
                ]
            };
            // Progress when the transition's read matches the symbol exactly
            // If it doesn't, progress only if the symbol is non-empty and contained within the read
            if (symbolsToExclude.length > 0 && !symbolsToExclude.includes(symbol) || transition.read === symbol || symbol.length > 0 && transition.read.includes(symbol)) {
                const graphState = new $208bec1398813a04$export$fda3015c34001716(nextState.id, nextState.isFinal, nextTape, transition.direction, lambdaTransitionRead ? '' : symbol, lambdaTransitionWrite ? '' : writeSymbol);
                const successor = new (0, $ce181ead39041575$export$85c928794f8d04d4)(graphState, node);
                successors.push(successor);
            }
        }
        return successors;
    }
    progressTape(node, transition) {
        const tapeTrace = node.state.tape.trace;
        const write = transition.write;
        const direction = transition.direction;
        let newTapePointer = structuredClone(node.state.tape.pointer);
        const newTapeTrace = structuredClone(tapeTrace);
        // Direction input handled to only be uppercase
        if (direction === 'L') newTapePointer--;
        else if (direction === 'R') newTapePointer++;
        newTapeTrace[node.state.tape.pointer] = write;
        const newTape = {
            pointer: newTapePointer,
            trace: newTapeTrace
        };
        return newTape;
    }
}


class $f0c60b702340507d$export$b32e6f1361e7 {
    constructor(graph, frontier = [
        graph.initial
    ]){
        this.graph = graph;
        this.frontier = frontier;
    }
    forward() {
        const frontierCopy = this.frontier.slice();
        this.frontier = [];
        while(frontierCopy.length > 0){
            const node = frontierCopy.shift();
            for (const successor of this.graph.getSuccessors(node))this.frontier.push(successor);
        }
        return this.frontier;
    }
    backward() {
        if (this.frontier.length === 1 && this.frontier[0].state.key() === this.graph.initial.state.key()) // This is the root node!
        return this.frontier;
        const previousFrontier = [];
        this.frontier.forEach((node)=>{
            if (node.parent && !this.checkForDuplicate(node.parent, previousFrontier)) previousFrontier.push(node.parent);
        });
        this.frontier = previousFrontier;
        return this.frontier;
    }
    checkForDuplicate(node, frontier) {
        return frontier.some((n)=>n.state.key() === node.state.key());
    }
    reset() {
        this.frontier = [
            this.graph.initial
        ];
        return this.frontier;
    }
    canMoveForward() {
        return this.frontier.some((node)=>this.graph.getSuccessors(node).length > 0);
    }
    canMoveBackward() {
        return this.frontier.some((node)=>!!node.parent);
    }
}


const $5277478820e2de90$export$21fb9b44b8827669 = (transitions)=>{
    return transitions.map((t)=>{
        if (t.read && t.read.startsWith('!') && t.read.length > 1) // Skip expansion for exclusion inputs
        return t;
        // Otherwise, proceed with the expansion
        return {
            ...t,
            read: (0, $daf601bb5fd2cd59$export$3d937f95c796e6d6)(t.read ?? '')
        };
    });
};
const $5277478820e2de90$export$b0cf2cc1a1ad8060 = (graph)=>{
    return {
        ...graph,
        transitions: $5277478820e2de90$export$21fb9b44b8827669(graph.transitions)
    };
};
const $5277478820e2de90$export$5b5bceafdcebea8b = (graph)=>{
    return graph.states.find((state)=>state.id === graph.initialState);
};
const $5277478820e2de90$export$3bf8493817698f1a = (input)=>({
        pointer: 0,
        trace: input ? input.split('') : [
            ''
        ]
    });
function $5277478820e2de90$export$af6c7e103af557ec(graph, input) {
    let StateType;
    let GraphType;
    // Find which constructor is needed.
    // Due to typescript weirdness this needs to be done like this (Hopefully can be changed in future)
    switch(graph.projectType){
        case 'FSA':
            StateType = (0, $1b693f7a7a9a02af$export$cd21d08b01560c2d);
            GraphType = (0, $1b693f7a7a9a02af$export$c5de5368b4b7011d);
            break;
        case 'PDA':
            StateType = (0, $63be718836364bba$export$ce739041b2375d0);
            GraphType = (0, $63be718836364bba$export$fb4f3c32c115192a);
            break;
        case 'TM':
            StateType = (0, $208bec1398813a04$export$fda3015c34001716);
            GraphType = (0, $208bec1398813a04$export$383d594f25f6bf8e);
            break;
    }
    const initialState = graph.states.find((s)=>s.id === graph.initialState);
    if (!initialState) return null;
    const initialNode = new (0, $ce181ead39041575$export$85c928794f8d04d4)(graph.projectType === 'TM' ? new (0, $208bec1398813a04$export$fda3015c34001716)(initialState.id, initialState.isFinal, $5277478820e2de90$export$3bf8493817698f1a(input)) : new StateType(initialState.id, initialState.isFinal, null, input));
    const states = graph.states.map((state)=>new StateType(state.id, state.isFinal));
    return new GraphType(initialNode, states, $5277478820e2de90$export$21fb9b44b8827669(graph.transitions));
}
const $5277478820e2de90$export$191dfa0423971949 = (graph, input)=>{
    const problem = $5277478820e2de90$export$af6c7e103af557ec(graph, input);
    if (!problem) return null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new (0, $f0c60b702340507d$export$b32e6f1361e7)(problem);
};


const $23cb935ba1678867$export$ba5c464ccdc9b6f = (node)=>{
    const trace = [];
    while(node.parent){
        trace.push({
            to: node.state.id,
            read: node.state.read
        });
        node = node.parent;
    }
    trace.push({
        to: node.state.id,
        read: null
    });
    return trace.reverse();
};
const $23cb935ba1678867$export$586e59fed64dc8e4 = (graph, input)=>{
    const problem = (0, $5277478820e2de90$export$af6c7e103af557ec)(graph, input);
    if (!problem) return {
        accepted: false,
        remaining: input,
        trace: []
    };
    const result = (0, $a2164468561efe4a$export$bc48d40a3b6f6f4b)(problem);
    if (!result) return {
        trace: [
            {
                to: 0,
                read: null
            }
        ],
        accepted: false,
        remaining: input
    };
    return {
        accepted: result.state.isFinal && result.state.remaining === '',
        remaining: result.state.remaining,
        trace: $23cb935ba1678867$export$ba5c464ccdc9b6f(result)
    };
};




const $09ed7afcc0cd3b10$export$ba5c464ccdc9b6f = (node)=>{
    const trace = [];
    while(node.parent){
        trace.push({
            to: node.state.id,
            read: node.state.read,
            pop: node.state.pop,
            push: node.state.push,
            currentStack: [],
            invalidPop: false
        });
        node = node.parent;
    }
    trace.push({
        to: node.state.id,
        read: null,
        pop: '',
        push: '',
        currentStack: [],
        invalidPop: false
    });
    return trace.reverse();
};
const $09ed7afcc0cd3b10$export$4a0f002607da29ea = (trace)=>{
    const tempStack = [];
    for(let i = 0; i < trace.length; i++){
        // Handle pop symbol first
        if (trace[i].pop !== '') {
            // Pop if symbol matches top of stack
            if (trace[i].pop === tempStack[tempStack.length - 1]) tempStack.pop();
            else if (tempStack.length === 0) // Else operation is invalid
            // Empty stack case
            // Consider providing feedback to user during the trace
            trace[i].invalidPop = true;
            else if (trace[i].pop !== tempStack[tempStack.length - 1]) // Non-matching symbol case
            // Consider providing feedback to user during the trace
            trace[i].invalidPop = true;
        }
        // Handle push symbol if it exists
        if (trace[i].push !== '') tempStack.push(trace[i].push);
        trace[i].currentStack = JSON.parse(JSON.stringify(tempStack));
    }
    return tempStack;
};
const $09ed7afcc0cd3b10$export$5da7e2d746a88cec = (graph, input)=>{
    const problem = (0, $5277478820e2de90$export$af6c7e103af557ec)(graph, input);
    if (!problem) return {
        accepted: false,
        remaining: input,
        trace: [],
        stack: []
    };
    const result = (0, $a2164468561efe4a$export$bc48d40a3b6f6f4b)(problem);
    if (!result) return {
        trace: [
            {
                to: 0,
                read: null,
                pop: '',
                push: '',
                currentStack: [],
                invalidPop: false
            }
        ],
        accepted: false,
        remaining: input,
        stack: []
    };
    const trace = $09ed7afcc0cd3b10$export$ba5c464ccdc9b6f(result);
    const stack = $09ed7afcc0cd3b10$export$4a0f002607da29ea(trace);
    return {
        accepted: result.state.isFinal && result.state.remaining === '' && stack.length === 0,
        remaining: result.state.remaining,
        trace: trace,
        stack: stack
    };
};


const $744f32c7b11f678d$export$da171dcc955f709b = (graph, currentStateID, predicate)=>{
    const closed = [];
    const open = graph.transitions.filter((tr)=>tr.from === currentStateID && predicate(tr)).map((transition)=>({
            transition: transition,
            parents: []
        }));
    // Perform flood fill until fully discovered
    while(open.length > 0){
        // Pop next value to check
        const node = open.pop();
        closed.push(node);
        // Add neighbouring transitions
        for (const neighbour of graph.transitions.filter((tr)=>tr.from === node.transition.to && predicate(tr)))if (![
            ...closed,
            ...open
        ].map(({ transition: transition })=>transition.id).includes(neighbour.id)) // Add neighbour to open set and record the path to it in parents
        open.push({
            transition: neighbour,
            parents: [
                ...node.parents,
                node.transition
            ]
        });
    }
    return new Set(closed.map((node)=>({
            state: node.transition.to,
            transitions: [
                ...node.parents,
                node.transition
            ]
        })));
};
var $744f32c7b11f678d$export$2e2bcd8739ae039 = $744f32c7b11f678d$export$da171dcc955f709b;





const $aefca3fec3d879d9$export$fed428813706893a = (graph, currentStateID, nextRead)=>{
    // Compute lambda closure (states accessible without consuming input)
    const closure = Array.from((0, $744f32c7b11f678d$export$2e2bcd8739ae039)(graph, currentStateID, (tr)=>tr.read.length === 0));
    // Find direct non-lambda transitions
    const directTransitions = graph.transitions.filter((transition)=>transition.from === currentStateID && transition.read.includes(nextRead)).map((transition)=>({
            transition: transition,
            trace: []
        }));
    // Find transitions from states in lambda closure that we can take
    const indirectTransitions = closure.map(({ state: state, transitions: transitions })=>graph.transitions.filter((transition)=>transition.from === state && transition.read.includes(nextRead)).map((transition)=>({
                transition: transition,
                trace: transitions
            }))).reduce((a, b)=>[
            ...a,
            ...b
        ], []);
    // Find transitions to final states in lambda closure
    const finalTransitions = closure.filter(({ state: state })=>graph.states.some((s)=>s.id === state && s.id !== currentStateID && s.isFinal)).map(({ state: state, transitions: transitions })=>({
            transition: graph.transitions.find((tr)=>tr.to === state && tr.read.length === 0),
            trace: transitions.slice(0, -1)
        }));
    // Combine transitions
    const allTransitions = [
        ...directTransitions,
        ...indirectTransitions,
        ...finalTransitions
    ];
    // Format trace, add final transition to trace and return
    return allTransitions.map(({ transition: transition, trace: trace })=>({
            transition: transition,
            trace: [
                ...trace,
                transition
            ].map((tr)=>({
                    to: tr.to,
                    read: tr.read.length === 0 ? '' : nextRead
                }))
        }));
};








const $08714987d1077153$var$PROJECT_TYPE_MAP = {
    FSA: 'fa',
    PDA: 'pda',
    TM: 'turing'
};
const $08714987d1077153$var$mapStates = (states, initialStateId, statePrefix)=>states.map((state)=>({
            _attributes: {
                id: state.id,
                name: state.name ?? `${statePrefix}${state.id}`
            },
            x: {
                _text: state.x
            },
            y: {
                _text: state.y
            },
            ...state.label ? {
                label: {
                    _text: state.label
                }
            } : {},
            ...state.isFinal ? {
                final: {}
            } : {},
            ...state.id === initialStateId ? {
                initial: {}
            } : {}
        }));
const $08714987d1077153$var$mapTransitions = (transitions, projectType)=>{
    /**
   *
   * @param transition The transition to add project specific attributes to
   * @param currentRead A single character to apply the transformation to. If the transition is a range, this will be
   * a single character from the range, otherwise will simply be the read symbol
   * @param projectType One of "FSA", "PDA", or "TM". Used to determine the additional attributes
   * @returns A JFLAP compatible transition with the project type specific attributes added
   */ const addProjectSpecificAttributes = (transition, currentRead, projectType)=>{
        const baseTransition = {
            from: {
                _text: transition.from
            },
            to: {
                _text: transition.to
            },
            read: currentRead ? {
                _text: currentRead
            } : {}
        };
        switch(projectType){
            // No extra properties needed for FSA
            case 'FSA':
                return baseTransition;
            // Add pop and push properties to transition
            case 'PDA':
                {
                    const pdaTransition = transition;
                    return {
                        ...baseTransition,
                        push: pdaTransition.push ? {
                            _text: pdaTransition.push
                        } : {},
                        pop: pdaTransition.pop ? {
                            _text: pdaTransition.pop
                        } : {}
                    };
                }
            // Add write and move properties to transition
            case 'TM':
                {
                    const tmTransition = transition;
                    return {
                        ...baseTransition,
                        write: tmTransition.write ? {
                            _text: tmTransition.write
                        } : {},
                        move: tmTransition.direction ? {
                            _text: tmTransition.direction
                        } : {}
                    };
                }
        }
    };
    // Sanity check for project type
    if (!Object.keys($08714987d1077153$var$PROJECT_TYPE_MAP).includes(projectType)) throw new Error(`Unsupported Automatarium project type "${projectType}"!`);
    return transitions.flatMap((transition)=>{
        if (transition.read === '') return addProjectSpecificAttributes(transition, '', projectType);
        // Automatarium stores transitions like [a-z] in a single transition, but it is best to
        // map these individually to a corresponding JFLAP transition
        const readSymbols = (0, $daf601bb5fd2cd59$export$3d937f95c796e6d6)(transition.read).split('');
        return readSymbols.map((readSymbol)=>addProjectSpecificAttributes(transition, readSymbol, projectType));
    });
};
const $08714987d1077153$var$mapComments = (comments)=>comments.map((comment)=>({
            text: {
                _text: comment.text
            },
            x: {
                _text: comment.x
            },
            y: {
                _text: comment.y
            }
        }));
const $08714987d1077153$export$c8b8433b2785e02d = (automatariumProject)=>{
    const jsonToXml = {
        _declaration: {
            _attributes: {
                version: '1.0',
                encoding: 'UTF-8',
                standalone: 'no'
            }
        },
        _comment: 'Created with love from Automatarium for JFLAP',
        structure: {
            type: $08714987d1077153$var$PROJECT_TYPE_MAP[automatariumProject.projectType],
            automaton: {
                state: $08714987d1077153$var$mapStates(automatariumProject.states, automatariumProject.initialState, automatariumProject.config.statePrefix),
                transition: $08714987d1077153$var$mapTransitions(automatariumProject.transitions, automatariumProject.projectType),
                note: $08714987d1077153$var$mapComments(automatariumProject.comments)
            }
        }
    };
    return (0, $6a124476dce670ed$exports.json2xml)(JSON.stringify(jsonToXml), {
        compact: true,
        spaces: 4
    });
};




/**
 * GEMLayoutAlgorithm by Thomas Finley
 * Ported and adapted from the JFLAP source code
 *
 * JFLAP is maintained by Associate Professor Susan H. Rodger of Duke University
 *
 */ const $eeb491f7acce125f$var$GemLayoutAlgorithm = (graph)=>{
    const graphClone = structuredClone(graph);
    const cloneStates = graphClone.states;
    // Remove the initial state from the vertices to move so we build around it
    const vArray = cloneStates.filter((s)=>s.id !== graphClone.initialState);
    const c = [
        0.0,
        0.0
    ];
    const records = {};
    vArray.forEach((v)=>{
        const adjacentStateIds = [];
        for (const t of graphClone.transitions){
            if (t.from === v.id && !adjacentStateIds.includes(t.to)) adjacentStateIds.push(t.to);
            if (t.to === v.id && !adjacentStateIds.includes(t.from)) adjacentStateIds.push(t.from);
        }
        const r = {
            point: {
                x: v.x,
                y: v.y
            },
            omega: 4,
            adjacentList: adjacentStateIds
        };
        c[0] += r.point.x;
        c[1] += r.point.y;
        records[v.id] = r;
    });
    const rMax = 120 * vArray.length;
    const gravitationalConstant = 0.0625;
    const optimalEdgeLength = 100.0;
    const o2 = optimalEdgeLength ** 2;
    // Iterate until done
    let vertexIndices = [
        ...Array(vArray.length).keys()
    ];
    for(let i = 0; i < rMax; ++i){
        if (vertexIndices.length === 0) {
            vertexIndices = [
                ...Array(vArray.length).keys()
            ];
            if (vertexIndices.length === 0) return;
        }
        // Chose a vertex
        const nextChoice = Math.floor(Math.random() * vertexIndices.length);
        const vertexIndex = vertexIndices.splice(nextChoice, 1)[0];
        const vertex = vArray[vertexIndex];
        const vRecord = records[vertex.id];
        const point = vRecord.point;
        // Compute impulse
        const theta = vRecord.adjacentList.length * (1.0 + vRecord.adjacentList.length / 2.0);
        const p = [
            (c[0] / vArray.length - point.x) * gravitationalConstant * theta,
            (c[1] / vArray.length - point.y) * gravitationalConstant * theta
        ];
        // Random disturbance
        p[0] += Math.random() * 10.0 - 5.0;
        p[1] += Math.random() * 10.0 - 5.0;
        // Forces exerted by other nodes
        vArray.forEach((otherVertex)=>{
            if (otherVertex.id === vertex.id) return;
            const otherPoint = {
                x: otherVertex.x,
                y: otherVertex.y
            };
            const delta = [
                point.x - otherPoint.x,
                point.y - otherPoint.y
            ];
            // Nudge state so they will separate
            if (delta[0] === 0 && delta[1] === 0) {
                delta[0] += Math.random() * 10.0 - 5.0;
                delta[1] += Math.random() * 10.0 - 5.0;
            }
            const d2 = delta[0] ** 2 + delta[1] ** 2;
            if (d2 !== 0) {
                p[0] += delta[0] * o2 / d2;
                p[1] += delta[1] * o2 / d2;
            }
            // Is adjacent?
            if (!vRecord.adjacentList.includes(otherVertex.id)) return;
            p[0] -= delta[0] * d2 / (o2 * theta);
            p[1] -= delta[1] * d2 / (o2 * theta);
        });
        // Adjust position and temperature
        if (p[0] !== 0.0 || p[1] !== 0.0) {
            const absp = Math.sqrt(Math.abs(p[0] ** 2 + p[1] ** 2));
            p[1] *= vRecord.omega / absp;
            p[0] *= vRecord.omega / absp;
            // Update position
            vertex.x += p[0];
            vertex.y += p[1];
            // Update barycenter
            c[0] += p[0];
            c[1] += p[1];
        }
    }
    return graphClone;
};
var $eeb491f7acce125f$export$2e2bcd8739ae039 = $eeb491f7acce125f$var$GemLayoutAlgorithm;


/**
 * Implements the algorithm described in [this paper](https://www.graphviz.org/documentation/TSE93.pdf)
 * 'A Technique for Drawing Directed Graphs' by Gansner E.R. et. al.
 */ const $1812551efebcf5e5$export$d12d81d9c5207ce8 = 30;
const $1812551efebcf5e5$export$4aa180e8a03344a1 = 25;
const $1812551efebcf5e5$export$bdd0075766057415 = 20;
const $1812551efebcf5e5$export$99ef5412ccf693f2 = Math.PI / 7;
const $1812551efebcf5e5$export$2d452e0d1851225b = 8;
const $1812551efebcf5e5$export$d4311fcb0a827d41 = 90;
const $1812551efebcf5e5$export$af6733fb5ef9e2cc = 2.4;
const $1812551efebcf5e5$export$fba9fbe7f888ef8e = 5;
const $1812551efebcf5e5$export$be4f6dacde269979 = 130;
const $1812551efebcf5e5$export$f5374a98ad8aa40f = 75;
const $1812551efebcf5e5$export$326d76bf7c385d63 = 10;
const $1812551efebcf5e5$export$75f78b310dfa0458 = 9 // em
;
const $1812551efebcf5e5$export$29fa6f666d45fe34 = 12 // em
;
const $1812551efebcf5e5$export$2b5cd01258598218 = 4;


const $2adae15813ec8bee$export$e53d89a454269236 = (graph, adjacencyList)=>{
    const transitions = [];
    adjacencyList.forEach((adjList, k)=>{
        adjList.forEach((adj)=>{
            const [from, to] = [
                k,
                adj.id
            ];
            transitions.push(graph.transitions.find((t)=>t.from === from && t.to === to));
        });
    });
    return transitions.sort((a, b)=>a.id - b.id);
};
const $2adae15813ec8bee$export$d53b75a45f71c45e = (graph)=>{
    /**
   * Priority:
   *  initialState -> finalStates (random) -> random state
   */ const getInitialState = (graph)=>{
        // Choose source node
        if (graph.initialState || graph.initialState === 0) return graph.initialState;
        // Choose sink node
        const finalStates = graph.states.filter((s)=>s.isFinal);
        if (finalStates) {
            // Choose a random sink
            const choice = Math.floor(Math.random() * finalStates.length);
            return finalStates[choice].id;
        }
        // Choose random state
        const choice = Math.floor(Math.random() * graph.states.length);
        return graph.states[choice].id;
    };
    /**
   * Perform depth-first traversal
   * @returns mapping with states to number of cycles associated with it
   * */ const getStateCycles = (currentState, problem, visited, frontier)=>{
        // Base case all states have been traversed and no cycles were found
        if (visited.length > 0 && problem.states.every((v)=>visited.includes(v))) return problem.cyclesCounter;
        const nextVisited = visited.includes(currentState) ? [
            ...visited
        ] : [
            ...visited,
            currentState
        ];
        const nextAdjList = problem.adjacencyList.get(currentState);
        // Add all adjacent states not in visited
        const frontierAdditions = [];
        if (nextAdjList) nextAdjList.forEach((p)=>{
            const id = p.id;
            if (nextVisited.includes(id)) {
                // If visited then is a cycle
                const edgeKey = [
                    currentState,
                    id
                ].join(',');
                problem.cyclesCounter.set(edgeKey, problem.cyclesCounter.get(edgeKey) + 1);
            } else frontierAdditions.push(id);
        });
        const nextFrontier = [
            ...frontier,
            ...frontierAdditions
        ];
        if (nextFrontier.length < 1) return problem.cyclesCounter;
        const nextState = nextFrontier.pop();
        return getStateCycles(nextState, problem, nextVisited, nextFrontier);
    };
    /** Get the Edge with the highest cycle */ const getMaximalCycler = (cyclesCounter)=>{
        const maxPair = [
            null,
            0
        ];
        for (const pair of cyclesCounter.entries())if (pair[1] > maxPair[1]) {
            maxPair[0] = pair[0];
            maxPair[1] = pair[1];
        }
        return maxPair[0];
    };
    /** Reverse all transitions in the directed edge then updates the adjacency list. */ const reverseEdge = (graph, edges, edgeKey)=>{
        const [from, to] = edgeKey.split(',').map((v)=>parseInt(v));
        const transitionsToReverse = graph.transitions.filter((t)=>t.to === to && t.from === from);
        const transitionsNotToReverse = graph.transitions.filter((t)=>t.to !== to || t.from !== from);
        transitionsToReverse.forEach((t)=>{
            const tmp = t.to;
            t.to = t.from;
            t.from = tmp;
        });
        graph.transitions = [
            ...transitionsToReverse,
            ...transitionsNotToReverse
        ];
        // Update adjacency list
        const toReverseWeight = structuredClone(edges.get(from).find((e)=>e.id === to));
        toReverseWeight.id = from;
        // Check if there was a transition from 1 -> 0
        if (edges.has(to)) {
            const otherValue = edges.get(to).find((e)=>e.id === from);
            if (otherValue) otherValue.weight = otherValue.weight + toReverseWeight.weight;
            else edges.set(to, [
                ...edges.get(to),
                toReverseWeight
            ]);
        } else edges.set(to, [
            toReverseWeight
        ]);
        // Filter out the removed value
        const newAdjacents = edges.get(from).filter((e)=>e.id !== to);
        if (newAdjacents.length > 0) edges.set(from, newAdjacents);
        else // Delete edge if there's no more
        edges.delete(from);
    };
    /** Start actual code */ // We don't want to edit the original graph reference as we are just rearranging
    const graphClone = structuredClone(graph);
    const cloneStates = graphClone.states;
    // Merge edges and assign weight according to number of transitions
    const edges = new Map();
    // Ignore reflexive transitions
    for (const t of graphClone.transitions.filter((t)=>t.from !== t.to))if (edges.has(t.from)) {
        if (edges.get(t.from).some((p)=>p.id === t.to)) edges.get(t.from).find((p)=>p.id === t.to).weight += 1;
        else edges.get(t.from).push({
            id: t.to,
            weight: 1
        });
    } else edges.set(t.from, [
        {
            id: t.to,
            weight: 1
        }
    ]);
    // Collapse edges to first transition
    graphClone.transitions = $2adae15813ec8bee$export$e53d89a454269236(graphClone, edges);
    const cyclesCounter = new Map();
    const initialState = getInitialState(graphClone);
    const stateIds = graphClone.states.map((s)=>s.id);
    // Repeat until all cycles are resolved
    let done = false;
    while(!done){
        // Reset cycles counter
        cloneStates.forEach((from)=>{
            cloneStates.forEach((to)=>{
                if (from !== to) cyclesCounter.set([
                    from.id,
                    to.id
                ].join(','), 0);
            });
        });
        const result = getStateCycles(initialState, {
            adjacencyList: edges,
            states: stateIds,
            cyclesCounter: cyclesCounter
        }, [], []);
        const maximalCycler = getMaximalCycler(result);
        if (!maximalCycler) // Maximal is null
        done = true;
        else reverseEdge(graphClone, edges, maximalCycler);
    }
    // Update result
    graphClone.transitions = $2adae15813ec8bee$export$e53d89a454269236(graphClone, edges);
    return [
        graphClone,
        edges
    ];
};


const $41e9d9b4970b984f$var$GraphvizLayoutAlgorithm = (graph)=>{
    const [dag, edges] = (0, $2adae15813ec8bee$export$d53b75a45f71c45e)(graph);
    const graphClone = structuredClone(graph);
    const cloneStates = graphClone.states;
    const MAX_ITERATIONS = 100;
    // Size of bounding box of a node
    const nodeB = [
        (0, $1812551efebcf5e5$export$d12d81d9c5207ce8),
        (0, $1812551efebcf5e5$export$d12d81d9c5207ce8)
    ];
    // Minimum horizontal separation
    const nodeSep = 5;
    // Minimum vertical separation
    const rankSep = 5;
    const records = {};
    cloneStates.forEach((v)=>{
        const adjacentStateIds = [];
        for (const t of graphClone.transitions){
            if (t.from === v.id && !adjacentStateIds.includes(t.to)) adjacentStateIds.push(t.to);
            if (t.to === v.id && !adjacentStateIds.includes(t.from)) adjacentStateIds.push(t.from);
        }
        const r = {
            point: {
                x: v.x,
                y: v.y
            },
            omega: 1,
            adjacentList: adjacentStateIds
        };
        records[v.id] = r;
    });
    // rank
    // TODO: Currently just creates a tree from the graph. Needs to be ranked properly wrt. to importance etc.
    const hierarchy = (graph, edges)=>{
        const { states: states } = graph;
        const getSuccessors = (parent, edges)=>{
            const adj = edges.get(parent.id);
            if (!adj) return [];
            adj.sort((a, b)=>a.weight + b.weight) // Descending
            ;
            const sortedNodes = adj.map((a)=>{
                const state = states.find((s)=>s.id === a.id);
                const node = {
                    id: state.id,
                    x: state.x,
                    y: state.y,
                    weight: a.weight,
                    parent: parent
                };
                node.children = getSuccessors(node, edges);
                return node;
            });
            return sortedNodes;
        };
        const constructLevels = (base)=>{
            if (base.nodes.length < 1) return;
            const nextLevel = {
                nodes: base.nodes.flatMap((n)=>n.children),
                next: null,
                gravity: 0,
                min: 0,
                max: 0
            };
            base.next = nextLevel;
            constructLevels(nextLevel);
        };
        const constructTree = (edges)=>{
            // Find root, source or node with the highest out degrees
            const rootNode = graph.initialState ? states.find((s)=>s.id === graph.initialState) : (()=>states[0])() // TODO: Actual out degree calculation
            ;
            const node = {
                id: rootNode.id,
                x: rootNode.x,
                y: rootNode.y,
                weight: 1,
                parent: null
            };
            node.children = getSuccessors(node, edges);
            const rootLevel = {
                nodes: [
                    node
                ],
                next: null,
                gravity: 0,
                min: 0,
                max: 0
            };
            constructLevels(rootLevel);
            return rootLevel;
        };
        return constructTree(edges);
    };
    const rank = hierarchy(dag, edges);
    // ordering
    // position
    const arrange = (root)=>{
        const globalGravity = {
            x: 0,
            y: 0
        };
        const gravStrength = Math.sqrt(nodeB[0] ** 2 + nodeB[1] ** 2);
        const ALPHA = 0.3 // 'Learning rate'
        ;
        const initialiseCoords = (parent)=>{
            parent.x = 0;
            parent.y = 0;
            parent.children.forEach((child)=>{
                initialiseCoords(child);
            });
        };
        const getCoords = (level)=>{
            return level.nodes.map((n)=>({
                    x: n.x,
                    y: n.y
                }));
        };
        const apply = (level, newCoords)=>{
            level.nodes.forEach((n, i)=>{
                n.x = (1 - ALPHA) * n.x + ALPHA * newCoords[i].x;
                n.y = (1 - ALPHA) * n.y + ALPHA * newCoords[i].y;
            });
        };
        /** Recursively update each level gravity and global gravity */ const updateGravity = (level)=>{
            if (level === null) return;
            level.nodes.forEach((n)=>{
                globalGravity.x = (globalGravity.x + n.x) / (n.weight + 1);
                globalGravity.y = (globalGravity.y + n.y) / (n.weight + 1);
            });
            updateGravity(level.next);
        };
        // Optimise towards rank separation
        const rankSeparationShift = (base, coords)=>{
            base.nodes.forEach((n, i)=>{
                if (n.parent === null) return;
                coords[i].y += Math.abs(n.parent.y - coords[i].y) - rankSep;
            });
        };
        // Optimise towards level separation
        const levelSeparationShift = (base, coords)=>{
            const sums = base.nodes.reduce((acc, val)=>{
                return [
                    acc[0] + val.x * val.weight,
                    acc[1] + val.weight
                ];
            }, [
                0,
                0
            ]);
            const currentSeparation = sums[0] / sums[1];
            const step = nodeSep - currentSeparation;
            base.nodes.forEach((_, i)=>{
                if (i >= base.nodes.length - 1) return;
                coords[i + 1].x += coords[i].x + step;
            });
        };
        // Move towards level and global centre
        const gravityShift = (base, coords)=>{
            const gravity = {
                x: (base.gravity + globalGravity.x) / 2,
                y: globalGravity.y
            };
            coords.forEach((c)=>{
                const vec = {
                    x: gravity.x - c.x,
                    y: gravity.y - c.y
                };
                const mag = Math.sqrt(vec.x ** 2 + vec.y ** 2);
                const unitVector = {
                    x: vec.x / mag,
                    y: vec.y / mag
                };
                c.x += unitVector.x * gravStrength;
                c.y += unitVector.y * gravStrength;
            });
        };
        // Align to parent rank coord
        const parentAlignmentShift = (base, coords)=>{
            base.nodes.forEach((n, i)=>{
                if (n.parent === null) return;
                const parentX = n.parent.x;
                coords[i].x += parentX - coords[i].x;
            });
        };
        initialiseCoords(root.nodes[0]);
        for(let _ = 0; _ < MAX_ITERATIONS; ++_){
            let level = root;
            while(level !== null){
                const coords = getCoords(level);
                rankSeparationShift(level, coords);
                levelSeparationShift(level, coords);
                gravityShift(level, coords);
                parentAlignmentShift(level, coords);
                apply(level, coords);
                level = level.next;
            }
            updateGravity(root);
        }
    };
    arrange(rank);
    // Update state positions
    return graphClone;
};
var $41e9d9b4970b984f$export$2e2bcd8739ae039 = $41e9d9b4970b984f$var$GraphvizLayoutAlgorithm;


const $31e4fa2b24ff8a97$var$autoLayout = (graph, algorithm = 'gem')=>{
    const algorithms = new Map([
        [
            'gem',
            (0, $eeb491f7acce125f$export$2e2bcd8739ae039)
        ],
        [
            'tree',
            (0, $41e9d9b4970b984f$export$2e2bcd8739ae039)
        ]
    ]);
    if (!algorithms.has(algorithm)) return null;
    return algorithms.get(algorithm)(graph);
};
var $31e4fa2b24ff8a97$export$2e2bcd8739ae039 = $31e4fa2b24ff8a97$var$autoLayout;



/**
 * Makes a label for a set of states.
 * States are sorted first e.g. [2, 0, 1] => "0, 1, 2".
 * If there are no states then it assumes its the trap state (and returns 'Trap')
 */ const $f14ade203442b518$var$makeStateLabel = (states)=>{
    return states.length === 0 ? 'Trap' : states.sort((a, b)=>a - b).join(', ');
};
/**
 * Returns all read symbols for a transition
 */ const $f14ade203442b518$var$readSymbols = (t)=>{
    return t.read ? (0, $daf601bb5fd2cd59$export$3d937f95c796e6d6)(t.read).split('') : [
        ''
    ];
};
const $f14ade203442b518$export$caf057dff8f8c051 = (nfa)=>{
    // Just in case
    if (nfa.initialState === null) return nfa;
    // Build an adjacency list for the NFA to make operations easier.
    // It is a mapping of stateID -> (read symbol -> states that reaches).
    const graphList = new Map();
    for (const t of nfa.transitions){
        // Create the second map if it doesn't exist
        if (!graphList.has(t.from)) graphList.set(t.from, new Map());
        // Now add the state in
        const forState = graphList.get(t.from);
        for (const symbol of $f14ade203442b518$var$readSymbols(t)){
            if (!forState.has(symbol)) forState.set(symbol, new Set());
            forState.get(symbol).add(t.to);
        }
    }
    /**
   * Returns all states that can be reached by either reading lambdas or by reading the symbol.
   * The read will only be performed once, but lambdas will always be traversed.
   * This was used instead of `validTransitions` since that doesn't handle transitions like λ -> A -> λ (It should return the last two)
   * and FSASearch only searches one step ahead
   */ const explore = (initialStates, read)=>{
        // Frontier of nodes to explore.
        // canRead is used to track if the symbol has been read yet for a path
        const frontier = initialStates.map((s)=>({
                canRead: true,
                state: s
            }));
        // Store a set of state + read symbol to check we aren't entering a state with a symbol we have used before.
        // We can't just store state since we need to track if we have both seen a state and seen it by already reading
        const seen = new Set();
        const result = new Set();
        while(frontier.length){
            const { canRead: canRead, state: state } = frontier.pop();
            const readTable = graphList.get(state);
            // If there are no transitions, ignore
            if (!readTable) continue;
            /**
       * Helper function to add transitions that are reachable by reading a certain symbol.
       */ const addTransitions = (symbol)=>{
                const states = readTable.get(symbol) || [];
                for (const state of states){
                    // The key will be a combo of the state plus if we can read while in that state
                    const seenKey = state.toString() + (canRead && symbol === '');
                    if (!seen.has(seenKey)) {
                        seen.add(seenKey);
                        // We can only continue reading if we haven't read the symbol yet
                        frontier.push({
                            canRead: canRead && symbol === '',
                            state: state
                        });
                        // But we only want to add states if we have actually read something (since that means a transitions has happened)
                        if (!canRead || symbol === read) result.add(state);
                    }
                }
            };
            // Add states that we can reach by reading the symbol
            if (canRead) addTransitions(read);
            // Add any states we can reach by going through a lambda
            addTransitions('');
        }
        return result;
    };
    // Build information about the graph
    const alphabet = new Set(nfa.transitions.flatMap((t)=>$f14ade203442b518$var$readSymbols(t)));
    const finalStates = new Set(nfa.states.flatMap((s)=>s.isFinal ? [
            s.id
        ] : []));
    // Find position of first node. Doesn't matter really, and we should just auto format + zoom to fit
    const initialPos = {
        x: nfa.states[0].x,
        y: nfa.states[0].y
    };
    // Mapping from DFA state label to its ID
    const labelMapping = new Map();
    // An adjacency list we will build for the DFA
    const dfaTable = new Map();
    // Our initial state is any state from the NFA's initial state that we can reach via lambdas
    const dfaInitialStates = [
        ...explore([
            nfa.initialState
        ], '').add(nfa.initialState)
    ];
    const frontier = [
        dfaInitialStates
    ];
    // Track seen states so we don't go into any loops
    const seen = new Set([
        $f14ade203442b518$var$makeStateLabel(dfaInitialStates)
    ]);
    // Make a copy of the graph and reset the values and make the DFA off of that
    const dfa = structuredClone(nfa);
    dfa.states = [];
    dfa.transitions = [];
    dfa.initialState = 0 // It gets reset to 0
    ;
    // Helper to get the next ID for item (I am too lazy to ++variable)
    const nextID = (x)=>(x[x.length - 1]?.id ?? -1) + 1;
    //
    // Main loop in the conversion process
    //
    while(frontier.length){
        const curr = frontier.pop();
        const currKey = $f14ade203442b518$var$makeStateLabel(curr);
        // Create a new state which represents the set of NFA states
        const id = nextID(dfa.states);
        dfa.states.push({
            id: id,
            label: currKey,
            ...initialPos,
            isFinal: curr.some((s)=>finalStates.has(s)) // If any of the states are final, then the new state is final
        });
        labelMapping.set(currKey, id);
        // Make sure the table can receive info for it
        dfaTable.set(currKey, []);
        // For every state in the closure, see what states we can be in
        // by trying to read everything in the alphabet
        for (const symbol of alphabet){
            // Remove lambda transitions
            if (symbol === '') continue;
            // Find distinct states we can be in by either reading a lambda or reading the symbol
            const states = [
                ...explore(curr, symbol)
            ];
            // Check if its a new state that we need to explore
            const key = $f14ade203442b518$var$makeStateLabel(states);
            if (!seen.has(key)) {
                // Make it seen so we don't add it again
                seen.add(key);
                // We will explore it later
                frontier.push(states);
            }
            // Add the transition
            dfaTable.get(currKey).push({
                read: symbol,
                to: key
            });
        }
    }
    // Now that the states are all found, we need to add the transitions in
    for (const [label, transitions] of dfaTable)for (const transition of transitions)dfa.transitions.push({
        id: nextID(dfa.transitions),
        from: labelMapping.get(label),
        to: labelMapping.get(transition.to),
        read: transition.read
    });
    return dfa;
};



const $c99e67a30febca32$export$d64d2ed55a3dc29e = (graph)=>{
    if (graph.initialState === null) return graph;
    // Convert the graph into an adjacency list of transitions
    const graphList = new Map();
    for (const t of graph.transitions){
        if (!graphList.has(t.from)) graphList.set(t.from, []);
        graphList.get(t.from).push(t.to);
    }
    // Sort the lists so that states with lower ID go first.
    // We iterate transitions instead of states since not every state will
    // be in graphList (We only care about states with transitions)
    for (const t of graph.transitions)graphList.get(t.from).sort((a, b)=>a - b);
    // Keep track of next available ID
    let nextID = 0;
    // Keep track of mapping from old ID to new ID
    const mappings = new Map();
    /**
   * @returns If the ID has been processed
   */ const seen = (id)=>mappings.has(id);
    const frontier = new (0, $cb912592ed19a590$export$3dc07afe418952bc)();
    frontier.add(graph.initialState);
    while(!frontier.isEmpty()){
        let currID = frontier.remove();
        if (seen(currID)) continue;
        mappings.set(currID, nextID++);
        // Continue down straight paths, so they have a continuous counting of ID's
        while(graphList.has(currID)){
            const notSeen = graphList.get(currID).filter((x)=>!seen(x));
            // Either path is not straight or we have seen everything
            if (notSeen.length !== 1) break;
            currID = notSeen[0];
            mappings.set(currID, nextID++);
        }
        // For multiple path options, we just add them to the queue and process later
        // We only add them if we haven't seen them
        graphList.get(currID)?.forEach((x)=>!seen(x) && frontier.add(x));
    }
    /**
   * Returns mapping for an ID. If a mapping doesn't exist then it picks next available ID
   */ const getMapping = (oldID)=>{
        let result = mappings.get(oldID);
        if (result === undefined) {
            result = nextID++;
            mappings.set(oldID, result);
        }
        return result;
    };
    // Clone the graph
    const output = structuredClone(graph);
    // Update the initial graph using the mappings
    output.states.forEach((state)=>state.id = getMapping(state.id));
    for (const t of output.transitions){
        t.from = getMapping(t.from);
        t.to = getMapping(t.to);
    }
    output.initialState = 0;
    return output;
};


function $910fba28ad75d713$export$78406e843f5312da(byte) {
    return "".concat(byte < 0 ? "-" : "", "0x").concat(Math.abs(byte).toString(16).padStart(2, "0"));
}


// ExtensionCodec to handle MessagePack extensions
/**
 * ExtData is used to handle Extension Types that are not registered to ExtensionCodec.
 */ var $e9a0641eb0d9288e$export$bcbeb236456bc779 = /** @class */ function() {
    function ExtData(type, data) {
        this.type = type;
        this.data = data;
    }
    return ExtData;
}();


// https://github.com/msgpack/msgpack/blob/master/spec.md#timestamp-extension-type
var $6ef4b54b91e46351$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6ef4b54b91e46351$export$ef3eed12d06c0285 = /** @class */ function(_super) {
    $6ef4b54b91e46351$var$__extends(DecodeError, _super);
    function DecodeError(message) {
        var _this = _super.call(this, message) || this;
        // fix the prototype chain in a cross-platform way
        var proto = Object.create(DecodeError.prototype);
        Object.setPrototypeOf(_this, proto);
        Object.defineProperty(_this, "name", {
            configurable: true,
            enumerable: false,
            value: DecodeError.name
        });
        return _this;
    }
    return DecodeError;
}(Error);


// Integer Utility
var $c6179d2c52c13237$export$3314b2c271c86d70 = 4294967295;
function $c6179d2c52c13237$export$20f71c4c8b0f96c3(view, offset, value) {
    var high = value / 4294967296;
    var low = value; // high bits are truncated by DataView
    view.setUint32(offset, high);
    view.setUint32(offset + 4, low);
}
function $c6179d2c52c13237$export$8532a5209571c04a(view, offset, value) {
    var high = Math.floor(value / 4294967296);
    var low = value; // high bits are truncated by DataView
    view.setUint32(offset, high);
    view.setUint32(offset + 4, low);
}
function $c6179d2c52c13237$export$69825c7adcc820c6(view, offset) {
    var high = view.getInt32(offset);
    var low = view.getUint32(offset + 4);
    return high * 4294967296 + low;
}
function $c6179d2c52c13237$export$59a2dbf579ff9568(view, offset) {
    var high = view.getUint32(offset);
    var low = view.getUint32(offset + 4);
    return high * 4294967296 + low;
}


var $fd097e337d877941$export$f18369fc203f4e13 = -1;
var $fd097e337d877941$var$TIMESTAMP32_MAX_SEC = 4294967295; // 32-bit unsigned int
var $fd097e337d877941$var$TIMESTAMP64_MAX_SEC = 17179869183; // 34-bit unsigned int
function $fd097e337d877941$export$2fd05b828dd81159(_a) {
    var sec = _a.sec, nsec = _a.nsec;
    if (sec >= 0 && nsec >= 0 && sec <= $fd097e337d877941$var$TIMESTAMP64_MAX_SEC) {
        // Here sec >= 0 && nsec >= 0
        if (nsec === 0 && sec <= $fd097e337d877941$var$TIMESTAMP32_MAX_SEC) {
            // timestamp 32 = { sec32 (unsigned) }
            var rv = new Uint8Array(4);
            var view = new DataView(rv.buffer);
            view.setUint32(0, sec);
            return rv;
        } else {
            // timestamp 64 = { nsec30 (unsigned), sec34 (unsigned) }
            var secHigh = sec / 0x100000000;
            var secLow = sec & 0xffffffff;
            var rv = new Uint8Array(8);
            var view = new DataView(rv.buffer);
            // nsec30 | secHigh2
            view.setUint32(0, nsec << 2 | secHigh & 0x3);
            // secLow32
            view.setUint32(4, secLow);
            return rv;
        }
    } else {
        // timestamp 96 = { nsec32 (unsigned), sec64 (signed) }
        var rv = new Uint8Array(12);
        var view = new DataView(rv.buffer);
        view.setUint32(0, nsec);
        (0, $c6179d2c52c13237$export$8532a5209571c04a)(view, 4, sec);
        return rv;
    }
}
function $fd097e337d877941$export$221d97b3b00b03c2(date) {
    var msec = date.getTime();
    var sec = Math.floor(msec / 1e3);
    var nsec = (msec - sec * 1e3) * 1e6;
    // Normalizes { sec, nsec } to ensure nsec is unsigned.
    var nsecInSec = Math.floor(nsec / 1e9);
    return {
        sec: sec + nsecInSec,
        nsec: nsec - nsecInSec * 1e9
    };
}
function $fd097e337d877941$export$32420f352fe0fc83(object) {
    if (object instanceof Date) {
        var timeSpec = $fd097e337d877941$export$221d97b3b00b03c2(object);
        return $fd097e337d877941$export$2fd05b828dd81159(timeSpec);
    } else return null;
}
function $fd097e337d877941$export$abfc8800a5159711(data) {
    var view = new DataView(data.buffer, data.byteOffset, data.byteLength);
    // data may be 32, 64, or 96 bits
    switch(data.byteLength){
        case 4:
            // timestamp 32 = { sec32 }
            var sec = view.getUint32(0);
            var nsec = 0;
            return {
                sec: sec,
                nsec: nsec
            };
        case 8:
            // timestamp 64 = { nsec30, sec34 }
            var nsec30AndSecHigh2 = view.getUint32(0);
            var secLow32 = view.getUint32(4);
            var sec = (nsec30AndSecHigh2 & 0x3) * 0x100000000 + secLow32;
            var nsec = nsec30AndSecHigh2 >>> 2;
            return {
                sec: sec,
                nsec: nsec
            };
        case 12:
            // timestamp 96 = { nsec32 (unsigned), sec64 (signed) }
            var sec = (0, $c6179d2c52c13237$export$69825c7adcc820c6)(view, 4);
            var nsec = view.getUint32(0);
            return {
                sec: sec,
                nsec: nsec
            };
        default:
            throw new (0, $6ef4b54b91e46351$export$ef3eed12d06c0285)("Unrecognized data size for timestamp (expected 4, 8, or 12): ".concat(data.length));
    }
}
function $fd097e337d877941$export$80b8ff9315e4298f(data) {
    var timeSpec = $fd097e337d877941$export$abfc8800a5159711(data);
    return new Date(timeSpec.sec * 1e3 + timeSpec.nsec / 1e6);
}
var $fd097e337d877941$export$8654479533463da1 = {
    type: $fd097e337d877941$export$f18369fc203f4e13,
    encode: $fd097e337d877941$export$32420f352fe0fc83,
    decode: $fd097e337d877941$export$80b8ff9315e4298f
};


var $5473c9f7ee128b2b$export$12677a794dbd89d7 = /** @class */ function() {
    function ExtensionCodec() {
        // built-in extensions
        this.builtInEncoders = [];
        this.builtInDecoders = [];
        // custom extensions
        this.encoders = [];
        this.decoders = [];
        this.register((0, $fd097e337d877941$export$8654479533463da1));
    }
    ExtensionCodec.prototype.register = function(_a) {
        var type = _a.type, encode = _a.encode, decode = _a.decode;
        if (type >= 0) {
            // custom extensions
            this.encoders[type] = encode;
            this.decoders[type] = decode;
        } else {
            // built-in extensions
            var index = 1 + type;
            this.builtInEncoders[index] = encode;
            this.builtInDecoders[index] = decode;
        }
    };
    ExtensionCodec.prototype.tryToEncode = function(object, context) {
        // built-in extensions
        for(var i = 0; i < this.builtInEncoders.length; i++){
            var encodeExt = this.builtInEncoders[i];
            if (encodeExt != null) {
                var data = encodeExt(object, context);
                if (data != null) {
                    var type = -1 - i;
                    return new (0, $e9a0641eb0d9288e$export$bcbeb236456bc779)(type, data);
                }
            }
        }
        // custom extensions
        for(var i = 0; i < this.encoders.length; i++){
            var encodeExt = this.encoders[i];
            if (encodeExt != null) {
                var data = encodeExt(object, context);
                if (data != null) {
                    var type = i;
                    return new (0, $e9a0641eb0d9288e$export$bcbeb236456bc779)(type, data);
                }
            }
        }
        if (object instanceof (0, $e9a0641eb0d9288e$export$bcbeb236456bc779)) // to keep ExtData as is
        return object;
        return null;
    };
    ExtensionCodec.prototype.decode = function(data, type, context) {
        var decodeExt = type < 0 ? this.builtInDecoders[-1 - type] : this.decoders[type];
        if (decodeExt) return decodeExt(data, type, context);
        else // decode() does not fail, returns ExtData instead.
        return new (0, $e9a0641eb0d9288e$export$bcbeb236456bc779)(type, data);
    };
    ExtensionCodec.defaultCodec = new ExtensionCodec();
    return ExtensionCodec;
}();




var $c96884cbd568d5d5$var$_a, $c96884cbd568d5d5$var$_b, $c96884cbd568d5d5$var$_c;
var $c96884cbd568d5d5$var$TEXT_ENCODING_AVAILABLE = typeof TextEncoder !== "undefined" && typeof TextDecoder !== "undefined";
function $c96884cbd568d5d5$export$b61de95301265227(str) {
    var strLength = str.length;
    var byteLength = 0;
    var pos = 0;
    while(pos < strLength){
        var value = str.charCodeAt(pos++);
        if ((value & 0xffffff80) === 0) {
            // 1-byte
            byteLength++;
            continue;
        } else if ((value & 0xfffff800) === 0) // 2-bytes
        byteLength += 2;
        else {
            // handle surrogate pair
            if (value >= 0xd800 && value <= 0xdbff) // high surrogate
            {
                if (pos < strLength) {
                    var extra = str.charCodeAt(pos);
                    if ((extra & 0xfc00) === 0xdc00) {
                        ++pos;
                        value = ((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000;
                    }
                }
            }
            if ((value & 0xffff0000) === 0) // 3-byte
            byteLength += 3;
            else // 4-byte
            byteLength += 4;
        }
    }
    return byteLength;
}
function $c96884cbd568d5d5$export$1042e4338f1ef853(str, output, outputOffset) {
    var strLength = str.length;
    var offset = outputOffset;
    var pos = 0;
    while(pos < strLength){
        var value = str.charCodeAt(pos++);
        if ((value & 0xffffff80) === 0) {
            // 1-byte
            output[offset++] = value;
            continue;
        } else if ((value & 0xfffff800) === 0) // 2-bytes
        output[offset++] = value >> 6 & 0x1f | 0xc0;
        else {
            // handle surrogate pair
            if (value >= 0xd800 && value <= 0xdbff) // high surrogate
            {
                if (pos < strLength) {
                    var extra = str.charCodeAt(pos);
                    if ((extra & 0xfc00) === 0xdc00) {
                        ++pos;
                        value = ((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000;
                    }
                }
            }
            if ((value & 0xffff0000) === 0) {
                // 3-byte
                output[offset++] = value >> 12 & 0x0f | 0xe0;
                output[offset++] = value >> 6 & 0x3f | 0x80;
            } else {
                // 4-byte
                output[offset++] = value >> 18 & 0x07 | 0xf0;
                output[offset++] = value >> 12 & 0x3f | 0x80;
                output[offset++] = value >> 6 & 0x3f | 0x80;
            }
        }
        output[offset++] = value & 0x3f | 0x80;
    }
}
var $c96884cbd568d5d5$var$sharedTextEncoder = $c96884cbd568d5d5$var$TEXT_ENCODING_AVAILABLE ? new TextEncoder() : undefined;
var $c96884cbd568d5d5$export$ed34c0622b397238 = !$c96884cbd568d5d5$var$TEXT_ENCODING_AVAILABLE ? (0, $c6179d2c52c13237$export$3314b2c271c86d70) : 0;
function $c96884cbd568d5d5$var$utf8EncodeTEencode(str, output, outputOffset) {
    output.set($c96884cbd568d5d5$var$sharedTextEncoder.encode(str), outputOffset);
}
function $c96884cbd568d5d5$var$utf8EncodeTEencodeInto(str, output, outputOffset) {
    $c96884cbd568d5d5$var$sharedTextEncoder.encodeInto(str, output.subarray(outputOffset));
}
var $c96884cbd568d5d5$export$34cfdc82d430524 = ($c96884cbd568d5d5$var$sharedTextEncoder === null || $c96884cbd568d5d5$var$sharedTextEncoder === void 0 ? void 0 : $c96884cbd568d5d5$var$sharedTextEncoder.encodeInto) ? $c96884cbd568d5d5$var$utf8EncodeTEencodeInto : $c96884cbd568d5d5$var$utf8EncodeTEencode;
var $c96884cbd568d5d5$var$CHUNK_SIZE = 4096;
function $c96884cbd568d5d5$export$551117984c2adf4f(bytes, inputOffset, byteLength) {
    var offset = inputOffset;
    var end = offset + byteLength;
    var units = [];
    var result = "";
    while(offset < end){
        var byte1 = bytes[offset++];
        if ((byte1 & 0x80) === 0) // 1 byte
        units.push(byte1);
        else if ((byte1 & 0xe0) === 0xc0) {
            // 2 bytes
            var byte2 = bytes[offset++] & 0x3f;
            units.push((byte1 & 0x1f) << 6 | byte2);
        } else if ((byte1 & 0xf0) === 0xe0) {
            // 3 bytes
            var byte2 = bytes[offset++] & 0x3f;
            var byte3 = bytes[offset++] & 0x3f;
            units.push((byte1 & 0x1f) << 12 | byte2 << 6 | byte3);
        } else if ((byte1 & 0xf8) === 0xf0) {
            // 4 bytes
            var byte2 = bytes[offset++] & 0x3f;
            var byte3 = bytes[offset++] & 0x3f;
            var byte4 = bytes[offset++] & 0x3f;
            var unit = (byte1 & 0x07) << 0x12 | byte2 << 0x0c | byte3 << 0x06 | byte4;
            if (unit > 0xffff) {
                unit -= 0x10000;
                units.push(unit >>> 10 & 0x3ff | 0xd800);
                unit = 0xdc00 | unit & 0x3ff;
            }
            units.push(unit);
        } else units.push(byte1);
        if (units.length >= $c96884cbd568d5d5$var$CHUNK_SIZE) {
            result += String.fromCharCode.apply(String, units);
            units.length = 0;
        }
    }
    if (units.length > 0) result += String.fromCharCode.apply(String, units);
    return result;
}
var $c96884cbd568d5d5$var$sharedTextDecoder = $c96884cbd568d5d5$var$TEXT_ENCODING_AVAILABLE ? new TextDecoder() : null;
var $c96884cbd568d5d5$export$d866281c5a66d1ef = !$c96884cbd568d5d5$var$TEXT_ENCODING_AVAILABLE ? (0, $c6179d2c52c13237$export$3314b2c271c86d70) : 0;
function $c96884cbd568d5d5$export$6ed79e41309992dc(bytes, inputOffset, byteLength) {
    var stringBytes = bytes.subarray(inputOffset, inputOffset + byteLength);
    return $c96884cbd568d5d5$var$sharedTextDecoder.decode(stringBytes);
}


function $c5f9dc8c720865ff$export$f8d669c2a17882f2(buffer) {
    if (buffer instanceof Uint8Array) return buffer;
    else if (ArrayBuffer.isView(buffer)) return new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.byteLength);
    else if (buffer instanceof ArrayBuffer) return new Uint8Array(buffer);
    else // ArrayLike<number>
    return Uint8Array.from(buffer);
}
function $c5f9dc8c720865ff$export$7277868462c1ba02(buffer) {
    if (buffer instanceof ArrayBuffer) return new DataView(buffer);
    var bufferView = $c5f9dc8c720865ff$export$f8d669c2a17882f2(buffer);
    return new DataView(bufferView.buffer, bufferView.byteOffset, bufferView.byteLength);
}



var $95f9e548f895be71$var$DEFAULT_MAX_KEY_LENGTH = 16;
var $95f9e548f895be71$var$DEFAULT_MAX_LENGTH_PER_KEY = 16;
var $95f9e548f895be71$export$529b830450faf29c = /** @class */ function() {
    function CachedKeyDecoder(maxKeyLength, maxLengthPerKey) {
        if (maxKeyLength === void 0) maxKeyLength = $95f9e548f895be71$var$DEFAULT_MAX_KEY_LENGTH;
        if (maxLengthPerKey === void 0) maxLengthPerKey = $95f9e548f895be71$var$DEFAULT_MAX_LENGTH_PER_KEY;
        this.maxKeyLength = maxKeyLength;
        this.maxLengthPerKey = maxLengthPerKey;
        this.hit = 0;
        this.miss = 0;
        // avoid `new Array(N)`, which makes a sparse array,
        // because a sparse array is typically slower than a non-sparse array.
        this.caches = [];
        for(var i = 0; i < this.maxKeyLength; i++)this.caches.push([]);
    }
    CachedKeyDecoder.prototype.canBeCached = function(byteLength) {
        return byteLength > 0 && byteLength <= this.maxKeyLength;
    };
    CachedKeyDecoder.prototype.find = function(bytes, inputOffset, byteLength) {
        var records = this.caches[byteLength - 1];
        FIND_CHUNK: for(var _i = 0, records_1 = records; _i < records_1.length; _i++){
            var record = records_1[_i];
            var recordBytes = record.bytes;
            for(var j = 0; j < byteLength; j++){
                if (recordBytes[j] !== bytes[inputOffset + j]) continue FIND_CHUNK;
            }
            return record.str;
        }
        return null;
    };
    CachedKeyDecoder.prototype.store = function(bytes, value) {
        var records = this.caches[bytes.length - 1];
        var record = {
            bytes: bytes,
            str: value
        };
        if (records.length >= this.maxLengthPerKey) // `records` are full!
        // Set `record` to an arbitrary position.
        records[Math.random() * records.length | 0] = record;
        else records.push(record);
    };
    CachedKeyDecoder.prototype.decode = function(bytes, inputOffset, byteLength) {
        var cachedValue = this.find(bytes, inputOffset, byteLength);
        if (cachedValue != null) {
            this.hit++;
            return cachedValue;
        }
        this.miss++;
        var str = (0, $c96884cbd568d5d5$export$551117984c2adf4f)(bytes, inputOffset, byteLength);
        // Ensure to copy a slice of bytes because the byte may be NodeJS Buffer and Buffer#slice() returns a reference to its internal ArrayBuffer.
        var slicedCopyOfBytes = Uint8Array.prototype.slice.call(bytes, inputOffset, inputOffset + byteLength);
        this.store(slicedCopyOfBytes, str);
        return str;
    };
    return CachedKeyDecoder;
}();



var $6f529688330cd902$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6f529688330cd902$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $6f529688330cd902$var$__asyncValues = undefined && undefined.__asyncValues || function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $6f529688330cd902$var$__await = undefined && undefined.__await || function(v) {
    return this instanceof $6f529688330cd902$var$__await ? (this.v = v, this) : new $6f529688330cd902$var$__await(v);
};
var $6f529688330cd902$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $6f529688330cd902$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
var $6f529688330cd902$var$isValidMapKeyType = function(key) {
    var keyType = typeof key;
    return keyType === "string" || keyType === "number";
};
var $6f529688330cd902$var$HEAD_BYTE_REQUIRED = -1;
var $6f529688330cd902$var$EMPTY_VIEW = new DataView(new ArrayBuffer(0));
var $6f529688330cd902$var$EMPTY_BYTES = new Uint8Array($6f529688330cd902$var$EMPTY_VIEW.buffer);
var $6f529688330cd902$export$449c37eaf7093493 = function() {
    try {
        // IE11: The spec says it should throw RangeError,
        // IE11: but in IE11 it throws TypeError.
        $6f529688330cd902$var$EMPTY_VIEW.getInt8(0);
    } catch (e) {
        return e.constructor;
    }
    throw new Error("never reached");
}();
var $6f529688330cd902$var$MORE_DATA = new $6f529688330cd902$export$449c37eaf7093493("Insufficient data");
var $6f529688330cd902$var$sharedCachedKeyDecoder = new (0, $95f9e548f895be71$export$529b830450faf29c)();
var $6f529688330cd902$export$f9de6ca0bc043724 = /** @class */ function() {
    function Decoder(extensionCodec, context, maxStrLength, maxBinLength, maxArrayLength, maxMapLength, maxExtLength, keyDecoder) {
        if (extensionCodec === void 0) extensionCodec = (0, $5473c9f7ee128b2b$export$12677a794dbd89d7).defaultCodec;
        if (context === void 0) context = undefined;
        if (maxStrLength === void 0) maxStrLength = (0, $c6179d2c52c13237$export$3314b2c271c86d70);
        if (maxBinLength === void 0) maxBinLength = (0, $c6179d2c52c13237$export$3314b2c271c86d70);
        if (maxArrayLength === void 0) maxArrayLength = (0, $c6179d2c52c13237$export$3314b2c271c86d70);
        if (maxMapLength === void 0) maxMapLength = (0, $c6179d2c52c13237$export$3314b2c271c86d70);
        if (maxExtLength === void 0) maxExtLength = (0, $c6179d2c52c13237$export$3314b2c271c86d70);
        if (keyDecoder === void 0) keyDecoder = $6f529688330cd902$var$sharedCachedKeyDecoder;
        this.extensionCodec = extensionCodec;
        this.context = context;
        this.maxStrLength = maxStrLength;
        this.maxBinLength = maxBinLength;
        this.maxArrayLength = maxArrayLength;
        this.maxMapLength = maxMapLength;
        this.maxExtLength = maxExtLength;
        this.keyDecoder = keyDecoder;
        this.totalPos = 0;
        this.pos = 0;
        this.view = $6f529688330cd902$var$EMPTY_VIEW;
        this.bytes = $6f529688330cd902$var$EMPTY_BYTES;
        this.headByte = $6f529688330cd902$var$HEAD_BYTE_REQUIRED;
        this.stack = [];
    }
    Decoder.prototype.reinitializeState = function() {
        this.totalPos = 0;
        this.headByte = $6f529688330cd902$var$HEAD_BYTE_REQUIRED;
        this.stack.length = 0;
    // view, bytes, and pos will be re-initialized in setBuffer()
    };
    Decoder.prototype.setBuffer = function(buffer) {
        this.bytes = (0, $c5f9dc8c720865ff$export$f8d669c2a17882f2)(buffer);
        this.view = (0, $c5f9dc8c720865ff$export$7277868462c1ba02)(this.bytes);
        this.pos = 0;
    };
    Decoder.prototype.appendBuffer = function(buffer) {
        if (this.headByte === $6f529688330cd902$var$HEAD_BYTE_REQUIRED && !this.hasRemaining(1)) this.setBuffer(buffer);
        else {
            var remainingData = this.bytes.subarray(this.pos);
            var newData = (0, $c5f9dc8c720865ff$export$f8d669c2a17882f2)(buffer);
            // concat remainingData + newData
            var newBuffer = new Uint8Array(remainingData.length + newData.length);
            newBuffer.set(remainingData);
            newBuffer.set(newData, remainingData.length);
            this.setBuffer(newBuffer);
        }
    };
    Decoder.prototype.hasRemaining = function(size) {
        return this.view.byteLength - this.pos >= size;
    };
    Decoder.prototype.createExtraByteError = function(posToShow) {
        var _a = this, view = _a.view, pos = _a.pos;
        return new RangeError("Extra ".concat(view.byteLength - pos, " of ").concat(view.byteLength, " byte(s) found at buffer[").concat(posToShow, "]"));
    };
    /**
     * @throws {@link DecodeError}
     * @throws {@link RangeError}
     */ Decoder.prototype.decode = function(buffer) {
        this.reinitializeState();
        this.setBuffer(buffer);
        var object = this.doDecodeSync();
        if (this.hasRemaining(1)) throw this.createExtraByteError(this.pos);
        return object;
    };
    Decoder.prototype.decodeMulti = function(buffer) {
        return $6f529688330cd902$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    this.reinitializeState();
                    this.setBuffer(buffer);
                    _a.label = 1;
                case 1:
                    if (!this.hasRemaining(1)) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        this.doDecodeSync()
                    ];
                case 2:
                    _a.sent();
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    };
    Decoder.prototype.decodeAsync = function(stream) {
        var stream_1, stream_1_1;
        var e_1, _a;
        return $6f529688330cd902$var$__awaiter(this, void 0, void 0, function() {
            var decoded, object, buffer, e_1_1, _b, headByte, pos, totalPos;
            return $6f529688330cd902$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        decoded = false;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            6,
                            7,
                            12
                        ]);
                        stream_1 = $6f529688330cd902$var$__asyncValues(stream);
                        _c.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            stream_1.next()
                        ];
                    case 3:
                        if (!(stream_1_1 = _c.sent(), !stream_1_1.done)) return [
                            3 /*break*/ ,
                            5
                        ];
                        buffer = stream_1_1.value;
                        if (decoded) throw this.createExtraByteError(this.totalPos);
                        this.appendBuffer(buffer);
                        try {
                            object = this.doDecodeSync();
                            decoded = true;
                        } catch (e) {
                            if (!(e instanceof $6f529688330cd902$export$449c37eaf7093493)) throw e; // rethrow
                        // fallthrough
                        }
                        this.totalPos += this.pos;
                        _c.label = 4;
                    case 4:
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 5:
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 6:
                        e_1_1 = _c.sent();
                        e_1 = {
                            error: e_1_1
                        };
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 7:
                        _c.trys.push([
                            7,
                            ,
                            10,
                            11
                        ]);
                        if (!(stream_1_1 && !stream_1_1.done && (_a = stream_1.return))) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            _a.call(stream_1)
                        ];
                    case 8:
                        _c.sent();
                        _c.label = 9;
                    case 9:
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 10:
                        if (e_1) throw e_1.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 11:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 12:
                        if (decoded) {
                            if (this.hasRemaining(1)) throw this.createExtraByteError(this.totalPos);
                            return [
                                2 /*return*/ ,
                                object
                            ];
                        }
                        _b = this, headByte = _b.headByte, pos = _b.pos, totalPos = _b.totalPos;
                        throw new RangeError("Insufficient data in parsing ".concat((0, $910fba28ad75d713$export$78406e843f5312da)(headByte), " at ").concat(totalPos, " (").concat(pos, " in the current buffer)"));
                }
            });
        });
    };
    Decoder.prototype.decodeArrayStream = function(stream) {
        return this.decodeMultiAsync(stream, true);
    };
    Decoder.prototype.decodeStream = function(stream) {
        return this.decodeMultiAsync(stream, false);
    };
    Decoder.prototype.decodeMultiAsync = function(stream, isArray) {
        return $6f529688330cd902$var$__asyncGenerator(this, arguments, function decodeMultiAsync_1() {
            var isArrayHeaderRequired, arrayItemsLeft, stream_2, stream_2_1, buffer, e_2, e_3_1;
            var e_3, _a;
            return $6f529688330cd902$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        isArrayHeaderRequired = isArray;
                        arrayItemsLeft = -1;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            13,
                            14,
                            19
                        ]);
                        stream_2 = $6f529688330cd902$var$__asyncValues(stream);
                        _b.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            $6f529688330cd902$var$__await(stream_2.next())
                        ];
                    case 3:
                        if (!(stream_2_1 = _b.sent(), !stream_2_1.done)) return [
                            3 /*break*/ ,
                            12
                        ];
                        buffer = stream_2_1.value;
                        if (isArray && arrayItemsLeft === 0) throw this.createExtraByteError(this.totalPos);
                        this.appendBuffer(buffer);
                        if (isArrayHeaderRequired) {
                            arrayItemsLeft = this.readArraySize();
                            isArrayHeaderRequired = false;
                            this.complete();
                        }
                        _b.label = 4;
                    case 4:
                        _b.trys.push([
                            4,
                            9,
                            ,
                            10
                        ]);
                        _b.label = 5;
                    case 5:
                        return [
                            4 /*yield*/ ,
                            $6f529688330cd902$var$__await(this.doDecodeSync())
                        ];
                    case 6:
                        return [
                            4 /*yield*/ ,
                            _b.sent()
                        ];
                    case 7:
                        _b.sent();
                        if (--arrayItemsLeft === 0) return [
                            3 /*break*/ ,
                            8
                        ];
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 8:
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        e_2 = _b.sent();
                        if (!(e_2 instanceof $6f529688330cd902$export$449c37eaf7093493)) throw e_2; // rethrow
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 10:
                        this.totalPos += this.pos;
                        _b.label = 11;
                    case 11:
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 12:
                        return [
                            3 /*break*/ ,
                            19
                        ];
                    case 13:
                        e_3_1 = _b.sent();
                        e_3 = {
                            error: e_3_1
                        };
                        return [
                            3 /*break*/ ,
                            19
                        ];
                    case 14:
                        _b.trys.push([
                            14,
                            ,
                            17,
                            18
                        ]);
                        if (!(stream_2_1 && !stream_2_1.done && (_a = stream_2.return))) return [
                            3 /*break*/ ,
                            16
                        ];
                        return [
                            4 /*yield*/ ,
                            $6f529688330cd902$var$__await(_a.call(stream_2))
                        ];
                    case 15:
                        _b.sent();
                        _b.label = 16;
                    case 16:
                        return [
                            3 /*break*/ ,
                            18
                        ];
                    case 17:
                        if (e_3) throw e_3.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 18:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 19:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Decoder.prototype.doDecodeSync = function() {
        DECODE: while(true){
            var headByte = this.readHeadByte();
            var object = void 0;
            if (headByte >= 0xe0) // negative fixint (111x xxxx) 0xe0 - 0xff
            object = headByte - 0x100;
            else if (headByte < 0xc0) {
                if (headByte < 0x80) // positive fixint (0xxx xxxx) 0x00 - 0x7f
                object = headByte;
                else if (headByte < 0x90) {
                    // fixmap (1000 xxxx) 0x80 - 0x8f
                    var size = headByte - 0x80;
                    if (size !== 0) {
                        this.pushMapState(size);
                        this.complete();
                        continue DECODE;
                    } else object = {};
                } else if (headByte < 0xa0) {
                    // fixarray (1001 xxxx) 0x90 - 0x9f
                    var size = headByte - 0x90;
                    if (size !== 0) {
                        this.pushArrayState(size);
                        this.complete();
                        continue DECODE;
                    } else object = [];
                } else {
                    // fixstr (101x xxxx) 0xa0 - 0xbf
                    var byteLength = headByte - 0xa0;
                    object = this.decodeUtf8String(byteLength, 0);
                }
            } else if (headByte === 0xc0) // nil
            object = null;
            else if (headByte === 0xc2) // false
            object = false;
            else if (headByte === 0xc3) // true
            object = true;
            else if (headByte === 0xca) // float 32
            object = this.readF32();
            else if (headByte === 0xcb) // float 64
            object = this.readF64();
            else if (headByte === 0xcc) // uint 8
            object = this.readU8();
            else if (headByte === 0xcd) // uint 16
            object = this.readU16();
            else if (headByte === 0xce) // uint 32
            object = this.readU32();
            else if (headByte === 0xcf) // uint 64
            object = this.readU64();
            else if (headByte === 0xd0) // int 8
            object = this.readI8();
            else if (headByte === 0xd1) // int 16
            object = this.readI16();
            else if (headByte === 0xd2) // int 32
            object = this.readI32();
            else if (headByte === 0xd3) // int 64
            object = this.readI64();
            else if (headByte === 0xd9) {
                // str 8
                var byteLength = this.lookU8();
                object = this.decodeUtf8String(byteLength, 1);
            } else if (headByte === 0xda) {
                // str 16
                var byteLength = this.lookU16();
                object = this.decodeUtf8String(byteLength, 2);
            } else if (headByte === 0xdb) {
                // str 32
                var byteLength = this.lookU32();
                object = this.decodeUtf8String(byteLength, 4);
            } else if (headByte === 0xdc) {
                // array 16
                var size = this.readU16();
                if (size !== 0) {
                    this.pushArrayState(size);
                    this.complete();
                    continue DECODE;
                } else object = [];
            } else if (headByte === 0xdd) {
                // array 32
                var size = this.readU32();
                if (size !== 0) {
                    this.pushArrayState(size);
                    this.complete();
                    continue DECODE;
                } else object = [];
            } else if (headByte === 0xde) {
                // map 16
                var size = this.readU16();
                if (size !== 0) {
                    this.pushMapState(size);
                    this.complete();
                    continue DECODE;
                } else object = {};
            } else if (headByte === 0xdf) {
                // map 32
                var size = this.readU32();
                if (size !== 0) {
                    this.pushMapState(size);
                    this.complete();
                    continue DECODE;
                } else object = {};
            } else if (headByte === 0xc4) {
                // bin 8
                var size = this.lookU8();
                object = this.decodeBinary(size, 1);
            } else if (headByte === 0xc5) {
                // bin 16
                var size = this.lookU16();
                object = this.decodeBinary(size, 2);
            } else if (headByte === 0xc6) {
                // bin 32
                var size = this.lookU32();
                object = this.decodeBinary(size, 4);
            } else if (headByte === 0xd4) // fixext 1
            object = this.decodeExtension(1, 0);
            else if (headByte === 0xd5) // fixext 2
            object = this.decodeExtension(2, 0);
            else if (headByte === 0xd6) // fixext 4
            object = this.decodeExtension(4, 0);
            else if (headByte === 0xd7) // fixext 8
            object = this.decodeExtension(8, 0);
            else if (headByte === 0xd8) // fixext 16
            object = this.decodeExtension(16, 0);
            else if (headByte === 0xc7) {
                // ext 8
                var size = this.lookU8();
                object = this.decodeExtension(size, 1);
            } else if (headByte === 0xc8) {
                // ext 16
                var size = this.lookU16();
                object = this.decodeExtension(size, 2);
            } else if (headByte === 0xc9) {
                // ext 32
                var size = this.lookU32();
                object = this.decodeExtension(size, 4);
            } else throw new (0, $6ef4b54b91e46351$export$ef3eed12d06c0285)("Unrecognized type byte: ".concat((0, $910fba28ad75d713$export$78406e843f5312da)(headByte)));
            this.complete();
            var stack = this.stack;
            while(stack.length > 0){
                // arrays and maps
                var state = stack[stack.length - 1];
                if (state.type === 0 /* State.ARRAY */ ) {
                    state.array[state.position] = object;
                    state.position++;
                    if (state.position === state.size) {
                        stack.pop();
                        object = state.array;
                    } else continue DECODE;
                } else if (state.type === 1 /* State.MAP_KEY */ ) {
                    if (!$6f529688330cd902$var$isValidMapKeyType(object)) throw new (0, $6ef4b54b91e46351$export$ef3eed12d06c0285)("The type of key must be string or number but " + typeof object);
                    if (object === "__proto__") throw new (0, $6ef4b54b91e46351$export$ef3eed12d06c0285)("The key __proto__ is not allowed");
                    state.key = object;
                    state.type = 2 /* State.MAP_VALUE */ ;
                    continue DECODE;
                } else {
                    // it must be `state.type === State.MAP_VALUE` here
                    state.map[state.key] = object;
                    state.readCount++;
                    if (state.readCount === state.size) {
                        stack.pop();
                        object = state.map;
                    } else {
                        state.key = null;
                        state.type = 1 /* State.MAP_KEY */ ;
                        continue DECODE;
                    }
                }
            }
            return object;
        }
    };
    Decoder.prototype.readHeadByte = function() {
        if (this.headByte === $6f529688330cd902$var$HEAD_BYTE_REQUIRED) this.headByte = this.readU8();
        return this.headByte;
    };
    Decoder.prototype.complete = function() {
        this.headByte = $6f529688330cd902$var$HEAD_BYTE_REQUIRED;
    };
    Decoder.prototype.readArraySize = function() {
        var headByte = this.readHeadByte();
        switch(headByte){
            case 0xdc:
                return this.readU16();
            case 0xdd:
                return this.readU32();
            default:
                if (headByte < 0xa0) return headByte - 0x90;
                else throw new (0, $6ef4b54b91e46351$export$ef3eed12d06c0285)("Unrecognized array type byte: ".concat((0, $910fba28ad75d713$export$78406e843f5312da)(headByte)));
        }
    };
    Decoder.prototype.pushMapState = function(size) {
        if (size > this.maxMapLength) throw new (0, $6ef4b54b91e46351$export$ef3eed12d06c0285)("Max length exceeded: map length (".concat(size, ") > maxMapLengthLength (").concat(this.maxMapLength, ")"));
        this.stack.push({
            type: 1 /* State.MAP_KEY */ ,
            size: size,
            key: null,
            readCount: 0,
            map: {}
        });
    };
    Decoder.prototype.pushArrayState = function(size) {
        if (size > this.maxArrayLength) throw new (0, $6ef4b54b91e46351$export$ef3eed12d06c0285)("Max length exceeded: array length (".concat(size, ") > maxArrayLength (").concat(this.maxArrayLength, ")"));
        this.stack.push({
            type: 0 /* State.ARRAY */ ,
            size: size,
            array: new Array(size),
            position: 0
        });
    };
    Decoder.prototype.decodeUtf8String = function(byteLength, headerOffset) {
        var _a;
        if (byteLength > this.maxStrLength) throw new (0, $6ef4b54b91e46351$export$ef3eed12d06c0285)("Max length exceeded: UTF-8 byte length (".concat(byteLength, ") > maxStrLength (").concat(this.maxStrLength, ")"));
        if (this.bytes.byteLength < this.pos + headerOffset + byteLength) throw $6f529688330cd902$var$MORE_DATA;
        var offset = this.pos + headerOffset;
        var object;
        if (this.stateIsMapKey() && ((_a = this.keyDecoder) === null || _a === void 0 ? void 0 : _a.canBeCached(byteLength))) object = this.keyDecoder.decode(this.bytes, offset, byteLength);
        else if (byteLength > (0, $c96884cbd568d5d5$export$d866281c5a66d1ef)) object = (0, $c96884cbd568d5d5$export$6ed79e41309992dc)(this.bytes, offset, byteLength);
        else object = (0, $c96884cbd568d5d5$export$551117984c2adf4f)(this.bytes, offset, byteLength);
        this.pos += headerOffset + byteLength;
        return object;
    };
    Decoder.prototype.stateIsMapKey = function() {
        if (this.stack.length > 0) {
            var state = this.stack[this.stack.length - 1];
            return state.type === 1 /* State.MAP_KEY */ ;
        }
        return false;
    };
    Decoder.prototype.decodeBinary = function(byteLength, headOffset) {
        if (byteLength > this.maxBinLength) throw new (0, $6ef4b54b91e46351$export$ef3eed12d06c0285)("Max length exceeded: bin length (".concat(byteLength, ") > maxBinLength (").concat(this.maxBinLength, ")"));
        if (!this.hasRemaining(byteLength + headOffset)) throw $6f529688330cd902$var$MORE_DATA;
        var offset = this.pos + headOffset;
        var object = this.bytes.subarray(offset, offset + byteLength);
        this.pos += headOffset + byteLength;
        return object;
    };
    Decoder.prototype.decodeExtension = function(size, headOffset) {
        if (size > this.maxExtLength) throw new (0, $6ef4b54b91e46351$export$ef3eed12d06c0285)("Max length exceeded: ext length (".concat(size, ") > maxExtLength (").concat(this.maxExtLength, ")"));
        var extType = this.view.getInt8(this.pos + headOffset);
        var data = this.decodeBinary(size, headOffset + 1 /* extType */ );
        return this.extensionCodec.decode(data, extType, this.context);
    };
    Decoder.prototype.lookU8 = function() {
        return this.view.getUint8(this.pos);
    };
    Decoder.prototype.lookU16 = function() {
        return this.view.getUint16(this.pos);
    };
    Decoder.prototype.lookU32 = function() {
        return this.view.getUint32(this.pos);
    };
    Decoder.prototype.readU8 = function() {
        var value = this.view.getUint8(this.pos);
        this.pos++;
        return value;
    };
    Decoder.prototype.readI8 = function() {
        var value = this.view.getInt8(this.pos);
        this.pos++;
        return value;
    };
    Decoder.prototype.readU16 = function() {
        var value = this.view.getUint16(this.pos);
        this.pos += 2;
        return value;
    };
    Decoder.prototype.readI16 = function() {
        var value = this.view.getInt16(this.pos);
        this.pos += 2;
        return value;
    };
    Decoder.prototype.readU32 = function() {
        var value = this.view.getUint32(this.pos);
        this.pos += 4;
        return value;
    };
    Decoder.prototype.readI32 = function() {
        var value = this.view.getInt32(this.pos);
        this.pos += 4;
        return value;
    };
    Decoder.prototype.readU64 = function() {
        var value = (0, $c6179d2c52c13237$export$59a2dbf579ff9568)(this.view, this.pos);
        this.pos += 8;
        return value;
    };
    Decoder.prototype.readI64 = function() {
        var value = (0, $c6179d2c52c13237$export$69825c7adcc820c6)(this.view, this.pos);
        this.pos += 8;
        return value;
    };
    Decoder.prototype.readF32 = function() {
        var value = this.view.getFloat32(this.pos);
        this.pos += 4;
        return value;
    };
    Decoder.prototype.readF64 = function() {
        var value = this.view.getFloat64(this.pos);
        this.pos += 8;
        return value;
    };
    return Decoder;
}();


var $c0213129d1a1dc2a$export$ca6ec972f712a9eb = {};
function $c0213129d1a1dc2a$export$2f872c0f2117be69(buffer, options) {
    if (options === void 0) options = $c0213129d1a1dc2a$export$ca6ec972f712a9eb;
    var decoder = new (0, $6f529688330cd902$export$f9de6ca0bc043724)(options.extensionCodec, options.context, options.maxStrLength, options.maxBinLength, options.maxArrayLength, options.maxMapLength, options.maxExtLength);
    return decoder.decode(buffer);
}
function $c0213129d1a1dc2a$export$43cc91859d9fdc54(buffer, options) {
    if (options === void 0) options = $c0213129d1a1dc2a$export$ca6ec972f712a9eb;
    var decoder = new (0, $6f529688330cd902$export$f9de6ca0bc043724)(options.extensionCodec, options.context, options.maxStrLength, options.maxBinLength, options.maxArrayLength, options.maxMapLength, options.maxExtLength);
    return decoder.decodeMulti(buffer);
}





var $64d0f73f428941a0$export$2c6de1218fe0e46d = 100;
var $64d0f73f428941a0$export$29659805a45f979c = 2048;
var $64d0f73f428941a0$export$a50aceb0e02a00aa = /** @class */ function() {
    function Encoder(extensionCodec, context, maxDepth, initialBufferSize, sortKeys, forceFloat32, ignoreUndefined, forceIntegerToFloat) {
        if (extensionCodec === void 0) extensionCodec = (0, $5473c9f7ee128b2b$export$12677a794dbd89d7).defaultCodec;
        if (context === void 0) context = undefined;
        if (maxDepth === void 0) maxDepth = $64d0f73f428941a0$export$2c6de1218fe0e46d;
        if (initialBufferSize === void 0) initialBufferSize = $64d0f73f428941a0$export$29659805a45f979c;
        if (sortKeys === void 0) sortKeys = false;
        if (forceFloat32 === void 0) forceFloat32 = false;
        if (ignoreUndefined === void 0) ignoreUndefined = false;
        if (forceIntegerToFloat === void 0) forceIntegerToFloat = false;
        this.extensionCodec = extensionCodec;
        this.context = context;
        this.maxDepth = maxDepth;
        this.initialBufferSize = initialBufferSize;
        this.sortKeys = sortKeys;
        this.forceFloat32 = forceFloat32;
        this.ignoreUndefined = ignoreUndefined;
        this.forceIntegerToFloat = forceIntegerToFloat;
        this.pos = 0;
        this.view = new DataView(new ArrayBuffer(this.initialBufferSize));
        this.bytes = new Uint8Array(this.view.buffer);
    }
    Encoder.prototype.reinitializeState = function() {
        this.pos = 0;
    };
    /**
     * This is almost equivalent to {@link Encoder#encode}, but it returns an reference of the encoder's internal buffer and thus much faster than {@link Encoder#encode}.
     *
     * @returns Encodes the object and returns a shared reference the encoder's internal buffer.
     */ Encoder.prototype.encodeSharedRef = function(object) {
        this.reinitializeState();
        this.doEncode(object, 1);
        return this.bytes.subarray(0, this.pos);
    };
    /**
     * @returns Encodes the object and returns a copy of the encoder's internal buffer.
     */ Encoder.prototype.encode = function(object) {
        this.reinitializeState();
        this.doEncode(object, 1);
        return this.bytes.slice(0, this.pos);
    };
    Encoder.prototype.doEncode = function(object, depth) {
        if (depth > this.maxDepth) throw new Error("Too deep objects in depth ".concat(depth));
        if (object == null) this.encodeNil();
        else if (typeof object === "boolean") this.encodeBoolean(object);
        else if (typeof object === "number") this.encodeNumber(object);
        else if (typeof object === "string") this.encodeString(object);
        else this.encodeObject(object, depth);
    };
    Encoder.prototype.ensureBufferSizeToWrite = function(sizeToWrite) {
        var requiredSize = this.pos + sizeToWrite;
        if (this.view.byteLength < requiredSize) this.resizeBuffer(requiredSize * 2);
    };
    Encoder.prototype.resizeBuffer = function(newSize) {
        var newBuffer = new ArrayBuffer(newSize);
        var newBytes = new Uint8Array(newBuffer);
        var newView = new DataView(newBuffer);
        newBytes.set(this.bytes);
        this.view = newView;
        this.bytes = newBytes;
    };
    Encoder.prototype.encodeNil = function() {
        this.writeU8(0xc0);
    };
    Encoder.prototype.encodeBoolean = function(object) {
        if (object === false) this.writeU8(0xc2);
        else this.writeU8(0xc3);
    };
    Encoder.prototype.encodeNumber = function(object) {
        if (Number.isSafeInteger(object) && !this.forceIntegerToFloat) {
            if (object >= 0) {
                if (object < 0x80) // positive fixint
                this.writeU8(object);
                else if (object < 0x100) {
                    // uint 8
                    this.writeU8(0xcc);
                    this.writeU8(object);
                } else if (object < 0x10000) {
                    // uint 16
                    this.writeU8(0xcd);
                    this.writeU16(object);
                } else if (object < 0x100000000) {
                    // uint 32
                    this.writeU8(0xce);
                    this.writeU32(object);
                } else {
                    // uint 64
                    this.writeU8(0xcf);
                    this.writeU64(object);
                }
            } else {
                if (object >= -32) // negative fixint
                this.writeU8(0xe0 | object + 0x20);
                else if (object >= -128) {
                    // int 8
                    this.writeU8(0xd0);
                    this.writeI8(object);
                } else if (object >= -32768) {
                    // int 16
                    this.writeU8(0xd1);
                    this.writeI16(object);
                } else if (object >= -2147483648) {
                    // int 32
                    this.writeU8(0xd2);
                    this.writeI32(object);
                } else {
                    // int 64
                    this.writeU8(0xd3);
                    this.writeI64(object);
                }
            }
        } else // non-integer numbers
        if (this.forceFloat32) {
            // float 32
            this.writeU8(0xca);
            this.writeF32(object);
        } else {
            // float 64
            this.writeU8(0xcb);
            this.writeF64(object);
        }
    };
    Encoder.prototype.writeStringHeader = function(byteLength) {
        if (byteLength < 32) // fixstr
        this.writeU8(0xa0 + byteLength);
        else if (byteLength < 0x100) {
            // str 8
            this.writeU8(0xd9);
            this.writeU8(byteLength);
        } else if (byteLength < 0x10000) {
            // str 16
            this.writeU8(0xda);
            this.writeU16(byteLength);
        } else if (byteLength < 0x100000000) {
            // str 32
            this.writeU8(0xdb);
            this.writeU32(byteLength);
        } else throw new Error("Too long string: ".concat(byteLength, " bytes in UTF-8"));
    };
    Encoder.prototype.encodeString = function(object) {
        var maxHeaderSize = 5;
        var strLength = object.length;
        if (strLength > (0, $c96884cbd568d5d5$export$ed34c0622b397238)) {
            var byteLength = (0, $c96884cbd568d5d5$export$b61de95301265227)(object);
            this.ensureBufferSizeToWrite(maxHeaderSize + byteLength);
            this.writeStringHeader(byteLength);
            (0, $c96884cbd568d5d5$export$34cfdc82d430524)(object, this.bytes, this.pos);
            this.pos += byteLength;
        } else {
            var byteLength = (0, $c96884cbd568d5d5$export$b61de95301265227)(object);
            this.ensureBufferSizeToWrite(maxHeaderSize + byteLength);
            this.writeStringHeader(byteLength);
            (0, $c96884cbd568d5d5$export$1042e4338f1ef853)(object, this.bytes, this.pos);
            this.pos += byteLength;
        }
    };
    Encoder.prototype.encodeObject = function(object, depth) {
        // try to encode objects with custom codec first of non-primitives
        var ext = this.extensionCodec.tryToEncode(object, this.context);
        if (ext != null) this.encodeExtension(ext);
        else if (Array.isArray(object)) this.encodeArray(object, depth);
        else if (ArrayBuffer.isView(object)) this.encodeBinary(object);
        else if (typeof object === "object") this.encodeMap(object, depth);
        else // symbol, function and other special object come here unless extensionCodec handles them.
        throw new Error("Unrecognized object: ".concat(Object.prototype.toString.apply(object)));
    };
    Encoder.prototype.encodeBinary = function(object) {
        var size = object.byteLength;
        if (size < 0x100) {
            // bin 8
            this.writeU8(0xc4);
            this.writeU8(size);
        } else if (size < 0x10000) {
            // bin 16
            this.writeU8(0xc5);
            this.writeU16(size);
        } else if (size < 0x100000000) {
            // bin 32
            this.writeU8(0xc6);
            this.writeU32(size);
        } else throw new Error("Too large binary: ".concat(size));
        var bytes = (0, $c5f9dc8c720865ff$export$f8d669c2a17882f2)(object);
        this.writeU8a(bytes);
    };
    Encoder.prototype.encodeArray = function(object, depth) {
        var size = object.length;
        if (size < 16) // fixarray
        this.writeU8(0x90 + size);
        else if (size < 0x10000) {
            // array 16
            this.writeU8(0xdc);
            this.writeU16(size);
        } else if (size < 0x100000000) {
            // array 32
            this.writeU8(0xdd);
            this.writeU32(size);
        } else throw new Error("Too large array: ".concat(size));
        for(var _i = 0, object_1 = object; _i < object_1.length; _i++){
            var item = object_1[_i];
            this.doEncode(item, depth + 1);
        }
    };
    Encoder.prototype.countWithoutUndefined = function(object, keys) {
        var count = 0;
        for(var _i = 0, keys_1 = keys; _i < keys_1.length; _i++){
            var key = keys_1[_i];
            if (object[key] !== undefined) count++;
        }
        return count;
    };
    Encoder.prototype.encodeMap = function(object, depth) {
        var keys = Object.keys(object);
        if (this.sortKeys) keys.sort();
        var size = this.ignoreUndefined ? this.countWithoutUndefined(object, keys) : keys.length;
        if (size < 16) // fixmap
        this.writeU8(0x80 + size);
        else if (size < 0x10000) {
            // map 16
            this.writeU8(0xde);
            this.writeU16(size);
        } else if (size < 0x100000000) {
            // map 32
            this.writeU8(0xdf);
            this.writeU32(size);
        } else throw new Error("Too large map object: ".concat(size));
        for(var _i = 0, keys_2 = keys; _i < keys_2.length; _i++){
            var key = keys_2[_i];
            var value = object[key];
            if (!(this.ignoreUndefined && value === undefined)) {
                this.encodeString(key);
                this.doEncode(value, depth + 1);
            }
        }
    };
    Encoder.prototype.encodeExtension = function(ext) {
        var size = ext.data.length;
        if (size === 1) // fixext 1
        this.writeU8(0xd4);
        else if (size === 2) // fixext 2
        this.writeU8(0xd5);
        else if (size === 4) // fixext 4
        this.writeU8(0xd6);
        else if (size === 8) // fixext 8
        this.writeU8(0xd7);
        else if (size === 16) // fixext 16
        this.writeU8(0xd8);
        else if (size < 0x100) {
            // ext 8
            this.writeU8(0xc7);
            this.writeU8(size);
        } else if (size < 0x10000) {
            // ext 16
            this.writeU8(0xc8);
            this.writeU16(size);
        } else if (size < 0x100000000) {
            // ext 32
            this.writeU8(0xc9);
            this.writeU32(size);
        } else throw new Error("Too large extension object: ".concat(size));
        this.writeI8(ext.type);
        this.writeU8a(ext.data);
    };
    Encoder.prototype.writeU8 = function(value) {
        this.ensureBufferSizeToWrite(1);
        this.view.setUint8(this.pos, value);
        this.pos++;
    };
    Encoder.prototype.writeU8a = function(values) {
        var size = values.length;
        this.ensureBufferSizeToWrite(size);
        this.bytes.set(values, this.pos);
        this.pos += size;
    };
    Encoder.prototype.writeI8 = function(value) {
        this.ensureBufferSizeToWrite(1);
        this.view.setInt8(this.pos, value);
        this.pos++;
    };
    Encoder.prototype.writeU16 = function(value) {
        this.ensureBufferSizeToWrite(2);
        this.view.setUint16(this.pos, value);
        this.pos += 2;
    };
    Encoder.prototype.writeI16 = function(value) {
        this.ensureBufferSizeToWrite(2);
        this.view.setInt16(this.pos, value);
        this.pos += 2;
    };
    Encoder.prototype.writeU32 = function(value) {
        this.ensureBufferSizeToWrite(4);
        this.view.setUint32(this.pos, value);
        this.pos += 4;
    };
    Encoder.prototype.writeI32 = function(value) {
        this.ensureBufferSizeToWrite(4);
        this.view.setInt32(this.pos, value);
        this.pos += 4;
    };
    Encoder.prototype.writeF32 = function(value) {
        this.ensureBufferSizeToWrite(4);
        this.view.setFloat32(this.pos, value);
        this.pos += 4;
    };
    Encoder.prototype.writeF64 = function(value) {
        this.ensureBufferSizeToWrite(8);
        this.view.setFloat64(this.pos, value);
        this.pos += 8;
    };
    Encoder.prototype.writeU64 = function(value) {
        this.ensureBufferSizeToWrite(8);
        (0, $c6179d2c52c13237$export$20f71c4c8b0f96c3)(this.view, this.pos, value);
        this.pos += 8;
    };
    Encoder.prototype.writeI64 = function(value) {
        this.ensureBufferSizeToWrite(8);
        (0, $c6179d2c52c13237$export$8532a5209571c04a)(this.view, this.pos, value);
        this.pos += 8;
    };
    return Encoder;
}();


var $69bf5a6db05fb59d$var$defaultEncodeOptions = {};
function $69bf5a6db05fb59d$export$c564cdbbe6da493(value, options) {
    if (options === void 0) options = $69bf5a6db05fb59d$var$defaultEncodeOptions;
    var encoder = new (0, $64d0f73f428941a0$export$a50aceb0e02a00aa)(options.extensionCodec, options.context, options.maxDepth, options.initialBufferSize, options.sortKeys, options.forceFloat32, options.ignoreUndefined, options.forceIntegerToFloat);
    return encoder.encodeSharedRef(value);
}


var $21fad10a767337ad$exports = {};

var $fHA2F = parcelRequire("fHA2F");
'use strict';

var $lGjml = parcelRequire("lGjml");
var $21fad10a767337ad$require$Buffer = $lGjml.Buffer;

var $d2HdY = parcelRequire("d2HdY");
var $21fad10a767337ad$require$Transform = $d2HdY.Transform;
var $84b780ee88fc5cbe$exports = {};

var $lGjml = parcelRequire("lGjml");
var $84b780ee88fc5cbe$require$Buffer = $lGjml.Buffer;

var $fHA2F = parcelRequire("fHA2F");
'use strict';

var $hWeez = parcelRequire("hWeez");
var $9157a19f3760ca94$exports = {};
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $9157a19f3760ca94$var$ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = '' /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
$9157a19f3760ca94$exports = $9157a19f3760ca94$var$ZStream;


var $cba2acc47781bd54$export$72b35d618fb8ad9b;
var $cba2acc47781bd54$export$a65c7b2bde87cb70;
var $cba2acc47781bd54$export$8f99f0e30bc7dd53;
var $cba2acc47781bd54$export$e78fab288549509;
var $cba2acc47781bd54$export$1cd50f7b2515ba19;
var $cba2acc47781bd54$export$2316623ecd1285ab;
var $cba2acc47781bd54$export$599854fa319a815f;
var $cba2acc47781bd54$export$f55e0b3ab66b5d46;
var $cba2acc47781bd54$export$12b6e1fcadea22f9;
'use strict';
var $2c6a85ff7e4ce93b$exports = {};
'use strict';
var $2c6a85ff7e4ce93b$var$TYPED_OK = typeof Uint8Array !== 'undefined' && typeof Uint16Array !== 'undefined' && typeof Int32Array !== 'undefined';
function $2c6a85ff7e4ce93b$var$_has(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
$2c6a85ff7e4ce93b$exports.assign = function(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        var source = sources.shift();
        if (!source) continue;
        if (typeof source !== 'object') throw new TypeError(source + 'must be non-object');
        for(var p in source)if ($2c6a85ff7e4ce93b$var$_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// reduce buffer size, avoiding mem copy
$2c6a85ff7e4ce93b$exports.shrinkBuf = function(buf, size) {
    if (buf.length === size) return buf;
    if (buf.subarray) return buf.subarray(0, size);
    buf.length = size;
    return buf;
};
var $2c6a85ff7e4ce93b$var$fnTyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        if (src.subarray && dest.subarray) {
            dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
            return;
        }
        // Fallback to ordinary array
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        var i, l, len, pos, chunk, result;
        // calculate data length
        len = 0;
        for(i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
        // join chunks
        result = new Uint8Array(len);
        pos = 0;
        for(i = 0, l = chunks.length; i < l; i++){
            chunk = chunks[i];
            result.set(chunk, pos);
            pos += chunk.length;
        }
        return result;
    }
};
var $2c6a85ff7e4ce93b$var$fnUntyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        return [].concat.apply([], chunks);
    }
};
// Enable/Disable typed arrays use, for testing
//
$2c6a85ff7e4ce93b$exports.setTyped = function(on) {
    if (on) {
        $2c6a85ff7e4ce93b$exports.Buf8 = Uint8Array;
        $2c6a85ff7e4ce93b$exports.Buf16 = Uint16Array;
        $2c6a85ff7e4ce93b$exports.Buf32 = Int32Array;
        $2c6a85ff7e4ce93b$exports.assign($2c6a85ff7e4ce93b$exports, $2c6a85ff7e4ce93b$var$fnTyped);
    } else {
        $2c6a85ff7e4ce93b$exports.Buf8 = Array;
        $2c6a85ff7e4ce93b$exports.Buf16 = Array;
        $2c6a85ff7e4ce93b$exports.Buf32 = Array;
        $2c6a85ff7e4ce93b$exports.assign($2c6a85ff7e4ce93b$exports, $2c6a85ff7e4ce93b$var$fnUntyped);
    }
};
$2c6a85ff7e4ce93b$exports.setTyped($2c6a85ff7e4ce93b$var$TYPED_OK);


var $d7b5f0f953a31c06$export$4e4fc0157c3cd14d;
var $d7b5f0f953a31c06$export$8959e34c5e020172;
var $d7b5f0f953a31c06$export$44f15b52eef0cf41;
var $d7b5f0f953a31c06$export$b3cbce147289408f;
var $d7b5f0f953a31c06$export$bfb360e02ee9b403;
'use strict';

/* Public constants ==========================================================*/ /* ===========================================================================*/ //var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var $d7b5f0f953a31c06$var$Z_FIXED = 4;
//var Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ var $d7b5f0f953a31c06$var$Z_BINARY = 0;
var $d7b5f0f953a31c06$var$Z_TEXT = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var $d7b5f0f953a31c06$var$Z_UNKNOWN = 2;
/*============================================================================*/ function $d7b5f0f953a31c06$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
var $d7b5f0f953a31c06$var$STORED_BLOCK = 0;
var $d7b5f0f953a31c06$var$STATIC_TREES = 1;
var $d7b5f0f953a31c06$var$DYN_TREES = 2;
/* The three kinds of block type */ var $d7b5f0f953a31c06$var$MIN_MATCH = 3;
var $d7b5f0f953a31c06$var$MAX_MATCH = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ var $d7b5f0f953a31c06$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $d7b5f0f953a31c06$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $d7b5f0f953a31c06$var$L_CODES = $d7b5f0f953a31c06$var$LITERALS + 1 + $d7b5f0f953a31c06$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $d7b5f0f953a31c06$var$D_CODES = 30;
/* number of distance codes */ var $d7b5f0f953a31c06$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $d7b5f0f953a31c06$var$HEAP_SIZE = 2 * $d7b5f0f953a31c06$var$L_CODES + 1;
/* maximum heap size */ var $d7b5f0f953a31c06$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $d7b5f0f953a31c06$var$Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ var $d7b5f0f953a31c06$var$MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ var $d7b5f0f953a31c06$var$END_BLOCK = 256;
/* end of block literal code */ var $d7b5f0f953a31c06$var$REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ var $d7b5f0f953a31c06$var$REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ var $d7b5f0f953a31c06$var$REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ var $d7b5f0f953a31c06$var$extra_lbits = /* extra bits for each length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
];
var $d7b5f0f953a31c06$var$extra_dbits = /* extra bits for each distance code */ [
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
];
var $d7b5f0f953a31c06$var$extra_blbits = /* extra bits for each bit length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
];
var $d7b5f0f953a31c06$var$bl_order = [
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
];
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
var $d7b5f0f953a31c06$var$DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var $d7b5f0f953a31c06$var$static_ltree = new Array(($d7b5f0f953a31c06$var$L_CODES + 2) * 2);
$d7b5f0f953a31c06$var$zero($d7b5f0f953a31c06$var$static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ var $d7b5f0f953a31c06$var$static_dtree = new Array($d7b5f0f953a31c06$var$D_CODES * 2);
$d7b5f0f953a31c06$var$zero($d7b5f0f953a31c06$var$static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ var $d7b5f0f953a31c06$var$_dist_code = new Array($d7b5f0f953a31c06$var$DIST_CODE_LEN);
$d7b5f0f953a31c06$var$zero($d7b5f0f953a31c06$var$_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ var $d7b5f0f953a31c06$var$_length_code = new Array($d7b5f0f953a31c06$var$MAX_MATCH - $d7b5f0f953a31c06$var$MIN_MATCH + 1);
$d7b5f0f953a31c06$var$zero($d7b5f0f953a31c06$var$_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ var $d7b5f0f953a31c06$var$base_length = new Array($d7b5f0f953a31c06$var$LENGTH_CODES);
$d7b5f0f953a31c06$var$zero($d7b5f0f953a31c06$var$base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ var $d7b5f0f953a31c06$var$base_dist = new Array($d7b5f0f953a31c06$var$D_CODES);
$d7b5f0f953a31c06$var$zero($d7b5f0f953a31c06$var$base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function $d7b5f0f953a31c06$var$StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
var $d7b5f0f953a31c06$var$static_l_desc;
var $d7b5f0f953a31c06$var$static_d_desc;
var $d7b5f0f953a31c06$var$static_bl_desc;
function $d7b5f0f953a31c06$var$TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
function $d7b5f0f953a31c06$var$d_code(dist) {
    return dist < 256 ? $d7b5f0f953a31c06$var$_dist_code[dist] : $d7b5f0f953a31c06$var$_dist_code[256 + (dist >>> 7)];
}
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ function $d7b5f0f953a31c06$var$put_short(s, w) {
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
}
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ function $d7b5f0f953a31c06$var$send_bits(s, value, length) {
    if (s.bi_valid > $d7b5f0f953a31c06$var$Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        $d7b5f0f953a31c06$var$put_short(s, s.bi_buf);
        s.bi_buf = value >> $d7b5f0f953a31c06$var$Buf_size - s.bi_valid;
        s.bi_valid += length - $d7b5f0f953a31c06$var$Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
}
function $d7b5f0f953a31c06$var$send_code(s, c, tree) {
    $d7b5f0f953a31c06$var$send_bits(s, tree[c * 2], tree[c * 2 + 1]);
}
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ function $d7b5f0f953a31c06$var$bi_reverse(code, len) {
    var res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
}
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ function $d7b5f0f953a31c06$var$bi_flush(s) {
    if (s.bi_valid === 16) {
        $d7b5f0f953a31c06$var$put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
}
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ function $d7b5f0f953a31c06$var$gen_bitlen(s, desc) //    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var max_code = desc.max_code;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var extra = desc.stat_desc.extra_bits;
    var base = desc.stat_desc.extra_base;
    var max_length = desc.stat_desc.max_length;
    var h; /* heap index */ 
    var n, m; /* iterate over the tree elements */ 
    var bits; /* bit length */ 
    var xbits; /* extra bits */ 
    var f; /* frequency */ 
    var overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= $d7b5f0f953a31c06$var$MAX_BITS; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < $d7b5f0f953a31c06$var$HEAP_SIZE; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Trace((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
}
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ function $d7b5f0f953a31c06$var$gen_codes(tree, max_code, bl_count) //    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
    var next_code = new Array($d7b5f0f953a31c06$var$MAX_BITS + 1); /* next code value for each bit length */ 
    var code = 0; /* running code value */ 
    var bits; /* bit index */ 
    var n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= $d7b5f0f953a31c06$var$MAX_BITS; bits++)next_code[bits] = code = code + bl_count[bits - 1] << 1;
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        var len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = $d7b5f0f953a31c06$var$bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
}
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ function $d7b5f0f953a31c06$var$tr_static_init() {
    var n; /* iterates over tree elements */ 
    var bits; /* bit counter */ 
    var length; /* length value */ 
    var code; /* code value */ 
    var dist; /* distance index */ 
    var bl_count = new Array($d7b5f0f953a31c06$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < $d7b5f0f953a31c06$var$LENGTH_CODES - 1; code++){
        $d7b5f0f953a31c06$var$base_length[code] = length;
        for(n = 0; n < 1 << $d7b5f0f953a31c06$var$extra_lbits[code]; n++)$d7b5f0f953a31c06$var$_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ $d7b5f0f953a31c06$var$_length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        $d7b5f0f953a31c06$var$base_dist[code] = dist;
        for(n = 0; n < 1 << $d7b5f0f953a31c06$var$extra_dbits[code]; n++)$d7b5f0f953a31c06$var$_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < $d7b5f0f953a31c06$var$D_CODES; code++){
        $d7b5f0f953a31c06$var$base_dist[code] = dist << 7;
        for(n = 0; n < 1 << $d7b5f0f953a31c06$var$extra_dbits[code] - 7; n++)$d7b5f0f953a31c06$var$_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= $d7b5f0f953a31c06$var$MAX_BITS; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        $d7b5f0f953a31c06$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        $d7b5f0f953a31c06$var$static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        $d7b5f0f953a31c06$var$static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        $d7b5f0f953a31c06$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ $d7b5f0f953a31c06$var$gen_codes($d7b5f0f953a31c06$var$static_ltree, $d7b5f0f953a31c06$var$L_CODES + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < $d7b5f0f953a31c06$var$D_CODES; n++){
        $d7b5f0f953a31c06$var$static_dtree[n * 2 + 1] = 5;
        $d7b5f0f953a31c06$var$static_dtree[n * 2] = $d7b5f0f953a31c06$var$bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    $d7b5f0f953a31c06$var$static_l_desc = new $d7b5f0f953a31c06$var$StaticTreeDesc($d7b5f0f953a31c06$var$static_ltree, $d7b5f0f953a31c06$var$extra_lbits, $d7b5f0f953a31c06$var$LITERALS + 1, $d7b5f0f953a31c06$var$L_CODES, $d7b5f0f953a31c06$var$MAX_BITS);
    $d7b5f0f953a31c06$var$static_d_desc = new $d7b5f0f953a31c06$var$StaticTreeDesc($d7b5f0f953a31c06$var$static_dtree, $d7b5f0f953a31c06$var$extra_dbits, 0, $d7b5f0f953a31c06$var$D_CODES, $d7b5f0f953a31c06$var$MAX_BITS);
    $d7b5f0f953a31c06$var$static_bl_desc = new $d7b5f0f953a31c06$var$StaticTreeDesc(new Array(0), $d7b5f0f953a31c06$var$extra_blbits, 0, $d7b5f0f953a31c06$var$BL_CODES, $d7b5f0f953a31c06$var$MAX_BL_BITS);
//static_init_done = true;
}
/* ===========================================================================
 * Initialize a new block.
 */ function $d7b5f0f953a31c06$var$init_block(s) {
    var n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < $d7b5f0f953a31c06$var$L_CODES; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < $d7b5f0f953a31c06$var$D_CODES; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < $d7b5f0f953a31c06$var$BL_CODES; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[$d7b5f0f953a31c06$var$END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.last_lit = s.matches = 0;
}
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ function $d7b5f0f953a31c06$var$bi_windup(s) {
    if (s.bi_valid > 8) $d7b5f0f953a31c06$var$put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
}
/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */ function $d7b5f0f953a31c06$var$copy_block(s, buf, len, header) //DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
    $d7b5f0f953a31c06$var$bi_windup(s); /* align on byte boundary */ 
    if (header) {
        $d7b5f0f953a31c06$var$put_short(s, len);
        $d7b5f0f953a31c06$var$put_short(s, ~len);
    }
    //  while (len--) {
    //    put_byte(s, *buf++);
    //  }
    $2c6a85ff7e4ce93b$exports.arraySet(s.pending_buf, s.window, buf, len, s.pending);
    s.pending += len;
}
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ function $d7b5f0f953a31c06$var$smaller(tree, n, m, depth) {
    var _n2 = n * 2;
    var _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
}
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ function $d7b5f0f953a31c06$var$pqdownheap(s, tree, k) //    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
    var v = s.heap[k];
    var j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && $d7b5f0f953a31c06$var$smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if ($d7b5f0f953a31c06$var$smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
}
// inlined manually
// var SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ function $d7b5f0f953a31c06$var$compress_block(s, ltree, dtree) //    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
    var dist; /* distance of matched string */ 
    var lc; /* match length or unmatched char (if dist == 0) */ 
    var lx = 0; /* running index in l_buf */ 
    var code; /* the code to send */ 
    var extra; /* number of extra bits to send */ 
    if (s.last_lit !== 0) do {
        dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
        lc = s.pending_buf[s.l_buf + lx];
        lx++;
        if (dist === 0) $d7b5f0f953a31c06$var$send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = $d7b5f0f953a31c06$var$_length_code[lc];
            $d7b5f0f953a31c06$var$send_code(s, code + $d7b5f0f953a31c06$var$LITERALS + 1, ltree); /* send the length code */ 
            extra = $d7b5f0f953a31c06$var$extra_lbits[code];
            if (extra !== 0) {
                lc -= $d7b5f0f953a31c06$var$base_length[code];
                $d7b5f0f953a31c06$var$send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = $d7b5f0f953a31c06$var$d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            $d7b5f0f953a31c06$var$send_code(s, code, dtree); /* send the distance code */ 
            extra = $d7b5f0f953a31c06$var$extra_dbits[code];
            if (extra !== 0) {
                dist -= $d7b5f0f953a31c06$var$base_dist[code];
                $d7b5f0f953a31c06$var$send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */ //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
    //       "pendingBuf overflow");
    }while (lx < s.last_lit);
    $d7b5f0f953a31c06$var$send_code(s, $d7b5f0f953a31c06$var$END_BLOCK, ltree);
}
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ function $d7b5f0f953a31c06$var$build_tree(s, desc) //    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var elems = desc.stat_desc.elems;
    var n, m; /* iterate over heap elements */ 
    var max_code = -1; /* largest code with non zero frequency */ 
    var node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = $d7b5f0f953a31c06$var$HEAP_SIZE;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)$d7b5f0f953a31c06$var$pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        $d7b5f0f953a31c06$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        $d7b5f0f953a31c06$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ $d7b5f0f953a31c06$var$gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ $d7b5f0f953a31c06$var$gen_codes(tree, max_code, s.bl_count);
}
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ function $d7b5f0f953a31c06$var$scan_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[$d7b5f0f953a31c06$var$REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[$d7b5f0f953a31c06$var$REPZ_3_10 * 2]++;
        else s.bl_tree[$d7b5f0f953a31c06$var$REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ function $d7b5f0f953a31c06$var$send_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do $d7b5f0f953a31c06$var$send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                $d7b5f0f953a31c06$var$send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            $d7b5f0f953a31c06$var$send_code(s, $d7b5f0f953a31c06$var$REP_3_6, s.bl_tree);
            $d7b5f0f953a31c06$var$send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            $d7b5f0f953a31c06$var$send_code(s, $d7b5f0f953a31c06$var$REPZ_3_10, s.bl_tree);
            $d7b5f0f953a31c06$var$send_bits(s, count - 3, 3);
        } else {
            $d7b5f0f953a31c06$var$send_code(s, $d7b5f0f953a31c06$var$REPZ_11_138, s.bl_tree);
            $d7b5f0f953a31c06$var$send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ function $d7b5f0f953a31c06$var$build_bl_tree(s) {
    var max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ $d7b5f0f953a31c06$var$scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    $d7b5f0f953a31c06$var$scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ $d7b5f0f953a31c06$var$build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = $d7b5f0f953a31c06$var$BL_CODES - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[$d7b5f0f953a31c06$var$bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
}
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ function $d7b5f0f953a31c06$var$send_all_trees(s, lcodes, dcodes, blcodes) //    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
    var rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    $d7b5f0f953a31c06$var$send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    $d7b5f0f953a31c06$var$send_bits(s, dcodes - 1, 5);
    $d7b5f0f953a31c06$var$send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    $d7b5f0f953a31c06$var$send_bits(s, s.bl_tree[$d7b5f0f953a31c06$var$bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    $d7b5f0f953a31c06$var$send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    $d7b5f0f953a31c06$var$send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ function $d7b5f0f953a31c06$var$detect_data_type(s) {
    /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ var black_mask = 0xf3ffc07f;
    var n;
    /* Check for non-textual ("black-listed") bytes. */ for(n = 0; n <= 31; n++, black_mask >>>= 1){
        if (black_mask & 1 && s.dyn_ltree[n * 2] !== 0) return $d7b5f0f953a31c06$var$Z_BINARY;
    }
    /* Check for textual ("white-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return $d7b5f0f953a31c06$var$Z_TEXT;
    for(n = 32; n < $d7b5f0f953a31c06$var$LITERALS; n++){
        if (s.dyn_ltree[n * 2] !== 0) return $d7b5f0f953a31c06$var$Z_TEXT;
    }
    /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return $d7b5f0f953a31c06$var$Z_BINARY;
}
var $d7b5f0f953a31c06$var$static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ function $d7b5f0f953a31c06$var$_tr_init(s) {
    if (!$d7b5f0f953a31c06$var$static_init_done) {
        $d7b5f0f953a31c06$var$tr_static_init();
        $d7b5f0f953a31c06$var$static_init_done = true;
    }
    s.l_desc = new $d7b5f0f953a31c06$var$TreeDesc(s.dyn_ltree, $d7b5f0f953a31c06$var$static_l_desc);
    s.d_desc = new $d7b5f0f953a31c06$var$TreeDesc(s.dyn_dtree, $d7b5f0f953a31c06$var$static_d_desc);
    s.bl_desc = new $d7b5f0f953a31c06$var$TreeDesc(s.bl_tree, $d7b5f0f953a31c06$var$static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ $d7b5f0f953a31c06$var$init_block(s);
}
/* ===========================================================================
 * Send a stored block
 */ function $d7b5f0f953a31c06$var$_tr_stored_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    $d7b5f0f953a31c06$var$send_bits(s, ($d7b5f0f953a31c06$var$STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    $d7b5f0f953a31c06$var$copy_block(s, buf, stored_len, true); /* with header */ 
}
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ function $d7b5f0f953a31c06$var$_tr_align(s) {
    $d7b5f0f953a31c06$var$send_bits(s, $d7b5f0f953a31c06$var$STATIC_TREES << 1, 3);
    $d7b5f0f953a31c06$var$send_code(s, $d7b5f0f953a31c06$var$END_BLOCK, $d7b5f0f953a31c06$var$static_ltree);
    $d7b5f0f953a31c06$var$bi_flush(s);
}
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */ function $d7b5f0f953a31c06$var$_tr_flush_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    var opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    var max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === $d7b5f0f953a31c06$var$Z_UNKNOWN) s.strm.data_type = $d7b5f0f953a31c06$var$detect_data_type(s);
        /* Construct the literal and distance trees */ $d7b5f0f953a31c06$var$build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        $d7b5f0f953a31c06$var$build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = $d7b5f0f953a31c06$var$build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->last_lit));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ $d7b5f0f953a31c06$var$_tr_stored_block(s, buf, stored_len, last);
    else if (s.strategy === $d7b5f0f953a31c06$var$Z_FIXED || static_lenb === opt_lenb) {
        $d7b5f0f953a31c06$var$send_bits(s, ($d7b5f0f953a31c06$var$STATIC_TREES << 1) + (last ? 1 : 0), 3);
        $d7b5f0f953a31c06$var$compress_block(s, $d7b5f0f953a31c06$var$static_ltree, $d7b5f0f953a31c06$var$static_dtree);
    } else {
        $d7b5f0f953a31c06$var$send_bits(s, ($d7b5f0f953a31c06$var$DYN_TREES << 1) + (last ? 1 : 0), 3);
        $d7b5f0f953a31c06$var$send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        $d7b5f0f953a31c06$var$compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ $d7b5f0f953a31c06$var$init_block(s);
    if (last) $d7b5f0f953a31c06$var$bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
}
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ function $d7b5f0f953a31c06$var$_tr_tally(s, dist, lc) //    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
    //var out_length, in_length, dcode;
    s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
    s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
    s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
    s.last_lit++;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[($d7b5f0f953a31c06$var$_length_code[lc] + $d7b5f0f953a31c06$var$LITERALS + 1) * 2]++;
        s.dyn_dtree[$d7b5f0f953a31c06$var$d_code(dist) * 2]++;
    }
    // (!) This block is disabled in zlib defaults,
    // don't enable it for binary compatibility
    //#ifdef TRUNCATE_BLOCK
    //  /* Try to guess if it is profitable to stop the current block here */
    //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
    //    /* Compute an upper bound for the compressed length */
    //    out_length = s.last_lit*8;
    //    in_length = s.strstart - s.block_start;
    //
    //    for (dcode = 0; dcode < D_CODES; dcode++) {
    //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
    //    }
    //    out_length >>>= 3;
    //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
    //    //       s->last_lit, in_length, out_length,
    //    //       100L - out_length*100L/in_length));
    //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
    //      return true;
    //    }
    //  }
    //#endif
    return s.last_lit === s.lit_bufsize - 1;
/* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ }
$d7b5f0f953a31c06$export$4e4fc0157c3cd14d = $d7b5f0f953a31c06$var$_tr_init;
$d7b5f0f953a31c06$export$8959e34c5e020172 = $d7b5f0f953a31c06$var$_tr_stored_block;
$d7b5f0f953a31c06$export$44f15b52eef0cf41 = $d7b5f0f953a31c06$var$_tr_flush_block;
$d7b5f0f953a31c06$export$b3cbce147289408f = $d7b5f0f953a31c06$var$_tr_tally;
$d7b5f0f953a31c06$export$bfb360e02ee9b403 = $d7b5f0f953a31c06$var$_tr_align;


var $e6e0cd37d3935915$exports = {};
'use strict';
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $e6e0cd37d3935915$var$adler32(adler, buf, len, pos) {
    var s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
}
$e6e0cd37d3935915$exports = $e6e0cd37d3935915$var$adler32;


var $abfa54b01eefbc9c$exports = {};
'use strict';
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
function $abfa54b01eefbc9c$var$makeTable() {
    var c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
}
// Create table on load. Just 255 signed longs. Not a problem.
var $abfa54b01eefbc9c$var$crcTable = $abfa54b01eefbc9c$var$makeTable();
function $abfa54b01eefbc9c$var$crc32(crc, buf, len, pos) {
    var t = $abfa54b01eefbc9c$var$crcTable, end = pos + len;
    crc ^= -1;
    for(var i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
}
$abfa54b01eefbc9c$exports = $abfa54b01eefbc9c$var$crc32;


var $c8d047d9ac274ccd$exports = {};
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
$c8d047d9ac274ccd$exports = {
    2: 'need dictionary',
    /* Z_NEED_DICT       2  */ 1: 'stream end',
    /* Z_STREAM_END      1  */ 0: '',
    /* Z_OK              0  */ '-1': 'file error',
    /* Z_ERRNO         (-1) */ '-2': 'stream error',
    /* Z_STREAM_ERROR  (-2) */ '-3': 'data error',
    /* Z_DATA_ERROR    (-3) */ '-4': 'insufficient memory',
    /* Z_MEM_ERROR     (-4) */ '-5': 'buffer error',
    /* Z_BUF_ERROR     (-5) */ '-6': 'incompatible version' /* Z_VERSION_ERROR (-6) */ 
};


/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ var $cba2acc47781bd54$var$Z_NO_FLUSH = 0;
var $cba2acc47781bd54$var$Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var $cba2acc47781bd54$var$Z_FULL_FLUSH = 3;
var $cba2acc47781bd54$var$Z_FINISH = 4;
var $cba2acc47781bd54$var$Z_BLOCK = 5;
//var Z_TREES         = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $cba2acc47781bd54$var$Z_OK = 0;
var $cba2acc47781bd54$var$Z_STREAM_END = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var $cba2acc47781bd54$var$Z_STREAM_ERROR = -2;
var $cba2acc47781bd54$var$Z_DATA_ERROR = -3;
//var Z_MEM_ERROR     = -4;
var $cba2acc47781bd54$var$Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* compression levels */ //var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var $cba2acc47781bd54$var$Z_DEFAULT_COMPRESSION = -1;
var $cba2acc47781bd54$var$Z_FILTERED = 1;
var $cba2acc47781bd54$var$Z_HUFFMAN_ONLY = 2;
var $cba2acc47781bd54$var$Z_RLE = 3;
var $cba2acc47781bd54$var$Z_FIXED = 4;
var $cba2acc47781bd54$var$Z_DEFAULT_STRATEGY = 0;
/* Possible values of the data_type field (though see inflate()) */ //var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var $cba2acc47781bd54$var$Z_UNKNOWN = 2;
/* The deflate compression method */ var $cba2acc47781bd54$var$Z_DEFLATED = 8;
/*============================================================================*/ var $cba2acc47781bd54$var$MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ var $cba2acc47781bd54$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $cba2acc47781bd54$var$DEF_MEM_LEVEL = 8;
var $cba2acc47781bd54$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $cba2acc47781bd54$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $cba2acc47781bd54$var$L_CODES = $cba2acc47781bd54$var$LITERALS + 1 + $cba2acc47781bd54$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $cba2acc47781bd54$var$D_CODES = 30;
/* number of distance codes */ var $cba2acc47781bd54$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $cba2acc47781bd54$var$HEAP_SIZE = 2 * $cba2acc47781bd54$var$L_CODES + 1;
/* maximum heap size */ var $cba2acc47781bd54$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $cba2acc47781bd54$var$MIN_MATCH = 3;
var $cba2acc47781bd54$var$MAX_MATCH = 258;
var $cba2acc47781bd54$var$MIN_LOOKAHEAD = $cba2acc47781bd54$var$MAX_MATCH + $cba2acc47781bd54$var$MIN_MATCH + 1;
var $cba2acc47781bd54$var$PRESET_DICT = 0x20;
var $cba2acc47781bd54$var$INIT_STATE = 42;
var $cba2acc47781bd54$var$EXTRA_STATE = 69;
var $cba2acc47781bd54$var$NAME_STATE = 73;
var $cba2acc47781bd54$var$COMMENT_STATE = 91;
var $cba2acc47781bd54$var$HCRC_STATE = 103;
var $cba2acc47781bd54$var$BUSY_STATE = 113;
var $cba2acc47781bd54$var$FINISH_STATE = 666;
var $cba2acc47781bd54$var$BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
var $cba2acc47781bd54$var$BS_BLOCK_DONE = 2; /* block flush performed */ 
var $cba2acc47781bd54$var$BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
var $cba2acc47781bd54$var$BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
var $cba2acc47781bd54$var$OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
function $cba2acc47781bd54$var$err(strm, errorCode) {
    strm.msg = $c8d047d9ac274ccd$exports[errorCode];
    return errorCode;
}
function $cba2acc47781bd54$var$rank(f) {
    return (f << 1) - (f > 4 ? 9 : 0);
}
function $cba2acc47781bd54$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */ function $cba2acc47781bd54$var$flush_pending(strm) {
    var s = strm.state;
    //_tr_flush_bits(s);
    var len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    $2c6a85ff7e4ce93b$exports.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
}
function $cba2acc47781bd54$var$flush_block_only(s, last) {
    $d7b5f0f953a31c06$export$44f15b52eef0cf41(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    $cba2acc47781bd54$var$flush_pending(s.strm);
}
function $cba2acc47781bd54$var$put_byte(s, b) {
    s.pending_buf[s.pending++] = b;
}
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ function $cba2acc47781bd54$var$putShortMSB(s, b) {
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
}
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ function $cba2acc47781bd54$var$read_buf(strm, buf, start, size) {
    var len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    $2c6a85ff7e4ce93b$exports.arraySet(buf, strm.input, strm.next_in, len, start);
    if (strm.state.wrap === 1) strm.adler = $e6e0cd37d3935915$exports(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = $abfa54b01eefbc9c$exports(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
}
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ function $cba2acc47781bd54$var$longest_match(s, cur_match) {
    var chain_length = s.max_chain_length; /* max hash chain length */ 
    var scan = s.strstart; /* current string */ 
    var match; /* matched string */ 
    var len; /* length of current match */ 
    var best_len = s.prev_length; /* best match length so far */ 
    var nice_match = s.nice_match; /* stop if match long enough */ 
    var limit = s.strstart > s.w_size - $cba2acc47781bd54$var$MIN_LOOKAHEAD ? s.strstart - (s.w_size - $cba2acc47781bd54$var$MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    var _win = s.window; // shortcut
    var wmask = s.w_mask;
    var prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ var strend = s.strstart + $cba2acc47781bd54$var$MAX_MATCH;
    var scan_end1 = _win[scan + best_len - 1];
    var scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = $cba2acc47781bd54$var$MAX_MATCH - (strend - scan);
        scan = strend - $cba2acc47781bd54$var$MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
}
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ function $cba2acc47781bd54$var$fill_window(s) {
    var _w_size = s.w_size;
    var p, n, m, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - $cba2acc47781bd54$var$MIN_LOOKAHEAD)) {
            $2c6a85ff7e4ce93b$exports.arraySet(s.window, s.window, _w_size, _w_size, 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */ n = s.hash_size;
            p = n;
            do {
                m = s.head[--p];
                s.head[p] = m >= _w_size ? m - _w_size : 0;
            }while (--n);
            n = _w_size;
            p = n;
            do {
                m = s.prev[--p];
                s.prev[p] = m >= _w_size ? m - _w_size : 0;
            /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */ }while (--n);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = $cba2acc47781bd54$var$read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= $cba2acc47781bd54$var$MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $cba2acc47781bd54$var$MIN_MATCH - 1]) & s.hash_mask;
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < $cba2acc47781bd54$var$MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < $cba2acc47781bd54$var$MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */ function $cba2acc47781bd54$var$deflate_stored(s, flush) {
    /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */ var max_block_size = 0xffff;
    if (max_block_size > s.pending_buf_size - 5) max_block_size = s.pending_buf_size - 5;
    /* Copy as much as possible from input to output: */ for(;;){
        /* Fill the window as much as possible: */ if (s.lookahead <= 1) {
            //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
            //  s->block_start >= (long)s->w_size, "slide too late");
            //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
            //        s.block_start >= s.w_size)) {
            //        throw  new Error("slide too late");
            //      }
            $cba2acc47781bd54$var$fill_window(s);
            if (s.lookahead === 0 && flush === $cba2acc47781bd54$var$Z_NO_FLUSH) return $cba2acc47781bd54$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
        /* flush the current block */ }
        //Assert(s->block_start >= 0L, "block gone");
        //    if (s.block_start < 0) throw new Error("block gone");
        s.strstart += s.lookahead;
        s.lookahead = 0;
        /* Emit a stored block if pending_buf will be full: */ var max_start = s.block_start + max_block_size;
        if (s.strstart === 0 || s.strstart >= max_start) {
            /* strstart == 0 is possible when wraparound on 16-bit machine */ s.lookahead = s.strstart - max_start;
            s.strstart = max_start;
            /*** FLUSH_BLOCK(s, 0); ***/ $cba2acc47781bd54$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $cba2acc47781bd54$var$BS_NEED_MORE;
        /***/ }
        /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */ if (s.strstart - s.block_start >= s.w_size - $cba2acc47781bd54$var$MIN_LOOKAHEAD) {
            /*** FLUSH_BLOCK(s, 0); ***/ $cba2acc47781bd54$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $cba2acc47781bd54$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $cba2acc47781bd54$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $cba2acc47781bd54$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $cba2acc47781bd54$var$BS_FINISH_STARTED;
        /***/ return $cba2acc47781bd54$var$BS_FINISH_DONE;
    }
    if (s.strstart > s.block_start) {
        /*** FLUSH_BLOCK(s, 0); ***/ $cba2acc47781bd54$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $cba2acc47781bd54$var$BS_NEED_MORE;
    /***/ }
    return $cba2acc47781bd54$var$BS_NEED_MORE;
}
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ function $cba2acc47781bd54$var$deflate_fast(s, flush) {
    var hash_head; /* head of the hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $cba2acc47781bd54$var$MIN_LOOKAHEAD) {
            $cba2acc47781bd54$var$fill_window(s);
            if (s.lookahead < $cba2acc47781bd54$var$MIN_LOOKAHEAD && flush === $cba2acc47781bd54$var$Z_NO_FLUSH) return $cba2acc47781bd54$var$BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $cba2acc47781bd54$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $cba2acc47781bd54$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - $cba2acc47781bd54$var$MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $cba2acc47781bd54$var$longest_match(s, hash_head);
        if (s.match_length >= $cba2acc47781bd54$var$MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = $d7b5f0f953a31c06$export$b3cbce147289408f(s, s.strstart - s.match_start, s.match_length - $cba2acc47781bd54$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= $cba2acc47781bd54$var$MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $cba2acc47781bd54$var$MIN_MATCH - 1]) & s.hash_mask;
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $d7b5f0f953a31c06$export$b3cbce147289408f(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $cba2acc47781bd54$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $cba2acc47781bd54$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < $cba2acc47781bd54$var$MIN_MATCH - 1 ? s.strstart : $cba2acc47781bd54$var$MIN_MATCH - 1;
    if (flush === $cba2acc47781bd54$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $cba2acc47781bd54$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $cba2acc47781bd54$var$BS_FINISH_STARTED;
        /***/ return $cba2acc47781bd54$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $cba2acc47781bd54$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $cba2acc47781bd54$var$BS_NEED_MORE;
    /***/ }
    return $cba2acc47781bd54$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ function $cba2acc47781bd54$var$deflate_slow(s, flush) {
    var hash_head; /* head of hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    var max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $cba2acc47781bd54$var$MIN_LOOKAHEAD) {
            $cba2acc47781bd54$var$fill_window(s);
            if (s.lookahead < $cba2acc47781bd54$var$MIN_LOOKAHEAD && flush === $cba2acc47781bd54$var$Z_NO_FLUSH) return $cba2acc47781bd54$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $cba2acc47781bd54$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $cba2acc47781bd54$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = $cba2acc47781bd54$var$MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - $cba2acc47781bd54$var$MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $cba2acc47781bd54$var$longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === $cba2acc47781bd54$var$Z_FILTERED || s.match_length === $cba2acc47781bd54$var$MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = $cba2acc47781bd54$var$MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= $cba2acc47781bd54$var$MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - $cba2acc47781bd54$var$MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = $d7b5f0f953a31c06$export$b3cbce147289408f(s, s.strstart - 1 - s.prev_match, s.prev_length - $cba2acc47781bd54$var$MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $cba2acc47781bd54$var$MIN_MATCH - 1]) & s.hash_mask;
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = $cba2acc47781bd54$var$MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ $cba2acc47781bd54$var$flush_block_only(s, false);
                if (s.strm.avail_out === 0) return $cba2acc47781bd54$var$BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $d7b5f0f953a31c06$export$b3cbce147289408f(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ $cba2acc47781bd54$var$flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return $cba2acc47781bd54$var$BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $d7b5f0f953a31c06$export$b3cbce147289408f(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < $cba2acc47781bd54$var$MIN_MATCH - 1 ? s.strstart : $cba2acc47781bd54$var$MIN_MATCH - 1;
    if (flush === $cba2acc47781bd54$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $cba2acc47781bd54$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $cba2acc47781bd54$var$BS_FINISH_STARTED;
        /***/ return $cba2acc47781bd54$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $cba2acc47781bd54$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $cba2acc47781bd54$var$BS_NEED_MORE;
    /***/ }
    return $cba2acc47781bd54$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ function $cba2acc47781bd54$var$deflate_rle(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    var prev; /* byte at distance one to match */ 
    var scan, strend; /* scan goes up to strend for length of run */ 
    var _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= $cba2acc47781bd54$var$MAX_MATCH) {
            $cba2acc47781bd54$var$fill_window(s);
            if (s.lookahead <= $cba2acc47781bd54$var$MAX_MATCH && flush === $cba2acc47781bd54$var$Z_NO_FLUSH) return $cba2acc47781bd54$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= $cba2acc47781bd54$var$MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + $cba2acc47781bd54$var$MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = $cba2acc47781bd54$var$MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= $cba2acc47781bd54$var$MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = $d7b5f0f953a31c06$export$b3cbce147289408f(s, 1, s.match_length - $cba2acc47781bd54$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $d7b5f0f953a31c06$export$b3cbce147289408f(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $cba2acc47781bd54$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $cba2acc47781bd54$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $cba2acc47781bd54$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $cba2acc47781bd54$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $cba2acc47781bd54$var$BS_FINISH_STARTED;
        /***/ return $cba2acc47781bd54$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $cba2acc47781bd54$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $cba2acc47781bd54$var$BS_NEED_MORE;
    /***/ }
    return $cba2acc47781bd54$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ function $cba2acc47781bd54$var$deflate_huff(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            $cba2acc47781bd54$var$fill_window(s);
            if (s.lookahead === 0) {
                if (flush === $cba2acc47781bd54$var$Z_NO_FLUSH) return $cba2acc47781bd54$var$BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $d7b5f0f953a31c06$export$b3cbce147289408f(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $cba2acc47781bd54$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $cba2acc47781bd54$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $cba2acc47781bd54$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $cba2acc47781bd54$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $cba2acc47781bd54$var$BS_FINISH_STARTED;
        /***/ return $cba2acc47781bd54$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $cba2acc47781bd54$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $cba2acc47781bd54$var$BS_NEED_MORE;
    /***/ }
    return $cba2acc47781bd54$var$BS_BLOCK_DONE;
}
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function $cba2acc47781bd54$var$Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
var $cba2acc47781bd54$var$configuration_table;
$cba2acc47781bd54$var$configuration_table = [
    /*      good lazy nice chain */ new $cba2acc47781bd54$var$Config(0, 0, 0, 0, $cba2acc47781bd54$var$deflate_stored),
    /* 0 store only */ new $cba2acc47781bd54$var$Config(4, 4, 8, 4, $cba2acc47781bd54$var$deflate_fast),
    /* 1 max speed, no lazy matches */ new $cba2acc47781bd54$var$Config(4, 5, 16, 8, $cba2acc47781bd54$var$deflate_fast),
    /* 2 */ new $cba2acc47781bd54$var$Config(4, 6, 32, 32, $cba2acc47781bd54$var$deflate_fast),
    /* 3 */ new $cba2acc47781bd54$var$Config(4, 4, 16, 16, $cba2acc47781bd54$var$deflate_slow),
    /* 4 lazy matches */ new $cba2acc47781bd54$var$Config(8, 16, 32, 32, $cba2acc47781bd54$var$deflate_slow),
    /* 5 */ new $cba2acc47781bd54$var$Config(8, 16, 128, 128, $cba2acc47781bd54$var$deflate_slow),
    /* 6 */ new $cba2acc47781bd54$var$Config(8, 32, 128, 256, $cba2acc47781bd54$var$deflate_slow),
    /* 7 */ new $cba2acc47781bd54$var$Config(32, 128, 258, 1024, $cba2acc47781bd54$var$deflate_slow),
    /* 8 */ new $cba2acc47781bd54$var$Config(32, 258, 258, 4096, $cba2acc47781bd54$var$deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ function $cba2acc47781bd54$var$lm_init(s) {
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ $cba2acc47781bd54$var$zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = $cba2acc47781bd54$var$configuration_table[s.level].max_lazy;
    s.good_match = $cba2acc47781bd54$var$configuration_table[s.level].good_length;
    s.nice_match = $cba2acc47781bd54$var$configuration_table[s.level].nice_length;
    s.max_chain_length = $cba2acc47781bd54$var$configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = $cba2acc47781bd54$var$MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
}
function $cba2acc47781bd54$var$DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = $cba2acc47781bd54$var$Z_DEFLATED; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new $2c6a85ff7e4ce93b$exports.Buf16($cba2acc47781bd54$var$HEAP_SIZE * 2);
    this.dyn_dtree = new $2c6a85ff7e4ce93b$exports.Buf16((2 * $cba2acc47781bd54$var$D_CODES + 1) * 2);
    this.bl_tree = new $2c6a85ff7e4ce93b$exports.Buf16((2 * $cba2acc47781bd54$var$BL_CODES + 1) * 2);
    $cba2acc47781bd54$var$zero(this.dyn_ltree);
    $cba2acc47781bd54$var$zero(this.dyn_dtree);
    $cba2acc47781bd54$var$zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new $2c6a85ff7e4ce93b$exports.Buf16($cba2acc47781bd54$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new $2c6a85ff7e4ce93b$exports.Buf16(2 * $cba2acc47781bd54$var$L_CODES + 1); /* heap used to build the Huffman trees */ 
    $cba2acc47781bd54$var$zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new $2c6a85ff7e4ce93b$exports.Buf16(2 * $cba2acc47781bd54$var$L_CODES + 1); //uch depth[2*L_CODES+1];
    $cba2acc47781bd54$var$zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.l_buf = 0; /* buffer index for literals or lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.last_lit = 0; /* running index in l_buf */ 
    this.d_buf = 0;
    /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */ this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
function $cba2acc47781bd54$var$deflateResetKeep(strm) {
    var s;
    if (!strm || !strm.state) return $cba2acc47781bd54$var$err(strm, $cba2acc47781bd54$var$Z_STREAM_ERROR);
    strm.total_in = strm.total_out = 0;
    strm.data_type = $cba2acc47781bd54$var$Z_UNKNOWN;
    s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = s.wrap ? $cba2acc47781bd54$var$INIT_STATE : $cba2acc47781bd54$var$BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = $cba2acc47781bd54$var$Z_NO_FLUSH;
    $d7b5f0f953a31c06$export$4e4fc0157c3cd14d(s);
    return $cba2acc47781bd54$var$Z_OK;
}
function $cba2acc47781bd54$var$deflateReset(strm) {
    var ret = $cba2acc47781bd54$var$deflateResetKeep(strm);
    if (ret === $cba2acc47781bd54$var$Z_OK) $cba2acc47781bd54$var$lm_init(strm.state);
    return ret;
}
function $cba2acc47781bd54$var$deflateSetHeader(strm, head) {
    if (!strm || !strm.state) return $cba2acc47781bd54$var$Z_STREAM_ERROR;
    if (strm.state.wrap !== 2) return $cba2acc47781bd54$var$Z_STREAM_ERROR;
    strm.state.gzhead = head;
    return $cba2acc47781bd54$var$Z_OK;
}
function $cba2acc47781bd54$var$deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
    if (!strm) return $cba2acc47781bd54$var$Z_STREAM_ERROR;
    var wrap = 1;
    if (level === $cba2acc47781bd54$var$Z_DEFAULT_COMPRESSION) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > $cba2acc47781bd54$var$MAX_MEM_LEVEL || method !== $cba2acc47781bd54$var$Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > $cba2acc47781bd54$var$Z_FIXED) return $cba2acc47781bd54$var$err(strm, $cba2acc47781bd54$var$Z_STREAM_ERROR);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ var s = new $cba2acc47781bd54$var$DeflateState();
    strm.state = s;
    s.strm = strm;
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + $cba2acc47781bd54$var$MIN_MATCH - 1) / $cba2acc47781bd54$var$MIN_MATCH);
    s.window = new $2c6a85ff7e4ce93b$exports.Buf8(s.w_size * 2);
    s.head = new $2c6a85ff7e4ce93b$exports.Buf16(s.hash_size);
    s.prev = new $2c6a85ff7e4ce93b$exports.Buf16(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    s.pending_buf_size = s.lit_bufsize * 4;
    //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
    //s->pending_buf = (uchf *) overlay;
    s.pending_buf = new $2c6a85ff7e4ce93b$exports.Buf8(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
    s.d_buf = 1 * s.lit_bufsize;
    //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
    s.l_buf = 3 * s.lit_bufsize;
    s.level = level;
    s.strategy = strategy;
    s.method = method;
    return $cba2acc47781bd54$var$deflateReset(strm);
}
function $cba2acc47781bd54$var$deflateInit(strm, level) {
    return $cba2acc47781bd54$var$deflateInit2(strm, level, $cba2acc47781bd54$var$Z_DEFLATED, $cba2acc47781bd54$var$MAX_WBITS, $cba2acc47781bd54$var$DEF_MEM_LEVEL, $cba2acc47781bd54$var$Z_DEFAULT_STRATEGY);
}
function $cba2acc47781bd54$var$deflate(strm, flush) {
    var old_flush, s;
    var beg, val; // for gzip header write only
    if (!strm || !strm.state || flush > $cba2acc47781bd54$var$Z_BLOCK || flush < 0) return strm ? $cba2acc47781bd54$var$err(strm, $cba2acc47781bd54$var$Z_STREAM_ERROR) : $cba2acc47781bd54$var$Z_STREAM_ERROR;
    s = strm.state;
    if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === $cba2acc47781bd54$var$FINISH_STATE && flush !== $cba2acc47781bd54$var$Z_FINISH) return $cba2acc47781bd54$var$err(strm, strm.avail_out === 0 ? $cba2acc47781bd54$var$Z_BUF_ERROR : $cba2acc47781bd54$var$Z_STREAM_ERROR);
    s.strm = strm; /* just in case */ 
    old_flush = s.last_flush;
    s.last_flush = flush;
    /* Write the header */ if (s.status === $cba2acc47781bd54$var$INIT_STATE) {
        if (s.wrap === 2) {
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
            $cba2acc47781bd54$var$put_byte(s, 31);
            $cba2acc47781bd54$var$put_byte(s, 139);
            $cba2acc47781bd54$var$put_byte(s, 8);
            if (!s.gzhead) {
                $cba2acc47781bd54$var$put_byte(s, 0);
                $cba2acc47781bd54$var$put_byte(s, 0);
                $cba2acc47781bd54$var$put_byte(s, 0);
                $cba2acc47781bd54$var$put_byte(s, 0);
                $cba2acc47781bd54$var$put_byte(s, 0);
                $cba2acc47781bd54$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $cba2acc47781bd54$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $cba2acc47781bd54$var$put_byte(s, $cba2acc47781bd54$var$OS_CODE);
                s.status = $cba2acc47781bd54$var$BUSY_STATE;
            } else {
                $cba2acc47781bd54$var$put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
                $cba2acc47781bd54$var$put_byte(s, s.gzhead.time & 0xff);
                $cba2acc47781bd54$var$put_byte(s, s.gzhead.time >> 8 & 0xff);
                $cba2acc47781bd54$var$put_byte(s, s.gzhead.time >> 16 & 0xff);
                $cba2acc47781bd54$var$put_byte(s, s.gzhead.time >> 24 & 0xff);
                $cba2acc47781bd54$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $cba2acc47781bd54$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $cba2acc47781bd54$var$put_byte(s, s.gzhead.os & 0xff);
                if (s.gzhead.extra && s.gzhead.extra.length) {
                    $cba2acc47781bd54$var$put_byte(s, s.gzhead.extra.length & 0xff);
                    $cba2acc47781bd54$var$put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
                }
                if (s.gzhead.hcrc) strm.adler = $abfa54b01eefbc9c$exports(strm.adler, s.pending_buf, s.pending, 0);
                s.gzindex = 0;
                s.status = $cba2acc47781bd54$var$EXTRA_STATE;
            }
        } else {
            var header = $cba2acc47781bd54$var$Z_DEFLATED + (s.w_bits - 8 << 4) << 8;
            var level_flags = -1;
            if (s.strategy >= $cba2acc47781bd54$var$Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
            else if (s.level < 6) level_flags = 1;
            else if (s.level === 6) level_flags = 2;
            else level_flags = 3;
            header |= level_flags << 6;
            if (s.strstart !== 0) header |= $cba2acc47781bd54$var$PRESET_DICT;
            header += 31 - header % 31;
            s.status = $cba2acc47781bd54$var$BUSY_STATE;
            $cba2acc47781bd54$var$putShortMSB(s, header);
            /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
                $cba2acc47781bd54$var$putShortMSB(s, strm.adler >>> 16);
                $cba2acc47781bd54$var$putShortMSB(s, strm.adler & 0xffff);
            }
            strm.adler = 1; // adler32(0L, Z_NULL, 0);
        }
    }
    //#ifdef GZIP
    if (s.status === $cba2acc47781bd54$var$EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            while(s.gzindex < (s.gzhead.extra.length & 0xffff)){
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $abfa54b01eefbc9c$exports(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $cba2acc47781bd54$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) break;
                }
                $cba2acc47781bd54$var$put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                s.gzindex++;
            }
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $abfa54b01eefbc9c$exports(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (s.gzindex === s.gzhead.extra.length) {
                s.gzindex = 0;
                s.status = $cba2acc47781bd54$var$NAME_STATE;
            }
        } else s.status = $cba2acc47781bd54$var$NAME_STATE;
    }
    if (s.status === $cba2acc47781bd54$var$NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $abfa54b01eefbc9c$exports(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $cba2acc47781bd54$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $cba2acc47781bd54$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $abfa54b01eefbc9c$exports(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) {
                s.gzindex = 0;
                s.status = $cba2acc47781bd54$var$COMMENT_STATE;
            }
        } else s.status = $cba2acc47781bd54$var$COMMENT_STATE;
    }
    if (s.status === $cba2acc47781bd54$var$COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $abfa54b01eefbc9c$exports(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $cba2acc47781bd54$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $cba2acc47781bd54$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $abfa54b01eefbc9c$exports(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) s.status = $cba2acc47781bd54$var$HCRC_STATE;
        } else s.status = $cba2acc47781bd54$var$HCRC_STATE;
    }
    if (s.status === $cba2acc47781bd54$var$HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) $cba2acc47781bd54$var$flush_pending(strm);
            if (s.pending + 2 <= s.pending_buf_size) {
                $cba2acc47781bd54$var$put_byte(s, strm.adler & 0xff);
                $cba2acc47781bd54$var$put_byte(s, strm.adler >> 8 & 0xff);
                strm.adler = 0; //crc32(0L, Z_NULL, 0);
                s.status = $cba2acc47781bd54$var$BUSY_STATE;
            }
        } else s.status = $cba2acc47781bd54$var$BUSY_STATE;
    }
    //#endif
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        $cba2acc47781bd54$var$flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return $cba2acc47781bd54$var$Z_OK;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && $cba2acc47781bd54$var$rank(flush) <= $cba2acc47781bd54$var$rank(old_flush) && flush !== $cba2acc47781bd54$var$Z_FINISH) return $cba2acc47781bd54$var$err(strm, $cba2acc47781bd54$var$Z_BUF_ERROR);
    /* User must not provide more input after the first FINISH: */ if (s.status === $cba2acc47781bd54$var$FINISH_STATE && strm.avail_in !== 0) return $cba2acc47781bd54$var$err(strm, $cba2acc47781bd54$var$Z_BUF_ERROR);
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== $cba2acc47781bd54$var$Z_NO_FLUSH && s.status !== $cba2acc47781bd54$var$FINISH_STATE) {
        var bstate = s.strategy === $cba2acc47781bd54$var$Z_HUFFMAN_ONLY ? $cba2acc47781bd54$var$deflate_huff(s, flush) : s.strategy === $cba2acc47781bd54$var$Z_RLE ? $cba2acc47781bd54$var$deflate_rle(s, flush) : $cba2acc47781bd54$var$configuration_table[s.level].func(s, flush);
        if (bstate === $cba2acc47781bd54$var$BS_FINISH_STARTED || bstate === $cba2acc47781bd54$var$BS_FINISH_DONE) s.status = $cba2acc47781bd54$var$FINISH_STATE;
        if (bstate === $cba2acc47781bd54$var$BS_NEED_MORE || bstate === $cba2acc47781bd54$var$BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return $cba2acc47781bd54$var$Z_OK;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === $cba2acc47781bd54$var$BS_BLOCK_DONE) {
            if (flush === $cba2acc47781bd54$var$Z_PARTIAL_FLUSH) $d7b5f0f953a31c06$export$bfb360e02ee9b403(s);
            else if (flush !== $cba2acc47781bd54$var$Z_BLOCK) {
                $d7b5f0f953a31c06$export$8959e34c5e020172(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === $cba2acc47781bd54$var$Z_FULL_FLUSH) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ $cba2acc47781bd54$var$zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            $cba2acc47781bd54$var$flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return $cba2acc47781bd54$var$Z_OK;
            }
        }
    }
    //Assert(strm->avail_out > 0, "bug2");
    //if (strm.avail_out <= 0) { throw new Error("bug2");}
    if (flush !== $cba2acc47781bd54$var$Z_FINISH) return $cba2acc47781bd54$var$Z_OK;
    if (s.wrap <= 0) return $cba2acc47781bd54$var$Z_STREAM_END;
    /* Write the trailer */ if (s.wrap === 2) {
        $cba2acc47781bd54$var$put_byte(s, strm.adler & 0xff);
        $cba2acc47781bd54$var$put_byte(s, strm.adler >> 8 & 0xff);
        $cba2acc47781bd54$var$put_byte(s, strm.adler >> 16 & 0xff);
        $cba2acc47781bd54$var$put_byte(s, strm.adler >> 24 & 0xff);
        $cba2acc47781bd54$var$put_byte(s, strm.total_in & 0xff);
        $cba2acc47781bd54$var$put_byte(s, strm.total_in >> 8 & 0xff);
        $cba2acc47781bd54$var$put_byte(s, strm.total_in >> 16 & 0xff);
        $cba2acc47781bd54$var$put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        $cba2acc47781bd54$var$putShortMSB(s, strm.adler >>> 16);
        $cba2acc47781bd54$var$putShortMSB(s, strm.adler & 0xffff);
    }
    $cba2acc47781bd54$var$flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? $cba2acc47781bd54$var$Z_OK : $cba2acc47781bd54$var$Z_STREAM_END;
}
function $cba2acc47781bd54$var$deflateEnd(strm) {
    var status;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $cba2acc47781bd54$var$Z_STREAM_ERROR;
    status = strm.state.status;
    if (status !== $cba2acc47781bd54$var$INIT_STATE && status !== $cba2acc47781bd54$var$EXTRA_STATE && status !== $cba2acc47781bd54$var$NAME_STATE && status !== $cba2acc47781bd54$var$COMMENT_STATE && status !== $cba2acc47781bd54$var$HCRC_STATE && status !== $cba2acc47781bd54$var$BUSY_STATE && status !== $cba2acc47781bd54$var$FINISH_STATE) return $cba2acc47781bd54$var$err(strm, $cba2acc47781bd54$var$Z_STREAM_ERROR);
    strm.state = null;
    return status === $cba2acc47781bd54$var$BUSY_STATE ? $cba2acc47781bd54$var$err(strm, $cba2acc47781bd54$var$Z_DATA_ERROR) : $cba2acc47781bd54$var$Z_OK;
}
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ function $cba2acc47781bd54$var$deflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var s;
    var str, n;
    var wrap;
    var avail;
    var next;
    var input;
    var tmpDict;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $cba2acc47781bd54$var$Z_STREAM_ERROR;
    s = strm.state;
    wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== $cba2acc47781bd54$var$INIT_STATE || s.lookahead) return $cba2acc47781bd54$var$Z_STREAM_ERROR;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = $e6e0cd37d3935915$exports(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ $cba2acc47781bd54$var$zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        tmpDict = new $2c6a85ff7e4ce93b$exports.Buf8(s.w_size);
        $2c6a85ff7e4ce93b$exports.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ avail = strm.avail_in;
    next = strm.next_in;
    input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    $cba2acc47781bd54$var$fill_window(s);
    while(s.lookahead >= $cba2acc47781bd54$var$MIN_MATCH){
        str = s.strstart;
        n = s.lookahead - ($cba2acc47781bd54$var$MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $cba2acc47781bd54$var$MIN_MATCH - 1]) & s.hash_mask;
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = $cba2acc47781bd54$var$MIN_MATCH - 1;
        $cba2acc47781bd54$var$fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = $cba2acc47781bd54$var$MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return $cba2acc47781bd54$var$Z_OK;
}
$cba2acc47781bd54$export$72b35d618fb8ad9b = $cba2acc47781bd54$var$deflateInit;
$cba2acc47781bd54$export$a65c7b2bde87cb70 = $cba2acc47781bd54$var$deflateInit2;
$cba2acc47781bd54$export$8f99f0e30bc7dd53 = $cba2acc47781bd54$var$deflateReset;
$cba2acc47781bd54$export$e78fab288549509 = $cba2acc47781bd54$var$deflateResetKeep;
$cba2acc47781bd54$export$1cd50f7b2515ba19 = $cba2acc47781bd54$var$deflateSetHeader;
$cba2acc47781bd54$export$2316623ecd1285ab = $cba2acc47781bd54$var$deflate;
$cba2acc47781bd54$export$599854fa319a815f = $cba2acc47781bd54$var$deflateEnd;
$cba2acc47781bd54$export$f55e0b3ab66b5d46 = $cba2acc47781bd54$var$deflateSetDictionary;
$cba2acc47781bd54$export$12b6e1fcadea22f9 = 'pako deflate (from Nodeca project)'; /* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/ 


var $ff5dc738affa778e$export$42de45683a92ba94;
var $ff5dc738affa778e$export$7633ac2cd30f9650;
var $ff5dc738affa778e$export$6710ea52c4ec9d6a;
var $ff5dc738affa778e$export$9c140b25e26874f9;
var $ff5dc738affa778e$export$6792d92addc5c8a0;
var $ff5dc738affa778e$export$cae1ce83fe4a1782;
var $ff5dc738affa778e$export$224e1a443c3fba76;
var $ff5dc738affa778e$export$6d4647cb9e1c75fc;
var $ff5dc738affa778e$export$60da749bed98ccf8;
var $ff5dc738affa778e$export$220f6291ca35fd71;
'use strict';



var $ff54ef8e9c6c3f90$exports = {};
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
var $ff54ef8e9c6c3f90$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $ff54ef8e9c6c3f90$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ $ff54ef8e9c6c3f90$exports = function inflate_fast(strm, start) {
    var state;
    var _in; /* local strm.input */ 
    var last; /* have enough input while in < last */ 
    var _out; /* local strm.output */ 
    var beg; /* inflate()'s initial strm.output */ 
    var end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    var dmax; /* maximum distance from zlib header */ 
    //#endif
    var wsize; /* window size or zero if not using window */ 
    var whave; /* valid bytes in the window */ 
    var wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    var s_window; /* allocated sliding window, if wsize != 0 */ 
    var hold; /* local strm.hold */ 
    var bits; /* local strm.bits */ 
    var lcode; /* local strm.lencode */ 
    var dcode; /* local strm.distcode */ 
    var lmask; /* mask for first level of length codes */ 
    var dmask; /* mask for first level of distance codes */ 
    var here; /* retrieved table entry */ 
    var op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ var len; /* match length, unused bytes */ 
    var dist; /* match distance */ 
    var from; /* where to copy match from */ 
    var from_source;
    var input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = 'invalid distance too far back';
                            state.mode = $ff54ef8e9c6c3f90$var$BAD;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = 'invalid distance too far back';
                                    state.mode = $ff54ef8e9c6c3f90$var$BAD;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = 'invalid distance code';
                        state.mode = $ff54ef8e9c6c3f90$var$BAD;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = $ff54ef8e9c6c3f90$var$TYPE;
                break top;
            } else {
                strm.msg = 'invalid literal/length code';
                state.mode = $ff54ef8e9c6c3f90$var$BAD;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};


var $6d8ea7ac8a31118f$exports = {};
'use strict';

var $6d8ea7ac8a31118f$var$MAXBITS = 15;
var $6d8ea7ac8a31118f$var$ENOUGH_LENS = 852;
var $6d8ea7ac8a31118f$var$ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
var $6d8ea7ac8a31118f$var$CODES = 0;
var $6d8ea7ac8a31118f$var$LENS = 1;
var $6d8ea7ac8a31118f$var$DISTS = 2;
var $6d8ea7ac8a31118f$var$lbase = [
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
];
var $6d8ea7ac8a31118f$var$lext = [
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
];
var $6d8ea7ac8a31118f$var$dbase = [
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
];
var $6d8ea7ac8a31118f$var$dext = [
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
];
$6d8ea7ac8a31118f$exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
    var bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    var len = 0; /* a code's length in bits */ 
    var sym = 0; /* index of code symbols */ 
    var min = 0, max = 0; /* minimum and maximum code lengths */ 
    var root = 0; /* number of index bits for root table */ 
    var curr = 0; /* number of index bits for current table */ 
    var drop = 0; /* code bits to drop for sub-table */ 
    var left = 0; /* number of prefix codes available */ 
    var used = 0; /* code entries in table used */ 
    var huff = 0; /* Huffman code */ 
    var incr; /* for incrementing code, index */ 
    var fill; /* index for replicating entries */ 
    var low; /* low bits for current root entry */ 
    var mask; /* mask for low root bits */ 
    var next; /* next available space in table */ 
    var base = null; /* base value table to use */ 
    var base_index = 0;
    //  var shoextra;    /* extra bits table to use */
    var end; /* use base and extra for symbol > end */ 
    var count = new $2c6a85ff7e4ce93b$exports.Buf16($6d8ea7ac8a31118f$var$MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    var offs = new $2c6a85ff7e4ce93b$exports.Buf16($6d8ea7ac8a31118f$var$MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    var extra = null;
    var extra_index = 0;
    var here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= $6d8ea7ac8a31118f$var$MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = $6d8ea7ac8a31118f$var$MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= $6d8ea7ac8a31118f$var$MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === $6d8ea7ac8a31118f$var$CODES || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < $6d8ea7ac8a31118f$var$MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === $6d8ea7ac8a31118f$var$CODES) {
        base = extra = work; /* dummy value--not used */ 
        end = 19;
    } else if (type === $6d8ea7ac8a31118f$var$LENS) {
        base = $6d8ea7ac8a31118f$var$lbase;
        base_index -= 257;
        extra = $6d8ea7ac8a31118f$var$lext;
        extra_index -= 257;
        end = 256;
    } else {
        base = $6d8ea7ac8a31118f$var$dbase;
        extra = $6d8ea7ac8a31118f$var$dext;
        end = -1;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === $6d8ea7ac8a31118f$var$LENS && used > $6d8ea7ac8a31118f$var$ENOUGH_LENS || type === $6d8ea7ac8a31118f$var$DISTS && used > $6d8ea7ac8a31118f$var$ENOUGH_DISTS) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] < end) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] > end) {
            here_op = extra[extra_index + work[sym]];
            here_val = base[base_index + work[sym]];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === $6d8ea7ac8a31118f$var$LENS && used > $6d8ea7ac8a31118f$var$ENOUGH_LENS || type === $6d8ea7ac8a31118f$var$DISTS && used > $6d8ea7ac8a31118f$var$ENOUGH_DISTS) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};


var $ff5dc738affa778e$var$CODES = 0;
var $ff5dc738affa778e$var$LENS = 1;
var $ff5dc738affa778e$var$DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ //var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var $ff5dc738affa778e$var$Z_FINISH = 4;
var $ff5dc738affa778e$var$Z_BLOCK = 5;
var $ff5dc738affa778e$var$Z_TREES = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $ff5dc738affa778e$var$Z_OK = 0;
var $ff5dc738affa778e$var$Z_STREAM_END = 1;
var $ff5dc738affa778e$var$Z_NEED_DICT = 2;
//var Z_ERRNO         = -1;
var $ff5dc738affa778e$var$Z_STREAM_ERROR = -2;
var $ff5dc738affa778e$var$Z_DATA_ERROR = -3;
var $ff5dc738affa778e$var$Z_MEM_ERROR = -4;
var $ff5dc738affa778e$var$Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* The deflate compression method */ var $ff5dc738affa778e$var$Z_DEFLATED = 8;
/* STATES ====================================================================*/ /* ===========================================================================*/ var $ff5dc738affa778e$var$HEAD = 1; /* i: waiting for magic header */ 
var $ff5dc738affa778e$var$FLAGS = 2; /* i: waiting for method and flags (gzip) */ 
var $ff5dc738affa778e$var$TIME = 3; /* i: waiting for modification time (gzip) */ 
var $ff5dc738affa778e$var$OS = 4; /* i: waiting for extra flags and operating system (gzip) */ 
var $ff5dc738affa778e$var$EXLEN = 5; /* i: waiting for extra length (gzip) */ 
var $ff5dc738affa778e$var$EXTRA = 6; /* i: waiting for extra bytes (gzip) */ 
var $ff5dc738affa778e$var$NAME = 7; /* i: waiting for end of file name (gzip) */ 
var $ff5dc738affa778e$var$COMMENT = 8; /* i: waiting for end of comment (gzip) */ 
var $ff5dc738affa778e$var$HCRC = 9; /* i: waiting for header crc (gzip) */ 
var $ff5dc738affa778e$var$DICTID = 10; /* i: waiting for dictionary check value */ 
var $ff5dc738affa778e$var$DICT = 11; /* waiting for inflateSetDictionary() call */ 
var $ff5dc738affa778e$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
var $ff5dc738affa778e$var$TYPEDO = 13; /* i: same, but skip check to exit inflate on new block */ 
var $ff5dc738affa778e$var$STORED = 14; /* i: waiting for stored size (length and complement) */ 
var $ff5dc738affa778e$var$COPY_ = 15; /* i/o: same as COPY below, but only first time in */ 
var $ff5dc738affa778e$var$COPY = 16; /* i/o: waiting for input or output to copy stored block */ 
var $ff5dc738affa778e$var$TABLE = 17; /* i: waiting for dynamic block table lengths */ 
var $ff5dc738affa778e$var$LENLENS = 18; /* i: waiting for code length code lengths */ 
var $ff5dc738affa778e$var$CODELENS = 19; /* i: waiting for length/lit and distance code lengths */ 
var $ff5dc738affa778e$var$LEN_ = 20; /* i: same as LEN below, but only first time in */ 
var $ff5dc738affa778e$var$LEN = 21; /* i: waiting for length/lit/eob code */ 
var $ff5dc738affa778e$var$LENEXT = 22; /* i: waiting for length extra bits */ 
var $ff5dc738affa778e$var$DIST = 23; /* i: waiting for distance code */ 
var $ff5dc738affa778e$var$DISTEXT = 24; /* i: waiting for distance extra bits */ 
var $ff5dc738affa778e$var$MATCH = 25; /* o: waiting for output space to copy string */ 
var $ff5dc738affa778e$var$LIT = 26; /* o: waiting for output space to write literal */ 
var $ff5dc738affa778e$var$CHECK = 27; /* i: waiting for 32-bit check value */ 
var $ff5dc738affa778e$var$LENGTH = 28; /* i: waiting for 32-bit length (gzip) */ 
var $ff5dc738affa778e$var$DONE = 29; /* finished check, done -- remain here until reset */ 
var $ff5dc738affa778e$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $ff5dc738affa778e$var$MEM = 31; /* got an inflate() memory error -- remain here until reset */ 
var $ff5dc738affa778e$var$SYNC = 32; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ var $ff5dc738affa778e$var$ENOUGH_LENS = 852;
var $ff5dc738affa778e$var$ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
var $ff5dc738affa778e$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $ff5dc738affa778e$var$DEF_WBITS = $ff5dc738affa778e$var$MAX_WBITS;
function $ff5dc738affa778e$var$zswap32(q) {
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
}
function $ff5dc738affa778e$var$InflateState() {
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib) */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new $2c6a85ff7e4ce93b$exports.Buf16(320); /* temporary storage for code lengths */ 
    this.work = new $2c6a85ff7e4ce93b$exports.Buf16(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
function $ff5dc738affa778e$var$inflateResetKeep(strm) {
    var state;
    if (!strm || !strm.state) return $ff5dc738affa778e$var$Z_STREAM_ERROR;
    state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ''; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = $ff5dc738affa778e$var$HEAD;
    state.last = 0;
    state.havedict = 0;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new $2c6a85ff7e4ce93b$exports.Buf32($ff5dc738affa778e$var$ENOUGH_LENS);
    state.distcode = state.distdyn = new $2c6a85ff7e4ce93b$exports.Buf32($ff5dc738affa778e$var$ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return $ff5dc738affa778e$var$Z_OK;
}
function $ff5dc738affa778e$var$inflateReset(strm) {
    var state;
    if (!strm || !strm.state) return $ff5dc738affa778e$var$Z_STREAM_ERROR;
    state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return $ff5dc738affa778e$var$inflateResetKeep(strm);
}
function $ff5dc738affa778e$var$inflateReset2(strm, windowBits) {
    var wrap;
    var state;
    /* get the state */ if (!strm || !strm.state) return $ff5dc738affa778e$var$Z_STREAM_ERROR;
    state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 1;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return $ff5dc738affa778e$var$Z_STREAM_ERROR;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return $ff5dc738affa778e$var$inflateReset(strm);
}
function $ff5dc738affa778e$var$inflateInit2(strm, windowBits) {
    var ret;
    var state;
    if (!strm) return $ff5dc738affa778e$var$Z_STREAM_ERROR;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    state = new $ff5dc738affa778e$var$InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.window = null /*Z_NULL*/ ;
    ret = $ff5dc738affa778e$var$inflateReset2(strm, windowBits);
    if (ret !== $ff5dc738affa778e$var$Z_OK) strm.state = null /*Z_NULL*/ ;
    return ret;
}
function $ff5dc738affa778e$var$inflateInit(strm) {
    return $ff5dc738affa778e$var$inflateInit2(strm, $ff5dc738affa778e$var$DEF_WBITS);
}
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ var $ff5dc738affa778e$var$virgin = true;
var $ff5dc738affa778e$var$lenfix, $ff5dc738affa778e$var$distfix; // We have no pointers in JS, so keep tables separate
function $ff5dc738affa778e$var$fixedtables(state) {
    /* build fixed huffman tables if first call (may not be thread safe) */ if ($ff5dc738affa778e$var$virgin) {
        var sym;
        $ff5dc738affa778e$var$lenfix = new $2c6a85ff7e4ce93b$exports.Buf32(512);
        $ff5dc738affa778e$var$distfix = new $2c6a85ff7e4ce93b$exports.Buf32(32);
        /* literal/length table */ sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        $6d8ea7ac8a31118f$exports($ff5dc738affa778e$var$LENS, state.lens, 0, 288, $ff5dc738affa778e$var$lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        $6d8ea7ac8a31118f$exports($ff5dc738affa778e$var$DISTS, state.lens, 0, 32, $ff5dc738affa778e$var$distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ $ff5dc738affa778e$var$virgin = false;
    }
    state.lencode = $ff5dc738affa778e$var$lenfix;
    state.lenbits = 9;
    state.distcode = $ff5dc738affa778e$var$distfix;
    state.distbits = 5;
}
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ function $ff5dc738affa778e$var$updatewindow(strm, src, end, copy) {
    var dist;
    var state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new $2c6a85ff7e4ce93b$exports.Buf8(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        $2c6a85ff7e4ce93b$exports.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        $2c6a85ff7e4ce93b$exports.arraySet(state.window, src, end - copy, dist, state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            $2c6a85ff7e4ce93b$exports.arraySet(state.window, src, end - copy, copy, 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
}
function $ff5dc738affa778e$var$inflate(strm, flush) {
    var state;
    var input, output; // input/output buffers
    var next; /* next input INDEX */ 
    var put; /* next output INDEX */ 
    var have, left; /* available input and output */ 
    var hold; /* bit buffer */ 
    var bits; /* bits in bit buffer */ 
    var _in, _out; /* save starting available input and output */ 
    var copy; /* number of stored or match bytes to copy */ 
    var from; /* where to copy match bytes from */ 
    var from_source;
    var here = 0; /* current decoding table entry */ 
    var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //var last;                   /* parent table entry */
    var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    var len; /* length to copy for repeats, bits to drop */ 
    var ret; /* return code */ 
    var hbuf = new $2c6a85ff7e4ce93b$exports.Buf8(4); /* buffer for gzip header crc calculation */ 
    var opts;
    var n; // temporary var for NEED_BITS
    var order = /* permutation of code lengths */ [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) return $ff5dc738affa778e$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.mode === $ff5dc738affa778e$var$TYPE) state.mode = $ff5dc738affa778e$var$TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = $ff5dc738affa778e$var$Z_OK;
    inf_leave: for(;;)switch(state.mode){
        case $ff5dc738affa778e$var$HEAD:
            if (state.wrap === 0) {
                state.mode = $ff5dc738affa778e$var$TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $abfa54b01eefbc9c$exports(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = $ff5dc738affa778e$var$FLAGS;
                break;
            }
            state.flags = 0; /* expect zlib header */ 
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = 'incorrect header check';
                state.mode = $ff5dc738affa778e$var$BAD;
                break;
            }
            if ((hold & 0x0f) !== $ff5dc738affa778e$var$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $ff5dc738affa778e$var$BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            else if (len > state.wbits) {
                strm.msg = 'invalid window size';
                state.mode = $ff5dc738affa778e$var$BAD;
                break;
            }
            state.dmax = 1 << len;
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? $ff5dc738affa778e$var$DICTID : $ff5dc738affa778e$var$TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case $ff5dc738affa778e$var$FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== $ff5dc738affa778e$var$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $ff5dc738affa778e$var$BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = 'unknown header flags set';
                state.mode = $ff5dc738affa778e$var$BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $abfa54b01eefbc9c$exports(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $ff5dc738affa778e$var$TIME;
        /* falls through */ case $ff5dc738affa778e$var$TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = $abfa54b01eefbc9c$exports(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $ff5dc738affa778e$var$OS;
        /* falls through */ case $ff5dc738affa778e$var$OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $abfa54b01eefbc9c$exports(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $ff5dc738affa778e$var$EXLEN;
        /* falls through */ case $ff5dc738affa778e$var$EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = $abfa54b01eefbc9c$exports(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = $ff5dc738affa778e$var$EXTRA;
        /* falls through */ case $ff5dc738affa778e$var$EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Array(state.head.extra_len);
                        $2c6a85ff7e4ce93b$exports.arraySet(state.head.extra, input, next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        copy, /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200) state.check = $abfa54b01eefbc9c$exports(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = $ff5dc738affa778e$var$NAME;
        /* falls through */ case $ff5dc738affa778e$var$NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $abfa54b01eefbc9c$exports(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = $ff5dc738affa778e$var$COMMENT;
        /* falls through */ case $ff5dc738affa778e$var$COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $abfa54b01eefbc9c$exports(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = $ff5dc738affa778e$var$HCRC;
        /* falls through */ case $ff5dc738affa778e$var$HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.check & 0xffff)) {
                    strm.msg = 'header crc mismatch';
                    state.mode = $ff5dc738affa778e$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = $ff5dc738affa778e$var$TYPE;
            break;
        case $ff5dc738affa778e$var$DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = $ff5dc738affa778e$var$zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $ff5dc738affa778e$var$DICT;
        /* falls through */ case $ff5dc738affa778e$var$DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return $ff5dc738affa778e$var$Z_NEED_DICT;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = $ff5dc738affa778e$var$TYPE;
        /* falls through */ case $ff5dc738affa778e$var$TYPE:
            if (flush === $ff5dc738affa778e$var$Z_BLOCK || flush === $ff5dc738affa778e$var$Z_TREES) break inf_leave;
        /* falls through */ case $ff5dc738affa778e$var$TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = $ff5dc738affa778e$var$CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $ff5dc738affa778e$var$STORED;
                    break;
                case 1:
                    /* fixed block */ $ff5dc738affa778e$var$fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $ff5dc738affa778e$var$LEN_; /* decode codes */ 
                    if (flush === $ff5dc738affa778e$var$Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $ff5dc738affa778e$var$TABLE;
                    break;
                case 3:
                    strm.msg = 'invalid block type';
                    state.mode = $ff5dc738affa778e$var$BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case $ff5dc738affa778e$var$STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = 'invalid stored block lengths';
                state.mode = $ff5dc738affa778e$var$BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $ff5dc738affa778e$var$COPY_;
            if (flush === $ff5dc738affa778e$var$Z_TREES) break inf_leave;
        /* falls through */ case $ff5dc738affa778e$var$COPY_:
            state.mode = $ff5dc738affa778e$var$COPY;
        /* falls through */ case $ff5dc738affa778e$var$COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                $2c6a85ff7e4ce93b$exports.arraySet(output, input, next, copy, put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = $ff5dc738affa778e$var$TYPE;
            break;
        case $ff5dc738affa778e$var$TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = 'too many length or distance symbols';
                state.mode = $ff5dc738affa778e$var$BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = $ff5dc738affa778e$var$LENLENS;
        /* falls through */ case $ff5dc738affa778e$var$LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = $6d8ea7ac8a31118f$exports($ff5dc738affa778e$var$CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = 'invalid code lengths set';
                state.mode = $ff5dc738affa778e$var$BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = $ff5dc738affa778e$var$CODELENS;
        /* falls through */ case $ff5dc738affa778e$var$CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = 'invalid bit length repeat';
                            state.mode = $ff5dc738affa778e$var$BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = 'invalid bit length repeat';
                        state.mode = $ff5dc738affa778e$var$BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === $ff5dc738affa778e$var$BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = 'invalid code -- missing end-of-block';
                state.mode = $ff5dc738affa778e$var$BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = $6d8ea7ac8a31118f$exports($ff5dc738affa778e$var$LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = 'invalid literal/lengths set';
                state.mode = $ff5dc738affa778e$var$BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = $6d8ea7ac8a31118f$exports($ff5dc738affa778e$var$DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = 'invalid distances set';
                state.mode = $ff5dc738affa778e$var$BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = $ff5dc738affa778e$var$LEN_;
            if (flush === $ff5dc738affa778e$var$Z_TREES) break inf_leave;
        /* falls through */ case $ff5dc738affa778e$var$LEN_:
            state.mode = $ff5dc738affa778e$var$LEN;
        /* falls through */ case $ff5dc738affa778e$var$LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                $ff54ef8e9c6c3f90$exports(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === $ff5dc738affa778e$var$TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = $ff5dc738affa778e$var$LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = $ff5dc738affa778e$var$TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = 'invalid literal/length code';
                state.mode = $ff5dc738affa778e$var$BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = $ff5dc738affa778e$var$LENEXT;
        /* falls through */ case $ff5dc738affa778e$var$LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = $ff5dc738affa778e$var$DIST;
        /* falls through */ case $ff5dc738affa778e$var$DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = 'invalid distance code';
                state.mode = $ff5dc738affa778e$var$BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = $ff5dc738affa778e$var$DISTEXT;
        /* falls through */ case $ff5dc738affa778e$var$DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = 'invalid distance too far back';
                state.mode = $ff5dc738affa778e$var$BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = $ff5dc738affa778e$var$MATCH;
        /* falls through */ case $ff5dc738affa778e$var$MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = 'invalid distance too far back';
                        state.mode = $ff5dc738affa778e$var$BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = $ff5dc738affa778e$var$LEN;
            break;
        case $ff5dc738affa778e$var$LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = $ff5dc738affa778e$var$LEN;
            break;
        case $ff5dc738affa778e$var$CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (_out) strm.adler = state.check = /*UPDATE(state.check, put - _out, _out);*/ state.flags ? $abfa54b01eefbc9c$exports(state.check, output, _out, put - _out) : $e6e0cd37d3935915$exports(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if ((state.flags ? hold : $ff5dc738affa778e$var$zswap32(hold)) !== state.check) {
                    strm.msg = 'incorrect data check';
                    state.mode = $ff5dc738affa778e$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = $ff5dc738affa778e$var$LENGTH;
        /* falls through */ case $ff5dc738affa778e$var$LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.total & 0xffffffff)) {
                    strm.msg = 'incorrect length check';
                    state.mode = $ff5dc738affa778e$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = $ff5dc738affa778e$var$DONE;
        /* falls through */ case $ff5dc738affa778e$var$DONE:
            ret = $ff5dc738affa778e$var$Z_STREAM_END;
            break inf_leave;
        case $ff5dc738affa778e$var$BAD:
            ret = $ff5dc738affa778e$var$Z_DATA_ERROR;
            break inf_leave;
        case $ff5dc738affa778e$var$MEM:
            return $ff5dc738affa778e$var$Z_MEM_ERROR;
        case $ff5dc738affa778e$var$SYNC:
        /* falls through */ default:
            return $ff5dc738affa778e$var$Z_STREAM_ERROR;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < $ff5dc738affa778e$var$BAD && (state.mode < $ff5dc738affa778e$var$CHECK || flush !== $ff5dc738affa778e$var$Z_FINISH)) {
        if ($ff5dc738affa778e$var$updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
            state.mode = $ff5dc738affa778e$var$MEM;
            return $ff5dc738affa778e$var$Z_MEM_ERROR;
        }
    }
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap && _out) strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/ state.flags ? $abfa54b01eefbc9c$exports(state.check, output, _out, strm.next_out - _out) : $e6e0cd37d3935915$exports(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === $ff5dc738affa778e$var$TYPE ? 128 : 0) + (state.mode === $ff5dc738affa778e$var$LEN_ || state.mode === $ff5dc738affa778e$var$COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === $ff5dc738affa778e$var$Z_FINISH) && ret === $ff5dc738affa778e$var$Z_OK) ret = $ff5dc738affa778e$var$Z_BUF_ERROR;
    return ret;
}
function $ff5dc738affa778e$var$inflateEnd(strm) {
    if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/ ) return $ff5dc738affa778e$var$Z_STREAM_ERROR;
    var state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return $ff5dc738affa778e$var$Z_OK;
}
function $ff5dc738affa778e$var$inflateGetHeader(strm, head) {
    var state;
    /* check state */ if (!strm || !strm.state) return $ff5dc738affa778e$var$Z_STREAM_ERROR;
    state = strm.state;
    if ((state.wrap & 2) === 0) return $ff5dc738affa778e$var$Z_STREAM_ERROR;
    /* save header structure */ state.head = head;
    head.done = false;
    return $ff5dc738affa778e$var$Z_OK;
}
function $ff5dc738affa778e$var$inflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var state;
    var dictid;
    var ret;
    /* check state */ if (!strm /* == Z_NULL */  || !strm.state /* == Z_NULL */ ) return $ff5dc738affa778e$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== $ff5dc738affa778e$var$DICT) return $ff5dc738affa778e$var$Z_STREAM_ERROR;
    /* check for correct dictionary identifier */ if (state.mode === $ff5dc738affa778e$var$DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = $e6e0cd37d3935915$exports(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return $ff5dc738affa778e$var$Z_DATA_ERROR;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = $ff5dc738affa778e$var$updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = $ff5dc738affa778e$var$MEM;
        return $ff5dc738affa778e$var$Z_MEM_ERROR;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return $ff5dc738affa778e$var$Z_OK;
}
$ff5dc738affa778e$export$42de45683a92ba94 = $ff5dc738affa778e$var$inflateReset;
$ff5dc738affa778e$export$7633ac2cd30f9650 = $ff5dc738affa778e$var$inflateReset2;
$ff5dc738affa778e$export$6710ea52c4ec9d6a = $ff5dc738affa778e$var$inflateResetKeep;
$ff5dc738affa778e$export$9c140b25e26874f9 = $ff5dc738affa778e$var$inflateInit;
$ff5dc738affa778e$export$6792d92addc5c8a0 = $ff5dc738affa778e$var$inflateInit2;
$ff5dc738affa778e$export$cae1ce83fe4a1782 = $ff5dc738affa778e$var$inflate;
$ff5dc738affa778e$export$224e1a443c3fba76 = $ff5dc738affa778e$var$inflateEnd;
$ff5dc738affa778e$export$6d4647cb9e1c75fc = $ff5dc738affa778e$var$inflateGetHeader;
$ff5dc738affa778e$export$60da749bed98ccf8 = $ff5dc738affa778e$var$inflateSetDictionary;
$ff5dc738affa778e$export$220f6291ca35fd71 = 'pako inflate (from Nodeca project)'; /* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/ 


var $b20a44cea599af70$exports = {};
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
$b20a44cea599af70$exports = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    //Z_MEM_ERROR:     -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};


for(var $84b780ee88fc5cbe$var$key in $b20a44cea599af70$exports)$84b780ee88fc5cbe$exports[$84b780ee88fc5cbe$var$key] = $b20a44cea599af70$exports[$84b780ee88fc5cbe$var$key];
// zlib modes
$84b780ee88fc5cbe$exports.NONE = 0;
$84b780ee88fc5cbe$exports.DEFLATE = 1;
$84b780ee88fc5cbe$exports.INFLATE = 2;
$84b780ee88fc5cbe$exports.GZIP = 3;
$84b780ee88fc5cbe$exports.GUNZIP = 4;
$84b780ee88fc5cbe$exports.DEFLATERAW = 5;
$84b780ee88fc5cbe$exports.INFLATERAW = 6;
$84b780ee88fc5cbe$exports.UNZIP = 7;
var $84b780ee88fc5cbe$var$GZIP_HEADER_ID1 = 0x1f;
var $84b780ee88fc5cbe$var$GZIP_HEADER_ID2 = 0x8b;
/**
 * Emulate Node's zlib C++ layer for use by the JS layer in index.js
 */ function $84b780ee88fc5cbe$var$Zlib(mode) {
    if (typeof mode !== 'number' || mode < $84b780ee88fc5cbe$exports.DEFLATE || mode > $84b780ee88fc5cbe$exports.UNZIP) throw new TypeError('Bad argument');
    this.dictionary = null;
    this.err = 0;
    this.flush = 0;
    this.init_done = false;
    this.level = 0;
    this.memLevel = 0;
    this.mode = mode;
    this.strategy = 0;
    this.windowBits = 0;
    this.write_in_progress = false;
    this.pending_close = false;
    this.gzip_id_bytes_read = 0;
}
$84b780ee88fc5cbe$var$Zlib.prototype.close = function() {
    if (this.write_in_progress) {
        this.pending_close = true;
        return;
    }
    this.pending_close = false;
    $hWeez(this.init_done, 'close before init');
    $hWeez(this.mode <= $84b780ee88fc5cbe$exports.UNZIP);
    if (this.mode === $84b780ee88fc5cbe$exports.DEFLATE || this.mode === $84b780ee88fc5cbe$exports.GZIP || this.mode === $84b780ee88fc5cbe$exports.DEFLATERAW) $cba2acc47781bd54$export$599854fa319a815f(this.strm);
    else if (this.mode === $84b780ee88fc5cbe$exports.INFLATE || this.mode === $84b780ee88fc5cbe$exports.GUNZIP || this.mode === $84b780ee88fc5cbe$exports.INFLATERAW || this.mode === $84b780ee88fc5cbe$exports.UNZIP) $ff5dc738affa778e$export$224e1a443c3fba76(this.strm);
    this.mode = $84b780ee88fc5cbe$exports.NONE;
    this.dictionary = null;
};
$84b780ee88fc5cbe$var$Zlib.prototype.write = function(flush, input, in_off, in_len, out, out_off, out_len) {
    return this._write(true, flush, input, in_off, in_len, out, out_off, out_len);
};
$84b780ee88fc5cbe$var$Zlib.prototype.writeSync = function(flush, input, in_off, in_len, out, out_off, out_len) {
    return this._write(false, flush, input, in_off, in_len, out, out_off, out_len);
};
$84b780ee88fc5cbe$var$Zlib.prototype._write = function(async, flush, input, in_off, in_len, out, out_off, out_len) {
    $hWeez.equal(arguments.length, 8);
    $hWeez(this.init_done, 'write before init');
    $hWeez(this.mode !== $84b780ee88fc5cbe$exports.NONE, 'already finalized');
    $hWeez.equal(false, this.write_in_progress, 'write already in progress');
    $hWeez.equal(false, this.pending_close, 'close is pending');
    this.write_in_progress = true;
    $hWeez.equal(false, flush === undefined, 'must provide flush value');
    this.write_in_progress = true;
    if (flush !== $84b780ee88fc5cbe$exports.Z_NO_FLUSH && flush !== $84b780ee88fc5cbe$exports.Z_PARTIAL_FLUSH && flush !== $84b780ee88fc5cbe$exports.Z_SYNC_FLUSH && flush !== $84b780ee88fc5cbe$exports.Z_FULL_FLUSH && flush !== $84b780ee88fc5cbe$exports.Z_FINISH && flush !== $84b780ee88fc5cbe$exports.Z_BLOCK) throw new Error('Invalid flush value');
    if (input == null) {
        input = $84b780ee88fc5cbe$require$Buffer.alloc(0);
        in_len = 0;
        in_off = 0;
    }
    this.strm.avail_in = in_len;
    this.strm.input = input;
    this.strm.next_in = in_off;
    this.strm.avail_out = out_len;
    this.strm.output = out;
    this.strm.next_out = out_off;
    this.flush = flush;
    if (!async) {
        // sync version
        this._process();
        if (this._checkError()) return this._afterSync();
        return;
    }
    // async version
    var self = this;
    $fHA2F.nextTick(function() {
        self._process();
        self._after();
    });
    return this;
};
$84b780ee88fc5cbe$var$Zlib.prototype._afterSync = function() {
    var avail_out = this.strm.avail_out;
    var avail_in = this.strm.avail_in;
    this.write_in_progress = false;
    return [
        avail_in,
        avail_out
    ];
};
$84b780ee88fc5cbe$var$Zlib.prototype._process = function() {
    var next_expected_header_byte = null;
    // If the avail_out is left at 0, then it means that it ran out
    // of room.  If there was avail_out left over, then it means
    // that all of the input was consumed.
    switch(this.mode){
        case $84b780ee88fc5cbe$exports.DEFLATE:
        case $84b780ee88fc5cbe$exports.GZIP:
        case $84b780ee88fc5cbe$exports.DEFLATERAW:
            this.err = $cba2acc47781bd54$export$2316623ecd1285ab(this.strm, this.flush);
            break;
        case $84b780ee88fc5cbe$exports.UNZIP:
            if (this.strm.avail_in > 0) next_expected_header_byte = this.strm.next_in;
            switch(this.gzip_id_bytes_read){
                case 0:
                    if (next_expected_header_byte === null) break;
                    if (this.strm.input[next_expected_header_byte] === $84b780ee88fc5cbe$var$GZIP_HEADER_ID1) {
                        this.gzip_id_bytes_read = 1;
                        next_expected_header_byte++;
                        if (this.strm.avail_in === 1) break;
                    } else {
                        this.mode = $84b780ee88fc5cbe$exports.INFLATE;
                        break;
                    }
                // fallthrough
                case 1:
                    if (next_expected_header_byte === null) break;
                    if (this.strm.input[next_expected_header_byte] === $84b780ee88fc5cbe$var$GZIP_HEADER_ID2) {
                        this.gzip_id_bytes_read = 2;
                        this.mode = $84b780ee88fc5cbe$exports.GUNZIP;
                    } else // There is no actual difference between INFLATE and INFLATERAW
                    // (after initialization).
                    this.mode = $84b780ee88fc5cbe$exports.INFLATE;
                    break;
                default:
                    throw new Error('invalid number of gzip magic number bytes read');
            }
        // fallthrough
        case $84b780ee88fc5cbe$exports.INFLATE:
        case $84b780ee88fc5cbe$exports.GUNZIP:
        case $84b780ee88fc5cbe$exports.INFLATERAW:
            this.err = $ff5dc738affa778e$export$cae1ce83fe4a1782(this.strm, this.flush);
            if (this.err === $84b780ee88fc5cbe$exports.Z_NEED_DICT && this.dictionary) {
                // Load it
                this.err = $ff5dc738affa778e$export$60da749bed98ccf8(this.strm, this.dictionary);
                if (this.err === $84b780ee88fc5cbe$exports.Z_OK) // And try to decode again
                this.err = $ff5dc738affa778e$export$cae1ce83fe4a1782(this.strm, this.flush);
                else if (this.err === $84b780ee88fc5cbe$exports.Z_DATA_ERROR) // Both inflateSetDictionary() and inflate() return Z_DATA_ERROR.
                // Make it possible for After() to tell a bad dictionary from bad
                // input.
                this.err = $84b780ee88fc5cbe$exports.Z_NEED_DICT;
            }
            while(this.strm.avail_in > 0 && this.mode === $84b780ee88fc5cbe$exports.GUNZIP && this.err === $84b780ee88fc5cbe$exports.Z_STREAM_END && this.strm.next_in[0] !== 0x00){
                // Bytes remain in input buffer. Perhaps this is another compressed
                // member in the same archive, or just trailing garbage.
                // Trailing zero bytes are okay, though, since they are frequently
                // used for padding.
                this.reset();
                this.err = $ff5dc738affa778e$export$cae1ce83fe4a1782(this.strm, this.flush);
            }
            break;
        default:
            throw new Error('Unknown mode ' + this.mode);
    }
};
$84b780ee88fc5cbe$var$Zlib.prototype._checkError = function() {
    // Acceptable error states depend on the type of zlib stream.
    switch(this.err){
        case $84b780ee88fc5cbe$exports.Z_OK:
        case $84b780ee88fc5cbe$exports.Z_BUF_ERROR:
            if (this.strm.avail_out !== 0 && this.flush === $84b780ee88fc5cbe$exports.Z_FINISH) {
                this._error('unexpected end of file');
                return false;
            }
            break;
        case $84b780ee88fc5cbe$exports.Z_STREAM_END:
            break;
        case $84b780ee88fc5cbe$exports.Z_NEED_DICT:
            if (this.dictionary == null) this._error('Missing dictionary');
            else this._error('Bad dictionary');
            return false;
        default:
            // something else.
            this._error('Zlib error');
            return false;
    }
    return true;
};
$84b780ee88fc5cbe$var$Zlib.prototype._after = function() {
    if (!this._checkError()) return;
    var avail_out = this.strm.avail_out;
    var avail_in = this.strm.avail_in;
    this.write_in_progress = false;
    // call the write() cb
    this.callback(avail_in, avail_out);
    if (this.pending_close) this.close();
};
$84b780ee88fc5cbe$var$Zlib.prototype._error = function(message) {
    if (this.strm.msg) message = this.strm.msg;
    this.onerror(message, this.err);
    this.write_in_progress = false;
    if (this.pending_close) this.close();
};
$84b780ee88fc5cbe$var$Zlib.prototype.init = function(windowBits, level, memLevel, strategy, dictionary) {
    $hWeez(arguments.length === 4 || arguments.length === 5, 'init(windowBits, level, memLevel, strategy, [dictionary])');
    $hWeez(windowBits >= 8 && windowBits <= 15, 'invalid windowBits');
    $hWeez(level >= -1 && level <= 9, 'invalid compression level');
    $hWeez(memLevel >= 1 && memLevel <= 9, 'invalid memlevel');
    $hWeez(strategy === $84b780ee88fc5cbe$exports.Z_FILTERED || strategy === $84b780ee88fc5cbe$exports.Z_HUFFMAN_ONLY || strategy === $84b780ee88fc5cbe$exports.Z_RLE || strategy === $84b780ee88fc5cbe$exports.Z_FIXED || strategy === $84b780ee88fc5cbe$exports.Z_DEFAULT_STRATEGY, 'invalid strategy');
    this._init(level, windowBits, memLevel, strategy, dictionary);
    this._setDictionary();
};
$84b780ee88fc5cbe$var$Zlib.prototype.params = function() {
    throw new Error('deflateParams Not supported');
};
$84b780ee88fc5cbe$var$Zlib.prototype.reset = function() {
    this._reset();
    this._setDictionary();
};
$84b780ee88fc5cbe$var$Zlib.prototype._init = function(level, windowBits, memLevel, strategy, dictionary) {
    this.level = level;
    this.windowBits = windowBits;
    this.memLevel = memLevel;
    this.strategy = strategy;
    this.flush = $84b780ee88fc5cbe$exports.Z_NO_FLUSH;
    this.err = $84b780ee88fc5cbe$exports.Z_OK;
    if (this.mode === $84b780ee88fc5cbe$exports.GZIP || this.mode === $84b780ee88fc5cbe$exports.GUNZIP) this.windowBits += 16;
    if (this.mode === $84b780ee88fc5cbe$exports.UNZIP) this.windowBits += 32;
    if (this.mode === $84b780ee88fc5cbe$exports.DEFLATERAW || this.mode === $84b780ee88fc5cbe$exports.INFLATERAW) this.windowBits = -1 * this.windowBits;
    this.strm = new $9157a19f3760ca94$exports();
    switch(this.mode){
        case $84b780ee88fc5cbe$exports.DEFLATE:
        case $84b780ee88fc5cbe$exports.GZIP:
        case $84b780ee88fc5cbe$exports.DEFLATERAW:
            this.err = $cba2acc47781bd54$export$a65c7b2bde87cb70(this.strm, this.level, $84b780ee88fc5cbe$exports.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
            break;
        case $84b780ee88fc5cbe$exports.INFLATE:
        case $84b780ee88fc5cbe$exports.GUNZIP:
        case $84b780ee88fc5cbe$exports.INFLATERAW:
        case $84b780ee88fc5cbe$exports.UNZIP:
            this.err = $ff5dc738affa778e$export$6792d92addc5c8a0(this.strm, this.windowBits);
            break;
        default:
            throw new Error('Unknown mode ' + this.mode);
    }
    if (this.err !== $84b780ee88fc5cbe$exports.Z_OK) this._error('Init error');
    this.dictionary = dictionary;
    this.write_in_progress = false;
    this.init_done = true;
};
$84b780ee88fc5cbe$var$Zlib.prototype._setDictionary = function() {
    if (this.dictionary == null) return;
    this.err = $84b780ee88fc5cbe$exports.Z_OK;
    switch(this.mode){
        case $84b780ee88fc5cbe$exports.DEFLATE:
        case $84b780ee88fc5cbe$exports.DEFLATERAW:
            this.err = $cba2acc47781bd54$export$f55e0b3ab66b5d46(this.strm, this.dictionary);
            break;
        default:
            break;
    }
    if (this.err !== $84b780ee88fc5cbe$exports.Z_OK) this._error('Failed to set dictionary');
};
$84b780ee88fc5cbe$var$Zlib.prototype._reset = function() {
    this.err = $84b780ee88fc5cbe$exports.Z_OK;
    switch(this.mode){
        case $84b780ee88fc5cbe$exports.DEFLATE:
        case $84b780ee88fc5cbe$exports.DEFLATERAW:
        case $84b780ee88fc5cbe$exports.GZIP:
            this.err = $cba2acc47781bd54$export$8f99f0e30bc7dd53(this.strm);
            break;
        case $84b780ee88fc5cbe$exports.INFLATE:
        case $84b780ee88fc5cbe$exports.INFLATERAW:
        case $84b780ee88fc5cbe$exports.GUNZIP:
            this.err = $ff5dc738affa778e$export$42de45683a92ba94(this.strm);
            break;
        default:
            break;
    }
    if (this.err !== $84b780ee88fc5cbe$exports.Z_OK) this._error('Failed to reset stream');
};
$84b780ee88fc5cbe$exports.Zlib = $84b780ee88fc5cbe$var$Zlib;



var $62zul = parcelRequire("62zul");

var $hWeez = parcelRequire("hWeez");
var $21fad10a767337ad$require$assert = $hWeez.ok;

var $lGjml = parcelRequire("lGjml");
var $21fad10a767337ad$require$kMaxLength = $lGjml.kMaxLength;
var $21fad10a767337ad$var$kRangeErrorMessage = "Cannot create final Buffer. It would be larger than 0x" + $21fad10a767337ad$require$kMaxLength.toString(16) + ' bytes';
// zlib doesn't provide these, so kludge them in following the same
// const naming scheme zlib uses.
$84b780ee88fc5cbe$exports.Z_MIN_WINDOWBITS = 8;
$84b780ee88fc5cbe$exports.Z_MAX_WINDOWBITS = 15;
$84b780ee88fc5cbe$exports.Z_DEFAULT_WINDOWBITS = 15;
// fewer than 64 bytes per chunk is stupid.
// technically it could work with as few as 8, but even 64 bytes
// is absurdly low.  Usually a MB or more is best.
$84b780ee88fc5cbe$exports.Z_MIN_CHUNK = 64;
$84b780ee88fc5cbe$exports.Z_MAX_CHUNK = Infinity;
$84b780ee88fc5cbe$exports.Z_DEFAULT_CHUNK = 16384;
$84b780ee88fc5cbe$exports.Z_MIN_MEMLEVEL = 1;
$84b780ee88fc5cbe$exports.Z_MAX_MEMLEVEL = 9;
$84b780ee88fc5cbe$exports.Z_DEFAULT_MEMLEVEL = 8;
$84b780ee88fc5cbe$exports.Z_MIN_LEVEL = -1;
$84b780ee88fc5cbe$exports.Z_MAX_LEVEL = 9;
$84b780ee88fc5cbe$exports.Z_DEFAULT_LEVEL = $84b780ee88fc5cbe$exports.Z_DEFAULT_COMPRESSION;
// expose all the zlib constants
var $21fad10a767337ad$var$bkeys = Object.keys($84b780ee88fc5cbe$exports);
for(var $21fad10a767337ad$var$bk = 0; $21fad10a767337ad$var$bk < $21fad10a767337ad$var$bkeys.length; $21fad10a767337ad$var$bk++){
    var $21fad10a767337ad$var$bkey = $21fad10a767337ad$var$bkeys[$21fad10a767337ad$var$bk];
    if ($21fad10a767337ad$var$bkey.match(/^Z/)) Object.defineProperty($21fad10a767337ad$exports, $21fad10a767337ad$var$bkey, {
        enumerable: true,
        value: $84b780ee88fc5cbe$exports[$21fad10a767337ad$var$bkey],
        writable: false
    });
}
// translation table for return codes.
var $21fad10a767337ad$var$codes = {
    Z_OK: $84b780ee88fc5cbe$exports.Z_OK,
    Z_STREAM_END: $84b780ee88fc5cbe$exports.Z_STREAM_END,
    Z_NEED_DICT: $84b780ee88fc5cbe$exports.Z_NEED_DICT,
    Z_ERRNO: $84b780ee88fc5cbe$exports.Z_ERRNO,
    Z_STREAM_ERROR: $84b780ee88fc5cbe$exports.Z_STREAM_ERROR,
    Z_DATA_ERROR: $84b780ee88fc5cbe$exports.Z_DATA_ERROR,
    Z_MEM_ERROR: $84b780ee88fc5cbe$exports.Z_MEM_ERROR,
    Z_BUF_ERROR: $84b780ee88fc5cbe$exports.Z_BUF_ERROR,
    Z_VERSION_ERROR: $84b780ee88fc5cbe$exports.Z_VERSION_ERROR
};
var $21fad10a767337ad$var$ckeys = Object.keys($21fad10a767337ad$var$codes);
for(var $21fad10a767337ad$var$ck = 0; $21fad10a767337ad$var$ck < $21fad10a767337ad$var$ckeys.length; $21fad10a767337ad$var$ck++){
    var $21fad10a767337ad$var$ckey = $21fad10a767337ad$var$ckeys[$21fad10a767337ad$var$ck];
    $21fad10a767337ad$var$codes[$21fad10a767337ad$var$codes[$21fad10a767337ad$var$ckey]] = $21fad10a767337ad$var$ckey;
}
Object.defineProperty($21fad10a767337ad$exports, 'codes', {
    enumerable: true,
    value: Object.freeze($21fad10a767337ad$var$codes),
    writable: false
});
$21fad10a767337ad$exports.Deflate = $21fad10a767337ad$var$Deflate;
$21fad10a767337ad$exports.Inflate = $21fad10a767337ad$var$Inflate;
$21fad10a767337ad$exports.Gzip = $21fad10a767337ad$var$Gzip;
$21fad10a767337ad$exports.Gunzip = $21fad10a767337ad$var$Gunzip;
$21fad10a767337ad$exports.DeflateRaw = $21fad10a767337ad$var$DeflateRaw;
$21fad10a767337ad$exports.InflateRaw = $21fad10a767337ad$var$InflateRaw;
$21fad10a767337ad$exports.Unzip = $21fad10a767337ad$var$Unzip;
$21fad10a767337ad$exports.createDeflate = function(o) {
    return new $21fad10a767337ad$var$Deflate(o);
};
$21fad10a767337ad$exports.createInflate = function(o) {
    return new $21fad10a767337ad$var$Inflate(o);
};
$21fad10a767337ad$exports.createDeflateRaw = function(o) {
    return new $21fad10a767337ad$var$DeflateRaw(o);
};
$21fad10a767337ad$exports.createInflateRaw = function(o) {
    return new $21fad10a767337ad$var$InflateRaw(o);
};
$21fad10a767337ad$exports.createGzip = function(o) {
    return new $21fad10a767337ad$var$Gzip(o);
};
$21fad10a767337ad$exports.createGunzip = function(o) {
    return new $21fad10a767337ad$var$Gunzip(o);
};
$21fad10a767337ad$exports.createUnzip = function(o) {
    return new $21fad10a767337ad$var$Unzip(o);
};
// Convenience methods.
// compress/decompress a string or buffer in one step.
$21fad10a767337ad$exports.deflate = function(buffer, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    return $21fad10a767337ad$var$zlibBuffer(new $21fad10a767337ad$var$Deflate(opts), buffer, callback);
};
$21fad10a767337ad$exports.deflateSync = function(buffer, opts) {
    return $21fad10a767337ad$var$zlibBufferSync(new $21fad10a767337ad$var$Deflate(opts), buffer);
};
$21fad10a767337ad$exports.gzip = function(buffer, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    return $21fad10a767337ad$var$zlibBuffer(new $21fad10a767337ad$var$Gzip(opts), buffer, callback);
};
$21fad10a767337ad$exports.gzipSync = function(buffer, opts) {
    return $21fad10a767337ad$var$zlibBufferSync(new $21fad10a767337ad$var$Gzip(opts), buffer);
};
$21fad10a767337ad$exports.deflateRaw = function(buffer, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    return $21fad10a767337ad$var$zlibBuffer(new $21fad10a767337ad$var$DeflateRaw(opts), buffer, callback);
};
$21fad10a767337ad$exports.deflateRawSync = function(buffer, opts) {
    return $21fad10a767337ad$var$zlibBufferSync(new $21fad10a767337ad$var$DeflateRaw(opts), buffer);
};
$21fad10a767337ad$exports.unzip = function(buffer, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    return $21fad10a767337ad$var$zlibBuffer(new $21fad10a767337ad$var$Unzip(opts), buffer, callback);
};
$21fad10a767337ad$exports.unzipSync = function(buffer, opts) {
    return $21fad10a767337ad$var$zlibBufferSync(new $21fad10a767337ad$var$Unzip(opts), buffer);
};
$21fad10a767337ad$exports.inflate = function(buffer, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    return $21fad10a767337ad$var$zlibBuffer(new $21fad10a767337ad$var$Inflate(opts), buffer, callback);
};
$21fad10a767337ad$exports.inflateSync = function(buffer, opts) {
    return $21fad10a767337ad$var$zlibBufferSync(new $21fad10a767337ad$var$Inflate(opts), buffer);
};
$21fad10a767337ad$exports.gunzip = function(buffer, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    return $21fad10a767337ad$var$zlibBuffer(new $21fad10a767337ad$var$Gunzip(opts), buffer, callback);
};
$21fad10a767337ad$exports.gunzipSync = function(buffer, opts) {
    return $21fad10a767337ad$var$zlibBufferSync(new $21fad10a767337ad$var$Gunzip(opts), buffer);
};
$21fad10a767337ad$exports.inflateRaw = function(buffer, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    return $21fad10a767337ad$var$zlibBuffer(new $21fad10a767337ad$var$InflateRaw(opts), buffer, callback);
};
$21fad10a767337ad$exports.inflateRawSync = function(buffer, opts) {
    return $21fad10a767337ad$var$zlibBufferSync(new $21fad10a767337ad$var$InflateRaw(opts), buffer);
};
function $21fad10a767337ad$var$zlibBuffer(engine, buffer, callback) {
    var buffers = [];
    var nread = 0;
    engine.on('error', onError);
    engine.on('end', onEnd);
    engine.end(buffer);
    flow();
    function flow() {
        var chunk;
        while(null !== (chunk = engine.read())){
            buffers.push(chunk);
            nread += chunk.length;
        }
        engine.once('readable', flow);
    }
    function onError(err) {
        engine.removeListener('end', onEnd);
        engine.removeListener('readable', flow);
        callback(err);
    }
    function onEnd() {
        var buf;
        var err = null;
        if (nread >= $21fad10a767337ad$require$kMaxLength) err = new RangeError($21fad10a767337ad$var$kRangeErrorMessage);
        else buf = $21fad10a767337ad$require$Buffer.concat(buffers, nread);
        buffers = [];
        engine.close();
        callback(err, buf);
    }
}
function $21fad10a767337ad$var$zlibBufferSync(engine, buffer) {
    if (typeof buffer === 'string') buffer = $21fad10a767337ad$require$Buffer.from(buffer);
    if (!$21fad10a767337ad$require$Buffer.isBuffer(buffer)) throw new TypeError('Not a string or buffer');
    var flushFlag = engine._finishFlushFlag;
    return engine._processChunk(buffer, flushFlag);
}
// generic zlib
// minimal 2-byte header
function $21fad10a767337ad$var$Deflate(opts) {
    if (!(this instanceof $21fad10a767337ad$var$Deflate)) return new $21fad10a767337ad$var$Deflate(opts);
    $21fad10a767337ad$var$Zlib.call(this, opts, $84b780ee88fc5cbe$exports.DEFLATE);
}
function $21fad10a767337ad$var$Inflate(opts) {
    if (!(this instanceof $21fad10a767337ad$var$Inflate)) return new $21fad10a767337ad$var$Inflate(opts);
    $21fad10a767337ad$var$Zlib.call(this, opts, $84b780ee88fc5cbe$exports.INFLATE);
}
// gzip - bigger header, same deflate compression
function $21fad10a767337ad$var$Gzip(opts) {
    if (!(this instanceof $21fad10a767337ad$var$Gzip)) return new $21fad10a767337ad$var$Gzip(opts);
    $21fad10a767337ad$var$Zlib.call(this, opts, $84b780ee88fc5cbe$exports.GZIP);
}
function $21fad10a767337ad$var$Gunzip(opts) {
    if (!(this instanceof $21fad10a767337ad$var$Gunzip)) return new $21fad10a767337ad$var$Gunzip(opts);
    $21fad10a767337ad$var$Zlib.call(this, opts, $84b780ee88fc5cbe$exports.GUNZIP);
}
// raw - no header
function $21fad10a767337ad$var$DeflateRaw(opts) {
    if (!(this instanceof $21fad10a767337ad$var$DeflateRaw)) return new $21fad10a767337ad$var$DeflateRaw(opts);
    $21fad10a767337ad$var$Zlib.call(this, opts, $84b780ee88fc5cbe$exports.DEFLATERAW);
}
function $21fad10a767337ad$var$InflateRaw(opts) {
    if (!(this instanceof $21fad10a767337ad$var$InflateRaw)) return new $21fad10a767337ad$var$InflateRaw(opts);
    $21fad10a767337ad$var$Zlib.call(this, opts, $84b780ee88fc5cbe$exports.INFLATERAW);
}
// auto-detect header.
function $21fad10a767337ad$var$Unzip(opts) {
    if (!(this instanceof $21fad10a767337ad$var$Unzip)) return new $21fad10a767337ad$var$Unzip(opts);
    $21fad10a767337ad$var$Zlib.call(this, opts, $84b780ee88fc5cbe$exports.UNZIP);
}
function $21fad10a767337ad$var$isValidFlushFlag(flag) {
    return flag === $84b780ee88fc5cbe$exports.Z_NO_FLUSH || flag === $84b780ee88fc5cbe$exports.Z_PARTIAL_FLUSH || flag === $84b780ee88fc5cbe$exports.Z_SYNC_FLUSH || flag === $84b780ee88fc5cbe$exports.Z_FULL_FLUSH || flag === $84b780ee88fc5cbe$exports.Z_FINISH || flag === $84b780ee88fc5cbe$exports.Z_BLOCK;
}
// the Zlib class they all inherit from
// This thing manages the queue of requests, and returns
// true or false if there is anything in the queue when
// you call the .write() method.
function $21fad10a767337ad$var$Zlib(opts, mode) {
    var _this = this;
    this._opts = opts = opts || {};
    this._chunkSize = opts.chunkSize || $21fad10a767337ad$exports.Z_DEFAULT_CHUNK;
    $21fad10a767337ad$require$Transform.call(this, opts);
    if (opts.flush && !$21fad10a767337ad$var$isValidFlushFlag(opts.flush)) throw new Error('Invalid flush flag: ' + opts.flush);
    if (opts.finishFlush && !$21fad10a767337ad$var$isValidFlushFlag(opts.finishFlush)) throw new Error('Invalid flush flag: ' + opts.finishFlush);
    this._flushFlag = opts.flush || $84b780ee88fc5cbe$exports.Z_NO_FLUSH;
    this._finishFlushFlag = typeof opts.finishFlush !== 'undefined' ? opts.finishFlush : $84b780ee88fc5cbe$exports.Z_FINISH;
    if (opts.chunkSize) {
        if (opts.chunkSize < $21fad10a767337ad$exports.Z_MIN_CHUNK || opts.chunkSize > $21fad10a767337ad$exports.Z_MAX_CHUNK) throw new Error('Invalid chunk size: ' + opts.chunkSize);
    }
    if (opts.windowBits) {
        if (opts.windowBits < $21fad10a767337ad$exports.Z_MIN_WINDOWBITS || opts.windowBits > $21fad10a767337ad$exports.Z_MAX_WINDOWBITS) throw new Error('Invalid windowBits: ' + opts.windowBits);
    }
    if (opts.level) {
        if (opts.level < $21fad10a767337ad$exports.Z_MIN_LEVEL || opts.level > $21fad10a767337ad$exports.Z_MAX_LEVEL) throw new Error('Invalid compression level: ' + opts.level);
    }
    if (opts.memLevel) {
        if (opts.memLevel < $21fad10a767337ad$exports.Z_MIN_MEMLEVEL || opts.memLevel > $21fad10a767337ad$exports.Z_MAX_MEMLEVEL) throw new Error('Invalid memLevel: ' + opts.memLevel);
    }
    if (opts.strategy) {
        if (opts.strategy != $21fad10a767337ad$exports.Z_FILTERED && opts.strategy != $21fad10a767337ad$exports.Z_HUFFMAN_ONLY && opts.strategy != $21fad10a767337ad$exports.Z_RLE && opts.strategy != $21fad10a767337ad$exports.Z_FIXED && opts.strategy != $21fad10a767337ad$exports.Z_DEFAULT_STRATEGY) throw new Error('Invalid strategy: ' + opts.strategy);
    }
    if (opts.dictionary) {
        if (!$21fad10a767337ad$require$Buffer.isBuffer(opts.dictionary)) throw new Error('Invalid dictionary: it should be a Buffer instance');
    }
    this._handle = new $84b780ee88fc5cbe$exports.Zlib(mode);
    var self = this;
    this._hadError = false;
    this._handle.onerror = function(message, errno) {
        // there is no way to cleanly recover.
        // continuing only obscures problems.
        $21fad10a767337ad$var$_close(self);
        self._hadError = true;
        var error = new Error(message);
        error.errno = errno;
        error.code = $21fad10a767337ad$exports.codes[errno];
        self.emit('error', error);
    };
    var level = $21fad10a767337ad$exports.Z_DEFAULT_COMPRESSION;
    if (typeof opts.level === 'number') level = opts.level;
    var strategy = $21fad10a767337ad$exports.Z_DEFAULT_STRATEGY;
    if (typeof opts.strategy === 'number') strategy = opts.strategy;
    this._handle.init(opts.windowBits || $21fad10a767337ad$exports.Z_DEFAULT_WINDOWBITS, level, opts.memLevel || $21fad10a767337ad$exports.Z_DEFAULT_MEMLEVEL, strategy, opts.dictionary);
    this._buffer = $21fad10a767337ad$require$Buffer.allocUnsafe(this._chunkSize);
    this._offset = 0;
    this._level = level;
    this._strategy = strategy;
    this.once('end', this.close);
    Object.defineProperty(this, '_closed', {
        get: function() {
            return !_this._handle;
        },
        configurable: true,
        enumerable: true
    });
}
$62zul.inherits($21fad10a767337ad$var$Zlib, $21fad10a767337ad$require$Transform);
$21fad10a767337ad$var$Zlib.prototype.params = function(level, strategy, callback) {
    if (level < $21fad10a767337ad$exports.Z_MIN_LEVEL || level > $21fad10a767337ad$exports.Z_MAX_LEVEL) throw new RangeError('Invalid compression level: ' + level);
    if (strategy != $21fad10a767337ad$exports.Z_FILTERED && strategy != $21fad10a767337ad$exports.Z_HUFFMAN_ONLY && strategy != $21fad10a767337ad$exports.Z_RLE && strategy != $21fad10a767337ad$exports.Z_FIXED && strategy != $21fad10a767337ad$exports.Z_DEFAULT_STRATEGY) throw new TypeError('Invalid strategy: ' + strategy);
    if (this._level !== level || this._strategy !== strategy) {
        var self = this;
        this.flush($84b780ee88fc5cbe$exports.Z_SYNC_FLUSH, function() {
            $21fad10a767337ad$require$assert(self._handle, 'zlib binding closed');
            self._handle.params(level, strategy);
            if (!self._hadError) {
                self._level = level;
                self._strategy = strategy;
                if (callback) callback();
            }
        });
    } else $fHA2F.nextTick(callback);
};
$21fad10a767337ad$var$Zlib.prototype.reset = function() {
    $21fad10a767337ad$require$assert(this._handle, 'zlib binding closed');
    return this._handle.reset();
};
// This is the _flush function called by the transform class,
// internally, when the last chunk has been written.
$21fad10a767337ad$var$Zlib.prototype._flush = function(callback) {
    this._transform($21fad10a767337ad$require$Buffer.alloc(0), '', callback);
};
$21fad10a767337ad$var$Zlib.prototype.flush = function(kind, callback) {
    var _this2 = this;
    var ws = this._writableState;
    if (typeof kind === 'function' || kind === undefined && !callback) {
        callback = kind;
        kind = $84b780ee88fc5cbe$exports.Z_FULL_FLUSH;
    }
    if (ws.ended) {
        if (callback) $fHA2F.nextTick(callback);
    } else if (ws.ending) {
        if (callback) this.once('end', callback);
    } else if (ws.needDrain) {
        if (callback) this.once('drain', function() {
            return _this2.flush(kind, callback);
        });
    } else {
        this._flushFlag = kind;
        this.write($21fad10a767337ad$require$Buffer.alloc(0), '', callback);
    }
};
$21fad10a767337ad$var$Zlib.prototype.close = function(callback) {
    $21fad10a767337ad$var$_close(this, callback);
    $fHA2F.nextTick($21fad10a767337ad$var$emitCloseNT, this);
};
function $21fad10a767337ad$var$_close(engine, callback) {
    if (callback) $fHA2F.nextTick(callback);
    // Caller may invoke .close after a zlib error (which will null _handle).
    if (!engine._handle) return;
    engine._handle.close();
    engine._handle = null;
}
function $21fad10a767337ad$var$emitCloseNT(self) {
    self.emit('close');
}
$21fad10a767337ad$var$Zlib.prototype._transform = function(chunk, encoding, cb) {
    var flushFlag;
    var ws = this._writableState;
    var ending = ws.ending || ws.ended;
    var last = ending && (!chunk || ws.length === chunk.length);
    if (chunk !== null && !$21fad10a767337ad$require$Buffer.isBuffer(chunk)) return cb(new Error('invalid input'));
    if (!this._handle) return cb(new Error('zlib binding closed'));
    // If it's the last chunk, or a final flush, we use the Z_FINISH flush flag
    // (or whatever flag was provided using opts.finishFlush).
    // If it's explicitly flushing at some other time, then we use
    // Z_FULL_FLUSH. Otherwise, use Z_NO_FLUSH for maximum compression
    // goodness.
    if (last) flushFlag = this._finishFlushFlag;
    else {
        flushFlag = this._flushFlag;
        // once we've flushed the last of the queue, stop flushing and
        // go back to the normal behavior.
        if (chunk.length >= ws.length) this._flushFlag = this._opts.flush || $84b780ee88fc5cbe$exports.Z_NO_FLUSH;
    }
    this._processChunk(chunk, flushFlag, cb);
};
$21fad10a767337ad$var$Zlib.prototype._processChunk = function(chunk, flushFlag, cb) {
    var availInBefore = chunk && chunk.length;
    var availOutBefore = this._chunkSize - this._offset;
    var inOff = 0;
    var self = this;
    var async = typeof cb === 'function';
    if (!async) {
        var buffers = [];
        var nread = 0;
        var error;
        this.on('error', function(er) {
            error = er;
        });
        $21fad10a767337ad$require$assert(this._handle, 'zlib binding closed');
        do var res = this._handle.writeSync(flushFlag, chunk, inOff, availInBefore, this._buffer, this._offset, availOutBefore); // out_len
        while (!this._hadError && callback(res[0], res[1]));
        if (this._hadError) throw error;
        if (nread >= $21fad10a767337ad$require$kMaxLength) {
            $21fad10a767337ad$var$_close(this);
            throw new RangeError($21fad10a767337ad$var$kRangeErrorMessage);
        }
        var buf = $21fad10a767337ad$require$Buffer.concat(buffers, nread);
        $21fad10a767337ad$var$_close(this);
        return buf;
    }
    $21fad10a767337ad$require$assert(this._handle, 'zlib binding closed');
    var req = this._handle.write(flushFlag, chunk, inOff, availInBefore, this._buffer, this._offset, availOutBefore); // out_len
    req.buffer = chunk;
    req.callback = callback;
    function callback(availInAfter, availOutAfter) {
        // When the callback is used in an async write, the callback's
        // context is the `req` object that was created. The req object
        // is === this._handle, and that's why it's important to null
        // out the values after they are done being used. `this._handle`
        // can stay in memory longer than the callback and buffer are needed.
        if (this) {
            this.buffer = null;
            this.callback = null;
        }
        if (self._hadError) return;
        var have = availOutBefore - availOutAfter;
        $21fad10a767337ad$require$assert(have >= 0, 'have should not go down');
        if (have > 0) {
            var out = self._buffer.slice(self._offset, self._offset + have);
            self._offset += have;
            // serve some output to the consumer.
            if (async) self.push(out);
            else {
                buffers.push(out);
                nread += out.length;
            }
        }
        // exhausted the output buffer, or used all the input create a new one.
        if (availOutAfter === 0 || self._offset >= self._chunkSize) {
            availOutBefore = self._chunkSize;
            self._offset = 0;
            self._buffer = $21fad10a767337ad$require$Buffer.allocUnsafe(self._chunkSize);
        }
        if (availOutAfter === 0) {
            // Not actually done.  Need to reprocess.
            // Also, update the availInBefore to the availInAfter value,
            // so that if we have to hit it a third (fourth, etc.) time,
            // it'll have the correct byte counts.
            inOff += availInBefore - availInAfter;
            availInBefore = availInAfter;
            if (!async) return true;
            var newReq = self._handle.write(flushFlag, chunk, inOff, availInBefore, self._buffer, self._offset, self._chunkSize);
            newReq.callback = callback; // this same function
            newReq.buffer = chunk;
            return;
        }
        if (!async) return false;
        // finished with the chunk.
        cb();
    }
};
$62zul.inherits($21fad10a767337ad$var$Deflate, $21fad10a767337ad$var$Zlib);
$62zul.inherits($21fad10a767337ad$var$Inflate, $21fad10a767337ad$var$Zlib);
$62zul.inherits($21fad10a767337ad$var$Gzip, $21fad10a767337ad$var$Zlib);
$62zul.inherits($21fad10a767337ad$var$Gunzip, $21fad10a767337ad$var$Zlib);
$62zul.inherits($21fad10a767337ad$var$DeflateRaw, $21fad10a767337ad$var$Zlib);
$62zul.inherits($21fad10a767337ad$var$InflateRaw, $21fad10a767337ad$var$Zlib);
$62zul.inherits($21fad10a767337ad$var$Unzip, $21fad10a767337ad$var$Zlib);



var $lGjml = parcelRequire("lGjml");
var $6a48311326306a05$require$Buffer = $lGjml.Buffer;
const $6a48311326306a05$var$urlSafe = (data)=>data.replaceAll('/', '_');
const $6a48311326306a05$var$urlUnsafe = (data)=>data.replaceAll('_', '/');
const $6a48311326306a05$export$cfdd1f2478131e3d = async (data)=>{
    // msgpack javascript object
    // zip
    // base64
    // make url safe
    const getGZip = new Promise((resolve)=>{
        (0, $21fad10a767337ad$exports.gzip)($6a48311326306a05$require$Buffer.from((0, $69bf5a6db05fb59d$export$c564cdbbe6da493)(data)), (_, buffer)=>{
            resolve(buffer);
        });
    });
    const results = await getGZip;
    return $6a48311326306a05$var$urlSafe($6a48311326306a05$require$Buffer.from(results).toString('base64'));
};
const $6a48311326306a05$export$13923bea59211b58 = async (data)=>{
    // undo url safe replacements
    // base64
    // unzip
    // inflate
    const getGUnzip = new Promise((resolve)=>{
        (0, $21fad10a767337ad$exports.gunzip)($6a48311326306a05$require$Buffer.from($6a48311326306a05$var$urlUnsafe(data), 'base64'), (_, buffer)=>{
            resolve(buffer);
        });
    });
    const results = await getGUnzip;
    return (0, $c0213129d1a1dc2a$export$2f872c0f2117be69)(results);
};


var $7f648b6e3795e45a$exports = {};
'use strict';
var $0fa147e238ef80b0$exports = {};
'use strict';
var $0fa147e238ef80b0$var$createStoreImpl = function createStoreImpl(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === 'function' ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            var _previousState = state;
            state = (replace != null ? replace : typeof nextState !== 'object' || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var getInitialState = function getInitialState() {
        return initialState;
    };
    var subscribe = function subscribe(listener) {
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    var initialState = state = createState(setState, getState, api);
    return api;
};
var $0fa147e238ef80b0$var$createStore = function createStore(createState) {
    return createState ? $0fa147e238ef80b0$var$createStoreImpl(createState) : $0fa147e238ef80b0$var$createStoreImpl;
};
var $0fa147e238ef80b0$var$vanilla = function(createState) {
    return $0fa147e238ef80b0$var$createStore(createState);
};
$0fa147e238ef80b0$exports.createStore = $0fa147e238ef80b0$var$createStore;
$0fa147e238ef80b0$exports.default = $0fa147e238ef80b0$var$vanilla;
$0fa147e238ef80b0$exports = $0fa147e238ef80b0$var$vanilla;
$0fa147e238ef80b0$exports.createStore = $0fa147e238ef80b0$var$createStore;
$0fa147e238ef80b0$exports.default = $0fa147e238ef80b0$exports;



var $h2ArV = parcelRequire("h2ArV");
var $521c8f26fcd2795f$exports = {};
'use strict';

$521c8f26fcd2795f$exports = (parcelRequire("3fly5"));


var $7f648b6e3795e45a$var$useDebugValue = $h2ArV.useDebugValue;
var $7f648b6e3795e45a$var$useSyncExternalStoreWithSelector = $521c8f26fcd2795f$exports.useSyncExternalStoreWithSelector;
var $7f648b6e3795e45a$var$didWarnAboutEqualityFn = false;
var $7f648b6e3795e45a$var$identity = function identity(arg) {
    return arg;
};
function $7f648b6e3795e45a$var$useStore(api, selector, equalityFn) {
    if (selector === void 0) selector = $7f648b6e3795e45a$var$identity;
    var slice = $7f648b6e3795e45a$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $7f648b6e3795e45a$var$useDebugValue(slice);
    return slice;
}
var $7f648b6e3795e45a$var$createImpl = function createImpl(createState) {
    var api = typeof createState === 'function' ? $0fa147e238ef80b0$exports.createStore(createState) : createState;
    var useBoundStore = function useBoundStore(selector, equalityFn) {
        return $7f648b6e3795e45a$var$useStore(api, selector, equalityFn);
    };
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
var $7f648b6e3795e45a$var$create = function create(createState) {
    return createState ? $7f648b6e3795e45a$var$createImpl(createState) : $7f648b6e3795e45a$var$createImpl;
};
var $7f648b6e3795e45a$var$react = function(createState) {
    return $7f648b6e3795e45a$var$create(createState);
};
$7f648b6e3795e45a$exports.create = $7f648b6e3795e45a$var$create;
$7f648b6e3795e45a$exports.default = $7f648b6e3795e45a$var$react;
$7f648b6e3795e45a$exports.useStore = $7f648b6e3795e45a$var$useStore;
Object.keys($0fa147e238ef80b0$exports).forEach(function(k) {
    if (k !== 'default' && !Object.prototype.hasOwnProperty.call($7f648b6e3795e45a$exports, k)) Object.defineProperty($7f648b6e3795e45a$exports, k, {
        enumerable: true,
        get: function() {
            return $0fa147e238ef80b0$exports[k];
        }
    });
});
$7f648b6e3795e45a$exports = $7f648b6e3795e45a$var$react;
$7f648b6e3795e45a$exports.create = $7f648b6e3795e45a$var$create;
$7f648b6e3795e45a$exports.useStore = $7f648b6e3795e45a$var$useStore;
$7f648b6e3795e45a$exports.createStore = $0fa147e238ef80b0$exports.createStore;
$7f648b6e3795e45a$exports.default = $7f648b6e3795e45a$exports;


var $4ec74dd61b3f0976$export$1be1fc439b849fdf;
var $4ec74dd61b3f0976$export$95a3b7b12ab518f9;
var $4ec74dd61b3f0976$export$6922d3b3a607469e;
var $4ec74dd61b3f0976$export$9a6132153fba2e0;
var $4ec74dd61b3f0976$export$4feba8a1bc8e9afd;
var $4ec74dd61b3f0976$export$5c593627aef9f076;
'use strict';
function $4ec74dd61b3f0976$var$_extends() {
    return $4ec74dd61b3f0976$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4ec74dd61b3f0976$var$_extends.apply(null, arguments);
}
function $4ec74dd61b3f0976$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $4ec74dd61b3f0976$var$reduxImpl = function reduxImpl(reducer, initial) {
    return function(set, _get, api) {
        api.dispatch = function(action) {
            set(function(state) {
                return reducer(state, action);
            }, false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return $4ec74dd61b3f0976$var$_extends({
            dispatch: function dispatch() {
                var _ref;
                return (_ref = api).dispatch.apply(_ref, arguments);
            }
        }, initial);
    };
};
var $4ec74dd61b3f0976$var$redux = $4ec74dd61b3f0976$var$reduxImpl;
var $4ec74dd61b3f0976$var$_excluded = [
    "enabled",
    "anonymousActionType",
    "store"
], $4ec74dd61b3f0976$var$_excluded2 = [
    "connection"
];
var $4ec74dd61b3f0976$var$trackedConnections = new Map();
var $4ec74dd61b3f0976$var$getTrackedConnectionState = function getTrackedConnectionState(name) {
    var api = $4ec74dd61b3f0976$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(function(_ref) {
        var key = _ref[0], api = _ref[1];
        return [
            key,
            api.getState()
        ];
    }));
};
var $4ec74dd61b3f0976$var$extractConnectionInformation = function extractConnectionInformation(store, extensionConnector, options) {
    if (store === undefined) return {
        type: 'untracked',
        connection: extensionConnector.connect(options)
    };
    var existingConnection = $4ec74dd61b3f0976$var$trackedConnections.get(options.name);
    if (existingConnection) return $4ec74dd61b3f0976$var$_extends({
        type: 'tracked',
        store: store
    }, existingConnection);
    var newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $4ec74dd61b3f0976$var$trackedConnections.set(options.name, newConnection);
    return $4ec74dd61b3f0976$var$_extends({
        type: 'tracked',
        store: store
    }, newConnection);
};
var $4ec74dd61b3f0976$var$devtoolsImpl = function devtoolsImpl(fn, devtoolsOptions) {
    if (devtoolsOptions === void 0) devtoolsOptions = {};
    return function(set, get, api) {
        var _devtoolsOptions = devtoolsOptions, enabled = _devtoolsOptions.enabled, anonymousActionType = _devtoolsOptions.anonymousActionType, store = _devtoolsOptions.store, options = $4ec74dd61b3f0976$var$_objectWithoutPropertiesLoose(_devtoolsOptions, $4ec74dd61b3f0976$var$_excluded);
        var extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : false) && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (_e) {}
        if (!extensionConnector) return fn(set, get, api);
        var _extractConnectionInf = $4ec74dd61b3f0976$var$extractConnectionInformation(store, extensionConnector, options), connection = _extractConnectionInf.connection, connectionInformation = $4ec74dd61b3f0976$var$_objectWithoutPropertiesLoose(_extractConnectionInf, $4ec74dd61b3f0976$var$_excluded2);
        var isRecording = true;
        api.setState = function(state, replace, nameOrAction) {
            var _extends2;
            var r = set(state, replace);
            if (!isRecording) return r;
            var action = nameOrAction === undefined ? {
                type: anonymousActionType || 'anonymous'
            } : typeof nameOrAction === 'string' ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === undefined) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send($4ec74dd61b3f0976$var$_extends({}, action, {
                type: store + "/" + action.type
            }), $4ec74dd61b3f0976$var$_extends({}, $4ec74dd61b3f0976$var$getTrackedConnectionState(options.name), (_extends2 = {}, _extends2[store] = api.getState(), _extends2)));
            return r;
        };
        var setStateFromDevtools = function setStateFromDevtools() {
            var originalIsRecording = isRecording;
            isRecording = false;
            set.apply(void 0, arguments);
            isRecording = originalIsRecording;
        };
        var initialState = fn(api.setState, get, api);
        if (connectionInformation.type === 'untracked') connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(function(_ref2) {
                var key = _ref2[0], store = _ref2[1];
                return [
                    key,
                    key === connectionInformation.store ? initialState : store.getState()
                ];
            })));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === 'function') {
            var didWarnAboutReservedActionType = false;
            var originalDispatch = api.dispatch;
            api.dispatch = function() {
                for(var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++)a[_key] = arguments[_key];
                originalDispatch.apply(void 0, a);
            };
        }
        connection.subscribe(function(message) {
            switch(message.type){
                case 'ACTION':
                    if (typeof message.payload !== 'string') {
                        console.error('[zustand devtools middleware] Unsupported action format');
                        return;
                    }
                    return $4ec74dd61b3f0976$var$parseJsonThen(message.payload, function(action) {
                        if (action.type === '__setState') {
                            if (store === undefined) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error("\n                    [zustand devtools middleware] Unsupported __setState action format. \n                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),\n                    and value of this only key should be a state object. Example: { \"type\": \"__setState\", \"state\": { \"abc123Store\": { \"foo\": \"bar\" } } }\n                    ");
                            var stateFromDevtools = action.state[store];
                            if (stateFromDevtools === undefined || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== 'function') return;
                        api.dispatch(action);
                    });
                case 'DISPATCH':
                    switch(message.payload.type){
                        case 'RESET':
                            setStateFromDevtools(initialState);
                            if (store === undefined) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($4ec74dd61b3f0976$var$getTrackedConnectionState(options.name));
                        case 'COMMIT':
                            if (store === undefined) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($4ec74dd61b3f0976$var$getTrackedConnectionState(options.name));
                        case 'ROLLBACK':
                            return $4ec74dd61b3f0976$var$parseJsonThen(message.state, function(state) {
                                if (store === undefined) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($4ec74dd61b3f0976$var$getTrackedConnectionState(options.name));
                            });
                        case 'JUMP_TO_STATE':
                        case 'JUMP_TO_ACTION':
                            return $4ec74dd61b3f0976$var$parseJsonThen(message.state, function(state) {
                                if (store === undefined) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case 'IMPORT_STATE':
                            var _nextLiftedState$comp;
                            var nextLiftedState = message.payload.nextLiftedState;
                            var lastComputedState = (_nextLiftedState$comp = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _nextLiftedState$comp.state;
                            if (!lastComputedState) return;
                            if (store === undefined) setStateFromDevtools(lastComputedState);
                            else setStateFromDevtools(lastComputedState[store]);
                            connection == null || connection.send(null, nextLiftedState);
                            return;
                        case 'PAUSE_RECORDING':
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
};
var $4ec74dd61b3f0976$var$devtools = $4ec74dd61b3f0976$var$devtoolsImpl;
var $4ec74dd61b3f0976$var$parseJsonThen = function parseJsonThen(stringified, f) {
    var parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error('[zustand devtools middleware] Could not parse the received json', e);
    }
    if (parsed !== undefined) f(parsed);
};
var $4ec74dd61b3f0976$var$subscribeWithSelectorImpl = function subscribeWithSelectorImpl(fn) {
    return function(set, get, api) {
        var origSubscribe = api.subscribe;
        api.subscribe = function(selector, optListener, options) {
            var listener = selector;
            if (optListener) {
                var equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                var currentSlice = selector(api.getState());
                listener = function listener(state) {
                    var nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        var previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options != null && options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        var initialState = fn(set, get, api);
        return initialState;
    };
};
var $4ec74dd61b3f0976$var$subscribeWithSelector = $4ec74dd61b3f0976$var$subscribeWithSelectorImpl;
var $4ec74dd61b3f0976$var$combine = function combine(initialState, create) {
    return function() {
        return Object.assign({}, initialState, create.apply(void 0, arguments));
    };
};
function $4ec74dd61b3f0976$var$createJSONStorage(getStorage, options) {
    var storage;
    try {
        storage = getStorage();
    } catch (_e) {
        return;
    }
    var persistStorage = {
        getItem: function getItem(name) {
            var _getItem;
            var parse = function parse(str) {
                if (str === null) return null;
                return JSON.parse(str, options == null ? void 0 : options.reviver);
            };
            var str = (_getItem = storage.getItem(name)) != null ? _getItem : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: function setItem(name, newValue) {
            return storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer));
        },
        removeItem: function removeItem(name) {
            return storage.removeItem(name);
        }
    };
    return persistStorage;
}
var $4ec74dd61b3f0976$var$_toThenable = function toThenable(fn) {
    return function(input) {
        try {
            var result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then: function then(onFulfilled) {
                    return $4ec74dd61b3f0976$var$_toThenable(onFulfilled)(result);
                },
                catch: function _catch(_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then: function then(_onFulfilled) {
                    return this;
                },
                catch: function _catch(onRejected) {
                    return $4ec74dd61b3f0976$var$_toThenable(onRejected)(e);
                }
            };
        }
    };
};
var $4ec74dd61b3f0976$var$oldImpl = function oldImpl(config, baseOptions) {
    return function(set, get, api) {
        var options = $4ec74dd61b3f0976$var$_extends({
            getStorage: function getStorage() {
                return localStorage;
            },
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: function partialize(state) {
                return state;
            },
            version: 0,
            merge: function merge(persistedState, currentState) {
                return $4ec74dd61b3f0976$var$_extends({}, currentState, persistedState);
            }
        }, baseOptions);
        var _hasHydrated = false;
        var hydrationListeners = new Set();
        var finishHydrationListeners = new Set();
        var storage;
        try {
            storage = options.getStorage();
        } catch (_e) {}
        if (!storage) return config(function() {
            console.warn("[zustand persist middleware] Unable to update item '" + options.name + "', the given storage is currently unavailable.");
            set.apply(void 0, arguments);
        }, get, api);
        var thenableSerialize = $4ec74dd61b3f0976$var$_toThenable(options.serialize);
        var setItem = function setItem() {
            var state = options.partialize($4ec74dd61b3f0976$var$_extends({}, get()));
            var errorInSync;
            var thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then(function(serializedValue) {
                return storage.setItem(options.name, serializedValue);
            }).catch(function(e) {
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        var savedSetState = api.setState;
        api.setState = function(state, replace) {
            savedSetState(state, replace);
            setItem();
        };
        var configResult = config(function() {
            set.apply(void 0, arguments);
            setItem();
        }, get, api);
        var stateFromStorage;
        var hydrate = function hydrate() {
            if (!storage) return;
            _hasHydrated = false;
            hydrationListeners.forEach(function(cb) {
                return cb(get());
            });
            var postRehydrationCallback = (options.onRehydrateStorage == null ? void 0 : options.onRehydrateStorage(get())) || undefined;
            return $4ec74dd61b3f0976$var$_toThenable(storage.getItem.bind(storage))(options.name).then(function(storageValue) {
                if (storageValue) return options.deserialize(storageValue);
            }).then(function(deserializedStorageValue) {
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === 'number' && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error("State loaded from storage couldn't be migrated since no migrate function was provided");
                    } else return deserializedStorageValue.state;
                }
            }).then(function(migratedState) {
                var _get;
                stateFromStorage = options.merge(migratedState, (_get = get()) != null ? _get : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(function() {
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, undefined);
                _hasHydrated = true;
                finishHydrationListeners.forEach(function(cb) {
                    return cb(stateFromStorage);
                });
            }).catch(function(e) {
                postRehydrationCallback == null || postRehydrationCallback(undefined, e);
            });
        };
        api.persist = {
            setOptions: function setOptions(newOptions) {
                options = $4ec74dd61b3f0976$var$_extends({}, options, newOptions);
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: function clearStorage() {
                var _storage;
                (_storage = storage) == null || _storage.removeItem(options.name);
            },
            getOptions: function getOptions() {
                return options;
            },
            rehydrate: function rehydrate() {
                return hydrate();
            },
            hasHydrated: function hasHydrated() {
                return _hasHydrated;
            },
            onHydrate: function onHydrate(cb) {
                hydrationListeners.add(cb);
                return function() {
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: function onFinishHydration(cb) {
                finishHydrationListeners.add(cb);
                return function() {
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
};
var $4ec74dd61b3f0976$var$newImpl = function newImpl(config, baseOptions) {
    return function(set, get, api) {
        var options = $4ec74dd61b3f0976$var$_extends({
            storage: $4ec74dd61b3f0976$var$createJSONStorage(function() {
                return localStorage;
            }),
            partialize: function partialize(state) {
                return state;
            },
            version: 0,
            merge: function merge(persistedState, currentState) {
                return $4ec74dd61b3f0976$var$_extends({}, currentState, persistedState);
            }
        }, baseOptions);
        var _hasHydrated2 = false;
        var hydrationListeners = new Set();
        var finishHydrationListeners = new Set();
        var storage = options.storage;
        if (!storage) return config(function() {
            console.warn("[zustand persist middleware] Unable to update item '" + options.name + "', the given storage is currently unavailable.");
            set.apply(void 0, arguments);
        }, get, api);
        var setItem = function setItem() {
            var state = options.partialize($4ec74dd61b3f0976$var$_extends({}, get()));
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        var savedSetState = api.setState;
        api.setState = function(state, replace) {
            savedSetState(state, replace);
            setItem();
        };
        var configResult = config(function() {
            set.apply(void 0, arguments);
            setItem();
        }, get, api);
        api.getInitialState = function() {
            return configResult;
        };
        var stateFromStorage;
        var hydrate = function hydrate() {
            var _get3;
            if (!storage) return;
            _hasHydrated2 = false;
            hydrationListeners.forEach(function(cb) {
                var _get2;
                return cb((_get2 = get()) != null ? _get2 : configResult);
            });
            var postRehydrationCallback = (options.onRehydrateStorage == null ? void 0 : options.onRehydrateStorage((_get3 = get()) != null ? _get3 : configResult)) || undefined;
            return $4ec74dd61b3f0976$var$_toThenable(storage.getItem.bind(storage))(options.name).then(function(deserializedStorageValue) {
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === 'number' && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return [
                            true,
                            options.migrate(deserializedStorageValue.state, deserializedStorageValue.version)
                        ];
                        console.error("State loaded from storage couldn't be migrated since no migrate function was provided");
                    } else return [
                        false,
                        deserializedStorageValue.state
                    ];
                }
                return [
                    false,
                    undefined
                ];
            }).then(function(migrationResult) {
                var _get4;
                var migrated = migrationResult[0], migratedState = migrationResult[1];
                stateFromStorage = options.merge(migratedState, (_get4 = get()) != null ? _get4 : configResult);
                set(stateFromStorage, true);
                if (migrated) return setItem();
            }).then(function() {
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, undefined);
                stateFromStorage = get();
                _hasHydrated2 = true;
                finishHydrationListeners.forEach(function(cb) {
                    return cb(stateFromStorage);
                });
            }).catch(function(e) {
                postRehydrationCallback == null || postRehydrationCallback(undefined, e);
            });
        };
        api.persist = {
            setOptions: function setOptions(newOptions) {
                options = $4ec74dd61b3f0976$var$_extends({}, options, newOptions);
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: function clearStorage() {
                var _storage2;
                (_storage2 = storage) == null || _storage2.removeItem(options.name);
            },
            getOptions: function getOptions() {
                return options;
            },
            rehydrate: function rehydrate() {
                return hydrate();
            },
            hasHydrated: function hasHydrated() {
                return _hasHydrated2;
            },
            onHydrate: function onHydrate(cb) {
                hydrationListeners.add(cb);
                return function() {
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: function onFinishHydration(cb) {
                finishHydrationListeners.add(cb);
                return function() {
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
};
var $4ec74dd61b3f0976$var$persistImpl = function persistImpl(config, baseOptions) {
    if ('getStorage' in baseOptions || 'serialize' in baseOptions || 'deserialize' in baseOptions) return $4ec74dd61b3f0976$var$oldImpl(config, baseOptions);
    return $4ec74dd61b3f0976$var$newImpl(config, baseOptions);
};
var $4ec74dd61b3f0976$var$persist = $4ec74dd61b3f0976$var$persistImpl;
$4ec74dd61b3f0976$export$1be1fc439b849fdf = $4ec74dd61b3f0976$var$combine;
$4ec74dd61b3f0976$export$95a3b7b12ab518f9 = $4ec74dd61b3f0976$var$createJSONStorage;
$4ec74dd61b3f0976$export$6922d3b3a607469e = $4ec74dd61b3f0976$var$devtools;
$4ec74dd61b3f0976$export$9a6132153fba2e0 = $4ec74dd61b3f0976$var$persist;
$4ec74dd61b3f0976$export$4feba8a1bc8e9afd = $4ec74dd61b3f0976$var$redux;
$4ec74dd61b3f0976$export$5c593627aef9f076 = $4ec74dd61b3f0976$var$subscribeWithSelector;



var $hkL0p = parcelRequire("hkL0p");

var $2ObCI = parcelRequire("2ObCI");
// SFW adjectives
const $05c0391770bda4cd$export$f8d29c35207085df = [
    'Adorable',
    'Adventurous',
    'Aggressive',
    'Agreeable',
    'Alert',
    'Alive',
    'Amused',
    'Angry',
    'Annoyed',
    'Annoying',
    'Anxious',
    'Arrogant',
    'Ashamed',
    'Attractive',
    'Average',
    'Beautiful',
    'Better',
    'Bewildered',
    'Blue',
    'Blushing',
    'Bored',
    'Brainy',
    'Brave',
    'Breakable',
    'Bright',
    'Busy',
    'Calm',
    'Careful',
    'Cautious',
    'Charming',
    'Cheerful',
    'Clean',
    'Clear',
    'Clever',
    'Cloudy',
    'Clumsy',
    'Colorful',
    'Comfortable',
    'Concerned',
    'Confused',
    'Cooperative',
    'Courageous',
    'Crazy',
    'Creepy',
    'Crowded',
    'Curious',
    'Cute',
    'Dangerous',
    'Dark',
    'Defiant',
    'Delightful',
    'Depressed',
    'Determined',
    'Different',
    'Difficult',
    'Disgusted',
    'Distinct',
    'Disturbed',
    'Dizzy',
    'Doubtful',
    'Drab',
    'Dull',
    'Eager',
    'Easy',
    'Elated',
    'Elegant',
    'Embarrassed',
    'Enchanting',
    'Encouraging',
    'Energetic',
    'Enthusiastic',
    'Envious',
    'Evil',
    'Excited',
    'Expensive',
    'Exuberant',
    'Fair',
    'Faithful',
    'Famous',
    'Fancy',
    'Fantastic',
    'Fierce',
    'Fine',
    'Foolish',
    'Fragile',
    'Frail',
    'Frantic',
    'Friendly',
    'Frightened',
    'Funny',
    'Gentle',
    'Gifted',
    'Glamorous',
    'Gleaming',
    'Glorious',
    'Good',
    'Gorgeous',
    'Graceful',
    'Grumpy',
    'Handsome',
    'Happy',
    'Healthy',
    'Helpful',
    'Hilarious',
    'Homely',
    'Hungry',
    'Important',
    'Impossible',
    'Inexpensive',
    'Innocent',
    'Inquisitive',
    'Itchy',
    'Jealous',
    'Jittery',
    'Jolly',
    'Joyous',
    'Kind',
    'Lazy',
    'Light',
    'Lively',
    'Lonely',
    'Long',
    'Lovely',
    'Lucky',
    'Magnificent',
    'Misty',
    'Modern',
    'Motionless',
    'Muddy',
    'Mushy',
    'Mysterious',
    'Naughty',
    'Nervous',
    'Nice',
    'Nutty',
    'Obedient',
    'Obnoxious',
    'Odd',
    'Old-fashioned',
    'Open',
    'Outrageous',
    'Outstanding',
    'Panicky',
    'Perfect',
    'Plain',
    'Pleasant',
    'Poised',
    'Powerful',
    'Precious',
    'Prickly',
    'Proud',
    'Puzzled',
    'Quaint',
    'Real',
    'Relieved',
    'Scary',
    'Selfish',
    'Shiny',
    'Shy',
    'Silly',
    'Sleepy',
    'Smiling',
    'Smoggy',
    'Sparkling',
    'Splendid',
    'Spotless',
    'Stormy',
    'Strange',
    'Successful',
    'Super',
    'Talented',
    'Tame',
    'Tasty',
    'Tender',
    'Tense',
    'Terrible',
    'Thankful',
    'Thoughtful',
    'Thoughtless',
    'Tired',
    'Tough',
    'Uninterested',
    'Unsightly',
    'Unusual',
    'Upset',
    'Uptight',
    'Vast',
    'Victorious',
    'Vivacious',
    'Wandering',
    'Weary',
    'Wicked',
    'Wide-eyed',
    'Wild',
    'Witty',
    'Worried',
    'Worrisome',
    'Zany',
    'Zealous',
    'Uncooked' // ;)
];
const $05c0391770bda4cd$export$22ec21820dc52d0a = [
    // Planets
    'Mercury',
    'Venus',
    'Earth',
    'Mars',
    'Jupiter',
    'Saturn',
    'Uranus',
    'Neptune',
    'Pluto',
    'Moon',
    'Sun',
    // Garden-themed nouns
    'Ant',
    'Bark',
    'Bee',
    'Bird',
    'Boot',
    'Branch',
    'Broom',
    'Bucket',
    'Bunny',
    'Bush',
    'Butterfly',
    'Cabbage',
    'Cactus',
    'Carrot',
    'Caterpillar',
    'Celery',
    'Chilli',
    'Cloud',
    'Clover',
    'Compost',
    'Concrete',
    'Cucumber',
    'Daffodil',
    'Daisy',
    'Dirt',
    'Fence',
    'Fertiliser',
    'Flower',
    'Flower Pot',
    'Fountain',
    'Frog',
    'Garden Bed',
    'Glove',
    'Gnome',
    'Grass',
    'Gravel',
    'Greenhouse',
    'Gumboot',
    'Hat',
    'Hedge',
    'Hose',
    'Ladybug',
    'Lawn Mower',
    'Leaf',
    'Leaf Blower',
    'Lilac',
    'Moss',
    'Mud',
    'Mulch',
    'Mushroom',
    'Onion',
    'Orchid',
    'Path',
    'Photosynthesis',
    'Pollen',
    'Pond',
    'Potato',
    'Rabbit',
    'Rain',
    'Raincoat',
    'Rake',
    'Rose',
    'Sapling',
    'Seed',
    'Shears',
    'Shed',
    'Shovel',
    'Snail',
    'Soil',
    'Spade',
    'Spider',
    'Sprinkler',
    'Sunshine',
    'Tomato',
    'Tool',
    'Tree',
    'Tulip',
    'Twig',
    'Water',
    'Watering Can',
    'Wheelbarrow',
    'Worm',
    // Spirit animals
    'Crab',
    'Dolphin',
    'Giraffe',
    'Marine Iguana',
    'Octopus',
    'Squid',
    'White Lion',
    'Cat'
];
const $05c0391770bda4cd$export$cc5acd52dd9611ac = ()=>{
    if (Math.random() < 0.001) return 'James Harland';
    const adj = $05c0391770bda4cd$export$f8d29c35207085df[Math.floor(Math.random() * $05c0391770bda4cd$export$f8d29c35207085df.length)];
    const noun = $05c0391770bda4cd$export$22ec21820dc52d0a[Math.floor(Math.random() * $05c0391770bda4cd$export$22ec21820dc52d0a.length)];
    return `${adj} ${noun}`;
};





var $920b9ecb34a1fb18$export$7eda682a4373126 = /*#__PURE__*/ function(InsertGroupResponseType) {
    InsertGroupResponseType[InsertGroupResponseType["FAIL"] = 1] = "FAIL";
    InsertGroupResponseType[InsertGroupResponseType["SUCCESS"] = 2] = "SUCCESS";
    return InsertGroupResponseType;
}({});
const $920b9ecb34a1fb18$export$2d5adde7dc289012 = (projectType = (0, $09ff7c1d5f0c0758$export$3609f80921b12b4b))=>({
        projectType: projectType,
        _id: crypto.randomUUID(),
        states: [],
        transitions: [],
        comments: [],
        simResult: [],
        tests: {
            single: '',
            batch: [
                ''
            ]
        },
        initialState: null,
        meta: {
            name: (0, $05c0391770bda4cd$export$cc5acd52dd9611ac)(),
            dateCreated: new Date().getTime(),
            dateEdited: new Date().getTime(),
            version: (0, $09ff7c1d5f0c0758$export$3167453beff01750),
            automatariumVersion: (0, $09ff7c1d5f0c0758$export$8ee1df3c6367a60)
        },
        config: {
            type: projectType,
            statePrefix: (0, $09ff7c1d5f0c0758$export$84ea809ec961cd1),
            orOperator: (0, $09ff7c1d5f0c0758$export$6a13b8d132417b20),
            acceptanceCriteria: (0, $09ff7c1d5f0c0758$export$951617dc07b67a12),
            color: (0, $09ff7c1d5f0c0758$export$63642992e287c571)[projectType]
        }
    });
/**
 * Returns the next ID for a list of items. This doesn't get the next available ID
 * but instead returns the number of the highest
 * e.g. [1, 4, 7] next ID would be 8
 */ const $920b9ecb34a1fb18$var$nextIDFor = (elementArr)=>{
    // We can't do elementArr.length + 1 since that might reuse an ID from a deleted item.
    // Order also is guaranteed so we can't just get the last element.
    return 1 + Math.max(-1, ...elementArr.map((e)=>e.id));
};
/**
 * Updates an item with the same ID from a list of items.
 * Expects the item to exist in items
 */ const $920b9ecb34a1fb18$var$updateById = (items, item)=>{
    const index = items.findIndex((x)=>x.id === item.id);
    items[index] = {
        ...items[index],
        ...item
    };
};
const $920b9ecb34a1fb18$var$useProjectStore = (0, $7f648b6e3795e45a$exports.create)()((0, $4ec74dd61b3f0976$export$9a6132153fba2e0)((set, get)=>({
        project: null,
        history: [],
        historyPointer: null,
        lastChangeDate: null,
        lastSaveDate: null,
        set: (project)=>{
            set({
                project: project,
                history: [
                    (0, (/*@__PURE__*/$parcel$interopDefault($2ObCI)))(project)
                ],
                historyPointer: 0
            });
        },
        update: (project)=>set((0, $hkL0p.default)((state)=>{
                state.project = project;
            })),
        /* Add current project state to stored history of project states */ commit: ()=>set((0, $hkL0p.default)((state)=>{
                // Check whether anything changed before committing
                const didChange = !((0, $hkL0p.current)(state.history[state.historyPointer]) === (0, $hkL0p.current)(state.project));
                if (!didChange) return;
                // Delete the future
                state.history = state.history.slice(0, state.historyPointer + 1);
                // Add new history
                state.history.push((0, (/*@__PURE__*/$parcel$interopDefault($2ObCI)))(state.project));
                // Reset pointer
                state.historyPointer = state.history.length - 1;
                // Update edited date
                state.lastChangeDate = new Date().getTime();
            })),
        undo: ()=>set((0, $hkL0p.default)((state)=>{
                // Can we undo?
                if (state.historyPointer === 0) return;
                // Move pointer
                state.historyPointer--;
                // Update project
                state.project = state.history[state.historyPointer];
                // Update edited date
                state.lastChangeDate = new Date().getTime();
            })),
        redo: ()=>set((0, $hkL0p.default)((state)=>{
                // Can we redo?
                if (state.historyPointer === state.history.length - 1) return;
                // Move pointer
                state.historyPointer++;
                // Update project
                state.project = state.history[state.historyPointer];
                // Update edited date
                state.lastChangeDate = new Date().getTime();
            })),
        /* Change the date the project was last saved */ setLastSaveDate: (lastSaveDate)=>set({
                lastSaveDate: lastSaveDate
            }),
        /* Change the projects name */ setName: (name)=>set((s)=>({
                    project: {
                        ...s.project,
                        meta: {
                            ...s.project.meta,
                            name: name
                        }
                    },
                    lastChangeDate: new Date().getTime()
                })),
        /* Create a new transition */ createTransition: (transition)=>{
            const id = $920b9ecb34a1fb18$var$nextIDFor(get().project.transitions);
            set((0, $hkL0p.default)(({ project: project })=>{
                project.transitions.push({
                    ...transition,
                    id: id
                });
            }));
            return id;
        },
        editTransition: (newTransition)=>set((0, $hkL0p.default)(({ project: project })=>{
                // Refactor types to enums later
                const ti = project.transitions.findIndex((t)=>t.id === newTransition.id);
                // Merge the new transition info with existing transition info
                project.transitions[ti] = {
                    ...project.transitions[ti],
                    ...newTransition
                };
            })),
        // Same as edit but restricted to from/to edits. Should they be the same function?
        moveTransition: (newTransition)=>set((0, $hkL0p.default)(({ project: project })=>{
                // Refactor types to enums later
                const ti = project.transitions.findIndex((t)=>t.id === newTransition.id);
                // Merge the new transition info with existing transition info
                project.transitions[ti] = {
                    ...project.transitions[ti],
                    ...newTransition
                };
            })),
        /* Create a new comment */ createComment: (comment)=>{
            const id = $920b9ecb34a1fb18$var$nextIDFor(get().project.comments);
            set((0, $hkL0p.default)(({ project: project })=>{
                project.comments.push({
                    ...comment,
                    id: id
                });
            }));
            return id;
        },
        /* Update a comment by id */ updateComment: (comment)=>set((0, $hkL0p.default)(({ project: project })=>{
                $920b9ecb34a1fb18$var$updateById(project.comments, comment);
            })),
        updateComments: (comments)=>set((0, $hkL0p.default)(({ project: project })=>{
                for (const comment of comments)$920b9ecb34a1fb18$var$updateById(project.comments, comment);
            })),
        /* Remove a comment by id */ removeComment: (comment)=>set((0, $hkL0p.default)(({ project: project })=>{
                project.comments = project.comments.filter((cm)=>cm.id !== comment.id);
            })),
        /* Create a new state */ createState: (state)=>{
            const id = $920b9ecb34a1fb18$var$nextIDFor(get().project.states);
            set((0, $hkL0p.default)(({ project: project })=>{
                project.states.push({
                    ...state,
                    id: id,
                    isFinal: state.isFinal ?? false
                });
                if (project.states.length === 1) project.initialState = id;
            }));
            return id;
        },
        /* Update a state by id */ updateState: (state)=>set((0, $hkL0p.default)(({ project: project })=>{
                $920b9ecb34a1fb18$var$updateById(project.states, state);
            })),
        updateStates: (states)=>set((0, $hkL0p.default)(({ project: project })=>{
                for (const state of states)$920b9ecb34a1fb18$var$updateById(project.states, state);
            })),
        /* Remove a state by id */ removeState: (state)=>set((0, $hkL0p.default)(({ project: project })=>{
                project.states = project.states.filter((st)=>st.id !== state.id);
            })),
        insertGroup: (createData, isTemplate = false)=>{
            // Check that we are inserting into same project type
            if (createData.projectType !== get().project.projectType) return {
                type: 1,
                body: `You cannot insert elements from a ${createData.projectType} project into a ${get().project.projectType} project.`
            };
            // Check that for transitions being inserted, to and from states are also inserted
            const stateIDs = new Set(createData.states.map((it)=>it.id));
            for (const transition of createData.transitions){
                const hasTo = stateIDs.has(transition.to);
                const hasFrom = stateIDs.has(transition.from);
                // If either `to` or `from` is missing then return an error
                if (!(hasTo && hasFrom)) return {
                    type: 1,
                    body: 'Sorry, there was an error.'
                };
            }
            set((0, $hkL0p.default)(({ project: project })=>{
                let isInitialStateUpdated = false;
                const isNewProject = createData.projectSource !== project._id;
                const positionOffset = isTemplate ? 0 : (0, $1812551efebcf5e5$export$326d76bf7c385d63);
                const newTransitions = structuredClone(createData.transitions);
                newTransitions.forEach((transition)=>{
                    transition.from = null;
                    transition.to = null;
                });
                const nextStateId = $920b9ecb34a1fb18$var$nextIDFor(project.states);
                createData.states.forEach((state, i)=>{
                    // TODO: ensure position isn't out of window
                    // Probably will have to take adjusting position out of this function
                    [state.x, state.y] = [
                        state.x + positionOffset,
                        state.y + positionOffset
                    ];
                    const newId = nextStateId + i;
                    // Update transitions to new state id
                    createData.transitions.forEach((transition, i)=>{
                        if (transition.from === state.id && newTransitions[i].from === null) newTransitions[i].from = newId;
                        if (transition.to === state.id && newTransitions[i].to === null) newTransitions[i].to = newId;
                    });
                    // Update initial state id if applicable
                    if (createData.initialStateId === state.id && !isInitialStateUpdated) {
                        createData.initialStateId = newId;
                        isInitialStateUpdated = true;
                    }
                    state.id = newId;
                    // createState
                    project.states.push({
                        ...state
                    });
                });
                createData.transitions = newTransitions;
                const nextCommentId = $920b9ecb34a1fb18$var$nextIDFor(project.comments);
                createData.comments.forEach((comment, i)=>{
                    // TODO: ensure position isn't out of window
                    [comment.x, comment.y] = [
                        comment.x + positionOffset,
                        comment.y + positionOffset
                    ];
                    comment.id = nextCommentId + i;
                    // createComment
                    project.comments.push({
                        ...comment
                    });
                });
                const nextTransitionId = $920b9ecb34a1fb18$var$nextIDFor(project.transitions);
                createData.transitions.forEach((transition, i)=>{
                    transition.id = nextTransitionId + i;
                    // createTransition
                    project.transitions.push({
                        ...transition
                    });
                });
                if (isNewProject && createData.initialStateId !== null && project.initialState === null) project.initialState = createData.initialStateId;
            }));
            return {
                type: 2,
                body: createData
            };
        },
        /* Update tests */ setSingleTest: (value)=>set((0, $hkL0p.default)((state)=>{
                state.project.tests.single = value;
                state.lastChangeDate = new Date().getTime();
            })),
        addBatchTest: (value)=>set((0, $hkL0p.default)((state)=>{
                value = value ?? '';
                state.project.tests.batch.push(value);
                state.lastChangeDate = new Date().getTime();
            })),
        updateBatchTest: (index, value)=>set((0, $hkL0p.default)((state)=>{
                state.project.tests.batch[index] = value;
                state.lastChangeDate = new Date().getTime();
            })),
        removeBatchTest: (index)=>set((0, $hkL0p.default)((state)=>{
                state.project.tests.batch.splice(index, 1);
                state.lastChangeDate = new Date().getTime();
            })),
        /* Set given state to be the initial state */ setStateInitial: (stateID)=>set((s)=>({
                    project: {
                        ...s.project,
                        initialState: stateID
                    }
                })),
        /* Set all provided states as final */ toggleStatesFinal: (stateIDs)=>set((0, $hkL0p.default)(({ project: project })=>{
                project.states = project.states.map((state)=>({
                        ...state,
                        isFinal: stateIDs.includes(state.id) ? !state.isFinal : state.isFinal
                    }));
            })),
        /* Toggle direction of transitions */ flipTransitions: (transitionIDs)=>set((0, $hkL0p.default)(({ project: project })=>{
                project.transitions = project.transitions.map((t)=>transitionIDs.includes(t.id) ? {
                        ...t,
                        from: t.to,
                        to: t.from
                    } : t);
            })),
        /* Remove states by id */ removeStates: (stateIDs)=>set((0, $hkL0p.default)(({ project: project })=>{
                // Remove states
                project.states = project.states.filter((st)=>!stateIDs.includes(st.id));
                // Remove associated transitions
                project.transitions = project.transitions.filter((t)=>!stateIDs.includes(t.from) && !stateIDs.includes(t.to));
                // Remove initial state if deleted
                if (stateIDs.includes(project.initialState)) project.initialState = null;
            })),
        /* Remove transitions by id */ removeTransitions: (transitionIDs)=>set((0, $hkL0p.default)(({ project: project })=>{
                project.transitions = project.transitions.filter((t)=>!transitionIDs.includes(t.id));
            })),
        /* Remove comments by id */ removeComments: (commentIDs)=>set((0, $hkL0p.default)(({ project: project })=>{
                project.comments = project.comments.filter((c)=>!commentIDs.includes(c.id));
            })),
        // Change the config
        updateConfig: (newConfig)=>set((0, $hkL0p.default)((state)=>{
                state.project.config = {
                    ...state.project.config,
                    ...newConfig
                };
                state.lastChangeDate = new Date().getTime();
            })),
        getGraph: ()=>{
            const project = get().project;
            return {
                initialState: project.initialState,
                projectType: project.projectType,
                states: project.states,
                transitions: (0, $5277478820e2de90$export$21fb9b44b8827669)(project.transitions)
            };
        },
        updateGraph: (graph)=>set((0, $hkL0p.default)(({ project: project })=>{
                project.transitions = graph.transitions;
                project.states = graph.states;
                project.initialState = graph.initialState;
            })),
        reset: ()=>set({
                project: $920b9ecb34a1fb18$export$2d5adde7dc289012(),
                history: [],
                historyPointer: 0,
                lastChangeDate: -1,
                lastSaveDate: -1
            })
    }), {
    name: 'automatarium-project'
}));
var $920b9ecb34a1fb18$export$2e2bcd8739ae039 = $920b9ecb34a1fb18$var$useProjectStore;




var $hkL0p = parcelRequire("hkL0p");
const $2c8de4ab9c0d9b91$var$screenToCanvasSpace = (x, y, container)=>{
    const b = container.getBoundingClientRect();
    return [
        x - b.left,
        y - b.top
    ];
};
const $2c8de4ab9c0d9b91$var$canvasToScreenSpace = (x, y, container)=>{
    const b = container.getBoundingClientRect();
    return [
        x + b.left,
        y + b.top
    ];
};
const $2c8de4ab9c0d9b91$var$useViewStore = (0, $7f648b6e3795e45a$exports.create)((set, get)=>({
        svgElement: null,
        position: {
            x: 0,
            y: 0
        },
        size: {
            width: 0,
            height: 0
        },
        scale: 1,
        moveViewPosition: ({ x: x = 0, y: y = 0 })=>set((0, $hkL0p.default)((state)=>{
                state.position.x += x * state.scale;
                state.position.y += y * state.scale;
            })),
        setViewPosition: (position)=>set({
                position: position
            }),
        setViewSize: (size)=>set({
                size: size
            }),
        setViewScale: (scale)=>set({
                scale: scale
            }),
        setSvgElement: (svgElement)=>set({
                svgElement: svgElement
            }),
        setViewPositionAndScale: (position, scale)=>set({
                position: position,
                scale: scale
            }),
        applyView: (x, y)=>[
                x * get().scale + get().position.x,
                y * get().scale + get().position.y
            ],
        applyInverseView: (x, y)=>[
                (x - get().position.x) / get().scale,
                (y - get().position.y) / get().scale
            ],
        screenToViewSpace: (clientX, clientY)=>get().applyView(...$2c8de4ab9c0d9b91$var$screenToCanvasSpace(clientX, clientY, get().svgElement)),
        viewToScreenSpace: (viewX, viewY)=>$2c8de4ab9c0d9b91$var$canvasToScreenSpace(...get().applyInverseView(viewX, viewY), get().svgElement)
    }));
var $2c8de4ab9c0d9b91$export$2e2bcd8739ae039 = $2c8de4ab9c0d9b91$var$useViewStore;



const $9ea7efd115f178cf$var$useToolStore = (0, $7f648b6e3795e45a$exports.create)((set)=>({
        tool: 'cursor',
        setTool: (tool)=>set({
                tool: tool
            })
    }));
var $9ea7efd115f178cf$export$2e2bcd8739ae039 = $9ea7efd115f178cf$var$useToolStore;




const $a0ca2e9b6bccb84a$var$useSelectionStore = (0, $7f648b6e3795e45a$exports.create)((set)=>({
        selectedStates: [],
        selectedTransitions: [],
        selectedComments: [],
        setComments: (selectedComments)=>set({
                selectedComments: selectedComments
            }),
        setStates: (selectedStates)=>set({
                selectedStates: selectedStates
            }),
        addState: (state)=>set((s)=>({
                    selectedStates: [
                        ...s.selectedStates,
                        state
                    ]
                })),
        setTransitions: (selectedTransitions)=>set({
                selectedTransitions: selectedTransitions
            }),
        addTransition: (transition)=>set((s)=>({
                    selectedTransitions: [
                        ...s.selectedTransitions,
                        transition
                    ]
                })),
        selectNone: ()=>set({
                selectedStates: [],
                selectedTransitions: [],
                selectedComments: []
            }),
        selectAll: ()=>set({
                selectedStates: (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039).getState().project?.states?.map((s)=>s.id) ?? [],
                selectedTransitions: (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039).getState().project?.transitions?.map((t)=>t.id) ?? [],
                selectedComments: (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039).getState().project?.comments?.map((c)=>c.id) ?? []
            })
    }));
var $a0ca2e9b6bccb84a$export$2e2bcd8739ae039 = $a0ca2e9b6bccb84a$var$useSelectionStore;




const $a882b4a4b7f1e12c$var$useProjectsStore = (0, $7f648b6e3795e45a$exports.create)()((0, $4ec74dd61b3f0976$export$9a6132153fba2e0)((set)=>({
        projects: [],
        setProjects: (projects)=>set({
                projects: projects
            }),
        clearProjects: ()=>set({
                projects: []
            }),
        upsertProject: (project)=>set((s)=>({
                    projects: s.projects.find((p)=>p._id === project._id) ? s.projects.map((p)=>p._id === project._id ? project : p) : [
                        ...s.projects,
                        project
                    ]
                })),
        deleteProject: (pid)=>set((s)=>({
                    projects: s.projects.filter((p)=>p._id !== pid)
                }))
    }), {
    name: 'automatarium-projects'
}));
var $a882b4a4b7f1e12c$export$2e2bcd8739ae039 = $a882b4a4b7f1e12c$var$useProjectsStore;




const $8af1fe532609b934$var$defaultPreferences = {
    theme: 'system',
    color: 'match',
    showGrid: true,
    ctrlZoom: !navigator.platform?.match(/Win/),
    pauseTM: true,
    language: 'en'
};
const $8af1fe532609b934$var$usePreferencesStore = (0, $7f648b6e3795e45a$exports.create)()((0, $4ec74dd61b3f0976$export$9a6132153fba2e0)((set, get)=>({
        preferences: {
            ...$8af1fe532609b934$var$defaultPreferences
        },
        setPreferences: (preferences)=>set({
                preferences: preferences
            }),
        getTheme: ()=>{
            const theme = get().preferences.theme;
            return theme === 'system' ? window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light' : theme;
        }
    }), {
    name: 'automatarium-preferences'
}));
var $8af1fe532609b934$export$2e2bcd8739ae039 = $8af1fe532609b934$var$usePreferencesStore;




const $87c0b991aa949aa0$var$defaultPopups = {
    showFinalState: true
};
const $87c0b991aa949aa0$var$usePopupsStore = (0, $7f648b6e3795e45a$exports.create)()((0, $4ec74dd61b3f0976$export$9a6132153fba2e0)((set)=>({
        popups: {
            ...$87c0b991aa949aa0$var$defaultPopups
        },
        setPopups: (popups)=>set({
                popups: popups
            })
    }), {
    name: 'automatarium-popups'
}));
var $87c0b991aa949aa0$export$2e2bcd8739ae039 = $87c0b991aa949aa0$var$usePopupsStore;



const $ef9e10319983727e$var$defaultOptions = {
    filename: '',
    type: 'png',
    margin: 20,
    color: '',
    darkMode: false,
    background: 'solid'
};
const $ef9e10319983727e$var$useExportStore = (0, $7f648b6e3795e45a$exports.create)((set)=>({
        exportVisible: false,
        options: {
            ...$ef9e10319983727e$var$defaultOptions
        },
        setExportVisible: (exportVisible)=>set({
                exportVisible: exportVisible
            }),
        setOptions: (options)=>set((state)=>({
                    options: {
                        ...state.options,
                        ...options
                    }
                })),
        reset: ()=>set({
                options: {
                    ...$ef9e10319983727e$var$defaultOptions
                }
            })
    }));
var $ef9e10319983727e$export$2e2bcd8739ae039 = $ef9e10319983727e$var$useExportStore;




const $3954b8dde947d829$var$useThumbnailStore = (0, $7f648b6e3795e45a$exports.create)()((0, $4ec74dd61b3f0976$export$9a6132153fba2e0)((set)=>({
        thumbnails: {},
        setThumbnail: (id, thumbnail)=>set((state)=>({
                    thumbnails: {
                        ...state.thumbnails,
                        [id]: thumbnail
                    }
                })),
        removeThumbnail: (id)=>set((state)=>{
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const { [id]: removed, ...thumbnails } = state.thumbnails;
                return {
                    thumbnails: thumbnails
                };
            }),
        clearThumbnails: ()=>set({
                thumbnails: {}
            })
    }), {
    name: 'automatarium-thumbnails'
}));
var $3954b8dde947d829$export$2e2bcd8739ae039 = $3954b8dde947d829$var$useThumbnailStore;



const $d2aaad49862844e1$var$useSteppingStore = (0, $7f648b6e3795e45a$exports.create)((set)=>({
        steppedStates: [],
        /* Update graph step state */ setSteppedStates: (steppedStates)=>{
            const ids = steppedStates.map((s)=>s.state.id);
            set({
                steppedStates: ids
            });
        }
    }));
var $d2aaad49862844e1$export$2e2bcd8739ae039 = $d2aaad49862844e1$var$useSteppingStore;




var $hkL0p = parcelRequire("hkL0p");
const $6baf371cdce3f20b$var$useTMSimResultStore = (0, $7f648b6e3795e45a$exports.create)((set)=>({
        traceIDx: 0,
        simResults: [],
        setSimResults: (simResults)=>set((0, $hkL0p.default)((state)=>{
                state.simResults = simResults;
                state.traceIDx = 0;
            })),
        clearSimResults: ()=>set((0, $hkL0p.default)((state)=>{
                state.simResults = [];
                state.traceIDx = 0;
            })),
        setTraceIDx: (IDx)=>set((0, $hkL0p.default)((state)=>{
                state.traceIDx = IDx;
            }))
    }));
var $6baf371cdce3f20b$export$2e2bcd8739ae039 = $6baf371cdce3f20b$var$useTMSimResultStore;



const $438f85b735159247$var$usePDAVisualiserStore = (0, $7f648b6e3795e45a$exports.create)((set)=>({
        stack: null,
        setStack: (stack)=>set({
                stack: stack
            }),
        clearStack: ()=>set({
                stack: null
            })
    }));
var $438f85b735159247$export$2e2bcd8739ae039 = $438f85b735159247$var$usePDAVisualiserStore;




const $05b6df1ad576ef23$var$useTemplatesStore = (0, $7f648b6e3795e45a$exports.create)()((0, $4ec74dd61b3f0976$export$9a6132153fba2e0)((set)=>({
        templates: [],
        setTemplates: (templates)=>set({
                templates: templates
            }),
        clearTemplates: ()=>set({
                templates: []
            }),
        // Update template, or insert if it doesn't exist
        upsertTemplate: (template)=>set((s)=>({
                    templates: s.templates.find((t)=>t._id === template._id) ? s.templates.map((t)=>t._id === template._id ? template : t) : [
                        ...s.templates,
                        template
                    ]
                })),
        deleteTemplate: (tid)=>set((s)=>({
                    templates: s.templates.filter((t)=>t._id !== tid)
                }))
    }), {
    name: 'automatarium-templates'
}));
var $05b6df1ad576ef23$export$2e2bcd8739ae039 = $05b6df1ad576ef23$var$useTemplatesStore;



const $f8e54bb3e6739765$var$useTemplateStore = (0, $7f648b6e3795e45a$exports.create)((set)=>({
        template: null,
        setTemplate: (template)=>{
            set({
                template: template
            });
        }
    }));
var $f8e54bb3e6739765$export$2e2bcd8739ae039 = $f8e54bb3e6739765$var$useTemplateStore;




// The app has no way to know on which item the user right-clicked on after the context menu is fired
// This aims to solve that issue
const $992c0f2e4bd5c228$var$useContextStore = (0, $7f648b6e3795e45a$exports.create)()((0, $4ec74dd61b3f0976$export$9a6132153fba2e0)((set)=>({
        context: null,
        setContext: (id)=>set({
                context: id
            }),
        clearContext: ()=>set({
                context: null
            })
    }), {
    name: 'automatarium-context'
}));
var $992c0f2e4bd5c228$export$2e2bcd8739ae039 = $992c0f2e4bd5c228$var$useContextStore;






function $be91e446fcb94886$export$ff4e209d475e9bd8(type, name) {
    return {
        _id: crypto.randomUUID(),
        projectType: type,
        states: [],
        transitions: [],
        initialState: null,
        comments: [],
        config: {
            acceptanceCriteria: (0, $09ff7c1d5f0c0758$export$951617dc07b67a12),
            // All lab projects are set to pink to distinguish the difference between a lab and a normal project
            color: 'pink',
            orOperator: (0, $09ff7c1d5f0c0758$export$6a13b8d132417b20),
            statePrefix: (0, $09ff7c1d5f0c0758$export$84ea809ec961cd1),
            type: type
        },
        meta: {
            name: name ?? "New Project",
            dateCreated: Date.now(),
            dateEdited: Date.now(),
            version: (0, $09ff7c1d5f0c0758$export$3167453beff01750),
            automatariumVersion: (0, $09ff7c1d5f0c0758$export$8ee1df3c6367a60)
        },
        simResult: [],
        tests: {
            batch: [],
            single: ""
        }
    };
}
const $be91e446fcb94886$export$e6f852ab53eb4018 = (description = "Write a description here")=>({
        _id: crypto.randomUUID(),
        description: description,
        projects: [],
        questions: {},
        meta: {
            name: (0, $05c0391770bda4cd$export$cc5acd52dd9611ac)(),
            dateCreated: Date.now(),
            dateEdited: Date.now(),
            version: (0, $09ff7c1d5f0c0758$export$3167453beff01750),
            automatariumVersion: (0, $09ff7c1d5f0c0758$export$8ee1df3c6367a60)
        }
    });
const $be91e446fcb94886$var$useModuleStore = (0, $7f648b6e3795e45a$exports.create)()((0, $4ec74dd61b3f0976$export$9a6132153fba2e0)((set, get)=>({
        module: null,
        showModuleWindow: false,
        lastChangeDate: null,
        setModule: (module)=>set({
                module: module
            }),
        setProjects: (projects)=>set((state)=>state.module ? {
                    module: {
                        ...state.module,
                        projects: projects
                    }
                } : state),
        clearProjects: ()=>set((state)=>state.module ? {
                    module: {
                        ...state.module,
                        projects: []
                    }
                } : state),
        upsertProject: (project)=>set((state)=>{
                if (!state.module) return state;
                const exists = state.module.projects.some((p)=>p._id === project._id);
                const updated = exists ? state.module.projects.map((p)=>p._id === project._id ? project : p) : [
                    ...state.module.projects,
                    project
                ];
                return {
                    module: {
                        ...state.module,
                        projects: updated
                    },
                    lastChangeDate: Date.now()
                };
            }),
        deleteProject: (id)=>set((state)=>state.module ? {
                    module: {
                        ...state.module,
                        projects: state.module.projects.filter((p)=>p._id !== id)
                    },
                    lastChangeDate: Date.now()
                } : state),
        getProject: (index)=>get().module?.projects[index],
        getProjectById: (id)=>get().module?.projects.find((p)=>p._id === id),
        setName: (name)=>set((state)=>state.module ? {
                    module: {
                        ...state.module,
                        meta: {
                            ...state.module.meta,
                            name: name
                        }
                    },
                    lastChangeDate: Date.now()
                } : state),
        setModuleDescription: (description)=>set((state)=>state.module ? {
                    module: {
                        ...state.module,
                        description: description
                    },
                    lastChangeDate: Date.now()
                } : state),
        setAllProjectNames: (name)=>set((state)=>state.module ? {
                    module: {
                        ...state.module,
                        projects: state.module.projects.map((p)=>({
                                ...p,
                                meta: {
                                    ...p.meta,
                                    name: name
                                }
                            }))
                    },
                    lastChangeDate: Date.now()
                } : state),
        setShowModuleWindow: (show)=>set({
                showModuleWindow: show
            }),
        upsertQuestion: (pid, question)=>set((state)=>state.module ? {
                    module: {
                        ...state.module,
                        questions: {
                            ...state.module.questions,
                            [pid]: question
                        }
                    },
                    lastChangeDate: Date.now()
                } : state),
        deleteQuestion: (pid)=>set((state)=>state.module ? {
                    module: {
                        ...state.module,
                        questions: Object.fromEntries(Object.entries(state.module.questions).filter(([key])=>key !== pid))
                    },
                    lastChangeDate: Date.now()
                } : state)
    }), {
    name: "automatarium-module",
    version: 1
}));
var $be91e446fcb94886$export$2e2bcd8739ae039 = $be91e446fcb94886$var$useModuleStore;




const $38932e4472f33f50$export$ed4cf056f0ce91d0 = (0, $7f648b6e3795e45a$exports.create)()((0, $4ec74dd61b3f0976$export$9a6132153fba2e0)((set, get)=>({
        modules: [],
        setModules: (modules)=>set({
                modules: modules
            }),
        clearModules: ()=>set({
                modules: []
            }),
        upsertModule: (module)=>set((state)=>{
                const exists = state.modules.some((m)=>m._id === module._id);
                const updated = exists ? state.modules.map((m)=>m._id === module._id ? module : m) : [
                    ...state.modules,
                    module
                ];
                return {
                    modules: updated
                };
            }),
        deleteModule: (id)=>set((state)=>({
                    modules: state.modules.filter((m)=>m._id !== id)
                })),
        getModuleById: (id)=>get().modules.find((m)=>m._id === id)
    }), {
    name: "automatarium-modules",
    version: 1
}));
var $38932e4472f33f50$export$2e2bcd8739ae039 = $38932e4472f33f50$export$ed4cf056f0ce91d0;




const $d782d8e92e006c64$var$useEdgeContext = ()=>{
    const projectTransitions = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039).getState().project?.transitions ?? [];
    const transitionFromCtx = ()=>{
        const ctx = (0, $992c0f2e4bd5c228$export$2e2bcd8739ae039).getState().context;
        if (ctx === null) return undefined;
        return projectTransitions.find((t)=>t.id === ctx);
    };
    const transitionsFromCtx = ()=>{
        const transitionCtx = transitionFromCtx();
        if (transitionCtx === undefined) return undefined;
        return projectTransitions.filter((t)=>t.from === transitionCtx.from && t.to === transitionCtx.to);
    };
    return {
        getTransitionFromContext: transitionFromCtx,
        getTransitionsFromContext: transitionsFromCtx
    };
};
var $d782d8e92e006c64$export$2e2bcd8739ae039 = $d782d8e92e006c64$var$useEdgeContext;







const $0f27907e04d49c69$export$8a23e74e5cf3ca41 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('button')`
  display: grid;
  grid-template-rows: 1.3fr 1fr;
  box-sizing: border-box;
  min-width: 18em;
  width: 20em;
  // Default to 100% if anything wrong happens so its still viewable
  height: ${(p)=>p.height || '100%'}px;
  
  border-radius: .5rem;
  border: 3px solid transparent;
  overflow: hidden;
  user-select: none;
  background: none;
  font: inherit;
  color: inherit;
  cursor: pointer;
  padding: 0;
  text-align: left;

  &:hover:not(:disabled), &:focus {
    border: 3px solid var(--primary);
    outline: none;
  }

  &:disabled {
    cursor: default;
    opacity: .7;
  }
`;
const $0f27907e04d49c69$export$64ef9b8c11710c47 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  background: var(--toolbar);
  padding: .9em;

  > p {
    margin: 0;
    margin-top: .5em;
    font-size: .9rem;
  }
`;
const $0f27907e04d49c69$export$8a8c015277a3d77a = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  height: 100%;
  background: var(--grid-pattern${(p)=>p.theme});
  background-size: 1.875em 1.875em;
  background-position: .4375em .4375em;
  position: relative;

  ${(p)=>p.$disabled && `
    position: relative;
    &::after {
      content: 'Coming Soon';
      display: flex;
      align-items: center;
      justify-content: center;
      color: grey;
      font-size: 1.7rem;
      opacity: .4;
      position: absolute;
      inset: 0;
    }
  `}

  img, svg {
    display: block;
    object-fit: contain;
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
  }
`;



const $61cc15d35249d28a$var$NewProjectCard = ({ title: title, description: description, image: image, height: height, ...props })=>{
    const preferences = (0, $8af1fe532609b934$export$2e2bcd8739ae039)((state)=>state.preferences);
    // If matching system theme, don't append a theme to css vars
    const theme = preferences.theme === 'system' ? '' : `-${preferences.theme}`;
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $0f27907e04d49c69$export$8a23e74e5cf3ca41), {
        height: height,
        ...props,
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $0f27907e04d49c69$export$8a8c015277a3d77a), {
                $disabled: props.disabled,
                theme: theme,
                children: image
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $0f27907e04d49c69$export$64ef9b8c11710c47), {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("strong", {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("p", {
                        children: description
                    })
                ]
            })
        ]
    });
};
var $61cc15d35249d28a$export$2e2bcd8739ae039 = $61cc15d35249d28a$var$NewProjectCard;





var $h2ArV = parcelRequire("h2ArV");
const $e2410b7e741a8d66$export$8d67da3de22a29a9 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  width: 100%;
  gap: 1em;
  align-items: center;
`;
const $e2410b7e741a8d66$export$5544fb7275d75e73 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('h2')`
  margin-block: 0;
`;
const $e2410b7e741a8d66$export$b2091b6a19255a17 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div', (0, $h2ArV.forwardRef))`
  display: flex;
  gap: .4em;
  margin-block-start: 1em;
  margin-block-end: 3em;
  flex-wrap: wrap;
  align-items: flex-start;
`;


const $ca969eaeccef5bfe$var$CardList = ({ title: title, button: button, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $e2410b7e741a8d66$export$8d67da3de22a29a9), {
                children: [
                    title && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e2410b7e741a8d66$export$5544fb7275d75e73), {
                        children: title
                    }),
                    button
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e2410b7e741a8d66$export$b2091b6a19255a17), {
                ref: innerRef,
                ...props
            })
        ]
    });
var $ca969eaeccef5bfe$export$2e2bcd8739ae039 = $ca969eaeccef5bfe$var$CardList;




var $h2ArV = parcelRequire("h2ArV");

var $h2ArV = parcelRequire("h2ArV");
var $8ec10c32591aa46c$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $8ec10c32591aa46c$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $bde65846ecdf2f1f$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $bde65846ecdf2f1f$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($8ec10c32591aa46c$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("--\x3e");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($bde65846ecdf2f1f$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $bde65846ecdf2f1f$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $bde65846ecdf2f1f$var$i = /^\s*$/, $bde65846ecdf2f1f$var$s = Object.create(null);
function $bde65846ecdf2f1f$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($bde65846ecdf2f1f$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "\x3c!--" + t.comment + "--\x3e";
    }
}
var $bde65846ecdf2f1f$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $bde65846ecdf2f1f$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($bde65846ecdf2f1f$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("\x3c!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $bde65846ecdf2f1f$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $bde65846ecdf2f1f$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $bde65846ecdf2f1f$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $bde65846ecdf2f1f$var$a("", t);
        }, "");
    }
};
var $bde65846ecdf2f1f$export$2e2bcd8739ae039 = $bde65846ecdf2f1f$var$c;


function $acfca6eb0992e44d$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if ($acfca6eb0992e44d$export$844ec244b1367d54(args[0])) args[0] = `react-i18next:: ${args[0]}`;
        console.warn(...args);
    }
}
const $acfca6eb0992e44d$var$alreadyWarned = {};
function $acfca6eb0992e44d$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if ($acfca6eb0992e44d$export$844ec244b1367d54(args[0]) && $acfca6eb0992e44d$var$alreadyWarned[args[0]]) return;
    if ($acfca6eb0992e44d$export$844ec244b1367d54(args[0])) $acfca6eb0992e44d$var$alreadyWarned[args[0]] = new Date();
    $acfca6eb0992e44d$export$c106dd0671a0fc2d(...args);
}
const $acfca6eb0992e44d$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    };
const $acfca6eb0992e44d$export$83be934b53fff43b = (i18n, ns, cb)=>{
    i18n.loadNamespaces(ns, $acfca6eb0992e44d$var$loadedClb(i18n, cb));
};
const $acfca6eb0992e44d$export$8cd7e7a54fa865bc = (i18n, lng, ns, cb)=>{
    if ($acfca6eb0992e44d$export$844ec244b1367d54(ns)) ns = [
        ns
    ];
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $acfca6eb0992e44d$var$loadedClb(i18n, cb));
};
const $acfca6eb0992e44d$var$oldI18nextHasLoadedNamespace = function(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const lng = i18n.languages[0];
    const fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    const lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === 'cimode') return true;
    const loadNotPending = (l, n)=>{
        const loadState = i18n.services.backendConnector.state[`${l}|${n}`];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
};
const $acfca6eb0992e44d$export$93d9ee97c1ad3f31 = function(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $acfca6eb0992e44d$export$5b28268982f175ba('i18n.languages were undefined or empty', i18n.languages);
        return true;
    }
    const isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $acfca6eb0992e44d$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
};
const $acfca6eb0992e44d$export$be63e0664592e141 = (Component)=>Component.displayName || Component.name || ($acfca6eb0992e44d$export$844ec244b1367d54(Component) && Component.length > 0 ? Component : 'Unknown');
const $acfca6eb0992e44d$export$844ec244b1367d54 = (obj)=>typeof obj === 'string';
const $acfca6eb0992e44d$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'object' && obj !== null;


const $9c8d384d552076e1$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $9c8d384d552076e1$var$htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
const $9c8d384d552076e1$var$unescapeHtmlEntity = (m)=>$9c8d384d552076e1$var$htmlEntities[m];
const $9c8d384d552076e1$export$e8bacd2802a88316 = (text)=>text.replace($9c8d384d552076e1$var$matchHtmlEntity, $9c8d384d552076e1$var$unescapeHtmlEntity);


let $ce4ef0c092760011$var$defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: $9c8d384d552076e1$export$e8bacd2802a88316
};
const $ce4ef0c092760011$export$2e2366488d12e20d = function() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $ce4ef0c092760011$var$defaultOptions = {
        ...$ce4ef0c092760011$var$defaultOptions,
        ...options
    };
};
const $ce4ef0c092760011$export$212bb2fc580a90a8 = ()=>$ce4ef0c092760011$var$defaultOptions;


let $632231db0495f0bd$var$i18nInstance;
const $632231db0495f0bd$export$a039134f2fc7e0 = (instance)=>{
    $632231db0495f0bd$var$i18nInstance = instance;
};
const $632231db0495f0bd$export$64af334f494c2f47 = ()=>$632231db0495f0bd$var$i18nInstance;


const $80572834fdbda445$var$hasChildren = (node, checkLength)=>{
    if (!node) return false;
    const base = node.props ? node.props.children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
};
const $80572834fdbda445$var$getChildren = (node)=>{
    if (!node) return [];
    const children = node.props ? node.props.children : node.children;
    return node.props && node.props.i18nIsDynamicList ? $80572834fdbda445$var$getAsArray(children) : children;
};
const $80572834fdbda445$var$hasValidReactChildren = (children)=>Array.isArray(children) && children.every((0, $h2ArV.isValidElement));
const $80572834fdbda445$var$getAsArray = (data)=>Array.isArray(data) ? data : [
        data
    ];
const $80572834fdbda445$var$mergeProps = (source, target)=>{
    const newTarget = {
        ...target
    };
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
};
const $80572834fdbda445$export$4f7a36dd898f1267 = (children, i18nOptions)=>{
    if (!children) return '';
    let stringNode = '';
    const childrenArray = $80572834fdbda445$var$getAsArray(children);
    const keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
    childrenArray.forEach((child, childIndex)=>{
        if ((0, $acfca6eb0992e44d$export$844ec244b1367d54)(child)) stringNode += `${child}`;
        else if ((0, $h2ArV.isValidElement)(child)) {
            const { props: props, type: type } = child;
            const childPropsCount = Object.keys(props).length;
            const shouldKeepChild = keepArray.indexOf(type) > -1;
            const childChildren = props.children;
            if (!childChildren && shouldKeepChild && !childPropsCount) stringNode += `<${type}/>`;
            else if (!childChildren && (!shouldKeepChild || childPropsCount) || props.i18nIsDynamicList) stringNode += `<${childIndex}></${childIndex}>`;
            else if (shouldKeepChild && childPropsCount === 1 && (0, $acfca6eb0992e44d$export$844ec244b1367d54)(childChildren)) stringNode += `<${type}>${childChildren}</${type}>`;
            else {
                const content = $80572834fdbda445$export$4f7a36dd898f1267(childChildren, i18nOptions);
                stringNode += `<${childIndex}>${content}</${childIndex}>`;
            }
        } else if (child === null) (0, $acfca6eb0992e44d$export$c106dd0671a0fc2d)(`Trans: the passed in value is invalid - seems you passed in a null child.`);
        else if ((0, $acfca6eb0992e44d$export$a6cdc56e425d0d0a)(child)) {
            const { format: format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
            } else (0, $acfca6eb0992e44d$export$c106dd0671a0fc2d)(`react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.`, child);
        } else (0, $acfca6eb0992e44d$export$c106dd0671a0fc2d)(`Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.`, child);
    });
    return stringNode;
};
const $80572834fdbda445$var$renderNodes = (children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape)=>{
    if (targetString === '') return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join('|')).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = {};
    const getData = (childs)=>{
        const childrenArray = $80572834fdbda445$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if ((0, $acfca6eb0992e44d$export$844ec244b1367d54)(child)) return;
            if ($80572834fdbda445$var$hasChildren(child)) getData($80572834fdbda445$var$getChildren(child));
            else if ((0, $acfca6eb0992e44d$export$a6cdc56e425d0d0a)(child) && !(0, $h2ArV.isValidElement)(child)) Object.assign(data, child);
        });
    };
    getData(children);
    const ast = (0, $bde65846ecdf2f1f$export$2e2bcd8739ae039).parse(`<0>${targetString}</0>`);
    const opts = {
        ...data,
        ...combinedTOpts
    };
    const renderInner = (child, node, rootReactNode)=>{
        const childs = $80572834fdbda445$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $80572834fdbda445$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props && child.props.i18nIsDynamicList ? childs : mappedChildren;
    };
    const pushTranslatedJSX = (child, inner, mem, i, isVoid)=>{
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $h2ArV.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $h2ArV.Children).map([
            child
        ], (c)=>{
            const props = {
                ...c.props
            };
            delete props.i18nIsDynamicList;
            return (0, $h2ArV.createElement)(c.type, {
                ...props,
                key: i,
                ref: c.ref
            }, isVoid ? null : inner);
        }));
    };
    const mapAST = (reactNode, astNode, rootReactNode)=>{
        const reactNodes = $80572834fdbda445$var$getAsArray(reactNode);
        const astNodes = $80572834fdbda445$var$getAsArray(astNode);
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === 'tag') {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const child = Object.keys(node.attrs).length !== 0 ? $80572834fdbda445$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                const isElement = (0, $h2ArV.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && $80572834fdbda445$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, $acfca6eb0992e44d$export$a6cdc56e425d0d0a)(child) && child.dummy && !isElement;
                const isKnownComponent = (0, $acfca6eb0992e44d$export$a6cdc56e425d0d0a)(children) && Object.hasOwnProperty.call(children, node.name);
                if ((0, $acfca6eb0992e44d$export$844ec244b1367d54)(child)) {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($80572834fdbda445$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $h2ArV.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const inner = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $h2ArV.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if ((0, $acfca6eb0992e44d$export$a6cdc56e425d0d0a)(child) && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === 'text') {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $h2ArV.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    };
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $80572834fdbda445$var$getAsArray(children || []));
    return $80572834fdbda445$var$getChildren(result[0]);
};
function $80572834fdbda445$export$8d6a9236f2e3f2ce(_ref) {
    let { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps } = _ref;
    const i18n = i18nFromProps || (0, $632231db0495f0bd$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $acfca6eb0992e44d$export$5b28268982f175ba)('You will need to pass in an i18next instance by using i18nextReactModule');
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    const reactI18nextOptions = {
        ...(0, $ce4ef0c092760011$export$212bb2fc580a90a8)(),
        ...i18n.options && i18n.options.react
    };
    let namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
    namespaces = (0, $acfca6eb0992e44d$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    const nodeAsString = $80572834fdbda445$export$4f7a36dd898f1267(children, reactI18nextOptions);
    const defaultValue = defaults || nodeAsString || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    if (i18n.options && i18n.options.interpolation && i18n.options.interpolation.defaultVariables) values = values && Object.keys(values).length > 0 ? {
        ...values,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    const interpolationOverride = values || count !== undefined || !children ? tOptions.interpolation : {
        interpolation: {
            ...tOptions.interpolation,
            prefix: '#$?',
            suffix: '?$#'
        }
    };
    const combinedTOpts = {
        ...tOptions,
        context: context || tOptions.context,
        count: count,
        ...values,
        ...interpolationOverride,
        defaultValue: defaultValue,
        ns: namespaces
    };
    const translation = key ? t(key, combinedTOpts) : defaultValue;
    if (components) Object.keys(components).forEach((c)=>{
        const comp = components[c];
        if (typeof comp.type === 'function' || !comp.props || !comp.props.children || translation.indexOf(`${c}/>`) < 0 && translation.indexOf(`${c} />`) < 0) return;
        function Componentized() {
            return (0, $h2ArV.createElement)((0, $h2ArV.Fragment), null, comp);
        }
        components[c] = (0, $h2ArV.createElement)(Componentized);
    });
    const content = $80572834fdbda445$var$renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    const useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $h2ArV.createElement)(useAsParent, additionalProps, content) : content;
}



var $h2ArV = parcelRequire("h2ArV");




const $4108570c8605a395$export$ae7e14d40d89f296 = {
    type: '3rdParty',
    init (instance) {
        (0, $ce4ef0c092760011$export$2e2366488d12e20d)(instance.options.react);
        (0, $632231db0495f0bd$export$a039134f2fc7e0)(instance);
    }
};


const $777c28893dc68df0$export$5603ab5ced17ce64 = (0, $h2ArV.createContext)();
class $777c28893dc68df0$export$ea171b67e3820290 {
    constructor(){
        this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces = ()=>Object.keys(this.usedNamespaces);
}
const $777c28893dc68df0$export$30ff0342ccf735a = (ForComponent)=>async (ctx)=>{
        const componentsInitialProps = ForComponent.getInitialProps ? await ForComponent.getInitialProps(ctx) : {};
        const i18nInitialProps = $777c28893dc68df0$export$704200e5d0b9e8f();
        return {
            ...componentsInitialProps,
            ...i18nInitialProps
        };
    };
const $777c28893dc68df0$export$704200e5d0b9e8f = ()=>{
    const i18n = (0, $632231db0495f0bd$export$64af334f494c2f47)();
    const namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
};


function $830e59bd42af92d3$export$8d6a9236f2e3f2ce(_ref) {
    let { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps } = _ref;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $h2ArV.useContext)((0, $777c28893dc68df0$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $632231db0495f0bd$export$64af334f494c2f47)();
    const t = tFromProps || i18n && i18n.t.bind(i18n);
    return (0, $80572834fdbda445$export$8d6a9236f2e3f2ce)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape,
        ...additionalProps
    });
}




var $h2ArV = parcelRequire("h2ArV");


const $e52c02d9f8a7380f$var$usePrevious = (value, ignore)=>{
    const ref = (0, $h2ArV.useRef)();
    (0, $h2ArV.useEffect)(()=>{
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
const $e52c02d9f8a7380f$var$alwaysNewT = (i18n, language, namespace, keyPrefix)=>i18n.getFixedT(language, namespace, keyPrefix);
const $e52c02d9f8a7380f$var$useMemoizedT = (i18n, language, namespace, keyPrefix)=>(0, $h2ArV.useCallback)($e52c02d9f8a7380f$var$alwaysNewT(i18n, language, namespace, keyPrefix), [
        i18n,
        language,
        namespace,
        keyPrefix
    ]);
const $e52c02d9f8a7380f$export$9fc83ad70ead8663 = function(ns) {
    let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $h2ArV.useContext)((0, $777c28893dc68df0$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $632231db0495f0bd$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $777c28893dc68df0$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $acfca6eb0992e44d$export$5b28268982f175ba)('You will need to pass in an i18next instance by using initReactI18next');
        const notReadyT = (k, optsOrDefaultValue)=>{
            if ((0, $acfca6eb0992e44d$export$844ec244b1367d54)(optsOrDefaultValue)) return optsOrDefaultValue;
            if ((0, $acfca6eb0992e44d$export$a6cdc56e425d0d0a)(optsOrDefaultValue) && (0, $acfca6eb0992e44d$export$844ec244b1367d54)(optsOrDefaultValue.defaultValue)) return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        const retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $acfca6eb0992e44d$export$5b28268982f175ba)('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
    const i18nOptions = {
        ...(0, $ce4ef0c092760011$export$212bb2fc580a90a8)(),
        ...i18n.options.react,
        ...props
    };
    const { useSuspense: useSuspense, keyPrefix: keyPrefix } = i18nOptions;
    let namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = (0, $acfca6eb0992e44d$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    const ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $acfca6eb0992e44d$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions));
    const memoGetT = $e52c02d9f8a7380f$var$useMemoizedT(i18n, props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    const getT = ()=>memoGetT;
    const getNewT = ()=>$e52c02d9f8a7380f$var$alwaysNewT(i18n, props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    const [t, setT] = (0, $h2ArV.useState)(getT);
    let joinedNS = namespaces.join();
    if (props.lng) joinedNS = `${props.lng}${joinedNS}`;
    const previousJoinedNS = $e52c02d9f8a7380f$var$usePrevious(joinedNS);
    const isMounted = (0, $h2ArV.useRef)(true);
    (0, $h2ArV.useEffect)(()=>{
        const { bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) (0, $acfca6eb0992e44d$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>{
                if (isMounted.current) setT(getNewT);
            });
            else (0, $acfca6eb0992e44d$export$83be934b53fff43b)(i18n, namespaces, ()=>{
                if (isMounted.current) setT(getNewT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getNewT);
        const boundReset = ()=>{
            if (isMounted.current) setT(getNewT);
        };
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return ()=>{
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(' ').forEach((e)=>i18n.off(e, boundReset));
            if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach((e)=>i18n.store.off(e, boundReset));
        };
    }, [
        i18n,
        joinedNS
    ]);
    (0, $h2ArV.useEffect)(()=>{
        if (isMounted.current && ready) setT(getT);
    }, [
        i18n,
        keyPrefix,
        ready
    ]);
    const ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise((resolve)=>{
        if (props.lng) (0, $acfca6eb0992e44d$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>resolve());
        else (0, $acfca6eb0992e44d$export$83be934b53fff43b)(i18n, namespaces, ()=>resolve());
    });
};



var $h2ArV = parcelRequire("h2ArV");


const $f59eb41a9883ff15$export$2dcb0053efd21124 = function(ns) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function Extend(WrappedComponent) {
        function I18nextWithTranslation(_ref) {
            let { forwardedRef: forwardedRef, ...rest } = _ref;
            const [t, i18n, ready] = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t: t,
                i18n: i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $h2ArV.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, $acfca6eb0992e44d$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, $h2ArV.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, $h2ArV.forwardRef)(forwardRef) : I18nextWithTranslation;
    };
};



function $28aff71cafe27925$export$b63289fbda65eed1(props) {
    const { ns: ns, children: children, ...options } = props;
    const [t, i18n, ready] = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)(ns, options);
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
}



var $h2ArV = parcelRequire("h2ArV");

function $c517d8667a39cb5c$export$1325e8699caa160f(_ref) {
    let { i18n: i18n, defaultNS: defaultNS, children: children } = _ref;
    const value = (0, $h2ArV.useMemo)(()=>({
            i18n: i18n,
            defaultNS: defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, $h2ArV.createElement)((0, $777c28893dc68df0$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}



var $h2ArV = parcelRequire("h2ArV");

var $h2ArV = parcelRequire("h2ArV");

const $394386a96ed19ab0$export$3526fb65ade8d8b7 = function(initialI18nStore, initialLanguage) {
    let props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, $h2ArV.useContext)((0, $777c28893dc68df0$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $632231db0495f0bd$export$64af334f494c2f47)();
    if (i18n.options && i18n.options.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
};




const $6eb26f7dfa96d426$export$80dfa519af1c8605 = ()=>function Extend(WrappedComponent) {
        function I18nextWithSSR(_ref) {
            let { initialI18nStore: initialI18nStore, initialLanguage: initialLanguage, ...rest } = _ref;
            (0, $394386a96ed19ab0$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $h2ArV.createElement)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, $777c28893dc68df0$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, $acfca6eb0992e44d$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };







const $3c356b166952b2e8$export$324d90190a8b822a = ()=>'';
const $3c356b166952b2e8$export$2da9be4cfdb689b1 = ()=>'';
const $3c356b166952b2e8$export$98e628dec113755e = ()=>'';
const $3c356b166952b2e8$export$2e6c959c16ff56b8 = ()=>'';
const $3c356b166952b2e8$export$4e35d5c922a95490 = ()=>'';
const $3c356b166952b2e8$export$720a3b9db04b7a0f = ()=>'';




const $4e8aac9c208f6626$var$DeleteConfirmationDialog = ({ ...props })=>{
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)([
        'common',
        'newfile'
    ]);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('modal:deleteConfirm', ()=>props.isOpenReducer(true), []);
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $a5fe3119a76402fb$export$2e2bcd8739ae039), {
        title: t('component.delete_dialog.title', {
            ns: 'newfile'
        }),
        description: t('component.delete_dialog.description', {
            ns: 'newfile',
            projectName: props.projectName
        }),
        isOpen: props.isOpen,
        onClose: props.onClose,
        role: "alertdialog",
        actions: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                    secondary: true,
                    onClick: ()=>props.isOpenReducer(false),
                    children: t('cancel', {
                        ns: 'common'
                    })
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                    onClick: props.onConfirm,
                    children: t('delete', {
                        ns: 'common'
                    })
                })
            ]
        })
    });
};
var $4e8aac9c208f6626$export$2e2bcd8739ae039 = $4e8aac9c208f6626$var$DeleteConfirmationDialog;






/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $h2ArV = parcelRequire("h2ArV");
/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $5a1934b83ee1aeda$export$73bda83cddbc7187 = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const $5a1934b83ee1aeda$export$86f54f62aa7a7514 = (string)=>string.replace(/^([A-Z])|[\s-_]+(\w)/g, (match, p1, p2)=>p2 ? p2.toUpperCase() : p1.toLowerCase());
const $5a1934b83ee1aeda$export$6fb43ff9addf7357 = (string)=>{
    const camelCase = $5a1934b83ee1aeda$export$86f54f62aa7a7514(string);
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};
const $5a1934b83ee1aeda$export$3d46f4579dba46e5 = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();
const $5a1934b83ee1aeda$export$ab365959aa6deed0 = (props)=>{
    for(const prop in props){
        if (prop.startsWith("aria-") || prop === "role" || prop === "title") return true;
    }
};


/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $h2ArV = parcelRequire("h2ArV");
/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $99a299b31ebb220d$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};



const $fdaeea3ba8fec85e$export$2e2bcd8739ae039 = (0, $h2ArV.forwardRef)(({ color: color = "currentColor", size: size = 24, strokeWidth: strokeWidth = 2, absoluteStrokeWidth: absoluteStrokeWidth, className: className = "", children: children, iconNode: iconNode, ...rest }, ref)=>(0, $h2ArV.createElement)("svg", {
        ref: ref,
        ...(0, $99a299b31ebb220d$export$2e2bcd8739ae039),
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: (0, $5a1934b83ee1aeda$export$3d46f4579dba46e5)("lucide", className),
        ...!children && !(0, $5a1934b83ee1aeda$export$ab365959aa6deed0)(rest) && {
            "aria-hidden": "true"
        },
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, $h2ArV.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]));


const $764ec6f19a629312$export$2e2bcd8739ae039 = (iconName, iconNode)=>{
    const Component = (0, $h2ArV.forwardRef)(({ className: className, ...props }, ref)=>(0, $h2ArV.createElement)((0, $fdaeea3ba8fec85e$export$2e2bcd8739ae039), {
            ref: ref,
            iconNode: iconNode,
            className: (0, $5a1934b83ee1aeda$export$3d46f4579dba46e5)(`lucide-${(0, $5a1934b83ee1aeda$export$73bda83cddbc7187)((0, $5a1934b83ee1aeda$export$6fb43ff9addf7357)(iconName))}`, `lucide-${iconName}`, className),
            ...props
        }));
    Component.displayName = (0, $5a1934b83ee1aeda$export$6fb43ff9addf7357)(iconName);
    return Component;
};


const $cfc59ee7830ac2d1$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "1",
            key: "41hilf"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "5",
            r: "1",
            key: "gxeob9"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "19",
            r: "1",
            key: "lyex9k"
        }
    ]
];
const $cfc59ee7830ac2d1$export$2e2bcd8739ae039 = (0, $764ec6f19a629312$export$2e2bcd8739ae039)("ellipsis-vertical", $cfc59ee7830ac2d1$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $18a55aecbfde5f55$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 6h18",
            key: "d0wm0j"
        }
    ],
    [
        "path",
        {
            d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6",
            key: "4alrt4"
        }
    ],
    [
        "path",
        {
            d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2",
            key: "v07s0e"
        }
    ]
];
const $18a55aecbfde5f55$export$2e2bcd8739ae039 = (0, $764ec6f19a629312$export$2e2bcd8739ae039)("trash", $18a55aecbfde5f55$export$3efd853dbb351e94);



const $91310500c4ff9fec$export$8a23e74e5cf3ca41 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('button')`
  width: ${(props)=>props.width}em;
  padding: 0;
  margin: 3px;
  background: none;
  border: 0;
  font: inherit;
  text-align: left;
  color: inherit;
  cursor: pointer;

  &:hover${(props)=>!props.$istemplate && ', &:focus'} {
    outline: none;

    &:not(:disabled) > div:first-of-type {
      box-shadow: 0 0 0 3px var(--primary);
    }
  }
  &:disabled {
    cursor: default;
  }
`;
const $91310500c4ff9fec$export$8a8c015277a3d77a = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  aspect-ratio: 1;
  border-radius: .6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background: var(--grid-bg);

  svg {
    width: 60%;
    height: 60%;
    aspect-ratio: inherit;
    display: block;
  }
  img {
    height: 100%;
    width: 100%;
    display: block;
    object-fit: contain;
  }

  ${(props)=>!props.$image && `
    background: var(--grid-pattern);
    background-size: 1.875em 1.875em;
    background-position: .4735em .4735em;
  `}
`;
const $91310500c4ff9fec$export$6be4972368479c02 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  position: absolute;
  top: 1em;
  right: 1em;
  background: var(--toolbar);
  padding: .4em .6em;
  border-radius: .3em;
  letter-spacing: .1em;
  font-size: .8rem;
  font-weight: 600;
  opacity: .9;
`;
const $91310500c4ff9fec$export$1e9faae0a9ae64d0 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  a {
    color: var(--white);
    opacity: 0.5;

    &:hover {
      opacity: 1;
    }
  }
`;
const $91310500c4ff9fec$export$b074a5f8ba27f480 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  margin-block-start: 1em;
  list-style-type: none;

  span {
    display: block;
    opacity: .5;
    margin-block-start: .2rem;
    font-size: .9em;
  }
`;
const $91310500c4ff9fec$export$7e4d17f97c7d718e = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  position: absolute;
  z-index: 9;
  background: hsla(var(--primary-h), var(--primary-s), var(--primary-l), 0.4);
  width: 100%;
  height: 100%;
  border-radius: .6rem;
  box-shadow: 0 0 0 3px var(--primary);
`;


(0, (/*@__PURE__*/$parcel$interopDefault($de07f2c205919029$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($11e5497bd9439d83$exports))));
const $6c2ba1e571e78271$var$ModuleCard = ({ name: name, image: image, isSelectedTemplate: isSelectedTemplate = false, ...props })=>{
    const { ...rest } = props;
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $91310500c4ff9fec$export$8a23e74e5cf3ca41), {
        ...rest,
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $91310500c4ff9fec$export$8a8c015277a3d77a), {
                $image: !!image,
                children: [
                    image ? /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("img", {
                        src: image,
                        alt: ""
                    }) : /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $2fdc1cc89313d290$export$2e2bcd8739ae039), {}),
                    isSelectedTemplate && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $91310500c4ff9fec$export$7e4d17f97c7d718e), {})
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $91310500c4ff9fec$export$b074a5f8ba27f480), {
                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $91310500c4ff9fec$export$1e9faae0a9ae64d0), {
                    children: [
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("strong", {
                            children: name
                        }),
                        props.$istemplate ? /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("a", {
                                onClick: props.$deleteLabTemplate,
                                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $18a55aecbfde5f55$export$2e2bcd8739ae039), {})
                            })
                        }) : /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("a", {
                                onClick: props.$kebabClick,
                                ref: props.$kebabRef,
                                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $cfc59ee7830ac2d1$export$2e2bcd8739ae039), {})
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $6c2ba1e571e78271$export$2e2bcd8739ae039 = $6c2ba1e571e78271$var$ModuleCard;





/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8f2b0b47dafdf586$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
            key: "wmoenq"
        }
    ],
    [
        "path",
        {
            d: "M12 9v4",
            key: "juzpu7"
        }
    ],
    [
        "path",
        {
            d: "M12 17h.01",
            key: "p32p05"
        }
    ]
];
const $8f2b0b47dafdf586$export$2e2bcd8739ae039 = (0, $764ec6f19a629312$export$2e2bcd8739ae039)("triangle-alert", $8f2b0b47dafdf586$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $21c0b4c3fc3b1107$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "M12 5v14",
            key: "s699le"
        }
    ]
];
const $21c0b4c3fc3b1107$export$2e2bcd8739ae039 = (0, $764ec6f19a629312$export$2e2bcd8739ae039)("plus", $21c0b4c3fc3b1107$export$3efd853dbb351e94);




const $2974cf74ad49e162$export$e6dfd72ab29f8598 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  flex-direction: column;
  gap: .8rem;
  margin: .8rem;
`;



const $7cc0a06bcf2a84f7$export$e6dfd72ab29f8598 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('label')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-block: .75em;

  ${(props)=>props.$fullWidth && `
    flex-direction: column;
    gap: .2em;
    align-items: flex-start;

    select, input {
      width: 100%;
    }
  `}
`;
const $7cc0a06bcf2a84f7$export$393edc798c47379d = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('span')`
  display: block;
  font-size: .75em;
  opacity: .5;
`;



var $h2ArV = parcelRequire("h2ArV");


const $07c16c411dfdf516$export$e6dfd72ab29f8598 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  flex-direction: column;
  gap: .8rem;
  margin: .8rem;
`;
const $07c16c411dfdf516$export$9e2d3073c028f69a = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: .4em;
`;
const $07c16c411dfdf516$export$9d58cd99b2891644 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('code')`
  background: var(--toolbar);
  display: block;
  border-end-end-radius: .3em;
  border-end-start-radius: .3em;
  box-sizing: border-box;
  padding: .5rem .7rem;

  pre {
    margin: 0;
  }
`;
const $07c16c411dfdf516$export$bb965054011846aa = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;

  & input {
    flex: 1;
  }

  & button {
    max-width: 0;
    padding: 0;
    margin-left: 0;
  }
  &:focus-within button {
    max-width: 4em;
    padding: 0 .5em;
    margin-left: .2em;
  }
`;
const $07c16c411dfdf516$export$4e9d5ce1e6c22a94 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('button')`
  background: none;
  border: 0;
  appearance: none;
  color: inherit;
  font: inherit;
  padding: 0;
  margin: 0;
  display: block;
  cursor: pointer;
  overflow: hidden;
  transition: max-width .15s, padding .15s, margin-left .15s;
`;
const $07c16c411dfdf516$export$b131c49b26d3f427 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: .8em;
  color: var(--error);

  ${(props)=>props.$accepted && `
    color: var(--success);
  `}
`;
const $07c16c411dfdf516$export$faadb9d3691bb990 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  margin: .8rem;
  border-radius: .3rem;
  padding: .5em;
  gap: .5em;
  align-items: center;
  background: var(--error);
`;


const $ca2884de04f532f3$export$fb20829f6af70575 = (name, detail)=>{
    document.dispatchEvent(new CustomEvent(name, {
        detail: detail
    }));
};



const $d1ca26ed0feeda99$export$b1376a1346f30465 = (setTemplate, setTool)=>{
    setTemplate(null);
    setTool('cursor');
};
const $d1ca26ed0feeda99$var$Templates = ()=>{
    const project = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project);
    const templates = (0, $05b6df1ad576ef23$export$2e2bcd8739ae039)((s)=>s.templates).filter((temp)=>temp.projectType === project.projectType);
    const addTemplate = (0, $05b6df1ad576ef23$export$2e2bcd8739ae039)((s)=>s.upsertTemplate);
    const setTemplate = (0, $f8e54bb3e6739765$export$2e2bcd8739ae039)((s)=>s.setTemplate);
    const template = (0, $f8e54bb3e6739765$export$2e2bcd8739ae039)((s)=>s.template);
    const selectedStatesIds = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.selectedStates);
    const selectedCommentsIds = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.selectedComments);
    const selectedTransitionsIds = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.selectedTransitions);
    const setTool = (0, $9ea7efd115f178cf$export$2e2bcd8739ae039)((s)=>s.setTool);
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)('common');
    const thumbs = (0, $3954b8dde947d829$export$2e2bcd8739ae039)((s)=>s.thumbnails);
    const theme = (0, $8af1fe532609b934$export$2e2bcd8739ae039)((state)=>state.getTheme());
    const getThumbTheme = (0, $h2ArV.useCallback)((id)=>{
        const thumbTheme = theme === 'dark' ? '-dark' : '';
        return `tmp${id}${thumbTheme}`;
    }, [
        theme
    ]);
    const [templateNameInput, setTemplateNameInput] = (0, $h2ArV.useState)('');
    const [error, setError] = (0, $h2ArV.useState)('');
    const pickTemplate = (id)=>{
        // Deselect if template already selected
        if (template !== null && template._id === id) {
            $d1ca26ed0feeda99$export$b1376a1346f30465(setTemplate, setTool);
            return;
        }
        // If template isn't yet selected, select it
        setTemplate(templates.find((template)=>template._id === id));
        setTool(null);
    };
    const createTemplate = (0, $h2ArV.useCallback)(()=>{
        const templateName = templateNameInput;
        // Show errors
        if (selectedStatesIds.length < 1) {
            setError(t('templates.error_no_state'));
            return;
        }
        if (selectedTransitionsIds.length > 0) {
            const { transitions: transitions } = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039).getState()?.project ?? {
                transitions: []
            };
            const selectedTransitions = transitions.filter((t)=>selectedTransitionsIds.includes(t.id));
            if (!selectedTransitions.every((t)=>selectedStatesIds.includes(t.from) && selectedStatesIds.includes(t.to))) {
                setError(t('templates.error_transition'));
                return;
            }
        }
        if (templateName === '') {
            setError(t('templates.error_no_name'));
            return;
        }
        if (templates.map((temp)=>temp.name).includes(templateName)) {
            setError(t('templates.error_dupe_name', {
                name: templateName
            }));
            return;
        }
        const temp = (0, $b9bf89f7d3b36cd8$export$72f7477d09e262ce)(selectedStatesIds, selectedCommentsIds, selectedTransitionsIds, project);
        const newTemplate = temp;
        // Set template attributes
        newTemplate._id = crypto.randomUUID();
        newTemplate.name = templateName;
        newTemplate.date = new Date().getTime();
        (0, $ca2884de04f532f3$export$fb20829f6af70575)('createTemplateThumbnail', newTemplate._id);
        addTemplate(newTemplate);
        setTemplateNameInput('');
        setError('');
    }, [
        selectedTransitionsIds,
        selectedStatesIds,
        selectedCommentsIds,
        templateNameInput,
        templates
    ]);
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $f6c0a8acd60d8875$export$2e2bcd8739ae039), {
                children: t('templates.create')
            }),
            error !== '' && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $d15f6e8ca8604f1a$exports.Fragment), {
                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $07c16c411dfdf516$export$faadb9d3691bb990), {
                    children: [
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $8f2b0b47dafdf586$export$2e2bcd8739ae039), {}),
                        error
                    ]
                })
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $2974cf74ad49e162$export$e6dfd72ab29f8598), {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                        onChange: (e)=>{
                            setTemplateNameInput(e.target.value);
                            setError('');
                        },
                        value: templateNameInput,
                        placeholder: t('templates.name')
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $21c0b4c3fc3b1107$export$2e2bcd8739ae039), {}),
                        onClick: createTemplate,
                        children: t('templates.add')
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $7cc0a06bcf2a84f7$export$393edc798c47379d), {
                        children: t('templates.description')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $f6c0a8acd60d8875$export$2e2bcd8739ae039), {
                children: t('templates.insert')
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $2974cf74ad49e162$export$e6dfd72ab29f8598), {
                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ca969eaeccef5bfe$export$2e2bcd8739ae039), {
                    title: "",
                    style: {
                        gap: '1em 1em'
                    },
                    children: templates.sort((a, b)=>b.date - a.date).map((temp)=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $eb202bee839f342f$export$2e2bcd8739ae039), {
                            name: temp.name,
                            date: (0, (/*@__PURE__*/$parcel$interopDefault($de07f2c205919029$exports)))(temp.date),
                            width: (0, $1812551efebcf5e5$export$75f78b310dfa0458),
                            image: thumbs[getThumbTheme(temp._id)],
                            $istemplate: true,
                            $deleteTemplate: (e)=>{
                                e.stopPropagation();
                                (0, $ca2884de04f532f3$export$fb20829f6af70575)('modal:editorConfirmation', {
                                    title: t('templates.delete'),
                                    description: t('templates.delete_desc', {
                                        name: temp.name
                                    }),
                                    tid: temp._id
                                });
                            },
                            isSelectedTemplate: template && template._id === temp._id,
                            onClick: ()=>pickTemplate(temp._id)
                        }, temp._id))
                })
            })
        ]
    });
};
var $d1ca26ed0feeda99$export$2e2bcd8739ae039 = $d1ca26ed0feeda99$var$Templates;




var $h2ArV = parcelRequire("h2ArV");




const $919cfef8d63aa373$export$c688898c4e3580ee = ()=>{
    const [isOpen, setIsOpen] = (0, $h2ArV.useState)(false);
    const [message, setMessage] = (0, $h2ArV.useState)('');
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)('common');
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('showWarning', (e)=>{
        setMessage(e.detail);
        setIsOpen(true);
    });
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $a5fe3119a76402fb$export$2e2bcd8739ae039), {
        title: t('warning'),
        isOpen: isOpen,
        onClose: ()=>{
            setIsOpen(false);
        },
        role: "alertdialog" // Prevents closing by clicking away
        ,
        actions: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
            onClick: ()=>setIsOpen(false),
            children: t('ok')
        }),
        description: message
    });
};
function $919cfef8d63aa373$export$da2f4e8190fdb5e1(msg) {
    (0, $ca2884de04f532f3$export$fb20829f6af70575)('showWarning', msg);
}


const $e50e5255b7875dbd$export$be7376dc5870de68 = 15;
const $e50e5255b7875dbd$export$f3b760e2f1d2445a = 15;
const $e50e5255b7875dbd$export$dd4614b42b3873f0 = 3;
const $e50e5255b7875dbd$export$2768ada4b712324b = 0.2;
const $e50e5255b7875dbd$export$724cbe3218b353a0 = 0.008;
const $e50e5255b7875dbd$export$7399f3984de375b0 = 'copyData';




const $ca3c15cc6dee748a$export$612e6723d69a3e6c = (e)=>[
        'input',
        'textarea',
        'select'
    ].includes(e.target.tagName.toLowerCase());





const $b9bf89f7d3b36cd8$var$isWindows = /Win/.test(navigator.platform);
const $b9bf89f7d3b36cd8$export$35d311008374d47b = (hotkey)=>[
        hotkey.meta && ($b9bf89f7d3b36cd8$var$isWindows ? $b9bf89f7d3b36cd8$var$isWindows ? 'Ctrl' : "\u2303" : "\u2318"),
        hotkey.alt && ($b9bf89f7d3b36cd8$var$isWindows ? 'Alt' : "\u2325"),
        hotkey.shift && ($b9bf89f7d3b36cd8$var$isWindows ? 'Shift' : "\u21E7"),
        hotkey.key === 'Escape' ? 'ESC' : hotkey.key?.toUpperCase()
    ].filter(Boolean).join($b9bf89f7d3b36cd8$var$isWindows ? '+' : "\u2009");
const $b9bf89f7d3b36cd8$export$e14a6f5d6f915b6b = ()=>{
    // Get state
    const view = (0, $2c8de4ab9c0d9b91$export$2e2bcd8739ae039).getState();
    // Margin around view
    const border = 40;
    // Get the bounding box of the SVG group
    const b = document.querySelector('#automatarium-graph > g').getBBox();
    // Bail if the bounding box is too small
    if (Math.max(Math.abs(b.width), Math.abs(b.height)) < border) return;
    const [x, y, width, height] = [
        b.x - border,
        b.y - border,
        b.width + border * 2,
        b.height + border * 2
    ];
    // Calculate fit region
    const desiredScale = Math.max(width / view.size.width, height / view.size.height);
    // Calculate x and y to centre graph
    return {
        scale: desiredScale,
        x: x + (width - view.size.width * desiredScale) / 2,
        y: y + (height - view.size.height * desiredScale) / 2
    };
};
const $b9bf89f7d3b36cd8$var$useActions = (registerHotkeys = false)=>{
    const undo = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.undo);
    const redo = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.redo);
    const selectNone = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.selectNone);
    const selectAll = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.selectAll);
    const selectedStatesIds = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.selectedStates);
    const selectedCommentsIds = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.selectedComments);
    const selectedTransitionsIds = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.selectedTransitions);
    const selectStates = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.setStates);
    const selectTransitions = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.setTransitions);
    const selectComments = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.setComments);
    const setStateInitial = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.setStateInitial);
    const toggleStatesFinal = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.toggleStatesFinal);
    const flipTransitions = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.flipTransitions);
    const removeStates = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.removeStates);
    const removeComments = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.removeComments);
    const removeTransitions = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.removeTransitions);
    const commit = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.commit);
    const setProject = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.set);
    const setLastSaveDate = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.setLastSaveDate);
    const upsertProject = (0, $a882b4a4b7f1e12c$export$2e2bcd8739ae039)((s)=>s.upsertProject);
    const moveView = (0, $2c8de4ab9c0d9b91$export$2e2bcd8739ae039)((s)=>s.moveViewPosition);
    const createState = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.createState);
    const screenToViewSpace = (0, $2c8de4ab9c0d9b91$export$2e2bcd8739ae039)((s)=>s.screenToViewSpace);
    const setTool = (0, $9ea7efd115f178cf$export$2e2bcd8739ae039)((s)=>s.setTool);
    const project = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project);
    const insertGroup = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.insertGroup);
    const updateGraph = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.updateGraph);
    const projectType = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project.config.type);
    const setViewPositionAndScale = (0, $2c8de4ab9c0d9b91$export$2e2bcd8739ae039)((s)=>s.setViewPositionAndScale);
    const template = (0, $f8e54bb3e6739765$export$2e2bcd8739ae039)((s)=>s.template);
    const setTemplate = (0, $f8e54bb3e6739765$export$2e2bcd8739ae039)((s)=>s.setTemplate);
    const deleteTemplate = (0, $05b6df1ad576ef23$export$2e2bcd8739ae039)((s)=>s.deleteTemplate);
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)('common');
    const navigate = (0, $4b112c041340d9ed$export$9770f232ac06a008)();
    const nothingSelected = selectedCommentsIds.length === 0 && selectedStatesIds.length === 0 && selectedTransitionsIds.length === 0;
    // TODO: memoize
    const actions = {
        NEW_FILE: {
            handler: ()=>navigate('/new')
        },
        IMPORT_AUTOMATARIUM_PROJECT: {
            hotkeys: [
                {
                    key: 'i',
                    meta: true
                }
            ],
            handler: async ()=>{
                if (window.confirm(t('use_actions.import_warning'))) $b9bf89f7d3b36cd8$export$9ff57f529c25dc9f(t, setProject, t('use_actions.failed_automatarium'), '.json');
            }
        },
        IMPORT_JFLAP_PROJECT: {
            hotkeys: [
                {
                    key: 'i',
                    meta: true,
                    shift: true
                }
            ],
            handler: async ()=>{
                if (window.confirm(t('use_actions.import_warning'))) $b9bf89f7d3b36cd8$export$9ff57f529c25dc9f(t, setProject, t('use_actions.failed_jflap'), '.jff');
            }
        },
        IMPORT_DIALOG: {
            handler: async ()=>{
                if (window.confirm(t('use_actions.import_warning'))) (0, $ca2884de04f532f3$export$fb20829f6af70575)('modal:import', null);
            }
        },
        IMPORT_MODULE: {
            handler: async ()=>{
                if (window.confirm(t('use_actions.import_warning'))) (0, $ca2884de04f532f3$export$fb20829f6af70575)('modal:importModule', null);
            }
        },
        SAVE_FILE: {
            hotkeys: [
                {
                    key: 's',
                    meta: true
                }
            ],
            handler: ()=>{
                const project = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039).getState().project;
                const toSave = {
                    ...project,
                    meta: {
                        ...project.meta,
                        dateEdited: new Date().getTime()
                    }
                };
                upsertProject(toSave);
                setLastSaveDate(new Date().getTime());
            }
        },
        SAVE_FILE_AS: {
            hotkeys: [
                {
                    key: 's',
                    shift: true,
                    meta: true
                }
            ],
            handler: ()=>{
                // Pull project state
                const project = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039).getState().project;
                // Create a download link and use it
                const a = document.createElement('a');
                const file = new Blob([
                    JSON.stringify(project, null, 2)
                ], {
                    type: 'application/json'
                });
                a.href = URL.createObjectURL(file);
                // File extension explicitly added to allow for file names with dots
                a.download = project.meta.name.replace(/[#%&{}\\<>*?/$!'":@+`|=]/g, '') + '.json';
                a.click();
            }
        },
        ENCODE_FILE: {
            handler: ()=>(0, $ca2884de04f532f3$export$fb20829f6af70575)('showSharing', null)
        },
        EXPORT: {
            hotkeys: [
                {
                    key: 'e',
                    meta: true
                }
            ],
            handler: ()=>(0, $ca2884de04f532f3$export$fb20829f6af70575)('exportImage', null)
        },
        EXPORT_AS_PNG: {
            hotkeys: [
                {
                    key: 'e',
                    shift: true,
                    meta: true
                }
            ],
            handler: ()=>(0, $ca2884de04f532f3$export$fb20829f6af70575)('exportImage', {
                    type: 'png'
                })
        },
        EXPORT_AS_SVG: {
            hotkeys: [
                {
                    key: 'e',
                    shift: true,
                    alt: true,
                    meta: true
                }
            ],
            handler: ()=>(0, $ca2884de04f532f3$export$fb20829f6af70575)('exportImage', {
                    type: 'svg'
                })
        },
        EXPORT_TO_CLIPBOARD: {
            hotkeys: [
                {
                    key: 'c',
                    shift: true,
                    meta: true
                }
            ],
            handler: ()=>(0, $ca2884de04f532f3$export$fb20829f6af70575)('exportImage', {
                    type: 'png',
                    clipboard: true
                })
        },
        EXPORT_AS_JFLAP: {
            hotkeys: [
                {
                    key: 's',
                    shift: true,
                    alt: true,
                    meta: true
                }
            ],
            handler: ()=>{
                // Pull project state
                const project = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039).getState().project;
                // Create a download link and use it
                const a = document.createElement('a');
                // Convert current project to JFLAP format
                const jflapFile = new Blob([
                    (0, $08714987d1077153$export$c8b8433b2785e02d)(project)
                ]);
                a.href = URL.createObjectURL(jflapFile);
                // File extension explicitly added to allow for file names with dots
                a.download = project.meta.name.replace(/[#%&{}\\<>*?/$!'":@+`|=]/g, '') + '.jff';
                a.click();
            }
        },
        OPEN_PREFERENCES: {
            hotkeys: [
                {
                    key: ',',
                    meta: true
                }
            ],
            handler: ()=>(0, $ca2884de04f532f3$export$fb20829f6af70575)('modal:preferences', null)
        },
        UNDO: {
            hotkeys: [
                {
                    key: 'z',
                    meta: true
                }
            ],
            handler: undo
        },
        REDO: {
            hotkeys: [
                {
                    key: 'y',
                    meta: true
                }
            ],
            handler: redo
        },
        COPY: {
            hotkeys: [
                {
                    key: 'c',
                    meta: true
                }
            ],
            handler: ()=>{
                // This will use the CopyData type defined in ProjectTypes
                const copyData = $b9bf89f7d3b36cd8$export$72f7477d09e262ce(selectedStatesIds, selectedCommentsIds, selectedTransitionsIds, project);
                localStorage.setItem((0, $e50e5255b7875dbd$export$7399f3984de375b0), JSON.stringify(copyData));
            }
        },
        PASTE: {
            hotkeys: [
                {
                    key: 'v',
                    meta: true
                }
            ],
            handler: ()=>{
                const pasteData = JSON.parse(localStorage.getItem((0, $e50e5255b7875dbd$export$7399f3984de375b0)));
                if (pasteData === null) // Copy has not been executed
                return;
                const insertResponse = insertGroup(pasteData);
                if (insertResponse.type === (0, $920b9ecb34a1fb18$export$7eda682a4373126).SUCCESS) {
                    selectComments(insertResponse.body.comments.map((comment)=>comment.id));
                    selectStates(insertResponse.body.states.map((state)=>state.id));
                    selectTransitions(insertResponse.body.transitions.map((transition)=>transition.id));
                    commit();
                } else if (insertResponse.type === (0, $920b9ecb34a1fb18$export$7eda682a4373126).FAIL) alert(insertResponse.body);
            }
        },
        SELECT_ALL: {
            hotkeys: [
                {
                    key: 'a',
                    meta: true
                }
            ],
            handler: selectAll
        },
        SELECT_NONE: {
            hotkeys: [
                {
                    key: 'Escape'
                }
            ],
            handler: selectNone
        },
        DELETE: {
            hotkeys: [
                {
                    key: 'Delete'
                },
                {
                    key: 'Backspace'
                }
            ],
            handler: ()=>{
                // If a template is selected and nothing else is, delete the template
                if (template !== null && nothingSelected) {
                    if (window.confirm(t('use_actions.delete_template_warning', {
                        name: template.name
                    }))) {
                        deleteTemplate(template._id);
                        (0, $d1ca26ed0feeda99$export$b1376a1346f30465)(setTemplate, setTool);
                    }
                } else if (!nothingSelected) {
                    // Otherwise, delete selection
                    removeStates(selectedStatesIds);
                    removeTransitions(selectedTransitionsIds);
                    removeComments(selectedCommentsIds);
                    selectNone();
                    commit();
                    (0, $ca2884de04f532f3$export$fb20829f6af70575)('ctx:close', null);
                }
            }
        },
        DELETE_EDGE: {
            disabled: ()=>(0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039).getState()?.selectedTransitions?.length === 0,
            handler: ()=>{
                const allTransitionIdsOnEdge = (0, $d782d8e92e006c64$export$2e2bcd8739ae039)().getTransitionsFromContext().map((t)=>t.id);
                removeTransitions(allTransitionIdsOnEdge);
                selectNone();
                commit();
            }
        },
        ZOOM_IN: {
            hotkeys: [
                {
                    key: '=',
                    meta: true
                }
            ],
            handler: ()=>$b9bf89f7d3b36cd8$var$zoomViewTo((0, $2c8de4ab9c0d9b91$export$2e2bcd8739ae039).getState().scale - 0.1)
        },
        ZOOM_OUT: {
            hotkeys: [
                {
                    key: '-',
                    meta: true
                }
            ],
            handler: ()=>$b9bf89f7d3b36cd8$var$zoomViewTo((0, $2c8de4ab9c0d9b91$export$2e2bcd8739ae039).getState().scale + 0.1)
        },
        ZOOM_100: {
            hotkeys: [
                {
                    key: '0',
                    meta: true
                }
            ],
            handler: ()=>{
                $b9bf89f7d3b36cd8$var$zoomViewTo(1);
            }
        },
        ZOOM_FIT: {
            hotkeys: [
                {
                    key: 'f',
                    shift: true
                }
            ],
            handler: ()=>{
                const values = $b9bf89f7d3b36cd8$export$e14a6f5d6f915b6b();
                if (values) setViewPositionAndScale({
                    x: values.x,
                    y: values.y
                }, values.scale);
            }
        },
        FULLSCREEN: {
            handler: ()=>document.fullscreenElement ? document.exitFullscreen() : document.documentElement.requestFullscreen()
        },
        TESTING_LAB: {
            hotkeys: [
                {
                    key: '1',
                    shift: true
                }
            ],
            handler: ()=>(0, $ca2884de04f532f3$export$fb20829f6af70575)('sidepanel:open', {
                    panel: 'test'
                })
        },
        /*
    STEPPING_LAB: {
      hotkeys: [{ key: '2', shift: true }],
      handler: () => dispatchCustomEvent('sidepanel:open', { panel: 'step' })
    },
    */ FILE_INFO: {
            hotkeys: [
                {
                    key: '2',
                    shift: true
                }
            ],
            handler: ()=>(0, $ca2884de04f532f3$export$fb20829f6af70575)('sidepanel:open', {
                    panel: 'about'
                })
        },
        FILE_OPTIONS: {
            hotkeys: [
                {
                    key: '3',
                    shift: true
                }
            ],
            handler: ()=>(0, $ca2884de04f532f3$export$fb20829f6af70575)('sidepanel:open', {
                    panel: 'options'
                })
        },
        TEMPLATES: {
            hotkeys: [
                {
                    key: '4',
                    shift: true
                }
            ],
            handler: ()=>(0, $ca2884de04f532f3$export$fb20829f6af70575)('sidepanel:open', {
                    panel: 'templates'
                })
        },
        MODULES: {
            hotkeys: [
                {
                    key: '5',
                    shift: true
                }
            ],
            handler: ()=>(0, $ca2884de04f532f3$export$fb20829f6af70575)('sidepanel:open', {
                    panel: 'modules'
                })
        },
        CONVERT_TO_DFA: {
            disabled: ()=>projectType !== 'FSA' || project.initialState === null,
            handler: ()=>{
                const dfa = (0, $f14ade203442b518$export$caf057dff8f8c051)(project);
                updateGraph((0, $31e4fa2b24ff8a97$export$2e2bcd8739ae039)(dfa));
                commit();
            }
        },
        AUTO_LAYOUT: {
            disabled: ()=>true,
            handler: ()=>{
                updateGraph((0, $31e4fa2b24ff8a97$export$2e2bcd8739ae039)(project));
                commit();
            }
        },
        // start tour action - sets the start tour handler to true
        START_TOUR: {
            handler: ()=>(0, $ca2884de04f532f3$export$fb20829f6af70575)('tour:start', null)
        },
        OPEN_DOCS: {
            handler: ()=>window.open('https://github.com/automatarium/automatarium/wiki', '_blank')
        },
        TUTORIAL_VIDEOS: {
            handler: ()=>window.open('/tutorials', '_blank')
        },
        KEYBOARD_SHORTCUTS: {
            hotkeys: [
                {
                    key: '/',
                    meta: true
                }
            ],
            handler: ()=>(0, $ca2884de04f532f3$export$fb20829f6af70575)('modal:shortcuts', null)
        },
        PRIVACY_POLICY: {
            handler: ()=>window.open('/privacy', '_blank')
        },
        OPEN_ABOUT: {
            handler: ()=>window.open('/about', '_blank')
        },
        MOVE_VIEW_LEFT: {
            hotkeys: [
                {
                    key: 'ArrowLeft'
                }
            ],
            handler: ()=>moveView({
                    x: -(0, $e50e5255b7875dbd$export$f3b760e2f1d2445a)
                })
        },
        MOVE_VIEW_RIGHT: {
            hotkeys: [
                {
                    key: 'ArrowRight'
                }
            ],
            handler: ()=>moveView({
                    x: (0, $e50e5255b7875dbd$export$f3b760e2f1d2445a)
                })
        },
        MOVE_VIEW_UP: {
            hotkeys: [
                {
                    key: 'ArrowUp'
                }
            ],
            handler: ()=>moveView({
                    y: -(0, $e50e5255b7875dbd$export$f3b760e2f1d2445a)
                })
        },
        MOVE_VIEW_DOWN: {
            hotkeys: [
                {
                    key: 'ArrowDown'
                }
            ],
            handler: ()=>moveView({
                    y: (0, $e50e5255b7875dbd$export$f3b760e2f1d2445a)
                })
        },
        SET_STATE_INITIAL: {
            disabled: ()=>(0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039).getState()?.selectedStates?.length !== 1,
            handler: ()=>{
                const selectedState = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039).getState().selectedStates?.[0];
                if (selectedState !== undefined) {
                    setStateInitial(selectedState);
                    commit();
                }
            }
        },
        TOGGLE_STATES_FINAL: {
            disabled: ()=>(0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039).getState()?.selectedStates?.length === 0,
            handler: ()=>{
                if (project.projectType === 'TM') {
                    // Show popup until confirmed
                    const showFinalState = (0, $87c0b991aa949aa0$export$2e2bcd8739ae039).getState().popups?.showFinalState;
                    if (showFinalState) (0, $ca2884de04f532f3$export$fb20829f6af70575)('modal:finalstate', null);
                }
                const selectedStateIDs = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039).getState().selectedStates;
                if (selectedStateIDs.length > 0) {
                    toggleStatesFinal(selectedStateIDs);
                    commit();
                }
            }
        },
        EDIT_COMMENT: {
            disabled: ()=>(0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039).getState()?.selectedComments?.length !== 1,
            handler: (e)=>{
                const selectedCommentID = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039).getState().selectedComments?.[0];
                if (selectedCommentID === undefined) return;
                window.setTimeout(()=>(0, $ca2884de04f532f3$export$fb20829f6af70575)('editComment', {
                        x: e.clientX,
                        y: e.clientY,
                        id: selectedCommentID
                    }), 100);
            }
        },
        EDIT_TRANSITION: {
            disabled: ()=>(0, $992c0f2e4bd5c228$export$2e2bcd8739ae039).getState()?.context === null,
            handler: ()=>{
                const selectedTransition = (0, $d782d8e92e006c64$export$2e2bcd8739ae039)().getTransitionFromContext();
                if (selectedTransition === undefined) return;
                window.setTimeout(()=>(0, $ca2884de04f532f3$export$fb20829f6af70575)('editTransition', {
                        id: selectedTransition.id,
                        new: false
                    }), 100);
            }
        },
        EDIT_FIRST: {
            disabled: ()=>(0, $992c0f2e4bd5c228$export$2e2bcd8739ae039).getState()?.context === null,
            handler: ()=>{
                const selectedTransition = (0, $d782d8e92e006c64$export$2e2bcd8739ae039)().getTransitionsFromContext()[0];
                if (selectedTransition === undefined) return;
                window.setTimeout(()=>(0, $ca2884de04f532f3$export$fb20829f6af70575)('editTransition', {
                        id: selectedTransition.id,
                        new: false
                    }), 100);
            }
        },
        EDIT_TRANSITIONS_GROUP: {
            disabled: ()=>(0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039).getState()?.selectedTransitions?.length === 0,
            handler: ()=>{
                const ctx = (0, $992c0f2e4bd5c228$export$2e2bcd8739ae039).getState().context;
                if (ctx === null) return;
                window.setTimeout(()=>(0, $ca2884de04f532f3$export$fb20829f6af70575)('editTransitionGroup', {
                        ctx: ctx
                    }), 100);
                (0, $992c0f2e4bd5c228$export$2e2bcd8739ae039).getState().clearContext();
            }
        },
        FLIP_TRANSITION: {
            handler: ()=>{
                const selectedTransitions = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039).getState().selectedTransitions;
                if (selectedTransitions === undefined || selectedTransitions?.length === 0) return;
                flipTransitions(selectedTransitions);
                commit();
            }
        },
        FLIP_EDGE: {
            disabled: ()=>(0, $992c0f2e4bd5c228$export$2e2bcd8739ae039).getState()?.context === null,
            handler: ()=>{
                const scope = (0, $d782d8e92e006c64$export$2e2bcd8739ae039)().getTransitionsFromContext();
                flipTransitions(scope.map((t)=>t.id));
                commit();
            }
        },
        CREATE_COMMENT: {
            handler: (e)=>window.setTimeout(()=>(0, $ca2884de04f532f3$export$fb20829f6af70575)('editComment', {
                        x: e.clientX,
                        y: e.clientY
                    }), 100)
        },
        SET_STATE_NAME: {
            handler: ()=>{
                const selectedStateID = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039).getState().selectedStates?.[0];
                if (selectedStateID === undefined) return;
                window.setTimeout(()=>(0, $ca2884de04f532f3$export$fb20829f6af70575)('editStateName', {
                        id: selectedStateID
                    }), 100);
            }
        },
        SET_STATE_LABEL: {
            handler: ()=>{
                const selectedStateID = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039).getState().selectedStates?.[0];
                if (selectedStateID === undefined) return;
                window.setTimeout(()=>(0, $ca2884de04f532f3$export$fb20829f6af70575)('editStateLabel', {
                        id: selectedStateID
                    }), 100);
            }
        },
        CREATE_STATE: {
            handler: (e)=>{
                const [viewX, viewY] = screenToViewSpace(e.clientX, e.clientY);
                createState({
                    x: viewX,
                    y: viewY
                });
                commit();
            }
        },
        ALIGN_STATES_HORIZONTAL: {
            disabled: ()=>(0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039).getState()?.selectedStates?.length <= 1,
            handler: ()=>{
                const selected = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039).getState().selectedStates;
                const storeState = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039).getState();
                const states = storeState?.project?.states?.filter((s)=>selected.includes(s.id));
                if (states && states.length > 1) {
                    const meanY = states.map((state)=>state.y).reduce((a, b)=>a + b) / states.length;
                    storeState.updateStates(states.map((state)=>({
                            ...state,
                            y: meanY
                        })));
                    commit();
                }
            }
        },
        ALIGN_STATES_VERTICAL: {
            disabled: ()=>(0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039).getState()?.selectedStates?.length <= 1,
            handler: ()=>{
                const selected = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039).getState().selectedStates;
                const storeState = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039).getState();
                const states = storeState?.project?.states?.filter((s)=>selected.includes(s.id));
                if (states && states.length > 1) {
                    const meanX = states.map((state)=>state.x).reduce((a, b)=>a + b) / states.length;
                    storeState.updateStates(states.map((state)=>({
                            ...state,
                            x: meanX
                        })));
                    commit();
                }
            }
        },
        TOOL_CURSOR: {
            hotkeys: [
                {
                    key: 'V'
                }
            ],
            handler: ()=>setTool('cursor')
        },
        TOOL_HAND: {
            hotkeys: [
                {
                    key: 'H'
                }
            ],
            handler: ()=>setTool('hand')
        },
        TOOL_STATE: {
            hotkeys: [
                {
                    key: 'S'
                }
            ],
            handler: ()=>setTool('state')
        },
        TOOL_TRANSITION: {
            hotkeys: [
                {
                    key: 'T'
                }
            ],
            handler: ()=>setTool('transition')
        },
        TOOL_COMMENT: {
            hotkeys: [
                {
                    key: 'C'
                }
            ],
            handler: ()=>setTool('comment')
        },
        TOOL_DELETE: {
            hotkeys: [
                {
                    key: 'D'
                }
            ],
            handler: ()=>{
                setTool('delete');
            }
        },
        REORDER_GRAPH: {
            disabled: ()=>project.initialState === null,
            handler: ()=>{
                updateGraph((0, $c99e67a30febca32$export$d64d2ed55a3dc29e)(project));
                commit();
            }
        },
        DELETE_PROJECT: {
            handler: ()=>(0, $ca2884de04f532f3$export$fb20829f6af70575)('modal:deleteConfirm', null)
        }
    };
    // Register action hotkeys
    (0, $h2ArV.useEffect)(()=>{
        if (registerHotkeys) {
            const handleKeyDown = (e)=>{
                // Hotkeys are disabled if an input is focused
                if ((0, $ca3c15cc6dee748a$export$612e6723d69a3e6c)(e)) return;
                // Check hotkeys
                for (const action of Object.values(actions)){
                    // Skip if no hotkey
                    if (!action.hotkeys) continue;
                    // Skip if disabled
                    if (action.disabled && action.disabled()) continue;
                    const hotkeys = action.hotkeys;
                    const activeHotkey = hotkeys.find((hotkey)=>{
                        // Guard against other keys
                        const letterMatch = e.code === `Key${hotkey.key.toUpperCase()}`;
                        const digitMatch = e.code === `Digit${hotkey.key}`;
                        const keyMatch = e.key === hotkey.key;
                        if (!(letterMatch || digitMatch || keyMatch)) return false;
                        // Check augmenting keys
                        // The !! is to force the type to be a boolean so that the equality check passess correctly
                        // i.e. Without it, if meta is undefined then it wont equal false
                        if (!!hotkey.meta !== (e.metaKey || e.ctrlKey)) return false;
                        if (!!hotkey.alt !== e.altKey) return false;
                        return !!hotkey.shift === e.shiftKey;
                    });
                    // Prevent default and exec callback
                    if (activeHotkey) {
                        e.preventDefault();
                        e.stopPropagation();
                        action.handler(e);
                        break;
                    }
                }
            };
            // Add listener
            document.addEventListener('keydown', handleKeyDown);
            return ()=>document.removeEventListener('keydown', handleKeyDown);
        }
    }, [
        actions
    ]);
    // Add formatted hotkeys to actions
    return (0, $h2ArV.useMemo)(()=>Object.fromEntries(Object.entries(actions).map(([key, action])=>[
                key,
                {
                    ...action,
                    label: action.hotkeys ? $b9bf89f7d3b36cd8$export$35d311008374d47b(action.hotkeys[0]) : null
                }
            ])), [
        actions
    ]);
};
const $b9bf89f7d3b36cd8$var$zoomViewTo = (to)=>{
    const view = (0, $2c8de4ab9c0d9b91$export$2e2bcd8739ae039).getState();
    if (view.scale === to) return;
    const newScale = Math.min((0, $e50e5255b7875dbd$export$dd4614b42b3873f0), Math.max((0, $e50e5255b7875dbd$export$2768ada4b712324b), to));
    const scrollAmount = newScale - view.scale;
    if (Math.abs(scrollAmount) < 1e-3) view.setViewScale(to < 1 ? (0, $e50e5255b7875dbd$export$2768ada4b712324b) : (0, $e50e5255b7875dbd$export$dd4614b42b3873f0));
    else {
        view.setViewPosition({
            x: view.position.x - view.size.width / 2 * scrollAmount,
            y: view.position.y - view.size.height / 2 * scrollAmount
        });
        view.setViewScale(newScale);
    }
};
const $b9bf89f7d3b36cd8$export$defde9079da2a3d9 = (onData, errorMessage, input, onFinishLoading, onFailedLoading)=>{
    // Read file data
    const reader = new FileReader();
    reader.onloadend = ()=>{
        try {
            const parse = input.name.toLowerCase().endsWith('.jff') ? (0, $fc69c1d2a2a16816$export$3f7dcd42a14cc9f5) : JSON.parse;
            const fileData = parse(reader.result);
            const project = {
                ...(0, $920b9ecb34a1fb18$export$2d5adde7dc289012)(),
                ...fileData
            };
            onData({
                ...project,
                meta: {
                    ...project.meta,
                    name: project.meta.name || input?.name.split('.').slice(0, -1).join('.')
                }
            });
            onFinishLoading();
        } catch (error) {
            (0, $919cfef8d63aa373$export$da2f4e8190fdb5e1)(`${errorMessage}\n${error}`);
            console.error(error);
            onFailedLoading();
        }
    };
    reader.readAsText(input);
};
const $b9bf89f7d3b36cd8$export$9ff57f529c25dc9f = (t, onData, errorMessage = t('use_actions.failed_parse'), accept, onFinishLoading = ()=>null, onFailedLoading = ()=>null)=>{
    // Prompt user for file input
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = accept;
    input.onchange = ()=>{
        $b9bf89f7d3b36cd8$export$defde9079da2a3d9(onData, errorMessage, input.files[0], onFinishLoading, onFailedLoading);
    };
    input.click();
};
const $b9bf89f7d3b36cd8$export$8d2732495f7c216e = (url, t, onData, errorMessage = t('use_actions.failed_parse'), onFinishLoading = ()=>null, onFailedLoading = ()=>null)=>{
    // Check that the user didn't just pass in the URL that was given from Automatarium
    const urlTokens = url.split('/') ?? null;
    if (urlTokens[urlTokens.length - 3] === 'share' && urlTokens[urlTokens.length - 2] === 'raw') (0, $6a48311326306a05$export$13923bea59211b58)(urlTokens[urlTokens.length - 1]).then((data)=>{
        const asFile = new File([
            JSON.stringify(data)
        ], 'Shared Project');
        $b9bf89f7d3b36cd8$export$defde9079da2a3d9(onData, errorMessage, asFile, onFinishLoading, onFailedLoading);
    });
    else fetch(url).then(async (res)=>{
        const resUrlTokens = res.url.split('/');
        const endpointName = decodeURIComponent(resUrlTokens[resUrlTokens.length - 1]);
        // Give a default filename based on the received URL
        const asFile = new File([
            await res.blob()
        ], endpointName);
        $b9bf89f7d3b36cd8$export$defde9079da2a3d9(onData, errorMessage, asFile, onFinishLoading, onFailedLoading);
    }).catch((error)=>{
        (0, $919cfef8d63aa373$export$da2f4e8190fdb5e1)(t('use_actions.failed_url') + `\n${error}`);
        console.error(error);
        onFailedLoading();
    });
};
const $b9bf89f7d3b36cd8$export$72f7477d09e262ce = (stateIds, commentIds, transitionIds, project)=>{
    const selectedStates = project.states.filter((state)=>stateIds.includes(state.id));
    const selectedComments = project.comments.filter((comment)=>commentIds.includes(comment.id));
    const selectedTransitions = project.transitions.filter((transition)=>transitionIds.includes(transition.id));
    const isInitialSelected = stateIds.includes(project.initialState);
    return {
        states: selectedStates,
        comments: selectedComments,
        transitions: selectedTransitions,
        projectSource: project._id,
        projectType: project.projectType,
        initialStateId: isInitialSelected ? project.initialState : null
    };
};
const $b9bf89f7d3b36cd8$export$df1cc06fea500b46 = (onData, errorMessage, input, onFinishLoading, onFailedLoading)=>{
    // Read file data
    const reader = new FileReader();
    reader.onloadend = ()=>{
        try {
            const parse = JSON.parse;
            const fileData = parse(reader.result);
            const module = {
                ...(0, $be91e446fcb94886$export$e6f852ab53eb4018)(),
                ...fileData
            };
            onData({
                ...module,
                meta: {
                    ...module.meta,
                    name: module.meta.name || input?.name.split('.').slice(0, -1).join('.')
                }
            });
            onFinishLoading();
        } catch (error) {
            (0, $919cfef8d63aa373$export$da2f4e8190fdb5e1)(`${errorMessage}\n${error}`);
            console.error(error);
            onFailedLoading();
        }
    };
    reader.readAsText(input);
};
const $b9bf89f7d3b36cd8$export$96148661aa4398b8 = (t, onData, errorMessage = t('use_actions.failed_parse'), accept, onFinishLoading = ()=>null, onFailedLoading = ()=>null)=>{
    // Prompt user for file input
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = accept;
    input.onchange = ()=>{
        $b9bf89f7d3b36cd8$export$df1cc06fea500b46(onData, errorMessage, input.files[0], onFinishLoading, onFailedLoading);
    };
    input.click();
};
const $b9bf89f7d3b36cd8$export$beeb3b669a0e7af3 = ()=>{
    // Pull module state
    const project = (0, $be91e446fcb94886$export$2e2bcd8739ae039).getState().module;
    // Create a download link and use it
    const a = document.createElement('a');
    const file = new Blob([
        JSON.stringify(project, null, 2)
    ], {
        type: 'application/json'
    });
    a.href = URL.createObjectURL(file);
    // File extension explicitly added to allow for file names with dots
    a.download = project.meta.name.replace(/[#%&{}\\<>*?/$!'":@+`|=]/g, '') + '.json';
    a.click();
};
const $b9bf89f7d3b36cd8$export$e355f5f85b187bdc = (url, t, onData, errorMessage = t('use_actions.failed_parse'), onFinishLoading = ()=>null, onFailedLoading = ()=>null)=>{
    // Check that the user didn't just pass in the URL that was given from Automatarium
    const urlTokens = url.split('/') ?? null;
    if (urlTokens[urlTokens.length - 3] === 'share' && urlTokens[urlTokens.length - 2] === 'module') (0, $6a48311326306a05$export$13923bea59211b58)(urlTokens[urlTokens.length - 1]).then((data)=>{
        const asFile = new File([
            JSON.stringify(data)
        ], 'Shared Project');
        $b9bf89f7d3b36cd8$export$defde9079da2a3d9(onData, errorMessage, asFile, onFinishLoading, onFailedLoading);
    });
    else fetch(url).then(async (res)=>{
        const resUrlTokens = res.url.split('/');
        const endpointName = decodeURIComponent(resUrlTokens[resUrlTokens.length - 1]);
        // Give a default filename based on the received URL
        const asFile = new File([
            await res.blob()
        ], endpointName);
        $b9bf89f7d3b36cd8$export$defde9079da2a3d9(onData, errorMessage, asFile, onFinishLoading, onFailedLoading);
    }).catch((error)=>{
        (0, $919cfef8d63aa373$export$da2f4e8190fdb5e1)(t('use_actions.failed_url') + `\n${error}`);
        console.error(error);
        onFailedLoading();
    });
};
var $b9bf89f7d3b36cd8$export$2e2bcd8739ae039 = $b9bf89f7d3b36cd8$var$useActions;




// Store state of easter egg across site instance
const $1b50533b0f169454$var$useDibStore = (0, $7f648b6e3795e45a$exports.create)((set)=>({
        intervalID: undefined,
        setIntervalID: (id)=>set({
                intervalID: id
            })
    }));
// Smoothly change between all colours
const $1b50533b0f169454$var$smoothHue = ()=>{
    // Get current hue
    const currHue = Number(document.documentElement.style.getPropertyValue('--primary-h'));
    // Set colour to new hue
    document.documentElement.style.setProperty('--primary-h', ((currHue + 1) % 360).toString());
    document.documentElement.style.setProperty('--primary-s', '63%');
    document.documentElement.style.setProperty('--primary-l', '48%');
};
// Cycle between colours of the site preferences
const $1b50533b0f169454$var$hues = Object.values((0, $d59e810d2f517544$export$2e2bcd8739ae039));
const $1b50533b0f169454$var$rainbowRoadHue = ()=>{
    const currHue = Number(document.documentElement.style.getPropertyValue('--primary-h'));
    // Calculate which hue to begin at & which hue is next
    let hueIndex = $1b50533b0f169454$var$hues.findIndex((c)=>c.h === currHue);
    if (hueIndex === -1) hueIndex = 0;
    else hueIndex = (hueIndex + 1) % $1b50533b0f169454$var$hues.length;
    // Set colour
    document.documentElement.style.setProperty('--primary-h', $1b50533b0f169454$var$hues[hueIndex].h.toString());
    document.documentElement.style.setProperty('--primary-s', `${$1b50533b0f169454$var$hues[hueIndex].s}%`);
    document.documentElement.style.setProperty('--primary-l', `${$1b50533b0f169454$var$hues[hueIndex].l}%`);
};
const $1b50533b0f169454$var$useDibEgg = ()=>{
    const { intervalID: intervalID, setIntervalID: setIntervalID } = $1b50533b0f169454$var$useDibStore();
    return (input, accepted)=>{
        // If user types dib and automaton accepts
        if (input === 'dib' && accepted) {
            if (intervalID) {
                clearInterval(intervalID);
                setIntervalID(undefined);
            } else setIntervalID(setInterval($1b50533b0f169454$var$smoothHue, 200));
        } else if (input === 'rainbowroad' && accepted) {
            if (intervalID) {
                clearInterval(intervalID);
                setIntervalID(undefined);
            } else setIntervalID(setInterval($1b50533b0f169454$var$rainbowRoadHue, 300));
        }
    };
};
var $1b50533b0f169454$export$2e2bcd8739ae039 = $1b50533b0f169454$var$useDibEgg;


// You thought you could just *read* the egg 0_0 :D

var $h2ArV = parcelRequire("h2ArV");
// @ts-ignore
const $a5ca60f5343d1bf8$var$_0x1c6771 = $a5ca60f5343d1bf8$var$_0x536b;
(function(_0xafa8d7, _0x46a108) {
    const _0x3d8a38 = $a5ca60f5343d1bf8$var$_0x536b;
    const _0x5b943a = _0xafa8d7();
    while(true)try {
        const _0x1d5704 = -parseInt(_0x3d8a38(0x17e)) / 0x1 + parseInt(_0x3d8a38(0x195)) / 0x2 * (-parseInt(_0x3d8a38(0x181)) / 0x3) + -parseInt(_0x3d8a38(0x18e)) / 0x4 + parseInt(_0x3d8a38(0x194)) / 0x5 * (parseInt(_0x3d8a38(0x197)) / 0x6) + parseInt(_0x3d8a38(0x18d)) / 0x7 + -parseInt(_0x3d8a38(0x189)) / 0x8 * (-parseInt(_0x3d8a38(0x183)) / 0x9) + parseInt(_0x3d8a38(0x17d)) / 0xa * (-parseInt(_0x3d8a38(0x192)) / 0xb);
        if (_0x1d5704 === _0x46a108) break;
        else _0x5b943a.push(_0x5b943a.shift());
    } catch (_0x2568cb) {
        _0x5b943a.push(_0x5b943a.shift());
    }
})($a5ca60f5343d1bf8$var$_0x38a1, 0x7ed6c);
function $a5ca60f5343d1bf8$var$_0x38a1() {
    const _0x472965 = [
        '9LEEIeF',
        '35862wSSIQf',
        'alert',
        '939652BYApdI',
        'ArrowRight',
        'length',
        '568552QrLBPc',
        '4vRRrMo',
        'shift',
        'indexOf',
        '6387059wwqZlU',
        '38028HAOVms',
        '5184344wKziKC',
        '370464pThlrJ',
        'ArrowDown',
        '761717eXsIfM',
        'addEventListener',
        '2300bLStGb',
        '2OfTtfd',
        'push',
        '11100NjxUNR',
        '2180919HcSyHC',
        'ArrowUp',
        '70NgCiQY',
        '413275mFDKyZ',
        'key',
        'keyup',
        '1222389jgxKrI',
        '1116441QNdqkw'
    ];
    $a5ca60f5343d1bf8$var$_0x38a1 = function() {
        return _0x472965;
    };
    return $a5ca60f5343d1bf8$var$_0x38a1();
}
const $a5ca60f5343d1bf8$var$_0x26ab3f = $a5ca60f5343d1bf8$var$_0x1dbf;
function $a5ca60f5343d1bf8$var$_0x1dbf(_0x7a148, _0x1c27d6) {
    const _0x43dcf0 = $a5ca60f5343d1bf8$var$_0x1dfe();
    return $a5ca60f5343d1bf8$var$_0x1dbf = function(_0x1b1840, _0x16f9ae) {
        _0x1b1840 = _0x1b1840 - 0x1f1;
        const _0x413fb9 = _0x43dcf0[_0x1b1840];
        return _0x413fb9;
    }, $a5ca60f5343d1bf8$var$_0x1dbf(_0x7a148, _0x1c27d6);
}
(function(_0x2e5d6c, _0x2ce51e) {
    const _0x2764fb = $a5ca60f5343d1bf8$var$_0x536b;
    const _0x4d7cf3 = $a5ca60f5343d1bf8$var$_0x1dbf;
    const _0x4a9438 = _0x2e5d6c();
    while(true)try {
        const _0x47054f = parseInt(_0x4d7cf3(0x1fd)) / 0x1 + -parseInt(_0x4d7cf3(0x1ff)) / 0x2 + -parseInt(_0x4d7cf3(0x203)) / 0x3 + -parseInt(_0x4d7cf3(0x205)) / 0x4 * (parseInt(_0x4d7cf3(0x1f3)) / 0x5) + -parseInt(_0x4d7cf3(0x204)) / 0x6 * (-parseInt(_0x4d7cf3(0x1f6)) / 0x7) + parseInt(_0x4d7cf3(0x1f4)) / 0x8 + parseInt(_0x4d7cf3(0x1fa)) / 0x9;
        if (_0x47054f === _0x2ce51e) break;
        else _0x4a9438[_0x2764fb(0x196)](_0x4a9438.shift());
    } catch (_0x13f519) {
        _0x4a9438[_0x2764fb(0x196)](_0x4a9438[_0x2764fb(0x18b)]());
    }
})($a5ca60f5343d1bf8$var$_0x1dfe, 0x670cb);
function $a5ca60f5343d1bf8$var$_0x536b(_0x33ca08, _0x1f4f7c) {
    const _0x38a11e = $a5ca60f5343d1bf8$var$_0x38a1();
    return $a5ca60f5343d1bf8$var$_0x536b = function(_0x536b45, _0x163b30) {
        _0x536b45 = _0x536b45 - 0x17c;
        const _0x4745f3 = _0x38a11e[_0x536b45];
        return _0x4745f3;
    }, $a5ca60f5343d1bf8$var$_0x536b(_0x33ca08, _0x1f4f7c);
}
function $a5ca60f5343d1bf8$var$_0x1dfe() {
    const _0x10755c = $a5ca60f5343d1bf8$var$_0x536b;
    const _0x1006ec = [
        _0x10755c(0x187),
        _0x10755c(0x188),
        _0x10755c(0x193),
        _0x10755c(0x182),
        _0x10755c(0x191),
        'ArrowLeft',
        _0x10755c(0x190),
        _0x10755c(0x17c),
        _0x10755c(0x186),
        "Howdy fellow wizard \uD83E\uDDD9\u200D\u2642\uFE0F",
        'removeEventListener',
        _0x10755c(0x180),
        _0x10755c(0x198),
        _0x10755c(0x184),
        _0x10755c(0x18a),
        _0x10755c(0x185),
        _0x10755c(0x18c),
        '1772345WdRHVO',
        _0x10755c(0x18f),
        _0x10755c(0x17f),
        '973UovFgR'
    ];
    return $a5ca60f5343d1bf8$var$_0x1dfe = function() {
        return _0x1006ec;
    }, $a5ca60f5343d1bf8$var$_0x1dfe();
}
const $a5ca60f5343d1bf8$var$EGG_PATTERN = [
    $a5ca60f5343d1bf8$var$_0x26ab3f(0x1fe),
    $a5ca60f5343d1bf8$var$_0x26ab3f(0x1fe),
    $a5ca60f5343d1bf8$var$_0x1c6771(0x191),
    $a5ca60f5343d1bf8$var$_0x26ab3f(0x1fb),
    $a5ca60f5343d1bf8$var$_0x26ab3f(0x1fc),
    $a5ca60f5343d1bf8$var$_0x26ab3f(0x1f7),
    $a5ca60f5343d1bf8$var$_0x26ab3f(0x1fc),
    $a5ca60f5343d1bf8$var$_0x1c6771(0x187),
    'b',
    'a',
    'j',
    'a',
    'm',
    'e',
    's',
    'h',
    'a',
    'r',
    'l',
    'a',
    'n',
    'd'
];
const $a5ca60f5343d1bf8$var$useEgg = ()=>{
    const [_0x3a4171, _0x2f6f78] = (0, $h2ArV.useState)(0x0);
    const [_0x96e604, _0x28559b] = (0, $h2ArV.useState)(false);
    const [_0x2b4742, _0x208963] = (0, $h2ArV.useState)(0x0);
    const _0x256f83 = (0, $h2ArV.useCallback)((_0x507525)=>{
        const _0x2bb16f = $a5ca60f5343d1bf8$var$_0x536b;
        const _0x32002b = $a5ca60f5343d1bf8$var$_0x1dbf;
        if ($a5ca60f5343d1bf8$var$EGG_PATTERN[_0x32002b(0x1f2)](_0x507525[_0x2bb16f(0x17f)]) < 0x0 || _0x507525[_0x32002b(0x1f5)] !== $a5ca60f5343d1bf8$var$EGG_PATTERN[_0x3a4171]) {
            _0x2f6f78(0x0);
            return;
        }
        _0x2f6f78(_0x3a4171 + 0x1), $a5ca60f5343d1bf8$var$EGG_PATTERN[_0x32002b(0x1f8)] === _0x3a4171 + 0x1 && (_0x208963(_0x2b4742 + 0x1), _0x2f6f78(0x0), window[_0x32002b(0x1f1)](_0x32002b(0x200)));
    }, [
        _0x3a4171,
        _0x2b4742
    ]);
    (0, $h2ArV.useEffect)(()=>{
        const _0x2c91f8 = $a5ca60f5343d1bf8$var$_0x1dbf;
        return document[_0x2c91f8(0x1f9)](_0x2c91f8(0x202), _0x256f83, false), ()=>{
            const _0x45773c = _0x2c91f8;
            document[_0x45773c(0x201)](_0x45773c(0x202), _0x256f83, false);
        };
    }, [
        _0x256f83
    ]);
};
var $a5ca60f5343d1bf8$export$2e2bcd8739ae039 = $a5ca60f5343d1bf8$var$useEgg;



var $h2ArV = parcelRequire("h2ArV");
const $c6c13878c6b77455$var$useEvent = (name, handler, dependencies, { target: target = document, options: options } = {})=>{
    const callback = (0, $h2ArV.useCallback)(handler, dependencies);
    (0, $h2ArV.useEffect)(()=>{
        target.addEventListener(name, callback, options);
        return ()=>target.removeEventListener(name, callback, options);
    }, [
        callback
    ]);
};
var $c6c13878c6b77455$export$2e2bcd8739ae039 = $c6c13878c6b77455$var$useEvent;




var $h2ArV = parcelRequire("h2ArV");



/**
 * Handles dragging of resources (e.g. comments, states)
 * @param resourcesFromIDs Function takes a list of IDs and returns resources with those IDs
 * @param makeUpdateResources Function that updates the resource in the store
 */ const $72e8c035668f04d7$var$useResourceDragging = (resourcesFromIDs, makeUpdateResources)=>{
    const tool = (0, $9ea7efd115f178cf$export$2e2bcd8739ae039)((s)=>s.tool);
    const toolActive = tool === 'cursor';
    const updateResources = makeUpdateResources();
    const commit = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.commit);
    const screenToViewSpace = (0, $2c8de4ab9c0d9b91$export$2e2bcd8739ae039)((s)=>s.screenToViewSpace);
    const [dragOffsets, setDragOffsets] = (0, $h2ArV.useState)();
    const [dragCenters, setDragCenters] = (0, $h2ArV.useState)();
    const [dragging, setDragging] = (0, $h2ArV.useState)(null);
    const gridVisible = (0, $8af1fe532609b934$export$2e2bcd8739ae039)((state)=>state.preferences.showGrid);
    const startDrag = (0, $h2ArV.useCallback)((e, selectedResourceIDs)=>{
        if (toolActive) {
            const [x, y] = screenToViewSpace(e.detail.originalEvent.clientX, e.detail.originalEvent.clientY);
            const selected = resourcesFromIDs(selectedResourceIDs);
            setDragOffsets(selected.map((r)=>[
                    x - r.x,
                    y - r.y
                ]));
            setDragCenters(selected.map((r)=>[
                    r.x,
                    r.y
                ]));
            setDragging(selected.map((r)=>r.id));
        }
    }, [
        toolActive
    ]);
    // Listen for mouse move - dragging states
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('svg:mousemove', (e)=>{
        if (dragging !== null && toolActive) {
            const updates = dragging.map((id, i)=>{
                const [x, y] = [
                    e.detail.viewX,
                    e.detail.viewY
                ];
                const [dx, dy] = [
                    x - dragOffsets[i][0],
                    y - dragOffsets[i][1]
                ];
                // Determine leader position and offset from this state's position
                // This is used to determine snapping when dragging multiple states
                // (Leader is arbitrarily chosen as first in list of selected states)
                const [lx, ly] = i === 0 ? [
                    dx,
                    dy
                ] : [
                    x - dragOffsets[0][0],
                    y - dragOffsets[0][1]
                ];
                const [lox, loy] = i === 0 ? [
                    0,
                    0
                ] : [
                    dragOffsets[0][0] - dragOffsets[i][0],
                    dragOffsets[0][1] - dragOffsets[i][1]
                ];
                // Snapped dragging
                // (Leader snaps to closest grid position, others follow leaders movement)
                const [sx, sy] = e.detail.originalEvent.altKey || !gridVisible ? [
                    dx,
                    dy
                ] : i === 0 ? [
                    Math.floor(dx / (0, $e50e5255b7875dbd$export$be7376dc5870de68)) * (0, $e50e5255b7875dbd$export$be7376dc5870de68),
                    Math.floor(dy / (0, $e50e5255b7875dbd$export$be7376dc5870de68)) * (0, $e50e5255b7875dbd$export$be7376dc5870de68)
                ] : [
                    Math.floor(lx / (0, $e50e5255b7875dbd$export$be7376dc5870de68)) * (0, $e50e5255b7875dbd$export$be7376dc5870de68) + lox,
                    Math.floor(ly / (0, $e50e5255b7875dbd$export$be7376dc5870de68)) * (0, $e50e5255b7875dbd$export$be7376dc5870de68) + loy
                ];
                return {
                    id: id,
                    x: sx,
                    y: sy
                };
            });
            updateResources(updates);
        }
    }, [
        toolActive,
        dragging,
        gridVisible
    ]);
    // Listen for mouse up - stop dragging states
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('svg:mouseup', (e)=>{
        if (e.detail.originalEvent.button === 0 && dragging !== null && toolActive) {
            // Commit drag to history
            commit();
            // Reset dragging state
            setDragOffsets(null);
            setDragCenters(null);
            setDragging(null);
            e.preventDefault();
        }
    }, [
        dragOffsets,
        dragCenters,
        toolActive,
        dragging
    ]);
    return {
        startDrag: startDrag
    };
};
var $72e8c035668f04d7$export$2e2bcd8739ae039 = $72e8c035668f04d7$var$useResourceDragging;


// Setup state interactivity deps
const $6fdc4b0e31d90a85$var$statesFromIDs = (IDs)=>{
    const states = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039).getState()?.project?.states ?? [];
    return states.filter((state)=>IDs.includes(state.id));
};
const $6fdc4b0e31d90a85$var$makeUpdateStates = ()=>(0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.updateStates);
var $6fdc4b0e31d90a85$export$2e2bcd8739ae039 = ()=>(0, $72e8c035668f04d7$export$2e2bcd8739ae039)($6fdc4b0e31d90a85$var$statesFromIDs, $6fdc4b0e31d90a85$var$makeUpdateStates);




const $1e863dd3611b4ed5$var$commentsFromIDs = (IDs)=>{
    const comments = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039).getState()?.project?.comments ?? [];
    return comments.filter((comment)=>IDs.includes(comment.id));
};
const $1e863dd3611b4ed5$var$makeUpdateComments = ()=>(0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.updateComments);
var $1e863dd3611b4ed5$export$2e2bcd8739ae039 = ()=>(0, $72e8c035668f04d7$export$2e2bcd8739ae039)($1e863dd3611b4ed5$var$commentsFromIDs, $1e863dd3611b4ed5$var$makeUpdateComments);



var $h2ArV = parcelRequire("h2ArV");



const $5803ecf8056a071e$export$110a106688b8ed86 = (p1, p2, t)=>({
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    });
const $5803ecf8056a071e$export$cd860dfe6e23495d = (p, tar, d)=>{
    const l = $5803ecf8056a071e$export$346677f925de839c({
        x: tar.x - p.x,
        y: tar.y - p.y
    });
    if (p.x === tar.x && p.y === tar.y) return p;
    return {
        x: p.x + d * (tar.x - p.x) / l,
        y: p.y + d * (tar.y - p.y) / l
    };
};
const $5803ecf8056a071e$export$346677f925de839c = (p)=>Math.sqrt(Math.pow(p.x, 2) + Math.pow(p.y, 2));
const $5803ecf8056a071e$export$17ad03344ac560eb = (p)=>({
        x: Math.floor(p.x / (0, $e50e5255b7875dbd$export$be7376dc5870de68)) * (0, $e50e5255b7875dbd$export$be7376dc5870de68),
        y: Math.floor(p.y / (0, $e50e5255b7875dbd$export$be7376dc5870de68)) * (0, $e50e5255b7875dbd$export$be7376dc5870de68)
    });


const $99bee47c84ba0b00$var$useStateCreation = ()=>{
    const tool = (0, $9ea7efd115f178cf$export$2e2bcd8739ae039)((s)=>s.tool);
    const createState = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.createState);
    const commit = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.commit);
    const [mousePos, setMousePos] = (0, $h2ArV.useState)();
    const [showGhost, setShowGhost] = (0, $h2ArV.useState)(false);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('svg:mousemove', (e)=>{
        setMousePos($99bee47c84ba0b00$var$positionFromEvent(e));
    });
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('svg:mousedown', (e)=>{
        if (tool === 'state' && e.detail.didTargetSVG && e.detail.originalEvent.button === 0) setShowGhost(true);
    });
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('svg:mouseup', (e)=>{
        setShowGhost(false);
        if (tool === 'state' && e.detail.didTargetSVG && e.detail.originalEvent.button === 0) {
            createState($99bee47c84ba0b00$var$positionFromEvent(e));
            commit();
        }
    }, [
        tool
    ]);
    return {
        ghostState: tool === 'state' && showGhost && mousePos
    };
};
const $99bee47c84ba0b00$var$positionFromEvent = (e)=>{
    const doSnap = !e.detail.originalEvent.altKey;
    const pos = {
        x: e.detail.viewX,
        y: e.detail.viewY
    };
    return doSnap ? (0, $5803ecf8056a071e$export$17ad03344ac560eb)(pos) : pos;
};
var $99bee47c84ba0b00$export$2e2bcd8739ae039 = $99bee47c84ba0b00$var$useStateCreation;



var $h2ArV = parcelRequire("h2ArV");



const $6b7327396d77ce8a$var$useTransitionCreation = ()=>{
    const createTransition = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.createTransition);
    const moveTransition = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.moveTransition);
    const commit = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.commit);
    const tool = (0, $9ea7efd115f178cf$export$2e2bcd8739ae039)((s)=>s.tool);
    const screenToViewSpace = (0, $2c8de4ab9c0d9b91$export$2e2bcd8739ae039)((s)=>s.screenToViewSpace);
    const [createTransitionStart, setCreateTransitionStart] = (0, $h2ArV.useState)(null);
    const [createTransitionState, setCreateTransitionState] = (0, $h2ArV.useState)(null);
    const [createTransitionEnd, setCreateTransitionEnd] = (0, $h2ArV.useState)(null);
    const [moveTransitionState, setMoveTransitionState] = (0, $h2ArV.useState)(null);
    const [isMoveStart, setIsMoveStart] = (0, $h2ArV.useState)(false);
    const [transitionsToUpdate, setTransitionsToUpdate] = (0, $h2ArV.useState)(null);
    const reattachTransitions = (updateTransitionIds, from, to)=>{
        const { transitions: transitions } = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039).getState()?.project ?? {};
        const transitionsScope = transitions.filter((t)=>updateTransitionIds.includes(t.id));
        transitionsScope.forEach((t)=>{
            moveTransition({
                id: t.id,
                from: from,
                to: to
            });
        });
        // Update state
        commit();
    };
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('state:mousedown', (e)=>{
        if (tool === 'transition' && e.detail.originalEvent.button === 0) {
            const [viewX, viewY] = screenToViewSpace(e.detail.originalEvent.clientX, e.detail.originalEvent.clientY);
            const states = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039).getState().project?.states ?? [];
            const state = states.find((s)=>s.id === e.detail.state.id);
            setCreateTransitionState(state);
            setCreateTransitionStart([
                viewX,
                viewY
            ]);
        }
    }, [
        tool
    ]);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('state:mouseup', (e)=>{
        if (createTransitionState && e.detail.originalEvent.button === 0) {
            const id = createTransition({
                from: createTransitionState.id,
                to: e.detail.state.id
            });
            setCreateTransitionStart(null);
            setCreateTransitionState(null);
            window.setTimeout(()=>(0, $ca2884de04f532f3$export$fb20829f6af70575)('editTransition', {
                    id: id
                }), 100);
        }
    }, [
        createTransitionState
    ]);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('state:mouseup', (e)=>{
        if (moveTransitionState && transitionsToUpdate && e.detail.originalEvent.button === 0) {
            const otherId = e.detail.state.id;
            if (isMoveStart) reattachTransitions(transitionsToUpdate, otherId, moveTransitionState.id);
            else reattachTransitions(transitionsToUpdate, moveTransitionState.id, otherId);
            setMoveTransitionState(null);
            setTransitionsToUpdate(null);
            setCreateTransitionStart(null);
            setCreateTransitionEnd(null);
        }
    }, [
        moveTransitionState
    ]);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('svg:mousemove', (e)=>{
        if (tool === 'transition' && createTransitionState) setCreateTransitionEnd([
            e.detail.viewX,
            e.detail.viewY
        ]);
    }, [
        tool,
        createTransitionState
    ]);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('svg:mousemove', (e)=>{
        if (tool === 'cursor' && moveTransitionState) {
            if (isMoveStart) setCreateTransitionStart([
                e.detail.viewX,
                e.detail.viewY
            ]);
            else setCreateTransitionEnd([
                e.detail.viewX,
                e.detail.viewY
            ]);
        }
    }, [
        tool,
        moveTransitionState
    ]);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('svg:mouseup', (e)=>{
        if (e.detail.didTargetSVG) {
            setCreateTransitionEnd(null);
            setCreateTransitionStart(null);
            setCreateTransitionState(null);
            setMoveTransitionState(null);
        }
    }, []);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('transitionhandle:mousedown', (e)=>{
        const isMovingStart = e.detail.transitionInfo.isMovingStart;
        setIsMoveStart(isMovingStart);
        setTransitionsToUpdate(e.detail.transitionInfo.transitionIds);
        const states = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039).getState().project?.states ?? [];
        if (isMovingStart) {
            setMoveTransitionState(states.find((s)=>s.id === e.detail.transitionInfo.toId));
            setCreateTransitionEnd([
                e.detail.transitionInfo.otherPosition.x,
                e.detail.transitionInfo.otherPosition.y
            ]);
        } else {
            setMoveTransitionState(states.find((s)=>s.id === e.detail.transitionInfo.fromId));
            setCreateTransitionStart([
                e.detail.transitionInfo.otherPosition.x,
                e.detail.transitionInfo.otherPosition.y
            ]);
        }
    });
    return {
        createTransitionStart: createTransitionStart && {
            x: createTransitionStart[0],
            y: createTransitionStart[1]
        },
        createTransitionEnd: createTransitionEnd && {
            x: createTransitionEnd[0],
            y: createTransitionEnd[1]
        }
    };
};
var $6b7327396d77ce8a$export$2e2bcd8739ae039 = $6b7327396d77ce8a$var$useTransitionCreation;



var $h2ArV = parcelRequire("h2ArV");



const $031a6c13090f0034$var$useCommentCreation = ()=>{
    const tool = (0, $9ea7efd115f178cf$export$2e2bcd8739ae039)((s)=>s.tool);
    const handleCommentMouseUp = (0, $h2ArV.useCallback)((e)=>{
        if (tool === 'comment' && e.detail.originalEvent.button === 0) window.setTimeout(()=>(0, $ca2884de04f532f3$export$fb20829f6af70575)('editComment', {
                x: e.detail.originalEvent.clientX,
                y: e.detail.originalEvent.clientY
            }), 100);
    }, [
        tool
    ]);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('svg:mouseup', handleCommentMouseUp);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('state:mouseup', handleCommentMouseUp);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('transition:mouseup', handleCommentMouseUp);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('comment:mouseup', handleCommentMouseUp);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('edge:mouseup', handleCommentMouseUp);
};
var $031a6c13090f0034$export$2e2bcd8739ae039 = $031a6c13090f0034$var$useCommentCreation;




var $h2ArV = parcelRequire("h2ArV");

const $6f4524a2c065e6e1$var$useResourceSelection = (getSelected, makeSetter, eventKey)=>{
    const tool = (0, $9ea7efd115f178cf$export$2e2bcd8739ae039)((s)=>s.tool);
    const selected = getSelected();
    const setSelected = makeSetter();
    const selectNone = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.selectNone);
    const select = (0, $h2ArV.useCallback)((e)=>{
        let newSelected;
        if (tool === 'cursor' || e.detail.originalEvent.button === 2 || tool === 'delete') {
            // Things like transitions need to be able to send multiple ID's so that they don't
            // need to send individual events for each transition (This is for stacked transitions).
            const ids = 'ids' in e.detail ? e.detail.ids : [
                e.detail[eventKey].id
            ];
            // If the selected is a single id then its a list of one item, so it's a search that
            // selected has that one ID
            // If it's an edge then all ids need to be in selected for it to be counted as selected
            // `.every` works for both cases rather than some
            const alreadySelected = ids.every((id)=>selected.includes(id));
            const usedShift = e.detail.originalEvent.shiftKey;
            if (alreadySelected && usedShift) // If shifting on an already selected item then we can remove it
            newSelected = selected.filter((id)=>!ids.includes(id));
            else if (usedShift) // If shifting on a new resource, add it to the selected list
            newSelected = [
                ...selected,
                ...ids
            ];
            else if (alreadySelected) // If already selected then keep selected items.
            // This keeps the items selecting while dragging
            newSelected = selected;
            else // Else just use what is selected
            newSelected = ids;
            // Reset selected states?
            if (!alreadySelected && !e.detail.originalEvent.shiftKey) selectNone();
            setSelected(newSelected);
        }
        return newSelected;
    }, [
        tool,
        selected
    ]);
    return {
        select: select
    };
};
var $6f4524a2c065e6e1$export$2e2bcd8739ae039 = $6f4524a2c065e6e1$var$useResourceSelection;


const $4d9084c042c6f7b7$var$useStateSelection = ()=>{
    return (0, $6f4524a2c065e6e1$export$2e2bcd8739ae039)(()=>(0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.selectedStates), ()=>(0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.setStates), 'state');
};
var $4d9084c042c6f7b7$export$2e2bcd8739ae039 = $4d9084c042c6f7b7$var$useStateSelection;




const $c2a319a6ebe46b18$var$useCommentSelection = ()=>{
    return (0, $6f4524a2c065e6e1$export$2e2bcd8739ae039)(()=>(0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.selectedComments), ()=>(0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.setComments), 'comment');
};
var $c2a319a6ebe46b18$export$2e2bcd8739ae039 = $c2a319a6ebe46b18$var$useCommentSelection;




const $d2b9768fe2819798$var$useStateSelection = ()=>{
    return (0, $6f4524a2c065e6e1$export$2e2bcd8739ae039)(()=>(0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.selectedTransitions), ()=>(0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.setTransitions), 'transition');
};
var $d2b9768fe2819798$export$2e2bcd8739ae039 = $d2b9768fe2819798$var$useStateSelection;



var $h2ArV = parcelRequire("h2ArV");



const $62273076b8702d48$var$useContextMenus = ()=>{
    const setContext = (0, $992c0f2e4bd5c228$export$2e2bcd8739ae039)((ctx)=>ctx.setContext);
    const showContext = (name)=>(0, $h2ArV.useCallback)((e)=>{
            setContext(e.detail.ctx);
            if (e.detail.originalEvent.button === 2) (0, $ca2884de04f532f3$export$fb20829f6af70575)(name, {
                x: e.detail.originalEvent.clientX,
                y: e.detail.originalEvent.clientY
            });
        }, []);
    // Set context handlers
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('svg:mouseup', showContext('ctx:svg'));
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('state:mouseup', showContext('ctx:state'));
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('transition:mouseup', showContext('ctx:transition'));
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('comment:mouseup', showContext('ctx:comment'));
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('edge:mouseup', showContext('ctx:edge'));
};
var $62273076b8702d48$export$2e2bcd8739ae039 = $62273076b8702d48$var$useContextMenus;



var $h2ArV = parcelRequire("h2ArV");


const $f7162e3030303bfe$var$SAVE_INTERVAL = 5000;
const $f7162e3030303bfe$var$SAVE_DIALOG_MIN_TIME = 1500;
/**
 * Use this to save the project on an interval. The project will only save if there are changes
 * and there are items in the project
 * @see SAVE_INTERVAL
 */ const $f7162e3030303bfe$var$useAutosaveProject = ()=>{
    const upsertProject = (0, $a882b4a4b7f1e12c$export$2e2bcd8739ae039)((s)=>s.upsertProject);
    const upsertModuleProject = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.upsertProject);
    const upsertModules = (0, $38932e4472f33f50$export$2e2bcd8739ae039)((s)=>s.upsertModule);
    const lastChangeDate = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.lastChangeDate);
    const lastSaveDate = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.lastSaveDate);
    const setLastSaveDate = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.setLastSaveDate);
    const [isSaving, setIsSaving] = (0, $h2ArV.useState)(false);
    const currentModule = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.module);
    (0, $h2ArV.useEffect)(()=>{
        const timer = setInterval(()=>{
            const currP = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039).getState().project;
            const totalItems = currP.comments.length + currP.states.length + currP.transitions.length;
            // Only save if there has been a change and there is something in the project
            if ((!lastSaveDate || (0, (/*@__PURE__*/$parcel$interopDefault($de07f2c205919029$exports)))(lastChangeDate).isAfter(lastSaveDate)) && totalItems > 0) {
                setIsSaving(true);
                const toSave = {
                    ...currP,
                    meta: {
                        ...currP.meta,
                        dateEdited: new Date().getTime()
                    }
                };
                if (currentModule != null) {
                    // Save to module
                    upsertModuleProject(toSave);
                    // Save module to modules locally on local storage
                    upsertModules(currentModule);
                } else upsertProject(toSave);
                setLastSaveDate(new Date().getTime());
                // Hide "Saving..." dialog after a short delay
                setTimeout(()=>{
                    setIsSaving(false);
                }, $f7162e3030303bfe$var$SAVE_DIALOG_MIN_TIME);
            }
        }, $f7162e3030303bfe$var$SAVE_INTERVAL);
        return ()=>clearInterval(timer);
    }, [
        lastChangeDate,
        lastSaveDate,
        upsertProject,
        setLastSaveDate
    ]);
    return isSaving;
};
var $f7162e3030303bfe$export$2e2bcd8739ae039 = $f7162e3030303bfe$var$useAutosaveProject;



var $h2ArV = parcelRequire("h2ArV");




const $22a6b7ea146a0a79$var$SVG_NS = 'http://www.w3.org/2000/svg';
const $22a6b7ea146a0a79$export$ada0ee09b3d8f53f = (filename, extension, data)=>{
    const link = document.createElement('a');
    link.download = `${filename.replace(/[#%&{}\\<>*?/$!'":@+`|=]/g, '')}.${extension}`;
    link.href = data;
    link.click();
};
const $22a6b7ea146a0a79$export$67db19a1608c2434 = ({ height: height, width: width, svg: svg })=>new Promise((resolve)=>{
        // Setup canvas
        const canvas = document.createElement('canvas');
        canvas.height = height * 2;
        canvas.width = width * 2;
        const ctx = canvas.getContext('2d');
        // Create an image to render
        const img = new Image();
        img.onload = ()=>{
            // Draw and save the image
            ctx.drawImage(img, 0, 0);
            resolve(canvas);
        };
        img.src = 'data:image/svg+xml,' + encodeURIComponent(svg);
    });
const $22a6b7ea146a0a79$export$2421ed4e781a60b3 = ({ svgElementTag: svgElementTag = 'automatarium-graph', margin: margin = 20, background: background = 'none', color: color = null, darkMode: darkMode = false } = {})=>{
    // Clone the SVG element
    const svgElement = document.querySelector(`#${svgElementTag}`);
    if (svgElement === null) return {
        svg: null,
        height: 0,
        width: 0
    };
    const clonedSvgElement = svgElement.cloneNode(true);
    // Set viewbox
    const b = svgElement.querySelector('g').getBBox();
    margin = Number(margin ?? 0) + 1;
    const [x, y, width, height] = [
        b.x - margin,
        b.y - margin,
        b.width + margin * 2,
        b.height + margin * 2
    ];
    clonedSvgElement.setAttribute('viewBox', `${x} ${y} ${width} ${height}`);
    clonedSvgElement.setAttribute('width', width * 2 + 'px');
    clonedSvgElement.setAttribute('height', height * 2 + 'px');
    // If changing colour, save what is on the actual svg, then change them temporarily
    // This is done because we need to recompute the variables below, and we can't
    // change the variables on the cloned element, as it's not attached to the DOM
    // and doesn't receive styles from the stylesheet
    const prevColor = {
        h: svgElement.style.getPropertyValue('--primary-h'),
        s: svgElement.style.getPropertyValue('--primary-s'),
        l: svgElement.style.getPropertyValue('--primary-l')
    };
    if (color) {
        const c = (0, $d59e810d2f517544$export$2e2bcd8739ae039)[color] ?? (0, $d59e810d2f517544$export$2e2bcd8739ae039).orange;
        svgElement.style.setProperty('--primary-h', c.h.toString());
        svgElement.style.setProperty('--primary-s', `${c.s}%`);
        svgElement.style.setProperty('--primary-l', `${c.l}%`);
    }
    // Get computed styles from the svg
    const styles = getComputedStyle(svgElement);
    const theme = darkMode ? 'dark' : 'light';
    // Background
    if (background === 'solid') {
        // Create a rect to fill the SVG background
        const bg = document.createElementNS($22a6b7ea146a0a79$var$SVG_NS, 'rect');
        bg.setAttributeNS($22a6b7ea146a0a79$var$SVG_NS, 'fill', styles.getPropertyValue(`--grid-bg-${theme}`));
        bg.setAttributeNS($22a6b7ea146a0a79$var$SVG_NS, 'x', String(x));
        bg.setAttributeNS($22a6b7ea146a0a79$var$SVG_NS, 'y', String(y));
        bg.setAttributeNS($22a6b7ea146a0a79$var$SVG_NS, 'width', String(width));
        bg.setAttributeNS($22a6b7ea146a0a79$var$SVG_NS, 'height', String(height));
        clonedSvgElement.prepend(bg);
    } else background;
    // Replace colour variables
    clonedSvgElement.style.fontFamily = styles.getPropertyValue('font-family');
    const svg = clonedSvgElement.outerHTML.replaceAll('var(--initial-arrow-bg, var(--grid-bg))', 'none').replaceAll('var(--input-border)', styles.getPropertyValue('--input-border')).replaceAll('var(--grid-bg)', styles.getPropertyValue(`--grid-bg-${theme}`)).replaceAll('var(--stroke)', styles.getPropertyValue(`--stroke-${theme}`)).replaceAll('var(--primary)', styles.getPropertyValue(`--stroke-${theme}`)).replaceAll('var(--state-bg)', styles.getPropertyValue(`--state-bg-${theme}`)).replaceAll('var(--state-bg-selected)', styles.getPropertyValue(`--state-bg-${theme}`)).replaceAll('var(--comment-text)', styles.getPropertyValue(`--comment-text-${theme}`));
    // If changing colour, reset the actual svg back to what it was previously
    if (color) {
        svgElement.style.setProperty('--primary-h', prevColor.h);
        svgElement.style.setProperty('--primary-s', prevColor.s);
        svgElement.style.setProperty('--primary-l', prevColor.l);
    }
    return {
        svg: svg,
        height: height,
        width: width
    };
};
const $22a6b7ea146a0a79$var$useImageExport = ()=>{
    const project = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project);
    const setExportVisible = (0, $ef9e10319983727e$export$2e2bcd8739ae039)((s)=>s.setExportVisible);
    const setThumbnail = (0, $3954b8dde947d829$export$2e2bcd8739ae039)((s)=>s.setThumbnail);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('exportImage', async (e)=>{
        // Detailed export
        if (!e.detail?.type) return setExportVisible(true);
        // Get the svg string
        const { svg: svg, height: height, width: width } = $22a6b7ea146a0a79$export$2421ed4e781a60b3();
        if (svg === null) return;
        // Quick export SVG
        if (e.detail?.type === 'svg') return $22a6b7ea146a0a79$export$ada0ee09b3d8f53f(project.meta.name, 'svg', 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent('<?xml version="1.0" standalone="no"?>\r\n' + svg));
        // Quick export PNG
        if (e.detail?.type === 'png') {
            const canvas = await $22a6b7ea146a0a79$export$67db19a1608c2434({
                height: height,
                width: width,
                svg: svg
            });
            // Export to clipboard
            if (e.detail.clipboard) return canvas.toBlob((blob)=>navigator.clipboard.write([
                    new window.ClipboardItem({
                        'image/png': blob
                    })
                ]));
            return $22a6b7ea146a0a79$export$ada0ee09b3d8f53f(project.meta.name, 'png', canvas.toDataURL());
        }
    }, [
        project.meta.name
    ]);
    // Generate project thumbnail
    (0, $h2ArV.useEffect)(()=>{
        const id = window.setTimeout(()=>{
            const { svg: svgLight } = $22a6b7ea146a0a79$export$2421ed4e781a60b3({
                darkMode: false
            });
            const { svg: svgDark } = $22a6b7ea146a0a79$export$2421ed4e781a60b3({
                darkMode: true
            });
            if (svgLight !== null) setThumbnail(project._id, 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent('<?xml version="1.0" standalone="no"?>\r\n' + svgLight));
            if (svgDark !== null) setThumbnail(`${project._id}-dark`, 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent('<?xml version="1.0" standalone="no"?>\r\n' + svgDark));
        }, 200);
        return ()=>window.clearTimeout(id);
    }, [
        project
    ]);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('storeTemplateThumbnail', (e)=>{
        const id = window.setTimeout(()=>{
            const { svg: svgLight } = $22a6b7ea146a0a79$export$2421ed4e781a60b3({
                svgElementTag: 'selected-graph',
                darkMode: false
            });
            const { svg: svgDark } = $22a6b7ea146a0a79$export$2421ed4e781a60b3({
                svgElementTag: 'selected-graph',
                darkMode: true
            });
            if (svgLight !== null) setThumbnail(`tmp${e.detail}`, 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent('<?xml version="1.0" standalone="no"?>\r\n' + svgLight));
            if (svgDark !== null) setThumbnail(`tmp${e.detail}-dark`, 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent('<?xml version="1.0" standalone="no"?>\r\n' + svgDark));
            (0, $ca2884de04f532f3$export$fb20829f6af70575)('selectionGraph:hide', null);
        }, 200);
        return ()=>window.clearTimeout(id);
    });
};
var $22a6b7ea146a0a79$export$2e2bcd8739ae039 = $22a6b7ea146a0a79$var$useImageExport;







var $h2ArV = parcelRequire("h2ArV");
const $9003adf927d831a8$var$useTemplateInsert = ()=>{
    const selectStates = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.setStates);
    const selectTransitions = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.setTransitions);
    const selectComments = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.setComments);
    const commit = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.commit);
    const insertGroup = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.insertGroup);
    const { template: template, setTemplate: setTemplate } = (0, $f8e54bb3e6739765$export$2e2bcd8739ae039)();
    const { tool: tool, setTool: setTool } = (0, $9ea7efd115f178cf$export$2e2bcd8739ae039)();
    const [mousePos, setMousePos] = (0, $h2ArV.useState)({
        x: 0,
        y: 0
    });
    const [showGhost, setShowGhost] = (0, $h2ArV.useState)(false);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('svg:mousemove', (e)=>{
        if (template !== null) setMousePos($9003adf927d831a8$var$positionFromEvent(e));
    }, [
        template
    ]);
    (0, $h2ArV.useEffect)(()=>{
        if (tool === null && template !== null) setShowGhost(true);
    }, [
        tool,
        template
    ]);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('svg:mouseup', (e)=>{
        // Track mouseup event
        setShowGhost(false);
        if (template !== null && e.detail.didTargetSVG && e.detail.originalEvent.button === 0) {
            const copyTemplate = structuredClone(template);
            $9003adf927d831a8$export$116c286ffc0cf8b2($9003adf927d831a8$var$positionFromEvent(e), copyTemplate.states, copyTemplate.comments);
            const insertResponse = insertGroup(copyTemplate, true);
            if (insertResponse.type === (0, $920b9ecb34a1fb18$export$7eda682a4373126).SUCCESS) {
                selectComments(insertResponse.body.comments.map((comment)=>comment.id));
                selectStates(insertResponse.body.states.map((state)=>state.id));
                selectTransitions(insertResponse.body.transitions.map((transition)=>transition.id));
                commit();
                setTool('cursor');
                setTemplate(null);
            } else if (insertResponse.type === (0, $920b9ecb34a1fb18$export$7eda682a4373126).FAIL) alert(insertResponse.body);
        }
    }, [
        template
    ]);
    return {
        ghostTemplate: template !== null && showGhost && mousePos
    };
};
const $9003adf927d831a8$var$positionFromEvent = (e)=>{
    const doSnap = !e.detail.originalEvent.altKey;
    const pos = {
        x: e.detail.viewX,
        y: e.detail.viewY
    };
    return doSnap ? (0, $5803ecf8056a071e$export$17ad03344ac560eb)(pos) : pos;
};
const $9003adf927d831a8$export$116c286ffc0cf8b2 = (mousePos, states, comments)=>{
    // Find the leftmost state (lowest x val)
    const originState = states.reduce((previous, current)=>{
        return current.x < previous.x ? current : previous;
    });
    const offsetX = mousePos.x - originState.x;
    const offsetY = mousePos.y - originState.y;
    states.forEach((state)=>{
        state.x += offsetX;
        state.y += offsetY;
    });
    if (comments) comments.forEach((comment)=>{
        comment.x += offsetX;
        comment.y += offsetY;
    });
};
var $9003adf927d831a8$export$2e2bcd8739ae039 = $9003adf927d831a8$var$useTemplateInsert;







var $h2ArV = parcelRequire("h2ArV");

const $bbf4d3a7fe915e9d$export$e6dfd72ab29f8598 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('nav')`
  background-color: var(--toolbar);
  color: var(--white);
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 2;
  position: relative;
`;
const $bbf4d3a7fe915e9d$export$d9b273488cd8ce6f = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  align-items: center;
  gap: 0em;
  flex: 1;

  & > div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
`;
const $bbf4d3a7fe915e9d$export$7b6268c93113b6c9 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  align-items: center;
  gap: .5em;
`;
const $bbf4d3a7fe915e9d$export$c7bd411105e2dec3 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('span')`
  display: block;
  font-size: 1.2em;
  padding: .2em .5rem;
`;
const $bbf4d3a7fe915e9d$export$e1eb8cd79d1ad2f8 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('input', (0, $h2ArV.forwardRef))`
  font: inherit;
  font-size: 1.2em;
  padding: .2em .5rem;
  border: 0;
  border-radius: .3em;
`;
const $bbf4d3a7fe915e9d$export$90442033ec981c61 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('span')`
  position: relative;
  font-size: .8em;
  opacity: 0;
  transition: opacity .3s;
  padding-left: 1.8em;
  user-select: none;
  pointer-events: none;

  ${(p)=>p.$show && `
    opacity: .75;
  `}

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: calc(50% - .6em);
    height: 1.2em;
    width: 1.2em;
    border-radius: 10em;
    box-sizing: border-box;
    border: 2px solid currentColor;
    border-block-end: 2px solid transparent;
    animation: spin 1s linear infinite;
  }

  @keyframes spin { to { transform: rotate(360deg); } }
`;
const $bbf4d3a7fe915e9d$export$b52183d5cfb26dc9 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  align-items: center;
  gap: 1em;
  padding: 1em;
`;
const $bbf4d3a7fe915e9d$export$707d60950b0ce92c = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  gap: .1em;
`;
const $bbf4d3a7fe915e9d$export$54a09b83c851a7ef = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('button', (0, $h2ArV.forwardRef))`
  font: inherit;
  margin: 0;
  color: inherit;
  background: none;
  border: 0;
  padding: .2em .5rem;
  cursor: pointer;
  font-size: .95em;
  border-radius: .2em;

  &:hover ${(props)=>props.$active && ',&'} {
    background: var(--surface);
  }
`;



const $1968aeaddea1e933$var$menus = (t)=>[
        {
            label: t('menus.file', {
                ns: 'common'
            }),
            items: [
                {
                    label: t('menus.file_new', {
                        ns: 'common'
                    }),
                    action: 'NEW_FILE'
                },
                // TODO: Support dynamic menu items to show recent files
                // {
                //   label: 'Open recent',
                //   items: [
                //     // { label: 'Test file' },
                //     // { label: 'Another test file' },
                //     // { label: 'Best NFA' },
                //     // { label: 'Turing machine' },
                //   ],
                // },
                'hr',
                {
                    label: t('import', {
                        ns: 'common'
                    }),
                    items: [
                        {
                            label: t('menus.import_automatarium', {
                                ns: 'common'
                            }),
                            action: 'IMPORT_AUTOMATARIUM_PROJECT'
                        },
                        {
                            label: t('menus.import_jflap', {
                                ns: 'common'
                            }),
                            action: 'IMPORT_JFLAP_PROJECT'
                        },
                        {
                            label: t('menus.import_other', {
                                ns: 'common'
                            }),
                            action: 'IMPORT_DIALOG'
                        }
                    ]
                },
                {
                    label: t('export', {
                        ns: 'common'
                    }),
                    items: [
                        {
                            label: t('menus.export_image', {
                                ns: 'common'
                            }),
                            action: 'EXPORT'
                        },
                        {
                            label: t('menus.export_png', {
                                ns: 'common'
                            }),
                            action: 'EXPORT_AS_PNG'
                        },
                        {
                            label: t('menus.export_svg', {
                                ns: 'common'
                            }),
                            action: 'EXPORT_AS_SVG'
                        },
                        {
                            label: t('menus.export_clipboard', {
                                ns: 'common'
                            }),
                            action: 'EXPORT_TO_CLIPBOARD'
                        },
                        'hr',
                        {
                            label: t('menus.export_automatarium', {
                                ns: 'common'
                            }),
                            action: 'SAVE_FILE_AS'
                        },
                        {
                            label: t('menus.export_jflap', {
                                ns: 'common'
                            }),
                            action: 'EXPORT_AS_JFLAP'
                        },
                        {
                            label: t('menus.export_url_data', {
                                ns: 'common'
                            }),
                            action: 'ENCODE_FILE'
                        }
                    ]
                },
                'hr',
                {
                    label: t('menus.preferences', {
                        ns: 'common'
                    }),
                    action: 'OPEN_PREFERENCES'
                }
            ]
        },
        {
            label: t('menus.edit', {
                ns: 'common'
            }),
            items: [
                {
                    label: t('menus.undo', {
                        ns: 'common'
                    }),
                    action: 'UNDO'
                },
                {
                    label: t('menus.redo', {
                        ns: 'common'
                    }),
                    action: 'REDO'
                },
                'hr',
                {
                    label: t('copy', {
                        ns: 'common'
                    }),
                    action: 'COPY'
                },
                {
                    label: t('paste', {
                        ns: 'common'
                    }),
                    action: 'PASTE'
                },
                {
                    label: t('menus.select_all', {
                        ns: 'common'
                    }),
                    action: 'SELECT_ALL'
                },
                {
                    label: t('menus.clear_selection', {
                        ns: 'common'
                    }),
                    action: 'SELECT_NONE'
                },
                'hr',
                {
                    label: t('delete', {
                        ns: 'common'
                    }),
                    shortcut: "\u232B",
                    action: 'DELETE'
                }
            ]
        },
        {
            label: t('menus.view', {
                ns: 'common'
            }),
            items: [
                {
                    label: t('menus.zoom_in', {
                        ns: 'common'
                    }),
                    action: 'ZOOM_IN'
                },
                {
                    label: t('menus.zoom_out', {
                        ns: 'common'
                    }),
                    action: 'ZOOM_OUT'
                },
                {
                    label: t('menus.zoom_100', {
                        ns: 'common'
                    }),
                    action: 'ZOOM_100'
                },
                {
                    label: t('menus.zoom_fit', {
                        ns: 'common'
                    }),
                    action: 'ZOOM_FIT'
                },
                'hr',
                {
                    label: t('menus.fullscreen', {
                        ns: 'common'
                    }),
                    shortcut: 'F11',
                    action: 'FULLSCREEN'
                },
                'hr',
                {
                    label: t('menus.testing_lab', {
                        ns: 'common'
                    }),
                    action: 'TESTING_LAB'
                },
                /*
      {
        label: 'Stepping lab',
        action: 'STEPPING_LAB'
      },
      */ {
                    label: t('menus.file_info', {
                        ns: 'common'
                    }),
                    action: 'FILE_INFO'
                },
                {
                    label: t('menus.file_options', {
                        ns: 'common'
                    }),
                    action: 'FILE_OPTIONS'
                },
                {
                    label: t('menus.templates', {
                        ns: 'common'
                    }),
                    action: 'TEMPLATES'
                },
                {
                    label: t('menus.modules', {
                        ns: 'common'
                    }),
                    action: 'MODULES'
                }
            ]
        },
        {
            label: t('menus.tools', {
                ns: 'common'
            }),
            items: [
                {
                    label: t('menus.convert_dfa', {
                        ns: 'common'
                    }),
                    action: 'CONVERT_TO_DFA'
                },
                'hr',
                {
                    label: t('menus.auto_layout', {
                        ns: 'common'
                    }),
                    action: 'AUTO_LAYOUT'
                },
                {
                    label: t('menus.reorder_graph', {
                        ns: 'common'
                    }),
                    action: 'REORDER_GRAPH'
                }
            ]
        },
        {
            label: t('menus.help', {
                ns: 'common'
            }),
            items: [
                {
                    label: t('menus.start_tour', {
                        ns: 'common'
                    }),
                    action: 'START_TOUR'
                },
                {
                    label: t('menus.view_documentation', {
                        ns: 'common'
                    }),
                    action: 'OPEN_DOCS'
                },
                {
                    label: t('menus.tutorial_videos', {
                        ns: 'common'
                    }),
                    action: 'TUTORIAL_VIDEOS'
                },
                {
                    label: t('menus.keyboard_shortcuts', {
                        ns: 'common'
                    }),
                    action: 'KEYBOARD_SHORTCUTS'
                },
                'hr',
                {
                    label: t('privacy_policy', {
                        ns: 'common'
                    }),
                    action: 'PRIVACY_POLICY'
                },
                {
                    label: t('menus.about_automatarium', {
                        ns: 'common'
                    }),
                    action: 'OPEN_ABOUT'
                },
                'hr',
                {
                    label: t('menus.version', {
                        ns: 'common',
                        version: (0, $09ff7c1d5f0c0758$export$8ee1df3c6367a60)
                    })
                }
            ]
        }
    ];
var $1968aeaddea1e933$export$2e2bcd8739ae039 = $1968aeaddea1e933$var$menus;



// Extend dayjs
(0, (/*@__PURE__*/$parcel$interopDefault($de07f2c205919029$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($11e5497bd9439d83$exports))));
const $a7169d08c7fb682a$var$DropdownButton = ({ item: item, dropdown: dropdown, setDropdown: setDropdown, ...props })=>{
    const buttonRef = (0, $h2ArV.useRef)();
    const [rect, setRect] = (0, $h2ArV.useState)();
    (0, $h2ArV.useEffect)(()=>{
        if (buttonRef.current) setRect(buttonRef.current.getBoundingClientRect());
    }, [
        buttonRef.current
    ]);
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $bbf4d3a7fe915e9d$export$54a09b83c851a7ef), {
                type: "button",
                ref: buttonRef,
                $active: dropdown === item.label,
                ...props,
                children: item.label
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $54cc07ecaf352272$export$2e2bcd8739ae039), {
                style: {
                    top: `${rect?.y + rect?.height + 10}px`,
                    left: `${rect?.x}px`
                },
                items: item.items,
                visible: dropdown === item.label,
                onClose: ()=>setDropdown(undefined)
            })
        ]
    });
};
const $a7169d08c7fb682a$var$Menubar = ({ isSaving: isSaving })=>{
    const navigate = (0, $4b112c041340d9ed$export$9770f232ac06a008)();
    const [dropdown, setDropdown] = (0, $h2ArV.useState)();
    const titleRef = (0, $h2ArV.useRef)();
    const [editingTitle, setEditingTitle] = (0, $h2ArV.useState)(false);
    const [titleValue, setTitleValue] = (0, $h2ArV.useState)('');
    const projectName = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project?.meta?.name);
    const setProjectName = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.setName);
    const lastChangeDate = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.lastChangeDate);
    const lastSaveDate = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.lastSaveDate);
    const setLastSaveDate = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.setLastSaveDate);
    const upsertProject = (0, $a882b4a4b7f1e12c$export$2e2bcd8739ae039)((s)=>s.upsertProject);
    const deleteProject = (0, $a882b4a4b7f1e12c$export$2e2bcd8739ae039)((s)=>s.deleteProject);
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)('common');
    // Modules
    const upsertModuleProject = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.upsertProject);
    const upsertModule = (0, $38932e4472f33f50$export$2e2bcd8739ae039)((s)=>s.upsertModule);
    const currentModule = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.module);
    const handleEditProjectName = ()=>{
        setTitleValue(projectName ?? '');
        setEditingTitle(true);
        window.setTimeout(()=>titleRef.current?.select(), 50);
    };
    const saveProject = ()=>{
        const project = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039).getState().project;
        upsertProject({
            ...project,
            meta: {
                ...project.meta,
                dateEdited: new Date().getTime()
            }
        });
        setLastSaveDate(new Date().getTime());
    };
    const saveLabProject = ()=>{
        const project = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039).getState().project;
        upsertModuleProject({
            ...project,
            meta: {
                ...project.meta,
                dateEdited: new Date().getTime()
            }
        });
    };
    const saveLab = ()=>{
        upsertModule(currentModule);
    };
    const handleSaveProjectName = ()=>{
        if (titleValue && !/^\s*$/.test(titleValue)) {
            setProjectName(titleValue);
            saveProject();
        }
        setEditingTitle(false);
    };
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('beforeunload', (e)=>{
        if (lastSaveDate > lastChangeDate) return;
        e.preventDefault();
        return t('menubar.not_saved');
    }, [
        lastSaveDate,
        lastChangeDate
    ], {
        options: {
            capture: true
        },
        target: window
    });
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $d15f6e8ca8604f1a$exports.Fragment), {
        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $bbf4d3a7fe915e9d$export$e6dfd72ab29f8598), {
            children: [
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $bbf4d3a7fe915e9d$export$d9b273488cd8ce6f), {
                    children: [
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("a", {
                            href: "/new",
                            onClick: (e)=>{
                                e.preventDefault();
                                const project = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039).getState().project;
                                const totalItems = project.comments.length + project.states.length + project.transitions.length;
                                if (totalItems > 0) {
                                    if (currentModule != null) {
                                        saveLabProject();
                                        saveLab();
                                    } else saveProject();
                                } else deleteProject(project._id);
                                navigate('/new');
                            },
                            children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $2fdc1cc89313d290$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $bbf4d3a7fe915e9d$export$7b6268c93113b6c9), {
                                    children: [
                                        editingTitle ? /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $bbf4d3a7fe915e9d$export$e1eb8cd79d1ad2f8), {
                                            value: titleValue,
                                            onChange: (e)=>setTitleValue(e.target.value),
                                            onBlur: handleSaveProjectName,
                                            onKeyDown: (e)=>e.code === 'Enter' && handleSaveProjectName(),
                                            ref: titleRef,
                                            disabled: currentModule != null
                                        }) : /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $bbf4d3a7fe915e9d$export$c7bd411105e2dec3), {
                                            onClick: handleEditProjectName,
                                            title: t('menubar.edit_title'),
                                            children: projectName ?? t('menubar.untitled')
                                        }),
                                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $bbf4d3a7fe915e9d$export$90442033ec981c61), {
                                            $show: isSaving,
                                            children: t('menubar.saving')
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $bbf4d3a7fe915e9d$export$707d60950b0ce92c), {
                                    children: (0, $1968aeaddea1e933$export$2e2bcd8739ae039)(t).map((item)=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)($a7169d08c7fb682a$var$DropdownButton, {
                                            item: item,
                                            dropdown: dropdown,
                                            setDropdown: setDropdown,
                                            onClick: (e)=>{
                                                setDropdown(dropdown === item.label ? undefined : item.label);
                                                e.stopPropagation();
                                            },
                                            onMouseEnter: ()=>dropdown !== undefined && setDropdown(item.label)
                                        }, item.label))
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $bbf4d3a7fe915e9d$export$b52183d5cfb26dc9), {
                    children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                        onClick: ()=>(0, $ca2884de04f532f3$export$fb20829f6af70575)('showSharing', null),
                        children: t('share')
                    })
                })
            ]
        })
    });
};
var $a7169d08c7fb682a$export$2e2bcd8739ae039 = $a7169d08c7fb682a$var$Menubar;




var $h2ArV = parcelRequire("h2ArV");
const $a3b7de28ad1e6565$var$Sidebar = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('nav')`
  background-color: var(--toolbar);
  color: var(--white);
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 2;

  ${(props)=>props.$tools && `
    & > button {
      min-width: 4rem;
    }
  `}
`;
const $a3b7de28ad1e6565$export$da76e993ddf038d = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('button', (0, $h2ArV.forwardRef))`
  background: none;
  font: inherit;
  color: inherit;
  border: 0;
  cursor: pointer;
  aspect-ratio: 1 / 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  min-width: 3rem;
  gap: .1em;

  &:hover {
    background: var(--surface);
  }

  &:active ${(props)=>props.$active && ',&,&:hover'} {
    background: var(--primary);
  }
`;
var $a3b7de28ad1e6565$export$2e2bcd8739ae039 = $a3b7de28ad1e6565$var$Sidebar;




var $h2ArV = parcelRequire("h2ArV");
/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8a27542e8a20cbdc$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M7 7h10v10",
            key: "1tivn9"
        }
    ],
    [
        "path",
        {
            d: "M7 17 17 7",
            key: "1vkiza"
        }
    ]
];
const $8a27542e8a20cbdc$export$2e2bcd8739ae039 = (0, $764ec6f19a629312$export$2e2bcd8739ae039)("arrow-up-right", $8a27542e8a20cbdc$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $65c5e8bf16e9c608$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m6 9 6 6 6-6",
            key: "qrunsl"
        }
    ]
];
const $65c5e8bf16e9c608$export$2e2bcd8739ae039 = (0, $764ec6f19a629312$export$2e2bcd8739ae039)("chevron-down", $65c5e8bf16e9c608$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $a5e712d7b7a447b6$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ]
];
const $a5e712d7b7a447b6$export$2e2bcd8739ae039 = (0, $764ec6f19a629312$export$2e2bcd8739ae039)("circle", $a5e712d7b7a447b6$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e21351e831545c86$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M18 11V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2",
            key: "1fvzgz"
        }
    ],
    [
        "path",
        {
            d: "M14 10V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v2",
            key: "1kc0my"
        }
    ],
    [
        "path",
        {
            d: "M10 10.5V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2v8",
            key: "10h0bg"
        }
    ],
    [
        "path",
        {
            d: "M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15",
            key: "1s1gnw"
        }
    ]
];
const $e21351e831545c86$export$2e2bcd8739ae039 = (0, $764ec6f19a629312$export$2e2bcd8739ae039)("hand", $e21351e831545c86$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $db653877009fa44e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z",
            key: "1lielz"
        }
    ]
];
const $db653877009fa44e$export$2e2bcd8739ae039 = (0, $764ec6f19a629312$export$2e2bcd8739ae039)("message-square", $db653877009fa44e$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c472c6f2d2b3edc7$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M4.037 4.688a.495.495 0 0 1 .651-.651l16 6.5a.5.5 0 0 1-.063.947l-6.124 1.58a2 2 0 0 0-1.438 1.435l-1.579 6.126a.5.5 0 0 1-.947.063z",
            key: "edeuup"
        }
    ]
];
const $c472c6f2d2b3edc7$export$2e2bcd8739ae039 = (0, $764ec6f19a629312$export$2e2bcd8739ae039)("mouse-pointer-2", $c472c6f2d2b3edc7$export$3efd853dbb351e94);


var $1442674a31386efe$exports = {};
function $1442674a31386efe$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $1442674a31386efe$var$lottie = $1442674a31386efe$var$_interopDefault((parcelRequire("1fEyG")));

var $h2ArV = parcelRequire("h2ArV");
var $1442674a31386efe$var$React__default = $1442674a31386efe$var$_interopDefault($h2ArV);

var $1442674a31386efe$var$equal = $1442674a31386efe$var$_interopDefault((parcelRequire("8LbvY")));

var $1442674a31386efe$var$clone = $1442674a31386efe$var$_interopDefault((parcelRequire("iZdGe")));
function $1442674a31386efe$var$_extends() {
    $1442674a31386efe$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1442674a31386efe$var$_extends.apply(this, arguments);
}
function $1442674a31386efe$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $1442674a31386efe$var$emptyObject = {};
var $1442674a31386efe$var$noOp = function noOp() {
    return undefined;
};
var $1442674a31386efe$var$makeLottiePlayer = function makeLottiePlayer(_ref) {
    var loadAnimation = _ref.loadAnimation;
    var Lottie = $h2ArV.memo($h2ArV.forwardRef(function(params, forwardedRef) {
        var _params$play = params.play, play = _params$play === void 0 ? null : _params$play, _params$speed = params.speed, speed = _params$speed === void 0 ? 1 : _params$speed, _params$direction = params.direction, direction = _params$direction === void 0 ? 1 : _params$direction, _params$segments = params.segments, segmentsIn = _params$segments === void 0 ? null : _params$segments, _params$goTo = params.goTo, goTo = _params$goTo === void 0 ? null : _params$goTo, _params$useSubframes = params.useSubframes, useSubframes = _params$useSubframes === void 0 ? true : _params$useSubframes, _params$renderer = params.renderer, renderer = _params$renderer === void 0 ? 'svg' : _params$renderer, _params$loop = params.loop, loop = _params$loop === void 0 ? true : _params$loop, _params$rendererSetti = params.rendererSettings, rendererSettingsIn = _params$rendererSetti === void 0 ? $1442674a31386efe$var$emptyObject : _params$rendererSetti, audioFactory = params.audioFactory, _params$onLoad = params.onLoad, onLoad = _params$onLoad === void 0 ? $1442674a31386efe$var$noOp : _params$onLoad, _params$onComplete = params.onComplete, onComplete = _params$onComplete === void 0 ? $1442674a31386efe$var$noOp : _params$onComplete, _params$onLoopComplet = params.onLoopComplete, onLoopComplete = _params$onLoopComplet === void 0 ? $1442674a31386efe$var$noOp : _params$onLoopComplet, _params$onEnterFrame = params.onEnterFrame, onEnterFrame = _params$onEnterFrame === void 0 ? $1442674a31386efe$var$noOp : _params$onEnterFrame, _params$onSegmentStar = params.onSegmentStart, onSegmentStart = _params$onSegmentStar === void 0 ? $1442674a31386efe$var$noOp : _params$onSegmentStar, props = $1442674a31386efe$var$_objectWithoutPropertiesLoose(params, [
            "play",
            "speed",
            "direction",
            "segments",
            "goTo",
            "useSubframes",
            "renderer",
            "loop",
            "rendererSettings",
            "audioFactory",
            "onLoad",
            "onComplete",
            "onLoopComplete",
            "onEnterFrame",
            "onSegmentStart"
        ]);
        var propsFiltered = props;
        var animationData;
        var path;
        if ('animationData' in props) {
            var _props = props;
            animationData = _props.animationData;
            propsFiltered = $1442674a31386efe$var$_objectWithoutPropertiesLoose(_props, [
                "animationData"
            ]);
        }
        if ('path' in props) {
            var _props2 = props;
            path = _props2.path;
            propsFiltered = $1442674a31386efe$var$_objectWithoutPropertiesLoose(_props2, [
                "path"
            ]);
        }
        var animElementRef = $h2ArV.useRef(null);
        var animRef = $h2ArV.useRef();
        var getAnim = $h2ArV.useCallback(function() {
            if (animRef.current == null) throw new Error('Lottie ref is not set');
            return animRef.current;
        }, []);
        var _useState = $h2ArV.useState(false), ready = _useState[0], setReady = _useState[1];
        var _useState2 = $h2ArV.useState(segmentsIn), segments = _useState2[0], setSegments = _useState2[1];
        $h2ArV.useEffect(function() {
            if (!$1442674a31386efe$var$equal(segments, segmentsIn)) setSegments(segmentsIn);
        }, [
            segmentsIn,
            segments
        ]);
        var _useState3 = $h2ArV.useState(rendererSettingsIn), rendererSettings = _useState3[0], setRendererSettings = _useState3[1];
        $h2ArV.useEffect(function() {
            if (!$1442674a31386efe$var$equal(rendererSettings, rendererSettingsIn)) setRendererSettings(rendererSettingsIn);
        }, [
            rendererSettingsIn,
            rendererSettings
        ]);
        $h2ArV.useEffect(function() {
            return function() {
                return getAnim().removeEventListener('complete', onComplete);
            };
        }, [
            getAnim,
            onComplete
        ]);
        $h2ArV.useEffect(function() {
            return function() {
                return getAnim().removeEventListener('loopComplete', onLoopComplete);
            };
        }, [
            getAnim,
            onLoopComplete
        ]);
        $h2ArV.useEffect(function() {
            return function() {
                return getAnim().removeEventListener('enterFrame', onEnterFrame);
            };
        }, [
            getAnim,
            onEnterFrame
        ]);
        $h2ArV.useEffect(function() {
            return function() {
                return getAnim().removeEventListener('segmentStart', onSegmentStart);
            };
        }, [
            getAnim,
            onSegmentStart
        ]);
        $h2ArV.useEffect(function() {
            return function() {
                return getAnim().removeEventListener('DOMLoaded', onLoad);
            };
        }, [
            getAnim,
            onLoad
        ]);
        var setLottieRefs = $h2ArV.useCallback(function(newRef) {
            animRef.current = newRef;
            if (typeof forwardedRef === 'function') forwardedRef(newRef);
            else if (forwardedRef !== undefined && forwardedRef !== null) forwardedRef.current = newRef;
        }, [
            forwardedRef
        ]);
        $h2ArV.useEffect(function() {
            function parseAnimationData() {
                if (animationData == null || typeof animationData !== 'object') return animationData;
                if ('default' in animationData && typeof animationData["default"] === 'object') return $1442674a31386efe$var$clone(animationData["default"]);
                return $1442674a31386efe$var$clone(animationData);
            }
            if (animElementRef.current == null) throw new Error('animElementRef is not set');
            var lottie = loadAnimation($1442674a31386efe$var$_extends({
                animationData: parseAnimationData(),
                path: path,
                container: animElementRef.current,
                renderer: renderer,
                loop: false,
                autoplay: false,
                rendererSettings: rendererSettings
            }, audioFactory ? {
                audioFactory: audioFactory
            } : {}));
            setLottieRefs(lottie);
            var onDomLoaded = function onDomLoaded() {
                return setReady(true);
            };
            getAnim().addEventListener('DOMLoaded', onDomLoaded);
            return function() {
                getAnim().removeEventListener('DOMLoaded', onDomLoaded);
                setReady(false);
                getAnim().destroy();
                setLottieRefs(undefined);
            };
        }, [
            loop,
            renderer,
            rendererSettings,
            animationData,
            path,
            audioFactory,
            setLottieRefs,
            getAnim
        ]);
        $h2ArV.useEffect(function() {
            getAnim().addEventListener('DOMLoaded', onLoad);
        }, [
            getAnim,
            onLoad
        ]);
        $h2ArV.useEffect(function() {
            getAnim().addEventListener('complete', onComplete);
        }, [
            getAnim,
            onComplete
        ]);
        $h2ArV.useEffect(function() {
            getAnim().addEventListener('loopComplete', onLoopComplete);
        }, [
            getAnim,
            onLoopComplete
        ]);
        $h2ArV.useEffect(function() {
            getAnim().addEventListener('enterFrame', onEnterFrame);
        }, [
            getAnim,
            onEnterFrame
        ]);
        $h2ArV.useEffect(function() {
            getAnim().addEventListener('segmentStart', onSegmentStart);
        }, [
            getAnim,
            onSegmentStart
        ]);
        $h2ArV.useEffect(function() {
            if (!ready) return;
            getAnim().loop = loop;
        }, [
            ready,
            loop,
            getAnim
        ]);
        var wasPlayingSegmentsRef = $h2ArV.useRef(false);
        $h2ArV.useEffect(function() {
            if (!ready) return;
            function playReverse(lastFrame) {
                getAnim().goToAndPlay(lastFrame, true);
                getAnim().setDirection(direction);
            }
            if (play === true) {
                var force = true;
                if (segments) {
                    getAnim().playSegments(segments, force);
                    wasPlayingSegmentsRef.current = true;
                    if (direction === -1) {
                        var lastFrame = typeof segments[1] === 'number' ? segments[1] : segments[1][1];
                        playReverse(lastFrame);
                    }
                } else {
                    if (wasPlayingSegmentsRef.current) getAnim().resetSegments(force);
                    wasPlayingSegmentsRef.current = false;
                    if (direction === -1) {
                        var _lastFrame = getAnim().getDuration(true);
                        playReverse(_lastFrame);
                    } else getAnim().play();
                }
            } else if (play === false) getAnim().pause();
        }, [
            play,
            segments,
            ready,
            direction,
            getAnim
        ]);
        $h2ArV.useEffect(function() {
            if (!ready) return;
            if (Number.isNaN(speed)) return;
            getAnim().setSpeed(speed);
        }, [
            speed,
            ready,
            getAnim
        ]);
        $h2ArV.useEffect(function() {
            if (!ready) return;
            getAnim().setDirection(direction);
        }, [
            direction,
            getAnim,
            ready
        ]);
        $h2ArV.useEffect(function() {
            if (!ready) return;
            if (goTo == null) return;
            var isFrame = true;
            if (play) getAnim().goToAndPlay(goTo, isFrame);
            else getAnim().goToAndStop(goTo, isFrame);
        }, [
            getAnim,
            goTo,
            play,
            ready
        ]);
        $h2ArV.useEffect(function() {
            if (getAnim().setSubframe) getAnim().setSubframe(useSubframes);
        }, [
            getAnim,
            useSubframes
        ]);
        return /*#__PURE__*/ $1442674a31386efe$var$React__default.createElement("div", $1442674a31386efe$var$_extends({}, propsFiltered, {
            ref: animElementRef
        }));
    }));
    return Lottie;
};
var $1442674a31386efe$var$LottiePlayerLight = $1442674a31386efe$var$makeLottiePlayer($1442674a31386efe$var$lottie);
$1442674a31386efe$exports = $1442674a31386efe$var$LottiePlayerLight;






const $45274391c854412e$export$581786309c1927ec = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  background: var(--toolbar);
  border-radius: .3em;
  overflow: hidden;
  position: fixed;
  top: ${(props)=>props.$y ?? 85}px;
  left: 5rem;
  z-index: 5;
  max-width: 225px;
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
  transition: opacity .15s, visibility .15s;
  box-shadow: 0 2px 5px rgba(0 0 0 / .3);

  &.visible {
    opacity: 1;
    visibility: visible;
  }

  & > div {
    padding: .6em .8em;

    & > span {
      font-size: .875em;
    }
  }
`;
const $45274391c854412e$export$523e40ee5aaa0bfd = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  align-items: center;
  gap: .5em;
  margin-block-end: .2em;
  font-weight: 600;
`;
const $45274391c854412e$export$76be3b1f11287f58 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('span')`
  font-weight: 400;
  display: inline-block;
  padding: .2em .4em;
  color: var(--input-border);
  border: 1px solid currentColor;
  border-radius: .3em;
  font-size: .7em;
`;
const $45274391c854412e$export$c35d437ae5945fcd = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('span')`
  display: block;
  background-color: var(--input-border);

  & > div {
    width: 100%;

    svg {
      display: block;
    }
  }
`;


var $796f04347b90ea04$exports = {};
$796f04347b90ea04$exports = JSON.parse("{\"v\":\"5.9.0\",\"fr\":30,\"ip\":0,\"op\":210,\"w\":600,\"h\":300,\"nm\":\"Cursor animation\",\"ddd\":0,\"assets\":[],\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":4,\"nm\":\"Select box\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":90.09,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":91.091,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":126.126,\"s\":[100]},{\"t\":127.126953125,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[72,137,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[-228,-13,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":90.09,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-224.617,-92],[-224.219,-92.023],[-223.984,-92.262],[-224.383,-92.238]],\"c\":true}]},{\"t\":118,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[235.358,-91.532],[235.482,61.935],[-224.259,61.229],[-224.383,-92.238]],\"c\":true}]}],\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[0,0,0,1],\"ix\":3},\"o\":{\"a\":0,\"k\":100,\"ix\":4},\"w\":{\"a\":0,\"k\":3,\"ix\":5},\"lc\":2,\"lj\":2,\"bm\":0,\"nm\":\"Stroke 1\",\"mn\":\"ADBE Vector Graphic - Stroke\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0,0,1],\"ix\":4},\"o\":{\"a\":0,\"k\":13,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[-228.973,-11.918],\"ix\":2},\"a\":{\"a\":0,\"k\":[-224.355,-90.156],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Rectangle 1\",\"np\":3,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":899.8998998999,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":4,\"nm\":\"Cursor\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":0,\"s\":[-74,204,0],\"to\":[42.167,-21,0],\"ti\":[-42.167,21,0]},{\"i\":{\"x\":0.667,\"y\":0.667},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":27.027,\"s\":[179,78,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":42.042,\"s\":[179,78,0],\"to\":[0,24.167,0],\"ti\":[0,-24.167,0]},{\"i\":{\"x\":0.667,\"y\":0.667},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":57.057,\"s\":[179,223,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":65.065,\"s\":[179,223,0],\"to\":[-18,-14.667,0],\"ti\":[18,14.667,0]},{\"i\":{\"x\":0.667,\"y\":0.667},\"o\":{\"x\":0.333,\"y\":0.333},\"t\":81.081,\"s\":[71,135,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":90.09,\"s\":[71,135,0],\"to\":[76.167,25.333,0],\"ti\":[-76.167,-25.333,0]},{\"i\":{\"x\":0.667,\"y\":0.667},\"o\":{\"x\":0.333,\"y\":0.333},\"t\":118.118,\"s\":[528,287,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":140.141,\"s\":[528,287,0],\"to\":[-17.833,-10.833,0],\"ti\":[17.833,10.833,0]},{\"i\":{\"x\":0.667,\"y\":0.667},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":158.158,\"s\":[421,222,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":166.166,\"s\":[421,222,0],\"to\":[0,-12.167,0],\"ti\":[0,12.167,0]},{\"t\":181.181640625,\"s\":[421,149,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[-0.321,-0.771],[0,0],[-0.277,0.817],[0,0],[-0.274,0.094],[0,0],[0.796,0.331],[0,0]],\"o\":[[0,0],[0.331,0.797],[0,0],[0.093,-0.275],[0,0],[0.815,-0.28],[0,0],[-0.771,-0.321]],\"v\":[[-16.743,-15.516],[-3.527,16.262],[-1.777,16.204],[2.618,3.268],[3.201,2.684],[16.212,-1.77],[16.268,-3.52],[-15.52,-16.738]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0,0,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[17.314,17.31],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":899.8998998999,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":4,\"nm\":\"State 2\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"t\":167,\"s\":[420.649,222.6,0],\"h\":1},{\"t\":173,\"s\":[420.649,198.45,0],\"h\":1},{\"t\":175,\"s\":[420.649,174.3,0],\"h\":1},{\"t\":179,\"s\":[420.649,150.15,0],\"h\":1}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[50.936,50.936,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[27.993,0],[0,-27.993],[-27.993,0],[0,27.993]],\"o\":[[-27.993,0],[0,27.993],[27.993,0],[0,-27.993]],\"v\":[[0,-50.686],[-50.686,0],[0,50.686],[50.686,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":1,\"ty\":\"sh\",\"ix\":2,\"ks\":{\"a\":0,\"k\":{\"i\":[[-25.743,0],[0,-25.743],[25.743,0],[0,25.743]],\"o\":[[25.743,0],[0,25.743],[-25.743,0],[0,-25.743]],\"v\":[[0,-46.686],[46.686,0],[0,46.686],[-46.686,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 2\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"mm\",\"mm\":1,\"nm\":\"Merge Paths 1\",\"mn\":\"ADBE Vector Filter - Merge\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":126.126,\"s\":[0,0,0,1]},{\"t\":127.126953125,\"s\":[0.92549020052,0.607843160629,0.082352943718,1]}],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[50.936,50.936],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":6,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[26.845,0],[0,26.846],[-26.846,0],[0,-26.845]],\"o\":[[-26.846,0],[0,-26.845],[26.845,0],[0,26.846]],\"v\":[[0,48.686],[-48.686,0],[0,-48.686],[48.686,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":126.126,\"s\":[0.960784373564,0.807843197093,0.541176470588,1]},{\"t\":127.126953125,\"s\":[0.89411765337,0.713725507259,0.403921574354,1]}],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[50.936,50.936],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":899.8998998999,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":4,\"nm\":\"State 1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"t\":42,\"s\":[179.35,77.7,0],\"h\":1},{\"t\":44,\"s\":[179.35,101.85,0],\"h\":1},{\"t\":46,\"s\":[179.35,126,0],\"h\":1},{\"t\":48,\"s\":[179.35,150.15,0],\"h\":1},{\"t\":49,\"s\":[179.35,174.3,0],\"h\":1},{\"t\":52,\"s\":[179.35,198.45,0],\"h\":1},{\"t\":54,\"s\":[179.35,222.6,0],\"h\":1},{\"t\":167,\"s\":[179.35,222.559,0],\"h\":1},{\"t\":173,\"s\":[179.351,198.45,0],\"h\":1},{\"t\":175,\"s\":[179.351,174.3,0],\"h\":1},{\"t\":179,\"s\":[179.351,150.15,0],\"h\":1}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[50.936,50.936,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[27.993,0],[0,-27.993],[-27.993,0],[0,27.993]],\"o\":[[-27.993,0],[0,27.993],[27.993,0],[0,-27.993]],\"v\":[[0,-50.686],[-50.686,0],[0,50.686],[50.686,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":1,\"ty\":\"sh\",\"ix\":2,\"ks\":{\"a\":0,\"k\":{\"i\":[[-25.743,0],[0,-25.743],[25.743,0],[0,25.743]],\"o\":[[25.743,0],[0,25.743],[-25.743,0],[0,-25.743]],\"v\":[[0,-46.686],[46.686,0],[0,46.686],[-46.686,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 2\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"mm\",\"mm\":1,\"nm\":\"Merge Paths 1\",\"mn\":\"ADBE Vector Filter - Merge\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":35.035,\"s\":[0,0,0,1]},{\"t\":36.0361328125,\"s\":[0.92549020052,0.607843160629,0.082352943718,1]}],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[50.936,50.936],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":6,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[26.846,0],[0,26.845],[-26.846,0],[0,-26.846]],\"o\":[[-26.846,0],[0,-26.846],[26.846,0],[0,26.845]],\"v\":[[0,48.686],[-48.686,0],[0,-48.686],[48.686,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":35.035,\"s\":[0.960784373564,0.807843197093,0.541176470588,1]},{\"t\":36.0361328125,\"s\":[0.89411765337,0.713725507259,0.403921574354,1]}],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[50.936,50.936],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":899.8998998999,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":5,\"ty\":4,\"nm\":\"Grid\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[300,150,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[300.25,200.25,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 3\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":3,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 4\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":4,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 5\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":5,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 6\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":6,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 7\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":7,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 8\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":8,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 9\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":9,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 10\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":10,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 11\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":11,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 12\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":12,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 13\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":13,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 14\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":14,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 15\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":15,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 16\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":16,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 17\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":17,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 18\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":18,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 19\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":19,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 20\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":20,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 21\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":21,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 22\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":22,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 23\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":23,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 24\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":24,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 25\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":25,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 26\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":26,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 27\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":27,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 28\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":28,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 29\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":29,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 30\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":30,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 31\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":31,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 32\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":32,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 33\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":33,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 34\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":34,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 35\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":35,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 36\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":36,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 37\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":37,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 38\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":38,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 39\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":39,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 40\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":40,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 41\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":41,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 42\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":42,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 43\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":43,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 44\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":44,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 45\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":45,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 46\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":46,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 47\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":47,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 48\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":48,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 49\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":49,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 50\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":50,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 51\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":51,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 52\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":52,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 53\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":53,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 54\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":54,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 55\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":55,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 56\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":56,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 57\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":57,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 58\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":58,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 59\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":59,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 60\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":60,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 61\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":61,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 62\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":62,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 63\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":63,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 64\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":64,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 65\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":65,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 66\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":66,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 67\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":67,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 68\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":68,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 69\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":69,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 70\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":70,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 71\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":71,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 72\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":72,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 73\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":73,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 74\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":74,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 75\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":75,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 76\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":76,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 77\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":77,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 78\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":78,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 79\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":79,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 80\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":80,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 81\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":81,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 82\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":82,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 83\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":83,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 84\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":84,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 85\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":85,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 86\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":86,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 87\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":87,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 88\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":88,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 89\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":89,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 90\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":90,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 91\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":91,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 92\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":92,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 93\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":93,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 94\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":94,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 95\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":95,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 96\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":96,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-300,200],[300,200],[300,-200],[-300,-200]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.980392216701,0.980392216701,0.980392216701,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[300.25,200.25],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 97\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":97,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":899.8998998999,\"st\":0,\"bm\":0}],\"markers\":[]}");


var $6eb38acfac99e87a$exports = {};
$6eb38acfac99e87a$exports = JSON.parse("{\"v\":\"5.9.0\",\"fr\":60,\"ip\":0,\"op\":397,\"w\":600,\"h\":300,\"nm\":\"Hand_animation\",\"ddd\":0,\"assets\":[],\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":4,\"nm\":\"Cursor Outlines\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":9,\"s\":[376.179,-26.244,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":0.667},\"o\":{\"x\":0.333,\"y\":0.333},\"t\":65,\"s\":[531.429,145.006,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":87,\"s\":[531.429,145.006,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":0.667},\"o\":{\"x\":0.333,\"y\":0.333},\"t\":144,\"s\":[344.929,60.506,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":185,\"s\":[344.929,60.506,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":0.667},\"o\":{\"x\":0.333,\"y\":0.333},\"t\":230,\"s\":[511.429,82.506,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":258,\"s\":[511.429,82.506,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":331,\"s\":[286.429,256.006,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[22.653,22.007,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[2.017,0],[0,-2.016],[0,0],[0,0],[0,0],[2.017,0],[0,-2.017],[0,0],[0,0],[0,0],[1.394,-1.259],[-1.351,-1.497],[0,0],[-5.112,0],[0,0],[0,8.067],[0,0],[2.016,0],[0,-2.016],[0,0],[0,0],[2.016,0],[0,-2.017]],\"o\":[[0,0],[0,-2.016],[-2.016,0],[0,0],[0,0],[0,0],[0,-2.017],[-2.016,0],[0,0],[0,0],[0,0],[-1.389,-1.263],[-1.496,1.351],[0,0],[2.721,2.702],[0,0],[8.067,0],[0,0],[0,-2.016],[-2.017,0],[0,0],[0,0],[0,-2.017],[-2.017,0],[0,0]],\"v\":[[3.953,-3.652],[3.953,-14.607],[0.301,-18.258],[-3.35,-14.607],[-3.35,-10.954],[-3.35,-2.738],[-3.35,-10.954],[-7.002,-14.607],[-10.653,-10.954],[-10.653,3.651],[-8.827,5.478],[-12.041,2.263],[-16.945,2.255],[-17.208,7.413],[-10.635,13.986],[0.301,18.258],[3.953,18.258],[18.559,3.651],[18.559,-7.303],[14.908,-10.954],[11.256,-7.303],[11.256,-1.826],[11.256,-10.954],[7.605,-14.607],[3.953,-10.952]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[0,0,0,1],\"ix\":3},\"o\":{\"a\":0,\"k\":100,\"ix\":4},\"w\":{\"a\":0,\"k\":2,\"ix\":5},\"lc\":2,\"lj\":2,\"bm\":0,\"nm\":\"Stroke 1\",\"mn\":\"ADBE Vector Graphic - Stroke\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[21.559,20.133],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":1,\"k\":[{\"t\":9,\"s\":[100],\"h\":1},{\"t\":73,\"s\":[0],\"h\":1},{\"t\":163,\"s\":[100],\"h\":1},{\"t\":249,\"s\":[0],\"h\":1},{\"t\":340,\"s\":[100],\"h\":1}],\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 3\",\"np\":3,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[-2.028,0],[0,-2.027],[0,0],[8.11,0],[0,0],[0,8.11],[-2.027,0],[0,-2.027],[0,0],[-2.027,0],[0,-2.027],[0,0],[0,0],[0,0],[-2.028,0],[0,-2.028],[0,0],[0,0],[0,0],[-2.027,0],[0,-2.027],[0,0]],\"o\":[[0,0],[0,-2.027],[2.027,0],[0,0],[0,8.11],[0,0],[-8.11,0],[0,-2.027],[2.028,0],[0,0],[0,-2.027],[2.027,0],[0,0],[0,0],[0,0],[0,-2.028],[2.027,0],[0,0],[0,0],[0,0],[0,-2.027],[2.028,0],[0,0],[0,0]],\"v\":[[11.012,-5.506],[11.012,-5.506],[14.683,-9.177],[18.354,-5.506],[18.354,0],[3.67,14.683],[-3.671,14.683],[-18.354,0],[-14.684,-3.671],[-11.013,0],[-11.013,-9.177],[-7.342,-12.848],[-3.671,-9.177],[-3.671,-7.525],[-3.671,-7.341],[-3.671,-11.012],[0,-14.683],[3.67,-11.012],[3.67,-7.341],[3.67,-6.607],[3.67,-9.177],[7.341,-12.848],[11.012,-9.177],[11.012,-4.588]],\"c\":false},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[0,0,0,1],\"ix\":3},\"o\":{\"a\":0,\"k\":100,\"ix\":4},\"w\":{\"a\":0,\"k\":2,\"ix\":5},\"lc\":2,\"lj\":2,\"bm\":0,\"nm\":\"Stroke 1\",\"mn\":\"ADBE Vector Graphic - Stroke\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[21.951,23.832],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":1,\"k\":[{\"t\":9,\"s\":[0],\"h\":1},{\"t\":73,\"s\":[100],\"h\":1},{\"t\":163,\"s\":[0],\"h\":1},{\"t\":249,\"s\":[100],\"h\":1},{\"t\":340,\"s\":[0],\"h\":1}],\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":3,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":420,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":4,\"nm\":\"Background Outlines\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":87,\"s\":[531.429,145.006,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":0.667},\"o\":{\"x\":0.333,\"y\":0.333},\"t\":144,\"s\":[344.929,60.506,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":258,\"s\":[344.929,60.506,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":331,\"s\":[119.929,234.006,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[559.665,512.662,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0]],\"o\":[[0,0],[0,0]],\"v\":[[-111.126,106.404],[111.126,-106.404]],\"c\":false},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[0,0,0,1],\"ix\":3},\"o\":{\"a\":0,\"k\":100,\"ix\":4},\"w\":{\"a\":0,\"k\":4,\"ix\":5},\"lc\":1,\"lj\":1,\"ml\":10,\"bm\":0,\"nm\":\"Stroke 1\",\"mn\":\"ADBE Vector Graphic - Stroke\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[716.414,493.605],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0]],\"v\":[[11.996,-11.993],[2.926,11.993],[-11.995,-3.271]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0,0,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[826.283,388.912],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0]],\"v\":[[12.821,9.455],[-12.822,9.724],[-4.025,-9.724]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0,0,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[514.514,605.059],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 3\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":3,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0]],\"o\":[[0,0],[0,0]],\"v\":[[-112.352,-50.324],[112.352,50.324]],\"c\":false},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[0,0,0,1],\"ix\":3},\"o\":{\"a\":0,\"k\":100,\"ix\":4},\"w\":{\"a\":0,\"k\":4,\"ix\":5},\"lc\":1,\"lj\":1,\"ml\":10,\"bm\":0,\"nm\":\"Stroke 1\",\"mn\":\"ADBE Vector Graphic - Stroke\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[402.161,558.472],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 4\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":4,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[27.993,0],[0,-27.993],[-27.993,0],[0,27.993]],\"o\":[[-27.993,0],[0,27.993],[27.993,0],[0,-27.993]],\"v\":[[0,-50.686],[-50.686,0],[0,50.686],[50.686,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":1,\"ty\":\"sh\",\"ix\":2,\"ks\":{\"a\":0,\"k\":{\"i\":[[-25.743,0],[0,-25.743],[25.743,0],[0,25.743]],\"o\":[[25.743,0],[0,25.743],[-25.743,0],[0,-25.743]],\"v\":[[0,-46.686],[46.686,0],[0,46.686],[-46.686,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 2\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"mm\",\"mm\":1,\"nm\":\"Merge Paths 1\",\"mn\":\"ADBE Vector Filter - Merge\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0,0,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[873.354,343.334],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 5\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":5,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[26.845,0],[0,26.846],[-26.846,0],[0,-26.845]],\"o\":[[-26.846,0],[0,-26.845],[26.845,0],[0,26.846]],\"v\":[[0,48.686],[-48.686,0],[0,-48.686],[48.686,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.960784373564,0.807843197093,0.541176470588,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[873.354,343.333],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 6\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":6,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[27.993,0],[0,-27.993],[-27.993,0],[0,27.993]],\"o\":[[-27.993,0],[0,27.993],[27.993,0],[0,-27.993]],\"v\":[[0,-50.686],[-50.686,0],[0,50.686],[50.686,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":1,\"ty\":\"sh\",\"ix\":2,\"ks\":{\"a\":0,\"k\":{\"i\":[[-25.743,0],[0,-25.743],[25.743,0],[0,25.743]],\"o\":[[25.743,0],[0,25.743],[-25.743,0],[0,-25.743]],\"v\":[[0,-46.686],[46.686,0],[0,46.686],[-46.686,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 2\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"mm\",\"mm\":1,\"nm\":\"Merge Paths 1\",\"mn\":\"ADBE Vector Filter - Merge\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0,0,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[570.106,633.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 7\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":7,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[26.845,0],[0,26.846],[-26.846,0],[0,-26.845]],\"o\":[[-26.846,0],[0,-26.845],[26.845,0],[0,26.846]],\"v\":[[0,48.686],[-48.686,0],[0,-48.686],[48.686,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.960784373564,0.807843197093,0.541176470588,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[570.106,633.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 8\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":8,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[27.993,0],[0,-27.993],[-27.993,0],[0,27.993]],\"o\":[[-27.993,0],[0,27.993],[27.993,0],[0,-27.993]],\"v\":[[0,-50.686],[-50.686,0],[0,50.686],[50.686,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":1,\"ty\":\"sh\",\"ix\":2,\"ks\":{\"a\":0,\"k\":{\"i\":[[-25.743,0],[0,-25.743],[25.743,0],[0,25.743]],\"o\":[[25.743,0],[0,25.743],[-25.743,0],[0,-25.743]],\"v\":[[0,-46.686],[46.686,0],[0,46.686],[-46.686,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 2\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"mm\",\"mm\":1,\"nm\":\"Merge Paths 1\",\"mn\":\"ADBE Vector Filter - Merge\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0,0,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[245.976,488.515],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 9\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":9,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[26.846,0],[0,26.845],[-26.846,0],[0,-26.846]],\"o\":[[-26.846,0],[0,-26.846],[26.846,0],[0,26.845]],\"v\":[[0,48.686],[-48.686,0],[0,-48.686],[48.686,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.960784373564,0.807843197093,0.541176470588,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[245.976,488.515],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 10\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":10,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[535.535,295.04],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 11\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":11,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[535.535,246.446],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 12\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":12,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[535.535,198.452],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 13\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":13,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[535.535,149.858],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 14\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":14,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[535.535,101.564],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 15\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":15,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[535.535,52.971],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 16\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":16,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[535.535,4.677],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 17\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":17,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[487.275,295.04],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 18\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":18,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[439.015,295.04],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 19\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":19,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[390.755,295.04],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 20\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":20,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[342.496,295.04],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 21\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":21,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[294.236,295.04],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 22\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":22,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[245.976,295.04],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 23\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":23,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[197.716,295.04],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 24\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":24,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[149.456,295.04],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 25\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":25,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[101.197,295.04],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 26\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":26,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[52.937,295.04],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 27\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":27,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[4.677,295.04],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 28\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":28,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[487.275,246.446],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 29\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":29,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[439.015,246.446],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 30\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":30,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[390.755,246.446],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 31\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":31,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[342.496,246.446],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 32\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":32,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[294.236,246.446],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 33\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":33,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[245.976,246.446],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 34\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":34,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[197.716,246.446],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 35\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":35,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[149.456,246.446],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 36\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":36,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[101.197,246.446],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 37\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":37,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[52.937,246.446],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 38\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":38,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[4.677,246.446],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 39\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":39,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[487.275,198.452],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 40\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":40,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[439.015,198.452],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 41\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":41,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[390.755,198.452],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 42\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":42,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[342.496,198.452],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 43\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":43,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[294.236,198.452],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 44\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":44,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[245.976,198.452],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 45\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":45,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[197.716,198.452],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 46\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":46,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[149.456,198.452],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 47\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":47,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[101.197,198.452],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 48\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":48,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[52.937,198.452],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 49\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":49,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[4.677,198.452],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 50\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":50,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[487.275,149.858],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 51\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":51,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[439.015,149.858],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 52\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":52,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[390.755,149.858],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 53\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":53,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[342.496,149.858],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 54\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":54,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[294.236,149.858],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 55\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":55,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[245.976,149.858],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 56\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":56,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[197.716,149.858],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 57\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":57,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[149.456,149.858],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 58\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":58,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[101.197,149.858],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 59\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":59,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[52.937,149.858],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 60\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":60,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[4.677,149.858],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 61\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":61,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[487.275,101.564],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 62\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":62,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[439.015,101.564],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 63\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":63,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[390.755,101.564],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 64\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":64,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[342.496,101.564],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 65\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":65,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[294.236,101.564],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 66\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":66,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[245.976,101.564],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 67\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":67,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[197.716,101.564],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 68\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":68,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[149.456,101.564],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 69\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":69,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[101.197,101.564],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 70\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":70,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[52.937,101.564],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 71\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":71,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[4.677,101.564],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 72\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":72,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[487.275,52.971],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 73\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":73,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[439.015,52.971],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 74\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":74,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[390.755,52.971],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 75\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":75,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[342.496,52.971],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 76\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":76,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[294.236,52.971],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 77\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":77,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[245.976,52.971],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 78\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":78,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[197.716,52.971],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 79\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":79,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[149.456,52.971],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 80\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":80,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[101.197,52.971],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 81\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":81,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[52.937,52.971],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 82\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":82,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[4.677,52.971],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 83\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":83,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[487.275,4.677],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 84\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":84,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[439.015,4.677],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 85\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":85,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[390.755,4.677],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 86\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":86,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[342.496,4.677],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 87\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":87,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[294.236,4.677],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 88\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":88,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[245.976,4.677],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 89\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":89,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[197.716,4.677],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 90\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":90,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[149.456,4.677],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 91\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":91,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[101.197,4.677],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 92\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":92,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[52.937,4.677],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 93\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":93,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[4.677,4.677],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 94\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":94,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1114.653,1020.647],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 95\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":95,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1114.653,972.353],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 96\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":96,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1114.653,923.76],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 97\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":97,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1114.653,875.765],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 98\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":98,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1114.653,827.172],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 99\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":99,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1114.653,778.878],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 100\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":100,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1114.653,730.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 101\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":101,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1066.393,1020.647],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 102\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":102,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1018.133,1020.647],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 103\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":103,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[969.873,1020.647],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 104\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":104,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[921.613,1020.647],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 105\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":105,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[873.354,1020.647],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 106\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":106,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[825.094,1020.647],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 107\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":107,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[776.834,1020.647],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 108\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":108,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[728.574,1020.647],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 109\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":109,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[680.314,1020.647],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 110\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":110,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[632.055,1020.647],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 111\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":111,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[583.795,1020.647],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 112\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":112,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1066.393,972.353],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 113\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":113,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1018.133,972.353],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 114\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":114,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[969.873,972.353],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 115\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":115,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[921.613,972.353],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 116\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":116,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[873.354,972.353],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 117\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":117,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[825.094,972.353],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 118\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":118,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[776.834,972.353],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 119\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":119,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[728.574,972.353],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 120\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":120,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[680.314,972.353],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 121\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":121,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[632.055,972.353],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 122\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":122,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[583.795,972.353],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 123\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":123,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1066.393,923.76],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 124\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":124,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1018.133,923.76],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 125\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":125,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[969.873,923.76],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 126\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":126,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[921.613,923.76],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 127\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":127,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[873.354,923.76],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 128\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":128,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[825.094,923.76],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 129\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":129,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[776.834,923.76],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 130\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":130,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[728.574,923.76],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 131\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":131,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[680.314,923.76],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 132\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":132,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[632.055,923.76],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 133\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":133,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[583.795,923.76],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 134\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":134,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1066.393,875.765],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 135\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":135,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1018.133,875.765],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 136\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":136,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[969.873,875.765],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 137\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":137,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[921.613,875.765],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 138\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":138,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[873.354,875.765],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 139\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":139,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[825.094,875.765],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 140\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":140,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[776.834,875.765],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 141\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":141,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[728.574,875.765],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 142\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":142,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[680.314,875.765],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 143\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":143,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[632.055,875.765],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 144\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":144,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[583.795,875.765],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 145\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":145,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1066.393,827.172],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 146\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":146,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1018.133,827.172],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 147\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":147,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[969.873,827.172],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 148\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":148,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[921.613,827.172],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 149\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":149,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[873.354,827.172],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 150\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":150,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[825.094,827.172],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 151\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":151,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[776.834,827.172],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 152\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":152,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[728.574,827.172],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 153\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":153,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[680.314,827.172],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 154\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":154,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[632.055,827.172],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 155\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":155,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[583.795,827.172],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 156\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":156,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1066.393,778.878],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 157\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":157,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1018.133,778.878],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 158\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":158,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[969.873,778.878],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 159\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":159,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[921.613,778.878],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 160\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":160,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[873.354,778.878],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 161\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":161,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[825.094,778.878],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 162\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":162,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[776.834,778.878],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 163\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":163,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[728.574,778.878],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 164\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":164,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[680.314,778.878],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 165\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":165,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[632.055,778.878],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 166\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":166,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[583.795,778.878],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 167\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":167,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1066.393,730.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 168\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":168,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1018.133,730.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 169\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":169,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[969.873,730.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 170\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":170,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[921.613,730.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 171\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":171,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[873.354,730.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 172\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":172,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[825.094,730.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 173\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":173,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[776.834,730.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 174\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":174,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[728.574,730.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 175\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":175,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[680.314,730.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 176\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":176,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[632.055,730.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 177\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":177,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[583.795,730.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 178\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":178,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[535.535,1020.647],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 179\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":179,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[535.535,972.353],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 180\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":180,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[535.535,923.76],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 181\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":181,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[535.535,875.765],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 182\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":182,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[535.535,827.172],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 183\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":183,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[535.535,778.878],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 184\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":184,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[535.535,730.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 185\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":185,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[487.275,1020.647],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 186\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":186,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[439.015,1020.647],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 187\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":187,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[390.755,1020.647],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 188\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":188,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[342.496,1020.647],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 189\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":189,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[294.236,1020.647],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 190\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":190,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[245.976,1020.647],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 191\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":191,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[197.716,1020.647],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 192\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":192,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[149.456,1020.647],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 193\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":193,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[101.197,1020.647],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 194\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":194,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[52.937,1020.647],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 195\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":195,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[4.677,1020.647],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 196\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":196,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[487.275,972.353],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 197\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":197,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[439.015,972.353],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 198\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":198,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[390.755,972.353],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 199\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":199,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[342.496,972.353],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 200\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":200,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[294.236,972.353],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 201\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":201,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[245.976,972.353],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 202\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":202,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[197.716,972.353],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 203\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":203,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[149.456,972.353],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 204\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":204,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[101.197,972.353],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 205\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":205,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[52.937,972.353],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 206\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":206,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[4.677,972.353],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 207\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":207,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[487.275,923.76],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 208\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":208,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[439.015,923.76],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 209\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":209,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[390.755,923.76],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 210\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":210,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[342.496,923.76],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 211\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":211,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[294.236,923.76],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 212\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":212,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[245.976,923.76],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 213\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":213,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[197.716,923.76],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 214\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":214,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[149.456,923.76],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 215\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":215,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[101.197,923.76],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 216\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":216,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[52.937,923.76],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 217\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":217,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[4.677,923.76],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 218\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":218,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[487.275,875.765],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 219\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":219,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[439.015,875.765],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 220\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":220,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[390.755,875.765],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 221\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":221,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[342.496,875.765],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 222\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":222,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[294.236,875.765],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 223\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":223,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[245.976,875.765],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 224\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":224,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[197.716,875.765],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 225\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":225,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[149.456,875.765],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 226\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":226,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[101.197,875.765],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 227\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":227,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[52.937,875.765],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 228\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":228,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[4.677,875.765],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 229\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":229,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[487.275,827.172],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 230\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":230,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[439.015,827.172],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 231\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":231,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[390.755,827.172],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 232\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":232,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[342.496,827.172],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 233\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":233,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[294.236,827.172],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 234\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":234,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[245.976,827.172],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 235\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":235,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[197.716,827.172],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 236\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":236,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[149.456,827.172],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 237\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":237,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[101.197,827.172],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 238\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":238,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[52.937,827.172],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 239\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":239,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[4.677,827.172],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 240\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":240,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[487.275,778.878],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 241\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":241,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[439.015,778.878],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 242\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":242,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[390.755,778.878],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 243\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":243,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[342.496,778.878],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 244\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":244,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[294.236,778.878],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 245\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":245,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[245.976,778.878],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 246\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":246,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[197.716,778.878],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 247\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":247,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[149.456,778.878],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 248\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":248,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[101.197,778.878],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 249\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":249,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[52.937,778.878],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 250\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":250,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[4.677,778.878],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 251\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":251,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[487.275,730.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 252\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":252,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[439.015,730.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 253\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":253,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[390.755,730.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 254\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":254,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[342.496,730.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 255\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":255,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[294.236,730.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 256\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":256,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[245.976,730.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 257\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":257,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[197.716,730.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 258\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":258,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[149.456,730.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 259\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":259,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[101.197,730.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 260\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":260,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[52.937,730.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 261\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":261,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[4.677,730.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 262\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":262,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1114.653,295.04],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 263\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":263,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1114.653,246.446],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 264\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":264,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1114.653,198.452],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 265\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":265,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1114.653,149.858],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 266\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":266,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1114.653,101.564],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 267\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":267,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1114.653,52.971],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 268\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":268,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1114.653,4.677],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 269\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":269,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1066.393,295.04],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 270\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":270,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1018.133,295.04],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 271\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":271,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[969.873,295.04],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 272\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":272,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[921.613,295.04],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 273\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":273,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[873.354,295.04],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 274\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":274,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[825.094,295.04],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 275\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":275,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[776.834,295.04],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 276\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":276,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[728.574,295.04],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 277\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":277,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[680.314,295.04],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 278\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":278,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[632.055,295.04],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 279\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":279,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[583.795,295.04],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 280\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":280,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1066.393,246.446],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 281\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":281,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1018.133,246.446],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 282\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":282,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[969.873,246.446],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 283\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":283,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[921.613,246.446],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 284\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":284,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[873.354,246.446],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 285\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":285,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[825.094,246.446],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 286\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":286,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[776.834,246.446],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 287\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":287,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[728.574,246.446],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 288\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":288,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[680.314,246.446],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 289\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":289,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[632.055,246.446],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 290\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":290,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[583.795,246.446],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 291\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":291,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1066.393,198.452],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 292\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":292,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1018.133,198.452],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 293\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":293,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[969.873,198.452],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 294\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":294,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[921.613,198.452],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 295\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":295,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[873.354,198.452],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 296\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":296,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[825.094,198.452],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 297\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":297,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[776.834,198.452],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 298\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":298,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[728.574,198.452],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 299\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":299,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[680.314,198.452],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 300\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":300,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[632.055,198.452],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 301\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":301,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[583.795,198.452],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 302\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":302,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1066.393,149.858],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 303\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":303,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1018.133,149.858],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 304\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":304,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[969.873,149.858],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 305\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":305,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[921.613,149.858],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 306\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":306,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[873.354,149.858],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 307\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":307,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[825.094,149.858],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 308\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":308,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[776.834,149.858],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 309\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":309,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[728.574,149.858],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 310\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":310,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[680.314,149.858],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 311\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":311,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[632.055,149.858],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 312\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":312,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[583.795,149.858],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 313\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":313,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1066.393,101.564],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 314\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":314,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1018.133,101.564],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 315\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":315,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[969.873,101.564],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 316\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":316,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[921.613,101.564],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 317\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":317,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[873.354,101.564],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 318\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":318,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[825.094,101.564],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 319\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":319,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[776.834,101.564],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 320\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":320,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[728.574,101.564],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 321\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":321,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[680.314,101.564],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 322\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":322,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[632.055,101.564],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 323\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":323,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[583.795,101.564],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 324\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":324,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1066.393,52.971],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 325\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":325,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1018.133,52.971],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 326\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":326,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[969.873,52.971],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 327\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":327,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[921.613,52.971],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 328\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":328,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[873.354,52.971],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 329\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":329,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[825.094,52.971],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 330\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":330,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[776.834,52.971],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 331\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":331,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[728.574,52.971],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 332\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":332,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[680.314,52.971],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 333\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":333,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[632.055,52.971],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 334\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":334,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[583.795,52.971],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 335\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":335,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1066.393,4.677],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 336\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":336,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1018.133,4.677],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 337\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":337,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[969.873,4.677],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 338\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":338,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[921.613,4.677],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 339\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":339,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[873.354,4.677],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 340\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":340,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[825.094,4.677],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 341\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":341,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[776.834,4.677],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 342\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":342,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[728.574,4.677],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 343\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":343,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[680.314,4.677],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 344\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":344,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[632.055,4.677],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 345\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":345,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[583.795,4.677],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 346\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":346,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1114.653,681.99],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 347\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":347,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1114.653,633.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 348\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":348,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1114.653,585.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 349\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":349,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1114.653,537.108],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 350\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":350,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1114.653,488.515],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 351\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":351,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1114.653,440.221],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 352\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":352,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1114.653,391.628],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 353\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":353,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1114.653,343.334],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 354\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":354,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1066.393,681.99],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 355\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":355,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1018.133,681.99],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 356\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":356,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[969.873,681.99],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 357\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":357,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[921.613,681.99],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 358\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":358,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[873.354,681.99],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 359\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":359,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[825.094,681.99],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 360\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":360,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[776.834,681.99],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 361\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":361,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[728.574,681.99],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 362\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":362,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[680.314,681.99],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 363\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":363,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[632.055,681.99],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 364\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":364,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[583.795,681.99],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 365\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":365,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1066.393,633.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 366\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":366,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1018.133,633.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 367\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":367,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[969.873,633.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 368\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":368,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[921.613,633.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 369\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":369,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[873.354,633.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 370\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":370,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[825.094,633.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 371\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":371,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[776.834,633.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 372\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":372,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[728.574,633.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 373\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":373,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[680.314,633.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 374\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":374,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[632.055,633.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 375\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":375,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[583.795,633.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 376\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":376,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1066.393,585.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 377\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":377,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1018.133,585.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 378\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":378,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[969.873,585.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 379\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":379,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[921.613,585.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 380\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":380,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[873.354,585.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 381\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":381,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[825.094,585.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 382\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":382,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[776.834,585.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 383\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":383,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[728.574,585.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 384\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":384,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[680.314,585.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 385\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":385,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[632.055,585.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 386\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":386,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[583.795,585.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 387\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":387,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1066.393,537.108],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 388\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":388,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1018.133,537.108],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 389\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":389,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[969.873,537.108],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 390\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":390,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[921.613,537.108],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 391\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":391,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[873.354,537.108],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 392\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":392,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[825.094,537.108],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 393\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":393,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[776.834,537.108],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 394\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":394,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[728.574,537.108],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 395\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":395,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[680.314,537.108],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 396\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":396,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[632.055,537.108],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 397\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":397,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[583.795,537.108],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 398\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":398,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1066.393,488.515],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 399\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":399,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1018.133,488.515],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 400\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":400,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[969.873,488.515],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 401\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":401,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[921.613,488.515],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 402\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":402,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[873.354,488.515],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 403\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":403,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[825.094,488.515],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 404\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":404,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[776.834,488.515],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 405\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":405,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[728.574,488.515],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 406\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":406,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[680.314,488.515],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 407\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":407,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[632.055,488.515],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 408\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":408,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[583.795,488.515],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 409\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":409,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1066.393,440.221],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 410\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":410,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1018.133,440.221],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 411\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":411,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[969.873,440.221],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 412\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":412,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[921.613,440.221],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 413\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":413,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[873.354,440.221],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 414\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":414,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[825.094,440.221],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 415\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":415,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[776.834,440.221],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 416\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":416,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[728.574,440.221],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 417\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":417,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[680.314,440.221],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 418\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":418,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[632.055,440.221],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 419\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":419,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[583.795,440.221],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 420\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":420,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1066.393,391.628],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 421\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":421,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1018.133,391.628],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 422\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":422,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[969.873,391.628],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 423\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":423,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[921.613,391.628],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 424\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":424,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[873.354,391.628],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 425\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":425,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[825.094,391.628],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 426\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":426,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[776.834,391.628],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 427\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":427,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[728.574,391.628],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 428\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":428,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[680.314,391.628],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 429\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":429,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[632.055,391.628],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 430\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":430,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[583.795,391.628],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 431\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":431,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1066.393,343.334],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 432\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":432,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[1018.133,343.334],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 433\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":433,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[969.873,343.334],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 434\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":434,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[921.613,343.334],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 435\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":435,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[873.354,343.334],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 436\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":436,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[825.094,343.334],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 437\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":437,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[776.834,343.334],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 438\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":438,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[728.574,343.334],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 439\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":439,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[680.314,343.334],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 440\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":440,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[632.055,343.334],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 441\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":441,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[583.795,343.334],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 442\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":442,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[535.535,681.99],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 443\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":443,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[535.535,633.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 444\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":444,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[535.535,585.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 445\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":445,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[535.535,537.108],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 446\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":446,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[535.535,488.515],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 447\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":447,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[535.535,440.221],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 448\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":448,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[535.535,391.628],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 449\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":449,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[535.535,343.334],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 450\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":450,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[487.275,681.99],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 451\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":451,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[439.015,681.99],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 452\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":452,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[390.755,681.99],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 453\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":453,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[342.496,681.99],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 454\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":454,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[294.236,681.99],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 455\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":455,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[245.976,681.99],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 456\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":456,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[197.716,681.99],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 457\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":457,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[149.456,681.99],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 458\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":458,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[101.197,681.99],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 459\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":459,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[52.937,681.99],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 460\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":460,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[4.677,681.99],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 461\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":461,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[487.275,633.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 462\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":462,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[439.015,633.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 463\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":463,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[390.755,633.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 464\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":464,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[342.496,633.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 465\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":465,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[294.236,633.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 466\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":466,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[245.976,633.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 467\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":467,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[197.716,633.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 468\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":468,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[149.456,633.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 469\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":469,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[101.197,633.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 470\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":470,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[52.937,633.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 471\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":471,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[4.677,633.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 472\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":472,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[487.275,585.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 473\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":473,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[439.015,585.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 474\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":474,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[390.755,585.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 475\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":475,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[342.496,585.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 476\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":476,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[294.236,585.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 477\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":477,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[245.976,585.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 478\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":478,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[197.716,585.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 479\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":479,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[149.456,585.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 480\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":480,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[101.197,585.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 481\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":481,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[52.937,585.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 482\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":482,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[4.677,585.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 483\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":483,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[487.275,537.108],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 484\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":484,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[439.015,537.108],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 485\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":485,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[390.755,537.108],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 486\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":486,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[342.496,537.108],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 487\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":487,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[294.236,537.108],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 488\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":488,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[245.976,537.108],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 489\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":489,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[197.716,537.108],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 490\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":490,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[149.456,537.108],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 491\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":491,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[101.197,537.108],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 492\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":492,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[52.937,537.108],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 493\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":493,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[4.677,537.108],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 494\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":494,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[487.275,488.515],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 495\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":495,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[439.015,488.515],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 496\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":496,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[390.755,488.515],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 497\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":497,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[342.496,488.515],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 498\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":498,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[294.236,488.515],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 499\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":499,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[245.976,488.515],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 500\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":500,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[197.716,488.515],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 501\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":501,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[149.456,488.515],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 502\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":502,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[101.197,488.515],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 503\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":503,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[52.937,488.515],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 504\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":504,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[4.677,488.515],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 505\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":505,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[487.275,440.221],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 506\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":506,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[439.015,440.221],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 507\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":507,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[390.755,440.221],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 508\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":508,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[342.496,440.221],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 509\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":509,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[294.236,440.221],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 510\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":510,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[245.976,440.221],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 511\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":511,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[197.716,440.221],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 512\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":512,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[149.456,440.221],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 513\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":513,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[101.197,440.221],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 514\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":514,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[52.937,440.221],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 515\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":515,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[4.677,440.221],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 516\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":516,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[487.275,391.628],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 517\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":517,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[439.015,391.628],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 518\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":518,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[390.755,391.628],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 519\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":519,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[342.496,391.628],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 520\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":520,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[294.236,391.628],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 521\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":521,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[245.976,391.628],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 522\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":522,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[197.716,391.628],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 523\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":523,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[149.456,391.628],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 524\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":524,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[101.197,391.628],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 525\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":525,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[52.937,391.628],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 526\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":526,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[4.677,391.628],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 527\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":527,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[487.275,343.334],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 528\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":528,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[439.015,343.334],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 529\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":529,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[390.755,343.334],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 530\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":530,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[342.496,343.334],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 531\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":531,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[294.236,343.334],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 532\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":532,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[245.976,343.334],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 533\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":533,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[197.716,343.334],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 534\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":534,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[149.456,343.334],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 535\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":535,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[101.197,343.334],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 536\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":536,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[52.937,343.334],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 537\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":537,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[4.677,343.334],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 538\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":538,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":420,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":1,\"nm\":\"White Solid 1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[300,150,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[300,150,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"sw\":600,\"sh\":300,\"sc\":\"#fafafa\",\"ip\":0,\"op\":420,\"st\":0,\"bm\":0}],\"markers\":[]}");


var $8d9f9884ab8fb022$exports = {};
$8d9f9884ab8fb022$exports = JSON.parse("{\"v\":\"5.9.0\",\"fr\":30,\"ip\":0,\"op\":152,\"w\":600,\"h\":300,\"nm\":\"State\",\"ddd\":0,\"assets\":[],\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":4,\"nm\":\"Cursor\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":0,\"s\":[-38.25,160.25,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":0.667},\"o\":{\"x\":0.333,\"y\":0.333},\"t\":32,\"s\":[179.375,173,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":38,\"s\":[179.375,173,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":0.667},\"o\":{\"x\":0.333,\"y\":0.333},\"t\":84,\"s\":[421.875,126.25,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":90,\"s\":[421.875,126.25,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":131,\"s\":[177.125,46,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[1.375,1,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[-0.321,-0.771],[0,0],[-0.277,0.817],[0,0],[-0.274,0.094],[0,0],[0.796,0.331],[0,0]],\"o\":[[0,0],[0.331,0.797],[0,0],[0.093,-0.275],[0,0],[0.815,-0.28],[0,0],[-0.771,-0.321]],\"v\":[[-16.743,-15.516],[-3.527,16.262],[-1.777,16.204],[2.618,3.268],[3.201,2.684],[16.212,-1.77],[16.268,-3.52],[-15.52,-16.738]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0,0,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[17.314,17.31],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":152,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":4,\"nm\":\"State 2\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"t\":86,\"s\":[0],\"h\":1},{\"t\":87,\"s\":[50],\"h\":1},{\"t\":89,\"s\":[100],\"h\":1}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[419.649,123.1,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[50.936,50.936,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[27.993,0],[0,-27.993],[-27.993,0],[0,27.993]],\"o\":[[-27.993,0],[0,27.993],[27.993,0],[0,-27.993]],\"v\":[[0,-50.686],[-50.686,0],[0,50.686],[50.686,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":1,\"ty\":\"sh\",\"ix\":2,\"ks\":{\"a\":0,\"k\":{\"i\":[[-25.743,0],[0,-25.743],[25.743,0],[0,25.743]],\"o\":[[25.743,0],[0,25.743],[-25.743,0],[0,-25.743]],\"v\":[[0,-46.686],[46.686,0],[0,46.686],[-46.686,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 2\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"mm\",\"mm\":1,\"nm\":\"Merge Paths 1\",\"mn\":\"ADBE Vector Filter - Merge\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0,0,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[50.936,50.936],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":6,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[26.845,0],[0,26.846],[-26.846,0],[0,-26.845]],\"o\":[[-26.846,0],[0,-26.845],[26.845,0],[0,26.846]],\"v\":[[0,48.686],[-48.686,0],[0,-48.686],[48.686,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.960784373564,0.807843197093,0.541176470588,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[50.936,50.936],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":152,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":4,\"nm\":\"State 1\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"t\":34,\"s\":[0],\"h\":1},{\"t\":35,\"s\":[50],\"h\":1},{\"t\":37,\"s\":[100],\"h\":1}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[178.6,171.2,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[50.936,50.936,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[27.993,0],[0,-27.993],[-27.993,0],[0,27.993]],\"o\":[[-27.993,0],[0,27.993],[27.993,0],[0,-27.993]],\"v\":[[0,-50.686],[-50.686,0],[0,50.686],[50.686,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":1,\"ty\":\"sh\",\"ix\":2,\"ks\":{\"a\":0,\"k\":{\"i\":[[-25.743,0],[0,-25.743],[25.743,0],[0,25.743]],\"o\":[[25.743,0],[0,25.743],[-25.743,0],[0,-25.743]],\"v\":[[0,-46.686],[46.686,0],[0,46.686],[-46.686,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 2\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"mm\",\"mm\":1,\"nm\":\"Merge Paths 1\",\"mn\":\"ADBE Vector Filter - Merge\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0,0,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[50.936,50.936],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":6,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[26.846,0],[0,26.845],[-26.846,0],[0,-26.846]],\"o\":[[-26.846,0],[0,-26.846],[26.846,0],[0,26.845]],\"v\":[[0,48.686],[-48.686,0],[0,-48.686],[48.686,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.960784373564,0.807843197093,0.541176470588,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[50.936,50.936],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":152,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":4,\"nm\":\"Grid\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[299,147,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[300.25,200.25,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 3\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":3,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 4\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":4,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 5\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":5,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 6\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":6,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 7\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":7,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 8\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":8,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 9\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":9,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 10\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":10,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 11\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":11,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 12\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":12,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 13\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":13,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 14\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":14,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 15\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":15,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 16\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":16,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 17\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":17,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 18\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":18,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 19\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":19,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 20\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":20,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 21\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":21,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 22\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":22,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 23\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":23,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 24\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":24,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 25\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":25,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 26\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":26,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 27\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":27,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 28\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":28,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 29\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":29,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 30\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":30,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 31\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":31,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 32\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":32,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 33\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":33,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 34\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":34,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 35\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":35,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 36\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":36,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 37\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":37,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 38\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":38,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 39\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":39,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 40\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":40,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 41\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":41,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 42\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":42,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 43\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":43,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 44\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":44,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 45\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":45,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 46\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":46,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 47\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":47,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 48\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":48,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 49\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":49,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 50\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":50,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 51\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":51,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 52\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":52,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 53\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":53,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 54\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":54,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 55\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":55,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 56\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":56,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 57\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":57,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 58\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":58,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 59\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":59,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 60\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":60,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 61\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":61,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 62\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":62,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 63\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":63,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 64\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":64,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 65\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":65,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 66\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":66,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 67\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":67,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 68\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":68,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 69\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":69,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 70\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":70,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 71\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":71,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 72\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":72,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 73\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":73,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 74\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":74,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 75\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":75,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 76\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":76,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 77\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":77,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 78\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":78,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 79\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":79,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 80\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":80,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 81\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":81,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 82\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":82,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 83\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":83,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 84\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":84,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 85\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":85,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 86\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":86,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 87\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":87,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 88\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":88,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 89\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":89,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 90\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":90,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 91\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":91,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 92\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":92,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 93\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":93,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 94\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":94,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 95\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":95,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 96\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":96,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-300,200],[300,200],[300,-200],[-300,-200]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.980392216701,0.980392216701,0.980392216701,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[300.25,200.25],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 97\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":97,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":152,\"st\":0,\"bm\":0}],\"markers\":[]}");


var $e270d1cb603ada0f$exports = {};
$e270d1cb603ada0f$exports = JSON.parse("{\"v\":\"5.9.0\",\"fr\":30,\"ip\":0,\"op\":172,\"w\":600,\"h\":300,\"nm\":\"Transition animation\",\"ddd\":0,\"assets\":[],\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":4,\"nm\":\"Cursor 2\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.833,\"y\":0.815},\"o\":{\"x\":0.167,\"y\":0.214},\"t\":286,\"s\":[-72.625,205,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":318,\"s\":[135,222.5,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":334,\"s\":[135,222.5,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":340,\"s\":[180.875,215.833,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":359,\"s\":[383.074,201.511,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":362,\"s\":[415,199.25,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[1.375,1,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[-0.321,-0.771],[0,0],[-0.277,0.817],[0,0],[-0.274,0.094],[0,0],[0.796,0.331],[0,0]],\"o\":[[0,0],[0.331,0.797],[0,0],[0.093,-0.275],[0,0],[0.815,-0.28],[0,0],[-0.771,-0.321]],\"v\":[[-16.743,-15.516],[-3.527,16.262],[-1.777,16.204],[2.618,3.268],[3.201,2.684],[16.212,-1.77],[16.268,-3.52],[-15.52,-16.738]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0,0,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[17.314,17.31],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":286,\"op\":496,\"st\":286,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":4,\"nm\":\"State 4\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[420.649,174.6,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[50.936,50.936,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[27.993,0],[0,-27.993],[-27.993,0],[0,27.993]],\"o\":[[-27.993,0],[0,27.993],[27.993,0],[0,-27.993]],\"v\":[[0,-50.686],[-50.686,0],[0,50.686],[50.686,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":1,\"ty\":\"sh\",\"ix\":2,\"ks\":{\"a\":0,\"k\":{\"i\":[[-25.743,0],[0,-25.743],[25.743,0],[0,25.743]],\"o\":[[25.743,0],[0,25.743],[-25.743,0],[0,-25.743]],\"v\":[[0,-46.686],[46.686,0],[0,46.686],[-46.686,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 2\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"mm\",\"mm\":1,\"nm\":\"Merge Paths 1\",\"mn\":\"ADBE Vector Filter - Merge\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0,0,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[50.936,50.936],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":6,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[26.845,0],[0,26.846],[-26.846,0],[0,-26.845]],\"o\":[[-26.846,0],[0,-26.845],[26.845,0],[0,26.846]],\"v\":[[0,48.686],[-48.686,0],[0,-48.686],[48.686,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.960784373564,0.807843197093,0.541176470588,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[50.936,50.936],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":286,\"op\":496,\"st\":286,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":4,\"nm\":\"State 3\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[131.35,222.7,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[50.936,50.936,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[27.993,0],[0,-27.993],[-27.993,0],[0,27.993]],\"o\":[[-27.993,0],[0,27.993],[27.993,0],[0,-27.993]],\"v\":[[0,-50.686],[-50.686,0],[0,50.686],[50.686,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":1,\"ty\":\"sh\",\"ix\":2,\"ks\":{\"a\":0,\"k\":{\"i\":[[-25.743,0],[0,-25.743],[25.743,0],[0,25.743]],\"o\":[[25.743,0],[0,25.743],[-25.743,0],[0,-25.743]],\"v\":[[0,-46.686],[46.686,0],[0,46.686],[-46.686,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 2\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"mm\",\"mm\":1,\"nm\":\"Merge Paths 1\",\"mn\":\"ADBE Vector Filter - Merge\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0,0,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[50.936,50.936],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":6,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[26.846,0],[0,26.845],[-26.846,0],[0,-26.846]],\"o\":[[-26.846,0],[0,-26.846],[26.846,0],[0,26.845]],\"v\":[[0,48.686],[-48.686,0],[0,-48.686],[48.686,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.960784373564,0.807843197093,0.541176470588,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[50.936,50.936],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":286,\"op\":496,\"st\":286,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":4,\"nm\":\"Arrow 2\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[531.429,145.006,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[559.665,512.662,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[99.644,110.158,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":340,\"s\":[{\"i\":[[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0]],\"v\":[[-162.608,-76.16],[-188.251,-75.891],[-179.454,-95.34]],\"c\":true}]},{\"t\":359,\"s\":[{\"i\":[[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0]],\"v\":[[12.502,28.558],[-13.057,26.469],[-2.51,7.911]],\"c\":true}],\"h\":1},{\"t\":366,\"s\":[{\"i\":[[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0]],\"v\":[[14.269,10.226],[-11.375,10.495],[-2.577,-8.954]],\"c\":true}],\"h\":1}],\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0,0,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[385.888,550],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":-34,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 3\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":340,\"s\":[{\"i\":[[0,0],[0,0]],\"o\":[[0,0],[0,0]],\"v\":[[-242.4,26.686],[-193.424,20.112]],\"c\":false}]},{\"t\":359,\"s\":[{\"i\":[[0,0],[0,0]],\"o\":[[0,0],[0,0]],\"v\":[[-254.945,27.595],[-3.436,9.786]],\"c\":false}],\"h\":1},{\"t\":366,\"s\":[{\"i\":[[0,0],[0,0]],\"o\":[[0,0],[0,0]],\"v\":[[-254.945,27.595],[-12.845,-5.76]],\"c\":false}],\"h\":1}],\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[0,0,0,1],\"ix\":3},\"o\":{\"a\":0,\"k\":100,\"ix\":4},\"w\":{\"a\":0,\"k\":4,\"ix\":5},\"lc\":1,\"lj\":1,\"ml\":10,\"bm\":0,\"nm\":\"Stroke 1\",\"mn\":\"ADBE Vector Graphic - Stroke\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[402.161,558.472],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 4\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":286,\"op\":496,\"st\":286,\"bm\":0},{\"ddd\":0,\"ind\":5,\"ty\":4,\"nm\":\"Layer 1 Outlines\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[169.168,94.901,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[29.418,43.651,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[1.4,6.573],[4.45,0],[8.275,-38.864],[0.03,-0.212],[0,0],[-4.434,20.82],[-1.054,0],[-8.242,-38.702],[-1.045,-5.89],[0,0],[0,0],[0,0]],\"o\":[[-1.058,-5.969],[-8.275,-38.864],[-4.449,0],[-4.464,20.961],[0,0],[0.029,-0.211],[8.242,-38.702],[1.055,0],[1.379,6.473],[0,0],[0,0],[0,0],[0,0]],\"v\":[[19.76,19.586],[16.053,0.447],[-2.839,-43.401],[-21.73,0.447],[-29.168,42.855],[-25.205,43.401],[-17.814,1.262],[-2.839,-39.401],[12.137,1.262],[15.791,20.116],[7.401,21.237],[21.509,43.128],[29.168,18.329]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0,0,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[29.418,43.651],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":122,\"op\":172,\"st\":51,\"bm\":0},{\"ddd\":0,\"ind\":6,\"ty\":4,\"nm\":\"Cursor\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":0,\"s\":[-38.25,160.25,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":0.667},\"o\":{\"x\":0.333,\"y\":0.333},\"t\":32,\"s\":[169.375,177.75,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.333,\"y\":0},\"t\":48,\"s\":[169.375,177.75,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.818,\"y\":0.891},\"o\":{\"x\":0.159,\"y\":0.095},\"t\":54,\"s\":[215.25,171.083,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":69,\"s\":[406.396,143.306,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":0.667},\"o\":{\"x\":0.333,\"y\":0.333},\"t\":74,\"s\":[444.625,137.75,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":90,\"s\":[444.625,137.75,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":0.667},\"o\":{\"x\":0.333,\"y\":0.333},\"t\":112,\"s\":[160.625,155.75,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":123,\"s\":[160.625,155.75,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[1.375,1,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[-0.321,-0.771],[0,0],[-0.277,0.817],[0,0],[-0.274,0.094],[0,0],[0.796,0.331],[0,0]],\"o\":[[0,0],[0.331,0.797],[0,0],[0.093,-0.275],[0,0],[0.815,-0.28],[0,0],[-0.771,-0.321]],\"v\":[[-16.743,-15.516],[-3.527,16.262],[-1.777,16.204],[2.618,3.268],[3.201,2.684],[16.212,-1.77],[16.268,-3.52],[-15.52,-16.738]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0,0,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[17.314,17.31],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":172,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":7,\"ty\":4,\"nm\":\"State 2\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[455.649,131.6,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[50.936,50.936,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[27.993,0],[0,-27.993],[-27.993,0],[0,27.993]],\"o\":[[-27.993,0],[0,27.993],[27.993,0],[0,-27.993]],\"v\":[[0,-50.686],[-50.686,0],[0,50.686],[50.686,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":1,\"ty\":\"sh\",\"ix\":2,\"ks\":{\"a\":0,\"k\":{\"i\":[[-25.743,0],[0,-25.743],[25.743,0],[0,25.743]],\"o\":[[25.743,0],[0,25.743],[-25.743,0],[0,-25.743]],\"v\":[[0,-46.686],[46.686,0],[0,46.686],[-46.686,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 2\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"mm\",\"mm\":1,\"nm\":\"Merge Paths 1\",\"mn\":\"ADBE Vector Filter - Merge\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0,0,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[50.936,50.936],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":6,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[26.845,0],[0,26.846],[-26.846,0],[0,-26.845]],\"o\":[[-26.846,0],[0,-26.845],[26.845,0],[0,26.846]],\"v\":[[0,48.686],[-48.686,0],[0,-48.686],[48.686,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.960784373564,0.807843197093,0.541176470588,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[50.936,50.936],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":172,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":8,\"ty\":4,\"nm\":\"State 1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[166.35,179.7,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[50.936,50.936,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[27.993,0],[0,-27.993],[-27.993,0],[0,27.993]],\"o\":[[-27.993,0],[0,27.993],[27.993,0],[0,-27.993]],\"v\":[[0,-50.686],[-50.686,0],[0,50.686],[50.686,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":1,\"ty\":\"sh\",\"ix\":2,\"ks\":{\"a\":0,\"k\":{\"i\":[[-25.743,0],[0,-25.743],[25.743,0],[0,25.743]],\"o\":[[25.743,0],[0,25.743],[-25.743,0],[0,-25.743]],\"v\":[[0,-46.686],[46.686,0],[0,46.686],[-46.686,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 2\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"mm\",\"mm\":1,\"nm\":\"Merge Paths 1\",\"mn\":\"ADBE Vector Filter - Merge\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0,0,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[50.936,50.936],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":6,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[26.846,0],[0,26.845],[-26.846,0],[0,-26.846]],\"o\":[[-26.846,0],[0,-26.846],[26.846,0],[0,26.845]],\"v\":[[0,48.686],[-48.686,0],[0,-48.686],[48.686,0]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.960784373564,0.807843197093,0.541176470588,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[50.936,50.936],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":172,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":9,\"ty\":4,\"nm\":\"Arrow\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[566.429,102.006,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[559.665,512.662,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[99.644,110.158,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":54,\"s\":[{\"i\":[[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0]],\"v\":[[-162.608,-76.16],[-188.251,-75.891],[-179.454,-95.34]],\"c\":true}]},{\"t\":69,\"s\":[{\"i\":[[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0]],\"v\":[[14.269,10.226],[-11.375,10.495],[-2.577,-8.954]],\"c\":true}]}],\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0,0,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[385.888,550],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":-34,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 3\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":54,\"s\":[{\"i\":[[0,0],[0,0]],\"o\":[[0,0],[0,0]],\"v\":[[-242.4,26.686],[-193.424,20.112]],\"c\":false}]},{\"t\":69,\"s\":[{\"i\":[[0,0],[0,0]],\"o\":[[0,0],[0,0]],\"v\":[[-254.945,27.595],[-12.845,-5.76]],\"c\":false}]}],\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[0,0,0,1],\"ix\":3},\"o\":{\"a\":0,\"k\":100,\"ix\":4},\"w\":{\"a\":0,\"k\":4,\"ix\":5},\"lc\":1,\"lj\":1,\"ml\":10,\"bm\":0,\"nm\":\"Stroke 1\",\"mn\":\"ADBE Vector Graphic - Stroke\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[402.161,558.472],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 4\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":172,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":10,\"ty\":4,\"nm\":\"Grid 2\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[-195.5,107,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[300.25,200.25,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 3\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":3,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 4\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":4,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 5\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":5,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 6\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":6,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 7\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":7,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 8\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":8,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 9\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":9,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 10\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":10,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 11\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":11,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 12\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":12,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 13\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":13,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 14\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":14,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 15\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":15,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 16\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":16,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 17\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":17,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 18\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":18,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 19\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":19,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 20\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":20,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 21\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":21,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 22\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":22,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 23\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":23,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 24\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":24,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 25\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":25,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 26\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":26,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 27\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":27,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 28\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":28,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 29\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":29,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 30\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":30,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 31\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":31,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 32\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":32,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 33\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":33,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 34\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":34,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 35\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":35,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 36\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":36,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 37\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":37,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 38\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":38,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 39\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":39,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 40\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":40,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 41\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":41,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 42\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":42,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 43\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":43,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 44\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":44,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 45\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":45,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 46\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":46,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 47\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":47,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 48\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":48,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 49\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":49,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 50\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":50,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 51\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":51,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 52\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":52,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 53\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":53,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 54\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":54,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 55\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":55,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 56\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":56,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 57\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":57,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 58\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":58,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 59\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":59,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 60\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":60,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 61\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":61,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 62\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":62,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 63\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":63,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 64\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":64,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 65\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":65,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 66\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":66,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 67\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":67,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 68\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":68,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 69\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":69,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 70\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":70,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 71\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":71,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 72\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":72,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 73\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":73,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 74\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":74,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 75\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":75,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 76\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":76,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 77\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":77,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 78\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":78,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 79\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":79,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 80\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":80,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 81\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":81,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 82\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":82,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 83\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":83,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 84\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":84,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 85\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":85,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 86\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":86,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 87\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":87,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 88\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":88,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 89\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":89,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 90\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":90,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 91\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":91,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 92\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":92,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 93\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":93,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 94\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":94,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 95\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":95,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 96\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":96,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-300,200],[300,200],[300,-200],[-300,-200]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.980392216701,0.980392216701,0.980392216701,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[300.25,200.25],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 97\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":97,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":172,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":11,\"ty\":4,\"nm\":\"Grid\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[335,107,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[300.25,200.25,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 3\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":3,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 4\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":4,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 5\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":5,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 6\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":6,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 7\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":7,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 8\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":8,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 9\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":9,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 10\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":10,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 11\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":11,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 12\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":12,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 13\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":13,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 14\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":14,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 15\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":15,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 16\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":16,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 17\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":17,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 18\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":18,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 19\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":19,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 20\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":20,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 21\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":21,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 22\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":22,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 23\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":23,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 24\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":24,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 25\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":25,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 26\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":26,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 27\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":27,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 28\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":28,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 29\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":29,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 30\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":30,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 31\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":31,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 32\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":32,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 33\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":33,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 34\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":34,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 35\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":35,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 36\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":36,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 37\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":37,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 38\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":38,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 39\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":39,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 40\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":40,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 41\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":41,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 42\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":42,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 43\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":43,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 44\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":44,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 45\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":45,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 46\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":46,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 47\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":47,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 48\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":48,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 49\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":49,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 50\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":50,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 51\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":51,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 52\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":52,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 53\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":53,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 54\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":54,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 55\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":55,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 56\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":56,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 57\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":57,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 58\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":58,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 59\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":59,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 60\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":60,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 61\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":61,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 62\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":62,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 63\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":63,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 64\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":64,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 65\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":65,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 66\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":66,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 67\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":67,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 68\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":68,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 69\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":69,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 70\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":70,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 71\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":71,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 72\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":72,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 73\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":73,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 74\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":74,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 75\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":75,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 76\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":76,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 77\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":77,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 78\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":78,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 79\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":79,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 80\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":80,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 81\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":81,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 82\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":82,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 83\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":83,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 84\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":84,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 85\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":85,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 86\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":86,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 87\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":87,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 88\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":88,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 89\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":89,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 90\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":90,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 91\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":91,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 92\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":92,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 93\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":93,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 94\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":94,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 95\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":95,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 96\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":96,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-300,200],[300,200],[300,-200],[-300,-200]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.980392216701,0.980392216701,0.980392216701,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[300.25,200.25],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 97\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":97,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":172,\"st\":0,\"bm\":0}],\"markers\":[]}");


var $312f29d5818253ef$exports = {};
$312f29d5818253ef$exports = JSON.parse("{\"v\":\"5.9.0\",\"fr\":30,\"ip\":0,\"op\":174,\"w\":600,\"h\":300,\"nm\":\"Comment\",\"ddd\":0,\"assets\":[{\"id\":\"comp_0\",\"nm\":\"Comment Prompt\",\"fr\":30,\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":4,\"nm\":\"Message Icon\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[205.25,152.25,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[11,11,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[119.444,119.444,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[1.105,0],[0,0],[0,0],[0,0],[-1.105,0],[0,0],[0,-1.105]],\"o\":[[0,1.105],[0,0],[0,0],[0,0],[0,-1.105],[0,0],[1.105,0],[0,0]],\"v\":[[9,3],[7,5],[-5,5],[-9,9],[-9,-7],[-7,-9],[7,-9],[9,-7]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[0.980392158031,0.980392158031,0.980392158031,1],\"ix\":3},\"o\":{\"a\":0,\"k\":100,\"ix\":4},\"w\":{\"a\":0,\"k\":2,\"ix\":5},\"lc\":2,\"lj\":2,\"bm\":0,\"nm\":\"Stroke 1\",\"mn\":\"ADBE Vector Graphic - Stroke\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[11,11],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":152,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":4,\"nm\":\"Return Icon\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[429.5,151.75,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[10,10,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[2.209,0],[0,0]],\"o\":[[0,0],[0,2.209],[0,0],[0,0]],\"v\":[[8,-5.5],[8,1.5],[4,5.5],[-8,5.5]],\"c\":false},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[0.172549024224,0.172549024224,0.172549024224,1],\"ix\":3},\"o\":{\"a\":0,\"k\":100,\"ix\":4},\"w\":{\"a\":0,\"k\":2,\"ix\":5},\"lc\":2,\"lj\":2,\"bm\":0,\"nm\":\"Stroke 1\",\"mn\":\"ADBE Vector Graphic - Stroke\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[10,7.5],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0]],\"v\":[[2.5,-5],[-2.5,0],[2.5,5]],\"c\":false},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[0.172549024224,0.172549024224,0.172549024224,1],\"ix\":3},\"o\":{\"a\":0,\"k\":100,\"ix\":4},\"w\":{\"a\":0,\"k\":2,\"ix\":5},\"lc\":2,\"lj\":2,\"bm\":0,\"nm\":\"Stroke 1\",\"mn\":\"ADBE Vector Graphic - Stroke\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[4.5,13],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":152,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":4,\"nm\":\"Text Box\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[321.25,150.25,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[73.469,73.469,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"rc\",\"d\":1,\"s\":{\"a\":0,\"k\":[293.5,56],\"ix\":2},\"p\":{\"a\":0,\"k\":[0,0],\"ix\":3},\"r\":{\"a\":0,\"k\":8,\"ix\":4},\"nm\":\"Rectangle Path 1\",\"mn\":\"ADBE Vector Shape - Rect\",\"hd\":false},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[0.921568627451,0.611764705882,0.078431372549,1],\"ix\":3},\"o\":{\"a\":0,\"k\":100,\"ix\":4},\"w\":{\"a\":0,\"k\":2,\"ix\":5},\"lc\":1,\"lj\":1,\"ml\":4,\"bm\":0,\"nm\":\"Stroke 1\",\"mn\":\"ADBE Vector Graphic - Stroke\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.980392156863,0.980392156863,0.980392156863,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[24.25,1],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Rectangle 1\",\"np\":3,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":152,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":4,\"nm\":\"Background\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[283.25,150.25,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"rc\",\"d\":1,\"s\":{\"a\":0,\"k\":[275,56],\"ix\":2},\"p\":{\"a\":0,\"k\":[0,0],\"ix\":3},\"r\":{\"a\":0,\"k\":6,\"ix\":4},\"nm\":\"Rectangle Path 1\",\"mn\":\"ADBE Vector Shape - Rect\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.172549019608,0.172549019608,0.172549019608,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[31.75,1],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Rectangle 1\",\"np\":3,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":152,\"st\":0,\"bm\":0}]}],\"fonts\":{\"list\":[{\"fName\":\"ArialMT\",\"fFamily\":\"Arial\",\"fStyle\":\"Regular\",\"ascent\":71.5988159179688}]},\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":4,\"nm\":\"Cursor\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":0,\"s\":[-38.25,160.25,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":0.667},\"o\":{\"x\":0.333,\"y\":0.333},\"t\":27,\"s\":[181.375,123,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.167,\"y\":0},\"t\":38,\"s\":[181.375,123,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":0.667},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":58,\"s\":[293.375,219,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.167,\"y\":0},\"t\":97,\"s\":[293.375,219,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":118,\"s\":[433.875,153,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[1.375,1,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[-0.321,-0.771],[0,0],[-0.277,0.817],[0,0],[-0.274,0.094],[0,0],[0.796,0.331],[0,0]],\"o\":[[0,0],[0.331,0.797],[0,0],[0.093,-0.275],[0,0],[0.815,-0.28],[0,0],[-0.771,-0.321]],\"v\":[[-16.743,-15.516],[-3.527,16.262],[-1.777,16.204],[2.618,3.268],[3.201,2.684],[16.212,-1.77],[16.268,-3.52],[-15.52,-16.738]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0,0,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[17.314,17.31],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":175,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":5,\"nm\":\"some text 2\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":128,\"s\":[100]},{\"t\":130,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[285.75,151.25,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[8.285,-69.043,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[9.052,9.052,100],\"ix\":6,\"l\":2}},\"ao\":0,\"t\":{\"d\":{\"k\":[{\"s\":{\"s\":236,\"f\":\"ArialMT\",\"t\":\"some text\",\"ca\":0,\"j\":2,\"tr\":0,\"lh\":116,\"ls\":0,\"fc\":[0.067,0.067,0.067]},\"t\":0}]},\"p\":{},\"m\":{\"g\":1,\"a\":{\"a\":0,\"k\":[0,0],\"ix\":2}},\"a\":[{\"nm\":\"Animator 1\",\"s\":{\"t\":0,\"xe\":{\"a\":0,\"k\":0,\"ix\":7},\"ne\":{\"a\":0,\"k\":0,\"ix\":8},\"a\":{\"a\":0,\"k\":100,\"ix\":4},\"b\":1,\"rn\":0,\"sh\":1,\"sm\":{\"a\":0,\"k\":0,\"ix\":6},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":66,\"s\":[0]},{\"t\":91,\"s\":[100]}],\"ix\":1},\"r\":1},\"a\":{\"o\":{\"a\":0,\"k\":0,\"ix\":9}}}]},\"ip\":66,\"op\":130,\"st\":22,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":0,\"nm\":\"Comment Prompt\",\"refId\":\"comp_0\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":-7,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":33,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":35,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":128,\"s\":[100]},{\"t\":130,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[300,150,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[300,150,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"w\":600,\"h\":300,\"ip\":33,\"op\":130,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":5,\"nm\":\"some text\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[305,176,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[12.207,12.207,100],\"ix\":6,\"l\":2}},\"ao\":0,\"t\":{\"d\":{\"k\":[{\"s\":{\"s\":236,\"f\":\"ArialMT\",\"t\":\"some text\",\"ca\":0,\"j\":2,\"tr\":0,\"lh\":116,\"ls\":0,\"fc\":[0.067,0.067,0.067]},\"t\":0}]},\"p\":{},\"m\":{\"g\":1,\"a\":{\"a\":0,\"k\":[0,0],\"ix\":2}},\"a\":[]},\"ip\":129,\"op\":175,\"st\":8,\"bm\":0},{\"ddd\":0,\"ind\":5,\"ty\":4,\"nm\":\"Shape Layer 1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[346.5,149.25,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"rc\",\"d\":1,\"s\":{\"a\":0,\"k\":[193.5,86.5],\"ix\":2},\"p\":{\"a\":0,\"k\":[0,0],\"ix\":3},\"r\":{\"a\":0,\"k\":15,\"ix\":4},\"nm\":\"Rectangle Path 1\",\"mn\":\"ADBE Vector Shape - Rect\",\"hd\":false},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[0.76862745098,0.76862745098,0.76862745098,1],\"ix\":3},\"o\":{\"a\":0,\"k\":100,\"ix\":4},\"w\":{\"a\":0,\"k\":5,\"ix\":5},\"lc\":1,\"lj\":1,\"ml\":4,\"bm\":0,\"nm\":\"Stroke 1\",\"mn\":\"ADBE Vector Graphic - Stroke\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.980392216701,0.980392216701,0.980392216701,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[-40.75,20.75],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Rectangle 1\",\"np\":3,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":129,\"op\":175,\"st\":8,\"bm\":0},{\"ddd\":0,\"ind\":6,\"ty\":4,\"nm\":\"Grid\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[299,147,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[300.25,200.25,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 3\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":3,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 4\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":4,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 5\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":5,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 6\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":6,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 7\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":7,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[565.679,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 8\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":8,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 9\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":9,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 10\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":10,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 11\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":11,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 12\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":12,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 13\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":13,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 14\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":14,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 15\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":15,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 16\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":16,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 17\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":17,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 18\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":18,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,369.578],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 19\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":19,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 20\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":20,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 21\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":21,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 22\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":22,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 23\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":23,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 24\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":24,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 25\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":25,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 26\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":26,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 27\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":27,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 28\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":28,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 29\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":29,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,321.284],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 30\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":30,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 31\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":31,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 32\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":32,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 33\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":33,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 34\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":34,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 35\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":35,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 36\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":36,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 37\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":37,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 38\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":38,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 39\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":39,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 40\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":40,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,272.691],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 41\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":41,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 42\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":42,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 43\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":43,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 44\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":44,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 45\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":45,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 46\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":46,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 47\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":47,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 48\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":48,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 49\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":49,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 50\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":50,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 51\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":51,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,224.696],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 52\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":52,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 53\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":53,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 54\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":54,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 55\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":55,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 56\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":56,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 57\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":57,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 58\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":58,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 59\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":59,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 60\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":60,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 61\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":61,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 62\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":62,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,176.103],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 63\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":63,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 64\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":64,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 65\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":65,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 66\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":66,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 67\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":67,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 68\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":68,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 69\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":69,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 70\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":70,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 71\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":71,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 72\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":72,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 73\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":73,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,127.809],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 74\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":74,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 75\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":75,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 76\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":76,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 77\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":77,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 78\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":78,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 79\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":79,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 80\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":80,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 81\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":81,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 82\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":82,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 83\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":83,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 84\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":84,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,79.216],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 85\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":85,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[517.419,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 86\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":86,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[469.159,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 87\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":87,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[420.9,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 88\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":88,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[372.64,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 89\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":89,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[324.38,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 90\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":90,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[276.12,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 91\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":91,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[227.86,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 92\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":92,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[179.6,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 93\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":93,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[131.341,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 94\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":94,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[83.081,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 95\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":95,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-2.445],[2.445,0],[0,2.445],[-2.445,0]],\"o\":[[0,2.445],[-2.445,0],[0,-2.445],[2.445,0]],\"v\":[[4.427,0],[0,4.427],[-4.427,0],[0,-4.427]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.866666726505,0.866666726505,0.866666726505,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[34.821,30.922],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 96\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":96,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-300,200],[300,200],[300,-200],[-300,-200]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.980392216701,0.980392216701,0.980392216701,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[300.25,200.25],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 97\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":97,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":175,\"st\":0,\"bm\":0}],\"markers\":[],\"chars\":[{\"ch\":\"s\",\"size\":236,\"style\":\"Regular\",\"w\":50,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[-3.532,-2.799],[-6.738,0],[-3.223,1.416],[-1.709,2.588],[0,2.93],[1.399,2.019],[2.457,1.058],[6.217,1.66],[0.879,0.326],[0.716,0.945],[0,1.14],[-1.726,1.335],[-4.037,0],[-1.872,-1.497],[-0.391,-2.669],[0,0],[1.465,2.002],[3.076,1.172],[4.069,0],[2.36,-0.7],[1.367,-1.009],[1.057,-1.969],[0,-2.311],[-1.286,-2.1],[-2.49,-1.188],[-6.445,-1.627],[-1.205,-0.781],[0,-1.985],[1.953,-1.643],[4.036,0],[2.229,1.855],[0.488,3.484],[0,0]],\"o\":[[3.532,2.8],[4.069,0],[3.223,-1.416],[1.709,-2.588],[0,-2.995],[-1.4,-2.018],[-2.458,-1.057],[-4.297,-1.172],[-1.53,-0.618],[-0.716,-0.911],[0,-1.79],[1.725,-1.334],[3.418,0],[1.871,1.498],[0,0],[-0.554,-3.352],[-1.465,-2.002],[-3.076,-1.172],[-2.702,0],[-2.361,0.7],[-1.823,1.302],[-1.058,1.97],[0,2.539],[1.286,2.1],[2.49,1.189],[4.785,1.205],[1.725,1.14],[0,2.214],[-1.953,1.644],[-4.004,0],[-2.23,-1.855],[0,0],[0.977,5.502]],\"v\":[[9.839,-3.027],[25.244,1.172],[36.182,-0.952],[43.579,-6.958],[46.143,-15.234],[44.043,-22.754],[38.257,-27.368],[25.244,-31.445],[17.48,-33.691],[14.111,-36.035],[13.037,-39.111],[15.625,-43.799],[24.268,-45.801],[32.202,-43.555],[35.596,-37.305],[44.189,-38.477],[41.162,-46.509],[34.351,-51.27],[23.633,-53.027],[16.04,-51.978],[10.449,-49.414],[6.128,-44.507],[4.541,-38.086],[6.47,-31.128],[12.134,-26.196],[25.537,-21.973],[34.521,-18.994],[37.109,-14.307],[34.18,-8.521],[25.195,-6.055],[15.845,-8.838],[11.768,-16.846],[3.076,-15.479]],\"c\":true},\"ix\":2},\"nm\":\"s\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false}],\"nm\":\"s\",\"np\":3,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}]},\"fFamily\":\"Arial\"},{\"ch\":\"o\",\"size\":236,\"style\":\"Regular\",\"w\":55.62,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[-4.476,-4.655],[-7.259,0],[-3.825,2.116],[-2.002,3.825],[0,6.673],[4.524,4.671],[7.129,0],[4.459,-3.841],[0,-9.602]],\"o\":[[4.475,4.655],[4.524,0],[3.825,-2.116],[2.002,-3.825],[0,-8.235],[-4.525,-4.671],[-6.413,0],[-5.339,4.623],[0,8.757]],\"v\":[[10.034,-5.811],[27.637,1.172],[40.161,-2.002],[48.901,-10.913],[51.904,-26.66],[45.117,-46.021],[27.637,-53.027],[11.328,-47.266],[3.32,-25.928]],\"c\":true},\"ix\":2},\"nm\":\"o\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":1,\"ty\":\"sh\",\"ix\":2,\"ks\":{\"a\":0,\"k\":{\"i\":[[-2.898,3.288],[-4.395,0],[-2.914,-3.304],[0,-6.413],[2.897,-3.32],[4.362,0],[2.897,3.304],[0,6.641]],\"o\":[[2.897,-3.288],[4.329,0],[2.913,3.304],[0,6.804],[-2.898,3.32],[-4.395,0],[-2.898,-3.304],[0,-6.641]],\"v\":[[16.699,-40.82],[27.637,-45.752],[38.501,-40.796],[42.871,-26.221],[38.525,-11.035],[27.637,-6.055],[16.699,-11.011],[12.354,-25.928]],\"c\":true},\"ix\":2},\"nm\":\"o\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false}],\"nm\":\"o\",\"np\":5,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}]},\"fFamily\":\"Arial\"},{\"ch\":\"m\",\"size\":236,\"style\":\"Regular\",\"w\":83.3,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[-0.945,2.507],[-2.1,1.302],[-2.474,0],[-1.433,-1.953],[0,-3.906],[0,0],[0,0],[0,0],[-2.409,2.425],[-3.646,0],[-1.498,-0.944],[-0.57,-1.546],[0,-3.516],[0,0],[0,0],[0,0],[2.766,2.849],[5.143,0],[4.102,-6.055],[2.457,1.595],[3.841,0],[2.702,-1.546],[1.627,-2.539],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,-4.72],[0.944,-2.506],[2.1,-1.302],[3.255,0],[1.432,1.953],[0,0],[0,0],[0,0],[0,-5.338],[2.409,-2.425],[2.018,0],[1.497,0.945],[0.569,1.546],[0,0],[0,0],[0,0],[0,-5.924],[-2.767,-2.848],[-6.576,0],[-1.009,-2.864],[-2.458,-1.595],[-3.451,0],[-2.702,1.546],[0,0],[0,0],[0,0],[0,0]],\"v\":[[15.381,0],[15.381,-26.904],[16.797,-37.744],[21.362,-43.457],[28.223,-45.41],[35.254,-42.48],[37.402,-33.691],[37.402,0],[46.191,0],[46.191,-30.127],[49.805,-41.772],[58.887,-45.41],[64.16,-43.994],[67.261,-40.259],[68.115,-32.666],[68.115,0],[76.855,0],[76.855,-35.596],[72.705,-48.755],[60.84,-53.027],[44.824,-43.945],[39.624,-50.635],[30.176,-53.027],[20.947,-50.708],[14.453,-44.58],[14.453,-51.855],[6.592,-51.855],[6.592,0]],\"c\":true},\"ix\":2},\"nm\":\"m\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false}],\"nm\":\"m\",\"np\":3,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}]},\"fFamily\":\"Arial\"},{\"ch\":\"e\",\"size\":236,\"style\":\"Regular\",\"w\":55.62,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[2.278,-1.692],[3.223,0],[2.897,3.027],[0.325,5.697],[0,0],[0,0.521],[4.395,4.72],[6.934,0],[4.492,-4.817],[0,-8.723],[-4.443,-4.671],[-7.585,0],[-3.874,2.93],[-1.433,5.306],[0,0]],\"o\":[[-2.279,1.693],[-4.33,0],[-2.898,-3.027],[0,0],[0.032,-1.041],[0,-8.561],[-4.395,-4.72],[-7.162,0],[-4.492,4.818],[0,8.431],[4.443,4.671],[6.022,0],[3.873,-2.93],[0,0],[-1.335,3.711]],\"v\":[[36.67,-8.594],[28.418,-6.055],[17.578,-10.596],[12.744,-23.682],[51.416,-23.682],[51.465,-26.025],[44.873,-45.947],[27.881,-53.027],[10.4,-45.801],[3.662,-25.488],[10.327,-5.835],[28.369,1.172],[43.213,-3.223],[51.172,-15.576],[42.09,-16.699]],\"c\":true},\"ix\":2},\"nm\":\"e\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":1,\"ty\":\"sh\",\"ix\":2,\"ks\":{\"a\":0,\"k\":{\"i\":[[-2.751,2.702],[-4.037,0],[-2.8,-3.385],[-0.391,-4.362],[0,0]],\"o\":[[2.75,-2.702],[4.459,0],[1.823,2.181],[0,0],[0.293,-4.524]],\"v\":[[17.798,-41.748],[27.979,-45.801],[38.867,-40.723],[42.188,-30.908],[13.232,-30.908]],\"c\":true},\"ix\":2},\"nm\":\"e\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false}],\"nm\":\"e\",\"np\":5,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}]},\"fFamily\":\"Arial\"},{\"ch\":\" \",\"size\":236,\"style\":\"Regular\",\"w\":27.78,\"data\":{},\"fFamily\":\"Arial\"},{\"ch\":\"t\",\"size\":236,\"style\":\"Regular\",\"w\":27.78,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0.977,0],[0.7,0.423],[0.309,0.716],[0,2.507],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-0.716,-1.643],[-1.758,-1.009],[-3.191,0],[-2.474,0.52],[0,0]],\"o\":[[-1.302,0],[-0.7,-0.423],[-0.31,-0.716],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,5.273],[0.716,1.644],[1.758,1.009],[1.953,0],[0,0],[-1.595,0.228]],\"v\":[[21.924,-7.52],[18.921,-8.154],[17.407,-9.863],[16.943,-14.697],[16.943,-45.02],[25.781,-45.02],[25.781,-51.855],[16.943,-51.855],[16.943,-69.971],[8.203,-64.697],[8.203,-51.855],[1.758,-51.855],[1.758,-45.02],[8.203,-45.02],[8.203,-15.186],[9.277,-4.81],[12.988,-0.83],[20.41,0.684],[27.051,-0.098],[25.781,-7.861]],\"c\":true},\"ix\":2},\"nm\":\"t\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false}],\"nm\":\"t\",\"np\":3,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}]},\"fFamily\":\"Arial\"},{\"ch\":\"x\",\"size\":236,\"style\":\"Regular\",\"w\":50,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[1.432,-2.148],[1.497,2.312],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-1.205,1.66],[-0.912,-1.562],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[11.377,0],[25,-20.459],[27.832,-16.113],[38.477,0],[49.268,0],[29.98,-27.441],[47.9,-51.855],[37.402,-51.855],[28.662,-39.6],[24.707,-33.887],[21.094,-39.697],[13.135,-51.855],[2.148,-51.855],[19.678,-26.953],[0.732,0]],\"c\":true},\"ix\":2},\"nm\":\"x\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false}],\"nm\":\"x\",\"np\":3,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}]},\"fFamily\":\"Arial\"}]}");




const $5d111e8a0f2066e2$var$tools = (t)=>[
        {
            label: t('tools.cursor'),
            hotkey: 'V',
            description: t('tools.cursor_desc'),
            value: 'cursor',
            icon: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $c472c6f2d2b3edc7$export$2e2bcd8739ae039), {}),
            animation: (0, (/*@__PURE__*/$parcel$interopDefault($796f04347b90ea04$exports)))
        },
        {
            label: t('tools.hand'),
            hotkey: 'H',
            description: t('tools.hand_desc'),
            value: 'hand',
            icon: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e21351e831545c86$export$2e2bcd8739ae039), {}),
            animation: (0, (/*@__PURE__*/$parcel$interopDefault($6eb38acfac99e87a$exports)))
        },
        {
            label: t('tools.state'),
            hotkey: 'S',
            description: t('tools.state_desc'),
            value: 'state',
            icon: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $a5e712d7b7a447b6$export$2e2bcd8739ae039), {}),
            animation: (0, (/*@__PURE__*/$parcel$interopDefault($8d9f9884ab8fb022$exports)))
        },
        {
            label: t('tools.transition'),
            hotkey: 'T',
            description: t('tools.transition_desc'),
            value: 'transition',
            icon: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $8a27542e8a20cbdc$export$2e2bcd8739ae039), {}),
            animation: (0, (/*@__PURE__*/$parcel$interopDefault($e270d1cb603ada0f$exports)))
        },
        {
            label: t('tools.comment'),
            hotkey: 'C',
            description: t('tools.comment_desc'),
            value: 'comment',
            icon: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $db653877009fa44e$export$2e2bcd8739ae039), {}),
            animation: (0, (/*@__PURE__*/$parcel$interopDefault($312f29d5818253ef$exports)))
        }
    ];
const $5d111e8a0f2066e2$var$Toolbar = ()=>{
    const { tool: tool, setTool: setTool } = (0, $9ea7efd115f178cf$export$2e2bcd8739ae039)();
    const setTemplate = (0, $f8e54bb3e6739765$export$2e2bcd8739ae039)((s)=>s.setTemplate);
    const zoomButtonRect = (0, $h2ArV.useRef)();
    const [zoomMenuOpen, setZoomMenuOpen] = (0, $h2ArV.useState)(false);
    const viewScale = (0, $2c8de4ab9c0d9b91$export$2e2bcd8739ae039)((s)=>s.scale);
    const [toolPopup, setToolPopup] = (0, $h2ArV.useState)({});
    const toolPopupHover = (0, $h2ArV.useRef)({});
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)('common');
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $a3b7de28ad1e6565$export$2e2bcd8739ae039), {
        $tools: true,
        children: [
            $5d111e8a0f2066e2$var$tools(t).map((toolOption)=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $a3b7de28ad1e6565$export$da76e993ddf038d), {
                    onClick: ()=>{
                        setTool(toolOption.value);
                        setTemplate(null);
                    },
                    $active: tool === toolOption.value,
                    onMouseEnter: (e)=>{
                        toolPopupHover.current = {
                            ...toolPopupHover.current,
                            value: toolOption.value
                        };
                        window.setTimeout(()=>{
                            if (toolPopupHover.current.value !== toolOption.value) return;
                            const box = e.target.getBoundingClientRect();
                            setToolPopup({
                                visible: true,
                                y: box.y,
                                tool: $5d111e8a0f2066e2$var$tools(t).find((t)=>t.value === toolOption.value)
                            });
                        }, toolPopupHover.current.timeout || 1000);
                    },
                    onMouseLeave: (e)=>{
                        toolPopupHover.current = {
                            value: undefined,
                            timeout: e.relatedTarget.tagName === 'BUTTON' && toolPopup.visible && 10
                        };
                        setToolPopup({
                            ...toolPopup,
                            visible: false
                        });
                    },
                    children: toolOption.icon
                }, toolOption.label)),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $45274391c854412e$export$581786309c1927ec), {
                $y: toolPopup.y,
                className: toolPopup.visible ? 'visible' : '',
                children: [
                    !!toolPopup.tool?.animation && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $45274391c854412e$export$c35d437ae5945fcd), {
                        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1442674a31386efe$exports))), {
                            loop: true,
                            animationData: toolPopup.tool.animation,
                            play: toolPopup.visible
                        })
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $45274391c854412e$export$523e40ee5aaa0bfd), {
                                children: [
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("span", {
                                        children: toolPopup.tool?.label
                                    }),
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $45274391c854412e$export$76be3b1f11287f58), {
                                        children: toolPopup.tool?.hotkey
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("span", {
                                children: toolPopup.tool?.description
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("div", {
                style: {
                    flex: 1
                }
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $a3b7de28ad1e6565$export$da76e993ddf038d), {
                style: {
                    aspectRatio: 'initial',
                    fontSize: '.9em',
                    padding: '.8em 0'
                },
                onClick: (e)=>{
                    setZoomMenuOpen(true);
                    e.stopPropagation();
                },
                ref: (r)=>{
                    zoomButtonRect.current = r?.getBoundingClientRect();
                    return zoomButtonRect.current;
                },
                $active: zoomMenuOpen,
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("span", {
                        children: [
                            Math.floor(1 / viewScale * 100),
                            "%"
                        ]
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $65c5e8bf16e9c608$export$2e2bcd8739ae039), {
                        size: "1.1em"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $54cc07ecaf352272$export$2e2bcd8739ae039), {
                visible: zoomMenuOpen,
                style: {
                    left: `${zoomButtonRect.current?.x + zoomButtonRect.current?.width + 4}px`,
                    bottom: 0
                },
                onClose: ()=>setZoomMenuOpen(false),
                items: [
                    {
                        label: t('menus.zoom_in'),
                        action: 'ZOOM_IN'
                    },
                    {
                        label: t('menus.zoom_out'),
                        action: 'ZOOM_OUT'
                    },
                    {
                        label: t('menus.zoom_100'),
                        action: 'ZOOM_100'
                    },
                    {
                        label: t('menus.zoom_fit'),
                        action: 'ZOOM_FIT'
                    },
                    'hr',
                    {
                        label: t('menus.fullscreen'),
                        shortcut: 'F11',
                        action: 'FULLSCREEN'
                    }
                ]
            })
        ]
    });
};
var $5d111e8a0f2066e2$export$2e2bcd8739ae039 = $5d111e8a0f2066e2$var$Toolbar;




var $h2ArV = parcelRequire("h2ArV");
/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $dfbd774c055342cf$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m9 18 6-6-6-6",
            key: "mthhwq"
        }
    ]
];
const $dfbd774c055342cf$export$2e2bcd8739ae039 = (0, $764ec6f19a629312$export$2e2bcd8739ae039)("chevron-right", $dfbd774c055342cf$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e438f551aa34f135$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M14 2v6a2 2 0 0 0 .245.96l5.51 10.08A2 2 0 0 1 18 22H6a2 2 0 0 1-1.755-2.96l5.51-10.08A2 2 0 0 0 10 8V2",
            key: "18mbvz"
        }
    ],
    [
        "path",
        {
            d: "M6.453 15h11.094",
            key: "3shlmq"
        }
    ],
    [
        "path",
        {
            d: "M8.5 2h7",
            key: "csnxdl"
        }
    ]
];
const $e438f551aa34f135$export$2e2bcd8739ae039 = (0, $764ec6f19a629312$export$2e2bcd8739ae039)("flask-conical", $e438f551aa34f135$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ed9b1098b0fefefa$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z",
            key: "j76jl0"
        }
    ],
    [
        "path",
        {
            d: "M22 10v6",
            key: "1lu8f3"
        }
    ],
    [
        "path",
        {
            d: "M6 12.5V16a6 3 0 0 0 12 0v-3.5",
            key: "1r8lef"
        }
    ]
];
const $ed9b1098b0fefefa$export$2e2bcd8739ae039 = (0, $764ec6f19a629312$export$2e2bcd8739ae039)("graduation-cap", $ed9b1098b0fefefa$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $827a5ca7f496cadf$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M12 16v-4",
            key: "1dtifu"
        }
    ],
    [
        "path",
        {
            d: "M12 8h.01",
            key: "e9boi3"
        }
    ]
];
const $827a5ca7f496cadf$export$2e2bcd8739ae039 = (0, $764ec6f19a629312$export$2e2bcd8739ae039)("info", $827a5ca7f496cadf$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $244b608a864e4ea9$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M14 17H5",
            key: "gfn3mx"
        }
    ],
    [
        "path",
        {
            d: "M19 7h-9",
            key: "6i9tg"
        }
    ],
    [
        "circle",
        {
            cx: "17",
            cy: "17",
            r: "3",
            key: "18b49y"
        }
    ],
    [
        "circle",
        {
            cx: "7",
            cy: "7",
            r: "3",
            key: "dfmy0x"
        }
    ]
];
const $244b608a864e4ea9$export$2e2bcd8739ae039 = (0, $764ec6f19a629312$export$2e2bcd8739ae039)("settings-2", $244b608a864e4ea9$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9e4e2ab5c2f172dc$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z",
            key: "r04s7s"
        }
    ]
];
const $9e4e2ab5c2f172dc$export$2e2bcd8739ae039 = (0, $764ec6f19a629312$export$2e2bcd8739ae039)("star", $9e4e2ab5c2f172dc$export$3efd853dbb351e94);





const $dbe8ae58eb2438c9$export$e6dfd72ab29f8598 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  position: relative;
`;
const $dbe8ae58eb2438c9$export$2ddb90ad54e5f587 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  width: 350px;
  height: 100%;
  background: var(--surface);
  position: relative;
  z-index: 1

  & > div {
    position: absolute;
    inset: 0;
    overflow-y: auto;
  }
`;
const $dbe8ae58eb2438c9$export$a8a3e93435678ff9 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('h2')`
  font-size: 1.2em;
  font-weight: 600;
  margin: .8em 1em .8em 2em;
`;
const $dbe8ae58eb2438c9$export$de65de8213222d10 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('button')`
  position: absolute;
  top: .6em;
  z-index: 1;
  left: -1em;
  height: 2em;
  width: 2em;
  font: inherit;
  color: inherit;
  background: var(--toolbar);
  border: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  border-radius: .3em;
  cursor: pointer;
`;


// export type SidePanelKey = 'test' | 'step' | 'about' | 'options' | 'templates'


var $h2ArV = parcelRequire("h2ArV");
/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $778837682f490239$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "m9 12 2 2 4-4",
            key: "dzmm74"
        }
    ]
];
const $778837682f490239$export$2e2bcd8739ae039 = (0, $764ec6f19a629312$export$2e2bcd8739ae039)("circle-check", $778837682f490239$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4521b69889606e38$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m15 18-6-6 6-6",
            key: "1wnfg3"
        }
    ]
];
const $4521b69889606e38$export$2e2bcd8739ae039 = (0, $764ec6f19a629312$export$2e2bcd8739ae039)("chevron-left", $4521b69889606e38$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $12a3f0203f358cb4$export$3efd853dbb351e94 = [
    [
        "polygon",
        {
            points: "19 20 9 12 19 4 19 20",
            key: "o2sva"
        }
    ],
    [
        "line",
        {
            x1: "5",
            x2: "5",
            y1: "19",
            y2: "5",
            key: "1ocqjk"
        }
    ]
];
const $12a3f0203f358cb4$export$2e2bcd8739ae039 = (0, $764ec6f19a629312$export$2e2bcd8739ae039)("skip-back", $12a3f0203f358cb4$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $79ec9bcde4a03dfc$export$3efd853dbb351e94 = [
    [
        "polygon",
        {
            points: "5 4 15 12 5 20 5 4",
            key: "16p6eg"
        }
    ],
    [
        "line",
        {
            x1: "19",
            x2: "19",
            y1: "5",
            y2: "19",
            key: "futhcm"
        }
    ]
];
const $79ec9bcde4a03dfc$export$2e2bcd8739ae039 = (0, $764ec6f19a629312$export$2e2bcd8739ae039)("skip-forward", $79ec9bcde4a03dfc$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $fb0fb771a77a83a3$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 6h18",
            key: "d0wm0j"
        }
    ],
    [
        "path",
        {
            d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6",
            key: "4alrt4"
        }
    ],
    [
        "path",
        {
            d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2",
            key: "v07s0e"
        }
    ],
    [
        "line",
        {
            x1: "10",
            x2: "10",
            y1: "11",
            y2: "17",
            key: "1uufr5"
        }
    ],
    [
        "line",
        {
            x1: "14",
            x2: "14",
            y1: "11",
            y2: "17",
            key: "xtxkd"
        }
    ]
];
const $fb0fb771a77a83a3$export$2e2bcd8739ae039 = (0, $764ec6f19a629312$export$2e2bcd8739ae039)("trash-2", $fb0fb771a77a83a3$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f6f1f95821435f2a$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "m15 9-6 6",
            key: "1uzhvr"
        }
    ],
    [
        "path",
        {
            d: "m9 9 6 6",
            key: "z0biqf"
        }
    ]
];
const $f6f1f95821435f2a$export$2e2bcd8739ae039 = (0, $764ec6f19a629312$export$2e2bcd8739ae039)("circle-x", $f6f1f95821435f2a$export$3efd853dbb351e94);










const $fca9153c90f9fd50$export$ba5c464ccdc9b6f = (node)=>{
    const trace = [];
    while(node.parent){
        trace.push({
            to: node.state.id,
            tape: node.state.tape,
            read: node.state.read,
            write: node.state.write,
            direction: node.state.direction
        });
        node = node.parent;
    }
    trace.push({
        to: node.state.id,
        tape: node.state.tape,
        read: null,
        write: null,
        direction: null
    });
    return trace.reverse();
};
const $fca9153c90f9fd50$export$9b81d910ca447517 = (graph, input, preferences)=>{
    const problem = (0, $5277478820e2de90$export$af6c7e103af557ec)(graph, input);
    if (!problem) return {
        accepted: false,
        tape: (0, $5277478820e2de90$export$3bf8493817698f1a)(input),
        trace: []
    };
    if (preferences.pauseTM) {
        const result = (0, $a2164468561efe4a$export$bc48d40a3b6f6f4b)(problem);
        if (!result) return {
            trace: [
                {
                    to: 0,
                    read: null,
                    tape: null,
                    write: null,
                    direction: null
                }
            ],
            accepted: false,
            tape: (0, $5277478820e2de90$export$3bf8493817698f1a)(input)
        };
        return {
            accepted: result.state.isFinal,
            tape: result.state.tape,
            trace: $fca9153c90f9fd50$export$ba5c464ccdc9b6f(result)
        };
    } else {
        const result = (0, $a2164468561efe4a$export$98a1d510892e5419)(problem);
        if (!result) return {
            trace: [
                {
                    to: 0,
                    read: null,
                    tape: null,
                    write: null,
                    direction: null
                }
            ],
            accepted: false,
            tape: (0, $5277478820e2de90$export$3bf8493817698f1a)(input)
        };
        return {
            accepted: result.state.isFinal,
            tape: result.state.tape,
            trace: $fca9153c90f9fd50$export$ba5c464ccdc9b6f(result)
        };
    }
};








const $6beaee6853357605$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $h2ArV.createContext)({});
const $6beaee6853357605$var$TestingLab = ()=>{
    const [simulationResult, setSimulationResult] = (0, $h2ArV.useState)();
    const [traceIdx, setTraceIdx] = (0, $h2ArV.useState)(0);
    const [multiTraceOutput, setMultiTraceOutput] = (0, $h2ArV.useState)([]);
    const [showTraceTape, setShowTraceTape] = (0, $h2ArV.useState)(false);
    const [enableManualStepping, setEnableManualStepping] = (0, $h2ArV.useState)(false);
    const [problem, setProblem] = (0, $h2ArV.useState)();
    const [currentManualNode, setCurrentManualNode] = (0, $h2ArV.useState)();
    const [currentManualSuccessors, setCurrentManualSuccessors] = (0, $h2ArV.useState)([]);
    // const [manualExecutionTrace, setManualExecutionTrace] = useState([])
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)('common');
    // Graph state
    const graph = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.getGraph());
    const statePrefix = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project.config?.statePrefix);
    const setProjectSimResults = (0, $6baf371cdce3f20b$export$2e2bcd8739ae039)((s)=>s.setSimResults);
    const setProjectSimTraceIDx = (0, $6baf371cdce3f20b$export$2e2bcd8739ae039)((s)=>s.setTraceIDx);
    const traceInput = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project.tests.single);
    const setTraceInput = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.setSingleTest);
    const multiTraceInput = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project.tests.batch);
    const addMultiTraceInput = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.addBatchTest);
    const updateMultiTraceInput = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.updateBatchTest);
    const removeMultiTraceInput = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.removeBatchTest);
    const lastChangeDate = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.lastChangeDate);
    const projectType = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project.config.type);
    const setPDAVisualiser = (0, $438f85b735159247$export$2e2bcd8739ae039)((state)=>state.setStack);
    // Preference option to pause/unpause TM at Final State
    const preferences = (0, $8af1fe532609b934$export$2e2bcd8739ae039)((state)=>state.preferences);
    const simulateAutomata = (graph, input, node = null)=>{
        let result;
        switch(graph.projectType){
            case 'PDA':
                if (!enableManualStepping) result = (0, $09ed7afcc0cd3b10$export$5da7e2d746a88cec)(graph, input ?? '');
                else {
                    (0, $be180ebd7a95f287$export$804de46662e4ac95)(node);
                    const trace = (0, $09ed7afcc0cd3b10$export$ba5c464ccdc9b6f)(node);
                    const stack = (0, $09ed7afcc0cd3b10$export$4a0f002607da29ea)(trace);
                    result = {
                        accepted: node.state.isFinal && node.state.remaining === '' && stack.length === 0,
                        remaining: node.state.remaining,
                        trace: trace,
                        stack: stack
                    };
                }
                break;
            case 'FSA':
                if (!enableManualStepping) result = (0, $23cb935ba1678867$export$586e59fed64dc8e4)(graph, input ?? '');
                else {
                    (0, $be180ebd7a95f287$export$804de46662e4ac95)(node);
                    const trace = (0, $23cb935ba1678867$export$ba5c464ccdc9b6f)(node);
                    result = {
                        accepted: node.state.isFinal && node.state.remaining === '',
                        remaining: node.state.remaining,
                        trace: trace
                    };
                }
                break;
            case 'TM':
                if (!enableManualStepping) result = (0, $fca9153c90f9fd50$export$9b81d910ca447517)(graph, input ?? '', preferences);
                else {
                    (0, $be180ebd7a95f287$export$804de46662e4ac95)(node);
                    const trace = (0, $fca9153c90f9fd50$export$ba5c464ccdc9b6f)(node);
                    result = {
                        accepted: node.state.isFinal,
                        tape: node.state.tape,
                        trace: trace
                    };
                }
        }
        return result;
    };
    // Add Stepper from (old) SteppingLab
    const stepper = (0, $h2ArV.useMemo)(()=>{
        // Graph stepper for PDA currently requires changes to BFS stack logic
        // to handle non-determinism so branching stops on the first rejected transition.
        return (0, $5277478820e2de90$export$191dfa0423971949)(graph, traceInput);
    }, [
        graph,
        traceInput
    ]);
    const setSteppedStates = (0, $d2aaad49862844e1$export$2e2bcd8739ae039)((s)=>s.setSteppedStates);
    const handleStep = (stepType)=>{
        let frontier = [];
        if (stepper) {
            switch(stepType){
                case 'Forward':
                    frontier = stepper.forward();
                    break;
                case 'Backward':
                    frontier = stepper.backward();
                    break;
                case 'Reset':
                    frontier = stepper.reset();
                    break;
                default:
                    break;
            }
            if (frontier && frontier.length > 0 && !enableManualStepping) setSteppedStates(frontier);
        }
    };
    (0, $h2ArV.useEffect)(()=>{
        if (enableManualStepping) setSteppedStates([]);
        else if (stepper) handleStep('Reset');
    }, [
        traceInput,
        enableManualStepping
    ]);
    /**
   * Runs the correct simulation result for a trace input and returns the result.
   * The simulation function to use depends on the project name
   */ const runSimulation = (input)=>{
        // Find how many transitions can be shown
        // TODO: Find reasoning behind the magical -1
        const transitionCount = (res)=>Math.max(1, res.trace.length) - (res.accepted ? 1 : graph.projectType === 'TM' ? 1 : 0);
        if ([
            'PDA',
            'FSA',
            'TM'
        ].includes(graph.projectType)) {
            let node = null;
            if (enableManualStepping) {
                let _problem = problem;
                // chance problem hasn't been created yet & node hasn't been, set to defaults if not found
                if (!_problem) _problem = (0, $5277478820e2de90$export$af6c7e103af557ec)(graph, input ?? '');
                node = currentManualNode ?? _problem.initial;
                // Sets node for simulation to be next one so ui doesn't say problem in progress is rejected
                if (!_problem.isFinalState(node) && _problem.getSuccessors(node).length !== 0) node = _problem.getSuccessors(node)[0];
            }
            const result = simulateAutomata(graph, input ?? '', node);
            // Formats a symbol. Makes an empty symbol become a lambda
            const formatSymbol = (char)=>char === null || char === '' ? "\u03BB" : char;
            return {
                ...result,
                // We need format the symbols in the trace so any empty symbols become lambdas
                trace: result.trace.map((step)=>({
                        to: step.to,
                        read: formatSymbol(step.read),
                        // Add extra info if its a PDA trace.
                        // I know this isn't needed, but it pleases typescript
                        ...'currentStack' in step ? {
                            pop: formatSymbol(step.pop),
                            push: formatSymbol(step.push),
                            currentStack: step.currentStack
                        } : {},
                        // Info for TMs
                        ...'tape' in step ? {
                            tape: step.tape,
                            write: formatSymbol(step.write),
                            direction: step.direction
                        } : {}
                    })),
                transitionCount: transitionCount(result)
            };
        } else throw new Error(`${projectType} is not supported`);
    };
    /** Runs all multi trace inputs and updates the output */ const rerunMultiTraceInput = ()=>{
        setMultiTraceOutput(multiTraceInput.map((input)=>runSimulation(input)));
    };
    const simulateGraph = (0, $h2ArV.useCallback)(()=>{
        const result = runSimulation(traceInput);
        // The `in` is just to type narrow for TS
        if ('tape' in result) {
            setSimulationResult(result);
            setProjectSimResults([
                {
                    accepted: result.accepted,
                    ...result
                }
            ]) // Currently for just a single simulation result. (DTM. Not yet NDTM).
            ;
        } else {
            setSimulationResult(result);
            // Adds result to PDA visualiser
            if (graph.projectType === 'PDA') setPDAVisualiser(result);
        }
        return result;
    }, [
        graph,
        traceInput,
        enableManualStepping,
        currentManualNode
    ]);
    // Determine last position allowed
    const lastTraceIdx = simulationResult?.transitionCount;
    const getStateName = (0, $h2ArV.useCallback)((id)=>graph.states.find((s)=>s.id === id)?.name, [
        graph.states
    ]);
    // Returns a string representing the transition from parent to current node, or empty string if no parent
    function nodeTransitionString(node) {
        if (node.parent !== null) return `${node.state.toTransitionString()}: ${getStateName(node.parent.state.id) ?? statePrefix + node.parent.state.id} -> ${getStateName(node.state.id) ?? statePrefix + node.state.id}`;
        else return '';
    }
    // Returns array of strings representing the transitions in the trace
    function traceTransitionsString(projectType, trace) {
        let transitions;
        switch(projectType){
            case 'FSA':
                (0, $be180ebd7a95f287$export$804de46662e4ac95)(trace);
                transitions = trace.slice(0, -1).map((_, i)=>[
                        trace[i + 1]?.read,
                        trace[i]?.to,
                        trace[i + 1]?.to
                    ]).map(([read, start, end])=>`${read}: ${getStateName(start) ?? statePrefix + start} -> ${getStateName(end) ?? statePrefix + end}`).filter((_x, i)=>i < traceIdx);
                break;
            case 'PDA':
                (0, $be180ebd7a95f287$export$804de46662e4ac95)(trace);
                transitions = trace.slice(0, -1).map((_, i)=>[
                        trace[i + 1]?.read,
                        trace[i]?.to,
                        trace[i + 1]?.to,
                        trace[i + 1]?.pop,
                        trace[i + 1]?.push
                    ]).map(([read, start, end, pop, push])=>`${read},${pop};${push}: ${getStateName(start) ?? statePrefix + start} -> ${getStateName(end) ?? statePrefix + end}`).filter((_x, i)=>i < traceIdx);
                break;
            case 'TM':
                (0, $be180ebd7a95f287$export$804de46662e4ac95)(trace);
                transitions = trace.slice(0, -1).map((_, i)=>[
                        trace[i + 1]?.read,
                        trace[i]?.to,
                        trace[i + 1]?.to,
                        trace[i + 1]?.write,
                        trace[i + 1]?.direction
                    ]).map(([read, start, end, write, direction])=>`${read},${write};${direction}: ${getStateName(start) ?? statePrefix + start} -> ${getStateName(end) ?? statePrefix + end}`).filter((_x, i)=>i < traceIdx);
        }
        return transitions;
    }
    const traceOutput = (0, $h2ArV.useMemo)(()=>{
        // No output before simulating
        if (!simulationResult) return '';
        (0, $be180ebd7a95f287$export$804de46662e4ac95)(simulationResult);
        const { trace: trace, accepted: accepted } = simulationResult;
        // Return null if not enough states in trace to render transitions
        if (trace.length < 2) {
            if (traceIdx > 0) return accepted ? t('testing_lab.acceped') : t('testing_lab.rejected');
            return null;
        }
        // Represent transitions as strings of form 'read: start -> end'
        const transitions = traceTransitionsString(graph.projectType, trace);
        let transitionsWithRejected = [
            ''
        ];
        if ('remaining' in simulationResult) // Add rejecting transition if applicable
        transitionsWithRejected = !accepted && traceIdx === trace.length ? [
            ...transitions,
            simulationResult.remaining[0] ? `${simulationResult.remaining[0]}: ${getStateName(trace[trace.length - 1].to) ?? statePrefix + trace[trace.length - 1].to} ->|` : `\n${getStateName(trace[trace.length - 1].to) ?? statePrefix + trace[trace.length - 1].to} ->|`
        ] : transitions;
        else // TODO add failed transition text for turing machines
        transitionsWithRejected = transitions;
        // Add 'REJECTED'/'ACCEPTED' label
        return `${transitionsWithRejected.join('\n')}${traceIdx === lastTraceIdx || enableManualStepping && currentManualSuccessors.length === 0 ? '\n\n' + (accepted ? t('testing_lab.accepted') : t('testing_lab.rejected')) : ''}`;
    }, [
        traceInput,
        simulationResult,
        statePrefix,
        traceIdx,
        getStateName,
        enableManualStepping
    ]);
    // Creates problem and sets it, should run every time trace/graph changes while enableManualStepping is enabled
    (0, $h2ArV.useEffect)(()=>{
        if (enableManualStepping) {
            const _problem = (0, $5277478820e2de90$export$af6c7e103af557ec)(graph, traceInput);
            if (_problem != null) {
                setProblem(_problem);
                setCurrentManualNode(_problem.initial);
                setTraceIdx(0);
            }
        } else setTraceIdx(0);
    }, [
        enableManualStepping,
        traceInput,
        lastChangeDate
    ]);
    // To move execution path back when backtracking while enableManualStepping is enabled
    (0, $h2ArV.useEffect)(()=>{
        if (enableManualStepping) {
            let nodeChainLength = 0;
            let currentNode = currentManualNode;
            while(currentNode){
                nodeChainLength += 1;
                currentNode = currentNode.parent;
            }
            // If traceIdx is larger than nodes in manual execution, then shrink
            if (nodeChainLength > traceIdx + 1) {
                const amountToShrink = nodeChainLength - (traceIdx + 1);
                for(let i = 0; i < amountToShrink; i++)setCurrentManualNode(currentManualNode.parent);
            }
        }
    }, [
        traceIdx
    ]);
    // Runs every time new node is selected while enableManualStepping is enabled
    (0, $h2ArV.useEffect)(()=>{
        if (enableManualStepping) // Updates array of successors
        {
            if (currentManualNode != null && problem) {
                if (preferences.pauseTM && problem.isFinalState(currentManualNode)) setCurrentManualSuccessors([]);
                else setCurrentManualSuccessors(problem.getSuccessors(currentManualNode));
            }
        }
    }, [
        traceInput,
        problem,
        currentManualNode
    ]);
    // To force simulation to update
    (0, $h2ArV.useEffect)(()=>{
        simulateGraph();
    }, [
        traceInput,
        enableManualStepping,
        currentManualNode
    ]);
    // Resets simultation on graph change
    (0, $h2ArV.useEffect)(()=>{
        simulateGraph();
        setMultiTraceOutput([]);
        setTraceIdx(0);
    }, [
        lastChangeDate
    ]);
    // Set the trace IDx to be passed through store to TMTapeLab component
    (0, $h2ArV.useEffect)(()=>{
        if ([
            'TM',
            'PDA'
        ].includes(graph.projectType)) setProjectSimTraceIDx(traceIdx);
    // Try this for PDA as well - stack display
    }, [
        traceIdx
    ]);
    // Update warnings
    const noInitialState = [
        null,
        undefined
    ].includes(graph?.initialState) || !graph?.states.find((s)=>s.id === graph?.initialState);
    const noFinalState = !graph?.states.find((s)=>s.isFinal);
    const warnings = [];
    // Update disconnected warning
    const pathToFinal = (0, $h2ArV.useMemo)(()=>{
        // Solution to #359 - Concat the intial state to solve the problem that a legal 1 state (both initial and final) 0 transition machine can accept λ
        const closure = (0, $744f32c7b11f678d$export$da171dcc955f709b)(graph, graph.initialState, ()=>true);
        return Array.from(closure).concat({
            state: graph.initialState,
            transitions: []
        }).some(({ state: state })=>graph.states.find((s)=>s.id === state)?.isFinal);
    }, [
        graph
    ]);
    // Also part of #359 - No need to flag that there is a disconnection if # states <= 1
    if (noInitialState) warnings.push(t('testing_lab.no_initial'));
    if (noFinalState) warnings.push(t('testing_lab.no_final'));
    else if (!pathToFinal) warnings.push(t('testing_lab.no_path'));
    // :^)
    const dibEgg = (0, $1b50533b0f169454$export$2e2bcd8739ae039)();
    // Determine input position
    const currentTrace = simulationResult?.trace.slice(0, traceIdx + 1) ?? [];
    const inputIdx = currentTrace.map((tr)=>'read' in tr && tr.read !== "\u03BB" ? 1 : 0).reduce((a, b)=>a + b, 0) ?? 0;
    const currentStateID = currentTrace?.[currentTrace.length - 1]?.to ?? graph?.initialState;
    const automataIsInvalid = noInitialState || noFinalState || !pathToFinal;
    // Display the valid transitions that could be manually chosen
    const buttonsArray = [];
    currentManualSuccessors.forEach((t)=>{
        // Add transition to the form of <Button>{'a,X;R: q0 -> q1'}</Button>
        buttonsArray.push(/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
            onClick: ()=>{
                setCurrentManualNode(t);
                setTraceIdx(traceIdx + 1);
            },
            children: nodeTransitionString(t)
        }, nodeTransitionString(t)));
    });
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
        children: [
            showTraceTape && graph.projectType !== 'TM' && traceInput !== '' && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $b3533db5722e5be6$export$2e2bcd8739ae039), {
                input: traceInput,
                index: inputIdx,
                stateID: currentStateID
            }),
            warnings.length > 0 && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $f6c0a8acd60d8875$export$2e2bcd8739ae039), {
                        children: t('testing_lab.warnings')
                    }),
                    warnings.map((warning)=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $07c16c411dfdf516$export$faadb9d3691bb990), {
                            children: [
                                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $8f2b0b47dafdf586$export$2e2bcd8739ae039), {}),
                                warning
                            ]
                        }, warning))
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $f6c0a8acd60d8875$export$2e2bcd8739ae039), {
                children: t('testing_lab.trace')
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $07c16c411dfdf516$export$e6dfd72ab29f8598), {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                        onChange: (e)=>{
                            setTraceInput(e.target.value);
                            setTraceIdx(0);
                            setSimulationResult(undefined);
                        },
                        value: traceInput ?? '',
                        placeholder: "\u03BB"
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $07c16c411dfdf516$export$9e2d3073c028f69a), {
                        children: [
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                                icon: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $12a3f0203f358cb4$export$2e2bcd8739ae039), {
                                    size: 20
                                }),
                                disabled: traceIdx <= 0 || automataIsInvalid,
                                onClick: ()=>{
                                    setTraceIdx(0);
                                    handleStep('Reset');
                                }
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                                icon: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $4521b69889606e38$export$2e2bcd8739ae039), {
                                    size: 23
                                }),
                                disabled: traceIdx <= 0 || automataIsInvalid,
                                onClick: ()=>{
                                    setTraceIdx(traceIdx - 1);
                                    handleStep('Backward');
                                }
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                                icon: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $dfbd774c055342cf$export$2e2bcd8739ae039), {
                                    size: 23
                                }),
                                disabled: traceIdx >= lastTraceIdx || automataIsInvalid || enableManualStepping,
                                onClick: ()=>{
                                    if (!simulationResult) simulateGraph();
                                    setTraceIdx(traceIdx + 1);
                                    handleStep('Forward');
                                }
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                                icon: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $79ec9bcde4a03dfc$export$2e2bcd8739ae039), {
                                    size: 20
                                }),
                                disabled: traceIdx >= lastTraceIdx || automataIsInvalid || enableManualStepping,
                                onClick: ()=>{
                                    // Increment tracer index
                                    const result = simulationResult ?? simulateGraph();
                                    setTraceIdx(lastTraceIdx);
                                    dibEgg(traceInput, result.accepted);
                                }
                            })
                        ]
                    }),
                    traceOutput && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $46256ad23271a97e$export$2e2bcd8739ae039), {
                                result: simulationResult,
                                step: traceIdx,
                                statePrefix: statePrefix,
                                states: graph.states
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $07c16c411dfdf516$export$9d58cd99b2891644), {
                                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("pre", {
                                    children: traceOutput
                                })
                            })
                        ]
                    }),
                    projectType !== 'TM' && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e44002cbb4794c3a$export$2e2bcd8739ae039), {
                        label: (0, $h2ArV.useMemo)(()=>Math.random() < 0.001 ? t('testing_lab.trace_buddy') : t('testing_lab.trace_tape'), []),
                        style: {
                            marginBlock: 0
                        },
                        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $0770ae362b3cd6e9$export$2e2bcd8739ae039), {
                            type: "checkbox",
                            checked: showTraceTape,
                            disabled: automataIsInvalid,
                            onChange: (e)=>setShowTraceTape(e.target.checked)
                        })
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e44002cbb4794c3a$export$2e2bcd8739ae039), {
                        label: t('testing_lab.manual'),
                        style: {
                            marginBlock: 0
                        },
                        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $0770ae362b3cd6e9$export$2e2bcd8739ae039), {
                            type: "checkbox",
                            checked: enableManualStepping,
                            disabled: automataIsInvalid,
                            onChange: (e)=>setEnableManualStepping(e.target.checked)
                        })
                    })
                ]
            }),
            enableManualStepping && currentManualSuccessors.length !== 0 && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $f6c0a8acd60d8875$export$2e2bcd8739ae039), {
                        children: t('testing_lab.transitions')
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $07c16c411dfdf516$export$e6dfd72ab29f8598), {
                        children: buttonsArray
                    })
                ]
            }),
            !enableManualStepping && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $f6c0a8acd60d8875$export$2e2bcd8739ae039), {
                        children: t('testing_lab.multirun')
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $07c16c411dfdf516$export$e6dfd72ab29f8598), {
                        children: [
                            multiTraceInput.map((value, index)=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $07c16c411dfdf516$export$bb965054011846aa), {
                                    children: [
                                        multiTraceOutput?.[index]?.accepted !== undefined && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $07c16c411dfdf516$export$b131c49b26d3f427), {
                                            $accepted: multiTraceOutput[index].accepted,
                                            children: multiTraceOutput[index].accepted ? /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $778837682f490239$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $f6f1f95821435f2a$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                                            onChange: (e)=>{
                                                updateMultiTraceInput(index, e.target.value);
                                                setMultiTraceOutput([]);
                                            },
                                            value: value,
                                            placeholder: "\u03BB",
                                            color: multiTraceOutput?.[index]?.accepted !== undefined ? multiTraceOutput[index].accepted ? 'success' : 'error' : undefined,
                                            onPaste: (e)=>{
                                                const paste = e.clipboardData.getData('text');
                                                if (!paste.includes('\n')) return;
                                                e.preventDefault();
                                                const lines = paste.split(/\r?\n/).filter((l)=>l !== '');
                                                lines.forEach((l, i)=>i === 0 ? updateMultiTraceInput(index, l) : addMultiTraceInput(l));
                                            },
                                            onKeyDown: (e)=>{
                                                (0, $be180ebd7a95f287$export$804de46662e4ac95)(e.target);
                                                if (e.key === 'Enter' && !e.repeat) {
                                                    if (e.metaKey || e.ctrlKey) // Run shortcut
                                                    rerunMultiTraceInput();
                                                    else {
                                                        addMultiTraceInput();
                                                        window.setTimeout(()=>e.target.closest('div').parentElement?.querySelector('div:last-of-type > input')?.focus(), 50);
                                                    }
                                                }
                                                if (e.key === 'Backspace' && value === '' && !e.repeat) {
                                                    if (multiTraceInput.length === 1) return;
                                                    e.preventDefault();
                                                    e.target?.focus();
                                                    if (e.target.closest('div').parentElement?.querySelector('div:last-of-type > input') === e.target) e.target?.closest('div')?.previousSibling?.querySelector('input')?.focus();
                                                    removeMultiTraceInput(index);
                                                    setMultiTraceOutput([]);
                                                }
                                                if (e.key === 'ArrowUp') e.target?.closest('div')?.previousSibling?.querySelector('input')?.focus();
                                                if (e.key === 'ArrowDown') e.target?.closest('div')?.nextSibling?.querySelector('input')?.focus();
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $07c16c411dfdf516$export$4e9d5ce1e6c22a94), {
                                            onClick: (e)=>{
                                                const container = e.target.closest('div');
                                                const next = container?.nextSibling?.tagName === 'DIV' || multiTraceInput.length === 1 ? container : container?.previousSibling;
                                                if (multiTraceInput.length === 1) updateMultiTraceInput(index, '');
                                                else removeMultiTraceInput(index);
                                                next?.querySelector('input')?.focus();
                                                setMultiTraceOutput([]);
                                            },
                                            title: "Remove",
                                            children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $fb0fb771a77a83a3$export$2e2bcd8739ae039), {})
                                        })
                                    ]
                                }, index)),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                                secondary: true,
                                onClick: ()=>{
                                    addMultiTraceInput();
                                    setMultiTraceOutput([]);
                                },
                                icon: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $21c0b4c3fc3b1107$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                                onClick: ()=>{
                                    rerunMultiTraceInput();
                                },
                                children: t('testing_lab.run')
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $6beaee6853357605$export$2e2bcd8739ae039 = $6beaee6853357605$var$TestingLab;




var $h2ArV = parcelRequire("h2ArV");




const $b8018bb661023881$export$e6dfd72ab29f8598 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  flex-direction: column;
  gap: .8rem;
  margin-block: .8rem;
  padding-inline: .8rem;
  overflow-x: auto;
`;
const $b8018bb661023881$export$3e25e887b7a5b37b = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: inline-block;
  align-items: center;
  text-align: center;
  justify-content: center;
  min-width: 2em;
  height: 2em;
  line-height: 2em;
  padding: 0 0.5em;
  background: var(--toolbar);
  border-radius: .2rem;
  box-sizing: border-box;
  font-size: 1.1rem;
`;
const $b8018bb661023881$export$2d50c51cb2418e58 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  flex-wrap: wrap;
  gap: .4em;
`;



const $051125520ff239fe$var$Info = ()=>{
    const statePrefix = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project?.config?.statePrefix);
    const states = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project?.states);
    const transitions = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project?.transitions);
    const graph = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.getGraph());
    const projectType = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project.config.type);
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)('common');
    // Function to get name of state from an id
    const getStateName = (0, $h2ArV.useCallback)((id)=>graph.states.find((s)=>s.id === id)?.name || `${statePrefix ?? 'q'}${id}`, [
        graph.states,
        statePrefix
    ]);
    // Determine alphabet
    const alphabet = (0, $h2ArV.useMemo)(()=>{
        return Array.from(new Set(graph.transitions.reduce((acc, tr)=>{
            // Type assertion here
            return tr.read.startsWith('!') ? [
                ...acc,
                tr.read
            ] : [
                ...acc,
                ...tr.read.split('')
            ];
        }, []).sort()));
    }, [
        transitions
    ]);
    // Determine stack alphabet
    const stackAlphabet = (0, $h2ArV.useMemo)(()=>{
        if (projectType !== 'PDA') return [];
        const pdaGraph = graph;
        const stackAlphabetSet = new Set();
        pdaGraph.transitions.forEach((transition)=>{
            if (transition.pop) stackAlphabetSet.add(transition.pop);
            if (transition.push) stackAlphabetSet.add(transition.push);
        });
        return Array.from(stackAlphabetSet).sort();
    }, [
        graph.transitions
    ]);
    const transitionMap = (0, $h2ArV.useMemo)(()=>{
        const map = new Map() // (ID, Symbol) -> ID[]
        ;
        for (const state of states ?? [])for (const symbol of alphabet){
            // Important it is set to variable, since the key needs to share the address
            const key = [
                state.id,
                symbol
            ];
            const transitions = (0, $aefca3fec3d879d9$export$fed428813706893a)(graph, state.id, symbol);
            for (const { transition: transition } of transitions){
                // Record accessibility after transition
                map.set(key, Array.from(new Set([
                    ...map.get(key) ?? [],
                    transition.to
                ])));
                // Record accessibility of states indirectly accessible after transition via lambdas
                if (transition.read.length > 0) {
                    const lambdaClosure = (0, $744f32c7b11f678d$export$da171dcc955f709b)(graph, transition.to, (tr)=>tr.read.length === 0);
                    for (const { state: state } of lambdaClosure)map.set(key, Array.from(new Set([
                        ...map.get(key) ?? [],
                        state
                    ])));
                }
            }
        }
        return map;
    }, [
        states,
        alphabet,
        graph
    ]);
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $f6c0a8acd60d8875$export$2e2bcd8739ae039), {
                children: t('info.alphabet')
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $b8018bb661023881$export$e6dfd72ab29f8598), {
                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $b8018bb661023881$export$2d50c51cb2418e58), {
                    children: alphabet.map((symbol)=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $b8018bb661023881$export$3e25e887b7a5b37b), {
                            children: symbol
                        }, symbol))
                })
            }),
            projectType === 'PDA' && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $f6c0a8acd60d8875$export$2e2bcd8739ae039), {
                        children: t('info.stack_alphabet')
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $b8018bb661023881$export$e6dfd72ab29f8598), {
                        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $b8018bb661023881$export$2d50c51cb2418e58), {
                            children: stackAlphabet.map((symbol)=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $b8018bb661023881$export$3e25e887b7a5b37b), {
                                    children: symbol
                                }, symbol))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $f6c0a8acd60d8875$export$2e2bcd8739ae039), {
                children: t('info.state_transition_table')
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $b8018bb661023881$export$e6dfd72ab29f8598), {
                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $782e9208955d1521$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("tbody", {
                        children: [
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("th", {
                                        children: "\u03B4"
                                    }),
                                    alphabet.map((symbol)=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("th", {
                                            children: symbol
                                        }, symbol))
                                ]
                            }),
                            graph.states?.map((state)=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("th", {
                                            children: getStateName(state.id)
                                        }),
                                        alphabet.map((symbol)=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("td", {
                                                children: [
                                                    ...transitionMap.entries()
                                                ].filter(([[stateID, read]])=>stateID === state.id && read === symbol).map(([, states])=>states.map((id)=>getStateName(id)).join(', '))[0] ?? '-'
                                            }, symbol))
                                    ]
                                }, state.id))
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $f6c0a8acd60d8875$export$2e2bcd8739ae039), {
                children: t('info.transition_function')
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $b8018bb661023881$export$e6dfd72ab29f8598), {
                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $782e9208955d1521$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("tbody", {
                        children: [
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("th", {
                                        children: "Q \xd7 \u03A3"
                                    }),
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("th", {
                                        children: " \u03B4(Q \xd7 \u03A3) "
                                    })
                                ]
                            }),
                            [
                                ...transitionMap.entries()
                            ].map(([[state, read], states])=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("td", {
                                            children: [
                                                "(",
                                                getStateName(state),
                                                ", ",
                                                read,
                                                ")"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("td", {
                                            children: `{${states.sort().map((id)=>getStateName(id)).join(',')}}`
                                        })
                                    ]
                                }, `${state},${read}`))
                        ]
                    })
                })
            })
        ]
    });
};
var $051125520ff239fe$export$2e2bcd8739ae039 = $051125520ff239fe$var$Info;






const $cf8c0bdc35ba5067$export$e6dfd72ab29f8598 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  padding-inline: .8rem;
`;



const $a43fca37b450352e$var$Options = ()=>{
    const statePrefix = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project?.config?.statePrefix);
    const orOperator = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project?.config?.orOperator);
    const projectColor = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project?.config?.color);
    const updateConfig = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.updateConfig);
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)('common');
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $f6c0a8acd60d8875$export$2e2bcd8739ae039), {
                children: t('options.states')
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $cf8c0bdc35ba5067$export$e6dfd72ab29f8598), {
                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e44002cbb4794c3a$export$2e2bcd8739ae039), {
                    label: t('options.identifier'),
                    description: t('options.identifier_desc'),
                    children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                        small: true,
                        style: {
                            width: '8ch'
                        },
                        value: statePrefix ?? 'q',
                        onChange: (e)=>updateConfig({
                                statePrefix: e.target.value
                            })
                    })
                })
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $f6c0a8acd60d8875$export$2e2bcd8739ae039), {
                children: t('options.operators')
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $cf8c0bdc35ba5067$export$e6dfd72ab29f8598), {
                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e44002cbb4794c3a$export$2e2bcd8739ae039), {
                    label: t('options.or_operator'),
                    description: t('options.or_desc'),
                    children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                        type: "select",
                        small: true,
                        value: orOperator === '' || !orOperator ? '|' : orOperator,
                        onChange: (e)=>updateConfig({
                                orOperator: e.target.value
                            }),
                        children: [
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                value: "\u2223",
                                children: "\u2223"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                value: "\u2225",
                                children: "\u2225"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                value: "\uFF0B",
                                children: "\uFF0B"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                value: "\u2228",
                                children: "v"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                value: "OR",
                                children: t('OR')
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                value: " ",
                                children: t('options.none')
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $f6c0a8acd60d8875$export$2e2bcd8739ae039), {
                children: t('options.theme')
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $cf8c0bdc35ba5067$export$e6dfd72ab29f8598), {
                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e44002cbb4794c3a$export$2e2bcd8739ae039), {
                    label: t('options.colour'),
                    description: t('options.colour_desc'),
                    children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                        type: "select",
                        small: true,
                        value: projectColor === '' || !projectColor ? 'orange' : projectColor,
                        onChange: (e)=>updateConfig({
                                color: e.target.value
                            }),
                        children: [
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                value: "red",
                                children: t('colours.red')
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                value: "orange",
                                children: t('colours.orange')
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                value: "green",
                                children: t('colours.green')
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                value: "teal",
                                children: t('colours.teal')
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                value: "blue",
                                children: t('colours.blue')
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                value: "purple",
                                children: t('colours.purple')
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                value: "pink",
                                children: t('colours.pink')
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $a43fca37b450352e$export$2e2bcd8739ae039 = $a43fca37b450352e$var$Options;






var $h2ArV = parcelRequire("h2ArV");

var $h2ArV = parcelRequire("h2ArV");
var $cf42f49a775636e7$var$isCheckBoxInput = (element)=>element.type === 'checkbox';
var $cf42f49a775636e7$var$isDateObject = (value1)=>value1 instanceof Date;
var $cf42f49a775636e7$var$isNullOrUndefined = (value1)=>value1 == null;
const $cf42f49a775636e7$var$isObjectType = (value1)=>typeof value1 === 'object';
var $cf42f49a775636e7$var$isObject = (value1)=>!$cf42f49a775636e7$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $cf42f49a775636e7$var$isObjectType(value1) && !$cf42f49a775636e7$var$isDateObject(value1);
var $cf42f49a775636e7$var$getEventValue = (event)=>$cf42f49a775636e7$var$isObject(event) && event.target ? $cf42f49a775636e7$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var $cf42f49a775636e7$var$getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var $cf42f49a775636e7$var$isNameInFieldArray = (names, name)=>names.has($cf42f49a775636e7$var$getNodeParentName(name));
var $cf42f49a775636e7$var$isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $cf42f49a775636e7$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf');
};
var $cf42f49a775636e7$var$isWeb = typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined' && typeof document !== 'undefined';
function $cf42f49a775636e7$var$cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    const isFileListInstance = typeof FileList !== 'undefined' ? data instanceof FileList : false;
    if (data instanceof Date) copy = new Date(data);
    else if (!($cf42f49a775636e7$var$isWeb && (data instanceof Blob || isFileListInstance)) && (isArray || $cf42f49a775636e7$var$isObject(data))) {
        copy = isArray ? [] : Object.create(Object.getPrototypeOf(data));
        if (!isArray && !$cf42f49a775636e7$var$isPlainObject(data)) copy = data;
        else {
            for(const key in data)if (data.hasOwnProperty(key)) copy[key] = $cf42f49a775636e7$var$cloneObject(data[key]);
        }
    } else return data;
    return copy;
}
var $cf42f49a775636e7$var$isKey = (value1)=>/^\w*$/.test(value1);
var $cf42f49a775636e7$var$isUndefined = (val)=>val === undefined;
var $cf42f49a775636e7$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var $cf42f49a775636e7$var$stringToPath = (input)=>$cf42f49a775636e7$var$compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));
var $cf42f49a775636e7$export$3988ae62b71be9a3 = (object, path, defaultValue)=>{
    if (!path || !$cf42f49a775636e7$var$isObject(object)) return defaultValue;
    const result = ($cf42f49a775636e7$var$isKey(path) ? [
        path
    ] : $cf42f49a775636e7$var$stringToPath(path)).reduce((result, key)=>$cf42f49a775636e7$var$isNullOrUndefined(result) ? result : result[key], object);
    return $cf42f49a775636e7$var$isUndefined(result) || result === object ? $cf42f49a775636e7$var$isUndefined(object[path]) ? defaultValue : object[path] : result;
};
var $cf42f49a775636e7$var$isBoolean = (value1)=>typeof value1 === 'boolean';
var $cf42f49a775636e7$export$adaa4cf7ef1b65be = (object, path, value1)=>{
    let index = -1;
    const tempPath = $cf42f49a775636e7$var$isKey(path) ? [
        path
    ] : $cf42f49a775636e7$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $cf42f49a775636e7$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        object[key] = newValue;
        object = object[key];
    }
};
const $cf42f49a775636e7$var$EVENTS = {
    BLUR: 'blur',
    FOCUS_OUT: 'focusout',
    CHANGE: 'change'
};
const $cf42f49a775636e7$var$VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all'
};
const $cf42f49a775636e7$var$INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate'
};
const $cf42f49a775636e7$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).createContext(null);
$cf42f49a775636e7$var$HookFormContext.displayName = 'HookFormContext';
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $cf42f49a775636e7$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useContext($cf42f49a775636e7$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $cf42f49a775636e7$export$8ce1ff4f94d08846 = (props)=>{
    const { children: children, ...data } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).createElement($cf42f49a775636e7$var$HookFormContext.Provider, {
        value: data
    }, children);
};
var $cf42f49a775636e7$var$getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {
        defaultValues: control._defaultValues
    };
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== $cf42f49a775636e7$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $cf42f49a775636e7$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
const $cf42f49a775636e7$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useLayoutEffect : (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useEffect;
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $cf42f49a775636e7$export$606f11b2eb45ecc6(props) {
    const methods = $cf42f49a775636e7$export$4d957a5e1be13b03();
    const { control: control = methods.control, disabled: disabled, name: name, exact: exact } = props || {};
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useState(control._formState);
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        validatingFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    $cf42f49a775636e7$var$useIsomorphicLayoutEffect(()=>control._subscribe({
            name: name,
            formState: _localProxyFormState.current,
            exact: exact,
            callback: (formState)=>{
                !disabled && updateFormState({
                    ...control._formState,
                    ...formState
                });
            }
        }), [
        name,
        disabled,
        exact
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useEffect(()=>{
        _localProxyFormState.current.isValid && control._setValid(true);
    }, [
        control
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useMemo(()=>$cf42f49a775636e7$var$getProxyFormState(formState, control, _localProxyFormState.current, false), [
        formState,
        control
    ]);
}
var $cf42f49a775636e7$var$isString = (value1)=>typeof value1 === 'string';
var $cf42f49a775636e7$var$generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if ($cf42f49a775636e7$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $cf42f49a775636e7$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $cf42f49a775636e7$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
var $cf42f49a775636e7$var$isPrimitive = (value1)=>$cf42f49a775636e7$var$isNullOrUndefined(value1) || !$cf42f49a775636e7$var$isObjectType(value1);
function $cf42f49a775636e7$var$deepEqual(object1, object2, _internal_visited = new WeakSet()) {
    if ($cf42f49a775636e7$var$isPrimitive(object1) || $cf42f49a775636e7$var$isPrimitive(object2)) return object1 === object2;
    if ($cf42f49a775636e7$var$isDateObject(object1) && $cf42f49a775636e7$var$isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    if (_internal_visited.has(object1) || _internal_visited.has(object2)) return true;
    _internal_visited.add(object1);
    _internal_visited.add(object2);
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== 'ref') {
            const val2 = object2[key];
            if ($cf42f49a775636e7$var$isDateObject(val1) && $cf42f49a775636e7$var$isDateObject(val2) || $cf42f49a775636e7$var$isObject(val1) && $cf42f49a775636e7$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$cf42f49a775636e7$var$deepEqual(val1, val2, _internal_visited) : val1 !== val2) return false;
        }
    }
    return true;
}
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $cf42f49a775636e7$export$3c773aa2b84f29e0(props) {
    const methods = $cf42f49a775636e7$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact, compute: compute } = props || {};
    const _defaultValue = (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useRef(defaultValue);
    const _compute = (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useRef(compute);
    const _computeFormValues = (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useRef(undefined);
    _compute.current = compute;
    const defaultValueMemo = (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useMemo(()=>control._getWatch(name, _defaultValue.current), [
        control,
        name
    ]);
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useState(_compute.current ? _compute.current(defaultValueMemo) : defaultValueMemo);
    $cf42f49a775636e7$var$useIsomorphicLayoutEffect(()=>control._subscribe({
            name: name,
            formState: {
                values: true
            },
            exact: exact,
            callback: (formState)=>{
                if (!disabled) {
                    const formValues = $cf42f49a775636e7$var$generateWatchOutput(name, control._names, formState.values || control._formValues, false, _defaultValue.current);
                    if (_compute.current) {
                        const computedFormValues = _compute.current(formValues);
                        if (!$cf42f49a775636e7$var$deepEqual(computedFormValues, _computeFormValues.current)) {
                            updateValue(computedFormValues);
                            _computeFormValues.current = computedFormValues;
                        }
                    } else updateValue(formValues);
                }
            }
        }), [
        control,
        disabled,
        name,
        exact
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useEffect(()=>control._removeUnmounted());
    return value1;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $cf42f49a775636e7$export$e8c786024a2b0a79(props) {
    const methods = $cf42f49a775636e7$export$4d957a5e1be13b03();
    const { name: name, disabled: disabled, control: control = methods.control, shouldUnregister: shouldUnregister, defaultValue: defaultValue } = props;
    const isArrayField = $cf42f49a775636e7$var$isNameInFieldArray(control._names.array, name);
    const defaultValueMemo = (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useMemo(()=>$cf42f49a775636e7$export$3988ae62b71be9a3(control._formValues, name, $cf42f49a775636e7$export$3988ae62b71be9a3(control._defaultValues, name, defaultValue)), [
        control,
        name,
        defaultValue
    ]);
    const value1 = $cf42f49a775636e7$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: defaultValueMemo,
        exact: true
    });
    const formState = $cf42f49a775636e7$export$606f11b2eb45ecc6({
        control: control,
        name: name,
        exact: true
    });
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useRef(props);
    const _previousNameRef = (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useRef(undefined);
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useRef(control.register(name, {
        ...props.rules,
        value: value1,
        ...$cf42f49a775636e7$var$isBoolean(props.disabled) ? {
            disabled: props.disabled
        } : {}
    }));
    _props.current = props;
    const fieldState = (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useMemo(()=>Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!$cf42f49a775636e7$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!$cf42f49a775636e7$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!$cf42f49a775636e7$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            isValidating: {
                enumerable: true,
                get: ()=>!!$cf42f49a775636e7$export$3988ae62b71be9a3(formState.validatingFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>$cf42f49a775636e7$export$3988ae62b71be9a3(formState.errors, name)
            }
        }), [
        formState,
        name
    ]);
    const onChange = (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useCallback((event)=>_registerProps.current.onChange({
            target: {
                value: $cf42f49a775636e7$var$getEventValue(event),
                name: name
            },
            type: $cf42f49a775636e7$var$EVENTS.CHANGE
        }), [
        name
    ]);
    const onBlur = (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useCallback(()=>_registerProps.current.onBlur({
            target: {
                value: $cf42f49a775636e7$export$3988ae62b71be9a3(control._formValues, name),
                name: name
            },
            type: $cf42f49a775636e7$var$EVENTS.BLUR
        }), [
        name,
        control._formValues
    ]);
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useCallback((elm)=>{
        const field = $cf42f49a775636e7$export$3988ae62b71be9a3(control._fields, name);
        if (field && elm) field._f.ref = {
            focus: ()=>elm.focus && elm.focus(),
            select: ()=>elm.select && elm.select(),
            setCustomValidity: (message)=>elm.setCustomValidity(message),
            reportValidity: ()=>elm.reportValidity()
        };
    }, [
        control._fields,
        name
    ]);
    const field = (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useMemo(()=>({
            name: name,
            value: value1,
            ...$cf42f49a775636e7$var$isBoolean(disabled) || formState.disabled ? {
                disabled: formState.disabled || disabled
            } : {},
            onChange: onChange,
            onBlur: onBlur,
            ref: ref
        }), [
        name,
        disabled,
        formState.disabled,
        onChange,
        onBlur,
        ref,
        value1
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const previousName = _previousNameRef.current;
        if (previousName && previousName !== name && !isArrayField) control.unregister(previousName);
        control.register(name, {
            ..._props.current.rules,
            ...$cf42f49a775636e7$var$isBoolean(_props.current.disabled) ? {
                disabled: _props.current.disabled
            } : {}
        });
        const updateMounted = (name, value1)=>{
            const field = $cf42f49a775636e7$export$3988ae62b71be9a3(control._fields, name);
            if (field && field._f) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = $cf42f49a775636e7$var$cloneObject($cf42f49a775636e7$export$3988ae62b71be9a3(control._options.defaultValues, name, _props.current.defaultValue));
            $cf42f49a775636e7$export$adaa4cf7ef1b65be(control._defaultValues, name, value1);
            if ($cf42f49a775636e7$var$isUndefined($cf42f49a775636e7$export$3988ae62b71be9a3(control._formValues, name))) $cf42f49a775636e7$export$adaa4cf7ef1b65be(control._formValues, name, value1);
        }
        !isArrayField && control.register(name);
        _previousNameRef.current = name;
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useEffect(()=>{
        control._setDisabledField({
            disabled: disabled,
            name: name
        });
    }, [
        disabled,
        name,
        control
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useMemo(()=>({
            field: field,
            formState: formState,
            fieldState: fieldState
        }), [
        field,
        formState,
        fieldState
    ]);
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $cf42f49a775636e7$export$bd0bf19f25da8474 = (props)=>props.render($cf42f49a775636e7$export$e8c786024a2b0a79(props));
const $cf42f49a775636e7$var$flatten = (obj)=>{
    const output = {};
    for (const key of Object.keys(obj))if ($cf42f49a775636e7$var$isObjectType(obj[key]) && obj[key] !== null) {
        const nested = $cf42f49a775636e7$var$flatten(obj[key]);
        for (const nestedKey of Object.keys(nested))output[`${key}.${nestedKey}`] = nested[nestedKey];
    } else output[key] = obj[key];
    return output;
};
const $cf42f49a775636e7$var$POST_REQUEST = 'post';
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function $cf42f49a775636e7$export$a7fed597f4b8afd8(props) {
    const methods = $cf42f49a775636e7$export$4d957a5e1be13b03();
    const [mounted, setMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useState(false);
    const { control: control = methods.control, onSubmit: onSubmit, children: children, action: action, method: method = $cf42f49a775636e7$var$POST_REQUEST, headers: headers, encType: encType, onError: onError, render: render, onSuccess: onSuccess, validateStatus: validateStatus, ...rest } = props;
    const submit = async (event)=>{
        let hasError = false;
        let type = '';
        await control.handleSubmit(async (data)=>{
            const formData = new FormData();
            let formDataJson = '';
            try {
                formDataJson = JSON.stringify(data);
            } catch (_a) {}
            const flattenFormValues = $cf42f49a775636e7$var$flatten(control._formValues);
            for(const key in flattenFormValues)formData.append(key, flattenFormValues[key]);
            if (onSubmit) await onSubmit({
                data: data,
                event: event,
                method: method,
                formData: formData,
                formDataJson: formDataJson
            });
            if (action) try {
                const shouldStringifySubmissionData = [
                    headers && headers['Content-Type'],
                    encType
                ].some((value1)=>value1 && value1.includes('json'));
                const response = await fetch(String(action), {
                    method: method,
                    headers: {
                        ...headers,
                        ...encType && encType !== 'multipart/form-data' ? {
                            'Content-Type': encType
                        } : {}
                    },
                    body: shouldStringifySubmissionData ? formDataJson : formData
                });
                if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                    hasError = true;
                    onError && onError({
                        response: response
                    });
                    type = String(response.status);
                } else onSuccess && onSuccess({
                    response: response
                });
            } catch (error) {
                hasError = true;
                onError && onError({
                    error: error
                });
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false
            });
            props.control.setError('root.server', {
                type: type
            });
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useEffect(()=>{
        setMounted(true);
    }, []);
    return render ? (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).Fragment, null, render({
        submit: submit
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).createElement("form", {
        noValidate: mounted,
        action: action,
        method: method,
        encType: encType,
        onSubmit: submit,
        ...rest
    }, children);
}
var $cf42f49a775636e7$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
var $cf42f49a775636e7$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $cf42f49a775636e7$var$createSubject = ()=>{
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
};
function $cf42f49a775636e7$var$extractFormValues(fieldsState, formValues) {
    const values = {};
    for(const key in fieldsState)if (fieldsState.hasOwnProperty(key)) {
        const fieldState = fieldsState[key];
        const fieldValue = formValues[key];
        if (fieldState && $cf42f49a775636e7$var$isObject(fieldState) && fieldValue) {
            const nestedFieldsState = $cf42f49a775636e7$var$extractFormValues(fieldState, fieldValue);
            if ($cf42f49a775636e7$var$isObject(nestedFieldsState)) values[key] = nestedFieldsState;
        } else if (fieldsState[key]) values[key] = fieldValue;
    }
    return values;
}
var $cf42f49a775636e7$var$isEmptyObject = (value1)=>$cf42f49a775636e7$var$isObject(value1) && !Object.keys(value1).length;
var $cf42f49a775636e7$var$isFileInput = (element)=>element.type === 'file';
var $cf42f49a775636e7$var$isFunction = (value1)=>typeof value1 === 'function';
var $cf42f49a775636e7$var$isHTMLElement = (value1)=>{
    if (!$cf42f49a775636e7$var$isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $cf42f49a775636e7$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $cf42f49a775636e7$var$isRadioInput = (element)=>element.type === 'radio';
var $cf42f49a775636e7$var$isRadioOrCheckbox = (ref)=>$cf42f49a775636e7$var$isRadioInput(ref) || $cf42f49a775636e7$var$isCheckBoxInput(ref);
var $cf42f49a775636e7$var$live = (ref)=>$cf42f49a775636e7$var$isHTMLElement(ref) && ref.isConnected;
function $cf42f49a775636e7$var$baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = $cf42f49a775636e7$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $cf42f49a775636e7$var$isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !$cf42f49a775636e7$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $cf42f49a775636e7$var$unset(object, path) {
    const paths = Array.isArray(path) ? path : $cf42f49a775636e7$var$isKey(path) ? [
        path
    ] : $cf42f49a775636e7$var$stringToPath(path);
    const childObject = paths.length === 1 ? object : $cf42f49a775636e7$var$baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($cf42f49a775636e7$var$isObject(childObject) && $cf42f49a775636e7$var$isEmptyObject(childObject) || Array.isArray(childObject) && $cf42f49a775636e7$var$isEmptyArray(childObject))) $cf42f49a775636e7$var$unset(object, paths.slice(0, -1));
    return object;
}
var $cf42f49a775636e7$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($cf42f49a775636e7$var$isFunction(data[key])) return true;
    }
    return false;
};
function $cf42f49a775636e7$var$isTraversable(value1) {
    return Array.isArray(value1) || $cf42f49a775636e7$var$isObject(value1) && !$cf42f49a775636e7$var$objectHasFunction(value1);
}
function $cf42f49a775636e7$var$markFieldsDirty(data, fields = {}) {
    for(const key in data){
        if ($cf42f49a775636e7$var$isTraversable(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            $cf42f49a775636e7$var$markFieldsDirty(data[key], fields[key]);
        } else if (!$cf42f49a775636e7$var$isUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function $cf42f49a775636e7$var$getDirtyFields(data, formValues, dirtyFieldsFromValues) {
    if (!dirtyFieldsFromValues) dirtyFieldsFromValues = $cf42f49a775636e7$var$markFieldsDirty(formValues);
    for(const key in data)if ($cf42f49a775636e7$var$isTraversable(data[key])) {
        if ($cf42f49a775636e7$var$isUndefined(formValues) || $cf42f49a775636e7$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = $cf42f49a775636e7$var$markFieldsDirty(data[key], Array.isArray(data[key]) ? [] : {});
        else $cf42f49a775636e7$var$getDirtyFields(data[key], $cf42f49a775636e7$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
    } else dirtyFieldsFromValues[key] = !$cf42f49a775636e7$var$deepEqual(data[key], formValues[key]);
    return dirtyFieldsFromValues;
}
const $cf42f49a775636e7$var$defaultResult = {
    value: false,
    isValid: false
};
const $cf42f49a775636e7$var$validResult = {
    value: true,
    isValid: true
};
var $cf42f49a775636e7$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$cf42f49a775636e7$var$isUndefined(options[0].attributes.value) ? $cf42f49a775636e7$var$isUndefined(options[0].value) || options[0].value === '' ? $cf42f49a775636e7$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $cf42f49a775636e7$var$validResult : $cf42f49a775636e7$var$defaultResult;
    }
    return $cf42f49a775636e7$var$defaultResult;
};
var $cf42f49a775636e7$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$cf42f49a775636e7$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === '' ? NaN : value1 ? +value1 : value1 : valueAsDate && $cf42f49a775636e7$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
const $cf42f49a775636e7$var$defaultReturn = {
    isValid: false,
    value: null
};
var $cf42f49a775636e7$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $cf42f49a775636e7$var$defaultReturn) : $cf42f49a775636e7$var$defaultReturn;
function $cf42f49a775636e7$var$getFieldValue(_f) {
    const ref = _f.ref;
    if ($cf42f49a775636e7$var$isFileInput(ref)) return ref.files;
    if ($cf42f49a775636e7$var$isRadioInput(ref)) return $cf42f49a775636e7$var$getRadioValue(_f.refs).value;
    if ($cf42f49a775636e7$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($cf42f49a775636e7$var$isCheckBoxInput(ref)) return $cf42f49a775636e7$var$getCheckboxValue(_f.refs).value;
    return $cf42f49a775636e7$var$getFieldValueAs($cf42f49a775636e7$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $cf42f49a775636e7$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $cf42f49a775636e7$export$3988ae62b71be9a3(_fields, name);
        field && $cf42f49a775636e7$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $cf42f49a775636e7$var$isRegex = (value1)=>value1 instanceof RegExp;
var $cf42f49a775636e7$var$getRuleValue = (rule)=>$cf42f49a775636e7$var$isUndefined(rule) ? rule : $cf42f49a775636e7$var$isRegex(rule) ? rule.source : $cf42f49a775636e7$var$isObject(rule) ? $cf42f49a775636e7$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
var $cf42f49a775636e7$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $cf42f49a775636e7$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $cf42f49a775636e7$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $cf42f49a775636e7$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $cf42f49a775636e7$var$VALIDATION_MODE.all,
        isOnTouch: mode === $cf42f49a775636e7$var$VALIDATION_MODE.onTouched
    });
const $cf42f49a775636e7$var$ASYNC_FUNCTION = 'AsyncFunction';
var $cf42f49a775636e7$var$hasPromiseValidation = (fieldReference)=>!!fieldReference && !!fieldReference.validate && !!($cf42f49a775636e7$var$isFunction(fieldReference.validate) && fieldReference.validate.constructor.name === $cf42f49a775636e7$var$ASYNC_FUNCTION || $cf42f49a775636e7$var$isObject(fieldReference.validate) && Object.values(fieldReference.validate).find((validateFunction)=>validateFunction.constructor.name === $cf42f49a775636e7$var$ASYNC_FUNCTION));
var $cf42f49a775636e7$var$hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
var $cf42f49a775636e7$var$isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
const $cf42f49a775636e7$var$iterateFieldsByAction = (fields, action, fieldsNames, abortEarly)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = $cf42f49a775636e7$export$3988ae62b71be9a3(fields, key);
        if (field) {
            const { _f: _f, ...currentField } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) return true;
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) return true;
                else {
                    if ($cf42f49a775636e7$var$iterateFieldsByAction(currentField, action)) break;
                }
            } else if ($cf42f49a775636e7$var$isObject(currentField)) {
                if ($cf42f49a775636e7$var$iterateFieldsByAction(currentField, action)) break;
            }
        }
    }
    return;
};
function $cf42f49a775636e7$var$schemaErrorLookup(errors, _fields, name) {
    const error = $cf42f49a775636e7$export$3988ae62b71be9a3(errors, name);
    if (error || $cf42f49a775636e7$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split('.');
    while(names.length){
        const fieldName = names.join('.');
        const field = $cf42f49a775636e7$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $cf42f49a775636e7$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        if (foundError && foundError.root && foundError.root.type) return {
            name: `${fieldName}.root`,
            error: foundError.root
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $cf42f49a775636e7$var$shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name: name, ...formState } = formStateData;
    return $cf42f49a775636e7$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || $cf42f49a775636e7$var$VALIDATION_MODE.all));
};
var $cf42f49a775636e7$var$shouldSubscribeByName = (name, signalName, exact)=>!name || !signalName || name === signalName || $cf42f49a775636e7$var$convertToArrayPayload(name).some((currentName)=>currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
var $cf42f49a775636e7$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $cf42f49a775636e7$var$unsetEmptyArray = (ref, name)=>!$cf42f49a775636e7$var$compact($cf42f49a775636e7$export$3988ae62b71be9a3(ref, name)).length && $cf42f49a775636e7$var$unset(ref, name);
var $cf42f49a775636e7$var$updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = $cf42f49a775636e7$var$convertToArrayPayload($cf42f49a775636e7$export$3988ae62b71be9a3(errors, name));
    $cf42f49a775636e7$export$adaa4cf7ef1b65be(fieldArrayErrors, 'root', error[name]);
    $cf42f49a775636e7$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
function $cf42f49a775636e7$var$getValidateError(result, ref, type = 'validate') {
    if ($cf42f49a775636e7$var$isString(result) || Array.isArray(result) && result.every($cf42f49a775636e7$var$isString) || $cf42f49a775636e7$var$isBoolean(result) && !result) return {
        type: type,
        message: $cf42f49a775636e7$var$isString(result) ? result : '',
        ref: ref
    };
}
var $cf42f49a775636e7$var$getValueAndMessage = (validationData)=>$cf42f49a775636e7$var$isObject(validationData) && !$cf42f49a775636e7$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ''
    };
var $cf42f49a775636e7$var$validateField = async (field, disabledFieldNames, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount } = field._f;
    const inputValue = $cf42f49a775636e7$export$3988ae62b71be9a3(formValues, name);
    if (!mount || disabledFieldNames.has(name)) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity($cf42f49a775636e7$var$isBoolean(message) ? '' : message || '');
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $cf42f49a775636e7$var$isRadioInput(ref);
    const isCheckBox = $cf42f49a775636e7$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $cf42f49a775636e7$var$isFileInput(ref)) && $cf42f49a775636e7$var$isUndefined(ref.value) && $cf42f49a775636e7$var$isUndefined(inputValue) || $cf42f49a775636e7$var$isHTMLElement(ref) && ref.value === '' || inputValue === '' || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $cf42f49a775636e7$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $cf42f49a775636e7$var$INPUT_VALIDATION_RULES.maxLength, minType = $cf42f49a775636e7$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $cf42f49a775636e7$var$isNullOrUndefined(inputValue)) || $cf42f49a775636e7$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$cf42f49a775636e7$var$getCheckboxValue(refs).isValid || isRadio && !$cf42f49a775636e7$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $cf42f49a775636e7$var$isString(required) ? {
            value: !!required,
            message: required
        } : $cf42f49a775636e7$var$getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: $cf42f49a775636e7$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef,
                ...appendErrorsCurry($cf42f49a775636e7$var$INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$cf42f49a775636e7$var$isNullOrUndefined(min) || !$cf42f49a775636e7$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $cf42f49a775636e7$var$getValueAndMessage(max);
        const minOutput = $cf42f49a775636e7$var$getValueAndMessage(min);
        if (!$cf42f49a775636e7$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!$cf42f49a775636e7$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$cf42f49a775636e7$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + ' ' + time);
            const isTime = ref.type == 'time';
            const isWeek = ref.type == 'week';
            if ($cf42f49a775636e7$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if ($cf42f49a775636e7$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $cf42f49a775636e7$var$INPUT_VALIDATION_RULES.max, $cf42f49a775636e7$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && ($cf42f49a775636e7$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $cf42f49a775636e7$var$getValueAndMessage(maxLength);
        const minLengthOutput = $cf42f49a775636e7$var$getValueAndMessage(minLength);
        const exceedMax = !$cf42f49a775636e7$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !$cf42f49a775636e7$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $cf42f49a775636e7$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $cf42f49a775636e7$var$getValueAndMessage(pattern);
        if ($cf42f49a775636e7$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: $cf42f49a775636e7$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref,
                ...appendErrorsCurry($cf42f49a775636e7$var$INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($cf42f49a775636e7$var$isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = $cf42f49a775636e7$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry($cf42f49a775636e7$var$INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($cf42f49a775636e7$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$cf42f49a775636e7$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $cf42f49a775636e7$var$getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$cf42f49a775636e7$var$isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
const $cf42f49a775636e7$var$defaultOptions = {
    mode: $cf42f49a775636e7$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $cf42f49a775636e7$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $cf42f49a775636e7$export$1361f5e0e4cca3c3(props = {}) {
    let _options = {
        ...$cf42f49a775636e7$var$defaultOptions,
        ...props
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isReady: false,
        isLoading: $cf42f49a775636e7$var$isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        validatingFields: {},
        errors: _options.errors || {},
        disabled: _options.disabled || false
    };
    let _fields = {};
    let _defaultValues = $cf42f49a775636e7$var$isObject(_options.defaultValues) || $cf42f49a775636e7$var$isObject(_options.values) ? $cf42f49a775636e7$var$cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : $cf42f49a775636e7$var$cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        disabled: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        validatingFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    let _proxySubscribeFormState = {
        ..._proxyFormState
    };
    const _subjects = {
        array: $cf42f49a775636e7$var$createSubject(),
        state: $cf42f49a775636e7$var$createSubject()
    };
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $cf42f49a775636e7$var$VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _setValid = async (shouldUpdateValid)=>{
        if (!_options.disabled && (_proxyFormState.isValid || _proxySubscribeFormState.isValid || shouldUpdateValid)) {
            const isValid = _options.resolver ? $cf42f49a775636e7$var$isEmptyObject((await _runSchema()).errors) : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid: isValid
            });
        }
    };
    const _updateIsValidating = (names, isValidating)=>{
        if (!_options.disabled && (_proxyFormState.isValidating || _proxyFormState.validatingFields || _proxySubscribeFormState.isValidating || _proxySubscribeFormState.validatingFields)) {
            (names || Array.from(_names.mount)).forEach((name)=>{
                if (name) isValidating ? $cf42f49a775636e7$export$adaa4cf7ef1b65be(_formState.validatingFields, name, isValidating) : $cf42f49a775636e7$var$unset(_formState.validatingFields, name);
            });
            _subjects.state.next({
                validatingFields: _formState.validatingFields,
                isValidating: !$cf42f49a775636e7$var$isEmptyObject(_formState.validatingFields)
            });
        }
    };
    const _setFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method && !_options.disabled) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($cf42f49a775636e7$export$3988ae62b71be9a3(_fields, name))) {
                const fieldValues = method($cf42f49a775636e7$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $cf42f49a775636e7$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray($cf42f49a775636e7$export$3988ae62b71be9a3(_formState.errors, name))) {
                const errors = method($cf42f49a775636e7$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $cf42f49a775636e7$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $cf42f49a775636e7$var$unsetEmptyArray(_formState.errors, name);
            }
            if ((_proxyFormState.touchedFields || _proxySubscribeFormState.touchedFields) && shouldUpdateFieldsAndState && Array.isArray($cf42f49a775636e7$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                const touchedFields = method($cf42f49a775636e7$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $cf42f49a775636e7$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields || _proxySubscribeFormState.dirtyFields) _formState.dirtyFields = $cf42f49a775636e7$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $cf42f49a775636e7$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $cf42f49a775636e7$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const _setErrors = (errors)=>{
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $cf42f49a775636e7$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            const defaultValue = $cf42f49a775636e7$export$3988ae62b71be9a3(_formValues, name, $cf42f49a775636e7$var$isUndefined(value1) ? $cf42f49a775636e7$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $cf42f49a775636e7$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $cf42f49a775636e7$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $cf42f49a775636e7$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _state.mount && _setValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name: name
        };
        if (!_options.disabled) {
            if (!isBlurEvent || shouldDirty) {
                if (_proxyFormState.isDirty || _proxySubscribeFormState.isDirty) {
                    isPreviousDirty = _formState.isDirty;
                    _formState.isDirty = output.isDirty = _getDirty();
                    shouldUpdateField = isPreviousDirty !== output.isDirty;
                }
                const isCurrentFieldPristine = $cf42f49a775636e7$var$deepEqual($cf42f49a775636e7$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
                isPreviousDirty = !!$cf42f49a775636e7$export$3988ae62b71be9a3(_formState.dirtyFields, name);
                isCurrentFieldPristine ? $cf42f49a775636e7$var$unset(_formState.dirtyFields, name) : $cf42f49a775636e7$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
                output.dirtyFields = _formState.dirtyFields;
                shouldUpdateField = shouldUpdateField || (_proxyFormState.dirtyFields || _proxySubscribeFormState.dirtyFields) && isPreviousDirty !== !isCurrentFieldPristine;
            }
            if (isBlurEvent) {
                const isPreviousFieldTouched = $cf42f49a775636e7$export$3988ae62b71be9a3(_formState.touchedFields, name);
                if (!isPreviousFieldTouched) {
                    $cf42f49a775636e7$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                    output.touchedFields = _formState.touchedFields;
                    shouldUpdateField = shouldUpdateField || (_proxyFormState.touchedFields || _proxySubscribeFormState.touchedFields) && isPreviousFieldTouched !== isBlurEvent;
                }
            }
            shouldUpdateField && shouldRender && _subjects.state.next(output);
        }
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = $cf42f49a775636e7$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = (_proxyFormState.isValid || _proxySubscribeFormState.isValid) && $cf42f49a775636e7$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (_options.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(_options.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? $cf42f49a775636e7$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $cf42f49a775636e7$var$unset(_formState.errors, name);
        }
        if ((error ? !$cf42f49a775636e7$var$deepEqual(previousFieldError, error) : previousFieldError) || !$cf42f49a775636e7$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid && $cf42f49a775636e7$var$isBoolean(isValid) ? {
                    isValid: isValid
                } : {},
                errors: _formState.errors,
                name: name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
    };
    const _runSchema = async (name)=>{
        _updateIsValidating(name, true);
        const result = await _options.resolver(_formValues, _options.context, $cf42f49a775636e7$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
        _updateIsValidating(name);
        return result;
    };
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors } = await _runSchema(names);
        if (names) for (const name of names){
            const error = $cf42f49a775636e7$export$3988ae62b71be9a3(errors, name);
            error ? $cf42f49a775636e7$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $cf42f49a775636e7$var$unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f: _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const isPromiseFunction = field._f && $cf42f49a775636e7$var$hasPromiseValidation(field._f);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        _f.name
                    ], true);
                    const fieldError = await $cf42f49a775636e7$var$validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        _f.name
                    ]);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    !shouldOnlyCheckValid && ($cf42f49a775636e7$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $cf42f49a775636e7$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $cf42f49a775636e7$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $cf42f49a775636e7$var$unset(_formState.errors, _f.name));
                }
                !$cf42f49a775636e7$var$isEmptyObject(fieldValue) && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $cf42f49a775636e7$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$cf42f49a775636e7$var$live(ref)) : !$cf42f49a775636e7$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>!_options.disabled && (name && data && $cf42f49a775636e7$export$adaa4cf7ef1b65be(_formValues, name, data), !$cf42f49a775636e7$var$deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>$cf42f49a775636e7$var$generateWatchOutput(names, _names, {
            ..._state.mount ? _formValues : $cf42f49a775636e7$var$isUndefined(defaultValue) ? _defaultValues : $cf42f49a775636e7$var$isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        }, isGlobal, defaultValue);
    const _getFieldArray = (name)=>$cf42f49a775636e7$var$compact($cf42f49a775636e7$export$3988ae62b71be9a3(_state.mount ? _formValues : _defaultValues, name, _options.shouldUnregister ? $cf42f49a775636e7$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = $cf42f49a775636e7$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $cf42f49a775636e7$export$adaa4cf7ef1b65be(_formValues, name, $cf42f49a775636e7$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $cf42f49a775636e7$var$isHTMLElement(fieldReference.ref) && $cf42f49a775636e7$var$isNullOrUndefined(value1) ? '' : value1;
                if ($cf42f49a775636e7$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if ($cf42f49a775636e7$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.forEach((checkboxRef)=>{
                        if (!checkboxRef.defaultChecked || !checkboxRef.disabled) {
                            if (Array.isArray(fieldValue)) checkboxRef.checked = !!fieldValue.find((data)=>data === checkboxRef.value);
                            else checkboxRef.checked = fieldValue === checkboxRef.value || !!fieldValue;
                        }
                    });
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($cf42f49a775636e7$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = '';
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.state.next({
                        name: name,
                        values: $cf42f49a775636e7$var$cloneObject(_formValues)
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            if (!value1.hasOwnProperty(fieldKey)) return;
            const fieldValue = value1[fieldKey];
            const fieldName = name + '.' + fieldKey;
            const field = $cf42f49a775636e7$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || $cf42f49a775636e7$var$isObject(fieldValue) || field && !field._f) && !$cf42f49a775636e7$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = $cf42f49a775636e7$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = $cf42f49a775636e7$var$cloneObject(value1);
        $cf42f49a775636e7$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: $cf42f49a775636e7$var$cloneObject(_formValues)
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields || _proxySubscribeFormState.isDirty || _proxySubscribeFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name: name,
                dirtyFields: $cf42f49a775636e7$var$getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !$cf42f49a775636e7$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        $cf42f49a775636e7$var$isWatched(name, _names) && _subjects.state.next({
            ..._formState,
            name: name
        });
        _subjects.state.next({
            name: _state.mount ? name : undefined,
            values: $cf42f49a775636e7$var$cloneObject(_formValues)
        });
    };
    const onChange = async (event)=>{
        _state.mount = true;
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = $cf42f49a775636e7$export$3988ae62b71be9a3(_fields, name);
        const _updateIsFieldValueUpdated = (fieldValue)=>{
            isFieldValueUpdated = Number.isNaN(fieldValue) || $cf42f49a775636e7$var$isDateObject(fieldValue) && isNaN(fieldValue.getTime()) || $cf42f49a775636e7$var$deepEqual(fieldValue, $cf42f49a775636e7$export$3988ae62b71be9a3(_formValues, name, fieldValue));
        };
        const validationModeBeforeSubmit = $cf42f49a775636e7$var$getValidationModes(_options.mode);
        const validationModeAfterSubmit = $cf42f49a775636e7$var$getValidationModes(_options.reValidateMode);
        if (field) {
            let error;
            let isValid;
            const fieldValue = target.type ? $cf42f49a775636e7$var$getFieldValue(field._f) : $cf42f49a775636e7$var$getEventValue(event);
            const isBlurEvent = event.type === $cf42f49a775636e7$var$EVENTS.BLUR || event.type === $cf42f49a775636e7$var$EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !$cf42f49a775636e7$var$hasValidation(field._f) && !_options.resolver && !$cf42f49a775636e7$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $cf42f49a775636e7$var$skipValidation(isBlurEvent, $cf42f49a775636e7$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = $cf42f49a775636e7$var$isWatched(name, _names, isBlurEvent);
            $cf42f49a775636e7$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) {
                if (!target || !target.readOnly) {
                    field._f.onBlur && field._f.onBlur(event);
                    delayErrorCallback && delayErrorCallback(0);
                }
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent);
            const shouldRender = !$cf42f49a775636e7$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.state.next({
                name: name,
                type: event.type,
                values: $cf42f49a775636e7$var$cloneObject(_formValues)
            });
            if (shouldSkipValidation) {
                if (_proxyFormState.isValid || _proxySubscribeFormState.isValid) {
                    if (_options.mode === 'onBlur') {
                        if (isBlurEvent) _setValid();
                    } else if (!isBlurEvent) _setValid();
                }
                return shouldRender && _subjects.state.next({
                    name: name,
                    ...watched ? {} : fieldState
                });
            }
            !isBlurEvent && watched && _subjects.state.next({
                ..._formState
            });
            if (_options.resolver) {
                const { errors: errors } = await _runSchema([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = $cf42f49a775636e7$var$schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = $cf42f49a775636e7$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = $cf42f49a775636e7$var$isEmptyObject(errors);
                }
            } else {
                _updateIsValidating([
                    name
                ], true);
                error = (await $cf42f49a775636e7$var$validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsValidating([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid || _proxySubscribeFormState.isValid) isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && (!Array.isArray(field._f.deps) || field._f.deps.length > 0) && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key)=>{
        if ($cf42f49a775636e7$export$3988ae62b71be9a3(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $cf42f49a775636e7$var$convertToArrayPayload(name);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($cf42f49a775636e7$var$isUndefined(name) ? name : fieldNames);
            isValid = $cf42f49a775636e7$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$cf42f49a775636e7$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $cf42f49a775636e7$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _setValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next({
            ...!$cf42f49a775636e7$var$isString(name) || (_proxyFormState.isValid || _proxySubscribeFormState.isValid) && isValid !== _formState.isValid ? {} : {
                name: name
            },
            ..._options.resolver || !name ? {
                isValid: isValid
            } : {},
            errors: _formState.errors
        });
        options.shouldFocus && !validationResult && $cf42f49a775636e7$var$iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames, config)=>{
        let values = {
            ..._state.mount ? _formValues : _defaultValues
        };
        if (config) values = $cf42f49a775636e7$var$extractFormValues(config.dirtyFields ? _formState.dirtyFields : _formState.touchedFields, values);
        return $cf42f49a775636e7$var$isUndefined(fieldNames) ? values : $cf42f49a775636e7$var$isString(fieldNames) ? $cf42f49a775636e7$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$cf42f49a775636e7$export$3988ae62b71be9a3(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!$cf42f49a775636e7$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$cf42f49a775636e7$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            error: $cf42f49a775636e7$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isValidating: !!$cf42f49a775636e7$export$3988ae62b71be9a3(_formState.validatingFields, name),
            isTouched: !!$cf42f49a775636e7$export$3988ae62b71be9a3((formState || _formState).touchedFields, name)
        });
    const clearErrors = (name)=>{
        name && $cf42f49a775636e7$var$convertToArrayPayload(name).forEach((inputName)=>$cf42f49a775636e7$var$unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = ($cf42f49a775636e7$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        const currentError = $cf42f49a775636e7$export$3988ae62b71be9a3(_formState.errors, name) || {};
        // Don't override existing error messages elsewhere in the object tree.
        const { ref: currentRef, message: message, type: type, ...restOfErrorTree } = currentError;
        $cf42f49a775636e7$export$adaa4cf7ef1b65be(_formState.errors, name, {
            ...restOfErrorTree,
            ...error,
            ref: ref
        });
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>$cf42f49a775636e7$var$isFunction(name) ? _subjects.state.subscribe({
            next: (payload)=>'values' in payload && name(_getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const _subscribe = (props)=>_subjects.state.subscribe({
            next: (formState)=>{
                if ($cf42f49a775636e7$var$shouldSubscribeByName(props.name, formState.name, props.exact) && $cf42f49a775636e7$var$shouldRenderFormState(formState, props.formState || _proxyFormState, _setFormState, props.reRenderRoot)) props.callback({
                    values: {
                        ..._formValues
                    },
                    ..._formState,
                    ...formState,
                    defaultValues: _defaultValues
                });
            }
        }).unsubscribe;
    const subscribe = (props)=>{
        _state.mount = true;
        _proxySubscribeFormState = {
            ..._proxySubscribeFormState,
            ...props.formState
        };
        return _subscribe({
            ...props,
            formState: _proxySubscribeFormState
        });
    };
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $cf42f49a775636e7$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                $cf42f49a775636e7$var$unset(_fields, fieldName);
                $cf42f49a775636e7$var$unset(_formValues, fieldName);
            }
            !options.keepError && $cf42f49a775636e7$var$unset(_formState.errors, fieldName);
            !options.keepDirty && $cf42f49a775636e7$var$unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && $cf42f49a775636e7$var$unset(_formState.touchedFields, fieldName);
            !options.keepIsValidating && $cf42f49a775636e7$var$unset(_formState.validatingFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && $cf42f49a775636e7$var$unset(_defaultValues, fieldName);
        }
        _subjects.state.next({
            values: $cf42f49a775636e7$var$cloneObject(_formValues)
        });
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _setValid();
    };
    const _setDisabledField = ({ disabled: disabled, name: name })=>{
        if ($cf42f49a775636e7$var$isBoolean(disabled) && _state.mount || !!disabled || _names.disabled.has(name)) disabled ? _names.disabled.add(name) : _names.disabled.delete(name);
    };
    const register = (name, options = {})=>{
        let field = $cf42f49a775636e7$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $cf42f49a775636e7$var$isBoolean(options.disabled) || $cf42f49a775636e7$var$isBoolean(_options.disabled);
        $cf42f49a775636e7$export$adaa4cf7ef1b65be(_fields, name, {
            ...field || {},
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name: name
                    }
                },
                name: name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        if (field) _setDisabledField({
            disabled: $cf42f49a775636e7$var$isBoolean(options.disabled) ? options.disabled : _options.disabled,
            name: name
        });
        else updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled || _options.disabled
            } : {},
            ..._options.progressive ? {
                required: !!options.required,
                min: $cf42f49a775636e7$var$getRuleValue(options.min),
                max: $cf42f49a775636e7$var$getRuleValue(options.max),
                minLength: $cf42f49a775636e7$var$getRuleValue(options.minLength),
                maxLength: $cf42f49a775636e7$var$getRuleValue(options.maxLength),
                pattern: $cf42f49a775636e7$var$getRuleValue(options.pattern)
            } : {},
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = $cf42f49a775636e7$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $cf42f49a775636e7$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll('input,select,textarea')[0] || ref : ref : ref;
                    const radioOrCheckbox = $cf42f49a775636e7$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    $cf42f49a775636e7$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter($cf42f49a775636e7$var$live),
                                    fieldRef,
                                    ...Array.isArray($cf42f49a775636e7$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name: name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $cf42f49a775636e7$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($cf42f49a775636e7$var$isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const _focusError = ()=>_options.shouldFocusError && $cf42f49a775636e7$var$iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled)=>{
        if ($cf42f49a775636e7$var$isBoolean(disabled)) {
            _subjects.state.next({
                disabled: disabled
            });
            $cf42f49a775636e7$var$iterateFieldsByAction(_fields, (ref, name)=>{
                const currentField = $cf42f49a775636e7$export$3988ae62b71be9a3(_fields, name);
                if (currentField) {
                    ref.disabled = currentField._f.disabled || disabled;
                    if (Array.isArray(currentField._f.refs)) currentField._f.refs.forEach((inputRef)=>{
                        inputRef.disabled = currentField._f.disabled || disabled;
                    });
                }
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            let onValidError = undefined;
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = $cf42f49a775636e7$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors: errors, values: values } = await _runSchema();
                _formState.errors = errors;
                fieldValues = $cf42f49a775636e7$var$cloneObject(values);
            } else await executeBuiltInValidation(_fields);
            if (_names.disabled.size) for (const name of _names.disabled)$cf42f49a775636e7$var$unset(fieldValues, name);
            $cf42f49a775636e7$var$unset(_formState.errors, 'root');
            if ($cf42f49a775636e7$var$isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                try {
                    await onValid(fieldValues, e);
                } catch (error) {
                    onValidError = error;
                }
            } else {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: $cf42f49a775636e7$var$isEmptyObject(_formState.errors) && !onValidError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
            if (onValidError) throw onValidError;
        };
    const resetField = (name, options = {})=>{
        if ($cf42f49a775636e7$export$3988ae62b71be9a3(_fields, name)) {
            if ($cf42f49a775636e7$var$isUndefined(options.defaultValue)) setValue(name, $cf42f49a775636e7$var$cloneObject($cf42f49a775636e7$export$3988ae62b71be9a3(_defaultValues, name)));
            else {
                setValue(name, options.defaultValue);
                $cf42f49a775636e7$export$adaa4cf7ef1b65be(_defaultValues, name, $cf42f49a775636e7$var$cloneObject(options.defaultValue));
            }
            if (!options.keepTouched) $cf42f49a775636e7$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $cf42f49a775636e7$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $cf42f49a775636e7$var$cloneObject($cf42f49a775636e7$export$3988ae62b71be9a3(_defaultValues, name))) : _getDirty();
            }
            if (!options.keepError) {
                $cf42f49a775636e7$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _setValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues ? $cf42f49a775636e7$var$cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = $cf42f49a775636e7$var$cloneObject(updatedValues);
        const isEmptyResetValues = $cf42f49a775636e7$var$isEmptyObject(formValues);
        const values = isEmptyResetValues ? _defaultValues : cloneUpdatedValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) {
                const fieldsToCheck = new Set([
                    ..._names.mount,
                    ...Object.keys($cf42f49a775636e7$var$getDirtyFields(_defaultValues, _formValues))
                ]);
                for (const fieldName of Array.from(fieldsToCheck))$cf42f49a775636e7$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName) ? $cf42f49a775636e7$export$adaa4cf7ef1b65be(values, fieldName, $cf42f49a775636e7$export$3988ae62b71be9a3(_formValues, fieldName)) : setValue(fieldName, $cf42f49a775636e7$export$3988ae62b71be9a3(values, fieldName));
            } else {
                if ($cf42f49a775636e7$var$isWeb && $cf42f49a775636e7$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $cf42f49a775636e7$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if ($cf42f49a775636e7$var$isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest('form');
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                if (keepStateOptions.keepFieldsRef) for (const fieldName of _names.mount)setValue(fieldName, $cf42f49a775636e7$export$3988ae62b71be9a3(values, fieldName));
                else _fields = {};
            }
            _formValues = _options.shouldUnregister ? keepStateOptions.keepDefaultValues ? $cf42f49a775636e7$var$cloneObject(_defaultValues) : {} : $cf42f49a775636e7$var$cloneObject(values);
            _subjects.array.next({
                values: {
                    ...values
                }
            });
            _subjects.state.next({
                values: {
                    ...values
                }
            });
        }
        _names = {
            mount: keepStateOptions.keepDirtyValues ? _names.mount : new Set(),
            unMount: new Set(),
            array: new Set(),
            disabled: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ''
        };
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues;
        _state.watch = !!_options.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: isEmptyResetValues ? false : keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$cf42f49a775636e7$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: isEmptyResetValues ? {} : keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? $cf42f49a775636e7$var$getDirtyFields(_defaultValues, _formValues) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $cf42f49a775636e7$var$getDirtyFields(_defaultValues, formValues) : keepStateOptions.keepDirty ? _formState.dirtyFields : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false,
            defaultValues: _defaultValues
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset($cf42f49a775636e7$var$isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    const setFocus = (name, options = {})=>{
        const field = $cf42f49a775636e7$export$3988ae62b71be9a3(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && $cf42f49a775636e7$var$isFunction(fieldRef.select) && fieldRef.select();
            }
        }
    };
    const _setFormState = (updatedFormState)=>{
        _formState = {
            ..._formState,
            ...updatedFormState
        };
    };
    const _resetDefaultValues = ()=>$cf42f49a775636e7$var$isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    const methods = {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            handleSubmit: handleSubmit,
            setError: setError,
            _subscribe: _subscribe,
            _runSchema: _runSchema,
            _focusError: _focusError,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _setValid: _setValid,
            _setFieldArray: _setFieldArray,
            _setDisabledField: _setDisabledField,
            _setErrors: _setErrors,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _resetDefaultValues: _resetDefaultValues,
            _removeUnmounted: _removeUnmounted,
            _disableForm: _disableForm,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
            }
        },
        subscribe: subscribe,
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
    return {
        ...methods,
        formControl: methods
    };
}
var $cf42f49a775636e7$var$generateId = ()=>{
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
    const d = typeof performance === 'undefined' ? Date.now() : performance.now() * 1000;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $cf42f49a775636e7$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $cf42f49a775636e7$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$cf42f49a775636e7$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : '';
var $cf42f49a775636e7$var$appendAt = (data, value1)=>[
        ...data,
        ...$cf42f49a775636e7$var$convertToArrayPayload(value1)
    ];
var $cf42f49a775636e7$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $cf42f49a775636e7$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$cf42f49a775636e7$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $cf42f49a775636e7$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($cf42f49a775636e7$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
var $cf42f49a775636e7$var$prependAt = (data, value1)=>[
        ...$cf42f49a775636e7$var$convertToArrayPayload(value1),
        ...$cf42f49a775636e7$var$convertToArrayPayload(data)
    ];
function $cf42f49a775636e7$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $cf42f49a775636e7$var$compact(temp).length ? temp : [];
}
var $cf42f49a775636e7$var$removeArrayAt = (data, index)=>$cf42f49a775636e7$var$isUndefined(index) ? [] : $cf42f49a775636e7$var$removeAtIndexes(data, $cf42f49a775636e7$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $cf42f49a775636e7$var$swapArrayAt = (data, indexA, indexB)=>{
    [data[indexA], data[indexB]] = [
        data[indexB],
        data[indexA]
    ];
};
var $cf42f49a775636e7$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $cf42f49a775636e7$export$310131896651d559(props) {
    const methods = $cf42f49a775636e7$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, keyName: keyName = 'id', shouldUnregister: shouldUnregister, rules: rules } = props;
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useState(control._getFieldArray(name));
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useRef(control._getFieldArray(name).map($cf42f49a775636e7$var$generateId));
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useRef(false);
    control._names.array.add(name);
    (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useMemo(()=>rules && fields.length >= 0 && control.register(name, rules), [
        control,
        name,
        fields.length,
        rules
    ]);
    $cf42f49a775636e7$var$useIsomorphicLayoutEffect(()=>control._subjects.array.subscribe({
            next: ({ values: values, name: fieldArrayName })=>{
                if (fieldArrayName === name || !fieldArrayName) {
                    const fieldValues = $cf42f49a775636e7$export$3988ae62b71be9a3(values, name);
                    if (Array.isArray(fieldValues)) {
                        setFields(fieldValues);
                        ids.current = fieldValues.map($cf42f49a775636e7$var$generateId);
                    }
                }
            }
        }).unsubscribe, [
        control,
        name
    ]);
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._setFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append = (value1, options)=>{
        const appendValue = $cf42f49a775636e7$var$convertToArrayPayload($cf42f49a775636e7$var$cloneObject(value1));
        const updatedFieldArrayValues = $cf42f49a775636e7$var$appendAt(control._getFieldArray(name), appendValue);
        control._names.focus = $cf42f49a775636e7$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $cf42f49a775636e7$var$appendAt(ids.current, appendValue.map($cf42f49a775636e7$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $cf42f49a775636e7$var$appendAt, {
            argA: $cf42f49a775636e7$var$fillEmptyArray(value1)
        });
    };
    const prepend = (value1, options)=>{
        const prependValue = $cf42f49a775636e7$var$convertToArrayPayload($cf42f49a775636e7$var$cloneObject(value1));
        const updatedFieldArrayValues = $cf42f49a775636e7$var$prependAt(control._getFieldArray(name), prependValue);
        control._names.focus = $cf42f49a775636e7$var$getFocusFieldName(name, 0, options);
        ids.current = $cf42f49a775636e7$var$prependAt(ids.current, prependValue.map($cf42f49a775636e7$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $cf42f49a775636e7$var$prependAt, {
            argA: $cf42f49a775636e7$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = $cf42f49a775636e7$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $cf42f49a775636e7$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        !Array.isArray($cf42f49a775636e7$export$3988ae62b71be9a3(control._fields, name)) && $cf42f49a775636e7$export$adaa4cf7ef1b65be(control._fields, name, undefined);
        control._setFieldArray(name, updatedFieldArrayValues, $cf42f49a775636e7$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = $cf42f49a775636e7$var$convertToArrayPayload($cf42f49a775636e7$var$cloneObject(value1));
        const updatedFieldArrayValues = $cf42f49a775636e7$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $cf42f49a775636e7$var$getFocusFieldName(name, index, options);
        ids.current = $cf42f49a775636e7$var$insert(ids.current, index, insertValue.map($cf42f49a775636e7$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $cf42f49a775636e7$var$insert, {
            argA: index,
            argB: $cf42f49a775636e7$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $cf42f49a775636e7$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $cf42f49a775636e7$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $cf42f49a775636e7$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $cf42f49a775636e7$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $cf42f49a775636e7$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $cf42f49a775636e7$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = $cf42f49a775636e7$var$cloneObject(value1);
        const updatedFieldArrayValues = $cf42f49a775636e7$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $cf42f49a775636e7$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._setFieldArray(name, updatedFieldArrayValues, $cf42f49a775636e7$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = $cf42f49a775636e7$var$convertToArrayPayload($cf42f49a775636e7$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($cf42f49a775636e7$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._setFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useEffect(()=>{
        control._state.action = false;
        $cf42f49a775636e7$var$isWatched(name, control._names) && control._subjects.state.next({
            ...control._formState
        });
        if (_actioned.current && (!$cf42f49a775636e7$var$getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted) && !$cf42f49a775636e7$var$getValidationModes(control._options.reValidateMode).isOnSubmit) {
            if (control._options.resolver) control._runSchema([
                name
            ]).then((result)=>{
                const error = $cf42f49a775636e7$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $cf42f49a775636e7$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
                    error ? $cf42f49a775636e7$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $cf42f49a775636e7$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $cf42f49a775636e7$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f && !($cf42f49a775636e7$var$getValidationModes(control._options.reValidateMode).isOnSubmit && $cf42f49a775636e7$var$getValidationModes(control._options.mode).isOnSubmit)) $cf42f49a775636e7$var$validateField(field, control._names.disabled, control._formValues, control._options.criteriaMode === $cf42f49a775636e7$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!$cf42f49a775636e7$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $cf42f49a775636e7$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.state.next({
            name: name,
            values: $cf42f49a775636e7$var$cloneObject(control._formValues)
        });
        control._names.focus && $cf42f49a775636e7$var$iterateFieldsByAction(control._fields, (ref, key)=>{
            if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
                ref.focus();
                return 1;
            }
            return;
        });
        control._names.focus = '';
        control._setValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useEffect(()=>{
        !$cf42f49a775636e7$export$3988ae62b71be9a3(control._formValues, name) && control._setFieldArray(name);
        return ()=>{
            const updateMounted = (name, value1)=>{
                const field = $cf42f49a775636e7$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f) field._f.mount = value1;
            };
            control._options.shouldUnregister || shouldUnregister ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useCallback(prepend, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useCallback(append, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    [keyName]: ids.current[index] || $cf42f49a775636e7$var$generateId()
                })), [
            fields,
            keyName
        ])
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function $cf42f49a775636e7$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useRef(undefined);
    const _values = (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useRef(undefined);
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useState({
        isDirty: false,
        isValidating: false,
        isLoading: $cf42f49a775636e7$var$isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        validatingFields: {},
        errors: props.errors || {},
        disabled: props.disabled || false,
        isReady: false,
        defaultValues: $cf42f49a775636e7$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
    });
    if (!_formControl.current) {
        if (props.formControl) {
            _formControl.current = {
                ...props.formControl,
                formState: formState
            };
            if (props.defaultValues && !$cf42f49a775636e7$var$isFunction(props.defaultValues)) props.formControl.reset(props.defaultValues, props.resetOptions);
        } else {
            const { formControl: formControl, ...rest } = $cf42f49a775636e7$export$1361f5e0e4cca3c3(props);
            _formControl.current = {
                ...rest,
                formState: formState
            };
        }
    }
    const control = _formControl.current.control;
    control._options = props;
    $cf42f49a775636e7$var$useIsomorphicLayoutEffect(()=>{
        const sub = control._subscribe({
            formState: control._proxyFormState,
            callback: ()=>updateFormState({
                    ...control._formState
                }),
            reRenderRoot: true
        });
        updateFormState((data)=>({
                ...data,
                isReady: true
            }));
        control._formState.isReady = true;
        return sub;
    }, [
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useEffect(()=>control._disableForm(props.disabled), [
        control,
        props.disabled
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useEffect(()=>{
        if (props.mode) control._options.mode = props.mode;
        if (props.reValidateMode) control._options.reValidateMode = props.reValidateMode;
    }, [
        control,
        props.mode,
        props.reValidateMode
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useEffect(()=>{
        if (props.errors) {
            control._setErrors(props.errors);
            control._focusError();
        }
    }, [
        control,
        props.errors
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useEffect(()=>{
        props.shouldUnregister && control._subjects.state.next({
            values: control._getWatch()
        });
    }, [
        control,
        props.shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useEffect(()=>{
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) control._subjects.state.next({
                isDirty: isDirty
            });
        }
    }, [
        control,
        formState.isDirty
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useEffect(()=>{
        if (props.values && !$cf42f49a775636e7$var$deepEqual(props.values, _values.current)) {
            control._reset(props.values, {
                keepFieldsRef: true,
                ...control._options.resetOptions
            });
            _values.current = props.values;
            updateFormState((state)=>({
                    ...state
                }));
        } else control._resetDefaultValues();
    }, [
        control,
        props.values
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).useEffect(()=>{
        if (!control._state.mount) {
            control._setValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({
                ...control._formState
            });
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = $cf42f49a775636e7$var$getProxyFormState(formState, control);
    return _formControl.current;
}
/**
 * Watch component that subscribes to form field changes and re-renders when watched fields update.
 *
 * @param control - The form control object from useForm
 * @param names - Array of field names to watch for changes
 * @param render - The function that receives watched values and returns ReactNode
 * @returns The result of calling render function with watched values
 *
 * @example
 * The `Watch` component only re-render when the values of `foo`, `bar`, and `baz.qux` change.
 * The types of `foo`, `bar`, and `baz.qux` are precisely inferred.
 *
 * ```tsx
 * const { control } = useForm();
 *
 * <Watch
 *   control={control}
 *   names={['foo', 'bar', 'baz.qux']}
 *   render={([foo, bar, baz_qux]) => <div>{foo}{bar}{baz_qux}</div>}
 * />
 * ```
 */ const $cf42f49a775636e7$export$4c68f1a79f88778c = ({ control: control, names: names, render: render })=>render($cf42f49a775636e7$export$3c773aa2b84f29e0({
        control: control,
        name: names
    }));





const $d0229c228556b4f9$export$e6dfd72ab29f8598 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  margin: 0.5rem;
`;
const $d0229c228556b4f9$export$718e92491c44b3f6 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  margin-bottom: 0.1rem;
  padding-bottom: 0.3rem;
  border-bottom: 1px solid var(--toolbar); 
  h2 {
    margin: 0;
    font-size: 1.5rem;
    padding-bottom: 0.5rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
const $d0229c228556b4f9$export$6f867529d0fa844e = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('tr')`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr; /* Set grid for Question, Type, Actions */
  align-items: center;
  padding: 0.8rem 0;

  & td {
    padding: 0.5rem;
    text-align: left; 
  }

  & td:last-child {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
  }
`;
const $d0229c228556b4f9$export$a8d3280cb45e38b8 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('button')`
  background-color: var(--primary);
  color: white;
  border: 1px solid transparent;
  border-radius: 0.3rem;
  padding: 0.4rem 0.8rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s;

`;
const $d0229c228556b4f9$export$4e9d5ce1e6c22a94 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('button')`
  background-color: var(--error);
  color: white;
  border: 1px solid transparent;
  border-radius: 0.3rem;
  padding: 0.4rem 0.8rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s;

  &:disabled {
    background-color: var(--disabled-button);
    cursor: default;
  }
`;
const $d0229c228556b4f9$export$f850895b287ef28e = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('thead')`
  background-color: var(--toolbar);
  color: white;

  & th {
    text-align: left;
    padding: 0.5rem;
  }
`;
const $d0229c228556b4f9$export$54ec01a60f47d33d = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('table')`
  width: 100%;
  border-collapse: collapse;
  margin-top: 0.8rem;

  th, td {
    padding: 0.5rem;
    text-align: left;
  }

  th {
    background-color: var(--toolbar); 
    color: white;
    border-bottom: 1px solid var(--toolbar); 
  }

  tr {
    border-bottom: 1px solid var(--toolbar);
  }

  tr:last-child td {
    border-bottom: none; 
  }

  td:last-child {
    display: flex;
    gap: 0.5rem;
    justify-content: flex-start; 
  }
`;
const $d0229c228556b4f9$export$f5b8910cec6cf069 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('input')`
  width: 100%;
  padding: 0.6rem;
  font-size: 1rem;
  border: 1px solid var(--border); 
  border-radius: 0.3rem;
  margin-bottom: 0.8rem;
  box-sizing: border-box;
  background-color: var(--toolbar) !important; 
  color: white; 
  
  &:focus {
    outline: none;
    border-color: var(--primary); 
  }
`;
const $d0229c228556b4f9$export$f5c9f3c2c4054eec = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('textarea')`
  width: 100%;
  padding: 0.6rem;
  font-size: 1rem;
  border: 1px solid var(--border);
  border-radius: 0.3rem;
  margin-bottom: 0.8rem;
  box-sizing: border-box;
  background-color: var(--toolbar);
  color: white; 
  resize: none;
  

  &:focus {
    outline: none;
    border-color: var(--primary); 
  }
`;
const $d0229c228556b4f9$export$e867c393ea9e2330 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('p')`
  display: -webkit-box;
  -webkit-line-clamp: 12; /* Limit to 8 lines */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis; /* Add ellipsis after truncation */
  white-space: pre-wrap; /* Allows text to wrap */
  line-height: 1.2rem; 
  max-height: calc(1.2rem * 12); /* Restrict to 12 lines */
  color: white;
`;
const $d0229c228556b4f9$export$bec7fd3dce2f28c0 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('button')`
  background-color: var(--primary);
  color: white;
  border: none;
  border-radius: 0.3rem;
  padding: 0.6rem 1.2rem;
  margin-top: 0.5rem;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: var(--primary-dark);
  }
`;
const $d0229c228556b4f9$export$faadb9d3691bb990 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  margin: 0.8rem;
  border-radius: 0.3rem;
  padding: 0.5em;
  gap: 0.5em;
  align-items: center;
  background: var(--error);
  color: white;
`;
const $d0229c228556b4f9$export$eddf54ea3db8d0f0 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  justify-content: center; 
  gap: 0.5em; 
  width: 100%;

  Button {
    width: 100%;
  }

  Button:nth-child(1) {
    background-color: transparent;
    color: var(--primary-dark);
    border: 2.5px solid var(--toolbar); 

    &:hover {
      background-color: var(--toolbar);
      color: white;
    }
  }
`;
const $d0229c228556b4f9$export$6a00f65eec6002a6 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  align-items: center;
  justify-content: space-between; 
  margin: 0.75rem 0;
  padding: .2rem 1rem;

  span {
    color: var(--primary-text);
    font-size: 1rem;
    white-space: nowrap;  
  }

  select {
    flex-shrink: 0;
    width: 100px;  
    padding: 0.4rem;
    border: 1px solid var(--border);
    border-radius: 0.25rem;
  }
`;






const $f750c14062f55f2d$var$Modules = ()=>{
    const setModuleProjects = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.setProjects);
    const setModuleDescription = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.setModuleDescription);
    const setModuleName = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.setName);
    const deleteQuestionFromModule = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.deleteQuestion);
    const addQuestionToModule = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.upsertQuestion);
    const deleteProjectFromModule = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.deleteProject);
    const updateProjectToModule = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.upsertProject);
    const currentModule = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.module);
    const showModuleWindow = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.showModuleWindow);
    const setShowModuleWindow = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.setShowModuleWindow);
    const updateModule = (0, $38932e4472f33f50$export$2e2bcd8739ae039)((s)=>s.upsertModule);
    const setProject = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.set);
    const currentProject = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project);
    const setAllProjectNames = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.setAllProjectNames);
    const setProjectName = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.setName);
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)('common');
    // Current assessment description and title
    const [isTitleEditing, setTitleIsEditing] = (0, $h2ArV.useState)(false);
    const [titleInput, setTitleInput] = (0, $h2ArV.useState)('');
    const [titleDescription, setTitleDescription] = (0, $h2ArV.useState)('');
    // Modal-related state management
    const [isModalOpen, setIsModalOpen] = (0, $h2ArV.useState)(false) // Controls modal visibility
    ;
    // Delete confirmation modal state
    const [isDeleteModalOpen, setIsDeleteModalOpen] = (0, $h2ArV.useState)(false);
    const [projectToDelete, setProjectToDelete] = (0, $h2ArV.useState)(null);
    // Load module values into local state when module changes
    (0, $h2ArV.useEffect)(()=>{
        if (currentModule) {
            setTitleInput(currentModule.meta.name || '') // Populate title input
            ;
            setTitleDescription(currentModule.description || '') // Populate description input
            ;
        }
    }, [
        currentModule
    ]);
    // Open edit mode and reset the input fields
    const handleEditClick = ()=>{
        if (currentModule) {
            setTitleInput(currentModule.meta.name || '') // Reset title input
            ;
            setTitleDescription(currentModule.description || '') // Reset description input
            ;
        }
        setTitleIsEditing(true) // Enable edit mode
        ;
    };
    // Save the new title and description to the store
    const handleEditSaveClick = ()=>{
        setModuleName(titleInput);
        setModuleDescription(titleDescription);
        setProjectName(titleInput) // Save title to current project
        ;
        setAllProjectNames(titleInput) // Save title to all projects stored in module
        ;
        setTitleIsEditing(false) // Exit edit mode after saving
        ;
        saveModule();
    };
    // Cancel editing and reset the input fields to the stored values
    const handleCancelClick = ()=>{
        if (currentModule) {
            setTitleInput(currentModule.meta.name || '') // Reset title input
            ;
            setTitleDescription(currentModule.description || '') // Reset description input
            ;
        }
        setTitleIsEditing(false) // Exit edit mode without saving
        ;
    };
    // Save changes to module
    const saveModule = ()=>{
        const project = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039).getState().project;
        if (!project) return;
        updateProjectToModule({
            ...project,
            meta: {
                ...project.meta,
                dateEdited: Date.now()
            }
        });
        if (currentModule) updateModule(currentModule);
    };
    // Function to open the modal
    const handleAddQuestionClick = ()=>setIsModalOpen(true);
    // Form handling using react-hook-form
    const { register: register, handleSubmit: handleSubmit } = (0, $cf42f49a775636e7$export$87c0cf8eb5a167e0)({
        defaultValues: {
            questionType: 'FSA'
        }
    });
    const handleAddQuestion = (data)=>{
        const newModuleProject = (0, $be91e446fcb94886$export$ff4e209d475e9bd8)(data.questionType, currentModule.meta.name);
        updateProjectToModule(newModuleProject) // Save new project with selected type
        ;
        addQuestionToModule(newModuleProject._id, '') // Add new question
        ;
        setProject(newModuleProject) // Set the project for editing
        ;
        setIsModalOpen(false) // Close the modal
        ;
    };
    const handleEditQuestion = (_project)=>{
        // Save current changes before moving to another question
        saveModule();
        // Set the project for the editor
        setProject(_project);
        // Open module window
        if (showModuleWindow === false) setShowModuleWindow(true);
    };
    const handleOpenQuestion = (_project)=>{
        // Save current changes before moving to another question
        saveModule();
        // Set the project for the editor
        setProject(_project);
    };
    // Show delete confirmation modal
    const handleDeleteQuestion = (_project)=>{
        setProjectToDelete(_project);
        setIsDeleteModalOpen(true);
    };
    // Perform actual deletion after confirmation
    const confirmDeleteQuestion = ()=>{
        if (!projectToDelete) return;
        deleteProjectFromModule(projectToDelete._id);
        deleteQuestionFromModule(projectToDelete._id);
        if (projectToDelete._id === currentProject?._id && currentModule) {
            const remainingProjects = currentModule.projects.filter((proj)=>proj._id !== projectToDelete._id);
            if (remainingProjects.length > 0) setProject(remainingProjects[0]); // Set the first remaining project as the current project
        }
        // Close the modal and reset projectToDelete
        setIsDeleteModalOpen(false);
        setProjectToDelete(null);
    };
    // Drag and drop
    const [draggedIndex, setDraggedIndex] = (0, $h2ArV.useState)(null) // Track the index of the dragged item
    ;
    const handleDragStart = (index)=>{
        setDraggedIndex(index) // Store the index of the dragged question
        ;
    };
    const handleDrop = (dropIndex)=>{
        if (!currentModule) return;
        if (draggedIndex === null || draggedIndex === dropIndex) return; // Avoid rearranging if the index hasn't changed
        const updatedProjects = [
            ...currentModule.projects
        ] // Clone projects array
        ;
        const [movedProject] = updatedProjects.splice(draggedIndex, 1) // Remove dragged project
        ;
        updatedProjects.splice(dropIndex, 0, movedProject) // Insert it at the drop location
        ;
        setModuleProjects(updatedProjects) // Update the project order
        ;
        setDraggedIndex(null) // Reset dragged index
        ;
    };
    const handleDragOver = (e)=>{
        e.preventDefault() // Allow drop by preventing the default behavior
        ;
    };
    const handleExportModule = ()=>(0, $b9bf89f7d3b36cd8$export$beeb3b669a0e7af3)();
    const handleCreateModule = ()=>(0, $ca2884de04f532f3$export$fb20829f6af70575)('modal:createModule', {
            project: true
        });
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $f6c0a8acd60d8875$export$2e2bcd8739ae039), {
                children: t('module_panel.current')
            }),
            !currentModule ? /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d0229c228556b4f9$export$e6dfd72ab29f8598), {
                children: [
                    t('module_panel.not_working'),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $21c0b4c3fc3b1107$export$2e2bcd8739ae039), {}),
                        onClick: handleCreateModule,
                        children: t('module_panel.modularise')
                    })
                ]
            }) : /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $d0229c228556b4f9$export$e6dfd72ab29f8598), {
                        children: isTitleEditing ? /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $d0229c228556b4f9$export$718e92491c44b3f6), {
                                    children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $d0229c228556b4f9$export$f5c9f3c2c4054eec), {
                                        value: titleInput,
                                        onChange: (e)=>setTitleInput(e.target.value),
                                        rows: 1,
                                        placeholder: t('module_panel.placeholder_title'),
                                        maxLength: 30
                                    })
                                }),
                                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $d0229c228556b4f9$export$f5c9f3c2c4054eec), {
                                    value: titleDescription,
                                    onChange: (e)=>setTitleDescription(e.target.value),
                                    rows: 4,
                                    placeholder: t('module_panel.placeholder_desc')
                                }),
                                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d0229c228556b4f9$export$eddf54ea3db8d0f0), {
                                    children: [
                                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                                            onClick: handleCancelClick,
                                            children: t('cancel')
                                        }),
                                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                                            onClick: handleEditSaveClick,
                                            children: t('save')
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $d0229c228556b4f9$export$718e92491c44b3f6), {
                                    children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("h2", {
                                        children: currentModule?.meta.name || t('create_module.untitled')
                                    })
                                }),
                                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $d0229c228556b4f9$export$e867c393ea9e2330), {
                                    children: currentModule?.description || ''
                                }),
                                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                                    onClick: handleEditClick,
                                    children: t('menus.edit')
                                }),
                                " "
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $f6c0a8acd60d8875$export$2e2bcd8739ae039), {
                        children: t('module_panel.settings')
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $d0229c228556b4f9$export$e6dfd72ab29f8598), {
                        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e44002cbb4794c3a$export$2e2bcd8739ae039), {
                            label: t('module_panel.open_questions'),
                            children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $0770ae362b3cd6e9$export$2e2bcd8739ae039), {
                                type: "checkbox",
                                checked: showModuleWindow,
                                onChange: ()=>setShowModuleWindow(!showModuleWindow)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $f6c0a8acd60d8875$export$2e2bcd8739ae039), {
                        children: t('module_panel.questions')
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d0229c228556b4f9$export$e6dfd72ab29f8598), {
                        children: [
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d0229c228556b4f9$export$54ec01a60f47d33d), {
                                children: [
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("th", {
                                                    children: t('module_panel.question')
                                                }),
                                                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("th", {
                                                    children: t('module_panel.actions')
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("tbody", {
                                        children: currentModule.projects.map((q, index)=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("tr", {
                                                style: {
                                                    backgroundColor: currentProject && currentProject._id === q._id ? 'var(--toolbar)' : 'transparent' // Highlight if it's the current project
                                                },
                                                draggable: currentProject && currentProject._id === q._id,
                                                onDragStart: ()=>handleDragStart(index),
                                                onDrop: ()=>handleDrop(index),
                                                onDragOver: handleDragOver,
                                                children: [
                                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("td", {
                                                        onClick: ()=>handleOpenQuestion(q),
                                                        children: t('module_panel.question_id', {
                                                            id: index + 1
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("td", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $d0229c228556b4f9$export$a8d3280cb45e38b8), {
                                                                onClick: ()=>handleEditQuestion(q),
                                                                children: t('menus.edit')
                                                            }),
                                                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $d0229c228556b4f9$export$4e9d5ce1e6c22a94), {
                                                                onClick: ()=>handleDeleteQuestion(q),
                                                                disabled: currentModule.projects.length <= 1,
                                                                children: t('module_panel.remove')
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, q._id))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                                icon: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $21c0b4c3fc3b1107$export$2e2bcd8739ae039), {}),
                                onClick: handleAddQuestionClick,
                                children: t('module_panel.add_question')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $a5fe3119a76402fb$export$2e2bcd8739ae039), {
                        title: t('module_panel.add_question_title'),
                        description: t('module_panel.add_question_desc'),
                        isOpen: isModalOpen,
                        onClose: ()=>setIsModalOpen(false),
                        actions: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                                    secondary: true,
                                    onClick: ()=>setIsModalOpen(false),
                                    children: t('cancel')
                                }),
                                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                                    type: "submit",
                                    form: "question_type_form",
                                    children: t('save')
                                })
                            ]
                        }),
                        style: {
                            paddingInline: 0
                        },
                        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("form", {
                            id: "question_type_form",
                            onSubmit: handleSubmit(handleAddQuestion),
                            children: [
                                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $f6c0a8acd60d8875$export$2e2bcd8739ae039), {
                                    children: t('module_panel.question_type')
                                }),
                                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d0229c228556b4f9$export$6a00f65eec6002a6), {
                                    children: [
                                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("span", {
                                            children: t('module_panel.select_type')
                                        }),
                                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                                            type: "select",
                                            small: true,
                                            ...register('questionType'),
                                            children: [
                                                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                                    value: "FSA",
                                                    children: t('fsa_short')
                                                }),
                                                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                                    value: "PDA",
                                                    children: t('pda_short')
                                                }),
                                                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                                    value: "TM",
                                                    children: t('tm_short')
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $a5fe3119a76402fb$export$2e2bcd8739ae039), {
                        title: t('module_panel.delete_question_title'),
                        description: t('module_panel.delete_question_desc'),
                        isOpen: isDeleteModalOpen,
                        onClose: ()=>{
                            setIsDeleteModalOpen(false);
                            setProjectToDelete(null);
                        },
                        actions: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                                    secondary: true,
                                    onClick: ()=>{
                                        setIsDeleteModalOpen(false);
                                        setProjectToDelete(null);
                                    },
                                    children: t('cancel')
                                }),
                                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                                    onClick: confirmDeleteQuestion,
                                    children: t('delete')
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $f6c0a8acd60d8875$export$2e2bcd8739ae039), {
                        children: t('export')
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d0229c228556b4f9$export$e6dfd72ab29f8598), {
                        children: [
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                                onClick: handleExportModule,
                                children: t('module_panel.export_automatarium')
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                                onClick: ()=>(0, $ca2884de04f532f3$export$fb20829f6af70575)('showModuleSharing', null),
                                children: t('module_panel.export_url')
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $f750c14062f55f2d$export$2e2bcd8739ae039 = $f750c14062f55f2d$var$Modules;









const $affe7841397c2517$var$panels = (t)=>[
        {
            label: t('panels.testing_lab'),
            value: 'test',
            icon: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e438f551aa34f135$export$2e2bcd8739ae039), {}),
            element: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $6beaee6853357605$export$2e2bcd8739ae039), {})
        },
        {
            label: t('panels.about'),
            value: 'about',
            icon: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $827a5ca7f496cadf$export$2e2bcd8739ae039), {}),
            element: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $051125520ff239fe$export$2e2bcd8739ae039), {})
        },
        {
            label: t('panels.options'),
            value: 'options',
            icon: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $244b608a864e4ea9$export$2e2bcd8739ae039), {}),
            element: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $a43fca37b450352e$export$2e2bcd8739ae039), {})
        },
        {
            label: t('menus.templates'),
            value: 'templates',
            icon: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $9e4e2ab5c2f172dc$export$2e2bcd8739ae039), {}),
            element: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $d1ca26ed0feeda99$export$2e2bcd8739ae039), {})
        },
        {
            label: t('menus.modules'),
            value: 'modules',
            icon: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ed9b1098b0fefefa$export$2e2bcd8739ae039), {}),
            element: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $f750c14062f55f2d$export$2e2bcd8739ae039), {})
        }
    ];
const $affe7841397c2517$var$Sidepanel = ({ onToggle: onToggle })=>{
    const [activePanel, setActivePanel] = (0, $h2ArV.useState)();
    const setTemplate = (0, $f8e54bb3e6739765$export$2e2bcd8739ae039)((s)=>s.setTemplate);
    const setTool = (0, $9ea7efd115f178cf$export$2e2bcd8739ae039)((s)=>s.setTool);
    const setSteppedStates = (0, $d2aaad49862844e1$export$2e2bcd8739ae039)((s)=>s.setSteppedStates);
    const projectType = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project.config.type);
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)('common');
    const cleanupPanel = ()=>{
        (0, $d1ca26ed0feeda99$export$b1376a1346f30465)(setTemplate, setTool);
        setSteppedStates([]);
        (0, $ca2884de04f532f3$export$fb20829f6af70575)('bottomPanel:close', null);
        (0, $ca2884de04f532f3$export$fb20829f6af70575)('stackVisualiser:toggle', {
            state: false
        });
    };
    const handleToggle = (panel)=>{
        const isSamePanel = activePanel?.value === panel.value;
        // Cleanup the previous panel regardless of the state
        cleanupPanel();
        if (isSamePanel) {
            // If the same panel is clicked, close it
            setActivePanel(undefined);
            onToggle?.(false) // Close side panel
            ;
        } else {
            // If a different panel is clicked, open it
            setActivePanel(panel);
            onToggle?.(true) // Open side panel
            ;
        }
    };
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('sidepanel:open', (e)=>{
        const panel = $affe7841397c2517$var$panels(t).find((p)=>p.value === e.detail.panel);
        handleToggle(panel);
    }, [
        activePanel
    ]);
    (0, $h2ArV.useEffect)(()=>{
        if (projectType === 'TM' && activePanel?.value === 'test') (0, $ca2884de04f532f3$export$fb20829f6af70575)('bottomPanel:open', {
            panel: 'tmTape'
        });
        else (0, $ca2884de04f532f3$export$fb20829f6af70575)('bottomPanel:close', null);
    }, [
        activePanel
    ]);
    const handleClose = ()=>{
        cleanupPanel();
        setActivePanel(undefined);
        onToggle?.(false);
        onToggle?.(true);
    };
    (0, $h2ArV.useEffect)(()=>{
        if (projectType === 'PDA' && activePanel?.value === 'test') (0, $ca2884de04f532f3$export$fb20829f6af70575)('stackVisualiser:toggle', {
            state: true
        });
        else (0, $ca2884de04f532f3$export$fb20829f6af70575)('stackVisualiser:toggle', {
            state: false
        });
    }, [
        activePanel
    ]);
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $dbe8ae58eb2438c9$export$e6dfd72ab29f8598), {
        children: [
            activePanel && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $dbe8ae58eb2438c9$export$de65de8213222d10), {
                        onClick: handleClose,
                        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $dfbd774c055342cf$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $dbe8ae58eb2438c9$export$2ddb90ad54e5f587), {
                        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $dbe8ae58eb2438c9$export$a8a3e93435678ff9), {
                                    children: activePanel?.label
                                }),
                                activePanel?.element
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $a3b7de28ad1e6565$export$2e2bcd8739ae039), {
                children: $affe7841397c2517$var$panels(t).map((panel)=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $a3b7de28ad1e6565$export$da76e993ddf038d), {
                        onClick: ()=>handleToggle(panel),
                        $active: activePanel?.value === panel.value,
                        title: panel.label,
                        children: panel.icon
                    }, panel.value))
            })
        ]
    });
};
var $affe7841397c2517$export$2e2bcd8739ae039 = $affe7841397c2517$var$Sidepanel;




var $h2ArV = parcelRequire("h2ArV");



const $12d0b7649b7c2a71$var$graphContextItems = (t)=>{
    return [
        {
            label: t('context_menu.add_comment', {
                ns: 'common'
            }),
            action: 'CREATE_COMMENT'
        },
        'hr',
        {
            label: t('context_menu.create_state', {
                ns: 'common'
            }),
            action: 'CREATE_STATE'
        },
        'hr',
        {
            label: t('context_menu.select_all', {
                ns: 'common'
            }),
            action: 'SELECT_ALL'
        },
        {
            label: t('paste', {
                ns: 'common'
            }),
            action: 'PASTE'
        }
    ];
};
var $12d0b7649b7c2a71$export$2e2bcd8739ae039 = $12d0b7649b7c2a71$var$graphContextItems;


const $e1d986929aa3c065$var$stateContextItems = (t)=>{
    return [
        {
            label: t('context_menu.set_initial', {
                ns: 'common'
            }),
            action: 'SET_STATE_INITIAL'
        },
        {
            label: t('context_menu.toggle_final', {
                ns: 'common'
            }),
            action: 'TOGGLE_STATES_FINAL'
        },
        'hr',
        {
            label: t('context_menu.align_horizontally', {
                ns: 'common'
            }),
            action: 'ALIGN_STATES_HORIZONTAL'
        },
        {
            label: t('context_menu.align_vertically', {
                ns: 'common'
            }),
            action: 'ALIGN_STATES_VERTICAL'
        },
        'hr',
        {
            label: t('context_menu.set_label', {
                ns: 'common'
            }),
            action: 'SET_STATE_LABEL'
        },
        {
            label: t('context_menu.change_name', {
                ns: 'common'
            }),
            action: 'SET_STATE_NAME'
        },
        'hr',
        {
            label: t('copy', {
                ns: 'common'
            }),
            action: 'COPY'
        },
        {
            label: t('paste', {
                ns: 'common'
            }),
            action: 'PASTE'
        },
        'hr',
        {
            label: t('delete', {
                ns: 'common'
            }),
            shortcut: "\u232B",
            action: 'DELETE'
        }
    ];
};
var $e1d986929aa3c065$export$2e2bcd8739ae039 = $e1d986929aa3c065$var$stateContextItems;


const $ce590d382a4c5216$var$transitionContextItems = (t)=>{
    return [
        {
            label: t('context_menu.edit_transition', {
                ns: 'common'
            }),
            action: 'EDIT_TRANSITION'
        },
        {
            label: t('context_menu.flip_selected_transitions', {
                ns: 'common'
            }),
            action: 'FLIP_TRANSITION'
        },
        'hr',
        {
            label: t('delete', {
                ns: 'common'
            }),
            shortcut: "\u232B",
            action: 'DELETE'
        }
    ];
};
var $ce590d382a4c5216$export$2e2bcd8739ae039 = $ce590d382a4c5216$var$transitionContextItems;


const $0af88ea88e0a6397$var$commentContextItems = (t)=>{
    return [
        {
            label: t('context_menu.edit_comment', {
                ns: 'common'
            }),
            action: 'EDIT_COMMENT'
        },
        'hr',
        {
            label: t('delete', {
                ns: 'common'
            }),
            shortcut: "\u232B",
            action: 'DELETE'
        }
    ];
};
var $0af88ea88e0a6397$export$2e2bcd8739ae039 = $0af88ea88e0a6397$var$commentContextItems;


const $cb6c2de1d55b1139$var$edgeContextItems = (t)=>{
    return [
        {
            label: t('context_menu.edit_transitions_group', {
                ns: 'common'
            }),
            action: 'EDIT_TRANSITIONS_GROUP'
        },
        {
            label: t('context_menu.flip_edge', {
                ns: 'common'
            }),
            action: 'FLIP_EDGE'
        },
        'hr',
        {
            label: t('context_menu.edit_first_transition', {
                ns: 'common'
            }),
            action: 'EDIT_FIRST'
        },
        'hr',
        {
            label: t('context_menu.delete_edge', {
                ns: 'common'
            }),
            action: 'DELETE_EDGE'
        }
    ];
};
var $cb6c2de1d55b1139$export$2e2bcd8739ae039 = $cb6c2de1d55b1139$var$edgeContextItems;


const $2baf3b7f870173d8$var$ContextMenus = ()=>{
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)('common');
    const [context, setContext] = (0, $h2ArV.useState)();
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('ctx:svg', ({ detail: { x: x, y: y } })=>{
        setContext({
            visible: true,
            x: x,
            y: y,
            items: (0, $12d0b7649b7c2a71$export$2e2bcd8739ae039)(t)
        });
    }, []);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('ctx:state', ({ detail: { x: x, y: y } })=>{
        setContext({
            visible: true,
            x: x,
            y: y,
            items: (0, $e1d986929aa3c065$export$2e2bcd8739ae039)(t)
        });
    }, []);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('ctx:transition', ({ detail: { x: x, y: y } })=>{
        setContext({
            visible: true,
            x: x,
            y: y,
            items: (0, $ce590d382a4c5216$export$2e2bcd8739ae039)(t)
        });
    }, []);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('ctx:comment', ({ detail: { x: x, y: y } })=>{
        setContext({
            visible: true,
            x: x,
            y: y,
            items: (0, $0af88ea88e0a6397$export$2e2bcd8739ae039)(t)
        });
    }, []);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('ctx:edge', ({ detail: { x: x, y: y } })=>{
        setContext({
            visible: true,
            x: x,
            y: y,
            items: (0, $cb6c2de1d55b1139$export$2e2bcd8739ae039)(t)
        });
    }, []);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('ctx:close', ()=>{
        setContext({
            ...context,
            visible: false
        });
    }, []);
    if (!context?.visible) return null;
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $54cc07ecaf352272$export$2e2bcd8739ae039), {
        visible: context.visible,
        onClose: ()=>setContext({
                ...context,
                visible: false
            }),
        style: {
            top: `${context.y}px`,
            left: `${context.x}px`
        },
        items: context.items
    });
};
var $2baf3b7f870173d8$export$2e2bcd8739ae039 = $2baf3b7f870173d8$var$ContextMenus;




var $h2ArV = parcelRequire("h2ArV");
/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e2fc0b2d396fb6da$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 4v7a4 4 0 0 1-4 4H4",
            key: "6o5b7l"
        }
    ],
    [
        "path",
        {
            d: "m9 10-5 5 5 5",
            key: "1kshq7"
        }
    ]
];
const $e2fc0b2d396fb6da$export$2e2bcd8739ae039 = (0, $764ec6f19a629312$export$2e2bcd8739ae039)("corner-down-left", $e2fc0b2d396fb6da$export$3efd853dbb351e94);





// Quantify the position of a transition using a list of states
const $3f368c329a5889b3$export$883a7ac0705d77b5 = (t, states)=>{
    const fromState = states.find((s)=>s.id === t.from);
    const toState = states.find((s)=>s.id === t.to);
    return {
        ...t,
        from: {
            x: fromState.x,
            y: fromState.y
        },
        to: {
            x: toState.x,
            y: toState.y
        }
    };
};






const $ffcb756031259e7f$export$5a65bc80584593de = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  gap: 0.5em;
  margin-right: 0.7em;
`;
const $ffcb756031259e7f$export$f10a404c6d903a79 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('label')`
  display: flex;
  align-items: center;
  cursor: pointer;
  text-transform: uppercase;
  font-size: .85em;
  font-weight: 600;
  color: var(--input-border);
`;
const $ffcb756031259e7f$export$9a40226186363e02 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('input')`
  width: 1.5em;  
  height: 1.5em;  
  appearance: none;
  outline: none;
  border: 2px solid white; 
  border-radius: 50%;
  position: relative;
  cursor: pointer;
  padding-right: 0.2em;  
  
  &:checked:before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1em; 
    height: 1em; 
    background-color: var(--primary);
    border-radius: 50%;
    transform: translate(-50%, -50%);
  }
`;


const $66e54ad82e4a6e2b$export$cec9f334da77a853 = ({ direction: direction, setDirection: setDirection, handleSave: handleSave, name: name })=>{
    const handleKeyUp = (e)=>{
        switch(e.key.toUpperCase()){
            case 'R':
                setDirection('R');
                break;
            case 'L':
                setDirection('L');
                break;
            case 'S':
                setDirection('S');
                break;
            default:
                handleSave(e);
                break;
        }
    };
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $ffcb756031259e7f$export$5a65bc80584593de), {
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $ffcb756031259e7f$export$f10a404c6d903a79), {
                htmlFor: `${name}-direction-R`,
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ffcb756031259e7f$export$9a40226186363e02), {
                        id: `${name}-direction-R`,
                        type: "radio",
                        name: name,
                        value: "R",
                        checked: direction === 'R',
                        onChange: (e)=>setDirection(e.target.value),
                        onKeyUp: handleKeyUp
                    }),
                    "R"
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $ffcb756031259e7f$export$f10a404c6d903a79), {
                htmlFor: `${name}-direction-L`,
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ffcb756031259e7f$export$9a40226186363e02), {
                        id: `${name}-direction-L`,
                        type: "radio",
                        name: name,
                        value: "L",
                        checked: direction === 'L',
                        onChange: (e)=>setDirection(e.target.value),
                        onKeyUp: handleKeyUp
                    }),
                    "L"
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $ffcb756031259e7f$export$f10a404c6d903a79), {
                htmlFor: `${name}-direction-S`,
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ffcb756031259e7f$export$9a40226186363e02), {
                        id: `${name}-direction-S`,
                        type: "radio",
                        name: name,
                        value: "S",
                        checked: direction === 'S',
                        onChange: (e)=>setDirection(e.target.value),
                        onKeyUp: handleKeyUp
                    }),
                    "S"
                ]
            })
        ]
    });
};



const $804ba8bb480a35bd$export$14e6dc83faa10b69 = {
    width: 'calc(12ch + 3.5em)',
    margin: '0 .4em',
    paddingRight: '2.5em'
};
const $804ba8bb480a35bd$export$b6395de9464a83ce = {
    ...$804ba8bb480a35bd$export$14e6dc83faa10b69,
    width: 'calc(13ch + 3.5em)'
};
const $804ba8bb480a35bd$export$fb9f58ebe9de6283 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  position: relative;
  display: flex;
  align-items: center;
`;
const $804ba8bb480a35bd$export$8b7b7cdfb85d78c5 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('button')`
  position: absolute;
  padding: 0;
  margin: 0;
  right: .4em;
  top: 0;
  bottom: 0;
  border: 0;
  background: none;
  font: inherit;
  color: var(--surface);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5em;
  cursor: pointer;
`;
const $804ba8bb480a35bd$export$6898c8c6ae2303dc = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)($804ba8bb480a35bd$export$8b7b7cdfb85d78c5)`
  color: white;
  right: .2em;
  width: 2.0em;
`;
const $804ba8bb480a35bd$export$ffcbb0cdcfc3e158 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  padding-top: 0.5em;
  padding-bottom: 0.3em;
  padding-left: 0.4em;
  `;




const $74a892b6cea20744$var$InputDialogs = ()=>{
    const [dialog, setDialog] = (0, $h2ArV.useState)();
    const inputRef = (0, $h2ArV.useRef)();
    const inputPopRef = (0, $h2ArV.useRef)();
    const inputPushRef = (0, $h2ArV.useRef)();
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)('common');
    const [value, setValue] = (0, $h2ArV.useState)('');
    const [valuePop, setValuePop] = (0, $h2ArV.useState)('');
    const [valuePush, setValuePush] = (0, $h2ArV.useState)('');
    const inputWriteRef = (0, $h2ArV.useRef)();
    const inputDirectionRef = (0, $h2ArV.useRef)();
    const [write, setWrite] = (0, $h2ArV.useState)('');
    const [direction, setDirection] = (0, $h2ArV.useState)('R');
    const editTransition = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.editTransition);
    const removeTransitions = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.removeTransitions);
    const commit = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.commit);
    const viewToScreenSpace = (0, $2c8de4ab9c0d9b91$export$2e2bcd8739ae039)((s)=>s.viewToScreenSpace);
    const screenToViewSpace = (0, $2c8de4ab9c0d9b91$export$2e2bcd8739ae039)((s)=>s.screenToViewSpace);
    const statePrefix = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project.config.statePrefix);
    const projectType = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project.config.type);
    const orOperator = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project.config.orOperator) ?? '|';
    const hideDialog = (0, $h2ArV.useCallback)(()=>setDialog({
            ...dialog,
            visible: false
        }), [
        dialog
    ]);
    const focusInput = (0, $h2ArV.useCallback)(()=>setTimeout(()=>inputRef.current?.focus(), 100), [
        inputRef.current
    ]);
    const [isNew, setIsNew] = (0, $h2ArV.useState)(true);
    const arr = [
        inputWriteRef.current,
        inputDirectionRef.current,
        inputRef.current
    ];
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('editTransition', ({ detail: { id: id, new: isNewTransition } })=>{
        const { states: states, transitions: transitions } = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039).getState()?.project ?? {};
        const transition = transitions.find((t)=>t.id === id);
        // Find midpoint of transition in screen space
        const pos = (0, $3f368c329a5889b3$export$883a7ac0705d77b5)(transition, states);
        const midPoint = (0, $5803ecf8056a071e$export$110a106688b8ed86)(pos.from, pos.to, 0.5);
        const screenMidPoint = viewToScreenSpace(midPoint.x, midPoint.y);
        setIsNew(isNewTransition ?? true) // Default a.k.a. previous functionality assumes new
        ;
        switch(projectType){
            case 'TM':
                (0, $be180ebd7a95f287$export$804de46662e4ac95)(transition);
                setValue((0, $7431f94c7ac0c9a7$export$8b9d5f9a071daa33)(transition?.read, orOperator) ?? '');
                setWrite(transition?.write ?? '');
                setDirection(transition?.direction ?? 'R');
                setDialog({
                    visible: true,
                    x: screenMidPoint[0] - 100,
                    y: screenMidPoint[1],
                    id: id,
                    type: 'TMTransition'
                });
                break;
            case 'PDA':
                (0, $be180ebd7a95f287$export$804de46662e4ac95)(transition);
                setValue((0, $7431f94c7ac0c9a7$export$8b9d5f9a071daa33)(transition?.read, orOperator) ?? '');
                setValuePush(transition?.push ?? '');
                setValuePop(transition?.pop ?? '');
                setDialog({
                    visible: true,
                    x: screenMidPoint[0],
                    y: screenMidPoint[1],
                    id: id,
                    type: 'PDATransition'
                });
                break;
            case 'FSA':
                setValue((0, $7431f94c7ac0c9a7$export$8b9d5f9a071daa33)(transition?.read, orOperator) ?? '');
                setDialog({
                    visible: true,
                    x: screenMidPoint[0],
                    y: screenMidPoint[1],
                    id: id,
                    type: 'FSATransition'
                });
        }
        focusInput();
    }, [
        arr,
        orOperator
    ]);
    const saveTransition = ()=>{
        editTransition({
            id: dialog.id,
            read: (0, $7431f94c7ac0c9a7$export$193046f9d1fa1ed1)(value, orOperator)
        });
        commit();
        hideDialog();
    };
    const saveTMTransition = ()=>{
        editTransition({
            id: dialog.id,
            read: (0, $7431f94c7ac0c9a7$export$193046f9d1fa1ed1)(value, orOperator),
            write: write,
            direction: direction || 'R'
        });
        commit();
        hideDialog();
    };
    const savePDATransition = ()=>{
        editTransition({
            id: dialog.id,
            read: (0, $7431f94c7ac0c9a7$export$193046f9d1fa1ed1)(value, orOperator),
            pop: valuePop,
            push: valuePush
        });
        commit();
        hideDialog();
    };
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('editComment', ({ detail: { id: id, x: x, y: y } })=>{
        const selectedComment = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039).getState().project?.comments.find((cm)=>cm.id === id);
        setValue(selectedComment?.text ?? '');
        setDialog({
            visible: true,
            selectedComment: selectedComment,
            x: x,
            y: y,
            type: 'comment'
        });
        focusInput();
    }, [
        inputRef.current
    ]);
    const saveComment = ()=>{
        if (value && !/^\s*$/.test(value) && dialog.type === 'comment') {
            if (dialog.selectedComment === undefined) {
                const pos = screenToViewSpace(dialog.x, dialog.y);
                (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039).getState().createComment({
                    x: pos[0],
                    y: pos[1],
                    text: value.trim()
                });
            } else (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039).getState().updateComment({
                ...dialog.selectedComment,
                text: value.trim()
            });
            commit();
        }
        hideDialog();
    };
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('editStateName', ({ detail: { id: id } })=>{
        const selectedState = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039).getState().project?.states.find((s)=>s.id === id);
        setValue(selectedState.name ?? '');
        const pos = viewToScreenSpace(selectedState.x, selectedState.y);
        setDialog({
            visible: true,
            selectedState: selectedState,
            x: pos[0],
            y: pos[1],
            type: 'stateName'
        });
        focusInput();
    }, [
        inputRef.current
    ]);
    const saveStateName = ()=>{
        (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039).getState().updateState({
            ...dialog.selectedState,
            name: !value || /^\s*$/.test(value) ? undefined : value
        });
        commit();
        hideDialog();
    };
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('editStateLabel', ({ detail: { id: id } })=>{
        const selectedState = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039).getState().project?.states.find((s)=>s.id === id);
        setValue(selectedState.label ?? '');
        const pos = viewToScreenSpace(selectedState.x, selectedState.y);
        setDialog({
            visible: true,
            selectedState: selectedState,
            x: pos[0],
            y: pos[1],
            type: 'stateLabel'
        });
        focusInput();
    }, [
        inputRef.current
    ]);
    const saveStateLabel = ()=>{
        (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039).getState().updateState({
            ...dialog.selectedState,
            label: !value || /^\s*$/.test(value) ? undefined : value
        });
        commit();
        hideDialog();
    };
    const save = {
        FSATransition: saveTransition,
        TMTransition: saveTMTransition,
        PDATransition: savePDATransition,
        comment: saveComment,
        stateName: saveStateName,
        stateLabel: saveStateLabel
    }[dialog?.type];
    const handleWriteIn = (e)=>{
        const input = e.target.value.toString();
        setWrite(input[input.length - 1] ?? '');
    };
    if (!dialog) return null;
    /**
   * Common properties of the parent dropdown
   */ const DROPDOWN_PROPS = {
        visible: dialog.visible,
        onClose: ()=>{
            hideDialog();
            if (isNew && [
                'FSATransition',
                'PDATransition',
                'TMTransition'
            ].includes(dialog.type)) removeTransitions([
                dialog.id
            ]);
        },
        style: {
            top: `${dialog.y}px`,
            left: `${dialog.x}px`
        }
    };
    /**
   * Calls `save` if the enter key is hit
   * @param e
   */ const handleSave = (e)=>e.key === 'Enter' && save();
    // Show the dialog depending on the type created
    switch(dialog.type){
        case 'FSATransition':
            return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $54cc07ecaf352272$export$2e2bcd8739ae039), {
                ...DROPDOWN_PROPS,
                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $804ba8bb480a35bd$export$fb9f58ebe9de6283), {
                    children: [
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                            ref: inputRef,
                            value: value,
                            onChange: (e)=>setValue(e.target.value),
                            onKeyUp: handleSave,
                            placeholder: "\u03BB",
                            style: (0, $804ba8bb480a35bd$export$14e6dc83faa10b69)
                        }),
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $804ba8bb480a35bd$export$8b7b7cdfb85d78c5), {
                            onClick: save,
                            children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e2fc0b2d396fb6da$export$2e2bcd8739ae039), {
                                size: "18px"
                            })
                        })
                    ]
                })
            });
        case 'PDATransition':
            return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $54cc07ecaf352272$export$2e2bcd8739ae039), {
                ...DROPDOWN_PROPS,
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $804ba8bb480a35bd$export$fb9f58ebe9de6283), {
                        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                            ref: inputRef,
                            value: value,
                            onChange: (e)=>setValue(e.target.value),
                            onKeyUp: handleSave,
                            placeholder: t('input_dialog.read'),
                            style: (0, $804ba8bb480a35bd$export$14e6dc83faa10b69)
                        })
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $804ba8bb480a35bd$export$fb9f58ebe9de6283), {
                        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                            ref: inputPopRef,
                            value: valuePop,
                            onChange: (e)=>setValuePop(e.target.value),
                            onKeyUp: handleSave,
                            placeholder: t('input_dialog.pop'),
                            style: (0, $804ba8bb480a35bd$export$14e6dc83faa10b69)
                        })
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $804ba8bb480a35bd$export$fb9f58ebe9de6283), {
                        children: [
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                                ref: inputPushRef,
                                value: valuePush,
                                onChange: (e)=>setValuePush(e.target.value),
                                onKeyUp: handleSave,
                                placeholder: t('input_dialog.push'),
                                style: (0, $804ba8bb480a35bd$export$14e6dc83faa10b69)
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $804ba8bb480a35bd$export$8b7b7cdfb85d78c5), {
                                onClick: save,
                                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e2fc0b2d396fb6da$export$2e2bcd8739ae039), {
                                    size: "18px"
                                })
                            })
                        ]
                    })
                ]
            });
        case 'TMTransition':
            return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $54cc07ecaf352272$export$2e2bcd8739ae039), {
                ...DROPDOWN_PROPS,
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $804ba8bb480a35bd$export$fb9f58ebe9de6283), {
                        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                            ref: inputRef,
                            value: value,
                            onChange: (e)=>setValue(e.target.value),
                            onKeyUp: handleSave,
                            placeholder: t('input_dialog.read'),
                            style: (0, $804ba8bb480a35bd$export$b6395de9464a83ce)
                        })
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $804ba8bb480a35bd$export$fb9f58ebe9de6283), {
                        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                            ref: inputWriteRef,
                            value: write,
                            onChange: handleWriteIn,
                            onKeyUp: handleSave,
                            placeholder: t('input_dialog.write'),
                            style: (0, $804ba8bb480a35bd$export$b6395de9464a83ce)
                        })
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $804ba8bb480a35bd$export$fb9f58ebe9de6283), {
                        children: [
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $804ba8bb480a35bd$export$ffcbb0cdcfc3e158), {
                                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $66e54ad82e4a6e2b$export$cec9f334da77a853), {
                                    direction: direction,
                                    setDirection: setDirection,
                                    handleSave: handleSave,
                                    name: `transition-${dialog.id}`
                                })
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $804ba8bb480a35bd$export$6898c8c6ae2303dc), {
                                onClick: save,
                                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e2fc0b2d396fb6da$export$2e2bcd8739ae039), {
                                    size: "18px"
                                })
                            })
                        ]
                    })
                ]
            });
        case 'comment':
        case 'stateName':
        case 'stateLabel':
            // Both comment and state altering modals are basically the same so we can stick
            // them in the same branch
            return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $54cc07ecaf352272$export$2e2bcd8739ae039), {
                ...DROPDOWN_PROPS,
                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $804ba8bb480a35bd$export$fb9f58ebe9de6283), {
                    children: [
                        dialog.type === 'comment' && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $db653877009fa44e$export$2e2bcd8739ae039), {
                            style: {
                                marginInline: '1em .6em'
                            }
                        }),
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                            ref: inputRef,
                            value: value,
                            onChange: (e)=>setValue(e.target.value),
                            onKeyUp: handleSave,
                            placeholder: {
                                stateName: `${statePrefix ?? 'q'}${dialog.selectedState?.id ?? '0'}`,
                                stateLabel: t('input_dialog.state_label'),
                                comment: t('input_dialog.comment_text')
                            }[dialog.type],
                            style: {
                                width: 'calc(20ch + 3.5em)',
                                margin: '0 .4em',
                                paddingRight: '2.5em'
                            }
                        }),
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $804ba8bb480a35bd$export$8b7b7cdfb85d78c5), {
                            onClick: save,
                            children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e2fc0b2d396fb6da$export$2e2bcd8739ae039), {
                                size: "18px"
                            })
                        })
                    ]
                })
            });
        default:
            return null;
    }
};
var $74a892b6cea20744$export$2e2bcd8739ae039 = $74a892b6cea20744$var$InputDialogs;



/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $127384410c27818a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M18 6 6 18",
            key: "1bl5f8"
        }
    ],
    [
        "path",
        {
            d: "m6 6 12 12",
            key: "d8bk6v"
        }
    ]
];
const $127384410c27818a$export$2e2bcd8739ae039 = (0, $764ec6f19a629312$export$2e2bcd8739ae039)("x", $127384410c27818a$export$3efd853dbb351e94);



var $h2ArV = parcelRequire("h2ArV");

const $5b7006d7aefff66f$export$bb1f8a15d1aa29db = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('span')`
  margin: .15em .6em .05em .6em;
`;
const $5b7006d7aefff66f$export$99fec8f892bdba25 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('span')`
  font-weight: bold;
`;
const $5b7006d7aefff66f$export$a8a3e93435678ff9 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  padding: 0.4em;
`;





const $5e8ea4a6afc47358$export$5ce225651d539142 = ({ $icon: $icon, $secondary: $secondary, $surface: $surface })=>(0, $b1e4a7d525070c66$export$dbf350e5966cf602)({
        margin: 0,
        border: 0,
        background: 'var(--primary)',
        font: 'inherit',
        color: 'var(--white)',
        fontWeight: '600',
        fontSize: '.9em',
        borderRadius: '.3em',
        cursor: 'pointer',
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        appearance: 'none',
        gap: '.5em',
        textDecoration: 'none',
        '&:active': {
            filter: 'brightness(0.94)'
        },
        '&:disabled': {
            filter: 'none',
            backgroundColor: 'var(--disabled-button)',
            opacity: '.8',
            cursor: 'default'
        },
        padding: $icon ? '.375em' : '.5em 1.2em',
        backgroundColor: $secondary ? 'var(--toolbar)' : $surface ? 'var(--surface)' : undefined
    });


const $5d3de4eeb487482a$var$Button = ({ type: type = 'button', children: children, icon: icon, secondary: secondary, surface: surface, ...props })=>{
    // Select which element to use.
    // This is done because the `as` prop didn't work well with goober
    let Element;
    if ('href' in props) Element = 'a';
    else if ('to' in props) Element = (0, $ea9c8114d35b5a84$export$a6c7ac8248d6e38a);
    else Element = 'button';
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)(Element, {
        className: (0, $5e8ea4a6afc47358$export$5ce225651d539142)({
            $icon: icon && !children,
            $secondary: secondary,
            $surface: surface
        }),
        type: type,
        ...props,
        children: [
            icon,
            children
        ]
    });
};
var $5d3de4eeb487482a$export$2e2bcd8739ae039 = $5d3de4eeb487482a$var$Button;





var $h2ArV = parcelRequire("h2ArV");


var $h2ArV = parcelRequire("h2ArV");
const $7037b5f7553840a8$export$a195049fd73b3fe2 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('input', (0, $h2ArV.forwardRef))`
  font: inherit;
  border: 1px solid var(--border-color, var(--input-border));
  background: var(--white);
  border-radius: .3em;
  padding: .6em .9em;
  width: 100%;
  box-sizing: border-box;
  ${(props)=>props.as === 'textarea' && 'resize: vertical;'}
  transition: box-shadow .1s, border-color .1s;
  color: var(--black);
  margin: 0;

  &:focus {
    outline: 0;
    box-shadow: inset 0 0 0 1px var(--border-color, var(--primary));
    border-color: var(--border-color, var(--primary));
  }

  ${(p)=>p.$color === 'success' && `
    background: hsl(var(--success-h), 53%, 76%);
    --border-color: var(--success);
  `}
  ${(p)=>p.$color === 'error' && `
    background: hsl(var(--error-h), 97%, 87%);
    --border-color: var(--error);
  `}

  ${(p)=>p.$small && `
    width: initial;
    padding: .4em .5em;
    font-size: .875em;
  `}
`;


const $ff69b033007af947$var$Input = /*#__PURE__*/ (0, $h2ArV.forwardRef)(({ type: type, color: color, small: small = false, ...props }, ref)=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $7037b5f7553840a8$export$a195049fd73b3fe2), {
        id: props.id ?? props.name,
        $color: color,
        $small: small,
        ...props,
        as: type === 'select' ? 'select' : 'input',
        type: type,
        ref: ref
    }));
$ff69b033007af947$var$Input.displayName = "inputComponent";
var $ff69b033007af947$export$2e2bcd8739ae039 = $ff69b033007af947$var$Input;





var $3NhwF = parcelRequire("3NhwF");

var $h2ArV = parcelRequire("h2ArV");
var $b7a42e48e3392ab4$exports = {};
"use strict";
Object.defineProperty($b7a42e48e3392ab4$exports, "__esModule", {
    value: true
});
$b7a42e48e3392ab4$exports.useA11yDialog = $b7a42e48e3392ab4$exports.A11yDialog = void 0;

var $b7a42e48e3392ab4$var$_react = $b7a42e48e3392ab4$var$_interopRequireDefault((parcelRequire("h2ArV")));

var $b7a42e48e3392ab4$var$_reactDom = $b7a42e48e3392ab4$var$_interopRequireDefault((parcelRequire("3NhwF")));

var $b7a42e48e3392ab4$var$_a11yDialog = $b7a42e48e3392ab4$var$_interopRequireDefault((parcelRequire("8rnSG")));

var $b7a42e48e3392ab4$var$_propTypes = $b7a42e48e3392ab4$var$_interopRequireDefault((parcelRequire("3eqDI")));
function $b7a42e48e3392ab4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $b7a42e48e3392ab4$var$_extends() {
    $b7a42e48e3392ab4$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b7a42e48e3392ab4$var$_extends.apply(this, arguments);
}
function $b7a42e48e3392ab4$var$_slicedToArray(arr, i) {
    return $b7a42e48e3392ab4$var$_arrayWithHoles(arr) || $b7a42e48e3392ab4$var$_iterableToArrayLimit(arr, i) || $b7a42e48e3392ab4$var$_unsupportedIterableToArray(arr, i) || $b7a42e48e3392ab4$var$_nonIterableRest();
}
function $b7a42e48e3392ab4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b7a42e48e3392ab4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b7a42e48e3392ab4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b7a42e48e3392ab4$var$_arrayLikeToArray(o, minLen);
}
function $b7a42e48e3392ab4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b7a42e48e3392ab4$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $b7a42e48e3392ab4$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $b7a42e48e3392ab4$var$useIsMounted = function useIsMounted() {
    var _React$useState = $b7a42e48e3392ab4$var$_react["default"].useState(false), _React$useState2 = $b7a42e48e3392ab4$var$_slicedToArray(_React$useState, 2), isMounted = _React$useState2[0], setIsMounted = _React$useState2[1];
    $b7a42e48e3392ab4$var$_react["default"].useEffect(function() {
        return setIsMounted(true);
    }, []);
    return isMounted;
};
var $b7a42e48e3392ab4$var$useA11yDialogInstance = function useA11yDialogInstance() {
    var _React$useState3 = $b7a42e48e3392ab4$var$_react["default"].useState(null), _React$useState4 = $b7a42e48e3392ab4$var$_slicedToArray(_React$useState3, 2), instance = _React$useState4[0], setInstance = _React$useState4[1];
    var container = $b7a42e48e3392ab4$var$_react["default"].useCallback(function(node) {
        if (node !== null) setInstance(new $b7a42e48e3392ab4$var$_a11yDialog["default"](node));
    }, []);
    return [
        instance,
        container
    ];
};
var $b7a42e48e3392ab4$var$useA11yDialog = function useA11yDialog(props) {
    var _useA11yDialogInstanc = $b7a42e48e3392ab4$var$useA11yDialogInstance(), _useA11yDialogInstanc2 = $b7a42e48e3392ab4$var$_slicedToArray(_useA11yDialogInstanc, 2), instance = _useA11yDialogInstanc2[0], ref = _useA11yDialogInstanc2[1];
    var close = $b7a42e48e3392ab4$var$_react["default"].useCallback(function() {
        return instance.hide();
    }, [
        instance
    ]);
    var role = props.role || 'dialog';
    var isAlertDialog = role === 'alertdialog';
    var titleId = props.titleId || props.id + '-title';
    // Destroy the `a11y-dialog` instance when unmounting the component.
    $b7a42e48e3392ab4$var$_react["default"].useEffect(function() {
        return function() {
            if (instance) instance.destroy();
        };
    }, [
        instance
    ]);
    return [
        instance,
        {
            container: {
                id: props.id,
                ref: ref,
                role: role,
                tabIndex: -1,
                'aria-modal': true,
                'aria-hidden': true,
                'aria-labelledby': titleId
            },
            overlay: {
                onClick: isAlertDialog ? undefined : close
            },
            dialog: {
                role: 'document'
            },
            closeButton: {
                type: 'button',
                onClick: close
            },
            // Using a paragraph with accessibility mapping can be useful to work
            // around SEO concerns of having multiple <h1> per page.
            // See: https://twitter.com/goetsu/status/1261253532315004930
            title: {
                role: 'heading',
                'aria-level': 1,
                id: titleId
            }
        }
    ];
};
$b7a42e48e3392ab4$exports.useA11yDialog = $b7a42e48e3392ab4$var$useA11yDialog;
var $b7a42e48e3392ab4$var$A11yDialog = function A11yDialog(props) {
    var isMounted = $b7a42e48e3392ab4$var$useIsMounted();
    var _useA11yDialog = $b7a42e48e3392ab4$var$useA11yDialog(props), _useA11yDialog2 = $b7a42e48e3392ab4$var$_slicedToArray(_useA11yDialog, 2), instance = _useA11yDialog2[0], attributes = _useA11yDialog2[1];
    var dialogRef = props.dialogRef;
    $b7a42e48e3392ab4$var$_react["default"].useEffect(function() {
        if (instance) dialogRef(instance);
        return function() {
            return dialogRef(undefined);
        };
    }, [
        dialogRef,
        instance
    ]);
    if (!isMounted) return null;
    var root = props.dialogRoot ? document.querySelector(props.dialogRoot) : document.body;
    var title = /*#__PURE__*/ $b7a42e48e3392ab4$var$_react["default"].createElement("p", $b7a42e48e3392ab4$var$_extends({}, attributes.title, {
        className: props.classNames.title,
        key: "title"
    }), props.title);
    var button = /*#__PURE__*/ $b7a42e48e3392ab4$var$_react["default"].createElement("button", $b7a42e48e3392ab4$var$_extends({}, attributes.closeButton, {
        className: props.classNames.closeButton,
        "aria-label": props.closeButtonLabel,
        key: "button"
    }), props.closeButtonContent);
    var children = [
        props.closeButtonPosition === 'first' && button,
        title,
        props.children,
        props.closeButtonPosition === 'last' && button
    ].filter(Boolean);
    return /*#__PURE__*/ $b7a42e48e3392ab4$var$_reactDom["default"].createPortal(/*#__PURE__*/ $b7a42e48e3392ab4$var$_react["default"].createElement("div", $b7a42e48e3392ab4$var$_extends({}, attributes.container, {
        className: props.classNames.container
    }), /*#__PURE__*/ $b7a42e48e3392ab4$var$_react["default"].createElement("div", $b7a42e48e3392ab4$var$_extends({}, attributes.overlay, {
        className: props.classNames.overlay
    })), /*#__PURE__*/ $b7a42e48e3392ab4$var$_react["default"].createElement("div", $b7a42e48e3392ab4$var$_extends({}, attributes.dialog, {
        className: props.classNames.dialog
    }), children)), root);
};
$b7a42e48e3392ab4$exports.A11yDialog = $b7a42e48e3392ab4$var$A11yDialog;
$b7a42e48e3392ab4$var$A11yDialog.defaultProps = {
    role: 'dialog',
    closeButtonLabel: 'Close this dialog window',
    closeButtonContent: "\xD7",
    closeButtonPosition: 'first',
    classNames: {},
    dialogRef: function dialogRef() {
        return void 0;
    }
};
$b7a42e48e3392ab4$var$A11yDialog.propTypes = {
    // The `role` attribute of the dialog element, either `dialog` (default) or
    // `alertdialog` to make it a modal (preventing closing on click outside of
    // ESC key).
    role: $b7a42e48e3392ab4$var$_propTypes["default"].oneOf([
        'dialog',
        'alertdialog'
    ]),
    // The HTML `id` attribute of the dialog element, internally used by
    // a11y-dialog to manipulate the dialog.
    id: $b7a42e48e3392ab4$var$_propTypes["default"].string.isRequired,
    // The title of the dialog, mandatory in the document to provide context to
    // assistive technology. Could be hidden (while remaining accessible) with
    // CSS though.
    title: $b7a42e48e3392ab4$var$_propTypes["default"].node.isRequired,
    // A function called when the component has mounted, receiving the instance
    // of A11yDialog so that it can be programmatically accessed later on.
    // E.g.: dialogRef={(dialog) => (this.dialog = dialog)}
    dialogRef: $b7a42e48e3392ab4$var$_propTypes["default"].func,
    // The HTML `id` attribute of the dialog’s title element, used by assistive
    // technologies to provide context and meaning to the dialog window. Falls
    // back to the `${this.props.id}-title` if not provided.
    titleId: $b7a42e48e3392ab4$var$_propTypes["default"].string,
    // The HTML `aria-label` attribute of the close button, used by assistive
    // technologies to provide extra meaning to the usual cross-mark. Defaults
    // to a generic English explanation.
    closeButtonLabel: $b7a42e48e3392ab4$var$_propTypes["default"].string,
    // The string that is the innerHTML of the close button.
    closeButtonContent: $b7a42e48e3392ab4$var$_propTypes["default"].node,
    // Whether the close button should be rendered as first/last children or not at all.
    closeButtonPosition: $b7a42e48e3392ab4$var$_propTypes["default"].oneOf([
        'first',
        'last',
        'none'
    ]),
    // React 16 requires a container for the portal’s content to be rendered
    // into; this needs to be an existing valid DOM node and defaults to the body
    // element.
    dialogRoot: $b7a42e48e3392ab4$var$_propTypes["default"].string,
    // Object of classes for each HTML element of the dialog element.
    // See: https://a11y-dialog.netlify.app/usage/markup
    classNames: $b7a42e48e3392ab4$var$_propTypes["default"].exact({
        container: $b7a42e48e3392ab4$var$_propTypes["default"].string,
        overlay: $b7a42e48e3392ab4$var$_propTypes["default"].string,
        dialog: $b7a42e48e3392ab4$var$_propTypes["default"].string,
        title: $b7a42e48e3392ab4$var$_propTypes["default"].string,
        closeButton: $b7a42e48e3392ab4$var$_propTypes["default"].string
    }),
    // Dialog content.
    // Anything that can be rendered: numbers, strings, elements or an array
    // (or fragment) containing these types.
    children: $b7a42e48e3392ab4$var$_propTypes["default"].node
};





var $h2ArV = parcelRequire("h2ArV");
const $c49d237f6ab4eeaa$export$42a852a2b6b56249 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div', (0, $h2ArV.forwardRef))`
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  opacity: 1;
  visibility: visible;
  transition: opacity .15s, visibility .15s;
  overflow-y: auto;
  padding: 2em 0;

  &[aria-hidden='true'] {
    opacity: 0;
    visibility: hidden;
  }
`;
const $c49d237f6ab4eeaa$export$c6fdb837b070b4ff = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div', (0, $h2ArV.forwardRef))`
  position: fixed;
  inset: 0;
  background: rgba(0 0 0 / .5);

  .dropdown & {
    background: transparent;
  }
`;
const $c49d237f6ab4eeaa$export$7c6e2c02157bb7d2 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div', (0, $h2ArV.forwardRef))`
  margin: auto;
  z-index: 2;
  position: relative;
  background: var(--surface);
  border-radius: 1em;
  width: 500px;
  max-width: calc(100% - 40px);
  box-sizing: border-box;
  box-shadow: 0 2px 5px rgba(0 0 0 / .5);

  transform: translateY(0);
  transition: transform .15s;

  [aria-hidden='true'] & {
    transform: translateY(5px);
  }
  [aria-hidden='true'].dropdown & {
    transform: translateY(-5px);
  }
`;
const $c49d237f6ab4eeaa$export$dca3b0875bd9a954 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  padding: .8rem 1rem 1rem;
`;
const $c49d237f6ab4eeaa$export$a8a3e93435678ff9 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('h2')`
  padding: 1rem 1rem 0;
  margin-block: 0 .2rem;
`;
const $c49d237f6ab4eeaa$export$393edc798c47379d = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('span')`
  display: block;
  padding-inline: 1rem;
  opacity: .5;
  margin-top: 0.5rem;
`;
const $c49d237f6ab4eeaa$export$665d5a662b7213f3 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 1rem;
  padding: 1rem;
  border-top: 1px solid var(--toolbar);
`;



const $a5fe3119a76402fb$var$Modal = ({ id: id = 'dialog', role: role = 'dialog', title: title, description: description, children: children, actions: actions, isOpen: isOpen, onClose: onClose, focusRef: focusRef, dropdown: dropdown = false, containerStyle: containerStyle, width: width, ...props })=>{
    const [instance, attr] = (0, $b7a42e48e3392ab4$exports.useA11yDialog)({
        id: id,
        role: role,
        title: title
    });
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)('common');
    (0, $h2ArV.useEffect)(()=>{
        if (isOpen) instance?.show();
        else instance?.hide();
    }, [
        instance,
        isOpen
    ]);
    (0, $h2ArV.useEffect)(()=>{
        if (!instance) return;
        if (onClose) instance.on('hide', onClose);
        if (focusRef?.current) instance.on('show', ()=>setTimeout(()=>focusRef.current?.focus(), 100));
    }, [
        instance,
        onClose,
        focusRef?.current
    ]);
    return /*#__PURE__*/ (0, $3NhwF.createPortal)(/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $c49d237f6ab4eeaa$export$42a852a2b6b56249), {
        ...attr.container,
        className: dropdown ? 'dropdown' : '',
        style: containerStyle,
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $c49d237f6ab4eeaa$export$c6fdb837b070b4ff), {
                ...attr.overlay
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $c49d237f6ab4eeaa$export$7c6e2c02157bb7d2), {
                ...attr.dialog,
                style: {
                    width: width
                },
                children: [
                    title && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $c49d237f6ab4eeaa$export$a8a3e93435678ff9), {
                        ...attr.title,
                        children: title
                    }),
                    description && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $c49d237f6ab4eeaa$export$393edc798c47379d), {
                        children: description
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $c49d237f6ab4eeaa$export$dca3b0875bd9a954), {
                        ...props,
                        children: children
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $c49d237f6ab4eeaa$export$665d5a662b7213f3), {
                        children: actions ?? /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                            ...attr.closeButton,
                            secondary: true,
                            children: t('close')
                        })
                    })
                ]
            })
        ]
    }), document.body);
};
var $a5fe3119a76402fb$export$2e2bcd8739ae039 = $a5fe3119a76402fb$var$Modal;







const $9800c65c5d2748a1$var$InputTransitionGroup = ()=>{
    const inputRef = (0, $h2ArV.useRef)();
    const [transitionListRef, setTransitionListRef] = (0, $h2ArV.useState)();
    // selectIndex === -1 is the new transition field, others is the index
    const [selectedIndex, setSelectedIndex] = (0, $h2ArV.useState)(-1);
    const [fromState, setFromState] = (0, $h2ArV.useState)();
    const [toState, setToState] = (0, $h2ArV.useState)();
    const [transitionsList, setTransitionsList] = (0, $h2ArV.useState)();
    const [readList, setReadList] = (0, $h2ArV.useState)();
    /** Pop/Write */ const [col2List, setCol2List] = (0, $h2ArV.useState)();
    /** Push/Direction */ const [col3List, setCol3List] = (0, $h2ArV.useState)();
    const [fromName, setFromName] = (0, $h2ArV.useState)();
    const [toName, setToName] = (0, $h2ArV.useState)();
    const [modalOpen, setModalOpen] = (0, $h2ArV.useState)(false);
    const [idList, setIdList] = (0, $h2ArV.useState)([]);
    // For the new transition
    const [readValue, setReadValue] = (0, $h2ArV.useState)('');
    const [popValue, setPopValue] = (0, $h2ArV.useState)('');
    const [pushValue, setPushValue] = (0, $h2ArV.useState)('');
    const [writeValue, setWriteValue] = (0, $h2ArV.useState)('');
    const [dirValue, setDirValue] = (0, $h2ArV.useState)('R');
    const statePrefix = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project.config.statePrefix);
    const projectType = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project.config.type);
    const orOperator = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project.config.orOperator) ?? '|';
    const editTransition = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.editTransition);
    const createTransition = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.createTransition);
    const removeTransitions = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.removeTransitions);
    const commit = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.commit);
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)('common');
    // Get data from event dispatch
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('editTransitionGroup', ({ detail: { ctx: ctx } })=>{
        const { transitions: transitions, states: states } = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039).getState()?.project ?? {};
        // Get one transition from the set to get the from and to state Ids
        const scopedTransition = transitions.find((t)=>ctx === t.id);
        // Get state connection information for the modal
        const scopeFrom = scopedTransition.from;
        const scopeTo = scopedTransition.to;
        const fName = states.find((s)=>s.id === scopeFrom).name ?? '' + statePrefix + scopeFrom;
        const tName = states.find((s)=>s.id === scopeTo).name ?? '' + statePrefix + scopeTo;
        setFromState(scopeFrom);
        setToState(scopeTo);
        setFromName(fName);
        setToName(tName);
        // Update ID list to include *ALL* transitions on this edge, including unselected
        // This will run the side effect of re-retrieving the updated id list when done
        const allIdList = transitions.filter((t)=>t.from === scopeFrom && t.to === scopeTo).map((t)=>t.id);
        setIdList([
            ...allIdList
        ]);
        setModalOpen(true);
    }, []);
    const retrieveTransitions = (0, $h2ArV.useCallback)(()=>{
        const { transitions: transitions } = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039).getState()?.project ?? {};
        const transitionsScope = transitions.filter((t)=>idList.includes(t.id));
        setTransitionsList([
            ...transitionsScope
        ]);
        setReadList(transitionsScope.map((t)=>(0, $7431f94c7ac0c9a7$export$8b9d5f9a071daa33)(t.read, orOperator)));
        switch(projectType){
            case 'PDA':
                (0, $be180ebd7a95f287$export$804de46662e4ac95)(transitionsScope);
                setCol2List(transitionsScope.map((t)=>t.pop));
                setCol3List(transitionsScope.map((t)=>t.push));
                break;
            case 'TM':
                (0, $be180ebd7a95f287$export$804de46662e4ac95)(transitionsScope);
                setCol2List(transitionsScope.map((t)=>t.write));
                setCol3List(transitionsScope.map((t)=>t.direction));
                break;
        }
    }, [
        idList,
        projectType
    ]);
    (0, $h2ArV.useEffect)(()=>{
        setTransitionListRef(Array.from({
            length: transitionsList?.length ?? 0
        }, ()=>/*#__PURE__*/ (0, $h2ArV.createRef)()));
    }, [
        transitionsList
    ]);
    // Re-retrieve transitions when the id list changes (i.e. on new transition)
    (0, $h2ArV.useEffect)(()=>{
        retrieveTransitions();
    }, [
        idList
    ]);
    const resetInputFields = ()=>{
        setReadValue('');
        setPopValue('');
        setPushValue('');
        setWriteValue('');
        setDirValue('R');
    };
    const createNewTransition = ()=>{
        const newId = createTransition({
            from: fromState,
            to: toState
        });
        setIdList([
            ...idList,
            newId
        ]);
        return newId;
    };
    const deleteTransition = (index)=>{
        const delId = idList[index];
        removeTransitions([
            delId
        ]);
        setIdList(idList.filter((_, i)=>i !== index));
    };
    const handleIndexDown = ()=>{
        const nextIndex = selectedIndex < 0 ? -1 : selectedIndex - 1;
        const nextInputRef = nextIndex >= 0 ? transitionListRef[nextIndex] : inputRef;
        const ro = nextInputRef;
        setSelectedIndex(nextIndex);
        ro?.current.focus();
    };
    const handleIndexUp = ()=>{
        if (selectedIndex < transitionListRef?.length - 1) {
            const prevIndex = selectedIndex === transitionListRef?.length - 1 ? transitionListRef?.length - 1 : selectedIndex + 1;
            const prevInputRef = transitionListRef[prevIndex];
            const ro = prevInputRef;
            setSelectedIndex(prevIndex);
            ro?.current.focus();
        }
    };
    const handleKeyUp = (e)=>{
        switch(e.key){
            case 'Enter':
                if (selectedIndex === -1) saveNewTransition();
                else handleIndexDown();
                break;
            case 'ArrowDown':
                handleIndexDown();
                break;
            case 'ArrowUp':
                handleIndexUp();
                break;
        }
    };
    /** Helper function to simplify slicing lists.
   *  Slices a new copy of the the list and sets it using the setter function
   */ const sliceListState = (state, setter, v, i)=>{
        setter([
            ...state.slice(0, i),
            v,
            ...state.slice(i + 1)
        ]);
    };
    /**
   * Functions for FSAs
   */ const saveFSATransition = ({ id: id, read: read })=>{
        editTransition({
            id: id,
            read: read
        });
        retrieveTransitions();
    };
    const saveNewFSATransition = ()=>{
        const newId = createNewTransition();
        editTransition({
            id: newId,
            read: (0, $7431f94c7ac0c9a7$export$193046f9d1fa1ed1)(readValue, orOperator)
        });
        resetInputFields();
    };
    const blankFSAInput = ()=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $804ba8bb480a35bd$export$fb9f58ebe9de6283), {
            children: [
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                    ref: inputRef,
                    value: readValue,
                    onChange: (e)=>setReadValue(e.target.value),
                    onClick: ()=>setSelectedIndex(-1),
                    onKeyUp: handleKeyUp,
                    onFocus: (e)=>{
                        e.target.select();
                        setSelectedIndex(-1);
                    },
                    placeholder: t('input_dialog.new_transition')
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $804ba8bb480a35bd$export$8b7b7cdfb85d78c5), {
                    onClick: saveNewTransition,
                    tabIndex: -1,
                    children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e2fc0b2d396fb6da$export$2e2bcd8739ae039), {
                        size: "18px"
                    })
                })
            ]
        });
    const fsaInputField = (t, i)=>{
        return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $804ba8bb480a35bd$export$fb9f58ebe9de6283), {
            children: [
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                    ref: transitionListRef[i] ?? null,
                    value: readList[i],
                    onChange: (e)=>{
                        sliceListState(readList, setReadList, e.target.value, i);
                    },
                    onClick: ()=>setSelectedIndex(i),
                    onKeyUp: handleKeyUp,
                    onFocus: (e)=>{
                        e.target.select();
                        setSelectedIndex(i);
                    },
                    onBlur: ()=>saveFSATransition({
                            id: t.id,
                            read: (0, $7431f94c7ac0c9a7$export$193046f9d1fa1ed1)(readList[i], orOperator)
                        }),
                    placeholder: "\u03BB"
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $804ba8bb480a35bd$export$8b7b7cdfb85d78c5), {
                    onClick: ()=>deleteTransition(i),
                    tabIndex: -1,
                    children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $127384410c27818a$export$2e2bcd8739ae039), {
                        size: "18px"
                    })
                })
            ]
        }, i);
    };
    /**
   * Functions for PDAs
   */ const savePDATransition = ({ id: id, read: read, pop: pop, push: push })=>{
        editTransition({
            id: id,
            read: read,
            pop: pop,
            push: push
        });
        retrieveTransitions();
    };
    const saveNewPDATransition = ()=>{
        const newId = createNewTransition();
        editTransition({
            id: newId,
            read: (0, $7431f94c7ac0c9a7$export$193046f9d1fa1ed1)(readValue, orOperator),
            pop: popValue,
            push: pushValue
        });
        resetInputFields();
    };
    const blankPDAInput = ()=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $804ba8bb480a35bd$export$fb9f58ebe9de6283), {
            children: [
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5b7006d7aefff66f$export$bb1f8a15d1aa29db), {
                    children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                        ref: inputRef,
                        value: readValue,
                        onChange: (e)=>setReadValue(e.target.value),
                        onClick: ()=>setSelectedIndex(-1),
                        onKeyUp: handleKeyUp,
                        onFocus: (e)=>{
                            e.target.select();
                            setSelectedIndex(-1);
                        },
                        placeholder: t('input_dialog.read')
                    })
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5b7006d7aefff66f$export$99fec8f892bdba25), {
                    children: ","
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5b7006d7aefff66f$export$bb1f8a15d1aa29db), {
                    children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                        value: popValue,
                        onChange: (e)=>setPopValue(e.target.value),
                        onClick: ()=>setSelectedIndex(-1),
                        onKeyUp: handleKeyUp,
                        onFocus: (e)=>{
                            e.target.select();
                            setSelectedIndex(-1);
                        },
                        placeholder: t('input_dialog.pop')
                    })
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5b7006d7aefff66f$export$99fec8f892bdba25), {
                    children: ";"
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5b7006d7aefff66f$export$bb1f8a15d1aa29db), {
                    children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                        value: pushValue,
                        onChange: (e)=>setPushValue(e.target.value),
                        onClick: ()=>setSelectedIndex(-1),
                        onKeyUp: handleKeyUp,
                        onFocus: (e)=>{
                            e.target.select();
                            setSelectedIndex(-1);
                        },
                        placeholder: t('input_dialog.push')
                    })
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $804ba8bb480a35bd$export$8b7b7cdfb85d78c5), {
                    onClick: saveNewTransition,
                    tabIndex: -1,
                    children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e2fc0b2d396fb6da$export$2e2bcd8739ae039), {
                        size: "18px"
                    })
                })
            ]
        });
    const pdaInputFields = (t, i)=>{
        return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $804ba8bb480a35bd$export$fb9f58ebe9de6283), {
            children: [
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5b7006d7aefff66f$export$bb1f8a15d1aa29db), {
                    children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                        ref: transitionListRef[i] ?? null,
                        value: readList[i],
                        onChange: (e)=>{
                            sliceListState(readList, setReadList, e.target.value, i);
                        },
                        onClick: ()=>setSelectedIndex(i),
                        onKeyUp: handleKeyUp,
                        onFocus: (e)=>{
                            e.target.select();
                            setSelectedIndex(i);
                        },
                        onBlur: ()=>savePDATransition({
                                id: t.id,
                                read: (0, $7431f94c7ac0c9a7$export$193046f9d1fa1ed1)(readList[i], orOperator),
                                pop: t.pop,
                                push: t.push
                            }),
                        placeholder: "\u03BB"
                    })
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5b7006d7aefff66f$export$99fec8f892bdba25), {
                    children: ","
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5b7006d7aefff66f$export$bb1f8a15d1aa29db), {
                    children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                        value: col2List[i],
                        onChange: (e)=>{
                            sliceListState(col2List, setCol2List, e.target.value, i);
                        },
                        onClick: ()=>setSelectedIndex(i),
                        onKeyUp: handleKeyUp,
                        onFocus: (e)=>{
                            e.target.select();
                            setSelectedIndex(i);
                        },
                        onBlur: ()=>savePDATransition({
                                id: t.id,
                                read: t.read,
                                pop: col2List[i],
                                push: t.push
                            }),
                        placeholder: "\u03BB"
                    })
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5b7006d7aefff66f$export$99fec8f892bdba25), {
                    children: ";"
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5b7006d7aefff66f$export$bb1f8a15d1aa29db), {
                    children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                        value: col3List[i],
                        onChange: (e)=>{
                            sliceListState(col3List, setCol3List, e.target.value, i);
                        },
                        onClick: ()=>setSelectedIndex(i),
                        onKeyUp: handleKeyUp,
                        onFocus: (e)=>{
                            e.target.select();
                            setSelectedIndex(i);
                        },
                        onBlur: ()=>savePDATransition({
                                id: t.id,
                                read: t.read,
                                pop: t.pop,
                                push: col3List[i]
                            }),
                        placeholder: "\u03BB"
                    })
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $804ba8bb480a35bd$export$8b7b7cdfb85d78c5), {
                    onClick: ()=>deleteTransition(i),
                    tabIndex: -1,
                    children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $127384410c27818a$export$2e2bcd8739ae039), {
                        size: "18px"
                    })
                })
            ]
        }, i);
    };
    /**
   * Functions for TMs
   */ const saveTMTransition = ({ id: id, read: read, write: write, direction: direction })=>{
        editTransition({
            id: id,
            read: read,
            write: write,
            direction: direction || 'R'
        });
        retrieveTransitions();
    };
    const saveNewTMTransition = ()=>{
        const newId = createNewTransition();
        editTransition({
            id: newId,
            read: (0, $7431f94c7ac0c9a7$export$193046f9d1fa1ed1)(readValue, orOperator),
            write: writeValue,
            direction: dirValue || 'R'
        });
        resetInputFields();
    };
    /** TMs operate with the assumption of writing one character */ const tmWriteValidate = (e)=>{
        const input = e.target.value.toString();
        return input[input.length - 1] ?? '';
    };
    const blankTMInput = ()=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $804ba8bb480a35bd$export$fb9f58ebe9de6283), {
            children: [
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5b7006d7aefff66f$export$bb1f8a15d1aa29db), {
                    children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                        ref: inputRef,
                        value: readValue,
                        onChange: (e)=>{
                            setReadValue(e.target.value);
                        },
                        onClick: ()=>setSelectedIndex(-1),
                        onKeyUp: handleKeyUp,
                        onFocus: (e)=>{
                            e.target.select();
                            setSelectedIndex(-1);
                        },
                        placeholder: t('input_dialog.read')
                    })
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5b7006d7aefff66f$export$99fec8f892bdba25), {
                    children: ","
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5b7006d7aefff66f$export$bb1f8a15d1aa29db), {
                    children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                        value: writeValue,
                        onChange: (e)=>{
                            const w = tmWriteValidate(e);
                            setWriteValue(w);
                        },
                        onClick: ()=>setSelectedIndex(-1),
                        onKeyUp: handleKeyUp,
                        onFocus: (e)=>{
                            e.target.select();
                            setSelectedIndex(-1);
                        },
                        placeholder: t('input_dialog.write')
                    })
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5b7006d7aefff66f$export$99fec8f892bdba25), {
                    children: ";"
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5b7006d7aefff66f$export$bb1f8a15d1aa29db), {
                    children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $66e54ad82e4a6e2b$export$cec9f334da77a853), {
                        direction: dirValue,
                        setDirection: (e)=>{
                            setDirValue(e);
                            setSelectedIndex(-1);
                        },
                        handleSave: handleKeyUp,
                        name: 'new-TM-transition'
                    })
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5b7006d7aefff66f$export$bb1f8a15d1aa29db), {
                    children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $804ba8bb480a35bd$export$6898c8c6ae2303dc), {
                        onClick: saveNewTransition,
                        tabIndex: -1,
                        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e2fc0b2d396fb6da$export$2e2bcd8739ae039), {
                            size: "18px"
                        })
                    })
                })
            ]
        });
    const tmInputFields = (t, i)=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $804ba8bb480a35bd$export$fb9f58ebe9de6283), {
            children: [
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5b7006d7aefff66f$export$bb1f8a15d1aa29db), {
                    children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                        ref: transitionListRef[i] ?? null,
                        value: readList[i],
                        onChange: (e)=>{
                            sliceListState(readList, setReadList, e.target.value, i);
                        },
                        onClick: ()=>setSelectedIndex(i),
                        onKeyUp: handleKeyUp,
                        onFocus: (e)=>{
                            e.target.select();
                            setSelectedIndex(i);
                        },
                        onBlur: ()=>saveTMTransition({
                                id: t.id,
                                read: (0, $7431f94c7ac0c9a7$export$193046f9d1fa1ed1)(readList[i], orOperator),
                                write: t.write,
                                direction: t.direction
                            }),
                        placeholder: "\u03BB"
                    })
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5b7006d7aefff66f$export$99fec8f892bdba25), {
                    children: ","
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5b7006d7aefff66f$export$bb1f8a15d1aa29db), {
                    children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                        value: col2List[i],
                        onChange: (e)=>{
                            sliceListState(col2List, setCol2List, tmWriteValidate(e), i);
                        },
                        onClick: ()=>setSelectedIndex(i),
                        onKeyUp: handleKeyUp,
                        onFocus: (e)=>{
                            e.target.select();
                            setSelectedIndex(i);
                        },
                        onBlur: ()=>saveTMTransition({
                                id: t.id,
                                read: t.read,
                                write: col2List[i],
                                direction: t.direction
                            }),
                        placeholder: "\u03BB"
                    })
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5b7006d7aefff66f$export$99fec8f892bdba25), {
                    children: ";"
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5b7006d7aefff66f$export$bb1f8a15d1aa29db), {
                    children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $66e54ad82e4a6e2b$export$cec9f334da77a853), {
                        direction: t.direction,
                        setDirection: (newDirection)=>{
                            saveTMTransition({
                                id: t.id,
                                read: t.read,
                                write: t.write,
                                direction: newDirection
                            });
                            setSelectedIndex(i);
                        },
                        name: `transition-group-${t.id}`,
                        handleSave: handleKeyUp
                    })
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5b7006d7aefff66f$export$bb1f8a15d1aa29db), {
                    children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $804ba8bb480a35bd$export$6898c8c6ae2303dc), {
                        onClick: ()=>deleteTransition(i),
                        tabIndex: -1,
                        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $127384410c27818a$export$2e2bcd8739ae039), {
                            size: "18px"
                        })
                    })
                })
            ]
        }, i);
    const saveNewTransition = ()=>{
        switch(projectType){
            case 'FSA':
                saveNewFSATransition();
                break;
            case 'PDA':
                saveNewPDATransition();
                break;
            case 'TM':
                saveNewTMTransition();
                break;
        }
        inputRef.current.focus();
    };
    /**
   * Modal contents
   */ if (!transitionsList) return null;
    const contents = ()=>{
        switch(projectType){
            case 'FSA':
                (0, $be180ebd7a95f287$export$804de46662e4ac95)(transitionsList);
                return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
                    children: [
                        transitionsList.map((t, i)=>fsaInputField(t, i)).reverse(),
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("hr", {}),
                        t('input_dialog.add_new_transition'),
                        blankFSAInput()
                    ]
                });
            case 'PDA':
                (0, $be180ebd7a95f287$export$804de46662e4ac95)(transitionsList);
                return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
                    children: [
                        transitionsList.map((t, i)=>pdaInputFields(t, i)).reverse(),
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("hr", {}),
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $5b7006d7aefff66f$export$a8a3e93435678ff9), {
                            children: [
                                t('input_dialog.add_new_transition'),
                                "n?"
                            ]
                        }),
                        blankPDAInput()
                    ]
                });
            case 'TM':
                (0, $be180ebd7a95f287$export$804de46662e4ac95)(transitionsList);
                return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
                    children: [
                        transitionsList.map((t, i)=>tmInputFields(t, i)).reverse(),
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("hr", {}),
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5b7006d7aefff66f$export$a8a3e93435678ff9), {
                            children: t('input_dialog.add_new_transition')
                        }),
                        blankTMInput()
                    ]
                });
        }
    };
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $a5fe3119a76402fb$export$2e2bcd8739ae039), {
        title: t('input_dialog.edge_editor'),
        description: t('input_dialog.editing_transition', {
            state1: fromName,
            state2: toName
        }),
        isOpen: modalOpen,
        onClose: ()=>{
            commit();
            setModalOpen(false);
            resetInputFields();
        },
        actions: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
            onClick: ()=>{
                commit();
                setModalOpen(false);
                resetInputFields();
            },
            children: t('done')
        }),
        children: contents()
    });
};
var $9800c65c5d2748a1$export$2e2bcd8739ae039 = $9800c65c5d2748a1$var$InputTransitionGroup;




var $h2ArV = parcelRequire("h2ArV");



var $8K1s2 = parcelRequire("8K1s2");

const $a9e8924451a9767d$export$59109e4b2bdb8ae5 = (transitions, states)=>{
    const groupedTransitions = Object.values((0, (/*@__PURE__*/$parcel$interopDefault($8K1s2)))(transitions, (t)=>[
            t.from,
            t.to
        ].sort((a, b)=>b - a)));
    return groupedTransitions.map((transitions)=>transitions.map((t)=>(0, $3f368c329a5889b3$export$883a7ac0705d77b5)(t, states)) // Resolve location of transition states
        // Sort by direction. If the x coordinates are the same then compare by Y axis
        .sort((t1, t2)=>(t2.from.x === t1.from.x ? t2.from.y < t1.from.y : t2.from.x < t1.from.x) ? 1 : -1));
};




var $h2ArV = parcelRequire("h2ArV");



const $522e2f3ea526d79b$export$bd67daaabffb2081 = {
    color: 'var(--comment-text)',
    background: 'var(--grid-bg)',
    padding: '.8em 1em',
    borderRadius: '.5rem',
    borderWidth: '2.5px',
    borderStyle: 'solid',
    borderColor: 'var(--input-border)',
    userSelect: 'none',
    width: 'max-content',
    maxWidth: '255px',
    boxSizing: 'border-box'
};
const $522e2f3ea526d79b$export$40f5935f13c15834 = (0, $b1e4a7d525070c66$export$dbf350e5966cf602)`
  border-color: var(--primary) !important;
`;


const $0a5e0a245d54ced4$var$CommentRect = ({ id: id, x: x, y: y, text: text })=>{
    const containerRef = (0, $h2ArV.useRef)();
    const [size, setSize] = (0, $h2ArV.useState)({
        height: 30,
        width: 30
    });
    const selectedComments = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.selectedComments);
    const selected = selectedComments.includes(id);
    (0, $h2ArV.useEffect)(()=>{
        if (containerRef.current) {
            const bounds = containerRef.current.getBoundingClientRect();
            const { scale: scale } = (0, $2c8de4ab9c0d9b91$export$2e2bcd8739ae039).getState();
            setSize({
                height: bounds.height * scale,
                width: bounds.width * scale
            });
        }
    }, [
        containerRef?.current,
        text,
        x,
        y
    ]);
    const dispatchMouseEvent = (name)=>(e)=>(0, $ca2884de04f532f3$export$fb20829f6af70575)(name, {
                originalEvent: e,
                comment: {
                    id: id,
                    text: text
                },
                ctx: id
            });
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("foreignObject", {
        x: x,
        y: y,
        ...size,
        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("div", {
            ref: containerRef,
            onMouseDown: dispatchMouseEvent('comment:mousedown'),
            onMouseUp: dispatchMouseEvent('comment:mouseup'),
            onDoubleClick: dispatchMouseEvent('comment:dblclick'),
            style: (0, $522e2f3ea526d79b$export$bd67daaabffb2081),
            className: selected && (0, $522e2f3ea526d79b$export$40f5935f13c15834) || undefined,
            children: text
        })
    });
};
var $0a5e0a245d54ced4$export$2e2bcd8739ae039 = $0a5e0a245d54ced4$var$CommentRect;




var $h2ArV = parcelRequire("h2ArV");




const $3f5dc26abc87c726$export$25ed228b88142187 = {
    fill: 'var(--state-bg)',
    stroke: 'var(--stroke)'
};
const $3f5dc26abc87c726$export$74fd02be9aa66ffe = {
    filter: 'drop-shadow(0px 0px 15px var(--primary)) drop-shadow(0px 0px 20px var(--primary))'
};
const $3f5dc26abc87c726$export$dc14748462a7a4a = (0, $b1e4a7d525070c66$export$dbf350e5966cf602)`
  fill: var(--state-bg-selected) !important;
  stroke: var(--primary) !important;
  stroke-width: 2.5px !important;
`;
const $3f5dc26abc87c726$export$6a54c24d15b0f6ba = {
    userSelect: 'none',
    fill: 'var(--stroke)'
};


const $5c6c2a9ebe102168$var$FINAL_OUTLINE_OFFSET = 5;
// Need to remove `id` or else it will be never type
const $5c6c2a9ebe102168$var$StateCircle = ({ id: id, name: name, label: label, isFinal: isFinal, cx: cx, cy: cy, selected: selected, stepped: stepped, ...props })=>{
    const statePrefix = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project?.config?.statePrefix) ?? 'q';
    const displayName = name || `${statePrefix}${id}`;
    const labelRef = (0, $h2ArV.useRef)();
    const [labelBox, setLabelBox] = (0, $h2ArV.useState)({
        x: 0,
        y: 0,
        width: 0,
        height: 0
    });
    (0, $h2ArV.useEffect)(()=>{
        const { x: x, y: y, width: width, height: height } = labelRef.current?.getBBox() ?? {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        setLabelBox({
            x: x,
            y: y - 3,
            width: width + 14,
            height: height + 6
        });
    }, [
        labelRef.current,
        label
    ]);
    // TODO: use Callback
    const handleEvent = (eventName)=>(e)=>{
            (0, $ca2884de04f532f3$export$fb20829f6af70575)(eventName, {
                originalEvent: e,
                state: {
                    id: id,
                    name: name,
                    cx: cx,
                    cy: cy
                },
                ctx: id
            });
        };
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("g", {
        transform: `translate(${cx}, ${cy})`,
        onMouseDown: handleEvent('state:mousedown'),
        onMouseUp: handleEvent('state:mouseup'),
        onDoubleClick: handleEvent('state:dblclick'),
        ...props,
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                r: (0, $1812551efebcf5e5$export$d12d81d9c5207ce8),
                style: {
                    ...(0, $3f5dc26abc87c726$export$25ed228b88142187),
                    ...stepped ? (0, $3f5dc26abc87c726$export$74fd02be9aa66ffe) : {}
                },
                className: selected && (0, $3f5dc26abc87c726$export$dc14748462a7a4a) || undefined
            }),
            isFinal && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                r: (0, $1812551efebcf5e5$export$d12d81d9c5207ce8) - $5c6c2a9ebe102168$var$FINAL_OUTLINE_OFFSET,
                style: (0, $3f5dc26abc87c726$export$25ed228b88142187),
                className: selected && (0, $3f5dc26abc87c726$export$dc14748462a7a4a) || undefined
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("text", {
                textAnchor: "middle",
                alignmentBaseline: "central",
                style: (0, $3f5dc26abc87c726$export$6a54c24d15b0f6ba),
                children: displayName
            }),
            label && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("g", {
                transform: `translate(0, ${(0, $1812551efebcf5e5$export$d12d81d9c5207ce8)})`,
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("rect", {
                        x: -(labelBox?.width ?? 0) / 2,
                        y: labelBox?.y,
                        width: labelBox?.width,
                        height: labelBox?.height,
                        style: (0, $3f5dc26abc87c726$export$25ed228b88142187),
                        className: selected && (0, $3f5dc26abc87c726$export$dc14748462a7a4a) || undefined,
                        ry: "5",
                        rx: "5"
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("text", {
                        ref: labelRef,
                        textAnchor: "middle",
                        alignmentBaseline: "central",
                        style: (0, $3f5dc26abc87c726$export$6a54c24d15b0f6ba),
                        children: label
                    })
                ]
            })
        ]
    });
};
$5c6c2a9ebe102168$var$StateCircle.Ghost = ({ cx: cx, cy: cy })=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
        cx: cx,
        cy: cy,
        r: (0, $1812551efebcf5e5$export$d12d81d9c5207ce8),
        style: {
            ...(0, $3f5dc26abc87c726$export$25ed228b88142187),
            opacity: 0.3,
            pointerEvents: 'none'
        }
    });
var $5c6c2a9ebe102168$export$2e2bcd8739ae039 = $5c6c2a9ebe102168$var$StateCircle;




var $h2ArV = parcelRequire("h2ArV");



var $h2ArV = parcelRequire("h2ArV");



const $965893e6ea4aa97a$export$cf0f437bd8226f7d = {
    fill: 'var(--toolbar)'
};
const $965893e6ea4aa97a$export$968b5100e81e814c = {
    fill: 'transparent'
};


const $3ba0b2df39f44c89$var$ChangeTransitionHandlebars = ({ edges: edges, selectedTransitions: selectedTransitions, isReflexive: isReflexive, isInvisible: isInvisible = false, ...props })=>{
    const [isSameEdge, setIsSameEdge] = (0, $h2ArV.useState)(true);
    const [from, setFrom] = (0, $h2ArV.useState)();
    const [to, setTo] = (0, $h2ArV.useState)();
    const { transitions: transitions } = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039).getState()?.project ?? {};
    const calcEdgeUnitVector = (t)=>{
        const vec = [
            t.end.x - t.start.x,
            t.end.y - t.start.y
        ];
        const mag = Math.sqrt(vec[0] ** 2 + vec[1] ** 2);
        return [
            vec[0] / mag,
            vec[1] / mag
        ];
    };
    (0, $h2ArV.useEffect)(()=>{
        const transitionsScope = transitions.filter((t)=>selectedTransitions.includes(t.id));
        setIsSameEdge(transitionsScope.every((t)=>t.from === transitionsScope[0].from && t.to === transitionsScope[0].to));
        setFrom(transitionsScope[0].from);
        setTo(transitionsScope[0].to);
    }, [
        transitions,
        selectedTransitions
    ]);
    const handleStartMouseDown = (e)=>{
        if (isSameEdge) (0, $ca2884de04f532f3$export$fb20829f6af70575)('transitionhandle:mousedown', {
            originalEvent: e,
            transitionInfo: {
                transitionIds: selectedTransitions,
                fromId: from,
                toId: to,
                isMovingStart: true,
                otherPosition: t.end
            }
        });
    };
    const handleEndMouseDown = (e)=>{
        if (isSameEdge) (0, $ca2884de04f532f3$export$fb20829f6af70575)('transitionhandle:mousedown', {
            originalEvent: e,
            transitionInfo: {
                transitionIds: selectedTransitions,
                fromId: from,
                toId: to,
                isMovingStart: false,
                otherPosition: t.start
            }
        });
    };
    // Middle-ise co-ordinates
    const t = (0, $h2ArV.useMemo)(()=>{
        return {
            start: {
                x: edges[0].x,
                y: edges[0].y
            },
            end: {
                x: edges[1].x,
                y: edges[1].y
            }
        };
    }, [
        edges
    ]);
    const tc = (0, $h2ArV.useMemo)(()=>{
        const m = 4;
        if (isReflexive) return {
            start: {
                x: t.start.x,
                y: t.start.y - m
            },
            end: {
                x: t.end.x,
                y: t.end.y - m
            }
        };
        else {
            const uv = calcEdgeUnitVector(t);
            return {
                start: {
                    x: t.start.x + m * uv[0],
                    y: t.start.y + m * uv[1]
                },
                end: {
                    x: t.end.x - m * uv[0],
                    y: t.end.y - m * uv[1]
                }
            };
        }
    }, [
        t
    ]);
    if (isInvisible) return isSameEdge && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("g", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                transform: `translate(${tc.start.x}, ${tc.start.y})`,
                r: 10,
                style: (0, $965893e6ea4aa97a$export$968b5100e81e814c),
                onMouseDown: handleStartMouseDown
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                transform: `translate(${tc.end.x}, ${tc.end.y})`,
                r: 10,
                style: (0, $965893e6ea4aa97a$export$968b5100e81e814c),
                onMouseDown: handleEndMouseDown
            })
        ]
    });
    return isSameEdge && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("g", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                transform: `translate(${tc.start.x}, ${tc.start.y})`,
                r: (0, $1812551efebcf5e5$export$2b5cd01258598218),
                style: (0, $965893e6ea4aa97a$export$cf0f437bd8226f7d)
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                transform: `translate(${tc.end.x}, ${tc.end.y})`,
                r: (0, $1812551efebcf5e5$export$2b5cd01258598218),
                style: (0, $965893e6ea4aa97a$export$cf0f437bd8226f7d)
            })
        ]
    });
};
var $3ba0b2df39f44c89$export$2e2bcd8739ae039 = $3ba0b2df39f44c89$var$ChangeTransitionHandlebars;



const $9883b7d698f201b1$export$e8a6ebf5a4cd9360 = {
    stroke: 'var(--stroke)',
    fill: 'none'
};
const $9883b7d698f201b1$export$96158a09d78a3fd = {
    stroke: 'var(--stroke)',
    fill: 'none',
    opacity: 0.3
};
const $9883b7d698f201b1$export$cb22dd8235b61d1f = (0, $b1e4a7d525070c66$export$dbf350e5966cf602)`
  stroke: var(--primary) !important;
`;





var $h2ArV = parcelRequire("h2ArV");

const $ad21efdb48dda924$export$f344bc39311a0bc6 = /*#__PURE__*/ (0, $h2ArV.createContext)({
    standardArrowHead: 'marker',
    selectedArrowHead: 'marker',
    lineArrowHead: 'marker'
});
const $ad21efdb48dda924$var$MarkerProvider = ({ children: children })=>{
    // Define marker ids
    const standardArrowHead = 'standard-arrow-head';
    const selectedArrowHead = 'selected-arrow-head';
    const lineArrowHead = 'line-arrow-head';
    // Calculate marker bounding box
    const markerWidth = 30;
    const markerHeight = 30;
    const markerRefX = markerWidth - 1;
    const markerRefY = markerHeight / 2;
    // Calculate arrow verts
    const arrowStart = `M${markerRefX}, ${markerRefY}`;
    const arrowTopLeft = `L${markerRefX - (0, $1812551efebcf5e5$export$2d452e0d1851225b) * Math.cos((0, $1812551efebcf5e5$export$99ef5412ccf693f2))} ${markerRefY - (0, $1812551efebcf5e5$export$2d452e0d1851225b) * Math.sin((0, $1812551efebcf5e5$export$99ef5412ccf693f2))}`;
    const arrowBottomLeft = `L${markerRefX - (0, $1812551efebcf5e5$export$2d452e0d1851225b) * Math.cos(-(0, $1812551efebcf5e5$export$99ef5412ccf693f2))} ${markerRefY - (0, $1812551efebcf5e5$export$2d452e0d1851225b) * Math.sin(-(0, $1812551efebcf5e5$export$99ef5412ccf693f2))}`;
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("marker", {
                        id: standardArrowHead,
                        markerWidth: markerWidth,
                        markerHeight: markerHeight,
                        refX: markerRefX,
                        refY: markerRefY,
                        orient: "auto",
                        markerUnits: "strokeWidth",
                        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                            d: `${arrowStart} ${arrowTopLeft} ${arrowBottomLeft} z`,
                            fill: "var(--stroke)"
                        })
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("marker", {
                        id: selectedArrowHead,
                        markerWidth: markerWidth,
                        markerHeight: markerHeight,
                        refX: markerRefX,
                        refY: markerRefY,
                        orient: "auto",
                        markerUnits: "strokeWidth",
                        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                            d: `${arrowStart} ${arrowTopLeft} ${arrowBottomLeft} z`,
                            fill: "var(--primary)"
                        })
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("marker", {
                        id: lineArrowHead,
                        markerWidth: markerWidth,
                        markerHeight: markerHeight,
                        refX: markerRefX,
                        refY: markerRefY,
                        orient: "auto",
                        markerUnits: "strokeWidth",
                        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                            d: `${arrowStart} ${arrowTopLeft} ${arrowStart} ${arrowBottomLeft}`,
                            stroke: "var(--stroke)"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)($ad21efdb48dda924$export$f344bc39311a0bc6.Provider, {
                value: {
                    standardArrowHead: standardArrowHead,
                    selectedArrowHead: selectedArrowHead,
                    lineArrowHead: lineArrowHead
                },
                children: children
            })
        ]
    });
};
var $ad21efdb48dda924$export$2e2bcd8739ae039 = $ad21efdb48dda924$var$MarkerProvider;










/**
 * Creates the transition text depending on the project type. Uses the following notation
 * - TM:  read,write;direction
 * - PDA: read,pop;direction
 * - FSA: read
 */ const $682d8c1f00111eb9$var$makeTransitionText = (type, orOperator, t)=>{
    // Since the type can't be narrowed, we need to narrow ourselves inside the blocks
    switch(type){
        case 'TM':
            (0, $be180ebd7a95f287$export$804de46662e4ac95)(t);
            return `${(0, $7431f94c7ac0c9a7$export$8b9d5f9a071daa33)(t.read, orOperator) || "\u03BB"} , ${t.write || "\u03BB"} ; ${t.direction || "\u03BB"}`;
        case 'PDA':
            (0, $be180ebd7a95f287$export$804de46662e4ac95)(t);
            return `${(0, $7431f94c7ac0c9a7$export$8b9d5f9a071daa33)(t.read, orOperator) || "\u03BB"} , ${t.pop || "\u03BB"} ; ${t.push || "\u03BB"}`;
        case 'FSA':
            return (0, $7431f94c7ac0c9a7$export$8b9d5f9a071daa33)(t.read, orOperator) || "\u03BB";
    }
};
const $682d8c1f00111eb9$var$getBendValue = (direction)=>({
        straight: 0,
        over: -0.5,
        under: 0.5
    })[direction] * (0, $1812551efebcf5e5$export$d4311fcb0a827d41);
/**
 * Return if transition b is to the right of a.
 * It is considered "to the right" if the a.x > b.x but if they are equal then it compares y coordinates
 * (It solved a lot of edge cases having it this way)
 */ const $682d8c1f00111eb9$var$toRightOf = (a, b)=>{
    return a.x === b.x ? a.y < b.y : a.x > b.x;
};
const $682d8c1f00111eb9$var$TransitionSet = ({ transitions: transitions, isGhost: isGhost = false, isTemplate: isTemplate = false })=>{
    const projectType = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project.config.type);
    // Split the transitions into the two directions (left->right and right->left)
    // This makes the code easier since we don't need to handle direction changes
    // Named over and under since
    const over = [];
    const under = [];
    transitions.forEach((t)=>{
        if ($682d8c1f00111eb9$var$toRightOf(t.from, t.to)) under.push(t);
        else over.push(t);
    });
    const renderTransition = (toRender, bend)=>{
        // The transitions sent should all start and end the same, so we only need to get the values
        // from the first transition
        const first = toRender[0];
        const props = {
            from: first.from,
            to: first.to,
            key: first.id,
            bendDirection: bend
        };
        if (isGhost) return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)($682d8c1f00111eb9$var$TransitionSet.Ghost, {
            ...props
        });
        else return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)($682d8c1f00111eb9$var$Transition, {
            transitions: toRender,
            id: first.id,
            projectType: projectType,
            isTemplate: isTemplate,
            ...props
        });
    };
    // We don't bend the transition if only rendering in one direction
    const isStraight = over.length === 0 && under.length > 0 || over.length > 0 && under.length === 0 ? 'straight' : '';
    // Now render both over and under sets of transitions
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
        children: [
            over.length > 0 && renderTransition(over, isStraight || 'over'),
            under.length > 0 && renderTransition(under, isStraight || 'under')
        ]
    });
};
/**
 * Returns the transform text to rotate an SVG element
 */ const $682d8c1f00111eb9$var$rotate = (degrees, centre)=>`rotate(${degrees}, ${centre.x}, ${centre.y})`;
const $682d8c1f00111eb9$var$RAD2DEG = 180 / Math.PI;
/**
 * Calculates the coordinate of a point along a quadratic curve
 * @param a The first point to use (This will be a point on a state circle)
 * @param b The control point (This is the midpoint between the two states)
 * @param c Third point to use (Will also be a point on a state circle)
 * @param t Value in range 0-1 of where to get point (0 being left, 0.5 middle, etc)
 */ const $682d8c1f00111eb9$var$calcPoint = (a, b, c, t)=>{
    /**
   * Calculate the coordinate along one axis (X or Y).
   * From here: https://en.wikipedia.org/wiki/B%C3%A9zier_curve#Quadratic_B%C3%A9zier_curves
   */ const forAxis = (a, b, c)=>Math.pow(1 - t, 2) * a + 2 * (1 - t) * t * b + Math.pow(t, 2) * c;
    return {
        x: forAxis(a.x, b.x, c.x),
        y: forAxis(a.y, b.y, c.y)
    };
};
const $682d8c1f00111eb9$var$Transition = ({ transitions: transitions = [], from: from, to: to, projectType: projectType, bendDirection: bendDirection = 'straight', fullWidth: fullWidth = false, suppressEvents: suppressEvents = false, isTemplate: isTemplate = false })=>{
    const { standardArrowHead: standardArrowHead, selectedArrowHead: selectedArrowHead } = (0, $h2ArV.useContext)((0, $ad21efdb48dda924$export$f344bc39311a0bc6));
    const selectedTransitions = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.selectedTransitions);
    const setSelected = transitions.some((t)=>selectedTransitions.includes(t.id));
    const orOperator = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project?.config?.orOperator) ?? '|';
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)('common');
    // We want transitions going from left to right to be bending like a hill and in the other direction bending like
    // a valley
    const bendValue = $682d8c1f00111eb9$var$getBendValue(bendDirection);
    // Calculate path
    const { pathData: pathData, textPathData: textPathData, control: control, normal: normal, edges: edges } = $682d8c1f00111eb9$var$calculateTransitionPath(from, to, bendValue, fullWidth);
    // Convert the normal to degrees
    const degrees = Math.acos(normal.x) * $682d8c1f00111eb9$var$RAD2DEG - 90;
    const isReflexive = from.x === to.x && from.y === to.y;
    // Generate a unique id for this path
    const pathID = `${from.x}${from.y}${to.x}${to.y}`;
    // Calculate the midpoint of the curve which is where we will place the text
    const midPoint = $682d8c1f00111eb9$var$calcPoint(edges[0], control, edges[1], 0.5);
    // Callbacks for individual transitions
    const handleTransitionMouseUp = (t)=>(e)=>(0, $ca2884de04f532f3$export$fb20829f6af70575)('transition:mouseup', {
                originalEvent: e,
                transition: t,
                ctx: t.id
            });
    const handleTransitionMouseDown = (t)=>(e)=>(0, $ca2884de04f532f3$export$fb20829f6af70575)('transition:mousedown', {
                originalEvent: e,
                transition: t,
                ctx: t.id
            });
    const handleTransitionDoubleClick = (t)=>(e)=>{
            (0, $ca2884de04f532f3$export$fb20829f6af70575)('editTransition', {
                id: t.id,
                new: false
            });
            // Needs to be a different event since this takes the whole transition object but editTransition only supports IDs
            // The need for the whole object is so that it is inline with the other events
            (0, $ca2884de04f532f3$export$fb20829f6af70575)('transition:dblclick', {
                originalEvent: e,
                transition: t,
                ctx: t.id
            });
        };
    // Callbacks for the edge
    const handleEdgeMouseUp = (e)=>{
        (0, $ca2884de04f532f3$export$fb20829f6af70575)('edge:mouseup', {
            originalEvent: e,
            transitions: transitions,
            ctx: transitions[0]?.id ?? null
        });
    };
    const handleEdgeMouseDown = (e)=>(0, $ca2884de04f532f3$export$fb20829f6af70575)('edge:mousedown', {
            originalEvent: e,
            transitions: transitions,
            ctx: transitions[0]?.id ?? null
        });
    const handleEdgeDoubleClick = (e)=>{
        // Edit only first transition on dbl-click
        (0, $ca2884de04f532f3$export$fb20829f6af70575)('editTransition', {
            id: transitions[0].id,
            new: false
        });
        (0, $ca2884de04f532f3$export$fb20829f6af70575)('edge:dblclick', {
            originalEvent: e,
            transitions: transitions,
            ctx: transitions[0]?.id ?? null
        });
    };
    // Calculate text offset. We want transitions that curve under to extend downwards and over/straight to extend
    // upwards.
    const offsetDirection = bendDirection === 'under' ? 1 : -1;
    // The offset for each transition label from each other
    const textOffset = 1.2 * offsetDirection + 'em';
    // Offset of the first transition label from the edge.
    // 'under' transitions require more spacing
    const initialOffset = (bendDirection === 'under' ? 1 : 0.3) * offsetDirection + 'em';
    const formatOrSymbols = (text)=>{
        const elements = [];
        const parts = text.split(orOperator);
        parts.forEach((part, index)=>{
            elements.push(/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("tspan", {
                children: part
            }, `part-${index}`));
            if (index !== parts.length - 1) elements.push(/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("tspan", {
                fill: "#999",
                children: t(orOperator)
            }, `operator-${index}`));
        });
        return elements;
    };
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("g", {
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                id: pathID,
                d: pathData,
                markerEnd: `url(#${setSelected || isReflexive && setSelected ? selectedArrowHead : standardArrowHead})`,
                style: (0, $9883b7d698f201b1$export$e8a6ebf5a4cd9360),
                className: (setSelected || isReflexive && setSelected) && (0, $9883b7d698f201b1$export$cb22dd8235b61d1f) || undefined
            }, pathID),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                id: `${pathID}-text`,
                d: textPathData,
                stroke: "none",
                fill: "none"
            }, `${pathID}-text`),
            !suppressEvents && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                id: pathID,
                d: pathData,
                stroke: "transparent",
                fill: "none",
                onMouseUp: handleEdgeMouseUp,
                onMouseDown: handleEdgeMouseDown,
                onDoubleClick: handleEdgeDoubleClick,
                strokeWidth: 20
            }, `${pathID}-selection`),
            !isTemplate && setSelected && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $3ba0b2df39f44c89$export$2e2bcd8739ae039), {
                edges: edges,
                selectedTransitions: selectedTransitions,
                isReflexive: isReflexive
            }),
            !isTemplate && setSelected && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $3ba0b2df39f44c89$export$2e2bcd8739ae039), {
                edges: edges,
                selectedTransitions: selectedTransitions,
                isReflexive: isReflexive,
                isInvisible: true
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("text", {
                ...midPoint,
                transform: $682d8c1f00111eb9$var$rotate(degrees, midPoint),
                textAnchor: "middle",
                children: transitions.map((t, i)=>{
                    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("tspan", {
                        dy: i === 0 ? initialOffset : textOffset,
                        fill: selectedTransitions.includes(t.id) ? 'var(--primary)' : 'var(--stroke)',
                        onMouseDown: handleTransitionMouseDown(t),
                        onMouseUp: handleTransitionMouseUp(t),
                        onDoubleClick: handleTransitionDoubleClick(t),
                        x: midPoint.x,
                        children: formatOrSymbols($682d8c1f00111eb9$var$makeTransitionText(projectType, orOperator, t))
                    }, t.id);
                })
            })
        ]
    });
};
const $682d8c1f00111eb9$var$calculateTransitionPath = (from, to, bendValue, fullWidth)=>{
    // Is this path reflexive
    const isReflexive = from.x === to.x && from.y === to.y;
    // Determine control position
    // -- this is determined by moving along the normal to the difference between the states
    // -- with the distance moved controlled by the `bend` value
    const [left, right] = $682d8c1f00111eb9$var$toRightOf(from, to) ? [
        from,
        to
    ] : [
        to,
        from
    ];
    const center = (0, $5803ecf8056a071e$export$110a106688b8ed86)(left, right, 0.5);
    const tangent = {
        x: left.x - right.x,
        y: left.y - right.y
    };
    const a = Math.PI / 2;
    const orth = {
        x: tangent.x * Math.cos(a) - tangent.y * Math.sin(a),
        y: tangent.x * Math.sin(a) + tangent.y * Math.cos(a)
    };
    const normal = (0, $5803ecf8056a071e$export$346677f925de839c)(orth) > 0 ? {
        x: orth.x / (0, $5803ecf8056a071e$export$346677f925de839c)(orth),
        y: orth.y / (0, $5803ecf8056a071e$export$346677f925de839c)(orth)
    } : {
        x: 0,
        y: 0
    };
    const control = isReflexive ? {
        x: left.x,
        y: left.y - (0, $1812551efebcf5e5$export$be4f6dacde269979)
    } : {
        x: center.x + bendValue * normal.x,
        y: center.y + bendValue * normal.y
    };
    // Translate control points (Used for reflexive paths)
    const translatedControl1 = !isReflexive ? control : {
        ...control,
        x: control.x - (0, $1812551efebcf5e5$export$f5374a98ad8aa40f)
    };
    const translatedControl2 = !isReflexive ? control : {
        ...control,
        x: control.x + (0, $1812551efebcf5e5$export$f5374a98ad8aa40f)
    };
    // We connect the edge to the closest point on each circle from the control point
    // (If fullWidth is set we move it just far enough to prevent accidental click events)
    const edge1 = fullWidth ? (0, $5803ecf8056a071e$export$cd860dfe6e23495d)(from, translatedControl1, 2) : (0, $5803ecf8056a071e$export$cd860dfe6e23495d)(from, translatedControl1, (0, $1812551efebcf5e5$export$d12d81d9c5207ce8));
    const edge2 = fullWidth ? (0, $5803ecf8056a071e$export$cd860dfe6e23495d)(to, translatedControl2, 2) : (0, $5803ecf8056a071e$export$cd860dfe6e23495d)(to, translatedControl2, (0, $1812551efebcf5e5$export$d12d81d9c5207ce8));
    // Generate the path data
    const pathData = `M${edge1.x}, ${edge1.y} Q${control.x}, ${control.y} ${edge2.x}, ${edge2.y}`;
    const pathReversed = `M${edge2.x}, ${edge2.y} Q${control.x}, ${control.y} ${edge1.x}, ${edge1.y}`;
    // Calculate the angle of the line
    const angle = Math.atan2(edge2.y - edge1.y, edge2.x - edge1.x) * 180 / Math.PI;
    return {
        pathData: pathData,
        textPathData: angle > 90 || angle <= -90 ? pathReversed : pathData,
        control: control,
        normal: normal,
        edges: [
            edge1,
            edge2
        ]
    };
};
$682d8c1f00111eb9$var$TransitionSet.Transition = $682d8c1f00111eb9$var$Transition;
$682d8c1f00111eb9$var$TransitionSet.Ghost = ({ from: from, to: to, bendDirection: bendDirection })=>{
    const pathID = `${from.x}${from.y}${to.x}${to.y}`;
    const bendValue = $682d8c1f00111eb9$var$getBendValue(bendDirection);
    const { pathData: pathData } = $682d8c1f00111eb9$var$calculateTransitionPath(from, to, bendValue, false);
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
        id: pathID,
        d: pathData,
        style: (0, $9883b7d698f201b1$export$96158a09d78a3fd)
    }, pathID);
};
var $682d8c1f00111eb9$export$2e2bcd8739ae039 = $682d8c1f00111eb9$var$TransitionSet;



const $e895a8b710e78d7e$var$SelectedGraphContent = ()=>{
    const project = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project);
    const { transitions: transitions, states: states, comments: comments } = project ?? {};
    const selectedTransitionIds = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.selectedTransitions);
    const selectedStateIds = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.selectedStates);
    const selectedCommentsIds = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.selectedComments);
    const selectedTransitions = transitions.filter((t)=>selectedTransitionIds.includes(t.id));
    const selectedStates = states.filter((s)=>selectedStateIds.includes(s.id));
    const selectedComments = comments.filter((c)=>selectedCommentsIds.includes(c.id));
    const locatedTransitions = (0, $a9e8924451a9767d$export$59109e4b2bdb8ae5)(selectedTransitions, selectedStates);
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
        children: [
            !!locatedTransitions && locatedTransitions.map((transitions, i)=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $682d8c1f00111eb9$export$2e2bcd8739ae039), {
                    transitions: transitions,
                    isTemplate: true
                }, i)),
            !!selectedStates && selectedStates.map((s)=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5c6c2a9ebe102168$export$2e2bcd8739ae039), {
                    id: s.id,
                    name: s.name,
                    label: s.label,
                    cx: s.x,
                    cy: s.y,
                    isFinal: s.isFinal,
                    selected: false,
                    stepped: false
                }, s.id)),
            !!selectedComments && selectedComments.map((c)=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $0a5e0a245d54ced4$export$2e2bcd8739ae039), {
                    id: c.id,
                    x: c.x,
                    y: c.y,
                    text: c.text
                }, c.id))
        ]
    });
};
var $e895a8b710e78d7e$export$2e2bcd8739ae039 = $e895a8b710e78d7e$var$SelectedGraphContent;





var $8K1s2 = parcelRequire("8K1s2");




const $7023de9e5d727868$var$TemplateGhost = ({ template: template, mousePos: mousePos })=>{
    const templateCopy = structuredClone(template);
    (0, $9003adf927d831a8$export$116c286ffc0cf8b2)(mousePos, templateCopy.states, templateCopy.comments);
    // Next few lines are from GraphContent.tsx, perhaps should make this its own function?
    const groupedTransitions = Object.values((0, (/*@__PURE__*/$parcel$interopDefault($8K1s2)))(templateCopy.transitions, (t)=>[
            t.from,
            t.to
        ].sort((a, b)=>b - a)));
    const locatedTransitions = groupedTransitions.map((transitions)=>transitions.map((t)=>(0, $3f368c329a5889b3$export$883a7ac0705d77b5)(t, templateCopy.states)) // Resolve location of transition states
        // Sort by direction. If the x coordinates are the same then compare by Y axis
        .sort((t1, t2)=>(t2.from.x === t1.from.x ? t2.from.y < t1.from.y : t2.from.x < t1.from.x) ? 1 : -1));
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
        children: [
            templateCopy.states.map((state, key)=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5c6c2a9ebe102168$export$2e2bcd8739ae039).Ghost, {
                    cx: state.x,
                    cy: state.y
                }, key)),
            locatedTransitions.map((transitions, i)=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $682d8c1f00111eb9$export$2e2bcd8739ae039), {
                    transitions: transitions,
                    isGhost: true
                }, i))
        ]
    });
};
var $7023de9e5d727868$export$2e2bcd8739ae039 = $7023de9e5d727868$var$TemplateGhost;





const $93f1d08e0fec2b6a$var$EditorPanel = ()=>{
    const [renderSelection, setRenderSelection] = (0, $h2ArV.useState)(false);
    // Interactivity hooks
    const { select: selectState } = (0, $4d9084c042c6f7b7$export$2e2bcd8739ae039)();
    const { select: selectTransition } = (0, $d2b9768fe2819798$export$2e2bcd8739ae039)();
    const { select: selectComment } = (0, $c2a319a6ebe46b18$export$2e2bcd8739ae039)();
    const { startDrag: startStateDrag } = (0, $6fdc4b0e31d90a85$export$2e2bcd8739ae039)();
    const { startDrag: startCommentDrag } = (0, $1e863dd3611b4ed5$export$2e2bcd8739ae039)();
    const { createTransitionStart: createTransitionStart, createTransitionEnd: createTransitionEnd } = (0, $6b7327396d77ce8a$export$2e2bcd8739ae039)();
    const { ghostState: ghostState } = (0, $99bee47c84ba0b00$export$2e2bcd8739ae039)();
    const { ghostTemplate: ghostTemplate } = (0, $9003adf927d831a8$export$2e2bcd8739ae039)();
    let selectedStates = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.selectedStates);
    let selectedComments = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.selectedComments);
    const setStates = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.setStates);
    const setComments = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.setComments);
    const setTransitions = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.setTransitions);
    const template = (0, $f8e54bb3e6739765$export$2e2bcd8739ae039)((s)=>s.template);
    (0, $031a6c13090f0034$export$2e2bcd8739ae039)();
    (0, $62273076b8702d48$export$2e2bcd8739ae039)();
    const handleDragging = (e)=>{
        const isLeftClick = e.detail.originalEvent.button === 0;
        // When the user isn't holding shift and is just clicking then we need to check if we
        // need to clear their selection.
        if (!e.detail.originalEvent.shiftKey && isLeftClick) {
            // Runs a test to see if the item being selected in the event is already selected.
            // If it isn't then we forget what we have selected before
            const testEvent = (eventKey, ids)=>{
                if (eventKey in e.detail) {
                    if (!ids.includes(e.detail[eventKey].id)) {
                        selectedComments = [];
                        selectedStates = [];
                    }
                }
            };
            testEvent('comment', selectedComments);
            testEvent('state', selectedStates);
        }
        // Only try and check if the user is selecting a new resource if the event correlates with that.
        // Else just use the previous value from the store.
        const selStates = e.type === 'state:mousedown' ? selectState(e) : selectedStates;
        const selComments = e.type === 'comment:mousedown' ? selectComment(e) : selectedComments;
        if (isLeftClick) {
            // Only drag if a left click.
            // We still allow selecting via right click so the user can directly click + edit something
            startStateDrag(e, selStates);
            startCommentDrag(e, selComments);
        }
    };
    // Setup dragging for comments and states
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('state:mousedown', handleDragging);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('comment:mousedown', handleDragging);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('transition:mousedown', selectTransition);
    const handleDoubleClick = (e)=>{
        // Return array of selected item. If event isn't for the key then just return empty so it unselects
        const getOrEmpty = (key)=>key in e.detail ? [
                e.detail[key].id
            ] : [];
        setStates(getOrEmpty('state'));
        setTransitions(getOrEmpty('transition'));
        setComments(getOrEmpty('comment'));
    };
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('state:dblclick', handleDoubleClick);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('comment:dblclick', handleDoubleClick);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('transition:dblclick', handleDoubleClick);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('edge:mousedown', (e)=>{
        // We want to call the selectTransition so that if holding shift and selecting two edges
        // the two sets of transitions will be selected (Instead of unselecting one and selecting the other)
        const newEvent = {
            ...e,
            detail: {
                ...e.detail,
                ids: e.detail.transitions.map((t)=>t.id)
            }
        };
        selectTransition(newEvent);
    });
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('edge:dblclick', (e)=>{
        setStates([]);
        setComments([]);
        setTransitions(e.detail.transitions.map((t)=>t.id));
    });
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('createTemplateThumbnail', (e)=>{
        setRenderSelection(true);
        (0, $ca2884de04f532f3$export$fb20829f6af70575)('storeTemplateThumbnail', e.detail);
    });
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('selectionGraph:hide', ()=>{
        setRenderSelection(false);
    });
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $ab43a4aca8f4d239$export$2e2bcd8739ae039), {
                children: [
                    createTransitionStart && createTransitionEnd && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $682d8c1f00111eb9$export$2e2bcd8739ae039).Transition, {
                        fullWidth: true,
                        suppressEvents: true,
                        from: createTransitionStart,
                        to: createTransitionEnd,
                        count: 1,
                        projectType: "FSA",
                        id: -1,
                        transitions: []
                    }),
                    ghostState && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5c6c2a9ebe102168$export$2e2bcd8739ae039).Ghost, {
                        cx: ghostState.x,
                        cy: ghostState.y
                    }),
                    ghostTemplate && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $7023de9e5d727868$export$2e2bcd8739ae039), {
                        template: template,
                        mousePos: {
                            x: ghostTemplate.x,
                            y: ghostTemplate.y
                        }
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $d20f688bb4f548df$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $af8bb90d70c37d0e$export$2e2bcd8739ae039), {})
                ]
            }),
            renderSelection && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ab43a4aca8f4d239$export$2e2bcd8739ae039), {
                $selectedOnly: true,
                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e895a8b710e78d7e$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $2baf3b7f870173d8$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $74a892b6cea20744$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $9800c65c5d2748a1$export$2e2bcd8739ae039), {})
        ]
    });
};
var $93f1d08e0fec2b6a$export$2e2bcd8739ae039 = $93f1d08e0fec2b6a$var$EditorPanel;




var $h2ArV = parcelRequire("h2ArV");


const $078434a750a5629b$export$e6dfd72ab29f8598 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  position: relative;
  width: 100%
`;
const $078434a750a5629b$export$2ddb90ad54e5f587 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  width: 100%;
  background: var(--surface);
  position: relative;
  z-index: 10;

  & > div {
    inset: 0;
    overflow-x: auto;
  }
`;






var $h2ArV = parcelRequire("h2ArV");

const $776feb9c9e4413f4$export$42a852a2b6b56249 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  --cell-width: 35px;
  --tape-background: var(--toolbar);
  flex: 1;
  position: relative;
  padding-block: .8em;
  background: var(--toolbar);
  min-width: calc(var(--cell-width) * 21);
  pointer-events: none;
  border-radius: .3rem;
  &.animate {
    transition: top .2s, left .2s;
  }

  & > div {
    overflow: hidden;
  }
`;
const $776feb9c9e4413f4$export$9936c50a269c50ec = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-self:start;
`;
const $776feb9c9e4413f4$export$528574b07d6189d5 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  flex-direction: row;
  transform: translateX(calc((${(p)=>p.$tapeLength - 1}/2) * var(--cell-width) + ${(p)=>-p.$index} * var(--cell-width)));
  width: max-content;
  ${(p)=>p.$inTransition && `
    transition: transform .2s;
  `}
`;
const $776feb9c9e4413f4$export$52fc9fed8e569929 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('span')`
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1;
  min-width: var(--cell-width);
  font-family: var(--font-mono);
  font-size: 1.2em;
  box-sizing: border-box;
  background: var(--white);
  color: var(--black);
  border-left: 1px dashed var(--input-border);

  &:last-of-type {
    border-right: 1px dashed var(--input-border);
  }
`;
const $776feb9c9e4413f4$export$7d48e63f7b0d36ae = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('svg')`
  position: absolute;
  right: 100%;
  top: 0;
  bottom: 0;
  height: 100%;

  ${(p)=>p.$flipped && `
    right: initial;
    left: 100%;
    transform: rotate(180deg);
  `}
`;
const $776feb9c9e4413f4$export$bfc53f5b439e4be7 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('svg')`
  position: absolute;
  left: calc(50% - 8px);
  top: 6px;
  height: 12px;
  width: 16px;
  z-index: 1;
`;


const $a0b62be9acbbd719$var$TMTraceStepWindow = ({ trace: trace, pointer: pointer, accepted: accepted, isEnd: isEnd })=>{
    const [green, setGreen] = (0, $h2ArV.useState)(false);
    const [red, setRed] = (0, $h2ArV.useState)(false);
    const [boxWidth, setBoxWidth] = (0, $h2ArV.useState)(760);
    const [tapeTrace, setTapeTrace] = (0, $h2ArV.useState)(trace);
    const [effectiveIndex, setEffectiveIndex] = (0, $h2ArV.useState)(0);
    const [effectiveEnd, setEffectiveEnd] = (0, $h2ArV.useState)(trace.length);
    const [lastPointer, setLastPointer] = (0, $h2ArV.useState)(0);
    const [inTransition, setInTransition] = (0, $h2ArV.useState)(true);
    const startTransition = (newTrace, newEnd)=>{
        setInTransition(true);
        setTimeout(()=>{
            // This will snap the tape so it doesn't do the steering jitter
            setInTransition(false);
            setTapeTrace(newTrace);
            setEffectiveEnd(newEnd);
        }, 20);
    };
    // INCREASE THE POINTER, WAIT THEN UPDATE THE TAPE
    const updateWidth = (0, $h2ArV.useCallback)(()=>{
        // Magic numbers come from the size of toolbar, min size of canvas and size of side panel
        const minSize = 1222;
        const usableWidth = window.innerWidth < minSize ? 760 : window.innerWidth - 398 - 64;
        setBoxWidth(usableWidth);
    }, [
        window.innerWidth
    ]);
    (0, $h2ArV.useEffect)(()=>{
        updateWidth();
        window.addEventListener('resize', updateWidth);
        return ()=>window.removeEventListener('resize', updateWidth);
    }, []);
    (0, $h2ArV.useEffect)(()=>{
        // Some offsets so the tape looks slightly more continuous
        const offset = 2;
        const endOffset = 2;
        const startOffset = 1;
        const maxTapeLength = Math.floor(boxWidth / 35) - offset - endOffset - startOffset;
        if (trace.length > maxTapeLength) {
            // Pointer is at the midpoint so calc the number of cells to get
            const halfFit = Math.ceil(maxTapeLength / 2);
            const canSeeStart = pointer - startOffset <= halfFit;
            const canSeeEnd = trace.length - pointer < halfFit + endOffset;
            const start = canSeeStart ? 0 : pointer - halfFit - startOffset;
            const end = canSeeEnd ? trace.length : halfFit + pointer + endOffset;
            // Save the last pointer to determine if you headed left or right
            const right = lastPointer <= pointer;
            setLastPointer(pointer);
            setEffectiveIndex(pointer - start);
            if (!canSeeStart && !canSeeEnd) {
                // If headed right remove from end, else remove from start
                setTapeTrace(trace.slice(right ? start : start - 1, right ? end - 1 : end));
                // The css function should now run the transition,
                // after the timeout the state will be updated and the animation finished
                startTransition(trace.slice(start, end), end);
            } else {
                // If we can see the start or end, it is clear the tape is moving
                setInTransition(true);
                setTapeTrace(trace.slice(start, end));
                setEffectiveEnd(end);
            }
        } else {
            // If the tape fits do the normal thang
            setInTransition(true);
            setTapeTrace(trace);
            setEffectiveIndex(pointer);
            setEffectiveEnd(trace.length);
        }
    }, [
        boxWidth,
        pointer,
        trace
    ]);
    (0, $h2ArV.useEffect)(()=>{
        setGreen(isEnd && accepted);
        setRed(isEnd && !accepted);
    }, [
        accepted,
        isEnd
    ]);
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $776feb9c9e4413f4$export$42a852a2b6b56249), {
        style: {
            background: green ? '#689540' : red ? '#d30303' : 'var(--toolbar)'
        },
        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)($a0b62be9acbbd719$export$b56007f12edf0c17, {}),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $776feb9c9e4413f4$export$9936c50a269c50ec), {
                    children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $776feb9c9e4413f4$export$528574b07d6189d5), {
                        $index: effectiveIndex,
                        $tapeLength: tapeTrace.length,
                        $inTransition: inTransition,
                        children: [
                            effectiveIndex === pointer && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)($a0b62be9acbbd719$export$763f5d34ceb8e0c8, {}),
                            tapeTrace.map((symbol, i)=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $776feb9c9e4413f4$export$52fc9fed8e569929), {
                                    children: symbol
                                }, i)),
                            trace.length === effectiveEnd && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)($a0b62be9acbbd719$export$763f5d34ceb8e0c8, {
                                flipped: true
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $a0b62be9acbbd719$export$763f5d34ceb8e0c8 = ({ flipped: flipped })=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $776feb9c9e4413f4$export$7d48e63f7b0d36ae), {
        viewBox: "0 0 7.3 50",
        $flipped: flipped,
        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("polygon", {
            fill: "var(--white)",
            points: "7.28 50 0 50 7.28 43.75 0 37.53 7.3 31.25 .02 25 7.3 18.75 .02 12.5 7.3 6.25 .02 0 7.3 0 7.28 50"
        })
    });
const $a0b62be9acbbd719$export$b56007f12edf0c17 = ()=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $776feb9c9e4413f4$export$bfc53f5b439e4be7), {
        viewBox: "0 0 20 15",
        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
            fill: "var(--primary)",
            d: "M2.45,0h15.1c2.05,0,3.19,2.37,1.91,3.97l-7.55,10.11c-.98,1.23-2.85,1.23-3.83,0L.54,3.97C-.74,2.37,.4,0,2.45,0Z"
        })
    });
var $a0b62be9acbbd719$export$2e2bcd8739ae039 = $a0b62be9acbbd719$var$TMTraceStepWindow;




const $32f6d577abfb6a15$export$e6dfd72ab29f8598 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  flex-wrap: wrap;
  gap: .8rem;
  margin: .8rem;
`;



const $1aa3ce5d11ec0fa8$var$TMTapeLab = ()=>{
    const traceIDx = (0, $6baf371cdce3f20b$export$2e2bcd8739ae039)((s)=>s.traceIDx);
    const traceInput = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project.tests.single);
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)('common');
    const simResults = (0, $6baf371cdce3f20b$export$2e2bcd8739ae039)((s)=>s.simResults);
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $f6c0a8acd60d8875$export$2e2bcd8739ae039), {
                children: t('turing_machine_tape')
            }),
            simResults.length !== 0 && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $32f6d577abfb6a15$export$e6dfd72ab29f8598), {
                children: simResults.map((result, index)=>{
                    const trace = result.trace[traceIDx] ?? {
                        tape: {
                            pointer: 0,
                            trace: (traceInput || ' ').split('')
                        },
                        to: 0
                    };
                    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $a0b62be9acbbd719$export$2e2bcd8739ae039), {
                        trace: trace.tape.trace,
                        pointer: trace.tape.pointer,
                        accepted: result.accepted,
                        isEnd: traceIDx === result.trace.length - 1
                    }, index);
                })
            })
        ]
    });
};
var $1aa3ce5d11ec0fa8$export$2e2bcd8739ae039 = $1aa3ce5d11ec0fa8$var$TMTapeLab;




const $5aadffeeffe570a7$var$panels = [
    {
        label: 'TMTapeLab',
        value: 'tmTape',
        element: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $1aa3ce5d11ec0fa8$export$2e2bcd8739ae039), {})
    }
];
const $5aadffeeffe570a7$var$BottomPanel = ()=>{
    const [activePanel, setActivePanel] = (0, $h2ArV.useState)();
    // Open panel via event
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('bottomPanel:open', (e)=>{
        const panel = $5aadffeeffe570a7$var$panels.find((p)=>p.value === e.detail.panel);
        setActivePanel(activePanel?.value === panel.value ? undefined : panel);
    }, [
        activePanel
    ]);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('bottomPanel:close', ()=>{
        setActivePanel(undefined);
    }, [
        activePanel
    ]);
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $078434a750a5629b$export$e6dfd72ab29f8598), {
        children: activePanel && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $078434a750a5629b$export$2ddb90ad54e5f587), {
            children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("div", {
                children: activePanel.element
            })
        })
    });
};
var $5aadffeeffe570a7$export$2e2bcd8739ae039 = $5aadffeeffe570a7$var$BottomPanel;




var $h2ArV = parcelRequire("h2ArV");







var $h2ArV = parcelRequire("h2ArV");

const $e305d86e3bc40ef0$export$e6dfd72ab29f8598 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div', (0, $h2ArV.forwardRef))`
  flex: 1;
  position: relative;
`;
const $e305d86e3bc40ef0$export$e17b9c1182212c96 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('svg', (0, $h2ArV.forwardRef))`
  position: absolute;
  inset: 0;
  display: block;
  background: var(--grid-bg);

  /* Grid */
  ${(p)=>p.$showGrid && `
    background: var(--grid-pattern);
  `}

  /* Text */
  text {
    user-select: none;
    -webkit-user-select: none; /* for safari */
  }

  /* Cursors */
  ${(p)=>p.$tool === 'hand' && `
    cursor: grab;
    &:active {
      cursor: grabbing;
    }
  `}
`;



var $h2ArV = parcelRequire("h2ArV");



const $b379591a2d2bfd73$var$useViewDragging = (containerRef)=>{
    const currentTool = (0, $9ea7efd115f178cf$export$2e2bcd8739ae039)((s)=>s.tool);
    const toolActive = currentTool === 'hand';
    const viewPosition = (0, $2c8de4ab9c0d9b91$export$2e2bcd8739ae039)((s)=>s.position);
    const viewScale = (0, $2c8de4ab9c0d9b91$export$2e2bcd8739ae039)((s)=>s.scale);
    const setViewPosition = (0, $2c8de4ab9c0d9b91$export$2e2bcd8739ae039)((s)=>s.setViewPosition);
    const setViewPositionAndScale = (0, $2c8de4ab9c0d9b91$export$2e2bcd8739ae039)((s)=>s.setViewPositionAndScale);
    const ctrlZoom = (0, $8af1fe532609b934$export$2e2bcd8739ae039)((s)=>s.preferences.ctrlZoom);
    // Keep track of drag events
    const [dragStartPosition, setDragStartPosition] = (0, $h2ArV.useState)(null);
    const [dragStartViewPosition, setDragStartViewPosition] = (0, $h2ArV.useState)(null);
    const relativeMousePosition = (0, $h2ArV.useCallback)((x, y)=>{
        const b = containerRef.current.getBoundingClientRect();
        return [
            x - b.left,
            y - b.top
        ];
    }, [
        containerRef?.current
    ]);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('wheel', (e)=>{
        if (!containerRef.current.contains(e.target)) return;
        // Prevent defaults
        e.stopPropagation();
        e.preventDefault();
        // Do zoom
        if (ctrlZoom ? e.ctrlKey : true) {
            // Determine scroll amount and whether its possible
            const desiredScrollAmount = Math.max(Math.min(e.deltaY, 50), -50) * (0, $e50e5255b7875dbd$export$724cbe3218b353a0) * viewScale;
            const newScale = Math.min((0, $e50e5255b7875dbd$export$dd4614b42b3873f0), Math.max((0, $e50e5255b7875dbd$export$2768ada4b712324b), viewScale + desiredScrollAmount));
            const scrollAmount = newScale - viewScale;
            if (scrollAmount === 0) return;
            const [mx, my] = relativeMousePosition(e.clientX, e.clientY);
            setViewPositionAndScale({
                x: viewPosition.x - mx * scrollAmount,
                y: viewPosition.y - my * scrollAmount
            }, newScale);
        } else // Pan
        setViewPosition({
            x: viewPosition.x + e.deltaX * viewScale,
            y: viewPosition.y + e.deltaY * viewScale
        });
    }, [
        viewScale,
        viewPosition,
        ctrlZoom
    ], {
        options: {
            passive: false
        }
    });
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('mousedown', (e)=>{
        if (toolActive && containerRef.current?.contains(e.target)) {
            setDragStartPosition(relativeMousePosition(e.clientX, e.clientY));
            setDragStartViewPosition(viewPosition);
        }
    }, [
        toolActive,
        viewPosition
    ]);
    const onMouseUp = ()=>{
        setDragStartPosition(null);
        setDragStartViewPosition(null);
    };
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('mouseup', onMouseUp, [
        onMouseUp
    ]);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('mousemove', (e)=>{
        if (toolActive) {
            if (dragStartPosition !== null && dragStartViewPosition !== null) {
                const [sx, sy] = dragStartPosition;
                const [mx, my] = relativeMousePosition(e.clientX, e.clientY);
                setViewPosition({
                    x: dragStartViewPosition.x + (sx - mx) * viewScale,
                    y: dragStartViewPosition.y + (sy - my) * viewScale
                });
            }
        } else onMouseUp();
    }, [
        dragStartPosition,
        dragStartViewPosition
    ]);
};
var $b379591a2d2bfd73$export$2e2bcd8739ae039 = $b379591a2d2bfd73$var$useViewDragging;





const $ab43a4aca8f4d239$var$GraphView = ({ children: children, $selectedOnly: $isTemplate = false, ...props })=>{
    const wrapperRef = (0, $h2ArV.useRef)();
    const svgRef = (0, $h2ArV.useRef)();
    const { position: position, size: size, scale: scale, setViewSize: setViewSize, setSvgElement: setSvgElement, screenToViewSpace: screenToViewSpace } = (0, $2c8de4ab9c0d9b91$export$2e2bcd8739ae039)();
    const projectColor = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((state)=>state.project?.config.color);
    const colorPref = (0, $8af1fe532609b934$export$2e2bcd8739ae039)((state)=>state.preferences.color);
    const tool = (0, $9ea7efd115f178cf$export$2e2bcd8739ae039)((state)=>state.tool);
    const setViewPositionAndScale = (0, $2c8de4ab9c0d9b91$export$2e2bcd8739ae039)((s)=>s.setViewPositionAndScale);
    const [resizeView, setResizeView] = (0, $h2ArV.useState)(true);
    (0, $b379591a2d2bfd73$export$2e2bcd8739ae039)(svgRef);
    (0, $22a6b7ea146a0a79$export$2e2bcd8739ae039)();
    // Update width and height on resize
    const onContainerResize = (0, $h2ArV.useCallback)(()=>{
        const b = wrapperRef.current?.getBoundingClientRect();
        if (!b) return;
        setViewSize({
            width: b.width,
            height: b.height
        });
        // Check if we are able to zoom fit and if we are meant to zoom fit.
        // This only needs to run once, but we need to check multiple times
        // since the SVG doesn't load initially
        const zoomFit = (0, $b9bf89f7d3b36cd8$export$e14a6f5d6f915b6b)();
        if (resizeView && zoomFit) {
            const { scale: scale, x: x, y: y } = zoomFit;
            // Set a min scale so it doesn't zoom in too much (Smaller scale means more zoomed in)
            setViewPositionAndScale({
                x: x,
                y: y
            }, Math.max(scale, 1));
            setResizeView(false);
        }
    }, []);
    const onContainerMouseDown = (0, $h2ArV.useCallback)((e)=>{
        const [viewX, viewY] = screenToViewSpace(e.clientX, e.clientY);
        (0, $ca2884de04f532f3$export$fb20829f6af70575)('svg:mousedown', {
            originalEvent: e,
            didTargetSVG: e.target === svgRef?.current,
            viewX: viewX,
            viewY: viewY,
            ctx: null
        });
    }, []);
    const onContainerMouseUp = (0, $h2ArV.useCallback)((e)=>{
        const [viewX, viewY] = screenToViewSpace(e.clientX, e.clientY);
        (0, $ca2884de04f532f3$export$fb20829f6af70575)('svg:mouseup', {
            originalEvent: e,
            didTargetSVG: e.target === svgRef?.current,
            viewX: viewX,
            viewY: viewY,
            ctx: null
        });
    }, []);
    const onContainerMouseMove = (0, $h2ArV.useCallback)((e)=>{
        const [viewX, viewY] = screenToViewSpace(e.clientX, e.clientY);
        (0, $ca2884de04f532f3$export$fb20829f6af70575)('svg:mousemove', {
            originalEvent: e,
            didTargetSVG: e.target === svgRef?.current,
            viewX: viewX,
            viewY: viewY,
            ctx: null
        });
    }, []);
    // Keep track of resizes
    if (!$isTemplate) (0, $h2ArV.useEffect)(()=>{
        if (svgRef.current) {
            // Update reference
            setSvgElement(svgRef.current);
            // Manage resizing of view
            onContainerResize();
            window.addEventListener('resize', onContainerResize);
            // Setup handlers
            svgRef.current.addEventListener('mousedown', onContainerMouseDown);
            svgRef.current.addEventListener('mouseup', onContainerMouseUp);
            svgRef.current.addEventListener('mousemove', onContainerMouseMove);
            // Unset handlers
            return ()=>{
                window.removeEventListener('resize', onContainerResize);
                svgRef.current?.removeEventListener('mousedown', onContainerMouseDown);
                svgRef.current?.removeEventListener('mouseup', onContainerMouseUp);
                svgRef.current?.removeEventListener('mousedown', onContainerMouseMove);
            };
        }
    }, [
        svgRef.current
    ]);
    // Add a resize observer to the wrapper div
    if (!$isTemplate) (0, $h2ArV.useEffect)(()=>{
        if (wrapperRef.current) {
            const resizeObserver = new ResizeObserver(onContainerResize);
            resizeObserver.observe(wrapperRef.current);
            return ()=>resizeObserver.disconnect();
        }
    }, [
        wrapperRef.current
    ]);
    // Set color theme
    (0, $h2ArV.useEffect)(()=>{
        const color = (0, $d59e810d2f517544$export$2e2bcd8739ae039)[projectColor !== '' && projectColor || 'orange'];
        svgRef.current.style.setProperty('--primary-h', color.h.toString());
        svgRef.current.style.setProperty('--primary-s', color.s + '%');
        svgRef.current.style.setProperty('--primary-l', color.l + '%');
    }, [
        projectColor,
        colorPref
    ]);
    // Determine svg background (grid)
    const backgroundPosition = `${-position.x / scale}px ${-position.y / scale}px`;
    const backgroundSize = `${1 / scale * (0, $e50e5255b7875dbd$export$be7376dc5870de68) * 2}px ${1 / scale * (0, $e50e5255b7875dbd$export$be7376dc5870de68) * 2}px`;
    const gridVisible = (0, $8af1fe532609b934$export$2e2bcd8739ae039)((state)=>state.preferences.showGrid);
    const viewBox = `${position.x} ${position.y} ${scale * size.width} ${scale * size.height}`;
    const svgId = $isTemplate ? 'selected-graph' : 'automatarium-graph';
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e305d86e3bc40ef0$export$e6dfd72ab29f8598), {
        ref: wrapperRef,
        id: "editor-panel-wrapper",
        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e305d86e3bc40ef0$export$e17b9c1182212c96), {
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            xmlnsXlink: "http://www.w3.org/1999/xlink",
            id: svgId,
            onContextMenu: (e)=>e.preventDefault(),
            viewBox: viewBox,
            ref: svgRef,
            $showGrid: gridVisible,
            $tool: tool,
            ...props,
            style: {
                strokeLinejoin: 'round',
                strokeLinecap: 'round',
                strokeWidth: '2px',
                backgroundSize: backgroundSize,
                backgroundPosition: backgroundPosition,
                ...props.style
            },
            children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ad21efdb48dda924$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("g", {
                    children: children
                })
            })
        })
    });
};
var $ab43a4aca8f4d239$export$2e2bcd8739ae039 = $ab43a4aca8f4d239$var$GraphView;






const $d20f688bb4f548df$var$GraphContent = ()=>{
    const project = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project);
    const selectedStates = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.selectedStates);
    const steppedStateIDs = (0, $d2aaad49862844e1$export$2e2bcd8739ae039)((s)=>s.steppedStates);
    // Destructure project to get state
    const states = project?.states ?? [];
    const transitions = project?.transitions ?? [];
    const comments = project?.comments ?? [];
    const initialState = project?.initialState;
    const locatedTransitions = (0, $a9e8924451a9767d$export$59109e4b2bdb8ae5)(transitions, states);
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e02fcc0a6f3b97af$export$2e2bcd8739ae039), {
                states: states,
                initialStateID: initialState
            }),
            locatedTransitions.map((transitions, i)=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $682d8c1f00111eb9$export$2e2bcd8739ae039), {
                    transitions: transitions
                }, i)),
            states.map((s)=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5c6c2a9ebe102168$export$2e2bcd8739ae039), {
                    id: s.id,
                    name: s.name,
                    label: s.label,
                    cx: s.x,
                    cy: s.y,
                    isFinal: s.isFinal,
                    selected: selectedStates.includes(s.id),
                    stepped: steppedStateIDs.includes(s.id)
                }, s.id)),
            comments.map((c)=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $0a5e0a245d54ced4$export$2e2bcd8739ae039), {
                    id: c.id,
                    x: c.x,
                    y: c.y,
                    text: c.text
                }, c.id))
        ]
    });
};
var $d20f688bb4f548df$export$2e2bcd8739ae039 = $d20f688bb4f548df$var$GraphContent;




const $e02fcc0a6f3b97af$var$InitialStateArrow = ({ states: states, initialStateID: initialStateID })=>{
    const initialState = states.find((s)=>s.id === initialStateID);
    if (!initialState) return null;
    const { x: x, y: y } = initialState;
    const triangleStart = `${x - (0, $1812551efebcf5e5$export$d12d81d9c5207ce8)}, ${y}`;
    const triangleTopLeft = `${x - (0, $1812551efebcf5e5$export$bdd0075766057415) - (0, $1812551efebcf5e5$export$d12d81d9c5207ce8)}, ${y - (0, $1812551efebcf5e5$export$4aa180e8a03344a1)}`;
    const triangleBottomLeft = `${x - (0, $1812551efebcf5e5$export$bdd0075766057415) - (0, $1812551efebcf5e5$export$d12d81d9c5207ce8)}, ${y + (0, $1812551efebcf5e5$export$4aa180e8a03344a1)}`;
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("g", {
        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("polygon", {
            points: `${triangleStart} ${triangleTopLeft} ${triangleBottomLeft}`,
            style: {
                fill: 'var(--initial-arrow-bg, var(--grid-bg))',
                stroke: 'var(--stroke)'
            }
        })
    });
};
var $e02fcc0a6f3b97af$export$2e2bcd8739ae039 = $e02fcc0a6f3b97af$var$InitialStateArrow;






var $h2ArV = parcelRequire("h2ArV");



const $af8bb90d70c37d0e$var$SelectionBox = ()=>{
    const tool = (0, $9ea7efd115f178cf$export$2e2bcd8739ae039)((s)=>s.tool);
    const toolActive = tool === 'cursor';
    const states = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project?.states);
    const transitions = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project?.transitions);
    const comments = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project?.comments);
    const screenToViewSpace = (0, $2c8de4ab9c0d9b91$export$2e2bcd8739ae039)((s)=>s.screenToViewSpace);
    const svgElement = (0, $2c8de4ab9c0d9b91$export$2e2bcd8739ae039)((s)=>s.svgElement);
    const setSelectedStates = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.setStates);
    const setSelectedTransitions = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.setTransitions);
    const setSelectedComments = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.setComments);
    const prevSelectedStates = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.selectedStates);
    const prevSelectedTransitions = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.selectedTransitions);
    const prevSelectedComments = (0, $a0ca2e9b6bccb84a$export$2e2bcd8739ae039)((s)=>s.selectedComments);
    const [dragStart, setDragStart] = (0, $h2ArV.useState)(null);
    const [mousePos, setMousePos] = (0, $h2ArV.useState)(null);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('mousemove', (e)=>{
        setMousePos(screenToViewSpace(e.clientX, e.clientY));
    }, []);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('svg:mousedown', (e)=>{
        if (e.detail.originalEvent.button === 0 && e.detail.didTargetSVG && toolActive) setDragStart([
            e.detail.viewX,
            e.detail.viewY
        ]);
    }, [
        toolActive,
        svgElement
    ]);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('svg:mouseup', (e)=>{
        if (dragStart !== null && toolActive) {
            // Calculate drag bounds
            const startX = Math.min(dragStart[0], mousePos[0]);
            const startY = Math.min(dragStart[1], mousePos[1]);
            const endX = Math.max(dragStart[0], mousePos[0]);
            const endY = Math.max(dragStart[1], mousePos[1]);
            // Determine selected states
            const selectedStates = states.filter((state)=>state.x >= startX && state.x <= endX && state.y >= startY && state.y <= endY).map((s)=>s.id);
            // Determine selected transitions
            const selectedTransitions = transitions.map((t)=>(0, $3f368c329a5889b3$export$883a7ac0705d77b5)(t, states)).filter((transition)=>transition.from.x >= startX && transition.from.x <= endX && transition.from.y >= startY && transition.from.y <= endY && transition.to.x >= startX && transition.to.x <= endX && transition.to.y >= startY && transition.to.y <= endY).map((t)=>t.id);
            // Determine selected comments
            const selectedComments = comments.filter((comment)=>comment.x >= startX && comment.y >= startY && comment.x <= endX && comment.y <= endY).map((c)=>c.id);
            // If the shift key is pressed then we need to append additional things
            if (e.detail.originalEvent.shiftKey) {
                selectedStates.push(...prevSelectedStates);
                selectedTransitions.push(...prevSelectedTransitions);
                selectedComments.push(...prevSelectedComments);
            }
            // Update state
            setSelectedStates(selectedStates);
            setSelectedTransitions(selectedTransitions);
            setSelectedComments(selectedComments);
            setDragStart(null);
        }
    }, [
        toolActive,
        dragStart,
        mousePos,
        states
    ]);
    if (!dragStart || !mousePos || !toolActive) return null;
    const startX = Math.min(dragStart[0], mousePos[0]);
    const startY = Math.min(dragStart[1], mousePos[1]);
    const endX = Math.max(dragStart[0], mousePos[0]);
    const endY = Math.max(dragStart[1], mousePos[1]);
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("rect", {
        x: startX,
        y: startY,
        width: endX - startX,
        height: endY - startY,
        fill: "var(--selection-fill)",
        stroke: "var(--stroke)",
        strokeWidth: "1.75",
        rx: 3,
        ry: 3
    });
};
var $af8bb90d70c37d0e$export$2e2bcd8739ae039 = $af8bb90d70c37d0e$var$SelectionBox;





const $4c162b6dcf5fcb5b$export$d653589df987fd93 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('main')`
  max-width: 600px;
  width: 100%;
  padding: 1em 2em;
  box-sizing: border-box;
  margin: 0 auto;
  padding-bottom: 3em;

  ${(p)=>p.$wide && `
    max-width: 1200px;
  `}

  ${(p)=>p.$fullWidth && `
    max-width: initial;
    padding-inline: 0;
  `}
`;


const $ca8af2a7a8a4cd53$var$Main = ({ wide: wide, fullWidth: fullWidth, ...props })=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $4c162b6dcf5fcb5b$export$d653589df987fd93), {
        $wide: wide,
        $fullWidth: fullWidth,
        ...props
    });
var $ca8af2a7a8a4cd53$export$2e2bcd8739ae039 = $ca8af2a7a8a4cd53$var$Main;



const $2fdc1cc89313d290$var$Logo = ({ size: size = '4rem', primary: primary = 'var(--primary)', secondary: secondary = 'hsl(var(--primary-h) var(--primary-s) 80%)', hideTriangle: hideTriangle = false, hidePlanet: hidePlanet = false, ...props })=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        style: {
            width: size,
            height: size
        },
        ...props,
        children: [
            !hidePlanet && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                fill: secondary,
                cx: "241.33",
                cy: "241.33",
                r: "173.99"
            }),
            !hideTriangle && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                fill: secondary,
                d: "M375.28,386.46l7.05,49.68c1.15,8.07,11.02,11.37,16.78,5.6l42.64-42.64c5.76-5.76,2.47-15.64-5.6-16.78l-49.68-7.05c-6.52-.92-12.1,4.66-11.18,11.18Z"
            }),
            !hidePlanet && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                        fill: primary,
                        d: "M275.17,153.93c-25.14,3.73-54.37,11.56-54.37,29.9,0,32.97,66.43,23.99,67.41,43.18,.58,11.49-13.38,18.41-11,40.41,3.11,28.77,81.43,29.8,129.76,27.28,5.42-16.82,8.35-34.75,8.35-53.37,0-33.33-9.38-64.47-25.63-90.93-39.53-3.06-79.69-1.65-114.52,3.52Z"
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                        fill: primary,
                        d: "M193.24,277.53c-11.59-7.6-73.05-20.03-124.98-18.25,2.83,27.58,12.1,53.25,26.28,75.49,34,1.87,90.31-.78,105.87-23.84,5.84-8.66,7.94-23.48-7.18-33.39Z"
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                        fill: primary,
                        d: "M241.33,415.32c25.67,0,50.04-5.56,71.97-15.54-35.4-25.35-113.41-30.89-155.4-5.73,24.77,13.56,53.19,21.27,83.42,21.27Z"
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                        fill: primary,
                        d: "M300.81,77.78c-18.56-6.75-38.59-10.43-59.48-10.43-18.36,0-36.05,2.85-52.66,8.12,34.12,33.19,89.74,23.67,112.14,2.31Z"
                    })
                ]
            })
        ]
    });
var $2fdc1cc89313d290$export$2e2bcd8739ae039 = $2fdc1cc89313d290$var$Logo;






const $d5b06d06ca2b13cc$export$1e86fd0e1db89578 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('header')`
  display: flex;
  align-items: center;
  margin-bottom: 1em;
  font-family: var(--font-header);
  gap: 1em;
  user-select: none;

  ${(p)=>p.$center && `
    justify-content: center;
  `}

  a {
    color: inherit;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 1em;
  }

  h1 {
    padding-right: 10px;
    margin-block: .6em;
  }
`;


const $193714fcc8f30367$var$content = /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
    children: [
        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $2fdc1cc89313d290$export$2e2bcd8739ae039), {}),
        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("h1", {
            children: "Automatarium"
        })
    ]
});
const $193714fcc8f30367$var$Header = ({ center: center, linkTo: linkTo })=>linkTo ? /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $d5b06d06ca2b13cc$export$1e86fd0e1db89578), {
        $center: center,
        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ea9c8114d35b5a84$export$a6c7ac8248d6e38a), {
            to: linkTo,
            children: $193714fcc8f30367$var$content
        })
    }) : /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $d5b06d06ca2b13cc$export$1e86fd0e1db89578), {
        $center: center,
        children: $193714fcc8f30367$var$content
    });
var $193714fcc8f30367$export$2e2bcd8739ae039 = $193714fcc8f30367$var$Header;






const $534f3ec1064ac59f$export$a5e06607a5ac6158 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 15em;
  height: 15em;

  svg {
    position: absolute;
    width: 15em;
    height: 15em;
  }

  svg:nth-child(2) {
    transform-origin: 47% 47%;
    animation: spin 5s linear infinite;
  }

  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
`;


const $706606fa822de154$var$Spinner = ()=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $534f3ec1064ac59f$export$a5e06607a5ac6158), {
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $2fdc1cc89313d290$export$2e2bcd8739ae039), {
                hideTriangle: true,
                size: ''
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $2fdc1cc89313d290$export$2e2bcd8739ae039), {
                hidePlanet: true,
                size: ''
            })
        ]
    });
var $706606fa822de154$export$2e2bcd8739ae039 = $706606fa822de154$var$Spinner;





var $h2ArV = parcelRequire("h2ArV");




var $h2ArV = parcelRequire("h2ArV");
const $7cc6199b5ef516d3$export$e6dfd72ab29f8598 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div', (0, $h2ArV.forwardRef))`
  background: var(--surface);
  border-radius: .3em;
  padding: .4em 0;
  display: flex;
  flex-direction: column;
  position: fixed;
  z-index: 1000;
  font-size: .95rem;
  transition: opacity .15s, transform .15s, visibility .15s;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-.2em);

  & > div {
    position: relative;
  }

  ${(props)=>props.$subMenu && `
    position: absolute;
    top: -.4em;
    left: calc(100% - .2em);
    transform: translateX(-.2em) translateY(0);
  `}

  ${(props)=>props.$visible && `
    opacity: 1;
    transform: translateX(0) translateY(0);
    pointer-events: all;
    visibility: visible;
  `}
`;
const $7cc6199b5ef516d3$export$59451aa6b6270879 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('span')`
  opacity: .5;
`;
const $7cc6199b5ef516d3$export$ef9839ae55b8ba40 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('button')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  white-space: nowrap;
  padding: .2em .8em;
  margin: 0;
  font: inherit;
  color: inherit;
  background: none;
  border: 0;
  cursor: pointer;
  gap: 1em;
  width: 100%;

  &:hover, &:focus ${(props)=>props.$active && ',&'} {
    background: var(--primary);
  }

  &:disabled, &:disabled:hover {
    background: none;
    cursor: default;

    label, svg {
      opacity: .5;
    }
  }

  label {
    cursor: inherit;
  }
`;
const $7cc6199b5ef516d3$export$2e0a83ec2e27ecbb = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('hr')`
  border: 0;
  margin: .3em 0;
  border-top: 1px solid var(--toolbar);
`;


const $54cc07ecaf352272$var$ItemWithItems = ({ item: item, onClose: onClose })=>{
    const [active, setActive] = (0, $h2ArV.useState)(false);
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("div", {
        onMouseEnter: ()=>setActive(true),
        onMouseLeave: ()=>setActive(false),
        onBlur: (e)=>!e.currentTarget.contains(e.relatedTarget) && setActive(false),
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)($54cc07ecaf352272$var$Item, {
                active: active,
                item: item,
                onClose: onClose,
                setActive: ()=>setActive(true)
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)($54cc07ecaf352272$var$Dropdown, {
                items: item.items,
                subMenu: true,
                visible: active,
                onClose: onClose
            })
        ]
    });
};
const $54cc07ecaf352272$var$Item = ({ item: item, active: active, setActive: setActive, onClose: onClose })=>{
    const actions = (0, $b9bf89f7d3b36cd8$export$2e2bcd8739ae039)();
    const actionHandler = item.action ? actions[item.action]?.handler : null;
    const hotKeyLabel = item.action ? actions[item.action]?.label : null;
    const actionDisabled = actions[item.action]?.disabled?.();
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $7cc6199b5ef516d3$export$ef9839ae55b8ba40), {
        onClick: actionHandler ? (e)=>{
            actionHandler(e);
            onClose();
        } : item.items?.length > 0 ? setActive : undefined,
        disabled: !actionHandler && !item.items || item.items?.length === 0 || actionDisabled,
        type: "button",
        $active: active,
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("label", {
                children: item.label
            }),
            item.shortcut && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $7cc6199b5ef516d3$export$59451aa6b6270879), {
                "aria-hidden": "true",
                children: item.shortcut
            }),
            !item.shortcut && hotKeyLabel && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $7cc6199b5ef516d3$export$59451aa6b6270879), {
                "aria-hidden": "true",
                children: hotKeyLabel
            }),
            item.items && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $dfbd774c055342cf$export$2e2bcd8739ae039), {
                size: "1em"
            })
        ]
    });
};
const $54cc07ecaf352272$var$Dropdown = ({ subMenu: subMenu, visible: visible = true, items: items, onClose: onClose, getRef: getRef, ...props })=>{
    const dropdownRef = (0, $h2ArV.useRef)();
    // Close dropdown if click outside
    const handleClick = (0, $h2ArV.useCallback)((e)=>!dropdownRef.current?.contains(e.target) && onClose(), [
        dropdownRef.current,
        onClose
    ]);
    // Close dropdown if escape pressed
    const handleKey = (0, $h2ArV.useCallback)((e)=>e.key === 'Escape' && onClose(), [
        onClose
    ]);
    (0, $h2ArV.useEffect)(()=>{
        if (!subMenu && visible) {
            document.addEventListener('click', handleClick);
            document.addEventListener('keydown', handleKey);
        }
        return ()=>{
            document.removeEventListener('click', handleClick);
            document.removeEventListener('keydown', handleKey);
        };
    }, [
        visible,
        subMenu,
        onClose,
        handleClick,
        handleKey
    ]);
    (0, $h2ArV.useEffect)(()=>dropdownRef.current && getRef && getRef(dropdownRef.current), [
        dropdownRef.current
    ]);
    if (!visible) return null;
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $7cc6199b5ef516d3$export$e6dfd72ab29f8598), {
        onContextMenu: (e)=>e.preventDefault(),
        $subMenu: subMenu,
        $visible: visible,
        ref: dropdownRef,
        // Close dropdown if focus leaves
        onBlur: (e)=>!subMenu && visible && !e.currentTarget.contains(e.relatedTarget),
        ...props,
        children: [
            items?.map((item, i)=>{
                if (item === 'hr') return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $7cc6199b5ef516d3$export$2e0a83ec2e27ecbb), {}, `hr-${i}`);
                else if (item.items) return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)($54cc07ecaf352272$var$ItemWithItems, {
                    item: item,
                    onClose: onClose
                }, item.label);
                else return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)($54cc07ecaf352272$var$Item, {
                    item: item,
                    onClose: onClose
                }, item.label);
            }),
            props.children
        ]
    });
};
var $54cc07ecaf352272$export$2e2bcd8739ae039 = $54cc07ecaf352272$var$Dropdown;



const $b0d6c4d3895396a0$var$Label = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('label')`
  display: block;
  margin-bottom: .3em;
`;
var $b0d6c4d3895396a0$export$2e2bcd8739ae039 = $b0d6c4d3895396a0$var$Label;



/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $a6478bf6bca06698$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m18 15-6-6-6 6",
            key: "153udz"
        }
    ]
];
const $a6478bf6bca06698$export$2e2bcd8739ae039 = (0, $764ec6f19a629312$export$2e2bcd8739ae039)("chevron-up", $a6478bf6bca06698$export$3efd853dbb351e94);




const $f6e8677b6444165c$export$5418e09f9ada53c4 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('details')`
  summary {
    > .chevron-down { display: initial; }
    > .chevron-up { display: none; }
  }

  &[open] {
    summary {
      > .chevron-down { display: none; }
      > .chevron-up { display: initial; }
    }
  }

  summary {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1em;
    user-select: none;
    cursor: pointer;
  }
`;


const $068baefaa3046cf8$var$Details = ({ label: label, children: children })=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $f6e8677b6444165c$export$5418e09f9ada53c4), {
        open: true,
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $f6c0a8acd60d8875$export$2e2bcd8739ae039), {
                as: "summary",
                children: [
                    label,
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $65c5e8bf16e9c608$export$2e2bcd8739ae039), {
                        className: "chevron-down"
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $a6478bf6bca06698$export$2e2bcd8739ae039), {
                        className: "chevron-up"
                    })
                ]
            }),
            children
        ]
    });
var $068baefaa3046cf8$export$2e2bcd8739ae039 = $068baefaa3046cf8$var$Details;



const $782e9208955d1521$var$Table = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('table')`
  border-spacing: 0;
  --table-radius: .3rem;
  --table-border-color: var(--input-border);

  tr {
    &:first-of-type > th, &:first-of-type > td {
      border-top: 1px solid var(--table-border-color);

      &:nth-child(1) {
        border-top-left-radius: var(--table-radius);
      }

      &:nth-last-child(1) {
        border-top-right-radius: var(--table-radius);
      }
    }

    &:last-of-type > th, &:last-of-type > td {
      &:nth-child(1) {
        border-bottom-left-radius: var(--table-radius);
      }

      &:nth-last-child(1) {
        border-bottom-right-radius: var(--table-radius);
      }
    }
  }

  th, td {
    border-bottom: 1px solid var(--table-border-color);
    border-left: 1px solid var(--table-border-color);
    padding: .5em;

    &:nth-last-child(1) {
      border-right: 1px solid var(--table-border-color);
    }
  }

   th {
    background: var(--toolbar);
    font-weight: 400;
    border-color: var(--table-border-color);
   }

   td {
    font-family: var(--font-mono);
    text-align: center;
   }
`;
var $782e9208955d1521$export$2e2bcd8739ae039 = $782e9208955d1521$var$Table;




var $h2ArV = parcelRequire("h2ArV");

const $02124e32ef33dd56$export$b04be29aa201d4f5 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('label', (0, $h2ArV.forwardRef))`
  text-transform: uppercase;
  font-size: .75em;
  font-weight: 600;
  letter-spacing: .1em;
  background: var(--toolbar);
  color: var(--input-border);
  display: block;
  padding: .7em .8rem;
`;


const $f6c0a8acd60d8875$var$SectionLabel = ({ children: children, ...props })=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $02124e32ef33dd56$export$b04be29aa201d4f5), {
        ...props,
        children: children
    });
var $f6c0a8acd60d8875$export$2e2bcd8739ae039 = $f6c0a8acd60d8875$var$SectionLabel;




var $h2ArV = parcelRequire("h2ArV");

const $235e0e1128ba9dcf$export$e6dfd72ab29f8598 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  background: var(--white);
  color: var(--black);
  border-start-start-radius: .3em;
  border-start-end-radius: .3em;
  padding: .6em;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  overflow-x: auto;
  width: 100%;
`;
const $235e0e1128ba9dcf$export$dd7ac4f3af4ba2d7 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('svg')`
  height: 2rem;
  min-width: 2rem;

  circle {
    stroke: currentColor;
    stroke-width: 1px;
    fill: var(--state-bg-light);
  }
  text {
    font-size: 1.2em;
  }
`;
const $235e0e1128ba9dcf$export$466b0433b4180de3 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('svg')`
  height: 2rem;
  min-width: 1rem;

  polygon {
    fill: var(--white);
    stroke: currentColor;
    stroke-width: 1px;
  }
`;
const $235e0e1128ba9dcf$export$a97425c616e1d1ce = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('svg')`
  height: 2rem;
  min-width: 1.6rem;

  path {
    fill: none;
    stroke: var(--success);
    ${(props)=>props.$error && 'stroke: var(--error);'}
    stroke-width: 2px;
    stroke-linecap: round;
  }
`;


const $46256ad23271a97e$var$InitialArrow = ()=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $235e0e1128ba9dcf$export$466b0433b4180de3), {
        viewBox: "0 0 14 32",
        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("polygon", {
            points: "14,16 2,0 2,32"
        })
    });
const $46256ad23271a97e$var$Transition = ({ error: error })=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $235e0e1128ba9dcf$export$a97425c616e1d1ce), {
        viewBox: "0 0 25 32",
        $error: error,
        children: [
            !error && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                d: "M0 16 L24 16 m-7 -7 l7 7 l-7 7"
            }),
            error && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                d: "M0 16 L22 16 m-7 -7 l7 7 l-7 7 M24 8 l0 16"
            })
        ]
    });
const $46256ad23271a97e$var$State = ({ final: final, children: children })=>{
    const textRef = (0, $h2ArV.useRef)();
    const [box, setBox] = (0, $h2ArV.useState)();
    (0, $h2ArV.useEffect)(()=>setBox(textRef.current?.getBBox()), [
        textRef.current
    ]);
    const width = Math.max(box?.width ?? 0, 32);
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $235e0e1128ba9dcf$export$dd7ac4f3af4ba2d7), {
        viewBox: "0 0 32 32",
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                r: "15",
                cx: "50%",
                cy: "50%"
            }),
            final && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                r: "12",
                cx: "50%",
                cy: "50%"
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("svg", {
                preserveAspectRatio: "xMinYMin",
                viewBox: `0 0 ${width} ${width}`,
                width: "70%",
                x: "15%",
                y: "15%",
                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("text", {
                    ref: textRef,
                    textAnchor: "middle",
                    alignmentBaseline: "central",
                    x: "50%",
                    y: "50%",
                    children: children
                })
            })
        ]
    });
};
const $46256ad23271a97e$var$TracePreview = ({ result: result, step: step, states: states, statePrefix: statePrefix = 'q', ...props })=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $235e0e1128ba9dcf$export$e6dfd72ab29f8598), {
        ...props,
        children: result.trace.slice(0, step + 1).map((item, i)=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $h2ArV.Fragment), {
                children: [
                    item.read === null && i === 0 && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)($46256ad23271a97e$var$InitialArrow, {}),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)($46256ad23271a97e$var$State, {
                        final: i + 1 === result.trace.length && result.accepted,
                        children: states?.find((s)=>s.id === item.to)?.name ?? statePrefix + item.to
                    }),
                    (i < step || !result.accepted && result.transitionCount === step) && (result.trace.length > 1 || !result.accepted) && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)($46256ad23271a97e$var$Transition, {
                        error: i + 1 === result.trace.length
                    })
                ]
            }, i))
    });
var $46256ad23271a97e$export$2e2bcd8739ae039 = $46256ad23271a97e$var$TracePreview;




const $e44002cbb4794c3a$var$Preference = ({ label: label, description: description, children: children, fullWidth: fullWidth, ...props })=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $7cc0a06bcf2a84f7$export$e6dfd72ab29f8598), {
        $fullWidth: fullWidth,
        ...props,
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("span", {
                        children: label
                    }),
                    description && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $7cc0a06bcf2a84f7$export$393edc798c47379d), {
                        children: description
                    })
                ]
            }),
            children
        ]
    });
var $e44002cbb4794c3a$export$2e2bcd8739ae039 = $e44002cbb4794c3a$var$Preference;




var $3NhwF = parcelRequire("3NhwF");

var $h2ArV = parcelRequire("h2ArV");


const $f8afe5d5b5d08856$export$42a852a2b6b56249 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  --cell-width: 35px;

  position: fixed;
  padding-block: .8em;
  background: var(--surface);
  width: calc(var(--cell-width) * 5);
  pointer-events: none;
  border-radius: .3rem;
  transform: translate(-50%, -180%);
  transform-origin: bottom;

  &::before {
    display: block;
    content: '';
    width: 2em;
    aspect-ratio: 1;
    transform: translate(-50%, -70%) rotate(45deg);
    border-radius: .3rem;
    background: inherit;
    top: 100%;
    position: absolute;
    left: 50%;
  }

  &.animate {
    transition: top .2s, left .2s;
  }

  & > div {
    overflow: hidden;
  }
`;
const $f8afe5d5b5d08856$export$528574b07d6189d5 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  flex-direction: row;
  width: max-content;

  transform: translateX(calc(${(p)=>-p.$index + 4} * var(--cell-width)));
  transition: transform .1s;
`;
const $f8afe5d5b5d08856$export$52fc9fed8e569929 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('span')`
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1;
  min-width: var(--cell-width);
  font-family: var(--font-mono);
  font-size: 1.2rem;
  box-sizing: border-box;
  background: var(--white);
  color: var(--black);
  border-left: 1px dashed var(--input-border);

  &:last-of-type {
    border-right: 1px dashed var(--input-border);
  }

  ${(p)=>p.$consumed && `
    color: #CCC;
  `}
`;



const $b3533db5722e5be6$var$TraceStepBubble = ({ stateID: stateID, input: input, index: index })=>{
    const [targetState, setTargetState] = (0, $h2ArV.useState)();
    const [transitionsEnabled, setTransitionsEnabled] = (0, $h2ArV.useState)(false);
    const viewToScreenSpace = (0, $2c8de4ab9c0d9b91$export$2e2bcd8739ae039)((s)=>s.viewToScreenSpace);
    const states = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project?.states);
    const viewPosition = (0, $2c8de4ab9c0d9b91$export$2e2bcd8739ae039)((s)=>s.position);
    const viewScale = (0, $2c8de4ab9c0d9b91$export$2e2bcd8739ae039)((s)=>s.scale);
    const viewSize = (0, $2c8de4ab9c0d9b91$export$2e2bcd8739ae039)((s)=>s.size);
    // Update state from ID
    (0, $h2ArV.useEffect)(()=>{
        setTargetState(states.find((s)=>s.id === stateID));
    }, [
        stateID,
        states
    ]);
    // Determine location on screen
    const position = (0, $h2ArV.useMemo)(()=>targetState && viewToScreenSpace(targetState.x, targetState.y), [
        targetState,
        viewPosition,
        viewScale,
        viewSize
    ]);
    (0, $h2ArV.useEffect)(()=>{
        setTransitionsEnabled(true);
        setTimeout(()=>setTransitionsEnabled(false), 300);
    }, [
        stateID,
        index
    ]);
    return /*#__PURE__*/ (0, $3NhwF.createPortal)(/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $d15f6e8ca8604f1a$exports.Fragment), {
        children: position && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $f8afe5d5b5d08856$export$42a852a2b6b56249), {
            style: {
                left: position[0],
                top: position[1]
            },
            className: transitionsEnabled ? 'animate' : '',
            children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $a0b62be9acbbd719$export$b56007f12edf0c17), {}),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $f8afe5d5b5d08856$export$528574b07d6189d5), {
                        $index: index + 2,
                        children: [
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $a0b62be9acbbd719$export$763f5d34ceb8e0c8), {}),
                            input?.split('').map((symbol, i)=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $f8afe5d5b5d08856$export$52fc9fed8e569929), {
                                    $consumed: i < index,
                                    children: symbol
                                }, i)),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $a0b62be9acbbd719$export$763f5d34ceb8e0c8), {
                                flipped: true
                            })
                        ]
                    })
                ]
            })
        })
    }), document.querySelector('#editor-panel-wrapper'));
};
var $b3533db5722e5be6$export$2e2bcd8739ae039 = $b3533db5722e5be6$var$TraceStepBubble;





var $h2ArV = parcelRequire("h2ArV");


var $h2ArV = parcelRequire("h2ArV");
const $ded9600a58abc312$export$f8fd43a15610a9c6 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('input', (0, $h2ArV.forwardRef))`
  height: 0;
  width: 0;
  border: 0;
  margin: 0;
  padding: 0;
  font-size: 0;
  opacity: 0;
  position: absolute;
`;
const $ded9600a58abc312$export$72a2d32c474a0267 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  height: 25px;
  width: 45px;
  min-width: 45px;
  box-sizing: border-box;
  background-color: var(--disabled-button);
  border: 3px solid var(--disabled-button);
  border-radius: 10em;
  transition: box-shadow .1s, background-color .1s, border-color .1s;
  position: relative;
  cursor: pointer;

  div {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    background-color: var(--white);
    border-radius: 10em;
    transform: translate(0, -50%);
    height: 100%;
    aspect-ratio: 1 / 1;
    transition: background-color .15s, padding .15s, transform .15s;
  }

  input:checked + & {
    background-color: var(--primary);
    border-color: var(--primary);

    div {
      transform: translate(100%, -50%);
    }
  }
  input:focus-visible + & {
    box-shadow: 0 0 0 2px var(--primary);
  }
`;


const $0770ae362b3cd6e9$var$Switch = /*#__PURE__*/ (0, $h2ArV.forwardRef)((props, ref)=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("label", {
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ded9600a58abc312$export$f8fd43a15610a9c6), {
                id: props.id ?? props.name,
                type: "checkbox",
                ref: ref,
                ...props
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ded9600a58abc312$export$72a2d32c474a0267), {
                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("div", {})
            })
        ]
    }));
var $0770ae362b3cd6e9$export$2e2bcd8739ae039 = $0770ae362b3cd6e9$var$Switch;





const $8e3d8eb1f1e99862$export$42a852a2b6b56249 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('footer')`
  display: flex;
  align-items: center;
  gap: 1em;
  padding-inline: 1em;
  margin-top: auto;
  bottom: 0;
  left: 0;
  width: 100%;
  min-height: 3em;
  box-sizing: border-box;

  background: var(--toolbar);
`;
const $8e3d8eb1f1e99862$export$cbef165a0b571911 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('span')`
  color: var(--white);
  font-size: .9em;

  > a {
    text-decoration: underline;
    color: inherit;
    &:hover {
      color: var(--primary);
    }
  }
`;


const $b2aae227ced67f2d$var$isString = (obj)=>typeof obj === 'string';
const $b2aae227ced67f2d$var$defer = ()=>{
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
};
const $b2aae227ced67f2d$var$makeString = (object)=>{
    if (object == null) return '';
    return '' + object;
};
const $b2aae227ced67f2d$var$copy = (a, s, t)=>{
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
};
const $b2aae227ced67f2d$var$lastOfPathSeparatorRegExp = /###/g;
const $b2aae227ced67f2d$var$cleanKey = (key)=>key && key.indexOf('###') > -1 ? key.replace($b2aae227ced67f2d$var$lastOfPathSeparatorRegExp, '.') : key;
const $b2aae227ced67f2d$var$canNotTraverseDeeper = (object)=>!object || $b2aae227ced67f2d$var$isString(object);
const $b2aae227ced67f2d$var$getLastOfPath = (object, path, Empty)=>{
    const stack = !$b2aae227ced67f2d$var$isString(path) ? path : path.split('.');
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if ($b2aae227ced67f2d$var$canNotTraverseDeeper(object)) return {};
        const key = $b2aae227ced67f2d$var$cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if ($b2aae227ced67f2d$var$canNotTraverseDeeper(object)) return {};
    return {
        obj: object,
        k: $b2aae227ced67f2d$var$cleanKey(stack[stackIndex])
    };
};
const $b2aae227ced67f2d$var$setPath = (object, path, newValue)=>{
    const { obj: obj, k: k } = $b2aae227ced67f2d$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $b2aae227ced67f2d$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $b2aae227ced67f2d$var$getLastOfPath(object, p, Object);
        if (last && last.obj && typeof last.obj[`${last.k}.${e}`] !== 'undefined') last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
};
const $b2aae227ced67f2d$var$pushPath = (object, path, newValue, concat)=>{
    const { obj: obj, k: k } = $b2aae227ced67f2d$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
};
const $b2aae227ced67f2d$var$getPath = (object, path)=>{
    const { obj: obj, k: k } = $b2aae227ced67f2d$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    return obj[k];
};
const $b2aae227ced67f2d$var$getPathWithDefaults = (data, defaultData, key)=>{
    const value = $b2aae227ced67f2d$var$getPath(data, key);
    if (value !== undefined) return value;
    return $b2aae227ced67f2d$var$getPath(defaultData, key);
};
const $b2aae227ced67f2d$var$deepExtend = (target, source, overwrite)=>{
    for(const prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if ($b2aae227ced67f2d$var$isString(target[prop]) || target[prop] instanceof String || $b2aae227ced67f2d$var$isString(source[prop]) || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $b2aae227ced67f2d$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
};
const $b2aae227ced67f2d$var$regexEscape = (str)=>str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
var $b2aae227ced67f2d$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
const $b2aae227ced67f2d$var$escape = (data)=>{
    if ($b2aae227ced67f2d$var$isString(data)) return data.replace(/[&<>"'\/]/g, (s)=>$b2aae227ced67f2d$var$_entityMap[s]);
    return data;
};
class $b2aae227ced67f2d$var$RegExpCache {
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
}
const $b2aae227ced67f2d$var$chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
const $b2aae227ced67f2d$var$looksLikeObjectPathRegExpCache = new $b2aae227ced67f2d$var$RegExpCache(20);
const $b2aae227ced67f2d$var$looksLikeObjectPath = (key, nsSeparator, keySeparator)=>{
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    const possibleChars = $b2aae227ced67f2d$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = $b2aae227ced67f2d$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === '?' ? '\\?' : c).join('|')})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
};
const $b2aae227ced67f2d$var$deepFind = function(obj, path) {
    let keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== 'object') return undefined;
        let next;
        let nextPath = '';
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    'string',
                    'number',
                    'boolean'
                ].indexOf(typeof next) > -1 && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
};
const $b2aae227ced67f2d$var$getCleanedCode = (code)=>code && code.replace('_', '-');
const $b2aae227ced67f2d$var$consoleLogger = {
    type: 'logger',
    log (args) {
        this.output('log', args);
    },
    warn (args) {
        this.output('warn', args);
    },
    error (args) {
        this.output('error', args);
    },
    output (type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
class $b2aae227ced67f2d$var$Logger {
    constructor(concreteLogger){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.init(concreteLogger, options);
    }
    init(concreteLogger) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.prefix = options.prefix || 'i18next:';
        this.logger = concreteLogger || $b2aae227ced67f2d$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.forward(args, 'log', '', true);
    }
    warn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return this.forward(args, 'warn', '', true);
    }
    error() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return this.forward(args, 'error', '');
    }
    deprecate() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if ($b2aae227ced67f2d$var$isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $b2aae227ced67f2d$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $b2aae227ced67f2d$var$Logger(this.logger, options);
    }
}
var $b2aae227ced67f2d$var$baseLogger = new $b2aae227ced67f2d$var$Logger();
class $b2aae227ced67f2d$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(' ').forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach((_ref)=>{
                let [observer, numTimesAdded] = _ref;
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers['*']) {
            const cloned = Array.from(this.observers['*'].entries());
            cloned.forEach((_ref2)=>{
                let [observer, numTimesAdded] = _ref2;
                for(let i = 0; i < numTimesAdded; i++)observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
}
class $b2aae227ced67f2d$var$ResourceStore extends $b2aae227ced67f2d$var$EventEmitter {
    constructor(data){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                'translation'
            ],
            defaultNS: 'translation'
        };
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.indexOf('.') > -1) path = lng.split('.');
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if ($b2aae227ced67f2d$var$isString(key) && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $b2aae227ced67f2d$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.indexOf('.') > -1) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join('.');
        }
        if (result || !ignoreJSONStructure || !$b2aae227ced67f2d$var$isString(key)) return result;
        return $b2aae227ced67f2d$var$deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
    addResource(lng, ns, key, value) {
        let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            silent: false
        };
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $b2aae227ced67f2d$var$setPath(this.data, path, value);
        if (!options.silent) this.emit('added', lng, ns, key, value);
    }
    addResources(lng, ns, resources) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
            silent: false
        };
        for(const m in resources)if ($b2aae227ced67f2d$var$isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
            silent: false,
            skipCopy: false
        };
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $b2aae227ced67f2d$var$getPath(this.data, path) || {};
        if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $b2aae227ced67f2d$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $b2aae227ced67f2d$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit('removed', lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        if (this.options.compatibilityAPI === 'v1') return {
            ...this.getResource(lng, ns)
        };
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $b2aae227ced67f2d$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            if (this.processors[processor]) value = this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
const $b2aae227ced67f2d$var$checkedLoadedFor = {};
class $b2aae227ced67f2d$var$Translator extends $b2aae227ced67f2d$var$EventEmitter {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        $b2aae227ced67f2d$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        this.logger = $b2aae227ced67f2d$var$baseLogger.create('translator');
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        if (key === undefined || key === null) return false;
        const resolved = this.resolve(key, options);
        return resolved && resolved.res !== undefined;
    }
    extractFromKey(key, options) {
        let nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let namespaces = options.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !$b2aae227ced67f2d$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: $b2aae227ced67f2d$var$isString(namespaces) ? [
                    namespaces
                ] : namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        return {
            key: key,
            namespaces: $b2aae227ced67f2d$var$isString(namespaces) ? [
                namespaces
            ] : namespaces
        };
    }
    translate(keys, options, lastKey) {
        if (typeof options !== 'object' && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof options === 'object') options = {
            ...options
        };
        if (!options) options = {};
        if (keys === undefined || keys === null) return '';
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], options);
        const namespace = namespaces[namespaces.length - 1];
        const lng = options.lng || this.language;
        const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng && lng.toLowerCase() === 'cimode') {
            if (appendNamespaceToCIMode) {
                const nsSeparator = options.nsSeparator || this.options.nsSeparator;
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(options)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(options)
            };
            return key;
        }
        const resolved = this.resolve(keys, options);
        let res = resolved && resolved.res;
        const resUsedKey = resolved && resolved.usedKey || key;
        const resExactUsedKey = resolved && resolved.exactUsedKey || key;
        const resType = Object.prototype.toString.apply(res);
        const noObject = [
            '[object Number]',
            '[object Function]',
            '[object RegExp]'
        ];
        const joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const handleAsObject = !$b2aae227ced67f2d$var$isString(res) && typeof res !== 'boolean' && typeof res !== 'number';
        if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !($b2aae227ced67f2d$var$isString(joinArrays) && Array.isArray(res))) {
            if (!options.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, {
                    ...options,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(options);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = Array.isArray(res);
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    copy[m] = this.translate(deepKey, {
                        ...options,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = res[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && $b2aae227ced67f2d$var$isString(joinArrays) && Array.isArray(res)) {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, options, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            const needsPluralHandling = options.count !== undefined && !$b2aae227ced67f2d$var$isString(options.count);
            const hasDefaultValue = $b2aae227ced67f2d$var$Translator.hasDefaultValue(options);
            const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
            const defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, {
                ordinal: false
            }) : '';
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const defaultValue = needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] || options[`defaultValue${defaultValueSuffix}`] || options[`defaultValue${defaultValueSuffixOrdinalFallback}`] || options.defaultValue;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...options,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                else lngs.push(options.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                    else if (this.backendConnector && this.backendConnector.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                    this.emit('missingKey', l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, options);
                        if (needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, options[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, options, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                if (this.options.compatibilityAPI !== 'v1') res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : undefined);
                else res = this.options.parseMissingKeyHandler(res);
            }
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(options);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, options, resolved, lastKey) {
        var _this = this;
        if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...options
        }, options.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!options.skipInterpolation) {
            if (options.interpolation) this.interpolator.init({
                ...options,
                interpolation: {
                    ...this.options.interpolation,
                    ...options.interpolation
                }
            });
            const skipOnVariables = $b2aae227ced67f2d$var$isString(res) && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = options.replace && !$b2aae227ced67f2d$var$isString(options.replace) ? options.replace : options;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, options.lng || this.language || resolved.usedLng, options);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) options.nest = false;
            }
            if (!options.lng && this.options.compatibilityAPI !== 'v1' && resolved && resolved.res) options.lng = this.language || resolved.usedLng;
            if (options.nest !== false) res = this.interpolator.nest(res, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (lastKey && lastKey[0] === args[0] && !options.context) {
                    _this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return _this.translate(...args, key);
            }, options);
            if (options.interpolation) this.interpolator.reset();
        }
        const postProcess = options.postProcess || this.options.postProcess;
        const postProcessorNames = $b2aae227ced67f2d$var$isString(postProcess) ? [
            postProcess
        ] : postProcess;
        if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $b2aae227ced67f2d$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(options)
            },
            ...options
        } : options, this);
        return res;
    }
    resolve(keys) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if ($b2aae227ced67f2d$var$isString(keys)) keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, options);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = options.count !== undefined && !$b2aae227ced67f2d$var$isString(options.count);
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const needsContextHandling = options.context !== undefined && ($b2aae227ced67f2d$var$isString(options.context) || typeof options.context === 'number') && options.context !== '';
            const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$b2aae227ced67f2d$var$checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(usedNS)) {
                    $b2aae227ced67f2d$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat && this.i18nFormat.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count, options);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            finalKeys.push(key + pluralSuffix);
                            if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator}${options.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                finalKeys.push(contextKey + pluralSuffix);
                                if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, options);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
    getResource(code, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const optionsKeys = [
            'defaultValue',
            'ordinal',
            'context',
            'replace',
            'lng',
            'lngs',
            'fallbackLng',
            'ns',
            'keySeparator',
            'nsSeparator',
            'returnObjects',
            'returnDetails',
            'joinArrays',
            'postProcess',
            'interpolation'
        ];
        const useOptionsReplaceForData = options.replace && !$b2aae227ced67f2d$var$isString(options.replace);
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== 'undefined') data.count = options.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = 'defaultValue';
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
}
const $b2aae227ced67f2d$var$capitalize = (string)=>string.charAt(0).toUpperCase() + string.slice(1);
class $b2aae227ced67f2d$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $b2aae227ced67f2d$var$baseLogger.create('languageUtils');
    }
    getScriptPartFromCode(code) {
        code = $b2aae227ced67f2d$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return null;
        const p = code.split('-');
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === 'x') return null;
        return this.formatLanguageCode(p.join('-'));
    }
    getLanguagePartFromCode(code) {
        code = $b2aae227ced67f2d$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return code;
        const p = code.split('-');
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if ($b2aae227ced67f2d$var$isString(code) && code.indexOf('-') > -1) {
            if (typeof Intl !== 'undefined' && typeof Intl.getCanonicalLocales !== 'undefined') try {
                let formattedCode = Intl.getCanonicalLocales(code)[0];
                if (formattedCode && this.options.lowerCaseLng) formattedCode = formattedCode.toLowerCase();
                if (formattedCode) return formattedCode;
            } catch (e) {}
            const specialCases = [
                'hans',
                'hant',
                'latn',
                'cyrl',
                'cans',
                'mong',
                'arab'
            ];
            let p = code.split('-');
            if (this.options.lowerCaseLng) p = p.map((part)=>part.toLowerCase());
            else if (p.length === 2) {
                p[0] = p[0].toLowerCase();
                p[1] = p[1].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $b2aae227ced67f2d$var$capitalize(p[1].toLowerCase());
            } else if (p.length === 3) {
                p[0] = p[0].toLowerCase();
                if (p[1].length === 2) p[1] = p[1].toUpperCase();
                if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $b2aae227ced67f2d$var$capitalize(p[1].toLowerCase());
                if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $b2aae227ced67f2d$var$capitalize(p[2].toLowerCase());
            }
            return p.join('-');
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
                if (supportedLng.indexOf('-') > 0 && lngOnly.indexOf('-') < 0 && supportedLng.substring(0, supportedLng.indexOf('-')) === lngOnly) return supportedLng;
                if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
        if ($b2aae227ced67f2d$var$isString(fallbacks)) fallbacks = [
            fallbacks
        ];
        if (Array.isArray(fallbacks)) return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if ($b2aae227ced67f2d$var$isString(code) && (code.indexOf('-') > -1 || code.indexOf('_') > -1)) {
            if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
            if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
        } else if ($b2aae227ced67f2d$var$isString(code)) addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
let $b2aae227ced67f2d$var$sets = [
    {
        lngs: [
            'ach',
            'ak',
            'am',
            'arn',
            'br',
            'fil',
            'gun',
            'ln',
            'mfe',
            'mg',
            'mi',
            'oc',
            'pt',
            'pt-BR',
            'tg',
            'tl',
            'ti',
            'tr',
            'uz',
            'wa'
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            'af',
            'an',
            'ast',
            'az',
            'bg',
            'bn',
            'ca',
            'da',
            'de',
            'dev',
            'el',
            'en',
            'eo',
            'es',
            'et',
            'eu',
            'fi',
            'fo',
            'fur',
            'fy',
            'gl',
            'gu',
            'ha',
            'hi',
            'hu',
            'hy',
            'ia',
            'it',
            'kk',
            'kn',
            'ku',
            'lb',
            'mai',
            'ml',
            'mn',
            'mr',
            'nah',
            'nap',
            'nb',
            'ne',
            'nl',
            'nn',
            'no',
            'nso',
            'pa',
            'pap',
            'pms',
            'ps',
            'pt-PT',
            'rm',
            'sco',
            'se',
            'si',
            'so',
            'son',
            'sq',
            'sv',
            'sw',
            'ta',
            'te',
            'tk',
            'ur',
            'yo'
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            'ay',
            'bo',
            'cgg',
            'fa',
            'ht',
            'id',
            'ja',
            'jbo',
            'ka',
            'km',
            'ko',
            'ky',
            'lo',
            'ms',
            'sah',
            'su',
            'th',
            'tt',
            'ug',
            'vi',
            'wo',
            'zh'
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            'be',
            'bs',
            'cnr',
            'dz',
            'hr',
            'ru',
            'sr',
            'uk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            'ar'
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            'cs',
            'sk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            'csb',
            'pl'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            'cy'
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            'fr'
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            'ga'
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            'gd'
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            'is'
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            'jv'
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            'kw'
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            'lt'
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            'lv'
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            'mk'
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            'mnk'
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            'mt'
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            'or'
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            'ro'
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            'sl'
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            'he',
            'iw'
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
let $b2aae227ced67f2d$var$_rulesPluralsTypes = {
    1: (n)=>Number(n > 1),
    2: (n)=>Number(n != 1),
    3: (n)=>0,
    4: (n)=>Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
    5: (n)=>Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5),
    6: (n)=>Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2),
    7: (n)=>Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
    8: (n)=>Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3),
    9: (n)=>Number(n >= 2),
    10: (n)=>Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4),
    11: (n)=>Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3),
    12: (n)=>Number(n % 10 != 1 || n % 100 == 11),
    13: (n)=>Number(n !== 0),
    14: (n)=>Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3),
    15: (n)=>Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
    16: (n)=>Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2),
    17: (n)=>Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1),
    18: (n)=>Number(n == 0 ? 0 : n == 1 ? 1 : 2),
    19: (n)=>Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3),
    20: (n)=>Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2),
    21: (n)=>Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0),
    22: (n)=>Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3)
};
const $b2aae227ced67f2d$var$nonIntlVersions = [
    'v1',
    'v2',
    'v3'
];
const $b2aae227ced67f2d$var$intlVersions = [
    'v4'
];
const $b2aae227ced67f2d$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
const $b2aae227ced67f2d$var$createRules = ()=>{
    const rules = {};
    $b2aae227ced67f2d$var$sets.forEach((set)=>{
        set.lngs.forEach((l)=>{
            rules[l] = {
                numbers: set.nr,
                plurals: $b2aae227ced67f2d$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
};
class $b2aae227ced67f2d$var$PluralResolver {
    constructor(languageUtils){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $b2aae227ced67f2d$var$baseLogger.create('pluralResolver');
        if ((!this.options.compatibilityJSON || $b2aae227ced67f2d$var$intlVersions.includes(this.options.compatibilityJSON)) && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
            this.options.compatibilityJSON = 'v3';
            this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
        }
        this.rules = $b2aae227ced67f2d$var$createRules();
        this.pluralRulesCache = {};
    }
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    clearCache() {
        this.pluralRulesCache = {};
    }
    getRule(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (this.shouldUseIntlApi()) {
            const cleanedCode = $b2aae227ced67f2d$var$getCleanedCode(code === 'dev' ? 'en' : code);
            const type = options.ordinal ? 'ordinal' : 'cardinal';
            const cacheKey = JSON.stringify({
                cleanedCode: cleanedCode,
                type: type
            });
            if (cacheKey in this.pluralRulesCache) return this.pluralRulesCache[cacheKey];
            let rule;
            try {
                rule = new Intl.PluralRules(cleanedCode, {
                    type: type
                });
            } catch (err) {
                if (!code.match(/-|_/)) return;
                const lngPart = this.languageUtils.getLanguagePartFromCode(code);
                rule = this.getRule(lngPart, options);
            }
            this.pluralRulesCache[cacheKey] = rule;
            return rule;
        }
        return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
    needsPlural(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
        return rule && rule.numbers.length > 1;
    }
    getPluralFormsOfKey(code, key) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (!rule) return [];
        if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$b2aae227ced67f2d$var$suffixesOrder[pluralCategory1] - $b2aae227ced67f2d$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
        return rule.numbers.map((number)=>this.getSuffix(code, number, options));
    }
    getSuffix(code, count) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const rule = this.getRule(code, options);
        if (rule) {
            if (this.shouldUseIntlApi()) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
            return this.getSuffixRetroCompatible(rule, count);
        }
        this.logger.warn(`no plural rule found for: ${code}`);
        return '';
    }
    getSuffixRetroCompatible(rule, count) {
        const idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        let suffix = rule.numbers[idx];
        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
            if (suffix === 2) suffix = 'plural';
            else if (suffix === 1) suffix = '';
        }
        const returnSuffix = ()=>this.options.prepend && suffix.toString() ? this.options.prepend + suffix.toString() : suffix.toString();
        if (this.options.compatibilityJSON === 'v1') {
            if (suffix === 1) return '';
            if (typeof suffix === 'number') return `_plural_${suffix.toString()}`;
            return returnSuffix();
        } else if (this.options.compatibilityJSON === 'v2') return returnSuffix();
        else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
    shouldUseIntlApi() {
        return !$b2aae227ced67f2d$var$nonIntlVersions.includes(this.options.compatibilityJSON);
    }
}
const $b2aae227ced67f2d$var$deepFindWithDefaults = function(data, defaultData, key) {
    let keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
    let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    let path = $b2aae227ced67f2d$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && $b2aae227ced67f2d$var$isString(key)) {
        path = $b2aae227ced67f2d$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $b2aae227ced67f2d$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
};
const $b2aae227ced67f2d$var$regexSafe = (val)=>val.replace(/\$/g, '$$$$');
class $b2aae227ced67f2d$var$Interpolator {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $b2aae227ced67f2d$var$baseLogger.create('interpolator');
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || ((value)=>value);
        this.init(options);
    }
    init() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1, escapeValue: escapeValue, useRawValueToEscape: useRawValueToEscape, prefix: prefix, prefixEscaped: prefixEscaped, suffix: suffix, suffixEscaped: suffixEscaped, formatSeparator: formatSeparator, unescapeSuffix: unescapeSuffix, unescapePrefix: unescapePrefix, nestingPrefix: nestingPrefix, nestingPrefixEscaped: nestingPrefixEscaped, nestingSuffix: nestingSuffix, nestingSuffixEscaped: nestingSuffixEscaped, nestingOptionsSeparator: nestingOptionsSeparator, maxReplaces: maxReplaces, alwaysFormat: alwaysFormat } = options.interpolation;
        this.escape = escape$1 !== undefined ? escape$1 : $b2aae227ced67f2d$var$escape;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? $b2aae227ced67f2d$var$regexEscape(prefix) : prefixEscaped || '{{';
        this.suffix = suffix ? $b2aae227ced67f2d$var$regexEscape(suffix) : suffixEscaped || '}}';
        this.formatSeparator = formatSeparator || ',';
        this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix || '-';
        this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix || '';
        this.nestingPrefix = nestingPrefix ? $b2aae227ced67f2d$var$regexEscape(nestingPrefix) : nestingPrefixEscaped || $b2aae227ced67f2d$var$regexEscape('$t(');
        this.nestingSuffix = nestingSuffix ? $b2aae227ced67f2d$var$regexEscape(nestingSuffix) : nestingSuffixEscaped || $b2aae227ced67f2d$var$regexEscape(')');
        this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp && existingRegExp.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, 'g');
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $b2aae227ced67f2d$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($b2aae227ced67f2d$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>$b2aae227ced67f2d$var$regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? $b2aae227ced67f2d$var$regexSafe(this.escape(val)) : $b2aae227ced67f2d$var$regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === 'function') {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = $b2aae227ced67f2d$var$isString(temp) ? temp : '';
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = '';
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = '';
                    }
                } else if (!$b2aae227ced67f2d$var$isString(value) && !this.useRawValueToEscape) value = $b2aae227ced67f2d$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let match;
        let value;
        let clonedOptions;
        const handleHasOptions = (key, inheritedOptions)=>{
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
            return key;
        };
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && !$b2aae227ced67f2d$var$isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            let doReduce = false;
            if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                const r = match[1].split(this.formatSeparator).map((elem)=>elem.trim());
                match[1] = r.shift();
                formatters = r;
                doReduce = true;
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && !$b2aae227ced67f2d$var$isString(value)) return value;
            if (!$b2aae227ced67f2d$var$isString(value)) value = $b2aae227ced67f2d$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = '';
            }
            if (doReduce) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
const $b2aae227ced67f2d$var$parseFormatStr = (formatStr)=>{
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf('(') > -1) {
        const p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === 'currency' && optStr.indexOf(':') < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(';');
            opts.forEach((opt)=>{
                if (opt) {
                    const [key, ...rest] = opt.split(':');
                    const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                    const trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === 'false') formatOptions[trimmedKey] = false;
                    if (val === 'true') formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
};
const $b2aae227ced67f2d$var$createCachedFormatter = (fn)=>{
    const cache = {};
    return (val, lng, options)=>{
        let optForCache = options;
        if (options && options.interpolationkey && options.formatParams && options.formatParams[options.interpolationkey] && options[options.interpolationkey]) optForCache = {
            ...optForCache,
            [options.interpolationkey]: undefined
        };
        const key = lng + JSON.stringify(optForCache);
        let formatter = cache[key];
        if (!formatter) {
            formatter = fn($b2aae227ced67f2d$var$getCleanedCode(lng), options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
};
class $b2aae227ced67f2d$var$Formatter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $b2aae227ced67f2d$var$baseLogger.create('formatter');
        this.options = options;
        this.formats = {
            number: $b2aae227ced67f2d$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: $b2aae227ced67f2d$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: 'currency'
                });
                return (val)=>formatter.format(val);
            }),
            datetime: $b2aae227ced67f2d$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: $b2aae227ced67f2d$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || 'day');
            }),
            list: $b2aae227ced67f2d$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
        this.init(options);
    }
    init(services) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        this.formatSeparator = options.interpolation.formatSeparator || ',';
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $b2aae227ced67f2d$var$createCachedFormatter(fc);
    }
    format(value, format, lng) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const formats = format.split(this.formatSeparator);
        if (formats.length > 1 && formats[0].indexOf('(') > 1 && formats[0].indexOf(')') < 0 && formats.find((f)=>f.indexOf(')') > -1)) {
            const lastIndex = formats.findIndex((f)=>f.indexOf(')') > -1);
            formats[0] = [
                formats[0],
                ...formats.splice(1, lastIndex)
            ].join(this.formatSeparator);
        }
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $b2aae227ced67f2d$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
const $b2aae227ced67f2d$var$removePending = (q, name)=>{
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
};
class $b2aae227ced67f2d$var$Connector extends $b2aae227ced67f2d$var$EventEmitter {
    constructor(backend, store, services){
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $b2aae227ced67f2d$var$baseLogger.create('backendConnector');
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        if (this.backend && this.backend.init) this.backend.init(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit('failedLoading', lng, ns, err);
        if (!err && data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        if (err && data) this.state[name] = 0;
        const loaded = {};
        this.queue.forEach((q)=>{
            $b2aae227ced67f2d$var$pushPath(q.loaded, [
                lng
            ], ns);
            $b2aae227ced67f2d$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit('loaded', loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName) {
        let tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        let wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
        let callback = arguments.length > 5 ? arguments[5] : undefined;
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === 'function') r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let callback = arguments.length > 3 ? arguments[3] : undefined;
        if (!this.backend) {
            this.logger.warn('No backend was added via i18next.use. Will not load resources.');
            return callback && callback();
        }
        if ($b2aae227ced67f2d$var$isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
        if ($b2aae227ced67f2d$var$isString(namespaces)) namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name) {
        let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, 'read', undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
        let clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : ()=>{};
        if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
            return;
        }
        if (key === undefined || key === null || key === '') return;
        if (this.backend && this.backend.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === 'function') r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
const $b2aae227ced67f2d$var$get = ()=>({
        debug: false,
        initImmediate: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: (args)=>{
            let ret = {};
            if (typeof args[1] === 'object') ret = args[1];
            if ($b2aae227ced67f2d$var$isString(args[1])) ret.defaultValue = args[1];
            if ($b2aae227ced67f2d$var$isString(args[2])) ret.tDescription = args[2];
            if (typeof args[2] === 'object' || typeof args[3] === 'object') {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value)=>value,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        }
    });
const $b2aae227ced67f2d$var$transformOptions = (options)=>{
    if ($b2aae227ced67f2d$var$isString(options.ns)) options.ns = [
        options.ns
    ];
    if ($b2aae227ced67f2d$var$isString(options.fallbackLng)) options.fallbackLng = [
        options.fallbackLng
    ];
    if ($b2aae227ced67f2d$var$isString(options.fallbackNS)) options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    return options;
};
const $b2aae227ced67f2d$var$noop = ()=>{};
const $b2aae227ced67f2d$var$bindMemberFunctions = (inst)=>{
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
};
class $b2aae227ced67f2d$var$I18n extends $b2aae227ced67f2d$var$EventEmitter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        super();
        this.options = $b2aae227ced67f2d$var$transformOptions(options);
        this.services = {};
        this.logger = $b2aae227ced67f2d$var$baseLogger;
        this.modules = {
            external: []
        };
        $b2aae227ced67f2d$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initImmediate) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init() {
        var _this = this;
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        this.isInitializing = true;
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        if (!options.defaultNS && options.defaultNS !== false && options.ns) {
            if ($b2aae227ced67f2d$var$isString(options.ns)) options.defaultNS = options.ns;
            else if (options.ns.indexOf('translation') < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = $b2aae227ced67f2d$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$b2aae227ced67f2d$var$transformOptions(options)
        };
        if (this.options.compatibilityAPI !== 'v1') this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        const createClassOnDemand = (ClassOrObject)=>{
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === 'function') return new ClassOrObject();
            return ClassOrObject;
        };
        if (!this.options.isClone) {
            if (this.modules.logger) $b2aae227ced67f2d$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $b2aae227ced67f2d$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else if (typeof Intl !== 'undefined') formatter = $b2aae227ced67f2d$var$Formatter;
            const lu = new $b2aae227ced67f2d$var$LanguageUtil(this.options);
            this.store = new $b2aae227ced67f2d$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $b2aae227ced67f2d$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $b2aae227ced67f2d$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                compatibilityJSON: this.options.compatibilityJSON,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $b2aae227ced67f2d$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $b2aae227ced67f2d$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on('*', function(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                _this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $b2aae227ced67f2d$var$Translator(this.services, this.options);
            this.translator.on('*', function(event) {
                for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                _this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $b2aae227ced67f2d$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
        const storeApi = [
            'getResource',
            'hasResourceBundle',
            'getResourceBundle',
            'getDataByLanguage'
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = function() {
                return _this.store[fcName](...arguments);
            };
        });
        const storeApiChained = [
            'addResource',
            'addResources',
            'addResourceBundle',
            'removeResourceBundle'
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = function() {
                _this.store[fcName](...arguments);
                return _this;
            };
        });
        const deferred = $b2aae227ced67f2d$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log('initialized', this.options);
                this.emit('initialized', this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && this.options.compatibilityAPI !== 'v1' && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initImmediate) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language) {
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $b2aae227ced67f2d$var$noop;
        let usedCallback = callback;
        const usedLng = $b2aae227ced67f2d$var$isString(language) ? language : this.language;
        if (typeof language === 'function') usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng && usedLng.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === 'cimode') return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === 'cimode') return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            if (this.options.preload) this.options.preload.forEach((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $b2aae227ced67f2d$var$defer();
        if (typeof lngs === 'function') {
            callback = lngs;
            lngs = undefined;
        }
        if (typeof ns === 'function') {
            callback = ns;
            ns = undefined;
        }
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $b2aae227ced67f2d$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
        if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
        if (module.type === 'backend') this.modules.backend = module;
        if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === 'languageDetector') this.modules.languageDetector = module;
        if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
        if (module.type === 'postProcessor') $b2aae227ced67f2d$var$postProcessor.addPostProcessor(module);
        if (module.type === 'formatter') this.modules.formatter = module;
        if (module.type === '3rdParty') this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            'cimode',
            'dev'
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                'cimode',
                'dev'
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
    }
    changeLanguage(lng, callback) {
        var _this2 = this;
        this.isLanguageChangingTo = lng;
        const deferred = $b2aae227ced67f2d$var$defer();
        this.emit('languageChanging', lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                setLngProps(l);
                this.translator.changeLanguage(l);
                this.isLanguageChangingTo = undefined;
                this.emit('languageChanged', l);
                this.logger.log('languageChanged', l);
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve(function() {
                return _this2.t(...arguments);
            });
            if (callback) callback(err, function() {
                return _this2.t(...arguments);
            });
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const l = $b2aae227ced67f2d$var$isString(lngs) ? lngs : this.services.languageUtils.getBestMatchFromCodes(lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                if (this.services.languageDetector && this.services.languageDetector.cacheUserLanguage) this.services.languageDetector.cacheUserLanguage(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        var _this3 = this;
        const fixedT = function(key, opts) {
            let options;
            if (typeof opts !== 'object') {
                for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                options = _this3.options.overloadTranslationOptionHandler([
                    key,
                    opts
                ].concat(rest));
            } else options = {
                ...opts
            };
            options.lng = options.lng || fixedT.lng;
            options.lngs = options.lngs || fixedT.lngs;
            options.ns = options.ns || fixedT.ns;
            if (options.keyPrefix !== '') options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = _this3.options.keySeparator || '.';
            let resultKey;
            if (options.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>`${options.keyPrefix}${keySeparator}${k}`);
            else resultKey = options.keyPrefix ? `${options.keyPrefix}${keySeparator}${key}` : key;
            return _this3.t(resultKey, options);
        };
        if ($b2aae227ced67f2d$var$isString(lng)) fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t() {
        return this.translator && this.translator.translate(...arguments);
    }
    exists() {
        return this.translator && this.translator.exists(...arguments);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!this.isInitialized) {
            this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === 'cimode') return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 0 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $b2aae227ced67f2d$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if ($b2aae227ced67f2d$var$isString(ns)) ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $b2aae227ced67f2d$var$defer();
        if ($b2aae227ced67f2d$var$isString(lngs)) lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
        if (!lng) return 'rtl';
        const rtlLngs = [
            'ar',
            'shu',
            'sqr',
            'ssh',
            'xaa',
            'yhd',
            'yud',
            'aao',
            'abh',
            'abv',
            'acm',
            'acq',
            'acw',
            'acx',
            'acy',
            'adf',
            'ads',
            'aeb',
            'aec',
            'afb',
            'ajp',
            'apc',
            'apd',
            'arb',
            'arq',
            'ars',
            'ary',
            'arz',
            'auz',
            'avl',
            'ayh',
            'ayl',
            'ayn',
            'ayp',
            'bbz',
            'pga',
            'he',
            'iw',
            'ps',
            'pbt',
            'pbu',
            'pst',
            'prp',
            'prd',
            'ug',
            'ur',
            'ydd',
            'yds',
            'yih',
            'ji',
            'yi',
            'hbo',
            'men',
            'xmn',
            'fa',
            'jpr',
            'peo',
            'pes',
            'prs',
            'dv',
            'sam',
            'ckb'
        ];
        const languageUtils = this.services && this.services.languageUtils || new $b2aae227ced67f2d$var$LanguageUtil($b2aae227ced67f2d$var$get());
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
    static createInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        return new $b2aae227ced67f2d$var$I18n(options, callback);
    }
    cloneInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $b2aae227ced67f2d$var$noop;
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $b2aae227ced67f2d$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            'store',
            'services',
            'language'
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            clone.store = new $b2aae227ced67f2d$var$ResourceStore(this.store.data, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        clone.translator = new $b2aae227ced67f2d$var$Translator(clone.services, mergedOptions);
        clone.translator.on('*', function(event) {
            for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $b2aae227ced67f2d$export$2e2bcd8739ae039 = $b2aae227ced67f2d$var$I18n.createInstance();
$b2aae227ced67f2d$export$2e2bcd8739ae039.createInstance = $b2aae227ced67f2d$var$I18n.createInstance;
const $b2aae227ced67f2d$export$99152e8d49ca4e7d = $b2aae227ced67f2d$export$2e2bcd8739ae039.createInstance;
const $b2aae227ced67f2d$export$147ec2801e896265 = $b2aae227ced67f2d$export$2e2bcd8739ae039.dir;
const $b2aae227ced67f2d$export$2cd8252107eb640b = $b2aae227ced67f2d$export$2e2bcd8739ae039.init;
const $b2aae227ced67f2d$export$d3d08d944062d7e = $b2aae227ced67f2d$export$2e2bcd8739ae039.loadResources;
const $b2aae227ced67f2d$export$a5d9bf5d83fcab09 = $b2aae227ced67f2d$export$2e2bcd8739ae039.reloadResources;
const $b2aae227ced67f2d$export$1f96ae73734a86cc = $b2aae227ced67f2d$export$2e2bcd8739ae039.use;
const $b2aae227ced67f2d$export$61465194746e7fd2 = $b2aae227ced67f2d$export$2e2bcd8739ae039.changeLanguage;
const $b2aae227ced67f2d$export$f90d180fc7da3b3b = $b2aae227ced67f2d$export$2e2bcd8739ae039.getFixedT;
const $b2aae227ced67f2d$export$625550452a3fa3ec = $b2aae227ced67f2d$export$2e2bcd8739ae039.t;
const $b2aae227ced67f2d$export$f7e9f41ea797a17 = $b2aae227ced67f2d$export$2e2bcd8739ae039.exists;
const $b2aae227ced67f2d$export$2b4b218e406d2d00 = $b2aae227ced67f2d$export$2e2bcd8739ae039.setDefaultNamespace;
const $b2aae227ced67f2d$export$93d9ee97c1ad3f31 = $b2aae227ced67f2d$export$2e2bcd8739ae039.hasLoadedNamespace;
const $b2aae227ced67f2d$export$83be934b53fff43b = $b2aae227ced67f2d$export$2e2bcd8739ae039.loadNamespaces;
const $b2aae227ced67f2d$export$8cd7e7a54fa865bc = $b2aae227ced67f2d$export$2e2bcd8739ae039.loadLanguages;



function $3888133de1dd5bbb$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3888133de1dd5bbb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3888133de1dd5bbb$var$_typeof(o);
}
var $3888133de1dd5bbb$var$arr = [];
var $3888133de1dd5bbb$var$each = $3888133de1dd5bbb$var$arr.forEach;
var $3888133de1dd5bbb$var$slice = $3888133de1dd5bbb$var$arr.slice;
function $3888133de1dd5bbb$export$ebe90cb607ad99e(obj) {
    $3888133de1dd5bbb$var$each.call($3888133de1dd5bbb$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
function $3888133de1dd5bbb$export$87022daa49baf612() {
    return typeof XMLHttpRequest === 'function' || (typeof XMLHttpRequest === "undefined" ? "undefined" : $3888133de1dd5bbb$var$_typeof(XMLHttpRequest)) === 'object';
}
function $3888133de1dd5bbb$var$isPromise(maybePromise) {
    return !!maybePromise && typeof maybePromise.then === 'function';
}
function $3888133de1dd5bbb$export$1625492ec82002b9(maybePromise) {
    if ($3888133de1dd5bbb$var$isPromise(maybePromise)) return maybePromise;
    return Promise.resolve(maybePromise);
}



function $33947820aa6fb8cf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $33947820aa6fb8cf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $33947820aa6fb8cf$var$ownKeys(Object(t), !0).forEach(function(r) {
            $33947820aa6fb8cf$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $33947820aa6fb8cf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $33947820aa6fb8cf$var$_defineProperty(e, r, t) {
    return (r = $33947820aa6fb8cf$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $33947820aa6fb8cf$var$_toPropertyKey(t) {
    var i = $33947820aa6fb8cf$var$_toPrimitive(t, "string");
    return "symbol" == $33947820aa6fb8cf$var$_typeof(i) ? i : i + "";
}
function $33947820aa6fb8cf$var$_toPrimitive(t, r) {
    if ("object" != $33947820aa6fb8cf$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $33947820aa6fb8cf$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $33947820aa6fb8cf$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $33947820aa6fb8cf$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $33947820aa6fb8cf$var$_typeof(o);
}
var $33947820aa6fb8cf$var$fetchApi = typeof fetch === 'function' ? fetch : undefined;
if (typeof $parcel$global !== 'undefined' && $parcel$global.fetch) $33947820aa6fb8cf$var$fetchApi = $parcel$global.fetch;
else if (typeof window !== 'undefined' && window.fetch) $33947820aa6fb8cf$var$fetchApi = window.fetch;
var $33947820aa6fb8cf$var$XmlHttpRequestApi;
if ((0, $3888133de1dd5bbb$export$87022daa49baf612)()) {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.XMLHttpRequest) $33947820aa6fb8cf$var$XmlHttpRequestApi = $parcel$global.XMLHttpRequest;
    else if (typeof window !== 'undefined' && window.XMLHttpRequest) $33947820aa6fb8cf$var$XmlHttpRequestApi = window.XMLHttpRequest;
}
var $33947820aa6fb8cf$var$ActiveXObjectApi;
if (typeof ActiveXObject === 'function') {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.ActiveXObject) $33947820aa6fb8cf$var$ActiveXObjectApi = $parcel$global.ActiveXObject;
    else if (typeof window !== 'undefined' && window.ActiveXObject) $33947820aa6fb8cf$var$ActiveXObjectApi = window.ActiveXObject;
}
if (typeof $33947820aa6fb8cf$var$fetchApi !== 'function') $33947820aa6fb8cf$var$fetchApi = undefined;

if (!$33947820aa6fb8cf$var$fetchApi && !$33947820aa6fb8cf$var$XmlHttpRequestApi && !$33947820aa6fb8cf$var$ActiveXObjectApi) try {
    (parcelRequire("lpVsW")).then(function(mod) {
        $33947820aa6fb8cf$var$fetchApi = mod.default;
    }).catch(function() {});
} catch (e) {}
var $33947820aa6fb8cf$var$addQueryString = function addQueryString(url, params) {
    if (params && $33947820aa6fb8cf$var$_typeof(params) === 'object') {
        var queryString = '';
        for(var paramName in params)queryString += '&' + encodeURIComponent(paramName) + '=' + encodeURIComponent(params[paramName]);
        if (!queryString) return url;
        url = url + (url.indexOf('?') !== -1 ? '&' : '?') + queryString.slice(1);
    }
    return url;
};
var $33947820aa6fb8cf$var$fetchIt = function fetchIt(url, fetchOptions, callback, altFetch) {
    var resolver = function resolver(response) {
        if (!response.ok) return callback(response.statusText || 'Error', {
            status: response.status
        });
        response.text().then(function(data) {
            callback(null, {
                status: response.status,
                data: data
            });
        }).catch(callback);
    };
    if (altFetch) {
        var altResponse = altFetch(url, fetchOptions);
        if (altResponse instanceof Promise) {
            altResponse.then(resolver).catch(callback);
            return;
        }
    }
    if (typeof fetch === 'function') fetch(url, fetchOptions).then(resolver).catch(callback);
    else $33947820aa6fb8cf$var$fetchApi(url, fetchOptions).then(resolver).catch(callback);
};
var $33947820aa6fb8cf$var$omitFetchOptions = false;
var $33947820aa6fb8cf$var$requestWithFetch = function requestWithFetch(options, url, payload, callback) {
    if (options.queryStringParams) url = $33947820aa6fb8cf$var$addQueryString(url, options.queryStringParams);
    var headers = $33947820aa6fb8cf$var$_objectSpread({}, typeof options.customHeaders === 'function' ? options.customHeaders() : options.customHeaders);
    if (typeof window === 'undefined' && typeof $parcel$global !== 'undefined' && typeof $parcel$global.process !== 'undefined' && $parcel$global.process.versions && $parcel$global.process.versions.node) headers['User-Agent'] = "i18next-http-backend (node/".concat($parcel$global.process.version, "; ").concat($parcel$global.process.platform, " ").concat($parcel$global.process.arch, ")");
    if (payload) headers['Content-Type'] = 'application/json';
    var reqOptions = typeof options.requestOptions === 'function' ? options.requestOptions(payload) : options.requestOptions;
    var fetchOptions = $33947820aa6fb8cf$var$_objectSpread({
        method: payload ? 'POST' : 'GET',
        body: payload ? options.stringify(payload) : undefined,
        headers: headers
    }, $33947820aa6fb8cf$var$omitFetchOptions ? {} : reqOptions);
    var altFetch = typeof options.alternateFetch === 'function' && options.alternateFetch.length >= 1 ? options.alternateFetch : undefined;
    try {
        $33947820aa6fb8cf$var$fetchIt(url, fetchOptions, callback, altFetch);
    } catch (e) {
        if (!reqOptions || Object.keys(reqOptions).length === 0 || !e.message || e.message.indexOf('not implemented') < 0) return callback(e);
        try {
            Object.keys(reqOptions).forEach(function(opt) {
                delete fetchOptions[opt];
            });
            $33947820aa6fb8cf$var$fetchIt(url, fetchOptions, callback, altFetch);
            $33947820aa6fb8cf$var$omitFetchOptions = true;
        } catch (err) {
            callback(err);
        }
    }
};
var $33947820aa6fb8cf$var$requestWithXmlHttpRequest = function requestWithXmlHttpRequest(options, url, payload, callback) {
    if (payload && $33947820aa6fb8cf$var$_typeof(payload) === 'object') payload = $33947820aa6fb8cf$var$addQueryString('', payload).slice(1);
    if (options.queryStringParams) url = $33947820aa6fb8cf$var$addQueryString(url, options.queryStringParams);
    try {
        var x = $33947820aa6fb8cf$var$XmlHttpRequestApi ? new $33947820aa6fb8cf$var$XmlHttpRequestApi() : new $33947820aa6fb8cf$var$ActiveXObjectApi('MSXML2.XMLHTTP.3.0');
        x.open(payload ? 'POST' : 'GET', url, 1);
        if (!options.crossDomain) x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        x.withCredentials = !!options.withCredentials;
        if (payload) x.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        if (x.overrideMimeType) x.overrideMimeType('application/json');
        var h = options.customHeaders;
        h = typeof h === 'function' ? h() : h;
        if (h) for(var i in h)x.setRequestHeader(i, h[i]);
        x.onreadystatechange = function() {
            x.readyState > 3 && callback(x.status >= 400 ? x.statusText : null, {
                status: x.status,
                data: x.responseText
            });
        };
        x.send(payload);
    } catch (e) {
        console && console.log(e);
    }
};
var $33947820aa6fb8cf$var$request = function request(options, url, payload, callback) {
    if (typeof payload === 'function') {
        callback = payload;
        payload = undefined;
    }
    callback = callback || function() {};
    if ($33947820aa6fb8cf$var$fetchApi && url.indexOf('file:') !== 0) return $33947820aa6fb8cf$var$requestWithFetch(options, url, payload, callback);
    if ((0, $3888133de1dd5bbb$export$87022daa49baf612)() || typeof ActiveXObject === 'function') return $33947820aa6fb8cf$var$requestWithXmlHttpRequest(options, url, payload, callback);
    callback(new Error('No fetch and no xhr implementation found!'));
};
var $33947820aa6fb8cf$export$2e2bcd8739ae039 = $33947820aa6fb8cf$var$request;


function $625494ccd381030b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $625494ccd381030b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $625494ccd381030b$var$_typeof(o);
}
function $625494ccd381030b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $625494ccd381030b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $625494ccd381030b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $625494ccd381030b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $625494ccd381030b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $625494ccd381030b$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $625494ccd381030b$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $625494ccd381030b$var$_toPropertyKey(o.key), o);
    }
}
function $625494ccd381030b$var$_createClass(e, r, t) {
    return r && $625494ccd381030b$var$_defineProperties(e.prototype, r), t && $625494ccd381030b$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $625494ccd381030b$var$_defineProperty(e, r, t) {
    return (r = $625494ccd381030b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $625494ccd381030b$var$_toPropertyKey(t) {
    var i = $625494ccd381030b$var$_toPrimitive(t, "string");
    return "symbol" == $625494ccd381030b$var$_typeof(i) ? i : i + "";
}
function $625494ccd381030b$var$_toPrimitive(t, r) {
    if ("object" != $625494ccd381030b$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $625494ccd381030b$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $625494ccd381030b$var$getDefaults = function getDefaults() {
    return {
        loadPath: '/locales/{{lng}}/{{ns}}.json',
        addPath: '/locales/add/{{lng}}/{{ns}}',
        parse: function parse(data) {
            return JSON.parse(data);
        },
        stringify: JSON.stringify,
        parsePayload: function parsePayload(namespace, key, fallbackValue) {
            return $625494ccd381030b$var$_defineProperty({}, key, fallbackValue || '');
        },
        parseLoadPayload: function parseLoadPayload(languages, namespaces) {
            return undefined;
        },
        request: (0, $33947820aa6fb8cf$export$2e2bcd8739ae039),
        reloadInterval: typeof window !== 'undefined' ? false : 3600000,
        customHeaders: {},
        queryStringParams: {},
        crossDomain: false,
        withCredentials: false,
        overrideMimeType: false,
        requestOptions: {
            mode: 'cors',
            credentials: 'same-origin',
            cache: 'default'
        }
    };
};
var $625494ccd381030b$var$Backend = function() {
    function Backend(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $625494ccd381030b$var$_classCallCheck(this, Backend);
        this.services = services;
        this.options = options;
        this.allOptions = allOptions;
        this.type = 'backend';
        this.init(services, options, allOptions);
    }
    return $625494ccd381030b$var$_createClass(Backend, [
        {
            key: "init",
            value: function init(services) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services;
                this.options = $625494ccd381030b$var$_objectSpread($625494ccd381030b$var$_objectSpread($625494ccd381030b$var$_objectSpread({}, $625494ccd381030b$var$getDefaults()), this.options || {}), options);
                this.allOptions = allOptions;
                if (this.services && this.options.reloadInterval) {
                    var timer = setInterval(function() {
                        return _this.reload();
                    }, this.options.reloadInterval);
                    if ($625494ccd381030b$var$_typeof(timer) === 'object' && typeof timer.unref === 'function') timer.unref();
                }
            }
        },
        {
            key: "readMulti",
            value: function readMulti(languages, namespaces, callback) {
                this._readAny(languages, languages, namespaces, namespaces, callback);
            }
        },
        {
            key: "read",
            value: function read(language, namespace, callback) {
                this._readAny([
                    language
                ], language, [
                    namespace
                ], namespace, callback);
            }
        },
        {
            key: "_readAny",
            value: function _readAny(languages, loadUrlLanguages, namespaces, loadUrlNamespaces, callback) {
                var _this2 = this;
                var loadPath = this.options.loadPath;
                if (typeof this.options.loadPath === 'function') loadPath = this.options.loadPath(languages, namespaces);
                loadPath = (0, $3888133de1dd5bbb$export$1625492ec82002b9)(loadPath);
                loadPath.then(function(resolvedLoadPath) {
                    if (!resolvedLoadPath) return callback(null, {});
                    var url = _this2.services.interpolator.interpolate(resolvedLoadPath, {
                        lng: languages.join('+'),
                        ns: namespaces.join('+')
                    });
                    _this2.loadUrl(url, callback, loadUrlLanguages, loadUrlNamespaces);
                });
            }
        },
        {
            key: "loadUrl",
            value: function loadUrl(url, callback, languages, namespaces) {
                var _this3 = this;
                var lng = typeof languages === 'string' ? [
                    languages
                ] : languages;
                var ns = typeof namespaces === 'string' ? [
                    namespaces
                ] : namespaces;
                var payload = this.options.parseLoadPayload(lng, ns);
                this.options.request(this.options, url, payload, function(err, res) {
                    if (res && (res.status >= 500 && res.status < 600 || !res.status)) return callback('failed loading ' + url + '; status code: ' + res.status, true);
                    if (res && res.status >= 400 && res.status < 500) return callback('failed loading ' + url + '; status code: ' + res.status, false);
                    if (!res && err && err.message) {
                        var errorMessage = err.message.toLowerCase();
                        var isNetworkError = [
                            'failed',
                            'fetch',
                            'network',
                            'load'
                        ].find(function(term) {
                            return errorMessage.indexOf(term) > -1;
                        });
                        if (isNetworkError) return callback('failed loading ' + url + ': ' + err.message, true);
                    }
                    if (err) return callback(err, false);
                    var ret, parseErr;
                    try {
                        if (typeof res.data === 'string') ret = _this3.options.parse(res.data, languages, namespaces);
                        else ret = res.data;
                    } catch (e) {
                        parseErr = 'failed parsing ' + url + ' to json';
                    }
                    if (parseErr) return callback(parseErr, false);
                    callback(null, ret);
                });
            }
        },
        {
            key: "create",
            value: function create(languages, namespace, key, fallbackValue, callback) {
                var _this4 = this;
                if (!this.options.addPath) return;
                if (typeof languages === 'string') languages = [
                    languages
                ];
                var payload = this.options.parsePayload(namespace, key, fallbackValue);
                var finished = 0;
                var dataArray = [];
                var resArray = [];
                languages.forEach(function(lng) {
                    var addPath = _this4.options.addPath;
                    if (typeof _this4.options.addPath === 'function') addPath = _this4.options.addPath(lng, namespace);
                    var url = _this4.services.interpolator.interpolate(addPath, {
                        lng: lng,
                        ns: namespace
                    });
                    _this4.options.request(_this4.options, url, payload, function(data, res) {
                        finished += 1;
                        dataArray.push(data);
                        resArray.push(res);
                        if (finished === languages.length) {
                            if (typeof callback === 'function') callback(dataArray, resArray);
                        }
                    });
                });
            }
        },
        {
            key: "reload",
            value: function reload() {
                var _this5 = this;
                var _this$services = this.services, backendConnector = _this$services.backendConnector, languageUtils = _this$services.languageUtils, logger = _this$services.logger;
                var currentLanguage = backendConnector.language;
                if (currentLanguage && currentLanguage.toLowerCase() === 'cimode') return;
                var toLoad = [];
                var append = function append(lng) {
                    var lngs = languageUtils.toResolveHierarchy(lng);
                    lngs.forEach(function(l) {
                        if (toLoad.indexOf(l) < 0) toLoad.push(l);
                    });
                };
                append(currentLanguage);
                if (this.allOptions.preload) this.allOptions.preload.forEach(function(l) {
                    return append(l);
                });
                toLoad.forEach(function(lng) {
                    _this5.allOptions.ns.forEach(function(ns) {
                        backendConnector.read(lng, ns, 'read', null, null, function(err, data) {
                            if (err) logger.warn("loading namespace ".concat(ns, " for language ").concat(lng, " failed"), err);
                            if (!err && data) logger.log("loaded namespace ".concat(ns, " for language ").concat(lng), data);
                            backendConnector.loaded("".concat(lng, "|").concat(ns), err, data);
                        });
                    });
                });
            }
        }
    ]);
}();
$625494ccd381030b$var$Backend.type = 'backend';
var $625494ccd381030b$export$2e2bcd8739ae039 = $625494ccd381030b$var$Backend;


const $dae7aefd84fd0ab6$export$df1c34db1371eeed = {
    en: 'English',
    bg: "\u0411\u044A\u043B\u0433\u0430\u0440\u0441\u043A\u0438"
};
// Contains the locale namespaces that are files
const $dae7aefd84fd0ab6$var$localeNamespaces = [
    'common'
];
(0, $b2aae227ced67f2d$export$2e2bcd8739ae039).use((0, $625494ccd381030b$export$2e2bcd8739ae039)).use((0, $4108570c8605a395$export$ae7e14d40d89f296)).init({
    lng: JSON.parse(localStorage.getItem('automatarium-preferences'))?.state.preferences.language,
    fallbackLng: 'en',
    supportedLngs: Object.keys($dae7aefd84fd0ab6$export$df1c34db1371eeed),
    defaultNS: $dae7aefd84fd0ab6$var$localeNamespaces.at(0),
    ns: $dae7aefd84fd0ab6$var$localeNamespaces,
    debug: true,
    react: {
        useSuspense: true
    },
    interpolation: {
        escapeValue: false
    },
    backend: {
        loadPath: './locales/{{lng}}/{{ns}}.json'
    }
});
var $dae7aefd84fd0ab6$export$2e2bcd8739ae039 = (0, $b2aae227ced67f2d$export$2e2bcd8739ae039);




const $c66ee0aaafbc7ad3$var$Footer = ()=>{
    const { t: t, i18n: i18n } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)('common');
    const preferences = (0, $8af1fe532609b934$export$2e2bcd8739ae039)((state)=>state.preferences);
    const setPreferences = (0, $8af1fe532609b934$export$2e2bcd8739ae039)((state)=>state.setPreferences);
    const handleChange = (event)=>{
        i18n.changeLanguage(event.target.value);
        preferences.language = event.target.value;
        setPreferences(preferences);
    };
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $8e3d8eb1f1e99862$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $8e3d8eb1f1e99862$export$cbef165a0b571911), {
                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ea9c8114d35b5a84$export$a6c7ac8248d6e38a), {
                    to: "/about",
                    children: t('about')
                })
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $8e3d8eb1f1e99862$export$cbef165a0b571911), {
                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ea9c8114d35b5a84$export$a6c7ac8248d6e38a), {
                    to: "/privacy",
                    children: t('privacy_policy')
                })
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $8e3d8eb1f1e99862$export$cbef165a0b571911), {
                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("a", {
                    href: "https://github.com/automatarium/automatarium",
                    target: "_blank",
                    rel: "noreferrer nofollow",
                    children: t('source_code')
                })
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("div", {
                style: {
                    flex: 1
                }
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $8e3d8eb1f1e99862$export$cbef165a0b571911), {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("label", {
                        htmlFor: "languageSelector",
                        style: {
                            marginRight: 2
                        },
                        children: t('language')
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("select", {
                        id: "languageSelector",
                        value: i18n.resolvedLanguage,
                        onChange: handleChange,
                        style: {
                            borderRadius: 6,
                            padding: 2
                        },
                        children: Object.entries((0, $dae7aefd84fd0ab6$export$df1c34db1371eeed)).map(([localeCode, localeName])=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                value: localeCode,
                                style: {
                                    zIndex: 1
                                },
                                children: localeName
                            }, localeCode))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $8e3d8eb1f1e99862$export$cbef165a0b571911), {
                children: t('licensed_mit')
            })
        ]
    });
};
var $c66ee0aaafbc7ad3$export$2e2bcd8739ae039 = $c66ee0aaafbc7ad3$var$Footer;








const $fd1e899946ad64a2$export$8a23e74e5cf3ca41 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('button')`
  width: ${(props)=>props.width}em;
  padding: 0;
  margin: 3px;
  background: none;
  border: 0;
  font: inherit;
  text-align: left;
  color: inherit;
  cursor: pointer;

  &:hover${(props)=>!props.$istemplate && ', &:focus'} {
    outline: none;

    &:not(:disabled) > div:first-of-type {
      box-shadow: 0 0 0 3px var(--primary);
    }
  }
  &:disabled {
    cursor: default;
  }
`;
const $fd1e899946ad64a2$export$8a8c015277a3d77a = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  aspect-ratio: 1;
  border-radius: .6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background: var(--grid-bg);

  svg {
    width: 60%;
    height: 60%;
    aspect-ratio: inherit;
    display: block;
  }
  img {
    height: 100%;
    width: 100%;
    display: block;
    object-fit: contain;
  }

  ${(props)=>!props.$image && `
    background: var(--grid-pattern);
    background-size: 1.875em 1.875em;
    background-position: .4735em .4735em;
  `}
`;
const $fd1e899946ad64a2$export$6be4972368479c02 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  position: absolute;
  top: 1em;
  right: 1em;
  background: var(--toolbar);
  padding: .4em .6em;
  border-radius: .3em;
  letter-spacing: .1em;
  font-size: .8rem;
  font-weight: 600;
  opacity: .9;
`;
const $fd1e899946ad64a2$export$1e9faae0a9ae64d0 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  a {
    color: var(--white);
    opacity: 0.5;

    &:hover {
      opacity: 1;
    }
  }
`;
const $fd1e899946ad64a2$export$b074a5f8ba27f480 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  margin-block-start: 1em;
  list-style-type: none;

  span {
    display: block;
    opacity: .5;
    margin-block-start: .2rem;
    font-size: .9em;
  }
`;
const $fd1e899946ad64a2$export$7e4d17f97c7d718e = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  position: absolute;
  z-index: 9;
  background: hsla(var(--primary-h), var(--primary-s), var(--primary-l), 0.4);
  width: 100%;
  height: 100%;
  border-radius: .6rem;
  box-shadow: 0 0 0 3px var(--primary);
`;


(0, (/*@__PURE__*/$parcel$interopDefault($de07f2c205919029$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($11e5497bd9439d83$exports))));
const $eb202bee839f342f$var$ProjectCard = ({ name: name, type: type, date: date, image: image, isSelectedTemplate: isSelectedTemplate = false, ...props })=>{
    const { ...rest } = props;
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $fd1e899946ad64a2$export$8a23e74e5cf3ca41), {
        ...rest,
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $fd1e899946ad64a2$export$8a8c015277a3d77a), {
                $image: !!image,
                children: [
                    image ? /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("img", {
                        src: image,
                        alt: ""
                    }) : /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $2fdc1cc89313d290$export$2e2bcd8739ae039), {}),
                    type && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $fd1e899946ad64a2$export$6be4972368479c02), {
                        children: type
                    }),
                    isSelectedTemplate && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $fd1e899946ad64a2$export$7e4d17f97c7d718e), {})
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $fd1e899946ad64a2$export$b074a5f8ba27f480), {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $fd1e899946ad64a2$export$1e9faae0a9ae64d0), {
                        children: [
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("strong", {
                                children: name
                            }),
                            props.$istemplate ? /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("a", {
                                    onClick: props.$deleteTemplate,
                                    children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $18a55aecbfde5f55$export$2e2bcd8739ae039), {})
                                })
                            }) : /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("a", {
                                    onClick: props.$kebabClick,
                                    ref: props.$kebabRef,
                                    children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $cfc59ee7830ac2d1$export$2e2bcd8739ae039), {})
                                })
                            })
                        ]
                    }),
                    date && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("span", {
                        children: date instanceof (0, (/*@__PURE__*/$parcel$interopDefault($de07f2c205919029$exports))) ? (0, (/*@__PURE__*/$parcel$interopDefault($de07f2c205919029$exports)))().to(date) : date
                    })
                ]
            })
        ]
    });
};
var $eb202bee839f342f$export$2e2bcd8739ae039 = $eb202bee839f342f$var$ProjectCard;




var $h2ArV = parcelRequire("h2ArV");

var $h2ArV = parcelRequire("h2ArV");

const $f0d0a434779be863$export$e93364aaaa97e46f = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('textarea', (0, $h2ArV.forwardRef))`
  font: inherit;
  border: 1px solid var(--border-color, var(--input-border));
  background: var(--white);
  border-radius: .3em;
  padding: .6em .9em;
  width: 100%;
  min-height: 125px;
  box-sizing: border-box;
  ${(props)=>props.as === 'textarea' && 'resize: vertical;'}
  transition: box-shadow .1s, border-color .1s;
  color: var(--black);
  margin: 0;

  &:focus {
    outline: 0;
    box-shadow: inset 0 0 0 1px var(--border-color, var(--primary));
    border-color: var(--border-color, var(--primary));
  }
`;


const $27d1a66ca5ccc4f6$var$TextArea = /*#__PURE__*/ (0, $h2ArV.forwardRef)(({ type: type, ...props }, ref)=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $f0d0a434779be863$export$e93364aaaa97e46f), {
        id: props.id ?? props.name,
        ...props,
        as: type === 'select' ? 'select' : 'textarea',
        ref: ref,
        ...type && type !== 'textarea' ? {
            type: type
        } : {}
    }));
var $27d1a66ca5ccc4f6$export$2e2bcd8739ae039 = $27d1a66ca5ccc4f6$var$TextArea;




var $h2ArV = parcelRequire("h2ArV");







const $62ca164bc3888523$var$CreateModule = ()=>{
    const navigate = (0, $4b112c041340d9ed$export$9770f232ac06a008)();
    const setProject = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.set);
    const setModule = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.setModule);
    const addModuleProject = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.upsertProject);
    const getModuleProject = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.getProject);
    const addQuestion = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.upsertQuestion);
    const showModuleWindow = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.showModuleWindow);
    const setShowModuleWindow = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.setShowModuleWindow);
    const currentProject = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project);
    const [isModalOpen, setModalOpen] = (0, $h2ArV.useState)(false);
    const [newModuleType, setModuleType] = (0, $h2ArV.useState)('FSA');
    const [moduleName, setModuleName] = (0, $h2ArV.useState)('');
    const [moduleDescription, setModuleDescription] = (0, $h2ArV.useState)('');
    const [project, setProjectforModule] = (0, $h2ArV.useState)(false);
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)('common');
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('modal:createModule', (e)=>{
        setModalOpen(true);
        setModuleType('FSA');
        setModuleName('');
        setModuleDescription('');
        setProjectforModule(e.detail.project);
    });
    const handleNewModuleFile = (project)=>{
        // Create a new module and module project
        const newModule = (0, $be91e446fcb94886$export$e6f852ab53eb4018)();
        const newModuleProject = project ? JSON.parse(JSON.stringify(project)) : (0, $be91e446fcb94886$export$ff4e209d475e9bd8)(newModuleType, moduleName);
        const pink = 'pink';
        newModuleProject._id = crypto.randomUUID();
        newModuleProject.config.color = pink;
        if (moduleName === '') {
            newModule.meta.name = (0, $dae7aefd84fd0ab6$export$2e2bcd8739ae039).t('create_module.untitled', {
                ns: 'common'
            });
            newModuleProject.meta.name = (0, $dae7aefd84fd0ab6$export$2e2bcd8739ae039).t('create_module.untitled', {
                ns: 'common'
            });
        } else {
            newModule.meta.name = moduleName;
            newModuleProject.meta.name = moduleName;
        }
        newModule.description = moduleDescription;
        // Set the new module and module project
        setModule(newModule);
        addModuleProject(newModuleProject);
        // Add question to module
        addQuestion(newModuleProject._id, '');
        // Set module project for editor
        setProject(getModuleProject(0));
        // Show module window when navigating to editor
        if (showModuleWindow === false) setShowModuleWindow(true);
        setModalOpen(false);
        // Go to the editor
        navigate('/editor');
    };
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $d15f6e8ca8604f1a$exports.Fragment), {
        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $a5fe3119a76402fb$export$2e2bcd8739ae039), {
            title: t('create_module.create_new'),
            isOpen: isModalOpen,
            onClose: ()=>setModalOpen(false),
            actions: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                        secondary: true,
                        onClick: ()=>setModalOpen(false),
                        children: t('cancel')
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            if (!project) handleNewModuleFile(null);
                            else handleNewModuleFile(currentProject);
                        },
                        children: t('create')
                    })
                ]
            }),
            children: [
                !project && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
                    children: [
                        t('create_module.select_type'),
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                            type: "select",
                            value: newModuleType,
                            onChange: (e)=>setModuleType(e.target.value),
                            children: [
                                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                    value: "FSA",
                                    children: t('fsa')
                                }),
                                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                    value: "PDA",
                                    children: t('pda')
                                }),
                                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                    value: "TM",
                                    children: t('tm')
                                })
                            ]
                        })
                    ]
                }),
                t('create_module.name'),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                    type: "text",
                    value: moduleName,
                    onChange: (e)=>setModuleName(e.target.value),
                    placeholder: t('create_module.name_placeholder')
                }),
                t('create_module.description'),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $27d1a66ca5ccc4f6$export$2e2bcd8739ae039), {
                    value: moduleDescription,
                    onChange: (e)=>setModuleDescription(e.target.value),
                    placeholder: t('create_module.description_placeholder')
                })
            ]
        })
    });
};
var $62ca164bc3888523$export$2e2bcd8739ae039 = $62ca164bc3888523$var$CreateModule;




var $h2ArV = parcelRequire("h2ArV");




const $bc71969aaf1243ed$export$6e2c8f0811a474ce = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('section')`
  padding: .2rem 1rem;
`;
const $bc71969aaf1243ed$export$59451aa6b6270879 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  padding-block: .5em;
  display: flex;
  align-items: center;
  gap: .5em;

  label {
    flex: 1;
  }

  kbd {
    background: var(--surface);
    border-radius: 5px;
    border: 2px solid var(--toolbar);
    box-shadow: 0 4px 0 var(--toolbar);
    font: inherit;
    display: inline-block;
    padding: .2em .4em;
    white-space: nowrap;
    font-size: 1rem;
    user-select: none;
    text-align: center;
    min-width: 1.5ch;
    transition: transform .15s, box-shadow .15s;

    &:active {
      transform: translateY(4px);
      box-shadow: 0 0 0 var(--toolbar);
    }
  }
`;



const $aecc316235466713$var$shortcuts = (t)=>[
        {
            title: t('shortcuts.application'),
            items: [
                {
                    label: t('menus.preferences'),
                    action: 'OPEN_PREFERENCES'
                },
                {
                    label: t('menus.keyboard_shortcuts'),
                    action: 'KEYBOARD_SHORTCUTS'
                }
            ]
        },
        {
            title: t('menus.tools'),
            items: [
                {
                    label: t('tools.cursor'),
                    action: 'TOOL_CURSOR'
                },
                {
                    label: t('tools.hand'),
                    action: 'TOOL_HAND'
                },
                {
                    label: t('tools.state'),
                    action: 'TOOL_STATE'
                },
                {
                    label: t('tools.transition'),
                    action: 'TOOL_TRANSITION'
                },
                {
                    label: t('tools.comment'),
                    action: 'TOOL_COMMENT'
                }
            ]
        },
        {
            title: t('menus.file'),
            items: [
                {
                    label: t('shortcuts.import_automatarium'),
                    action: 'IMPORT_AUTOMATARIUM_PROJECT'
                },
                {
                    label: t('shortcuts.import_jflap'),
                    action: 'IMPORT_JFLAP_PROJECT'
                },
                {
                    label: t('shortcuts.save_file'),
                    action: 'SAVE_FILE'
                },
                {
                    label: t('shortcuts.export_automatarium'),
                    action: 'SAVE_FILE_AS'
                },
                {
                    label: t('shortcuts.export_image'),
                    action: 'EXPORT'
                },
                {
                    label: t('menus.export_png'),
                    action: 'EXPORT_AS_PNG'
                },
                {
                    label: t('menus.export_svg'),
                    action: 'EXPORT_AS_SVG'
                },
                {
                    label: t('menus.export_clipboard'),
                    action: 'EXPORT_TO_CLIPBOARD'
                }
            ]
        },
        {
            title: t('menus.edit'),
            items: [
                {
                    label: t('menus.undo'),
                    action: 'UNDO'
                },
                {
                    label: t('menus.redo'),
                    action: 'REDO'
                },
                {
                    label: t('copy'),
                    action: 'COPY'
                },
                {
                    label: t('paste'),
                    action: 'PASTE'
                },
                {
                    label: t('menus.select_all'),
                    action: 'SELECT_ALL'
                },
                {
                    label: t('menus.clear_selection'),
                    action: 'SELECT_NONE'
                },
                {
                    label: t('shortcuts.select_multiple'),
                    hotkeys: [
                        {
                            shift: true,
                            key: ''
                        }
                    ]
                },
                {
                    label: t('delete'),
                    hotkeys: [
                        {
                            key: "\u232B"
                        }
                    ]
                }
            ]
        },
        {
            title: t('menus.view'),
            items: [
                {
                    label: t('menus.zoom_in'),
                    action: 'ZOOM_IN'
                },
                {
                    label: t('menus.zoom_out'),
                    action: 'ZOOM_OUT'
                },
                {
                    label: t('menus.zoom_100'),
                    action: 'ZOOM_100'
                },
                {
                    label: t('menus.zoom_fit'),
                    action: 'ZOOM_FIT'
                },
                {
                    label: t('menus.fullscreen'),
                    hotkeys: [
                        {
                            key: 'F11'
                        }
                    ]
                },
                {
                    label: t('menus.testing_lab'),
                    action: 'TESTING_LAB'
                },
                /*
      {
        label: 'Stepping lab',
        action: 'STEPPING_LAB'
      },
      */ {
                    label: t('menus.file_info'),
                    action: 'FILE_INFO'
                },
                {
                    label: t('menus.file_options'),
                    action: 'FILE_OPTIONS'
                },
                {
                    label: t('menus.templates'),
                    action: 'TEMPLATES'
                },
                {
                    label: t('menus.modules'),
                    action: 'MODULES'
                },
                {
                    label: t('shortcuts.move_view'),
                    hotkeys: [
                        {
                            key: "\u2190"
                        },
                        {
                            key: "\u2191"
                        },
                        {
                            key: "\u2192"
                        },
                        {
                            key: "\u2193"
                        }
                    ]
                },
                {
                    label: t('shortcuts.no_snapping'),
                    hotkeys: [
                        {
                            alt: true,
                            key: ''
                        }
                    ]
                }
            ]
        },
        {
            title: t('menus.testing_lab'),
            items: [
                {
                    label: t('shortcuts.move_cells'),
                    hotkeys: [
                        {
                            key: "\u2191"
                        },
                        {
                            key: "\u2193"
                        }
                    ]
                },
                {
                    label: t('shortcuts.create_cell'),
                    hotkeys: [
                        {
                            key: 'Enter'
                        }
                    ]
                },
                {
                    label: t('shortcuts.delete_cell'),
                    hotkeys: [
                        {
                            key: "\u232B"
                        }
                    ]
                },
                {
                    label: t('shortcuts.execute_multirun'),
                    hotkeys: [
                        {
                            meta: true,
                            key: 'Enter'
                        }
                    ]
                }
            ]
        }
    ];
const $aecc316235466713$var$ShortcutGuide = ()=>{
    const [isOpen, setIsOpen] = (0, $h2ArV.useState)(false);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('modal:shortcuts', ()=>setIsOpen(true), []);
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)('common');
    const actions = (0, $b9bf89f7d3b36cd8$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $a5fe3119a76402fb$export$2e2bcd8739ae039), {
        title: t('shortcuts.title'),
        description: t('shortcuts.description'),
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        style: {
            paddingInline: 0
        },
        children: (0, $h2ArV.useMemo)(()=>$aecc316235466713$var$shortcuts(t).map((category)=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $h2ArV.Fragment), {
                    children: [
                        category.title && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $f6c0a8acd60d8875$export$2e2bcd8739ae039), {
                            children: category.title
                        }),
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $bc71969aaf1243ed$export$6e2c8f0811a474ce), {
                            children: category.items.map((item)=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $bc71969aaf1243ed$export$59451aa6b6270879), {
                                    children: [
                                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("label", {
                                            children: item.label
                                        }),
                                        ('action' in item && actions[item.action]?.hotkeys || item.hotkeys)?.map((hotkey)=>{
                                            const key = (0, $b9bf89f7d3b36cd8$export$35d311008374d47b)(hotkey);
                                            return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("kbd", {
                                                children: key
                                            }, key);
                                        })
                                    ]
                                }, item.label))
                        })
                    ]
                }, category.title)), [
            actions
        ])
    });
};
var $aecc316235466713$export$2e2bcd8739ae039 = $aecc316235466713$var$ShortcutGuide;




var $h2ArV = parcelRequire("h2ArV");





const $ce35cecbfd3fb5a3$export$6e2c8f0811a474ce = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('section')`
  padding: .2rem 1rem;
`;



const $931143b92b0f570e$var$defaultValues = {
    pauseTM: true
};
const $931143b92b0f570e$var$FinalStatePopup = ()=>{
    const [isOpen, setIsOpen] = (0, $h2ArV.useState)(false);
    const setPopups = (0, $87c0b991aa949aa0$export$2e2bcd8739ae039)((state)=>state.setPopups);
    const preferences = (0, $8af1fe532609b934$export$2e2bcd8739ae039)((state)=>state.preferences);
    const setPreferences = (0, $8af1fe532609b934$export$2e2bcd8739ae039)((state)=>state.setPreferences);
    const { register: register, handleSubmit: handleSubmit, reset: reset } = (0, $cf42f49a775636e7$export$87c0cf8eb5a167e0)({
        defaultValues: $931143b92b0f570e$var$defaultValues
    });
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)('common');
    const onSubmit = (values)=>{
        // Get current preferences and modify only pauseTM
        const newPreferences = {
            ...preferences,
            pauseTM: values.pauseTM
        };
        setPreferences(newPreferences);
        setPopups({
            showFinalState: false
        }) // Don't show popup again after submitting
        ;
        setIsOpen(false);
    };
    (0, $h2ArV.useEffect)(()=>{
        console.log(preferences);
        reset({
            pauseTM: preferences.pauseTM
        });
    }, [
        preferences,
        isOpen
    ]);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('modal:finalstate', ()=>setIsOpen(true), []);
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $a5fe3119a76402fb$export$2e2bcd8739ae039), {
        title: t('final_state_popup.title'),
        description: t('final_state_popup.description'),
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        role: "alertdialog" // Prevents closing by clicking away
        ,
        actions: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                    secondary: true,
                    onClick: ()=>setIsOpen(false),
                    children: t('final_state_popup.close_nosave')
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                    type: "submit",
                    form: "popups_form",
                    children: t('final_state_popup.close_save')
                })
            ]
        }),
        style: {
            paddingInline: 0
        },
        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("form", {
            id: "popups_form",
            onSubmit: handleSubmit(onSubmit),
            children: [
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $f6c0a8acd60d8875$export$2e2bcd8739ae039), {
                    children: t('preferences.behaviour')
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ce35cecbfd3fb5a3$export$6e2c8f0811a474ce), {
                    children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e44002cbb4794c3a$export$2e2bcd8739ae039), {
                        label: t('preferences.tm_halt'),
                        description: t('preferences.tm_halt_description'),
                        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $0770ae362b3cd6e9$export$2e2bcd8739ae039), {
                            type: "checkbox",
                            ...register('pauseTM')
                        })
                    })
                })
            ]
        })
    });
};
var $931143b92b0f570e$export$2e2bcd8739ae039 = $931143b92b0f570e$var$FinalStatePopup;




var $h2ArV = parcelRequire("h2ArV");




const $b2f2ab13e03a8be2$export$e6dfd72ab29f8598 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  flex-wrap: wrap;
  gap: 1em;
  align-items: flex-start;

  & > div {
    flex-grow: 1;
    min-width: 180px;
  }
`;
const $b2f2ab13e03a8be2$export$3e431a229df88919 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('img')`
  background-color: hsl(0 0% 50%);
  display: block;
  flex: 1000;
  border-radius: .3em;
  min-width: 300px;
`;



const $ca9b0c437b693aa9$var$ExportImage = ()=>{
    const { exportVisible: exportVisible, setExportVisible: setExportVisible, options: options, setOptions: setOptions } = (0, $ef9e10319983727e$export$2e2bcd8739ae039)();
    const { filename: filename, type: type, margin: margin, color: color, darkMode: darkMode, background: background } = options;
    const projectName = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project?.meta.name);
    const projectColor = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project?.config.color);
    const [svg, setSvg] = (0, $h2ArV.useState)();
    const [size, setSize] = (0, $h2ArV.useState)({});
    const [preview, setPreview] = (0, $h2ArV.useState)('#');
    const [prevBG, setPrevBG] = (0, $h2ArV.useState)();
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)('common');
    // Set project settings if they change
    (0, $h2ArV.useEffect)(()=>{
        setOptions({
            filename: projectName,
            color: projectColor
        });
    }, [
        projectName,
        projectColor
    ]);
    // Set svg
    (0, $h2ArV.useEffect)(()=>{
        if (!exportVisible) return;
        const { height: height, width: width, svg: svg } = (0, $22a6b7ea146a0a79$export$2421ed4e781a60b3)({
            margin: margin,
            background: background,
            color: color,
            darkMode: darkMode
        });
        setSvg(svg);
        setSize({
            height: height,
            width: width
        });
    }, [
        margin,
        color,
        darkMode,
        background,
        exportVisible
    ]);
    (0, $h2ArV.useEffect)(()=>{
        if (type === 'svg') setPreview('data:image/svg+xml,' + encodeURIComponent(svg));
        else (0, $22a6b7ea146a0a79$export$67db19a1608c2434)({
            ...size,
            svg: svg
        }).then((canvas)=>setPreview(canvas.toDataURL(type === 'jpg' && 'image/jpeg')));
    }, [
        svg,
        size,
        type
    ]);
    // Prevent transparent background for JPG
    (0, $h2ArV.useEffect)(()=>{
        if (type === 'jpg' && background === 'none') {
            setPrevBG(background);
            setOptions({
                background: 'solid'
            });
        } else if (type !== 'jpg' && prevBG) {
            setOptions({
                background: prevBG
            });
            setPrevBG(undefined);
        }
    }, [
        type,
        prevBG,
        background
    ]);
    const doExport = (0, $h2ArV.useCallback)(async ()=>{
        let data;
        // SVG export
        if (type === 'svg') data = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent('<?xml version="1.0" standalone="no"?>\r\n' + svg);
        // PNG/JPG export
        if (type === 'png' || type === 'jpg') {
            const canvas = await (0, $22a6b7ea146a0a79$export$67db19a1608c2434)({
                ...size,
                svg: svg
            });
            data = canvas.toDataURL(type === 'jpg' && 'image/jpeg');
        }
        // Download file
        if (data) (0, $22a6b7ea146a0a79$export$ada0ee09b3d8f53f)(filename, type, data);
    }, [
        svg,
        size,
        type,
        filename
    ]);
    const copyToClipboard = (0, $h2ArV.useCallback)(async ()=>{
        if (type === 'svg') {
            // TODO: kinda broken, might need to clean the svg at an earlier stage
            const blob = new Blob([
                svg
            ], {
                type: 'text/plain'
            });
            await navigator.clipboard.write([
                new window.ClipboardItem({
                    'text/plain': blob
                })
            ]);
        } else if (type === 'png') {
            const canvas = await (0, $22a6b7ea146a0a79$export$67db19a1608c2434)({
                ...size,
                svg: svg
            });
            canvas.toBlob((blob)=>navigator.clipboard.write([
                    new window.ClipboardItem({
                        'image/png': blob
                    })
                ]));
        }
        setExportVisible(false);
    }, [
        svg,
        size,
        type,
        filename
    ]);
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $a5fe3119a76402fb$export$2e2bcd8739ae039), {
        title: t('export_image.title'),
        description: t('export_image.description'),
        isOpen: exportVisible,
        onClose: ()=>setExportVisible(false),
        actions: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                    secondary: true,
                    onClick: ()=>setExportVisible(false),
                    children: t('cancel')
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("div", {
                    style: {
                        flex: 1
                    }
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                    disabled: type === 'jpg',
                    secondary: true,
                    onClick: copyToClipboard,
                    children: t('export_image.copy')
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                    onClick: doExport,
                    children: t('export')
                })
            ]
        }),
        width: "800px",
        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $b2f2ab13e03a8be2$export$e6dfd72ab29f8598), {
            children: [
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $b2f2ab13e03a8be2$export$3e431a229df88919), {
                    src: preview,
                    alt: ""
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e44002cbb4794c3a$export$2e2bcd8739ae039), {
                            label: t('export_image.file_name'),
                            fullWidth: true,
                            children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                                small: true,
                                value: filename,
                                onChange: (e)=>setOptions({
                                        filename: e.target.value
                                    })
                            })
                        }),
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e44002cbb4794c3a$export$2e2bcd8739ae039), {
                            label: t('export_image.file_type'),
                            fullWidth: true,
                            children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                                type: "select",
                                small: true,
                                value: type,
                                onChange: (e)=>setOptions({
                                        type: e.target.value
                                    }),
                                children: [
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                        value: "png",
                                        children: "PNG"
                                    }),
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                        value: "jpg",
                                        children: "JPG"
                                    }),
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                        value: "svg",
                                        children: "SVG"
                                    })
                                ]
                            })
                        }),
                        type === 'svg' && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("span", {
                            style: {
                                fontSize: '.7em',
                                display: 'block',
                                maxWidth: 'fit-content',
                                color: 'var(--error)'
                            },
                            children: t('export_image.svg_note')
                        }),
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e44002cbb4794c3a$export$2e2bcd8739ae039), {
                            label: t('export_image.margin'),
                            fullWidth: true,
                            children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                                type: "number",
                                min: "0",
                                max: "500",
                                small: true,
                                value: margin,
                                onChange: (e)=>setOptions({
                                        margin: e.target.value === '' ? 0 : Math.min(Math.max(Number(e.target.value), 0), 500)
                                    })
                            })
                        }),
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e44002cbb4794c3a$export$2e2bcd8739ae039), {
                            label: t('export_image.accent_colour'),
                            fullWidth: true,
                            children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                                type: "select",
                                small: true,
                                value: color,
                                onChange: (e)=>setOptions({
                                        color: e.target.value
                                    }),
                                children: [
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                        value: "red",
                                        children: t('colours.red')
                                    }),
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                        value: "orange",
                                        children: t('colours.orange')
                                    }),
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                        value: "green",
                                        children: t('colours.green')
                                    }),
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                        value: "teal",
                                        children: t('colours.teal')
                                    }),
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                        value: "blue",
                                        children: t('colours.blue')
                                    }),
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                        value: "purple",
                                        children: t('colours.purple')
                                    }),
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                        value: "pink",
                                        children: t('colours.pink')
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e44002cbb4794c3a$export$2e2bcd8739ae039), {
                            label: t('export_image.background'),
                            fullWidth: true,
                            children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                                type: "select",
                                small: true,
                                value: background,
                                onChange: (e)=>setOptions({
                                        background: e.target.value
                                    }),
                                children: [
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                        value: "solid",
                                        children: t('export_image.solid')
                                    }),
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                        value: "none",
                                        disabled: type === 'jpg',
                                        children: t('export_image.transparent')
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e44002cbb4794c3a$export$2e2bcd8739ae039), {
                            label: t('export_image.dark_mode'),
                            children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $0770ae362b3cd6e9$export$2e2bcd8739ae039), {
                                checked: darkMode,
                                onChange: (e)=>setOptions({
                                        darkMode: e.target.checked
                                    })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $ca9b0c437b693aa9$export$2e2bcd8739ae039 = $ca9b0c437b693aa9$var$ExportImage;




var $h2ArV = parcelRequire("h2ArV");


/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $2ebb14b0c1366d2a$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "14",
            height: "14",
            x: "8",
            y: "8",
            rx: "2",
            ry: "2",
            key: "17jyea"
        }
    ],
    [
        "path",
        {
            d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2",
            key: "zix9uf"
        }
    ]
];
const $2ebb14b0c1366d2a$export$2e2bcd8739ae039 = (0, $764ec6f19a629312$export$2e2bcd8739ae039)("copy", $2ebb14b0c1366d2a$export$3efd853dbb351e94);




const $ba3a17bc0ab6fa06$export$6d1d8484a60ab5d9 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  color: var(--success);
`;
const $ba3a17bc0ab6fa06$export$6312e8f82ee6e672 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 0.5em;
  padding-bottom: 0.5em;
`;




const $fd8f52c67efbda5d$var$ShareUrl = ()=>{
    const project = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project);
    const [base64Project, setBase64Project] = (0, $h2ArV.useState)('');
    const shareRawLink = `${window.location.origin}#/share/raw/${base64Project}`;
    const [exportUrlOpen, setExportUrlOpen] = (0, $h2ArV.useState)(false);
    const [copySuccess, setCopySuccess] = (0, $h2ArV.useState)(false);
    const [dataCopySuccess, setDataCopySuccess] = (0, $h2ArV.useState)(false);
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)('common');
    (0, $h2ArV.useEffect)(()=>{
        if (exportUrlOpen) (0, $6a48311326306a05$export$cfdd1f2478131e3d)(project).then(setBase64Project);
    }, [
        exportUrlOpen
    ]);
    const handleClose = ()=>{
        setExportUrlOpen(false);
        setCopySuccess(false);
        setDataCopySuccess(false);
    };
    (0, $h2ArV.useEffect)(()=>{
        const timeout = setTimeout(()=>setCopySuccess(false), 3000);
        return ()=>clearTimeout(timeout);
    }, [
        copySuccess
    ]);
    (0, $h2ArV.useEffect)(()=>{
        const timeout = setTimeout(()=>setDataCopySuccess(false), 3000);
        return ()=>clearTimeout(timeout);
    }, [
        dataCopySuccess
    ]);
    const handleCopyUrl = ()=>{
        navigator.clipboard.writeText(shareRawLink);
        setCopySuccess(true);
    };
    const handleCopyEncoding = ()=>{
        navigator.clipboard.writeText(base64Project);
        setDataCopySuccess(true);
    };
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('showSharing', ()=>setExportUrlOpen(true));
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $d15f6e8ca8604f1a$exports.Fragment), {
        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $a5fe3119a76402fb$export$2e2bcd8739ae039), {
            title: t('share_url.title'),
            isOpen: exportUrlOpen,
            onClose: handleClose,
            actions: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                secondary: true,
                onClick: handleClose,
                children: t('close')
            }),
            children: [
                t('share_url.copy_data'),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $ba3a17bc0ab6fa06$export$6312e8f82ee6e672), {
                    children: [
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                            readOnly: true,
                            value: base64Project
                        }),
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                            onClick: handleCopyEncoding,
                            style: {
                                height: '100%'
                            },
                            children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $2ebb14b0c1366d2a$export$2e2bcd8739ae039), {
                                size: "18px"
                            })
                        })
                    ]
                }),
                dataCopySuccess ? /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ba3a17bc0ab6fa06$export$6d1d8484a60ab5d9), {
                    children: t('share_url.copied')
                }) : /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $d15f6e8ca8604f1a$exports.Fragment), {}),
                "URL",
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $ba3a17bc0ab6fa06$export$6312e8f82ee6e672), {
                    children: [
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                            readOnly: true,
                            value: shareRawLink
                        }),
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                            onClick: handleCopyUrl,
                            style: {
                                height: '100%'
                            },
                            children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $2ebb14b0c1366d2a$export$2e2bcd8739ae039), {
                                size: "18px"
                            })
                        })
                    ]
                }),
                copySuccess ? /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ba3a17bc0ab6fa06$export$6d1d8484a60ab5d9), {
                    children: t('share_url.copied')
                }) : /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $d15f6e8ca8604f1a$exports.Fragment), {}),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("hr", {})
            ]
        })
    });
};
var $fd8f52c67efbda5d$export$2e2bcd8739ae039 = $fd8f52c67efbda5d$var$ShareUrl;




var $h2ArV = parcelRequire("h2ArV");





const $94194907f68dadaa$export$6d1d8484a60ab5d9 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  color: var(--success);
`;
const $94194907f68dadaa$export$6312e8f82ee6e672 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 0.5em;
  padding-bottom: 0.5em;
`;




const $e102458d258008dd$var$ShareUrlModule = ()=>{
    const module = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.module);
    const [base64Project, setBase64Project] = (0, $h2ArV.useState)('');
    const shareRawLink = `${window.location.origin}#/share/module/${base64Project}`;
    const [exportUrlOpen, setExportUrlOpen] = (0, $h2ArV.useState)(false);
    const [copySuccess, setCopySuccess] = (0, $h2ArV.useState)(false);
    const [dataCopySuccess, setDataCopySuccess] = (0, $h2ArV.useState)(false);
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)('common');
    (0, $h2ArV.useEffect)(()=>{
        if (exportUrlOpen) (0, $6a48311326306a05$export$cfdd1f2478131e3d)(module).then(setBase64Project);
    }, [
        exportUrlOpen
    ]);
    const handleClose = ()=>{
        setExportUrlOpen(false);
        setCopySuccess(false);
        setDataCopySuccess(false);
    };
    (0, $h2ArV.useEffect)(()=>{
        const timeout = setTimeout(()=>setCopySuccess(false), 3000);
        return ()=>clearTimeout(timeout);
    }, [
        copySuccess
    ]);
    (0, $h2ArV.useEffect)(()=>{
        const timeout = setTimeout(()=>setDataCopySuccess(false), 3000);
        return ()=>clearTimeout(timeout);
    }, [
        dataCopySuccess
    ]);
    const handleCopyUrl = ()=>{
        navigator.clipboard.writeText(shareRawLink);
        setCopySuccess(true);
    };
    const handleCopyEncoding = ()=>{
        navigator.clipboard.writeText(base64Project);
        setDataCopySuccess(true);
    };
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('showModuleSharing', ()=>setExportUrlOpen(true));
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $a5fe3119a76402fb$export$2e2bcd8739ae039), {
        title: t('share_url.module_title'),
        isOpen: exportUrlOpen,
        onClose: handleClose,
        actions: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
            secondary: true,
            onClick: handleClose,
            children: t('close')
        }),
        children: [
            t('share_url.copy_data'),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $94194907f68dadaa$export$6312e8f82ee6e672), {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                        readOnly: true,
                        value: base64Project
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                        onClick: handleCopyEncoding,
                        style: {
                            height: '100%'
                        },
                        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $2ebb14b0c1366d2a$export$2e2bcd8739ae039), {
                            size: "18px"
                        })
                    })
                ]
            }),
            dataCopySuccess && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $94194907f68dadaa$export$6d1d8484a60ab5d9), {
                children: t('share_url.copied')
            }),
            "URL",
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $94194907f68dadaa$export$6312e8f82ee6e672), {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                        readOnly: true,
                        value: shareRawLink
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                        onClick: handleCopyUrl,
                        style: {
                            height: '100%'
                        },
                        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $2ebb14b0c1366d2a$export$2e2bcd8739ae039), {
                            size: "18px"
                        })
                    })
                ]
            }),
            copySuccess && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $94194907f68dadaa$export$6d1d8484a60ab5d9), {
                children: t('share_url.copied')
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("hr", {})
        ]
    });
};
var $e102458d258008dd$export$2e2bcd8739ae039 = $e102458d258008dd$var$ShareUrlModule;




var $h2ArV = parcelRequire("h2ArV");




const $f69c19edf02a790c$export$911599cf4533d8df = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 0.5em;
`;
const $f69c19edf02a790c$export$7f714e6c560938e5 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('span')`
  color: var(--error);
`;




const $cec82e41fb73de14$export$42a852a2b6b56249 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  min-height: calc(100vh - 3em);
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
  justify-content: center;

  gap: 2em;

  button { 
    min-width: 10em;
  }
`;




const $46e591ed4221d5f7$var$ImportDialog = ({ navigateFunction: navigateFunction })=>{
    const navigate = navigateFunction;
    const setProject = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.set);
    const upsertProject = (0, $a882b4a4b7f1e12c$export$2e2bcd8739ae039)((s)=>s.upsertProject);
    const [modalOpen, setModalOpen] = (0, $h2ArV.useState)(false);
    const [loading, setLoading] = (0, $h2ArV.useState)(false);
    const [urlValue, setUrlValue] = (0, $h2ArV.useState)('');
    const [rawValue, setRawValue] = (0, $h2ArV.useState)('');
    const [rawError, setRawError] = (0, $h2ArV.useState)(false);
    const [urlError, setUrlError] = (0, $h2ArV.useState)(false);
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)('common');
    (0, $h2ArV.useEffect)(()=>{
        const timeout = setTimeout(()=>setRawError(false), 3000);
        return ()=>clearTimeout(timeout);
    }, [
        rawError
    ]);
    (0, $h2ArV.useEffect)(()=>{
        const timeout = setTimeout(()=>setUrlError(false), 3000);
        return ()=>clearTimeout(timeout);
    }, [
        urlError
    ]);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('modal:import', ()=>{
        setModalOpen(true);
        setLoading(false);
        setRawError(false);
        setUrlError(false);
    });
    const resetModal = ()=>{
        setUrlValue('');
        setRawValue('');
        setLoading(false);
        setModalOpen(false);
        setRawError(false);
        setUrlError(false);
    };
    const onData = (project)=>{
        setProject(project);
        upsertProject(project);
    };
    return loading ? /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $cec82e41fb73de14$export$42a852a2b6b56249), {
        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $706606fa822de154$export$2e2bcd8739ae039), {})
    }) : /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $a5fe3119a76402fb$export$2e2bcd8739ae039), {
        title: t('import_project.title'),
        description: t('import_project.description'),
        isOpen: modalOpen,
        onClose: resetModal,
        actions: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
            secondary: true,
            onClick: resetModal,
            children: t('close')
        }),
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $f69c19edf02a790c$export$911599cf4533d8df), {
                children: [
                    t('import_project.from_computer'),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                        disabled: loading,
                        onClick: ()=>{
                            setLoading(true);
                            (0, $b9bf89f7d3b36cd8$export$9ff57f529c25dc9f)(t, onData, t('import_project.invalid_file'), '.jff,.json', ()=>{
                                resetModal();
                                navigate('/editor');
                            }, ()=>{
                                setLoading(false);
                            });
                        },
                        children: t('import_project.browse')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("hr", {}),
            t('import_project.from_url'),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $f69c19edf02a790c$export$911599cf4533d8df), {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                        value: urlValue,
                        onChange: (e)=>setUrlValue(e.target.value),
                        placeholder: 'www.example.com/paste/raw/CoolFSA.json'
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                        disabled: loading,
                        onClick: ()=>{
                            if (urlValue.length > 0) {
                                setLoading(true);
                                (0, $b9bf89f7d3b36cd8$export$8d2732495f7c216e)(urlValue, t, onData, t('import_project.failed_url'), ()=>{
                                    resetModal();
                                    navigate('/editor');
                                }, ()=>{
                                    setLoading(false);
                                });
                            } else setUrlError(true);
                        },
                        children: t('import')
                    })
                ]
            }),
            urlError ? /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $f69c19edf02a790c$export$7f714e6c560938e5), {
                children: t('import_project.no_url')
            }) : /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $d15f6e8ca8604f1a$exports.Fragment), {}),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("hr", {}),
            t('import_project.from_data'),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $f69c19edf02a790c$export$911599cf4533d8df), {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                        value: rawValue,
                        onChange: (e)=>setRawValue(e.target.value),
                        placeholder: t('import_project.enter_data')
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                        disabled: loading,
                        onClick: ()=>{
                            if (rawValue.length > 0) {
                                const data = rawValue[0] === '{' ? (0, $6a48311326306a05$export$cfdd1f2478131e3d)(JSON.parse(rawValue)) : rawValue;
                                navigate(`/share/raw/${data}`);
                            } else setRawError(true);
                        },
                        children: t('load')
                    })
                ]
            }),
            rawError ? /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $f69c19edf02a790c$export$7f714e6c560938e5), {
                children: t('import_file.cant_load')
            }) : /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $d15f6e8ca8604f1a$exports.Fragment), {})
        ]
    });
};
var $46e591ed4221d5f7$export$2e2bcd8739ae039 = $46e591ed4221d5f7$var$ImportDialog;




var $h2ArV = parcelRequire("h2ArV");




const $7db92e527e74c99a$export$911599cf4533d8df = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 0.5em;
`;
const $7db92e527e74c99a$export$7f714e6c560938e5 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('span')`
  color: var(--error);
`;






const $d2b713cf36a207ed$var$ImportModuleDialog = ({ navigateFunction: navigateFunction })=>{
    const navigate = navigateFunction;
    const setProject = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.set);
    const setModule = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.setModule);
    const getModuleProject = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.getProject);
    const upsertModule = (0, $38932e4472f33f50$export$2e2bcd8739ae039)((s)=>s.upsertModule);
    const showModuleWindow = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.showModuleWindow);
    const setShowModuleWindow = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.setShowModuleWindow);
    const [modalOpen, setModalOpen] = (0, $h2ArV.useState)(false);
    const [loading, setLoading] = (0, $h2ArV.useState)(false);
    const [urlValue, setUrlValue] = (0, $h2ArV.useState)('');
    const [rawValue, setRawValue] = (0, $h2ArV.useState)('');
    const [rawError, setRawError] = (0, $h2ArV.useState)(false);
    const [urlError, setUrlError] = (0, $h2ArV.useState)(false);
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)('common');
    (0, $h2ArV.useEffect)(()=>{
        const timeout = setTimeout(()=>setRawError(false), 3000);
        return ()=>clearTimeout(timeout);
    }, [
        rawError
    ]);
    (0, $h2ArV.useEffect)(()=>{
        const timeout = setTimeout(()=>setUrlError(false), 3000);
        return ()=>clearTimeout(timeout);
    }, [
        urlError
    ]);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('modal:importModule', ()=>{
        setModalOpen(true);
        setLoading(false);
        setRawError(false);
        setUrlError(false);
    });
    const resetModal = ()=>{
        setUrlValue('');
        setRawValue('');
        setLoading(false);
        setModalOpen(false);
        setRawError(false);
        setUrlError(false);
    };
    const onData = (module)=>{
        setModule(module);
        upsertModule(module);
    };
    const loadModule = ()=>{
        setProject(getModuleProject(0));
        if (showModuleWindow === false) setShowModuleWindow(true);
        navigate('/editor');
    };
    return loading ? /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $cec82e41fb73de14$export$42a852a2b6b56249), {
        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $706606fa822de154$export$2e2bcd8739ae039), {})
    }) : /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $a5fe3119a76402fb$export$2e2bcd8739ae039), {
        title: t('import_module.title'),
        description: t('import_module.description'),
        isOpen: modalOpen,
        onClose: resetModal,
        actions: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
            secondary: true,
            onClick: resetModal,
            children: t('close')
        }),
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $7db92e527e74c99a$export$911599cf4533d8df), {
                children: [
                    t('import_project.from_computer'),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                        disabled: loading,
                        onClick: ()=>{
                            setLoading(true);
                            (0, $b9bf89f7d3b36cd8$export$96148661aa4398b8)(t, onData, t('import_module.invalid_file'), '.json', ()=>{
                                resetModal();
                                loadModule();
                            }, ()=>{
                                setLoading(false);
                            });
                        },
                        children: t('import_project.browse')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("hr", {}),
            t('import_module.from_url'),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $7db92e527e74c99a$export$911599cf4533d8df), {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                        value: urlValue,
                        onChange: (e)=>setUrlValue(e.target.value),
                        placeholder: 'www.example.com/paste/module/CoolFSA.json'
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                        disabled: loading,
                        onClick: ()=>{
                            if (urlValue.length > 0) {
                                setLoading(true);
                                (0, $b9bf89f7d3b36cd8$export$e355f5f85b187bdc)(urlValue, t, onData, t('import_module.failed_url'), ()=>{
                                    resetModal();
                                    navigate('/editor');
                                }, ()=>{
                                    setLoading(false);
                                });
                            } else setUrlError(true);
                        },
                        children: t('import')
                    })
                ]
            }),
            urlError && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $7db92e527e74c99a$export$7f714e6c560938e5), {
                children: t('import_project.no_url')
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("hr", {}),
            t('import_module.from_data'),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $7db92e527e74c99a$export$911599cf4533d8df), {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                        value: rawValue,
                        onChange: (e)=>setRawValue(e.target.value),
                        placeholder: t('import_project.enter_data')
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                        disabled: loading,
                        onClick: ()=>{
                            if (rawValue.length > 0) {
                                const data = rawValue[0] === '{' ? (0, $6a48311326306a05$export$cfdd1f2478131e3d)(JSON.parse(rawValue)) : rawValue;
                                navigate(`/share/module/${data}`);
                            } else setRawError(true);
                        },
                        children: t('load')
                    })
                ]
            }),
            rawError && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $7db92e527e74c99a$export$7f714e6c560938e5), {
                children: t('import_project.cant_load')
            })
        ]
    });
};
var $d2b713cf36a207ed$export$2e2bcd8739ae039 = $d2b713cf36a207ed$var$ImportModuleDialog;








var $h2ArV = parcelRequire("h2ArV");
/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('react').ReactElement<{}>} ReactElement
 * @typedef {import('unified').PluggableList} PluggableList
 * @typedef {import('hast').Root} Root
 * @typedef {import('./rehype-filter.js').Options} FilterOptions
 * @typedef {import('./ast-to-react.js').Options} TransformOptions
 *
 * @typedef CoreOptions
 * @property {string} children
 *
 * @typedef PluginOptions
 * @property {PluggableList} [remarkPlugins=[]]
 * @property {PluggableList} [rehypePlugins=[]]
 * @property {import('remark-rehype').Options | undefined} [remarkRehypeOptions={}]
 *
 * @typedef LayoutOptions
 * @property {string} [className]
 *
 * @typedef {CoreOptions & PluginOptions & LayoutOptions & FilterOptions & TransformOptions} ReactMarkdownOptions
 *
 * @typedef Deprecation
 * @property {string} id
 * @property {string} [to]
 */ 
var $h2ArV = parcelRequire("h2ArV");
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {import('./minurl.shared.js').URL} URL
 * @typedef {import('../index.js').Data} Data
 * @typedef {import('../index.js').Value} Value
 */ /**
 * @typedef {Record<string, unknown> & {type: string, position?: Position | undefined}} NodeLike
 *
 * @typedef {'ascii' | 'utf8' | 'utf-8' | 'utf16le' | 'ucs2' | 'ucs-2' | 'base64' | 'base64url' | 'latin1' | 'binary' | 'hex'} BufferEncoding
 *   Encodings supported by the buffer class.
 *
 *   This is a copy of the types from Node, copied to prevent Node globals from
 *   being needed.
 *   Copied from: <https://github.com/DefinitelyTyped/DefinitelyTyped/blob/90a4ec8/types/node/buffer.d.ts#L170>
 *
 * @typedef {Options | URL | Value | VFile} Compatible
 *   Things that can be passed to the constructor.
 *
 * @typedef VFileCoreOptions
 *   Set multiple values.
 * @property {Value | null | undefined} [value]
 *   Set `value`.
 * @property {string | null | undefined} [cwd]
 *   Set `cwd`.
 * @property {Array<string> | null | undefined} [history]
 *   Set `history`.
 * @property {URL | string | null | undefined} [path]
 *   Set `path`.
 * @property {string | null | undefined} [basename]
 *   Set `basename`.
 * @property {string | null | undefined} [stem]
 *   Set `stem`.
 * @property {string | null | undefined} [extname]
 *   Set `extname`.
 * @property {string | null | undefined} [dirname]
 *   Set `dirname`.
 * @property {Data | null | undefined} [data]
 *   Set `data`.
 *
 * @typedef Map
 *   Raw source map.
 *
 *   See:
 *   <https://github.com/mozilla/source-map/blob/58819f0/source-map.d.ts#L15-L23>.
 * @property {number} version
 *   Which version of the source map spec this map is following.
 * @property {Array<string>} sources
 *   An array of URLs to the original source files.
 * @property {Array<string>} names
 *   An array of identifiers which can be referenced by individual mappings.
 * @property {string | undefined} [sourceRoot]
 *   The URL root from which all sources are relative.
 * @property {Array<string> | undefined} [sourcesContent]
 *   An array of contents of the original source files.
 * @property {string} mappings
 *   A string of base64 VLQs which contain the actual mappings.
 * @property {string} file
 *   The generated file this source map is associated with.
 *
 * @typedef {{[key: string]: unknown} & VFileCoreOptions} Options
 *   Configuration.
 *
 *   A bunch of keys that will be shallow copied over to the new file.
 *
 * @typedef {Record<string, unknown>} ReporterSettings
 *   Configuration for reporters.
 */ /**
 * @template {ReporterSettings} Settings
 *   Options type.
 * @callback Reporter
 *   Type for a reporter.
 * @param {Array<VFile>} files
 *   Files to report.
 * @param {Settings} options
 *   Configuration.
 * @returns {string}
 *   Report.
 */ var $c7ba1312e8534a1c$exports = {};
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ $c7ba1312e8534a1c$exports = function isBuffer(obj) {
    return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
};


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Serialize the positional info of a point, position (start and end points),
 * or node.
 *
 * @param {Node | NodeLike | Position | PositionLike | Point | PointLike | null | undefined} [value]
 *   Node, position, or point.
 * @returns {string}
 *   Pretty printed positional info of a node (`string`).
 *
 *   In the format of a range `ls:cs-le:ce` (when given `node` or `position`)
 *   or a point `l:c` (when given `point`), where `l` stands for line, `c` for
 *   column, `s` for `start`, and `e` for end.
 *   An empty string (`''`) is returned if the given value is neither `node`,
 *   `position`, nor `point`.
 */ function $9273ea25044c2ed9$export$c304dd45fe166145(value) {
    // Nothing.
    if (!value || typeof value !== 'object') return '';
    // Node.
    if ('position' in value || 'type' in value) return $9273ea25044c2ed9$var$position(value.position);
    // Position.
    if ('start' in value || 'end' in value) return $9273ea25044c2ed9$var$position(value);
    // Point.
    if ('line' in value || 'column' in value) return $9273ea25044c2ed9$var$point(value);
    // ?
    return '';
}
/**
 * @param {Point | PointLike | null | undefined} point
 * @returns {string}
 */ function $9273ea25044c2ed9$var$point(point) {
    return $9273ea25044c2ed9$var$index(point && point.line) + ':' + $9273ea25044c2ed9$var$index(point && point.column);
}
/**
 * @param {Position | PositionLike | null | undefined} pos
 * @returns {string}
 */ function $9273ea25044c2ed9$var$position(pos) {
    return $9273ea25044c2ed9$var$point(pos && pos.start) + '-' + $9273ea25044c2ed9$var$point(pos && pos.end);
}
/**
 * @param {number | null | undefined} value
 * @returns {number}
 */ function $9273ea25044c2ed9$var$index(value) {
    return value && typeof value === 'number' ? value : 1;
}


class $d04ce82d9197945b$export$752e5c445fe834ef extends Error {
    /**
   * Create a message for `reason` at `place` from `origin`.
   *
   * When an error is passed in as `reason`, the `stack` is copied.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   *
   *   > 👉 **Note**: you should use markdown.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */ // To do: next major: expose `undefined` everywhere instead of `null`.
    constructor(reason, place, origin){
        /** @type {[string | null, string | null]} */ const parts = [
            null,
            null
        ];
        /** @type {Position} */ let position = {
            // @ts-expect-error: we always follows the structure of `position`.
            start: {
                line: null,
                column: null
            },
            // @ts-expect-error: "
            end: {
                line: null,
                column: null
            }
        };
        super();
        if (typeof place === 'string') {
            origin = place;
            place = undefined;
        }
        if (typeof origin === 'string') {
            const index = origin.indexOf(':');
            if (index === -1) parts[1] = origin;
            else {
                parts[0] = origin.slice(0, index);
                parts[1] = origin.slice(index + 1);
            }
        }
        if (place) {
            // Node.
            if ('type' in place || 'position' in place) {
                if (place.position) // To do: next major: deep clone.
                // @ts-expect-error: looks like a position.
                position = place.position;
            } else if ('start' in place || 'end' in place) // @ts-expect-error: looks like a position.
            // To do: next major: deep clone.
            position = place;
            else if ('line' in place || 'column' in place) // To do: next major: deep clone.
            position.start = place;
        }
        // Fields from `Error`.
        /**
     * Serialized positional info of error.
     *
     * On normal errors, this would be something like `ParseError`, buit in
     * `VFile` messages we use this space to show where an error happened.
     */ this.name = (0, $9273ea25044c2ed9$export$c304dd45fe166145)(place) || '1:1';
        /**
     * Reason for message.
     *
     * @type {string}
     */ this.message = typeof reason === 'object' ? reason.message : reason;
        /**
     * Stack of message.
     *
     * This is used by normal errors to show where something happened in
     * programming code, irrelevant for `VFile` messages,
     *
     * @type {string}
     */ this.stack = '';
        if (typeof reason === 'object' && reason.stack) this.stack = reason.stack;
        /**
     * Reason for message.
     *
     * > 👉 **Note**: you should use markdown.
     *
     * @type {string}
     */ this.reason = this.message;
        /* eslint-disable no-unused-expressions */ /**
     * State of problem.
     *
     * * `true` — marks associated file as no longer processable (error)
     * * `false` — necessitates a (potential) change (warning)
     * * `null | undefined` — for things that might not need changing (info)
     *
     * @type {boolean | null | undefined}
     */ this.fatal;
        /**
     * Starting line of error.
     *
     * @type {number | null}
     */ this.line = position.start.line;
        /**
     * Starting column of error.
     *
     * @type {number | null}
     */ this.column = position.start.column;
        /**
     * Full unist position.
     *
     * @type {Position | null}
     */ this.position = position;
        /**
     * Namespace of message (example: `'my-package'`).
     *
     * @type {string | null}
     */ this.source = parts[0];
        /**
     * Category of message (example: `'my-rule'`).
     *
     * @type {string | null}
     */ this.ruleId = parts[1];
        /**
     * Path of a file (used throughout the `VFile` ecosystem).
     *
     * @type {string | null}
     */ this.file;
        // The following fields are “well known”.
        // Not standard.
        // Feel free to add other non-standard fields to your messages.
        /**
     * Specify the source value that’s being reported, which is deemed
     * incorrect.
     *
     * @type {string | null}
     */ this.actual;
        /**
     * Suggest acceptable values that can be used instead of `actual`.
     *
     * @type {Array<string> | null}
     */ this.expected;
        /**
     * Link to docs for the message.
     *
     * > 👉 **Note**: this must be an absolute URL that can be passed as `x`
     * > to `new URL(x)`.
     *
     * @type {string | null}
     */ this.url;
        /**
     * Long form description of the message (you should use markdown).
     *
     * @type {string | null}
     */ this.note;
    /* eslint-enable no-unused-expressions */ }
}
$d04ce82d9197945b$export$752e5c445fe834ef.prototype.file = '';
$d04ce82d9197945b$export$752e5c445fe834ef.prototype.name = '';
$d04ce82d9197945b$export$752e5c445fe834ef.prototype.reason = '';
$d04ce82d9197945b$export$752e5c445fe834ef.prototype.message = '';
$d04ce82d9197945b$export$752e5c445fe834ef.prototype.stack = '';
$d04ce82d9197945b$export$752e5c445fe834ef.prototype.fatal = null;
$d04ce82d9197945b$export$752e5c445fe834ef.prototype.column = null;
$d04ce82d9197945b$export$752e5c445fe834ef.prototype.line = null;
$d04ce82d9197945b$export$752e5c445fe834ef.prototype.source = null;
$d04ce82d9197945b$export$752e5c445fe834ef.prototype.ruleId = null;
$d04ce82d9197945b$export$752e5c445fe834ef.prototype.position = null;


// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
const $aedaa68cfe36f852$export$bb654e07daaf8c3a = {
    basename: $aedaa68cfe36f852$var$basename,
    dirname: $aedaa68cfe36f852$var$dirname,
    extname: $aedaa68cfe36f852$var$extname,
    join: $aedaa68cfe36f852$var$join,
    sep: '/'
};
/* eslint-disable max-depth, complexity */ /**
 * Get the basename from a path.
 *
 * @param {string} path
 *   File path.
 * @param {string | undefined} [ext]
 *   Extension to strip.
 * @returns {string}
 *   Stem or basename.
 */ function $aedaa68cfe36f852$var$basename(path, ext) {
    if (ext !== undefined && typeof ext !== 'string') throw new TypeError('"ext" argument must be a string');
    $aedaa68cfe36f852$var$assertPath(path);
    let start = 0;
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let seenNonSlash;
    if (ext === undefined || ext.length === 0 || ext.length > path.length) {
        while(index--){
            if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            {
                if (seenNonSlash) {
                    start = index + 1;
                    break;
                }
            } else if (end < 0) {
                // We saw the first non-path separator, mark this as the end of our
                // path component.
                seenNonSlash = true;
                end = index + 1;
            }
        }
        return end < 0 ? '' : path.slice(start, end);
    }
    if (ext === path) return '';
    let firstNonSlashEnd = -1;
    let extIndex = ext.length - 1;
    while(index--){
        if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        {
            if (seenNonSlash) {
                start = index + 1;
                break;
            }
        } else {
            if (firstNonSlashEnd < 0) {
                // We saw the first non-path separator, remember this index in case
                // we need it if the extension ends up not matching.
                seenNonSlash = true;
                firstNonSlashEnd = index + 1;
            }
            if (extIndex > -1) {
                // Try to match the explicit extension.
                if (path.charCodeAt(index) === ext.charCodeAt(extIndex--)) {
                    if (extIndex < 0) // We matched the extension, so mark this as the end of our path
                    // component
                    end = index;
                } else {
                    // Extension does not match, so our result is the entire path
                    // component
                    extIndex = -1;
                    end = firstNonSlashEnd;
                }
            }
        }
    }
    if (start === end) end = firstNonSlashEnd;
    else if (end < 0) end = path.length;
    return path.slice(start, end);
}
/**
 * Get the dirname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ function $aedaa68cfe36f852$var$dirname(path) {
    $aedaa68cfe36f852$var$assertPath(path);
    if (path.length === 0) return '.';
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    // Prefix `--` is important to not run on `0`.
    while(--index){
        if (path.charCodeAt(index) === 47 /* `/` */ ) {
            if (unmatchedSlash) {
                end = index;
                break;
            }
        } else if (!unmatchedSlash) // We saw the first non-path separator
        unmatchedSlash = true;
    }
    return end < 0 ? path.charCodeAt(0) === 47 /* `/` */  ? '/' : '.' : end === 1 && path.charCodeAt(0) === 47 /* `/` */  ? '//' : path.slice(0, end);
}
/**
 * Get an extname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   Extname.
 */ function $aedaa68cfe36f852$var$extname(path) {
    $aedaa68cfe36f852$var$assertPath(path);
    let index = path.length;
    let end = -1;
    let startPart = 0;
    let startDot = -1;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find.
    let preDotState = 0;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    while(index--){
        const code = path.charCodeAt(index);
        if (code === 47 /* `/` */ ) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            if (unmatchedSlash) {
                startPart = index + 1;
                break;
            }
            continue;
        }
        if (end < 0) {
            // We saw the first non-path separator, mark this as the end of our
            // extension.
            unmatchedSlash = true;
            end = index + 1;
        }
        if (code === 46 /* `.` */ ) {
            // If this is our first dot, mark it as the start of our extension.
            if (startDot < 0) startDot = index;
            else if (preDotState !== 1) preDotState = 1;
        } else if (startDot > -1) // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension.
        preDotState = -1;
    }
    if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
    preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return '';
    return path.slice(startDot, end);
}
/**
 * Join segments from a path.
 *
 * @param {Array<string>} segments
 *   Path segments.
 * @returns {string}
 *   File path.
 */ function $aedaa68cfe36f852$var$join(...segments) {
    let index = -1;
    /** @type {string | undefined} */ let joined;
    while(++index < segments.length){
        $aedaa68cfe36f852$var$assertPath(segments[index]);
        if (segments[index]) joined = joined === undefined ? segments[index] : joined + '/' + segments[index];
    }
    return joined === undefined ? '.' : $aedaa68cfe36f852$var$normalize(joined);
}
/**
 * Normalize a basic file path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ // Note: `normalize` is not exposed as `path.normalize`, so some code is
// manually removed from it.
function $aedaa68cfe36f852$var$normalize(path) {
    $aedaa68cfe36f852$var$assertPath(path);
    const absolute = path.charCodeAt(0) === 47 /* `/` */ ;
    // Normalize the path according to POSIX rules.
    let value = $aedaa68cfe36f852$var$normalizeString(path, !absolute);
    if (value.length === 0 && !absolute) value = '.';
    if (value.length > 0 && path.charCodeAt(path.length - 1) === 47 /* / */ ) value += '/';
    return absolute ? '/' + value : value;
}
/**
 * Resolve `.` and `..` elements in a path with directory names.
 *
 * @param {string} path
 *   File path.
 * @param {boolean} allowAboveRoot
 *   Whether `..` can move above root.
 * @returns {string}
 *   File path.
 */ function $aedaa68cfe36f852$var$normalizeString(path, allowAboveRoot) {
    let result = '';
    let lastSegmentLength = 0;
    let lastSlash = -1;
    let dots = 0;
    let index = -1;
    /** @type {number | undefined} */ let code;
    /** @type {number} */ let lastSlashIndex;
    while(++index <= path.length){
        if (index < path.length) code = path.charCodeAt(index);
        else if (code === 47 /* `/` */ ) break;
        else code = 47 /* `/` */ ;
        if (code === 47 /* `/` */ ) {
            if (lastSlash === index - 1 || dots === 1) ;
            else if (lastSlash !== index - 1 && dots === 2) {
                if (result.length < 2 || lastSegmentLength !== 2 || result.charCodeAt(result.length - 1) !== 46 /* `.` */  || result.charCodeAt(result.length - 2) !== 46 /* `.` */ ) {
                    if (result.length > 2) {
                        lastSlashIndex = result.lastIndexOf('/');
                        if (lastSlashIndex !== result.length - 1) {
                            if (lastSlashIndex < 0) {
                                result = '';
                                lastSegmentLength = 0;
                            } else {
                                result = result.slice(0, lastSlashIndex);
                                lastSegmentLength = result.length - 1 - result.lastIndexOf('/');
                            }
                            lastSlash = index;
                            dots = 0;
                            continue;
                        }
                    } else if (result.length > 0) {
                        result = '';
                        lastSegmentLength = 0;
                        lastSlash = index;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    result = result.length > 0 ? result + '/..' : '..';
                    lastSegmentLength = 2;
                }
            } else {
                if (result.length > 0) result += '/' + path.slice(lastSlash + 1, index);
                else result = path.slice(lastSlash + 1, index);
                lastSegmentLength = index - lastSlash - 1;
            }
            lastSlash = index;
            dots = 0;
        } else if (code === 46 /* `.` */  && dots > -1) dots++;
        else dots = -1;
    }
    return result;
}
/**
 * Make sure `path` is a string.
 *
 * @param {string} path
 *   File path.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $aedaa68cfe36f852$var$assertPath(path) {
    if (typeof path !== 'string') throw new TypeError('Path must be a string. Received ' + JSON.stringify(path));
} /* eslint-enable max-depth, complexity */ 


// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
const $c47256e3d2b5a354$export$97a5aaf482767187 = {
    cwd: $c47256e3d2b5a354$var$cwd
};
function $c47256e3d2b5a354$var$cwd() {
    return '/';
}


/// <reference lib="dom" />
/**
 * @typedef URL
 * @property {string} hash
 * @property {string} host
 * @property {string} hostname
 * @property {string} href
 * @property {string} origin
 * @property {string} password
 * @property {string} pathname
 * @property {string} port
 * @property {string} protocol
 * @property {string} search
 * @property {any} searchParams
 * @property {string} username
 * @property {() => string} toString
 * @property {() => string} toJSON
 */ /**
 * Check if `fileUrlOrPath` looks like a URL.
 *
 * @param {unknown} fileUrlOrPath
 *   File path or URL.
 * @returns {fileUrlOrPath is URL}
 *   Whether it’s a URL.
 */ // From: <https://github.com/nodejs/node/blob/fcf8ba4/lib/internal/url.js#L1501>
function $8550ee39725bf9b9$export$8304a22d431f958(fileUrlOrPath) {
    return fileUrlOrPath !== null && typeof fileUrlOrPath === 'object' && // @ts-expect-error: indexable.
    fileUrlOrPath.href && // @ts-expect-error: indexable.
    fileUrlOrPath.origin;
}


function $3e1edefe0844bd38$export$9b2b676c902de799(path) {
    if (typeof path === 'string') path = new URL(path);
    else if (!(0, $8550ee39725bf9b9$export$8304a22d431f958)(path)) {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('The "path" argument must be of type string or an instance of URL. Received `' + path + '`');
        error.code = 'ERR_INVALID_ARG_TYPE';
        throw error;
    }
    if (path.protocol !== 'file:') {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('The URL must be of scheme file');
        error.code = 'ERR_INVALID_URL_SCHEME';
        throw error;
    }
    return $3e1edefe0844bd38$var$getPathFromURLPosix(path);
}
/**
 * Get a path from a POSIX URL.
 *
 * @param {URL} url
 *   URL.
 * @returns {string}
 *   File path.
 */ function $3e1edefe0844bd38$var$getPathFromURLPosix(url) {
    if (url.hostname !== '') {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('File URL host must be "localhost" or empty on darwin');
        error.code = 'ERR_INVALID_FILE_URL_HOST';
        throw error;
    }
    const pathname = url.pathname;
    let index = -1;
    while(++index < pathname.length)if (pathname.charCodeAt(index) === 37 /* `%` */  && pathname.charCodeAt(index + 1) === 50 /* `2` */ ) {
        const third = pathname.charCodeAt(index + 2);
        if (third === 70 /* `F` */  || third === 102 /* `f` */ ) {
            /** @type {NodeJS.ErrnoException} */ const error = new TypeError('File URL path must not include encoded / characters');
            error.code = 'ERR_INVALID_FILE_URL_PATH';
            throw error;
        }
    }
    return decodeURIComponent(pathname);
}


/**
 * Order of setting (least specific to most), we need this because otherwise
 * `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
 * stem can be set.
 *
 * @type {Array<'basename' | 'dirname' | 'extname' | 'history' | 'path' | 'stem'>}
 */ const $1721c824e44cfb0f$var$order = [
    'history',
    'path',
    'basename',
    'stem',
    'extname',
    'dirname'
];
class $1721c824e44cfb0f$export$93dff69eb10dc7ce {
    /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Buffer` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */ constructor(value){
        /** @type {Options | VFile} */ let options;
        if (!value) options = {};
        else if (typeof value === 'string' || $1721c824e44cfb0f$var$buffer(value)) options = {
            value: value
        };
        else if ((0, $8550ee39725bf9b9$export$8304a22d431f958)(value)) options = {
            path: value
        };
        else options = value;
        /**
     * Place to store custom information (default: `{}`).
     *
     * It’s OK to store custom data directly on the file but moving it to
     * `data` is recommended.
     *
     * @type {Data}
     */ this.data = {};
        /**
     * List of messages associated with the file.
     *
     * @type {Array<VFileMessage>}
     */ this.messages = [];
        /**
     * List of filepaths the file moved between.
     *
     * The first is the original path and the last is the current path.
     *
     * @type {Array<string>}
     */ this.history = [];
        /**
     * Base of `path` (default: `process.cwd()` or `'/'` in browsers).
     *
     * @type {string}
     */ this.cwd = (0, $c47256e3d2b5a354$export$97a5aaf482767187).cwd();
        /* eslint-disable no-unused-expressions */ /**
     * Raw value.
     *
     * @type {Value}
     */ this.value;
        // The below are non-standard, they are “well-known”.
        // As in, used in several tools.
        /**
     * Whether a file was saved to disk.
     *
     * This is used by vfile reporters.
     *
     * @type {boolean}
     */ this.stored;
        /**
     * Custom, non-string, compiled, representation.
     *
     * This is used by unified to store non-string results.
     * One example is when turning markdown into React nodes.
     *
     * @type {unknown}
     */ this.result;
        /**
     * Source map.
     *
     * This type is equivalent to the `RawSourceMap` type from the `source-map`
     * module.
     *
     * @type {Map | null | undefined}
     */ this.map;
        /* eslint-enable no-unused-expressions */ // Set path related properties in the correct order.
        let index = -1;
        while(++index < $1721c824e44cfb0f$var$order.length){
            const prop = $1721c824e44cfb0f$var$order[index];
            // Note: we specifically use `in` instead of `hasOwnProperty` to accept
            // `vfile`s too.
            if (prop in options && options[prop] !== undefined && options[prop] !== null) // @ts-expect-error: TS doesn’t understand basic reality.
            this[prop] = prop === 'history' ? [
                ...options[prop]
            ] : options[prop];
        }
        /** @type {string} */ let prop;
        // Set non-path related properties.
        for(prop in options)// @ts-expect-error: fine to set other things.
        if (!$1721c824e44cfb0f$var$order.includes(prop)) // @ts-expect-error: fine to set other things.
        this[prop] = options[prop];
    }
    /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   */ get path() {
        return this.history[this.history.length - 1];
    }
    /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {string | URL} path
   */ set path(path) {
        if ((0, $8550ee39725bf9b9$export$8304a22d431f958)(path)) path = (0, $3e1edefe0844bd38$export$9b2b676c902de799)(path);
        $1721c824e44cfb0f$var$assertNonEmpty(path, 'path');
        if (this.path !== path) this.history.push(path);
    }
    /**
   * Get the parent path (example: `'~'`).
   */ get dirname() {
        return typeof this.path === 'string' ? (0, $aedaa68cfe36f852$export$bb654e07daaf8c3a).dirname(this.path) : undefined;
    }
    /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   */ set dirname(dirname) {
        $1721c824e44cfb0f$var$assertPath(this.basename, 'dirname');
        this.path = (0, $aedaa68cfe36f852$export$bb654e07daaf8c3a).join(dirname || '', this.basename);
    }
    /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   */ get basename() {
        return typeof this.path === 'string' ? (0, $aedaa68cfe36f852$export$bb654e07daaf8c3a).basename(this.path) : undefined;
    }
    /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */ set basename(basename) {
        $1721c824e44cfb0f$var$assertNonEmpty(basename, 'basename');
        $1721c824e44cfb0f$var$assertPart(basename, 'basename');
        this.path = (0, $aedaa68cfe36f852$export$bb654e07daaf8c3a).join(this.dirname || '', basename);
    }
    /**
   * Get the extname (including dot) (example: `'.js'`).
   */ get extname() {
        return typeof this.path === 'string' ? (0, $aedaa68cfe36f852$export$bb654e07daaf8c3a).extname(this.path) : undefined;
    }
    /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   */ set extname(extname) {
        $1721c824e44cfb0f$var$assertPart(extname, 'extname');
        $1721c824e44cfb0f$var$assertPath(this.dirname, 'extname');
        if (extname) {
            if (extname.charCodeAt(0) !== 46 /* `.` */ ) throw new Error('`extname` must start with `.`');
            if (extname.includes('.', 1)) throw new Error('`extname` cannot contain multiple dots');
        }
        this.path = (0, $aedaa68cfe36f852$export$bb654e07daaf8c3a).join(this.dirname, this.stem + (extname || ''));
    }
    /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   */ get stem() {
        return typeof this.path === 'string' ? (0, $aedaa68cfe36f852$export$bb654e07daaf8c3a).basename(this.path, this.extname) : undefined;
    }
    /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */ set stem(stem) {
        $1721c824e44cfb0f$var$assertNonEmpty(stem, 'stem');
        $1721c824e44cfb0f$var$assertPart(stem, 'stem');
        this.path = (0, $aedaa68cfe36f852$export$bb654e07daaf8c3a).join(this.dirname || '', stem + (this.extname || ''));
    }
    /**
   * Serialize the file.
   *
   * @param {BufferEncoding | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Buffer`
   *   (default: `'utf8'`).
   * @returns {string}
   *   Serialized file.
   */ toString(encoding) {
        return (this.value || '').toString(encoding || undefined);
    }
    /**
   * Create a warning message associated with the file.
   *
   * Its `fatal` is set to `false` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ message(reason, place, origin) {
        const message = new (0, $d04ce82d9197945b$export$752e5c445fe834ef)(reason, place, origin);
        if (this.path) {
            message.name = this.path + ':' + message.name;
            message.file = this.path;
        }
        message.fatal = false;
        this.messages.push(message);
        return message;
    }
    /**
   * Create an info message associated with the file.
   *
   * Its `fatal` is set to `null` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ info(reason, place, origin) {
        const message = this.message(reason, place, origin);
        message.fatal = null;
        return message;
    }
    /**
   * Create a fatal error associated with the file.
   *
   * Its `fatal` is set to `true` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * > 👉 **Note**: a fatal error means that a file is no longer processable.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Message.
   * @throws {VFileMessage}
   *   Message.
   */ fail(reason, place, origin) {
        const message = this.message(reason, place, origin);
        message.fatal = true;
        throw message;
    }
}
/**
 * Assert that `part` is not a path (as in, does not contain `path.sep`).
 *
 * @param {string | null | undefined} part
 *   File path part.
 * @param {string} name
 *   Part name.
 * @returns {void}
 *   Nothing.
 */ function $1721c824e44cfb0f$var$assertPart(part, name) {
    if (part && part.includes((0, $aedaa68cfe36f852$export$bb654e07daaf8c3a).sep)) throw new Error('`' + name + '` cannot be a path: did not expect `' + (0, $aedaa68cfe36f852$export$bb654e07daaf8c3a).sep + '`');
}
/**
 * Assert that `part` is not empty.
 *
 * @param {string | undefined} part
 *   Thing.
 * @param {string} name
 *   Part name.
 * @returns {asserts part is string}
 *   Nothing.
 */ function $1721c824e44cfb0f$var$assertNonEmpty(part, name) {
    if (!part) throw new Error('`' + name + '` cannot be empty');
}
/**
 * Assert `path` exists.
 *
 * @param {string | undefined} path
 *   Path.
 * @param {string} name
 *   Dependency name.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $1721c824e44cfb0f$var$assertPath(path, name) {
    if (!path) throw new Error('Setting `' + name + '` requires `path` to be set too');
}
/**
 * Assert `value` is a buffer.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Buffer}
 *   Whether `value` is a Node.js buffer.
 */ function $1721c824e44cfb0f$var$buffer(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($c7ba1312e8534a1c$exports)))(value);
}


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('vfile').VFileCompatible} VFileCompatible
 * @typedef {import('vfile').VFileValue} VFileValue
 * @typedef {import('..').Processor} Processor
 * @typedef {import('..').Plugin} Plugin
 * @typedef {import('..').Preset} Preset
 * @typedef {import('..').Pluggable} Pluggable
 * @typedef {import('..').PluggableList} PluggableList
 * @typedef {import('..').Transformer} Transformer
 * @typedef {import('..').Parser} Parser
 * @typedef {import('..').Compiler} Compiler
 * @typedef {import('..').RunCallback} RunCallback
 * @typedef {import('..').ProcessCallback} ProcessCallback
 *
 * @typedef Context
 * @property {Node} tree
 * @property {VFile} file
 */ /**
 * Throw a given error.
 *
 * @param {Error|null|undefined} [error]
 *   Maybe error.
 * @returns {asserts error is null|undefined}
 */ function $fad4d3de0a592c27$export$dd911e13ecb11e05(error) {
    if (error) throw error;
}



var $26e7a51f9ca4104b$exports = {};
'use strict';
var $26e7a51f9ca4104b$var$hasOwn = Object.prototype.hasOwnProperty;
var $26e7a51f9ca4104b$var$toStr = Object.prototype.toString;
var $26e7a51f9ca4104b$var$defineProperty = Object.defineProperty;
var $26e7a51f9ca4104b$var$gOPD = Object.getOwnPropertyDescriptor;
var $26e7a51f9ca4104b$var$isArray = function isArray(arr) {
    if (typeof Array.isArray === 'function') return Array.isArray(arr);
    return $26e7a51f9ca4104b$var$toStr.call(arr) === '[object Array]';
};
var $26e7a51f9ca4104b$var$isPlainObject = function isPlainObject(obj) {
    if (!obj || $26e7a51f9ca4104b$var$toStr.call(obj) !== '[object Object]') return false;
    var hasOwnConstructor = $26e7a51f9ca4104b$var$hasOwn.call(obj, 'constructor');
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && $26e7a51f9ca4104b$var$hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
    // Not own constructor property must be Object
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    var key;
    for(key in obj);
    return typeof key === 'undefined' || $26e7a51f9ca4104b$var$hasOwn.call(obj, key);
};
// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var $26e7a51f9ca4104b$var$setProperty = function setProperty(target, options) {
    if ($26e7a51f9ca4104b$var$defineProperty && options.name === '__proto__') $26e7a51f9ca4104b$var$defineProperty(target, options.name, {
        enumerable: true,
        configurable: true,
        value: options.newValue,
        writable: true
    });
    else target[options.name] = options.newValue;
};
// Return undefined instead of __proto__ if '__proto__' is not an own property
var $26e7a51f9ca4104b$var$getProperty = function getProperty(obj, name) {
    if (name === '__proto__') {
        if (!$26e7a51f9ca4104b$var$hasOwn.call(obj, name)) return void 0;
        else if ($26e7a51f9ca4104b$var$gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
        // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
        return $26e7a51f9ca4104b$var$gOPD(obj, name).value;
    }
    return obj[name];
};
$26e7a51f9ca4104b$exports = function extend() {
    var options, name, src, copy, copyIsArray, clone;
    var target = arguments[0];
    var i = 1;
    var length = arguments.length;
    var deep = false;
    // Handle a deep copy situation
    if (typeof target === 'boolean') {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    }
    if (target == null || typeof target !== 'object' && typeof target !== 'function') target = {};
    for(; i < length; ++i){
        options = arguments[i];
        // Only deal with non-null/undefined values
        if (options != null) // Extend the base object
        for(name in options){
            src = $26e7a51f9ca4104b$var$getProperty(target, name);
            copy = $26e7a51f9ca4104b$var$getProperty(options, name);
            // Prevent never-ending loop
            if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && ($26e7a51f9ca4104b$var$isPlainObject(copy) || (copyIsArray = $26e7a51f9ca4104b$var$isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && $26e7a51f9ca4104b$var$isArray(src) ? src : [];
                    } else clone = src && $26e7a51f9ca4104b$var$isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    $26e7a51f9ca4104b$var$setProperty(target, {
                        name: name,
                        newValue: extend(deep, clone, copy)
                    });
                // Don't bring in undefined values
                } else if (typeof copy !== 'undefined') $26e7a51f9ca4104b$var$setProperty(target, {
                    name: name,
                    newValue: copy
                });
            }
        }
    }
    // Return the modified object
    return target;
};


function $0e5c9b0577e44af4$export$2e2bcd8739ae039(value) {
    if (typeof value !== 'object' || value === null) return false;
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}


// To do: remove `void`s
// To do: remove `null` from output of our APIs, allow it as user APIs.
/**
 * @typedef {(error?: Error | null | undefined, ...output: Array<any>) => void} Callback
 *   Callback.
 *
 * @typedef {(...input: Array<any>) => any} Middleware
 *   Ware.
 *
 * @typedef Pipeline
 *   Pipeline.
 * @property {Run} run
 *   Run the pipeline.
 * @property {Use} use
 *   Add middleware.
 *
 * @typedef {(...input: Array<any>) => void} Run
 *   Call all middleware.
 *
 *   Calls `done` on completion with either an error or the output of the
 *   last middleware.
 *
 *   > 👉 **Note**: as the length of input defines whether async functions get a
 *   > `next` function,
 *   > it’s recommended to keep `input` at one value normally.

 *
 * @typedef {(fn: Middleware) => Pipeline} Use
 *   Add middleware.
 */ /**
 * Create new middleware.
 *
 * @returns {Pipeline}
 *   Pipeline.
 */ function $c8c259b9b0716925$export$91b56f5ca106aa43() {
    /** @type {Array<Middleware>} */ const fns = [];
    /** @type {Pipeline} */ const pipeline = {
        run: run,
        use: use
    };
    return pipeline;
    /** @type {Run} */ function run(...values) {
        let middlewareIndex = -1;
        /** @type {Callback} */ const callback = values.pop();
        if (typeof callback !== 'function') throw new TypeError('Expected function as last argument, not ' + callback);
        next(null, ...values);
        /**
     * Run the next `fn`, or we’re done.
     *
     * @param {Error | null | undefined} error
     * @param {Array<any>} output
     */ function next(error, ...output) {
            const fn = fns[++middlewareIndex];
            let index = -1;
            if (error) {
                callback(error);
                return;
            }
            // Copy non-nullish input into values.
            while(++index < values.length)if (output[index] === null || output[index] === undefined) output[index] = values[index];
            // Save the newly created `output` for the next call.
            values = output;
            // Next or done.
            if (fn) $c8c259b9b0716925$export$4997ffc0176396a6(fn, next)(...output);
            else callback(null, ...output);
        }
    }
    /** @type {Use} */ function use(middelware) {
        if (typeof middelware !== 'function') throw new TypeError('Expected `middelware` to be a function, not ' + middelware);
        fns.push(middelware);
        return pipeline;
    }
}
function $c8c259b9b0716925$export$4997ffc0176396a6(middleware, callback) {
    /** @type {boolean} */ let called;
    return wrapped;
    /**
   * Call `middleware`.
   * @this {any}
   * @param {Array<any>} parameters
   * @returns {void}
   */ function wrapped(...parameters) {
        const fnExpectsCallback = middleware.length > parameters.length;
        /** @type {any} */ let result;
        if (fnExpectsCallback) parameters.push(done);
        try {
            result = middleware.apply(this, parameters);
        } catch (error) {
            const exception = /** @type {Error} */ error;
            // Well, this is quite the pickle.
            // `middleware` received a callback and called it synchronously, but that
            // threw an error.
            // The only thing left to do is to throw the thing instead.
            if (fnExpectsCallback && called) throw exception;
            return done(exception);
        }
        if (!fnExpectsCallback) {
            if (result && result.then && typeof result.then === 'function') result.then(then, done);
            else if (result instanceof Error) done(result);
            else then(result);
        }
    }
    /**
   * Call `callback`, only once.
   *
   * @type {Callback}
   */ function done(error, ...output) {
        if (!called) {
            called = true;
            callback(error, ...output);
        }
    }
    /**
   * Call `done` with one value.
   *
   * @param {any} [value]
   */ function then(value) {
        done(null, value);
    }
}



const $488c3d2fa2528428$export$7cc1b2fe10c52bb = $488c3d2fa2528428$var$base().freeze();
const $488c3d2fa2528428$var$own = {}.hasOwnProperty;
// Function to create the first processor.
/**
 * @returns {Processor}
 */ function $488c3d2fa2528428$var$base() {
    const transformers = (0, $c8c259b9b0716925$export$91b56f5ca106aa43)();
    /** @type {Processor['attachers']} */ const attachers = [];
    /** @type {Record<string, unknown>} */ let namespace = {};
    /** @type {boolean|undefined} */ let frozen;
    let freezeIndex = -1;
    // Data management.
    // @ts-expect-error: overloads are handled.
    processor.data = data;
    processor.Parser = undefined;
    processor.Compiler = undefined;
    // Lock.
    processor.freeze = freeze;
    // Plugins.
    processor.attachers = attachers;
    // @ts-expect-error: overloads are handled.
    processor.use = use;
    // API.
    processor.parse = parse;
    processor.stringify = stringify;
    // @ts-expect-error: overloads are handled.
    processor.run = run;
    processor.runSync = runSync;
    // @ts-expect-error: overloads are handled.
    processor.process = process;
    processor.processSync = processSync;
    // Expose.
    return processor;
    // Create a new processor based on the processor in the current scope.
    /** @type {Processor} */ function processor() {
        const destination = $488c3d2fa2528428$var$base();
        let index = -1;
        while(++index < attachers.length)destination.use(...attachers[index]);
        destination.data((0, (/*@__PURE__*/$parcel$interopDefault($26e7a51f9ca4104b$exports)))(true, {}, namespace));
        return destination;
    }
    /**
   * @param {string|Record<string, unknown>} [key]
   * @param {unknown} [value]
   * @returns {unknown}
   */ function data(key, value) {
        if (typeof key === 'string') {
            // Set `key`.
            if (arguments.length === 2) {
                $488c3d2fa2528428$var$assertUnfrozen('data', frozen);
                namespace[key] = value;
                return processor;
            }
            // Get `key`.
            return $488c3d2fa2528428$var$own.call(namespace, key) && namespace[key] || null;
        }
        // Set space.
        if (key) {
            $488c3d2fa2528428$var$assertUnfrozen('data', frozen);
            namespace = key;
            return processor;
        }
        // Get space.
        return namespace;
    }
    /** @type {Processor['freeze']} */ function freeze() {
        if (frozen) return processor;
        while(++freezeIndex < attachers.length){
            const [attacher, ...options] = attachers[freezeIndex];
            if (options[0] === false) continue;
            if (options[0] === true) options[0] = undefined;
            /** @type {Transformer|void} */ const transformer = attacher.call(processor, ...options);
            if (typeof transformer === 'function') transformers.use(transformer);
        }
        frozen = true;
        freezeIndex = Number.POSITIVE_INFINITY;
        return processor;
    }
    /**
   * @param {Pluggable|null|undefined} [value]
   * @param {...unknown} options
   * @returns {Processor}
   */ function use(value, ...options) {
        /** @type {Record<string, unknown>|undefined} */ let settings;
        $488c3d2fa2528428$var$assertUnfrozen('use', frozen);
        if (value === null || value === undefined) ;
        else if (typeof value === 'function') addPlugin(value, ...options);
        else if (typeof value === 'object') {
            if (Array.isArray(value)) addList(value);
            else addPreset(value);
        } else throw new TypeError('Expected usable value, not `' + value + '`');
        if (settings) namespace.settings = Object.assign(namespace.settings || {}, settings);
        return processor;
        /**
     * @param {import('..').Pluggable<unknown[]>} value
     * @returns {void}
     */ function add(value) {
            if (typeof value === 'function') addPlugin(value);
            else if (typeof value === 'object') {
                if (Array.isArray(value)) {
                    const [plugin, ...options] = value;
                    addPlugin(plugin, ...options);
                } else addPreset(value);
            } else throw new TypeError('Expected usable value, not `' + value + '`');
        }
        /**
     * @param {Preset} result
     * @returns {void}
     */ function addPreset(result) {
            addList(result.plugins);
            if (result.settings) settings = Object.assign(settings || {}, result.settings);
        }
        /**
     * @param {PluggableList|null|undefined} [plugins]
     * @returns {void}
     */ function addList(plugins) {
            let index = -1;
            if (plugins === null || plugins === undefined) ;
            else if (Array.isArray(plugins)) while(++index < plugins.length){
                const thing = plugins[index];
                add(thing);
            }
            else throw new TypeError('Expected a list of plugins, not `' + plugins + '`');
        }
        /**
     * @param {Plugin} plugin
     * @param {...unknown} [value]
     * @returns {void}
     */ function addPlugin(plugin, value) {
            let index = -1;
            /** @type {Processor['attachers'][number]|undefined} */ let entry;
            while(++index < attachers.length)if (attachers[index][0] === plugin) {
                entry = attachers[index];
                break;
            }
            if (entry) {
                if ((0, $0e5c9b0577e44af4$export$2e2bcd8739ae039)(entry[1]) && (0, $0e5c9b0577e44af4$export$2e2bcd8739ae039)(value)) value = (0, (/*@__PURE__*/$parcel$interopDefault($26e7a51f9ca4104b$exports)))(true, entry[1], value);
                entry[1] = value;
            } else // @ts-expect-error: fine.
            attachers.push([
                ...arguments
            ]);
        }
    }
    /** @type {Processor['parse']} */ function parse(doc) {
        processor.freeze();
        const file = $488c3d2fa2528428$var$vfile(doc);
        const Parser = processor.Parser;
        $488c3d2fa2528428$var$assertParser('parse', Parser);
        if ($488c3d2fa2528428$var$newable(Parser, 'parse')) // @ts-expect-error: `newable` checks this.
        return new Parser(String(file), file).parse();
        // @ts-expect-error: `newable` checks this.
        return Parser(String(file), file) // eslint-disable-line new-cap
        ;
    }
    /** @type {Processor['stringify']} */ function stringify(node, doc) {
        processor.freeze();
        const file = $488c3d2fa2528428$var$vfile(doc);
        const Compiler = processor.Compiler;
        $488c3d2fa2528428$var$assertCompiler('stringify', Compiler);
        $488c3d2fa2528428$var$assertNode(node);
        if ($488c3d2fa2528428$var$newable(Compiler, 'compile')) // @ts-expect-error: `newable` checks this.
        return new Compiler(node, file).compile();
        // @ts-expect-error: `newable` checks this.
        return Compiler(node, file) // eslint-disable-line new-cap
        ;
    }
    /**
   * @param {Node} node
   * @param {VFileCompatible|RunCallback} [doc]
   * @param {RunCallback} [callback]
   * @returns {Promise<Node>|void}
   */ function run(node, doc, callback) {
        $488c3d2fa2528428$var$assertNode(node);
        processor.freeze();
        if (!callback && typeof doc === 'function') {
            callback = doc;
            doc = undefined;
        }
        if (!callback) return new Promise(executor);
        executor(null, callback);
        /**
     * @param {null|((node: Node) => void)} resolve
     * @param {(error: Error) => void} reject
     * @returns {void}
     */ function executor(resolve, reject) {
            // @ts-expect-error: `doc` can’t be a callback anymore, we checked.
            transformers.run(node, $488c3d2fa2528428$var$vfile(doc), done);
            /**
       * @param {Error|null} error
       * @param {Node} tree
       * @param {VFile} file
       * @returns {void}
       */ function done(error, tree, file) {
                tree = tree || node;
                if (error) reject(error);
                else if (resolve) resolve(tree);
                else // @ts-expect-error: `callback` is defined if `resolve` is not.
                callback(null, tree, file);
            }
        }
    }
    /** @type {Processor['runSync']} */ function runSync(node, file) {
        /** @type {Node|undefined} */ let result;
        /** @type {boolean|undefined} */ let complete;
        processor.run(node, file, done);
        $488c3d2fa2528428$var$assertDone('runSync', 'run', complete);
        // @ts-expect-error: we either bailed on an error or have a tree.
        return result;
        /**
     * @param {Error|null} [error]
     * @param {Node} [tree]
     * @returns {void}
     */ function done(error, tree) {
            (0, $fad4d3de0a592c27$export$dd911e13ecb11e05)(error);
            result = tree;
            complete = true;
        }
    }
    /**
   * @param {VFileCompatible} doc
   * @param {ProcessCallback} [callback]
   * @returns {Promise<VFile>|undefined}
   */ function process(doc, callback) {
        processor.freeze();
        $488c3d2fa2528428$var$assertParser('process', processor.Parser);
        $488c3d2fa2528428$var$assertCompiler('process', processor.Compiler);
        if (!callback) return new Promise(executor);
        executor(null, callback);
        /**
     * @param {null|((file: VFile) => void)} resolve
     * @param {(error?: Error|null|undefined) => void} reject
     * @returns {void}
     */ function executor(resolve, reject) {
            const file = $488c3d2fa2528428$var$vfile(doc);
            processor.run(processor.parse(file), file, (error, tree, file)=>{
                if (error || !tree || !file) done(error);
                else {
                    /** @type {unknown} */ const result = processor.stringify(tree, file);
                    if (result === undefined || result === null) ;
                    else if ($488c3d2fa2528428$var$looksLikeAVFileValue(result)) file.value = result;
                    else file.result = result;
                    done(error, file);
                }
            });
            /**
       * @param {Error|null|undefined} [error]
       * @param {VFile|undefined} [file]
       * @returns {void}
       */ function done(error, file) {
                if (error || !file) reject(error);
                else if (resolve) resolve(file);
                else // @ts-expect-error: `callback` is defined if `resolve` is not.
                callback(null, file);
            }
        }
    }
    /** @type {Processor['processSync']} */ function processSync(doc) {
        /** @type {boolean|undefined} */ let complete;
        processor.freeze();
        $488c3d2fa2528428$var$assertParser('processSync', processor.Parser);
        $488c3d2fa2528428$var$assertCompiler('processSync', processor.Compiler);
        const file = $488c3d2fa2528428$var$vfile(doc);
        processor.process(file, done);
        $488c3d2fa2528428$var$assertDone('processSync', 'process', complete);
        return file;
        /**
     * @param {Error|null|undefined} [error]
     * @returns {void}
     */ function done(error) {
            complete = true;
            (0, $fad4d3de0a592c27$export$dd911e13ecb11e05)(error);
        }
    }
}
/**
 * Check if `value` is a constructor.
 *
 * @param {unknown} value
 * @param {string} name
 * @returns {boolean}
 */ function $488c3d2fa2528428$var$newable(value, name) {
    return typeof value === 'function' && // Prototypes do exist.
    // type-coverage:ignore-next-line
    value.prototype && // A function with keys in its prototype is probably a constructor.
    // Classes’ prototype methods are not enumerable, so we check if some value
    // exists in the prototype.
    // type-coverage:ignore-next-line
    ($488c3d2fa2528428$var$keys(value.prototype) || name in value.prototype);
}
/**
 * Check if `value` is an object with keys.
 *
 * @param {Record<string, unknown>} value
 * @returns {boolean}
 */ function $488c3d2fa2528428$var$keys(value) {
    /** @type {string} */ let key;
    for(key in value){
        if ($488c3d2fa2528428$var$own.call(value, key)) return true;
    }
    return false;
}
/**
 * Assert a parser is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Parser}
 */ function $488c3d2fa2528428$var$assertParser(name, value) {
    if (typeof value !== 'function') throw new TypeError('Cannot `' + name + '` without `Parser`');
}
/**
 * Assert a compiler is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Compiler}
 */ function $488c3d2fa2528428$var$assertCompiler(name, value) {
    if (typeof value !== 'function') throw new TypeError('Cannot `' + name + '` without `Compiler`');
}
/**
 * Assert the processor is not frozen.
 *
 * @param {string} name
 * @param {unknown} frozen
 * @returns {asserts frozen is false}
 */ function $488c3d2fa2528428$var$assertUnfrozen(name, frozen) {
    if (frozen) throw new Error('Cannot call `' + name + '` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.');
}
/**
 * Assert `node` is a unist node.
 *
 * @param {unknown} node
 * @returns {asserts node is Node}
 */ function $488c3d2fa2528428$var$assertNode(node) {
    // `isPlainObj` unfortunately uses `any` instead of `unknown`.
    // type-coverage:ignore-next-line
    if (!(0, $0e5c9b0577e44af4$export$2e2bcd8739ae039)(node) || typeof node.type !== 'string') throw new TypeError('Expected node, got `' + node + '`');
}
/**
 * Assert that `complete` is `true`.
 *
 * @param {string} name
 * @param {string} asyncName
 * @param {unknown} complete
 * @returns {asserts complete is true}
 */ function $488c3d2fa2528428$var$assertDone(name, asyncName, complete) {
    if (!complete) throw new Error('`' + name + '` finished async. Use `' + asyncName + '` instead');
}
/**
 * @param {VFileCompatible} [value]
 * @returns {VFile}
 */ function $488c3d2fa2528428$var$vfile(value) {
    return $488c3d2fa2528428$var$looksLikeAVFile(value) ? value : new (0, $1721c824e44cfb0f$export$93dff69eb10dc7ce)(value);
}
/**
 * @param {VFileCompatible} [value]
 * @returns {value is VFile}
 */ function $488c3d2fa2528428$var$looksLikeAVFile(value) {
    return Boolean(value && typeof value === 'object' && 'message' in value && 'messages' in value);
}
/**
 * @param {unknown} [value]
 * @returns {value is VFileValue}
 */ function $488c3d2fa2528428$var$looksLikeAVFileValue(value) {
    return typeof value === 'string' || (0, (/*@__PURE__*/$parcel$interopDefault($c7ba1312e8534a1c$exports)))(value);
}


/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').Options} Options
 */ /**
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Value} Value
 *
 * @typedef {import('unist').Parent} UnistParent
 * @typedef {import('unist').Point} Point
 *
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').StaticPhrasingContent} StaticPhrasingContent
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Break} Break
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('mdast').Code} Code
 * @typedef {import('mdast').Definition} Definition
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('mdast').HTML} HTML
 * @typedef {import('mdast').Image} Image
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('mdast').List} List
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('mdast').Text} Text
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('mdast').ReferenceType} ReferenceType
 * @typedef {import('../index.js').CompileData} CompileData
 */ /**
 * @typedef {Root | Content} Node
 * @typedef {Extract<Node, UnistParent>} Parent
 *
 * @typedef {Omit<UnistParent, 'type' | 'children'> & {type: 'fragment', children: Array<PhrasingContent>}} Fragment
 */ /**
 * @callback Transform
 *   Extra transform, to change the AST afterwards.
 * @param {Root} tree
 *   Tree to transform.
 * @returns {Root | undefined | null | void}
 *   New tree or nothing (in which case the current tree is used).
 *
 * @callback Handle
 *   Handle a token.
 * @param {CompileContext} this
 *   Context.
 * @param {Token} token
 *   Current token.
 * @returns {void}
 *   Nothing.
 *
 * @typedef {Record<string, Handle>} Handles
 *   Token types mapping to handles
 *
 * @callback OnEnterError
 *   Handle the case where the `right` token is open, but it is closed (by the
 *   `left` token) or because we reached the end of the document.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token | undefined} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {void}
 *   Nothing.
 *
 * @callback OnExitError
 *   Handle the case where the `right` token is open but it is closed by
 *   exiting the `left` token.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {void}
 *   Nothing.
 *
 * @typedef {[Token, OnEnterError | undefined]} TokenTuple
 *   Open token on the stack, with an optional error handler for when
 *   that token isn’t closed properly.
 */ /**
 * @typedef Config
 *   Configuration.
 *
 *   We have our defaults, but extensions will add more.
 * @property {Array<string>} canContainEols
 *   Token types where line endings are used.
 * @property {Handles} enter
 *   Opening handles.
 * @property {Handles} exit
 *   Closing handles.
 * @property {Array<Transform>} transforms
 *   Tree transforms.
 *
 * @typedef {Partial<Config>} Extension
 *   Change how markdown tokens from micromark are turned into mdast.
 *
 * @typedef CompileContext
 *   mdast compiler context.
 * @property {Array<Node | Fragment>} stack
 *   Stack of nodes.
 * @property {Array<TokenTuple>} tokenStack
 *   Stack of tokens.
 * @property {<Key extends keyof CompileData>(key: Key) => CompileData[Key]} getData
 *   Get data from the key/value store.
 * @property {<Key extends keyof CompileData>(key: Key, value?: CompileData[Key]) => void} setData
 *   Set data into the key/value store.
 * @property {(this: CompileContext) => void} buffer
 *   Capture some of the output data.
 * @property {(this: CompileContext) => string} resume
 *   Stop capturing and access the output data.
 * @property {<Kind extends Node>(this: CompileContext, node: Kind, token: Token, onError?: OnEnterError) => Kind} enter
 *   Enter a token.
 * @property {(this: CompileContext, token: Token, onError?: OnExitError) => Node} exit
 *   Exit a token.
 * @property {TokenizeContext['sliceSerialize']} sliceSerialize
 *   Get the string value of a token.
 * @property {Config} config
 *   Configuration.
 *
 * @typedef FromMarkdownOptions
 *   Configuration for how to build mdast.
 * @property {Array<Extension | Array<Extension>> | null | undefined} [mdastExtensions]
 *   Extensions for this utility to change how tokens are turned into a tree.
 *
 * @typedef {ParseOptions & FromMarkdownOptions} Options
 *   Configuration.
 */ // To do: micromark: create a registry of tokens?
// To do: next major: don’t return given `Node` from `enter`.
// To do: next major: remove setter/getter.
/**
 * @typedef {import('mdast').Root|import('mdast').Content} Node
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [includeImageAlt=true]
 *   Whether to use `alt` for `image`s.
 * @property {boolean | null | undefined} [includeHtml=true]
 *   Whether to use `value` of HTML.
 */ /** @type {Options} */ const $1ad50519eb9a1fd0$var$emptyOptions = {};
function $1ad50519eb9a1fd0$export$f84e8e69fd4488a5(value, options) {
    const settings = options || $1ad50519eb9a1fd0$var$emptyOptions;
    const includeImageAlt = typeof settings.includeImageAlt === 'boolean' ? settings.includeImageAlt : true;
    const includeHtml = typeof settings.includeHtml === 'boolean' ? settings.includeHtml : true;
    return $1ad50519eb9a1fd0$var$one(value, includeImageAlt, includeHtml);
}
/**
 * One node or several nodes.
 *
 * @param {unknown} value
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized node.
 */ function $1ad50519eb9a1fd0$var$one(value, includeImageAlt, includeHtml) {
    if ($1ad50519eb9a1fd0$var$node(value)) {
        if ('value' in value) return value.type === 'html' && !includeHtml ? '' : value.value;
        if (includeImageAlt && 'alt' in value && value.alt) return value.alt;
        if ('children' in value) return $1ad50519eb9a1fd0$var$all(value.children, includeImageAlt, includeHtml);
    }
    if (Array.isArray(value)) return $1ad50519eb9a1fd0$var$all(value, includeImageAlt, includeHtml);
    return '';
}
/**
 * Serialize a list of nodes.
 *
 * @param {Array<unknown>} values
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized nodes.
 */ function $1ad50519eb9a1fd0$var$all(values, includeImageAlt, includeHtml) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    while(++index < values.length)result[index] = $1ad50519eb9a1fd0$var$one(values[index], includeImageAlt, includeHtml);
    return result.join('');
}
/**
 * Check if `value` looks like a node.
 *
 * @param {unknown} value
 *   Thing.
 * @returns {value is Node}
 *   Whether `value` is a node.
 */ function $1ad50519eb9a1fd0$var$node(value) {
    return Boolean(value && typeof value === 'object');
}


/**
 * @typedef {import('micromark-util-types').Create} Create
 * @typedef {import('micromark-util-types').FullNormalizedExtension} FullNormalizedExtension
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 */ /**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Handles} Handles
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').NormalizedExtension} NormalizedExtension
 */ /**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 *   Item type.
 * @param {Array<T>} list
 *   List to operate on.
 * @param {number} start
 *   Index to remove/insert at (can be negative).
 * @param {number} remove
 *   Number of items to remove.
 * @param {Array<T>} items
 *   Items to inject into `list`.
 * @returns {void}
 *   Nothing.
 */ function $5e612816a43dd8d9$export$869882364835d202(list, start, remove, items) {
    const end = list.length;
    let chunkStart = 0;
    /** @type {Array<unknown>} */ let parameters;
    // Make start between zero and `end` (included).
    if (start < 0) start = -start > end ? 0 : end + start;
    else start = start > end ? end : start;
    remove = remove > 0 ? remove : 0;
    // No need to chunk the items if there’s only a couple (10k) items.
    if (items.length < 10000) {
        parameters = Array.from(items);
        parameters.unshift(start, remove);
        // @ts-expect-error Hush, it’s fine.
        list.splice(...parameters);
    } else {
        // Delete `remove` items starting from `start`
        if (remove) list.splice(start, remove);
        // Insert the items in chunks to not cause stack overflows.
        while(chunkStart < items.length){
            parameters = items.slice(chunkStart, chunkStart + 10000);
            parameters.unshift(start, 0);
            // @ts-expect-error Hush, it’s fine.
            list.splice(...parameters);
            chunkStart += 10000;
            start += 10000;
        }
    }
}
function $5e612816a43dd8d9$export$4cbf152802aa238(list, items) {
    if (list.length > 0) {
        $5e612816a43dd8d9$export$869882364835d202(list, list.length, 0, items);
        return list;
    }
    return items;
}


const $2a95a8469ca77757$var$hasOwnProperty = {}.hasOwnProperty;
function $2a95a8469ca77757$export$86a865d89ef3c690(extensions) {
    /** @type {NormalizedExtension} */ const all = {};
    let index = -1;
    while(++index < extensions.length)$2a95a8469ca77757$var$syntaxExtension(all, extensions[index]);
    return all;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all
 *   Extension to merge into.
 * @param {Extension} extension
 *   Extension to merge.
 * @returns {void}
 */ function $2a95a8469ca77757$var$syntaxExtension(all, extension) {
    /** @type {keyof Extension} */ let hook;
    for(hook in extension){
        const maybe = $2a95a8469ca77757$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        /** @type {Record<string, unknown>} */ const left = maybe || (all[hook] = {});
        /** @type {Record<string, unknown> | undefined} */ const right = extension[hook];
        /** @type {string} */ let code;
        if (right) for(code in right){
            if (!$2a95a8469ca77757$var$hasOwnProperty.call(left, code)) left[code] = [];
            const value = right[code];
            $2a95a8469ca77757$var$constructs(// @ts-expect-error Looks like a list.
            left[code], Array.isArray(value) ? value : value ? [
                value
            ] : []);
        }
    }
}
/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {Array<unknown>} existing
 * @param {Array<unknown>} list
 * @returns {void}
 */ function $2a95a8469ca77757$var$constructs(existing, list) {
    let index = -1;
    /** @type {Array<unknown>} */ const before = [];
    while(++index < list.length)(list[index].add === 'after' ? existing : before).push(list[index]);
    (0, $5e612816a43dd8d9$export$869882364835d202)(existing, 0, 0, before);
}
function $2a95a8469ca77757$export$eaf8c406dfb0a620(htmlExtensions) {
    /** @type {HtmlExtension} */ const handlers = {};
    let index = -1;
    while(++index < htmlExtensions.length)$2a95a8469ca77757$var$htmlExtension(handlers, htmlExtensions[index]);
    return handlers;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {HtmlExtension} all
 *   Extension to merge into.
 * @param {HtmlExtension} extension
 *   Extension to merge.
 * @returns {void}
 */ function $2a95a8469ca77757$var$htmlExtension(all, extension) {
    /** @type {keyof HtmlExtension} */ let hook;
    for(hook in extension){
        const maybe = $2a95a8469ca77757$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        const left = maybe || (all[hook] = {});
        const right = extension[hook];
        /** @type {keyof Handles} */ let type;
        if (right) for(type in right)// @ts-expect-error assume document vs regular handler are managed correctly.
        left[type] = right[type];
    }
}


/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ /**
 * @typedef {import('micromark-util-types').Code} Code
 */ // This module is generated by `script/`.
//
// CommonMark handles attention (emphasis, strong) markers based on what comes
// before or after them.
// One such difference is if those characters are Unicode punctuation.
// This script is generated from the Unicode data.
/**
 * Regular expression that matches a unicode punctuation character.
 */ const $a06782c433973a3f$export$85b5101f24802e8c = /[!-\/:-@\[-`\{-~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/;


const $a967d3607431391e$export$d65d6b62c24d5436 = $a967d3607431391e$var$regexCheck(/[A-Za-z]/);
const $a967d3607431391e$export$75c76db11865a9f4 = $a967d3607431391e$var$regexCheck(/[\dA-Za-z]/);
const $a967d3607431391e$export$4397998b34fe597d = $a967d3607431391e$var$regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function $a967d3607431391e$export$67dbf494fc8394df(code) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127));
}
const $a967d3607431391e$export$ca8b5b1a6c320e6e = $a967d3607431391e$var$regexCheck(/\d/);
const $a967d3607431391e$export$eca2752363989806 = $a967d3607431391e$var$regexCheck(/[\dA-Fa-f]/);
const $a967d3607431391e$export$35794a7d1db99380 = $a967d3607431391e$var$regexCheck(/[!-/:-@[-`{-~]/);
function $a967d3607431391e$export$34a1dff1c0936953(code) {
    return code !== null && code < -2;
}
function $a967d3607431391e$export$a30284361b3814b7(code) {
    return code !== null && (code < 0 || code === 32);
}
function $a967d3607431391e$export$2c6cf65c1127992a(code) {
    return code === -2 || code === -1 || code === 32;
}
const $a967d3607431391e$export$aa04114dd888a7a0 = $a967d3607431391e$var$regexCheck((0, $a06782c433973a3f$export$85b5101f24802e8c));
const $a967d3607431391e$export$a0ff789c034ffdf4 = $a967d3607431391e$var$regexCheck(/\s/);
/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 * @returns {(code: Code) => boolean}
 */ function $a967d3607431391e$var$regexCheck(regex) {
    return check;
    /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code
   *   Character code.
   * @returns {boolean}
   *   Whether the character code matches the bound regex.
   */ function check(code) {
        return code !== null && regex.test(String.fromCharCode(code));
    }
}


function $602eae48ac3dea9e$export$ae105c1eb063a0a2(effects, ok, type, max) {
    const limit = max ? max - 1 : Number.POSITIVE_INFINITY;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $a967d3607431391e$export$2c6cf65c1127992a)(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return ok(code);
    }
    /** @type {State} */ function prefix(code) {
        if ((0, $a967d3607431391e$export$2c6cf65c1127992a)(code) && size++ < limit) {
            effects.consume(code);
            return prefix;
        }
        effects.exit(type);
        return ok(code);
    }
}



const $1a59ff6b3b229e4f$export$a7db06668cad9adb = {
    tokenize: $1a59ff6b3b229e4f$var$initializeContent
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $1a59ff6b3b229e4f$var$initializeContent(effects) {
    const contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
    /** @type {Token} */ let previous;
    return contentStart;
    /** @type {State} */ function afterContentStartConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return (0, $602eae48ac3dea9e$export$ae105c1eb063a0a2)(effects, contentStart, 'linePrefix');
    }
    /** @type {State} */ function paragraphInitial(code) {
        effects.enter('paragraph');
        return lineStart(code);
    }
    /** @type {State} */ function lineStart(code) {
        const token = effects.enter('chunkText', {
            contentType: 'text',
            previous: previous
        });
        if (previous) previous.next = token;
        previous = token;
        return data(code);
    }
    /** @type {State} */ function data(code) {
        if (code === null) {
            effects.exit('chunkText');
            effects.exit('paragraph');
            effects.consume(code);
            return;
        }
        if ((0, $a967d3607431391e$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            effects.exit('chunkText');
            return lineStart;
        }
        // Data.
        effects.consume(code);
        return data;
    }
}


/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {[Construct, ContainerState]} StackItem
 */ 


const $c2e10b7bcc4d280f$export$5a7bfc01df82fcd1 = {
    tokenize: $c2e10b7bcc4d280f$var$initializeDocument
};
/** @type {Construct} */ const $c2e10b7bcc4d280f$var$containerConstruct = {
    tokenize: $c2e10b7bcc4d280f$var$tokenizeContainer
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $c2e10b7bcc4d280f$var$initializeDocument(effects) {
    const self = this;
    /** @type {Array<StackItem>} */ const stack = [];
    let continued = 0;
    /** @type {TokenizeContext | undefined} */ let childFlow;
    /** @type {Token | undefined} */ let childToken;
    /** @type {number} */ let lineStartOffset;
    return start;
    /** @type {State} */ function start(code) {
        // First we iterate through the open blocks, starting with the root
        // document, and descending through last children down to the last open
        // block.
        // Each block imposes a condition that the line must satisfy if the block is
        // to remain open.
        // For example, a block quote requires a `>` character.
        // A paragraph requires a non-blank line.
        // In this phase we may match all or just some of the open blocks.
        // But we cannot close unmatched blocks yet, because we may have a lazy
        // continuation line.
        if (continued < stack.length) {
            const item = stack[continued];
            self.containerState = item[1];
            return effects.attempt(item[0].continuation, documentContinue, checkNewContainers)(code);
        }
        // Done.
        return checkNewContainers(code);
    }
    /** @type {State} */ function documentContinue(code) {
        continued++;
        // Note: this field is called `_closeFlow` but it also closes containers.
        // Perhaps a good idea to rename it but it’s already used in the wild by
        // extensions.
        if (self.containerState._closeFlow) {
            self.containerState._closeFlow = undefined;
            if (childFlow) closeFlow();
            // Note: this algorithm for moving events around is similar to the
            // algorithm when dealing with lazy lines in `writeToChild`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {Point | undefined} */ let point;
            // Find the flow chunk.
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === 'exit' && self.events[indexBeforeFlow][1].type === 'chunkFlow') {
                point = self.events[indexBeforeFlow][1].end;
                break;
            }
            exitContainers(continued);
            // Fix positions.
            let index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = Object.assign({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $5e612816a43dd8d9$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
            return checkNewContainers(code);
        }
        return start(code);
    }
    /** @type {State} */ function checkNewContainers(code) {
        // Next, after consuming the continuation markers for existing blocks, we
        // look for new block starts (e.g. `>` for a block quote).
        // If we encounter a new block start, we close any blocks unmatched in
        // step 1 before creating the new block as a child of the last matched
        // block.
        if (continued === stack.length) {
            // No need to `check` whether there’s a container, of `exitContainers`
            // would be moot.
            // We can instead immediately `attempt` to parse one.
            if (!childFlow) return documentContinued(code);
            // If we have concrete content, such as block HTML or fenced code,
            // we can’t have containers “pierce” into them, so we can immediately
            // start.
            if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) return flowStart(code);
            // If we do have flow, it could still be a blank line,
            // but we’d be interrupting it w/ a new container if there’s a current
            // construct.
            // To do: next major: remove `_gfmTableDynamicInterruptHack` (no longer
            // needed in micromark-extension-gfm-table@1.0.6).
            self.interrupt = Boolean(childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack);
        }
        // Check if there is a new container.
        self.containerState = {};
        return effects.check($c2e10b7bcc4d280f$var$containerConstruct, thereIsANewContainer, thereIsNoNewContainer)(code);
    }
    /** @type {State} */ function thereIsANewContainer(code) {
        if (childFlow) closeFlow();
        exitContainers(continued);
        return documentContinued(code);
    }
    /** @type {State} */ function thereIsNoNewContainer(code) {
        self.parser.lazy[self.now().line] = continued !== stack.length;
        lineStartOffset = self.now().offset;
        return flowStart(code);
    }
    /** @type {State} */ function documentContinued(code) {
        // Try new containers.
        self.containerState = {};
        return effects.attempt($c2e10b7bcc4d280f$var$containerConstruct, containerContinue, flowStart)(code);
    }
    /** @type {State} */ function containerContinue(code) {
        continued++;
        stack.push([
            self.currentConstruct,
            self.containerState
        ]);
        // Try another.
        return documentContinued(code);
    }
    /** @type {State} */ function flowStart(code) {
        if (code === null) {
            if (childFlow) closeFlow();
            exitContainers(0);
            effects.consume(code);
            return;
        }
        childFlow = childFlow || self.parser.flow(self.now());
        effects.enter('chunkFlow', {
            contentType: 'flow',
            previous: childToken,
            _tokenizer: childFlow
        });
        return flowContinue(code);
    }
    /** @type {State} */ function flowContinue(code) {
        if (code === null) {
            writeToChild(effects.exit('chunkFlow'), true);
            exitContainers(0);
            effects.consume(code);
            return;
        }
        if ((0, $a967d3607431391e$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            writeToChild(effects.exit('chunkFlow'));
            // Get ready for the next line.
            continued = 0;
            self.interrupt = undefined;
            return start;
        }
        effects.consume(code);
        return flowContinue;
    }
    /**
   * @param {Token} token
   * @param {boolean | undefined} [eof]
   * @returns {void}
   */ function writeToChild(token, eof) {
        const stream = self.sliceStream(token);
        if (eof) stream.push(null);
        token.previous = childToken;
        if (childToken) childToken.next = token;
        childToken = token;
        childFlow.defineSkip(token.start);
        childFlow.write(stream);
        // Alright, so we just added a lazy line:
        //
        // ```markdown
        // > a
        // b.
        //
        // Or:
        //
        // > ~~~c
        // d
        //
        // Or:
        //
        // > | e |
        // f
        // ```
        //
        // The construct in the second example (fenced code) does not accept lazy
        // lines, so it marked itself as done at the end of its first line, and
        // then the content construct parses `d`.
        // Most constructs in markdown match on the first line: if the first line
        // forms a construct, a non-lazy line can’t “unmake” it.
        //
        // The construct in the third example is potentially a GFM table, and
        // those are *weird*.
        // It *could* be a table, from the first line, if the following line
        // matches a condition.
        // In this case, that second line is lazy, which “unmakes” the first line
        // and turns the whole into one content block.
        //
        // We’ve now parsed the non-lazy and the lazy line, and can figure out
        // whether the lazy line started a new flow block.
        // If it did, we exit the current containers between the two flow blocks.
        if (self.parser.lazy[token.start.line]) {
            let index = childFlow.events.length;
            while(index--){
                if (// The token starts before the line ending…
                childFlow.events[index][1].start.offset < lineStartOffset && // …and either is not ended yet…
                (!childFlow.events[index][1].end || // …or ends after it.
                childFlow.events[index][1].end.offset > lineStartOffset)) // Exit: there’s still something open, which means it’s a lazy line
                // part of something.
                return;
            }
            // Note: this algorithm for moving events around is similar to the
            // algorithm when closing flow in `documentContinue`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {boolean | undefined} */ let seen;
            /** @type {Point | undefined} */ let point;
            // Find the previous chunk (the one before the lazy line).
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === 'exit' && self.events[indexBeforeFlow][1].type === 'chunkFlow') {
                if (seen) {
                    point = self.events[indexBeforeFlow][1].end;
                    break;
                }
                seen = true;
            }
            exitContainers(continued);
            // Fix positions.
            index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = Object.assign({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $5e612816a43dd8d9$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
        }
    }
    /**
   * @param {number} size
   * @returns {void}
   */ function exitContainers(size) {
        let index = stack.length;
        // Exit open containers.
        while(index-- > size){
            const entry = stack[index];
            self.containerState = entry[1];
            entry[0].exit.call(self, effects);
        }
        stack.length = size;
    }
    function closeFlow() {
        childFlow.write([
            null
        ]);
        childToken = undefined;
        childFlow = undefined;
        self.containerState._closeFlow = undefined;
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $c2e10b7bcc4d280f$var$tokenizeContainer(effects, ok, nok) {
    // Always populated by defaults.
    return (0, $602eae48ac3dea9e$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.document, ok, nok), 'linePrefix', this.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4);
}


/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $231ee94245fc5c87$export$d50d28ce3ab2a612 = {
    tokenize: $231ee94245fc5c87$var$tokenizeBlankLine,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $231ee94245fc5c87$var$tokenizeBlankLine(effects, ok, nok) {
    return start;
    /**
   * Start of blank line.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *     ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        return (0, $a967d3607431391e$export$2c6cf65c1127992a)(code) ? (0, $602eae48ac3dea9e$export$ae105c1eb063a0a2)(effects, after, 'linePrefix')(code) : after(code);
    }
    /**
   * At eof/eol, after optional whitespace.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *       ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return code === null || (0, $a967d3607431391e$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Token} Token
 */ 
function $614962c54f47e6e7$export$12949d1dd00fddf4(events) {
    /** @type {Record<string, number>} */ const jumps = {};
    let index = -1;
    /** @type {Event} */ let event;
    /** @type {number | undefined} */ let lineIndex;
    /** @type {number} */ let otherIndex;
    /** @type {Event} */ let otherEvent;
    /** @type {Array<Event>} */ let parameters;
    /** @type {Array<Event>} */ let subevents;
    /** @type {boolean | undefined} */ let more;
    while(++index < events.length){
        while(index in jumps)index = jumps[index];
        event = events[index];
        // Add a hook for the GFM tasklist extension, which needs to know if text
        // is in the first content of a list item.
        if (index && event[1].type === 'chunkFlow' && events[index - 1][1].type === 'listItemPrefix') {
            subevents = event[1]._tokenizer.events;
            otherIndex = 0;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === 'lineEndingBlank') otherIndex += 2;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === 'content') while(++otherIndex < subevents.length){
                if (subevents[otherIndex][1].type === 'content') break;
                if (subevents[otherIndex][1].type === 'chunkText') {
                    subevents[otherIndex][1]._isInFirstContentOfListItem = true;
                    otherIndex++;
                }
            }
        }
        // Enter.
        if (event[0] === 'enter') {
            if (event[1].contentType) {
                Object.assign(jumps, $614962c54f47e6e7$var$subcontent(events, index));
                index = jumps[index];
                more = true;
            }
        } else if (event[1]._container) {
            otherIndex = index;
            lineIndex = undefined;
            while(otherIndex--){
                otherEvent = events[otherIndex];
                if (otherEvent[1].type === 'lineEnding' || otherEvent[1].type === 'lineEndingBlank') {
                    if (otherEvent[0] === 'enter') {
                        if (lineIndex) events[lineIndex][1].type = 'lineEndingBlank';
                        otherEvent[1].type = 'lineEnding';
                        lineIndex = otherIndex;
                    }
                } else break;
            }
            if (lineIndex) {
                // Fix position.
                event[1].end = Object.assign({}, events[lineIndex][1].start);
                // Switch container exit w/ line endings.
                parameters = events.slice(lineIndex, index);
                parameters.unshift(event);
                (0, $5e612816a43dd8d9$export$869882364835d202)(events, lineIndex, index - lineIndex + 1, parameters);
            }
        }
    }
    return !more;
}
/**
 * Tokenize embedded tokens.
 *
 * @param {Array<Event>} events
 * @param {number} eventIndex
 * @returns {Record<string, number>}
 */ function $614962c54f47e6e7$var$subcontent(events, eventIndex) {
    const token = events[eventIndex][1];
    const context = events[eventIndex][2];
    let startPosition = eventIndex - 1;
    /** @type {Array<number>} */ const startPositions = [];
    const tokenizer = token._tokenizer || context.parser[token.contentType](token.start);
    const childEvents = tokenizer.events;
    /** @type {Array<[number, number]>} */ const jumps = [];
    /** @type {Record<string, number>} */ const gaps = {};
    /** @type {Array<Chunk>} */ let stream;
    /** @type {Token | undefined} */ let previous;
    let index = -1;
    /** @type {Token | undefined} */ let current = token;
    let adjust = 0;
    let start = 0;
    const breaks = [
        start
    ];
    // Loop forward through the linked tokens to pass them in order to the
    // subtokenizer.
    while(current){
        // Find the position of the event for this token.
        while(events[++startPosition][1] !== current);
        startPositions.push(startPosition);
        if (!current._tokenizer) {
            stream = context.sliceStream(current);
            if (!current.next) stream.push(null);
            if (previous) tokenizer.defineSkip(current.start);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
            tokenizer.write(stream);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = undefined;
        }
        // Unravel the next token.
        previous = current;
        current = current.next;
    }
    // Now, loop back through all events (and linked tokens), to figure out which
    // parts belong where.
    current = token;
    while(++index < childEvents.length)if (// Find a void token that includes a break.
    childEvents[index][0] === 'exit' && childEvents[index - 1][0] === 'enter' && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
        start = index + 1;
        breaks.push(start);
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
        current = current.next;
    }
    // Help GC.
    tokenizer.events = [];
    // If there’s one more token (which is the cases for lines that end in an
    // EOF), that’s perfect: the last point we found starts it.
    // If there isn’t then make sure any remaining content is added to it.
    if (current) {
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
    } else breaks.pop();
    // Now splice the events from the subtokenizer into the current events,
    // moving back to front so that splice indices aren’t affected.
    index = breaks.length;
    while(index--){
        const slice = childEvents.slice(breaks[index], breaks[index + 1]);
        const start = startPositions.pop();
        jumps.unshift([
            start,
            start + slice.length - 1
        ]);
        (0, $5e612816a43dd8d9$export$869882364835d202)(events, start, 2, slice);
    }
    index = -1;
    while(++index < jumps.length){
        gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
        adjust += jumps[index][1] - jumps[index][0] - 1;
    }
    return gaps;
}


const $22c6b0ad5cd2d74d$export$a7db06668cad9adb = {
    tokenize: $22c6b0ad5cd2d74d$var$tokenizeContent,
    resolve: $22c6b0ad5cd2d74d$var$resolveContent
};
/** @type {Construct} */ const $22c6b0ad5cd2d74d$var$continuationConstruct = {
    tokenize: $22c6b0ad5cd2d74d$var$tokenizeContinuation,
    partial: true
};
/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */ function $22c6b0ad5cd2d74d$var$resolveContent(events) {
    (0, $614962c54f47e6e7$export$12949d1dd00fddf4)(events);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $22c6b0ad5cd2d74d$var$tokenizeContent(effects, ok) {
    /** @type {Token | undefined} */ let previous;
    return chunkStart;
    /**
   * Before a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^
   * ```
   *
   * @type {State}
   */ function chunkStart(code) {
        effects.enter('content');
        previous = effects.enter('chunkContent', {
            contentType: 'content'
        });
        return chunkInside(code);
    }
    /**
   * In a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^^^
   * ```
   *
   * @type {State}
   */ function chunkInside(code) {
        if (code === null) return contentEnd(code);
        // To do: in `markdown-rs`, each line is parsed on its own, and everything
        // is stitched together resolving.
        if ((0, $a967d3607431391e$export$34a1dff1c0936953)(code)) return effects.check($22c6b0ad5cd2d74d$var$continuationConstruct, contentContinue, contentEnd)(code);
        // Data.
        effects.consume(code);
        return chunkInside;
    }
    /**
   *
   *
   * @type {State}
   */ function contentEnd(code) {
        effects.exit('chunkContent');
        effects.exit('content');
        return ok(code);
    }
    /**
   *
   *
   * @type {State}
   */ function contentContinue(code) {
        effects.consume(code);
        effects.exit('chunkContent');
        previous.next = effects.enter('chunkContent', {
            contentType: 'content',
            previous: previous
        });
        previous = previous.next;
        return chunkInside;
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $22c6b0ad5cd2d74d$var$tokenizeContinuation(effects, ok, nok) {
    const self = this;
    return startLookahead;
    /**
   *
   *
   * @type {State}
   */ function startLookahead(code) {
        effects.exit('chunkContent');
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return (0, $602eae48ac3dea9e$export$ae105c1eb063a0a2)(effects, prefixed, 'linePrefix');
    }
    /**
   *
   *
   * @type {State}
   */ function prefixed(code) {
        if (code === null || (0, $a967d3607431391e$export$34a1dff1c0936953)(code)) return nok(code);
        // Always populated by defaults.
        const tail = self.events[self.events.length - 1];
        if (!self.parser.constructs.disable.null.includes('codeIndented') && tail && tail[1].type === 'linePrefix' && tail[2].sliceSerialize(tail[1], true).length >= 4) return ok(code);
        return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
    }
}




const $142c2d2926b9eb29$export$ccc7b0636abaffc3 = {
    tokenize: $142c2d2926b9eb29$var$initializeFlow
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $142c2d2926b9eb29$var$initializeFlow(effects) {
    const self = this;
    const initial = effects.attempt(// Try to parse a blank line.
    (0, $231ee94245fc5c87$export$d50d28ce3ab2a612), atBlankEnding, // Try to parse initial flow (essentially, only code).
    effects.attempt(this.parser.constructs.flowInitial, afterConstruct, (0, $602eae48ac3dea9e$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt((0, $22c6b0ad5cd2d74d$export$a7db06668cad9adb), afterConstruct)), 'linePrefix')));
    return initial;
    /** @type {State} */ function atBlankEnding(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter('lineEndingBlank');
        effects.consume(code);
        effects.exit('lineEndingBlank');
        self.currentConstruct = undefined;
        return initial;
    }
    /** @type {State} */ function afterConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        self.currentConstruct = undefined;
        return initial;
    }
}


/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ const $70c7ce3ee5a8f588$export$50397835cbfdbc24 = {
    resolveAll: $70c7ce3ee5a8f588$var$createResolver()
};
const $70c7ce3ee5a8f588$export$22b082955e083ec3 = $70c7ce3ee5a8f588$var$initializeFactory('string');
const $70c7ce3ee5a8f588$export$6f093cfa640b7166 = $70c7ce3ee5a8f588$var$initializeFactory('text');
/**
 * @param {'string' | 'text'} field
 * @returns {InitialConstruct}
 */ function $70c7ce3ee5a8f588$var$initializeFactory(field) {
    return {
        tokenize: initializeText,
        resolveAll: $70c7ce3ee5a8f588$var$createResolver(field === 'text' ? $70c7ce3ee5a8f588$var$resolveAllLineSuffixes : undefined)
    };
    /**
   * @this {TokenizeContext}
   * @type {Initializer}
   */ function initializeText(effects) {
        const self = this;
        const constructs = this.parser.constructs[field];
        const text = effects.attempt(constructs, start, notText);
        return start;
        /** @type {State} */ function start(code) {
            return atBreak(code) ? text(code) : notText(code);
        }
        /** @type {State} */ function notText(code) {
            if (code === null) {
                effects.consume(code);
                return;
            }
            effects.enter('data');
            effects.consume(code);
            return data;
        }
        /** @type {State} */ function data(code) {
            if (atBreak(code)) {
                effects.exit('data');
                return text(code);
            }
            // Data.
            effects.consume(code);
            return data;
        }
        /**
     * @param {Code} code
     * @returns {boolean}
     */ function atBreak(code) {
            if (code === null) return true;
            const list = constructs[code];
            let index = -1;
            if (list) // Always populated by defaults.
            while(++index < list.length){
                const item = list[index];
                if (!item.previous || item.previous.call(self, self.previous)) return true;
            }
            return false;
        }
    }
}
/**
 * @param {Resolver | undefined} [extraResolver]
 * @returns {Resolver}
 */ function $70c7ce3ee5a8f588$var$createResolver(extraResolver) {
    return resolveAllText;
    /** @type {Resolver} */ function resolveAllText(events, context) {
        let index = -1;
        /** @type {number | undefined} */ let enter;
        // A rather boring computation (to merge adjacent `data` events) which
        // improves mm performance by 29%.
        while(++index <= events.length){
            if (enter === undefined) {
                if (events[index] && events[index][1].type === 'data') {
                    enter = index;
                    index++;
                }
            } else if (!events[index] || events[index][1].type !== 'data') {
                // Don’t do anything if there is one data token.
                if (index !== enter + 2) {
                    events[enter][1].end = events[index - 1][1].end;
                    events.splice(enter + 2, index - enter - 2);
                    index = enter + 2;
                }
                enter = undefined;
            }
        }
        return extraResolver ? extraResolver(events, context) : events;
    }
}
/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */ function $70c7ce3ee5a8f588$var$resolveAllLineSuffixes(events, context) {
    let eventIndex = 0 // Skip first.
    ;
    while(++eventIndex <= events.length)if ((eventIndex === events.length || events[eventIndex][1].type === 'lineEnding') && events[eventIndex - 1][1].type === 'data') {
        const data = events[eventIndex - 1][1];
        const chunks = context.sliceStream(data);
        let index = chunks.length;
        let bufferIndex = -1;
        let size = 0;
        /** @type {boolean | undefined} */ let tabs;
        while(index--){
            const chunk = chunks[index];
            if (typeof chunk === 'string') {
                bufferIndex = chunk.length;
                while(chunk.charCodeAt(bufferIndex - 1) === 32){
                    size++;
                    bufferIndex--;
                }
                if (bufferIndex) break;
                bufferIndex = -1;
            } else if (chunk === -2) {
                tabs = true;
                size++;
            } else if (chunk === -1) ;
            else {
                // Replacement character, exit.
                index++;
                break;
            }
        }
        if (size) {
            const token = {
                type: eventIndex === events.length || tabs || size < 2 ? 'lineSuffix' : 'hardBreakTrailing',
                start: {
                    line: data.end.line,
                    column: data.end.column - size,
                    offset: data.end.offset - size,
                    _index: data.start._index + index,
                    _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex
                },
                end: Object.assign({}, data.end)
            };
            data.end = Object.assign({}, token.start);
            if (data.start.offset === data.end.offset) Object.assign(data, token);
            else {
                events.splice(eventIndex, 0, [
                    'enter',
                    token,
                    context
                ], [
                    'exit',
                    token,
                    context
                ]);
                eventIndex += 2;
            }
        }
        eventIndex++;
    }
    return events;
}


/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenType} TokenType
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @callback Restore
 * @returns {void}
 *
 * @typedef Info
 * @property {Restore} restore
 * @property {number} from
 *
 * @callback ReturnHandle
 *   Handle a successful run.
 * @param {Construct} construct
 * @param {Info} info
 * @returns {void}
 */ 

/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * Call all `resolveAll`s.
 *
 * @param {Array<{resolveAll?: Resolver | undefined}>} constructs
 *   List of constructs, optionally with `resolveAll`s.
 * @param {Array<Event>} events
 *   List of events.
 * @param {TokenizeContext} context
 *   Context used by `tokenize`.
 * @returns {Array<Event>}
 *   Changed events.
 */ function $a7db008f78200e80$export$3ff61ec196ff408b(constructs, events, context) {
    /** @type {Array<Resolver>} */ const called = [];
    let index = -1;
    while(++index < constructs.length){
        const resolve = constructs[index].resolveAll;
        if (resolve && !called.includes(resolve)) {
            events = resolve(events, context);
            called.push(resolve);
        }
    }
    return events;
}


function $b9f5a97a12a1617f$export$ae34f10ee4b29837(parser, initialize, from) {
    /** @type {Point} */ let point = Object.assign(from ? Object.assign({}, from) : {
        line: 1,
        column: 1,
        offset: 0
    }, {
        _index: 0,
        _bufferIndex: -1
    });
    /** @type {Record<string, number>} */ const columnStart = {};
    /** @type {Array<Construct>} */ const resolveAllConstructs = [];
    /** @type {Array<Chunk>} */ let chunks = [];
    /** @type {Array<Token>} */ let stack = [];
    /** @type {boolean | undefined} */ let consumed = true;
    /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */ const effects = {
        consume: consume,
        enter: enter,
        exit: exit,
        attempt: constructFactory(onsuccessfulconstruct),
        check: constructFactory(onsuccessfulcheck),
        interrupt: constructFactory(onsuccessfulcheck, {
            interrupt: true
        })
    };
    /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */ const context = {
        previous: null,
        code: null,
        containerState: {},
        events: [],
        parser: parser,
        sliceStream: sliceStream,
        sliceSerialize: sliceSerialize,
        now: now,
        defineSkip: defineSkip,
        write: write
    };
    /**
   * The state function.
   *
   * @type {State | void}
   */ let state = initialize.tokenize.call(context, effects);
    /**
   * Track which character we expect to be consumed, to catch bugs.
   *
   * @type {Code}
   */ let expectedCode;
    if (initialize.resolveAll) resolveAllConstructs.push(initialize);
    return context;
    /** @type {TokenizeContext['write']} */ function write(slice) {
        chunks = (0, $5e612816a43dd8d9$export$4cbf152802aa238)(chunks, slice);
        main();
        // Exit if we’re not done, resolve might change stuff.
        if (chunks[chunks.length - 1] !== null) return [];
        addResult(initialize, 0);
        // Otherwise, resolve, and exit.
        context.events = (0, $a7db008f78200e80$export$3ff61ec196ff408b)(resolveAllConstructs, context.events, context);
        return context.events;
    }
    //
    // Tools.
    //
    /** @type {TokenizeContext['sliceSerialize']} */ function sliceSerialize(token, expandTabs) {
        return $b9f5a97a12a1617f$var$serializeChunks(sliceStream(token), expandTabs);
    }
    /** @type {TokenizeContext['sliceStream']} */ function sliceStream(token) {
        return $b9f5a97a12a1617f$var$sliceChunks(chunks, token);
    }
    /** @type {TokenizeContext['now']} */ function now() {
        // This is a hot path, so we clone manually instead of `Object.assign({}, point)`
        const { line: line, column: column, offset: offset, _index: _index, _bufferIndex: _bufferIndex } = point;
        return {
            line: line,
            column: column,
            offset: offset,
            _index: _index,
            _bufferIndex: _bufferIndex
        };
    }
    /** @type {TokenizeContext['defineSkip']} */ function defineSkip(value) {
        columnStart[value.line] = value.column;
        accountForPotentialSkip();
    }
    //
    // State management.
    //
    /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {void}
   */ function main() {
        /** @type {number} */ let chunkIndex;
        while(point._index < chunks.length){
            const chunk = chunks[point._index];
            // If we’re in a buffer chunk, loop through it.
            if (typeof chunk === 'string') {
                chunkIndex = point._index;
                if (point._bufferIndex < 0) point._bufferIndex = 0;
                while(point._index === chunkIndex && point._bufferIndex < chunk.length)go(chunk.charCodeAt(point._bufferIndex));
            } else go(chunk);
        }
    }
    /**
   * Deal with one code.
   *
   * @param {Code} code
   * @returns {void}
   */ function go(code) {
        consumed = undefined;
        expectedCode = code;
        state = state(code);
    }
    /** @type {Effects['consume']} */ function consume(code) {
        if ((0, $a967d3607431391e$export$34a1dff1c0936953)(code)) {
            point.line++;
            point.column = 1;
            point.offset += code === -3 ? 2 : 1;
            accountForPotentialSkip();
        } else if (code !== -1) {
            point.column++;
            point.offset++;
        }
        // Not in a string chunk.
        if (point._bufferIndex < 0) point._index++;
        else {
            point._bufferIndex++;
            // At end of string chunk.
            // @ts-expect-error Points w/ non-negative `_bufferIndex` reference
            // strings.
            if (point._bufferIndex === chunks[point._index].length) {
                point._bufferIndex = -1;
                point._index++;
            }
        }
        // Expose the previous character.
        context.previous = code;
        // Mark as consumed.
        consumed = true;
    }
    /** @type {Effects['enter']} */ function enter(type, fields) {
        /** @type {Token} */ // @ts-expect-error Patch instead of assign required fields to help GC.
        const token = fields || {};
        token.type = type;
        token.start = now();
        context.events.push([
            'enter',
            token,
            context
        ]);
        stack.push(token);
        return token;
    }
    /** @type {Effects['exit']} */ function exit(type) {
        const token = stack.pop();
        token.end = now();
        context.events.push([
            'exit',
            token,
            context
        ]);
        return token;
    }
    /**
   * Use results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulconstruct(construct, info) {
        addResult(construct, info.from);
    }
    /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulcheck(_, info) {
        info.restore();
    }
    /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   * @param {{interrupt?: boolean | undefined} | undefined} [fields]
   */ function constructFactory(onreturn, fields) {
        return hook;
        /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Array<Construct> | Construct | ConstructRecord} constructs
     * @param {State} returnState
     * @param {State | undefined} [bogusState]
     * @returns {State}
     */ function hook(constructs, returnState, bogusState) {
            /** @type {Array<Construct>} */ let listOfConstructs;
            /** @type {number} */ let constructIndex;
            /** @type {Construct} */ let currentConstruct;
            /** @type {Info} */ let info;
            return Array.isArray(constructs) ? handleListOfConstructs(constructs) : 'tokenize' in constructs ? handleListOfConstructs([
                constructs
            ]) : handleMapOfConstructs(constructs);
            /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       * @returns {State}
       */ function handleMapOfConstructs(map) {
                return start;
                /** @type {State} */ function start(code) {
                    const def = code !== null && map[code];
                    const all = code !== null && map.null;
                    const list = [
                        // To do: add more extension tests.
                        /* c8 ignore next 2 */ ...Array.isArray(def) ? def : def ? [
                            def
                        ] : [],
                        ...Array.isArray(all) ? all : all ? [
                            all
                        ] : []
                    ];
                    return handleListOfConstructs(list)(code);
                }
            }
            /**
       * Handle a list of construct.
       *
       * @param {Array<Construct>} list
       * @returns {State}
       */ function handleListOfConstructs(list) {
                listOfConstructs = list;
                constructIndex = 0;
                if (list.length === 0) return bogusState;
                return handleConstruct(list[constructIndex]);
            }
            /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       * @returns {State}
       */ function handleConstruct(construct) {
                return start;
                /** @type {State} */ function start(code) {
                    // To do: not needed to store if there is no bogus state, probably?
                    // Currently doesn’t work because `inspect` in document does a check
                    // w/o a bogus, which doesn’t make sense. But it does seem to help perf
                    // by not storing.
                    info = store();
                    currentConstruct = construct;
                    if (!construct.partial) context.currentConstruct = construct;
                    // Always populated by defaults.
                    if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) return nok(code);
                    return construct.tokenize.call(// If we do have fields, create an object w/ `context` as its
                    // prototype.
                    // This allows a “live binding”, which is needed for `interrupt`.
                    fields ? Object.assign(Object.create(context), fields) : context, effects, ok, nok)(code);
                }
            }
            /** @type {State} */ function ok(code) {
                consumed = true;
                onreturn(currentConstruct, info);
                return returnState;
            }
            /** @type {State} */ function nok(code) {
                consumed = true;
                info.restore();
                if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
                return bogusState;
            }
        }
    }
    /**
   * @param {Construct} construct
   * @param {number} from
   * @returns {void}
   */ function addResult(construct, from) {
        if (construct.resolveAll && !resolveAllConstructs.includes(construct)) resolveAllConstructs.push(construct);
        if (construct.resolve) (0, $5e612816a43dd8d9$export$869882364835d202)(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
        if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
    }
    /**
   * Store state.
   *
   * @returns {Info}
   */ function store() {
        const startPoint = now();
        const startPrevious = context.previous;
        const startCurrentConstruct = context.currentConstruct;
        const startEventsIndex = context.events.length;
        const startStack = Array.from(stack);
        return {
            restore: restore,
            from: startEventsIndex
        };
        /**
     * Restore state.
     *
     * @returns {void}
     */ function restore() {
            point = startPoint;
            context.previous = startPrevious;
            context.currentConstruct = startCurrentConstruct;
            context.events.length = startEventsIndex;
            stack = startStack;
            accountForPotentialSkip();
        }
    }
    /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {void}
   */ function accountForPotentialSkip() {
        if (point.line in columnStart && point.column < 2) {
            point.column = columnStart[point.line];
            point.offset += columnStart[point.line] - 1;
        }
    }
}
/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {Array<Chunk>} chunks
 * @param {Pick<Token, 'end' | 'start'>} token
 * @returns {Array<Chunk>}
 */ function $b9f5a97a12a1617f$var$sliceChunks(chunks, token) {
    const startIndex = token.start._index;
    const startBufferIndex = token.start._bufferIndex;
    const endIndex = token.end._index;
    const endBufferIndex = token.end._bufferIndex;
    /** @type {Array<Chunk>} */ let view;
    if (startIndex === endIndex) // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [
        chunks[startIndex].slice(startBufferIndex, endBufferIndex)
    ];
    else {
        view = chunks.slice(startIndex, endIndex);
        if (startBufferIndex > -1) {
            const head = view[0];
            if (typeof head === 'string') view[0] = head.slice(startBufferIndex);
            else view.shift();
        }
        if (endBufferIndex > 0) // @ts-expect-error `_bufferIndex` is used on string chunks.
        view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
    return view;
}
/**
 * Get the string value of a slice of chunks.
 *
 * @param {Array<Chunk>} chunks
 * @param {boolean | undefined} [expandTabs=false]
 * @returns {string}
 */ function $b9f5a97a12a1617f$var$serializeChunks(chunks, expandTabs) {
    let index = -1;
    /** @type {Array<string>} */ const result = [];
    /** @type {boolean | undefined} */ let atTab;
    while(++index < chunks.length){
        const chunk = chunks[index];
        /** @type {string} */ let value;
        if (typeof chunk === 'string') value = chunk;
        else switch(chunk){
            case -5:
                value = '\r';
                break;
            case -4:
                value = '\n';
                break;
            case -3:
                value = "\r\n";
                break;
            case -2:
                value = expandTabs ? ' ' : '\t';
                break;
            case -1:
                if (!expandTabs && atTab) continue;
                value = ' ';
                break;
            default:
                // Currently only replacement character.
                value = String.fromCharCode(chunk);
        }
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join('');
}


var $38c5b8a1dbcce833$exports = {};

$parcel$export($38c5b8a1dbcce833$exports, "document", () => $38c5b8a1dbcce833$export$5a7bfc01df82fcd1);
$parcel$export($38c5b8a1dbcce833$exports, "contentInitial", () => $38c5b8a1dbcce833$export$5a2181fb44b58173);
$parcel$export($38c5b8a1dbcce833$exports, "flowInitial", () => $38c5b8a1dbcce833$export$cf8bead395eff824);
$parcel$export($38c5b8a1dbcce833$exports, "flow", () => $38c5b8a1dbcce833$export$ccc7b0636abaffc3);
$parcel$export($38c5b8a1dbcce833$exports, "string", () => $38c5b8a1dbcce833$export$22b082955e083ec3);
$parcel$export($38c5b8a1dbcce833$exports, "text", () => $38c5b8a1dbcce833$export$6f093cfa640b7166);
$parcel$export($38c5b8a1dbcce833$exports, "insideSpan", () => $38c5b8a1dbcce833$export$d44f260a3f9b69f5);
$parcel$export($38c5b8a1dbcce833$exports, "attentionMarkers", () => $38c5b8a1dbcce833$export$b9c0b60d74426aea);
$parcel$export($38c5b8a1dbcce833$exports, "disable", () => $38c5b8a1dbcce833$export$e20fbacbb41798b);
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 */ /**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
/**
 * @typedef {import('micromark-util-types').Code} Code
 */ 
function $6a79389e7a2bfb92$export$e3902bc0d835cad0(code) {
    if (code === null || (0, $a967d3607431391e$export$a30284361b3814b7)(code) || (0, $a967d3607431391e$export$a0ff789c034ffdf4)(code)) return 1;
    if ((0, $a967d3607431391e$export$aa04114dd888a7a0)(code)) return 2;
}



const $2914a5bd571ad3f6$export$45b92471da762af7 = {
    name: 'attention',
    tokenize: $2914a5bd571ad3f6$var$tokenizeAttention,
    resolveAll: $2914a5bd571ad3f6$var$resolveAllAttention
};
/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */ function $2914a5bd571ad3f6$var$resolveAllAttention(events, context) {
    let index = -1;
    /** @type {number} */ let open;
    /** @type {Token} */ let group;
    /** @type {Token} */ let text;
    /** @type {Token} */ let openingSequence;
    /** @type {Token} */ let closingSequence;
    /** @type {number} */ let use;
    /** @type {Array<Event>} */ let nextEvents;
    /** @type {number} */ let offset;
    // Walk through all events.
    //
    // Note: performance of this is fine on an mb of normal markdown, but it’s
    // a bottleneck for malicious stuff.
    while(++index < events.length)// Find a token that can close.
    if (events[index][0] === 'enter' && events[index][1].type === 'attentionSequence' && events[index][1]._close) {
        open = index;
        // Now walk back to find an opener.
        while(open--)// Find a token that can open the closer.
        if (events[open][0] === 'exit' && events[open][1].type === 'attentionSequence' && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
            // If the opening can close or the closing can open,
            // and the close size *is not* a multiple of three,
            // but the sum of the opening and closing size *is* multiple of three,
            // then don’t match.
            if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
            // Number of markers to use from the sequence.
            use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
            const start = Object.assign({}, events[open][1].end);
            const end = Object.assign({}, events[index][1].start);
            $2914a5bd571ad3f6$var$movePoint(start, -use);
            $2914a5bd571ad3f6$var$movePoint(end, use);
            openingSequence = {
                type: use > 1 ? 'strongSequence' : 'emphasisSequence',
                start: start,
                end: Object.assign({}, events[open][1].end)
            };
            closingSequence = {
                type: use > 1 ? 'strongSequence' : 'emphasisSequence',
                start: Object.assign({}, events[index][1].start),
                end: end
            };
            text = {
                type: use > 1 ? 'strongText' : 'emphasisText',
                start: Object.assign({}, events[open][1].end),
                end: Object.assign({}, events[index][1].start)
            };
            group = {
                type: use > 1 ? 'strong' : 'emphasis',
                start: Object.assign({}, openingSequence.start),
                end: Object.assign({}, closingSequence.end)
            };
            events[open][1].end = Object.assign({}, openingSequence.start);
            events[index][1].start = Object.assign({}, closingSequence.end);
            nextEvents = [];
            // If there are more markers in the opening, add them before.
            if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = (0, $5e612816a43dd8d9$export$4cbf152802aa238)(nextEvents, [
                [
                    'enter',
                    events[open][1],
                    context
                ],
                [
                    'exit',
                    events[open][1],
                    context
                ]
            ]);
            // Opening.
            nextEvents = (0, $5e612816a43dd8d9$export$4cbf152802aa238)(nextEvents, [
                [
                    'enter',
                    group,
                    context
                ],
                [
                    'enter',
                    openingSequence,
                    context
                ],
                [
                    'exit',
                    openingSequence,
                    context
                ],
                [
                    'enter',
                    text,
                    context
                ]
            ]);
            // Always populated by defaults.
            // Between.
            nextEvents = (0, $5e612816a43dd8d9$export$4cbf152802aa238)(nextEvents, (0, $a7db008f78200e80$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context));
            // Closing.
            nextEvents = (0, $5e612816a43dd8d9$export$4cbf152802aa238)(nextEvents, [
                [
                    'exit',
                    text,
                    context
                ],
                [
                    'enter',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    group,
                    context
                ]
            ]);
            // If there are more markers in the closing, add them after.
            if (events[index][1].end.offset - events[index][1].start.offset) {
                offset = 2;
                nextEvents = (0, $5e612816a43dd8d9$export$4cbf152802aa238)(nextEvents, [
                    [
                        'enter',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        events[index][1],
                        context
                    ]
                ]);
            } else offset = 0;
            (0, $5e612816a43dd8d9$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - offset - 2;
            break;
        }
    }
    // Remove remaining sequences.
    index = -1;
    while(++index < events.length)if (events[index][1].type === 'attentionSequence') events[index][1].type = 'data';
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2914a5bd571ad3f6$var$tokenizeAttention(effects, ok) {
    const attentionMarkers = this.parser.constructs.attentionMarkers.null;
    const previous = this.previous;
    const before = (0, $6a79389e7a2bfb92$export$e3902bc0d835cad0)(previous);
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Before a sequence.
   *
   * ```markdown
   * > | **
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        marker = code;
        effects.enter('attentionSequence');
        return inside(code);
    }
    /**
   * In a sequence.
   *
   * ```markdown
   * > | **
   *     ^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        const token = effects.exit('attentionSequence');
        // To do: next major: move this to resolver, just like `markdown-rs`.
        const after = (0, $6a79389e7a2bfb92$export$e3902bc0d835cad0)(code);
        // Always populated by defaults.
        const open = !after || after === 2 && before || attentionMarkers.includes(code);
        const close = !before || before === 2 && after || attentionMarkers.includes(previous);
        token._open = Boolean(marker === 42 ? open : open && (before || !close));
        token._close = Boolean(marker === 42 ? close : close && (after || !open));
        return ok(code);
    }
}
/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 * @param {number} offset
 * @returns {void}
 */ function $2914a5bd571ad3f6$var$movePoint(point, offset) {
    point.column += offset;
    point.offset += offset;
    point._bufferIndex += offset;
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $3321952f24a8c2bf$export$17ddf85e4c916ad6 = {
    name: 'autolink',
    tokenize: $3321952f24a8c2bf$var$tokenizeAutolink
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $3321952f24a8c2bf$var$tokenizeAutolink(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of an autolink.
   *
   * ```markdown
   * > | a<https://example.com>b
   *      ^
   * > | a<user@example.com>b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('autolink');
        effects.enter('autolinkMarker');
        effects.consume(code);
        effects.exit('autolinkMarker');
        effects.enter('autolinkProtocol');
        return open;
    }
    /**
   * After `<`, at protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *       ^
   * > | a<user@example.com>b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if ((0, $a967d3607431391e$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return schemeOrEmailAtext;
        }
        return emailAtext(code);
    }
    /**
   * At second byte of protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeOrEmailAtext(code) {
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if (code === 43 || code === 45 || code === 46 || (0, $a967d3607431391e$export$75c76db11865a9f4)(code)) {
            // Count the previous alphabetical from `open` too.
            size = 1;
            return schemeInsideOrEmailAtext(code);
        }
        return emailAtext(code);
    }
    /**
   * In ambiguous protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeInsideOrEmailAtext(code) {
        if (code === 58) {
            effects.consume(code);
            size = 0;
            return urlInside;
        }
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if ((code === 43 || code === 45 || code === 46 || (0, $a967d3607431391e$export$75c76db11865a9f4)(code)) && size++ < 32) {
            effects.consume(code);
            return schemeInsideOrEmailAtext;
        }
        size = 0;
        return emailAtext(code);
    }
    /**
   * After protocol, in URL.
   *
   * ```markdown
   * > | a<https://example.com>b
   *             ^
   * ```
   *
   * @type {State}
   */ function urlInside(code) {
        if (code === 62) {
            effects.exit('autolinkProtocol');
            effects.enter('autolinkMarker');
            effects.consume(code);
            effects.exit('autolinkMarker');
            effects.exit('autolink');
            return ok;
        }
        // ASCII control, space, or `<`.
        if (code === null || code === 32 || code === 60 || (0, $a967d3607431391e$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return urlInside;
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *              ^
   * ```
   *
   * @type {State}
   */ function emailAtext(code) {
        if (code === 64) {
            effects.consume(code);
            return emailAtSignOrDot;
        }
        if ((0, $a967d3607431391e$export$4397998b34fe597d)(code)) {
            effects.consume(code);
            return emailAtext;
        }
        return nok(code);
    }
    /**
   * In label, after at-sign or dot.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                 ^       ^
   * ```
   *
   * @type {State}
   */ function emailAtSignOrDot(code) {
        return (0, $a967d3607431391e$export$75c76db11865a9f4)(code) ? emailLabel(code) : nok(code);
    }
    /**
   * In label, where `.` and `>` are allowed.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                   ^
   * ```
   *
   * @type {State}
   */ function emailLabel(code) {
        if (code === 46) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (code === 62) {
            // Exit, then change the token type.
            effects.exit('autolinkProtocol').type = 'autolinkEmail';
            effects.enter('autolinkMarker');
            effects.consume(code);
            effects.exit('autolinkMarker');
            effects.exit('autolink');
            return ok;
        }
        return emailValue(code);
    }
    /**
   * In label, where `.` and `>` are *not* allowed.
   *
   * Though, this is also used in `emailLabel` to parse other values.
   *
   * ```markdown
   * > | a<user.name@ex-ample.com>b
   *                    ^
   * ```
   *
   * @type {State}
   */ function emailValue(code) {
        // ASCII alphanumeric or `-`.
        if ((code === 45 || (0, $a967d3607431391e$export$75c76db11865a9f4)(code)) && size++ < 63) {
            const next = code === 45 ? emailValue : emailLabel;
            effects.consume(code);
            return next;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $2d60636958356360$export$200dcd0a5903c968 = {
    name: 'blockQuote',
    tokenize: $2d60636958356360$var$tokenizeBlockQuoteStart,
    continuation: {
        tokenize: $2d60636958356360$var$tokenizeBlockQuoteContinuation
    },
    exit: $2d60636958356360$var$exit
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2d60636958356360$var$tokenizeBlockQuoteStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of block quote.
   *
   * ```markdown
   * > | > a
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 62) {
            const state = self.containerState;
            if (!state.open) {
                effects.enter('blockQuote', {
                    _container: true
                });
                state.open = true;
            }
            effects.enter('blockQuotePrefix');
            effects.enter('blockQuoteMarker');
            effects.consume(code);
            effects.exit('blockQuoteMarker');
            return after;
        }
        return nok(code);
    }
    /**
   * After `>`, before optional whitespace.
   *
   * ```markdown
   * > | > a
   *      ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if ((0, $a967d3607431391e$export$2c6cf65c1127992a)(code)) {
            effects.enter('blockQuotePrefixWhitespace');
            effects.consume(code);
            effects.exit('blockQuotePrefixWhitespace');
            effects.exit('blockQuotePrefix');
            return ok;
        }
        effects.exit('blockQuotePrefix');
        return ok(code);
    }
}
/**
 * Start of block quote continuation.
 *
 * ```markdown
 *   | > a
 * > | > b
 *     ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2d60636958356360$var$tokenizeBlockQuoteContinuation(effects, ok, nok) {
    const self = this;
    return contStart;
    /**
   * Start of block quote continuation.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contStart(code) {
        if ((0, $a967d3607431391e$export$2c6cf65c1127992a)(code)) // Always populated by defaults.
        return (0, $602eae48ac3dea9e$export$ae105c1eb063a0a2)(effects, contBefore, 'linePrefix', self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
        return contBefore(code);
    }
    /**
   * At `>`, after optional whitespace.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contBefore(code) {
        return effects.attempt($2d60636958356360$export$200dcd0a5903c968, ok, nok)(code);
    }
}
/** @type {Exiter} */ function $2d60636958356360$var$exit(effects) {
    effects.exit('blockQuote');
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $02cb63cd83f0abed$export$2005478564e78d96 = {
    name: 'characterEscape',
    tokenize: $02cb63cd83f0abed$var$tokenizeCharacterEscape
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $02cb63cd83f0abed$var$tokenizeCharacterEscape(effects, ok, nok) {
    return start;
    /**
   * Start of character escape.
   *
   * ```markdown
   * > | a\*b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('characterEscape');
        effects.enter('escapeMarker');
        effects.consume(code);
        effects.exit('escapeMarker');
        return inside;
    }
    /**
   * After `\`, at punctuation.
   *
   * ```markdown
   * > | a\*b
   *       ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // ASCII punctuation.
        if ((0, $a967d3607431391e$export$35794a7d1db99380)(code)) {
            effects.enter('characterEscapeValue');
            effects.consume(code);
            effects.exit('characterEscapeValue');
            effects.exit('characterEscape');
            return ok;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * Map of named character references.
 *
 * @type {Record<string, string>}
 */ const $7956d80b12e9dacc$export$ec810d1aafce79a7 = {
    AElig: "\xc6",
    AMP: '&',
    Aacute: "\xc1",
    Abreve: "\u0102",
    Acirc: "\xc2",
    Acy: "\u0410",
    Afr: "\uD835\uDD04",
    Agrave: "\xc0",
    Alpha: "\u0391",
    Amacr: "\u0100",
    And: "\u2A53",
    Aogon: "\u0104",
    Aopf: "\uD835\uDD38",
    ApplyFunction: "\u2061",
    Aring: "\xc5",
    Ascr: "\uD835\uDC9C",
    Assign: "\u2254",
    Atilde: "\xc3",
    Auml: "\xc4",
    Backslash: "\u2216",
    Barv: "\u2AE7",
    Barwed: "\u2306",
    Bcy: "\u0411",
    Because: "\u2235",
    Bernoullis: "\u212C",
    Beta: "\u0392",
    Bfr: "\uD835\uDD05",
    Bopf: "\uD835\uDD39",
    Breve: "\u02D8",
    Bscr: "\u212C",
    Bumpeq: "\u224E",
    CHcy: "\u0427",
    COPY: "\xa9",
    Cacute: "\u0106",
    Cap: "\u22D2",
    CapitalDifferentialD: "\u2145",
    Cayleys: "\u212D",
    Ccaron: "\u010C",
    Ccedil: "\xc7",
    Ccirc: "\u0108",
    Cconint: "\u2230",
    Cdot: "\u010A",
    Cedilla: "\xb8",
    CenterDot: "\xb7",
    Cfr: "\u212D",
    Chi: "\u03A7",
    CircleDot: "\u2299",
    CircleMinus: "\u2296",
    CirclePlus: "\u2295",
    CircleTimes: "\u2297",
    ClockwiseContourIntegral: "\u2232",
    CloseCurlyDoubleQuote: "\u201D",
    CloseCurlyQuote: "\u2019",
    Colon: "\u2237",
    Colone: "\u2A74",
    Congruent: "\u2261",
    Conint: "\u222F",
    ContourIntegral: "\u222E",
    Copf: "\u2102",
    Coproduct: "\u2210",
    CounterClockwiseContourIntegral: "\u2233",
    Cross: "\u2A2F",
    Cscr: "\uD835\uDC9E",
    Cup: "\u22D3",
    CupCap: "\u224D",
    DD: "\u2145",
    DDotrahd: "\u2911",
    DJcy: "\u0402",
    DScy: "\u0405",
    DZcy: "\u040F",
    Dagger: "\u2021",
    Darr: "\u21A1",
    Dashv: "\u2AE4",
    Dcaron: "\u010E",
    Dcy: "\u0414",
    Del: "\u2207",
    Delta: "\u0394",
    Dfr: "\uD835\uDD07",
    DiacriticalAcute: "\xb4",
    DiacriticalDot: "\u02D9",
    DiacriticalDoubleAcute: "\u02DD",
    DiacriticalGrave: '`',
    DiacriticalTilde: "\u02DC",
    Diamond: "\u22C4",
    DifferentialD: "\u2146",
    Dopf: "\uD835\uDD3B",
    Dot: "\xa8",
    DotDot: "\u20DC",
    DotEqual: "\u2250",
    DoubleContourIntegral: "\u222F",
    DoubleDot: "\xa8",
    DoubleDownArrow: "\u21D3",
    DoubleLeftArrow: "\u21D0",
    DoubleLeftRightArrow: "\u21D4",
    DoubleLeftTee: "\u2AE4",
    DoubleLongLeftArrow: "\u27F8",
    DoubleLongLeftRightArrow: "\u27FA",
    DoubleLongRightArrow: "\u27F9",
    DoubleRightArrow: "\u21D2",
    DoubleRightTee: "\u22A8",
    DoubleUpArrow: "\u21D1",
    DoubleUpDownArrow: "\u21D5",
    DoubleVerticalBar: "\u2225",
    DownArrow: "\u2193",
    DownArrowBar: "\u2913",
    DownArrowUpArrow: "\u21F5",
    DownBreve: "\u0311",
    DownLeftRightVector: "\u2950",
    DownLeftTeeVector: "\u295E",
    DownLeftVector: "\u21BD",
    DownLeftVectorBar: "\u2956",
    DownRightTeeVector: "\u295F",
    DownRightVector: "\u21C1",
    DownRightVectorBar: "\u2957",
    DownTee: "\u22A4",
    DownTeeArrow: "\u21A7",
    Downarrow: "\u21D3",
    Dscr: "\uD835\uDC9F",
    Dstrok: "\u0110",
    ENG: "\u014A",
    ETH: "\xd0",
    Eacute: "\xc9",
    Ecaron: "\u011A",
    Ecirc: "\xca",
    Ecy: "\u042D",
    Edot: "\u0116",
    Efr: "\uD835\uDD08",
    Egrave: "\xc8",
    Element: "\u2208",
    Emacr: "\u0112",
    EmptySmallSquare: "\u25FB",
    EmptyVerySmallSquare: "\u25AB",
    Eogon: "\u0118",
    Eopf: "\uD835\uDD3C",
    Epsilon: "\u0395",
    Equal: "\u2A75",
    EqualTilde: "\u2242",
    Equilibrium: "\u21CC",
    Escr: "\u2130",
    Esim: "\u2A73",
    Eta: "\u0397",
    Euml: "\xcb",
    Exists: "\u2203",
    ExponentialE: "\u2147",
    Fcy: "\u0424",
    Ffr: "\uD835\uDD09",
    FilledSmallSquare: "\u25FC",
    FilledVerySmallSquare: "\u25AA",
    Fopf: "\uD835\uDD3D",
    ForAll: "\u2200",
    Fouriertrf: "\u2131",
    Fscr: "\u2131",
    GJcy: "\u0403",
    GT: '>',
    Gamma: "\u0393",
    Gammad: "\u03DC",
    Gbreve: "\u011E",
    Gcedil: "\u0122",
    Gcirc: "\u011C",
    Gcy: "\u0413",
    Gdot: "\u0120",
    Gfr: "\uD835\uDD0A",
    Gg: "\u22D9",
    Gopf: "\uD835\uDD3E",
    GreaterEqual: "\u2265",
    GreaterEqualLess: "\u22DB",
    GreaterFullEqual: "\u2267",
    GreaterGreater: "\u2AA2",
    GreaterLess: "\u2277",
    GreaterSlantEqual: "\u2A7E",
    GreaterTilde: "\u2273",
    Gscr: "\uD835\uDCA2",
    Gt: "\u226B",
    HARDcy: "\u042A",
    Hacek: "\u02C7",
    Hat: '^',
    Hcirc: "\u0124",
    Hfr: "\u210C",
    HilbertSpace: "\u210B",
    Hopf: "\u210D",
    HorizontalLine: "\u2500",
    Hscr: "\u210B",
    Hstrok: "\u0126",
    HumpDownHump: "\u224E",
    HumpEqual: "\u224F",
    IEcy: "\u0415",
    IJlig: "\u0132",
    IOcy: "\u0401",
    Iacute: "\xcd",
    Icirc: "\xce",
    Icy: "\u0418",
    Idot: "\u0130",
    Ifr: "\u2111",
    Igrave: "\xcc",
    Im: "\u2111",
    Imacr: "\u012A",
    ImaginaryI: "\u2148",
    Implies: "\u21D2",
    Int: "\u222C",
    Integral: "\u222B",
    Intersection: "\u22C2",
    InvisibleComma: "\u2063",
    InvisibleTimes: "\u2062",
    Iogon: "\u012E",
    Iopf: "\uD835\uDD40",
    Iota: "\u0399",
    Iscr: "\u2110",
    Itilde: "\u0128",
    Iukcy: "\u0406",
    Iuml: "\xcf",
    Jcirc: "\u0134",
    Jcy: "\u0419",
    Jfr: "\uD835\uDD0D",
    Jopf: "\uD835\uDD41",
    Jscr: "\uD835\uDCA5",
    Jsercy: "\u0408",
    Jukcy: "\u0404",
    KHcy: "\u0425",
    KJcy: "\u040C",
    Kappa: "\u039A",
    Kcedil: "\u0136",
    Kcy: "\u041A",
    Kfr: "\uD835\uDD0E",
    Kopf: "\uD835\uDD42",
    Kscr: "\uD835\uDCA6",
    LJcy: "\u0409",
    LT: '<',
    Lacute: "\u0139",
    Lambda: "\u039B",
    Lang: "\u27EA",
    Laplacetrf: "\u2112",
    Larr: "\u219E",
    Lcaron: "\u013D",
    Lcedil: "\u013B",
    Lcy: "\u041B",
    LeftAngleBracket: "\u27E8",
    LeftArrow: "\u2190",
    LeftArrowBar: "\u21E4",
    LeftArrowRightArrow: "\u21C6",
    LeftCeiling: "\u2308",
    LeftDoubleBracket: "\u27E6",
    LeftDownTeeVector: "\u2961",
    LeftDownVector: "\u21C3",
    LeftDownVectorBar: "\u2959",
    LeftFloor: "\u230A",
    LeftRightArrow: "\u2194",
    LeftRightVector: "\u294E",
    LeftTee: "\u22A3",
    LeftTeeArrow: "\u21A4",
    LeftTeeVector: "\u295A",
    LeftTriangle: "\u22B2",
    LeftTriangleBar: "\u29CF",
    LeftTriangleEqual: "\u22B4",
    LeftUpDownVector: "\u2951",
    LeftUpTeeVector: "\u2960",
    LeftUpVector: "\u21BF",
    LeftUpVectorBar: "\u2958",
    LeftVector: "\u21BC",
    LeftVectorBar: "\u2952",
    Leftarrow: "\u21D0",
    Leftrightarrow: "\u21D4",
    LessEqualGreater: "\u22DA",
    LessFullEqual: "\u2266",
    LessGreater: "\u2276",
    LessLess: "\u2AA1",
    LessSlantEqual: "\u2A7D",
    LessTilde: "\u2272",
    Lfr: "\uD835\uDD0F",
    Ll: "\u22D8",
    Lleftarrow: "\u21DA",
    Lmidot: "\u013F",
    LongLeftArrow: "\u27F5",
    LongLeftRightArrow: "\u27F7",
    LongRightArrow: "\u27F6",
    Longleftarrow: "\u27F8",
    Longleftrightarrow: "\u27FA",
    Longrightarrow: "\u27F9",
    Lopf: "\uD835\uDD43",
    LowerLeftArrow: "\u2199",
    LowerRightArrow: "\u2198",
    Lscr: "\u2112",
    Lsh: "\u21B0",
    Lstrok: "\u0141",
    Lt: "\u226A",
    Map: "\u2905",
    Mcy: "\u041C",
    MediumSpace: "\u205F",
    Mellintrf: "\u2133",
    Mfr: "\uD835\uDD10",
    MinusPlus: "\u2213",
    Mopf: "\uD835\uDD44",
    Mscr: "\u2133",
    Mu: "\u039C",
    NJcy: "\u040A",
    Nacute: "\u0143",
    Ncaron: "\u0147",
    Ncedil: "\u0145",
    Ncy: "\u041D",
    NegativeMediumSpace: "\u200B",
    NegativeThickSpace: "\u200B",
    NegativeThinSpace: "\u200B",
    NegativeVeryThinSpace: "\u200B",
    NestedGreaterGreater: "\u226B",
    NestedLessLess: "\u226A",
    NewLine: '\n',
    Nfr: "\uD835\uDD11",
    NoBreak: "\u2060",
    NonBreakingSpace: "\xa0",
    Nopf: "\u2115",
    Not: "\u2AEC",
    NotCongruent: "\u2262",
    NotCupCap: "\u226D",
    NotDoubleVerticalBar: "\u2226",
    NotElement: "\u2209",
    NotEqual: "\u2260",
    NotEqualTilde: "\u2242\u0338",
    NotExists: "\u2204",
    NotGreater: "\u226F",
    NotGreaterEqual: "\u2271",
    NotGreaterFullEqual: "\u2267\u0338",
    NotGreaterGreater: "\u226B\u0338",
    NotGreaterLess: "\u2279",
    NotGreaterSlantEqual: "\u2A7E\u0338",
    NotGreaterTilde: "\u2275",
    NotHumpDownHump: "\u224E\u0338",
    NotHumpEqual: "\u224F\u0338",
    NotLeftTriangle: "\u22EA",
    NotLeftTriangleBar: "\u29CF\u0338",
    NotLeftTriangleEqual: "\u22EC",
    NotLess: "\u226E",
    NotLessEqual: "\u2270",
    NotLessGreater: "\u2278",
    NotLessLess: "\u226A\u0338",
    NotLessSlantEqual: "\u2A7D\u0338",
    NotLessTilde: "\u2274",
    NotNestedGreaterGreater: "\u2AA2\u0338",
    NotNestedLessLess: "\u2AA1\u0338",
    NotPrecedes: "\u2280",
    NotPrecedesEqual: "\u2AAF\u0338",
    NotPrecedesSlantEqual: "\u22E0",
    NotReverseElement: "\u220C",
    NotRightTriangle: "\u22EB",
    NotRightTriangleBar: "\u29D0\u0338",
    NotRightTriangleEqual: "\u22ED",
    NotSquareSubset: "\u228F\u0338",
    NotSquareSubsetEqual: "\u22E2",
    NotSquareSuperset: "\u2290\u0338",
    NotSquareSupersetEqual: "\u22E3",
    NotSubset: "\u2282\u20D2",
    NotSubsetEqual: "\u2288",
    NotSucceeds: "\u2281",
    NotSucceedsEqual: "\u2AB0\u0338",
    NotSucceedsSlantEqual: "\u22E1",
    NotSucceedsTilde: "\u227F\u0338",
    NotSuperset: "\u2283\u20D2",
    NotSupersetEqual: "\u2289",
    NotTilde: "\u2241",
    NotTildeEqual: "\u2244",
    NotTildeFullEqual: "\u2247",
    NotTildeTilde: "\u2249",
    NotVerticalBar: "\u2224",
    Nscr: "\uD835\uDCA9",
    Ntilde: "\xd1",
    Nu: "\u039D",
    OElig: "\u0152",
    Oacute: "\xd3",
    Ocirc: "\xd4",
    Ocy: "\u041E",
    Odblac: "\u0150",
    Ofr: "\uD835\uDD12",
    Ograve: "\xd2",
    Omacr: "\u014C",
    Omega: "\u03A9",
    Omicron: "\u039F",
    Oopf: "\uD835\uDD46",
    OpenCurlyDoubleQuote: "\u201C",
    OpenCurlyQuote: "\u2018",
    Or: "\u2A54",
    Oscr: "\uD835\uDCAA",
    Oslash: "\xd8",
    Otilde: "\xd5",
    Otimes: "\u2A37",
    Ouml: "\xd6",
    OverBar: "\u203E",
    OverBrace: "\u23DE",
    OverBracket: "\u23B4",
    OverParenthesis: "\u23DC",
    PartialD: "\u2202",
    Pcy: "\u041F",
    Pfr: "\uD835\uDD13",
    Phi: "\u03A6",
    Pi: "\u03A0",
    PlusMinus: "\xb1",
    Poincareplane: "\u210C",
    Popf: "\u2119",
    Pr: "\u2ABB",
    Precedes: "\u227A",
    PrecedesEqual: "\u2AAF",
    PrecedesSlantEqual: "\u227C",
    PrecedesTilde: "\u227E",
    Prime: "\u2033",
    Product: "\u220F",
    Proportion: "\u2237",
    Proportional: "\u221D",
    Pscr: "\uD835\uDCAB",
    Psi: "\u03A8",
    QUOT: '"',
    Qfr: "\uD835\uDD14",
    Qopf: "\u211A",
    Qscr: "\uD835\uDCAC",
    RBarr: "\u2910",
    REG: "\xae",
    Racute: "\u0154",
    Rang: "\u27EB",
    Rarr: "\u21A0",
    Rarrtl: "\u2916",
    Rcaron: "\u0158",
    Rcedil: "\u0156",
    Rcy: "\u0420",
    Re: "\u211C",
    ReverseElement: "\u220B",
    ReverseEquilibrium: "\u21CB",
    ReverseUpEquilibrium: "\u296F",
    Rfr: "\u211C",
    Rho: "\u03A1",
    RightAngleBracket: "\u27E9",
    RightArrow: "\u2192",
    RightArrowBar: "\u21E5",
    RightArrowLeftArrow: "\u21C4",
    RightCeiling: "\u2309",
    RightDoubleBracket: "\u27E7",
    RightDownTeeVector: "\u295D",
    RightDownVector: "\u21C2",
    RightDownVectorBar: "\u2955",
    RightFloor: "\u230B",
    RightTee: "\u22A2",
    RightTeeArrow: "\u21A6",
    RightTeeVector: "\u295B",
    RightTriangle: "\u22B3",
    RightTriangleBar: "\u29D0",
    RightTriangleEqual: "\u22B5",
    RightUpDownVector: "\u294F",
    RightUpTeeVector: "\u295C",
    RightUpVector: "\u21BE",
    RightUpVectorBar: "\u2954",
    RightVector: "\u21C0",
    RightVectorBar: "\u2953",
    Rightarrow: "\u21D2",
    Ropf: "\u211D",
    RoundImplies: "\u2970",
    Rrightarrow: "\u21DB",
    Rscr: "\u211B",
    Rsh: "\u21B1",
    RuleDelayed: "\u29F4",
    SHCHcy: "\u0429",
    SHcy: "\u0428",
    SOFTcy: "\u042C",
    Sacute: "\u015A",
    Sc: "\u2ABC",
    Scaron: "\u0160",
    Scedil: "\u015E",
    Scirc: "\u015C",
    Scy: "\u0421",
    Sfr: "\uD835\uDD16",
    ShortDownArrow: "\u2193",
    ShortLeftArrow: "\u2190",
    ShortRightArrow: "\u2192",
    ShortUpArrow: "\u2191",
    Sigma: "\u03A3",
    SmallCircle: "\u2218",
    Sopf: "\uD835\uDD4A",
    Sqrt: "\u221A",
    Square: "\u25A1",
    SquareIntersection: "\u2293",
    SquareSubset: "\u228F",
    SquareSubsetEqual: "\u2291",
    SquareSuperset: "\u2290",
    SquareSupersetEqual: "\u2292",
    SquareUnion: "\u2294",
    Sscr: "\uD835\uDCAE",
    Star: "\u22C6",
    Sub: "\u22D0",
    Subset: "\u22D0",
    SubsetEqual: "\u2286",
    Succeeds: "\u227B",
    SucceedsEqual: "\u2AB0",
    SucceedsSlantEqual: "\u227D",
    SucceedsTilde: "\u227F",
    SuchThat: "\u220B",
    Sum: "\u2211",
    Sup: "\u22D1",
    Superset: "\u2283",
    SupersetEqual: "\u2287",
    Supset: "\u22D1",
    THORN: "\xde",
    TRADE: "\u2122",
    TSHcy: "\u040B",
    TScy: "\u0426",
    Tab: '\t',
    Tau: "\u03A4",
    Tcaron: "\u0164",
    Tcedil: "\u0162",
    Tcy: "\u0422",
    Tfr: "\uD835\uDD17",
    Therefore: "\u2234",
    Theta: "\u0398",
    ThickSpace: "\u205F\u200A",
    ThinSpace: "\u2009",
    Tilde: "\u223C",
    TildeEqual: "\u2243",
    TildeFullEqual: "\u2245",
    TildeTilde: "\u2248",
    Topf: "\uD835\uDD4B",
    TripleDot: "\u20DB",
    Tscr: "\uD835\uDCAF",
    Tstrok: "\u0166",
    Uacute: "\xda",
    Uarr: "\u219F",
    Uarrocir: "\u2949",
    Ubrcy: "\u040E",
    Ubreve: "\u016C",
    Ucirc: "\xdb",
    Ucy: "\u0423",
    Udblac: "\u0170",
    Ufr: "\uD835\uDD18",
    Ugrave: "\xd9",
    Umacr: "\u016A",
    UnderBar: '_',
    UnderBrace: "\u23DF",
    UnderBracket: "\u23B5",
    UnderParenthesis: "\u23DD",
    Union: "\u22C3",
    UnionPlus: "\u228E",
    Uogon: "\u0172",
    Uopf: "\uD835\uDD4C",
    UpArrow: "\u2191",
    UpArrowBar: "\u2912",
    UpArrowDownArrow: "\u21C5",
    UpDownArrow: "\u2195",
    UpEquilibrium: "\u296E",
    UpTee: "\u22A5",
    UpTeeArrow: "\u21A5",
    Uparrow: "\u21D1",
    Updownarrow: "\u21D5",
    UpperLeftArrow: "\u2196",
    UpperRightArrow: "\u2197",
    Upsi: "\u03D2",
    Upsilon: "\u03A5",
    Uring: "\u016E",
    Uscr: "\uD835\uDCB0",
    Utilde: "\u0168",
    Uuml: "\xdc",
    VDash: "\u22AB",
    Vbar: "\u2AEB",
    Vcy: "\u0412",
    Vdash: "\u22A9",
    Vdashl: "\u2AE6",
    Vee: "\u22C1",
    Verbar: "\u2016",
    Vert: "\u2016",
    VerticalBar: "\u2223",
    VerticalLine: '|',
    VerticalSeparator: "\u2758",
    VerticalTilde: "\u2240",
    VeryThinSpace: "\u200A",
    Vfr: "\uD835\uDD19",
    Vopf: "\uD835\uDD4D",
    Vscr: "\uD835\uDCB1",
    Vvdash: "\u22AA",
    Wcirc: "\u0174",
    Wedge: "\u22C0",
    Wfr: "\uD835\uDD1A",
    Wopf: "\uD835\uDD4E",
    Wscr: "\uD835\uDCB2",
    Xfr: "\uD835\uDD1B",
    Xi: "\u039E",
    Xopf: "\uD835\uDD4F",
    Xscr: "\uD835\uDCB3",
    YAcy: "\u042F",
    YIcy: "\u0407",
    YUcy: "\u042E",
    Yacute: "\xdd",
    Ycirc: "\u0176",
    Ycy: "\u042B",
    Yfr: "\uD835\uDD1C",
    Yopf: "\uD835\uDD50",
    Yscr: "\uD835\uDCB4",
    Yuml: "\u0178",
    ZHcy: "\u0416",
    Zacute: "\u0179",
    Zcaron: "\u017D",
    Zcy: "\u0417",
    Zdot: "\u017B",
    ZeroWidthSpace: "\u200B",
    Zeta: "\u0396",
    Zfr: "\u2128",
    Zopf: "\u2124",
    Zscr: "\uD835\uDCB5",
    aacute: "\xe1",
    abreve: "\u0103",
    ac: "\u223E",
    acE: "\u223E\u0333",
    acd: "\u223F",
    acirc: "\xe2",
    acute: "\xb4",
    acy: "\u0430",
    aelig: "\xe6",
    af: "\u2061",
    afr: "\uD835\uDD1E",
    agrave: "\xe0",
    alefsym: "\u2135",
    aleph: "\u2135",
    alpha: "\u03B1",
    amacr: "\u0101",
    amalg: "\u2A3F",
    amp: '&',
    and: "\u2227",
    andand: "\u2A55",
    andd: "\u2A5C",
    andslope: "\u2A58",
    andv: "\u2A5A",
    ang: "\u2220",
    ange: "\u29A4",
    angle: "\u2220",
    angmsd: "\u2221",
    angmsdaa: "\u29A8",
    angmsdab: "\u29A9",
    angmsdac: "\u29AA",
    angmsdad: "\u29AB",
    angmsdae: "\u29AC",
    angmsdaf: "\u29AD",
    angmsdag: "\u29AE",
    angmsdah: "\u29AF",
    angrt: "\u221F",
    angrtvb: "\u22BE",
    angrtvbd: "\u299D",
    angsph: "\u2222",
    angst: "\xc5",
    angzarr: "\u237C",
    aogon: "\u0105",
    aopf: "\uD835\uDD52",
    ap: "\u2248",
    apE: "\u2A70",
    apacir: "\u2A6F",
    ape: "\u224A",
    apid: "\u224B",
    apos: "'",
    approx: "\u2248",
    approxeq: "\u224A",
    aring: "\xe5",
    ascr: "\uD835\uDCB6",
    ast: '*',
    asymp: "\u2248",
    asympeq: "\u224D",
    atilde: "\xe3",
    auml: "\xe4",
    awconint: "\u2233",
    awint: "\u2A11",
    bNot: "\u2AED",
    backcong: "\u224C",
    backepsilon: "\u03F6",
    backprime: "\u2035",
    backsim: "\u223D",
    backsimeq: "\u22CD",
    barvee: "\u22BD",
    barwed: "\u2305",
    barwedge: "\u2305",
    bbrk: "\u23B5",
    bbrktbrk: "\u23B6",
    bcong: "\u224C",
    bcy: "\u0431",
    bdquo: "\u201E",
    becaus: "\u2235",
    because: "\u2235",
    bemptyv: "\u29B0",
    bepsi: "\u03F6",
    bernou: "\u212C",
    beta: "\u03B2",
    beth: "\u2136",
    between: "\u226C",
    bfr: "\uD835\uDD1F",
    bigcap: "\u22C2",
    bigcirc: "\u25EF",
    bigcup: "\u22C3",
    bigodot: "\u2A00",
    bigoplus: "\u2A01",
    bigotimes: "\u2A02",
    bigsqcup: "\u2A06",
    bigstar: "\u2605",
    bigtriangledown: "\u25BD",
    bigtriangleup: "\u25B3",
    biguplus: "\u2A04",
    bigvee: "\u22C1",
    bigwedge: "\u22C0",
    bkarow: "\u290D",
    blacklozenge: "\u29EB",
    blacksquare: "\u25AA",
    blacktriangle: "\u25B4",
    blacktriangledown: "\u25BE",
    blacktriangleleft: "\u25C2",
    blacktriangleright: "\u25B8",
    blank: "\u2423",
    blk12: "\u2592",
    blk14: "\u2591",
    blk34: "\u2593",
    block: "\u2588",
    bne: "=\u20E5",
    bnequiv: "\u2261\u20E5",
    bnot: "\u2310",
    bopf: "\uD835\uDD53",
    bot: "\u22A5",
    bottom: "\u22A5",
    bowtie: "\u22C8",
    boxDL: "\u2557",
    boxDR: "\u2554",
    boxDl: "\u2556",
    boxDr: "\u2553",
    boxH: "\u2550",
    boxHD: "\u2566",
    boxHU: "\u2569",
    boxHd: "\u2564",
    boxHu: "\u2567",
    boxUL: "\u255D",
    boxUR: "\u255A",
    boxUl: "\u255C",
    boxUr: "\u2559",
    boxV: "\u2551",
    boxVH: "\u256C",
    boxVL: "\u2563",
    boxVR: "\u2560",
    boxVh: "\u256B",
    boxVl: "\u2562",
    boxVr: "\u255F",
    boxbox: "\u29C9",
    boxdL: "\u2555",
    boxdR: "\u2552",
    boxdl: "\u2510",
    boxdr: "\u250C",
    boxh: "\u2500",
    boxhD: "\u2565",
    boxhU: "\u2568",
    boxhd: "\u252C",
    boxhu: "\u2534",
    boxminus: "\u229F",
    boxplus: "\u229E",
    boxtimes: "\u22A0",
    boxuL: "\u255B",
    boxuR: "\u2558",
    boxul: "\u2518",
    boxur: "\u2514",
    boxv: "\u2502",
    boxvH: "\u256A",
    boxvL: "\u2561",
    boxvR: "\u255E",
    boxvh: "\u253C",
    boxvl: "\u2524",
    boxvr: "\u251C",
    bprime: "\u2035",
    breve: "\u02D8",
    brvbar: "\xa6",
    bscr: "\uD835\uDCB7",
    bsemi: "\u204F",
    bsim: "\u223D",
    bsime: "\u22CD",
    bsol: '\\',
    bsolb: "\u29C5",
    bsolhsub: "\u27C8",
    bull: "\u2022",
    bullet: "\u2022",
    bump: "\u224E",
    bumpE: "\u2AAE",
    bumpe: "\u224F",
    bumpeq: "\u224F",
    cacute: "\u0107",
    cap: "\u2229",
    capand: "\u2A44",
    capbrcup: "\u2A49",
    capcap: "\u2A4B",
    capcup: "\u2A47",
    capdot: "\u2A40",
    caps: "\u2229\uFE00",
    caret: "\u2041",
    caron: "\u02C7",
    ccaps: "\u2A4D",
    ccaron: "\u010D",
    ccedil: "\xe7",
    ccirc: "\u0109",
    ccups: "\u2A4C",
    ccupssm: "\u2A50",
    cdot: "\u010B",
    cedil: "\xb8",
    cemptyv: "\u29B2",
    cent: "\xa2",
    centerdot: "\xb7",
    cfr: "\uD835\uDD20",
    chcy: "\u0447",
    check: "\u2713",
    checkmark: "\u2713",
    chi: "\u03C7",
    cir: "\u25CB",
    cirE: "\u29C3",
    circ: "\u02C6",
    circeq: "\u2257",
    circlearrowleft: "\u21BA",
    circlearrowright: "\u21BB",
    circledR: "\xae",
    circledS: "\u24C8",
    circledast: "\u229B",
    circledcirc: "\u229A",
    circleddash: "\u229D",
    cire: "\u2257",
    cirfnint: "\u2A10",
    cirmid: "\u2AEF",
    cirscir: "\u29C2",
    clubs: "\u2663",
    clubsuit: "\u2663",
    colon: ':',
    colone: "\u2254",
    coloneq: "\u2254",
    comma: ',',
    commat: '@',
    comp: "\u2201",
    compfn: "\u2218",
    complement: "\u2201",
    complexes: "\u2102",
    cong: "\u2245",
    congdot: "\u2A6D",
    conint: "\u222E",
    copf: "\uD835\uDD54",
    coprod: "\u2210",
    copy: "\xa9",
    copysr: "\u2117",
    crarr: "\u21B5",
    cross: "\u2717",
    cscr: "\uD835\uDCB8",
    csub: "\u2ACF",
    csube: "\u2AD1",
    csup: "\u2AD0",
    csupe: "\u2AD2",
    ctdot: "\u22EF",
    cudarrl: "\u2938",
    cudarrr: "\u2935",
    cuepr: "\u22DE",
    cuesc: "\u22DF",
    cularr: "\u21B6",
    cularrp: "\u293D",
    cup: "\u222A",
    cupbrcap: "\u2A48",
    cupcap: "\u2A46",
    cupcup: "\u2A4A",
    cupdot: "\u228D",
    cupor: "\u2A45",
    cups: "\u222A\uFE00",
    curarr: "\u21B7",
    curarrm: "\u293C",
    curlyeqprec: "\u22DE",
    curlyeqsucc: "\u22DF",
    curlyvee: "\u22CE",
    curlywedge: "\u22CF",
    curren: "\xa4",
    curvearrowleft: "\u21B6",
    curvearrowright: "\u21B7",
    cuvee: "\u22CE",
    cuwed: "\u22CF",
    cwconint: "\u2232",
    cwint: "\u2231",
    cylcty: "\u232D",
    dArr: "\u21D3",
    dHar: "\u2965",
    dagger: "\u2020",
    daleth: "\u2138",
    darr: "\u2193",
    dash: "\u2010",
    dashv: "\u22A3",
    dbkarow: "\u290F",
    dblac: "\u02DD",
    dcaron: "\u010F",
    dcy: "\u0434",
    dd: "\u2146",
    ddagger: "\u2021",
    ddarr: "\u21CA",
    ddotseq: "\u2A77",
    deg: "\xb0",
    delta: "\u03B4",
    demptyv: "\u29B1",
    dfisht: "\u297F",
    dfr: "\uD835\uDD21",
    dharl: "\u21C3",
    dharr: "\u21C2",
    diam: "\u22C4",
    diamond: "\u22C4",
    diamondsuit: "\u2666",
    diams: "\u2666",
    die: "\xa8",
    digamma: "\u03DD",
    disin: "\u22F2",
    div: "\xf7",
    divide: "\xf7",
    divideontimes: "\u22C7",
    divonx: "\u22C7",
    djcy: "\u0452",
    dlcorn: "\u231E",
    dlcrop: "\u230D",
    dollar: '$',
    dopf: "\uD835\uDD55",
    dot: "\u02D9",
    doteq: "\u2250",
    doteqdot: "\u2251",
    dotminus: "\u2238",
    dotplus: "\u2214",
    dotsquare: "\u22A1",
    doublebarwedge: "\u2306",
    downarrow: "\u2193",
    downdownarrows: "\u21CA",
    downharpoonleft: "\u21C3",
    downharpoonright: "\u21C2",
    drbkarow: "\u2910",
    drcorn: "\u231F",
    drcrop: "\u230C",
    dscr: "\uD835\uDCB9",
    dscy: "\u0455",
    dsol: "\u29F6",
    dstrok: "\u0111",
    dtdot: "\u22F1",
    dtri: "\u25BF",
    dtrif: "\u25BE",
    duarr: "\u21F5",
    duhar: "\u296F",
    dwangle: "\u29A6",
    dzcy: "\u045F",
    dzigrarr: "\u27FF",
    eDDot: "\u2A77",
    eDot: "\u2251",
    eacute: "\xe9",
    easter: "\u2A6E",
    ecaron: "\u011B",
    ecir: "\u2256",
    ecirc: "\xea",
    ecolon: "\u2255",
    ecy: "\u044D",
    edot: "\u0117",
    ee: "\u2147",
    efDot: "\u2252",
    efr: "\uD835\uDD22",
    eg: "\u2A9A",
    egrave: "\xe8",
    egs: "\u2A96",
    egsdot: "\u2A98",
    el: "\u2A99",
    elinters: "\u23E7",
    ell: "\u2113",
    els: "\u2A95",
    elsdot: "\u2A97",
    emacr: "\u0113",
    empty: "\u2205",
    emptyset: "\u2205",
    emptyv: "\u2205",
    emsp13: "\u2004",
    emsp14: "\u2005",
    emsp: "\u2003",
    eng: "\u014B",
    ensp: "\u2002",
    eogon: "\u0119",
    eopf: "\uD835\uDD56",
    epar: "\u22D5",
    eparsl: "\u29E3",
    eplus: "\u2A71",
    epsi: "\u03B5",
    epsilon: "\u03B5",
    epsiv: "\u03F5",
    eqcirc: "\u2256",
    eqcolon: "\u2255",
    eqsim: "\u2242",
    eqslantgtr: "\u2A96",
    eqslantless: "\u2A95",
    equals: '=',
    equest: "\u225F",
    equiv: "\u2261",
    equivDD: "\u2A78",
    eqvparsl: "\u29E5",
    erDot: "\u2253",
    erarr: "\u2971",
    escr: "\u212F",
    esdot: "\u2250",
    esim: "\u2242",
    eta: "\u03B7",
    eth: "\xf0",
    euml: "\xeb",
    euro: "\u20AC",
    excl: '!',
    exist: "\u2203",
    expectation: "\u2130",
    exponentiale: "\u2147",
    fallingdotseq: "\u2252",
    fcy: "\u0444",
    female: "\u2640",
    ffilig: "\uFB03",
    fflig: "\uFB00",
    ffllig: "\uFB04",
    ffr: "\uD835\uDD23",
    filig: "\uFB01",
    fjlig: 'fj',
    flat: "\u266D",
    fllig: "\uFB02",
    fltns: "\u25B1",
    fnof: "\u0192",
    fopf: "\uD835\uDD57",
    forall: "\u2200",
    fork: "\u22D4",
    forkv: "\u2AD9",
    fpartint: "\u2A0D",
    frac12: "\xbd",
    frac13: "\u2153",
    frac14: "\xbc",
    frac15: "\u2155",
    frac16: "\u2159",
    frac18: "\u215B",
    frac23: "\u2154",
    frac25: "\u2156",
    frac34: "\xbe",
    frac35: "\u2157",
    frac38: "\u215C",
    frac45: "\u2158",
    frac56: "\u215A",
    frac58: "\u215D",
    frac78: "\u215E",
    frasl: "\u2044",
    frown: "\u2322",
    fscr: "\uD835\uDCBB",
    gE: "\u2267",
    gEl: "\u2A8C",
    gacute: "\u01F5",
    gamma: "\u03B3",
    gammad: "\u03DD",
    gap: "\u2A86",
    gbreve: "\u011F",
    gcirc: "\u011D",
    gcy: "\u0433",
    gdot: "\u0121",
    ge: "\u2265",
    gel: "\u22DB",
    geq: "\u2265",
    geqq: "\u2267",
    geqslant: "\u2A7E",
    ges: "\u2A7E",
    gescc: "\u2AA9",
    gesdot: "\u2A80",
    gesdoto: "\u2A82",
    gesdotol: "\u2A84",
    gesl: "\u22DB\uFE00",
    gesles: "\u2A94",
    gfr: "\uD835\uDD24",
    gg: "\u226B",
    ggg: "\u22D9",
    gimel: "\u2137",
    gjcy: "\u0453",
    gl: "\u2277",
    glE: "\u2A92",
    gla: "\u2AA5",
    glj: "\u2AA4",
    gnE: "\u2269",
    gnap: "\u2A8A",
    gnapprox: "\u2A8A",
    gne: "\u2A88",
    gneq: "\u2A88",
    gneqq: "\u2269",
    gnsim: "\u22E7",
    gopf: "\uD835\uDD58",
    grave: '`',
    gscr: "\u210A",
    gsim: "\u2273",
    gsime: "\u2A8E",
    gsiml: "\u2A90",
    gt: '>',
    gtcc: "\u2AA7",
    gtcir: "\u2A7A",
    gtdot: "\u22D7",
    gtlPar: "\u2995",
    gtquest: "\u2A7C",
    gtrapprox: "\u2A86",
    gtrarr: "\u2978",
    gtrdot: "\u22D7",
    gtreqless: "\u22DB",
    gtreqqless: "\u2A8C",
    gtrless: "\u2277",
    gtrsim: "\u2273",
    gvertneqq: "\u2269\uFE00",
    gvnE: "\u2269\uFE00",
    hArr: "\u21D4",
    hairsp: "\u200A",
    half: "\xbd",
    hamilt: "\u210B",
    hardcy: "\u044A",
    harr: "\u2194",
    harrcir: "\u2948",
    harrw: "\u21AD",
    hbar: "\u210F",
    hcirc: "\u0125",
    hearts: "\u2665",
    heartsuit: "\u2665",
    hellip: "\u2026",
    hercon: "\u22B9",
    hfr: "\uD835\uDD25",
    hksearow: "\u2925",
    hkswarow: "\u2926",
    hoarr: "\u21FF",
    homtht: "\u223B",
    hookleftarrow: "\u21A9",
    hookrightarrow: "\u21AA",
    hopf: "\uD835\uDD59",
    horbar: "\u2015",
    hscr: "\uD835\uDCBD",
    hslash: "\u210F",
    hstrok: "\u0127",
    hybull: "\u2043",
    hyphen: "\u2010",
    iacute: "\xed",
    ic: "\u2063",
    icirc: "\xee",
    icy: "\u0438",
    iecy: "\u0435",
    iexcl: "\xa1",
    iff: "\u21D4",
    ifr: "\uD835\uDD26",
    igrave: "\xec",
    ii: "\u2148",
    iiiint: "\u2A0C",
    iiint: "\u222D",
    iinfin: "\u29DC",
    iiota: "\u2129",
    ijlig: "\u0133",
    imacr: "\u012B",
    image: "\u2111",
    imagline: "\u2110",
    imagpart: "\u2111",
    imath: "\u0131",
    imof: "\u22B7",
    imped: "\u01B5",
    in: "\u2208",
    incare: "\u2105",
    infin: "\u221E",
    infintie: "\u29DD",
    inodot: "\u0131",
    int: "\u222B",
    intcal: "\u22BA",
    integers: "\u2124",
    intercal: "\u22BA",
    intlarhk: "\u2A17",
    intprod: "\u2A3C",
    iocy: "\u0451",
    iogon: "\u012F",
    iopf: "\uD835\uDD5A",
    iota: "\u03B9",
    iprod: "\u2A3C",
    iquest: "\xbf",
    iscr: "\uD835\uDCBE",
    isin: "\u2208",
    isinE: "\u22F9",
    isindot: "\u22F5",
    isins: "\u22F4",
    isinsv: "\u22F3",
    isinv: "\u2208",
    it: "\u2062",
    itilde: "\u0129",
    iukcy: "\u0456",
    iuml: "\xef",
    jcirc: "\u0135",
    jcy: "\u0439",
    jfr: "\uD835\uDD27",
    jmath: "\u0237",
    jopf: "\uD835\uDD5B",
    jscr: "\uD835\uDCBF",
    jsercy: "\u0458",
    jukcy: "\u0454",
    kappa: "\u03BA",
    kappav: "\u03F0",
    kcedil: "\u0137",
    kcy: "\u043A",
    kfr: "\uD835\uDD28",
    kgreen: "\u0138",
    khcy: "\u0445",
    kjcy: "\u045C",
    kopf: "\uD835\uDD5C",
    kscr: "\uD835\uDCC0",
    lAarr: "\u21DA",
    lArr: "\u21D0",
    lAtail: "\u291B",
    lBarr: "\u290E",
    lE: "\u2266",
    lEg: "\u2A8B",
    lHar: "\u2962",
    lacute: "\u013A",
    laemptyv: "\u29B4",
    lagran: "\u2112",
    lambda: "\u03BB",
    lang: "\u27E8",
    langd: "\u2991",
    langle: "\u27E8",
    lap: "\u2A85",
    laquo: "\xab",
    larr: "\u2190",
    larrb: "\u21E4",
    larrbfs: "\u291F",
    larrfs: "\u291D",
    larrhk: "\u21A9",
    larrlp: "\u21AB",
    larrpl: "\u2939",
    larrsim: "\u2973",
    larrtl: "\u21A2",
    lat: "\u2AAB",
    latail: "\u2919",
    late: "\u2AAD",
    lates: "\u2AAD\uFE00",
    lbarr: "\u290C",
    lbbrk: "\u2772",
    lbrace: '{',
    lbrack: '[',
    lbrke: "\u298B",
    lbrksld: "\u298F",
    lbrkslu: "\u298D",
    lcaron: "\u013E",
    lcedil: "\u013C",
    lceil: "\u2308",
    lcub: '{',
    lcy: "\u043B",
    ldca: "\u2936",
    ldquo: "\u201C",
    ldquor: "\u201E",
    ldrdhar: "\u2967",
    ldrushar: "\u294B",
    ldsh: "\u21B2",
    le: "\u2264",
    leftarrow: "\u2190",
    leftarrowtail: "\u21A2",
    leftharpoondown: "\u21BD",
    leftharpoonup: "\u21BC",
    leftleftarrows: "\u21C7",
    leftrightarrow: "\u2194",
    leftrightarrows: "\u21C6",
    leftrightharpoons: "\u21CB",
    leftrightsquigarrow: "\u21AD",
    leftthreetimes: "\u22CB",
    leg: "\u22DA",
    leq: "\u2264",
    leqq: "\u2266",
    leqslant: "\u2A7D",
    les: "\u2A7D",
    lescc: "\u2AA8",
    lesdot: "\u2A7F",
    lesdoto: "\u2A81",
    lesdotor: "\u2A83",
    lesg: "\u22DA\uFE00",
    lesges: "\u2A93",
    lessapprox: "\u2A85",
    lessdot: "\u22D6",
    lesseqgtr: "\u22DA",
    lesseqqgtr: "\u2A8B",
    lessgtr: "\u2276",
    lesssim: "\u2272",
    lfisht: "\u297C",
    lfloor: "\u230A",
    lfr: "\uD835\uDD29",
    lg: "\u2276",
    lgE: "\u2A91",
    lhard: "\u21BD",
    lharu: "\u21BC",
    lharul: "\u296A",
    lhblk: "\u2584",
    ljcy: "\u0459",
    ll: "\u226A",
    llarr: "\u21C7",
    llcorner: "\u231E",
    llhard: "\u296B",
    lltri: "\u25FA",
    lmidot: "\u0140",
    lmoust: "\u23B0",
    lmoustache: "\u23B0",
    lnE: "\u2268",
    lnap: "\u2A89",
    lnapprox: "\u2A89",
    lne: "\u2A87",
    lneq: "\u2A87",
    lneqq: "\u2268",
    lnsim: "\u22E6",
    loang: "\u27EC",
    loarr: "\u21FD",
    lobrk: "\u27E6",
    longleftarrow: "\u27F5",
    longleftrightarrow: "\u27F7",
    longmapsto: "\u27FC",
    longrightarrow: "\u27F6",
    looparrowleft: "\u21AB",
    looparrowright: "\u21AC",
    lopar: "\u2985",
    lopf: "\uD835\uDD5D",
    loplus: "\u2A2D",
    lotimes: "\u2A34",
    lowast: "\u2217",
    lowbar: '_',
    loz: "\u25CA",
    lozenge: "\u25CA",
    lozf: "\u29EB",
    lpar: '(',
    lparlt: "\u2993",
    lrarr: "\u21C6",
    lrcorner: "\u231F",
    lrhar: "\u21CB",
    lrhard: "\u296D",
    lrm: "\u200E",
    lrtri: "\u22BF",
    lsaquo: "\u2039",
    lscr: "\uD835\uDCC1",
    lsh: "\u21B0",
    lsim: "\u2272",
    lsime: "\u2A8D",
    lsimg: "\u2A8F",
    lsqb: '[',
    lsquo: "\u2018",
    lsquor: "\u201A",
    lstrok: "\u0142",
    lt: '<',
    ltcc: "\u2AA6",
    ltcir: "\u2A79",
    ltdot: "\u22D6",
    lthree: "\u22CB",
    ltimes: "\u22C9",
    ltlarr: "\u2976",
    ltquest: "\u2A7B",
    ltrPar: "\u2996",
    ltri: "\u25C3",
    ltrie: "\u22B4",
    ltrif: "\u25C2",
    lurdshar: "\u294A",
    luruhar: "\u2966",
    lvertneqq: "\u2268\uFE00",
    lvnE: "\u2268\uFE00",
    mDDot: "\u223A",
    macr: "\xaf",
    male: "\u2642",
    malt: "\u2720",
    maltese: "\u2720",
    map: "\u21A6",
    mapsto: "\u21A6",
    mapstodown: "\u21A7",
    mapstoleft: "\u21A4",
    mapstoup: "\u21A5",
    marker: "\u25AE",
    mcomma: "\u2A29",
    mcy: "\u043C",
    mdash: "\u2014",
    measuredangle: "\u2221",
    mfr: "\uD835\uDD2A",
    mho: "\u2127",
    micro: "\xb5",
    mid: "\u2223",
    midast: '*',
    midcir: "\u2AF0",
    middot: "\xb7",
    minus: "\u2212",
    minusb: "\u229F",
    minusd: "\u2238",
    minusdu: "\u2A2A",
    mlcp: "\u2ADB",
    mldr: "\u2026",
    mnplus: "\u2213",
    models: "\u22A7",
    mopf: "\uD835\uDD5E",
    mp: "\u2213",
    mscr: "\uD835\uDCC2",
    mstpos: "\u223E",
    mu: "\u03BC",
    multimap: "\u22B8",
    mumap: "\u22B8",
    nGg: "\u22D9\u0338",
    nGt: "\u226B\u20D2",
    nGtv: "\u226B\u0338",
    nLeftarrow: "\u21CD",
    nLeftrightarrow: "\u21CE",
    nLl: "\u22D8\u0338",
    nLt: "\u226A\u20D2",
    nLtv: "\u226A\u0338",
    nRightarrow: "\u21CF",
    nVDash: "\u22AF",
    nVdash: "\u22AE",
    nabla: "\u2207",
    nacute: "\u0144",
    nang: "\u2220\u20D2",
    nap: "\u2249",
    napE: "\u2A70\u0338",
    napid: "\u224B\u0338",
    napos: "\u0149",
    napprox: "\u2249",
    natur: "\u266E",
    natural: "\u266E",
    naturals: "\u2115",
    nbsp: "\xa0",
    nbump: "\u224E\u0338",
    nbumpe: "\u224F\u0338",
    ncap: "\u2A43",
    ncaron: "\u0148",
    ncedil: "\u0146",
    ncong: "\u2247",
    ncongdot: "\u2A6D\u0338",
    ncup: "\u2A42",
    ncy: "\u043D",
    ndash: "\u2013",
    ne: "\u2260",
    neArr: "\u21D7",
    nearhk: "\u2924",
    nearr: "\u2197",
    nearrow: "\u2197",
    nedot: "\u2250\u0338",
    nequiv: "\u2262",
    nesear: "\u2928",
    nesim: "\u2242\u0338",
    nexist: "\u2204",
    nexists: "\u2204",
    nfr: "\uD835\uDD2B",
    ngE: "\u2267\u0338",
    nge: "\u2271",
    ngeq: "\u2271",
    ngeqq: "\u2267\u0338",
    ngeqslant: "\u2A7E\u0338",
    nges: "\u2A7E\u0338",
    ngsim: "\u2275",
    ngt: "\u226F",
    ngtr: "\u226F",
    nhArr: "\u21CE",
    nharr: "\u21AE",
    nhpar: "\u2AF2",
    ni: "\u220B",
    nis: "\u22FC",
    nisd: "\u22FA",
    niv: "\u220B",
    njcy: "\u045A",
    nlArr: "\u21CD",
    nlE: "\u2266\u0338",
    nlarr: "\u219A",
    nldr: "\u2025",
    nle: "\u2270",
    nleftarrow: "\u219A",
    nleftrightarrow: "\u21AE",
    nleq: "\u2270",
    nleqq: "\u2266\u0338",
    nleqslant: "\u2A7D\u0338",
    nles: "\u2A7D\u0338",
    nless: "\u226E",
    nlsim: "\u2274",
    nlt: "\u226E",
    nltri: "\u22EA",
    nltrie: "\u22EC",
    nmid: "\u2224",
    nopf: "\uD835\uDD5F",
    not: "\xac",
    notin: "\u2209",
    notinE: "\u22F9\u0338",
    notindot: "\u22F5\u0338",
    notinva: "\u2209",
    notinvb: "\u22F7",
    notinvc: "\u22F6",
    notni: "\u220C",
    notniva: "\u220C",
    notnivb: "\u22FE",
    notnivc: "\u22FD",
    npar: "\u2226",
    nparallel: "\u2226",
    nparsl: "\u2AFD\u20E5",
    npart: "\u2202\u0338",
    npolint: "\u2A14",
    npr: "\u2280",
    nprcue: "\u22E0",
    npre: "\u2AAF\u0338",
    nprec: "\u2280",
    npreceq: "\u2AAF\u0338",
    nrArr: "\u21CF",
    nrarr: "\u219B",
    nrarrc: "\u2933\u0338",
    nrarrw: "\u219D\u0338",
    nrightarrow: "\u219B",
    nrtri: "\u22EB",
    nrtrie: "\u22ED",
    nsc: "\u2281",
    nsccue: "\u22E1",
    nsce: "\u2AB0\u0338",
    nscr: "\uD835\uDCC3",
    nshortmid: "\u2224",
    nshortparallel: "\u2226",
    nsim: "\u2241",
    nsime: "\u2244",
    nsimeq: "\u2244",
    nsmid: "\u2224",
    nspar: "\u2226",
    nsqsube: "\u22E2",
    nsqsupe: "\u22E3",
    nsub: "\u2284",
    nsubE: "\u2AC5\u0338",
    nsube: "\u2288",
    nsubset: "\u2282\u20D2",
    nsubseteq: "\u2288",
    nsubseteqq: "\u2AC5\u0338",
    nsucc: "\u2281",
    nsucceq: "\u2AB0\u0338",
    nsup: "\u2285",
    nsupE: "\u2AC6\u0338",
    nsupe: "\u2289",
    nsupset: "\u2283\u20D2",
    nsupseteq: "\u2289",
    nsupseteqq: "\u2AC6\u0338",
    ntgl: "\u2279",
    ntilde: "\xf1",
    ntlg: "\u2278",
    ntriangleleft: "\u22EA",
    ntrianglelefteq: "\u22EC",
    ntriangleright: "\u22EB",
    ntrianglerighteq: "\u22ED",
    nu: "\u03BD",
    num: '#',
    numero: "\u2116",
    numsp: "\u2007",
    nvDash: "\u22AD",
    nvHarr: "\u2904",
    nvap: "\u224D\u20D2",
    nvdash: "\u22AC",
    nvge: "\u2265\u20D2",
    nvgt: ">\u20D2",
    nvinfin: "\u29DE",
    nvlArr: "\u2902",
    nvle: "\u2264\u20D2",
    nvlt: "<\u20D2",
    nvltrie: "\u22B4\u20D2",
    nvrArr: "\u2903",
    nvrtrie: "\u22B5\u20D2",
    nvsim: "\u223C\u20D2",
    nwArr: "\u21D6",
    nwarhk: "\u2923",
    nwarr: "\u2196",
    nwarrow: "\u2196",
    nwnear: "\u2927",
    oS: "\u24C8",
    oacute: "\xf3",
    oast: "\u229B",
    ocir: "\u229A",
    ocirc: "\xf4",
    ocy: "\u043E",
    odash: "\u229D",
    odblac: "\u0151",
    odiv: "\u2A38",
    odot: "\u2299",
    odsold: "\u29BC",
    oelig: "\u0153",
    ofcir: "\u29BF",
    ofr: "\uD835\uDD2C",
    ogon: "\u02DB",
    ograve: "\xf2",
    ogt: "\u29C1",
    ohbar: "\u29B5",
    ohm: "\u03A9",
    oint: "\u222E",
    olarr: "\u21BA",
    olcir: "\u29BE",
    olcross: "\u29BB",
    oline: "\u203E",
    olt: "\u29C0",
    omacr: "\u014D",
    omega: "\u03C9",
    omicron: "\u03BF",
    omid: "\u29B6",
    ominus: "\u2296",
    oopf: "\uD835\uDD60",
    opar: "\u29B7",
    operp: "\u29B9",
    oplus: "\u2295",
    or: "\u2228",
    orarr: "\u21BB",
    ord: "\u2A5D",
    order: "\u2134",
    orderof: "\u2134",
    ordf: "\xaa",
    ordm: "\xba",
    origof: "\u22B6",
    oror: "\u2A56",
    orslope: "\u2A57",
    orv: "\u2A5B",
    oscr: "\u2134",
    oslash: "\xf8",
    osol: "\u2298",
    otilde: "\xf5",
    otimes: "\u2297",
    otimesas: "\u2A36",
    ouml: "\xf6",
    ovbar: "\u233D",
    par: "\u2225",
    para: "\xb6",
    parallel: "\u2225",
    parsim: "\u2AF3",
    parsl: "\u2AFD",
    part: "\u2202",
    pcy: "\u043F",
    percnt: '%',
    period: '.',
    permil: "\u2030",
    perp: "\u22A5",
    pertenk: "\u2031",
    pfr: "\uD835\uDD2D",
    phi: "\u03C6",
    phiv: "\u03D5",
    phmmat: "\u2133",
    phone: "\u260E",
    pi: "\u03C0",
    pitchfork: "\u22D4",
    piv: "\u03D6",
    planck: "\u210F",
    planckh: "\u210E",
    plankv: "\u210F",
    plus: '+',
    plusacir: "\u2A23",
    plusb: "\u229E",
    pluscir: "\u2A22",
    plusdo: "\u2214",
    plusdu: "\u2A25",
    pluse: "\u2A72",
    plusmn: "\xb1",
    plussim: "\u2A26",
    plustwo: "\u2A27",
    pm: "\xb1",
    pointint: "\u2A15",
    popf: "\uD835\uDD61",
    pound: "\xa3",
    pr: "\u227A",
    prE: "\u2AB3",
    prap: "\u2AB7",
    prcue: "\u227C",
    pre: "\u2AAF",
    prec: "\u227A",
    precapprox: "\u2AB7",
    preccurlyeq: "\u227C",
    preceq: "\u2AAF",
    precnapprox: "\u2AB9",
    precneqq: "\u2AB5",
    precnsim: "\u22E8",
    precsim: "\u227E",
    prime: "\u2032",
    primes: "\u2119",
    prnE: "\u2AB5",
    prnap: "\u2AB9",
    prnsim: "\u22E8",
    prod: "\u220F",
    profalar: "\u232E",
    profline: "\u2312",
    profsurf: "\u2313",
    prop: "\u221D",
    propto: "\u221D",
    prsim: "\u227E",
    prurel: "\u22B0",
    pscr: "\uD835\uDCC5",
    psi: "\u03C8",
    puncsp: "\u2008",
    qfr: "\uD835\uDD2E",
    qint: "\u2A0C",
    qopf: "\uD835\uDD62",
    qprime: "\u2057",
    qscr: "\uD835\uDCC6",
    quaternions: "\u210D",
    quatint: "\u2A16",
    quest: '?',
    questeq: "\u225F",
    quot: '"',
    rAarr: "\u21DB",
    rArr: "\u21D2",
    rAtail: "\u291C",
    rBarr: "\u290F",
    rHar: "\u2964",
    race: "\u223D\u0331",
    racute: "\u0155",
    radic: "\u221A",
    raemptyv: "\u29B3",
    rang: "\u27E9",
    rangd: "\u2992",
    range: "\u29A5",
    rangle: "\u27E9",
    raquo: "\xbb",
    rarr: "\u2192",
    rarrap: "\u2975",
    rarrb: "\u21E5",
    rarrbfs: "\u2920",
    rarrc: "\u2933",
    rarrfs: "\u291E",
    rarrhk: "\u21AA",
    rarrlp: "\u21AC",
    rarrpl: "\u2945",
    rarrsim: "\u2974",
    rarrtl: "\u21A3",
    rarrw: "\u219D",
    ratail: "\u291A",
    ratio: "\u2236",
    rationals: "\u211A",
    rbarr: "\u290D",
    rbbrk: "\u2773",
    rbrace: '}',
    rbrack: ']',
    rbrke: "\u298C",
    rbrksld: "\u298E",
    rbrkslu: "\u2990",
    rcaron: "\u0159",
    rcedil: "\u0157",
    rceil: "\u2309",
    rcub: '}',
    rcy: "\u0440",
    rdca: "\u2937",
    rdldhar: "\u2969",
    rdquo: "\u201D",
    rdquor: "\u201D",
    rdsh: "\u21B3",
    real: "\u211C",
    realine: "\u211B",
    realpart: "\u211C",
    reals: "\u211D",
    rect: "\u25AD",
    reg: "\xae",
    rfisht: "\u297D",
    rfloor: "\u230B",
    rfr: "\uD835\uDD2F",
    rhard: "\u21C1",
    rharu: "\u21C0",
    rharul: "\u296C",
    rho: "\u03C1",
    rhov: "\u03F1",
    rightarrow: "\u2192",
    rightarrowtail: "\u21A3",
    rightharpoondown: "\u21C1",
    rightharpoonup: "\u21C0",
    rightleftarrows: "\u21C4",
    rightleftharpoons: "\u21CC",
    rightrightarrows: "\u21C9",
    rightsquigarrow: "\u219D",
    rightthreetimes: "\u22CC",
    ring: "\u02DA",
    risingdotseq: "\u2253",
    rlarr: "\u21C4",
    rlhar: "\u21CC",
    rlm: "\u200F",
    rmoust: "\u23B1",
    rmoustache: "\u23B1",
    rnmid: "\u2AEE",
    roang: "\u27ED",
    roarr: "\u21FE",
    robrk: "\u27E7",
    ropar: "\u2986",
    ropf: "\uD835\uDD63",
    roplus: "\u2A2E",
    rotimes: "\u2A35",
    rpar: ')',
    rpargt: "\u2994",
    rppolint: "\u2A12",
    rrarr: "\u21C9",
    rsaquo: "\u203A",
    rscr: "\uD835\uDCC7",
    rsh: "\u21B1",
    rsqb: ']',
    rsquo: "\u2019",
    rsquor: "\u2019",
    rthree: "\u22CC",
    rtimes: "\u22CA",
    rtri: "\u25B9",
    rtrie: "\u22B5",
    rtrif: "\u25B8",
    rtriltri: "\u29CE",
    ruluhar: "\u2968",
    rx: "\u211E",
    sacute: "\u015B",
    sbquo: "\u201A",
    sc: "\u227B",
    scE: "\u2AB4",
    scap: "\u2AB8",
    scaron: "\u0161",
    sccue: "\u227D",
    sce: "\u2AB0",
    scedil: "\u015F",
    scirc: "\u015D",
    scnE: "\u2AB6",
    scnap: "\u2ABA",
    scnsim: "\u22E9",
    scpolint: "\u2A13",
    scsim: "\u227F",
    scy: "\u0441",
    sdot: "\u22C5",
    sdotb: "\u22A1",
    sdote: "\u2A66",
    seArr: "\u21D8",
    searhk: "\u2925",
    searr: "\u2198",
    searrow: "\u2198",
    sect: "\xa7",
    semi: ';',
    seswar: "\u2929",
    setminus: "\u2216",
    setmn: "\u2216",
    sext: "\u2736",
    sfr: "\uD835\uDD30",
    sfrown: "\u2322",
    sharp: "\u266F",
    shchcy: "\u0449",
    shcy: "\u0448",
    shortmid: "\u2223",
    shortparallel: "\u2225",
    shy: "\xad",
    sigma: "\u03C3",
    sigmaf: "\u03C2",
    sigmav: "\u03C2",
    sim: "\u223C",
    simdot: "\u2A6A",
    sime: "\u2243",
    simeq: "\u2243",
    simg: "\u2A9E",
    simgE: "\u2AA0",
    siml: "\u2A9D",
    simlE: "\u2A9F",
    simne: "\u2246",
    simplus: "\u2A24",
    simrarr: "\u2972",
    slarr: "\u2190",
    smallsetminus: "\u2216",
    smashp: "\u2A33",
    smeparsl: "\u29E4",
    smid: "\u2223",
    smile: "\u2323",
    smt: "\u2AAA",
    smte: "\u2AAC",
    smtes: "\u2AAC\uFE00",
    softcy: "\u044C",
    sol: '/',
    solb: "\u29C4",
    solbar: "\u233F",
    sopf: "\uD835\uDD64",
    spades: "\u2660",
    spadesuit: "\u2660",
    spar: "\u2225",
    sqcap: "\u2293",
    sqcaps: "\u2293\uFE00",
    sqcup: "\u2294",
    sqcups: "\u2294\uFE00",
    sqsub: "\u228F",
    sqsube: "\u2291",
    sqsubset: "\u228F",
    sqsubseteq: "\u2291",
    sqsup: "\u2290",
    sqsupe: "\u2292",
    sqsupset: "\u2290",
    sqsupseteq: "\u2292",
    squ: "\u25A1",
    square: "\u25A1",
    squarf: "\u25AA",
    squf: "\u25AA",
    srarr: "\u2192",
    sscr: "\uD835\uDCC8",
    ssetmn: "\u2216",
    ssmile: "\u2323",
    sstarf: "\u22C6",
    star: "\u2606",
    starf: "\u2605",
    straightepsilon: "\u03F5",
    straightphi: "\u03D5",
    strns: "\xaf",
    sub: "\u2282",
    subE: "\u2AC5",
    subdot: "\u2ABD",
    sube: "\u2286",
    subedot: "\u2AC3",
    submult: "\u2AC1",
    subnE: "\u2ACB",
    subne: "\u228A",
    subplus: "\u2ABF",
    subrarr: "\u2979",
    subset: "\u2282",
    subseteq: "\u2286",
    subseteqq: "\u2AC5",
    subsetneq: "\u228A",
    subsetneqq: "\u2ACB",
    subsim: "\u2AC7",
    subsub: "\u2AD5",
    subsup: "\u2AD3",
    succ: "\u227B",
    succapprox: "\u2AB8",
    succcurlyeq: "\u227D",
    succeq: "\u2AB0",
    succnapprox: "\u2ABA",
    succneqq: "\u2AB6",
    succnsim: "\u22E9",
    succsim: "\u227F",
    sum: "\u2211",
    sung: "\u266A",
    sup1: "\xb9",
    sup2: "\xb2",
    sup3: "\xb3",
    sup: "\u2283",
    supE: "\u2AC6",
    supdot: "\u2ABE",
    supdsub: "\u2AD8",
    supe: "\u2287",
    supedot: "\u2AC4",
    suphsol: "\u27C9",
    suphsub: "\u2AD7",
    suplarr: "\u297B",
    supmult: "\u2AC2",
    supnE: "\u2ACC",
    supne: "\u228B",
    supplus: "\u2AC0",
    supset: "\u2283",
    supseteq: "\u2287",
    supseteqq: "\u2AC6",
    supsetneq: "\u228B",
    supsetneqq: "\u2ACC",
    supsim: "\u2AC8",
    supsub: "\u2AD4",
    supsup: "\u2AD6",
    swArr: "\u21D9",
    swarhk: "\u2926",
    swarr: "\u2199",
    swarrow: "\u2199",
    swnwar: "\u292A",
    szlig: "\xdf",
    target: "\u2316",
    tau: "\u03C4",
    tbrk: "\u23B4",
    tcaron: "\u0165",
    tcedil: "\u0163",
    tcy: "\u0442",
    tdot: "\u20DB",
    telrec: "\u2315",
    tfr: "\uD835\uDD31",
    there4: "\u2234",
    therefore: "\u2234",
    theta: "\u03B8",
    thetasym: "\u03D1",
    thetav: "\u03D1",
    thickapprox: "\u2248",
    thicksim: "\u223C",
    thinsp: "\u2009",
    thkap: "\u2248",
    thksim: "\u223C",
    thorn: "\xfe",
    tilde: "\u02DC",
    times: "\xd7",
    timesb: "\u22A0",
    timesbar: "\u2A31",
    timesd: "\u2A30",
    tint: "\u222D",
    toea: "\u2928",
    top: "\u22A4",
    topbot: "\u2336",
    topcir: "\u2AF1",
    topf: "\uD835\uDD65",
    topfork: "\u2ADA",
    tosa: "\u2929",
    tprime: "\u2034",
    trade: "\u2122",
    triangle: "\u25B5",
    triangledown: "\u25BF",
    triangleleft: "\u25C3",
    trianglelefteq: "\u22B4",
    triangleq: "\u225C",
    triangleright: "\u25B9",
    trianglerighteq: "\u22B5",
    tridot: "\u25EC",
    trie: "\u225C",
    triminus: "\u2A3A",
    triplus: "\u2A39",
    trisb: "\u29CD",
    tritime: "\u2A3B",
    trpezium: "\u23E2",
    tscr: "\uD835\uDCC9",
    tscy: "\u0446",
    tshcy: "\u045B",
    tstrok: "\u0167",
    twixt: "\u226C",
    twoheadleftarrow: "\u219E",
    twoheadrightarrow: "\u21A0",
    uArr: "\u21D1",
    uHar: "\u2963",
    uacute: "\xfa",
    uarr: "\u2191",
    ubrcy: "\u045E",
    ubreve: "\u016D",
    ucirc: "\xfb",
    ucy: "\u0443",
    udarr: "\u21C5",
    udblac: "\u0171",
    udhar: "\u296E",
    ufisht: "\u297E",
    ufr: "\uD835\uDD32",
    ugrave: "\xf9",
    uharl: "\u21BF",
    uharr: "\u21BE",
    uhblk: "\u2580",
    ulcorn: "\u231C",
    ulcorner: "\u231C",
    ulcrop: "\u230F",
    ultri: "\u25F8",
    umacr: "\u016B",
    uml: "\xa8",
    uogon: "\u0173",
    uopf: "\uD835\uDD66",
    uparrow: "\u2191",
    updownarrow: "\u2195",
    upharpoonleft: "\u21BF",
    upharpoonright: "\u21BE",
    uplus: "\u228E",
    upsi: "\u03C5",
    upsih: "\u03D2",
    upsilon: "\u03C5",
    upuparrows: "\u21C8",
    urcorn: "\u231D",
    urcorner: "\u231D",
    urcrop: "\u230E",
    uring: "\u016F",
    urtri: "\u25F9",
    uscr: "\uD835\uDCCA",
    utdot: "\u22F0",
    utilde: "\u0169",
    utri: "\u25B5",
    utrif: "\u25B4",
    uuarr: "\u21C8",
    uuml: "\xfc",
    uwangle: "\u29A7",
    vArr: "\u21D5",
    vBar: "\u2AE8",
    vBarv: "\u2AE9",
    vDash: "\u22A8",
    vangrt: "\u299C",
    varepsilon: "\u03F5",
    varkappa: "\u03F0",
    varnothing: "\u2205",
    varphi: "\u03D5",
    varpi: "\u03D6",
    varpropto: "\u221D",
    varr: "\u2195",
    varrho: "\u03F1",
    varsigma: "\u03C2",
    varsubsetneq: "\u228A\uFE00",
    varsubsetneqq: "\u2ACB\uFE00",
    varsupsetneq: "\u228B\uFE00",
    varsupsetneqq: "\u2ACC\uFE00",
    vartheta: "\u03D1",
    vartriangleleft: "\u22B2",
    vartriangleright: "\u22B3",
    vcy: "\u0432",
    vdash: "\u22A2",
    vee: "\u2228",
    veebar: "\u22BB",
    veeeq: "\u225A",
    vellip: "\u22EE",
    verbar: '|',
    vert: '|',
    vfr: "\uD835\uDD33",
    vltri: "\u22B2",
    vnsub: "\u2282\u20D2",
    vnsup: "\u2283\u20D2",
    vopf: "\uD835\uDD67",
    vprop: "\u221D",
    vrtri: "\u22B3",
    vscr: "\uD835\uDCCB",
    vsubnE: "\u2ACB\uFE00",
    vsubne: "\u228A\uFE00",
    vsupnE: "\u2ACC\uFE00",
    vsupne: "\u228B\uFE00",
    vzigzag: "\u299A",
    wcirc: "\u0175",
    wedbar: "\u2A5F",
    wedge: "\u2227",
    wedgeq: "\u2259",
    weierp: "\u2118",
    wfr: "\uD835\uDD34",
    wopf: "\uD835\uDD68",
    wp: "\u2118",
    wr: "\u2240",
    wreath: "\u2240",
    wscr: "\uD835\uDCCC",
    xcap: "\u22C2",
    xcirc: "\u25EF",
    xcup: "\u22C3",
    xdtri: "\u25BD",
    xfr: "\uD835\uDD35",
    xhArr: "\u27FA",
    xharr: "\u27F7",
    xi: "\u03BE",
    xlArr: "\u27F8",
    xlarr: "\u27F5",
    xmap: "\u27FC",
    xnis: "\u22FB",
    xodot: "\u2A00",
    xopf: "\uD835\uDD69",
    xoplus: "\u2A01",
    xotime: "\u2A02",
    xrArr: "\u27F9",
    xrarr: "\u27F6",
    xscr: "\uD835\uDCCD",
    xsqcup: "\u2A06",
    xuplus: "\u2A04",
    xutri: "\u25B3",
    xvee: "\u22C1",
    xwedge: "\u22C0",
    yacute: "\xfd",
    yacy: "\u044F",
    ycirc: "\u0177",
    ycy: "\u044B",
    yen: "\xa5",
    yfr: "\uD835\uDD36",
    yicy: "\u0457",
    yopf: "\uD835\uDD6A",
    yscr: "\uD835\uDCCE",
    yucy: "\u044E",
    yuml: "\xff",
    zacute: "\u017A",
    zcaron: "\u017E",
    zcy: "\u0437",
    zdot: "\u017C",
    zeetrf: "\u2128",
    zeta: "\u03B6",
    zfr: "\uD835\uDD37",
    zhcy: "\u0436",
    zigrarr: "\u21DD",
    zopf: "\uD835\uDD6B",
    zscr: "\uD835\uDCCF",
    zwj: "\u200D",
    zwnj: "\u200C"
};


// To do: next major: use `Object.hasOwn`.
const $63b35e5117053cb4$var$own = {}.hasOwnProperty;
function $63b35e5117053cb4$export$289b6a6320f709b4(value) {
    return $63b35e5117053cb4$var$own.call((0, $7956d80b12e9dacc$export$ec810d1aafce79a7), value) ? (0, $7956d80b12e9dacc$export$ec810d1aafce79a7)[value] : false;
}



const $e67aea4f6e667164$export$e31905600aaf3d8e = {
    name: 'characterReference',
    tokenize: $e67aea4f6e667164$var$tokenizeCharacterReference
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $e67aea4f6e667164$var$tokenizeCharacterReference(effects, ok, nok) {
    const self = this;
    let size = 0;
    /** @type {number} */ let max;
    /** @type {(code: Code) => boolean} */ let test;
    return start;
    /**
   * Start of character reference.
   *
   * ```markdown
   * > | a&amp;b
   *      ^
   * > | a&#123;b
   *      ^
   * > | a&#x9;b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('characterReference');
        effects.enter('characterReferenceMarker');
        effects.consume(code);
        effects.exit('characterReferenceMarker');
        return open;
    }
    /**
   * After `&`, at `#` for numeric references or alphanumeric for named
   * references.
   *
   * ```markdown
   * > | a&amp;b
   *       ^
   * > | a&#123;b
   *       ^
   * > | a&#x9;b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 35) {
            effects.enter('characterReferenceMarkerNumeric');
            effects.consume(code);
            effects.exit('characterReferenceMarkerNumeric');
            return numeric;
        }
        effects.enter('characterReferenceValue');
        max = 31;
        test = (0, $a967d3607431391e$export$75c76db11865a9f4);
        return value(code);
    }
    /**
   * After `#`, at `x` for hexadecimals or digit for decimals.
   *
   * ```markdown
   * > | a&#123;b
   *        ^
   * > | a&#x9;b
   *        ^
   * ```
   *
   * @type {State}
   */ function numeric(code) {
        if (code === 88 || code === 120) {
            effects.enter('characterReferenceMarkerHexadecimal');
            effects.consume(code);
            effects.exit('characterReferenceMarkerHexadecimal');
            effects.enter('characterReferenceValue');
            max = 6;
            test = (0, $a967d3607431391e$export$eca2752363989806);
            return value;
        }
        effects.enter('characterReferenceValue');
        max = 7;
        test = (0, $a967d3607431391e$export$ca8b5b1a6c320e6e);
        return value(code);
    }
    /**
   * After markers (`&#x`, `&#`, or `&`), in value, before `;`.
   *
   * The character reference kind defines what and how many characters are
   * allowed.
   *
   * ```markdown
   * > | a&amp;b
   *       ^^^
   * > | a&#123;b
   *        ^^^
   * > | a&#x9;b
   *         ^
   * ```
   *
   * @type {State}
   */ function value(code) {
        if (code === 59 && size) {
            const token = effects.exit('characterReferenceValue');
            if (test === (0, $a967d3607431391e$export$75c76db11865a9f4) && !(0, $63b35e5117053cb4$export$289b6a6320f709b4)(self.sliceSerialize(token))) return nok(code);
            // To do: `markdown-rs` uses a different name:
            // `CharacterReferenceMarkerSemi`.
            effects.enter('characterReferenceMarker');
            effects.consume(code);
            effects.exit('characterReferenceMarker');
            effects.exit('characterReference');
            return ok;
        }
        if (test(code) && size++ < max) {
            effects.consume(code);
            return value;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

/** @type {Construct} */ const $a4ad67fa4c34f4a0$var$nonLazyContinuation = {
    tokenize: $a4ad67fa4c34f4a0$var$tokenizeNonLazyContinuation,
    partial: true
};
const $a4ad67fa4c34f4a0$export$c23e4921f8d87e7c = {
    name: 'codeFenced',
    tokenize: $a4ad67fa4c34f4a0$var$tokenizeCodeFenced,
    concrete: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $a4ad67fa4c34f4a0$var$tokenizeCodeFenced(effects, ok, nok) {
    const self = this;
    /** @type {Construct} */ const closeStart = {
        tokenize: tokenizeCloseStart,
        partial: true
    };
    let initialPrefix = 0;
    let sizeOpen = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of code.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse whitespace like `markdown-rs`.
        return beforeSequenceOpen(code);
    }
    /**
   * In opening fence, after prefix, at sequence.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeSequenceOpen(code) {
        const tail = self.events[self.events.length - 1];
        initialPrefix = tail && tail[1].type === 'linePrefix' ? tail[2].sliceSerialize(tail[1], true).length : 0;
        marker = code;
        effects.enter('codeFenced');
        effects.enter('codeFencedFence');
        effects.enter('codeFencedFenceSequence');
        return sequenceOpen(code);
    }
    /**
   * In opening fence sequence.
   *
   * ```markdown
   * > | ~~~js
   *      ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === marker) {
            sizeOpen++;
            effects.consume(code);
            return sequenceOpen;
        }
        if (sizeOpen < 3) return nok(code);
        effects.exit('codeFencedFenceSequence');
        return (0, $a967d3607431391e$export$2c6cf65c1127992a)(code) ? (0, $602eae48ac3dea9e$export$ae105c1eb063a0a2)(effects, infoBefore, 'whitespace')(code) : infoBefore(code);
    }
    /**
   * In opening fence, after the sequence (and optional whitespace), before info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function infoBefore(code) {
        if (code === null || (0, $a967d3607431391e$export$34a1dff1c0936953)(code)) {
            effects.exit('codeFencedFence');
            return self.interrupt ? ok(code) : effects.check($a4ad67fa4c34f4a0$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        }
        effects.enter('codeFencedFenceInfo');
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return info(code);
    }
    /**
   * In info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function info(code) {
        if (code === null || (0, $a967d3607431391e$export$34a1dff1c0936953)(code)) {
            effects.exit('chunkString');
            effects.exit('codeFencedFenceInfo');
            return infoBefore(code);
        }
        if ((0, $a967d3607431391e$export$2c6cf65c1127992a)(code)) {
            effects.exit('chunkString');
            effects.exit('codeFencedFenceInfo');
            return (0, $602eae48ac3dea9e$export$ae105c1eb063a0a2)(effects, metaBefore, 'whitespace')(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return info;
    }
    /**
   * In opening fence, after info and whitespace, before meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function metaBefore(code) {
        if (code === null || (0, $a967d3607431391e$export$34a1dff1c0936953)(code)) return infoBefore(code);
        effects.enter('codeFencedFenceMeta');
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return meta(code);
    }
    /**
   * In meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function meta(code) {
        if (code === null || (0, $a967d3607431391e$export$34a1dff1c0936953)(code)) {
            effects.exit('chunkString');
            effects.exit('codeFencedFenceMeta');
            return infoBefore(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return meta;
    }
    /**
   * At eol/eof in code, before a non-lazy closing fence or content.
   *
   * ```markdown
   * > | ~~~js
   *          ^
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function atNonLazyBreak(code) {
        return effects.attempt(closeStart, after, contentBefore)(code);
    }
    /**
   * Before code content, not a closing fence, at eol.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentBefore(code) {
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return contentStart;
    }
    /**
   * Before code content, not a closing fence.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentStart(code) {
        return initialPrefix > 0 && (0, $a967d3607431391e$export$2c6cf65c1127992a)(code) ? (0, $602eae48ac3dea9e$export$ae105c1eb063a0a2)(effects, beforeContentChunk, 'linePrefix', initialPrefix + 1)(code) : beforeContentChunk(code);
    }
    /**
   * Before code content, after optional prefix.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeContentChunk(code) {
        if (code === null || (0, $a967d3607431391e$export$34a1dff1c0936953)(code)) return effects.check($a4ad67fa4c34f4a0$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        effects.enter('codeFlowValue');
        return contentChunk(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^^^^^^^^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentChunk(code) {
        if (code === null || (0, $a967d3607431391e$export$34a1dff1c0936953)(code)) {
            effects.exit('codeFlowValue');
            return beforeContentChunk(code);
        }
        effects.consume(code);
        return contentChunk;
    }
    /**
   * After code.
   *
   * ```markdown
   *   | ~~~js
   *   | alert(1)
   * > | ~~~
   *        ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        effects.exit('codeFenced');
        return ok(code);
    }
    /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */ function tokenizeCloseStart(effects, ok, nok) {
        let size = 0;
        return startBefore;
        /**
     *
     *
     * @type {State}
     */ function startBefore(code) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return start;
        }
        /**
     * Before closing fence, at optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function start(code) {
            // Always populated by defaults.
            // To do: `enter` here or in next state?
            effects.enter('codeFencedFence');
            return (0, $a967d3607431391e$export$2c6cf65c1127992a)(code) ? (0, $602eae48ac3dea9e$export$ae105c1eb063a0a2)(effects, beforeSequenceClose, 'linePrefix', self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : beforeSequenceClose(code);
        }
        /**
     * In closing fence, after optional whitespace, at sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function beforeSequenceClose(code) {
            if (code === marker) {
                effects.enter('codeFencedFenceSequence');
                return sequenceClose(code);
            }
            return nok(code);
        }
        /**
     * In closing fence sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function sequenceClose(code) {
            if (code === marker) {
                size++;
                effects.consume(code);
                return sequenceClose;
            }
            if (size >= sizeOpen) {
                effects.exit('codeFencedFenceSequence');
                return (0, $a967d3607431391e$export$2c6cf65c1127992a)(code) ? (0, $602eae48ac3dea9e$export$ae105c1eb063a0a2)(effects, sequenceCloseAfter, 'whitespace')(code) : sequenceCloseAfter(code);
            }
            return nok(code);
        }
        /**
     * After closing fence sequence, after optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *        ^
     * ```
     *
     * @type {State}
     */ function sequenceCloseAfter(code) {
            if (code === null || (0, $a967d3607431391e$export$34a1dff1c0936953)(code)) {
                effects.exit('codeFencedFence');
                return ok(code);
            }
            return nok(code);
        }
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $a4ad67fa4c34f4a0$var$tokenizeNonLazyContinuation(effects, ok, nok) {
    const self = this;
    return start;
    /**
   *
   *
   * @type {State}
   */ function start(code) {
        if (code === null) return nok(code);
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return lineStart;
    }
    /**
   *
   *
   * @type {State}
   */ function lineStart(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $067e2f85c5820cf1$export$47910b7ab28d1853 = {
    name: 'codeIndented',
    tokenize: $067e2f85c5820cf1$var$tokenizeCodeIndented
};
/** @type {Construct} */ const $067e2f85c5820cf1$var$furtherStart = {
    tokenize: $067e2f85c5820cf1$var$tokenizeFurtherStart,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $067e2f85c5820cf1$var$tokenizeCodeIndented(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of code (indented).
   *
   * > **Parsing note**: it is not needed to check if this first line is a
   * > filled line (that it has a non-whitespace character), because blank lines
   * > are parsed already, so we never run into that.
   *
   * ```markdown
   * > |     aaa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: manually check if interrupting like `markdown-rs`.
        effects.enter('codeIndented');
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $602eae48ac3dea9e$export$ae105c1eb063a0a2)(effects, afterPrefix, 'linePrefix', 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === 'linePrefix' && tail[2].sliceSerialize(tail[1], true).length >= 4 ? atBreak(code) : nok(code);
    }
    /**
   * At a break.
   *
   * ```markdown
   * > |     aaa
   *         ^  ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === null) return after(code);
        if ((0, $a967d3607431391e$export$34a1dff1c0936953)(code)) return effects.attempt($067e2f85c5820cf1$var$furtherStart, atBreak, after)(code);
        effects.enter('codeFlowValue');
        return inside(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   * > |     aaa
   *         ^^^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === null || (0, $a967d3607431391e$export$34a1dff1c0936953)(code)) {
            effects.exit('codeFlowValue');
            return atBreak(code);
        }
        effects.consume(code);
        return inside;
    }
    /** @type {State} */ function after(code) {
        effects.exit('codeIndented');
        // To do: allow interrupting like `markdown-rs`.
        // Feel free to interrupt.
        // tokenizer.interrupt = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $067e2f85c5820cf1$var$tokenizeFurtherStart(effects, ok, nok) {
    const self = this;
    return furtherStart;
    /**
   * At eol, trying to parse another indent.
   *
   * ```markdown
   * > |     aaa
   *            ^
   *   |     bbb
   * ```
   *
   * @type {State}
   */ function furtherStart(code) {
        // To do: improve `lazy` / `pierce` handling.
        // If this is a lazy line, it can’t be code.
        if (self.parser.lazy[self.now().line]) return nok(code);
        if ((0, $a967d3607431391e$export$34a1dff1c0936953)(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return furtherStart;
        }
        // To do: the code here in `micromark-js` is a bit different from
        // `markdown-rs` because there it can attempt spaces.
        // We can’t yet.
        //
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $602eae48ac3dea9e$export$ae105c1eb063a0a2)(effects, afterPrefix, 'linePrefix', 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === 'linePrefix' && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok(code) : (0, $a967d3607431391e$export$34a1dff1c0936953)(code) ? furtherStart(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $94b5a13c82b48dc5$export$d24f93e715f9df88 = {
    name: 'codeText',
    tokenize: $94b5a13c82b48dc5$var$tokenizeCodeText,
    resolve: $94b5a13c82b48dc5$var$resolveCodeText,
    previous: $94b5a13c82b48dc5$var$previous
};
// To do: next major: don’t resolve, like `markdown-rs`.
/** @type {Resolver} */ function $94b5a13c82b48dc5$var$resolveCodeText(events) {
    let tailExitIndex = events.length - 4;
    let headEnterIndex = 3;
    /** @type {number} */ let index;
    /** @type {number | undefined} */ let enter;
    // If we start and end with an EOL or a space.
    if ((events[headEnterIndex][1].type === 'lineEnding' || events[headEnterIndex][1].type === 'space') && (events[tailExitIndex][1].type === 'lineEnding' || events[tailExitIndex][1].type === 'space')) {
        index = headEnterIndex;
        // And we have data.
        while(++index < tailExitIndex)if (events[index][1].type === 'codeTextData') {
            // Then we have padding.
            events[headEnterIndex][1].type = 'codeTextPadding';
            events[tailExitIndex][1].type = 'codeTextPadding';
            headEnterIndex += 2;
            tailExitIndex -= 2;
            break;
        }
    }
    // Merge adjacent spaces and data.
    index = headEnterIndex - 1;
    tailExitIndex++;
    while(++index <= tailExitIndex){
        if (enter === undefined) {
            if (index !== tailExitIndex && events[index][1].type !== 'lineEnding') enter = index;
        } else if (index === tailExitIndex || events[index][1].type === 'lineEnding') {
            events[enter][1].type = 'codeTextData';
            if (index !== enter + 2) {
                events[enter][1].end = events[index - 1][1].end;
                events.splice(enter + 2, index - enter - 2);
                tailExitIndex -= index - enter - 2;
                index = enter + 2;
            }
            enter = undefined;
        }
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Previous}
 */ function $94b5a13c82b48dc5$var$previous(code) {
    // If there is a previous code, there will always be a tail.
    return code !== 96 || this.events[this.events.length - 1][1].type === 'characterEscape';
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $94b5a13c82b48dc5$var$tokenizeCodeText(effects, ok, nok) {
    const self = this;
    let sizeOpen = 0;
    /** @type {number} */ let size;
    /** @type {Token} */ let token;
    return start;
    /**
   * Start of code (text).
   *
   * ```markdown
   * > | `a`
   *     ^
   * > | \`a`
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('codeText');
        effects.enter('codeTextSequence');
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | `a`
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 96) {
            effects.consume(code);
            sizeOpen++;
            return sequenceOpen;
        }
        effects.exit('codeTextSequence');
        return between(code);
    }
    /**
   * Between something and something else.
   *
   * ```markdown
   * > | `a`
   *      ^^
   * ```
   *
   * @type {State}
   */ function between(code) {
        // EOF.
        if (code === null) return nok(code);
        // To do: next major: don’t do spaces in resolve, but when compiling,
        // like `markdown-rs`.
        // Tabs don’t work, and virtual spaces don’t make sense.
        if (code === 32) {
            effects.enter('space');
            effects.consume(code);
            effects.exit('space');
            return between;
        }
        // Closing fence? Could also be data.
        if (code === 96) {
            token = effects.enter('codeTextSequence');
            size = 0;
            return sequenceClose(code);
        }
        if ((0, $a967d3607431391e$export$34a1dff1c0936953)(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return between;
        }
        // Data.
        effects.enter('codeTextData');
        return data(code);
    }
    /**
   * In data.
   *
   * ```markdown
   * > | `a`
   *      ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 32 || code === 96 || (0, $a967d3607431391e$export$34a1dff1c0936953)(code)) {
            effects.exit('codeTextData');
            return between(code);
        }
        effects.consume(code);
        return data;
    }
    /**
   * In closing sequence.
   *
   * ```markdown
   * > | `a`
   *       ^
   * ```
   *
   * @type {State}
   */ function sequenceClose(code) {
        // More.
        if (code === 96) {
            effects.consume(code);
            size++;
            return sequenceClose;
        }
        // Done!
        if (size === sizeOpen) {
            effects.exit('codeTextSequence');
            effects.exit('codeText');
            return ok(code);
        }
        // More or less accents: mark as data.
        token.type = 'codeTextData';
        return data(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
function $d9459511544b920a$export$2e6c8deaa96af245(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
    const limit = max || Number.POSITIVE_INFINITY;
    let balance = 0;
    return start;
    /**
   * Start of destination.
   *
   * ```markdown
   * > | <aa>
   *     ^
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 60) {
            effects.enter(type);
            effects.enter(literalType);
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            return enclosedBefore;
        }
        // ASCII control, space, closing paren.
        if (code === null || code === 32 || code === 41 || (0, $a967d3607431391e$export$67dbf494fc8394df)(code)) return nok(code);
        effects.enter(type);
        effects.enter(rawType);
        effects.enter(stringType);
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return raw(code);
    }
    /**
   * After `<`, at an enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosedBefore(code) {
        if (code === 62) {
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            effects.exit(literalType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return enclosed(code);
    }
    /**
   * In enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosed(code) {
        if (code === 62) {
            effects.exit('chunkString');
            effects.exit(stringType);
            return enclosedBefore(code);
        }
        if (code === null || code === 60 || (0, $a967d3607431391e$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? enclosedEscape : enclosed;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | <a\*a>
   *        ^
   * ```
   *
   * @type {State}
   */ function enclosedEscape(code) {
        if (code === 60 || code === 62 || code === 92) {
            effects.consume(code);
            return enclosed;
        }
        return enclosed(code);
    }
    /**
   * In raw destination.
   *
   * ```markdown
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function raw(code) {
        if (!balance && (code === null || code === 41 || (0, $a967d3607431391e$export$a30284361b3814b7)(code))) {
            effects.exit('chunkString');
            effects.exit(stringType);
            effects.exit(rawType);
            effects.exit(type);
            return ok(code);
        }
        if (balance < limit && code === 40) {
            effects.consume(code);
            balance++;
            return raw;
        }
        if (code === 41) {
            effects.consume(code);
            balance--;
            return raw;
        }
        // ASCII control (but *not* `\0`) and space and `(`.
        // Note: in `markdown-rs`, `\0` exists in codes, in `micromark-js` it
        // doesn’t.
        if (code === null || code === 32 || code === 40 || (0, $a967d3607431391e$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? rawEscape : raw;
    }
    /**
   * After `\`, at special character.
   *
   * ```markdown
   * > | a\*a
   *       ^
   * ```
   *
   * @type {State}
   */ function rawEscape(code) {
        if (code === 40 || code === 41 || code === 92) {
            effects.consume(code);
            return raw;
        }
        return raw(code);
    }
}


/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
function $841e56874cc763b9$export$7b768614d8ba97a7(effects, ok, nok, type, markerType, stringType) {
    const self = this;
    let size = 0;
    /** @type {boolean} */ let seen;
    return start;
    /**
   * Start of label.
   *
   * ```markdown
   * > | [a]
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        effects.enter(stringType);
        return atBreak;
    }
    /**
   * In label, at something, before something else.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (size > 999 || code === null || code === 91 || code === 93 && !seen || // To do: remove in the future once we’ve switched from
        // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
        // which doesn’t need this.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ code === 94 && !size && '_hiddenFootnoteSupport' in self.parser.constructs) return nok(code);
        if (code === 93) {
            effects.exit(stringType);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        // To do: indent? Link chunks and EOLs together?
        if ((0, $a967d3607431391e$export$34a1dff1c0936953)(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return atBreak;
        }
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return labelInside(code);
    }
    /**
   * In label, in text.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (code === null || code === 91 || code === 93 || (0, $a967d3607431391e$export$34a1dff1c0936953)(code) || size++ > 999) {
            effects.exit('chunkString');
            return atBreak(code);
        }
        effects.consume(code);
        if (!seen) seen = !(0, $a967d3607431391e$export$2c6cf65c1127992a)(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | [a\*a]
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
}



/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 

function $a4f1de42e1e8107b$export$f970569cc855e483(effects, ok, nok, type, markerType, stringType) {
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of title.
   *
   * ```markdown
   * > | "a"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 34 || code === 39 || code === 40) {
            effects.enter(type);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            marker = code === 40 ? 41 : code;
            return begin;
        }
        return nok(code);
    }
    /**
   * After opening marker.
   *
   * This is also used at the closing marker.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function begin(code) {
        if (code === marker) {
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        return atBreak(code);
    }
    /**
   * At something, before something else.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.exit(stringType);
            return begin(marker);
        }
        if (code === null) return nok(code);
        // Note: blank lines can’t exist in content.
        if ((0, $a967d3607431391e$export$34a1dff1c0936953)(code)) {
            // To do: use `space_or_tab_eol_with_options`, connect.
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return (0, $602eae48ac3dea9e$export$ae105c1eb063a0a2)(effects, atBreak, 'linePrefix');
        }
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return inside(code);
    }
    /**
   *
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker || code === null || (0, $a967d3607431391e$export$34a1dff1c0936953)(code)) {
            effects.exit('chunkString');
            return atBreak(code);
        }
        effects.consume(code);
        return code === 92 ? escape : inside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | "a\*b"
   *      ^
   * ```
   *
   * @type {State}
   */ function escape(code) {
        if (code === marker || code === 92) {
            effects.consume(code);
            return inside;
        }
        return inside(code);
    }
}


/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 */ 

function $48659b40c7eec554$export$1f27bd1aa33ce173(effects, ok) {
    /** @type {boolean} */ let seen;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $a967d3607431391e$export$34a1dff1c0936953)(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            seen = true;
            return start;
        }
        if ((0, $a967d3607431391e$export$2c6cf65c1127992a)(code)) return (0, $602eae48ac3dea9e$export$ae105c1eb063a0a2)(effects, start, seen ? 'linePrefix' : 'lineSuffix')(code);
        return ok(code);
    }
}



/**
 * Normalize an identifier (as found in references, definitions).
 *
 * Collapses markdown whitespace, trim, and then lower- and uppercase.
 *
 * Some characters are considered “uppercase”, such as U+03F4 (`ϴ`), but if their
 * lowercase counterpart (U+03B8 (`θ`)) is uppercased will result in a different
 * uppercase character (U+0398 (`Θ`)).
 * So, to get a canonical form, we perform both lower- and uppercase.
 *
 * Using uppercase last makes sure keys will never interact with default
 * prototypal values (such as `constructor`): nothing in the prototype of
 * `Object` is uppercase.
 *
 * @param {string} value
 *   Identifier to normalize.
 * @returns {string}
 *   Normalized identifier.
 */ function $e41ed80474602082$export$806d55e226cfcd08(value) {
    return value// Collapse markdown whitespace.
    .replace(/[\t\n\r ]+/g, ' ')// Trim.
    .replace(/^ | $/g, '')// Some characters are considered “uppercase”, but if their lowercase
    // counterpart is uppercased will result in a different uppercase
    // character.
    // Hence, to get that form, we perform both lower- and uppercase.
    // Upper case makes sure keys will not interact with default prototypal
    // methods: no method is uppercase.
    .toLowerCase().toUpperCase();
}


const $b9388d71e52b125b$export$69f215ed977cdb73 = {
    name: 'definition',
    tokenize: $b9388d71e52b125b$var$tokenizeDefinition
};
/** @type {Construct} */ const $b9388d71e52b125b$var$titleBefore = {
    tokenize: $b9388d71e52b125b$var$tokenizeTitleBefore,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $b9388d71e52b125b$var$tokenizeDefinition(effects, ok, nok) {
    const self = this;
    /** @type {string} */ let identifier;
    return start;
    /**
   * At start of a definition.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Do not interrupt paragraphs (but do follow definitions).
        // To do: do `interrupt` the way `markdown-rs` does.
        // To do: parse whitespace the way `markdown-rs` does.
        effects.enter('definition');
        return before(code);
    }
    /**
   * After optional whitespace, at `[`.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        // To do: parse whitespace the way `markdown-rs` does.
        return (0, $841e56874cc763b9$export$7b768614d8ba97a7).call(self, effects, labelAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, 'definitionLabel', 'definitionLabelMarker', 'definitionLabelString')(code);
    }
    /**
   * After label.
   *
   * ```markdown
   * > | [a]: b "c"
   *        ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        identifier = (0, $e41ed80474602082$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
        if (code === 58) {
            effects.enter('definitionMarker');
            effects.consume(code);
            effects.exit('definitionMarker');
            return markerAfter;
        }
        return nok(code);
    }
    /**
   * After marker.
   *
   * ```markdown
   * > | [a]: b "c"
   *         ^
   * ```
   *
   * @type {State}
   */ function markerAfter(code) {
        // Note: whitespace is optional.
        return (0, $a967d3607431391e$export$a30284361b3814b7)(code) ? (0, $48659b40c7eec554$export$1f27bd1aa33ce173)(effects, destinationBefore)(code) : destinationBefore(code);
    }
    /**
   * Before destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *          ^
   * ```
   *
   * @type {State}
   */ function destinationBefore(code) {
        return (0, $d9459511544b920a$export$2e6c8deaa96af245)(effects, destinationAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, 'definitionDestination', 'definitionDestinationLiteral', 'definitionDestinationLiteralMarker', 'definitionDestinationRaw', 'definitionDestinationString')(code);
    }
    /**
   * After destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function destinationAfter(code) {
        return effects.attempt($b9388d71e52b125b$var$titleBefore, after, after)(code);
    }
    /**
   * After definition.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return (0, $a967d3607431391e$export$2c6cf65c1127992a)(code) ? (0, $602eae48ac3dea9e$export$ae105c1eb063a0a2)(effects, afterWhitespace, 'whitespace')(code) : afterWhitespace(code);
    }
    /**
   * After definition, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function afterWhitespace(code) {
        if (code === null || (0, $a967d3607431391e$export$34a1dff1c0936953)(code)) {
            effects.exit('definition');
            // Note: we don’t care about uniqueness.
            // It’s likely that that doesn’t happen very frequently.
            // It is more likely that it wastes precious time.
            self.parser.defined.push(identifier);
            // To do: `markdown-rs` interrupt.
            // // You’d be interrupting.
            // tokenizer.interrupt = true
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $b9388d71e52b125b$var$tokenizeTitleBefore(effects, ok, nok) {
    return titleBefore;
    /**
   * After destination, at whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function titleBefore(code) {
        return (0, $a967d3607431391e$export$a30284361b3814b7)(code) ? (0, $48659b40c7eec554$export$1f27bd1aa33ce173)(effects, beforeMarker)(code) : nok(code);
    }
    /**
   * At title.
   *
   * ```markdown
   *   | [a]: b
   * > | "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function beforeMarker(code) {
        return (0, $a4f1de42e1e8107b$export$f970569cc855e483)(effects, titleAfter, nok, 'definitionTitle', 'definitionTitleMarker', 'definitionTitleString')(code);
    }
    /**
   * After title.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfter(code) {
        return (0, $a967d3607431391e$export$2c6cf65c1127992a)(code) ? (0, $602eae48ac3dea9e$export$ae105c1eb063a0a2)(effects, titleAfterOptionalWhitespace, 'whitespace')(code) : titleAfterOptionalWhitespace(code);
    }
    /**
   * After title, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfterOptionalWhitespace(code) {
        return code === null || (0, $a967d3607431391e$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $00ae8f5ed19b00f4$export$86c573ab9e06f418 = {
    name: 'hardBreakEscape',
    tokenize: $00ae8f5ed19b00f4$var$tokenizeHardBreakEscape
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $00ae8f5ed19b00f4$var$tokenizeHardBreakEscape(effects, ok, nok) {
    return start;
    /**
   * Start of a hard break (escape).
   *
   * ```markdown
   * > | a\
   *      ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('hardBreakEscape');
        effects.consume(code);
        return after;
    }
    /**
   * After `\`, at eol.
   *
   * ```markdown
   * > | a\
   *       ^
   *   | b
   * ```
   *
   *  @type {State}
   */ function after(code) {
        if ((0, $a967d3607431391e$export$34a1dff1c0936953)(code)) {
            effects.exit('hardBreakEscape');
            return ok(code);
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 


const $c7653936fe864536$export$3871e9deb360695c = {
    name: 'headingAtx',
    tokenize: $c7653936fe864536$var$tokenizeHeadingAtx,
    resolve: $c7653936fe864536$var$resolveHeadingAtx
};
/** @type {Resolver} */ function $c7653936fe864536$var$resolveHeadingAtx(events, context) {
    let contentEnd = events.length - 2;
    let contentStart = 3;
    /** @type {Token} */ let content;
    /** @type {Token} */ let text;
    // Prefix whitespace, part of the opening.
    if (events[contentStart][1].type === 'whitespace') contentStart += 2;
    // Suffix whitespace, part of the closing.
    if (contentEnd - 2 > contentStart && events[contentEnd][1].type === 'whitespace') contentEnd -= 2;
    if (events[contentEnd][1].type === 'atxHeadingSequence' && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === 'whitespace')) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
    if (contentEnd > contentStart) {
        content = {
            type: 'atxHeadingText',
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end
        };
        text = {
            type: 'chunkText',
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end,
            contentType: 'text'
        };
        (0, $5e612816a43dd8d9$export$869882364835d202)(events, contentStart, contentEnd - contentStart + 1, [
            [
                'enter',
                content,
                context
            ],
            [
                'enter',
                text,
                context
            ],
            [
                'exit',
                text,
                context
            ],
            [
                'exit',
                content,
                context
            ]
        ]);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $c7653936fe864536$var$tokenizeHeadingAtx(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of a heading (atx).
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        effects.enter('atxHeading');
        return before(code);
    }
    /**
   * After optional whitespace, at `#`.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter('atxHeadingSequence');
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 35 && size++ < 6) {
            effects.consume(code);
            return sequenceOpen;
        }
        // Always at least one `#`.
        if (code === null || (0, $a967d3607431391e$export$a30284361b3814b7)(code)) {
            effects.exit('atxHeadingSequence');
            return atBreak(code);
        }
        return nok(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ## aa
   *       ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === 35) {
            effects.enter('atxHeadingSequence');
            return sequenceFurther(code);
        }
        if (code === null || (0, $a967d3607431391e$export$34a1dff1c0936953)(code)) {
            effects.exit('atxHeading');
            // To do: interrupt like `markdown-rs`.
            // // Feel free to interrupt.
            // tokenizer.interrupt = false
            return ok(code);
        }
        if ((0, $a967d3607431391e$export$2c6cf65c1127992a)(code)) return (0, $602eae48ac3dea9e$export$ae105c1eb063a0a2)(effects, atBreak, 'whitespace')(code);
        // To do: generate `data` tokens, add the `text` token later.
        // Needs edit map, see: `markdown.rs`.
        effects.enter('atxHeadingText');
        return data(code);
    }
    /**
   * In further sequence (after whitespace).
   *
   * Could be normal “visible” hashes in the heading or a final sequence.
   *
   * ```markdown
   * > | ## aa ##
   *           ^
   * ```
   *
   * @type {State}
   */ function sequenceFurther(code) {
        if (code === 35) {
            effects.consume(code);
            return sequenceFurther;
        }
        effects.exit('atxHeadingSequence');
        return atBreak(code);
    }
    /**
   * In text.
   *
   * ```markdown
   * > | ## aa
   *        ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 35 || (0, $a967d3607431391e$export$a30284361b3814b7)(code)) {
            effects.exit('atxHeadingText');
            return atBreak(code);
        }
        effects.consume(code);
        return data;
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
/**
 * List of lowercase HTML “block” tag names.
 *
 * The list, when parsing HTML (flow), results in more relaxed rules (condition
 * 6).
 * Because they are known blocks, the HTML-like syntax doesn’t have to be
 * strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * > 👉 **Note**: `search` was added in `CommonMark@0.31`.
 */ const $cd8bc94a957618c6$export$7364aee1c59d1879 = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'search',
    'section',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];
const $cd8bc94a957618c6$export$948e66da505d080 = [
    'pre',
    'script',
    'style',
    'textarea'
];



const $5039b0600d59fdd9$export$476ac411cb7d0d8f = {
    name: 'htmlFlow',
    tokenize: $5039b0600d59fdd9$var$tokenizeHtmlFlow,
    resolveTo: $5039b0600d59fdd9$var$resolveToHtmlFlow,
    concrete: true
};
/** @type {Construct} */ const $5039b0600d59fdd9$var$blankLineBefore = {
    tokenize: $5039b0600d59fdd9$var$tokenizeBlankLineBefore,
    partial: true
};
const $5039b0600d59fdd9$var$nonLazyContinuationStart = {
    tokenize: $5039b0600d59fdd9$var$tokenizeNonLazyContinuationStart,
    partial: true
};
/** @type {Resolver} */ function $5039b0600d59fdd9$var$resolveToHtmlFlow(events) {
    let index = events.length;
    while(index--){
        if (events[index][0] === 'enter' && events[index][1].type === 'htmlFlow') break;
    }
    if (index > 1 && events[index - 2][1].type === 'linePrefix') {
        // Add the prefix start to the HTML token.
        events[index][1].start = events[index - 2][1].start;
        // Add the prefix start to the HTML line token.
        events[index + 1][1].start = events[index - 2][1].start;
        // Remove the line prefix.
        events.splice(index - 2, 2);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $5039b0600d59fdd9$var$tokenizeHtmlFlow(effects, ok, nok) {
    const self = this;
    /** @type {number} */ let marker;
    /** @type {boolean} */ let closingTag;
    /** @type {string} */ let buffer;
    /** @type {number} */ let index;
    /** @type {Code} */ let markerB;
    return start;
    /**
   * Start of HTML (flow).
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * At `<`, after optional whitespace.
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter('htmlFlow');
        effects.enter('htmlFlowData');
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | <x />
   *      ^
   * > | <!doctype>
   *      ^
   * > | <!--xxx-->
   *      ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            closingTag = true;
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            marker = 3;
            // To do:
            // tokenizer.concrete = true
            // To do: use `markdown-rs` style interrupt.
            // While we’re in an instruction instead of a declaration, we’re on a `?`
            // right now, so we do need to search for `>`, similar to declarations.
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        // ASCII alphabetical.
        if ((0, $a967d3607431391e$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | <!doctype>
   *       ^
   * > | <!--xxx-->
   *       ^
   * > | <![CDATA[>&<]]>
   *       ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            marker = 2;
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            marker = 5;
            index = 0;
            return cdataOpenInside;
        }
        // ASCII alphabetical.
        if ((0, $a967d3607431391e$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            marker = 4;
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<!-`, inside a comment, at another `-`.
   *
   * ```markdown
   * > | <!--xxx-->
   *        ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<![`, inside CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *        ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = 'CDATA[';
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            if (index === value.length) // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
            return cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | </x>
   *       ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        if ((0, $a967d3607431391e$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * In tag name.
   *
   * ```markdown
   * > | <ab>
   *      ^^
   * > | </ab>
   *       ^^
   * ```
   *
   * @type {State}
   */ function tagName(code) {
        if (code === null || code === 47 || code === 62 || (0, $a967d3607431391e$export$a30284361b3814b7)(code)) {
            const slash = code === 47;
            const name = buffer.toLowerCase();
            if (!slash && !closingTag && (0, $cd8bc94a957618c6$export$948e66da505d080).includes(name)) {
                marker = 1;
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            if ((0, $cd8bc94a957618c6$export$7364aee1c59d1879).includes(buffer.toLowerCase())) {
                marker = 6;
                if (slash) {
                    effects.consume(code);
                    return basicSelfClosing;
                }
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            marker = 7;
            // Do not support complete HTML when interrupting.
            return self.interrupt && !self.parser.lazy[self.now().line] ? nok(code) : closingTag ? completeClosingTagAfter(code) : completeAttributeNameBefore(code);
        }
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $a967d3607431391e$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After closing slash of a basic tag name.
   *
   * ```markdown
   * > | <div/>
   *          ^
   * ```
   *
   * @type {State}
   */ function basicSelfClosing(code) {
        if (code === 62) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
        }
        return nok(code);
    }
    /**
   * After closing slash of a complete tag name.
   *
   * ```markdown
   * > | <x/>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeClosingTagAfter(code) {
        if ((0, $a967d3607431391e$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeClosingTagAfter;
        }
        return completeEnd(code);
    }
    /**
   * At an attribute name.
   *
   * At first, this state is used after a complete tag name, after whitespace,
   * where it expects optional attributes or the end of the tag.
   * It is also reused after attributes, when expecting more optional
   * attributes.
   *
   * ```markdown
   * > | <a />
   *        ^
   * > | <a :b>
   *        ^
   * > | <a _b>
   *        ^
   * > | <a b>
   *        ^
   * > | <a >
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameBefore(code) {
        if (code === 47) {
            effects.consume(code);
            return completeEnd;
        }
        // ASCII alphanumerical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $a967d3607431391e$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        if ((0, $a967d3607431391e$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameBefore;
        }
        return completeEnd(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | <a :b>
   *         ^
   * > | <a _b>
   *         ^
   * > | <a b>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeName(code) {
        // ASCII alphanumerical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $a967d3607431391e$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        return completeAttributeNameAfter(code);
    }
    /**
   * After attribute name, at an optional initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | <a b>
   *         ^
   * > | <a b=c>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        if ((0, $a967d3607431391e$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameAfter;
        }
        return completeAttributeNameBefore(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * > | <a b="c">
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            markerB = code;
            return completeAttributeValueQuoted;
        }
        if ((0, $a967d3607431391e$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        return completeAttributeValueUnquoted(code);
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | <a b="c">
   *           ^
   * > | <a b='c'>
   *           ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuoted(code) {
        if (code === markerB) {
            effects.consume(code);
            markerB = null;
            return completeAttributeValueQuotedAfter;
        }
        if (code === null || (0, $a967d3607431391e$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return completeAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 47 || code === 60 || code === 61 || code === 62 || code === 96 || (0, $a967d3607431391e$export$a30284361b3814b7)(code)) return completeAttributeNameAfter(code);
        effects.consume(code);
        return completeAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the
   * end of the tag.
   *
   * ```markdown
   * > | <a b="c">
   *            ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $a967d3607431391e$export$2c6cf65c1127992a)(code)) return completeAttributeNameBefore(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a complete tag where only an `>` is allowed.
   *
   * ```markdown
   * > | <a b="c">
   *             ^
   * ```
   *
   * @type {State}
   */ function completeEnd(code) {
        if (code === 62) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * After `>` in a complete tag.
   *
   * ```markdown
   * > | <x>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAfter(code) {
        if (code === null || (0, $a967d3607431391e$export$34a1dff1c0936953)(code)) // // Do not form containers.
        // tokenizer.concrete = true
        return continuation(code);
        if ((0, $a967d3607431391e$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * In continuation of any HTML kind.
   *
   * ```markdown
   * > | <!--xxx-->
   *          ^
   * ```
   *
   * @type {State}
   */ function continuation(code) {
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationCommentInside;
        }
        if (code === 60 && marker === 1) {
            effects.consume(code);
            return continuationRawTagOpen;
        }
        if (code === 62 && marker === 4) {
            effects.consume(code);
            return continuationClose;
        }
        if (code === 63 && marker === 3) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        if (code === 93 && marker === 5) {
            effects.consume(code);
            return continuationCdataInside;
        }
        if ((0, $a967d3607431391e$export$34a1dff1c0936953)(code) && (marker === 6 || marker === 7)) {
            effects.exit('htmlFlowData');
            return effects.check($5039b0600d59fdd9$var$blankLineBefore, continuationAfter, continuationStart)(code);
        }
        if (code === null || (0, $a967d3607431391e$export$34a1dff1c0936953)(code)) {
            effects.exit('htmlFlowData');
            return continuationStart(code);
        }
        effects.consume(code);
        return continuation;
    }
    /**
   * In continuation, at eol.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStart(code) {
        return effects.check($5039b0600d59fdd9$var$nonLazyContinuationStart, continuationStartNonLazy, continuationAfter)(code);
    }
    /**
   * In continuation, at eol, before non-lazy content.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStartNonLazy(code) {
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return continuationBefore;
    }
    /**
   * In continuation, before non-lazy content.
   *
   * ```markdown
   *   | <x>
   * > | asd
   *     ^
   * ```
   *
   * @type {State}
   */ function continuationBefore(code) {
        if (code === null || (0, $a967d3607431391e$export$34a1dff1c0936953)(code)) return continuationStart(code);
        effects.enter('htmlFlowData');
        return continuation(code);
    }
    /**
   * In comment continuation, after one `-`, expecting another.
   *
   * ```markdown
   * > | <!--xxx-->
   *             ^
   * ```
   *
   * @type {State}
   */ function continuationCommentInside(code) {
        if (code === 45) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `<`, at `/`.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                            ^
   * ```
   *
   * @type {State}
   */ function continuationRawTagOpen(code) {
        if (code === 47) {
            effects.consume(code);
            buffer = '';
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `</`, in a raw tag name.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                             ^^^^^^
   * ```
   *
   * @type {State}
   */ function continuationRawEndTag(code) {
        if (code === 62) {
            const name = buffer.toLowerCase();
            if ((0, $cd8bc94a957618c6$export$948e66da505d080).includes(name)) {
                effects.consume(code);
                return continuationClose;
            }
            return continuation(code);
        }
        if ((0, $a967d3607431391e$export$d65d6b62c24d5436)(code) && buffer.length < 8) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer += String.fromCharCode(code);
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In cdata continuation, after `]`, expecting `]>`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *                  ^
   * ```
   *
   * @type {State}
   */ function continuationCdataInside(code) {
        if (code === 93) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In declaration or instruction continuation, at `>`.
   *
   * ```markdown
   * > | <!-->
   *         ^
   * > | <?>
   *       ^
   * > | <!q>
   *        ^
   * > | <!--ab-->
   *             ^
   * > | <![CDATA[>&<]]>
   *                   ^
   * ```
   *
   * @type {State}
   */ function continuationDeclarationInside(code) {
        if (code === 62) {
            effects.consume(code);
            return continuationClose;
        }
        // More dashes.
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In closed continuation: everything we get until the eol/eof is part of it.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationClose(code) {
        if (code === null || (0, $a967d3607431391e$export$34a1dff1c0936953)(code)) {
            effects.exit('htmlFlowData');
            return continuationAfter(code);
        }
        effects.consume(code);
        return continuationClose;
    }
    /**
   * Done.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationAfter(code) {
        effects.exit('htmlFlow');
        // // Feel free to interrupt.
        // tokenizer.interrupt = false
        // // No longer concrete.
        // tokenizer.concrete = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $5039b0600d59fdd9$var$tokenizeNonLazyContinuationStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * At eol, before continuation.
   *
   * ```markdown
   * > | * ```js
   *            ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        if ((0, $a967d3607431391e$export$34a1dff1c0936953)(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return after;
        }
        return nok(code);
    }
    /**
   * A continuation.
   *
   * ```markdown
   *   | * ```js
   * > | b
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $5039b0600d59fdd9$var$tokenizeBlankLineBefore(effects, ok, nok) {
    return start;
    /**
   * Before eol, expecting blank line.
   *
   * ```markdown
   * > | <div>
   *          ^
   *   |
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return effects.attempt((0, $231ee94245fc5c87$export$d50d28ce3ab2a612), ok, nok);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $e886134b78912936$export$398af27f284914fe = {
    name: 'htmlText',
    tokenize: $e886134b78912936$var$tokenizeHtmlText
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $e886134b78912936$var$tokenizeHtmlText(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code> | undefined} */ let marker;
    /** @type {number} */ let index;
    /** @type {State} */ let returnState;
    return start;
    /**
   * Start of HTML (text).
   *
   * ```markdown
   * > | a <b> c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('htmlText');
        effects.enter('htmlTextData');
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | a <b> c
   *        ^
   * > | a <!doctype> c
   *        ^
   * > | a <!--b--> c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            return instruction;
        }
        // ASCII alphabetical.
        if ((0, $a967d3607431391e$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | a <!doctype> c
   *         ^
   * > | a <!--b--> c
   *         ^
   * > | a <![CDATA[>&<]]> c
   *         ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            index = 0;
            return cdataOpenInside;
        }
        if ((0, $a967d3607431391e$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return declaration;
        }
        return nok(code);
    }
    /**
   * In a comment, after `<!-`, at another `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *          ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return nok(code);
    }
    /**
   * In comment.
   *
   * ```markdown
   * > | a <!--b--> c
   *           ^
   * ```
   *
   * @type {State}
   */ function comment(code) {
        if (code === null) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentClose;
        }
        if ((0, $a967d3607431391e$export$34a1dff1c0936953)(code)) {
            returnState = comment;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return comment;
    }
    /**
   * In comment, after `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *             ^
   * ```
   *
   * @type {State}
   */ function commentClose(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return comment(code);
    }
    /**
   * In comment, after `--`.
   *
   * ```markdown
   * > | a <!--b--> c
   *              ^
   * ```
   *
   * @type {State}
   */ function commentEnd(code) {
        return code === 62 ? end(code) : code === 45 ? commentClose(code) : comment(code);
    }
    /**
   * After `<![`, in CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *          ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = 'CDATA[';
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            return index === value.length ? cdata : cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * In CDATA.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                ^^^
   * ```
   *
   * @type {State}
   */ function cdata(code) {
        if (code === null) return nok(code);
        if (code === 93) {
            effects.consume(code);
            return cdataClose;
        }
        if ((0, $a967d3607431391e$export$34a1dff1c0936953)(code)) {
            returnState = cdata;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return cdata;
    }
    /**
   * In CDATA, after `]`, at another `]`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                    ^
   * ```
   *
   * @type {State}
   */ function cdataClose(code) {
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In CDATA, after `]]`, at `>`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                     ^
   * ```
   *
   * @type {State}
   */ function cdataEnd(code) {
        if (code === 62) return end(code);
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In declaration.
   *
   * ```markdown
   * > | a <!b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function declaration(code) {
        if (code === null || code === 62) return end(code);
        if ((0, $a967d3607431391e$export$34a1dff1c0936953)(code)) {
            returnState = declaration;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return declaration;
    }
    /**
   * In instruction.
   *
   * ```markdown
   * > | a <?b?> c
   *         ^
   * ```
   *
   * @type {State}
   */ function instruction(code) {
        if (code === null) return nok(code);
        if (code === 63) {
            effects.consume(code);
            return instructionClose;
        }
        if ((0, $a967d3607431391e$export$34a1dff1c0936953)(code)) {
            returnState = instruction;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return instruction;
    }
    /**
   * In instruction, after `?`, at `>`.
   *
   * ```markdown
   * > | a <?b?> c
   *           ^
   * ```
   *
   * @type {State}
   */ function instructionClose(code) {
        return code === 62 ? end(code) : instruction(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | a </b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        // ASCII alphabetical.
        if ((0, $a967d3607431391e$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return nok(code);
    }
    /**
   * After `</x`, in a tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagClose(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $a967d3607431391e$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return tagCloseBetween(code);
    }
    /**
   * In closing tag, after tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagCloseBetween(code) {
        if ((0, $a967d3607431391e$export$34a1dff1c0936953)(code)) {
            returnState = tagCloseBetween;
            return lineEndingBefore(code);
        }
        if ((0, $a967d3607431391e$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagCloseBetween;
        }
        return end(code);
    }
    /**
   * After `<x`, in opening tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpen(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $a967d3607431391e$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        if (code === 47 || code === 62 || (0, $a967d3607431391e$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In opening tag, after tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpenBetween(code) {
        if (code === 47) {
            effects.consume(code);
            return end;
        }
        // ASCII alphabetical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $a967d3607431391e$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        if ((0, $a967d3607431391e$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenBetween;
            return lineEndingBefore(code);
        }
        if ((0, $a967d3607431391e$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenBetween;
        }
        return end(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | a <b c> d
   *          ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeName(code) {
        // ASCII alphabetical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $a967d3607431391e$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        return tagOpenAttributeNameAfter(code);
    }
    /**
   * After attribute name, before initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | a <b c> d
   *           ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        if ((0, $a967d3607431391e$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeNameAfter;
            return lineEndingBefore(code);
        }
        if ((0, $a967d3607431391e$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeNameAfter;
        }
        return tagOpenBetween(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return tagOpenAttributeValueQuoted;
        }
        if ((0, $a967d3607431391e$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueBefore;
            return lineEndingBefore(code);
        }
        if ((0, $a967d3607431391e$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | a <b c="d"> e
   *             ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            marker = undefined;
            return tagOpenAttributeValueQuotedAfter;
        }
        if (code === null) return nok(code);
        if ((0, $a967d3607431391e$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueQuoted;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return tagOpenAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) return nok(code);
        if (code === 47 || code === 62 || (0, $a967d3607431391e$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the end
   * of the tag.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $a967d3607431391e$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a tag where only an `>` is allowed.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function end(code) {
        if (code === 62) {
            effects.consume(code);
            effects.exit('htmlTextData');
            effects.exit('htmlText');
            return ok;
        }
        return nok(code);
    }
    /**
   * At eol.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   * > | a <!--a
   *            ^
   *   | b-->
   * ```
   *
   * @type {State}
   */ function lineEndingBefore(code) {
        effects.exit('htmlTextData');
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return lineEndingAfter;
    }
    /**
   * After eol, at optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfter(code) {
        // Always populated by defaults.
        return (0, $a967d3607431391e$export$2c6cf65c1127992a)(code) ? (0, $602eae48ac3dea9e$export$ae105c1eb063a0a2)(effects, lineEndingAfterPrefix, 'linePrefix', self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : lineEndingAfterPrefix(code);
    }
    /**
   * After eol, after optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfterPrefix(code) {
        effects.enter('htmlTextData');
        return returnState(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 







const $7911f51dbd5582ba$export$470a5dafbbf62654 = {
    name: 'labelEnd',
    tokenize: $7911f51dbd5582ba$var$tokenizeLabelEnd,
    resolveTo: $7911f51dbd5582ba$var$resolveToLabelEnd,
    resolveAll: $7911f51dbd5582ba$var$resolveAllLabelEnd
};
/** @type {Construct} */ const $7911f51dbd5582ba$var$resourceConstruct = {
    tokenize: $7911f51dbd5582ba$var$tokenizeResource
};
/** @type {Construct} */ const $7911f51dbd5582ba$var$referenceFullConstruct = {
    tokenize: $7911f51dbd5582ba$var$tokenizeReferenceFull
};
/** @type {Construct} */ const $7911f51dbd5582ba$var$referenceCollapsedConstruct = {
    tokenize: $7911f51dbd5582ba$var$tokenizeReferenceCollapsed
};
/** @type {Resolver} */ function $7911f51dbd5582ba$var$resolveAllLabelEnd(events) {
    let index = -1;
    while(++index < events.length){
        const token = events[index][1];
        if (token.type === 'labelImage' || token.type === 'labelLink' || token.type === 'labelEnd') {
            // Remove the marker.
            events.splice(index + 1, token.type === 'labelImage' ? 4 : 2);
            token.type = 'data';
            index++;
        }
    }
    return events;
}
/** @type {Resolver} */ function $7911f51dbd5582ba$var$resolveToLabelEnd(events, context) {
    let index = events.length;
    let offset = 0;
    /** @type {Token} */ let token;
    /** @type {number | undefined} */ let open;
    /** @type {number | undefined} */ let close;
    /** @type {Array<Event>} */ let media;
    // Find an opening.
    while(index--){
        token = events[index][1];
        if (open) {
            // If we see another link, or inactive link label, we’ve been here before.
            if (token.type === 'link' || token.type === 'labelLink' && token._inactive) break;
            // Mark other link openings as inactive, as we can’t have links in
            // links.
            if (events[index][0] === 'enter' && token.type === 'labelLink') token._inactive = true;
        } else if (close) {
            if (events[index][0] === 'enter' && (token.type === 'labelImage' || token.type === 'labelLink') && !token._balanced) {
                open = index;
                if (token.type !== 'labelLink') {
                    offset = 2;
                    break;
                }
            }
        } else if (token.type === 'labelEnd') close = index;
    }
    const group = {
        type: events[open][1].type === 'labelLink' ? 'link' : 'image',
        start: Object.assign({}, events[open][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    const label = {
        type: 'label',
        start: Object.assign({}, events[open][1].start),
        end: Object.assign({}, events[close][1].end)
    };
    const text = {
        type: 'labelText',
        start: Object.assign({}, events[open + offset + 2][1].end),
        end: Object.assign({}, events[close - 2][1].start)
    };
    media = [
        [
            'enter',
            group,
            context
        ],
        [
            'enter',
            label,
            context
        ]
    ];
    // Opening marker.
    media = (0, $5e612816a43dd8d9$export$4cbf152802aa238)(media, events.slice(open + 1, open + offset + 3));
    // Text open.
    media = (0, $5e612816a43dd8d9$export$4cbf152802aa238)(media, [
        [
            'enter',
            text,
            context
        ]
    ]);
    // Always populated by defaults.
    // Between.
    media = (0, $5e612816a43dd8d9$export$4cbf152802aa238)(media, (0, $a7db008f78200e80$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context));
    // Text close, marker close, label close.
    media = (0, $5e612816a43dd8d9$export$4cbf152802aa238)(media, [
        [
            'exit',
            text,
            context
        ],
        events[close - 2],
        events[close - 1],
        [
            'exit',
            label,
            context
        ]
    ]);
    // Reference, resource, or so.
    media = (0, $5e612816a43dd8d9$export$4cbf152802aa238)(media, events.slice(close + 1));
    // Media close.
    media = (0, $5e612816a43dd8d9$export$4cbf152802aa238)(media, [
        [
            'exit',
            group,
            context
        ]
    ]);
    (0, $5e612816a43dd8d9$export$869882364835d202)(events, open, events.length, media);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $7911f51dbd5582ba$var$tokenizeLabelEnd(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    /** @type {Token} */ let labelStart;
    /** @type {boolean} */ let defined;
    // Find an opening.
    while(index--)if ((self.events[index][1].type === 'labelImage' || self.events[index][1].type === 'labelLink') && !self.events[index][1]._balanced) {
        labelStart = self.events[index][1];
        break;
    }
    return start;
    /**
   * Start of label end.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   * ```
   *
   * @type {State}
   */ function start(code) {
        // If there is not an okay opening.
        if (!labelStart) return nok(code);
        // If the corresponding label (link) start is marked as inactive,
        // it means we’d be wrapping a link, like this:
        //
        // ```markdown
        // > | a [b [c](d) e](f) g.
        //                  ^
        // ```
        //
        // We can’t have that, so it’s just balanced brackets.
        if (labelStart._inactive) return labelEndNok(code);
        defined = self.parser.defined.includes((0, $e41ed80474602082$export$806d55e226cfcd08)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        })));
        effects.enter('labelEnd');
        effects.enter('labelMarker');
        effects.consume(code);
        effects.exit('labelMarker');
        effects.exit('labelEnd');
        return after;
    }
    /**
   * After `]`.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Note: `markdown-rs` also parses GFM footnotes here, which for us is in
        // an extension.
        // Resource (`[asd](fgh)`)?
        if (code === 40) return effects.attempt($7911f51dbd5582ba$var$resourceConstruct, labelEndOk, defined ? labelEndOk : labelEndNok)(code);
        // Full (`[asd][fgh]`) or collapsed (`[asd][]`) reference?
        if (code === 91) return effects.attempt($7911f51dbd5582ba$var$referenceFullConstruct, labelEndOk, defined ? referenceNotFull : labelEndNok)(code);
        // Shortcut (`[asd]`) reference?
        return defined ? labelEndOk(code) : labelEndNok(code);
    }
    /**
   * After `]`, at `[`, but not at a full reference.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] b
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceNotFull(code) {
        return effects.attempt($7911f51dbd5582ba$var$referenceCollapsedConstruct, labelEndOk, labelEndNok)(code);
    }
    /**
   * Done, we found something.
   *
   * ```markdown
   * > | [a](b) c
   *           ^
   * > | [a][b] c
   *           ^
   * > | [a][] b
   *          ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndOk(code) {
        // Note: `markdown-rs` does a bunch of stuff here.
        return ok(code);
    }
    /**
   * Done, it’s nothing.
   *
   * There was an okay opening, but we didn’t match anything.
   *
   * ```markdown
   * > | [a](b c
   *        ^
   * > | [a][b c
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndNok(code) {
        labelStart._balanced = true;
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $7911f51dbd5582ba$var$tokenizeResource(effects, ok, nok) {
    return resourceStart;
    /**
   * At a resource.
   *
   * ```markdown
   * > | [a](b) c
   *        ^
   * ```
   *
   * @type {State}
   */ function resourceStart(code) {
        effects.enter('resource');
        effects.enter('resourceMarker');
        effects.consume(code);
        effects.exit('resourceMarker');
        return resourceBefore;
    }
    /**
   * In resource, after `(`, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceBefore(code) {
        return (0, $a967d3607431391e$export$a30284361b3814b7)(code) ? (0, $48659b40c7eec554$export$1f27bd1aa33ce173)(effects, resourceOpen)(code) : resourceOpen(code);
    }
    /**
   * In resource, after optional whitespace, at `)` or a destination.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceOpen(code) {
        if (code === 41) return resourceEnd(code);
        return (0, $d9459511544b920a$export$2e6c8deaa96af245)(effects, resourceDestinationAfter, resourceDestinationMissing, 'resourceDestination', 'resourceDestinationLiteral', 'resourceDestinationLiteralMarker', 'resourceDestinationRaw', 'resourceDestinationString', 32)(code);
    }
    /**
   * In resource, after destination, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationAfter(code) {
        return (0, $a967d3607431391e$export$a30284361b3814b7)(code) ? (0, $48659b40c7eec554$export$1f27bd1aa33ce173)(effects, resourceBetween)(code) : resourceEnd(code);
    }
    /**
   * At invalid destination.
   *
   * ```markdown
   * > | [a](<<) b
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationMissing(code) {
        return nok(code);
    }
    /**
   * In resource, after destination and whitespace, at `(` or title.
   *
   * ```markdown
   * > | [a](b ) c
   *           ^
   * ```
   *
   * @type {State}
   */ function resourceBetween(code) {
        if (code === 34 || code === 39 || code === 40) return (0, $a4f1de42e1e8107b$export$f970569cc855e483)(effects, resourceTitleAfter, nok, 'resourceTitle', 'resourceTitleMarker', 'resourceTitleString')(code);
        return resourceEnd(code);
    }
    /**
   * In resource, after title, at optional whitespace.
   *
   * ```markdown
   * > | [a](b "c") d
   *              ^
   * ```
   *
   * @type {State}
   */ function resourceTitleAfter(code) {
        return (0, $a967d3607431391e$export$a30284361b3814b7)(code) ? (0, $48659b40c7eec554$export$1f27bd1aa33ce173)(effects, resourceEnd)(code) : resourceEnd(code);
    }
    /**
   * In resource, at `)`.
   *
   * ```markdown
   * > | [a](b) d
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceEnd(code) {
        if (code === 41) {
            effects.enter('resourceMarker');
            effects.consume(code);
            effects.exit('resourceMarker');
            effects.exit('resource');
            return ok;
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $7911f51dbd5582ba$var$tokenizeReferenceFull(effects, ok, nok) {
    const self = this;
    return referenceFull;
    /**
   * In a reference (full), at the `[`.
   *
   * ```markdown
   * > | [a][b] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFull(code) {
        return (0, $841e56874cc763b9$export$7b768614d8ba97a7).call(self, effects, referenceFullAfter, referenceFullMissing, 'reference', 'referenceMarker', 'referenceString')(code);
    }
    /**
   * In a reference (full), after `]`.
   *
   * ```markdown
   * > | [a][b] d
   *          ^
   * ```
   *
   * @type {State}
   */ function referenceFullAfter(code) {
        return self.parser.defined.includes((0, $e41ed80474602082$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) ? ok(code) : nok(code);
    }
    /**
   * In reference (full) that was missing.
   *
   * ```markdown
   * > | [a][b d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFullMissing(code) {
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $7911f51dbd5582ba$var$tokenizeReferenceCollapsed(effects, ok, nok) {
    return referenceCollapsedStart;
    /**
   * In reference (collapsed), at `[`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceCollapsedStart(code) {
        // We only attempt a collapsed label if there’s a `[`.
        effects.enter('reference');
        effects.enter('referenceMarker');
        effects.consume(code);
        effects.exit('referenceMarker');
        return referenceCollapsedOpen;
    }
    /**
   * In reference (collapsed), at `]`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *         ^
   * ```
   *
   *  @type {State}
   */ function referenceCollapsedOpen(code) {
        if (code === 93) {
            effects.enter('referenceMarker');
            effects.consume(code);
            effects.exit('referenceMarker');
            effects.exit('reference');
            return ok;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $8c66c68fd6b8c905$export$3d754936e25aa5f5 = {
    name: 'labelStartImage',
    tokenize: $8c66c68fd6b8c905$var$tokenizeLabelStartImage,
    resolveAll: (0, $7911f51dbd5582ba$export$470a5dafbbf62654).resolveAll
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $8c66c68fd6b8c905$var$tokenizeLabelStartImage(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (image) start.
   *
   * ```markdown
   * > | a ![b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('labelImage');
        effects.enter('labelImageMarker');
        effects.consume(code);
        effects.exit('labelImageMarker');
        return open;
    }
    /**
   * After `!`, at `[`.
   *
   * ```markdown
   * > | a ![b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 91) {
            effects.enter('labelMarker');
            effects.consume(code);
            effects.exit('labelMarker');
            effects.exit('labelImage');
            return after;
        }
        return nok(code);
    }
    /**
   * After `![`.
   *
   * ```markdown
   * > | a ![b] c
   *         ^
   * ```
   *
   * This is needed in because, when GFM footnotes are enabled, images never
   * form when started with a `^`.
   * Instead, links form:
   *
   * ```markdown
   * ![^a](b)
   *
   * ![^a][b]
   *
   * [b]: c
   * ```
   *
   * ```html
   * <p>!<a href=\"b\">^a</a></p>
   * <p>!<a href=\"c\">^a</a></p>
   * ```
   *
   * @type {State}
   */ function after(code) {
        // To do: use a new field to do this, this is still needed for
        // `micromark-extension-gfm-footnote`, but the `label-start-link`
        // behavior isn’t.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $6863fa32df57e96a$export$5c0cee0701a3b584 = {
    name: 'labelStartLink',
    tokenize: $6863fa32df57e96a$var$tokenizeLabelStartLink,
    resolveAll: (0, $7911f51dbd5582ba$export$470a5dafbbf62654).resolveAll
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $6863fa32df57e96a$var$tokenizeLabelStartLink(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (link) start.
   *
   * ```markdown
   * > | a [b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('labelLink');
        effects.enter('labelMarker');
        effects.consume(code);
        effects.exit('labelMarker');
        effects.exit('labelLink');
        return after;
    }
    /** @type {State} */ function after(code) {
        // To do: this isn’t needed in `micromark-extension-gfm-footnote`,
        // remove.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $df7050672ddd3f55$export$8e62e0ad51c97b2 = {
    name: 'lineEnding',
    tokenize: $df7050672ddd3f55$var$tokenizeLineEnding
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $df7050672ddd3f55$var$tokenizeLineEnding(effects, ok) {
    return start;
    /** @type {State} */ function start(code) {
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return (0, $602eae48ac3dea9e$export$ae105c1eb063a0a2)(effects, ok, 'linePrefix');
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 


/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $5ccdb290d9e77dba$export$ba7b13e047416c03 = {
    name: 'thematicBreak',
    tokenize: $5ccdb290d9e77dba$var$tokenizeThematicBreak
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $5ccdb290d9e77dba$var$tokenizeThematicBreak(effects, ok, nok) {
    let size = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of thematic break.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('thematicBreak');
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * After optional whitespace, at marker.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        marker = code;
        return atBreak(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.enter('thematicBreakSequence');
            return sequence(code);
        }
        if (size >= 3 && (code === null || (0, $a967d3607431391e$export$34a1dff1c0936953)(code))) {
            effects.exit('thematicBreak');
            return ok(code);
        }
        return nok(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            size++;
            return sequence;
        }
        effects.exit('thematicBreakSequence');
        return (0, $a967d3607431391e$export$2c6cf65c1127992a)(code) ? (0, $602eae48ac3dea9e$export$ae105c1eb063a0a2)(effects, atBreak, 'whitespace')(code) : atBreak(code);
    }
}


const $b34ddba85a94ed06$export$8837f4fc672e936d = {
    name: 'list',
    tokenize: $b34ddba85a94ed06$var$tokenizeListStart,
    continuation: {
        tokenize: $b34ddba85a94ed06$var$tokenizeListContinuation
    },
    exit: $b34ddba85a94ed06$var$tokenizeListEnd
};
/** @type {Construct} */ const $b34ddba85a94ed06$var$listItemPrefixWhitespaceConstruct = {
    tokenize: $b34ddba85a94ed06$var$tokenizeListItemPrefixWhitespace,
    partial: true
};
/** @type {Construct} */ const $b34ddba85a94ed06$var$indentConstruct = {
    tokenize: $b34ddba85a94ed06$var$tokenizeIndent,
    partial: true
};
// To do: `markdown-rs` parses list items on their own and later stitches them
// together.
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $b34ddba85a94ed06$var$tokenizeListStart(effects, ok, nok) {
    const self = this;
    const tail = self.events[self.events.length - 1];
    let initialSize = tail && tail[1].type === 'linePrefix' ? tail[2].sliceSerialize(tail[1], true).length : 0;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        const kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? 'listUnordered' : 'listOrdered');
        if (kind === 'listUnordered' ? !self.containerState.marker || code === self.containerState.marker : (0, $a967d3607431391e$export$ca8b5b1a6c320e6e)(code)) {
            if (!self.containerState.type) {
                self.containerState.type = kind;
                effects.enter(kind, {
                    _container: true
                });
            }
            if (kind === 'listUnordered') {
                effects.enter('listItemPrefix');
                return code === 42 || code === 45 ? effects.check((0, $5ccdb290d9e77dba$export$ba7b13e047416c03), nok, atMarker)(code) : atMarker(code);
            }
            if (!self.interrupt || code === 49) {
                effects.enter('listItemPrefix');
                effects.enter('listItemValue');
                return inside(code);
            }
        }
        return nok(code);
    }
    /** @type {State} */ function inside(code) {
        if ((0, $a967d3607431391e$export$ca8b5b1a6c320e6e)(code) && ++size < 10) {
            effects.consume(code);
            return inside;
        }
        if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
            effects.exit('listItemValue');
            return atMarker(code);
        }
        return nok(code);
    }
    /**
   * @type {State}
   **/ function atMarker(code) {
        effects.enter('listItemMarker');
        effects.consume(code);
        effects.exit('listItemMarker');
        self.containerState.marker = self.containerState.marker || code;
        return effects.check((0, $231ee94245fc5c87$export$d50d28ce3ab2a612), // Can’t be empty when interrupting.
        self.interrupt ? nok : onBlank, effects.attempt($b34ddba85a94ed06$var$listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
    }
    /** @type {State} */ function onBlank(code) {
        self.containerState.initialBlankLine = true;
        initialSize++;
        return endOfPrefix(code);
    }
    /** @type {State} */ function otherPrefix(code) {
        if ((0, $a967d3607431391e$export$2c6cf65c1127992a)(code)) {
            effects.enter('listItemPrefixWhitespace');
            effects.consume(code);
            effects.exit('listItemPrefixWhitespace');
            return endOfPrefix;
        }
        return nok(code);
    }
    /** @type {State} */ function endOfPrefix(code) {
        self.containerState.size = initialSize + self.sliceSerialize(effects.exit('listItemPrefix'), true).length;
        return ok(code);
    }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $b34ddba85a94ed06$var$tokenizeListContinuation(effects, ok, nok) {
    const self = this;
    self.containerState._closeFlow = undefined;
    return effects.check((0, $231ee94245fc5c87$export$d50d28ce3ab2a612), onBlank, notBlank);
    /** @type {State} */ function onBlank(code) {
        self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine;
        // We have a blank line.
        // Still, try to consume at most the items size.
        return (0, $602eae48ac3dea9e$export$ae105c1eb063a0a2)(effects, ok, 'listItemIndent', self.containerState.size + 1)(code);
    }
    /** @type {State} */ function notBlank(code) {
        if (self.containerState.furtherBlankLines || !(0, $a967d3607431391e$export$2c6cf65c1127992a)(code)) {
            self.containerState.furtherBlankLines = undefined;
            self.containerState.initialBlankLine = undefined;
            return notInCurrentItem(code);
        }
        self.containerState.furtherBlankLines = undefined;
        self.containerState.initialBlankLine = undefined;
        return effects.attempt($b34ddba85a94ed06$var$indentConstruct, ok, notInCurrentItem)(code);
    }
    /** @type {State} */ function notInCurrentItem(code) {
        // While we do continue, we signal that the flow should be closed.
        self.containerState._closeFlow = true;
        // As we’re closing flow, we’re no longer interrupting.
        self.interrupt = undefined;
        // Always populated by defaults.
        return (0, $602eae48ac3dea9e$export$ae105c1eb063a0a2)(effects, effects.attempt($b34ddba85a94ed06$export$8837f4fc672e936d, ok, nok), 'linePrefix', self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
    }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $b34ddba85a94ed06$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $602eae48ac3dea9e$export$ae105c1eb063a0a2)(effects, afterPrefix, 'listItemIndent', self.containerState.size + 1);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === 'listItemIndent' && tail[2].sliceSerialize(tail[1], true).length === self.containerState.size ? ok(code) : nok(code);
    }
}
/**
 * @type {Exiter}
 * @this {TokenizeContext}
 */ function $b34ddba85a94ed06$var$tokenizeListEnd(effects) {
    effects.exit(this.containerState.type);
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $b34ddba85a94ed06$var$tokenizeListItemPrefixWhitespace(effects, ok, nok) {
    const self = this;
    // Always populated by defaults.
    return (0, $602eae48ac3dea9e$export$ae105c1eb063a0a2)(effects, afterPrefix, 'listItemPrefixWhitespace', self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 5);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return !(0, $a967d3607431391e$export$2c6cf65c1127992a)(code) && tail && tail[1].type === 'listItemPrefixWhitespace' ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $c42b85decda1f4a6$export$e104e2de391dfde9 = {
    name: 'setextUnderline',
    tokenize: $c42b85decda1f4a6$var$tokenizeSetextUnderline,
    resolveTo: $c42b85decda1f4a6$var$resolveToSetextUnderline
};
/** @type {Resolver} */ function $c42b85decda1f4a6$var$resolveToSetextUnderline(events, context) {
    // To do: resolve like `markdown-rs`.
    let index = events.length;
    /** @type {number | undefined} */ let content;
    /** @type {number | undefined} */ let text;
    /** @type {number | undefined} */ let definition;
    // Find the opening of the content.
    // It’ll always exist: we don’t tokenize if it isn’t there.
    while(index--)if (events[index][0] === 'enter') {
        if (events[index][1].type === 'content') {
            content = index;
            break;
        }
        if (events[index][1].type === 'paragraph') text = index;
    } else {
        if (events[index][1].type === 'content') // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
        if (!definition && events[index][1].type === 'definition') definition = index;
    }
    const heading = {
        type: 'setextHeading',
        start: Object.assign({}, events[text][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    // Change the paragraph to setext heading text.
    events[text][1].type = 'setextHeadingText';
    // If we have definitions in the content, we’ll keep on having content,
    // but we need move it.
    if (definition) {
        events.splice(text, 0, [
            'enter',
            heading,
            context
        ]);
        events.splice(definition + 1, 0, [
            'exit',
            events[content][1],
            context
        ]);
        events[content][1].end = Object.assign({}, events[definition][1].end);
    } else events[content][1] = heading;
    // Add the heading exit at the end.
    events.push([
        'exit',
        heading,
        context
    ]);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $c42b85decda1f4a6$var$tokenizeSetextUnderline(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * At start of heading (setext) underline.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        let index = self.events.length;
        /** @type {boolean | undefined} */ let paragraph;
        // Find an opening.
        while(index--)// Skip enter/exit of line ending, line prefix, and content.
        // We can now either have a definition or a paragraph.
        if (self.events[index][1].type !== 'lineEnding' && self.events[index][1].type !== 'linePrefix' && self.events[index][1].type !== 'content') {
            paragraph = self.events[index][1].type === 'paragraph';
            break;
        }
        // To do: handle lazy/pierce like `markdown-rs`.
        // To do: parse indent like `markdown-rs`.
        if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
            effects.enter('setextHeadingLine');
            marker = code;
            return before(code);
        }
        return nok(code);
    }
    /**
   * After optional whitespace, at `-` or `=`.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter('setextHeadingLineSequence');
        return inside(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        effects.exit('setextHeadingLineSequence');
        return (0, $a967d3607431391e$export$2c6cf65c1127992a)(code) ? (0, $602eae48ac3dea9e$export$ae105c1eb063a0a2)(effects, after, 'lineSuffix')(code) : after(code);
    }
    /**
   * After sequence, after optional whitespace.
   *
   * ```markdown
   *   | aa
   * > | ==
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if (code === null || (0, $a967d3607431391e$export$34a1dff1c0936953)(code)) {
            effects.exit('setextHeadingLine');
            return ok(code);
        }
        return nok(code);
    }
}



const $38c5b8a1dbcce833$export$5a7bfc01df82fcd1 = {
    [42]: (0, $b34ddba85a94ed06$export$8837f4fc672e936d),
    [43]: (0, $b34ddba85a94ed06$export$8837f4fc672e936d),
    [45]: (0, $b34ddba85a94ed06$export$8837f4fc672e936d),
    [48]: (0, $b34ddba85a94ed06$export$8837f4fc672e936d),
    [49]: (0, $b34ddba85a94ed06$export$8837f4fc672e936d),
    [50]: (0, $b34ddba85a94ed06$export$8837f4fc672e936d),
    [51]: (0, $b34ddba85a94ed06$export$8837f4fc672e936d),
    [52]: (0, $b34ddba85a94ed06$export$8837f4fc672e936d),
    [53]: (0, $b34ddba85a94ed06$export$8837f4fc672e936d),
    [54]: (0, $b34ddba85a94ed06$export$8837f4fc672e936d),
    [55]: (0, $b34ddba85a94ed06$export$8837f4fc672e936d),
    [56]: (0, $b34ddba85a94ed06$export$8837f4fc672e936d),
    [57]: (0, $b34ddba85a94ed06$export$8837f4fc672e936d),
    [62]: (0, $2d60636958356360$export$200dcd0a5903c968)
};
const $38c5b8a1dbcce833$export$5a2181fb44b58173 = {
    [91]: (0, $b9388d71e52b125b$export$69f215ed977cdb73)
};
const $38c5b8a1dbcce833$export$cf8bead395eff824 = {
    [-2]: (0, $067e2f85c5820cf1$export$47910b7ab28d1853),
    [-1]: (0, $067e2f85c5820cf1$export$47910b7ab28d1853),
    [32]: (0, $067e2f85c5820cf1$export$47910b7ab28d1853)
};
const $38c5b8a1dbcce833$export$ccc7b0636abaffc3 = {
    [35]: (0, $c7653936fe864536$export$3871e9deb360695c),
    [42]: (0, $5ccdb290d9e77dba$export$ba7b13e047416c03),
    [45]: [
        (0, $c42b85decda1f4a6$export$e104e2de391dfde9),
        (0, $5ccdb290d9e77dba$export$ba7b13e047416c03)
    ],
    [60]: (0, $5039b0600d59fdd9$export$476ac411cb7d0d8f),
    [61]: (0, $c42b85decda1f4a6$export$e104e2de391dfde9),
    [95]: (0, $5ccdb290d9e77dba$export$ba7b13e047416c03),
    [96]: (0, $a4ad67fa4c34f4a0$export$c23e4921f8d87e7c),
    [126]: (0, $a4ad67fa4c34f4a0$export$c23e4921f8d87e7c)
};
const $38c5b8a1dbcce833$export$22b082955e083ec3 = {
    [38]: (0, $e67aea4f6e667164$export$e31905600aaf3d8e),
    [92]: (0, $02cb63cd83f0abed$export$2005478564e78d96)
};
const $38c5b8a1dbcce833$export$6f093cfa640b7166 = {
    [-5]: (0, $df7050672ddd3f55$export$8e62e0ad51c97b2),
    [-4]: (0, $df7050672ddd3f55$export$8e62e0ad51c97b2),
    [-3]: (0, $df7050672ddd3f55$export$8e62e0ad51c97b2),
    [33]: (0, $8c66c68fd6b8c905$export$3d754936e25aa5f5),
    [38]: (0, $e67aea4f6e667164$export$e31905600aaf3d8e),
    [42]: (0, $2914a5bd571ad3f6$export$45b92471da762af7),
    [60]: [
        (0, $3321952f24a8c2bf$export$17ddf85e4c916ad6),
        (0, $e886134b78912936$export$398af27f284914fe)
    ],
    [91]: (0, $6863fa32df57e96a$export$5c0cee0701a3b584),
    [92]: [
        (0, $00ae8f5ed19b00f4$export$86c573ab9e06f418),
        (0, $02cb63cd83f0abed$export$2005478564e78d96)
    ],
    [93]: (0, $7911f51dbd5582ba$export$470a5dafbbf62654),
    [95]: (0, $2914a5bd571ad3f6$export$45b92471da762af7),
    [96]: (0, $94b5a13c82b48dc5$export$d24f93e715f9df88)
};
const $38c5b8a1dbcce833$export$d44f260a3f9b69f5 = {
    null: [
        (0, $2914a5bd571ad3f6$export$45b92471da762af7),
        (0, $70c7ce3ee5a8f588$export$50397835cbfdbc24)
    ]
};
const $38c5b8a1dbcce833$export$b9c0b60d74426aea = {
    null: [
        42,
        95
    ]
};
const $38c5b8a1dbcce833$export$e20fbacbb41798b = {
    null: []
};


function $560d30bb4fcf5f1d$export$98e6a39c04603d36(options) {
    const settings = options || {};
    const constructs = /** @type {FullNormalizedExtension} */ (0, $2a95a8469ca77757$export$86a865d89ef3c690)([
        $38c5b8a1dbcce833$exports,
        ...settings.extensions || []
    ]);
    /** @type {ParseContext} */ const parser = {
        defined: [],
        lazy: {},
        constructs: constructs,
        content: create((0, $1a59ff6b3b229e4f$export$a7db06668cad9adb)),
        document: create((0, $c2e10b7bcc4d280f$export$5a7bfc01df82fcd1)),
        flow: create((0, $142c2d2926b9eb29$export$ccc7b0636abaffc3)),
        string: create((0, $70c7ce3ee5a8f588$export$22b082955e083ec3)),
        text: create((0, $70c7ce3ee5a8f588$export$6f093cfa640b7166))
    };
    return parser;
    /**
   * @param {InitialConstruct} initial
   */ function create(initial) {
        return creator;
        /** @type {Create} */ function creator(from) {
            return (0, $b9f5a97a12a1617f$export$ae34f10ee4b29837)(parser, initial, from);
        }
    }
}


/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Value} Value
 */ /**
 * @callback Preprocessor
 * @param {Value} value
 * @param {Encoding | null | undefined} [encoding]
 * @param {boolean | null | undefined} [end=false]
 * @returns {Array<Chunk>}
 */ const $4e7fb73136b0ca71$var$search = /[\0\t\n\r]/g;
function $4e7fb73136b0ca71$export$fc37fe19dfda43ee() {
    let column = 1;
    let buffer = '';
    /** @type {boolean | undefined} */ let start = true;
    /** @type {boolean | undefined} */ let atCarriageReturn;
    return preprocessor;
    /** @type {Preprocessor} */ function preprocessor(value, encoding, end) {
        /** @type {Array<Chunk>} */ const chunks = [];
        /** @type {RegExpMatchArray | null} */ let match;
        /** @type {number} */ let next;
        /** @type {number} */ let startPosition;
        /** @type {number} */ let endPosition;
        /** @type {Code} */ let code;
        // @ts-expect-error `Buffer` does allow an encoding.
        value = buffer + value.toString(encoding);
        startPosition = 0;
        buffer = '';
        if (start) {
            // To do: `markdown-rs` actually parses BOMs (byte order mark).
            if (value.charCodeAt(0) === 65279) startPosition++;
            start = undefined;
        }
        while(startPosition < value.length){
            $4e7fb73136b0ca71$var$search.lastIndex = startPosition;
            match = $4e7fb73136b0ca71$var$search.exec(value);
            endPosition = match && match.index !== undefined ? match.index : value.length;
            code = value.charCodeAt(endPosition);
            if (!match) {
                buffer = value.slice(startPosition);
                break;
            }
            if (code === 10 && startPosition === endPosition && atCarriageReturn) {
                chunks.push(-3);
                atCarriageReturn = undefined;
            } else {
                if (atCarriageReturn) {
                    chunks.push(-5);
                    atCarriageReturn = undefined;
                }
                if (startPosition < endPosition) {
                    chunks.push(value.slice(startPosition, endPosition));
                    column += endPosition - startPosition;
                }
                switch(code){
                    case 0:
                        chunks.push(65533);
                        column++;
                        break;
                    case 9:
                        next = Math.ceil(column / 4) * 4;
                        chunks.push(-2);
                        while(column++ < next)chunks.push(-1);
                        break;
                    case 10:
                        chunks.push(-4);
                        column = 1;
                        break;
                    default:
                        atCarriageReturn = true;
                        column = 1;
                }
            }
            startPosition = endPosition + 1;
        }
        if (end) {
            if (atCarriageReturn) chunks.push(-5);
            if (buffer) chunks.push(buffer);
            chunks.push(null);
        }
        return chunks;
    }
}


/**
 * @typedef {import('micromark-util-types').Event} Event
 */ 
function $e919e1553354373c$export$bd0e6e1378a871d7(events) {
    while(!(0, $614962c54f47e6e7$export$12949d1dd00fddf4)(events));
    return events;
}


/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * Sort of like `String.fromCharCode(Number.parseInt(value, base))`, but makes
 * non-characters and control characters safe.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 *   Character.
 */ function $bcd9fb83ca0a1b4a$export$15a69557afac2c20(value, base) {
    const code = Number.parseInt(value, base);
    if (// C0 except for HT, LF, FF, CR, space.
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of C0, and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || (code & 65535) === 65535 || (code & 65535) === 65534 /* eslint-enable no-bitwise */  || // Out of range
    code > 1114111) return '\uFFFD';
    return String.fromCharCode(code);
}




const $ffe56b5769e270cf$var$characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function $ffe56b5769e270cf$export$a0fb664af7d0cc44(value) {
    return value.replace($ffe56b5769e270cf$var$characterEscapeOrReference, $ffe56b5769e270cf$var$decode);
}
/**
 * @param {string} $0
 * @param {string} $1
 * @param {string} $2
 * @returns {string}
 */ function $ffe56b5769e270cf$var$decode($0, $1, $2) {
    if ($1) // Escape.
    return $1;
    // Reference.
    const head = $2.charCodeAt(0);
    if (head === 35) {
        const head = $2.charCodeAt(1);
        const hex = head === 120 || head === 88;
        return (0, $bcd9fb83ca0a1b4a$export$15a69557afac2c20)($2.slice(hex ? 2 : 1), hex ? 16 : 10);
    }
    return (0, $63b35e5117053cb4$export$289b6a6320f709b4)($2) || $0;
}





const $868092e410d31d98$var$own = {}.hasOwnProperty;
const $868092e410d31d98$export$d744d789c09bfde6 = /**
   * @type {(
   *   ((value: Value, encoding: Encoding, options?: Options | null | undefined) => Root) &
   *   ((value: Value, options?: Options | null | undefined) => Root)
   * )}
   */ /**
   * @param {Value} value
   * @param {Encoding | Options | null | undefined} [encoding]
   * @param {Options | null | undefined} [options]
   * @returns {Root}
   */ function(value, encoding, options) {
    if (typeof encoding !== 'string') {
        options = encoding;
        encoding = undefined;
    }
    return $868092e410d31d98$var$compiler(options)((0, $e919e1553354373c$export$bd0e6e1378a871d7)((0, $560d30bb4fcf5f1d$export$98e6a39c04603d36)(options).document().write((0, $4e7fb73136b0ca71$export$fc37fe19dfda43ee)()(value, encoding, true))));
};
/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options | null | undefined} [options]
 */ function $868092e410d31d98$var$compiler(options) {
    /** @type {Config} */ const config = {
        transforms: [],
        canContainEols: [
            'emphasis',
            'fragment',
            'heading',
            'paragraph',
            'strong'
        ],
        enter: {
            autolink: opener(link),
            autolinkProtocol: onenterdata,
            autolinkEmail: onenterdata,
            atxHeading: opener(heading),
            blockQuote: opener(blockQuote),
            characterEscape: onenterdata,
            characterReference: onenterdata,
            codeFenced: opener(codeFlow),
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: opener(codeFlow, buffer),
            codeText: opener(codeText, buffer),
            codeTextData: onenterdata,
            data: onenterdata,
            codeFlowValue: onenterdata,
            definition: opener(definition),
            definitionDestinationString: buffer,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: opener(emphasis),
            hardBreakEscape: opener(hardBreak),
            hardBreakTrailing: opener(hardBreak),
            htmlFlow: opener(html, buffer),
            htmlFlowData: onenterdata,
            htmlText: opener(html, buffer),
            htmlTextData: onenterdata,
            image: opener(image),
            label: buffer,
            link: opener(link),
            listItem: opener(listItem),
            listItemValue: onenterlistitemvalue,
            listOrdered: opener(list, onenterlistordered),
            listUnordered: opener(list),
            paragraph: opener(paragraph),
            reference: onenterreference,
            referenceString: buffer,
            resourceDestinationString: buffer,
            resourceTitleString: buffer,
            setextHeading: opener(heading),
            strong: opener(strong),
            thematicBreak: opener(thematicBreak)
        },
        exit: {
            atxHeading: closer(),
            atxHeadingSequence: onexitatxheadingsequence,
            autolink: closer(),
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: closer(),
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: closer(onexitcodefenced),
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onexitcodefencedfencemeta,
            codeFlowValue: onexitdata,
            codeIndented: closer(onexitcodeindented),
            codeText: closer(onexitcodetext),
            codeTextData: onexitdata,
            data: onexitdata,
            definition: closer(),
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: closer(),
            hardBreakEscape: closer(onexithardbreak),
            hardBreakTrailing: closer(onexithardbreak),
            htmlFlow: closer(onexithtmlflow),
            htmlFlowData: onexitdata,
            htmlText: closer(onexithtmltext),
            htmlTextData: onexitdata,
            image: closer(onexitimage),
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: closer(onexitlink),
            listItem: closer(),
            listOrdered: closer(),
            listUnordered: closer(),
            paragraph: closer(),
            referenceString: onexitreferencestring,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            resource: onexitresource,
            setextHeading: closer(onexitsetextheading),
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: closer(),
            thematicBreak: closer()
        }
    };
    $868092e410d31d98$var$configure(config, (options || {}).mdastExtensions || []);
    /** @type {CompileData} */ const data = {};
    return compile;
    /**
   * Turn micromark events into an mdast tree.
   *
   * @param {Array<Event>} events
   *   Events.
   * @returns {Root}
   *   mdast tree.
   */ function compile(events) {
        /** @type {Root} */ let tree = {
            type: 'root',
            children: []
        };
        /** @type {Omit<CompileContext, 'sliceSerialize'>} */ const context = {
            stack: [
                tree
            ],
            tokenStack: [],
            config: config,
            enter: enter,
            exit: exit,
            buffer: buffer,
            resume: resume,
            setData: setData,
            getData: getData
        };
        /** @type {Array<number>} */ const listStack = [];
        let index = -1;
        while(++index < events.length)// We preprocess lists to add `listItem` tokens, and to infer whether
        // items the list itself are spread out.
        if (events[index][1].type === 'listOrdered' || events[index][1].type === 'listUnordered') {
            if (events[index][0] === 'enter') listStack.push(index);
            else {
                const tail = listStack.pop();
                index = prepareList(events, tail, index);
            }
        }
        index = -1;
        while(++index < events.length){
            const handler = config[events[index][0]];
            if ($868092e410d31d98$var$own.call(handler, events[index][1].type)) handler[events[index][1].type].call(Object.assign({
                sliceSerialize: events[index][2].sliceSerialize
            }, context), events[index][1]);
        }
        // Handle tokens still being open.
        if (context.tokenStack.length > 0) {
            const tail = context.tokenStack[context.tokenStack.length - 1];
            const handler = tail[1] || $868092e410d31d98$var$defaultOnError;
            handler.call(context, undefined, tail[0]);
        }
        // Figure out `root` position.
        tree.position = {
            start: $868092e410d31d98$var$point(events.length > 0 ? events[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: $868092e410d31d98$var$point(events.length > 0 ? events[events.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        };
        // Call transforms.
        index = -1;
        while(++index < config.transforms.length)tree = config.transforms[index](tree) || tree;
        return tree;
    }
    /**
   * @param {Array<Event>} events
   * @param {number} start
   * @param {number} length
   * @returns {number}
   */ function prepareList(events, start, length) {
        let index = start - 1;
        let containerBalance = -1;
        let listSpread = false;
        /** @type {Token | undefined} */ let listItem;
        /** @type {number | undefined} */ let lineIndex;
        /** @type {number | undefined} */ let firstBlankLineIndex;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index <= length){
            const event = events[index];
            if (event[1].type === 'listUnordered' || event[1].type === 'listOrdered' || event[1].type === 'blockQuote') {
                if (event[0] === 'enter') containerBalance++;
                else containerBalance--;
                atMarker = undefined;
            } else if (event[1].type === 'lineEndingBlank') {
                if (event[0] === 'enter') {
                    if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
                    atMarker = undefined;
                }
            } else if (event[1].type === 'linePrefix' || event[1].type === 'listItemValue' || event[1].type === 'listItemMarker' || event[1].type === 'listItemPrefix' || event[1].type === 'listItemPrefixWhitespace') ;
            else atMarker = undefined;
            if (!containerBalance && event[0] === 'enter' && event[1].type === 'listItemPrefix' || containerBalance === -1 && event[0] === 'exit' && (event[1].type === 'listUnordered' || event[1].type === 'listOrdered')) {
                if (listItem) {
                    let tailIndex = index;
                    lineIndex = undefined;
                    while(tailIndex--){
                        const tailEvent = events[tailIndex];
                        if (tailEvent[1].type === 'lineEnding' || tailEvent[1].type === 'lineEndingBlank') {
                            if (tailEvent[0] === 'exit') continue;
                            if (lineIndex) {
                                events[lineIndex][1].type = 'lineEndingBlank';
                                listSpread = true;
                            }
                            tailEvent[1].type = 'lineEnding';
                            lineIndex = tailIndex;
                        } else if (tailEvent[1].type === 'linePrefix' || tailEvent[1].type === 'blockQuotePrefix' || tailEvent[1].type === 'blockQuotePrefixWhitespace' || tailEvent[1].type === 'blockQuoteMarker' || tailEvent[1].type === 'listItemIndent') ;
                        else break;
                    }
                    if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) listItem._spread = true;
                    // Fix position.
                    listItem.end = Object.assign({}, lineIndex ? events[lineIndex][1].start : event[1].end);
                    events.splice(lineIndex || index, 0, [
                        'exit',
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                }
                // Create a new list item.
                if (event[1].type === 'listItemPrefix') {
                    listItem = {
                        type: 'listItem',
                        _spread: false,
                        start: Object.assign({}, event[1].start),
                        // @ts-expect-error: we’ll add `end` in a second.
                        end: undefined
                    };
                    // @ts-expect-error: `listItem` is most definitely defined, TS...
                    events.splice(index, 0, [
                        'enter',
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                    firstBlankLineIndex = undefined;
                    atMarker = true;
                }
            }
        }
        events[start][1]._spread = listSpread;
        return length;
    }
    /**
   * Set data.
   *
   * @template {keyof CompileData} Key
   *   Field type.
   * @param {Key} key
   *   Key of field.
   * @param {CompileData[Key]} [value]
   *   New value.
   * @returns {void}
   *   Nothing.
   */ function setData(key, value) {
        data[key] = value;
    }
    /**
   * Get data.
   *
   * @template {keyof CompileData} Key
   *   Field type.
   * @param {Key} key
   *   Key of field.
   * @returns {CompileData[Key]}
   *   Value.
   */ function getData(key) {
        return data[key];
    }
    /**
   * Create an opener handle.
   *
   * @param {(token: Token) => Node} create
   *   Create a node.
   * @param {Handle} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function opener(create, and) {
        return open;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {void}
     */ function open(token) {
            enter.call(this, create(token), token);
            if (and) and.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @returns {void}
   */ function buffer() {
        this.stack.push({
            type: 'fragment',
            children: []
        });
    }
    /**
   * @template {Node} Kind
   *   Node type.
   * @this {CompileContext}
   *   Context.
   * @param {Kind} node
   *   Node to enter.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnEnterError | undefined} [errorHandler]
   *   Handle the case where this token is open, but it is closed by something else.
   * @returns {Kind}
   *   The given node.
   */ function enter(node, token, errorHandler) {
        const parent = this.stack[this.stack.length - 1];
        // @ts-expect-error: Assume `Node` can exist as a child of `parent`.
        parent.children.push(node);
        this.stack.push(node);
        this.tokenStack.push([
            token,
            errorHandler
        ]);
        // @ts-expect-error: `end` will be patched later.
        node.position = {
            start: $868092e410d31d98$var$point(token.start)
        };
        return node;
    }
    /**
   * Create a closer handle.
   *
   * @param {Handle} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function closer(and) {
        return close;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {void}
     */ function close(token) {
            if (and) and.call(this, token);
            exit.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   *   Context.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnExitError | undefined} [onExitError]
   *   Handle the case where another token is open.
   * @returns {Node}
   *   The closed node.
   */ function exit(token, onExitError) {
        const node = this.stack.pop();
        const open = this.tokenStack.pop();
        if (!open) throw new Error('Cannot close `' + token.type + '` (' + (0, $9273ea25044c2ed9$export$c304dd45fe166145)({
            start: token.start,
            end: token.end
        }) + "): it\u2019s not open");
        else if (open[0].type !== token.type) {
            if (onExitError) onExitError.call(this, token, open[0]);
            else {
                const handler = open[1] || $868092e410d31d98$var$defaultOnError;
                handler.call(this, token, open[0]);
            }
        }
        node.position.end = $868092e410d31d98$var$point(token.end);
        return node;
    }
    /**
   * @this {CompileContext}
   * @returns {string}
   */ function resume() {
        return (0, $1ad50519eb9a1fd0$export$f84e8e69fd4488a5)(this.stack.pop());
    }
    //
    // Handlers.
    //
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered() {
        setData('expectingFirstListItemValue', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (getData('expectingFirstListItemValue')) {
            const ancestor = this.stack[this.stack.length - 2];
            ancestor.start = Number.parseInt(this.sliceSerialize(token), 10);
            setData('expectingFirstListItemValue');
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.lang = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfencemeta() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.meta = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        // Exit if this is the closing fence.
        if (getData('flowCodeInside')) return;
        this.buffer();
        setData('flowCodeInside', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefenced() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, '');
        setData('flowCodeInside');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeindented() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/(\r?\n|\r)$/g, '');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.label = label;
        node.identifier = (0, $e41ed80474602082$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        const node = this.stack[this.stack.length - 1];
        if (!node.depth) {
            const depth = this.sliceSerialize(token).length;
            node.depth = depth;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        setData('setextHeadingSlurpLineEnding', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        const node = this.stack[this.stack.length - 1];
        node.depth = this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        setData('setextHeadingSlurpLineEnding');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdata(token) {
        const node = this.stack[this.stack.length - 1];
        let tail = node.children[node.children.length - 1];
        if (!tail || tail.type !== 'text') {
            // Add a new text node.
            tail = text();
            // @ts-expect-error: we’ll add `end` later.
            tail.position = {
                start: $868092e410d31d98$var$point(token.start)
            };
            // @ts-expect-error: Assume `parent` accepts `text`.
            node.children.push(tail);
        }
        this.stack.push(tail);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        const tail = this.stack.pop();
        tail.value += this.sliceSerialize(token);
        tail.position.end = $868092e410d31d98$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        const context = this.stack[this.stack.length - 1];
        // If we’re at a hard break, include the line ending in there.
        if (getData('atHardBreak')) {
            const tail = context.children[context.children.length - 1];
            tail.position.end = $868092e410d31d98$var$point(token.end);
            setData('atHardBreak');
            return;
        }
        if (!getData('setextHeadingSlurpLineEnding') && config.canContainEols.includes(context.type)) {
            onenterdata.call(this, token);
            onexitdata.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        setData('atHardBreak', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmlflow() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmltext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodetext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlink() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (getData('inReference')) {
            /** @type {ReferenceType} */ const referenceType = getData('referenceType') || 'shortcut';
            node.type += 'Reference';
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        setData('referenceType');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitimage() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (getData('inReference')) {
            /** @type {ReferenceType} */ const referenceType = getData('referenceType') || 'shortcut';
            node.type += 'Reference';
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        setData('referenceType');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        const string = this.sliceSerialize(token);
        const ancestor = this.stack[this.stack.length - 2];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        ancestor.label = (0, $ffe56b5769e270cf$export$a0fb664af7d0cc44)(string);
        // @ts-expect-error: same as above.
        ancestor.identifier = (0, $e41ed80474602082$export$806d55e226cfcd08)(string).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        const fragment = this.stack[this.stack.length - 1];
        const value = this.resume();
        const node = this.stack[this.stack.length - 1];
        // Assume a reference.
        setData('inReference', true);
        if (node.type === 'link') {
            /** @type {Array<StaticPhrasingContent>} */ // @ts-expect-error: Assume static phrasing content.
            const children = fragment.children;
            node.children = children;
        } else node.alt = value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresource() {
        setData('inReference');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterreference() {
        setData('referenceType', 'collapsed');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        node.label = label;
        // @ts-expect-error: same as above.
        node.identifier = (0, $e41ed80474602082$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
        setData('referenceType', 'full');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencemarker(token) {
        setData('characterReferenceType', token.type);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const data = this.sliceSerialize(token);
        const type = getData('characterReferenceType');
        /** @type {string} */ let value;
        if (type) {
            value = (0, $bcd9fb83ca0a1b4a$export$15a69557afac2c20)(data, type === 'characterReferenceMarkerNumeric' ? 10 : 16);
            setData('characterReferenceType');
        } else {
            const result = (0, $63b35e5117053cb4$export$289b6a6320f709b4)(data);
            value = result;
        }
        const tail = this.stack.pop();
        tail.value += value;
        tail.position.end = $868092e410d31d98$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = 'mailto:' + this.sliceSerialize(token);
    }
    //
    // Creaters.
    //
    /** @returns {Blockquote} */ function blockQuote() {
        return {
            type: 'blockquote',
            children: []
        };
    }
    /** @returns {Code} */ function codeFlow() {
        return {
            type: 'code',
            lang: null,
            meta: null,
            value: ''
        };
    }
    /** @returns {InlineCode} */ function codeText() {
        return {
            type: 'inlineCode',
            value: ''
        };
    }
    /** @returns {Definition} */ function definition() {
        return {
            type: 'definition',
            identifier: '',
            label: null,
            title: null,
            url: ''
        };
    }
    /** @returns {Emphasis} */ function emphasis() {
        return {
            type: 'emphasis',
            children: []
        };
    }
    /** @returns {Heading} */ function heading() {
        // @ts-expect-error `depth` will be set later.
        return {
            type: 'heading',
            depth: undefined,
            children: []
        };
    }
    /** @returns {Break} */ function hardBreak() {
        return {
            type: 'break'
        };
    }
    /** @returns {HTML} */ function html() {
        return {
            type: 'html',
            value: ''
        };
    }
    /** @returns {Image} */ function image() {
        return {
            type: 'image',
            title: null,
            url: '',
            alt: null
        };
    }
    /** @returns {Link} */ function link() {
        return {
            type: 'link',
            title: null,
            url: '',
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {List}
   */ function list(token) {
        return {
            type: 'list',
            ordered: token.type === 'listOrdered',
            start: null,
            spread: token._spread,
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {ListItem}
   */ function listItem(token) {
        return {
            type: 'listItem',
            spread: token._spread,
            checked: null,
            children: []
        };
    }
    /** @returns {Paragraph} */ function paragraph() {
        return {
            type: 'paragraph',
            children: []
        };
    }
    /** @returns {Strong} */ function strong() {
        return {
            type: 'strong',
            children: []
        };
    }
    /** @returns {Text} */ function text() {
        return {
            type: 'text',
            value: ''
        };
    }
    /** @returns {ThematicBreak} */ function thematicBreak() {
        return {
            type: 'thematicBreak'
        };
    }
}
/**
 * Copy a point-like value.
 *
 * @param {Point} d
 *   Point-like value.
 * @returns {Point}
 *   unist point.
 */ function $868092e410d31d98$var$point(d) {
    return {
        line: d.line,
        column: d.column,
        offset: d.offset
    };
}
/**
 * @param {Config} combined
 * @param {Array<Extension | Array<Extension>>} extensions
 * @returns {void}
 */ function $868092e410d31d98$var$configure(combined, extensions) {
    let index = -1;
    while(++index < extensions.length){
        const value = extensions[index];
        if (Array.isArray(value)) $868092e410d31d98$var$configure(combined, value);
        else $868092e410d31d98$var$extension(combined, value);
    }
}
/**
 * @param {Config} combined
 * @param {Extension} extension
 * @returns {void}
 */ function $868092e410d31d98$var$extension(combined, extension) {
    /** @type {keyof Extension} */ let key;
    for(key in extension)if ($868092e410d31d98$var$own.call(extension, key)) {
        if (key === 'canContainEols') {
            const right = extension[key];
            if (right) combined[key].push(...right);
        } else if (key === 'transforms') {
            const right = extension[key];
            if (right) combined[key].push(...right);
        } else if (key === 'enter' || key === 'exit') {
            const right = extension[key];
            if (right) Object.assign(combined[key], right);
        }
    }
}
/** @type {OnEnterError} */ function $868092e410d31d98$var$defaultOnError(left, right) {
    if (left) throw new Error('Cannot close `' + left.type + '` (' + (0, $9273ea25044c2ed9$export$c304dd45fe166145)({
        start: left.start,
        end: left.end
    }) + '): a different token (`' + right.type + '`, ' + (0, $9273ea25044c2ed9$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ') is open');
    else throw new Error('Cannot close document, a token (`' + right.type + '`, ' + (0, $9273ea25044c2ed9$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ') is still open');
}


function $042dcb53d47f39c2$export$2e2bcd8739ae039(options) {
    /** @type {import('unified').ParserFunction<Root>} */ const parser = (doc)=>{
        // Assume options.
        const settings = /** @type {Options} */ this.data('settings');
        return (0, $868092e410d31d98$export$d744d789c09bfde6)(doc, Object.assign({}, settings, options, {
            // Note: these options are not in the readme.
            // The goal is for them to be set by plugins on `data` instead of being
            // passed by users.
            extensions: this.data('micromarkExtensions') || [],
            mdastExtensions: this.data('fromMarkdownExtensions') || []
        }));
    };
    Object.assign(this, {
        Parser: parser
    });
}


/**
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('mdast-util-to-hast').Options} Options
 * @typedef {import('unified').Processor<any, any, any, any>} Processor
 *
 * @typedef {import('mdast-util-to-hast')} DoNotTouchAsThisImportIncludesRawInTree
 */ /**
 * @typedef {import('hast').Content} HastContent
 * @typedef {import('hast').Root} HastRoot
 *
 * @typedef {import('mdast').Content} MdastContent
 * @typedef {import('mdast').Root} MdastRoot
 *
 * @typedef {import('./state.js').Options} Options
 */ /**
 * @typedef {HastRoot | HastContent} HastNodes
 * @typedef {MdastRoot | MdastContent} MdastNodes
 */ /**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('./state.js').State} State
 */ 
const $39eba4d463f6519d$var$characterReferences = {
    '"': 'quot',
    '&': 'amp',
    '<': 'lt',
    '>': 'gt'
};
function $39eba4d463f6519d$export$c564cdbbe6da493(value) {
    return value.replace(/["&<>]/g, replace);
    /**
   * @param {string} value
   * @returns {string}
   */ function replace(value) {
        // @ts-expect-error Hush, it’s fine.
        return '&' + $39eba4d463f6519d$var$characterReferences[value] + ';';
    }
}


function $691a5d9e44d0b640$export$d130a2d684099e5a(url, protocol) {
    const value = (0, $39eba4d463f6519d$export$c564cdbbe6da493)($691a5d9e44d0b640$export$e42a3e39590d28b5(url || ''));
    if (!protocol) return value;
    const colon = value.indexOf(':');
    const questionMark = value.indexOf('?');
    const numberSign = value.indexOf('#');
    const slash = value.indexOf('/');
    if (// If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign || // It is a protocol, it should be allowed.
    protocol.test(value.slice(0, colon))) return value;
    return '';
}
function $691a5d9e44d0b640$export$e42a3e39590d28b5(value) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    let start = 0;
    let skip = 0;
    while(++index < value.length){
        const code = value.charCodeAt(index);
        /** @type {string} */ let replace = '';
        // A correct percent encoded value.
        if (code === 37 && (0, $a967d3607431391e$export$75c76db11865a9f4)(value.charCodeAt(index + 1)) && (0, $a967d3607431391e$export$75c76db11865a9f4)(value.charCodeAt(index + 2))) skip = 2;
        else if (code < 128) {
            if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) replace = String.fromCharCode(code);
        } else if (code > 55295 && code < 57344) {
            const next = value.charCodeAt(index + 1);
            // A correct surrogate pair.
            if (code < 56320 && next > 56319 && next < 57344) {
                replace = String.fromCharCode(code, next);
                skip = 1;
            } else replace = '\uFFFD';
        } else replace = String.fromCharCode(code);
        if (replace) {
            result.push(value.slice(start, index), encodeURIComponent(replace));
            start = index + skip + 1;
            replace = '';
        }
        if (skip) {
            index += skip;
            skip = 0;
        }
    }
    return result.join('') + value.slice(start);
}


function $8f4f19859ddef155$export$adb608be33961c98(state) {
    /** @type {Array<ElementContent>} */ const listItems = [];
    let index = -1;
    while(++index < state.footnoteOrder.length){
        const def = state.footnoteById[state.footnoteOrder[index]];
        if (!def) continue;
        const content = state.all(def);
        const id = String(def.identifier).toUpperCase();
        const safeId = (0, $691a5d9e44d0b640$export$e42a3e39590d28b5)(id.toLowerCase());
        let referenceIndex = 0;
        /** @type {Array<ElementContent>} */ const backReferences = [];
        while(++referenceIndex <= state.footnoteCounts[id]){
            /** @type {Element} */ const backReference = {
                type: 'element',
                tagName: 'a',
                properties: {
                    href: '#' + state.clobberPrefix + 'fnref-' + safeId + (referenceIndex > 1 ? '-' + referenceIndex : ''),
                    dataFootnoteBackref: true,
                    className: [
                        'data-footnote-backref'
                    ],
                    ariaLabel: state.footnoteBackLabel
                },
                children: [
                    {
                        type: 'text',
                        value: "\u21A9"
                    }
                ]
            };
            if (referenceIndex > 1) backReference.children.push({
                type: 'element',
                tagName: 'sup',
                children: [
                    {
                        type: 'text',
                        value: String(referenceIndex)
                    }
                ]
            });
            if (backReferences.length > 0) backReferences.push({
                type: 'text',
                value: ' '
            });
            backReferences.push(backReference);
        }
        const tail = content[content.length - 1];
        if (tail && tail.type === 'element' && tail.tagName === 'p') {
            const tailTail = tail.children[tail.children.length - 1];
            if (tailTail && tailTail.type === 'text') tailTail.value += ' ';
            else tail.children.push({
                type: 'text',
                value: ' '
            });
            tail.children.push(...backReferences);
        } else content.push(...backReferences);
        /** @type {Element} */ const listItem = {
            type: 'element',
            tagName: 'li',
            properties: {
                id: state.clobberPrefix + 'fn-' + safeId
            },
            children: state.wrap(content, true)
        };
        state.patch(def, listItem);
        listItems.push(listItem);
    }
    if (listItems.length === 0) return;
    return {
        type: 'element',
        tagName: 'section',
        properties: {
            dataFootnotes: true,
            className: [
                'footnotes'
            ]
        },
        children: [
            {
                type: 'element',
                tagName: state.footnoteLabelTagName,
                properties: {
                    // To do: use structured clone.
                    ...JSON.parse(JSON.stringify(state.footnoteLabelProperties)),
                    id: 'footnote-label'
                },
                children: [
                    {
                        type: 'text',
                        value: state.footnoteLabel
                    }
                ]
            },
            {
                type: 'text',
                value: '\n'
            },
            {
                type: 'element',
                tagName: 'ol',
                properties: {},
                children: state.wrap(listItems, true)
            },
            {
                type: 'text',
                value: '\n'
            }
        ]
    };
}


/**
 * @typedef {import('hast').Content} HastContent
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').ElementContent} HastElementContent
 * @typedef {import('hast').Properties} HastProperties
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('hast').Text} HastText
 *
 * @typedef {import('mdast').Content} MdastContent
 * @typedef {import('mdast').Definition} MdastDefinition
 * @typedef {import('mdast').FootnoteDefinition} MdastFootnoteDefinition
 * @typedef {import('mdast').Parent} MdastParent
 * @typedef {import('mdast').Root} MdastRoot
 */ /**
 * @typedef {HastRoot | HastContent} HastNodes
 * @typedef {MdastRoot | MdastContent} MdastNodes
 * @typedef {Extract<MdastNodes, MdastParent>} MdastParents
 *
 * @typedef EmbeddedHastFields
 *   hast fields.
 * @property {string | null | undefined} [hName]
 *   Generate a specific element with this tag name instead.
 * @property {HastProperties | null | undefined} [hProperties]
 *   Generate an element with these properties instead.
 * @property {Array<HastElementContent> | null | undefined} [hChildren]
 *   Generate an element with this content instead.
 *
 * @typedef {Record<string, unknown> & EmbeddedHastFields} MdastData
 *   mdast data with embedded hast fields.
 *
 * @typedef {MdastNodes & {data?: MdastData | null | undefined}} MdastNodeWithData
 *   mdast node with embedded hast data.
 *
 * @typedef PointLike
 *   Point-like value.
 * @property {number | null | undefined} [line]
 *   Line.
 * @property {number | null | undefined} [column]
 *   Column.
 * @property {number | null | undefined} [offset]
 *   Offset.
 *
 * @typedef PositionLike
 *   Position-like value.
 * @property {PointLike | null | undefined} [start]
 *   Point-like value.
 * @property {PointLike | null | undefined} [end]
 *   Point-like value.
 *
 * @callback Handler
 *   Handle a node.
 * @param {State} state
 *   Info passed around.
 * @param {any} node
 *   mdast node to handle.
 * @param {MdastParents | null | undefined} parent
 *   Parent of `node`.
 * @returns {HastElementContent | Array<HastElementContent> | null | undefined}
 *   hast node.
 *
 * @callback HFunctionProps
 *   Signature of `state` for when props are passed.
 * @param {MdastNodes | PositionLike | null | undefined} node
 *   mdast node or unist position.
 * @param {string} tagName
 *   HTML tag name.
 * @param {HastProperties} props
 *   Properties.
 * @param {Array<HastElementContent> | null | undefined} [children]
 *   hast content.
 * @returns {HastElement}
 *   Compiled element.
 *
 * @callback HFunctionNoProps
 *   Signature of `state` for when no props are passed.
 * @param {MdastNodes | PositionLike | null | undefined} node
 *   mdast node or unist position.
 * @param {string} tagName
 *   HTML tag name.
 * @param {Array<HastElementContent> | null | undefined} [children]
 *   hast content.
 * @returns {HastElement}
 *   Compiled element.
 *
 * @typedef HFields
 *   Info on `state`.
 * @property {boolean} dangerous
 *   Whether HTML is allowed.
 * @property {string} clobberPrefix
 *   Prefix to use to prevent DOM clobbering.
 * @property {string} footnoteLabel
 *   Label to use to introduce the footnote section.
 * @property {string} footnoteLabelTagName
 *   HTML used for the footnote label.
 * @property {HastProperties} footnoteLabelProperties
 *   Properties on the HTML tag used for the footnote label.
 * @property {string} footnoteBackLabel
 *   Label to use from backreferences back to their footnote call.
 * @property {(identifier: string) => MdastDefinition | null} definition
 *   Definition cache.
 * @property {Record<string, MdastFootnoteDefinition>} footnoteById
 *   Footnote definitions by their identifier.
 * @property {Array<string>} footnoteOrder
 *   Identifiers of order when footnote calls first appear in tree order.
 * @property {Record<string, number>} footnoteCounts
 *   Counts for how often the same footnote was called.
 * @property {Handlers} handlers
 *   Applied handlers.
 * @property {Handler} unknownHandler
 *   Handler for any none not in `passThrough` or otherwise handled.
 * @property {(from: MdastNodes, node: HastNodes) => void} patch
 *   Copy a node’s positional info.
 * @property {<Type extends HastNodes>(from: MdastNodes, to: Type) => Type | HastElement} applyData
 *   Honor the `data` of `from`, and generate an element instead of `node`.
 * @property {(node: MdastNodes, parent: MdastParents | null | undefined) => HastElementContent | Array<HastElementContent> | null | undefined} one
 *   Transform an mdast node to hast.
 * @property {(node: MdastNodes) => Array<HastElementContent>} all
 *   Transform the children of an mdast parent to hast.
 * @property {<Type extends HastContent>(nodes: Array<Type>, loose?: boolean | null | undefined) => Array<Type | HastText>} wrap
 *   Wrap `nodes` with line endings between each node, adds initial/final line endings when `loose`.
 * @property {(left: MdastNodeWithData | PositionLike | null | undefined, right: HastElementContent) => HastElementContent} augment
 *   Like `state` but lower-level and usable on non-elements.
 *   Deprecated: use `patch` and `applyData`.
 * @property {Array<string>} passThrough
 *   List of node types to pass through untouched (except for their children).
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [allowDangerousHtml=false]
 *   Whether to persist raw HTML in markdown in the hast tree.
 * @property {string | null | undefined} [clobberPrefix='user-content-']
 *   Prefix to use before the `id` attribute on footnotes to prevent it from
 *   *clobbering*.
 * @property {string | null | undefined} [footnoteBackLabel='Back to content']
 *   Label to use from backreferences back to their footnote call (affects
 *   screen readers).
 * @property {string | null | undefined} [footnoteLabel='Footnotes']
 *   Label to use for the footnotes section (affects screen readers).
 * @property {HastProperties | null | undefined} [footnoteLabelProperties={className: ['sr-only']}]
 *   Properties to use on the footnote label (note that `id: 'footnote-label'`
 *   is always added as footnote calls use it with `aria-describedby` to
 *   provide an accessible label).
 * @property {string | null | undefined} [footnoteLabelTagName='h2']
 *   Tag name to use for the footnote label.
 * @property {Handlers | null | undefined} [handlers]
 *   Extra handlers for nodes.
 * @property {Array<string> | null | undefined} [passThrough]
 *   List of custom mdast node types to pass through (keep) in hast (note that
 *   the node itself is passed, but eventual children are transformed).
 * @property {Handler | null | undefined} [unknownHandler]
 *   Handler for all unknown nodes.
 *
 * @typedef {Record<string, Handler>} Handlers
 *   Handle nodes.
 *
 * @typedef {HFunctionProps & HFunctionNoProps & HFields} State
 *   Info passed around.
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */ /**
 * Check if `Child` can be a child of `Ancestor`.
 *
 * Returns the ancestor when `Child` can be a child of `Ancestor`, or returns
 * `never`.
 *
 * @template {Node} Ancestor
 *   Node type.
 * @template {Node} Child
 *   Node type.
 * @typedef {(
 *   Ancestor extends Parent
 *     ? Child extends Ancestor['children'][number]
 *       ? Ancestor
 *       : never
 *     : never
 * )} ParentsOf
 */ /**
 * @template {Node} [Visited=Node]
 *   Visited node type.
 * @template {Parent} [Ancestor=Parent]
 *   Ancestor type.
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform `parent`.
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of `parent` still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Visited extends Node ? number | null : never} index
 *   Index of `node` in `parent`.
 * @param {Ancestor extends Node ? Ancestor | null : never} parent
 *   Parent of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 */ /**
 * Build a typed `Visitor` function from a node and all possible parents.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} Visited
 *   Node type.
 * @template {Parent} Ancestor
 *   Parent type.
 * @typedef {Visitor<Visited, ParentsOf<Ancestor, Visited>>} BuildVisitorFromMatch
 */ /**
 * Build a typed `Visitor` function from a list of descendants and a test.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} Descendant
 *   Node type.
 * @template {Test} Check
 *   Test type.
 * @typedef {(
 *   BuildVisitorFromMatch<
 *     import('unist-util-visit-parents/complex-types.js').Matches<Descendant, Check>,
 *     Extract<Descendant, Parent>
 *   >
 * )} BuildVisitorFromDescendants
 */ /**
 * Build a typed `Visitor` function from a tree and a test.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} [Tree=Node]
 *   Node type.
 * @template {Test} [Check=string]
 *   Test type.
 * @typedef {(
 *   BuildVisitorFromDescendants<
 *     import('unist-util-visit-parents/complex-types.js').InclusiveDescendant<Tree>,
 *     Check
 *   >
 * )} BuildVisitor
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 */ /**
 * @typedef {boolean | 'skip'} Action
 *   Union of the action types.
 *
 * @typedef {number} Index
 *   Move to the sibling at `index` next (after node itself is completely
 *   traversed).
 *
 *   Useful if mutating the tree, such as removing the node the visitor is
 *   currently on, or any of its previous siblings.
 *   Results less than 0 or greater than or equal to `children.length` stop
 *   traversing the parent.
 *
 * @typedef {[(Action | null | undefined | void)?, (Index | null | undefined)?]} ActionTuple
 *   List with one or two values, the first an action, the second an index.
 *
 * @typedef {Action | ActionTuple | Index | null | undefined | void} VisitorResult
 *   Any value that can be returned from a visitor.
 */ /**
 * @template {Node} [Visited=Node]
 *   Visited node type.
 * @template {Parent} [Ancestor=Parent]
 *   Ancestor type.
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform the parent of node (the last of `ancestors`).
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of an ancestor still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Array<Ancestor>} ancestors
 *   Ancestors of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 */ /**
 * @template {Node} [Tree=Node]
 *   Tree type.
 * @template {Test} [Check=string]
 *   Test type.
 * @typedef {Visitor<import('./complex-types.js').Matches<import('./complex-types.js').InclusiveDescendant<Tree>, Check>, Extract<import('./complex-types.js').InclusiveDescendant<Tree>, Parent>>} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parents`.
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 */ /**
 * @typedef {Record<string, unknown>} Props
 * @typedef {null | undefined | string | Props | TestFunctionAnything | Array<string | Props | TestFunctionAnything>} Test
 *   Check for an arbitrary node, unaware of TypeScript inferral.
 *
 * @callback TestFunctionAnything
 *   Check if a node passes a test, unaware of TypeScript inferral.
 * @param {unknown} this
 *   The given context.
 * @param {Node} node
 *   A node.
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean | void}
 *   Whether this node passes the test.
 */ /**
 * @template {Node} Kind
 *   Node type.
 * @typedef {Kind['type'] | Partial<Kind> | TestFunctionPredicate<Kind> | Array<Kind['type'] | Partial<Kind> | TestFunctionPredicate<Kind>>} PredicateTest
 *   Check for a node that can be inferred by TypeScript.
 */ /**
 * Check if a node passes a certain test.
 *
 * @template {Node} Kind
 *   Node type.
 * @callback TestFunctionPredicate
 *   Complex test function for a node that can be inferred by TypeScript.
 * @param {Node} node
 *   A node.
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {node is Kind}
 *   Whether this node passes the test.
 */ /**
 * @callback AssertAnything
 *   Check that an arbitrary value is a node, unaware of TypeScript inferral.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean}
 *   Whether this is a node and passes a test.
 */ /**
 * Check if a node is a node and passes a certain node test.
 *
 * @template {Node} Kind
 *   Node type.
 * @callback AssertPredicate
 *   Check that an arbitrary value is a specific node, aware of TypeScript.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {node is Kind}
 *   Whether this is a node and passes a test.
 */ /**
 * Check if `node` is a `Node` and whether it passes the given test.
 *
 * @param node
 *   Thing to check, typically `Node`.
 * @param test
 *   A check for a specific node.
 * @param index
 *   The node’s position in its parent.
 * @param parent
 *   The node’s parent.
 * @returns
 *   Whether `node` is a node and passes a test.
 */ const $50890d350e0caf4e$export$226b3eccf92c9ed9 = /**
   * @type {(
   *   (() => false) &
   *   (<Kind extends Node = Node>(node: unknown, test: PredicateTest<Kind>, index: number, parent: Parent, context?: unknown) => node is Kind) &
   *   (<Kind extends Node = Node>(node: unknown, test: PredicateTest<Kind>, index?: null | undefined, parent?: null | undefined, context?: unknown) => node is Kind) &
   *   ((node: unknown, test: Test, index: number, parent: Parent, context?: unknown) => boolean) &
   *   ((node: unknown, test?: Test, index?: null | undefined, parent?: null | undefined, context?: unknown) => boolean)
   * )}
   */ /**
     * @param {unknown} [node]
     * @param {Test} [test]
     * @param {number | null | undefined} [index]
     * @param {Parent | null | undefined} [parent]
     * @param {unknown} [context]
     * @returns {boolean}
     */ // eslint-disable-next-line max-params
function is(node, test, index, parent, context) {
    const check = $50890d350e0caf4e$export$9c68d69a4c5bbcf9(test);
    if (index !== undefined && index !== null && (typeof index !== 'number' || index < 0 || index === Number.POSITIVE_INFINITY)) throw new Error('Expected positive finite index');
    if (parent !== undefined && parent !== null && (!is(parent) || !parent.children)) throw new Error('Expected parent node');
    if ((parent === undefined || parent === null) !== (index === undefined || index === null)) throw new Error('Expected both parent and index');
    // @ts-expect-error Looks like a node.
    return node && node.type && typeof node.type === 'string' ? Boolean(check.call(context, node, index, parent)) : false;
};
const $50890d350e0caf4e$export$9c68d69a4c5bbcf9 = /**
   * @type {(
   *   (<Kind extends Node>(test: PredicateTest<Kind>) => AssertPredicate<Kind>) &
   *   ((test?: Test) => AssertAnything)
   * )}
   */ /**
     * @param {Test} [test]
     * @returns {AssertAnything}
     */ function(test) {
    if (test === undefined || test === null) return $50890d350e0caf4e$var$ok;
    if (typeof test === 'string') return $50890d350e0caf4e$var$typeFactory(test);
    if (typeof test === 'object') return Array.isArray(test) ? $50890d350e0caf4e$var$anyFactory(test) : $50890d350e0caf4e$var$propsFactory(test);
    if (typeof test === 'function') return $50890d350e0caf4e$var$castFactory(test);
    throw new Error('Expected function, string, or object as test');
};
/**
 * @param {Array<string | Props | TestFunctionAnything>} tests
 * @returns {AssertAnything}
 */ function $50890d350e0caf4e$var$anyFactory(tests) {
    /** @type {Array<AssertAnything>} */ const checks = [];
    let index = -1;
    while(++index < tests.length)checks[index] = $50890d350e0caf4e$export$9c68d69a4c5bbcf9(tests[index]);
    return $50890d350e0caf4e$var$castFactory(any);
    /**
   * @this {unknown}
   * @param {Array<unknown>} parameters
   * @returns {boolean}
   */ function any(...parameters) {
        let index = -1;
        while(++index < checks.length){
            if (checks[index].call(this, ...parameters)) return true;
        }
        return false;
    }
}
/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {AssertAnything}
 */ function $50890d350e0caf4e$var$propsFactory(check) {
    return $50890d350e0caf4e$var$castFactory(all);
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function all(node) {
        /** @type {string} */ let key;
        for(key in check){
            // @ts-expect-error: hush, it sure works as an index.
            if (node[key] !== check[key]) return false;
        }
        return true;
    }
}
/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {AssertAnything}
 */ function $50890d350e0caf4e$var$typeFactory(check) {
    return $50890d350e0caf4e$var$castFactory(type);
    /**
   * @param {Node} node
   */ function type(node) {
        return node && node.type === check;
    }
}
/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunctionAnything} check
 * @returns {AssertAnything}
 */ function $50890d350e0caf4e$var$castFactory(check) {
    return assertion;
    /**
   * @this {unknown}
   * @param {unknown} node
   * @param {Array<unknown>} parameters
   * @returns {boolean}
   */ function assertion(node, ...parameters) {
        return Boolean(node && typeof node === 'object' && 'type' in node && // @ts-expect-error: fine.
        Boolean(check.call(this, node, ...parameters)));
    }
}
function $50890d350e0caf4e$var$ok() {
    return true;
}


/**
 * @param {string} d
 * @returns {string}
 */ function $21ada8452fab3bf9$export$35e9368ef982300f(d) {
    return d;
}


const $b5c1a3ea54435789$export$f4d8133c446fe484 = true;
const $b5c1a3ea54435789$export$7f100f842f565dc9 = false;
const $b5c1a3ea54435789$export$8773f85c2fb2c116 = 'skip';
const $b5c1a3ea54435789$export$70008a21eb6de899 = /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */ /**
     * @param {Node} tree
     * @param {Test} test
     * @param {Visitor<Node>} visitor
     * @param {boolean | null | undefined} [reverse]
     * @returns {void}
     */ function(tree, test, visitor, reverse) {
    if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test;
        test = null;
    }
    const is = (0, $50890d350e0caf4e$export$9c68d69a4c5bbcf9)(test);
    const step = reverse ? -1 : 1;
    factory(tree, undefined, [])();
    /**
       * @param {Node} node
       * @param {number | undefined} index
       * @param {Array<Parent>} parents
       */ function factory(node, index, parents) {
        /** @type {Record<string, unknown>} */ // @ts-expect-error: hush
        const value = node && typeof node === 'object' ? node : {};
        if (typeof value.type === 'string') {
            const name = // `hast`
            typeof value.tagName === 'string' ? value.tagName : typeof value.name === 'string' ? value.name : undefined;
            Object.defineProperty(visit, 'name', {
                value: 'node (' + (0, $21ada8452fab3bf9$export$35e9368ef982300f)(node.type + (name ? '<' + name + '>' : '')) + ')'
            });
        }
        return visit;
        function visit() {
            /** @type {ActionTuple} */ let result = [];
            /** @type {ActionTuple} */ let subresult;
            /** @type {number} */ let offset;
            /** @type {Array<Parent>} */ let grandparents;
            if (!test || is(node, index, parents[parents.length - 1] || null)) {
                result = $b5c1a3ea54435789$var$toResult(visitor(node, parents));
                if (result[0] === $b5c1a3ea54435789$export$7f100f842f565dc9) return result;
            }
            // @ts-expect-error looks like a parent.
            if (node.children && result[0] !== $b5c1a3ea54435789$export$8773f85c2fb2c116) {
                // @ts-expect-error looks like a parent.
                offset = (reverse ? node.children.length : -1) + step;
                // @ts-expect-error looks like a parent.
                grandparents = parents.concat(node);
                // @ts-expect-error looks like a parent.
                while(offset > -1 && offset < node.children.length){
                    // @ts-expect-error looks like a parent.
                    subresult = factory(node.children[offset], offset, grandparents)();
                    if (subresult[0] === $b5c1a3ea54435789$export$7f100f842f565dc9) return subresult;
                    offset = typeof subresult[1] === 'number' ? subresult[1] : offset + step;
                }
            }
            return result;
        }
    }
};
/**
 * Turn a return value into a clean result.
 *
 * @param {VisitorResult} value
 *   Valid return values from visitors.
 * @returns {ActionTuple}
 *   Clean result.
 */ function $b5c1a3ea54435789$var$toResult(value) {
    if (Array.isArray(value)) return value;
    if (typeof value === 'number') return [
        $b5c1a3ea54435789$export$f4d8133c446fe484,
        value
    ];
    return [
        value
    ];
}


const $7b8aaa01fbc1a004$export$bf638b60ea8b89b7 = /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */ /**
     * @param {Node} tree
     * @param {Test} test
     * @param {Visitor} visitor
     * @param {boolean | null | undefined} [reverse]
     * @returns {void}
     */ function(tree, test, visitor, reverse) {
    if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    (0, $b5c1a3ea54435789$export$70008a21eb6de899)(tree, test, overload, reverse);
    /**
       * @param {Node} node
       * @param {Array<Parent>} parents
       */ function overload(node, parents) {
        const parent = parents[parents.length - 1];
        return visitor(node, parent ? parent.children.indexOf(node) : null, parent);
    }
};


/**
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Get the starting point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */ const $3a7a04fbc54e0c66$export$771bf3e4949bfbee = $3a7a04fbc54e0c66$var$point('start');
const $3a7a04fbc54e0c66$export$da309cdce9dc2a25 = $3a7a04fbc54e0c66$var$point('end');
function $3a7a04fbc54e0c66$export$5880b8b5730aff45(node) {
    return {
        start: $3a7a04fbc54e0c66$export$771bf3e4949bfbee(node),
        end: $3a7a04fbc54e0c66$export$da309cdce9dc2a25(node)
    };
}
/**
 * Get the positional info of `node`.
 *
 * @param {'start' | 'end'} type
 *   Side.
 * @returns
 *   Getter.
 */ function $3a7a04fbc54e0c66$var$point(type) {
    return point;
    /**
   * Get the point info of `node` at a bound side.
   *
   * @param {NodeLike | Node | null | undefined} [node]
   * @returns {Point}
   */ function point(node) {
        const point = node && node.position && node.position[type] || {};
        // To do: next major: don’t return points when invalid.
        return {
            // @ts-expect-error: in practice, null is allowed.
            line: point.line || null,
            // @ts-expect-error: in practice, null is allowed.
            column: point.column || null,
            // @ts-expect-error: in practice, null is allowed.
            offset: point.offset > -1 ? point.offset : null
        };
    }
}


/**
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef NodeLike
 * @property {PositionLike | null | undefined} [position]
 */ /**
 * Check if `node` is generated.
 *
 * @param {NodeLike | null | undefined} [node]
 *   Node to check.
 * @returns {boolean}
 *   Whether `node` is generated (does not have positional info).
 */ function $f1e2817d2bac219a$export$41ad1363166ec91a(node) {
    return !node || !node.position || !node.position.start || !node.position.start.line || !node.position.start.column || !node.position.end || !node.position.end.line || !node.position.end.column;
}


/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Definition} Definition
 */ /**
 * @typedef {Root | Content} Node
 *
 * @callback GetDefinition
 *   Get a definition by identifier.
 * @param {string | null | undefined} [identifier]
 *   Identifier of definition.
 * @returns {Definition | null}
 *   Definition corresponding to `identifier` or `null`.
 */ 
const $8a07efab8031ad90$var$own = {}.hasOwnProperty;
function $8a07efab8031ad90$export$d79264f26953ec1(tree) {
    /** @type {Record<string, Definition>} */ const cache = Object.create(null);
    if (!tree || !tree.type) throw new Error('mdast-util-definitions expected node');
    (0, $7b8aaa01fbc1a004$export$bf638b60ea8b89b7)(tree, 'definition', (definition)=>{
        const id = $8a07efab8031ad90$var$clean(definition.identifier);
        if (id && !$8a07efab8031ad90$var$own.call(cache, id)) cache[id] = definition;
    });
    return definition;
    /** @type {GetDefinition} */ function definition(identifier) {
        const id = $8a07efab8031ad90$var$clean(identifier);
        // To do: next major: return `undefined` when not found.
        return id && $8a07efab8031ad90$var$own.call(cache, id) ? cache[id] : null;
    }
}
/**
 * @param {string | null | undefined} [value]
 * @returns {string}
 */ function $8a07efab8031ad90$var$clean(value) {
    return String(value || '').toUpperCase();
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `blockquote` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Blockquote} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $311d9eadeda2e417$export$67dc04e652a298ca(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'blockquote',
        properties: {},
        children: state.wrap(state.all(node), true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').Break} Break
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `break` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Break} node
 *   mdast node.
 * @returns {Array<Element | Text>}
 *   hast element content.
 */ function $9cec01468fd0d07b$export$371da9dd35aba193(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'br',
        properties: {},
        children: []
    };
    state.patch(node, result);
    return [
        state.applyData(node, result),
        {
            type: 'text',
            value: '\n'
        }
    ];
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Code} Code
 * @typedef {import('../state.js').State} State

 */ /**
 * Turn an mdast `code` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Code} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $8cd71ff6ffcd014b$export$6565f9f03506010b(state, node) {
    const value = node.value ? node.value + '\n' : '';
    // To do: next major, use `node.lang` w/o regex, the splitting’s been going
    // on for years in remark now.
    const lang = node.lang ? node.lang.match(/^[^ \t]+(?=[ \t]|$)/) : null;
    /** @type {Properties} */ const properties = {};
    if (lang) properties.className = [
        'language-' + lang
    ];
    // Create `<code>`.
    /** @type {Element} */ let result = {
        type: 'element',
        tagName: 'code',
        properties: properties,
        children: [
            {
                type: 'text',
                value: value
            }
        ]
    };
    if (node.meta) result.data = {
        meta: node.meta
    };
    state.patch(node, result);
    result = state.applyData(node, result);
    // Create `<pre>`.
    result = {
        type: 'element',
        tagName: 'pre',
        properties: {},
        children: [
            result
        ]
    };
    state.patch(node, result);
    return result;
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Delete} Delete
 * @typedef {import('../state.js').State} State

 */ /**
 * Turn an mdast `delete` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Delete} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $3fa29c64ab0d254a$export$19426ff118fe8be(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'del',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `emphasis` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Emphasis} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $12d1dade67a463e5$export$bef81ba411953b51(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'em',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('hast').Element} Element
 * @typedef {import('../state.js').State} State
 */ 
function $ae7018ffb9983cd4$export$7f87ee744075c1ba(state, node) {
    const id = String(node.identifier).toUpperCase();
    const safeId = (0, $691a5d9e44d0b640$export$e42a3e39590d28b5)(id.toLowerCase());
    const index = state.footnoteOrder.indexOf(id);
    /** @type {number} */ let counter;
    if (index === -1) {
        state.footnoteOrder.push(id);
        state.footnoteCounts[id] = 1;
        counter = state.footnoteOrder.length;
    } else {
        state.footnoteCounts[id]++;
        counter = index + 1;
    }
    const reuseCounter = state.footnoteCounts[id];
    /** @type {Element} */ const link = {
        type: 'element',
        tagName: 'a',
        properties: {
            href: '#' + state.clobberPrefix + 'fn-' + safeId,
            id: state.clobberPrefix + 'fnref-' + safeId + (reuseCounter > 1 ? '-' + reuseCounter : ''),
            dataFootnoteRef: true,
            ariaDescribedBy: [
                'footnote-label'
            ]
        },
        children: [
            {
                type: 'text',
                value: String(counter)
            }
        ]
    };
    state.patch(node, link);
    /** @type {Element} */ const sup = {
        type: 'element',
        tagName: 'sup',
        properties: {},
        children: [
            link
        ]
    };
    state.patch(node, sup);
    return state.applyData(node, sup);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Footnote} Footnote
 * @typedef {import('../state.js').State} State
 */ 
function $6d883fb6e8976829$export$3b6a720baa2c20ec(state, node) {
    const footnoteById = state.footnoteById;
    let no = 1;
    while(no in footnoteById)no++;
    const identifier = String(no);
    footnoteById[identifier] = {
        type: 'footnoteDefinition',
        identifier: identifier,
        children: [
            {
                type: 'paragraph',
                children: node.children
            }
        ],
        position: node.position
    };
    return (0, $ae7018ffb9983cd4$export$7f87ee744075c1ba)(state, {
        type: 'footnoteReference',
        identifier: identifier,
        position: node.position
    });
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `heading` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Heading} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $1f5cd18a65d44008$export$46e4a324ac90507f(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'h' + node.depth,
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').HTML} Html
 * @typedef {import('../state.js').State} State
 * @typedef {import('../../index.js').Raw} Raw
 */ /**
 * Turn an mdast `html` node into hast (`raw` node in dangerous mode, otherwise
 * nothing).
 *
 * @param {State} state
 *   Info passed around.
 * @param {Html} node
 *   mdast node.
 * @returns {Raw | Element | null}
 *   hast node.
 */ function $41da7061c0b9adb2$export$c0bb0b647f701bb5(state, node) {
    if (state.dangerous) {
        /** @type {Raw} */ const result = {
            type: 'raw',
            value: node.value
        };
        state.patch(node, result);
        return state.applyData(node, result);
    }
    // To do: next major: return `undefined`.
    return null;
}


/**
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('../state.js').State} State
 */ 
/**
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Reference} Reference
 * @typedef {import('mdast').Root} Root
 *
 * @typedef {import('./state.js').State} State
 */ /**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Reference>} References
 */ // To do: next major: always return array.
/**
 * Return the content of a reference without definition as plain text.
 *
 * @param {State} state
 *   Info passed around.
 * @param {References} node
 *   Reference node (image, link).
 * @returns {ElementContent | Array<ElementContent>}
 *   hast content.
 */ function $cff1f7f79e61bc2e$export$3fdd26f3d9e7dc78(state, node) {
    const subtype = node.referenceType;
    let suffix = ']';
    if (subtype === 'collapsed') suffix += '[]';
    else if (subtype === 'full') suffix += '[' + (node.label || node.identifier) + ']';
    if (node.type === 'imageReference') return {
        type: 'text',
        value: '![' + node.alt + suffix
    };
    const contents = state.all(node);
    const head = contents[0];
    if (head && head.type === 'text') head.value = '[' + head.value;
    else contents.unshift({
        type: 'text',
        value: '['
    });
    const tail = contents[contents.length - 1];
    if (tail && tail.type === 'text') tail.value += suffix;
    else contents.push({
        type: 'text',
        value: suffix
    });
    return contents;
}


function $f768d2a7a17dfe1a$export$f281796f6bc3b8db(state, node) {
    const def = state.definition(node.identifier);
    if (!def) return (0, $cff1f7f79e61bc2e$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ const properties = {
        src: (0, $691a5d9e44d0b640$export$e42a3e39590d28b5)(def.url || ''),
        alt: node.alt
    };
    if (def.title !== null && def.title !== undefined) properties.title = def.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'img',
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Image} Image
 * @typedef {import('../state.js').State} State
 */ 
function $a95c259132437986$export$5c452ff88e35e47d(state, node) {
    /** @type {Properties} */ const properties = {
        src: (0, $691a5d9e44d0b640$export$e42a3e39590d28b5)(node.url)
    };
    if (node.alt !== null && node.alt !== undefined) properties.alt = node.alt;
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'img',
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `inlineCode` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {InlineCode} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $e7f507c7808d046e$export$91b9bee19a0d8569(state, node) {
    /** @type {Text} */ const text = {
        type: 'text',
        value: node.value.replace(/\r?\n|\r/g, ' ')
    };
    state.patch(node, text);
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'code',
        properties: {},
        children: [
            text
        ]
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('../state.js').State} State
 */ 

function $bedc7b7c3e186321$export$e6c469b1b7b2bc6a(state, node) {
    const def = state.definition(node.identifier);
    if (!def) return (0, $cff1f7f79e61bc2e$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ const properties = {
        href: (0, $691a5d9e44d0b640$export$e42a3e39590d28b5)(def.url || '')
    };
    if (def.title !== null && def.title !== undefined) properties.title = def.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'a',
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Link} Link
 * @typedef {import('../state.js').State} State
 */ 
function $14dad6d0bb263d38$export$9c30223ca0a664fb(state, node) {
    /** @type {Properties} */ const properties = {
        href: (0, $691a5d9e44d0b640$export$e42a3e39590d28b5)(node.url)
    };
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'a',
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('../state.js').State} State
 */ /**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Parent>} Parents
 */ /**
 * Turn an mdast `listItem` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ListItem} node
 *   mdast node.
 * @param {Parents | null | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */ function $f362a6c0cd98649d$export$76c7e83ecc9cdf05(state, node, parent) {
    const results = state.all(node);
    const loose = parent ? $f362a6c0cd98649d$var$listLoose(parent) : $f362a6c0cd98649d$var$listItemLoose(node);
    /** @type {Properties} */ const properties = {};
    /** @type {Array<ElementContent>} */ const children = [];
    if (typeof node.checked === 'boolean') {
        const head = results[0];
        /** @type {Element} */ let paragraph;
        if (head && head.type === 'element' && head.tagName === 'p') paragraph = head;
        else {
            paragraph = {
                type: 'element',
                tagName: 'p',
                properties: {},
                children: []
            };
            results.unshift(paragraph);
        }
        if (paragraph.children.length > 0) paragraph.children.unshift({
            type: 'text',
            value: ' '
        });
        paragraph.children.unshift({
            type: 'element',
            tagName: 'input',
            properties: {
                type: 'checkbox',
                checked: node.checked,
                disabled: true
            },
            children: []
        });
        // According to github-markdown-css, this class hides bullet.
        // See: <https://github.com/sindresorhus/github-markdown-css>.
        properties.className = [
            'task-list-item'
        ];
    }
    let index = -1;
    while(++index < results.length){
        const child = results[index];
        // Add eols before nodes, except if this is a loose, first paragraph.
        if (loose || index !== 0 || child.type !== 'element' || child.tagName !== 'p') children.push({
            type: 'text',
            value: '\n'
        });
        if (child.type === 'element' && child.tagName === 'p' && !loose) children.push(...child.children);
        else children.push(child);
    }
    const tail = results[results.length - 1];
    // Add a final eol.
    if (tail && (loose || tail.type !== 'element' || tail.tagName !== 'p')) children.push({
        type: 'text',
        value: '\n'
    });
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'li',
        properties: properties,
        children: children
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
/**
 * @param {Parents} node
 * @return {Boolean}
 */ function $f362a6c0cd98649d$var$listLoose(node) {
    let loose = false;
    if (node.type === 'list') {
        loose = node.spread || false;
        const children = node.children;
        let index = -1;
        while(!loose && ++index < children.length)loose = $f362a6c0cd98649d$var$listItemLoose(children[index]);
    }
    return loose;
}
/**
 * @param {ListItem} node
 * @return {Boolean}
 */ function $f362a6c0cd98649d$var$listItemLoose(node) {
    const spread = node.spread;
    return spread === undefined || spread === null ? node.children.length > 1 : spread;
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').List} List
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `list` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {List} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $85b2a77b79058797$export$8837f4fc672e936d(state, node) {
    /** @type {Properties} */ const properties = {};
    const results = state.all(node);
    let index = -1;
    if (typeof node.start === 'number' && node.start !== 1) properties.start = node.start;
    // Like GitHub, add a class for custom styling.
    while(++index < results.length){
        const child = results[index];
        if (child.type === 'element' && child.tagName === 'li' && child.properties && Array.isArray(child.properties.className) && child.properties.className.includes('task-list-item')) {
            properties.className = [
                'contains-task-list'
            ];
            break;
        }
    }
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: node.ordered ? 'ol' : 'ul',
        properties: properties,
        children: state.wrap(results, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `paragraph` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Paragraph} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $44c2680dd10e8983$export$9c206ddddb32a9b(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'p',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `root` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastRoot} node
 *   mdast node.
 * @returns {HastRoot | HastElement}
 *   hast node.
 */ function $cf3ce00ad3caafcc$export$e8e78c978b129247(state, node) {
    /** @type {HastRoot} */ const result = {
        type: 'root',
        children: state.wrap(state.all(node))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `strong` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Strong} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $ca7833f771cfe9b6$export$59ae2c325a998f89(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'strong',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Table} Table
 * @typedef {import('../state.js').State} State
 */ 
function $d79b5c65304296c5$export$9852986a3ec5f6a0(state, node) {
    const rows = state.all(node);
    const firstRow = rows.shift();
    /** @type {Array<Element>} */ const tableContent = [];
    if (firstRow) {
        /** @type {Element} */ const head = {
            type: 'element',
            tagName: 'thead',
            properties: {},
            children: state.wrap([
                firstRow
            ], true)
        };
        state.patch(node.children[0], head);
        tableContent.push(head);
    }
    if (rows.length > 0) {
        /** @type {Element} */ const body = {
            type: 'element',
            tagName: 'tbody',
            properties: {},
            children: state.wrap(rows, true)
        };
        const start = (0, $3a7a04fbc54e0c66$export$771bf3e4949bfbee)(node.children[1]);
        const end = (0, $3a7a04fbc54e0c66$export$da309cdce9dc2a25)(node.children[node.children.length - 1]);
        if (start.line && end.line) body.position = {
            start: start,
            end: end
        };
        tableContent.push(body);
    }
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'table',
        properties: {},
        children: state.wrap(tableContent, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').TableRow} TableRow
 * @typedef {import('../state.js').State} State
 */ /**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Parent>} Parents
 */ /**
 * Turn an mdast `tableRow` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableRow} node
 *   mdast node.
 * @param {Parents | null | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */ function $6287ed4f5fddff38$export$ce666bf02318c957(state, node, parent) {
    const siblings = parent ? parent.children : undefined;
    // Generate a body row when without parent.
    const rowIndex = siblings ? siblings.indexOf(node) : 1;
    const tagName = rowIndex === 0 ? 'th' : 'td';
    const align = parent && parent.type === 'table' ? parent.align : undefined;
    const length = align ? align.length : node.children.length;
    let cellIndex = -1;
    /** @type {Array<ElementContent>} */ const cells = [];
    while(++cellIndex < length){
        // Note: can also be undefined.
        const cell = node.children[cellIndex];
        /** @type {Properties} */ const properties = {};
        const alignValue = align ? align[cellIndex] : undefined;
        if (alignValue) properties.align = alignValue;
        /** @type {Element} */ let result = {
            type: 'element',
            tagName: tagName,
            properties: properties,
            children: []
        };
        if (cell) {
            result.children = state.all(cell);
            state.patch(cell, result);
            result = state.applyData(node, result);
        }
        cells.push(result);
    }
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'tr',
        properties: {},
        children: state.wrap(cells, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `tableCell` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableCell} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $777f63b63ba5cbd8$export$e1e720e5f4603e6a(state, node) {
    // Note: this function is normally not called: see `table-row` for how rows
    // and their cells are compiled.
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'td',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').Text} HastText
 * @typedef {import('mdast').Text} MdastText
 * @typedef {import('../state.js').State} State
 */ const $bb5397b5afb50c4f$var$tab = 9 /* `\t` */ ;
const $bb5397b5afb50c4f$var$space = 32 /* ` ` */ ;
function $bb5397b5afb50c4f$export$a771f20bdd13def9(value) {
    const source = String(value);
    const search = /\r?\n|\r/g;
    let match = search.exec(source);
    let last = 0;
    /** @type {Array<string>} */ const lines = [];
    while(match){
        lines.push($bb5397b5afb50c4f$var$trimLine(source.slice(last, match.index), last > 0, true), match[0]);
        last = match.index + match[0].length;
        match = search.exec(source);
    }
    lines.push($bb5397b5afb50c4f$var$trimLine(source.slice(last), last > 0, false));
    return lines.join('');
}
/**
 * @param {string} value
 *   Line to trim.
 * @param {boolean} start
 *   Whether to trim the start of the line.
 * @param {boolean} end
 *   Whether to trim the end of the line.
 * @returns {string}
 *   Trimmed line.
 */ function $bb5397b5afb50c4f$var$trimLine(value, start, end) {
    let startIndex = 0;
    let endIndex = value.length;
    if (start) {
        let code = value.codePointAt(startIndex);
        while(code === $bb5397b5afb50c4f$var$tab || code === $bb5397b5afb50c4f$var$space){
            startIndex++;
            code = value.codePointAt(startIndex);
        }
    }
    if (end) {
        let code = value.codePointAt(endIndex - 1);
        while(code === $bb5397b5afb50c4f$var$tab || code === $bb5397b5afb50c4f$var$space){
            endIndex--;
            code = value.codePointAt(endIndex - 1);
        }
    }
    return endIndex > startIndex ? value.slice(startIndex, endIndex) : '';
}


function $1b92d8edc73cabe0$export$6f093cfa640b7166(state, node) {
    /** @type {HastText} */ const result = {
        type: 'text',
        value: (0, $bb5397b5afb50c4f$export$a771f20bdd13def9)(String(node.value))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `thematicBreak` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ThematicBreak} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $2c9851a69be9d779$export$ba7b13e047416c03(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'hr',
        properties: {},
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


const $498c5449f11bc03c$export$455ce229eb3d2472 = {
    blockquote: $311d9eadeda2e417$export$67dc04e652a298ca,
    break: (0, $9cec01468fd0d07b$export$371da9dd35aba193),
    code: $8cd71ff6ffcd014b$export$6565f9f03506010b,
    delete: (0, $3fa29c64ab0d254a$export$19426ff118fe8be),
    emphasis: $12d1dade67a463e5$export$bef81ba411953b51,
    footnoteReference: $ae7018ffb9983cd4$export$7f87ee744075c1ba,
    footnote: $6d883fb6e8976829$export$3b6a720baa2c20ec,
    heading: $1f5cd18a65d44008$export$46e4a324ac90507f,
    html: $41da7061c0b9adb2$export$c0bb0b647f701bb5,
    imageReference: $f768d2a7a17dfe1a$export$f281796f6bc3b8db,
    image: $a95c259132437986$export$5c452ff88e35e47d,
    inlineCode: $e7f507c7808d046e$export$91b9bee19a0d8569,
    linkReference: $bedc7b7c3e186321$export$e6c469b1b7b2bc6a,
    link: $14dad6d0bb263d38$export$9c30223ca0a664fb,
    listItem: $f362a6c0cd98649d$export$76c7e83ecc9cdf05,
    list: $85b2a77b79058797$export$8837f4fc672e936d,
    paragraph: $44c2680dd10e8983$export$9c206ddddb32a9b,
    root: $cf3ce00ad3caafcc$export$e8e78c978b129247,
    strong: $ca7833f771cfe9b6$export$59ae2c325a998f89,
    table: $d79b5c65304296c5$export$9852986a3ec5f6a0,
    tableCell: $777f63b63ba5cbd8$export$e1e720e5f4603e6a,
    tableRow: $6287ed4f5fddff38$export$ce666bf02318c957,
    text: $1b92d8edc73cabe0$export$6f093cfa640b7166,
    thematicBreak: $2c9851a69be9d779$export$ba7b13e047416c03,
    toml: $498c5449f11bc03c$var$ignore,
    yaml: $498c5449f11bc03c$var$ignore,
    definition: $498c5449f11bc03c$var$ignore,
    footnoteDefinition: $498c5449f11bc03c$var$ignore
};
// Return nothing for nodes that are ignored.
function $498c5449f11bc03c$var$ignore() {
    // To do: next major: return `undefined`.
    return null;
}


const $29ab35d79f558615$var$own = {}.hasOwnProperty;
function $29ab35d79f558615$export$e6a0daad8304de(tree, options) {
    const settings = options || {};
    const dangerous = settings.allowDangerousHtml || false;
    /** @type {Record<string, MdastFootnoteDefinition>} */ const footnoteById = {};
    // To do: next major: add `options` to state, remove:
    // `dangerous`, `clobberPrefix`, `footnoteLabel`, `footnoteLabelTagName`,
    // `footnoteLabelProperties`, `footnoteBackLabel`, `passThrough`,
    // `unknownHandler`.
    // To do: next major: move to `state.options.allowDangerousHtml`.
    state.dangerous = dangerous;
    // To do: next major: move to `state.options`.
    state.clobberPrefix = settings.clobberPrefix === undefined || settings.clobberPrefix === null ? 'user-content-' : settings.clobberPrefix;
    // To do: next major: move to `state.options`.
    state.footnoteLabel = settings.footnoteLabel || 'Footnotes';
    // To do: next major: move to `state.options`.
    state.footnoteLabelTagName = settings.footnoteLabelTagName || 'h2';
    // To do: next major: move to `state.options`.
    state.footnoteLabelProperties = settings.footnoteLabelProperties || {
        className: [
            'sr-only'
        ]
    };
    // To do: next major: move to `state.options`.
    state.footnoteBackLabel = settings.footnoteBackLabel || 'Back to content';
    // To do: next major: move to `state.options`.
    state.unknownHandler = settings.unknownHandler;
    // To do: next major: move to `state.options`.
    state.passThrough = settings.passThrough;
    state.handlers = {
        ...(0, $498c5449f11bc03c$export$455ce229eb3d2472),
        ...settings.handlers
    };
    // To do: next major: replace utility with `definitionById` object, so we
    // only walk once (as we need footnotes too).
    state.definition = (0, $8a07efab8031ad90$export$d79264f26953ec1)(tree);
    state.footnoteById = footnoteById;
    /** @type {Array<string>} */ state.footnoteOrder = [];
    /** @type {Record<string, number>} */ state.footnoteCounts = {};
    state.patch = $29ab35d79f558615$var$patch;
    state.applyData = $29ab35d79f558615$var$applyData;
    state.one = oneBound;
    state.all = allBound;
    state.wrap = $29ab35d79f558615$export$4997ffc0176396a6;
    // To do: next major: remove `augment`.
    state.augment = augment;
    (0, $7b8aaa01fbc1a004$export$bf638b60ea8b89b7)(tree, 'footnoteDefinition', (definition)=>{
        const id = String(definition.identifier).toUpperCase();
        // Mimick CM behavior of link definitions.
        // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/8290999/index.js#L26>.
        if (!$29ab35d79f558615$var$own.call(footnoteById, id)) footnoteById[id] = definition;
    });
    // @ts-expect-error Hush, it’s fine!
    return state;
    /**
   * Finalise the created `right`, a hast node, from `left`, an mdast node.
   *
   * @param {MdastNodeWithData | PositionLike | null | undefined} left
   * @param {HastElementContent} right
   * @returns {HastElementContent}
   */ /* c8 ignore start */ // To do: next major: remove.
    function augment(left, right) {
        // Handle `data.hName`, `data.hProperties, `data.hChildren`.
        if (left && 'data' in left && left.data) {
            /** @type {MdastData} */ const data = left.data;
            if (data.hName) {
                if (right.type !== 'element') right = {
                    type: 'element',
                    tagName: '',
                    properties: {},
                    children: []
                };
                right.tagName = data.hName;
            }
            if (right.type === 'element' && data.hProperties) right.properties = {
                ...right.properties,
                ...data.hProperties
            };
            if ('children' in right && right.children && data.hChildren) right.children = data.hChildren;
        }
        if (left) {
            const ctx = 'type' in left ? left : {
                position: left
            };
            if (!(0, $f1e2817d2bac219a$export$41ad1363166ec91a)(ctx)) // @ts-expect-error: fine.
            right.position = {
                start: (0, $3a7a04fbc54e0c66$export$771bf3e4949bfbee)(ctx),
                end: (0, $3a7a04fbc54e0c66$export$da309cdce9dc2a25)(ctx)
            };
        }
        return right;
    }
    /* c8 ignore stop */ /**
   * Create an element for `node`.
   *
   * @type {HFunctionProps}
   */ /* c8 ignore start */ // To do: next major: remove.
    function state(node, tagName, props, children) {
        if (Array.isArray(props)) {
            children = props;
            props = {};
        }
        // @ts-expect-error augmenting an element yields an element.
        return augment(node, {
            type: 'element',
            tagName: tagName,
            properties: props || {},
            children: children || []
        });
    }
    /* c8 ignore stop */ /**
   * Transform an mdast node into a hast node.
   *
   * @param {MdastNodes} node
   *   mdast node.
   * @param {MdastParents | null | undefined} [parent]
   *   Parent of `node`.
   * @returns {HastElementContent | Array<HastElementContent> | null | undefined}
   *   Resulting hast node.
   */ function oneBound(node, parent) {
        // @ts-expect-error: that’s a state :)
        return $29ab35d79f558615$export$80bf7733f1207381(state, node, parent);
    }
    /**
   * Transform the children of an mdast node into hast nodes.
   *
   * @param {MdastNodes} parent
   *   mdast node to compile
   * @returns {Array<HastElementContent>}
   *   Resulting hast nodes.
   */ function allBound(parent) {
        // @ts-expect-error: that’s a state :)
        return $29ab35d79f558615$export$84bf76cd7afc7469(state, parent);
    }
}
/**
 * Copy a node’s positional info.
 *
 * @param {MdastNodes} from
 *   mdast node to copy from.
 * @param {HastNodes} to
 *   hast node to copy into.
 * @returns {void}
 *   Nothing.
 */ function $29ab35d79f558615$var$patch(from, to) {
    if (from.position) to.position = (0, $3a7a04fbc54e0c66$export$5880b8b5730aff45)(from);
}
/**
 * Honor the `data` of `from` and maybe generate an element instead of `to`.
 *
 * @template {HastNodes} Type
 *   Node type.
 * @param {MdastNodes} from
 *   mdast node to use data from.
 * @param {Type} to
 *   hast node to change.
 * @returns {Type | HastElement}
 *   Nothing.
 */ function $29ab35d79f558615$var$applyData(from, to) {
    /** @type {Type | HastElement} */ let result = to;
    // Handle `data.hName`, `data.hProperties, `data.hChildren`.
    if (from && from.data) {
        const hName = from.data.hName;
        const hChildren = from.data.hChildren;
        const hProperties = from.data.hProperties;
        if (typeof hName === 'string') {
            // Transforming the node resulted in an element with a different name
            // than wanted:
            if (result.type === 'element') result.tagName = hName;
            else result = {
                type: 'element',
                tagName: hName,
                properties: {},
                children: []
            };
        }
        if (result.type === 'element' && hProperties) result.properties = {
            ...result.properties,
            ...hProperties
        };
        if ('children' in result && result.children && hChildren !== null && hChildren !== undefined) // @ts-expect-error: assume valid children are defined.
        result.children = hChildren;
    }
    return result;
}
function $29ab35d79f558615$export$80bf7733f1207381(state, node, parent) {
    const type = node && node.type;
    // Fail on non-nodes.
    if (!type) throw new Error('Expected node, got `' + node + '`');
    if ($29ab35d79f558615$var$own.call(state.handlers, type)) return state.handlers[type](state, node, parent);
    if (state.passThrough && state.passThrough.includes(type)) // To do: next major: deep clone.
    // @ts-expect-error: types of passed through nodes are expected to be added manually.
    return 'children' in node ? {
        ...node,
        children: $29ab35d79f558615$export$84bf76cd7afc7469(state, node)
    } : node;
    if (state.unknownHandler) return state.unknownHandler(state, node, parent);
    return $29ab35d79f558615$var$defaultUnknownHandler(state, node);
}
function $29ab35d79f558615$export$84bf76cd7afc7469(state, parent) {
    /** @type {Array<HastElementContent>} */ const values = [];
    if ('children' in parent) {
        const nodes = parent.children;
        let index = -1;
        while(++index < nodes.length){
            const result = $29ab35d79f558615$export$80bf7733f1207381(state, nodes[index], parent);
            // To do: see if we van clean this? Can we merge texts?
            if (result) {
                if (index && nodes[index - 1].type === 'break') {
                    if (!Array.isArray(result) && result.type === 'text') result.value = result.value.replace(/^\s+/, '');
                    if (!Array.isArray(result) && result.type === 'element') {
                        const head = result.children[0];
                        if (head && head.type === 'text') head.value = head.value.replace(/^\s+/, '');
                    }
                }
                if (Array.isArray(result)) values.push(...result);
                else values.push(result);
            }
        }
    }
    return values;
}
/**
 * Transform an unknown node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastNodes} node
 *   Unknown mdast node.
 * @returns {HastText | HastElement}
 *   Resulting hast node.
 */ function $29ab35d79f558615$var$defaultUnknownHandler(state, node) {
    const data = node.data || {};
    /** @type {HastText | HastElement} */ const result = 'value' in node && !($29ab35d79f558615$var$own.call(data, 'hProperties') || $29ab35d79f558615$var$own.call(data, 'hChildren')) ? {
        type: 'text',
        value: node.value
    } : {
        type: 'element',
        tagName: 'div',
        properties: {},
        children: $29ab35d79f558615$export$84bf76cd7afc7469(state, node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
function $29ab35d79f558615$export$4997ffc0176396a6(nodes, loose) {
    /** @type {Array<Type | HastText>} */ const result = [];
    let index = -1;
    if (loose) result.push({
        type: 'text',
        value: '\n'
    });
    while(++index < nodes.length){
        if (index) result.push({
            type: 'text',
            value: '\n'
        });
        result.push(nodes[index]);
    }
    if (loose && nodes.length > 0) result.push({
        type: 'text',
        value: '\n'
    });
    return result;
}


function $66c4ba44cde7e006$export$c0e4c5cf07538633(tree, options) {
    const state = (0, $29ab35d79f558615$export$e6a0daad8304de)(tree, options);
    const node = state.one(tree, null);
    const foot = (0, $8f4f19859ddef155$export$adb608be33961c98)(state);
    if (foot) // @ts-expect-error If there’s a footer, there were definitions, meaning block
    // content.
    // So assume `node` is a parent node.
    node.children.push({
        type: 'text',
        value: '\n'
    }, foot);
    // To do: next major: always return root?
    return Array.isArray(node) ? {
        type: 'root',
        children: node
    } : node;
}


// Note: the `<MdastRoot, HastRoot>` overload doesn’t seem to work :'(
/**
 * Plugin that turns markdown into HTML to support rehype.
 *
 * *   If a destination processor is given, that processor runs with a new HTML
 *     (hast) tree (bridge-mode).
 *     As the given processor runs with a hast tree, and rehype plugins support
 *     hast, that means rehype plugins can be used with the given processor.
 *     The hast tree is discarded in the end.
 *     It’s highly unlikely that you want to do this.
 * *   The common case is to not pass a destination processor, in which case the
 *     current processor continues running with a new HTML (hast) tree
 *     (mutate-mode).
 *     As the current processor continues with a hast tree, and rehype plugins
 *     support hast, that means rehype plugins can be used after
 *     `remark-rehype`.
 *     It’s likely that this is what you want to do.
 *
 * @param destination
 *   Optional unified processor.
 * @param options
 *   Options passed to `mdast-util-to-hast`.
 */ const $2efd413341b24da5$var$remarkRehype = /** @type {(import('unified').Plugin<[Processor, Options?]|[null|undefined, Options?]|[Options]|[], MdastRoot>)} */ function(destination, options) {
    return destination && 'run' in destination ? $2efd413341b24da5$var$bridge(destination, options) : $2efd413341b24da5$var$mutate(destination || options);
};
var $2efd413341b24da5$export$2e2bcd8739ae039 = $2efd413341b24da5$var$remarkRehype;
/**
 * Bridge-mode.
 * Runs the destination with the new hast tree.
 *
 * @type {import('unified').Plugin<[Processor, Options?], MdastRoot>}
 */ function $2efd413341b24da5$var$bridge(destination, options) {
    return (node, file, next)=>{
        destination.run((0, $66c4ba44cde7e006$export$c0e4c5cf07538633)(node, options), file, (error)=>{
            next(error);
        });
    };
}
/**
 * Mutate-mode.
 * Further plugins run on the hast tree.
 *
 * @type {import('unified').Plugin<[Options?]|void[], MdastRoot, HastRoot>}
 */ function $2efd413341b24da5$var$mutate(options) {
    // @ts-expect-error: assume a corresponding node is returned by `toHast`.
    return (node)=>(0, $66c4ba44cde7e006$export$c0e4c5cf07538633)(node, options);
}



var $3eqDI = parcelRequire("3eqDI");
/**
 * @typedef {import('./lib/util/info.js').Info} Info
 * @typedef {import('./lib/util/schema.js').Schema} Schema
 */ /**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 */ /**
 * @typedef {import('./info.js').Info} Info
 * @typedef {Record<string, Info>} Properties
 * @typedef {Record<string, string>} Normal
 */ class $d7a1890cf8e1b890$export$19342e026b58ebb7 {
    /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */ constructor(property, normal, space){
        this.property = property;
        this.normal = normal;
        if (space) this.space = space;
    }
}
/** @type {Properties} */ $d7a1890cf8e1b890$export$19342e026b58ebb7.prototype.property = {};
/** @type {Normal} */ $d7a1890cf8e1b890$export$19342e026b58ebb7.prototype.normal = {};
/** @type {string|null} */ $d7a1890cf8e1b890$export$19342e026b58ebb7.prototype.space = null;


function $7f41ae780ac957a8$export$4950aa0f605343fb(definitions, space) {
    /** @type {Properties} */ const property = {};
    /** @type {Normal} */ const normal = {};
    let index = -1;
    while(++index < definitions.length){
        Object.assign(property, definitions[index].property);
        Object.assign(normal, definitions[index].normal);
    }
    return new (0, $d7a1890cf8e1b890$export$19342e026b58ebb7)(property, normal, space);
}


/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 *
 * @typedef {Record<string, string>} Attributes
 *
 * @typedef {Object} Definition
 * @property {Record<string, number|null>} properties
 * @property {(attributes: Attributes, property: string) => string} transform
 * @property {string} [space]
 * @property {Attributes} [attributes]
 * @property {Array<string>} [mustUseProperty]
 */ /**
 * @param {string} value
 * @returns {string}
 */ function $fd8dc6b15be37ef8$export$a3295358bff77e(value) {
    return value.toLowerCase();
}



class $524088d361a7d4ee$export$c4868e4a24d48fad {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */ constructor(property, attribute){
        /** @type {string} */ this.property = property;
        /** @type {string} */ this.attribute = attribute;
    }
}
/** @type {string|null} */ $524088d361a7d4ee$export$c4868e4a24d48fad.prototype.space = null;
$524088d361a7d4ee$export$c4868e4a24d48fad.prototype.boolean = false;
$524088d361a7d4ee$export$c4868e4a24d48fad.prototype.booleanish = false;
$524088d361a7d4ee$export$c4868e4a24d48fad.prototype.overloadedBoolean = false;
$524088d361a7d4ee$export$c4868e4a24d48fad.prototype.number = false;
$524088d361a7d4ee$export$c4868e4a24d48fad.prototype.commaSeparated = false;
$524088d361a7d4ee$export$c4868e4a24d48fad.prototype.spaceSeparated = false;
$524088d361a7d4ee$export$c4868e4a24d48fad.prototype.commaOrSpaceSeparated = false;
$524088d361a7d4ee$export$c4868e4a24d48fad.prototype.mustUseProperty = false;
$524088d361a7d4ee$export$c4868e4a24d48fad.prototype.defined = false;


var $de5bc928940d8fd6$exports = {};

$parcel$export($de5bc928940d8fd6$exports, "boolean", () => $de5bc928940d8fd6$export$4a21f16c33752377);
$parcel$export($de5bc928940d8fd6$exports, "booleanish", () => $de5bc928940d8fd6$export$55e9e1fbc638dc8f);
$parcel$export($de5bc928940d8fd6$exports, "overloadedBoolean", () => $de5bc928940d8fd6$export$242ac3d3042558aa);
$parcel$export($de5bc928940d8fd6$exports, "number", () => $de5bc928940d8fd6$export$98e628dec113755e);
$parcel$export($de5bc928940d8fd6$exports, "spaceSeparated", () => $de5bc928940d8fd6$export$ab8645c862eb5a3e);
$parcel$export($de5bc928940d8fd6$exports, "commaSeparated", () => $de5bc928940d8fd6$export$9c8d678629b3d3);
$parcel$export($de5bc928940d8fd6$exports, "commaOrSpaceSeparated", () => $de5bc928940d8fd6$export$2ad25cfebf36cacd);
let $de5bc928940d8fd6$var$powers = 0;
const $de5bc928940d8fd6$export$4a21f16c33752377 = $de5bc928940d8fd6$var$increment();
const $de5bc928940d8fd6$export$55e9e1fbc638dc8f = $de5bc928940d8fd6$var$increment();
const $de5bc928940d8fd6$export$242ac3d3042558aa = $de5bc928940d8fd6$var$increment();
const $de5bc928940d8fd6$export$98e628dec113755e = $de5bc928940d8fd6$var$increment();
const $de5bc928940d8fd6$export$ab8645c862eb5a3e = $de5bc928940d8fd6$var$increment();
const $de5bc928940d8fd6$export$9c8d678629b3d3 = $de5bc928940d8fd6$var$increment();
const $de5bc928940d8fd6$export$2ad25cfebf36cacd = $de5bc928940d8fd6$var$increment();
function $de5bc928940d8fd6$var$increment() {
    return 2 ** ++$de5bc928940d8fd6$var$powers;
}


/** @type {Array<keyof types>} */ // @ts-expect-error: hush.
const $e7d63acfa4a14b83$var$checks = Object.keys($de5bc928940d8fd6$exports);
class $e7d63acfa4a14b83$export$ea6b9f0064e88c9b extends (0, $524088d361a7d4ee$export$c4868e4a24d48fad) {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */ constructor(property, attribute, mask, space){
        let index = -1;
        super(property, attribute);
        $e7d63acfa4a14b83$var$mark(this, 'space', space);
        if (typeof mask === 'number') while(++index < $e7d63acfa4a14b83$var$checks.length){
            const check = $e7d63acfa4a14b83$var$checks[index];
            $e7d63acfa4a14b83$var$mark(this, $e7d63acfa4a14b83$var$checks[index], (mask & $de5bc928940d8fd6$exports[check]) === $de5bc928940d8fd6$exports[check]);
        }
    }
}
$e7d63acfa4a14b83$export$ea6b9f0064e88c9b.prototype.defined = true;
/**
 * @param {DefinedInfo} values
 * @param {string} key
 * @param {unknown} value
 */ function $e7d63acfa4a14b83$var$mark(values, key, value) {
    if (value) // @ts-expect-error: assume `value` matches the expected value of `key`.
    values[key] = value;
}


const $de2b678ad8261455$var$own = {}.hasOwnProperty;
function $de2b678ad8261455$export$185802fd694ee1f5(definition) {
    /** @type {Properties} */ const property = {};
    /** @type {Normal} */ const normal = {};
    /** @type {string} */ let prop;
    for(prop in definition.properties)if ($de2b678ad8261455$var$own.call(definition.properties, prop)) {
        const value = definition.properties[prop];
        const info = new (0, $e7d63acfa4a14b83$export$ea6b9f0064e88c9b)(prop, definition.transform(definition.attributes || {}, prop), value, definition.space);
        if (definition.mustUseProperty && definition.mustUseProperty.includes(prop)) info.mustUseProperty = true;
        property[prop] = info;
        normal[(0, $fd8dc6b15be37ef8$export$a3295358bff77e)(prop)] = prop;
        normal[(0, $fd8dc6b15be37ef8$export$a3295358bff77e)(info.attribute)] = prop;
    }
    return new (0, $d7a1890cf8e1b890$export$19342e026b58ebb7)(property, normal, definition.space);
}


const $caa7e0800a3df881$export$2bd1230ec7600845 = (0, $de2b678ad8261455$export$185802fd694ee1f5)({
    space: 'xlink',
    transform (_, prop) {
        return 'xlink:' + prop.slice(5).toLowerCase();
    },
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    }
});



const $357cb676d4bd90e9$export$f2913fe8983302e = (0, $de2b678ad8261455$export$185802fd694ee1f5)({
    space: 'xml',
    transform (_, prop) {
        return 'xml:' + prop.slice(3).toLowerCase();
    },
    properties: {
        xmlLang: null,
        xmlBase: null,
        xmlSpace: null
    }
});



/**
 * @param {Record<string, string>} attributes
 * @param {string} attribute
 * @returns {string}
 */ function $2af6444fa2fcad12$export$5b10b3bc32d7efbc(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}


function $01027a20087954dd$export$32b9e4cec9c208e1(attributes, property) {
    return (0, $2af6444fa2fcad12$export$5b10b3bc32d7efbc)(attributes, property.toLowerCase());
}


const $ae0993701c73ed4c$export$e20c24a128671213 = (0, $de2b678ad8261455$export$185802fd694ee1f5)({
    space: 'xmlns',
    attributes: {
        xmlnsxlink: 'xmlns:xlink'
    },
    transform: (0, $01027a20087954dd$export$32b9e4cec9c208e1),
    properties: {
        xmlns: null,
        xmlnsXLink: null
    }
});




const $9921ebbc6b22e5b1$export$4d2d26490572750a = (0, $de2b678ad8261455$export$185802fd694ee1f5)({
    transform (_, prop) {
        return prop === 'role' ? prop : 'aria-' + prop.slice(4).toLowerCase();
    },
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: (0, $de5bc928940d8fd6$export$55e9e1fbc638dc8f),
        ariaAutoComplete: null,
        ariaBusy: (0, $de5bc928940d8fd6$export$55e9e1fbc638dc8f),
        ariaChecked: (0, $de5bc928940d8fd6$export$55e9e1fbc638dc8f),
        ariaColCount: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        ariaColIndex: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        ariaColSpan: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        ariaControls: (0, $de5bc928940d8fd6$export$ab8645c862eb5a3e),
        ariaCurrent: null,
        ariaDescribedBy: (0, $de5bc928940d8fd6$export$ab8645c862eb5a3e),
        ariaDetails: null,
        ariaDisabled: (0, $de5bc928940d8fd6$export$55e9e1fbc638dc8f),
        ariaDropEffect: (0, $de5bc928940d8fd6$export$ab8645c862eb5a3e),
        ariaErrorMessage: null,
        ariaExpanded: (0, $de5bc928940d8fd6$export$55e9e1fbc638dc8f),
        ariaFlowTo: (0, $de5bc928940d8fd6$export$ab8645c862eb5a3e),
        ariaGrabbed: (0, $de5bc928940d8fd6$export$55e9e1fbc638dc8f),
        ariaHasPopup: null,
        ariaHidden: (0, $de5bc928940d8fd6$export$55e9e1fbc638dc8f),
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: (0, $de5bc928940d8fd6$export$ab8645c862eb5a3e),
        ariaLevel: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        ariaLive: null,
        ariaModal: (0, $de5bc928940d8fd6$export$55e9e1fbc638dc8f),
        ariaMultiLine: (0, $de5bc928940d8fd6$export$55e9e1fbc638dc8f),
        ariaMultiSelectable: (0, $de5bc928940d8fd6$export$55e9e1fbc638dc8f),
        ariaOrientation: null,
        ariaOwns: (0, $de5bc928940d8fd6$export$ab8645c862eb5a3e),
        ariaPlaceholder: null,
        ariaPosInSet: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        ariaPressed: (0, $de5bc928940d8fd6$export$55e9e1fbc638dc8f),
        ariaReadOnly: (0, $de5bc928940d8fd6$export$55e9e1fbc638dc8f),
        ariaRelevant: null,
        ariaRequired: (0, $de5bc928940d8fd6$export$55e9e1fbc638dc8f),
        ariaRoleDescription: (0, $de5bc928940d8fd6$export$ab8645c862eb5a3e),
        ariaRowCount: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        ariaRowIndex: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        ariaRowSpan: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        ariaSelected: (0, $de5bc928940d8fd6$export$55e9e1fbc638dc8f),
        ariaSetSize: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        ariaSort: null,
        ariaValueMax: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        ariaValueMin: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        ariaValueNow: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        ariaValueText: null,
        role: null
    }
});





const $efaa6e19099b8c52$export$c0bb0b647f701bb5 = (0, $de2b678ad8261455$export$185802fd694ee1f5)({
    space: 'html',
    attributes: {
        acceptcharset: 'accept-charset',
        classname: 'class',
        htmlfor: 'for',
        httpequiv: 'http-equiv'
    },
    transform: (0, $01027a20087954dd$export$32b9e4cec9c208e1),
    mustUseProperty: [
        'checked',
        'multiple',
        'muted',
        'selected'
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: (0, $de5bc928940d8fd6$export$9c8d678629b3d3),
        acceptCharset: (0, $de5bc928940d8fd6$export$ab8645c862eb5a3e),
        accessKey: (0, $de5bc928940d8fd6$export$ab8645c862eb5a3e),
        action: null,
        allow: null,
        allowFullScreen: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        allowPaymentRequest: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        allowUserMedia: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        alt: null,
        as: null,
        async: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        autoCapitalize: null,
        autoComplete: (0, $de5bc928940d8fd6$export$ab8645c862eb5a3e),
        autoFocus: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        autoPlay: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        blocking: (0, $de5bc928940d8fd6$export$ab8645c862eb5a3e),
        capture: null,
        charSet: null,
        checked: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        cite: null,
        className: (0, $de5bc928940d8fd6$export$ab8645c862eb5a3e),
        cols: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        colSpan: null,
        content: null,
        contentEditable: (0, $de5bc928940d8fd6$export$55e9e1fbc638dc8f),
        controls: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        controlsList: (0, $de5bc928940d8fd6$export$ab8645c862eb5a3e),
        coords: (0, $de5bc928940d8fd6$export$98e628dec113755e) | (0, $de5bc928940d8fd6$export$9c8d678629b3d3),
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        defer: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        dir: null,
        dirName: null,
        disabled: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        download: (0, $de5bc928940d8fd6$export$242ac3d3042558aa),
        draggable: (0, $de5bc928940d8fd6$export$55e9e1fbc638dc8f),
        encType: null,
        enterKeyHint: null,
        fetchPriority: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        formTarget: null,
        headers: (0, $de5bc928940d8fd6$export$ab8645c862eb5a3e),
        height: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        hidden: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        high: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        href: null,
        hrefLang: null,
        htmlFor: (0, $de5bc928940d8fd6$export$ab8645c862eb5a3e),
        httpEquiv: (0, $de5bc928940d8fd6$export$ab8645c862eb5a3e),
        id: null,
        imageSizes: null,
        imageSrcSet: null,
        inert: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        inputMode: null,
        integrity: null,
        is: null,
        isMap: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        itemId: null,
        itemProp: (0, $de5bc928940d8fd6$export$ab8645c862eb5a3e),
        itemRef: (0, $de5bc928940d8fd6$export$ab8645c862eb5a3e),
        itemScope: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        itemType: (0, $de5bc928940d8fd6$export$ab8645c862eb5a3e),
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        low: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        manifest: null,
        max: null,
        maxLength: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        media: null,
        method: null,
        min: null,
        minLength: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        multiple: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        muted: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        name: null,
        nonce: null,
        noModule: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        noValidate: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforeMatch: null,
        onBeforePrint: null,
        onBeforeToggle: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextLost: null,
        onContextMenu: null,
        onContextRestored: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onScrollEnd: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        optimum: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        pattern: null,
        ping: (0, $de5bc928940d8fd6$export$ab8645c862eb5a3e),
        placeholder: null,
        playsInline: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        popover: null,
        popoverTarget: null,
        popoverTargetAction: null,
        poster: null,
        preload: null,
        readOnly: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        referrerPolicy: null,
        rel: (0, $de5bc928940d8fd6$export$ab8645c862eb5a3e),
        required: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        reversed: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        rows: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        rowSpan: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        sandbox: (0, $de5bc928940d8fd6$export$ab8645c862eb5a3e),
        scope: null,
        scoped: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        seamless: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        selected: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        shadowRootClonable: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        shadowRootDelegatesFocus: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        shadowRootMode: null,
        shape: null,
        size: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        sizes: null,
        slot: null,
        span: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        spellCheck: (0, $de5bc928940d8fd6$export$55e9e1fbc638dc8f),
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: null,
        start: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        step: null,
        style: null,
        tabIndex: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        useMap: null,
        value: (0, $de5bc928940d8fd6$export$55e9e1fbc638dc8f),
        width: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        wrap: null,
        writingSuggestions: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: (0, $de5bc928940d8fd6$export$ab8645c862eb5a3e),
        axis: null,
        background: null,
        bgColor: null,
        border: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        borderColor: null,
        bottomMargin: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        declare: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        leftMargin: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        marginWidth: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        noResize: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        noHref: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        noShade: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        noWrap: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        rules: null,
        scheme: null,
        scrolling: (0, $de5bc928940d8fd6$export$55e9e1fbc638dc8f),
        standby: null,
        summary: null,
        text: null,
        topMargin: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        disablePictureInPicture: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        disableRemotePlayback: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        prefix: null,
        property: null,
        results: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        security: null,
        unselectable: null
    }
});





const $2087a7c4369e9115$export$7ed1367e7fa1ad68 = (0, $de2b678ad8261455$export$185802fd694ee1f5)({
    space: 'svg',
    attributes: {
        accentHeight: 'accent-height',
        alignmentBaseline: 'alignment-baseline',
        arabicForm: 'arabic-form',
        baselineShift: 'baseline-shift',
        capHeight: 'cap-height',
        className: 'class',
        clipPath: 'clip-path',
        clipRule: 'clip-rule',
        colorInterpolation: 'color-interpolation',
        colorInterpolationFilters: 'color-interpolation-filters',
        colorProfile: 'color-profile',
        colorRendering: 'color-rendering',
        crossOrigin: 'crossorigin',
        dataType: 'datatype',
        dominantBaseline: 'dominant-baseline',
        enableBackground: 'enable-background',
        fillOpacity: 'fill-opacity',
        fillRule: 'fill-rule',
        floodColor: 'flood-color',
        floodOpacity: 'flood-opacity',
        fontFamily: 'font-family',
        fontSize: 'font-size',
        fontSizeAdjust: 'font-size-adjust',
        fontStretch: 'font-stretch',
        fontStyle: 'font-style',
        fontVariant: 'font-variant',
        fontWeight: 'font-weight',
        glyphName: 'glyph-name',
        glyphOrientationHorizontal: 'glyph-orientation-horizontal',
        glyphOrientationVertical: 'glyph-orientation-vertical',
        hrefLang: 'hreflang',
        horizAdvX: 'horiz-adv-x',
        horizOriginX: 'horiz-origin-x',
        horizOriginY: 'horiz-origin-y',
        imageRendering: 'image-rendering',
        letterSpacing: 'letter-spacing',
        lightingColor: 'lighting-color',
        markerEnd: 'marker-end',
        markerMid: 'marker-mid',
        markerStart: 'marker-start',
        navDown: 'nav-down',
        navDownLeft: 'nav-down-left',
        navDownRight: 'nav-down-right',
        navLeft: 'nav-left',
        navNext: 'nav-next',
        navPrev: 'nav-prev',
        navRight: 'nav-right',
        navUp: 'nav-up',
        navUpLeft: 'nav-up-left',
        navUpRight: 'nav-up-right',
        onAbort: 'onabort',
        onActivate: 'onactivate',
        onAfterPrint: 'onafterprint',
        onBeforePrint: 'onbeforeprint',
        onBegin: 'onbegin',
        onCancel: 'oncancel',
        onCanPlay: 'oncanplay',
        onCanPlayThrough: 'oncanplaythrough',
        onChange: 'onchange',
        onClick: 'onclick',
        onClose: 'onclose',
        onCopy: 'oncopy',
        onCueChange: 'oncuechange',
        onCut: 'oncut',
        onDblClick: 'ondblclick',
        onDrag: 'ondrag',
        onDragEnd: 'ondragend',
        onDragEnter: 'ondragenter',
        onDragExit: 'ondragexit',
        onDragLeave: 'ondragleave',
        onDragOver: 'ondragover',
        onDragStart: 'ondragstart',
        onDrop: 'ondrop',
        onDurationChange: 'ondurationchange',
        onEmptied: 'onemptied',
        onEnd: 'onend',
        onEnded: 'onended',
        onError: 'onerror',
        onFocus: 'onfocus',
        onFocusIn: 'onfocusin',
        onFocusOut: 'onfocusout',
        onHashChange: 'onhashchange',
        onInput: 'oninput',
        onInvalid: 'oninvalid',
        onKeyDown: 'onkeydown',
        onKeyPress: 'onkeypress',
        onKeyUp: 'onkeyup',
        onLoad: 'onload',
        onLoadedData: 'onloadeddata',
        onLoadedMetadata: 'onloadedmetadata',
        onLoadStart: 'onloadstart',
        onMessage: 'onmessage',
        onMouseDown: 'onmousedown',
        onMouseEnter: 'onmouseenter',
        onMouseLeave: 'onmouseleave',
        onMouseMove: 'onmousemove',
        onMouseOut: 'onmouseout',
        onMouseOver: 'onmouseover',
        onMouseUp: 'onmouseup',
        onMouseWheel: 'onmousewheel',
        onOffline: 'onoffline',
        onOnline: 'ononline',
        onPageHide: 'onpagehide',
        onPageShow: 'onpageshow',
        onPaste: 'onpaste',
        onPause: 'onpause',
        onPlay: 'onplay',
        onPlaying: 'onplaying',
        onPopState: 'onpopstate',
        onProgress: 'onprogress',
        onRateChange: 'onratechange',
        onRepeat: 'onrepeat',
        onReset: 'onreset',
        onResize: 'onresize',
        onScroll: 'onscroll',
        onSeeked: 'onseeked',
        onSeeking: 'onseeking',
        onSelect: 'onselect',
        onShow: 'onshow',
        onStalled: 'onstalled',
        onStorage: 'onstorage',
        onSubmit: 'onsubmit',
        onSuspend: 'onsuspend',
        onTimeUpdate: 'ontimeupdate',
        onToggle: 'ontoggle',
        onUnload: 'onunload',
        onVolumeChange: 'onvolumechange',
        onWaiting: 'onwaiting',
        onZoom: 'onzoom',
        overlinePosition: 'overline-position',
        overlineThickness: 'overline-thickness',
        paintOrder: 'paint-order',
        panose1: 'panose-1',
        pointerEvents: 'pointer-events',
        referrerPolicy: 'referrerpolicy',
        renderingIntent: 'rendering-intent',
        shapeRendering: 'shape-rendering',
        stopColor: 'stop-color',
        stopOpacity: 'stop-opacity',
        strikethroughPosition: 'strikethrough-position',
        strikethroughThickness: 'strikethrough-thickness',
        strokeDashArray: 'stroke-dasharray',
        strokeDashOffset: 'stroke-dashoffset',
        strokeLineCap: 'stroke-linecap',
        strokeLineJoin: 'stroke-linejoin',
        strokeMiterLimit: 'stroke-miterlimit',
        strokeOpacity: 'stroke-opacity',
        strokeWidth: 'stroke-width',
        tabIndex: 'tabindex',
        textAnchor: 'text-anchor',
        textDecoration: 'text-decoration',
        textRendering: 'text-rendering',
        transformOrigin: 'transform-origin',
        typeOf: 'typeof',
        underlinePosition: 'underline-position',
        underlineThickness: 'underline-thickness',
        unicodeBidi: 'unicode-bidi',
        unicodeRange: 'unicode-range',
        unitsPerEm: 'units-per-em',
        vAlphabetic: 'v-alphabetic',
        vHanging: 'v-hanging',
        vIdeographic: 'v-ideographic',
        vMathematical: 'v-mathematical',
        vectorEffect: 'vector-effect',
        vertAdvY: 'vert-adv-y',
        vertOriginX: 'vert-origin-x',
        vertOriginY: 'vert-origin-y',
        wordSpacing: 'word-spacing',
        writingMode: 'writing-mode',
        xHeight: 'x-height',
        // These were camelcased in Tiny. Now lowercased in SVG 2
        playbackOrder: 'playbackorder',
        timelineBegin: 'timelinebegin'
    },
    transform: (0, $2af6444fa2fcad12$export$5b10b3bc32d7efbc),
    properties: {
        about: (0, $de5bc928940d8fd6$export$2ad25cfebf36cacd),
        accentHeight: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        accumulate: null,
        additive: null,
        alignmentBaseline: null,
        alphabetic: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        amplitude: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        arabicForm: null,
        ascent: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        attributeName: null,
        attributeType: null,
        azimuth: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        bandwidth: null,
        baselineShift: null,
        baseFrequency: null,
        baseProfile: null,
        bbox: null,
        begin: null,
        bias: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        by: null,
        calcMode: null,
        capHeight: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        className: (0, $de5bc928940d8fd6$export$ab8645c862eb5a3e),
        clip: null,
        clipPath: null,
        clipPathUnits: null,
        clipRule: null,
        color: null,
        colorInterpolation: null,
        colorInterpolationFilters: null,
        colorProfile: null,
        colorRendering: null,
        content: null,
        contentScriptType: null,
        contentStyleType: null,
        crossOrigin: null,
        cursor: null,
        cx: null,
        cy: null,
        d: null,
        dataType: null,
        defaultAction: null,
        descent: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        diffuseConstant: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        direction: null,
        display: null,
        dur: null,
        divisor: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        dominantBaseline: null,
        download: (0, $de5bc928940d8fd6$export$4a21f16c33752377),
        dx: null,
        dy: null,
        edgeMode: null,
        editable: null,
        elevation: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        enableBackground: null,
        end: null,
        event: null,
        exponent: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        externalResourcesRequired: null,
        fill: null,
        fillOpacity: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        fillRule: null,
        filter: null,
        filterRes: null,
        filterUnits: null,
        floodColor: null,
        floodOpacity: null,
        focusable: null,
        focusHighlight: null,
        fontFamily: null,
        fontSize: null,
        fontSizeAdjust: null,
        fontStretch: null,
        fontStyle: null,
        fontVariant: null,
        fontWeight: null,
        format: null,
        fr: null,
        from: null,
        fx: null,
        fy: null,
        g1: (0, $de5bc928940d8fd6$export$9c8d678629b3d3),
        g2: (0, $de5bc928940d8fd6$export$9c8d678629b3d3),
        glyphName: (0, $de5bc928940d8fd6$export$9c8d678629b3d3),
        glyphOrientationHorizontal: null,
        glyphOrientationVertical: null,
        glyphRef: null,
        gradientTransform: null,
        gradientUnits: null,
        handler: null,
        hanging: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        hatchContentUnits: null,
        hatchUnits: null,
        height: null,
        href: null,
        hrefLang: null,
        horizAdvX: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        horizOriginX: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        horizOriginY: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        id: null,
        ideographic: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        imageRendering: null,
        initialVisibility: null,
        in: null,
        in2: null,
        intercept: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        k: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        k1: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        k2: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        k3: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        k4: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        kernelMatrix: (0, $de5bc928940d8fd6$export$2ad25cfebf36cacd),
        kernelUnitLength: null,
        keyPoints: null,
        keySplines: null,
        keyTimes: null,
        kerning: null,
        lang: null,
        lengthAdjust: null,
        letterSpacing: null,
        lightingColor: null,
        limitingConeAngle: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        local: null,
        markerEnd: null,
        markerMid: null,
        markerStart: null,
        markerHeight: null,
        markerUnits: null,
        markerWidth: null,
        mask: null,
        maskContentUnits: null,
        maskUnits: null,
        mathematical: null,
        max: null,
        media: null,
        mediaCharacterEncoding: null,
        mediaContentEncodings: null,
        mediaSize: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        mediaTime: null,
        method: null,
        min: null,
        mode: null,
        name: null,
        navDown: null,
        navDownLeft: null,
        navDownRight: null,
        navLeft: null,
        navNext: null,
        navPrev: null,
        navRight: null,
        navUp: null,
        navUpLeft: null,
        navUpRight: null,
        numOctaves: null,
        observer: null,
        offset: null,
        onAbort: null,
        onActivate: null,
        onAfterPrint: null,
        onBeforePrint: null,
        onBegin: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnd: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFocusIn: null,
        onFocusOut: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadStart: null,
        onMessage: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onMouseWheel: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRepeat: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onShow: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onZoom: null,
        opacity: null,
        operator: null,
        order: null,
        orient: null,
        orientation: null,
        origin: null,
        overflow: null,
        overlay: null,
        overlinePosition: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        overlineThickness: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        paintOrder: null,
        panose1: null,
        path: null,
        pathLength: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        patternContentUnits: null,
        patternTransform: null,
        patternUnits: null,
        phase: null,
        ping: (0, $de5bc928940d8fd6$export$ab8645c862eb5a3e),
        pitch: null,
        playbackOrder: null,
        pointerEvents: null,
        points: null,
        pointsAtX: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        pointsAtY: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        pointsAtZ: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        preserveAlpha: null,
        preserveAspectRatio: null,
        primitiveUnits: null,
        propagate: null,
        property: (0, $de5bc928940d8fd6$export$2ad25cfebf36cacd),
        r: null,
        radius: null,
        referrerPolicy: null,
        refX: null,
        refY: null,
        rel: (0, $de5bc928940d8fd6$export$2ad25cfebf36cacd),
        rev: (0, $de5bc928940d8fd6$export$2ad25cfebf36cacd),
        renderingIntent: null,
        repeatCount: null,
        repeatDur: null,
        requiredExtensions: (0, $de5bc928940d8fd6$export$2ad25cfebf36cacd),
        requiredFeatures: (0, $de5bc928940d8fd6$export$2ad25cfebf36cacd),
        requiredFonts: (0, $de5bc928940d8fd6$export$2ad25cfebf36cacd),
        requiredFormats: (0, $de5bc928940d8fd6$export$2ad25cfebf36cacd),
        resource: null,
        restart: null,
        result: null,
        rotate: null,
        rx: null,
        ry: null,
        scale: null,
        seed: null,
        shapeRendering: null,
        side: null,
        slope: null,
        snapshotTime: null,
        specularConstant: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        specularExponent: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        spreadMethod: null,
        spacing: null,
        startOffset: null,
        stdDeviation: null,
        stemh: null,
        stemv: null,
        stitchTiles: null,
        stopColor: null,
        stopOpacity: null,
        strikethroughPosition: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        strikethroughThickness: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        string: null,
        stroke: null,
        strokeDashArray: (0, $de5bc928940d8fd6$export$2ad25cfebf36cacd),
        strokeDashOffset: null,
        strokeLineCap: null,
        strokeLineJoin: null,
        strokeMiterLimit: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        strokeOpacity: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        strokeWidth: null,
        style: null,
        surfaceScale: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        syncBehavior: null,
        syncBehaviorDefault: null,
        syncMaster: null,
        syncTolerance: null,
        syncToleranceDefault: null,
        systemLanguage: (0, $de5bc928940d8fd6$export$2ad25cfebf36cacd),
        tabIndex: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        tableValues: null,
        target: null,
        targetX: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        targetY: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        textAnchor: null,
        textDecoration: null,
        textRendering: null,
        textLength: null,
        timelineBegin: null,
        title: null,
        transformBehavior: null,
        type: null,
        typeOf: (0, $de5bc928940d8fd6$export$2ad25cfebf36cacd),
        to: null,
        transform: null,
        transformOrigin: null,
        u1: null,
        u2: null,
        underlinePosition: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        underlineThickness: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        unicode: null,
        unicodeBidi: null,
        unicodeRange: null,
        unitsPerEm: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        values: null,
        vAlphabetic: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        vMathematical: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        vectorEffect: null,
        vHanging: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        vIdeographic: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        version: null,
        vertAdvY: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        vertOriginX: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        vertOriginY: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        viewBox: null,
        viewTarget: null,
        visibility: null,
        width: null,
        widths: null,
        wordSpacing: null,
        writingMode: null,
        x: null,
        x1: null,
        x2: null,
        xChannelSelector: null,
        xHeight: (0, $de5bc928940d8fd6$export$98e628dec113755e),
        y: null,
        y1: null,
        y2: null,
        yChannelSelector: null,
        z: null,
        zoomAndPan: null
    }
});


/**
 * @typedef {import('./util/schema.js').Schema} Schema
 */ 


const $9c81ef46d3d90a0a$var$valid = /^data[-\w.:]+$/i;
const $9c81ef46d3d90a0a$var$dash = /-[a-z]/g;
const $9c81ef46d3d90a0a$var$cap = /[A-Z]/g;
function $9c81ef46d3d90a0a$export$71aa6c912b956294(schema, value) {
    const normal = (0, $fd8dc6b15be37ef8$export$a3295358bff77e)(value);
    let prop = value;
    let Type = (0, $524088d361a7d4ee$export$c4868e4a24d48fad);
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === 'data' && $9c81ef46d3d90a0a$var$valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === '-') {
            // Turn it into a property.
            const rest = value.slice(5).replace($9c81ef46d3d90a0a$var$dash, $9c81ef46d3d90a0a$var$camelcase);
            prop = 'data' + rest.charAt(0).toUpperCase() + rest.slice(1);
        } else {
            // Turn it into an attribute.
            const rest = value.slice(4);
            if (!$9c81ef46d3d90a0a$var$dash.test(rest)) {
                let dashes = rest.replace($9c81ef46d3d90a0a$var$cap, $9c81ef46d3d90a0a$var$kebab);
                if (dashes.charAt(0) !== '-') dashes = '-' + dashes;
                value = 'data' + dashes;
            }
        }
        Type = (0, $e7d63acfa4a14b83$export$ea6b9f0064e88c9b);
    }
    return new Type(prop, value);
}
/**
 * @param {string} $0
 * @returns {string}
 */ function $9c81ef46d3d90a0a$var$kebab($0) {
    return '-' + $0.toLowerCase();
}
/**
 * @param {string} $0
 * @returns {string}
 */ function $9c81ef46d3d90a0a$var$camelcase($0) {
    return $0.charAt(1).toUpperCase();
}


/**
 * `hast` is close to `React`, but differs in a couple of cases.
 *
 * To get a React property from a hast property, check if it is in
 * `hastToReact`, if it is, then use the corresponding value,
 * otherwise, use the hast property.
 *
 * @type {Record<string, string>}
 */ const $86a1126900a14ef4$export$d8abd7e5fb6871f9 = {
    classId: 'classID',
    dataType: 'datatype',
    itemId: 'itemID',
    strokeDashArray: 'strokeDasharray',
    strokeDashOffset: 'strokeDashoffset',
    strokeLineCap: 'strokeLinecap',
    strokeLineJoin: 'strokeLinejoin',
    strokeMiterLimit: 'strokeMiterlimit',
    typeOf: 'typeof',
    xLinkActuate: 'xlinkActuate',
    xLinkArcRole: 'xlinkArcrole',
    xLinkHref: 'xlinkHref',
    xLinkRole: 'xlinkRole',
    xLinkShow: 'xlinkShow',
    xLinkTitle: 'xlinkTitle',
    xLinkType: 'xlinkType',
    xmlnsXLink: 'xmlnsXlink'
};



const $6926d29791d555d9$export$c0bb0b647f701bb5 = (0, $7f41ae780ac957a8$export$4950aa0f605343fb)([
    (0, $357cb676d4bd90e9$export$f2913fe8983302e),
    (0, $caa7e0800a3df881$export$2bd1230ec7600845),
    (0, $ae0993701c73ed4c$export$e20c24a128671213),
    (0, $9921ebbc6b22e5b1$export$4d2d26490572750a),
    (0, $efaa6e19099b8c52$export$c0bb0b647f701bb5)
], 'html');
const $6926d29791d555d9$export$7ed1367e7fa1ad68 = (0, $7f41ae780ac957a8$export$4950aa0f605343fb)([
    (0, $357cb676d4bd90e9$export$f2913fe8983302e),
    (0, $caa7e0800a3df881$export$2bd1230ec7600845),
    (0, $ae0993701c73ed4c$export$e20c24a128671213),
    (0, $9921ebbc6b22e5b1$export$4d2d26490572750a),
    (0, $2087a7c4369e9115$export$7ed1367e7fa1ad68)
], 'svg');



function $b9008a4eced26230$export$2e2bcd8739ae039(options) {
    if (options.allowedElements && options.disallowedElements) throw new TypeError('Only one of `allowedElements` and `disallowedElements` should be defined');
    if (options.allowedElements || options.disallowedElements || options.allowElement) return (tree)=>{
        (0, $7b8aaa01fbc1a004$export$bf638b60ea8b89b7)(tree, 'element', (node, index, parent_)=>{
            const parent = /** @type {Element|Root} */ parent_;
            /** @type {boolean|undefined} */ let remove;
            if (options.allowedElements) remove = !options.allowedElements.includes(node.tagName);
            else if (options.disallowedElements) remove = options.disallowedElements.includes(node.tagName);
            if (!remove && options.allowElement && typeof index === 'number') remove = !options.allowElement(node, index, parent);
            if (remove && typeof index === 'number') {
                if (options.unwrapDisallowed && node.children) parent.children.splice(index, 1, ...node.children);
                else parent.children.splice(index, 1);
                return index;
            }
            return undefined;
        });
    };
}


/**
 * @template T
 * @typedef {import('react').ComponentType<T>} ComponentType<T>
 */ /**
 * @template {import('react').ElementType} T
 * @typedef {import('react').ComponentPropsWithoutRef<T>} ComponentPropsWithoutRef<T>
 */ /**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('unist').Position} Position
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Text} Text
 * @typedef {import('hast').Comment} Comment
 * @typedef {import('hast').DocType} Doctype
 * @typedef {import('property-information').Info} Info
 * @typedef {import('property-information').Schema} Schema
 * @typedef {import('./complex-types.js').ReactMarkdownProps} ReactMarkdownProps
 *
 * @typedef Raw
 * @property {'raw'} type
 * @property {string} value
 *
 * @typedef Context
 * @property {Options} options
 * @property {Schema} schema
 * @property {number} listDepth
 *
 * @callback TransformLink
 * @param {string} href
 * @param {Array<ElementContent>} children
 * @param {string?} title
 * @returns {string}
 *
 * @callback TransformImage
 * @param {string} src
 * @param {string} alt
 * @param {string?} title
 * @returns {string}
 *
 * @typedef {import('react').HTMLAttributeAnchorTarget} TransformLinkTargetType
 *
 * @callback TransformLinkTarget
 * @param {string} href
 * @param {Array<ElementContent>} children
 * @param {string?} title
 * @returns {TransformLinkTargetType|undefined}
 *
 * @typedef {keyof JSX.IntrinsicElements} ReactMarkdownNames
 *
 * To do: is `data-sourcepos` typeable?
 *
 * @typedef {ComponentPropsWithoutRef<'code'> & ReactMarkdownProps & {inline?: boolean}} CodeProps
 * @typedef {ComponentPropsWithoutRef<'h1'> & ReactMarkdownProps & {level: number}} HeadingProps
 * @typedef {ComponentPropsWithoutRef<'li'> & ReactMarkdownProps & {checked: boolean|null, index: number, ordered: boolean}} LiProps
 * @typedef {ComponentPropsWithoutRef<'ol'> & ReactMarkdownProps & {depth: number, ordered: true}} OrderedListProps
 * @typedef {ComponentPropsWithoutRef<'td'> & ReactMarkdownProps & {style?: Record<string, unknown>, isHeader: false}} TableDataCellProps
 * @typedef {ComponentPropsWithoutRef<'th'> & ReactMarkdownProps & {style?: Record<string, unknown>, isHeader: true}} TableHeaderCellProps
 * @typedef {ComponentPropsWithoutRef<'tr'> & ReactMarkdownProps & {isHeader: boolean}} TableRowProps
 * @typedef {ComponentPropsWithoutRef<'ul'> & ReactMarkdownProps & {depth: number, ordered: false}} UnorderedListProps
 *
 * @typedef {ComponentType<CodeProps>} CodeComponent
 * @typedef {ComponentType<HeadingProps>} HeadingComponent
 * @typedef {ComponentType<LiProps>} LiComponent
 * @typedef {ComponentType<OrderedListProps>} OrderedListComponent
 * @typedef {ComponentType<TableDataCellProps>} TableDataCellComponent
 * @typedef {ComponentType<TableHeaderCellProps>} TableHeaderCellComponent
 * @typedef {ComponentType<TableRowProps>} TableRowComponent
 * @typedef {ComponentType<UnorderedListProps>} UnorderedListComponent
 *
 * @typedef SpecialComponents
 * @property {CodeComponent|ReactMarkdownNames} code
 * @property {HeadingComponent|ReactMarkdownNames} h1
 * @property {HeadingComponent|ReactMarkdownNames} h2
 * @property {HeadingComponent|ReactMarkdownNames} h3
 * @property {HeadingComponent|ReactMarkdownNames} h4
 * @property {HeadingComponent|ReactMarkdownNames} h5
 * @property {HeadingComponent|ReactMarkdownNames} h6
 * @property {LiComponent|ReactMarkdownNames} li
 * @property {OrderedListComponent|ReactMarkdownNames} ol
 * @property {TableDataCellComponent|ReactMarkdownNames} td
 * @property {TableHeaderCellComponent|ReactMarkdownNames} th
 * @property {TableRowComponent|ReactMarkdownNames} tr
 * @property {UnorderedListComponent|ReactMarkdownNames} ul
 *
 * @typedef {Partial<Omit<import('./complex-types.js').NormalComponents, keyof SpecialComponents> & SpecialComponents>} Components
 *
 * @typedef Options
 * @property {boolean} [sourcePos=false]
 * @property {boolean} [rawSourcePos=false]
 * @property {boolean} [skipHtml=false]
 * @property {boolean} [includeElementIndex=false]
 * @property {null|false|TransformLink} [transformLinkUri]
 * @property {TransformImage} [transformImageUri]
 * @property {TransformLinkTargetType|TransformLinkTarget} [linkTarget]
 * @property {Components} [components]
 */ 
var $h2ArV = parcelRequire("h2ArV");
var $fe0433f671cac268$exports = {};
'use strict';

$fe0433f671cac268$exports = (parcelRequire("i9dMJ"));


/**
 * Check if the given value is *inter-element whitespace*.
 *
 * @param {unknown} thing
 *   Thing to check (typically `Node` or `string`).
 * @returns {boolean}
 *   Whether the `value` is inter-element whitespace (`boolean`): consisting of
 *   zero or more of space, tab (`\t`), line feed (`\n`), carriage return
 *   (`\r`), or form feed (`\f`).
 *   If a node is passed it must be a `Text` node, whose `value` field is
 *   checked.
 */ function $de298f3c9d804ad5$export$7af1228ff777d175(thing) {
    /** @type {string} */ const value = // @ts-expect-error looks like a node.
    thing && typeof thing === 'object' && thing.type === 'text' ? thing.value || '' : thing;
    // HTML whitespace expression.
    // See <https://infra.spec.whatwg.org/#ascii-whitespace>.
    return typeof value === 'string' && value.replace(/[ \t\n\f\r]/g, '') === '';
}



/**
 * Parse space-separated tokens to an array of strings.
 *
 * @param {string} value
 *   Space-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $e6d3d39aedf2c7dd$export$98e6a39c04603d36(value) {
    const input = String(value || '').trim();
    return input ? input.split(/[ \t\n\r\f]+/g) : [];
}
function $e6d3d39aedf2c7dd$export$fac44ee5b035f737(values) {
    return values.join(' ').trim();
}


/**
 * @typedef Options
 *   Configuration for `stringify`.
 * @property {boolean} [padLeft=true]
 *   Whether to pad a space before a token.
 * @property {boolean} [padRight=false]
 *   Whether to pad a space after a token.
 */ /**
 * @typedef {Options} StringifyOptions
 *   Please use `StringifyOptions` instead.
 */ /**
 * Parse comma-separated tokens to an array.
 *
 * @param {string} value
 *   Comma-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $856d7ec56f5fd9f9$export$98e6a39c04603d36(value) {
    /** @type {Array<string>} */ const tokens = [];
    const input = String(value || '');
    let index = input.indexOf(',');
    let start = 0;
    /** @type {boolean} */ let end = false;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        const token = input.slice(start, index).trim();
        if (token || !end) tokens.push(token);
        start = index + 1;
        index = input.indexOf(',', start);
    }
    return tokens;
}
function $856d7ec56f5fd9f9$export$fac44ee5b035f737(values, options) {
    const settings = options || {};
    // Ensure the last empty entry is seen.
    const input = values[values.length - 1] === '' ? [
        ...values,
        ''
    ] : values;
    return input.join((settings.padRight ? ' ' : '') + ',' + (settings.padLeft === false ? '' : ' ')).trim();
}


var $7127513da02de6e5$exports = {};
var $1a61182dbb13405c$exports = {};
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $1a61182dbb13405c$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $1a61182dbb13405c$var$NEWLINE_REGEX = /\n/g;
var $1a61182dbb13405c$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $1a61182dbb13405c$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $1a61182dbb13405c$var$COLON_REGEX = /^:\s*/;
var $1a61182dbb13405c$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $1a61182dbb13405c$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $1a61182dbb13405c$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $1a61182dbb13405c$var$NEWLINE = '\n';
var $1a61182dbb13405c$var$FORWARD_SLASH = '/';
var $1a61182dbb13405c$var$ASTERISK = '*';
var $1a61182dbb13405c$var$EMPTY_STRING = '';
// types
var $1a61182dbb13405c$var$TYPE_COMMENT = 'comment';
var $1a61182dbb13405c$var$TYPE_DECLARATION = 'declaration';
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ $1a61182dbb13405c$exports = function(style, options) {
    if (typeof style !== 'string') throw new TypeError('First argument must be a string');
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($1a61182dbb13405c$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($1a61182dbb13405c$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    var errorsList = [];
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ':' + lineno + ':' + column + ': ' + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) errorsList.push(err);
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($1a61182dbb13405c$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($1a61182dbb13405c$var$FORWARD_SLASH != style.charAt(0) || $1a61182dbb13405c$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($1a61182dbb13405c$var$EMPTY_STRING != style.charAt(i) && ($1a61182dbb13405c$var$ASTERISK != style.charAt(i) || $1a61182dbb13405c$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($1a61182dbb13405c$var$EMPTY_STRING === style.charAt(i - 1)) return error('End of comment missing');
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $1a61182dbb13405c$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($1a61182dbb13405c$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($1a61182dbb13405c$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($1a61182dbb13405c$var$VALUE_REGEX);
        var ret = pos({
            type: $1a61182dbb13405c$var$TYPE_DECLARATION,
            property: $1a61182dbb13405c$var$trim(prop[0].replace($1a61182dbb13405c$var$COMMENT_REGEX, $1a61182dbb13405c$var$EMPTY_STRING)),
            value: val ? $1a61182dbb13405c$var$trim(val[0].replace($1a61182dbb13405c$var$COMMENT_REGEX, $1a61182dbb13405c$var$EMPTY_STRING)) : $1a61182dbb13405c$var$EMPTY_STRING
        });
        // ;
        match($1a61182dbb13405c$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
};
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $1a61182dbb13405c$var$trim(str) {
    return str ? str.replace($1a61182dbb13405c$var$TRIM_REGEX, $1a61182dbb13405c$var$EMPTY_STRING) : $1a61182dbb13405c$var$EMPTY_STRING;
}


/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */ function $7127513da02de6e5$var$StyleToObject(style, iterator) {
    var output = null;
    if (!style || typeof style !== 'string') return output;
    var declaration;
    var declarations = $1a61182dbb13405c$exports(style);
    var hasIterator = typeof iterator === 'function';
    var property;
    var value;
    for(var i = 0, len = declarations.length; i < len; i++){
        declaration = declarations[i];
        property = declaration.property;
        value = declaration.value;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            output || (output = {});
            output[property] = value;
        }
    }
    return output;
}
$7127513da02de6e5$exports = $7127513da02de6e5$var$StyleToObject;
$7127513da02de6e5$exports.default = $7127513da02de6e5$var$StyleToObject; // ESM support


var $bae855ff07f7124e$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($7127513da02de6e5$exports)));


const $692184a95457be04$var$protocols = [
    'http',
    'https',
    'mailto',
    'tel'
];
function $692184a95457be04$export$b83532a10e2e268b(uri) {
    const url = (uri || '').trim();
    const first = url.charAt(0);
    if (first === '#' || first === '/') return url;
    const colon = url.indexOf(':');
    if (colon === -1) return url;
    let index = -1;
    while(++index < $692184a95457be04$var$protocols.length){
        const protocol = $692184a95457be04$var$protocols[index];
        if (colon === protocol.length && url.slice(0, protocol.length).toLowerCase() === protocol) return url;
    }
    index = url.indexOf('?');
    if (index !== -1 && colon > index) return url;
    index = url.indexOf('#');
    if (index !== -1 && colon > index) return url;
    // eslint-disable-next-line no-script-url
    return 'javascript:void(0)';
}


const $c7ae602cff1e74bd$var$own = {}.hasOwnProperty;
// The table-related elements that must not contain whitespace text according
// to React.
const $c7ae602cff1e74bd$var$tableElements = new Set([
    'table',
    'thead',
    'tbody',
    'tfoot',
    'tr'
]);
function $c7ae602cff1e74bd$export$4b745c302603ab5d(context, node) {
    /** @type {Array<ReactNode>} */ const children = [];
    let childIndex = -1;
    /** @type {Comment|Doctype|Element|Raw|Text} */ let child;
    while(++childIndex < node.children.length){
        child = node.children[childIndex];
        if (child.type === 'element') children.push($c7ae602cff1e74bd$var$toReact(context, child, childIndex, node));
        else if (child.type === 'text') // Currently, a warning is triggered by react for *any* white space in
        // tables.
        // So we drop it.
        // See: <https://github.com/facebook/react/pull/7081>.
        // See: <https://github.com/facebook/react/pull/7515>.
        // See: <https://github.com/remarkjs/remark-react/issues/64>.
        // See: <https://github.com/remarkjs/react-markdown/issues/576>.
        {
            if (node.type !== 'element' || !$c7ae602cff1e74bd$var$tableElements.has(node.tagName) || !(0, $de298f3c9d804ad5$export$7af1228ff777d175)(child)) children.push(child.value);
        } else if (child.type === 'raw' && !context.options.skipHtml) // Default behavior is to show (encoded) HTML.
        children.push(child.value);
    }
    return children;
}
/**
 * @param {Context} context
 * @param {Element} node
 * @param {number} index
 * @param {Element|Root} parent
 */ function $c7ae602cff1e74bd$var$toReact(context, node, index, parent) {
    const options = context.options;
    const transform = options.transformLinkUri === undefined ? (0, $692184a95457be04$export$b83532a10e2e268b) : options.transformLinkUri;
    const parentSchema = context.schema;
    /** @type {ReactMarkdownNames} */ // @ts-expect-error assume a known HTML/SVG element.
    const name = node.tagName;
    /** @type {Record<string, unknown>} */ const properties = {};
    let schema = parentSchema;
    /** @type {string} */ let property;
    if (parentSchema.space === 'html' && name === 'svg') {
        schema = (0, $6926d29791d555d9$export$7ed1367e7fa1ad68);
        context.schema = schema;
    }
    if (node.properties) {
        for(property in node.properties)if ($c7ae602cff1e74bd$var$own.call(node.properties, property)) $c7ae602cff1e74bd$var$addProperty(properties, property, node.properties[property], context);
    }
    if (name === 'ol' || name === 'ul') context.listDepth++;
    const children = $c7ae602cff1e74bd$export$4b745c302603ab5d(context, node);
    if (name === 'ol' || name === 'ul') context.listDepth--;
    // Restore parent schema.
    context.schema = parentSchema;
    // Nodes created by plugins do not have positional info, in which case we use
    // an object that matches the position interface.
    const position = node.position || {
        start: {
            line: null,
            column: null,
            offset: null
        },
        end: {
            line: null,
            column: null,
            offset: null
        }
    };
    const component = options.components && $c7ae602cff1e74bd$var$own.call(options.components, name) ? options.components[name] : name;
    const basic = typeof component === 'string' || component === (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).Fragment;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($fe0433f671cac268$exports))).isValidElementType(component)) throw new TypeError(`Component for name \`${name}\` not defined or is not renderable`);
    properties.key = index;
    if (name === 'a' && options.linkTarget) properties.target = typeof options.linkTarget === 'function' ? options.linkTarget(String(properties.href || ''), node.children, typeof properties.title === 'string' ? properties.title : null) : options.linkTarget;
    if (name === 'a' && transform) properties.href = transform(String(properties.href || ''), node.children, typeof properties.title === 'string' ? properties.title : null);
    if (!basic && name === 'code' && parent.type === 'element' && parent.tagName !== 'pre') properties.inline = true;
    if (!basic && (name === 'h1' || name === 'h2' || name === 'h3' || name === 'h4' || name === 'h5' || name === 'h6')) properties.level = Number.parseInt(name.charAt(1), 10);
    if (name === 'img' && options.transformImageUri) properties.src = options.transformImageUri(String(properties.src || ''), String(properties.alt || ''), typeof properties.title === 'string' ? properties.title : null);
    if (!basic && name === 'li' && parent.type === 'element') {
        const input = $c7ae602cff1e74bd$var$getInputElement(node);
        properties.checked = input && input.properties ? Boolean(input.properties.checked) : null;
        properties.index = $c7ae602cff1e74bd$var$getElementsBeforeCount(parent, node);
        properties.ordered = parent.tagName === 'ol';
    }
    if (!basic && (name === 'ol' || name === 'ul')) {
        properties.ordered = name === 'ol';
        properties.depth = context.listDepth;
    }
    if (name === 'td' || name === 'th') {
        if (properties.align) {
            if (!properties.style) properties.style = {};
            // @ts-expect-error assume `style` is an object
            properties.style.textAlign = properties.align;
            delete properties.align;
        }
        if (!basic) properties.isHeader = name === 'th';
    }
    if (!basic && name === 'tr' && parent.type === 'element') properties.isHeader = Boolean(parent.tagName === 'thead');
    // If `sourcePos` is given, pass source information (line/column info from markdown source).
    if (options.sourcePos) properties['data-sourcepos'] = $c7ae602cff1e74bd$var$flattenPosition(position);
    if (!basic && options.rawSourcePos) properties.sourcePosition = node.position;
    // If `includeElementIndex` is given, pass node index info to components.
    if (!basic && options.includeElementIndex) {
        properties.index = $c7ae602cff1e74bd$var$getElementsBeforeCount(parent, node);
        properties.siblingCount = $c7ae602cff1e74bd$var$getElementsBeforeCount(parent);
    }
    if (!basic) properties.node = node;
    // Ensure no React warnings are emitted for void elements w/ children.
    return children.length > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).createElement(component, properties, children) : (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).createElement(component, properties);
}
/**
 * @param {Element|Root} node
 * @returns {Element?}
 */ function $c7ae602cff1e74bd$var$getInputElement(node) {
    let index = -1;
    while(++index < node.children.length){
        const child = node.children[index];
        if (child.type === 'element' && child.tagName === 'input') return child;
    }
    return null;
}
/**
 * @param {Element|Root} parent
 * @param {Element} [node]
 * @returns {number}
 */ function $c7ae602cff1e74bd$var$getElementsBeforeCount(parent, node) {
    let index = -1;
    let count = 0;
    while(++index < parent.children.length){
        if (parent.children[index] === node) break;
        if (parent.children[index].type === 'element') count++;
    }
    return count;
}
/**
 * @param {Record<string, unknown>} props
 * @param {string} prop
 * @param {unknown} value
 * @param {Context} ctx
 */ function $c7ae602cff1e74bd$var$addProperty(props, prop, value, ctx) {
    const info = (0, $9c81ef46d3d90a0a$export$71aa6c912b956294)(ctx.schema, prop);
    let result = value;
    // Ignore nullish and `NaN` values.
    // eslint-disable-next-line no-self-compare
    if (result === null || result === undefined || result !== result) return;
    // Accept `array`.
    // Most props are space-separated.
    if (Array.isArray(result)) result = info.commaSeparated ? (0, $856d7ec56f5fd9f9$export$fac44ee5b035f737)(result) : (0, $e6d3d39aedf2c7dd$export$fac44ee5b035f737)(result);
    if (info.property === 'style' && typeof result === 'string') result = $c7ae602cff1e74bd$var$parseStyle(result);
    if (info.space && info.property) props[$c7ae602cff1e74bd$var$own.call((0, $86a1126900a14ef4$export$d8abd7e5fb6871f9), info.property) ? (0, $86a1126900a14ef4$export$d8abd7e5fb6871f9)[info.property] : info.property] = result;
    else if (info.attribute) props[info.attribute] = result;
}
/**
 * @param {string} value
 * @returns {Record<string, string>}
 */ function $c7ae602cff1e74bd$var$parseStyle(value) {
    /** @type {Record<string, string>} */ const result = {};
    try {
        (0, $bae855ff07f7124e$export$2e2bcd8739ae039)(value, iterator);
    } catch  {
    // Silent.
    }
    return result;
    /**
   * @param {string} name
   * @param {string} v
   */ function iterator(name, v) {
        const k = name.slice(0, 4) === '-ms-' ? `ms-${name.slice(4)}` : name;
        result[k.replace(/-([a-z])/g, $c7ae602cff1e74bd$var$styleReplacer)] = v;
    }
}
/**
 * @param {unknown} _
 * @param {string} $1
 */ function $c7ae602cff1e74bd$var$styleReplacer(_, $1) {
    return $1.toUpperCase();
}
/**
 * @param {Position|{start: {line: null, column: null, offset: null}, end: {line: null, column: null, offset: null}}} pos
 * @returns {string}
 */ function $c7ae602cff1e74bd$var$flattenPosition(pos) {
    return [
        pos.start.line,
        ':',
        pos.start.column,
        '-',
        pos.end.line,
        ':',
        pos.end.column
    ].map(String).join('');
}


const $22413668b049720a$var$own = {}.hasOwnProperty;
const $22413668b049720a$var$changelog = 'https://github.com/remarkjs/react-markdown/blob/main/changelog.md';
/** @type {Record<string, Deprecation>} */ const $22413668b049720a$var$deprecated = {
    plugins: {
        to: 'remarkPlugins',
        id: 'change-plugins-to-remarkplugins'
    },
    renderers: {
        to: 'components',
        id: 'change-renderers-to-components'
    },
    astPlugins: {
        id: 'remove-buggy-html-in-markdown-parser'
    },
    allowDangerousHtml: {
        id: 'remove-buggy-html-in-markdown-parser'
    },
    escapeHtml: {
        id: 'remove-buggy-html-in-markdown-parser'
    },
    source: {
        to: 'children',
        id: 'change-source-to-children'
    },
    allowNode: {
        to: 'allowElement',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes'
    },
    allowedTypes: {
        to: 'allowedElements',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes'
    },
    disallowedTypes: {
        to: 'disallowedElements',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes'
    },
    includeNodeIndex: {
        to: 'includeElementIndex',
        id: 'change-includenodeindex-to-includeelementindex'
    }
};
function $22413668b049720a$export$83ef7ab426386201(options) {
    for(const key in $22413668b049720a$var$deprecated)if ($22413668b049720a$var$own.call($22413668b049720a$var$deprecated, key) && $22413668b049720a$var$own.call(options, key)) {
        const deprecation = $22413668b049720a$var$deprecated[key];
        console.warn(`[react-markdown] Warning: please ${deprecation.to ? `use \`${deprecation.to}\` instead of` : 'remove'} \`${key}\` (see <${$22413668b049720a$var$changelog}#${deprecation.id}> for more info)`);
        delete $22413668b049720a$var$deprecated[key];
    }
    const processor = (0, $488c3d2fa2528428$export$7cc1b2fe10c52bb)().use((0, $042dcb53d47f39c2$export$2e2bcd8739ae039)).use(options.remarkPlugins || []).use((0, $2efd413341b24da5$export$2e2bcd8739ae039), {
        ...options.remarkRehypeOptions,
        allowDangerousHtml: true
    }).use(options.rehypePlugins || []).use((0, $b9008a4eced26230$export$2e2bcd8739ae039), options);
    const file = new (0, $1721c824e44cfb0f$export$93dff69eb10dc7ce)();
    if (typeof options.children === 'string') file.value = options.children;
    else if (options.children !== undefined && options.children !== null) console.warn(`[react-markdown] Warning: please pass a string as \`children\` (not: \`${options.children}\`)`);
    const hastNode = processor.runSync(processor.parse(file), file);
    if (hastNode.type !== 'root') throw new TypeError('Expected a `root` node');
    /** @type {ReactElement} */ let result = (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).Fragment, {}, (0, $c7ae602cff1e74bd$export$4b745c302603ab5d)({
        options: options,
        schema: (0, $6926d29791d555d9$export$c0bb0b647f701bb5),
        listDepth: 0
    }, hastNode));
    if (options.className) result = (0, (/*@__PURE__*/$parcel$interopDefault($h2ArV))).createElement('div', {
        className: options.className
    }, result);
    return result;
}
$22413668b049720a$export$83ef7ab426386201.propTypes = {
    // Core options:
    children: (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).string,
    // Layout options:
    className: (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).string,
    // Filter options:
    allowElement: (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).func,
    allowedElements: (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).string),
    disallowedElements: (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).string),
    unwrapDisallowed: (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).bool,
    // Plugin options:
    remarkPlugins: (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).bool,
            (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).arrayOf(// prettier-ignore
            // type-coverage:ignore-next-line
            (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).any)
        ]))
    ])),
    rehypePlugins: (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).bool,
            (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).arrayOf(// prettier-ignore
            // type-coverage:ignore-next-line
            (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).any)
        ]))
    ])),
    // Transform options:
    sourcePos: (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).bool,
    rawSourcePos: (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).bool,
    skipHtml: (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).bool,
    includeElementIndex: (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).bool,
    transformLinkUri: (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).bool
    ]),
    linkTarget: (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).string
    ]),
    transformImageUri: (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).func,
    components: (0, (/*@__PURE__*/$parcel$interopDefault($3eqDI))).object
};





var $h2ArV = parcelRequire("h2ArV");
const $1e61c80feaac64ad$export$1a1b434dde1370b3 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div', (0, $h2ArV.forwardRef))`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: ${(props)=>props.width}; /* Dynamic width */
  background-color: var(--surface);
  border-right: 1px solid var(--surface);
  overflow-y: auto;
  color: var(--white);
  position: relative; /* To position the resize handle */
  overflow-y: auto;
  overflow: visible; 
  padding: 0 1em 1em;
`;
const $1e61c80feaac64ad$export$33f2411a0ad35be7 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  height: 100%;

  background-color: rgb(165, 165, 165);
  width: 2px;

  position: absolute;
  top: 0;
  right: 0;

  cursor: ew-resize;

  // these prevent text selection while dragging
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  transition: background-color 0.2s ease-out, width 0.2s ease-out;

  &:hover {
    width: 3px;
    background-color: rgb(93, 159, 235);
  }
`;
const $1e61c80feaac64ad$export$de65de8213222d10 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('button')`
  position: absolute;
  top: .6em;
  z-index: 1;
  right: -1em;
  height: 2em;
  width: 2em;
  font: inherit;
  color: inherit;
  background: var(--toolbar);
  border: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  border-radius: .3em;
  cursor: pointer;
`;
const $1e61c80feaac64ad$export$585a3b23e887288b = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
`;
const $1e61c80feaac64ad$export$f99233281efd08a0 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('h2')`
  font-size: 1.2em;
  font-weight: 600;
`;
const $1e61c80feaac64ad$export$7c6e2c02157bb7d2 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  margin-top: 30px;
`;
const $1e61c80feaac64ad$export$eddf54ea3db8d0f0 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  position: absolute;
  top: .6em;
  right: 2em;
  height: 2em;
  display: flex;
  justify-content: center; 
  gap: 0.5em; 


  Button:nth-child(1) {
    background-color: transparent;
    color: var(--primary-dark);
    border: 2.5px solid var(--toolbar); 

    &:hover {
      background-color: var(--toolbar);
      color: white;
    }
  }
`;
const $1e61c80feaac64ad$export$a8d3280cb45e38b8 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  position: absolute;
  top: .6em;
  right: 2em;
  height: 2em;
  display: flex;
  justify-content: center; 
  gap: 0.5em; 
`;
const $1e61c80feaac64ad$export$f5c9f3c2c4054eec = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('textarea')`
  width: 100%;
  padding: 0.6rem;
  font-size: 1rem;
  border: 1px solid var(--border);
  border-radius: 0.3rem;
  margin-bottom: 0.8rem;
  box-sizing: border-box;
  background-color: var(--toolbar);
  color: white; 
  resize: none;

  
  &:focus {
    outline: none;
    border-color: var(--primary); 
  }
`;
const $1e61c80feaac64ad$export$3e5e12dc01f20a43 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  justify-content: center;

  gap: 8px;
  margin-top: auto; /* Ensures pagination sticks to the bottom */
`;
const $1e61c80feaac64ad$export$ebde6d4e7862fe9d = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('select')`
  background-color: var(--surface);
  color: var(--white);
  border: 1px solid var(--white);
  padding: 0.2em;
  font-size: 14px;
  border-radius: 0.3em;
  cursor: pointer;

  &:hover {
    background-color: var(--white);
    color: var(--toolbar);
  }
`;





const $f0b54dc08bfd6ae3$var$ModuleWindow = ({ onPanelWidthChange: onPanelWidthChange })=>{
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)([
        'common',
        'editor'
    ]);
    const currentModule = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.module);
    const updateQuestion = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.upsertQuestion);
    const updateProject = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.upsertProject);
    const questions = currentModule.questions;
    const totalQuestions = Object.keys(questions).length;
    const currentProject = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project);
    const currentQuestionIndex = currentModule.projects.findIndex((project)=>project._id === currentProject._id);
    const updateModule = (0, $38932e4472f33f50$export$2e2bcd8739ae039)((s)=>s.upsertModule);
    const setProject = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.set);
    const currentQuestion = questions[currentProject._id];
    const setShowModuleWindow = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.setShowModuleWindow);
    const [panelWidth, setPanelWidth] = (0, $h2ArV.useState)('300px');
    const panelRef = (0, $h2ArV.useRef)(null);
    const [isEditing, setIsEditing] = (0, $h2ArV.useState)(false);
    const [question, setQuestion] = (0, $h2ArV.useState)(currentQuestion || '');
    const handleMouseDown = (e)=>{
        const startX = e.clientX;
        const startWidth = panelRef.current ? panelRef.current.offsetWidth : 300;
        const handleMouseMove = (moveEvent)=>{
            let newWidth = startWidth + (moveEvent.clientX - startX);
            if (newWidth > 650) newWidth = 650;
            if (newWidth < 300) newWidth = 300;
            setPanelWidth(`${newWidth}px`);
            onPanelWidthChange(newWidth);
        };
        const handleMouseUp = ()=>{
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };
    const handleClose = ()=>{
        setShowModuleWindow(false) // Close the module panel
        ;
    };
    (0, $h2ArV.useEffect)(()=>{
        // Ensure that the question is updated when the current question or module changes
        if (currentModule && currentProject._id) setQuestion(questions[currentProject._id] || '');
    }, [
        currentModule,
        currentProject._id
    ]);
    const saveModule = ()=>{
        const project = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039).getState().project;
        updateProject({
            ...project,
            meta: {
                ...project.meta,
                dateEdited: new Date().getTime()
            }
        });
        updateModule(currentModule);
    };
    const handleEditClick = ()=>{
        if (isEditing) {
            const currentQuestionId = Object.keys(questions)[currentQuestionIndex];
            updateQuestion(currentQuestionId, question);
            updateModule(currentModule);
        }
        setIsEditing(!isEditing);
    };
    const handlePageChange = (index)=>{
        saveModule();
        setProject(currentModule.projects[index]);
    };
    // If there are no questions or module data yet, show a loading or fallback message
    if (!questions || totalQuestions === 0 || !currentModule) return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $1e61c80feaac64ad$export$1a1b434dde1370b3), {
        width: panelWidth,
        children: t('component.module.loading', {
            ns: 'editor'
        })
    });
    // Cancel editing and reset the input fields to the stored values
    const handleCancelClick = ()=>{
        if (currentModule) setQuestion(currentQuestion || '') // Reset description input
        ;
        setIsEditing(false) // Exit edit mode without saving
        ;
    };
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $1e61c80feaac64ad$export$1a1b434dde1370b3), {
        ref: panelRef,
        width: panelWidth,
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $1e61c80feaac64ad$export$585a3b23e887288b), {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $1e61c80feaac64ad$export$f99233281efd08a0), {
                        children: t('component.module.title', {
                            ns: 'editor',
                            qNumber: currentQuestionIndex + 1
                        })
                    }),
                    isEditing ? /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $1e61c80feaac64ad$export$eddf54ea3db8d0f0), {
                        children: [
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                                onClick: handleCancelClick,
                                children: t('cancel', {
                                    ns: 'common'
                                })
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                                onClick: handleEditClick,
                                children: t('component.module.button.save', {
                                    ns: 'editor'
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $1e61c80feaac64ad$export$a8d3280cb45e38b8), {
                        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                            onClick: handleEditClick,
                            children: t('component.module.button.edit', {
                                ns: 'editor'
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $1e61c80feaac64ad$export$de65de8213222d10), {
                onClick: handleClose,
                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $127384410c27818a$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("hr", {}),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $1e61c80feaac64ad$export$7c6e2c02157bb7d2), {
                        children: isEditing ? /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $1e61c80feaac64ad$export$f5c9f3c2c4054eec), {
                            value: question,
                            onChange: (e)=>setQuestion(e.target.value),
                            placeholder: t('component.module.edit_placeholder', {
                                ns: 'editor'
                            }),
                            rows: 39
                        }) : /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $22413668b049720a$export$83ef7ab426386201), {
                            children: question
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $1e61c80feaac64ad$export$3e5e12dc01f20a43), {
                children: [
                    currentQuestionIndex !== 0 ? /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            if (currentQuestionIndex > 0) {
                                const newIndex = currentQuestionIndex - 1;
                                handlePageChange(newIndex);
                            }
                        },
                        disabled: currentQuestionIndex === 0,
                        style: {
                            backgroundColor: currentQuestionIndex > 0 ? 'var(--primary)' : 'transparent',
                            margin: '0 2px',
                            flex: 0
                        },
                        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $4521b69889606e38$export$2e2bcd8739ae039), {})
                    }) : null,
                    currentQuestionIndex > 0 ? /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                        onClick: ()=>handlePageChange(currentQuestionIndex - 1),
                        style: {
                            backgroundColor: 'var(--primary)',
                            margin: '0 2px',
                            flex: 0
                        },
                        children: currentQuestionIndex
                    }) : /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("div", {
                        style: {
                            flex: 0
                        }
                    }) // Empty space when no previous question
                    ,
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                        style: {
                            backgroundColor: 'gray',
                            margin: '0 2px',
                            flex: 0
                        },
                        children: currentQuestionIndex + 1
                    }),
                    currentQuestionIndex < totalQuestions - 1 ? /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                        onClick: ()=>handlePageChange(currentQuestionIndex + 1),
                        style: {
                            backgroundColor: 'var(--primary)',
                            margin: '0 2px',
                            flex: 0
                        },
                        children: currentQuestionIndex + 2
                    }) : /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("div", {
                        style: {
                            flex: 0
                        }
                    }) // Empty space when no next question
                    ,
                    currentQuestionIndex !== totalQuestions - 1 ? /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            if (currentQuestionIndex < totalQuestions - 1) {
                                const newIndex = currentQuestionIndex + 1;
                                handlePageChange(newIndex);
                            }
                        },
                        style: {
                            backgroundColor: currentQuestionIndex < totalQuestions - 1 ? 'var(--primary)' : 'transparent',
                            margin: '0 2px',
                            flex: 0
                        },
                        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $dfbd774c055342cf$export$2e2bcd8739ae039), {})
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $1e61c80feaac64ad$export$33f2411a0ad35be7), {
                onMouseDown: handleMouseDown
            })
        ]
    });
};
var $f0b54dc08bfd6ae3$export$2e2bcd8739ae039 = $f0b54dc08bfd6ae3$var$ModuleWindow;




var $h2ArV = parcelRequire("h2ArV");



const $44fce0dac798ce8f$export$9d2b4227a95687cc = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;         
  flex-direction: column; 
  align-items: center;   
  justify-content: flex-start; 
  bottom: 1rem;
  left: ${(p)=>p.$showLabWindow && p.$panelWidth ? `${p.$panelWidth + 110}px` : '5rem'}; 
  padding: 1.2rem;
  background: var(--surface);
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  font-size: 12px;
  font-weight: bold;
  position: fixed;
`;
const $44fce0dac798ce8f$export$d6858e9338295e66 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  padding: 0.2rem;
`;
const $44fce0dac798ce8f$export$50d5391cd1a018c6 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  font-weight: bold;
  font-size: 16px;
  width: 4.5rem;
  height: 1.8rem;
  margin-top: 0.4rem;
  padding-top: 0.5rem;
  background: var(--primary);
  color: white;
  border-radius: 7px;
  border: 0;
  text-align: center;  
  display: flex;       
  align-items: center; 
  justify-content: center; 
`;
const $44fce0dac798ce8f$export$1ed22987e4bcb895 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('button')`
  position: absolute;
  top: -.4em;
  z-index: 15;
  right: -0.6em;
  height: 2em;
  width: 2em;
  font-size: 1.2em;
  background: var(--toolbar);
  border: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: .3em;
  cursor: pointer;
`;
const $44fce0dac798ce8f$export$b04be29aa201d4f5 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('label')`
  text-transform: uppercase;
  font-size: 1.00em;
  font-weight: 600;
  letter-spacing: .1em;
  color: var(--input-border);
  display: block;
  padding: .6em .6rem;
`;



const $91b4ca9d41ef827a$var$PDAStackVisualiser = ({ panelWidth: panelWidth })=>{
    // Opens and closes the stack tab within the visualiser
    const [showStackTab, setShowStackTab] = (0, $h2ArV.useState)(true);
    // Opens and closes the entire stack visualiser component
    const [showStackVisualiser, setShowStackVisualiser] = (0, $h2ArV.useState)(true);
    const traceIDx = (0, $6baf371cdce3f20b$export$2e2bcd8739ae039)((s)=>s.traceIDx);
    const stackInfo = (0, $438f85b735159247$export$2e2bcd8739ae039)((s)=>s.stack);
    const projectType = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project.config.type);
    // Module window
    const showModuleWindow = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.showModuleWindow);
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)('common');
    // Stack
    const stack = [];
    let currentStack;
    // Stores stack variables
    if (stackInfo?.trace) {
        if (stackInfo.trace[traceIDx]) {
            currentStack = stackInfo.trace[traceIDx].currentStack;
            for(let i = 0; i < currentStack.length; i++)stack.push({
                element: currentStack[i],
                key: i
            });
        }
    }
    // Displays the stack
    function displayStack() {
        return stack.slice(0).reverse().map((x)=>{
            return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $44fce0dac798ce8f$export$50d5391cd1a018c6), {
                children: x.element
            }, x.key);
        });
    }
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('stackVisualiser:toggle', (e)=>{
        setShowStackVisualiser(e.detail.state);
    });
    return projectType === 'PDA' && showStackVisualiser && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $44fce0dac798ce8f$export$9d2b4227a95687cc), {
        $panelWidth: panelWidth,
        $showLabWindow: showModuleWindow,
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $44fce0dac798ce8f$export$b04be29aa201d4f5), {
                children: t('stack')
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $44fce0dac798ce8f$export$1ed22987e4bcb895), {
                onClick: ()=>setShowStackTab((e)=>!e),
                children: showStackTab ? '-' : '+'
            }),
            showStackTab ? /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $44fce0dac798ce8f$export$d6858e9338295e66), {
                children: displayStack()
            }) : null
        ]
    });
};
var $91b4ca9d41ef827a$export$2e2bcd8739ae039 = $91b4ca9d41ef827a$var$PDAStackVisualiser;




var $h2ArV = parcelRequire("h2ArV");




const $81cc5296beafa29a$var$TemplateDelConfDialog = ({ isOpen: isOpen, setOpen: setOpen, setClose: setClose })=>{
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)('common');
    const [title, setTitle] = (0, $h2ArV.useState)('');
    const [description, setDescription] = (0, $h2ArV.useState)('');
    const [tid, setTid] = (0, $h2ArV.useState)();
    const deleteTemplate = (0, $05b6df1ad576ef23$export$2e2bcd8739ae039)((s)=>s.deleteTemplate);
    const removeThumbnail = (0, $3954b8dde947d829$export$2e2bcd8739ae039)((s)=>s.removeThumbnail);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('modal:editorConfirmation', ({ detail: { title: title, description: description, tid: tid } })=>{
        setTitle(title);
        setDescription(description);
        setTid(tid);
        window.setTimeout(()=>setOpen(), 50);
    }, []);
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $a5fe3119a76402fb$export$2e2bcd8739ae039), {
        title: title,
        description: description,
        isOpen: isOpen,
        onClose: setClose,
        role: "alertdialog",
        actions: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                    secondary: true,
                    onClick: setClose,
                    children: t('cancel')
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                    onClick: ()=>{
                        deleteTemplate(tid);
                        removeThumbnail(`tmp${tid}-light`);
                        removeThumbnail(`tmp${tid}-dark`);
                        setClose();
                    },
                    children: t('confirm')
                })
            ]
        })
    });
};
var $81cc5296beafa29a$export$2e2bcd8739ae039 = $81cc5296beafa29a$var$TemplateDelConfDialog;




var $h2ArV = parcelRequire("h2ArV");












const $bba37ec52d58f54e$export$eddf54ea3db8d0f0 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  justify-content: right; 
  gap: 1em; 
  padding: 1em;
`;
const $bba37ec52d58f54e$export$d8b9db17e4be80d = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
`;
const $bba37ec52d58f54e$export$3c8c44a030fbe001 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
    pointer-events: auto;
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;
    max-width: 50%;
    max-height: 80%;
    overflow: auto;
    background-color: var(--surface);
    outline: 1px solid var(--input-border);
    box-shadow: 0 2px 5px rgba(0 0 0 / .5);
`;



const $c86c6ace0c08a331$var$TourContent = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;
    max-width: 50%;
    max-height: 80%;
    overflow: auto;
    background-color: var(--surface);
    outline: 1px solid var(--input-border);
    box-shadow: 0 2px 5px rgba(0 0 0 / .5);
`;
const $c86c6ace0c08a331$var$EditorPageTour = ({ onClose: onClose })=>{
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)([
        'common',
        'tutorials'
    ]);
    const [step, setStep] = (0, $h2ArV.useState)(0);
    // Define tour steps
    const steps = [
        {
            target: '',
            content: t('editor_tour.step1', {
                ns: 'tutorials'
            })
        },
        {
            target: '',
            content: t('editor_tour.step2', {
                ns: 'tutorials'
            })
        },
        {
            target: '',
            content: t('editor_tour.step3', {
                ns: 'tutorials'
            })
        },
        {
            target: '',
            content: t('editor_tour.step4', {
                ns: 'tutorials'
            })
        },
        {
            target: '',
            content: t('editor_tour.step5', {
                ns: 'tutorials'
            })
        },
        {
            target: '',
            content: t('editor_tour.step6', {
                ns: 'tutorials'
            })
        },
        {
            target: '',
            content: t('editor_tour.step7', {
                ns: 'tutorials'
            })
        },
        {
            target: '',
            content: t('editor_tour.step8', {
                ns: 'tutorials'
            })
        },
        {
            target: '',
            content: t('editor_tour.step9', {
                ns: 'tutorials'
            })
        },
        {
            target: '',
            content: t('editor_tour.step10', {
                ns: 'tutorials'
            })
        },
        {
            target: '',
            content: t('editor_tour.step11', {
                ns: 'tutorials'
            })
        }
    ];
    const handleNext = ()=>{
        if (step < steps.length - 1) setStep(step + 1);
        else // End the tour if it reaches the last step
        onClose();
    };
    const handleSkip = ()=>{
        onClose() // Close the tour
        ;
    };
    const handlePrevious = ()=>{
        if (step > 0) setStep(step - 1);
    };
    const icons = [
        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $c472c6f2d2b3edc7$export$2e2bcd8739ae039), {}, "MousePointer2"),
        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e21351e831545c86$export$2e2bcd8739ae039), {}, "Hand"),
        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $a5e712d7b7a447b6$export$2e2bcd8739ae039), {}, "Circle"),
        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $8a27542e8a20cbdc$export$2e2bcd8739ae039), {}, "ArrowUpRight"),
        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $db653877009fa44e$export$2e2bcd8739ae039), {}, "MessageSquare"),
        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e438f551aa34f135$export$2e2bcd8739ae039), {}, "FlaskConical"),
        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $827a5ca7f496cadf$export$2e2bcd8739ae039), {}, "InfoIcon"),
        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $244b608a864e4ea9$export$2e2bcd8739ae039), {}, "Settings"),
        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $9e4e2ab5c2f172dc$export$2e2bcd8739ae039), {}, "Star"),
        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ed9b1098b0fefefa$export$2e2bcd8739ae039), {}, "GraduationCap")
    ];
    const other = [
        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $051125520ff239fe$export$2e2bcd8739ae039), {}, "Info")
    ];
    const animations = [
        (0, (/*@__PURE__*/$parcel$interopDefault($796f04347b90ea04$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($6eb38acfac99e87a$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($8d9f9884ab8fb022$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($e270d1cb603ada0f$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($312f29d5818253ef$exports)))
    ];
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $bba37ec52d58f54e$export$d8b9db17e4be80d), {
        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)($c86c6ace0c08a331$var$TourContent, {
            tourStep: step,
            isBannerStep: steps[step].target === ".banner",
            children: [
                icons[step - 1],
                step === 7 && other[0],
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("p", {
                    children: steps[step].content
                }),
                step >= 1 && step <= 5 && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $45274391c854412e$export$c35d437ae5945fcd), {
                    children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1442674a31386efe$exports))), {
                        loop: true,
                        animationData: animations[step - 1],
                        play: true
                    })
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $bba37ec52d58f54e$export$eddf54ea3db8d0f0), {
                    children: [
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                            secondary: true,
                            onClick: handleSkip,
                            children: t("tour.skip", {
                                ns: "common"
                            })
                        }),
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                            onClick: handlePrevious,
                            disabled: step === 0,
                            children: t("tour.previous", {
                                ns: "common"
                            })
                        }),
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                            onClick: handleNext,
                            children: step === steps.length - 1 ? t("tour.finish", {
                                ns: "common"
                            }) : t("tour.next", {
                                ns: "common"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $c86c6ace0c08a331$export$2e2bcd8739ae039 = $c86c6ace0c08a331$var$EditorPageTour;



var $h2ArV = parcelRequire("h2ArV");


function $d99edbe15f6d5130$export$b5781dc2a74b92() {
    const navigate = (0, $4b112c041340d9ed$export$9770f232ac06a008)();
    const resetExportSettings = (0, $ef9e10319983727e$export$2e2bcd8739ae039)((s)=>s.reset);
    const setViewPositionAndScale = (0, $2c8de4ab9c0d9b91$export$2e2bcd8739ae039)((s)=>s.setViewPositionAndScale);
    const project = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project);
    const currentModule = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.module);
    const getProjectinModule = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.getProjectById);
    const setModule = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.setModule);
    const setShowModuleWindow = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.setShowModuleWindow);
    const updateModule = (0, $38932e4472f33f50$export$2e2bcd8739ae039)((s)=>s.upsertModule);
    // Redirect if project not found
    (0, $h2ArV.useEffect)(()=>{
        if (!project) navigate("/new");
    }, [
        project
    ]);
    // Initialize editor state
    (0, $h2ArV.useEffect)(()=>{
        resetExportSettings();
        setViewPositionAndScale({
            x: 0,
            y: 0
        }, 1);
    }, []);
    // Keep module synced with project
    (0, $h2ArV.useEffect)(()=>{
        if (!project) return;
        if (currentModule == null) setShowModuleWindow(false);
        else if (getProjectinModule(project._id) === undefined) {
            setModule(null);
            setShowModuleWindow(false);
        } else updateModule(currentModule);
    }, [
        currentModule,
        project
    ]);
}



var $h2ArV = parcelRequire("h2ArV");



function $3c23467febef82e4$export$baca0626c59a9dc4() {
    const { tool: tool, setTool: setTool } = (0, $9ea7efd115f178cf$export$2e2bcd8739ae039)();
    const [priorTool, setPriorTool] = (0, $h2ArV.useState)(undefined);
    // Spacebar down → temporarily switch to "hand" tool
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)("keydown", (e)=>{
        if ((0, $ca3c15cc6dee748a$export$612e6723d69a3e6c)(e)) return;
        if (!priorTool && e.code === "Space") {
            setPriorTool(tool);
            setTool("hand");
        }
        if (e.code === "Space") {
            e.preventDefault();
            e.stopPropagation();
        }
    }, [
        tool,
        priorTool
    ]);
    // Spacebar up → restore previous tool
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)("keyup", (e)=>{
        if ((0, $ca3c15cc6dee748a$export$612e6723d69a3e6c)(e)) return;
        if (priorTool && e.code === "Space") {
            setTool(priorTool);
            setPriorTool(undefined);
        }
        if (e.code === "Space") {
            e.preventDefault();
            e.stopPropagation();
        }
    }, [
        tool,
        priorTool
    ]);
    // Middle mouse click also switches to "hand" tool
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)("svg:mousedown", (e)=>{
        if (!priorTool && e.detail.originalEvent.button === 1) {
            setPriorTool(tool);
            setTool("hand");
        }
    }, [
        tool,
        priorTool
    ]);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)("svg:mouseup", (e)=>{
        if (priorTool && e.detail.originalEvent.button === 1) {
            setTool(priorTool);
            setPriorTool(undefined);
        }
    }, [
        tool,
        priorTool
    ]);
}



var $h2ArV = parcelRequire("h2ArV");


function $86c2d4d79d2983cc$export$cffe182d5f33b373() {
    const navigate = (0, $4b112c041340d9ed$export$9770f232ac06a008)();
    const project = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project);
    const currentModule = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.module);
    const getProjectinModule = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.getProjectById);
    const setModule = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.setModule);
    const setShowModuleWindow = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.setShowModuleWindow);
    const updateModule = (0, $38932e4472f33f50$export$2e2bcd8739ae039)((s)=>s.upsertModule);
    (0, $h2ArV.useEffect)(()=>{
        if (!project) {
            navigate("/new");
            return;
        }
        if (currentModule == null) {
            setShowModuleWindow(false);
            return;
        }
        if (getProjectinModule(project._id) === undefined) {
            setModule(null);
            setShowModuleWindow(false);
            return;
        }
        updateModule(currentModule);
    }, [
        project,
        currentModule
    ]);
}




var $h2ArV = parcelRequire("h2ArV");
const $b88fc222e516ac77$var$EditorUIContext = /*#__PURE__*/ (0, $h2ArV.createContext)(undefined);
function $b88fc222e516ac77$export$4da1ca2f19041183({ children: children }) {
    const [confirmDialogOpen, setConfirmDialogOpen] = (0, $h2ArV.useState)(false);
    const [showTour, setShowTour] = (0, $h2ArV.useState)(false);
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)($b88fc222e516ac77$var$EditorUIContext.Provider, {
        value: {
            confirmDialogOpen: confirmDialogOpen,
            setConfirmDialogOpen: setConfirmDialogOpen,
            showTour: showTour,
            setShowTour: setShowTour
        },
        children: children
    });
}
function $b88fc222e516ac77$export$145e27f7b5ad9d80() {
    const context = (0, $h2ArV.useContext)($b88fc222e516ac77$var$EditorUIContext);
    if (!context) throw new Error("useEditorUI must be used within an EditorUIProvider");
    return context;
}



var $h2ArV = parcelRequire("h2ArV");

function $6b3bbbd4fec85d91$export$82b270f291af5a5(defaultWidth = 300) {
    const [panelWidth, setPanelWidth] = (0, $h2ArV.useState)(defaultWidth);
    const showModuleWindow = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.showModuleWindow);
    (0, $h2ArV.useEffect)(()=>{
        if (showModuleWindow) setPanelWidth(defaultWidth);
    }, [
        showModuleWindow
    ]);
    return [
        panelWidth,
        setPanelWidth
    ];
}



function $b3cfd8deb28a43a1$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $b88fc222e516ac77$export$4da1ca2f19041183), {
        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)($b3cfd8deb28a43a1$var$Editor, {})
    });
}
function $b3cfd8deb28a43a1$var$Editor() {
    const [panelWidth, setPanelWidth] = (0, $6b3bbbd4fec85d91$export$82b270f291af5a5)();
    const { confirmDialogOpen: confirmDialogOpen, setConfirmDialogOpen: setConfirmDialogOpen, showTour: showTour, setShowTour: setShowTour } = (0, $b88fc222e516ac77$export$145e27f7b5ad9d80)();
    const project = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project);
    const projectType = project?.config.type;
    const isSaving = (0, $f7162e3030303bfe$export$2e2bcd8739ae039)();
    const { showModuleWindow: showModuleWindow, module: module } = (0, $be91e446fcb94886$export$2e2bcd8739ae039)();
    const setShowModuleWindow = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.setShowModuleWindow);
    (0, $d99edbe15f6d5130$export$b5781dc2a74b92)();
    (0, $3c23467febef82e4$export$baca0626c59a9dc4)();
    (0, $86c2d4d79d2983cc$export$cffe182d5f33b373)();
    // Listen to the custom event 'tour:start' to show the tour
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('tour:start', ()=>{
        setShowTour(true);
    });
    const handlePanelWidthChange = (newWidth)=>setPanelWidth(newWidth);
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $a7169d08c7fb682a$export$2e2bcd8739ae039), {
                isSaving: isSaving
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $63f12a9c983db38b$export$7c6e2c02157bb7d2), {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d111e8a0f2066e2$export$2e2bcd8739ae039), {}),
                    showModuleWindow && module && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $f0b54dc08bfd6ae3$export$2e2bcd8739ae039), {
                        onPanelWidthChange: handlePanelWidthChange
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $63f12a9c983db38b$export$a92c4e92ed722350), {
                        children: [
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $93f1d08e0fec2b6a$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5aadffeeffe570a7$export$2e2bcd8739ae039), {})
                        ]
                    }),
                    projectType === "PDA" && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $91b4ca9d41ef827a$export$2e2bcd8739ae039), {
                        panelWidth: panelWidth
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $affe7841397c2517$export$2e2bcd8739ae039), {
                        onToggle: setShowModuleWindow
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $aecc316235466713$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $931143b92b0f570e$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ca9b0c437b693aa9$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $fd8f52c67efbda5d$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e102458d258008dd$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $81cc5296beafa29a$export$2e2bcd8739ae039), {
                isOpen: confirmDialogOpen,
                setOpen: ()=>setConfirmDialogOpen(true),
                setClose: ()=>setConfirmDialogOpen(false)
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $46e591ed4221d5f7$export$2e2bcd8739ae039), {
                navigateFunction: (0, $4b112c041340d9ed$export$9770f232ac06a008)()
            }),
            showTour && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $c86c6ace0c08a331$export$2e2bcd8739ae039), {
                onClose: ()=>setShowTour(false)
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $62ca164bc3888523$export$2e2bcd8739ae039), {})
        ]
    });
}





const $a6c08777ae81de46$var$About = ()=>{
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)('about');
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $ca8af2a7a8a4cd53$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $193714fcc8f30367$export$2e2bcd8739ae039), {
                center: true,
                linkTo: "/"
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("h2", {
                children: t('heading')
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("p", {
                children: t('paragraph1')
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $830e59bd42af92d3$export$8d6a9236f2e3f2ce), {
                    ns: "about",
                    i18nKey: "paragraph2",
                    components: {
                        linkjflap: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("a", {
                            href: "https://www.jflap.org/",
                            target: "_blank",
                            rel: "nofollow noreferrer"
                        })
                    }
                })
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $830e59bd42af92d3$export$8d6a9236f2e3f2ce), {
                    ns: "about",
                    i18nKey: "paragraph3",
                    components: {
                        linksource: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("a", {
                            href: "https://github.com/automatarium/automatarium",
                            target: "_blank",
                            rel: "nofollow noreferrer"
                        }),
                        createissue: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("a", {
                            href: "https://github.com/automatarium/automatarium/issues/new/choose",
                            target: "_blank",
                            rel: "nofollow noreferrer"
                        })
                    }
                })
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("p", {
                children: t('note')
            })
        ]
    });
};
var $a6c08777ae81de46$export$2e2bcd8739ae039 = $a6c08777ae81de46$var$About;




const $a76a3f4d862cd577$var$Privacy = ()=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $ca8af2a7a8a4cd53$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $193714fcc8f30367$export$2e2bcd8739ae039), {
                center: true,
                linkTo: "/"
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("h2", {
                children: "Privacy"
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("p", {
                children: 'Automatarium (hereafter referred to as "Automatarium" or "we" or "our") understands your privacy is important, and has developed this privacy policy that describes how we collect and use your personal information when you are using the Automatarium website, platform, applications and related web technologies hereafter referred as the "Service" and the steps we take to protect your data.'
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("p", {
                children: "This page is used to inform visitors regarding the policies of the collection, use, and disclosure of Personal Information if using the Service."
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("p", {
                children: "If you choose to use the Service, then you agree to the collection and use of information in relation to this policy. Your information will not be used or shared with anyone except as described in this Privacy Policy."
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("h3", {
                children: "Information Collection and Use"
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("p", {
                children: "When you interact with our Service, we may collect the following information from you, as described below:"
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("strong", {
                                children: "Information you provide:"
                            }),
                            " All information in the project, including project name, state names and labels, transition inputs, etc. will be included in the data that you share. We do not see this, but anyone you share your projects with will, so sharing projects are done at your own risk."
                        ]
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("strong", {
                                children: "Information collected automatically:"
                            }),
                            " When you interact with our Service, we collect information that is automatically sent to us, this includes your IP address, any information that your browser sends to our Service as well as your activity in the Service"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("h3", {
                children: "Information Disclosure"
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("p", {
                children: "Automatarium does not provide, sell, rent or lease your information to any third parties. However, there are certain circumstances where your information may be disclosed to certain third parties:"
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("strong", {
                                children: "Consent:"
                            }),
                            " We may disclose your information with your consent."
                        ]
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("strong", {
                                children: "Business transfer:"
                            }),
                            " If we or our business assets are acquired and user information among our assets transferred to or be acquired by a third party. You acknowledge that such transfers may occur, and that any parties who acquire us may continue to use your personal information according to this policy."
                        ]
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("strong", {
                                children: "Legal obligation:"
                            }),
                            " We may disclose your information if required to do so by law, to comply with our legal obligations or to protect the safety and integrity of our Service."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("h3", {
                children: "Security"
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("p", {
                children: "We take security seriously and use industry standard practices to protect personal information from loss or theft, as well as unauthorized access, disclosure, copying, use or modification. We regularly review our information collection, storage and processing practices."
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("h3", {
                children: "Cookies"
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("p", {
                children: "Cookies are files with a small amount of data that are commonly used as anonymous unique identifiers. These are sent to your browser from the websites that you visit and are stored on your device's internal memory."
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("p", {
                children: "We currently do not use cookies in Automatarium."
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("h3", {
                children: "Links to Other Sites"
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("p", {
                children: "The Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by the Service. Therefore, you are advised to review the Privacy Policy of these websites."
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("p", {
                children: [
                    "Our tutorial videos use the YouTube service. Please review the ",
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("a", {
                        href: "https://policies.google.com/privacy",
                        children: "YouTube Privacy Policy"
                    }),
                    " if you are unsure."
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("h3", {
                children: "Children's Privacy"
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("p", {
                children: "Our services are for users over the age of 13. We do not knowingly collect or store personal information from children (visitors under the age of 13). If you are under the age of 13, you are ineligible to use the Service. If you believe your child has provided us with personal information, we encourage you to contact us immediately, and we will promptly remove such information from our Service."
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("h3", {
                children: "Changes to our Privacy Policy"
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("p", {
                children: "We reserve the right to update or modify this Privacy Policy at any time and from time to time without prior notice. Please review this policy periodically, and especially before you provide any information. This Privacy Policy was last updated on the date indicated below. Your continued use of the Service after any changes or revisions to this Privacy Policy shall indicate your agreement with the terms of such revised Privacy Policy."
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("h3", {
                children: "Contact"
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("p", {
                children: [
                    "For any questions or concerns please contact ",
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("a", {
                        href: "https://www.rmit.edu.au/contact",
                        children: "RMIT University"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("p", {
                children: [
                    "Last updated: ",
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("strong", {
                        children: "28th October, 2023"
                    })
                ]
            })
        ]
    });
var $a76a3f4d862cd577$export$2e2bcd8739ae039 = $a76a3f4d862cd577$var$Privacy;




/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c52315ffced03e9e$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3",
            key: "1u773s"
        }
    ],
    [
        "path",
        {
            d: "M12 17h.01",
            key: "p32p05"
        }
    ]
];
const $c52315ffced03e9e$export$2e2bcd8739ae039 = (0, $764ec6f19a629312$export$2e2bcd8739ae039)("circle-help", $c52315ffced03e9e$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ae567ab0bba67702$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z",
            key: "1qme2f"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "3",
            key: "1v7zrd"
        }
    ]
];
const $ae567ab0bba67702$export$2e2bcd8739ae039 = (0, $764ec6f19a629312$export$2e2bcd8739ae039)("settings", $ae567ab0bba67702$export$3efd853dbb351e94);



var $h2ArV = parcelRequire("h2ArV");







const $cf4f73e50c7c8f12$export$118eab7b533de050 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('span')`
  opacity: .5;
  font-style: italic;
`;
const $cf4f73e50c7c8f12$export$f7dae34e2e37c751 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1em;
  flex-wrap: wrap;

  header { margin-bottom: 0; }
`;
const $cf4f73e50c7c8f12$export$69b1032f2ecdf404 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  gap: .8em;
`;
const $cf4f73e50c7c8f12$export$6d6b178f509c8df9 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('button')`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  border: 0;
  background: none;
  font: inherit;
  color: inherit;
  cursor: pointer;
  height: 2em;
  width: 2em;
`;





const $94edb6d6b302e375$export$aaf4394c64f68ed2 = ({ $icon: $icon, $secondary: $secondary, $surface: $surface })=>(0, $b1e4a7d525070c66$export$dbf350e5966cf602)({
        margin: 0,
        border: 0,
        background: 'var(--primary)',
        font: 'inherit',
        color: 'var(--white)',
        fontWeight: '600',
        borderRadius: '50%',
        fontSize: '.9em',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        appearance: 'none',
        gap: '.5em',
        padding: $icon ? '.375em' : '.5em 1.2em',
        position: 'fixed',
        bottom: '55px',
        right: '55px',
        width: '60px',
        height: '60px',
        textDecoration: 'none',
        '&:active': {
            filter: 'brightness(0.94)'
        },
        '&:disabled': {
            filter: 'none',
            backgroundColor: 'var(--disabled-button)',
            opacity: '.8',
            cursor: 'default'
        },
        backgroundColor: $secondary ? 'var(--toolbar)' : $surface ? 'var(--surface)' : undefined
    });


const $a61484d98edfe0cd$var$TourButton = ({ type: type = 'button', children: children, icon: icon, secondary: secondary, surface: surface, ...props })=>{
    // Select which element to use.
    let Element;
    if ('href' in props) Element = 'a';
    else if ('to' in props) Element = (0, $ea9c8114d35b5a84$export$a6c7ac8248d6e38a);
    else Element = 'button';
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)(Element, {
        className: (0, $94edb6d6b302e375$export$aaf4394c64f68ed2)({
            $icon: icon && !children,
            $secondary: secondary,
            $surface: surface
        }),
        type: type,
        ...props,
        children: [
            icon,
            children
        ]
    });
};
var $a61484d98edfe0cd$export$2e2bcd8739ae039 = $a61484d98edfe0cd$var$TourButton;




const $d45000dd58c0a4ae$var$FSA = ({ stateFill: stateFill, strokeColor: strokeColor })=>{
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("svg", {
        viewBox: "0 0 600 300",
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                        cx: "139.98",
                        cy: "79.08",
                        r: "48.69",
                        fill: stateFill
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                        d: "M139.98,32.39c25.74,0,46.69,20.94,46.69,46.69s-20.94,46.69-46.69,46.69-46.69-20.94-46.69-46.69,20.94-46.69,46.69-46.69m0-4c-27.99,0-50.69,22.69-50.69,50.69s22.69,50.69,50.69,50.69,50.69-22.69,50.69-50.69-22.69-50.69-50.69-50.69h0Z",
                        fill: strokeColor
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                        d: "M491.05,269.61c-26.85,0-48.69-21.84-48.69-48.69s21.84-48.69,48.69-48.69,48.69,21.84,48.69,48.69-21.84,48.69-48.69,48.69Z",
                        fill: stateFill
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                        d: "M491.05,174.24c25.74,0,46.69,20.94,46.69,46.69s-20.94,46.69-46.69,46.69-46.69-20.94-46.69-46.69,20.94-46.69,46.69-46.69m0-4c-27.99,0-50.69,22.69-50.69,50.69s22.69,50.69,50.69,50.69,50.69-22.69,50.69-50.69-22.69-50.69-50.69-50.69h0Z",
                        fill: strokeColor
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                d: "M491.05,183.28c20.76,0,37.64,16.89,37.64,37.64s-16.89,37.64-37.64,37.64-37.64-16.89-37.64-37.64,16.89-37.64,37.64-37.64m0-4c-23,0-41.64,18.65-41.64,41.64s18.65,41.64,41.64,41.64,41.64-18.65,41.64-41.64-18.65-41.64-41.64-41.64h0Z",
                fill: strokeColor
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("polygon", {
                points: "91.1 79.08 58.27 38.21 58.27 120.15 91.1 79.08",
                fill: "none",
                stroke: strokeColor,
                strokeLinejoin: "round",
                strokeWidth: "4"
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("line", {
                        x1: "185.19",
                        y1: "97.34",
                        x2: "432.97",
                        y2: "197.46",
                        fill: "none",
                        stroke: strokeColor,
                        strokeLinejoin: "round",
                        strokeWidth: "4"
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("polygon", {
                        points: "419.87 204.29 446.07 202.84 428.48 183.38 419.87 204.29",
                        fill: strokeColor
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                        d: "M285.86,120.06l13.16-32.39,6.86,2.79-1.05,2.58-3.75-1.52-11.06,27.23,3.75,1.52-1.05,2.58-6.86-2.79Z",
                        fill: strokeColor
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                        d: "M311.39,119.6c-1.55,.51-2.94,.75-4.17,.72-1.23-.03-2.46-.29-3.68-.79-2.02-.82-3.37-1.94-4.05-3.37-.68-1.42-.71-2.91-.09-4.44,.37-.9,.9-1.64,1.61-2.21s1.49-.96,2.34-1.14c.85-.18,1.73-.22,2.65-.11,.68,.09,1.66,.3,2.96,.66,2.63,.72,4.63,1.12,5.99,1.18,.18-.42,.3-.69,.35-.81,.51-1.27,.58-2.28,.21-3.04-.51-1.03-1.55-1.86-3.12-2.5-1.46-.59-2.65-.78-3.55-.55s-1.79,.93-2.65,2.09l-2.87-1.65c.81-1.19,1.69-2.06,2.65-2.6,.96-.54,2.13-.79,3.5-.73,1.37,.05,2.85,.4,4.43,1.04,1.57,.64,2.77,1.34,3.6,2.11,.83,.77,1.36,1.52,1.6,2.27,.23,.75,.27,1.58,.11,2.51-.11,.57-.45,1.55-1.01,2.93l-1.69,4.15c-1.17,2.89-1.85,4.75-2.03,5.57s-.21,1.66-.11,2.52l-3.25-1.32c-.06-.78,.04-1.62,.3-2.52Zm2.57-7.06c-1.32,0-3.17-.29-5.56-.89-1.35-.34-2.34-.5-2.97-.48-.62,.02-1.17,.19-1.64,.51-.47,.33-.81,.76-1.03,1.3-.34,.83-.3,1.65,.1,2.46,.4,.81,1.21,1.46,2.42,1.95,1.2,.49,2.37,.66,3.52,.51,1.15-.14,2.12-.58,2.93-1.32,.62-.57,1.21-1.54,1.77-2.91l.46-1.14Z",
                        fill: strokeColor
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                        d: "M320.06,116.89l1.27-3.13,9.56,3.88-1.27,3.13-9.56-3.88Z",
                        fill: strokeColor
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                        d: "M328.33,129.12l1.03-2.52,17.14-8.67c-1.35-.47-2.54-.91-3.55-1.32l-7.49-3.04,1.03-2.52,15.01,6.1-.84,2.06-14.68,7.61-2.78,1.35c1.44,.46,2.77,.94,3.99,1.44l8.49,3.45-1.09,2.68-16.25-6.6Z",
                        fill: strokeColor
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                        d: "M350.02,146.13l-6.86-2.79,1.05-2.58,3.75,1.52,11.06-27.23-3.75-1.52,1.05-2.58,6.86,2.79-13.16,32.38Z",
                        fill: strokeColor
                    })
                ]
            })
        ]
    });
};
var $d45000dd58c0a4ae$export$2e2bcd8739ae039 = $d45000dd58c0a4ae$var$FSA;


// Used https://svg2jsx.com/ for SVG conversion and manually deleted unncecessary parts/made inline to make similar to FSA.js

const $60e60342b049d73c$var$PDA = ({ stateFill: stateFill, strokeColor: strokeColor })=>{
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("svg", {
        viewBox: "364 324 347 192",
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("marker", {
                        id: "standard-arrow-head",
                        strokeWidth: "2",
                        markerHeight: "30",
                        markerUnits: "strokeWidth",
                        markerWidth: "30",
                        orient: "auto",
                        refX: "29",
                        refY: "15",
                        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                            fill: strokeColor,
                            d: "M29 15l-7.208-3.471v6.942z",
                            strokeWidth: "2"
                        })
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("marker", {
                        strokeWidth: "2",
                        markerHeight: "30",
                        markerUnits: "strokeWidth",
                        markerWidth: "30",
                        orient: "auto",
                        refX: "29",
                        refY: "15",
                        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                            strokeWidth: "2",
                            fill: strokeColor,
                            d: "M29 15l-7.208-3.471v6.942z"
                        })
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("marker", {
                        strokeWidth: "2",
                        markerHeight: "30",
                        markerUnits: "strokeWidth",
                        markerWidth: "30",
                        orient: "auto",
                        refX: "29",
                        refY: "15",
                        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                            stroke: strokeColor,
                            strokeWidth: "2",
                            d: "M29 15l-7.208-3.471M29 15l-7.208 3.471"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("g", {
                transform: "translate(435 465)",
                strokeWidth: "2.5",
                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                    r: "30",
                    fill: stateFill,
                    stroke: strokeColor
                })
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("g", {
                transform: "translate(660 375)",
                strokeWidth: "2.5",
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                        r: "30",
                        fill: stateFill,
                        stroke: strokeColor
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                        r: "25",
                        fill: stateFill,
                        stroke: strokeColor
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                fill: "none",
                stroke: strokeColor,
                d: "M405 465L385 440 385 490z",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                fill: "none",
                stroke: strokeColor,
                markerEnd: "url(#standard-arrow-head)",
                d: "M462.854 453.858l169.292-67.716",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                id: "0435465660375-text",
                fill: "none",
                stroke: "none",
                d: "M462.854 453.858l169.292-67.716"
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                fill: "none",
                stroke: "transparent",
                strokeWidth: "20",
                d: "M462.854 453.858l169.292-67.716"
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("text", {
                fill: strokeColor,
                alignmentBaseline: "central",
                dy: "-12",
                textAnchor: "middle",
                fontSize: "1.5em",
                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("textPath", {
                    startOffset: "50%",
                    xlinkHref: "#0435465660375-text",
                    children: "a,b;c"
                })
            })
        ]
    });
};
var $60e60342b049d73c$export$2e2bcd8739ae039 = $60e60342b049d73c$var$PDA;


// Used https://svg2jsx.com/ for SVG conversion and manually deleted unncecessary parts/made inline to make similar to FSA.js

const $87be68ad6a388013$var$TM = ({ stateFill: stateFill, strokeColor: strokeColor })=>{
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("svg", {
        viewBox: "454 384 362 192",
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("marker", {
                        id: "standard-arrow-head",
                        strokeWidth: "2",
                        markerHeight: "30",
                        markerUnits: "strokeWidth",
                        markerWidth: "30",
                        orient: "auto",
                        refX: "29",
                        refY: "15",
                        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                            fill: strokeColor,
                            d: "M29 15l-7.208-3.471v6.942z",
                            strokeWidth: "2"
                        })
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("marker", {
                        strokeWidth: "2",
                        markerHeight: "30",
                        markerUnits: "strokeWidth",
                        markerWidth: "30",
                        orient: "auto",
                        refX: "29",
                        refY: "15",
                        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                            strokeWidth: "2",
                            fill: strokeColor,
                            d: "M29 15l-7.208-3.471v6.942z"
                        })
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("marker", {
                        strokeWidth: "2",
                        markerHeight: "30",
                        markerUnits: "strokeWidth",
                        markerWidth: "30",
                        orient: "auto",
                        refX: "29",
                        refY: "15",
                        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                            stroke: strokeColor,
                            strokeWidth: "2",
                            d: "M29 15l-7.208-3.471M29 15l-7.208 3.471"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("g", {
                transform: "translate(525 525)",
                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                    r: "30",
                    fill: stateFill,
                    stroke: strokeColor,
                    strokeWidth: "2.5"
                })
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("g", {
                transform: "translate(645 435)",
                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                    r: "30",
                    fill: stateFill,
                    stroke: strokeColor,
                    strokeWidth: "2.5"
                })
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("g", {
                transform: "translate(765 525)",
                strokeWidth: "2.5",
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                        r: "30",
                        fill: stateFill,
                        stroke: strokeColor
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                        r: "25",
                        fill: stateFill,
                        stroke: strokeColor
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                fill: "none",
                stroke: strokeColor,
                strokeWidth: "2.5",
                d: "M495 525L475 500 475 550z",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                fill: "none",
                stroke: strokeColor,
                strokeWidth: "2",
                markerEnd: "url(#standard-arrow-head)",
                d: "M549 507l72-54"
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                id: "0525525645435-text",
                fill: "none",
                stroke: "none",
                d: "M549 507l72-54"
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("text", {
                fill: strokeColor,
                alignmentBaseline: "central",
                dy: "-12",
                textAnchor: "middle",
                fontSize: "1.2em",
                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("textPath", {
                    startOffset: "50%",
                    xlinkHref: "#0525525645435-text",
                    children: "a,a;L"
                })
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                fill: "none",
                stroke: strokeColor,
                strokeWidth: "2",
                markerEnd: "url(#standard-arrow-head)",
                d: "M669 453l72 54"
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                id: "0645435765525-text",
                fill: "none",
                stroke: "none",
                d: "M669 453l72 54"
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("text", {
                fill: strokeColor,
                alignmentBaseline: "central",
                dy: "-12",
                textAnchor: "middle",
                fontSize: "1.2em",
                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("textPath", {
                    startOffset: "50%",
                    xlinkHref: "#0645435765525-text",
                    children: "b,b;R"
                })
            })
        ]
    });
};
var $87be68ad6a388013$export$2e2bcd8739ae039 = $87be68ad6a388013$var$TM;





const $bdb8140b328a853c$var$kebabContextItems = (t)=>[
        {
            label: t('rename', {
                ns: 'common'
            }),
            action: 'RENAME_PROJECT'
        },
        {
            label: t('copy', {
                ns: 'common'
            }),
            action: 'COPY_PROJECT'
        },
        'hr',
        {
            label: t('delete', {
                ns: 'common'
            }),
            action: 'DELETE_PROJECT'
        }
    ];
var $bdb8140b328a853c$export$2e2bcd8739ae039 = $bdb8140b328a853c$var$kebabContextItems;


const $e548cd0ed0a6f946$var$KebabMenu = (props)=>{
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)('common');
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $54cc07ecaf352272$export$2e2bcd8739ae039), {
        visible: props.isOpen,
        onClose: props.onClose,
        style: {
            position: 'absolute',
            top: `${props.y}px`,
            left: `${props.x}px`,
            borderStyle: 'solid',
            borderWidth: '1px',
            borderColor: 'var(--toolbar)',
            boxShadow: '0 2px 5px rgba(0 0 0 / .3)'
        },
        items: (0, $bdb8140b328a853c$export$2e2bcd8739ae039)(t)
    });
};
var $e548cd0ed0a6f946$export$2e2bcd8739ae039 = $e548cd0ed0a6f946$var$KebabMenu;




var $h2ArV = parcelRequire("h2ArV");




const $e3f4b68bb9ed712a$var$TourContent = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
    pointer-events: auto;
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;
    max-width: 50%;
    max-height: 80%;
    overflow: auto;
    background-color: var(--surface);
    outline: 1px solid var(--input-border);
    box-shadow: 0 2px 5px rgba(0 0 0 / .5);

    ${({ tourStep: tourStep })=>tourStep === 1 && `
    position: absolute;
    top: 140px;
    right:20px;
    width: 200px;
    
   `}
    ${({ tourStep: tourStep })=>tourStep === 2 && `
    position: absolute;
    right:100px;
    width: 330px;
    
    `}
    ${({ tourStep: tourStep })=>tourStep === 3 && `
    position: absolute;
    left:400px;
    top:10px;
    width:300px;

    `}
    ${({ tourStep: tourStep })=>tourStep === 4 && `
    position: absolute;
    right:100px;
    width:200px;

    `}
    ${({ tourStep: tourStep })=>tourStep === 5 && `
    position: absolute;
    right:100px;
    width:200px;

    `}
    ${({ tourStep: tourStep })=>tourStep === 6 && `
    position: absolute;
    right:px;
    width:200px;

    `}
`;
const $e3f4b68bb9ed712a$var$NewPageTour = ({ onClose: onClose, stepCallback: stepCallback })=>{
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)([
        'common',
        'tutorials'
    ]);
    const [step, setStep] = (0, $h2ArV.useState)(0);
    // Define tour steps
    const steps = [
        {
            target: '',
            content: t('new_tour.step1', {
                ns: 'tutorials'
            })
        },
        {
            target: '',
            content: t('new_tour.step2', {
                ns: 'tutorials'
            })
        },
        {
            target: '',
            content: t('new_tour.step3', {
                ns: 'tutorials'
            })
        },
        {
            target: '',
            content: t('new_tour.step4', {
                ns: 'tutorials'
            })
        }
    ];
    (0, $h2ArV.useEffect)(()=>{
        stepCallback(step);
    }, [
        step,
        stepCallback
    ]);
    const handleNext = ()=>{
        if (step < steps.length - 1) setStep(step + 1);
        else // End the tour if it reaches the last step
        onClose();
    };
    const handleSkip = ()=>{
        onClose() // Close the tour
        ;
    };
    const handlePrevious = ()=>{
        if (step > 0) setStep(step - 1);
    };
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $bba37ec52d58f54e$export$d8b9db17e4be80d), {
        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)($e3f4b68bb9ed712a$var$TourContent, {
            tourStep: step,
            isBannerStep: steps[step].target === '.banner',
            children: [
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("p", {
                    children: steps[step].content
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $bba37ec52d58f54e$export$eddf54ea3db8d0f0), {
                    children: [
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                            secondary: true,
                            onClick: handleSkip,
                            children: t('tour.skip', {
                                ns: 'common'
                            })
                        }),
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                            onClick: handlePrevious,
                            disabled: step === 0,
                            children: t('tour.previous', {
                                ns: 'common'
                            })
                        }),
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                            onClick: handleNext,
                            children: step === steps.length - 1 ? t('tour.finish', {
                                ns: 'common'
                            }) : t('tour.next', {
                                ns: 'common'
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $e3f4b68bb9ed712a$export$2e2bcd8739ae039 = $e3f4b68bb9ed712a$var$NewPageTour;



const $6725d54c9664f81c$var$NewFile = ()=>{
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)([
        'common',
        'newfile'
    ]);
    const navigate = (0, $4b112c041340d9ed$export$9770f232ac06a008)();
    const projects = (0, $a882b4a4b7f1e12c$export$2e2bcd8739ae039)((s)=>s.projects);
    const setProject = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.set);
    const thumbnails = (0, $3954b8dde947d829$export$2e2bcd8739ae039)((s)=>s.thumbnails);
    const removeThumbnail = (0, $3954b8dde947d829$export$2e2bcd8739ae039)((s)=>s.removeThumbnail);
    const preferences = (0, $8af1fe532609b934$export$2e2bcd8739ae039)((state)=>state.preferences);
    const theme = (0, $8af1fe532609b934$export$2e2bcd8739ae039)((state)=>state.getTheme());
    // We find the tallest card using method shown here
    // https://legacy.reactjs.org/docs/hooks-faq.html#how-can-i-measure-a-dom-node
    const [height, setHeight] = (0, $h2ArV.useState)(0);
    const cardsRef = (0, $h2ArV.useCallback)((node)=>{
        if (node === null) return;
        // Get the height of the tallest card, we will set the rest of the cards to it
        setHeight(Math.max(...[
            ...node.children
        ].map((it)=>it.getBoundingClientRect().height)));
    }, []);
    const deleteProject = (0, $a882b4a4b7f1e12c$export$2e2bcd8739ae039)((s)=>s.deleteProject);
    const [deleteConfirmationVisible, setDeleteConfirmationVisible] = (0, $h2ArV.useState)(false);
    const [selectedProjectId, setSelectedProjectId] = (0, $h2ArV.useState)('');
    const [selectedProjectName, setSelectedProjectName] = (0, $h2ArV.useState)('');
    const [kebabOpen, setKebabOpen] = (0, $h2ArV.useState)(false);
    const [coordinates, setCoordinates] = (0, $h2ArV.useState)({
        x: 0,
        y: 0
    });
    const [kebabRefsProjects, setKebabRefsProjects] = (0, $h2ArV.useState)([]);
    const [kebabRefsLabs, setKebabRefsLabs] = (0, $h2ArV.useState)([]);
    /// Tour stuff
    const [showTour, setShowTour] = (0, $h2ArV.useState)(false);
    // Starts the tour
    const showTourHandler = ()=>{
        setShowTour(true);
    };
    const closeTour = ()=>{
        setShowTour(false);
    };
    const handleStep = (step)=>{
        // Define the behavior when the tour reaches the banner step
        if (step) // setIsBannerStep(true);
        scrollToArea(step);
    };
    const scrollToArea = (step)=>{
        if (step === 1) window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        else if (step === 2) window.scrollTo({
            top: 1010,
            behavior: 'smooth'
        });
        else if (step === 3) window.scrollTo({
            top: 10,
            behavior: 'smooth'
        });
    };
    // Modules
    const modules = (0, $38932e4472f33f50$export$2e2bcd8739ae039)((s)=>s.modules);
    const setModule = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.setModule);
    const getModuleProject = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.getProject);
    const deleteModule = (0, $38932e4472f33f50$export$2e2bcd8739ae039)((s)=>s.deleteModule);
    const currentModule = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.module);
    const showModuleWindow = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.showModuleWindow);
    const setShowModuleWindow = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.setShowModuleWindow);
    // Dynamic styling values for new project thumbnails
    // Will likely be extended to 'Your Projects' list
    // If matching system theme, don't append a theme to css vars
    const cssTheme = preferences.theme === 'system' ? '' : `-${preferences.theme}`;
    const getThumbTheme = (0, $h2ArV.useCallback)((id)=>{
        const thumbTheme = theme === 'dark' ? '-dark' : '';
        return `${id}${thumbTheme}`;
    }, [
        theme
    ]);
    const stylingVals = {
        stateFill: `var(--state-bg${cssTheme})`,
        strokeColor: `var(--stroke${cssTheme})`
    };
    // Remove old thumbnails
    (0, $h2ArV.useEffect)(()=>{
        if (projects.length) Object.keys(thumbnails).forEach((id)=>!id.startsWith('tmp') && !projects.some((p)=>p._id === id || `${p._id}-dark` === id) && removeThumbnail(id));
    }, [
        projects,
        thumbnails
    ]);
    // Separate refs to avoid kebab menu showing up in the wrong place
    // For "Your Projects Section"
    (0, $h2ArV.useEffect)(()=>{
        setKebabRefsProjects(Array.from({
            length: projects.length
        }, ()=>/*#__PURE__*/ (0, $h2ArV.createRef)()));
    }, [
        projects
    ]);
    (0, $h2ArV.useEffect)(()=>{
        // Scroll to the element if the URL contains the hash
        if (window.location.hash) {
            const targetId = window.location.hash.substring(1) // Remove the '#' character
            ;
            const targetElement = document.getElementById(targetId);
            if (targetElement) {
                // Set the offset value for how much higher you want to scroll
                const offset = 70 // Adjust this value for the desired space
                ;
                const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
                const offsetPosition = elementPosition - offset // Calculate the new scroll position
                ;
                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth' // Smooth scrolling effect
                });
            }
        }
    }, []);
    // For "Your modules Section"
    (0, $h2ArV.useEffect)(()=>{
        setKebabRefsLabs(Array.from({
            length: modules.length
        }, ()=>/*#__PURE__*/ (0, $h2ArV.createRef)()));
    }, [
        modules
    ]);
    // Function to open the module modal
    const handleNewModuleClick = ()=>{
        // setIsModalOpen(true)
        (0, $ca2884de04f532f3$export$fb20829f6af70575)('modal:createModule', {
            project: false
        });
    };
    const handleNewFile = (type)=>{
        setShowModuleWindow(false);
        setProject((0, $920b9ecb34a1fb18$export$2d5adde7dc289012)(type));
        navigate('/editor');
    };
    const handleLoadProject = (project)=>{
        setShowModuleWindow(false);
        setProject(project);
        navigate('/editor');
    };
    const handleDeleteProject = (pid)=>{
        deleteProject(pid);
    };
    const importProject = ()=>{
        // promptLoadFile(setProject, 'The file format provided is not valid. Please only open Automatarium .json or JFLAP .jff file formats.', '.jff,.json', () => navigate('/editor'))
        (0, $ca2884de04f532f3$export$fb20829f6af70575)('modal:import', null);
    };
    const importModule = ()=>{
        (0, $ca2884de04f532f3$export$fb20829f6af70575)('modal:importModule', null);
    };
    const handleLoadModule = (module)=>{
        setModule(module);
        setProject(getModuleProject(0));
        if (showModuleWindow === false) setShowModuleWindow(true);
        navigate('/editor');
    };
    const handleDeleteModule = (pid)=>{
        deleteModule(pid);
        if (currentModule && currentModule._id === pid) setModule(null);
    };
    const handleNewExample = (type)=>{
        setShowModuleWindow(false);
        setProject((0, $920b9ecb34a1fb18$export$2d5adde7dc289012)(type));
        navigate('/example');
    };
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $ca8af2a7a8a4cd53$export$2e2bcd8739ae039), {
        wide: true,
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $cf4f73e50c7c8f12$export$f7dae34e2e37c751), {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $193714fcc8f30367$export$2e2bcd8739ae039), {
                        linkTo: "/"
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("div", {
                        style: {
                            flex: 1
                        }
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $cf4f73e50c7c8f12$export$69b1032f2ecdf404), {
                        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $cf4f73e50c7c8f12$export$6d6b178f509c8df9), {
                            title: t('header.button.title', {
                                ns: 'newfile'
                            }),
                            type: "button",
                            onClick: ()=>(0, $ca2884de04f532f3$export$fb20829f6af70575)('modal:preferences', null),
                            children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ae567ab0bba67702$export$2e2bcd8739ae039), {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $ca969eaeccef5bfe$export$2e2bcd8739ae039), {
                title: t('new_project.title', {
                    ns: 'newfile'
                }),
                button: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                    onClick: importProject,
                    children: t('new_project.button.import', {
                        ns: 'newfile'
                    })
                }),
                innerRef: cardsRef,
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $61cc15d35249d28a$export$2e2bcd8739ae039), {
                        title: t('fsa', {
                            ns: 'common'
                        }),
                        description: t('new_project.fsa_desc', {
                            ns: 'newfile'
                        }),
                        onClick: ()=>handleNewFile('FSA'),
                        height: height,
                        image: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $d45000dd58c0a4ae$export$2e2bcd8739ae039), {
                            ...stylingVals
                        })
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $61cc15d35249d28a$export$2e2bcd8739ae039), {
                        title: t('pda', {
                            ns: 'common'
                        }),
                        description: t('new_project.pda_desc', {
                            ns: 'newfile'
                        }),
                        onClick: ()=>handleNewFile('PDA'),
                        height: height,
                        image: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $60e60342b049d73c$export$2e2bcd8739ae039), {
                            ...stylingVals
                        })
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $61cc15d35249d28a$export$2e2bcd8739ae039), {
                        title: t('tm', {
                            ns: 'common'
                        }),
                        description: t('new_project.tm_desc', {
                            ns: 'newfile'
                        }),
                        onClick: ()=>handleNewFile('TM'),
                        height: height,
                        image: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $87be68ad6a388013$export$2e2bcd8739ae039), {
                            ...stylingVals
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $ca969eaeccef5bfe$export$2e2bcd8739ae039), {
                title: t('examples.title', {
                    ns: 'newfile'
                }),
                innerRef: cardsRef,
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $61cc15d35249d28a$export$2e2bcd8739ae039), {
                        title: t('fsa', {
                            ns: 'common'
                        }),
                        description: t('examples.fsa_desc', {
                            ns: 'newfile'
                        }),
                        onClick: ()=>handleNewExample('FSA'),
                        height: height,
                        image: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $d45000dd58c0a4ae$export$2e2bcd8739ae039), {
                            ...stylingVals
                        })
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $61cc15d35249d28a$export$2e2bcd8739ae039), {
                        title: t('pda', {
                            ns: 'common'
                        }),
                        description: t('examples.pda_desc', {
                            ns: 'newfile'
                        }),
                        onClick: ()=>handleNewExample('PDA'),
                        height: height,
                        image: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $60e60342b049d73c$export$2e2bcd8739ae039), {
                            ...stylingVals
                        })
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $61cc15d35249d28a$export$2e2bcd8739ae039), {
                        title: t('tm', {
                            ns: 'common'
                        }),
                        description: t('examples.tm_desc', {
                            ns: 'newfile'
                        }),
                        onClick: ()=>handleNewExample('TM'),
                        height: height,
                        image: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $87be68ad6a388013$export$2e2bcd8739ae039), {
                            ...stylingVals
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $ca969eaeccef5bfe$export$2e2bcd8739ae039), {
                title: t('projects.title', {
                    ns: 'newfile'
                }),
                style: {
                    gap: '1.5em .4em'
                },
                children: [
                    projects.sort((a, b)=>b.meta.dateEdited - a.meta.dateEdited).map((p, i)=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $eb202bee839f342f$export$2e2bcd8739ae039), {
                            name: p?.meta?.name ?? '<Untitled>',
                            type: p?.config?.type ?? '???',
                            date: (0, (/*@__PURE__*/$parcel$interopDefault($de07f2c205919029$exports)))(p?.meta?.dateEdited),
                            image: thumbnails[getThumbTheme(p._id)],
                            width: (0, $1812551efebcf5e5$export$29fa6f666d45fe34),
                            onClick: ()=>handleLoadProject(p),
                            $kebabClick: (event)=>{
                                event.stopPropagation();
                                // dispatchCustomEvent('modal:deleteConfirm', null)
                                setKebabOpen(true);
                                const thisRef = kebabRefsProjects[i] === null ? {
                                    offsetLeft: 0,
                                    offsetTop: 0,
                                    offsetHeight: 0
                                } : kebabRefsProjects[i].current;
                                const coords = {
                                    x: thisRef.offsetLeft,
                                    y: thisRef.offsetTop + thisRef.offsetHeight
                                };
                                setCoordinates(coords);
                                setSelectedProjectId(p._id);
                                setSelectedProjectName(p?.meta?.name ?? '<Untitled>');
                            },
                            $kebabRef: kebabRefsProjects === undefined ? null : kebabRefsProjects[i],
                            $istemplate: false
                        }, p._id)),
                    projects.length === 0 && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $cf4f73e50c7c8f12$export$118eab7b533de050), {
                        children: t('projects.nothing', {
                            ns: 'newfile'
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ca969eaeccef5bfe$export$2e2bcd8739ae039 // Using modal to create module
            ), {
                id: "new-module-cardlist",
                title: t('new_module.title', {
                    ns: 'newfile'
                }),
                button: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                    onClick: importModule,
                    children: t('new_module.button.import', {
                        ns: 'newfile'
                    })
                }),
                innerRef: cardsRef,
                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $61cc15d35249d28a$export$2e2bcd8739ae039), {
                    title: t('new_module.create.title', {
                        ns: 'newfile'
                    }),
                    description: t('new_module.create.description', {
                        ns: 'newfile'
                    }),
                    onClick: handleNewModuleClick,
                    height: height,
                    image: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $d45000dd58c0a4ae$export$2e2bcd8739ae039), {
                        ...stylingVals
                    })
                })
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $ca969eaeccef5bfe$export$2e2bcd8739ae039), {
                title: t('modules.title', {
                    ns: 'newfile'
                }),
                style: {
                    gap: '1.5em .4em'
                },
                children: [
                    modules.sort((a, b)=>b.meta.dateEdited - a.meta.dateEdited).map((module, index)=>{
                        return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $6c2ba1e571e78271$export$2e2bcd8739ae039), {
                            name: module.meta.name ?? '<Untitled>',
                            image: thumbnails[getThumbTheme(module._id)],
                            width: (0, $1812551efebcf5e5$export$29fa6f666d45fe34),
                            onClick: ()=>handleLoadModule(module),
                            $kebabClick: (event)=>{
                                event.stopPropagation();
                                setKebabOpen(true);
                                const thisRef = kebabRefsLabs[index]?.current || {
                                    offsetLeft: 0,
                                    offsetTop: 0,
                                    offsetHeight: 0
                                };
                                const coords = {
                                    x: thisRef.offsetLeft,
                                    y: thisRef.offsetTop + thisRef.offsetHeight
                                };
                                setCoordinates(coords);
                                setSelectedProjectId(module._id);
                                setSelectedProjectName(module.meta.name);
                            },
                            $kebabRef: kebabRefsLabs?.[index] ?? null,
                            $istemplate: false
                        }, module._id);
                    }),
                    modules.length === 0 && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $cf4f73e50c7c8f12$export$118eab7b533de050), {
                        children: t('modules.nothing', {
                            ns: 'newfile'
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e548cd0ed0a6f946$export$2e2bcd8739ae039), {
                x: coordinates.x,
                y: coordinates.y,
                isOpen: kebabOpen,
                onClose: ()=>setKebabOpen(false)
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $4e8aac9c208f6626$export$2e2bcd8739ae039), {
                projectName: selectedProjectName,
                isOpen: deleteConfirmationVisible,
                isOpenReducer: setDeleteConfirmationVisible,
                onClose: ()=>setDeleteConfirmationVisible(false),
                onConfirm: ()=>{
                    handleDeleteProject(selectedProjectId);
                    handleDeleteModule(selectedProjectId);
                    setDeleteConfirmationVisible(false);
                }
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $a61484d98edfe0cd$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $c52315ffced03e9e$export$2e2bcd8739ae039), {}),
                onClick: showTourHandler
            }),
            showTour && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e3f4b68bb9ed712a$export$2e2bcd8739ae039), {
                onClose: closeTour,
                stepCallback: handleStep
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $46e591ed4221d5f7$export$2e2bcd8739ae039), {
                navigateFunction: navigate
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $d2b713cf36a207ed$export$2e2bcd8739ae039), {
                navigateFunction: navigate
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $62ca164bc3888523$export$2e2bcd8739ae039), {})
        ]
    });
};
var $6725d54c9664f81c$export$2e2bcd8739ae039 = $6725d54c9664f81c$var$NewFile;




var $h2ArV = parcelRequire("h2ArV");
/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $0a0a5e3fb12d5ba5$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4",
            key: "tonef"
        }
    ],
    [
        "path",
        {
            d: "M9 18c-4.51 2-5-2-7-2",
            key: "9comsn"
        }
    ]
];
const $0a0a5e3fb12d5ba5$export$2e2bcd8739ae039 = (0, $764ec6f19a629312$export$2e2bcd8739ae039)("github", $0a0a5e3fb12d5ba5$export$3efd853dbb351e94);



const $7af80a00fd600ebc$export$285cbcdb788689a9 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6em;
  margin-block-start: 3em;

  @media (max-width: 600px) {
    gap: 3em;
  }
`;
const $7af80a00fd600ebc$export$6e2c8f0811a474ce = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('section')`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 1.2fr;
  grid-template-areas: "img text";
  gap: 2em;
  max-width: 800px;
  min-height: 5em;
  padding-inline: 2em;
  box-sizing: border-box;

  ${(p)=>p.$reverse && `
    grid-template-areas: "text img";
    grid-template-columns: 1.2fr 1fr;
  `}

  .text {
    grid-area: text;
  }

  @media (max-width: 600px) {
    display: flex;
    flex-direction: column;
    gap: 1em;
  }
`;
const $7af80a00fd600ebc$export$3b4e64e77073e307 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('section')`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 2em;
  box-sizing: border-box;
  background: hsl(var(--primary-h) var(--primary-s) var(--primary-l) / 25%);

  h2, h3 {
    margin: 0;
  }
`;





const $c4c80c42c0464fa1$var$Automata = ()=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 285 235",
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("rect", {
                        fill: "var(--grid-bg-light)",
                        x: ".71",
                        width: "284.29",
                        height: "235",
                        rx: "8",
                        ry: "8"
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "3.3",
                                cy: "11.29",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "31.61",
                                cy: "11.29",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "59.92",
                                cy: "11.29",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "88.23",
                                cy: "11.29",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "116.53",
                                cy: "11.29",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "144.84",
                                cy: "11.29",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "173.15",
                                cy: "11.29",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "201.45",
                                cy: "11.29",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "229.76",
                                cy: "11.29",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "258.07",
                                cy: "11.29",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "3.3",
                                cy: "39.62",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "31.61",
                                cy: "39.62",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "59.92",
                                cy: "39.62",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "88.23",
                                cy: "39.62",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "116.53",
                                cy: "39.62",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "144.84",
                                cy: "39.62",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "173.15",
                                cy: "39.62",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "201.45",
                                cy: "39.62",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "229.76",
                                cy: "39.62",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "258.07",
                                cy: "39.62",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "3.3",
                                cy: "68.12",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "31.61",
                                cy: "68.12",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "59.92",
                                cy: "68.12",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "88.23",
                                cy: "68.12",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "116.53",
                                cy: "68.12",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "144.84",
                                cy: "68.12",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "173.15",
                                cy: "68.12",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "201.45",
                                cy: "68.12",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "229.76",
                                cy: "68.12",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "258.07",
                                cy: "68.12",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "3.3",
                                cy: "96.45",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "31.61",
                                cy: "96.45",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "59.92",
                                cy: "96.45",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "88.23",
                                cy: "96.45",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "116.53",
                                cy: "96.45",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "144.84",
                                cy: "96.45",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "173.15",
                                cy: "96.45",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "201.45",
                                cy: "96.45",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "229.76",
                                cy: "96.45",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "258.07",
                                cy: "96.45",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "3.3",
                                cy: "124.95",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "31.61",
                                cy: "124.95",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "59.92",
                                cy: "124.95",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "88.23",
                                cy: "124.95",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "116.53",
                                cy: "124.95",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "144.84",
                                cy: "124.95",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "173.15",
                                cy: "124.95",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "201.45",
                                cy: "124.95",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "229.76",
                                cy: "124.95",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "258.07",
                                cy: "124.95",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "3.3",
                                cy: "153.11",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "31.61",
                                cy: "153.11",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "59.92",
                                cy: "153.11",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "88.23",
                                cy: "153.11",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "116.53",
                                cy: "153.11",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "144.84",
                                cy: "153.11",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "173.15",
                                cy: "153.11",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "201.45",
                                cy: "153.11",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "229.76",
                                cy: "153.11",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "258.07",
                                cy: "153.11",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "3.3",
                                cy: "181.61",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "31.61",
                                cy: "181.61",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "59.92",
                                cy: "181.61",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "88.23",
                                cy: "181.61",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "116.53",
                                cy: "181.61",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "144.84",
                                cy: "181.61",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "173.15",
                                cy: "181.61",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "201.45",
                                cy: "181.61",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "229.76",
                                cy: "181.61",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "258.07",
                                cy: "181.61",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "3.3",
                                cy: "209.94",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "31.61",
                                cy: "209.94",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "59.92",
                                cy: "209.94",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "88.23",
                                cy: "209.94",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "116.53",
                                cy: "209.94",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "144.84",
                                cy: "209.94",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "173.15",
                                cy: "209.94",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "201.45",
                                cy: "209.94",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "229.76",
                                cy: "209.94",
                                r: "2.6"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                                fill: "var(--grid-dot-light)",
                                cx: "258.07",
                                cy: "209.94",
                                r: "2.6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("polygon", {
                        fill: "var(--grid-bg-light)",
                        points: "26.95 86.83 26.95 133.76 45.77 110.38 26.95 86.83"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                        fill: "var(--state-bg-light)",
                        cx: "74.03",
                        cy: "110.47",
                        r: "28.25"
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                                d: "M71.62,119.24v-3.83c-.21,.29-.5,.53-.87,.72-.37,.19-.77,.29-1.18,.29-.93,0-1.73-.37-2.4-1.11s-1.01-1.76-1.01-3.05c0-.79,.14-1.49,.41-2.12s.67-1.1,1.19-1.42c.52-.32,1.09-.48,1.71-.48,.97,0,1.73,.41,2.29,1.22v-1.05h1.19v10.83h-1.33Zm-4.09-6.94c0,1.01,.21,1.76,.63,2.27,.42,.5,.93,.76,1.52,.76s1.05-.24,1.46-.72c.41-.48,.61-1.21,.61-2.19,0-1.04-.22-1.83-.65-2.35-.43-.53-.94-.79-1.52-.79s-1.06,.24-1.46,.73c-.4,.49-.6,1.25-.6,2.29Z"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                                d: "M74.65,110.91c0-1.28,.13-2.31,.39-3.09,.26-.78,.65-1.38,1.17-1.8,.52-.42,1.17-.63,1.96-.63,.58,0,1.09,.12,1.53,.35,.44,.23,.8,.57,1.08,1.01,.29,.44,.51,.98,.67,1.61,.16,.63,.24,1.48,.24,2.55,0,1.27-.13,2.29-.39,3.07-.26,.78-.65,1.38-1.17,1.81s-1.17,.64-1.96,.64c-1.04,0-1.86-.37-2.46-1.12-.71-.9-1.07-2.36-1.07-4.39Zm1.36,0c0,1.77,.21,2.96,.62,3.54,.42,.59,.93,.88,1.54,.88s1.12-.29,1.54-.88c.42-.59,.62-1.77,.62-3.54s-.21-2.96-.62-3.55c-.42-.58-.93-.88-1.55-.88s-1.1,.26-1.46,.77c-.46,.66-.69,1.88-.69,3.65Z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                        fill: "var(--state-bg-light)",
                        cx: "229.73",
                        cy: "53.96",
                        r: "28.25"
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                                d: "M227.32,62.73v-3.83c-.21,.29-.49,.53-.87,.72s-.77,.29-1.18,.29c-.93,0-1.73-.37-2.4-1.11s-1.01-1.76-1.01-3.05c0-.79,.14-1.49,.41-2.12s.67-1.1,1.19-1.42c.52-.32,1.09-.48,1.71-.48,.97,0,1.73,.41,2.29,1.22v-1.05h1.19v10.83h-1.33Zm-4.09-6.94c0,1.01,.21,1.76,.63,2.27,.42,.5,.93,.76,1.52,.76s1.05-.24,1.46-.72,.61-1.21,.61-2.19c0-1.04-.21-1.83-.65-2.35s-.94-.79-1.52-.79-1.06,.24-1.46,.73-.6,1.25-.6,2.29Z"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                                d: "M235.36,59.73h-1.33v-8.46c-.32,.31-.74,.61-1.26,.91-.52,.3-.98,.53-1.4,.69v-1.28c.74-.35,1.39-.77,1.95-1.27,.56-.5,.95-.98,1.18-1.45h.86v10.85Z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("circle", {
                        fill: "var(--state-bg-light)",
                        cx: "229.73",
                        cy: "181.25",
                        r: "28.25"
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                        d: "M229.73,205.77c-13.52,0-24.53-11-24.53-24.53s11-24.53,24.53-24.53,24.53,11,24.53,24.53-11,24.53-24.53,24.53Zm0-47.17c-12.48,0-22.64,10.16-22.64,22.64s10.16,22.64,22.64,22.64,22.64-10.16,22.64-22.64-10.16-22.64-22.64-22.64Z"
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                                d: "M227.32,190.02v-3.83c-.21,.29-.49,.53-.87,.72s-.77,.29-1.18,.29c-.93,0-1.73-.37-2.4-1.11-.67-.74-1.01-1.76-1.01-3.05,0-.79,.14-1.49,.41-2.12,.27-.62,.67-1.1,1.19-1.42,.52-.32,1.09-.48,1.71-.48,.97,0,1.73,.41,2.29,1.22v-1.05h1.19v10.83h-1.33Zm-4.09-6.94c0,1.01,.21,1.76,.63,2.27s.93,.76,1.52,.76,1.05-.24,1.46-.72,.61-1.21,.61-2.19c0-1.04-.21-1.83-.65-2.35-.43-.53-.94-.79-1.52-.79s-1.06,.24-1.46,.73c-.4,.49-.6,1.25-.6,2.29Z"
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                                d: "M237.34,185.74v1.28h-7.14c-.01-.32,.04-.63,.15-.92,.18-.49,.47-.97,.87-1.44s.98-1.02,1.74-1.64c1.17-.96,1.97-1.73,2.38-2.29,.41-.56,.62-1.09,.62-1.6,0-.53-.19-.97-.56-1.33s-.87-.54-1.47-.54c-.64,0-1.15,.19-1.53,.58s-.58,.91-.58,1.59l-1.36-.14c.09-1.02,.44-1.79,1.05-2.33,.61-.53,1.43-.8,2.46-.8s1.86,.29,2.46,.86,.91,1.29,.91,2.14c0,.43-.09,.86-.27,1.28-.18,.42-.47,.86-.88,1.32-.41,.46-1.09,1.1-2.05,1.9-.8,.67-1.31,1.12-1.53,1.36s-.41,.48-.56,.72h5.3Z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                        d: "M230.41,152.07l5.85-12.74h-5.58v-56.19c15.66-.5,28.25-13.39,28.25-29.17s-13.1-29.2-29.2-29.2-29.2,13.1-29.2,29.2c0,3.25,.54,6.37,1.52,9.28l-13.79-1.25,1.85,5.24-89.01,32.36c-4.32-10.73-14.83-18.33-27.09-18.33-15.24,0-27.78,11.74-29.08,26.65l-17.23-21.62c-.25-.31-.67-.44-1.05-.3-.38,.13-.63,.49-.63,.89v47.02c0,.4,.25,.76,.63,.89,.1,.04,.21,.05,.31,.05,.28,0,.55-.13,.74-.35l17.23-21.49c1.29,14.91,13.84,26.66,29.08,26.66,16.1,0,29.2-13.1,29.2-29.2,0-3.18-.52-6.23-1.46-9.1l88.99-32.36,1.86,5.28,9.95-9.65c4.16,10.55,14.3,18.11,26.22,18.49v56.19h-5.58l5.85,12.74c-15.79,.36-28.52,13.31-28.52,29.18s13.1,29.2,29.2,29.2,29.2-13.1,29.2-29.2-12.73-28.82-28.52-29.18ZM27.92,131.22v-41.64l16.64,20.88-16.64,20.75Zm46.1,6.56c-15.06,0-27.31-12.25-27.31-27.31h0c0-15.06,12.25-27.31,27.31-27.31s27.31,12.25,27.31,27.31-12.25,27.31-27.31,27.31ZM202.42,53.96c0-15.06,12.25-27.31,27.31-27.31s27.31,12.25,27.31,27.31-12.25,27.31-27.31,27.31-27.31-12.25-27.31-27.31Zm27.31,154.6c-15.06,0-27.31-12.25-27.31-27.31s12.25-27.31,27.31-27.31,27.31,12.25,27.31,27.31-12.25,27.31-27.31,27.31Z"
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                        d: "M151.86,76.28c-.33,.6-.68,1.07-1.07,1.41-.38,.34-.83,.61-1.35,.81-.85,.33-1.58,.37-2.2,.13-.62-.24-1.05-.68-1.3-1.33-.15-.38-.19-.76-.14-1.14,.05-.38,.18-.72,.39-1.01,.21-.3,.47-.56,.78-.79,.23-.17,.59-.38,1.09-.65,1.01-.53,1.73-.99,2.17-1.35-.06-.18-.11-.3-.12-.35-.21-.53-.47-.86-.81-.99-.45-.17-1-.12-1.67,.13-.62,.24-1.03,.52-1.24,.85-.21,.33-.28,.8-.21,1.4l-1.35,.32c-.09-.59-.07-1.11,.06-1.55,.14-.44,.42-.85,.86-1.23,.44-.38,.99-.69,1.65-.95,.66-.25,1.23-.38,1.7-.39s.85,.08,1.14,.24c.28,.16,.53,.41,.75,.74,.13,.21,.31,.6,.53,1.18l.67,1.75c.47,1.22,.79,1.98,.97,2.28,.18,.3,.41,.57,.69,.8l-1.37,.53c-.24-.22-.45-.5-.63-.85Zm-1.24-2.89c-.4,.38-1.05,.82-1.95,1.32-.51,.28-.86,.52-1.04,.7-.19,.18-.3,.39-.35,.63-.05,.23-.03,.46,.06,.69,.13,.35,.38,.59,.73,.72,.35,.13,.79,.1,1.3-.1,.51-.19,.91-.48,1.22-.85,.31-.37,.48-.79,.52-1.24,.03-.35-.07-.81-.29-1.39l-.18-.48Z"
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("path", {
                        d: "M234.36,115.41v-1.3h11.45v1.41h-4.09c.74,.59,1.12,1.35,1.12,2.27,0,.51-.1,.99-.31,1.45-.21,.46-.49,.83-.87,1.13-.37,.29-.82,.52-1.35,.69-.53,.17-1.09,.25-1.69,.25-1.42,0-2.52-.35-3.3-1.05s-1.16-1.55-1.16-2.53,.41-1.75,1.23-2.3h-1.04Zm4.21-.02c-.99,0-1.71,.14-2.16,.41-.72,.44-1.09,1.04-1.09,1.8,0,.61,.27,1.15,.8,1.59,.53,.45,1.33,.67,2.39,.67s1.88-.21,2.4-.65c.52-.43,.77-.95,.77-1.56s-.27-1.15-.8-1.59-1.31-.67-2.32-.67Z"
                    })
                ]
            })
        ]
    });
var $c4c80c42c0464fa1$export$2e2bcd8739ae039 = $c4c80c42c0464fa1$var$Automata;




var $h2ArV = parcelRequire("h2ArV");




const $787a8b585674aee1$export$e6dfd72ab29f8598 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  flex-direction: column;
  gap: .8rem;
`;
const $787a8b585674aee1$export$9e2d3073c028f69a = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: .4em;
`;
const $787a8b585674aee1$export$9d58cd99b2891644 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('code')`
  background: var(--toolbar);
  display: block;
  border-end-end-radius: .3em;
  border-end-start-radius: .3em;
  box-sizing: border-box;
  padding: .5rem .7rem;

  pre {
    margin: 0;
  }
`;



// Example automaton graph
const $e711ced56635907b$var$graph = {
    projectType: 'FSA',
    states: [
        {
            id: 0,
            isFinal: false,
            x: 0,
            y: 0
        },
        {
            id: 1,
            isFinal: false,
            x: 0,
            y: 0
        },
        {
            id: 2,
            isFinal: true,
            x: 0,
            y: 0
        }
    ],
    transitions: [
        {
            id: 0,
            from: 0,
            to: 1,
            read: 'a'
        },
        {
            id: 1,
            from: 1,
            to: 2,
            read: 'b'
        }
    ],
    initialState: 0
};
const $e711ced56635907b$var$TestingLab = ({ Step: Step })=>{
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)('landing');
    const [input, setInput] = (0, $h2ArV.useState)('ab');
    const [idx, setIdx] = (0, $h2ArV.useState)(0);
    const [result, setResult] = (0, $h2ArV.useState)();
    const simulateGraph = (0, $h2ArV.useCallback)(()=>{
        const { accepted: accepted, trace: trace, remaining: remaining } = (0, $23cb935ba1678867$export$586e59fed64dc8e4)($e711ced56635907b$var$graph, input ?? '');
        const result = {
            accepted: accepted,
            remaining: remaining,
            trace: trace.map((step)=>({
                    to: step.to,
                    read: step.read === '' ? "\u03BB" : step.read
                })),
            transitionCount: Math.max(1, trace.length - (accepted ? 1 : 0))
        };
        setResult(result);
        return result;
    }, [
        input
    ]);
    const trace = (0, $h2ArV.useMemo)(()=>{
        if (!result) return '';
        const { trace: trace, accepted: accepted, remaining: remaining, transitionCount: transitionCount } = result;
        if (trace.length < 2) {
            if (idx > 0) return accepted ? t('component.testing_lab.accepted') : t('component.testing_lab.rejected');
            return null;
        }
        const transitions = trace.slice(0, -1).map((_, i)=>[
                trace[i + 1]?.read,
                trace[i]?.to,
                trace[i + 1]?.to
            ]).map(([read, start, end])=>`${read}: q${start} -> q${end}`).filter((_x, i)=>i < idx);
        const transitionsWithRejected = !accepted && idx === trace.length ? [
            ...transitions,
            remaining[0] ? `${remaining[0]}: q${trace[trace.length - 1].to} ->|` : `\nq${trace[trace.length - 1].to} ->|`
        ] : transitions;
        return `${transitionsWithRejected.join('\n')}${idx === transitionCount ? '\n\n' + (accepted ? t('component.testing_lab.accepted') : t('component.testing_lab.rejected')) : ''}`;
    }, [
        input,
        result,
        idx
    ]);
    (0, $h2ArV.useEffect)(()=>{
        const r = simulateGraph();
        setIdx(r.trace.length - (r.accepted ? 1 : 0));
    }, []);
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $787a8b585674aee1$export$e6dfd72ab29f8598), {
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                onChange: (e)=>{
                    setInput(e.target.value);
                    setIdx(0);
                    setResult(undefined);
                },
                value: input,
                placeholder: t('component.testing_lab.input_placeholder')
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $787a8b585674aee1$export$9e2d3073c028f69a), {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $12a3f0203f358cb4$export$2e2bcd8739ae039), {
                            size: 20
                        }),
                        disabled: idx <= 0,
                        onClick: ()=>setIdx(0)
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                        style: {
                            backgroundColor: Step === 4 ? '#90EE90' : '',
                            color: Step === 4 ? 'green' : 'white'
                        },
                        icon: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $4521b69889606e38$export$2e2bcd8739ae039), {
                            size: 23
                        }),
                        disabled: idx <= 0,
                        onClick: ()=>setIdx(idx - 1)
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                        style: {
                            backgroundColor: Step === 4 ? '#90EE90' : '',
                            color: Step === 4 ? 'green' : 'white'
                        },
                        icon: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $dfbd774c055342cf$export$2e2bcd8739ae039), {
                            size: 23
                        }),
                        disabled: idx >= result?.transitionCount,
                        onClick: ()=>{
                            if (!result) simulateGraph();
                            setIdx(idx + 1);
                        }
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                        style: {
                            backgroundColor: Step === 5 ? '#90EE90' : '',
                            color: Step === 5 ? 'green' : 'white'
                        },
                        icon: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $79ec9bcde4a03dfc$export$2e2bcd8739ae039), {
                            size: 20
                        }),
                        disabled: idx === result?.transitionCount && idx !== 0,
                        onClick: ()=>{
                            // Increment tracer index
                            const r = result ?? simulateGraph();
                            setIdx(r.trace.length - (r.accepted ? 1 : 0));
                        }
                    })
                ]
            }),
            trace && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $46256ad23271a97e$export$2e2bcd8739ae039), {
                        result: result,
                        step: idx,
                        states: $e711ced56635907b$var$graph.states
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $787a8b585674aee1$export$9d58cd99b2891644), {
                        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("pre", {
                            children: trace
                        })
                    })
                ]
            })
        ]
    });
};
var $e711ced56635907b$export$2e2bcd8739ae039 = $e711ced56635907b$var$TestingLab;





var $h2ArV = parcelRequire("h2ArV");




const $f456db2266155407$var$TourContent = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
    pointer-events: auto;
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;
    max-width: 50%;
    max-height: 80%;
    overflow: auto;
    background-color: var(--surface);
    outline: 1px solid var(--input-border);
    box-shadow: 0 2px 5px rgba(0 0 0 / .5);

    ${({ tourStep: tourStep })=>tourStep === 1 && `
    position: absolute;
    left:100px;
    width: 400px;
    
   `}
    ${({ tourStep: tourStep })=>tourStep === 2 && `
    position: absolute;
    left:100px;
    width: 400px;
    
    `}
    ${({ tourStep: tourStep })=>tourStep === 3 && `
    position: absolute;
    right:10px;
    width:200px;

    `}
    ${({ tourStep: tourStep })=>tourStep === 4 && `
    position: absolute;
    right:10px;
    width:200px;

    `}
    ${({ tourStep: tourStep })=>tourStep === 5 && `
    position: absolute;
    right:10px;
    width:200px;

    `}
    ${({ tourStep: tourStep })=>tourStep === 6 && `
    position: absolute;
    right:10px;
    width:200px;

    `}
`;
const $f456db2266155407$var$LandingPageTour = ({ onClose: onClose, stepCallback: stepCallback })=>{
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)([
        'common',
        'tutorials'
    ]);
    const [step, setStep] = (0, $h2ArV.useState)(0);
    // Define tour steps
    const steps = [
        {
            target: '.text',
            content: t('landing_tour.step1', {
                ns: 'tutorials'
            })
        },
        {
            target: '.banner',
            content: t('landing_tour.step2', {
                ns: 'tutorials'
            })
        },
        {
            target: '',
            content: t('landing_tour.step3', {
                ns: 'tutorials'
            })
        },
        {
            target: '',
            content: t('landing_tour.step4', {
                ns: 'tutorials'
            })
        },
        {
            target: '',
            content: t('landing_tour.step5', {
                ns: 'tutorials'
            })
        },
        {
            target: '',
            content: t('landing_tour.step6', {
                ns: 'tutorials'
            })
        },
        {
            target: '',
            content: t('landing_tour.step7', {
                ns: 'tutorials'
            })
        }
    ];
    (0, $h2ArV.useEffect)(()=>{
        stepCallback(step);
    }, [
        step,
        stepCallback
    ]);
    const handleNext = ()=>{
        if (step < steps.length - 1) setStep(step + 1);
        else // End the tour if it reaches the last step
        onClose();
    };
    const handleSkip = ()=>{
        onClose() // Close the tour
        ;
    };
    const handlePrevious = ()=>{
        if (step > 0) setStep(step - 1);
    };
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $bba37ec52d58f54e$export$d8b9db17e4be80d), {
        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)($f456db2266155407$var$TourContent, {
            tourStep: step,
            isBannerStep: steps[step].target === '.banner',
            children: [
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("p", {
                    children: steps[step].content
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $bba37ec52d58f54e$export$eddf54ea3db8d0f0), {
                    children: [
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                            secondary: true,
                            onClick: handleSkip,
                            children: t('tour.skip', {
                                ns: 'common'
                            })
                        }),
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                            onClick: handlePrevious,
                            disabled: step === 0,
                            children: t('tour.previous', {
                                ns: 'common'
                            })
                        }),
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                            onClick: handleNext,
                            children: step === steps.length - 1 ? t('tour.finish', {
                                ns: 'common'
                            }) : t('tour.next', {
                                ns: 'common'
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $f456db2266155407$export$2e2bcd8739ae039 = $f456db2266155407$var$LandingPageTour;



const $918a8914a1976199$var$Landing = ()=>{
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)('landing');
    // creating booleans for tour
    const [showTour, setShowTour] = (0, $h2ArV.useState)(false);
    const [Step, setStep] = (0, $h2ArV.useState)(0);
    const scrollToArea = (step)=>{
        // const element = document.getElementById('start-build');
        // if (element) {
        //   element.scrollIntoView({   behavior: 'smooth', block: 'start' });
        // }
        if (step === 1) window.scrollTo({
            top: 10,
            behavior: 'smooth'
        });
        else if (step === 2) window.scrollTo({
            top: 10,
            behavior: 'smooth'
        });
        else if (step === 3) window.scrollTo({
            top: 600,
            behavior: 'smooth'
        });
        else if (step === 4) window.scrollTo({
            top: 600,
            behavior: 'smooth'
        });
        else if (step === 5) window.scrollTo({
            top: 600,
            behavior: 'smooth'
        });
        else if (step === 6) window.scrollTo({
            top: 1200,
            behavior: 'smooth'
        });
    };
    const handleBannerStep = (step)=>{
        // Define the behavior when the tour reaches the banner step
        if (step) {
            // setIsBannerStep(true);
            scrollToArea(step);
            setStep(step);
        }
    };
    const startTour = ()=>{
        setShowTour(true);
    };
    const closeTour = ()=>{
        setShowTour(false);
        setStep(0);
    };
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $ca8af2a7a8a4cd53$export$2e2bcd8739ae039), {
        fullWidth: true,
        style: {
            paddingBottom: 0
        },
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $193714fcc8f30367$export$2e2bcd8739ae039), {
                center: true
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $7af80a00fd600ebc$export$285cbcdb788689a9), {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $7af80a00fd600ebc$export$6e2c8f0811a474ce), {
                        children: [
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $c4c80c42c0464fa1$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("div", {
                                className: "text",
                                children: [
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("p", {
                                        children: t('section1.description.paragraph1')
                                    }),
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("p", {
                                        children: t('section1.description.paragraph2')
                                    }),
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("p", {
                                        children: t('section1.description.paragraph3')
                                    }),
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                                        id: "start-build",
                                        to: "/new",
                                        style: {
                                            backgroundColor: Step === 1 ? '#90EE90' : '',
                                            color: Step === 1 ? 'green' : 'white'
                                        },
                                        children: t('section1.button.start_building')
                                    }),
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("p", {
                                        children: t('section1.description.paragraph4')
                                    }),
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                                        to: "/tutorials",
                                        style: {
                                            backgroundColor: Step === 2 ? '#90EE90' : '',
                                            color: Step === 2 ? 'green' : 'white'
                                        },
                                        children: t('section1.button.tutorials')
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $7af80a00fd600ebc$export$3b4e64e77073e307), {
                        children: [
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("h3", {
                                children: t('banner1.description.heading')
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("p", {
                                children: t('banner1.description.paragraph1')
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                                icon: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $0a0a5e3fb12d5ba5$export$2e2bcd8739ae039), {}),
                                href: "https://github.com/automatarium/automatarium",
                                target: "_blank",
                                rel: "nofollow noreferrer",
                                children: t('banner1.button.visit_github')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $7af80a00fd600ebc$export$6e2c8f0811a474ce), {
                        $reverse: true,
                        children: [
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e711ced56635907b$export$2e2bcd8739ae039), {
                                Step: Step
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("div", {
                                className: "text",
                                children: [
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("h3", {
                                        children: t('section2.description.heading')
                                    }),
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("p", {
                                        children: t('section2.description.paragraph1')
                                    }),
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("p", {
                                        children: t('section2.description.paragraph2')
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $7af80a00fd600ebc$export$6e2c8f0811a474ce), {
                        children: [
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $782e9208955d1521$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("tbody", {
                                    children: [
                                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("th", {
                                                    children: "\u03B4"
                                                }),
                                                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("th", {
                                                    children: "a"
                                                }),
                                                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("th", {
                                                    children: "b"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("th", {
                                                    children: "q0"
                                                }),
                                                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("td", {
                                                    children: "q1"
                                                }),
                                                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("td", {
                                                    children: "-"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("th", {
                                                    children: "q1"
                                                }),
                                                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("td", {
                                                    children: "-"
                                                }),
                                                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("td", {
                                                    children: "q2"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("th", {
                                                    children: "q2"
                                                }),
                                                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("td", {
                                                    children: "-"
                                                }),
                                                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("td", {
                                                    children: "-"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("div", {
                                className: "text",
                                children: [
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("h3", {
                                        children: t('section3.description.heading')
                                    }),
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("p", {
                                        children: t('section3.description.paragraph1')
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $7af80a00fd600ebc$export$6e2c8f0811a474ce), {
                        $reverse: true,
                        children: [
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $eb202bee839f342f$export$2e2bcd8739ae039), {
                                name: t('section4.project_name'),
                                type: "FSA",
                                date: t('section4.date'),
                                disabled: true,
                                width: (0, $1812551efebcf5e5$export$29fa6f666d45fe34),
                                $istemplate: false
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("div", {
                                className: "text",
                                children: [
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("h3", {
                                        children: t('section4.description.heading')
                                    }),
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("p", {
                                        children: t('section4.description.paragraph1')
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $7af80a00fd600ebc$export$3b4e64e77073e307), {
                        children: [
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("h3", {
                                children: t('banner2.description.heading')
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("p", {
                                children: t('banner2.description.paragraph1')
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                                to: "/new",
                                children: t('banner2.button.start_building')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $a61484d98edfe0cd$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $c52315ffced03e9e$export$2e2bcd8739ae039), {}),
                onClick: startTour
            }),
            showTour && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $f456db2266155407$export$2e2bcd8739ae039), {
                onClose: closeTour,
                stepCallback: handleBannerStep
            })
        ]
    });
};
var $918a8914a1976199$export$2e2bcd8739ae039 = $918a8914a1976199$var$Landing;





const $b66aab51ab24e47d$export$52f0f02147b12c03 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  padding: 1em;
  background: var(--toolbar);
  font-family: var(--font-mono);
  border-radius: .5rem;
`;
const $b66aab51ab24e47d$export$8d13340382210b65 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('p')`
  margin-top: 100vh;
  color: grey;
  opacity: .2;
  border-radius: .5rem;
`;


const $701cfe5b284cadd9$var$NotFound = ()=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $ca8af2a7a8a4cd53$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $193714fcc8f30367$export$2e2bcd8739ae039), {
                center: true,
                linkTo: "/"
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("h2", {
                children: "404 Not Found"
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("p", {
                children: "As recompense, try out this cool puzzle. Can you figure out what this says?"
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $b66aab51ab24e47d$export$52f0f02147b12c03), {
                children: "Svvrz sprl fvby puwba nva ylqljalk olol"
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $b66aab51ab24e47d$export$8d13340382210b65), {
                children: "Think about salad and backstabbing."
            })
        ]
    });
var $701cfe5b284cadd9$export$2e2bcd8739ae039 = $701cfe5b284cadd9$var$NotFound;




var $h2ArV = parcelRequire("h2ArV");








const $a1f0c40ef9872565$var$Share = ()=>{
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)('share');
    const { type: type, data: data } = (0, $4b112c041340d9ed$export$99eaa27ddbbb95ef)();
    const navigate = (0, $4b112c041340d9ed$export$9770f232ac06a008)();
    const setProject = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.set);
    const addProject = (0, $a882b4a4b7f1e12c$export$2e2bcd8739ae039)((s)=>s.upsertProject);
    const addModule = (0, $38932e4472f33f50$export$2e2bcd8739ae039)((s)=>s.upsertModule);
    const setModule = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.setModule);
    const showModuleWindow = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.showModuleWindow);
    const setShowModuleWindow = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.setShowModuleWindow);
    const getModuleProject = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.getProject);
    (0, $h2ArV.useEffect)(()=>{
        switch(type){
            case 'raw':
                (0, $6a48311326306a05$export$13923bea59211b58)(data).then((decodedJson)=>{
                    const dataJson = new File([
                        JSON.stringify(decodedJson)
                    ], 'Shared Project');
                    (0, $b9bf89f7d3b36cd8$export$defde9079da2a3d9)(onData, t('load_fail'), dataJson, handleLoadSuccess, handleLoadFail);
                });
                break;
            case 'module':
                (0, $6a48311326306a05$export$13923bea59211b58)(data).then((decodedJson)=>{
                    const dataJson = new File([
                        JSON.stringify(decodedJson)
                    ], 'Shared Project');
                    (0, $b9bf89f7d3b36cd8$export$df1cc06fea500b46)(onModule, t('load_fail'), dataJson, handleLoadSuccess, handleLoadFail);
                });
                break;
            default:
                (0, $919cfef8d63aa373$export$da2f4e8190fdb5e1)(t('unknown_type') + ` ${type}`);
                handleLoadFail();
                break;
        }
    }, [
        data
    ]);
    const onData = (project)=>{
        setProject(project);
        addProject(project);
    };
    const onModule = (module)=>{
        setModule(module);
        addModule(module);
        setProject(getModuleProject(0));
        if (showModuleWindow === false) setShowModuleWindow(true);
    };
    const handleLoadSuccess = ()=>{
        navigate('/editor');
    };
    const handleLoadFail = ()=>{
        navigate('/new');
    };
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $cec82e41fb73de14$export$42a852a2b6b56249), {
        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $706606fa822de154$export$2e2bcd8739ae039), {})
    });
};
var $a1f0c40ef9872565$export$2e2bcd8739ae039 = $a1f0c40ef9872565$var$Share;




var $h2ArV = parcelRequire("h2ArV");





const $2c4dff5c3663bff3$export$6e2c8f0811a474ce = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('section')`
  padding: .2rem 1rem;
`;




const $31dc36e7a32a250a$var$defaultValues = {
    theme: 'system',
    color: 'match',
    showGrid: true,
    ctrlZoom: true,
    pauseTM: true,
    language: 'en'
};
const $31dc36e7a32a250a$var$PreferencesMenu = ()=>{
    const { t: t, i18n: i18n } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)('preferences');
    const [isOpen, setIsOpen] = (0, $h2ArV.useState)(false);
    const preferences = (0, $8af1fe532609b934$export$2e2bcd8739ae039)((state)=>state.preferences);
    const setPreferences = (0, $8af1fe532609b934$export$2e2bcd8739ae039)((state)=>state.setPreferences);
    const { register: register, handleSubmit: handleSubmit, reset: reset } = (0, $cf42f49a775636e7$export$87c0cf8eb5a167e0)({
        defaultValues: $31dc36e7a32a250a$var$defaultValues
    });
    const onSubmit = (values)=>{
        setPreferences(values);
        setIsOpen(false);
        i18n.changeLanguage(values.language);
        window.location.reload();
    };
    (0, $h2ArV.useEffect)(()=>{
        reset(preferences);
    }, [
        preferences,
        isOpen
    ]);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('modal:preferences', ()=>setIsOpen(true), []);
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $a5fe3119a76402fb$export$2e2bcd8739ae039), {
        title: t('title'),
        description: t('description'),
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        role: "alertdialog" // Prevents closing by clicking away
        ,
        actions: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                    secondary: true,
                    onClick: ()=>setIsOpen(false),
                    children: t('button.without_save')
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                    type: "submit",
                    form: "preferences_form",
                    children: t('button.save')
                })
            ]
        }),
        style: {
            paddingInline: 0
        },
        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("form", {
            id: "preferences_form",
            onSubmit: handleSubmit(onSubmit),
            children: [
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $f6c0a8acd60d8875$export$2e2bcd8739ae039), {
                    children: t('appearance.label')
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $2c4dff5c3663bff3$export$6e2c8f0811a474ce), {
                    children: [
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e44002cbb4794c3a$export$2e2bcd8739ae039), {
                            label: t('appearance.theme.label'),
                            description: t('appearance.theme.description'),
                            children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                                type: "select",
                                small: true,
                                ...register('theme'),
                                children: [
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                        value: "system",
                                        children: t('appearance.theme.system')
                                    }),
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                        value: "light",
                                        children: t('appearance.theme.light')
                                    }),
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                        value: "dark",
                                        children: t('appearance.theme.dark')
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e44002cbb4794c3a$export$2e2bcd8739ae039), {
                            label: t('appearance.colour_accent.label'),
                            description: t('appearance.colour_accent.description'),
                            children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                                type: "select",
                                small: true,
                                ...register('color'),
                                children: [
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                        value: "match",
                                        children: t('appearance.colour_accent.match')
                                    }),
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                        value: "red",
                                        children: t('appearance.colour_accent.red')
                                    }),
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                        value: "orange",
                                        children: t('appearance.colour_accent.orange')
                                    }),
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                        value: "green",
                                        children: t('appearance.colour_accent.green')
                                    }),
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                        value: "teal",
                                        children: t('appearance.colour_accent.teal')
                                    }),
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                        value: "blue",
                                        children: t('appearance.colour_accent.blue')
                                    }),
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                        value: "purple",
                                        children: t('appearance.colour_accent.purple')
                                    }),
                                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                        value: "pink",
                                        children: t('appearance.colour_accent.pink')
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $f6c0a8acd60d8875$export$2e2bcd8739ae039), {
                    children: t('behaviour.label')
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $2c4dff5c3663bff3$export$6e2c8f0811a474ce), {
                    children: [
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e44002cbb4794c3a$export$2e2bcd8739ae039), {
                            label: t('behaviour.enable_grid.label'),
                            description: t('behaviour.enable_grid.description'),
                            children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $0770ae362b3cd6e9$export$2e2bcd8739ae039), {
                                type: "checkbox",
                                ...register('showGrid')
                            })
                        }),
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e44002cbb4794c3a$export$2e2bcd8739ae039), {
                            label: t('behaviour.zoom_control.label'),
                            description: t('behaviour.zoom_control.description'),
                            children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $0770ae362b3cd6e9$export$2e2bcd8739ae039), {
                                type: "checkbox",
                                ...register('ctrlZoom')
                            })
                        }),
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e44002cbb4794c3a$export$2e2bcd8739ae039), {
                            label: t('behaviour.tm_halt.label'),
                            description: t('behaviour.tm_halt.description'),
                            children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $0770ae362b3cd6e9$export$2e2bcd8739ae039), {
                                type: "checkbox",
                                ...register('pauseTM')
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $f6c0a8acd60d8875$export$2e2bcd8739ae039), {
                    children: t('language.label')
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $2c4dff5c3663bff3$export$6e2c8f0811a474ce), {
                    children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e44002cbb4794c3a$export$2e2bcd8739ae039), {
                        label: t('language.language.label'),
                        description: t('language.language.description'),
                        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ff69b033007af947$export$2e2bcd8739ae039), {
                            type: "select",
                            small: true,
                            ...register('language'),
                            children: Object.entries((0, $dae7aefd84fd0ab6$export$df1c34db1371eeed)).map(([localeCode, localeName])=>/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("option", {
                                    value: localeCode,
                                    style: {
                                        zIndex: 1
                                    },
                                    children: localeName
                                }, localeCode))
                        })
                    })
                })
            ]
        })
    });
};
var $31dc36e7a32a250a$export$2e2bcd8739ae039 = $31dc36e7a32a250a$var$PreferencesMenu;




var $h2ArV = parcelRequire("h2ArV");





const $2879923a6de71ce2$export$8a23e74e5cf3ca41 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('button')`
  margin: 3px;
  min-height: 240px;
  height: 360px;
  min-width: 366px;
  width: 20em;

  border-radius: .5rem;
  border: 3px solid transparent;
  overflow: hidden;
  user-select: none;
  font: inherit;
  color: inherit;
  cursor: pointer;
  padding: 0;
  text-align: left;

  padding: 6px;

  &:hover, &:focus {
    border: 3px solid var(--primary);
    outline: none;
  }

  display: flex;
  flex-direction: column;

  background: var(--toolbar);

  overflow: hidden;

  ${(p)=>p.$cardClass === 'title-only' && `
    justify-content: space-around;
  `}
`;
const $2879923a6de71ce2$export$474db65c3c394e1c = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  text-align: center;
  font-weight: bold;
  font-size: large;
  padding-top: 1em;
`;
const $2879923a6de71ce2$export$8fae0f92a810aff = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  overflow: hidden;
  ${(p)=>p.$cardClass === 'img-text' && `
    height: 50%;
  `}
  ${(p)=>p.$cardClass === 'img-only' && `
    padding-bottom: 1em;
  `}
`;
const $2879923a6de71ce2$export$8a8c015277a3d77a = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  border-radius: .6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  min-height: 50%;

  img {
    width: 100%;
    display: block;
    object-fit: contain;
  }

  ${(p)=>p.$cardClass === 'text-only' && `
    background: var(--grid-pattern-light);
  `}
`;



const $9e8cfce1b0c381e1$var$TutorialCard = ({ title: title, blurb: blurb, image: image, ...props })=>{
    // 4 modes: text only, image and text, image and title, title only
    const hasBlurb = blurb && blurb.length > 0;
    const cardClass = image ? hasBlurb ? 'img-text' : 'img-only' : hasBlurb ? 'text-only' : 'title-only';
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $2879923a6de71ce2$export$8a23e74e5cf3ca41), {
        $cardClass: cardClass,
        ...props,
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $2879923a6de71ce2$export$8a8c015277a3d77a), {
                $cardClass: cardClass,
                children: image ? /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("img", {
                    src: image,
                    alt: title
                }) : /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $2fdc1cc89313d290$export$2e2bcd8739ae039), {
                    size: "8rem"
                })
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $2879923a6de71ce2$export$8fae0f92a810aff), {
                $cardClass: cardClass,
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $2879923a6de71ce2$export$474db65c3c394e1c), {
                        children: title
                    }),
                    hasBlurb && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("p", {
                        children: blurb
                    })
                ]
            })
        ]
    });
};
var $9e8cfce1b0c381e1$export$2e2bcd8739ae039 = $9e8cfce1b0c381e1$var$TutorialCard;






const $6d81c977693653d7$export$95e1448be3853ac0 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  flex-direction: row;
  gap: 0.5em;
  flex-wrap: wrap;
  align-items: flex-start;
`;


const $69178770fc98d354$export$ed93dbcf5ca2424b = (link)=>{
    const tokens = link.split('/') ?? null;
    return tokens.find((tk)=>tk === 'youtu.be') === undefined ? null : tokens[tokens.length - 1].split('?')[0];
};


const $ad415a31886780b0$var$TutorialsSection = ({ pageInfo: pageInfo, pagePath: pagePath })=>{
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_, setSearchParams] = (0, $ea9c8114d35b5a84$export$f1a78c17382fe22a)();
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $6d81c977693653d7$export$95e1448be3853ac0), {
        children: pageInfo.items.map((child)=>{
            const thumb = child.type === 'item' && !child.thumbnail && (0, $69178770fc98d354$export$ed93dbcf5ca2424b)(child.link) ? `https://i3.ytimg.com/vi/${(0, $69178770fc98d354$export$ed93dbcf5ca2424b)(child.link)}/mqdefault.jpg` : child.thumbnail;
            return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $9e8cfce1b0c381e1$export$2e2bcd8739ae039), {
                title: child.title,
                blurb: child.blurb,
                image: thumb,
                onClick: ()=>setSearchParams([
                        ...pagePath,
                        child.id
                    ].join('&'))
            }, child.id);
        })
    });
};
var $ad415a31886780b0$export$2e2bcd8739ae039 = $ad415a31886780b0$var$TutorialsSection;




var $h2ArV = parcelRequire("h2ArV");


const $f14e166fc42e85f8$var$EmbeddedVideo = ({ link: link })=>{
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)('tutorials');
    const [aspectRatios, setAspectRatio] = (0, $h2ArV.useState)([
        560,
        315
    ]);
    const updateRatios = ()=>{
        const usableWidth = window.innerWidth > 1200 ? 1136 : window.innerWidth - 64;
        const videoHeight = usableWidth * 0.5625;
        setAspectRatio([
            usableWidth,
            videoHeight
        ]);
    };
    (0, $h2ArV.useLayoutEffect)(()=>{
        updateRatios();
        window.addEventListener('resize', updateRatios);
        return ()=>{
            window.removeEventListener('resize', updateRatios);
        };
    }, []);
    const vidId = (0, $69178770fc98d354$export$ed93dbcf5ca2424b)(link);
    return vidId && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("p", {}),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("iframe", {
                width: aspectRatios[0],
                height: aspectRatios[1],
                src: `https://www.youtube.com/embed/${vidId}`,
                allow: "accelerometer; clipboard-write; encrypted-media",
                allowFullScreen: true,
                title: t('components.tutorial_video')
            })
        ]
    });
};
var $f14e166fc42e85f8$export$2e2bcd8739ae039 = $f14e166fc42e85f8$var$EmbeddedVideo;





const $b248028f5267860e$export$e3ee8ef29b7904ef = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 1em;
`;
const $b248028f5267860e$export$f99233281efd08a0 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('h2')`
  margin-block: 0;
`;
const $b248028f5267860e$export$5501ba450bfeeb44 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  justify-content: center;
`;
const $b248028f5267860e$export$6ee2119e85cdd757 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  max-width: 100%;
  padding: 14px 20px;
  background-color: var(--error);
  color: white;
  text-align: center;
  margin: 20px 0;
  border-radius: 6px;
  font-size: 15px;
  font-weight: 500;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  line-height: 1.4;
`;



var $c2b7aadf2e27bca8$exports = {};
$c2b7aadf2e27bca8$exports = JSON.parse("{\"id\":\"tutorials\",\"title\":\"Tutorials\",\"blurb\":\"\",\"description\":\"Explore how to use Automatarium with the following tutorials.\",\"type\":\"section\",\"items\":[{\"id\":\"creating-project-walkthrough\",\"title\":\"Getting Started\",\"blurb\":\"In this tutorial, learn how to create a project and customise your workspace in Automatarium.\",\"description\":\"<p>GitHub: <a href='https://github.com/automatarium/automatarium'>https://github.com/automatarium/automatarium</a></p>\",\"type\":\"item\",\"link\":\"https://youtu.be/BpCn5adYPEs\"},{\"id\":\"transitions-walkthrough\",\"title\":\"Transitions Tutorial\",\"blurb\":\"In this tutorial, learn how to manage transitions using Automatarium's unique features.\",\"description\":\"<p>GitHub: <a href='https://github.com/automatarium/automatarium'>https://github.com/automatarium/automatarium</a></p>\",\"type\":\"item\",\"link\":\"https://youtu.be/ciRVwFgT1eg\"},{\"id\":\"fsa-walkthrough\",\"title\":\"FSA Tutorial\",\"blurb\":\"In this tutorial, learn how to create a Finite State Automaton in Automatarium.\",\"description\":\"<p>GitHub: <a href='https://github.com/automatarium/automatarium'>https://github.com/automatarium/automatarium</a></p>\",\"type\":\"item\",\"link\":\"https://youtu.be/kiG8RlEaaHw\"},{\"id\":\"pda-walkthrough\",\"title\":\"PDA Tutorial\",\"blurb\":\"In this tutorial, learn how to create a Pushdown Automaton in Automatarium.\",\"description\":\"<p>GitHub: <a href='https://github.com/automatarium/automatarium'>https://github.com/automatarium/automatarium</a></p>\",\"type\":\"item\",\"link\":\"https://youtu.be/ZPbuYOLs2QA\"},{\"id\":\"tm-walkthrough\",\"title\":\"TM Tutorial\",\"blurb\":\"In this tutorial, learn how to create a Turing Machine in Automatarium.\",\"description\":\"<p>GitHub: <a href='https://github.com/automatarium/automatarium'>https://github.com/automatarium/automatarium</a></p>\",\"type\":\"item\",\"link\":\"https://youtu.be/Hg2APtqHlTk\"},{\"id\":\"template-walkthrough\",\"title\":\"Templates Tutorial\",\"blurb\":\"In this tutorial, learn how to use templates in Automatarium.\",\"description\":\"<p>GitHub: <a href='https://github.com/automatarium/automatarium'>https://github.com/automatarium/automatarium</a></p>\",\"type\":\"item\",\"link\":\"https://youtu.be/lCQb5q-DVU0\"},{\"id\":\"module-walkthrough\",\"title\":\"Modules Tutorial\",\"blurb\":\"In this tutorial, learn how to use modules in Automatarium.\",\"description\":\"<p>GitHub: <a href='https://github.com/automatarium/automatarium'>https://github.com/automatarium/automatarium</a></p>\",\"type\":\"item\",\"link\":\"https://youtu.be/mjEWi34XD3c\"}]}");




var $h2ArV = parcelRequire("h2ArV");
function $10f0a031776be25d$export$a32c5b7f472865fb() {
    const [isOnline, setIsOnline] = (0, $h2ArV.useState)(null);
    (0, $h2ArV.useEffect)(()=>{
        const checkOnline = async ()=>{
            try {
                // Fetch to check connectivity
                const response = await fetch('./ping.txt', {
                    method: 'HEAD',
                    cache: 'no-store'
                });
                setIsOnline(response.ok);
            } catch  {
                setIsOnline(false);
            }
        };
        checkOnline();
    }, []);
    return isOnline;
}


const $fa77931eb1e8037c$var$TutorialsPage = ()=>{
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)('tutorials');
    const [searchParams, setSearchParams] = (0, $ea9c8114d35b5a84$export$f1a78c17382fe22a)();
    const [pageInfo, setPageInfo] = (0, $h2ArV.useState)();
    const [pagePath, setPagePath] = (0, $h2ArV.useState)();
    const isOnline = (0, $10f0a031776be25d$export$a32c5b7f472865fb)();
    const navigate = (0, $4b112c041340d9ed$export$9770f232ac06a008)();
    // Determine if section, leaf or not found
    const traceTree = (params, manifestState, path = [])=>{
        const iResult = params.next();
        if (iResult.done) {
            setPagePath(path);
            return manifestState;
        }
        // If the tree is a leaf and there is more then the page doesn't exist
        if (manifestState.type === 'item') return 'not found';
        const assertedSection = manifestState;
        const nextState = assertedSection.items.find((mi)=>mi.id === iResult.value);
        // Not found
        if (nextState === undefined) return 'not found';
        const nextPath = [
            ...path,
            nextState.id
        ];
        return traceTree(params, nextState, nextPath);
    };
    (0, $h2ArV.useEffect)(()=>{
        setPageInfo(traceTree(searchParams.keys(), (0, (/*@__PURE__*/$parcel$interopDefault($c2b7aadf2e27bca8$exports)))));
    }, [
        searchParams
    ]);
    if (pageInfo === undefined || pageInfo === 'not found') return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $701cfe5b284cadd9$export$2e2bcd8739ae039), {});
    else return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $ca8af2a7a8a4cd53$export$2e2bcd8739ae039), {
                wide: true,
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $193714fcc8f30367$export$2e2bcd8739ae039), {
                        linkTo: "/"
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $b248028f5267860e$export$e3ee8ef29b7904ef), {
                        children: [
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $b248028f5267860e$export$f99233281efd08a0), {
                                children: pageInfo.title
                            }),
                            pagePath.length > 0 ? /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                                onClick: ()=>setSearchParams(pagePath.slice(0, -1).join('&')),
                                children: t('header.button.back')
                            }) : /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                                onClick: ()=>navigate('/'),
                                children: t('header.button.home')
                            })
                        ]
                    }),
                    isOnline === null ? /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $d15f6e8ca8604f1a$exports.Fragment), {}) : !isOnline ? /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $b248028f5267860e$export$6ee2119e85cdd757), {
                        children: "You are currently offline. Please connect to the internet to access tutorials."
                    }) : /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
                        children: [
                            pageInfo.type === 'section' && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("p", {
                                dangerouslySetInnerHTML: {
                                    __html: pageInfo.description
                                }
                            }),
                            pageInfo.type === 'section' ? /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ad415a31886780b0$export$2e2bcd8739ae039), {
                                pageInfo: pageInfo,
                                pagePath: pagePath
                            }) : /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $f14e166fc42e85f8$export$2e2bcd8739ae039), {
                                link: pageInfo.link
                            }),
                            pageInfo.type === 'item' && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("p", {
                                dangerouslySetInnerHTML: {
                                    __html: pageInfo.description
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $7af80a00fd600ebc$export$3b4e64e77073e307), {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("p", {
                        children: t('banner.paragraph')
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                        to: "/new",
                        children: t('banner.button')
                    })
                ]
            })
        ]
    });
};
var $fa77931eb1e8037c$export$2e2bcd8739ae039 = $fa77931eb1e8037c$var$TutorialsPage;




var $h2ArV = parcelRequire("h2ArV");



const $6d2ff50b3ab62996$export$7c6e2c02157bb7d2 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('main')`
  flex: 1;
  display: flex;
`;
const $6d2ff50b3ab62996$export$a92c4e92ed722350 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('main')`
  flex: 1;
  display: flex;
  flex-direction: column;
`;
const $6d2ff50b3ab62996$export$5e3f251c730829 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('main')`
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
  justify-content: center;
  text-align: center;
`;









var $h2ArV = parcelRequire("h2ArV");




var $h2ArV = parcelRequire("h2ArV");
const $877a9f4cf38979f8$export$1a1b434dde1370b3 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div', (0, $h2ArV.forwardRef))`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: ${(props)=>props.width}; /* Dynamic width */
  background-color: var(--surface);
  border-right: 1px solid var(--surface);
  overflow-y: auto;
  color: var(--white);
  position: relative; /* To position the resize handle */
  overflow-y: auto;
  overflow: visible; 
  padding: 0 1em 1em;
`;
const $877a9f4cf38979f8$export$33f2411a0ad35be7 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  height: 100%;

  background-color: rgb(165, 165, 165);
  width: 2px;

  position: absolute;
  top: 0;
  right: 0;

  cursor: ew-resize;

  // these prevent text selection while dragging
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  transition: background-color 0.2s ease-out, width 0.2s ease-out;

  &:hover {
    width: 3px;
    background-color: rgb(93, 159, 235);
  }
`;
const $877a9f4cf38979f8$export$de65de8213222d10 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('button')`
  position: absolute;
  top: .6em;
  z-index: 1;
  right: -1em;
  height: 2em;
  width: 2em;
  font: inherit;
  color: inherit;
  background: var(--toolbar);
  border: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  border-radius: .3em;
  cursor: pointer;
`;
const $877a9f4cf38979f8$export$585a3b23e887288b = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
`;
const $877a9f4cf38979f8$export$f99233281efd08a0 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('h2')`
  font-size: 1.2em;
  font-weight: 600;
`;
const $877a9f4cf38979f8$export$7c6e2c02157bb7d2 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  margin-top: 30px;
`;
const $877a9f4cf38979f8$export$eddf54ea3db8d0f0 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  position: absolute;
  top: .6em;
  right: 2em;
  height: 2em;
  display: flex;
  justify-content: center; 
  gap: 0.5em; 


  Button:nth-child(1) {
    background-color: transparent;
    color: var(--primary-dark);
    border: 2.5px solid var(--toolbar); 

    &:hover {
      background-color: var(--toolbar);
      color: white;
    }
  }
`;
const $877a9f4cf38979f8$export$a8d3280cb45e38b8 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  position: absolute;
  top: .6em;
  right: 2em;
  height: 2em;
  display: flex;
  justify-content: center; 
  gap: 0.5em; 
`;
const $877a9f4cf38979f8$export$f5c9f3c2c4054eec = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('textarea')`
  width: 100%;
  padding: 0.6rem;
  font-size: 1rem;
  border: 1px solid var(--border);
  border-radius: 0.3rem;
  margin-bottom: 0.8rem;
  box-sizing: border-box;
  background-color: var(--toolbar);
  color: white; 
  resize: none;

  
  &:focus {
    outline: none;
    border-color: var(--primary); 
  }
`;
const $877a9f4cf38979f8$export$3e5e12dc01f20a43 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('div')`
  display: flex;
  justify-content: center;

  gap: 8px;
  margin-top: auto; /* Ensures pagination sticks to the bottom */
`;
const $877a9f4cf38979f8$export$ebde6d4e7862fe9d = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)('select')`
  background-color: var(--surface);
  color: var(--white);
  border: 1px solid var(--white);
  padding: 0.2em;
  font-size: 14px;
  border-radius: 0.3em;
  cursor: pointer;

  &:hover {
    background-color: var(--white);
    color: var(--toolbar);
  }
`;





const $a101b96589bd7a00$var$ModuleWindow = ({ onPanelWidthChange: onPanelWidthChange })=>{
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)([
        'common',
        'example'
    ]);
    const currentModule = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.module);
    const updateQuestion = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.upsertQuestion);
    const updateProject = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.upsertProject);
    const questions = currentModule.questions;
    const totalQuestions = Object.keys(questions).length;
    const currentProject = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project);
    const currentQuestionIndex = currentModule.projects.findIndex((project)=>project._id === currentProject._id);
    const updateModule = (0, $38932e4472f33f50$export$2e2bcd8739ae039)((s)=>s.upsertModule);
    const setProject = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.set);
    const currentQuestion = questions[currentProject._id];
    const setShowModuleWindow = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.setShowModuleWindow);
    const [panelWidth, setPanelWidth] = (0, $h2ArV.useState)('300px');
    const panelRef = (0, $h2ArV.useRef)(null);
    const [isEditing, setIsEditing] = (0, $h2ArV.useState)(false);
    const [question, setQuestion] = (0, $h2ArV.useState)(currentQuestion || '');
    const handleMouseDown = (e)=>{
        const startX = e.clientX;
        const startWidth = panelRef.current ? panelRef.current.offsetWidth : 300;
        const handleMouseMove = (moveEvent)=>{
            let newWidth = startWidth + (moveEvent.clientX - startX);
            if (newWidth > 650) newWidth = 650;
            if (newWidth < 300) newWidth = 300;
            setPanelWidth(`${newWidth}px`);
            onPanelWidthChange(newWidth);
        };
        const handleMouseUp = ()=>{
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };
    const handleClose = ()=>{
        setShowModuleWindow(false) // Close the module panel
        ;
    };
    (0, $h2ArV.useEffect)(()=>{
        // Ensure that the question is updated when the current question or module changes
        if (currentModule && currentProject._id) setQuestion(questions[currentProject._id] || '');
    }, [
        currentModule,
        currentProject._id
    ]);
    const saveModule = ()=>{
        const project = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039).getState().project;
        updateProject({
            ...project,
            meta: {
                ...project.meta,
                dateEdited: new Date().getTime()
            }
        });
        updateModule(currentModule);
    };
    const handleEditClick = ()=>{
        if (isEditing) {
            const currentQuestionId = Object.keys(questions)[currentQuestionIndex];
            updateQuestion(currentQuestionId, question);
            updateModule(currentModule);
        }
        setIsEditing(!isEditing);
    };
    const handlePageChange = (index)=>{
        saveModule();
        setProject(currentModule.projects[index]);
    };
    // If there are no questions or module data yet, show a loading or fallback message
    if (!questions || totalQuestions === 0 || !currentModule) return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $877a9f4cf38979f8$export$1a1b434dde1370b3), {
        width: panelWidth,
        children: t('component.module.loading', {
            ns: 'example'
        })
    });
    // Cancel editing and reset the input fields to the stored values
    const handleCancelClick = ()=>{
        if (currentModule) setQuestion(currentQuestion || '') // Reset description input
        ;
        setIsEditing(false) // Exit edit mode without saving
        ;
    };
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $877a9f4cf38979f8$export$1a1b434dde1370b3), {
        ref: panelRef,
        width: panelWidth,
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $877a9f4cf38979f8$export$585a3b23e887288b), {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $877a9f4cf38979f8$export$f99233281efd08a0), {
                        children: t('component.module.title', {
                            ns: 'example',
                            qNumber: currentQuestionIndex + 1
                        })
                    }),
                    isEditing ? /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $877a9f4cf38979f8$export$eddf54ea3db8d0f0), {
                        children: [
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                                onClick: handleCancelClick,
                                children: t('cancel', {
                                    ns: 'common'
                                })
                            }),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                                onClick: handleEditClick,
                                children: t('component.module.button.save', {
                                    ns: 'example'
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $877a9f4cf38979f8$export$a8d3280cb45e38b8), {
                        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                            onClick: handleEditClick,
                            children: t('component.module.button.edit', {
                                ns: 'example'
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $877a9f4cf38979f8$export$de65de8213222d10), {
                onClick: handleClose,
                children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $127384410c27818a$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("hr", {}),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $877a9f4cf38979f8$export$7c6e2c02157bb7d2), {
                        children: isEditing ? /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $877a9f4cf38979f8$export$f5c9f3c2c4054eec), {
                            value: question,
                            onChange: (e)=>setQuestion(e.target.value),
                            placeholder: t('component.module.edit_placeholder', {
                                ns: 'example'
                            }),
                            rows: 39
                        }) : /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $22413668b049720a$export$83ef7ab426386201), {
                            children: question
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $877a9f4cf38979f8$export$3e5e12dc01f20a43), {
                children: [
                    currentQuestionIndex !== 0 ? /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            if (currentQuestionIndex > 0) {
                                const newIndex = currentQuestionIndex - 1;
                                handlePageChange(newIndex);
                            }
                        },
                        disabled: currentQuestionIndex === 0,
                        style: {
                            backgroundColor: currentQuestionIndex > 0 ? 'var(--primary)' : 'transparent',
                            margin: '0 2px',
                            flex: 0
                        },
                        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $4521b69889606e38$export$2e2bcd8739ae039), {})
                    }) : null,
                    currentQuestionIndex > 0 ? /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                        onClick: ()=>handlePageChange(currentQuestionIndex - 1),
                        style: {
                            backgroundColor: 'var(--primary)',
                            margin: '0 2px',
                            flex: 0
                        },
                        children: currentQuestionIndex
                    }) : /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("div", {
                        style: {
                            flex: 0
                        }
                    }) // Empty space when no previous question
                    ,
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                        style: {
                            backgroundColor: 'gray',
                            margin: '0 2px',
                            flex: 0
                        },
                        children: currentQuestionIndex + 1
                    }),
                    currentQuestionIndex < totalQuestions - 1 ? /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                        onClick: ()=>handlePageChange(currentQuestionIndex + 1),
                        style: {
                            backgroundColor: 'var(--primary)',
                            margin: '0 2px',
                            flex: 0
                        },
                        children: currentQuestionIndex + 2
                    }) : /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("div", {
                        style: {
                            flex: 0
                        }
                    }) // Empty space when no next question
                    ,
                    currentQuestionIndex !== totalQuestions - 1 ? /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            if (currentQuestionIndex < totalQuestions - 1) {
                                const newIndex = currentQuestionIndex + 1;
                                handlePageChange(newIndex);
                            }
                        },
                        style: {
                            backgroundColor: currentQuestionIndex < totalQuestions - 1 ? 'var(--primary)' : 'transparent',
                            margin: '0 2px',
                            flex: 0
                        },
                        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $dfbd774c055342cf$export$2e2bcd8739ae039), {})
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $877a9f4cf38979f8$export$33f2411a0ad35be7), {
                onMouseDown: handleMouseDown
            })
        ]
    });
};
var $a101b96589bd7a00$export$2e2bcd8739ae039 = $a101b96589bd7a00$var$ModuleWindow;





var $h2ArV = parcelRequire("h2ArV");




const $9877678a0b493a26$var$TemplateDelConfDialog = ({ isOpen: isOpen, setOpen: setOpen, setClose: setClose })=>{
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)('common');
    const [title, setTitle] = (0, $h2ArV.useState)('');
    const [description, setDescription] = (0, $h2ArV.useState)('');
    const [tid, setTid] = (0, $h2ArV.useState)();
    const deleteTemplate = (0, $05b6df1ad576ef23$export$2e2bcd8739ae039)((s)=>s.deleteTemplate);
    const removeThumbnail = (0, $3954b8dde947d829$export$2e2bcd8739ae039)((s)=>s.removeThumbnail);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('modal:editorConfirmation', ({ detail: { title: title, description: description, tid: tid } })=>{
        setTitle(title);
        setDescription(description);
        setTid(tid);
        window.setTimeout(()=>setOpen(), 50);
    }, []);
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $a5fe3119a76402fb$export$2e2bcd8739ae039), {
        title: title,
        description: description,
        isOpen: isOpen,
        onClose: setClose,
        role: "alertdialog",
        actions: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                    secondary: true,
                    onClick: setClose,
                    children: t('cancel')
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                    onClick: ()=>{
                        deleteTemplate(tid);
                        removeThumbnail(`tmp${tid}-light`);
                        removeThumbnail(`tmp${tid}-dark`);
                        setClose();
                    },
                    children: t('confirm')
                })
            ]
        })
    });
};
var $9877678a0b493a26$export$2e2bcd8739ae039 = $9877678a0b493a26$var$TemplateDelConfDialog;





var $h2ArV = parcelRequire("h2ArV");




const $acaaa27c558f53f7$var$ProjectTour = ({ steps: steps, onClose: onClose })=>{
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)([
        'common',
        'tutorials'
    ]);
    const [step, setStep] = (0, $h2ArV.useState)(0);
    // Define tour steps
    // Next button
    const handleNext = ()=>{
        // Set step state, if all steps are not complete
        if (step < steps.length - 1) setStep(step + 1);
        else onClose();
    };
    // Skip tour button
    const handleSkip = ()=>{
        onClose() // Close tour
        ;
    };
    // Previous button
    const handlePrevious = ()=>{
        // If previous step exists, set step state
        if (step > 0) setStep(step - 1);
    };
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $bba37ec52d58f54e$export$d8b9db17e4be80d), {
        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $bba37ec52d58f54e$export$3c8c44a030fbe001), {
            tourStep: step,
            isBannerStep: steps[step].target === ".banner",
            children: [
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("p", {
                    children: steps[step].content
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $b248028f5267860e$export$5501ba450bfeeb44), {
                    children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("img", {
                        src: steps[step].gifUrl
                    })
                }),
                /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $bba37ec52d58f54e$export$eddf54ea3db8d0f0), {
                    children: [
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                            secondary: true,
                            onClick: handleSkip,
                            children: t("tour.skip", {
                                ns: "common"
                            })
                        }),
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                            onClick: handlePrevious,
                            disabled: step === 0,
                            children: t("tour.previous", {
                                ns: "common"
                            })
                        }),
                        /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d3de4eeb487482a$export$2e2bcd8739ae039), {
                            onClick: handleNext,
                            children: step === steps.length - 1 ? t("tour.finish", {
                                ns: "common"
                            }) : t("tour.next", {
                                ns: "common"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $acaaa27c558f53f7$export$2e2bcd8739ae039 = $acaaa27c558f53f7$var$ProjectTour;



var $2f9db0f695f13064$exports = {};
$2f9db0f695f13064$exports = JSON.parse("{\"fsaTourGifs\":[\"https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExNnBqMHcybWt0b240eHgyeGoxNnVnN3ZkamJ4NGR1aGxoZ2FmOXhzeCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/CEhv9ob2WWq2aUHWcK/giphy.gif\",\"https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExamF0bWd6OW1mYXRhemF5am5pamE5cWx1cmRqZzkycnBybWM4azIxbCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/gz6AZuHqdW620z78Cf/giphy.gif\",\"https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExMmRlNDYzcmx0YjM0YW9hdGUzMnF4eWZ1dGI0d3RncWpscmU4Z2l5NiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/8gxgNz6BWWzNb7yMO9/giphy.gif\",\"https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExaXl2OTN6N2FobDZ6anYwYTMwZHNpdmQ3a2I0OHVkazdrem9vNzNpcyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/lqAP4be6RHzicbwP4b/giphy.gif\",\"https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExMXI2cDF0MWNjcGJnZ3pveWEwZnRmY3RuYXJvZzh5dWN4MGVzcDdxMCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/kNNU6jziwCCs7jRl4V/giphy.gif\",\"https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExeGVhc3RqM2owZ2s3MHRqNnNncW11dTNiemVwY3hzYjJpdGdzN3NkZiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/F71XE0yKbDGzp7uSQj/giphy.gif\",\"https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExZDk1cTV4ZnBsa2Z0ZWs3cmc5bno5cGdna2RsZm9nYTk2ZTdndXF3MCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/vK75iMbo4P3pewcg0j/giphy.gif\"],\"pdaTourGifs\":[\"https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExYndtZGVwdzJubnFuejNxeG9ybG4zYm9leGZleThrMDJveTA5eDc2MCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/uD4qr1AGOaKaJQrFXG/giphy.gif\",\"https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExenBzYjJ1a3VyYml5bHViMXdtenh1bXVuMHRicHB5cjYxaWhscWd0ZSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/NMgNDytfx6PQDc3EmP/giphy.gif\",\"https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExczNmbTllbjhpcmpqbTJ4Z2FkcTdod3p0MWs3cW9nMGxnNmRscWJ6ZiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/whdDzqi05KxOYIf5wu/giphy.gif\",\"https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExcXNoOGswc2k3NTYxeWw2ODBkZHR0dXNocDVtejZybWFmbzFqNmVqNCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/5LzPcMx9Tfk1lTC6TN/giphy.gif\",\"https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExY3AydjU0Z2s1cTJhMmNsZ25jMzgyMHdrZzBrZDU0M3k4OWVyZjVzdSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/IH0xajIIS5dZ9J68WW/giphy.gif\",\"https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExM2l5MXNxcWZxMjYyNTdmNmtzMDJieHhnbXFpcDR1ODkyNnJqN2RobSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/FDc1LxcmwaNpalpgKH/giphy.gif\"],\"tmTourGifs\":[\"https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExYXF0eHB6anF1d2k5ZHpzcHkzNDFzOHhmbzdiMTZ5aHJtc3N3bmhhZCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/BfG7jCKbBaFFqXtguF/giphy.gif\",\"https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExZmNscHFpMGR2dWhvZjFvYWsxcXJiMDk3c2ZvYnkzYTdvNXFrNjNudyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/N4kbu1oD7yBjpqJ3Ds/giphy.gif\",\"https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExMzZkdHN4Y3NsejdkMHY0YTlwOTRrZHIxb3NodThsa2U5eDA2N3pubCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/09m2R4ygCMmKaqgsMu/giphy.gif\",\"https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExZzY1cDl2ZnVqeHVjMThnYW05cnlzZXlkbXB1cWF3Z3d0OTFlZmx1dSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/qa6Lla3yz0N9BpuVts/giphy.gif\",\"https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExZ3hkc250bWF1bXdnNmoybm04dXU1N2tuNDVhNHB6OXFsaGVnM2U5eSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/kyFHjOElupMGiMJFGX/giphy.gif\",\"https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExanhseG8waDZtcGN4ODdldnU0YzY0a3JkM2JyeWxhNjZmYjNubWlwNiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/Ouqp9MIKu1Mn8xuDks/giphy.gif\",\"https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExOXdmMjhsOWVidGRsbHFyMWI1eGg5Y3kyeGpqNnJjOXN0OW0waHdjcyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/f4uDAsTo18z15yo5Jt/giphy.gif\",\"https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExajN6ZnR3OThyZmQ1ZjM4a2E4N2FvMTkzdTZ0a2Y5YzVkaG5sbnByZyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/bThh2HbFg7bVY3Nfnp/giphy.gif\",\"https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExbzlxdm81aGJqZjJqdjd4MzNhd3RnZDFqNjczNG9kZThtOHB2ZHhidCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/MLHMaIrBGcOABkZuLN/giphy.gif\"]}");


const $2870e5d30a15cd02$export$baf3a230e7969138 = (t)=>[
        {
            target: "",
            content: t("fsa_tour.step1", {
                ns: "tutorials"
            }),
            gifUrl: (0, $2f9db0f695f13064$exports.fsaTourGifs)[0]
        },
        {
            target: "",
            content: t("fsa_tour.step2", {
                ns: "tutorials"
            }),
            gifUrl: (0, $2f9db0f695f13064$exports.fsaTourGifs)[1]
        },
        {
            target: "",
            content: t("fsa_tour.step3", {
                ns: "tutorials"
            }),
            gifUrl: (0, $2f9db0f695f13064$exports.fsaTourGifs)[2]
        },
        {
            target: "",
            content: t("fsa_tour.step4", {
                ns: "tutorials"
            }),
            gifUrl: (0, $2f9db0f695f13064$exports.fsaTourGifs)[3]
        },
        {
            target: "",
            content: t("fsa_tour.step5", {
                ns: "tutorials"
            }),
            gifUrl: (0, $2f9db0f695f13064$exports.fsaTourGifs)[4]
        },
        {
            target: "",
            content: t("fsa_tour.step6", {
                ns: "tutorials"
            }),
            gifUrl: (0, $2f9db0f695f13064$exports.fsaTourGifs)[5]
        },
        {
            target: "",
            content: t("fsa_tour.step7", {
                ns: "tutorials"
            }),
            gifUrl: (0, $2f9db0f695f13064$exports.fsaTourGifs)[6]
        }
    ];



const $f904e9bc4c39e754$export$8d35ff1b2487fd2 = (t)=>[
        {
            target: "",
            content: t("pda_tour.step1", {
                ns: "tutorials"
            }),
            gifUrl: (0, $2f9db0f695f13064$exports.pdaTourGifs)[0]
        },
        {
            target: "",
            content: t("pda_tour.step2", {
                ns: "tutorials"
            }),
            gifUrl: (0, $2f9db0f695f13064$exports.pdaTourGifs)[1]
        },
        {
            target: "",
            content: t("pda_tour.step3", {
                ns: "tutorials"
            }),
            gifUrl: (0, $2f9db0f695f13064$exports.pdaTourGifs)[2]
        },
        {
            target: "",
            content: t("pda_tour.step4", {
                ns: "tutorials"
            }),
            gifUrl: (0, $2f9db0f695f13064$exports.pdaTourGifs)[3]
        },
        {
            target: "",
            content: t("pda_tour.step5", {
                ns: "tutorials"
            }),
            gifUrl: (0, $2f9db0f695f13064$exports.pdaTourGifs)[4]
        },
        {
            target: "",
            content: t("pda_tour.step6", {
                ns: "tutorials"
            }),
            gifUrl: (0, $2f9db0f695f13064$exports.pdaTourGifs)[5]
        }
    ];



const $7ef9f3f95c85367b$export$c7056358d86dd890 = (t)=>[
        {
            target: "",
            content: t("tm_tour.step1", {
                ns: "tutorials"
            }),
            gifUrl: (0, $2f9db0f695f13064$exports.tmTourGifs)[0]
        },
        {
            target: "",
            content: t("tm_tour.step2", {
                ns: "tutorials"
            }),
            gifUrl: (0, $2f9db0f695f13064$exports.tmTourGifs)[1]
        },
        {
            target: "",
            content: t("tm_tour.step3", {
                ns: "tutorials"
            }),
            gifUrl: (0, $2f9db0f695f13064$exports.tmTourGifs)[2]
        },
        {
            target: "",
            content: t("tm_tour.step4", {
                ns: "tutorials"
            }),
            gifUrl: (0, $2f9db0f695f13064$exports.tmTourGifs)[3]
        },
        {
            target: "",
            content: t("tm_tour.step5", {
                ns: "tutorials"
            }),
            gifUrl: (0, $2f9db0f695f13064$exports.tmTourGifs)[4]
        },
        {
            target: "",
            content: t("tm_tour.step6", {
                ns: "tutorials"
            }),
            gifUrl: (0, $2f9db0f695f13064$exports.tmTourGifs)[5]
        },
        {
            target: "",
            content: t("tm_tour.step7", {
                ns: "tutorials"
            }),
            gifUrl: (0, $2f9db0f695f13064$exports.tmTourGifs)[6]
        },
        {
            target: "",
            content: t("tm_tour.step8", {
                ns: "tutorials"
            }),
            gifUrl: (0, $2f9db0f695f13064$exports.tmTourGifs)[7]
        },
        {
            target: "",
            content: t("tm_tour.step9", {
                ns: "tutorials"
            }),
            gifUrl: (0, $2f9db0f695f13064$exports.tmTourGifs)[8]
        }
    ];


const $539642c630a1c3b9$var$Example = ()=>{
    const { t: t } = (0, $e52c02d9f8a7380f$export$9fc83ad70ead8663)([
        "common",
        "tutorials"
    ]);
    const navigate = (0, $4b112c041340d9ed$export$9770f232ac06a008)();
    const { tool: tool, setTool: setTool } = (0, $9ea7efd115f178cf$export$2e2bcd8739ae039)();
    const [priorTool, setPriorTool] = (0, $h2ArV.useState)();
    const [confirmDialogOpen, setConfirmDialogOpen] = (0, $h2ArV.useState)(false);
    const resetExportSettings = (0, $ef9e10319983727e$export$2e2bcd8739ae039)((s)=>s.reset);
    const setViewPositionAndScale = (0, $2c8de4ab9c0d9b91$export$2e2bcd8739ae039)((s)=>s.setViewPositionAndScale);
    const project = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((s)=>s.project);
    const [showTour, setShowTour] = (0, $h2ArV.useState)(true);
    const [isSidepanelOpen, setIsSidepanelOpen] = (0, $h2ArV.useState)(false);
    const closeTour = ()=>{
        setShowTour(false);
    };
    const showTourHandler = ()=>{
        setShowTour(true);
    };
    const currentModule = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.module);
    const getProjectinModule = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.getProjectById);
    const setModule = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.setModule);
    const showModuleWindow = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.showModuleWindow);
    const setShowModuleWindow = (0, $be91e446fcb94886$export$2e2bcd8739ae039)((s)=>s.setShowModuleWindow);
    const updateModule = (0, $38932e4472f33f50$export$2e2bcd8739ae039)((s)=>s.upsertModule);
    const [panelWidth, setPanelWidth] = (0, $h2ArV.useState)(300) // Default panel width
    ;
    const handlePanelWidthChange = (newWidth)=>{
        setPanelWidth(newWidth);
    };
    (0, $h2ArV.useEffect)(()=>{
        // Reset panel width when currentModule changes
        if (showModuleWindow) setPanelWidth(300) // Reset to default width
        ;
    }, [
        showModuleWindow
    ]);
    if (!project) {
        navigate('/new');
        return null;
    }
    (0, $h2ArV.useEffect)(()=>{
        if (currentModule == null) setShowModuleWindow(false);
        if (currentModule && getProjectinModule(project._id) === undefined) {
            setModule(null);
            setShowModuleWindow(false);
        } else if (currentModule) updateModule(currentModule);
    }, [
        currentModule,
        project,
        getProjectinModule
    ]);
    const projectType = project.config.type;
    const [buttonRight, setButtonRight] = (0, $h2ArV.useState)('60px');
    // Adjust button position when side panel is toggled
    (0, $h2ArV.useEffect)(()=>{
        setButtonRight(isSidepanelOpen ? '410px' : '60px');
    }, [
        isSidepanelOpen
    ]);
    // Toggle side panel and update button position
    const handleSidepanelToggle = (isOpen)=>{
        setIsSidepanelOpen(isOpen);
    };
    const isSaving = (0, $f7162e3030303bfe$export$2e2bcd8739ae039)();
    (0, $b9bf89f7d3b36cd8$export$2e2bcd8739ae039)(true);
    (0, $h2ArV.useEffect)(()=>{
        resetExportSettings();
        setViewPositionAndScale({
            x: 0,
            y: 0
        }, 1);
    }, []);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('keydown', (e)=>{
        if ((0, $ca3c15cc6dee748a$export$612e6723d69a3e6c)(e)) return;
        if (!priorTool && e.code === 'Space') {
            setPriorTool(tool);
            setTool('hand');
        }
        if (e.code === 'Space') {
            e.preventDefault();
            e.stopPropagation();
        }
    }, [
        tool,
        priorTool
    ]);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('keyup', (e)=>{
        if ((0, $ca3c15cc6dee748a$export$612e6723d69a3e6c)(e)) return;
        if (priorTool && e.code === 'Space') {
            setTool(priorTool);
            setPriorTool(undefined);
        }
        if (e.code === 'Space') {
            e.preventDefault();
            e.stopPropagation();
        }
    }, [
        tool,
        priorTool
    ]);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('svg:mousedown', (e)=>{
        if (!priorTool && e.detail.originalEvent.button === 1) {
            setPriorTool(tool);
            setTool('hand');
        }
    }, [
        tool,
        priorTool
    ]);
    (0, $c6c13878c6b77455$export$2e2bcd8739ae039)('svg:mouseup', (e)=>{
        if (priorTool && e.detail.originalEvent.button === 1) {
            setTool(priorTool);
            setPriorTool(undefined);
        }
    }, [
        tool,
        priorTool
    ]);
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $a7169d08c7fb682a$export$2e2bcd8739ae039), {
                isSaving: isSaving
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $6d2ff50b3ab62996$export$7c6e2c02157bb7d2), {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5d111e8a0f2066e2$export$2e2bcd8739ae039), {}),
                    showModuleWindow && currentModule && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $a101b96589bd7a00$export$2e2bcd8739ae039), {
                        onPanelWidthChange: handlePanelWidthChange
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $6d2ff50b3ab62996$export$a92c4e92ed722350), {
                        children: [
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $93f1d08e0fec2b6a$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5aadffeeffe570a7$export$2e2bcd8739ae039), {})
                        ]
                    }),
                    projectType === 'PDA' && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $91b4ca9d41ef827a$export$2e2bcd8739ae039), {
                        panelWidth: panelWidth
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $affe7841397c2517$export$2e2bcd8739ae039), {
                        onToggle: handleSidepanelToggle
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $aecc316235466713$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $931143b92b0f570e$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ca9b0c437b693aa9$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $fd8f52c67efbda5d$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $e102458d258008dd$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $9877678a0b493a26$export$2e2bcd8739ae039), {
                isOpen: confirmDialogOpen,
                setOpen: ()=>setConfirmDialogOpen(true),
                setClose: ()=>setConfirmDialogOpen(false)
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $a61484d98edfe0cd$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $c52315ffced03e9e$export$2e2bcd8739ae039), {}),
                onClick: showTourHandler,
                style: {
                    position: 'fixed',
                    right: buttonRight,
                    bottom: '20px'
                }
            }),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $46e591ed4221d5f7$export$2e2bcd8739ae039), {
                navigateFunction: navigate
            }),
            showTour && (projectType === 'FSA' ? /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $acaaa27c558f53f7$export$2e2bcd8739ae039), {
                steps: (0, $2870e5d30a15cd02$export$baf3a230e7969138)(t),
                onClose: closeTour
            }) : projectType === 'PDA' ? /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $acaaa27c558f53f7$export$2e2bcd8739ae039), {
                steps: (0, $f904e9bc4c39e754$export$8d35ff1b2487fd2)(t),
                onClose: closeTour
            }) : /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $acaaa27c558f53f7$export$2e2bcd8739ae039), {
                steps: (0, $7ef9f3f95c85367b$export$c7056358d86dd890)(t),
                onClose: closeTour
            })),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $62ca164bc3888523$export$2e2bcd8739ae039), {})
        ]
    });
};
var $539642c630a1c3b9$export$2e2bcd8739ae039 = $539642c630a1c3b9$var$Example;










var $3ed49ae08720cac5$exports = {};
$3ed49ae08720cac5$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><defs><style>.primary{fill:var(--primary,#eb9c14)}.secondary{fill:var(--state-bg,#f5ce8a)}</style></defs><circle cx=\"236.37\" cy=\"236.37\" r=\"232.69\" class=\"secondary\"/><path d=\"m414.89 426.07 10.99 77.46c1.15 8.07 11.02 11.37 16.78 5.6l66.47-66.47c5.76-5.76 2.47-15.64-5.6-16.78l-77.46-10.99c-6.52-.92-12.1 4.66-11.18 11.18\" class=\"secondary\"/><path d=\"M281.62 119.47c-33.62 4.99-72.72 15.46-72.72 39.99 0 44.1 88.85 32.08 90.15 57.75.78 15.37-17.89 24.63-14.71 54.05 4.16 38.48 108.91 39.85 173.54 36.48 7.24-22.5 11.17-46.48 11.17-71.38 0-44.58-12.54-86.22-34.28-121.61-52.87-4.1-106.57-2.2-153.16 4.71ZM172.04 284.78c-15.5-10.16-97.69-26.79-167.14-24.41 3.78 36.89 16.18 71.22 35.15 100.96 45.47 2.49 120.79-1.05 141.59-31.89 7.82-11.59 10.62-31.4-9.6-44.66M236.37 469.06c34.33 0 66.92-7.44 96.26-20.79-47.34-33.91-151.67-41.32-207.83-7.66 33.13 18.13 71.14 28.45 111.57 28.45M315.91 17.63c-24.82-9.03-51.6-13.96-79.54-13.96-24.55 0-48.21 3.81-70.43 10.86 45.64 44.39 120.02 31.66 149.97 3.09Z\" class=\"primary\"/></svg>";




const $eb5b726ce98896a1$export$4bd79b86b9fce870 = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)("div")`
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  background: var(--toolbar);
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  cursor: pointer;
  z-index: 9999;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transition: opacity 0.3s ease;
`;


function $5c6982248878ffae$export$e2f7ceae8279c45a() {
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $eb5b726ce98896a1$export$4bd79b86b9fce870), {
        onClick: ()=>window.location.reload(),
        children: "A new version is available \u2013 click to refresh"
    });
}




var $h2ArV = parcelRequire("h2ArV");

const $65b4015a2f62b9da$export$d10711b592e44b9c = (0, $b1e4a7d525070c66$export$3817b7a54a07cec7)("div")`
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%) translateY(10px);
  background: var(--toolbar);
  color: var(--white);
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 14px;
  opacity: 0;
  z-index: 9999;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transition: opacity 0.4s ease, transform 0.4s ease;
`;


function $f13ae6e76ab79838$export$db8c5995a968d288() {
    const [visible, setVisible] = (0, $h2ArV.useState)(false);
    (0, $h2ArV.useEffect)(()=>{
        // trigger fade-in
        const showTimer = requestAnimationFrame(()=>setVisible(true));
        // fade out after 3 seconds
        const hideTimer = setTimeout(()=>setVisible(false), 3000);
        return ()=>{
            cancelAnimationFrame(showTimer);
            clearTimeout(hideTimer);
        };
    }, []);
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $65b4015a2f62b9da$export$d10711b592e44b9c), {
        style: {
            opacity: visible ? 1 : 0,
            transform: visible ? "translateX(-50%) translateY(0)" : "translateX(-50%) translateY(10px)"
        },
        children: "Ready to use offline"
    });
}


// Set up goober to use React
(0, $b1e4a7d525070c66$export$de27182ff8187d6c)((0, $h2ArV.createElement), undefined, undefined, // Remove transient props from the DOM
(props)=>Object.keys(props).forEach((p)=>p[0] === '$' && delete props[p]));
const $70fc9a727fa662ae$var$App = ()=>{
    const location = (0, $4b112c041340d9ed$export$45d76561a5302f2b)();
    const hideFooter = location.pathname.match('/editor');
    // Set color theme
    const colorPref = (0, $8af1fe532609b934$export$2e2bcd8739ae039)((state)=>state.preferences.color);
    const projectColor = (0, $920b9ecb34a1fb18$export$2e2bcd8739ae039)((state)=>state.project?.config.color);
    (0, $h2ArV.useEffect)(()=>{
        const computedColor = projectColor !== '' && projectColor || 'orange';
        const color = colorPref === 'match' ? (0, $d59e810d2f517544$export$2e2bcd8739ae039)[computedColor] : (0, $d59e810d2f517544$export$2e2bcd8739ae039)[colorPref];
        document.documentElement.style.setProperty('--primary-h', color.h.toString());
        document.documentElement.style.setProperty('--primary-s', color.s + '%');
        document.documentElement.style.setProperty('--primary-l', color.l + '%');
        // Set favicon
        const link = document.querySelector('head link[rel=icon]');
        link.setAttribute('href', 'data:image/svg+xml,' + encodeURIComponent((0, (/*@__PURE__*/$parcel$interopDefault($3ed49ae08720cac5$exports))).replace(/var\(--primary,.*?\)/, `hsl(${color.h} ${color.s}% ${color.l}%)`).replace(/var\(--state-bg,.*?\)/, `hsl(${color.h} ${color.s}% 75%)`)));
    }, [
        colorPref,
        projectColor
    ]);
    // Set light/dark mode
    const themePref = (0, $8af1fe532609b934$export$2e2bcd8739ae039)((state)=>state.preferences.theme);
    (0, $h2ArV.useEffect)(()=>{
        document.body.classList.toggle('light', themePref === 'light');
        document.body.classList.toggle('dark', themePref === 'dark');
    }, [
        themePref
    ]);
    // Check if the pauseTM preference is missing
    const preferences = (0, $8af1fe532609b934$export$2e2bcd8739ae039)((state)=>state.preferences);
    const setPreferences = (0, $8af1fe532609b934$export$2e2bcd8739ae039)((state)=>state.setPreferences);
    if (typeof preferences.pauseTM === 'undefined') // Add the pauseTM preference with a default value
    setPreferences({
        ...preferences,
        pauseTM: true
    });
    // Check for update toast event
    const [showUpdateToast, setShowUpdateToast] = (0, $h2ArV.useState)(false);
    (0, $h2ArV.useEffect)(()=>{
        const handleSWUpdate = ()=>{
            setShowUpdateToast(true);
        };
        window.addEventListener("sw-update-available", handleSWUpdate);
        return ()=>window.removeEventListener("sw-update-available", handleSWUpdate);
    }, []);
    // Check for offline ready toast event
    const [showOfflineReadyToast, setShowOfflineReadyToast] = (0, $h2ArV.useState)(false);
    (0, $h2ArV.useEffect)(()=>{
        const handleOfflineReady = ()=>{
            setShowOfflineReadyToast(true);
        };
        window.addEventListener("sw-offline-ready", handleOfflineReady);
        return ()=>window.removeEventListener("sw-offline-ready", handleOfflineReady);
    }, []);
    (0, $a5ca60f5343d1bf8$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $d15f6e8ca8604f1a$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsxs)((0, $4b112c041340d9ed$export$3565eb3d00ca5a74), {
                children: [
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $4b112c041340d9ed$export$e7b0ac011bb776c6), {
                        path: "/",
                        element: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)($918a8914a1976199$export$2e2bcd8739ae039, {})
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $4b112c041340d9ed$export$e7b0ac011bb776c6), {
                        path: "/editor",
                        element: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)($b3cfd8deb28a43a1$export$2e2bcd8739ae039, {})
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $4b112c041340d9ed$export$e7b0ac011bb776c6), {
                        path: "/about",
                        element: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)($a6c08777ae81de46$export$2e2bcd8739ae039, {})
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $4b112c041340d9ed$export$e7b0ac011bb776c6), {
                        path: "/privacy",
                        element: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)($a76a3f4d862cd577$export$2e2bcd8739ae039, {})
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $4b112c041340d9ed$export$e7b0ac011bb776c6), {
                        path: "/new",
                        element: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)($6725d54c9664f81c$export$2e2bcd8739ae039, {})
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $4b112c041340d9ed$export$e7b0ac011bb776c6), {
                        path: "/share/:type/:data",
                        element: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)($a1f0c40ef9872565$export$2e2bcd8739ae039, {})
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $4b112c041340d9ed$export$e7b0ac011bb776c6), {
                        path: "/tutorials",
                        element: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)($fa77931eb1e8037c$export$2e2bcd8739ae039, {})
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $4b112c041340d9ed$export$e7b0ac011bb776c6), {
                        path: "/example",
                        element: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)($539642c630a1c3b9$export$2e2bcd8739ae039, {})
                    }),
                    /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $4b112c041340d9ed$export$e7b0ac011bb776c6), {
                        path: "*",
                        element: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)($701cfe5b284cadd9$export$2e2bcd8739ae039, {})
                    })
                ]
            }),
            !hideFooter && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $c66ee0aaafbc7ad3$export$2e2bcd8739ae039), {}),
            showUpdateToast && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $5c6982248878ffae$export$e2f7ceae8279c45a), {}),
            showOfflineReadyToast && /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $f13ae6e76ab79838$export$db8c5995a968d288), {}),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $919cfef8d63aa373$export$c688898c4e3580ee), {}),
            /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)($31dc36e7a32a250a$export$2e2bcd8739ae039, {})
        ]
    });
};
var $067526635ae29371$exports = {};
$067526635ae29371$exports = import.meta.resolve("dtFQi");


if ("serviceWorker" in navigator) window.addEventListener("load", async ()=>{
    {
        // Check if SW exists
        const hasController = !!navigator.serviceWorker.controller;
        const registration = await navigator.serviceWorker.register($067526635ae29371$exports);
        // Display offline ready when SW completes installation
        navigator.serviceWorker.addEventListener("message", (event)=>{
            if (event.data?.type === "OFFLINE_READY") window.dispatchEvent(new Event('sw-offline-ready'));
        });
        // Display offline ready if SW already exists. 
        navigator.serviceWorker.ready.then(()=>{
            // If there's an active controller, the app is already cached
            if (navigator.serviceWorker.controller) window.dispatchEvent(new Event('sw-offline-ready'));
        });
        // Display update toast if previous controller exists and is updated.
        if (hasController) registration.addEventListener("updatefound", ()=>{
            const newWorker = registration.installing;
            if (!newWorker) return;
            newWorker.addEventListener("statechange", ()=>{
                if (newWorker.state === "activated") window.dispatchEvent(new Event('sw-update-available'));
            });
        });
    }
});
// Render the app
(0, (/*@__PURE__*/$parcel$interopDefault($3NhwF))).render(/*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $h2ArV.StrictMode), {
    children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $h2ArV.Suspense), {
        fallback: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)("div", {
            children: "Loading"
        }),
        children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)((0, $ea9c8114d35b5a84$export$7221d69dcfc8e36b), {
            children: /*#__PURE__*/ (0, $d15f6e8ca8604f1a$exports.jsx)($70fc9a727fa662ae$var$App, {})
        })
    })
}), document.getElementById('app'));


//# sourceMappingURL=public.3b2be6d4.js.map
